(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kI8SP", function(module, exports) {

$parcel$export(module.exports, "register", () => $f13ecebb1f16f955$export$6503ec6e8aabbaf, (v) => $f13ecebb1f16f955$export$6503ec6e8aabbaf = v);
var $f13ecebb1f16f955$export$6503ec6e8aabbaf;
var $f13ecebb1f16f955$export$f7ad0328861e2f03;
"use strict";
var $f13ecebb1f16f955$var$mapping = new Map();
function $f13ecebb1f16f955$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$f13ecebb1f16f955$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $f13ecebb1f16f955$var$resolve(id) {
    var resolved = $f13ecebb1f16f955$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$f13ecebb1f16f955$export$6503ec6e8aabbaf = $f13ecebb1f16f955$var$register;
$f13ecebb1f16f955$export$f7ad0328861e2f03 = $f13ecebb1f16f955$var$resolve;

});

parcelRegister("hIarR", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", () => $ce4ea6902f7a0721$export$bdfd709ae4826697, (v) => $ce4ea6902f7a0721$export$bdfd709ae4826697 = v);
var $ce4ea6902f7a0721$export$bdfd709ae4826697;
var $ce4ea6902f7a0721$export$c9e73fbda7da57b6;
var $ce4ea6902f7a0721$export$5a759dc7a1cfb72a;
"use strict";
var $ce4ea6902f7a0721$var$bundleURL = {};
function $ce4ea6902f7a0721$var$getBundleURLCached(id) {
    var value = $ce4ea6902f7a0721$var$bundleURL[id];
    if (!value) {
        value = $ce4ea6902f7a0721$var$getBundleURL();
        $ce4ea6902f7a0721$var$bundleURL[id] = value;
    }
    return value;
}
function $ce4ea6902f7a0721$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $ce4ea6902f7a0721$var$getBaseURL(matches[2]);
    }
    return '/';
}
function $ce4ea6902f7a0721$var$getBaseURL(url) {
    return ('' + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, '$1') + '/';
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $ce4ea6902f7a0721$var$getOrigin(url) {
    var matches = ('' + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error('Origin not found');
    return matches[0];
}
$ce4ea6902f7a0721$export$bdfd709ae4826697 = $ce4ea6902f7a0721$var$getBundleURLCached;
$ce4ea6902f7a0721$export$c9e73fbda7da57b6 = $ce4ea6902f7a0721$var$getBaseURL;
$ce4ea6902f7a0721$export$5a759dc7a1cfb72a = $ce4ea6902f7a0721$var$getOrigin;

});

parcelRegister("89wqa", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $5ef850295e0236ca$export$ffb0004e005737fa, (v) => $5ef850295e0236ca$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $5ef850295e0236ca$export$34b9dba7ce09269b, (v) => $5ef850295e0236ca$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $5ef850295e0236ca$export$25062201e9e25d76, (v) => $5ef850295e0236ca$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5ef850295e0236ca$export$ffb0004e005737fa;
var $5ef850295e0236ca$export$34b9dba7ce09269b;
var $5ef850295e0236ca$export$25062201e9e25d76;
'use strict';

var $8NFma = parcelRequire("8NFma");
var $5ef850295e0236ca$var$k = Symbol.for("react.element"), $5ef850295e0236ca$var$l = Symbol.for("react.fragment"), $5ef850295e0236ca$var$m = Object.prototype.hasOwnProperty, $5ef850295e0236ca$var$n = $8NFma.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $5ef850295e0236ca$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $5ef850295e0236ca$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$5ef850295e0236ca$var$m.call(a, b) && !$5ef850295e0236ca$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $5ef850295e0236ca$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $5ef850295e0236ca$var$n.current
    };
}
$5ef850295e0236ca$export$ffb0004e005737fa = $5ef850295e0236ca$var$l;
$5ef850295e0236ca$export$34b9dba7ce09269b = $5ef850295e0236ca$var$q;
$5ef850295e0236ca$export$25062201e9e25d76 = $5ef850295e0236ca$var$q;

});
parcelRegister("8NFma", function(module, exports) {
'use strict';

module.exports = (parcelRequire("j1rj6"));

});
parcelRegister("j1rj6", function(module, exports) {

$parcel$export(module.exports, "Children", () => $dd934af551f44020$export$dca3b0875bd9a954, (v) => $dd934af551f44020$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $dd934af551f44020$export$16fa2f45be04daa8, (v) => $dd934af551f44020$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $dd934af551f44020$export$ffb0004e005737fa, (v) => $dd934af551f44020$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $dd934af551f44020$export$e2c29f18771995cb, (v) => $dd934af551f44020$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $dd934af551f44020$export$221d75b3f55bb0bd, (v) => $dd934af551f44020$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $dd934af551f44020$export$5f8d39834fd61797, (v) => $dd934af551f44020$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $dd934af551f44020$export$74bf444e3cd11ea5, (v) => $dd934af551f44020$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $dd934af551f44020$export$ae55be85d98224ed, (v) => $dd934af551f44020$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $dd934af551f44020$export$e530037191fcd5d7, (v) => $dd934af551f44020$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $dd934af551f44020$export$fd42f52fd3ae1109, (v) => $dd934af551f44020$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $dd934af551f44020$export$c8a8987d4410bf2d, (v) => $dd934af551f44020$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $dd934af551f44020$export$d38cd72104c1f0e9, (v) => $dd934af551f44020$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $dd934af551f44020$export$7d1e3a5e95ceca43, (v) => $dd934af551f44020$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $dd934af551f44020$export$257a8862b851cb5b, (v) => $dd934af551f44020$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $dd934af551f44020$export$a8257692ac88316c, (v) => $dd934af551f44020$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $dd934af551f44020$export$488013bae63b21da, (v) => $dd934af551f44020$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $dd934af551f44020$export$7c73462e0d25e514, (v) => $dd934af551f44020$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $dd934af551f44020$export$7568632d0d33d16d, (v) => $dd934af551f44020$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $dd934af551f44020$export$88948ce120ea2619, (v) => $dd934af551f44020$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $dd934af551f44020$export$35808ee640e87ca7, (v) => $dd934af551f44020$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $dd934af551f44020$export$fae74005e78b1a27, (v) => $dd934af551f44020$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $dd934af551f44020$export$dc8fbce3eb94dc1e, (v) => $dd934af551f44020$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $dd934af551f44020$export$6a7bc4e911dc01cf, (v) => $dd934af551f44020$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $dd934af551f44020$export$6d9c69b0de29b591, (v) => $dd934af551f44020$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $dd934af551f44020$export$f680877a34711e37, (v) => $dd934af551f44020$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $dd934af551f44020$export$d5a552a76deda3c2, (v) => $dd934af551f44020$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $dd934af551f44020$export$aaabe4eda9ed9969, (v) => $dd934af551f44020$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $dd934af551f44020$export$e5c5a5f917a5871c, (v) => $dd934af551f44020$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $dd934af551f44020$export$1538c33de8887b59, (v) => $dd934af551f44020$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $dd934af551f44020$export$13e3392192263954, (v) => $dd934af551f44020$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $dd934af551f44020$export$b8f5890fc79d6aca, (v) => $dd934af551f44020$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $dd934af551f44020$export$60241385465d0a34, (v) => $dd934af551f44020$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $dd934af551f44020$export$306c0aa65ff9ec16, (v) => $dd934af551f44020$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $dd934af551f44020$export$7b286972b8d8ccbf, (v) => $dd934af551f44020$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $dd934af551f44020$export$83d89fbfd8236492, (v) => $dd934af551f44020$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $dd934af551f44020$export$dca3b0875bd9a954;
var $dd934af551f44020$export$16fa2f45be04daa8;
var $dd934af551f44020$export$ffb0004e005737fa;
var $dd934af551f44020$export$e2c29f18771995cb;
var $dd934af551f44020$export$221d75b3f55bb0bd;
var $dd934af551f44020$export$5f8d39834fd61797;
var $dd934af551f44020$export$74bf444e3cd11ea5;
var $dd934af551f44020$export$ae55be85d98224ed;
var $dd934af551f44020$export$e530037191fcd5d7;
var $dd934af551f44020$export$fd42f52fd3ae1109;
var $dd934af551f44020$export$c8a8987d4410bf2d;
var $dd934af551f44020$export$d38cd72104c1f0e9;
var $dd934af551f44020$export$7d1e3a5e95ceca43;
var $dd934af551f44020$export$257a8862b851cb5b;
var $dd934af551f44020$export$a8257692ac88316c;
var $dd934af551f44020$export$488013bae63b21da;
var $dd934af551f44020$export$7c73462e0d25e514;
var $dd934af551f44020$export$7568632d0d33d16d;
var $dd934af551f44020$export$88948ce120ea2619;
var $dd934af551f44020$export$35808ee640e87ca7;
var $dd934af551f44020$export$fae74005e78b1a27;
var $dd934af551f44020$export$dc8fbce3eb94dc1e;
var $dd934af551f44020$export$6a7bc4e911dc01cf;
var $dd934af551f44020$export$6d9c69b0de29b591;
var $dd934af551f44020$export$f680877a34711e37;
var $dd934af551f44020$export$d5a552a76deda3c2;
var $dd934af551f44020$export$aaabe4eda9ed9969;
var $dd934af551f44020$export$e5c5a5f917a5871c;
var $dd934af551f44020$export$1538c33de8887b59;
var $dd934af551f44020$export$13e3392192263954;
var $dd934af551f44020$export$b8f5890fc79d6aca;
var $dd934af551f44020$export$60241385465d0a34;
var $dd934af551f44020$export$306c0aa65ff9ec16;
var $dd934af551f44020$export$7b286972b8d8ccbf;
var $dd934af551f44020$export$83d89fbfd8236492;
'use strict';
var $dd934af551f44020$var$l = Symbol.for("react.element"), $dd934af551f44020$var$n = Symbol.for("react.portal"), $dd934af551f44020$var$p = Symbol.for("react.fragment"), $dd934af551f44020$var$q = Symbol.for("react.strict_mode"), $dd934af551f44020$var$r = Symbol.for("react.profiler"), $dd934af551f44020$var$t = Symbol.for("react.provider"), $dd934af551f44020$var$u = Symbol.for("react.context"), $dd934af551f44020$var$v = Symbol.for("react.forward_ref"), $dd934af551f44020$var$w = Symbol.for("react.suspense"), $dd934af551f44020$var$x = Symbol.for("react.memo"), $dd934af551f44020$var$y = Symbol.for("react.lazy"), $dd934af551f44020$var$z = Symbol.iterator;
function $dd934af551f44020$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $dd934af551f44020$var$z && a[$dd934af551f44020$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $dd934af551f44020$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $dd934af551f44020$var$C = Object.assign, $dd934af551f44020$var$D = {};
function $dd934af551f44020$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $dd934af551f44020$var$D;
    this.updater = e || $dd934af551f44020$var$B;
}
$dd934af551f44020$var$E.prototype.isReactComponent = {};
$dd934af551f44020$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$dd934af551f44020$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $dd934af551f44020$var$F() {}
$dd934af551f44020$var$F.prototype = $dd934af551f44020$var$E.prototype;
function $dd934af551f44020$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $dd934af551f44020$var$D;
    this.updater = e || $dd934af551f44020$var$B;
}
var $dd934af551f44020$var$H = $dd934af551f44020$var$G.prototype = new $dd934af551f44020$var$F;
$dd934af551f44020$var$H.constructor = $dd934af551f44020$var$G;
$dd934af551f44020$var$C($dd934af551f44020$var$H, $dd934af551f44020$var$E.prototype);
$dd934af551f44020$var$H.isPureReactComponent = !0;
var $dd934af551f44020$var$I = Array.isArray, $dd934af551f44020$var$J = Object.prototype.hasOwnProperty, $dd934af551f44020$var$K = {
    current: null
}, $dd934af551f44020$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $dd934af551f44020$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$dd934af551f44020$var$J.call(b, d) && !$dd934af551f44020$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $dd934af551f44020$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $dd934af551f44020$var$K.current
    };
}
function $dd934af551f44020$var$N(a, b) {
    return {
        $$typeof: $dd934af551f44020$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $dd934af551f44020$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $dd934af551f44020$var$l;
}
function $dd934af551f44020$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $dd934af551f44020$var$P = /\/+/g;
function $dd934af551f44020$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $dd934af551f44020$var$escape("" + a.key) : b.toString(36);
}
function $dd934af551f44020$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $dd934af551f44020$var$l:
                case $dd934af551f44020$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $dd934af551f44020$var$Q(h, 0) : d, $dd934af551f44020$var$I(c) ? (e = "", null != a && (e = a.replace($dd934af551f44020$var$P, "$&/") + "/"), $dd934af551f44020$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($dd934af551f44020$var$O(c) && (c = $dd934af551f44020$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($dd934af551f44020$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($dd934af551f44020$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $dd934af551f44020$var$Q(k, g);
        h += $dd934af551f44020$var$R(k, b, e, f, c);
    }
    else if (f = $dd934af551f44020$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $dd934af551f44020$var$Q(k, g++), h += $dd934af551f44020$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $dd934af551f44020$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $dd934af551f44020$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $dd934af551f44020$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $dd934af551f44020$var$U = {
    current: null
}, $dd934af551f44020$var$V = {
    transition: null
}, $dd934af551f44020$var$W = {
    ReactCurrentDispatcher: $dd934af551f44020$var$U,
    ReactCurrentBatchConfig: $dd934af551f44020$var$V,
    ReactCurrentOwner: $dd934af551f44020$var$K
};
$dd934af551f44020$export$dca3b0875bd9a954 = {
    map: $dd934af551f44020$var$S,
    forEach: function(a, b, e) {
        $dd934af551f44020$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $dd934af551f44020$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $dd934af551f44020$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$dd934af551f44020$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$dd934af551f44020$export$16fa2f45be04daa8 = $dd934af551f44020$var$E;
$dd934af551f44020$export$ffb0004e005737fa = $dd934af551f44020$var$p;
$dd934af551f44020$export$e2c29f18771995cb = $dd934af551f44020$var$r;
$dd934af551f44020$export$221d75b3f55bb0bd = $dd934af551f44020$var$G;
$dd934af551f44020$export$5f8d39834fd61797 = $dd934af551f44020$var$q;
$dd934af551f44020$export$74bf444e3cd11ea5 = $dd934af551f44020$var$w;
$dd934af551f44020$export$ae55be85d98224ed = $dd934af551f44020$var$W;
$dd934af551f44020$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $dd934af551f44020$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $dd934af551f44020$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$dd934af551f44020$var$J.call(b, f) && !$dd934af551f44020$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $dd934af551f44020$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$dd934af551f44020$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $dd934af551f44020$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $dd934af551f44020$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$dd934af551f44020$export$c8a8987d4410bf2d = $dd934af551f44020$var$M;
$dd934af551f44020$export$d38cd72104c1f0e9 = function(a) {
    var b = $dd934af551f44020$var$M.bind(null, a);
    b.type = a;
    return b;
};
$dd934af551f44020$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$dd934af551f44020$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $dd934af551f44020$var$v,
        render: a
    };
};
$dd934af551f44020$export$a8257692ac88316c = $dd934af551f44020$var$O;
$dd934af551f44020$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $dd934af551f44020$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $dd934af551f44020$var$T
    };
};
$dd934af551f44020$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $dd934af551f44020$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$dd934af551f44020$export$7568632d0d33d16d = function(a) {
    var b = $dd934af551f44020$var$V.transition;
    $dd934af551f44020$var$V.transition = {};
    try {
        a();
    } finally{
        $dd934af551f44020$var$V.transition = b;
    }
};
$dd934af551f44020$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$dd934af551f44020$export$35808ee640e87ca7 = function(a, b) {
    return $dd934af551f44020$var$U.current.useCallback(a, b);
};
$dd934af551f44020$export$fae74005e78b1a27 = function(a) {
    return $dd934af551f44020$var$U.current.useContext(a);
};
$dd934af551f44020$export$dc8fbce3eb94dc1e = function() {};
$dd934af551f44020$export$6a7bc4e911dc01cf = function(a) {
    return $dd934af551f44020$var$U.current.useDeferredValue(a);
};
$dd934af551f44020$export$6d9c69b0de29b591 = function(a, b) {
    return $dd934af551f44020$var$U.current.useEffect(a, b);
};
$dd934af551f44020$export$f680877a34711e37 = function() {
    return $dd934af551f44020$var$U.current.useId();
};
$dd934af551f44020$export$d5a552a76deda3c2 = function(a, b, e) {
    return $dd934af551f44020$var$U.current.useImperativeHandle(a, b, e);
};
$dd934af551f44020$export$aaabe4eda9ed9969 = function(a, b) {
    return $dd934af551f44020$var$U.current.useInsertionEffect(a, b);
};
$dd934af551f44020$export$e5c5a5f917a5871c = function(a, b) {
    return $dd934af551f44020$var$U.current.useLayoutEffect(a, b);
};
$dd934af551f44020$export$1538c33de8887b59 = function(a, b) {
    return $dd934af551f44020$var$U.current.useMemo(a, b);
};
$dd934af551f44020$export$13e3392192263954 = function(a, b, e) {
    return $dd934af551f44020$var$U.current.useReducer(a, b, e);
};
$dd934af551f44020$export$b8f5890fc79d6aca = function(a) {
    return $dd934af551f44020$var$U.current.useRef(a);
};
$dd934af551f44020$export$60241385465d0a34 = function(a) {
    return $dd934af551f44020$var$U.current.useState(a);
};
$dd934af551f44020$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $dd934af551f44020$var$U.current.useSyncExternalStore(a, b, e);
};
$dd934af551f44020$export$7b286972b8d8ccbf = function() {
    return $dd934af551f44020$var$U.current.useTransition();
};
$dd934af551f44020$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("2pmb0", function(module, exports) {
'use strict';
function $1c0f1e610963dfb8$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($1c0f1e610963dfb8$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$1c0f1e610963dfb8$var$checkDCE();

module.exports = (parcelRequire("23wBm"));

});
parcelRegister("23wBm", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $17f526922e4a857c$export$ae55be85d98224ed, (v) => $17f526922e4a857c$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $17f526922e4a857c$export$d39a5bbd09211389, (v) => $17f526922e4a857c$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $17f526922e4a857c$export$882461b6382ed46c, (v) => $17f526922e4a857c$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $17f526922e4a857c$export$466bfc07425424d5, (v) => $17f526922e4a857c$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $17f526922e4a857c$export$cd75ccfd720a3cd4, (v) => $17f526922e4a857c$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $17f526922e4a857c$export$fa8d919ba61d84db, (v) => $17f526922e4a857c$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $17f526922e4a857c$export$757ceba2d55c277e, (v) => $17f526922e4a857c$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $17f526922e4a857c$export$b3890eb0ae9dca99, (v) => $17f526922e4a857c$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $17f526922e4a857c$export$502457920280e6be, (v) => $17f526922e4a857c$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $17f526922e4a857c$export$c78a37762a8d58e1, (v) => $17f526922e4a857c$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $17f526922e4a857c$export$dc54d992c10e8a18, (v) => $17f526922e4a857c$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $17f526922e4a857c$export$83d89fbfd8236492, (v) => $17f526922e4a857c$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $17f526922e4a857c$export$ae55be85d98224ed;
var $17f526922e4a857c$export$d39a5bbd09211389;
var $17f526922e4a857c$export$882461b6382ed46c;
var $17f526922e4a857c$export$466bfc07425424d5;
var $17f526922e4a857c$export$cd75ccfd720a3cd4;
var $17f526922e4a857c$export$fa8d919ba61d84db;
var $17f526922e4a857c$export$757ceba2d55c277e;
var $17f526922e4a857c$export$b3890eb0ae9dca99;
var $17f526922e4a857c$export$502457920280e6be;
var $17f526922e4a857c$export$c78a37762a8d58e1;
var $17f526922e4a857c$export$dc54d992c10e8a18;
var $17f526922e4a857c$export$83d89fbfd8236492;
'use strict';

var $8NFma = parcelRequire("8NFma");

var $clk2u = parcelRequire("clk2u");
function $17f526922e4a857c$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $17f526922e4a857c$var$da = new Set, $17f526922e4a857c$var$ea = {};
function $17f526922e4a857c$var$fa(a, b) {
    $17f526922e4a857c$var$ha(a, b);
    $17f526922e4a857c$var$ha(a + "Capture", b);
}
function $17f526922e4a857c$var$ha(a, b) {
    $17f526922e4a857c$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$17f526922e4a857c$var$da.add(b[a]);
}
var $17f526922e4a857c$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $17f526922e4a857c$var$ja = Object.prototype.hasOwnProperty, $17f526922e4a857c$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $17f526922e4a857c$var$la = {}, $17f526922e4a857c$var$ma = {};
function $17f526922e4a857c$var$oa(a) {
    if ($17f526922e4a857c$var$ja.call($17f526922e4a857c$var$ma, a)) return !0;
    if ($17f526922e4a857c$var$ja.call($17f526922e4a857c$var$la, a)) return !1;
    if ($17f526922e4a857c$var$ka.test(a)) return $17f526922e4a857c$var$ma[a] = !0;
    $17f526922e4a857c$var$la[a] = !0;
    return !1;
}
function $17f526922e4a857c$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $17f526922e4a857c$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $17f526922e4a857c$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $17f526922e4a857c$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $17f526922e4a857c$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $17f526922e4a857c$var$z[b] = new $17f526922e4a857c$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $17f526922e4a857c$var$ra = /[\-:]([a-z])/g;
function $17f526922e4a857c$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($17f526922e4a857c$var$ra, $17f526922e4a857c$var$sa);
    $17f526922e4a857c$var$z[b] = new $17f526922e4a857c$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($17f526922e4a857c$var$ra, $17f526922e4a857c$var$sa);
    $17f526922e4a857c$var$z[b] = new $17f526922e4a857c$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($17f526922e4a857c$var$ra, $17f526922e4a857c$var$sa);
    $17f526922e4a857c$var$z[b] = new $17f526922e4a857c$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$17f526922e4a857c$var$z.xlinkHref = new $17f526922e4a857c$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $17f526922e4a857c$var$ta(a, b, c, d) {
    var e = $17f526922e4a857c$var$z.hasOwnProperty(b) ? $17f526922e4a857c$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $17f526922e4a857c$var$qa(b, c, e, d) && (c = null), d || null === e ? $17f526922e4a857c$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $17f526922e4a857c$var$ua = $8NFma.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $17f526922e4a857c$var$va = Symbol.for("react.element"), $17f526922e4a857c$var$wa = Symbol.for("react.portal"), $17f526922e4a857c$var$ya = Symbol.for("react.fragment"), $17f526922e4a857c$var$za = Symbol.for("react.strict_mode"), $17f526922e4a857c$var$Aa = Symbol.for("react.profiler"), $17f526922e4a857c$var$Ba = Symbol.for("react.provider"), $17f526922e4a857c$var$Ca = Symbol.for("react.context"), $17f526922e4a857c$var$Da = Symbol.for("react.forward_ref"), $17f526922e4a857c$var$Ea = Symbol.for("react.suspense"), $17f526922e4a857c$var$Fa = Symbol.for("react.suspense_list"), $17f526922e4a857c$var$Ga = Symbol.for("react.memo"), $17f526922e4a857c$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $17f526922e4a857c$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $17f526922e4a857c$var$Ja = Symbol.iterator;
function $17f526922e4a857c$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $17f526922e4a857c$var$Ja && a[$17f526922e4a857c$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $17f526922e4a857c$var$A = Object.assign, $17f526922e4a857c$var$La;
function $17f526922e4a857c$var$Ma(a) {
    if (void 0 === $17f526922e4a857c$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $17f526922e4a857c$var$La = b && b[1] || "";
    }
    return "\n" + $17f526922e4a857c$var$La + a;
}
var $17f526922e4a857c$var$Na = !1;
function $17f526922e4a857c$var$Oa(a, b) {
    if (!a || $17f526922e4a857c$var$Na) return "";
    $17f526922e4a857c$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $17f526922e4a857c$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $17f526922e4a857c$var$Ma(a) : "";
}
function $17f526922e4a857c$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $17f526922e4a857c$var$Ma(a.type);
        case 16:
            return $17f526922e4a857c$var$Ma("Lazy");
        case 13:
            return $17f526922e4a857c$var$Ma("Suspense");
        case 19:
            return $17f526922e4a857c$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $17f526922e4a857c$var$Oa(a.type, !1), a;
        case 11:
            return a = $17f526922e4a857c$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $17f526922e4a857c$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $17f526922e4a857c$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $17f526922e4a857c$var$ya:
            return "Fragment";
        case $17f526922e4a857c$var$wa:
            return "Portal";
        case $17f526922e4a857c$var$Aa:
            return "Profiler";
        case $17f526922e4a857c$var$za:
            return "StrictMode";
        case $17f526922e4a857c$var$Ea:
            return "Suspense";
        case $17f526922e4a857c$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $17f526922e4a857c$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $17f526922e4a857c$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $17f526922e4a857c$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $17f526922e4a857c$var$Ga:
            return b = a.displayName || null, null !== b ? b : $17f526922e4a857c$var$Qa(a.type) || "Memo";
        case $17f526922e4a857c$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $17f526922e4a857c$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $17f526922e4a857c$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $17f526922e4a857c$var$Qa(b);
        case 8:
            return b === $17f526922e4a857c$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $17f526922e4a857c$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $17f526922e4a857c$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $17f526922e4a857c$var$Ua(a) {
    var b = $17f526922e4a857c$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $17f526922e4a857c$var$Va(a) {
    a._valueTracker || (a._valueTracker = $17f526922e4a857c$var$Ua(a));
}
function $17f526922e4a857c$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $17f526922e4a857c$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $17f526922e4a857c$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $17f526922e4a857c$var$Ya(a, b) {
    var c = b.checked;
    return $17f526922e4a857c$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $17f526922e4a857c$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $17f526922e4a857c$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $17f526922e4a857c$var$ab(a, b) {
    b = b.checked;
    null != b && $17f526922e4a857c$var$ta(a, "checked", b, !1);
}
function $17f526922e4a857c$var$bb(a, b) {
    $17f526922e4a857c$var$ab(a, b);
    var c = $17f526922e4a857c$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $17f526922e4a857c$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $17f526922e4a857c$var$cb(a, b.type, $17f526922e4a857c$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $17f526922e4a857c$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $17f526922e4a857c$var$cb(a, b, c) {
    if ("number" !== b || $17f526922e4a857c$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $17f526922e4a857c$var$eb = Array.isArray;
function $17f526922e4a857c$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $17f526922e4a857c$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $17f526922e4a857c$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($17f526922e4a857c$var$p(91));
    return $17f526922e4a857c$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $17f526922e4a857c$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($17f526922e4a857c$var$p(92));
            if ($17f526922e4a857c$var$eb(c)) {
                if (1 < c.length) throw Error($17f526922e4a857c$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $17f526922e4a857c$var$Sa(c)
    };
}
function $17f526922e4a857c$var$ib(a, b) {
    var c = $17f526922e4a857c$var$Sa(b.value), d = $17f526922e4a857c$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $17f526922e4a857c$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $17f526922e4a857c$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $17f526922e4a857c$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $17f526922e4a857c$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $17f526922e4a857c$var$mb, $17f526922e4a857c$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $17f526922e4a857c$var$mb = $17f526922e4a857c$var$mb || document.createElement("div");
        $17f526922e4a857c$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $17f526922e4a857c$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $17f526922e4a857c$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $17f526922e4a857c$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $17f526922e4a857c$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($17f526922e4a857c$var$pb).forEach(function(a) {
    $17f526922e4a857c$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $17f526922e4a857c$var$pb[b] = $17f526922e4a857c$var$pb[a];
    });
});
function $17f526922e4a857c$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $17f526922e4a857c$var$pb.hasOwnProperty(a) && $17f526922e4a857c$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $17f526922e4a857c$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $17f526922e4a857c$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $17f526922e4a857c$var$tb = $17f526922e4a857c$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $17f526922e4a857c$var$ub(a, b) {
    if (b) {
        if ($17f526922e4a857c$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($17f526922e4a857c$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($17f526922e4a857c$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($17f526922e4a857c$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($17f526922e4a857c$var$p(62));
    }
}
function $17f526922e4a857c$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $17f526922e4a857c$var$wb = null;
function $17f526922e4a857c$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $17f526922e4a857c$var$yb = null, $17f526922e4a857c$var$zb = null, $17f526922e4a857c$var$Ab = null;
function $17f526922e4a857c$var$Bb(a) {
    if (a = $17f526922e4a857c$var$Cb(a)) {
        if ("function" !== typeof $17f526922e4a857c$var$yb) throw Error($17f526922e4a857c$var$p(280));
        var b = a.stateNode;
        b && (b = $17f526922e4a857c$var$Db(b), $17f526922e4a857c$var$yb(a.stateNode, a.type, b));
    }
}
function $17f526922e4a857c$var$Eb(a) {
    $17f526922e4a857c$var$zb ? $17f526922e4a857c$var$Ab ? $17f526922e4a857c$var$Ab.push(a) : $17f526922e4a857c$var$Ab = [
        a
    ] : $17f526922e4a857c$var$zb = a;
}
function $17f526922e4a857c$var$Fb() {
    if ($17f526922e4a857c$var$zb) {
        var a = $17f526922e4a857c$var$zb, b = $17f526922e4a857c$var$Ab;
        $17f526922e4a857c$var$Ab = $17f526922e4a857c$var$zb = null;
        $17f526922e4a857c$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$17f526922e4a857c$var$Bb(b[a]);
    }
}
function $17f526922e4a857c$var$Gb(a, b) {
    return a(b);
}
function $17f526922e4a857c$var$Hb() {}
var $17f526922e4a857c$var$Ib = !1;
function $17f526922e4a857c$var$Jb(a, b, c) {
    if ($17f526922e4a857c$var$Ib) return a(b, c);
    $17f526922e4a857c$var$Ib = !0;
    try {
        return $17f526922e4a857c$var$Gb(a, b, c);
    } finally{
        if ($17f526922e4a857c$var$Ib = !1, null !== $17f526922e4a857c$var$zb || null !== $17f526922e4a857c$var$Ab) $17f526922e4a857c$var$Hb(), $17f526922e4a857c$var$Fb();
    }
}
function $17f526922e4a857c$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $17f526922e4a857c$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($17f526922e4a857c$var$p(231, b, typeof c));
    return c;
}
var $17f526922e4a857c$var$Lb = !1;
if ($17f526922e4a857c$var$ia) try {
    var $17f526922e4a857c$var$Mb = {};
    Object.defineProperty($17f526922e4a857c$var$Mb, "passive", {
        get: function() {
            $17f526922e4a857c$var$Lb = !0;
        }
    });
    window.addEventListener("test", $17f526922e4a857c$var$Mb, $17f526922e4a857c$var$Mb);
    window.removeEventListener("test", $17f526922e4a857c$var$Mb, $17f526922e4a857c$var$Mb);
} catch (a) {
    $17f526922e4a857c$var$Lb = !1;
}
function $17f526922e4a857c$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $17f526922e4a857c$var$Ob = !1, $17f526922e4a857c$var$Pb = null, $17f526922e4a857c$var$Qb = !1, $17f526922e4a857c$var$Rb = null, $17f526922e4a857c$var$Sb = {
    onError: function(a) {
        $17f526922e4a857c$var$Ob = !0;
        $17f526922e4a857c$var$Pb = a;
    }
};
function $17f526922e4a857c$var$Tb(a, b, c, d, e, f, g, h, k) {
    $17f526922e4a857c$var$Ob = !1;
    $17f526922e4a857c$var$Pb = null;
    $17f526922e4a857c$var$Nb.apply($17f526922e4a857c$var$Sb, arguments);
}
function $17f526922e4a857c$var$Ub(a, b, c, d, e, f, g, h, k) {
    $17f526922e4a857c$var$Tb.apply(this, arguments);
    if ($17f526922e4a857c$var$Ob) {
        if ($17f526922e4a857c$var$Ob) {
            var l = $17f526922e4a857c$var$Pb;
            $17f526922e4a857c$var$Ob = !1;
            $17f526922e4a857c$var$Pb = null;
        } else throw Error($17f526922e4a857c$var$p(198));
        $17f526922e4a857c$var$Qb || ($17f526922e4a857c$var$Qb = !0, $17f526922e4a857c$var$Rb = l);
    }
}
function $17f526922e4a857c$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $17f526922e4a857c$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $17f526922e4a857c$var$Xb(a) {
    if ($17f526922e4a857c$var$Vb(a) !== a) throw Error($17f526922e4a857c$var$p(188));
}
function $17f526922e4a857c$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $17f526922e4a857c$var$Vb(a);
        if (null === b) throw Error($17f526922e4a857c$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $17f526922e4a857c$var$Xb(e), a;
                if (f === d) return $17f526922e4a857c$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($17f526922e4a857c$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($17f526922e4a857c$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($17f526922e4a857c$var$p(190));
    }
    if (3 !== c.tag) throw Error($17f526922e4a857c$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $17f526922e4a857c$var$Zb(a) {
    a = $17f526922e4a857c$var$Yb(a);
    return null !== a ? $17f526922e4a857c$var$$b(a) : null;
}
function $17f526922e4a857c$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $17f526922e4a857c$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $17f526922e4a857c$var$ac = $clk2u.unstable_scheduleCallback, $17f526922e4a857c$var$bc = $clk2u.unstable_cancelCallback, $17f526922e4a857c$var$cc = $clk2u.unstable_shouldYield, $17f526922e4a857c$var$dc = $clk2u.unstable_requestPaint, $17f526922e4a857c$var$B = $clk2u.unstable_now, $17f526922e4a857c$var$ec = $clk2u.unstable_getCurrentPriorityLevel, $17f526922e4a857c$var$fc = $clk2u.unstable_ImmediatePriority, $17f526922e4a857c$var$gc = $clk2u.unstable_UserBlockingPriority, $17f526922e4a857c$var$hc = $clk2u.unstable_NormalPriority, $17f526922e4a857c$var$ic = $clk2u.unstable_LowPriority, $17f526922e4a857c$var$jc = $clk2u.unstable_IdlePriority, $17f526922e4a857c$var$kc = null, $17f526922e4a857c$var$lc = null;
function $17f526922e4a857c$var$mc(a) {
    if ($17f526922e4a857c$var$lc && "function" === typeof $17f526922e4a857c$var$lc.onCommitFiberRoot) try {
        $17f526922e4a857c$var$lc.onCommitFiberRoot($17f526922e4a857c$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $17f526922e4a857c$var$oc = Math.clz32 ? Math.clz32 : $17f526922e4a857c$var$nc, $17f526922e4a857c$var$pc = Math.log, $17f526922e4a857c$var$qc = Math.LN2;
function $17f526922e4a857c$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($17f526922e4a857c$var$pc(a) / $17f526922e4a857c$var$qc | 0) | 0;
}
var $17f526922e4a857c$var$rc = 64, $17f526922e4a857c$var$sc = 4194304;
function $17f526922e4a857c$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $17f526922e4a857c$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $17f526922e4a857c$var$tc(h) : (f &= g, 0 !== f && (d = $17f526922e4a857c$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $17f526922e4a857c$var$tc(g) : 0 !== f && (d = $17f526922e4a857c$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $17f526922e4a857c$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $17f526922e4a857c$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $17f526922e4a857c$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $17f526922e4a857c$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $17f526922e4a857c$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $17f526922e4a857c$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $17f526922e4a857c$var$yc() {
    var a = $17f526922e4a857c$var$rc;
    $17f526922e4a857c$var$rc <<= 1;
    0 === ($17f526922e4a857c$var$rc & 4194240) && ($17f526922e4a857c$var$rc = 64);
    return a;
}
function $17f526922e4a857c$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $17f526922e4a857c$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $17f526922e4a857c$var$oc(b);
    a[b] = c;
}
function $17f526922e4a857c$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $17f526922e4a857c$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $17f526922e4a857c$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $17f526922e4a857c$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $17f526922e4a857c$var$C = 0;
function $17f526922e4a857c$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $17f526922e4a857c$var$Ec, $17f526922e4a857c$var$Fc, $17f526922e4a857c$var$Gc, $17f526922e4a857c$var$Hc, $17f526922e4a857c$var$Ic, $17f526922e4a857c$var$Jc = !1, $17f526922e4a857c$var$Kc = [], $17f526922e4a857c$var$Lc = null, $17f526922e4a857c$var$Mc = null, $17f526922e4a857c$var$Nc = null, $17f526922e4a857c$var$Oc = new Map, $17f526922e4a857c$var$Pc = new Map, $17f526922e4a857c$var$Qc = [], $17f526922e4a857c$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $17f526922e4a857c$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $17f526922e4a857c$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $17f526922e4a857c$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $17f526922e4a857c$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $17f526922e4a857c$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $17f526922e4a857c$var$Pc.delete(b.pointerId);
    }
}
function $17f526922e4a857c$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $17f526922e4a857c$var$Cb(b), null !== b && $17f526922e4a857c$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $17f526922e4a857c$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $17f526922e4a857c$var$Lc = $17f526922e4a857c$var$Tc($17f526922e4a857c$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $17f526922e4a857c$var$Mc = $17f526922e4a857c$var$Tc($17f526922e4a857c$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $17f526922e4a857c$var$Nc = $17f526922e4a857c$var$Tc($17f526922e4a857c$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $17f526922e4a857c$var$Oc.set(f, $17f526922e4a857c$var$Tc($17f526922e4a857c$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $17f526922e4a857c$var$Pc.set(f, $17f526922e4a857c$var$Tc($17f526922e4a857c$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $17f526922e4a857c$var$Vc(a) {
    var b = $17f526922e4a857c$var$Wc(a.target);
    if (null !== b) {
        var c = $17f526922e4a857c$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $17f526922e4a857c$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $17f526922e4a857c$var$Ic(a.priority, function() {
                        $17f526922e4a857c$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $17f526922e4a857c$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $17f526922e4a857c$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $17f526922e4a857c$var$wb = d;
            c.target.dispatchEvent(d);
            $17f526922e4a857c$var$wb = null;
        } else return b = $17f526922e4a857c$var$Cb(c), null !== b && $17f526922e4a857c$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $17f526922e4a857c$var$Zc(a, b, c) {
    $17f526922e4a857c$var$Xc(a) && c.delete(b);
}
function $17f526922e4a857c$var$$c() {
    $17f526922e4a857c$var$Jc = !1;
    null !== $17f526922e4a857c$var$Lc && $17f526922e4a857c$var$Xc($17f526922e4a857c$var$Lc) && ($17f526922e4a857c$var$Lc = null);
    null !== $17f526922e4a857c$var$Mc && $17f526922e4a857c$var$Xc($17f526922e4a857c$var$Mc) && ($17f526922e4a857c$var$Mc = null);
    null !== $17f526922e4a857c$var$Nc && $17f526922e4a857c$var$Xc($17f526922e4a857c$var$Nc) && ($17f526922e4a857c$var$Nc = null);
    $17f526922e4a857c$var$Oc.forEach($17f526922e4a857c$var$Zc);
    $17f526922e4a857c$var$Pc.forEach($17f526922e4a857c$var$Zc);
}
function $17f526922e4a857c$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $17f526922e4a857c$var$Jc || ($17f526922e4a857c$var$Jc = !0, $clk2u.unstable_scheduleCallback($clk2u.unstable_NormalPriority, $17f526922e4a857c$var$$c)));
}
function $17f526922e4a857c$var$bd(a) {
    function b(b) {
        return $17f526922e4a857c$var$ad(b, a);
    }
    if (0 < $17f526922e4a857c$var$Kc.length) {
        $17f526922e4a857c$var$ad($17f526922e4a857c$var$Kc[0], a);
        for(var c = 1; c < $17f526922e4a857c$var$Kc.length; c++){
            var d = $17f526922e4a857c$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $17f526922e4a857c$var$Lc && $17f526922e4a857c$var$ad($17f526922e4a857c$var$Lc, a);
    null !== $17f526922e4a857c$var$Mc && $17f526922e4a857c$var$ad($17f526922e4a857c$var$Mc, a);
    null !== $17f526922e4a857c$var$Nc && $17f526922e4a857c$var$ad($17f526922e4a857c$var$Nc, a);
    $17f526922e4a857c$var$Oc.forEach(b);
    $17f526922e4a857c$var$Pc.forEach(b);
    for(c = 0; c < $17f526922e4a857c$var$Qc.length; c++)d = $17f526922e4a857c$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $17f526922e4a857c$var$Qc.length && (c = $17f526922e4a857c$var$Qc[0], null === c.blockedOn);)$17f526922e4a857c$var$Vc(c), null === c.blockedOn && $17f526922e4a857c$var$Qc.shift();
}
var $17f526922e4a857c$var$cd = $17f526922e4a857c$var$ua.ReactCurrentBatchConfig, $17f526922e4a857c$var$dd = !0;
function $17f526922e4a857c$var$ed(a, b, c, d) {
    var e = $17f526922e4a857c$var$C, f = $17f526922e4a857c$var$cd.transition;
    $17f526922e4a857c$var$cd.transition = null;
    try {
        $17f526922e4a857c$var$C = 1, $17f526922e4a857c$var$fd(a, b, c, d);
    } finally{
        $17f526922e4a857c$var$C = e, $17f526922e4a857c$var$cd.transition = f;
    }
}
function $17f526922e4a857c$var$gd(a, b, c, d) {
    var e = $17f526922e4a857c$var$C, f = $17f526922e4a857c$var$cd.transition;
    $17f526922e4a857c$var$cd.transition = null;
    try {
        $17f526922e4a857c$var$C = 4, $17f526922e4a857c$var$fd(a, b, c, d);
    } finally{
        $17f526922e4a857c$var$C = e, $17f526922e4a857c$var$cd.transition = f;
    }
}
function $17f526922e4a857c$var$fd(a, b, c, d) {
    if ($17f526922e4a857c$var$dd) {
        var e = $17f526922e4a857c$var$Yc(a, b, c, d);
        if (null === e) $17f526922e4a857c$var$hd(a, b, d, $17f526922e4a857c$var$id, c), $17f526922e4a857c$var$Sc(a, d);
        else if ($17f526922e4a857c$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($17f526922e4a857c$var$Sc(a, d), b & 4 && -1 < $17f526922e4a857c$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $17f526922e4a857c$var$Cb(e);
                null !== f && $17f526922e4a857c$var$Ec(f);
                f = $17f526922e4a857c$var$Yc(a, b, c, d);
                null === f && $17f526922e4a857c$var$hd(a, b, d, $17f526922e4a857c$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $17f526922e4a857c$var$hd(a, b, d, null, c);
    }
}
var $17f526922e4a857c$var$id = null;
function $17f526922e4a857c$var$Yc(a, b, c, d) {
    $17f526922e4a857c$var$id = null;
    a = $17f526922e4a857c$var$xb(d);
    a = $17f526922e4a857c$var$Wc(a);
    if (null !== a) {
        if (b = $17f526922e4a857c$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $17f526922e4a857c$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $17f526922e4a857c$var$id = a;
    return null;
}
function $17f526922e4a857c$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($17f526922e4a857c$var$ec()){
                case $17f526922e4a857c$var$fc:
                    return 1;
                case $17f526922e4a857c$var$gc:
                    return 4;
                case $17f526922e4a857c$var$hc:
                case $17f526922e4a857c$var$ic:
                    return 16;
                case $17f526922e4a857c$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $17f526922e4a857c$var$kd = null, $17f526922e4a857c$var$ld = null, $17f526922e4a857c$var$md = null;
function $17f526922e4a857c$var$nd() {
    if ($17f526922e4a857c$var$md) return $17f526922e4a857c$var$md;
    var a, b = $17f526922e4a857c$var$ld, c = b.length, d, e = "value" in $17f526922e4a857c$var$kd ? $17f526922e4a857c$var$kd.value : $17f526922e4a857c$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $17f526922e4a857c$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $17f526922e4a857c$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $17f526922e4a857c$var$pd() {
    return !0;
}
function $17f526922e4a857c$var$qd() {
    return !1;
}
function $17f526922e4a857c$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $17f526922e4a857c$var$pd : $17f526922e4a857c$var$qd;
        this.isPropagationStopped = $17f526922e4a857c$var$qd;
        return this;
    }
    $17f526922e4a857c$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $17f526922e4a857c$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $17f526922e4a857c$var$pd);
        },
        persist: function() {},
        isPersistent: $17f526922e4a857c$var$pd
    });
    return b;
}
var $17f526922e4a857c$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $17f526922e4a857c$var$td = $17f526922e4a857c$var$rd($17f526922e4a857c$var$sd), $17f526922e4a857c$var$ud = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$sd, {
    view: 0,
    detail: 0
}), $17f526922e4a857c$var$vd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$ud), $17f526922e4a857c$var$wd, $17f526922e4a857c$var$xd, $17f526922e4a857c$var$yd, $17f526922e4a857c$var$Ad = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $17f526922e4a857c$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $17f526922e4a857c$var$yd && ($17f526922e4a857c$var$yd && "mousemove" === a.type ? ($17f526922e4a857c$var$wd = a.screenX - $17f526922e4a857c$var$yd.screenX, $17f526922e4a857c$var$xd = a.screenY - $17f526922e4a857c$var$yd.screenY) : $17f526922e4a857c$var$xd = $17f526922e4a857c$var$wd = 0, $17f526922e4a857c$var$yd = a);
        return $17f526922e4a857c$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $17f526922e4a857c$var$xd;
    }
}), $17f526922e4a857c$var$Bd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Ad), $17f526922e4a857c$var$Cd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$Ad, {
    dataTransfer: 0
}), $17f526922e4a857c$var$Dd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Cd), $17f526922e4a857c$var$Ed = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$ud, {
    relatedTarget: 0
}), $17f526922e4a857c$var$Fd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Ed), $17f526922e4a857c$var$Gd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $17f526922e4a857c$var$Hd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Gd), $17f526922e4a857c$var$Id = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $17f526922e4a857c$var$Jd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Id), $17f526922e4a857c$var$Kd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$sd, {
    data: 0
}), $17f526922e4a857c$var$Ld = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Kd), $17f526922e4a857c$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $17f526922e4a857c$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $17f526922e4a857c$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $17f526922e4a857c$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $17f526922e4a857c$var$Od[a]) ? !!b[a] : !1;
}
function $17f526922e4a857c$var$zd() {
    return $17f526922e4a857c$var$Pd;
}
var $17f526922e4a857c$var$Qd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $17f526922e4a857c$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $17f526922e4a857c$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $17f526922e4a857c$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $17f526922e4a857c$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $17f526922e4a857c$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $17f526922e4a857c$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $17f526922e4a857c$var$Rd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Qd), $17f526922e4a857c$var$Sd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $17f526922e4a857c$var$Td = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Sd), $17f526922e4a857c$var$Ud = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $17f526922e4a857c$var$zd
}), $17f526922e4a857c$var$Vd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Ud), $17f526922e4a857c$var$Wd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $17f526922e4a857c$var$Xd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Wd), $17f526922e4a857c$var$Yd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $17f526922e4a857c$var$Zd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Yd), $17f526922e4a857c$var$$d = [
    9,
    13,
    27,
    32
], $17f526922e4a857c$var$ae = $17f526922e4a857c$var$ia && "CompositionEvent" in window, $17f526922e4a857c$var$be = null;
$17f526922e4a857c$var$ia && "documentMode" in document && ($17f526922e4a857c$var$be = document.documentMode);
var $17f526922e4a857c$var$ce = $17f526922e4a857c$var$ia && "TextEvent" in window && !$17f526922e4a857c$var$be, $17f526922e4a857c$var$de = $17f526922e4a857c$var$ia && (!$17f526922e4a857c$var$ae || $17f526922e4a857c$var$be && 8 < $17f526922e4a857c$var$be && 11 >= $17f526922e4a857c$var$be), $17f526922e4a857c$var$ee = String.fromCharCode(32), $17f526922e4a857c$var$fe = !1;
function $17f526922e4a857c$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $17f526922e4a857c$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $17f526922e4a857c$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $17f526922e4a857c$var$ie = !1;
function $17f526922e4a857c$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $17f526922e4a857c$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $17f526922e4a857c$var$fe = !0;
            return $17f526922e4a857c$var$ee;
        case "textInput":
            return a = b.data, a === $17f526922e4a857c$var$ee && $17f526922e4a857c$var$fe ? null : a;
        default:
            return null;
    }
}
function $17f526922e4a857c$var$ke(a, b) {
    if ($17f526922e4a857c$var$ie) return "compositionend" === a || !$17f526922e4a857c$var$ae && $17f526922e4a857c$var$ge(a, b) ? (a = $17f526922e4a857c$var$nd(), $17f526922e4a857c$var$md = $17f526922e4a857c$var$ld = $17f526922e4a857c$var$kd = null, $17f526922e4a857c$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $17f526922e4a857c$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $17f526922e4a857c$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $17f526922e4a857c$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$17f526922e4a857c$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $17f526922e4a857c$var$ne(a, b, c, d) {
    $17f526922e4a857c$var$Eb(d);
    b = $17f526922e4a857c$var$oe(b, "onChange");
    0 < b.length && (c = new $17f526922e4a857c$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $17f526922e4a857c$var$pe = null, $17f526922e4a857c$var$qe = null;
function $17f526922e4a857c$var$re(a) {
    $17f526922e4a857c$var$se(a, 0);
}
function $17f526922e4a857c$var$te(a) {
    var b = $17f526922e4a857c$var$ue(a);
    if ($17f526922e4a857c$var$Wa(b)) return a;
}
function $17f526922e4a857c$var$ve(a, b) {
    if ("change" === a) return b;
}
var $17f526922e4a857c$var$we = !1;
if ($17f526922e4a857c$var$ia) {
    var $17f526922e4a857c$var$xe;
    if ($17f526922e4a857c$var$ia) {
        var $17f526922e4a857c$var$ye = "oninput" in document;
        if (!$17f526922e4a857c$var$ye) {
            var $17f526922e4a857c$var$ze = document.createElement("div");
            $17f526922e4a857c$var$ze.setAttribute("oninput", "return;");
            $17f526922e4a857c$var$ye = "function" === typeof $17f526922e4a857c$var$ze.oninput;
        }
        $17f526922e4a857c$var$xe = $17f526922e4a857c$var$ye;
    } else $17f526922e4a857c$var$xe = !1;
    $17f526922e4a857c$var$we = $17f526922e4a857c$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $17f526922e4a857c$var$Ae() {
    $17f526922e4a857c$var$pe && ($17f526922e4a857c$var$pe.detachEvent("onpropertychange", $17f526922e4a857c$var$Be), $17f526922e4a857c$var$qe = $17f526922e4a857c$var$pe = null);
}
function $17f526922e4a857c$var$Be(a) {
    if ("value" === a.propertyName && $17f526922e4a857c$var$te($17f526922e4a857c$var$qe)) {
        var b = [];
        $17f526922e4a857c$var$ne(b, $17f526922e4a857c$var$qe, a, $17f526922e4a857c$var$xb(a));
        $17f526922e4a857c$var$Jb($17f526922e4a857c$var$re, b);
    }
}
function $17f526922e4a857c$var$Ce(a, b, c) {
    "focusin" === a ? ($17f526922e4a857c$var$Ae(), $17f526922e4a857c$var$pe = b, $17f526922e4a857c$var$qe = c, $17f526922e4a857c$var$pe.attachEvent("onpropertychange", $17f526922e4a857c$var$Be)) : "focusout" === a && $17f526922e4a857c$var$Ae();
}
function $17f526922e4a857c$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $17f526922e4a857c$var$te($17f526922e4a857c$var$qe);
}
function $17f526922e4a857c$var$Ee(a, b) {
    if ("click" === a) return $17f526922e4a857c$var$te(b);
}
function $17f526922e4a857c$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $17f526922e4a857c$var$te(b);
}
function $17f526922e4a857c$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $17f526922e4a857c$var$He = "function" === typeof Object.is ? Object.is : $17f526922e4a857c$var$Ge;
function $17f526922e4a857c$var$Ie(a, b) {
    if ($17f526922e4a857c$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$17f526922e4a857c$var$ja.call(b, e) || !$17f526922e4a857c$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $17f526922e4a857c$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $17f526922e4a857c$var$Ke(a, b) {
    var c = $17f526922e4a857c$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $17f526922e4a857c$var$Je(c);
    }
}
function $17f526922e4a857c$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $17f526922e4a857c$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $17f526922e4a857c$var$Me() {
    for(var a = window, b = $17f526922e4a857c$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $17f526922e4a857c$var$Xa(a.document);
    }
    return b;
}
function $17f526922e4a857c$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $17f526922e4a857c$var$Oe(a) {
    var b = $17f526922e4a857c$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $17f526922e4a857c$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $17f526922e4a857c$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $17f526922e4a857c$var$Ke(c, f);
                var g = $17f526922e4a857c$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $17f526922e4a857c$var$Pe = $17f526922e4a857c$var$ia && "documentMode" in document && 11 >= document.documentMode, $17f526922e4a857c$var$Qe = null, $17f526922e4a857c$var$Re = null, $17f526922e4a857c$var$Se = null, $17f526922e4a857c$var$Te = !1;
function $17f526922e4a857c$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $17f526922e4a857c$var$Te || null == $17f526922e4a857c$var$Qe || $17f526922e4a857c$var$Qe !== $17f526922e4a857c$var$Xa(d) || (d = $17f526922e4a857c$var$Qe, "selectionStart" in d && $17f526922e4a857c$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $17f526922e4a857c$var$Se && $17f526922e4a857c$var$Ie($17f526922e4a857c$var$Se, d) || ($17f526922e4a857c$var$Se = d, d = $17f526922e4a857c$var$oe($17f526922e4a857c$var$Re, "onSelect"), 0 < d.length && (b = new $17f526922e4a857c$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $17f526922e4a857c$var$Qe)));
}
function $17f526922e4a857c$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $17f526922e4a857c$var$We = {
    animationend: $17f526922e4a857c$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $17f526922e4a857c$var$Ve("Animation", "AnimationIteration"),
    animationstart: $17f526922e4a857c$var$Ve("Animation", "AnimationStart"),
    transitionend: $17f526922e4a857c$var$Ve("Transition", "TransitionEnd")
}, $17f526922e4a857c$var$Xe = {}, $17f526922e4a857c$var$Ye = {};
$17f526922e4a857c$var$ia && ($17f526922e4a857c$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $17f526922e4a857c$var$We.animationend.animation, delete $17f526922e4a857c$var$We.animationiteration.animation, delete $17f526922e4a857c$var$We.animationstart.animation), "TransitionEvent" in window || delete $17f526922e4a857c$var$We.transitionend.transition);
function $17f526922e4a857c$var$Ze(a) {
    if ($17f526922e4a857c$var$Xe[a]) return $17f526922e4a857c$var$Xe[a];
    if (!$17f526922e4a857c$var$We[a]) return a;
    var b = $17f526922e4a857c$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $17f526922e4a857c$var$Ye) return $17f526922e4a857c$var$Xe[a] = b[c];
    return a;
}
var $17f526922e4a857c$var$$e = $17f526922e4a857c$var$Ze("animationend"), $17f526922e4a857c$var$af = $17f526922e4a857c$var$Ze("animationiteration"), $17f526922e4a857c$var$bf = $17f526922e4a857c$var$Ze("animationstart"), $17f526922e4a857c$var$cf = $17f526922e4a857c$var$Ze("transitionend"), $17f526922e4a857c$var$df = new Map, $17f526922e4a857c$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $17f526922e4a857c$var$ff(a, b) {
    $17f526922e4a857c$var$df.set(a, b);
    $17f526922e4a857c$var$fa(b, [
        a
    ]);
}
for(var $17f526922e4a857c$var$gf = 0; $17f526922e4a857c$var$gf < $17f526922e4a857c$var$ef.length; $17f526922e4a857c$var$gf++){
    var $17f526922e4a857c$var$hf = $17f526922e4a857c$var$ef[$17f526922e4a857c$var$gf], $17f526922e4a857c$var$jf = $17f526922e4a857c$var$hf.toLowerCase(), $17f526922e4a857c$var$kf = $17f526922e4a857c$var$hf[0].toUpperCase() + $17f526922e4a857c$var$hf.slice(1);
    $17f526922e4a857c$var$ff($17f526922e4a857c$var$jf, "on" + $17f526922e4a857c$var$kf);
}
$17f526922e4a857c$var$ff($17f526922e4a857c$var$$e, "onAnimationEnd");
$17f526922e4a857c$var$ff($17f526922e4a857c$var$af, "onAnimationIteration");
$17f526922e4a857c$var$ff($17f526922e4a857c$var$bf, "onAnimationStart");
$17f526922e4a857c$var$ff("dblclick", "onDoubleClick");
$17f526922e4a857c$var$ff("focusin", "onFocus");
$17f526922e4a857c$var$ff("focusout", "onBlur");
$17f526922e4a857c$var$ff($17f526922e4a857c$var$cf, "onTransitionEnd");
$17f526922e4a857c$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$17f526922e4a857c$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$17f526922e4a857c$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$17f526922e4a857c$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$17f526922e4a857c$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$17f526922e4a857c$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$17f526922e4a857c$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$17f526922e4a857c$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$17f526922e4a857c$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$17f526922e4a857c$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $17f526922e4a857c$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $17f526922e4a857c$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($17f526922e4a857c$var$lf));
function $17f526922e4a857c$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $17f526922e4a857c$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $17f526922e4a857c$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $17f526922e4a857c$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $17f526922e4a857c$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($17f526922e4a857c$var$Qb) throw a = $17f526922e4a857c$var$Rb, $17f526922e4a857c$var$Qb = !1, $17f526922e4a857c$var$Rb = null, a;
}
function $17f526922e4a857c$var$D(a, b) {
    var c = b[$17f526922e4a857c$var$of];
    void 0 === c && (c = b[$17f526922e4a857c$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($17f526922e4a857c$var$pf(b, a, 2, !1), c.add(d));
}
function $17f526922e4a857c$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $17f526922e4a857c$var$pf(c, a, d, b);
}
var $17f526922e4a857c$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $17f526922e4a857c$var$sf(a) {
    if (!a[$17f526922e4a857c$var$rf]) {
        a[$17f526922e4a857c$var$rf] = !0;
        $17f526922e4a857c$var$da.forEach(function(b) {
            "selectionchange" !== b && ($17f526922e4a857c$var$mf.has(b) || $17f526922e4a857c$var$qf(b, !1, a), $17f526922e4a857c$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$17f526922e4a857c$var$rf] || (b[$17f526922e4a857c$var$rf] = !0, $17f526922e4a857c$var$qf("selectionchange", !1, b));
    }
}
function $17f526922e4a857c$var$pf(a, b, c, d) {
    switch($17f526922e4a857c$var$jd(b)){
        case 1:
            var e = $17f526922e4a857c$var$ed;
            break;
        case 4:
            e = $17f526922e4a857c$var$gd;
            break;
        default:
            e = $17f526922e4a857c$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$17f526922e4a857c$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $17f526922e4a857c$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $17f526922e4a857c$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $17f526922e4a857c$var$Jb(function() {
        var d = f, e = $17f526922e4a857c$var$xb(c), g = [];
        a: {
            var h = $17f526922e4a857c$var$df.get(a);
            if (void 0 !== h) {
                var k = $17f526922e4a857c$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $17f526922e4a857c$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $17f526922e4a857c$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $17f526922e4a857c$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $17f526922e4a857c$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $17f526922e4a857c$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $17f526922e4a857c$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $17f526922e4a857c$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $17f526922e4a857c$var$Vd;
                        break;
                    case $17f526922e4a857c$var$$e:
                    case $17f526922e4a857c$var$af:
                    case $17f526922e4a857c$var$bf:
                        k = $17f526922e4a857c$var$Hd;
                        break;
                    case $17f526922e4a857c$var$cf:
                        k = $17f526922e4a857c$var$Xd;
                        break;
                    case "scroll":
                        k = $17f526922e4a857c$var$vd;
                        break;
                    case "wheel":
                        k = $17f526922e4a857c$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $17f526922e4a857c$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $17f526922e4a857c$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $17f526922e4a857c$var$Kb(w, x), null != F && t.push($17f526922e4a857c$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $17f526922e4a857c$var$wb && (n = c.relatedTarget || c.fromElement) && ($17f526922e4a857c$var$Wc(n) || n[$17f526922e4a857c$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $17f526922e4a857c$var$Wc(n) : null, null !== n && (J = $17f526922e4a857c$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $17f526922e4a857c$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $17f526922e4a857c$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $17f526922e4a857c$var$ue(k);
                        u = null == n ? h : $17f526922e4a857c$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $17f526922e4a857c$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $17f526922e4a857c$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $17f526922e4a857c$var$vf(F))u++;
                            for(; 0 < w - u;)t = $17f526922e4a857c$var$vf(t), w--;
                            for(; 0 < u - w;)x = $17f526922e4a857c$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $17f526922e4a857c$var$vf(t);
                                x = $17f526922e4a857c$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $17f526922e4a857c$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $17f526922e4a857c$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $17f526922e4a857c$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $17f526922e4a857c$var$ve;
                else if ($17f526922e4a857c$var$me(h)) {
                    if ($17f526922e4a857c$var$we) na = $17f526922e4a857c$var$Fe;
                    else {
                        na = $17f526922e4a857c$var$De;
                        var xa = $17f526922e4a857c$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $17f526922e4a857c$var$Ee);
                if (na && (na = na(a, d))) {
                    $17f526922e4a857c$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $17f526922e4a857c$var$cb(h, "number", h.value);
            }
            xa = d ? $17f526922e4a857c$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($17f526922e4a857c$var$me(xa) || "true" === xa.contentEditable) $17f526922e4a857c$var$Qe = xa, $17f526922e4a857c$var$Re = d, $17f526922e4a857c$var$Se = null;
                    break;
                case "focusout":
                    $17f526922e4a857c$var$Se = $17f526922e4a857c$var$Re = $17f526922e4a857c$var$Qe = null;
                    break;
                case "mousedown":
                    $17f526922e4a857c$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $17f526922e4a857c$var$Te = !1;
                    $17f526922e4a857c$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($17f526922e4a857c$var$Pe) break;
                case "keydown":
                case "keyup":
                    $17f526922e4a857c$var$Ue(g, c, e);
            }
            var $a;
            if ($17f526922e4a857c$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $17f526922e4a857c$var$ie ? $17f526922e4a857c$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($17f526922e4a857c$var$de && "ko" !== c.locale && ($17f526922e4a857c$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $17f526922e4a857c$var$ie && ($a = $17f526922e4a857c$var$nd()) : ($17f526922e4a857c$var$kd = e, $17f526922e4a857c$var$ld = "value" in $17f526922e4a857c$var$kd ? $17f526922e4a857c$var$kd.value : $17f526922e4a857c$var$kd.textContent, $17f526922e4a857c$var$ie = !0)), xa = $17f526922e4a857c$var$oe(d, ba), 0 < xa.length && (ba = new $17f526922e4a857c$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $17f526922e4a857c$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $17f526922e4a857c$var$ce ? $17f526922e4a857c$var$je(a, c) : $17f526922e4a857c$var$ke(a, c)) d = $17f526922e4a857c$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $17f526922e4a857c$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $17f526922e4a857c$var$se(g, b);
    });
}
function $17f526922e4a857c$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $17f526922e4a857c$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $17f526922e4a857c$var$Kb(a, c), null != f && d.unshift($17f526922e4a857c$var$tf(a, f, e)), f = $17f526922e4a857c$var$Kb(a, b), null != f && d.push($17f526922e4a857c$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $17f526922e4a857c$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $17f526922e4a857c$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $17f526922e4a857c$var$Kb(c, f), null != k && g.unshift($17f526922e4a857c$var$tf(c, k, h))) : e || (k = $17f526922e4a857c$var$Kb(c, f), null != k && g.push($17f526922e4a857c$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $17f526922e4a857c$var$xf = /\r\n?/g, $17f526922e4a857c$var$yf = /\u0000|\uFFFD/g;
function $17f526922e4a857c$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($17f526922e4a857c$var$xf, "\n").replace($17f526922e4a857c$var$yf, "");
}
function $17f526922e4a857c$var$Af(a, b, c) {
    b = $17f526922e4a857c$var$zf(b);
    if ($17f526922e4a857c$var$zf(a) !== b && c) throw Error($17f526922e4a857c$var$p(425));
}
function $17f526922e4a857c$var$Bf() {}
var $17f526922e4a857c$var$Cf = null, $17f526922e4a857c$var$Df = null;
function $17f526922e4a857c$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $17f526922e4a857c$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $17f526922e4a857c$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $17f526922e4a857c$var$Hf = "function" === typeof Promise ? Promise : void 0, $17f526922e4a857c$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $17f526922e4a857c$var$Hf ? function(a) {
    return $17f526922e4a857c$var$Hf.resolve(null).then(a).catch($17f526922e4a857c$var$If);
} : $17f526922e4a857c$var$Ff;
function $17f526922e4a857c$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $17f526922e4a857c$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $17f526922e4a857c$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $17f526922e4a857c$var$bd(b);
}
function $17f526922e4a857c$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $17f526922e4a857c$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $17f526922e4a857c$var$Nf = Math.random().toString(36).slice(2), $17f526922e4a857c$var$Of = "__reactFiber$" + $17f526922e4a857c$var$Nf, $17f526922e4a857c$var$Pf = "__reactProps$" + $17f526922e4a857c$var$Nf, $17f526922e4a857c$var$uf = "__reactContainer$" + $17f526922e4a857c$var$Nf, $17f526922e4a857c$var$of = "__reactEvents$" + $17f526922e4a857c$var$Nf, $17f526922e4a857c$var$Qf = "__reactListeners$" + $17f526922e4a857c$var$Nf, $17f526922e4a857c$var$Rf = "__reactHandles$" + $17f526922e4a857c$var$Nf;
function $17f526922e4a857c$var$Wc(a) {
    var b = a[$17f526922e4a857c$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$17f526922e4a857c$var$uf] || c[$17f526922e4a857c$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $17f526922e4a857c$var$Mf(a); null !== a;){
                if (c = a[$17f526922e4a857c$var$Of]) return c;
                a = $17f526922e4a857c$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $17f526922e4a857c$var$Cb(a) {
    a = a[$17f526922e4a857c$var$Of] || a[$17f526922e4a857c$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $17f526922e4a857c$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($17f526922e4a857c$var$p(33));
}
function $17f526922e4a857c$var$Db(a) {
    return a[$17f526922e4a857c$var$Pf] || null;
}
var $17f526922e4a857c$var$Sf = [], $17f526922e4a857c$var$Tf = -1;
function $17f526922e4a857c$var$Uf(a) {
    return {
        current: a
    };
}
function $17f526922e4a857c$var$E(a) {
    0 > $17f526922e4a857c$var$Tf || (a.current = $17f526922e4a857c$var$Sf[$17f526922e4a857c$var$Tf], $17f526922e4a857c$var$Sf[$17f526922e4a857c$var$Tf] = null, $17f526922e4a857c$var$Tf--);
}
function $17f526922e4a857c$var$G(a, b) {
    $17f526922e4a857c$var$Tf++;
    $17f526922e4a857c$var$Sf[$17f526922e4a857c$var$Tf] = a.current;
    a.current = b;
}
var $17f526922e4a857c$var$Vf = {}, $17f526922e4a857c$var$H = $17f526922e4a857c$var$Uf($17f526922e4a857c$var$Vf), $17f526922e4a857c$var$Wf = $17f526922e4a857c$var$Uf(!1), $17f526922e4a857c$var$Xf = $17f526922e4a857c$var$Vf;
function $17f526922e4a857c$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $17f526922e4a857c$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $17f526922e4a857c$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $17f526922e4a857c$var$$f() {
    $17f526922e4a857c$var$E($17f526922e4a857c$var$Wf);
    $17f526922e4a857c$var$E($17f526922e4a857c$var$H);
}
function $17f526922e4a857c$var$ag(a, b, c) {
    if ($17f526922e4a857c$var$H.current !== $17f526922e4a857c$var$Vf) throw Error($17f526922e4a857c$var$p(168));
    $17f526922e4a857c$var$G($17f526922e4a857c$var$H, b);
    $17f526922e4a857c$var$G($17f526922e4a857c$var$Wf, c);
}
function $17f526922e4a857c$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($17f526922e4a857c$var$p(108, $17f526922e4a857c$var$Ra(a) || "Unknown", e));
    return $17f526922e4a857c$var$A({}, c, d);
}
function $17f526922e4a857c$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $17f526922e4a857c$var$Vf;
    $17f526922e4a857c$var$Xf = $17f526922e4a857c$var$H.current;
    $17f526922e4a857c$var$G($17f526922e4a857c$var$H, a);
    $17f526922e4a857c$var$G($17f526922e4a857c$var$Wf, $17f526922e4a857c$var$Wf.current);
    return !0;
}
function $17f526922e4a857c$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($17f526922e4a857c$var$p(169));
    c ? (a = $17f526922e4a857c$var$bg(a, b, $17f526922e4a857c$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $17f526922e4a857c$var$E($17f526922e4a857c$var$Wf), $17f526922e4a857c$var$E($17f526922e4a857c$var$H), $17f526922e4a857c$var$G($17f526922e4a857c$var$H, a)) : $17f526922e4a857c$var$E($17f526922e4a857c$var$Wf);
    $17f526922e4a857c$var$G($17f526922e4a857c$var$Wf, c);
}
var $17f526922e4a857c$var$eg = null, $17f526922e4a857c$var$fg = !1, $17f526922e4a857c$var$gg = !1;
function $17f526922e4a857c$var$hg(a) {
    null === $17f526922e4a857c$var$eg ? $17f526922e4a857c$var$eg = [
        a
    ] : $17f526922e4a857c$var$eg.push(a);
}
function $17f526922e4a857c$var$ig(a) {
    $17f526922e4a857c$var$fg = !0;
    $17f526922e4a857c$var$hg(a);
}
function $17f526922e4a857c$var$jg() {
    if (!$17f526922e4a857c$var$gg && null !== $17f526922e4a857c$var$eg) {
        $17f526922e4a857c$var$gg = !0;
        var a = 0, b = $17f526922e4a857c$var$C;
        try {
            var c = $17f526922e4a857c$var$eg;
            for($17f526922e4a857c$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $17f526922e4a857c$var$eg = null;
            $17f526922e4a857c$var$fg = !1;
        } catch (e) {
            throw null !== $17f526922e4a857c$var$eg && ($17f526922e4a857c$var$eg = $17f526922e4a857c$var$eg.slice(a + 1)), $17f526922e4a857c$var$ac($17f526922e4a857c$var$fc, $17f526922e4a857c$var$jg), e;
        } finally{
            $17f526922e4a857c$var$C = b, $17f526922e4a857c$var$gg = !1;
        }
    }
    return null;
}
var $17f526922e4a857c$var$kg = [], $17f526922e4a857c$var$lg = 0, $17f526922e4a857c$var$mg = null, $17f526922e4a857c$var$ng = 0, $17f526922e4a857c$var$og = [], $17f526922e4a857c$var$pg = 0, $17f526922e4a857c$var$qg = null, $17f526922e4a857c$var$rg = 1, $17f526922e4a857c$var$sg = "";
function $17f526922e4a857c$var$tg(a, b) {
    $17f526922e4a857c$var$kg[$17f526922e4a857c$var$lg++] = $17f526922e4a857c$var$ng;
    $17f526922e4a857c$var$kg[$17f526922e4a857c$var$lg++] = $17f526922e4a857c$var$mg;
    $17f526922e4a857c$var$mg = a;
    $17f526922e4a857c$var$ng = b;
}
function $17f526922e4a857c$var$ug(a, b, c) {
    $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg++] = $17f526922e4a857c$var$rg;
    $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg++] = $17f526922e4a857c$var$sg;
    $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg++] = $17f526922e4a857c$var$qg;
    $17f526922e4a857c$var$qg = a;
    var d = $17f526922e4a857c$var$rg;
    a = $17f526922e4a857c$var$sg;
    var e = 32 - $17f526922e4a857c$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $17f526922e4a857c$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $17f526922e4a857c$var$rg = 1 << 32 - $17f526922e4a857c$var$oc(b) + e | c << e | d;
        $17f526922e4a857c$var$sg = f + a;
    } else $17f526922e4a857c$var$rg = 1 << f | c << e | d, $17f526922e4a857c$var$sg = a;
}
function $17f526922e4a857c$var$vg(a) {
    null !== a.return && ($17f526922e4a857c$var$tg(a, 1), $17f526922e4a857c$var$ug(a, 1, 0));
}
function $17f526922e4a857c$var$wg(a) {
    for(; a === $17f526922e4a857c$var$mg;)$17f526922e4a857c$var$mg = $17f526922e4a857c$var$kg[--$17f526922e4a857c$var$lg], $17f526922e4a857c$var$kg[$17f526922e4a857c$var$lg] = null, $17f526922e4a857c$var$ng = $17f526922e4a857c$var$kg[--$17f526922e4a857c$var$lg], $17f526922e4a857c$var$kg[$17f526922e4a857c$var$lg] = null;
    for(; a === $17f526922e4a857c$var$qg;)$17f526922e4a857c$var$qg = $17f526922e4a857c$var$og[--$17f526922e4a857c$var$pg], $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg] = null, $17f526922e4a857c$var$sg = $17f526922e4a857c$var$og[--$17f526922e4a857c$var$pg], $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg] = null, $17f526922e4a857c$var$rg = $17f526922e4a857c$var$og[--$17f526922e4a857c$var$pg], $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg] = null;
}
var $17f526922e4a857c$var$xg = null, $17f526922e4a857c$var$yg = null, $17f526922e4a857c$var$I = !1, $17f526922e4a857c$var$zg = null;
function $17f526922e4a857c$var$Ag(a, b) {
    var c = $17f526922e4a857c$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $17f526922e4a857c$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $17f526922e4a857c$var$xg = a, $17f526922e4a857c$var$yg = $17f526922e4a857c$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $17f526922e4a857c$var$xg = a, $17f526922e4a857c$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $17f526922e4a857c$var$qg ? {
                id: $17f526922e4a857c$var$rg,
                overflow: $17f526922e4a857c$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $17f526922e4a857c$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $17f526922e4a857c$var$xg = a, $17f526922e4a857c$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $17f526922e4a857c$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $17f526922e4a857c$var$Eg(a) {
    if ($17f526922e4a857c$var$I) {
        var b = $17f526922e4a857c$var$yg;
        if (b) {
            var c = b;
            if (!$17f526922e4a857c$var$Cg(a, b)) {
                if ($17f526922e4a857c$var$Dg(a)) throw Error($17f526922e4a857c$var$p(418));
                b = $17f526922e4a857c$var$Lf(c.nextSibling);
                var d = $17f526922e4a857c$var$xg;
                b && $17f526922e4a857c$var$Cg(a, b) ? $17f526922e4a857c$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $17f526922e4a857c$var$I = !1, $17f526922e4a857c$var$xg = a);
            }
        } else {
            if ($17f526922e4a857c$var$Dg(a)) throw Error($17f526922e4a857c$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $17f526922e4a857c$var$I = !1;
            $17f526922e4a857c$var$xg = a;
        }
    }
}
function $17f526922e4a857c$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $17f526922e4a857c$var$xg = a;
}
function $17f526922e4a857c$var$Gg(a) {
    if (a !== $17f526922e4a857c$var$xg) return !1;
    if (!$17f526922e4a857c$var$I) return $17f526922e4a857c$var$Fg(a), $17f526922e4a857c$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$17f526922e4a857c$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $17f526922e4a857c$var$yg)) {
        if ($17f526922e4a857c$var$Dg(a)) throw $17f526922e4a857c$var$Hg(), Error($17f526922e4a857c$var$p(418));
        for(; b;)$17f526922e4a857c$var$Ag(a, b), b = $17f526922e4a857c$var$Lf(b.nextSibling);
    }
    $17f526922e4a857c$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($17f526922e4a857c$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $17f526922e4a857c$var$yg = $17f526922e4a857c$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $17f526922e4a857c$var$yg = null;
        }
    } else $17f526922e4a857c$var$yg = $17f526922e4a857c$var$xg ? $17f526922e4a857c$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $17f526922e4a857c$var$Hg() {
    for(var a = $17f526922e4a857c$var$yg; a;)a = $17f526922e4a857c$var$Lf(a.nextSibling);
}
function $17f526922e4a857c$var$Ig() {
    $17f526922e4a857c$var$yg = $17f526922e4a857c$var$xg = null;
    $17f526922e4a857c$var$I = !1;
}
function $17f526922e4a857c$var$Jg(a) {
    null === $17f526922e4a857c$var$zg ? $17f526922e4a857c$var$zg = [
        a
    ] : $17f526922e4a857c$var$zg.push(a);
}
var $17f526922e4a857c$var$Kg = $17f526922e4a857c$var$ua.ReactCurrentBatchConfig;
function $17f526922e4a857c$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $17f526922e4a857c$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $17f526922e4a857c$var$Mg = $17f526922e4a857c$var$Uf(null), $17f526922e4a857c$var$Ng = null, $17f526922e4a857c$var$Og = null, $17f526922e4a857c$var$Pg = null;
function $17f526922e4a857c$var$Qg() {
    $17f526922e4a857c$var$Pg = $17f526922e4a857c$var$Og = $17f526922e4a857c$var$Ng = null;
}
function $17f526922e4a857c$var$Rg(a) {
    var b = $17f526922e4a857c$var$Mg.current;
    $17f526922e4a857c$var$E($17f526922e4a857c$var$Mg);
    a._currentValue = b;
}
function $17f526922e4a857c$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $17f526922e4a857c$var$Tg(a, b) {
    $17f526922e4a857c$var$Ng = a;
    $17f526922e4a857c$var$Pg = $17f526922e4a857c$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($17f526922e4a857c$var$Ug = !0), a.firstContext = null);
}
function $17f526922e4a857c$var$Vg(a) {
    var b = a._currentValue;
    if ($17f526922e4a857c$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $17f526922e4a857c$var$Og) {
            if (null === $17f526922e4a857c$var$Ng) throw Error($17f526922e4a857c$var$p(308));
            $17f526922e4a857c$var$Og = a;
            $17f526922e4a857c$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $17f526922e4a857c$var$Og = $17f526922e4a857c$var$Og.next = a;
    }
    return b;
}
var $17f526922e4a857c$var$Wg = null;
function $17f526922e4a857c$var$Xg(a) {
    null === $17f526922e4a857c$var$Wg ? $17f526922e4a857c$var$Wg = [
        a
    ] : $17f526922e4a857c$var$Wg.push(a);
}
function $17f526922e4a857c$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $17f526922e4a857c$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $17f526922e4a857c$var$Zg(a, d);
}
function $17f526922e4a857c$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $17f526922e4a857c$var$$g = !1;
function $17f526922e4a857c$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $17f526922e4a857c$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $17f526922e4a857c$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $17f526922e4a857c$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($17f526922e4a857c$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $17f526922e4a857c$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $17f526922e4a857c$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $17f526922e4a857c$var$Zg(a, c);
}
function $17f526922e4a857c$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $17f526922e4a857c$var$Cc(a, c);
    }
}
function $17f526922e4a857c$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $17f526922e4a857c$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $17f526922e4a857c$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $17f526922e4a857c$var$A({}, q, r);
                            break a;
                        case 2:
                            $17f526922e4a857c$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $17f526922e4a857c$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $17f526922e4a857c$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($17f526922e4a857c$var$p(191, e));
            e.call(d);
        }
    }
}
var $17f526922e4a857c$var$jh = (new $8NFma.Component).refs;
function $17f526922e4a857c$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $17f526922e4a857c$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $17f526922e4a857c$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $17f526922e4a857c$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $17f526922e4a857c$var$L(), e = $17f526922e4a857c$var$lh(a), f = $17f526922e4a857c$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $17f526922e4a857c$var$dh(a, f, e);
        null !== b && ($17f526922e4a857c$var$mh(b, a, e, d), $17f526922e4a857c$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $17f526922e4a857c$var$L(), e = $17f526922e4a857c$var$lh(a), f = $17f526922e4a857c$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $17f526922e4a857c$var$dh(a, f, e);
        null !== b && ($17f526922e4a857c$var$mh(b, a, e, d), $17f526922e4a857c$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $17f526922e4a857c$var$L(), d = $17f526922e4a857c$var$lh(a), e = $17f526922e4a857c$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $17f526922e4a857c$var$dh(a, e, d);
        null !== b && ($17f526922e4a857c$var$mh(b, a, d, c), $17f526922e4a857c$var$eh(b, a, d));
    }
};
function $17f526922e4a857c$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$17f526922e4a857c$var$Ie(c, d) || !$17f526922e4a857c$var$Ie(e, f) : !0;
}
function $17f526922e4a857c$var$ph(a, b, c) {
    var d = !1, e = $17f526922e4a857c$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $17f526922e4a857c$var$Vg(f) : (e = $17f526922e4a857c$var$Zf(b) ? $17f526922e4a857c$var$Xf : $17f526922e4a857c$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $17f526922e4a857c$var$Yf(a, e) : $17f526922e4a857c$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $17f526922e4a857c$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $17f526922e4a857c$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $17f526922e4a857c$var$nh.enqueueReplaceState(b, b.state, null);
}
function $17f526922e4a857c$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $17f526922e4a857c$var$jh;
    $17f526922e4a857c$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $17f526922e4a857c$var$Vg(f) : (f = $17f526922e4a857c$var$Zf(b) ? $17f526922e4a857c$var$Xf : $17f526922e4a857c$var$H.current, e.context = $17f526922e4a857c$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($17f526922e4a857c$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $17f526922e4a857c$var$nh.enqueueReplaceState(e, e.state, null), $17f526922e4a857c$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $17f526922e4a857c$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($17f526922e4a857c$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($17f526922e4a857c$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $17f526922e4a857c$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($17f526922e4a857c$var$p(284));
        if (!c._owner) throw Error($17f526922e4a857c$var$p(290, a));
    }
    return a;
}
function $17f526922e4a857c$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($17f526922e4a857c$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $17f526922e4a857c$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $17f526922e4a857c$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $17f526922e4a857c$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $17f526922e4a857c$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $17f526922e4a857c$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $17f526922e4a857c$var$Ha && $17f526922e4a857c$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $17f526922e4a857c$var$sh(a, b, c), d.return = a, d;
        d = $17f526922e4a857c$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $17f526922e4a857c$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $17f526922e4a857c$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $17f526922e4a857c$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $17f526922e4a857c$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $17f526922e4a857c$var$va:
                    return c = $17f526922e4a857c$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $17f526922e4a857c$var$sh(a, null, b), c.return = a, c;
                case $17f526922e4a857c$var$wa:
                    return b = $17f526922e4a857c$var$zh(b, a.mode, c), b.return = a, b;
                case $17f526922e4a857c$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($17f526922e4a857c$var$eb(b) || $17f526922e4a857c$var$Ka(b)) return b = $17f526922e4a857c$var$Ah(b, a.mode, c, null), b.return = a, b;
            $17f526922e4a857c$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $17f526922e4a857c$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $17f526922e4a857c$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $17f526922e4a857c$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($17f526922e4a857c$var$eb(c) || $17f526922e4a857c$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $17f526922e4a857c$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $17f526922e4a857c$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $17f526922e4a857c$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $17f526922e4a857c$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($17f526922e4a857c$var$eb(d) || $17f526922e4a857c$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $17f526922e4a857c$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $17f526922e4a857c$var$I && $17f526922e4a857c$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $17f526922e4a857c$var$I && $17f526922e4a857c$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $17f526922e4a857c$var$I && $17f526922e4a857c$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $17f526922e4a857c$var$Ka(h);
        if ("function" !== typeof l) throw Error($17f526922e4a857c$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($17f526922e4a857c$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $17f526922e4a857c$var$I && $17f526922e4a857c$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $17f526922e4a857c$var$I && $17f526922e4a857c$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $17f526922e4a857c$var$I && $17f526922e4a857c$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $17f526922e4a857c$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $17f526922e4a857c$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $17f526922e4a857c$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $17f526922e4a857c$var$Ha && $17f526922e4a857c$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $17f526922e4a857c$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $17f526922e4a857c$var$ya ? (d = $17f526922e4a857c$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $17f526922e4a857c$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $17f526922e4a857c$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $17f526922e4a857c$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $17f526922e4a857c$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $17f526922e4a857c$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($17f526922e4a857c$var$eb(f)) return n(a, d, f, h);
            if ($17f526922e4a857c$var$Ka(f)) return t(a, d, f, h);
            $17f526922e4a857c$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $17f526922e4a857c$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $17f526922e4a857c$var$Bh = $17f526922e4a857c$var$vh(!0), $17f526922e4a857c$var$Ch = $17f526922e4a857c$var$vh(!1), $17f526922e4a857c$var$Dh = {}, $17f526922e4a857c$var$Eh = $17f526922e4a857c$var$Uf($17f526922e4a857c$var$Dh), $17f526922e4a857c$var$Fh = $17f526922e4a857c$var$Uf($17f526922e4a857c$var$Dh), $17f526922e4a857c$var$Gh = $17f526922e4a857c$var$Uf($17f526922e4a857c$var$Dh);
function $17f526922e4a857c$var$Hh(a) {
    if (a === $17f526922e4a857c$var$Dh) throw Error($17f526922e4a857c$var$p(174));
    return a;
}
function $17f526922e4a857c$var$Ih(a, b) {
    $17f526922e4a857c$var$G($17f526922e4a857c$var$Gh, b);
    $17f526922e4a857c$var$G($17f526922e4a857c$var$Fh, a);
    $17f526922e4a857c$var$G($17f526922e4a857c$var$Eh, $17f526922e4a857c$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $17f526922e4a857c$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $17f526922e4a857c$var$lb(b, a);
    }
    $17f526922e4a857c$var$E($17f526922e4a857c$var$Eh);
    $17f526922e4a857c$var$G($17f526922e4a857c$var$Eh, b);
}
function $17f526922e4a857c$var$Jh() {
    $17f526922e4a857c$var$E($17f526922e4a857c$var$Eh);
    $17f526922e4a857c$var$E($17f526922e4a857c$var$Fh);
    $17f526922e4a857c$var$E($17f526922e4a857c$var$Gh);
}
function $17f526922e4a857c$var$Kh(a) {
    $17f526922e4a857c$var$Hh($17f526922e4a857c$var$Gh.current);
    var b = $17f526922e4a857c$var$Hh($17f526922e4a857c$var$Eh.current);
    var c = $17f526922e4a857c$var$lb(b, a.type);
    b !== c && ($17f526922e4a857c$var$G($17f526922e4a857c$var$Fh, a), $17f526922e4a857c$var$G($17f526922e4a857c$var$Eh, c));
}
function $17f526922e4a857c$var$Lh(a) {
    $17f526922e4a857c$var$Fh.current === a && ($17f526922e4a857c$var$E($17f526922e4a857c$var$Eh), $17f526922e4a857c$var$E($17f526922e4a857c$var$Fh));
}
var $17f526922e4a857c$var$M = $17f526922e4a857c$var$Uf(0);
function $17f526922e4a857c$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $17f526922e4a857c$var$Nh = [];
function $17f526922e4a857c$var$Oh() {
    for(var a = 0; a < $17f526922e4a857c$var$Nh.length; a++)$17f526922e4a857c$var$Nh[a]._workInProgressVersionPrimary = null;
    $17f526922e4a857c$var$Nh.length = 0;
}
var $17f526922e4a857c$var$Ph = $17f526922e4a857c$var$ua.ReactCurrentDispatcher, $17f526922e4a857c$var$Qh = $17f526922e4a857c$var$ua.ReactCurrentBatchConfig, $17f526922e4a857c$var$Rh = 0, $17f526922e4a857c$var$N = null, $17f526922e4a857c$var$O = null, $17f526922e4a857c$var$P = null, $17f526922e4a857c$var$Sh = !1, $17f526922e4a857c$var$Th = !1, $17f526922e4a857c$var$Uh = 0, $17f526922e4a857c$var$Vh = 0;
function $17f526922e4a857c$var$Q() {
    throw Error($17f526922e4a857c$var$p(321));
}
function $17f526922e4a857c$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$17f526922e4a857c$var$He(a[c], b[c])) return !1;
    return !0;
}
function $17f526922e4a857c$var$Xh(a, b, c, d, e, f) {
    $17f526922e4a857c$var$Rh = f;
    $17f526922e4a857c$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $17f526922e4a857c$var$Ph.current = null === a || null === a.memoizedState ? $17f526922e4a857c$var$Yh : $17f526922e4a857c$var$Zh;
    a = c(d, e);
    if ($17f526922e4a857c$var$Th) {
        f = 0;
        do {
            $17f526922e4a857c$var$Th = !1;
            $17f526922e4a857c$var$Uh = 0;
            if (25 <= f) throw Error($17f526922e4a857c$var$p(301));
            f += 1;
            $17f526922e4a857c$var$P = $17f526922e4a857c$var$O = null;
            b.updateQueue = null;
            $17f526922e4a857c$var$Ph.current = $17f526922e4a857c$var$$h;
            a = c(d, e);
        }while ($17f526922e4a857c$var$Th);
    }
    $17f526922e4a857c$var$Ph.current = $17f526922e4a857c$var$ai;
    b = null !== $17f526922e4a857c$var$O && null !== $17f526922e4a857c$var$O.next;
    $17f526922e4a857c$var$Rh = 0;
    $17f526922e4a857c$var$P = $17f526922e4a857c$var$O = $17f526922e4a857c$var$N = null;
    $17f526922e4a857c$var$Sh = !1;
    if (b) throw Error($17f526922e4a857c$var$p(300));
    return a;
}
function $17f526922e4a857c$var$bi() {
    var a = 0 !== $17f526922e4a857c$var$Uh;
    $17f526922e4a857c$var$Uh = 0;
    return a;
}
function $17f526922e4a857c$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $17f526922e4a857c$var$P ? $17f526922e4a857c$var$N.memoizedState = $17f526922e4a857c$var$P = a : $17f526922e4a857c$var$P = $17f526922e4a857c$var$P.next = a;
    return $17f526922e4a857c$var$P;
}
function $17f526922e4a857c$var$di() {
    if (null === $17f526922e4a857c$var$O) {
        var a = $17f526922e4a857c$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $17f526922e4a857c$var$O.next;
    var b = null === $17f526922e4a857c$var$P ? $17f526922e4a857c$var$N.memoizedState : $17f526922e4a857c$var$P.next;
    if (null !== b) $17f526922e4a857c$var$P = b, $17f526922e4a857c$var$O = a;
    else {
        if (null === a) throw Error($17f526922e4a857c$var$p(310));
        $17f526922e4a857c$var$O = a;
        a = {
            memoizedState: $17f526922e4a857c$var$O.memoizedState,
            baseState: $17f526922e4a857c$var$O.baseState,
            baseQueue: $17f526922e4a857c$var$O.baseQueue,
            queue: $17f526922e4a857c$var$O.queue,
            next: null
        };
        null === $17f526922e4a857c$var$P ? $17f526922e4a857c$var$N.memoizedState = $17f526922e4a857c$var$P = a : $17f526922e4a857c$var$P = $17f526922e4a857c$var$P.next = a;
    }
    return $17f526922e4a857c$var$P;
}
function $17f526922e4a857c$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $17f526922e4a857c$var$fi(a) {
    var b = $17f526922e4a857c$var$di(), c = b.queue;
    if (null === c) throw Error($17f526922e4a857c$var$p(311));
    c.lastRenderedReducer = a;
    var d = $17f526922e4a857c$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($17f526922e4a857c$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $17f526922e4a857c$var$N.lanes |= m;
                $17f526922e4a857c$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $17f526922e4a857c$var$He(d, b.memoizedState) || ($17f526922e4a857c$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $17f526922e4a857c$var$N.lanes |= f, $17f526922e4a857c$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $17f526922e4a857c$var$gi(a) {
    var b = $17f526922e4a857c$var$di(), c = b.queue;
    if (null === c) throw Error($17f526922e4a857c$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $17f526922e4a857c$var$He(f, b.memoizedState) || ($17f526922e4a857c$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $17f526922e4a857c$var$hi() {}
function $17f526922e4a857c$var$ii(a, b) {
    var c = $17f526922e4a857c$var$N, d = $17f526922e4a857c$var$di(), e = b(), f = !$17f526922e4a857c$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $17f526922e4a857c$var$Ug = !0);
    d = d.queue;
    $17f526922e4a857c$var$ji($17f526922e4a857c$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $17f526922e4a857c$var$P && $17f526922e4a857c$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $17f526922e4a857c$var$li(9, $17f526922e4a857c$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $17f526922e4a857c$var$R) throw Error($17f526922e4a857c$var$p(349));
        0 !== ($17f526922e4a857c$var$Rh & 30) || $17f526922e4a857c$var$ni(c, b, e);
    }
    return e;
}
function $17f526922e4a857c$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $17f526922e4a857c$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $17f526922e4a857c$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $17f526922e4a857c$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $17f526922e4a857c$var$oi(b) && $17f526922e4a857c$var$pi(a);
}
function $17f526922e4a857c$var$ki(a, b, c) {
    return c(function() {
        $17f526922e4a857c$var$oi(b) && $17f526922e4a857c$var$pi(a);
    });
}
function $17f526922e4a857c$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$17f526922e4a857c$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $17f526922e4a857c$var$pi(a) {
    var b = $17f526922e4a857c$var$Zg(a, 1);
    null !== b && $17f526922e4a857c$var$mh(b, a, 1, -1);
}
function $17f526922e4a857c$var$qi(a) {
    var b = $17f526922e4a857c$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $17f526922e4a857c$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $17f526922e4a857c$var$ri.bind(null, $17f526922e4a857c$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $17f526922e4a857c$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $17f526922e4a857c$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $17f526922e4a857c$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $17f526922e4a857c$var$si() {
    return $17f526922e4a857c$var$di().memoizedState;
}
function $17f526922e4a857c$var$ti(a, b, c, d) {
    var e = $17f526922e4a857c$var$ci();
    $17f526922e4a857c$var$N.flags |= a;
    e.memoizedState = $17f526922e4a857c$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $17f526922e4a857c$var$ui(a, b, c, d) {
    var e = $17f526922e4a857c$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $17f526922e4a857c$var$O) {
        var g = $17f526922e4a857c$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $17f526922e4a857c$var$Wh(d, g.deps)) {
            e.memoizedState = $17f526922e4a857c$var$li(b, c, f, d);
            return;
        }
    }
    $17f526922e4a857c$var$N.flags |= a;
    e.memoizedState = $17f526922e4a857c$var$li(1 | b, c, f, d);
}
function $17f526922e4a857c$var$vi(a, b) {
    return $17f526922e4a857c$var$ti(8390656, 8, a, b);
}
function $17f526922e4a857c$var$ji(a, b) {
    return $17f526922e4a857c$var$ui(2048, 8, a, b);
}
function $17f526922e4a857c$var$wi(a, b) {
    return $17f526922e4a857c$var$ui(4, 2, a, b);
}
function $17f526922e4a857c$var$xi(a, b) {
    return $17f526922e4a857c$var$ui(4, 4, a, b);
}
function $17f526922e4a857c$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $17f526922e4a857c$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $17f526922e4a857c$var$ui(4, 4, $17f526922e4a857c$var$yi.bind(null, b, a), c);
}
function $17f526922e4a857c$var$Ai() {}
function $17f526922e4a857c$var$Bi(a, b) {
    var c = $17f526922e4a857c$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $17f526922e4a857c$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $17f526922e4a857c$var$Ci(a, b) {
    var c = $17f526922e4a857c$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $17f526922e4a857c$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $17f526922e4a857c$var$Di(a, b, c) {
    if (0 === ($17f526922e4a857c$var$Rh & 21)) return a.baseState && (a.baseState = !1, $17f526922e4a857c$var$Ug = !0), a.memoizedState = c;
    $17f526922e4a857c$var$He(c, b) || (c = $17f526922e4a857c$var$yc(), $17f526922e4a857c$var$N.lanes |= c, $17f526922e4a857c$var$hh |= c, a.baseState = !0);
    return b;
}
function $17f526922e4a857c$var$Ei(a, b) {
    var c = $17f526922e4a857c$var$C;
    $17f526922e4a857c$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $17f526922e4a857c$var$Qh.transition;
    $17f526922e4a857c$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $17f526922e4a857c$var$C = c, $17f526922e4a857c$var$Qh.transition = d;
    }
}
function $17f526922e4a857c$var$Fi() {
    return $17f526922e4a857c$var$di().memoizedState;
}
function $17f526922e4a857c$var$Gi(a, b, c) {
    var d = $17f526922e4a857c$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($17f526922e4a857c$var$Hi(a)) $17f526922e4a857c$var$Ii(b, c);
    else if (c = $17f526922e4a857c$var$Yg(a, b, c, d), null !== c) {
        var e = $17f526922e4a857c$var$L();
        $17f526922e4a857c$var$mh(c, a, d, e);
        $17f526922e4a857c$var$Ji(c, b, d);
    }
}
function $17f526922e4a857c$var$ri(a, b, c) {
    var d = $17f526922e4a857c$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($17f526922e4a857c$var$Hi(a)) $17f526922e4a857c$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($17f526922e4a857c$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $17f526922e4a857c$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $17f526922e4a857c$var$Yg(a, b, e, d);
        null !== c && (e = $17f526922e4a857c$var$L(), $17f526922e4a857c$var$mh(c, a, d, e), $17f526922e4a857c$var$Ji(c, b, d));
    }
}
function $17f526922e4a857c$var$Hi(a) {
    var b = a.alternate;
    return a === $17f526922e4a857c$var$N || null !== b && b === $17f526922e4a857c$var$N;
}
function $17f526922e4a857c$var$Ii(a, b) {
    $17f526922e4a857c$var$Th = $17f526922e4a857c$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $17f526922e4a857c$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $17f526922e4a857c$var$Cc(a, c);
    }
}
var $17f526922e4a857c$var$ai = {
    readContext: $17f526922e4a857c$var$Vg,
    useCallback: $17f526922e4a857c$var$Q,
    useContext: $17f526922e4a857c$var$Q,
    useEffect: $17f526922e4a857c$var$Q,
    useImperativeHandle: $17f526922e4a857c$var$Q,
    useInsertionEffect: $17f526922e4a857c$var$Q,
    useLayoutEffect: $17f526922e4a857c$var$Q,
    useMemo: $17f526922e4a857c$var$Q,
    useReducer: $17f526922e4a857c$var$Q,
    useRef: $17f526922e4a857c$var$Q,
    useState: $17f526922e4a857c$var$Q,
    useDebugValue: $17f526922e4a857c$var$Q,
    useDeferredValue: $17f526922e4a857c$var$Q,
    useTransition: $17f526922e4a857c$var$Q,
    useMutableSource: $17f526922e4a857c$var$Q,
    useSyncExternalStore: $17f526922e4a857c$var$Q,
    useId: $17f526922e4a857c$var$Q,
    unstable_isNewReconciler: !1
}, $17f526922e4a857c$var$Yh = {
    readContext: $17f526922e4a857c$var$Vg,
    useCallback: function(a, b) {
        $17f526922e4a857c$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $17f526922e4a857c$var$Vg,
    useEffect: $17f526922e4a857c$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $17f526922e4a857c$var$ti(4194308, 4, $17f526922e4a857c$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $17f526922e4a857c$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $17f526922e4a857c$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $17f526922e4a857c$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $17f526922e4a857c$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $17f526922e4a857c$var$Gi.bind(null, $17f526922e4a857c$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $17f526922e4a857c$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $17f526922e4a857c$var$qi,
    useDebugValue: $17f526922e4a857c$var$Ai,
    useDeferredValue: function(a) {
        return $17f526922e4a857c$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $17f526922e4a857c$var$qi(!1), b = a[0];
        a = $17f526922e4a857c$var$Ei.bind(null, a[1]);
        $17f526922e4a857c$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $17f526922e4a857c$var$N, e = $17f526922e4a857c$var$ci();
        if ($17f526922e4a857c$var$I) {
            if (void 0 === c) throw Error($17f526922e4a857c$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $17f526922e4a857c$var$R) throw Error($17f526922e4a857c$var$p(349));
            0 !== ($17f526922e4a857c$var$Rh & 30) || $17f526922e4a857c$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $17f526922e4a857c$var$vi($17f526922e4a857c$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $17f526922e4a857c$var$li(9, $17f526922e4a857c$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $17f526922e4a857c$var$ci(), b = $17f526922e4a857c$var$R.identifierPrefix;
        if ($17f526922e4a857c$var$I) {
            var c = $17f526922e4a857c$var$sg;
            var d = $17f526922e4a857c$var$rg;
            c = (d & ~(1 << 32 - $17f526922e4a857c$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $17f526922e4a857c$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $17f526922e4a857c$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $17f526922e4a857c$var$Zh = {
    readContext: $17f526922e4a857c$var$Vg,
    useCallback: $17f526922e4a857c$var$Bi,
    useContext: $17f526922e4a857c$var$Vg,
    useEffect: $17f526922e4a857c$var$ji,
    useImperativeHandle: $17f526922e4a857c$var$zi,
    useInsertionEffect: $17f526922e4a857c$var$wi,
    useLayoutEffect: $17f526922e4a857c$var$xi,
    useMemo: $17f526922e4a857c$var$Ci,
    useReducer: $17f526922e4a857c$var$fi,
    useRef: $17f526922e4a857c$var$si,
    useState: function() {
        return $17f526922e4a857c$var$fi($17f526922e4a857c$var$ei);
    },
    useDebugValue: $17f526922e4a857c$var$Ai,
    useDeferredValue: function(a) {
        var b = $17f526922e4a857c$var$di();
        return $17f526922e4a857c$var$Di(b, $17f526922e4a857c$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $17f526922e4a857c$var$fi($17f526922e4a857c$var$ei)[0], b = $17f526922e4a857c$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $17f526922e4a857c$var$hi,
    useSyncExternalStore: $17f526922e4a857c$var$ii,
    useId: $17f526922e4a857c$var$Fi,
    unstable_isNewReconciler: !1
}, $17f526922e4a857c$var$$h = {
    readContext: $17f526922e4a857c$var$Vg,
    useCallback: $17f526922e4a857c$var$Bi,
    useContext: $17f526922e4a857c$var$Vg,
    useEffect: $17f526922e4a857c$var$ji,
    useImperativeHandle: $17f526922e4a857c$var$zi,
    useInsertionEffect: $17f526922e4a857c$var$wi,
    useLayoutEffect: $17f526922e4a857c$var$xi,
    useMemo: $17f526922e4a857c$var$Ci,
    useReducer: $17f526922e4a857c$var$gi,
    useRef: $17f526922e4a857c$var$si,
    useState: function() {
        return $17f526922e4a857c$var$gi($17f526922e4a857c$var$ei);
    },
    useDebugValue: $17f526922e4a857c$var$Ai,
    useDeferredValue: function(a) {
        var b = $17f526922e4a857c$var$di();
        return null === $17f526922e4a857c$var$O ? b.memoizedState = a : $17f526922e4a857c$var$Di(b, $17f526922e4a857c$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $17f526922e4a857c$var$gi($17f526922e4a857c$var$ei)[0], b = $17f526922e4a857c$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $17f526922e4a857c$var$hi,
    useSyncExternalStore: $17f526922e4a857c$var$ii,
    useId: $17f526922e4a857c$var$Fi,
    unstable_isNewReconciler: !1
};
function $17f526922e4a857c$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $17f526922e4a857c$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $17f526922e4a857c$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $17f526922e4a857c$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $17f526922e4a857c$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $17f526922e4a857c$var$Oi(a, b, c) {
    c = $17f526922e4a857c$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $17f526922e4a857c$var$Pi || ($17f526922e4a857c$var$Pi = !0, $17f526922e4a857c$var$Qi = d);
        $17f526922e4a857c$var$Mi(a, b);
    };
    return c;
}
function $17f526922e4a857c$var$Ri(a, b, c) {
    c = $17f526922e4a857c$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $17f526922e4a857c$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $17f526922e4a857c$var$Mi(a, b);
        "function" !== typeof d && (null === $17f526922e4a857c$var$Si ? $17f526922e4a857c$var$Si = new Set([
            this
        ]) : $17f526922e4a857c$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $17f526922e4a857c$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $17f526922e4a857c$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $17f526922e4a857c$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $17f526922e4a857c$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $17f526922e4a857c$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $17f526922e4a857c$var$ch(-1, 1), b.tag = 2, $17f526922e4a857c$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $17f526922e4a857c$var$Xi = $17f526922e4a857c$var$ua.ReactCurrentOwner, $17f526922e4a857c$var$Ug = !1;
function $17f526922e4a857c$var$Yi(a, b, c, d) {
    b.child = null === a ? $17f526922e4a857c$var$Ch(b, null, c, d) : $17f526922e4a857c$var$Bh(b, a.child, c, d);
}
function $17f526922e4a857c$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $17f526922e4a857c$var$Tg(b, e);
    d = $17f526922e4a857c$var$Xh(a, b, c, d, f, e);
    c = $17f526922e4a857c$var$bi();
    if (null !== a && !$17f526922e4a857c$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $17f526922e4a857c$var$$i(a, b, e);
    $17f526922e4a857c$var$I && c && $17f526922e4a857c$var$vg(b);
    b.flags |= 1;
    $17f526922e4a857c$var$Yi(a, b, d, e);
    return b.child;
}
function $17f526922e4a857c$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$17f526922e4a857c$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $17f526922e4a857c$var$cj(a, b, f, d, e);
        a = $17f526922e4a857c$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $17f526922e4a857c$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $17f526922e4a857c$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $17f526922e4a857c$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $17f526922e4a857c$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($17f526922e4a857c$var$Ie(f, d) && a.ref === b.ref) {
            if ($17f526922e4a857c$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($17f526922e4a857c$var$Ug = !0);
            else return b.lanes = a.lanes, $17f526922e4a857c$var$$i(a, b, e);
        }
    }
    return $17f526922e4a857c$var$dj(a, b, c, d, e);
}
function $17f526922e4a857c$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $17f526922e4a857c$var$G($17f526922e4a857c$var$fj, $17f526922e4a857c$var$gj), $17f526922e4a857c$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $17f526922e4a857c$var$G($17f526922e4a857c$var$fj, $17f526922e4a857c$var$gj), $17f526922e4a857c$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $17f526922e4a857c$var$G($17f526922e4a857c$var$fj, $17f526922e4a857c$var$gj);
            $17f526922e4a857c$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $17f526922e4a857c$var$G($17f526922e4a857c$var$fj, $17f526922e4a857c$var$gj), $17f526922e4a857c$var$gj |= d;
    $17f526922e4a857c$var$Yi(a, b, e, c);
    return b.child;
}
function $17f526922e4a857c$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $17f526922e4a857c$var$dj(a, b, c, d, e) {
    var f = $17f526922e4a857c$var$Zf(c) ? $17f526922e4a857c$var$Xf : $17f526922e4a857c$var$H.current;
    f = $17f526922e4a857c$var$Yf(b, f);
    $17f526922e4a857c$var$Tg(b, e);
    c = $17f526922e4a857c$var$Xh(a, b, c, d, f, e);
    d = $17f526922e4a857c$var$bi();
    if (null !== a && !$17f526922e4a857c$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $17f526922e4a857c$var$$i(a, b, e);
    $17f526922e4a857c$var$I && d && $17f526922e4a857c$var$vg(b);
    b.flags |= 1;
    $17f526922e4a857c$var$Yi(a, b, c, e);
    return b.child;
}
function $17f526922e4a857c$var$ij(a, b, c, d, e) {
    if ($17f526922e4a857c$var$Zf(c)) {
        var f = !0;
        $17f526922e4a857c$var$cg(b);
    } else f = !1;
    $17f526922e4a857c$var$Tg(b, e);
    if (null === b.stateNode) $17f526922e4a857c$var$jj(a, b), $17f526922e4a857c$var$ph(b, c, d), $17f526922e4a857c$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $17f526922e4a857c$var$Vg(l) : (l = $17f526922e4a857c$var$Zf(c) ? $17f526922e4a857c$var$Xf : $17f526922e4a857c$var$H.current, l = $17f526922e4a857c$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $17f526922e4a857c$var$qh(b, g, d, l);
        $17f526922e4a857c$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $17f526922e4a857c$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $17f526922e4a857c$var$Wf.current || $17f526922e4a857c$var$$g ? ("function" === typeof m && ($17f526922e4a857c$var$kh(b, c, m, d), k = b.memoizedState), (h = $17f526922e4a857c$var$$g || $17f526922e4a857c$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $17f526922e4a857c$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $17f526922e4a857c$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $17f526922e4a857c$var$Vg(k) : (k = $17f526922e4a857c$var$Zf(c) ? $17f526922e4a857c$var$Xf : $17f526922e4a857c$var$H.current, k = $17f526922e4a857c$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $17f526922e4a857c$var$qh(b, g, d, k);
        $17f526922e4a857c$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $17f526922e4a857c$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $17f526922e4a857c$var$Wf.current || $17f526922e4a857c$var$$g ? ("function" === typeof y && ($17f526922e4a857c$var$kh(b, c, y, d), n = b.memoizedState), (l = $17f526922e4a857c$var$$g || $17f526922e4a857c$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $17f526922e4a857c$var$kj(a, b, c, d, f, e);
}
function $17f526922e4a857c$var$kj(a, b, c, d, e, f) {
    $17f526922e4a857c$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $17f526922e4a857c$var$dg(b, c, !1), $17f526922e4a857c$var$$i(a, b, f);
    d = b.stateNode;
    $17f526922e4a857c$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $17f526922e4a857c$var$Bh(b, a.child, null, f), b.child = $17f526922e4a857c$var$Bh(b, null, h, f)) : $17f526922e4a857c$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $17f526922e4a857c$var$dg(b, c, !0);
    return b.child;
}
function $17f526922e4a857c$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $17f526922e4a857c$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $17f526922e4a857c$var$ag(a, b.context, !1);
    $17f526922e4a857c$var$Ih(a, b.containerInfo);
}
function $17f526922e4a857c$var$mj(a, b, c, d, e) {
    $17f526922e4a857c$var$Ig();
    $17f526922e4a857c$var$Jg(e);
    b.flags |= 256;
    $17f526922e4a857c$var$Yi(a, b, c, d);
    return b.child;
}
var $17f526922e4a857c$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $17f526922e4a857c$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $17f526922e4a857c$var$pj(a, b, c) {
    var d = b.pendingProps, e = $17f526922e4a857c$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $17f526922e4a857c$var$G($17f526922e4a857c$var$M, e & 1);
    if (null === a) {
        $17f526922e4a857c$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $17f526922e4a857c$var$qj(g, d, 0, null), a = $17f526922e4a857c$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $17f526922e4a857c$var$oj(c), b.memoizedState = $17f526922e4a857c$var$nj, a) : $17f526922e4a857c$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $17f526922e4a857c$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $17f526922e4a857c$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $17f526922e4a857c$var$wh(h, f) : (f = $17f526922e4a857c$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $17f526922e4a857c$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $17f526922e4a857c$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $17f526922e4a857c$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $17f526922e4a857c$var$rj(a, b) {
    b = $17f526922e4a857c$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $17f526922e4a857c$var$tj(a, b, c, d) {
    null !== d && $17f526922e4a857c$var$Jg(d);
    $17f526922e4a857c$var$Bh(b, a.child, null, c);
    a = $17f526922e4a857c$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $17f526922e4a857c$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $17f526922e4a857c$var$Li(Error($17f526922e4a857c$var$p(422))), $17f526922e4a857c$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $17f526922e4a857c$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $17f526922e4a857c$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $17f526922e4a857c$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $17f526922e4a857c$var$oj(g);
        b.memoizedState = $17f526922e4a857c$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $17f526922e4a857c$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($17f526922e4a857c$var$p(419));
        d = $17f526922e4a857c$var$Li(f, d, void 0);
        return $17f526922e4a857c$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($17f526922e4a857c$var$Ug || h) {
        d = $17f526922e4a857c$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $17f526922e4a857c$var$Zg(a, e), $17f526922e4a857c$var$mh(d, a, e, -1));
        }
        $17f526922e4a857c$var$uj();
        d = $17f526922e4a857c$var$Li(Error($17f526922e4a857c$var$p(421)));
        return $17f526922e4a857c$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $17f526922e4a857c$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $17f526922e4a857c$var$yg = $17f526922e4a857c$var$Lf(e.nextSibling);
    $17f526922e4a857c$var$xg = b;
    $17f526922e4a857c$var$I = !0;
    $17f526922e4a857c$var$zg = null;
    null !== a && ($17f526922e4a857c$var$og[$17f526922e4a857c$var$pg++] = $17f526922e4a857c$var$rg, $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg++] = $17f526922e4a857c$var$sg, $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg++] = $17f526922e4a857c$var$qg, $17f526922e4a857c$var$rg = a.id, $17f526922e4a857c$var$sg = a.overflow, $17f526922e4a857c$var$qg = b);
    b = $17f526922e4a857c$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $17f526922e4a857c$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $17f526922e4a857c$var$Sg(a.return, b, c);
}
function $17f526922e4a857c$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $17f526922e4a857c$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $17f526922e4a857c$var$Yi(a, b, d.children, c);
    d = $17f526922e4a857c$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $17f526922e4a857c$var$wj(a, c, b);
            else if (19 === a.tag) $17f526922e4a857c$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $17f526922e4a857c$var$G($17f526922e4a857c$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $17f526922e4a857c$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $17f526922e4a857c$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $17f526922e4a857c$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $17f526922e4a857c$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $17f526922e4a857c$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $17f526922e4a857c$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $17f526922e4a857c$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $17f526922e4a857c$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($17f526922e4a857c$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $17f526922e4a857c$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $17f526922e4a857c$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $17f526922e4a857c$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $17f526922e4a857c$var$lj(b);
            $17f526922e4a857c$var$Ig();
            break;
        case 5:
            $17f526922e4a857c$var$Kh(b);
            break;
        case 1:
            $17f526922e4a857c$var$Zf(b.type) && $17f526922e4a857c$var$cg(b);
            break;
        case 4:
            $17f526922e4a857c$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $17f526922e4a857c$var$G($17f526922e4a857c$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $17f526922e4a857c$var$G($17f526922e4a857c$var$M, $17f526922e4a857c$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $17f526922e4a857c$var$pj(a, b, c);
                $17f526922e4a857c$var$G($17f526922e4a857c$var$M, $17f526922e4a857c$var$M.current & 1);
                a = $17f526922e4a857c$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $17f526922e4a857c$var$G($17f526922e4a857c$var$M, $17f526922e4a857c$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $17f526922e4a857c$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $17f526922e4a857c$var$G($17f526922e4a857c$var$M, $17f526922e4a857c$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $17f526922e4a857c$var$ej(a, b, c);
    }
    return $17f526922e4a857c$var$$i(a, b, c);
}
var $17f526922e4a857c$var$Aj, $17f526922e4a857c$var$Bj, $17f526922e4a857c$var$Cj, $17f526922e4a857c$var$Dj;
$17f526922e4a857c$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$17f526922e4a857c$var$Bj = function() {};
$17f526922e4a857c$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $17f526922e4a857c$var$Hh($17f526922e4a857c$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $17f526922e4a857c$var$Ya(a, e);
                d = $17f526922e4a857c$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $17f526922e4a857c$var$A({}, e, {
                    value: void 0
                });
                d = $17f526922e4a857c$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $17f526922e4a857c$var$gb(a, e);
                d = $17f526922e4a857c$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $17f526922e4a857c$var$Bf);
        }
        $17f526922e4a857c$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($17f526922e4a857c$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($17f526922e4a857c$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $17f526922e4a857c$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$17f526922e4a857c$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $17f526922e4a857c$var$Ej(a, b) {
    if (!$17f526922e4a857c$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $17f526922e4a857c$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $17f526922e4a857c$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $17f526922e4a857c$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $17f526922e4a857c$var$S(b), null;
        case 1:
            return $17f526922e4a857c$var$Zf(b.type) && $17f526922e4a857c$var$$f(), $17f526922e4a857c$var$S(b), null;
        case 3:
            d = b.stateNode;
            $17f526922e4a857c$var$Jh();
            $17f526922e4a857c$var$E($17f526922e4a857c$var$Wf);
            $17f526922e4a857c$var$E($17f526922e4a857c$var$H);
            $17f526922e4a857c$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $17f526922e4a857c$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $17f526922e4a857c$var$zg && ($17f526922e4a857c$var$Gj($17f526922e4a857c$var$zg), $17f526922e4a857c$var$zg = null));
            $17f526922e4a857c$var$Bj(a, b);
            $17f526922e4a857c$var$S(b);
            return null;
        case 5:
            $17f526922e4a857c$var$Lh(b);
            var e = $17f526922e4a857c$var$Hh($17f526922e4a857c$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $17f526922e4a857c$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($17f526922e4a857c$var$p(166));
                    $17f526922e4a857c$var$S(b);
                    return null;
                }
                a = $17f526922e4a857c$var$Hh($17f526922e4a857c$var$Eh.current);
                if ($17f526922e4a857c$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$17f526922e4a857c$var$Of] = b;
                    d[$17f526922e4a857c$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $17f526922e4a857c$var$D("cancel", d);
                            $17f526922e4a857c$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $17f526922e4a857c$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $17f526922e4a857c$var$lf.length; e++)$17f526922e4a857c$var$D($17f526922e4a857c$var$lf[e], d);
                            break;
                        case "source":
                            $17f526922e4a857c$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $17f526922e4a857c$var$D("error", d);
                            $17f526922e4a857c$var$D("load", d);
                            break;
                        case "details":
                            $17f526922e4a857c$var$D("toggle", d);
                            break;
                        case "input":
                            $17f526922e4a857c$var$Za(d, f);
                            $17f526922e4a857c$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $17f526922e4a857c$var$D("invalid", d);
                            break;
                        case "textarea":
                            $17f526922e4a857c$var$hb(d, f), $17f526922e4a857c$var$D("invalid", d);
                    }
                    $17f526922e4a857c$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $17f526922e4a857c$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $17f526922e4a857c$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $17f526922e4a857c$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $17f526922e4a857c$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $17f526922e4a857c$var$Va(d);
                            $17f526922e4a857c$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $17f526922e4a857c$var$Va(d);
                            $17f526922e4a857c$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $17f526922e4a857c$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $17f526922e4a857c$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$17f526922e4a857c$var$Of] = b;
                    a[$17f526922e4a857c$var$Pf] = d;
                    $17f526922e4a857c$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $17f526922e4a857c$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $17f526922e4a857c$var$D("cancel", a);
                                $17f526922e4a857c$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $17f526922e4a857c$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $17f526922e4a857c$var$lf.length; e++)$17f526922e4a857c$var$D($17f526922e4a857c$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $17f526922e4a857c$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $17f526922e4a857c$var$D("error", a);
                                $17f526922e4a857c$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $17f526922e4a857c$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $17f526922e4a857c$var$Za(a, d);
                                e = $17f526922e4a857c$var$Ya(a, d);
                                $17f526922e4a857c$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $17f526922e4a857c$var$A({}, d, {
                                    value: void 0
                                });
                                $17f526922e4a857c$var$D("invalid", a);
                                break;
                            case "textarea":
                                $17f526922e4a857c$var$hb(a, d);
                                e = $17f526922e4a857c$var$gb(a, d);
                                $17f526922e4a857c$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $17f526922e4a857c$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $17f526922e4a857c$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $17f526922e4a857c$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $17f526922e4a857c$var$ob(a, k) : "number" === typeof k && $17f526922e4a857c$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($17f526922e4a857c$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $17f526922e4a857c$var$D("scroll", a) : null != k && $17f526922e4a857c$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $17f526922e4a857c$var$Va(a);
                                $17f526922e4a857c$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $17f526922e4a857c$var$Va(a);
                                $17f526922e4a857c$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $17f526922e4a857c$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $17f526922e4a857c$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $17f526922e4a857c$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $17f526922e4a857c$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $17f526922e4a857c$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $17f526922e4a857c$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($17f526922e4a857c$var$p(166));
                c = $17f526922e4a857c$var$Hh($17f526922e4a857c$var$Gh.current);
                $17f526922e4a857c$var$Hh($17f526922e4a857c$var$Eh.current);
                if ($17f526922e4a857c$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$17f526922e4a857c$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $17f526922e4a857c$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $17f526922e4a857c$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $17f526922e4a857c$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$17f526922e4a857c$var$Of] = b, b.stateNode = d;
            }
            $17f526922e4a857c$var$S(b);
            return null;
        case 13:
            $17f526922e4a857c$var$E($17f526922e4a857c$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($17f526922e4a857c$var$I && null !== $17f526922e4a857c$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $17f526922e4a857c$var$Hg(), $17f526922e4a857c$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $17f526922e4a857c$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($17f526922e4a857c$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($17f526922e4a857c$var$p(317));
                        f[$17f526922e4a857c$var$Of] = b;
                    } else $17f526922e4a857c$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $17f526922e4a857c$var$S(b);
                    f = !1;
                } else null !== $17f526922e4a857c$var$zg && ($17f526922e4a857c$var$Gj($17f526922e4a857c$var$zg), $17f526922e4a857c$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($17f526922e4a857c$var$M.current & 1) ? 0 === $17f526922e4a857c$var$T && ($17f526922e4a857c$var$T = 3) : $17f526922e4a857c$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $17f526922e4a857c$var$S(b);
            return null;
        case 4:
            return $17f526922e4a857c$var$Jh(), $17f526922e4a857c$var$Bj(a, b), null === a && $17f526922e4a857c$var$sf(b.stateNode.containerInfo), $17f526922e4a857c$var$S(b), null;
        case 10:
            return $17f526922e4a857c$var$Rg(b.type._context), $17f526922e4a857c$var$S(b), null;
        case 17:
            return $17f526922e4a857c$var$Zf(b.type) && $17f526922e4a857c$var$$f(), $17f526922e4a857c$var$S(b), null;
        case 19:
            $17f526922e4a857c$var$E($17f526922e4a857c$var$M);
            f = b.memoizedState;
            if (null === f) return $17f526922e4a857c$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $17f526922e4a857c$var$Ej(f, !1);
                else {
                    if (0 !== $17f526922e4a857c$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $17f526922e4a857c$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $17f526922e4a857c$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $17f526922e4a857c$var$G($17f526922e4a857c$var$M, $17f526922e4a857c$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $17f526922e4a857c$var$B() > $17f526922e4a857c$var$Hj && (b.flags |= 128, d = !0, $17f526922e4a857c$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $17f526922e4a857c$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $17f526922e4a857c$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$17f526922e4a857c$var$I) return $17f526922e4a857c$var$S(b), null;
                    } else 2 * $17f526922e4a857c$var$B() - f.renderingStartTime > $17f526922e4a857c$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $17f526922e4a857c$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $17f526922e4a857c$var$B(), b.sibling = null, c = $17f526922e4a857c$var$M.current, $17f526922e4a857c$var$G($17f526922e4a857c$var$M, d ? c & 1 | 2 : c & 1), b;
            $17f526922e4a857c$var$S(b);
            return null;
        case 22:
        case 23:
            return $17f526922e4a857c$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($17f526922e4a857c$var$gj & 1073741824) && ($17f526922e4a857c$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $17f526922e4a857c$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($17f526922e4a857c$var$p(156, b.tag));
}
function $17f526922e4a857c$var$Jj(a, b) {
    $17f526922e4a857c$var$wg(b);
    switch(b.tag){
        case 1:
            return $17f526922e4a857c$var$Zf(b.type) && $17f526922e4a857c$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $17f526922e4a857c$var$Jh(), $17f526922e4a857c$var$E($17f526922e4a857c$var$Wf), $17f526922e4a857c$var$E($17f526922e4a857c$var$H), $17f526922e4a857c$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $17f526922e4a857c$var$Lh(b), null;
        case 13:
            $17f526922e4a857c$var$E($17f526922e4a857c$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($17f526922e4a857c$var$p(340));
                $17f526922e4a857c$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $17f526922e4a857c$var$E($17f526922e4a857c$var$M), null;
        case 4:
            return $17f526922e4a857c$var$Jh(), null;
        case 10:
            return $17f526922e4a857c$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $17f526922e4a857c$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $17f526922e4a857c$var$Kj = !1, $17f526922e4a857c$var$U = !1, $17f526922e4a857c$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $17f526922e4a857c$var$V = null;
function $17f526922e4a857c$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $17f526922e4a857c$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $17f526922e4a857c$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $17f526922e4a857c$var$W(a, b, d);
    }
}
var $17f526922e4a857c$var$Oj = !1;
function $17f526922e4a857c$var$Pj(a, b) {
    $17f526922e4a857c$var$Cf = $17f526922e4a857c$var$dd;
    a = $17f526922e4a857c$var$Me();
    if ($17f526922e4a857c$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $17f526922e4a857c$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $17f526922e4a857c$var$dd = !1;
    for($17f526922e4a857c$var$V = b; null !== $17f526922e4a857c$var$V;)if (b = $17f526922e4a857c$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $17f526922e4a857c$var$V = a;
    else for(; null !== $17f526922e4a857c$var$V;){
        b = $17f526922e4a857c$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $17f526922e4a857c$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($17f526922e4a857c$var$p(163));
            }
        } catch (F) {
            $17f526922e4a857c$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $17f526922e4a857c$var$V = a;
            break;
        }
        $17f526922e4a857c$var$V = b.return;
    }
    n = $17f526922e4a857c$var$Oj;
    $17f526922e4a857c$var$Oj = !1;
    return n;
}
function $17f526922e4a857c$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $17f526922e4a857c$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $17f526922e4a857c$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $17f526922e4a857c$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $17f526922e4a857c$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $17f526922e4a857c$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$17f526922e4a857c$var$Of], delete b[$17f526922e4a857c$var$Pf], delete b[$17f526922e4a857c$var$of], delete b[$17f526922e4a857c$var$Qf], delete b[$17f526922e4a857c$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $17f526922e4a857c$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $17f526922e4a857c$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $17f526922e4a857c$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $17f526922e4a857c$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $17f526922e4a857c$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($17f526922e4a857c$var$Wj(a, b, c), a = a.sibling; null !== a;)$17f526922e4a857c$var$Wj(a, b, c), a = a.sibling;
}
function $17f526922e4a857c$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($17f526922e4a857c$var$Xj(a, b, c), a = a.sibling; null !== a;)$17f526922e4a857c$var$Xj(a, b, c), a = a.sibling;
}
var $17f526922e4a857c$var$X = null, $17f526922e4a857c$var$Yj = !1;
function $17f526922e4a857c$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$17f526922e4a857c$var$ak(a, b, c), c = c.sibling;
}
function $17f526922e4a857c$var$ak(a, b, c) {
    if ($17f526922e4a857c$var$lc && "function" === typeof $17f526922e4a857c$var$lc.onCommitFiberUnmount) try {
        $17f526922e4a857c$var$lc.onCommitFiberUnmount($17f526922e4a857c$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $17f526922e4a857c$var$U || $17f526922e4a857c$var$Mj(c, b);
        case 6:
            var d = $17f526922e4a857c$var$X, e = $17f526922e4a857c$var$Yj;
            $17f526922e4a857c$var$X = null;
            $17f526922e4a857c$var$Zj(a, b, c);
            $17f526922e4a857c$var$X = d;
            $17f526922e4a857c$var$Yj = e;
            null !== $17f526922e4a857c$var$X && ($17f526922e4a857c$var$Yj ? (a = $17f526922e4a857c$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $17f526922e4a857c$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $17f526922e4a857c$var$X && ($17f526922e4a857c$var$Yj ? (a = $17f526922e4a857c$var$X, c = c.stateNode, 8 === a.nodeType ? $17f526922e4a857c$var$Kf(a.parentNode, c) : 1 === a.nodeType && $17f526922e4a857c$var$Kf(a, c), $17f526922e4a857c$var$bd(a)) : $17f526922e4a857c$var$Kf($17f526922e4a857c$var$X, c.stateNode));
            break;
        case 4:
            d = $17f526922e4a857c$var$X;
            e = $17f526922e4a857c$var$Yj;
            $17f526922e4a857c$var$X = c.stateNode.containerInfo;
            $17f526922e4a857c$var$Yj = !0;
            $17f526922e4a857c$var$Zj(a, b, c);
            $17f526922e4a857c$var$X = d;
            $17f526922e4a857c$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$17f526922e4a857c$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $17f526922e4a857c$var$Nj(c, b, g) : 0 !== (f & 4) && $17f526922e4a857c$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $17f526922e4a857c$var$Zj(a, b, c);
            break;
        case 1:
            if (!$17f526922e4a857c$var$U && ($17f526922e4a857c$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $17f526922e4a857c$var$W(c, b, h);
            }
            $17f526922e4a857c$var$Zj(a, b, c);
            break;
        case 21:
            $17f526922e4a857c$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($17f526922e4a857c$var$U = (d = $17f526922e4a857c$var$U) || null !== c.memoizedState, $17f526922e4a857c$var$Zj(a, b, c), $17f526922e4a857c$var$U = d) : $17f526922e4a857c$var$Zj(a, b, c);
            break;
        default:
            $17f526922e4a857c$var$Zj(a, b, c);
    }
}
function $17f526922e4a857c$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $17f526922e4a857c$var$Lj);
        b.forEach(function(b) {
            var d = $17f526922e4a857c$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $17f526922e4a857c$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $17f526922e4a857c$var$X = h.stateNode;
                        $17f526922e4a857c$var$Yj = !1;
                        break a;
                    case 3:
                        $17f526922e4a857c$var$X = h.stateNode.containerInfo;
                        $17f526922e4a857c$var$Yj = !0;
                        break a;
                    case 4:
                        $17f526922e4a857c$var$X = h.stateNode.containerInfo;
                        $17f526922e4a857c$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $17f526922e4a857c$var$X) throw Error($17f526922e4a857c$var$p(160));
            $17f526922e4a857c$var$ak(f, g, e);
            $17f526922e4a857c$var$X = null;
            $17f526922e4a857c$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $17f526922e4a857c$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$17f526922e4a857c$var$ek(b, a), b = b.sibling;
}
function $17f526922e4a857c$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $17f526922e4a857c$var$dk(b, a);
            $17f526922e4a857c$var$fk(a);
            if (d & 4) {
                try {
                    $17f526922e4a857c$var$Qj(3, a, a.return), $17f526922e4a857c$var$Rj(3, a);
                } catch (t) {
                    $17f526922e4a857c$var$W(a, a.return, t);
                }
                try {
                    $17f526922e4a857c$var$Qj(5, a, a.return);
                } catch (t) {
                    $17f526922e4a857c$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $17f526922e4a857c$var$dk(b, a);
            $17f526922e4a857c$var$fk(a);
            d & 512 && null !== c && $17f526922e4a857c$var$Mj(c, c.return);
            break;
        case 5:
            $17f526922e4a857c$var$dk(b, a);
            $17f526922e4a857c$var$fk(a);
            d & 512 && null !== c && $17f526922e4a857c$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $17f526922e4a857c$var$ob(e, "");
                } catch (t) {
                    $17f526922e4a857c$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $17f526922e4a857c$var$ab(e, f);
                    $17f526922e4a857c$var$vb(h, g);
                    var l = $17f526922e4a857c$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $17f526922e4a857c$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $17f526922e4a857c$var$nb(e, q) : "children" === m ? $17f526922e4a857c$var$ob(e, q) : $17f526922e4a857c$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $17f526922e4a857c$var$bb(e, f);
                            break;
                        case "textarea":
                            $17f526922e4a857c$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $17f526922e4a857c$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $17f526922e4a857c$var$fb(e, !!f.multiple, f.defaultValue, !0) : $17f526922e4a857c$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$17f526922e4a857c$var$Pf] = f;
                } catch (t) {
                    $17f526922e4a857c$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $17f526922e4a857c$var$dk(b, a);
            $17f526922e4a857c$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($17f526922e4a857c$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $17f526922e4a857c$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $17f526922e4a857c$var$dk(b, a);
            $17f526922e4a857c$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $17f526922e4a857c$var$bd(b.containerInfo);
            } catch (t) {
                $17f526922e4a857c$var$W(a, a.return, t);
            }
            break;
        case 4:
            $17f526922e4a857c$var$dk(b, a);
            $17f526922e4a857c$var$fk(a);
            break;
        case 13:
            $17f526922e4a857c$var$dk(b, a);
            $17f526922e4a857c$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($17f526922e4a857c$var$gk = $17f526922e4a857c$var$B()));
            d & 4 && $17f526922e4a857c$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($17f526922e4a857c$var$U = (l = $17f526922e4a857c$var$U) || m, $17f526922e4a857c$var$dk(b, a), $17f526922e4a857c$var$U = l) : $17f526922e4a857c$var$dk(b, a);
            $17f526922e4a857c$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($17f526922e4a857c$var$V = a, m = a.child; null !== m;){
                    for(q = $17f526922e4a857c$var$V = m; null !== $17f526922e4a857c$var$V;){
                        r = $17f526922e4a857c$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $17f526922e4a857c$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $17f526922e4a857c$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $17f526922e4a857c$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $17f526922e4a857c$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $17f526922e4a857c$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $17f526922e4a857c$var$V = y) : $17f526922e4a857c$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $17f526922e4a857c$var$rb("display", g));
                            } catch (t) {
                                $17f526922e4a857c$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $17f526922e4a857c$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $17f526922e4a857c$var$dk(b, a);
            $17f526922e4a857c$var$fk(a);
            d & 4 && $17f526922e4a857c$var$bk(a);
            break;
        case 21:
            break;
        default:
            $17f526922e4a857c$var$dk(b, a), $17f526922e4a857c$var$fk(a);
    }
}
function $17f526922e4a857c$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($17f526922e4a857c$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($17f526922e4a857c$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($17f526922e4a857c$var$ob(e, ""), d.flags &= -33);
                    var f = $17f526922e4a857c$var$Vj(a);
                    $17f526922e4a857c$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $17f526922e4a857c$var$Vj(a);
                    $17f526922e4a857c$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($17f526922e4a857c$var$p(161));
            }
        } catch (k) {
            $17f526922e4a857c$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $17f526922e4a857c$var$ik(a, b, c) {
    $17f526922e4a857c$var$V = a;
    $17f526922e4a857c$var$jk(a, b, c);
}
function $17f526922e4a857c$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $17f526922e4a857c$var$V;){
        var e = $17f526922e4a857c$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $17f526922e4a857c$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $17f526922e4a857c$var$U;
                h = $17f526922e4a857c$var$Kj;
                var l = $17f526922e4a857c$var$U;
                $17f526922e4a857c$var$Kj = g;
                if (($17f526922e4a857c$var$U = k) && !l) for($17f526922e4a857c$var$V = e; null !== $17f526922e4a857c$var$V;)g = $17f526922e4a857c$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $17f526922e4a857c$var$kk(e) : null !== k ? (k.return = g, $17f526922e4a857c$var$V = k) : $17f526922e4a857c$var$kk(e);
                for(; null !== f;)$17f526922e4a857c$var$V = f, $17f526922e4a857c$var$jk(f, b, c), f = f.sibling;
                $17f526922e4a857c$var$V = e;
                $17f526922e4a857c$var$Kj = h;
                $17f526922e4a857c$var$U = l;
            }
            $17f526922e4a857c$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $17f526922e4a857c$var$V = f) : $17f526922e4a857c$var$lk(a, b, c);
    }
}
function $17f526922e4a857c$var$lk(a) {
    for(; null !== $17f526922e4a857c$var$V;){
        var b = $17f526922e4a857c$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $17f526922e4a857c$var$U || $17f526922e4a857c$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$17f526922e4a857c$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $17f526922e4a857c$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $17f526922e4a857c$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $17f526922e4a857c$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $17f526922e4a857c$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($17f526922e4a857c$var$p(163));
                }
                $17f526922e4a857c$var$U || b.flags & 512 && $17f526922e4a857c$var$Sj(b);
            } catch (r) {
                $17f526922e4a857c$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $17f526922e4a857c$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $17f526922e4a857c$var$V = c;
            break;
        }
        $17f526922e4a857c$var$V = b.return;
    }
}
function $17f526922e4a857c$var$hk(a) {
    for(; null !== $17f526922e4a857c$var$V;){
        var b = $17f526922e4a857c$var$V;
        if (b === a) {
            $17f526922e4a857c$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $17f526922e4a857c$var$V = c;
            break;
        }
        $17f526922e4a857c$var$V = b.return;
    }
}
function $17f526922e4a857c$var$kk(a) {
    for(; null !== $17f526922e4a857c$var$V;){
        var b = $17f526922e4a857c$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $17f526922e4a857c$var$Rj(4, b);
                    } catch (k) {
                        $17f526922e4a857c$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $17f526922e4a857c$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $17f526922e4a857c$var$Sj(b);
                    } catch (k) {
                        $17f526922e4a857c$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $17f526922e4a857c$var$Sj(b);
                    } catch (k) {
                        $17f526922e4a857c$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $17f526922e4a857c$var$W(b, b.return, k);
        }
        if (b === a) {
            $17f526922e4a857c$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $17f526922e4a857c$var$V = h;
            break;
        }
        $17f526922e4a857c$var$V = b.return;
    }
}
var $17f526922e4a857c$var$mk = Math.ceil, $17f526922e4a857c$var$nk = $17f526922e4a857c$var$ua.ReactCurrentDispatcher, $17f526922e4a857c$var$ok = $17f526922e4a857c$var$ua.ReactCurrentOwner, $17f526922e4a857c$var$pk = $17f526922e4a857c$var$ua.ReactCurrentBatchConfig, $17f526922e4a857c$var$K = 0, $17f526922e4a857c$var$R = null, $17f526922e4a857c$var$Y = null, $17f526922e4a857c$var$Z = 0, $17f526922e4a857c$var$gj = 0, $17f526922e4a857c$var$fj = $17f526922e4a857c$var$Uf(0), $17f526922e4a857c$var$T = 0, $17f526922e4a857c$var$qk = null, $17f526922e4a857c$var$hh = 0, $17f526922e4a857c$var$rk = 0, $17f526922e4a857c$var$sk = 0, $17f526922e4a857c$var$tk = null, $17f526922e4a857c$var$uk = null, $17f526922e4a857c$var$gk = 0, $17f526922e4a857c$var$Hj = Infinity, $17f526922e4a857c$var$vk = null, $17f526922e4a857c$var$Pi = !1, $17f526922e4a857c$var$Qi = null, $17f526922e4a857c$var$Si = null, $17f526922e4a857c$var$wk = !1, $17f526922e4a857c$var$xk = null, $17f526922e4a857c$var$yk = 0, $17f526922e4a857c$var$zk = 0, $17f526922e4a857c$var$Ak = null, $17f526922e4a857c$var$Bk = -1, $17f526922e4a857c$var$Ck = 0;
function $17f526922e4a857c$var$L() {
    return 0 !== ($17f526922e4a857c$var$K & 6) ? $17f526922e4a857c$var$B() : -1 !== $17f526922e4a857c$var$Bk ? $17f526922e4a857c$var$Bk : $17f526922e4a857c$var$Bk = $17f526922e4a857c$var$B();
}
function $17f526922e4a857c$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($17f526922e4a857c$var$K & 2) && 0 !== $17f526922e4a857c$var$Z) return $17f526922e4a857c$var$Z & -$17f526922e4a857c$var$Z;
    if (null !== $17f526922e4a857c$var$Kg.transition) return 0 === $17f526922e4a857c$var$Ck && ($17f526922e4a857c$var$Ck = $17f526922e4a857c$var$yc()), $17f526922e4a857c$var$Ck;
    a = $17f526922e4a857c$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $17f526922e4a857c$var$jd(a.type);
    return a;
}
function $17f526922e4a857c$var$mh(a, b, c, d) {
    if (50 < $17f526922e4a857c$var$zk) throw $17f526922e4a857c$var$zk = 0, $17f526922e4a857c$var$Ak = null, Error($17f526922e4a857c$var$p(185));
    $17f526922e4a857c$var$Ac(a, c, d);
    if (0 === ($17f526922e4a857c$var$K & 2) || a !== $17f526922e4a857c$var$R) a === $17f526922e4a857c$var$R && (0 === ($17f526922e4a857c$var$K & 2) && ($17f526922e4a857c$var$rk |= c), 4 === $17f526922e4a857c$var$T && $17f526922e4a857c$var$Dk(a, $17f526922e4a857c$var$Z)), $17f526922e4a857c$var$Ek(a, d), 1 === c && 0 === $17f526922e4a857c$var$K && 0 === (b.mode & 1) && ($17f526922e4a857c$var$Hj = $17f526922e4a857c$var$B() + 500, $17f526922e4a857c$var$fg && $17f526922e4a857c$var$jg());
}
function $17f526922e4a857c$var$Ek(a, b) {
    var c = a.callbackNode;
    $17f526922e4a857c$var$wc(a, b);
    var d = $17f526922e4a857c$var$uc(a, a === $17f526922e4a857c$var$R ? $17f526922e4a857c$var$Z : 0);
    if (0 === d) null !== c && $17f526922e4a857c$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $17f526922e4a857c$var$bc(c);
        if (1 === b) 0 === a.tag ? $17f526922e4a857c$var$ig($17f526922e4a857c$var$Fk.bind(null, a)) : $17f526922e4a857c$var$hg($17f526922e4a857c$var$Fk.bind(null, a)), $17f526922e4a857c$var$Jf(function() {
            0 === ($17f526922e4a857c$var$K & 6) && $17f526922e4a857c$var$jg();
        }), c = null;
        else {
            switch($17f526922e4a857c$var$Dc(d)){
                case 1:
                    c = $17f526922e4a857c$var$fc;
                    break;
                case 4:
                    c = $17f526922e4a857c$var$gc;
                    break;
                case 16:
                    c = $17f526922e4a857c$var$hc;
                    break;
                case 536870912:
                    c = $17f526922e4a857c$var$jc;
                    break;
                default:
                    c = $17f526922e4a857c$var$hc;
            }
            c = $17f526922e4a857c$var$Gk(c, $17f526922e4a857c$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $17f526922e4a857c$var$Hk(a, b) {
    $17f526922e4a857c$var$Bk = -1;
    $17f526922e4a857c$var$Ck = 0;
    if (0 !== ($17f526922e4a857c$var$K & 6)) throw Error($17f526922e4a857c$var$p(327));
    var c = a.callbackNode;
    if ($17f526922e4a857c$var$Ik() && a.callbackNode !== c) return null;
    var d = $17f526922e4a857c$var$uc(a, a === $17f526922e4a857c$var$R ? $17f526922e4a857c$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $17f526922e4a857c$var$Jk(a, d);
    else {
        b = d;
        var e = $17f526922e4a857c$var$K;
        $17f526922e4a857c$var$K |= 2;
        var f = $17f526922e4a857c$var$Kk();
        if ($17f526922e4a857c$var$R !== a || $17f526922e4a857c$var$Z !== b) $17f526922e4a857c$var$vk = null, $17f526922e4a857c$var$Hj = $17f526922e4a857c$var$B() + 500, $17f526922e4a857c$var$Lk(a, b);
        for(;;)try {
            $17f526922e4a857c$var$Mk();
            break;
        } catch (h) {
            $17f526922e4a857c$var$Nk(a, h);
        }
        $17f526922e4a857c$var$Qg();
        $17f526922e4a857c$var$nk.current = f;
        $17f526922e4a857c$var$K = e;
        null !== $17f526922e4a857c$var$Y ? b = 0 : ($17f526922e4a857c$var$R = null, $17f526922e4a857c$var$Z = 0, b = $17f526922e4a857c$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $17f526922e4a857c$var$xc(a), 0 !== e && (d = e, b = $17f526922e4a857c$var$Ok(a, e)));
        if (1 === b) throw c = $17f526922e4a857c$var$qk, $17f526922e4a857c$var$Lk(a, 0), $17f526922e4a857c$var$Dk(a, d), $17f526922e4a857c$var$Ek(a, $17f526922e4a857c$var$B()), c;
        if (6 === b) $17f526922e4a857c$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$17f526922e4a857c$var$Pk(e) && (b = $17f526922e4a857c$var$Jk(a, d), 2 === b && (f = $17f526922e4a857c$var$xc(a), 0 !== f && (d = f, b = $17f526922e4a857c$var$Ok(a, f))), 1 === b)) throw c = $17f526922e4a857c$var$qk, $17f526922e4a857c$var$Lk(a, 0), $17f526922e4a857c$var$Dk(a, d), $17f526922e4a857c$var$Ek(a, $17f526922e4a857c$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($17f526922e4a857c$var$p(345));
                case 2:
                    $17f526922e4a857c$var$Qk(a, $17f526922e4a857c$var$uk, $17f526922e4a857c$var$vk);
                    break;
                case 3:
                    $17f526922e4a857c$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $17f526922e4a857c$var$gk + 500 - $17f526922e4a857c$var$B(), 10 < b)) {
                        if (0 !== $17f526922e4a857c$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $17f526922e4a857c$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $17f526922e4a857c$var$Ff($17f526922e4a857c$var$Qk.bind(null, a, $17f526922e4a857c$var$uk, $17f526922e4a857c$var$vk), b);
                        break;
                    }
                    $17f526922e4a857c$var$Qk(a, $17f526922e4a857c$var$uk, $17f526922e4a857c$var$vk);
                    break;
                case 4:
                    $17f526922e4a857c$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $17f526922e4a857c$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $17f526922e4a857c$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $17f526922e4a857c$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $17f526922e4a857c$var$Ff($17f526922e4a857c$var$Qk.bind(null, a, $17f526922e4a857c$var$uk, $17f526922e4a857c$var$vk), d);
                        break;
                    }
                    $17f526922e4a857c$var$Qk(a, $17f526922e4a857c$var$uk, $17f526922e4a857c$var$vk);
                    break;
                case 5:
                    $17f526922e4a857c$var$Qk(a, $17f526922e4a857c$var$uk, $17f526922e4a857c$var$vk);
                    break;
                default:
                    throw Error($17f526922e4a857c$var$p(329));
            }
        }
    }
    $17f526922e4a857c$var$Ek(a, $17f526922e4a857c$var$B());
    return a.callbackNode === c ? $17f526922e4a857c$var$Hk.bind(null, a) : null;
}
function $17f526922e4a857c$var$Ok(a, b) {
    var c = $17f526922e4a857c$var$tk;
    a.current.memoizedState.isDehydrated && ($17f526922e4a857c$var$Lk(a, b).flags |= 256);
    a = $17f526922e4a857c$var$Jk(a, b);
    2 !== a && (b = $17f526922e4a857c$var$uk, $17f526922e4a857c$var$uk = c, null !== b && $17f526922e4a857c$var$Gj(b));
    return a;
}
function $17f526922e4a857c$var$Gj(a) {
    null === $17f526922e4a857c$var$uk ? $17f526922e4a857c$var$uk = a : $17f526922e4a857c$var$uk.push.apply($17f526922e4a857c$var$uk, a);
}
function $17f526922e4a857c$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$17f526922e4a857c$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $17f526922e4a857c$var$Dk(a, b) {
    b &= ~$17f526922e4a857c$var$sk;
    b &= ~$17f526922e4a857c$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $17f526922e4a857c$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $17f526922e4a857c$var$Fk(a) {
    if (0 !== ($17f526922e4a857c$var$K & 6)) throw Error($17f526922e4a857c$var$p(327));
    $17f526922e4a857c$var$Ik();
    var b = $17f526922e4a857c$var$uc(a, 0);
    if (0 === (b & 1)) return $17f526922e4a857c$var$Ek(a, $17f526922e4a857c$var$B()), null;
    var c = $17f526922e4a857c$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $17f526922e4a857c$var$xc(a);
        0 !== d && (b = d, c = $17f526922e4a857c$var$Ok(a, d));
    }
    if (1 === c) throw c = $17f526922e4a857c$var$qk, $17f526922e4a857c$var$Lk(a, 0), $17f526922e4a857c$var$Dk(a, b), $17f526922e4a857c$var$Ek(a, $17f526922e4a857c$var$B()), c;
    if (6 === c) throw Error($17f526922e4a857c$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $17f526922e4a857c$var$Qk(a, $17f526922e4a857c$var$uk, $17f526922e4a857c$var$vk);
    $17f526922e4a857c$var$Ek(a, $17f526922e4a857c$var$B());
    return null;
}
function $17f526922e4a857c$var$Rk(a, b) {
    var c = $17f526922e4a857c$var$K;
    $17f526922e4a857c$var$K |= 1;
    try {
        return a(b);
    } finally{
        $17f526922e4a857c$var$K = c, 0 === $17f526922e4a857c$var$K && ($17f526922e4a857c$var$Hj = $17f526922e4a857c$var$B() + 500, $17f526922e4a857c$var$fg && $17f526922e4a857c$var$jg());
    }
}
function $17f526922e4a857c$var$Sk(a) {
    null !== $17f526922e4a857c$var$xk && 0 === $17f526922e4a857c$var$xk.tag && 0 === ($17f526922e4a857c$var$K & 6) && $17f526922e4a857c$var$Ik();
    var b = $17f526922e4a857c$var$K;
    $17f526922e4a857c$var$K |= 1;
    var c = $17f526922e4a857c$var$pk.transition, d = $17f526922e4a857c$var$C;
    try {
        if ($17f526922e4a857c$var$pk.transition = null, $17f526922e4a857c$var$C = 1, a) return a();
    } finally{
        $17f526922e4a857c$var$C = d, $17f526922e4a857c$var$pk.transition = c, $17f526922e4a857c$var$K = b, 0 === ($17f526922e4a857c$var$K & 6) && $17f526922e4a857c$var$jg();
    }
}
function $17f526922e4a857c$var$Ij() {
    $17f526922e4a857c$var$gj = $17f526922e4a857c$var$fj.current;
    $17f526922e4a857c$var$E($17f526922e4a857c$var$fj);
}
function $17f526922e4a857c$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $17f526922e4a857c$var$Gf(c));
    if (null !== $17f526922e4a857c$var$Y) for(c = $17f526922e4a857c$var$Y.return; null !== c;){
        var d = c;
        $17f526922e4a857c$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $17f526922e4a857c$var$$f();
                break;
            case 3:
                $17f526922e4a857c$var$Jh();
                $17f526922e4a857c$var$E($17f526922e4a857c$var$Wf);
                $17f526922e4a857c$var$E($17f526922e4a857c$var$H);
                $17f526922e4a857c$var$Oh();
                break;
            case 5:
                $17f526922e4a857c$var$Lh(d);
                break;
            case 4:
                $17f526922e4a857c$var$Jh();
                break;
            case 13:
                $17f526922e4a857c$var$E($17f526922e4a857c$var$M);
                break;
            case 19:
                $17f526922e4a857c$var$E($17f526922e4a857c$var$M);
                break;
            case 10:
                $17f526922e4a857c$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $17f526922e4a857c$var$Ij();
        }
        c = c.return;
    }
    $17f526922e4a857c$var$R = a;
    $17f526922e4a857c$var$Y = a = $17f526922e4a857c$var$wh(a.current, null);
    $17f526922e4a857c$var$Z = $17f526922e4a857c$var$gj = b;
    $17f526922e4a857c$var$T = 0;
    $17f526922e4a857c$var$qk = null;
    $17f526922e4a857c$var$sk = $17f526922e4a857c$var$rk = $17f526922e4a857c$var$hh = 0;
    $17f526922e4a857c$var$uk = $17f526922e4a857c$var$tk = null;
    if (null !== $17f526922e4a857c$var$Wg) {
        for(b = 0; b < $17f526922e4a857c$var$Wg.length; b++)if (c = $17f526922e4a857c$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $17f526922e4a857c$var$Wg = null;
    }
    return a;
}
function $17f526922e4a857c$var$Nk(a, b) {
    do {
        var c = $17f526922e4a857c$var$Y;
        try {
            $17f526922e4a857c$var$Qg();
            $17f526922e4a857c$var$Ph.current = $17f526922e4a857c$var$ai;
            if ($17f526922e4a857c$var$Sh) {
                for(var d = $17f526922e4a857c$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $17f526922e4a857c$var$Sh = !1;
            }
            $17f526922e4a857c$var$Rh = 0;
            $17f526922e4a857c$var$P = $17f526922e4a857c$var$O = $17f526922e4a857c$var$N = null;
            $17f526922e4a857c$var$Th = !1;
            $17f526922e4a857c$var$Uh = 0;
            $17f526922e4a857c$var$ok.current = null;
            if (null === c || null === c.return) {
                $17f526922e4a857c$var$T = 1;
                $17f526922e4a857c$var$qk = b;
                $17f526922e4a857c$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $17f526922e4a857c$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $17f526922e4a857c$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $17f526922e4a857c$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $17f526922e4a857c$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $17f526922e4a857c$var$Ti(f, l, b);
                            $17f526922e4a857c$var$uj();
                            break a;
                        }
                        k = Error($17f526922e4a857c$var$p(426));
                    }
                } else if ($17f526922e4a857c$var$I && h.mode & 1) {
                    var J = $17f526922e4a857c$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $17f526922e4a857c$var$Wi(J, g, h, f, b);
                        $17f526922e4a857c$var$Jg($17f526922e4a857c$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $17f526922e4a857c$var$Ki(k, h);
                4 !== $17f526922e4a857c$var$T && ($17f526922e4a857c$var$T = 2);
                null === $17f526922e4a857c$var$tk ? $17f526922e4a857c$var$tk = [
                    f
                ] : $17f526922e4a857c$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $17f526922e4a857c$var$Oi(f, k, b);
                            $17f526922e4a857c$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $17f526922e4a857c$var$Si || !$17f526922e4a857c$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $17f526922e4a857c$var$Ri(f, h, b);
                                $17f526922e4a857c$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $17f526922e4a857c$var$Tk(c);
        } catch (na) {
            b = na;
            $17f526922e4a857c$var$Y === c && null !== c && ($17f526922e4a857c$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $17f526922e4a857c$var$Kk() {
    var a = $17f526922e4a857c$var$nk.current;
    $17f526922e4a857c$var$nk.current = $17f526922e4a857c$var$ai;
    return null === a ? $17f526922e4a857c$var$ai : a;
}
function $17f526922e4a857c$var$uj() {
    if (0 === $17f526922e4a857c$var$T || 3 === $17f526922e4a857c$var$T || 2 === $17f526922e4a857c$var$T) $17f526922e4a857c$var$T = 4;
    null === $17f526922e4a857c$var$R || 0 === ($17f526922e4a857c$var$hh & 268435455) && 0 === ($17f526922e4a857c$var$rk & 268435455) || $17f526922e4a857c$var$Dk($17f526922e4a857c$var$R, $17f526922e4a857c$var$Z);
}
function $17f526922e4a857c$var$Jk(a, b) {
    var c = $17f526922e4a857c$var$K;
    $17f526922e4a857c$var$K |= 2;
    var d = $17f526922e4a857c$var$Kk();
    if ($17f526922e4a857c$var$R !== a || $17f526922e4a857c$var$Z !== b) $17f526922e4a857c$var$vk = null, $17f526922e4a857c$var$Lk(a, b);
    for(;;)try {
        $17f526922e4a857c$var$Uk();
        break;
    } catch (e) {
        $17f526922e4a857c$var$Nk(a, e);
    }
    $17f526922e4a857c$var$Qg();
    $17f526922e4a857c$var$K = c;
    $17f526922e4a857c$var$nk.current = d;
    if (null !== $17f526922e4a857c$var$Y) throw Error($17f526922e4a857c$var$p(261));
    $17f526922e4a857c$var$R = null;
    $17f526922e4a857c$var$Z = 0;
    return $17f526922e4a857c$var$T;
}
function $17f526922e4a857c$var$Uk() {
    for(; null !== $17f526922e4a857c$var$Y;)$17f526922e4a857c$var$Vk($17f526922e4a857c$var$Y);
}
function $17f526922e4a857c$var$Mk() {
    for(; null !== $17f526922e4a857c$var$Y && !$17f526922e4a857c$var$cc();)$17f526922e4a857c$var$Vk($17f526922e4a857c$var$Y);
}
function $17f526922e4a857c$var$Vk(a) {
    var b = $17f526922e4a857c$var$Wk(a.alternate, a, $17f526922e4a857c$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $17f526922e4a857c$var$Tk(a) : $17f526922e4a857c$var$Y = b;
    $17f526922e4a857c$var$ok.current = null;
}
function $17f526922e4a857c$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $17f526922e4a857c$var$Fj(c, b, $17f526922e4a857c$var$gj), null !== c) {
                $17f526922e4a857c$var$Y = c;
                return;
            }
        } else {
            c = $17f526922e4a857c$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $17f526922e4a857c$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $17f526922e4a857c$var$T = 6;
                $17f526922e4a857c$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $17f526922e4a857c$var$Y = b;
            return;
        }
        $17f526922e4a857c$var$Y = b = a;
    }while (null !== b);
    0 === $17f526922e4a857c$var$T && ($17f526922e4a857c$var$T = 5);
}
function $17f526922e4a857c$var$Qk(a, b, c) {
    var d = $17f526922e4a857c$var$C, e = $17f526922e4a857c$var$pk.transition;
    try {
        $17f526922e4a857c$var$pk.transition = null, $17f526922e4a857c$var$C = 1, $17f526922e4a857c$var$Xk(a, b, c, d);
    } finally{
        $17f526922e4a857c$var$pk.transition = e, $17f526922e4a857c$var$C = d;
    }
    return null;
}
function $17f526922e4a857c$var$Xk(a, b, c, d) {
    do $17f526922e4a857c$var$Ik();
    while (null !== $17f526922e4a857c$var$xk);
    if (0 !== ($17f526922e4a857c$var$K & 6)) throw Error($17f526922e4a857c$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($17f526922e4a857c$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $17f526922e4a857c$var$Bc(a, f);
    a === $17f526922e4a857c$var$R && ($17f526922e4a857c$var$Y = $17f526922e4a857c$var$R = null, $17f526922e4a857c$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $17f526922e4a857c$var$wk || ($17f526922e4a857c$var$wk = !0, $17f526922e4a857c$var$Gk($17f526922e4a857c$var$hc, function() {
        $17f526922e4a857c$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $17f526922e4a857c$var$pk.transition;
        $17f526922e4a857c$var$pk.transition = null;
        var g = $17f526922e4a857c$var$C;
        $17f526922e4a857c$var$C = 1;
        var h = $17f526922e4a857c$var$K;
        $17f526922e4a857c$var$K |= 4;
        $17f526922e4a857c$var$ok.current = null;
        $17f526922e4a857c$var$Pj(a, c);
        $17f526922e4a857c$var$ek(c, a);
        $17f526922e4a857c$var$Oe($17f526922e4a857c$var$Df);
        $17f526922e4a857c$var$dd = !!$17f526922e4a857c$var$Cf;
        $17f526922e4a857c$var$Df = $17f526922e4a857c$var$Cf = null;
        a.current = c;
        $17f526922e4a857c$var$ik(c, a, e);
        $17f526922e4a857c$var$dc();
        $17f526922e4a857c$var$K = h;
        $17f526922e4a857c$var$C = g;
        $17f526922e4a857c$var$pk.transition = f;
    } else a.current = c;
    $17f526922e4a857c$var$wk && ($17f526922e4a857c$var$wk = !1, $17f526922e4a857c$var$xk = a, $17f526922e4a857c$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($17f526922e4a857c$var$Si = null);
    $17f526922e4a857c$var$mc(c.stateNode, d);
    $17f526922e4a857c$var$Ek(a, $17f526922e4a857c$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($17f526922e4a857c$var$Pi) throw $17f526922e4a857c$var$Pi = !1, a = $17f526922e4a857c$var$Qi, $17f526922e4a857c$var$Qi = null, a;
    0 !== ($17f526922e4a857c$var$yk & 1) && 0 !== a.tag && $17f526922e4a857c$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $17f526922e4a857c$var$Ak ? $17f526922e4a857c$var$zk++ : ($17f526922e4a857c$var$zk = 0, $17f526922e4a857c$var$Ak = a) : $17f526922e4a857c$var$zk = 0;
    $17f526922e4a857c$var$jg();
    return null;
}
function $17f526922e4a857c$var$Ik() {
    if (null !== $17f526922e4a857c$var$xk) {
        var a = $17f526922e4a857c$var$Dc($17f526922e4a857c$var$yk), b = $17f526922e4a857c$var$pk.transition, c = $17f526922e4a857c$var$C;
        try {
            $17f526922e4a857c$var$pk.transition = null;
            $17f526922e4a857c$var$C = 16 > a ? 16 : a;
            if (null === $17f526922e4a857c$var$xk) var d = !1;
            else {
                a = $17f526922e4a857c$var$xk;
                $17f526922e4a857c$var$xk = null;
                $17f526922e4a857c$var$yk = 0;
                if (0 !== ($17f526922e4a857c$var$K & 6)) throw Error($17f526922e4a857c$var$p(331));
                var e = $17f526922e4a857c$var$K;
                $17f526922e4a857c$var$K |= 4;
                for($17f526922e4a857c$var$V = a.current; null !== $17f526922e4a857c$var$V;){
                    var f = $17f526922e4a857c$var$V, g = f.child;
                    if (0 !== ($17f526922e4a857c$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($17f526922e4a857c$var$V = l; null !== $17f526922e4a857c$var$V;){
                                    var m = $17f526922e4a857c$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $17f526922e4a857c$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $17f526922e4a857c$var$V = q;
                                    else for(; null !== $17f526922e4a857c$var$V;){
                                        m = $17f526922e4a857c$var$V;
                                        var r = m.sibling, y = m.return;
                                        $17f526922e4a857c$var$Tj(m);
                                        if (m === l) {
                                            $17f526922e4a857c$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $17f526922e4a857c$var$V = r;
                                            break;
                                        }
                                        $17f526922e4a857c$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $17f526922e4a857c$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $17f526922e4a857c$var$V = g;
                    else b: for(; null !== $17f526922e4a857c$var$V;){
                        f = $17f526922e4a857c$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $17f526922e4a857c$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $17f526922e4a857c$var$V = x;
                            break b;
                        }
                        $17f526922e4a857c$var$V = f.return;
                    }
                }
                var w = a.current;
                for($17f526922e4a857c$var$V = w; null !== $17f526922e4a857c$var$V;){
                    g = $17f526922e4a857c$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $17f526922e4a857c$var$V = u;
                    else b: for(g = w; null !== $17f526922e4a857c$var$V;){
                        h = $17f526922e4a857c$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $17f526922e4a857c$var$Rj(9, h);
                            }
                        } catch (na) {
                            $17f526922e4a857c$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $17f526922e4a857c$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $17f526922e4a857c$var$V = F;
                            break b;
                        }
                        $17f526922e4a857c$var$V = h.return;
                    }
                }
                $17f526922e4a857c$var$K = e;
                $17f526922e4a857c$var$jg();
                if ($17f526922e4a857c$var$lc && "function" === typeof $17f526922e4a857c$var$lc.onPostCommitFiberRoot) try {
                    $17f526922e4a857c$var$lc.onPostCommitFiberRoot($17f526922e4a857c$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $17f526922e4a857c$var$C = c, $17f526922e4a857c$var$pk.transition = b;
        }
    }
    return !1;
}
function $17f526922e4a857c$var$Yk(a, b, c) {
    b = $17f526922e4a857c$var$Ki(c, b);
    b = $17f526922e4a857c$var$Oi(a, b, 1);
    a = $17f526922e4a857c$var$dh(a, b, 1);
    b = $17f526922e4a857c$var$L();
    null !== a && ($17f526922e4a857c$var$Ac(a, 1, b), $17f526922e4a857c$var$Ek(a, b));
}
function $17f526922e4a857c$var$W(a, b, c) {
    if (3 === a.tag) $17f526922e4a857c$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $17f526922e4a857c$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $17f526922e4a857c$var$Si || !$17f526922e4a857c$var$Si.has(d))) {
                a = $17f526922e4a857c$var$Ki(c, a);
                a = $17f526922e4a857c$var$Ri(b, a, 1);
                b = $17f526922e4a857c$var$dh(b, a, 1);
                a = $17f526922e4a857c$var$L();
                null !== b && ($17f526922e4a857c$var$Ac(b, 1, a), $17f526922e4a857c$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $17f526922e4a857c$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $17f526922e4a857c$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $17f526922e4a857c$var$R === a && ($17f526922e4a857c$var$Z & c) === c && (4 === $17f526922e4a857c$var$T || 3 === $17f526922e4a857c$var$T && ($17f526922e4a857c$var$Z & 130023424) === $17f526922e4a857c$var$Z && 500 > $17f526922e4a857c$var$B() - $17f526922e4a857c$var$gk ? $17f526922e4a857c$var$Lk(a, 0) : $17f526922e4a857c$var$sk |= c);
    $17f526922e4a857c$var$Ek(a, b);
}
function $17f526922e4a857c$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $17f526922e4a857c$var$sc, $17f526922e4a857c$var$sc <<= 1, 0 === ($17f526922e4a857c$var$sc & 130023424) && ($17f526922e4a857c$var$sc = 4194304)));
    var c = $17f526922e4a857c$var$L();
    a = $17f526922e4a857c$var$Zg(a, b);
    null !== a && ($17f526922e4a857c$var$Ac(a, b, c), $17f526922e4a857c$var$Ek(a, c));
}
function $17f526922e4a857c$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $17f526922e4a857c$var$Zk(a, c);
}
function $17f526922e4a857c$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($17f526922e4a857c$var$p(314));
    }
    null !== d && d.delete(b);
    $17f526922e4a857c$var$Zk(a, c);
}
var $17f526922e4a857c$var$Wk;
$17f526922e4a857c$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $17f526922e4a857c$var$Wf.current) $17f526922e4a857c$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $17f526922e4a857c$var$Ug = !1, $17f526922e4a857c$var$zj(a, b, c);
            $17f526922e4a857c$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $17f526922e4a857c$var$Ug = !1, $17f526922e4a857c$var$I && 0 !== (b.flags & 1048576) && $17f526922e4a857c$var$ug(b, $17f526922e4a857c$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $17f526922e4a857c$var$jj(a, b);
            a = b.pendingProps;
            var e = $17f526922e4a857c$var$Yf(b, $17f526922e4a857c$var$H.current);
            $17f526922e4a857c$var$Tg(b, c);
            e = $17f526922e4a857c$var$Xh(null, b, d, a, e, c);
            var f = $17f526922e4a857c$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $17f526922e4a857c$var$Zf(d) ? (f = !0, $17f526922e4a857c$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $17f526922e4a857c$var$ah(b), e.updater = $17f526922e4a857c$var$nh, b.stateNode = e, e._reactInternals = b, $17f526922e4a857c$var$rh(b, d, a, c), b = $17f526922e4a857c$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $17f526922e4a857c$var$I && f && $17f526922e4a857c$var$vg(b), $17f526922e4a857c$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $17f526922e4a857c$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $17f526922e4a857c$var$$k(d);
                a = $17f526922e4a857c$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $17f526922e4a857c$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $17f526922e4a857c$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $17f526922e4a857c$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $17f526922e4a857c$var$aj(null, b, d, $17f526922e4a857c$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($17f526922e4a857c$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $17f526922e4a857c$var$Lg(d, e), $17f526922e4a857c$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $17f526922e4a857c$var$Lg(d, e), $17f526922e4a857c$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $17f526922e4a857c$var$lj(b);
                if (null === a) throw Error($17f526922e4a857c$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $17f526922e4a857c$var$bh(a, b);
                $17f526922e4a857c$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $17f526922e4a857c$var$Ki(Error($17f526922e4a857c$var$p(423)), b);
                        b = $17f526922e4a857c$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $17f526922e4a857c$var$Ki(Error($17f526922e4a857c$var$p(424)), b);
                        b = $17f526922e4a857c$var$mj(a, b, d, c, e);
                        break a;
                    } else for($17f526922e4a857c$var$yg = $17f526922e4a857c$var$Lf(b.stateNode.containerInfo.firstChild), $17f526922e4a857c$var$xg = b, $17f526922e4a857c$var$I = !0, $17f526922e4a857c$var$zg = null, c = $17f526922e4a857c$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $17f526922e4a857c$var$Ig();
                    if (d === e) {
                        b = $17f526922e4a857c$var$$i(a, b, c);
                        break a;
                    }
                    $17f526922e4a857c$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $17f526922e4a857c$var$Kh(b), null === a && $17f526922e4a857c$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $17f526922e4a857c$var$Ef(d, e) ? g = null : null !== f && $17f526922e4a857c$var$Ef(d, f) && (b.flags |= 32), $17f526922e4a857c$var$hj(a, b), $17f526922e4a857c$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $17f526922e4a857c$var$Eg(b), null;
        case 13:
            return $17f526922e4a857c$var$pj(a, b, c);
        case 4:
            return $17f526922e4a857c$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $17f526922e4a857c$var$Bh(b, null, d, c) : $17f526922e4a857c$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $17f526922e4a857c$var$Lg(d, e), $17f526922e4a857c$var$Zi(a, b, d, e, c);
        case 7:
            return $17f526922e4a857c$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $17f526922e4a857c$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $17f526922e4a857c$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $17f526922e4a857c$var$G($17f526922e4a857c$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($17f526922e4a857c$var$He(f.value, g)) {
                        if (f.children === e.children && !$17f526922e4a857c$var$Wf.current) {
                            b = $17f526922e4a857c$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $17f526922e4a857c$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $17f526922e4a857c$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($17f526922e4a857c$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $17f526922e4a857c$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $17f526922e4a857c$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $17f526922e4a857c$var$Tg(b, c), e = $17f526922e4a857c$var$Vg(e), d = d(e), b.flags |= 1, $17f526922e4a857c$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $17f526922e4a857c$var$Lg(d, b.pendingProps), e = $17f526922e4a857c$var$Lg(d.type, e), $17f526922e4a857c$var$aj(a, b, d, e, c);
        case 15:
            return $17f526922e4a857c$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $17f526922e4a857c$var$Lg(d, e), $17f526922e4a857c$var$jj(a, b), b.tag = 1, $17f526922e4a857c$var$Zf(d) ? (a = !0, $17f526922e4a857c$var$cg(b)) : a = !1, $17f526922e4a857c$var$Tg(b, c), $17f526922e4a857c$var$ph(b, d, e), $17f526922e4a857c$var$rh(b, d, e, c), $17f526922e4a857c$var$kj(null, b, d, !0, a, c);
        case 19:
            return $17f526922e4a857c$var$yj(a, b, c);
        case 22:
            return $17f526922e4a857c$var$ej(a, b, c);
    }
    throw Error($17f526922e4a857c$var$p(156, b.tag));
};
function $17f526922e4a857c$var$Gk(a, b) {
    return $17f526922e4a857c$var$ac(a, b);
}
function $17f526922e4a857c$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $17f526922e4a857c$var$Bg(a, b, c, d) {
    return new $17f526922e4a857c$var$al(a, b, c, d);
}
function $17f526922e4a857c$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $17f526922e4a857c$var$$k(a) {
    if ("function" === typeof a) return $17f526922e4a857c$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $17f526922e4a857c$var$Da) return 11;
        if (a === $17f526922e4a857c$var$Ga) return 14;
    }
    return 2;
}
function $17f526922e4a857c$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $17f526922e4a857c$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $17f526922e4a857c$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $17f526922e4a857c$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $17f526922e4a857c$var$ya:
            return $17f526922e4a857c$var$Ah(c.children, e, f, b);
        case $17f526922e4a857c$var$za:
            g = 8;
            e |= 8;
            break;
        case $17f526922e4a857c$var$Aa:
            return a = $17f526922e4a857c$var$Bg(12, c, b, e | 2), a.elementType = $17f526922e4a857c$var$Aa, a.lanes = f, a;
        case $17f526922e4a857c$var$Ea:
            return a = $17f526922e4a857c$var$Bg(13, c, b, e), a.elementType = $17f526922e4a857c$var$Ea, a.lanes = f, a;
        case $17f526922e4a857c$var$Fa:
            return a = $17f526922e4a857c$var$Bg(19, c, b, e), a.elementType = $17f526922e4a857c$var$Fa, a.lanes = f, a;
        case $17f526922e4a857c$var$Ia:
            return $17f526922e4a857c$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $17f526922e4a857c$var$Ba:
                    g = 10;
                    break a;
                case $17f526922e4a857c$var$Ca:
                    g = 9;
                    break a;
                case $17f526922e4a857c$var$Da:
                    g = 11;
                    break a;
                case $17f526922e4a857c$var$Ga:
                    g = 14;
                    break a;
                case $17f526922e4a857c$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($17f526922e4a857c$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $17f526922e4a857c$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $17f526922e4a857c$var$Ah(a, b, c, d) {
    a = $17f526922e4a857c$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $17f526922e4a857c$var$qj(a, b, c, d) {
    a = $17f526922e4a857c$var$Bg(22, a, d, b);
    a.elementType = $17f526922e4a857c$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $17f526922e4a857c$var$xh(a, b, c) {
    a = $17f526922e4a857c$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $17f526922e4a857c$var$zh(a, b, c) {
    b = $17f526922e4a857c$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $17f526922e4a857c$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $17f526922e4a857c$var$zc(0);
    this.expirationTimes = $17f526922e4a857c$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $17f526922e4a857c$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $17f526922e4a857c$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $17f526922e4a857c$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $17f526922e4a857c$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $17f526922e4a857c$var$ah(f);
    return a;
}
function $17f526922e4a857c$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $17f526922e4a857c$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $17f526922e4a857c$var$el(a) {
    if (!a) return $17f526922e4a857c$var$Vf;
    a = a._reactInternals;
    a: {
        if ($17f526922e4a857c$var$Vb(a) !== a || 1 !== a.tag) throw Error($17f526922e4a857c$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($17f526922e4a857c$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($17f526922e4a857c$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($17f526922e4a857c$var$Zf(c)) return $17f526922e4a857c$var$bg(a, c, b);
    }
    return b;
}
function $17f526922e4a857c$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $17f526922e4a857c$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $17f526922e4a857c$var$el(null);
    c = a.current;
    d = $17f526922e4a857c$var$L();
    e = $17f526922e4a857c$var$lh(c);
    f = $17f526922e4a857c$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $17f526922e4a857c$var$dh(c, f, e);
    a.current.lanes = e;
    $17f526922e4a857c$var$Ac(a, e, d);
    $17f526922e4a857c$var$Ek(a, d);
    return a;
}
function $17f526922e4a857c$var$gl(a, b, c, d) {
    var e = b.current, f = $17f526922e4a857c$var$L(), g = $17f526922e4a857c$var$lh(e);
    c = $17f526922e4a857c$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $17f526922e4a857c$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $17f526922e4a857c$var$dh(e, b, g);
    null !== a && ($17f526922e4a857c$var$mh(a, e, g, f), $17f526922e4a857c$var$eh(a, e, g));
    return g;
}
function $17f526922e4a857c$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $17f526922e4a857c$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $17f526922e4a857c$var$jl(a, b) {
    $17f526922e4a857c$var$il(a, b);
    (a = a.alternate) && $17f526922e4a857c$var$il(a, b);
}
function $17f526922e4a857c$var$kl() {
    return null;
}
var $17f526922e4a857c$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $17f526922e4a857c$var$ml(a) {
    this._internalRoot = a;
}
$17f526922e4a857c$var$nl.prototype.render = $17f526922e4a857c$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($17f526922e4a857c$var$p(409));
    $17f526922e4a857c$var$gl(a, b, null, null);
};
$17f526922e4a857c$var$nl.prototype.unmount = $17f526922e4a857c$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $17f526922e4a857c$var$Sk(function() {
            $17f526922e4a857c$var$gl(null, a, null, null);
        });
        b[$17f526922e4a857c$var$uf] = null;
    }
};
function $17f526922e4a857c$var$nl(a) {
    this._internalRoot = a;
}
$17f526922e4a857c$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $17f526922e4a857c$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $17f526922e4a857c$var$Qc.length && 0 !== b && b < $17f526922e4a857c$var$Qc[c].priority; c++);
        $17f526922e4a857c$var$Qc.splice(c, 0, a);
        0 === c && $17f526922e4a857c$var$Vc(a);
    }
};
function $17f526922e4a857c$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $17f526922e4a857c$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $17f526922e4a857c$var$ql() {}
function $17f526922e4a857c$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $17f526922e4a857c$var$hl(g);
                f.call(a);
            };
        }
        var g = $17f526922e4a857c$var$fl(b, d, a, 0, null, !1, !1, "", $17f526922e4a857c$var$ql);
        a._reactRootContainer = g;
        a[$17f526922e4a857c$var$uf] = g.current;
        $17f526922e4a857c$var$sf(8 === a.nodeType ? a.parentNode : a);
        $17f526922e4a857c$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $17f526922e4a857c$var$hl(k);
            h.call(a);
        };
    }
    var k = $17f526922e4a857c$var$cl(a, 0, !1, null, null, !1, !1, "", $17f526922e4a857c$var$ql);
    a._reactRootContainer = k;
    a[$17f526922e4a857c$var$uf] = k.current;
    $17f526922e4a857c$var$sf(8 === a.nodeType ? a.parentNode : a);
    $17f526922e4a857c$var$Sk(function() {
        $17f526922e4a857c$var$gl(b, k, c, d);
    });
    return k;
}
function $17f526922e4a857c$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $17f526922e4a857c$var$hl(g);
                h.call(a);
            };
        }
        $17f526922e4a857c$var$gl(b, g, a, e);
    } else g = $17f526922e4a857c$var$rl(c, b, a, e, d);
    return $17f526922e4a857c$var$hl(g);
}
$17f526922e4a857c$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $17f526922e4a857c$var$tc(b.pendingLanes);
                0 !== c && ($17f526922e4a857c$var$Cc(b, c | 1), $17f526922e4a857c$var$Ek(b, $17f526922e4a857c$var$B()), 0 === ($17f526922e4a857c$var$K & 6) && ($17f526922e4a857c$var$Hj = $17f526922e4a857c$var$B() + 500, $17f526922e4a857c$var$jg()));
            }
            break;
        case 13:
            $17f526922e4a857c$var$Sk(function() {
                var b = $17f526922e4a857c$var$Zg(a, 1);
                if (null !== b) {
                    var c = $17f526922e4a857c$var$L();
                    $17f526922e4a857c$var$mh(b, a, 1, c);
                }
            }), $17f526922e4a857c$var$jl(a, 1);
    }
};
$17f526922e4a857c$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $17f526922e4a857c$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $17f526922e4a857c$var$L();
            $17f526922e4a857c$var$mh(b, a, 134217728, c);
        }
        $17f526922e4a857c$var$jl(a, 134217728);
    }
};
$17f526922e4a857c$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $17f526922e4a857c$var$lh(a), c = $17f526922e4a857c$var$Zg(a, b);
        if (null !== c) {
            var d = $17f526922e4a857c$var$L();
            $17f526922e4a857c$var$mh(c, a, b, d);
        }
        $17f526922e4a857c$var$jl(a, b);
    }
};
$17f526922e4a857c$var$Hc = function() {
    return $17f526922e4a857c$var$C;
};
$17f526922e4a857c$var$Ic = function(a, b) {
    var c = $17f526922e4a857c$var$C;
    try {
        return $17f526922e4a857c$var$C = a, b();
    } finally{
        $17f526922e4a857c$var$C = c;
    }
};
$17f526922e4a857c$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $17f526922e4a857c$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $17f526922e4a857c$var$Db(d);
                        if (!e) throw Error($17f526922e4a857c$var$p(90));
                        $17f526922e4a857c$var$Wa(d);
                        $17f526922e4a857c$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $17f526922e4a857c$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $17f526922e4a857c$var$fb(a, !!c.multiple, b, !1);
    }
};
$17f526922e4a857c$var$Gb = $17f526922e4a857c$var$Rk;
$17f526922e4a857c$var$Hb = $17f526922e4a857c$var$Sk;
var $17f526922e4a857c$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $17f526922e4a857c$var$Cb,
        $17f526922e4a857c$var$ue,
        $17f526922e4a857c$var$Db,
        $17f526922e4a857c$var$Eb,
        $17f526922e4a857c$var$Fb,
        $17f526922e4a857c$var$Rk
    ]
}, $17f526922e4a857c$var$ul = {
    findFiberByHostInstance: $17f526922e4a857c$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $17f526922e4a857c$var$vl = {
    bundleType: $17f526922e4a857c$var$ul.bundleType,
    version: $17f526922e4a857c$var$ul.version,
    rendererPackageName: $17f526922e4a857c$var$ul.rendererPackageName,
    rendererConfig: $17f526922e4a857c$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $17f526922e4a857c$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $17f526922e4a857c$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $17f526922e4a857c$var$ul.findFiberByHostInstance || $17f526922e4a857c$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $17f526922e4a857c$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$17f526922e4a857c$var$wl.isDisabled && $17f526922e4a857c$var$wl.supportsFiber) try {
        $17f526922e4a857c$var$kc = $17f526922e4a857c$var$wl.inject($17f526922e4a857c$var$vl), $17f526922e4a857c$var$lc = $17f526922e4a857c$var$wl;
    } catch (a) {}
}
$17f526922e4a857c$export$ae55be85d98224ed = $17f526922e4a857c$var$tl;
$17f526922e4a857c$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$17f526922e4a857c$var$ol(b)) throw Error($17f526922e4a857c$var$p(200));
    return $17f526922e4a857c$var$dl(a, b, null, c);
};
$17f526922e4a857c$export$882461b6382ed46c = function(a, b) {
    if (!$17f526922e4a857c$var$ol(a)) throw Error($17f526922e4a857c$var$p(299));
    var c = !1, d = "", e = $17f526922e4a857c$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $17f526922e4a857c$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$17f526922e4a857c$var$uf] = b.current;
    $17f526922e4a857c$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $17f526922e4a857c$var$ml(b);
};
$17f526922e4a857c$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($17f526922e4a857c$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($17f526922e4a857c$var$p(268, a));
    }
    a = $17f526922e4a857c$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$17f526922e4a857c$export$cd75ccfd720a3cd4 = function(a) {
    return $17f526922e4a857c$var$Sk(a);
};
$17f526922e4a857c$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$17f526922e4a857c$var$pl(b)) throw Error($17f526922e4a857c$var$p(200));
    return $17f526922e4a857c$var$sl(null, a, b, !0, c);
};
$17f526922e4a857c$export$757ceba2d55c277e = function(a, b, c) {
    if (!$17f526922e4a857c$var$ol(a)) throw Error($17f526922e4a857c$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $17f526922e4a857c$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $17f526922e4a857c$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$17f526922e4a857c$var$uf] = b.current;
    $17f526922e4a857c$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $17f526922e4a857c$var$nl(b);
};
$17f526922e4a857c$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$17f526922e4a857c$var$pl(b)) throw Error($17f526922e4a857c$var$p(200));
    return $17f526922e4a857c$var$sl(null, a, b, !1, c);
};
$17f526922e4a857c$export$502457920280e6be = function(a) {
    if (!$17f526922e4a857c$var$pl(a)) throw Error($17f526922e4a857c$var$p(40));
    return a._reactRootContainer ? ($17f526922e4a857c$var$Sk(function() {
        $17f526922e4a857c$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$17f526922e4a857c$var$uf] = null;
        });
    }), !0) : !1;
};
$17f526922e4a857c$export$c78a37762a8d58e1 = $17f526922e4a857c$var$Rk;
$17f526922e4a857c$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$17f526922e4a857c$var$pl(c)) throw Error($17f526922e4a857c$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($17f526922e4a857c$var$p(38));
    return $17f526922e4a857c$var$sl(a, b, c, !1, d);
};
$17f526922e4a857c$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("clk2u", function(module, exports) {
'use strict';

module.exports = (parcelRequire("5fXYF"));

});
parcelRegister("5fXYF", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $3d3ce0c592af0505$export$c4744153514ff05d, (v) => $3d3ce0c592af0505$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $3d3ce0c592af0505$export$3e506c1ccc9cc1a7, (v) => $3d3ce0c592af0505$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $3d3ce0c592af0505$export$e26fe2ed2fa76875, (v) => $3d3ce0c592af0505$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $3d3ce0c592af0505$export$502329bbf4b505b1, (v) => $3d3ce0c592af0505$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $3d3ce0c592af0505$export$6e3807111c4874c4, (v) => $3d3ce0c592af0505$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $3d3ce0c592af0505$export$c27134553091fb3a, (v) => $3d3ce0c592af0505$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $3d3ce0c592af0505$export$33ee1acdc04fd2a2, (v) => $3d3ce0c592af0505$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $3d3ce0c592af0505$export$b00a404bbd5edef2, (v) => $3d3ce0c592af0505$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $3d3ce0c592af0505$export$8352ce38b91d0c62, (v) => $3d3ce0c592af0505$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $3d3ce0c592af0505$export$d66a1c1c77bd778b, (v) => $3d3ce0c592af0505$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $3d3ce0c592af0505$export$d3dfb8e4810cb555, (v) => $3d3ce0c592af0505$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $3d3ce0c592af0505$export$839f9183b0465a69, (v) => $3d3ce0c592af0505$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $3d3ce0c592af0505$export$72fdf0e06517287b, (v) => $3d3ce0c592af0505$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $3d3ce0c592af0505$export$4b844e58a3e414b4, (v) => $3d3ce0c592af0505$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $3d3ce0c592af0505$export$816d2913ae6b83b1, (v) => $3d3ce0c592af0505$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $3d3ce0c592af0505$export$61bcfe829111a1d0, (v) => $3d3ce0c592af0505$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $3d3ce0c592af0505$export$7ee8c9beb337bc3f, (v) => $3d3ce0c592af0505$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $3d3ce0c592af0505$export$b5836b71941fa3ed, (v) => $3d3ce0c592af0505$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $3d3ce0c592af0505$export$cf845f2c119da08a, (v) => $3d3ce0c592af0505$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3d3ce0c592af0505$export$c4744153514ff05d;
var $3d3ce0c592af0505$export$3e506c1ccc9cc1a7;
var $3d3ce0c592af0505$export$e26fe2ed2fa76875;
var $3d3ce0c592af0505$export$502329bbf4b505b1;
var $3d3ce0c592af0505$export$6e3807111c4874c4;
var $3d3ce0c592af0505$export$c27134553091fb3a;
var $3d3ce0c592af0505$export$33ee1acdc04fd2a2;
var $3d3ce0c592af0505$export$b00a404bbd5edef2;
var $3d3ce0c592af0505$export$8352ce38b91d0c62;
var $3d3ce0c592af0505$export$d66a1c1c77bd778b;
var $3d3ce0c592af0505$export$d3dfb8e4810cb555;
var $3d3ce0c592af0505$export$839f9183b0465a69;
var $3d3ce0c592af0505$export$72fdf0e06517287b;
var $3d3ce0c592af0505$export$4b844e58a3e414b4;
var $3d3ce0c592af0505$export$816d2913ae6b83b1;
var $3d3ce0c592af0505$export$61bcfe829111a1d0;
var $3d3ce0c592af0505$export$7ee8c9beb337bc3f;
var $3d3ce0c592af0505$export$b5836b71941fa3ed;
var $3d3ce0c592af0505$export$cf845f2c119da08a;
'use strict';
function $3d3ce0c592af0505$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $3d3ce0c592af0505$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $3d3ce0c592af0505$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $3d3ce0c592af0505$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $3d3ce0c592af0505$var$g(C, c)) n < e && 0 > $3d3ce0c592af0505$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $3d3ce0c592af0505$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $3d3ce0c592af0505$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $3d3ce0c592af0505$var$l = performance;
    $3d3ce0c592af0505$export$c4744153514ff05d = function() {
        return $3d3ce0c592af0505$var$l.now();
    };
} else {
    var $3d3ce0c592af0505$var$p = Date, $3d3ce0c592af0505$var$q = $3d3ce0c592af0505$var$p.now();
    $3d3ce0c592af0505$export$c4744153514ff05d = function() {
        return $3d3ce0c592af0505$var$p.now() - $3d3ce0c592af0505$var$q;
    };
}
var $3d3ce0c592af0505$var$r = [], $3d3ce0c592af0505$var$t = [], $3d3ce0c592af0505$var$u = 1, $3d3ce0c592af0505$var$v = null, $3d3ce0c592af0505$var$y = 3, $3d3ce0c592af0505$var$z = !1, $3d3ce0c592af0505$var$A = !1, $3d3ce0c592af0505$var$B = !1, $3d3ce0c592af0505$var$D = "function" === typeof setTimeout ? setTimeout : null, $3d3ce0c592af0505$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $3d3ce0c592af0505$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $3d3ce0c592af0505$var$G(a) {
    for(var b = $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$t); null !== b;){
        if (null === b.callback) $3d3ce0c592af0505$var$k($3d3ce0c592af0505$var$t);
        else if (b.startTime <= a) $3d3ce0c592af0505$var$k($3d3ce0c592af0505$var$t), b.sortIndex = b.expirationTime, $3d3ce0c592af0505$var$f($3d3ce0c592af0505$var$r, b);
        else break;
        b = $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$t);
    }
}
function $3d3ce0c592af0505$var$H(a) {
    $3d3ce0c592af0505$var$B = !1;
    $3d3ce0c592af0505$var$G(a);
    if (!$3d3ce0c592af0505$var$A) {
        if (null !== $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$r)) $3d3ce0c592af0505$var$A = !0, $3d3ce0c592af0505$var$I($3d3ce0c592af0505$var$J);
        else {
            var b = $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$t);
            null !== b && $3d3ce0c592af0505$var$K($3d3ce0c592af0505$var$H, b.startTime - a);
        }
    }
}
function $3d3ce0c592af0505$var$J(a, b) {
    $3d3ce0c592af0505$var$A = !1;
    $3d3ce0c592af0505$var$B && ($3d3ce0c592af0505$var$B = !1, $3d3ce0c592af0505$var$E($3d3ce0c592af0505$var$L), $3d3ce0c592af0505$var$L = -1);
    $3d3ce0c592af0505$var$z = !0;
    var c = $3d3ce0c592af0505$var$y;
    try {
        $3d3ce0c592af0505$var$G(b);
        for($3d3ce0c592af0505$var$v = $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$r); null !== $3d3ce0c592af0505$var$v && (!($3d3ce0c592af0505$var$v.expirationTime > b) || a && !$3d3ce0c592af0505$var$M());){
            var d = $3d3ce0c592af0505$var$v.callback;
            if ("function" === typeof d) {
                $3d3ce0c592af0505$var$v.callback = null;
                $3d3ce0c592af0505$var$y = $3d3ce0c592af0505$var$v.priorityLevel;
                var e = d($3d3ce0c592af0505$var$v.expirationTime <= b);
                b = $3d3ce0c592af0505$export$c4744153514ff05d();
                "function" === typeof e ? $3d3ce0c592af0505$var$v.callback = e : $3d3ce0c592af0505$var$v === $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$r) && $3d3ce0c592af0505$var$k($3d3ce0c592af0505$var$r);
                $3d3ce0c592af0505$var$G(b);
            } else $3d3ce0c592af0505$var$k($3d3ce0c592af0505$var$r);
            $3d3ce0c592af0505$var$v = $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$r);
        }
        if (null !== $3d3ce0c592af0505$var$v) var w = !0;
        else {
            var m = $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$t);
            null !== m && $3d3ce0c592af0505$var$K($3d3ce0c592af0505$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $3d3ce0c592af0505$var$v = null, $3d3ce0c592af0505$var$y = c, $3d3ce0c592af0505$var$z = !1;
    }
}
var $3d3ce0c592af0505$var$N = !1, $3d3ce0c592af0505$var$O = null, $3d3ce0c592af0505$var$L = -1, $3d3ce0c592af0505$var$P = 5, $3d3ce0c592af0505$var$Q = -1;
function $3d3ce0c592af0505$var$M() {
    return $3d3ce0c592af0505$export$c4744153514ff05d() - $3d3ce0c592af0505$var$Q < $3d3ce0c592af0505$var$P ? !1 : !0;
}
function $3d3ce0c592af0505$var$R() {
    if (null !== $3d3ce0c592af0505$var$O) {
        var a = $3d3ce0c592af0505$export$c4744153514ff05d();
        $3d3ce0c592af0505$var$Q = a;
        var b = !0;
        try {
            b = $3d3ce0c592af0505$var$O(!0, a);
        } finally{
            b ? $3d3ce0c592af0505$var$S() : ($3d3ce0c592af0505$var$N = !1, $3d3ce0c592af0505$var$O = null);
        }
    } else $3d3ce0c592af0505$var$N = !1;
}
var $3d3ce0c592af0505$var$S;
if ("function" === typeof $3d3ce0c592af0505$var$F) $3d3ce0c592af0505$var$S = function() {
    $3d3ce0c592af0505$var$F($3d3ce0c592af0505$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $3d3ce0c592af0505$var$T = new MessageChannel, $3d3ce0c592af0505$var$U = $3d3ce0c592af0505$var$T.port2;
    $3d3ce0c592af0505$var$T.port1.onmessage = $3d3ce0c592af0505$var$R;
    $3d3ce0c592af0505$var$S = function() {
        $3d3ce0c592af0505$var$U.postMessage(null);
    };
} else $3d3ce0c592af0505$var$S = function() {
    $3d3ce0c592af0505$var$D($3d3ce0c592af0505$var$R, 0);
};
function $3d3ce0c592af0505$var$I(a) {
    $3d3ce0c592af0505$var$O = a;
    $3d3ce0c592af0505$var$N || ($3d3ce0c592af0505$var$N = !0, $3d3ce0c592af0505$var$S());
}
function $3d3ce0c592af0505$var$K(a, b) {
    $3d3ce0c592af0505$var$L = $3d3ce0c592af0505$var$D(function() {
        a($3d3ce0c592af0505$export$c4744153514ff05d());
    }, b);
}
$3d3ce0c592af0505$export$3e506c1ccc9cc1a7 = 5;
$3d3ce0c592af0505$export$e26fe2ed2fa76875 = 1;
$3d3ce0c592af0505$export$502329bbf4b505b1 = 4;
$3d3ce0c592af0505$export$6e3807111c4874c4 = 3;
$3d3ce0c592af0505$export$c27134553091fb3a = null;
$3d3ce0c592af0505$export$33ee1acdc04fd2a2 = 2;
$3d3ce0c592af0505$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$3d3ce0c592af0505$export$8352ce38b91d0c62 = function() {
    $3d3ce0c592af0505$var$A || $3d3ce0c592af0505$var$z || ($3d3ce0c592af0505$var$A = !0, $3d3ce0c592af0505$var$I($3d3ce0c592af0505$var$J));
};
$3d3ce0c592af0505$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $3d3ce0c592af0505$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$3d3ce0c592af0505$export$d3dfb8e4810cb555 = function() {
    return $3d3ce0c592af0505$var$y;
};
$3d3ce0c592af0505$export$839f9183b0465a69 = function() {
    return $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$r);
};
$3d3ce0c592af0505$export$72fdf0e06517287b = function(a) {
    switch($3d3ce0c592af0505$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $3d3ce0c592af0505$var$y;
    }
    var c = $3d3ce0c592af0505$var$y;
    $3d3ce0c592af0505$var$y = b;
    try {
        return a();
    } finally{
        $3d3ce0c592af0505$var$y = c;
    }
};
$3d3ce0c592af0505$export$4b844e58a3e414b4 = function() {};
$3d3ce0c592af0505$export$816d2913ae6b83b1 = function() {};
$3d3ce0c592af0505$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $3d3ce0c592af0505$var$y;
    $3d3ce0c592af0505$var$y = a;
    try {
        return b();
    } finally{
        $3d3ce0c592af0505$var$y = c;
    }
};
$3d3ce0c592af0505$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $3d3ce0c592af0505$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $3d3ce0c592af0505$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $3d3ce0c592af0505$var$f($3d3ce0c592af0505$var$t, a), null === $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$r) && a === $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$t) && ($3d3ce0c592af0505$var$B ? ($3d3ce0c592af0505$var$E($3d3ce0c592af0505$var$L), $3d3ce0c592af0505$var$L = -1) : $3d3ce0c592af0505$var$B = !0, $3d3ce0c592af0505$var$K($3d3ce0c592af0505$var$H, c - d))) : (a.sortIndex = e, $3d3ce0c592af0505$var$f($3d3ce0c592af0505$var$r, a), $3d3ce0c592af0505$var$A || $3d3ce0c592af0505$var$z || ($3d3ce0c592af0505$var$A = !0, $3d3ce0c592af0505$var$I($3d3ce0c592af0505$var$J)));
    return a;
};
$3d3ce0c592af0505$export$b5836b71941fa3ed = $3d3ce0c592af0505$var$M;
$3d3ce0c592af0505$export$cf845f2c119da08a = function(a) {
    var b = $3d3ce0c592af0505$var$y;
    return function() {
        var c = $3d3ce0c592af0505$var$y;
        $3d3ce0c592af0505$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $3d3ce0c592af0505$var$y = c;
        }
    };
};

});




parcelRegister("eZfYi", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $ae9326d050e081cf$export$bf730a2d8bf68b42, (v) => $ae9326d050e081cf$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ae9326d050e081cf$export$bf730a2d8bf68b42;
'use strict';

var $8NFma = parcelRequire("8NFma");
function $ae9326d050e081cf$var$n(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $ae9326d050e081cf$var$p = "function" === typeof Object.is ? Object.is : $ae9326d050e081cf$var$n, $ae9326d050e081cf$var$q = $8NFma.useSyncExternalStore, $ae9326d050e081cf$var$r = $8NFma.useRef, $ae9326d050e081cf$var$t = $8NFma.useEffect, $ae9326d050e081cf$var$u = $8NFma.useMemo, $ae9326d050e081cf$var$v = $8NFma.useDebugValue;
$ae9326d050e081cf$export$bf730a2d8bf68b42 = function(a, b, e, l, h) {
    var c = $ae9326d050e081cf$var$r(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $ae9326d050e081cf$var$u(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== h && f.hasValue) {
                    var b = f.value;
                    if (h(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($ae9326d050e081cf$var$p(d, a)) return b;
            var e = l(a);
            if (void 0 !== h && h(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        h
    ]);
    var d = $ae9326d050e081cf$var$q(a, c[0], c[1]);
    $ae9326d050e081cf$var$t(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $ae9326d050e081cf$var$v(d);
    return d;
};

});

parcelRegister("YChVI", function(module, exports) {
//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, 'toString')) a.toString = b.toString;
        if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m), parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            }), isNowValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
            if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
            else return isNowValid;
        }
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this['_' + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
        return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = '', i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
            return tok;
        }).join('');
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {};
    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }
    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {};
    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        return mom.isValid() ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }
    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            } else mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === 'string') token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken('M', [
        'MM',
        2
    ], 'Mo', function() {
        return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // ALIASES
    addUnitAlias('month', 'M');
    // PRIORITY
    addUnitPriority('month', 8);
    // PARSING
    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        'M',
        'MM'
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        'MMM',
        'MMMM'
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        var dayOfMonth;
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, 'Month');
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for(i = 0; i < 12; i++){
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for(i = 0; i < 24; i++)mixedPieces[i] = regexEscape(mixedPieces[i]);
        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken('Y', 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, [
        'YY',
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        'YYYY',
        4
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYY',
        5
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYYY',
        6,
        true
    ], 0, 'year');
    // ALIASES
    addUnitAlias('year', 'y');
    // PRIORITIES
    addUnitPriority('year', 1);
    // PARSING
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken([
        'YYYYY',
        'YYYYYY'
    ], YEAR);
    addParseToken('YYYY', function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken('w', [
        'ww',
        2
    ], 'wo', 'week');
    addFormatToken('W', [
        'WW',
        2
    ], 'Wo', 'isoWeek');
    // ALIASES
    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');
    // PRIORITIES
    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);
    // PARSING
    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken([
        'w',
        'ww',
        'W',
        'WW'
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    // FORMATTING
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    // ALIASES
    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');
    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);
    // PARSING
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        'dd',
        'ddd',
        'dddd'
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        'd',
        'e',
        'E'
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== 'string') return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === 'number') return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken('H', [
        'HH',
        2
    ], 0, 'hour');
    addFormatToken('h', [
        'hh',
        2
    ], 0, hFormat);
    addFormatToken('k', [
        'kk',
        2
    ], 0, kFormat);
    addFormatToken('hmm', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem('a', true);
    meridiem('A', false);
    // ALIASES
    addUnitAlias('hour', 'h');
    // PRIORITY
    addUnitPriority('hour', 13);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken([
        'H',
        'HH'
    ], HOUR);
    addParseToken([
        'k',
        'kk'
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        'a',
        'A'
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        'h',
        'hh'
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? 'pm' : 'PM';
        else return isLower ? 'am' : 'AM';
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        return name.match('^[^/\\\\]*$') != null;
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire('./locale/' + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== 'undefined' && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            'YYYYYY-MM-DD',
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            'YYYY-MM-DD',
            /\d{4}-\d\d-\d\d/
        ],
        [
            'GGGG-[W]WW-E',
            /\d{4}-W\d\d-\d/
        ],
        [
            'GGGG-[W]WW',
            /\d{4}-W\d\d/,
            false
        ],
        [
            'YYYY-DDD',
            /\d{4}-\d{3}/
        ],
        [
            'YYYY-MM',
            /\d{4}-\d\d/,
            false
        ],
        [
            'YYYYYYMMDD',
            /[+-]\d{10}/
        ],
        [
            'YYYYMMDD',
            /\d{8}/
        ],
        [
            'GGGG[W]WWE',
            /\d{4}W\d{3}/
        ],
        [
            'GGGG[W]WW',
            /\d{4}W\d{2}/,
            false
        ],
        [
            'YYYYDDD',
            /\d{7}/
        ],
        [
            'YYYYMM',
            /\d{6}/,
            false
        ],
        [
            'YYYY',
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            'HH:mm:ss.SSSS',
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            'HH:mm:ss,SSSS',
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            'HH:mm:ss',
            /\d\d:\d\d:\d\d/
        ],
        [
            'HH:mm',
            /\d\d:\d\d/
        ],
        [
            'HHmmss.SSSS',
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            'HHmmss,SSSS',
            /\d\d\d\d\d\d,\d+/
        ],
        [
            'HHmmss',
            /\d\d\d\d\d\d/
        ],
        [
            'HHmm',
            /\d\d\d\d/
        ],
        [
            'HH',
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = 'Z';
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === '') return createInvalid({
            nullInput: true
        });
        if (typeof input === 'string') config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === 'string') configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isBefore', args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isAfter', args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset('Z', ':');
    offset('ZZ', '');
    // PARSING
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken([
        'Z',
        'ZZ'
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || [
            '-',
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, 'm');
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, 'M');
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, 'Month') + months * isAdding);
        if (days) set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, 'add'), subtract = createAdder(-1, 'subtract');
    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms'
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
        var func = 'moment', zone = '', prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', [
        'y',
        1
    ], 'yo', 'eraYear');
    addFormatToken('y', [
        'yy',
        2
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyy',
        3
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyyy',
        4
    ], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken([
        'N',
        'NN',
        'NNN',
        'NNNN',
        'NNNNN'
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken([
        'y',
        'yy',
        'yyy',
        'yyyy'
    ], YEAR);
    addParseToken([
        'yo'
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale('en')._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case 'undefined':
                    eras[i].until = Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) return eras[i];
                    break;
                case 'NNNN':
                    if (name === eraName) return eras[i];
                    break;
                case 'NNNNN':
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return '';
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return '';
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return '';
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));
            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }
        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken(0, [
        'gg',
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        'GG',
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    // ALIASES
    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');
    // PRIORITY
    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);
    // PARSING
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken([
        'gggg',
        'ggggg',
        'GGGG',
        'GGGGG'
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        'gg',
        'GG'
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken('Q', 0, 'Qo', 'quarter');
    // ALIASES
    addUnitAlias('quarter', 'Q');
    // PRIORITY
    addUnitPriority('quarter', 7);
    // PARSING
    addRegexToken('Q', match1);
    addParseToken('Q', function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken('D', [
        'DD',
        2
    ], 'Do', 'date');
    // ALIASES
    addUnitAlias('date', 'D');
    // PRIORITY
    addUnitPriority('date', 9);
    // PARSING
    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        'D',
        'DD'
    ], DATE);
    addParseToken('Do', function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet('Date', true);
    // FORMATTING
    addFormatToken('DDD', [
        'DDDD',
        3
    ], 'DDDo', 'dayOfYear');
    // ALIASES
    addUnitAlias('dayOfYear', 'DDD');
    // PRIORITY
    addUnitPriority('dayOfYear', 4);
    // PARSING
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken([
        'DDD',
        'DDDD'
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    // FORMATTING
    addFormatToken('m', [
        'mm',
        2
    ], 0, 'minute');
    // ALIASES
    addUnitAlias('minute', 'm');
    // PRIORITY
    addUnitPriority('minute', 14);
    // PARSING
    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken([
        'm',
        'mm'
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet('Minutes', false);
    // FORMATTING
    addFormatToken('s', [
        'ss',
        2
    ], 0, 'second');
    // ALIASES
    addUnitAlias('second', 's');
    // PRIORITY
    addUnitPriority('second', 15);
    // PARSING
    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken([
        's',
        'ss'
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet('Seconds', false);
    // FORMATTING
    addFormatToken('S', 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        'SS',
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        'SSS',
        3
    ], 0, 'millisecond');
    addFormatToken(0, [
        'SSSS',
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        'SSSSS',
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        'SSSSSS',
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        'SSSSSSS',
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        'SSSSSSSS',
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        'SSSSSSSSS',
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // ALIASES
    addUnitAlias('millisecond', 'ms');
    // PRIORITY
    addUnitPriority('millisecond', 16);
    // PARSING
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet('Milliseconds', false);
    // FORMATTING
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) proto[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return 'Moment<' + this.format() + '>';
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
        if (index != null) return get$1(format, index, field, 'month');
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD'
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC'
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }
    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) return NaN;
        return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y');
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
            's',
            seconds
        ] || seconds < thresholds.s && [
            'ss',
            seconds
        ] || minutes <= 1 && [
            'm'
        ] || minutes < thresholds.m && [
            'mm',
            minutes
        ] || hours <= 1 && [
            'h'
        ] || hours < thresholds.h && [
            'hh',
            hours
        ] || days <= 1 && [
            'd'
        ] || days < thresholds.d && [
            'dd',
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            'w'
        ] || weeks < thresholds.w && [
            'ww',
            weeks
        ];
        a = a || months <= 1 && [
            'M'
        ] || months < thresholds.M && [
            'MM',
            months
        ] || years <= 1 && [
            'y'
        ] || [
            'yy',
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === 's') thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    // PARSING
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = '2.29.4';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
        DATE: 'YYYY-MM-DD',
        TIME: 'HH:mm',
        TIME_SECONDS: 'HH:mm:ss',
        TIME_MS: 'HH:mm:ss.SSS',
        WEEK: 'GGGG-[W]WW',
        MONTH: 'YYYY-MM'
    };
    return hooks;
});

});

parcelRegister("6DzO8", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $iz60K = parcelRequire("iz60K");
function $4d52293a79bcab4c$var$emptyFunction() {}
function $4d52293a79bcab4c$var$emptyFunctionWithReset() {}
$4d52293a79bcab4c$var$emptyFunctionWithReset.resetWarningCache = $4d52293a79bcab4c$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $iz60K) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $4d52293a79bcab4c$var$emptyFunctionWithReset,
        resetWarningCache: $4d52293a79bcab4c$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("iz60K", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $d840288929500773$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $d840288929500773$var$ReactPropTypesSecret;

});


parcelRegister("iFFi9", function(module, exports) {

$parcel$export(module.exports, "default", () => $d97c160898750c37$export$2e2bcd8739ae039);

var $dBfB8 = parcelRequire("dBfB8");
var $d97c160898750c37$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $d97c160898750c37$var$index = (0, $dBfB8.default)(function(prop) {
    return $d97c160898750c37$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var $d97c160898750c37$export$2e2bcd8739ae039 = $d97c160898750c37$var$index;

});
parcelRegister("dBfB8", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e6ad47e343cb63b$export$2e2bcd8739ae039);
function $9e6ad47e343cb63b$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $9e6ad47e343cb63b$export$2e2bcd8739ae039 = $9e6ad47e343cb63b$var$memoize;

});


parcelRegister("4Y7rX", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used as the `TypeError` message for "Functions" methods. */ var FUNC_ERROR_TEXT = 'Expected a function';
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used to compose bitmasks for comparison styles. */ var UNORDERED_COMPARE_FLAG = 1, PARTIAL_COMPARE_FLAG = 2;
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', promiseTag = '[object Promise]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, reLeadingDot = /^\./, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding('util');
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        var value = array[index];
        setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
}
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') try {
        result = !!(value + '');
    } catch (e) {}
    return result;
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView'), Map = getNative(root, 'Map'), Promise = getNative(root, 'Promise'), Set = getNative(root, 'Set'), WeakMap = getNative(root, 'WeakMap'), nativeCreate = getNative(Object, 'create');
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    return getMapData(this, key)['delete'](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values ? values.length : 0;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    this.__data__ = new ListCache(entries);
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    return this.__data__['delete'](key);
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var cache = this.__data__;
    if (cache instanceof ListCache) {
        var pairs = cache.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            return this;
        }
        cache = this.__data__ = new MapCache(pairs);
    }
    cache.set(key, value);
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function baseAggregator(collection, setter, iteratee, accumulator) {
    baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
    });
    return accumulator;
}
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var baseEach = createBaseEach(baseForOwn);
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function baseForOwn(object, iteratee) {
    return object && baseFor(object, iteratee, keys);
}
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function baseGet(object, path) {
    path = isKey(path, object) ? [
        path
    ] : castPath(path);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[toKey(path[index++])];
    return index && index == length ? object : undefined;
}
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    return objectToString.call(value);
}
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function baseHasIn(object, key) {
    return object != null && key in Object(object);
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, customizer, bitmask, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObject(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = arrayTag, othTag = arrayTag;
    if (!objIsArr) {
        objTag = getTag(object);
        objTag = objTag == argsTag ? objectTag : objTag;
    }
    if (!othIsArr) {
        othTag = getTag(other);
        othTag = othTag == argsTag ? objectTag : othTag;
    }
    var objIsObj = objTag == objectTag && !isHostObject(object), othIsObj = othTag == objectTag && !isHostObject(other), isSameTag = objTag == othTag;
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, equalFunc, customizer, bitmask, stack) : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
    }
    if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
}
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new Stack;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack) : result)) return false;
        }
    }
    return true;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return identity;
    if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    return property(value);
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
    };
}
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
    return function(object) {
        var objValue = get(object, path);
        return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
    };
}
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyDeep(path) {
    return function(object) {
        return baseGet(object, path);
    };
}
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */ function castPath(value) {
    return isArray(value) ? value : stringToPath(value);
}
/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */ function createAggregator(setter, initializer) {
    return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
        return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
    };
}
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & UNORDERED_COMPARE_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!seen.has(othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) return seen.add(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= UNORDERED_COMPARE_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
            stack['delete'](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, objProps = keys(object), objLength = objProps.length, othProps = keys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function getMatchData(object) {
    var result = keys(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            isStrictComparable(value)
        ];
    }
    return result;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : undefined;
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function hasPath(object, path, hasFunc) {
    path = isKey(path, object) ? [
        path
    ] : castPath(path);
    var result, index = -1, length = path.length;
    while(++index < length){
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result) return result;
    var length = object ? object.length : 0;
    return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey(value, object) {
    if (isArray(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function isStrictComparable(value) {
    return value === value && !isObject(value);
}
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = memoize(function(string) {
    string = toString(string);
    var result = [];
    if (reLeadingDot.test(string)) result.push('');
    string.replace(rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace(reEscapeChar, '$1') : number || match);
    });
    return result;
});
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey(value) {
    if (typeof value == 'string' || isSymbol(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity]
 *  The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */ var groupBy = createAggregator(function(result, value, key) {
    if (hasOwnProperty.call(result, key)) result[key].push(value);
    else result[key] = [
        value
    ];
});
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != 'function' || resolver && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
    };
    memoized.cache = new (memoize.Cache || MapCache);
    return memoized;
}
// Assign cache to `_.memoize`.
memoize.Cache = MapCache;
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : '';
    return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? '' : baseToString(value);
}
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function property(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
module.exports = groupBy;

});

parcelRegister("3OyjO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2c70a992b42d5c22$var$assertString;
function $2c70a992b42d5c22$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2c70a992b42d5c22$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2c70a992b42d5c22$var$_typeof(o);
}
function $2c70a992b42d5c22$var$assertString(input) {
    var isString = typeof input === 'string' || input instanceof String;
    if (!isString) {
        var invalidType = $2c70a992b42d5c22$var$_typeof(input);
        if (input === null) invalidType = 'null';
        else if (invalidType === 'object') invalidType = input.constructor.name;
        throw new TypeError("Expected a string but received a ".concat(invalidType));
    }
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("3i3Ry", function(module, exports) {
(function(root) {
    function isValidEmail(v) {
        if (!v) return false;
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(v);
    }
    if (0, module.exports) exports = module.exports = isValidEmail;
    exports.isValidEmail = isValidEmail;
})(this);

});

parcelRegister("cdwfJ", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $8e4fb7a6186ef4a8$export$a7c73072b1a182ae, (v) => $8e4fb7a6186ef4a8$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $8e4fb7a6186ef4a8$export$9f27bc3417b4524d, (v) => $8e4fb7a6186ef4a8$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $8e4fb7a6186ef4a8$export$db77ccec0bb4ccac, (v) => $8e4fb7a6186ef4a8$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $8e4fb7a6186ef4a8$export$8392c0c9d3dcbd35, (v) => $8e4fb7a6186ef4a8$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $8e4fb7a6186ef4a8$export$ffb0004e005737fa, (v) => $8e4fb7a6186ef4a8$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $8e4fb7a6186ef4a8$export$b624eff549462981, (v) => $8e4fb7a6186ef4a8$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $8e4fb7a6186ef4a8$export$7897aa7841a5380c, (v) => $8e4fb7a6186ef4a8$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $8e4fb7a6186ef4a8$export$602eac185826482c, (v) => $8e4fb7a6186ef4a8$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $8e4fb7a6186ef4a8$export$e2c29f18771995cb, (v) => $8e4fb7a6186ef4a8$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $8e4fb7a6186ef4a8$export$5f8d39834fd61797, (v) => $8e4fb7a6186ef4a8$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $8e4fb7a6186ef4a8$export$74bf444e3cd11ea5, (v) => $8e4fb7a6186ef4a8$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $8e4fb7a6186ef4a8$export$998bcd577473dd93, (v) => $8e4fb7a6186ef4a8$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $8e4fb7a6186ef4a8$export$92387174baf9b227, (v) => $8e4fb7a6186ef4a8$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $8e4fb7a6186ef4a8$export$ec112efeb987d9c6, (v) => $8e4fb7a6186ef4a8$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $8e4fb7a6186ef4a8$export$b706b080d889d2c9, (v) => $8e4fb7a6186ef4a8$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $8e4fb7a6186ef4a8$export$5be5a87408f70ddc, (v) => $8e4fb7a6186ef4a8$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $8e4fb7a6186ef4a8$export$45a5e7f76e0caa8d, (v) => $8e4fb7a6186ef4a8$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $8e4fb7a6186ef4a8$export$455c2e768291efa6, (v) => $8e4fb7a6186ef4a8$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $8e4fb7a6186ef4a8$export$9522e17588c12572, (v) => $8e4fb7a6186ef4a8$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $8e4fb7a6186ef4a8$export$2110ac352bb060b9, (v) => $8e4fb7a6186ef4a8$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $8e4fb7a6186ef4a8$export$56885ab8b9c456ab, (v) => $8e4fb7a6186ef4a8$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $8e4fb7a6186ef4a8$export$d927fcb6adf8f9de, (v) => $8e4fb7a6186ef4a8$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $8e4fb7a6186ef4a8$export$b82d16f27459e05a, (v) => $8e4fb7a6186ef4a8$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $8e4fb7a6186ef4a8$export$522c17b4f5e123e8, (v) => $8e4fb7a6186ef4a8$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $8e4fb7a6186ef4a8$export$1aabd8a0274ecfd6, (v) => $8e4fb7a6186ef4a8$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $8e4fb7a6186ef4a8$export$3d6c20d97e46b957, (v) => $8e4fb7a6186ef4a8$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $8e4fb7a6186ef4a8$export$9b621391a187a31a, (v) => $8e4fb7a6186ef4a8$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $8e4fb7a6186ef4a8$export$f5bbd400c2f4426f, (v) => $8e4fb7a6186ef4a8$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8e4fb7a6186ef4a8$export$a7c73072b1a182ae;
var $8e4fb7a6186ef4a8$export$9f27bc3417b4524d;
var $8e4fb7a6186ef4a8$export$db77ccec0bb4ccac;
var $8e4fb7a6186ef4a8$export$8392c0c9d3dcbd35;
var $8e4fb7a6186ef4a8$export$ffb0004e005737fa;
var $8e4fb7a6186ef4a8$export$b624eff549462981;
var $8e4fb7a6186ef4a8$export$7897aa7841a5380c;
var $8e4fb7a6186ef4a8$export$602eac185826482c;
var $8e4fb7a6186ef4a8$export$e2c29f18771995cb;
var $8e4fb7a6186ef4a8$export$5f8d39834fd61797;
var $8e4fb7a6186ef4a8$export$74bf444e3cd11ea5;
var $8e4fb7a6186ef4a8$export$998bcd577473dd93;
var $8e4fb7a6186ef4a8$export$92387174baf9b227;
var $8e4fb7a6186ef4a8$export$ec112efeb987d9c6;
var $8e4fb7a6186ef4a8$export$b706b080d889d2c9;
var $8e4fb7a6186ef4a8$export$5be5a87408f70ddc;
var $8e4fb7a6186ef4a8$export$45a5e7f76e0caa8d;
var $8e4fb7a6186ef4a8$export$455c2e768291efa6;
var $8e4fb7a6186ef4a8$export$9522e17588c12572;
var $8e4fb7a6186ef4a8$export$2110ac352bb060b9;
var $8e4fb7a6186ef4a8$export$56885ab8b9c456ab;
var $8e4fb7a6186ef4a8$export$d927fcb6adf8f9de;
var $8e4fb7a6186ef4a8$export$b82d16f27459e05a;
var $8e4fb7a6186ef4a8$export$522c17b4f5e123e8;
var $8e4fb7a6186ef4a8$export$1aabd8a0274ecfd6;
var $8e4fb7a6186ef4a8$export$3d6c20d97e46b957;
var $8e4fb7a6186ef4a8$export$9b621391a187a31a;
var $8e4fb7a6186ef4a8$export$f5bbd400c2f4426f;
'use strict';
var $8e4fb7a6186ef4a8$var$b = Symbol.for("react.element"), $8e4fb7a6186ef4a8$var$c = Symbol.for("react.portal"), $8e4fb7a6186ef4a8$var$d = Symbol.for("react.fragment"), $8e4fb7a6186ef4a8$var$e = Symbol.for("react.strict_mode"), $8e4fb7a6186ef4a8$var$f = Symbol.for("react.profiler"), $8e4fb7a6186ef4a8$var$g = Symbol.for("react.provider"), $8e4fb7a6186ef4a8$var$h = Symbol.for("react.context"), $8e4fb7a6186ef4a8$var$k = Symbol.for("react.server_context"), $8e4fb7a6186ef4a8$var$l = Symbol.for("react.forward_ref"), $8e4fb7a6186ef4a8$var$m = Symbol.for("react.suspense"), $8e4fb7a6186ef4a8$var$n = Symbol.for("react.suspense_list"), $8e4fb7a6186ef4a8$var$p = Symbol.for("react.memo"), $8e4fb7a6186ef4a8$var$q = Symbol.for("react.lazy"), $8e4fb7a6186ef4a8$var$t = Symbol.for("react.offscreen"), $8e4fb7a6186ef4a8$var$u;
$8e4fb7a6186ef4a8$var$u = Symbol.for("react.module.reference");
function $8e4fb7a6186ef4a8$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $8e4fb7a6186ef4a8$var$b:
                switch(a = a.type, a){
                    case $8e4fb7a6186ef4a8$var$d:
                    case $8e4fb7a6186ef4a8$var$f:
                    case $8e4fb7a6186ef4a8$var$e:
                    case $8e4fb7a6186ef4a8$var$m:
                    case $8e4fb7a6186ef4a8$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $8e4fb7a6186ef4a8$var$k:
                            case $8e4fb7a6186ef4a8$var$h:
                            case $8e4fb7a6186ef4a8$var$l:
                            case $8e4fb7a6186ef4a8$var$q:
                            case $8e4fb7a6186ef4a8$var$p:
                            case $8e4fb7a6186ef4a8$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $8e4fb7a6186ef4a8$var$c:
                return r;
        }
    }
}
$8e4fb7a6186ef4a8$export$a7c73072b1a182ae = $8e4fb7a6186ef4a8$var$h;
$8e4fb7a6186ef4a8$export$9f27bc3417b4524d = $8e4fb7a6186ef4a8$var$g;
$8e4fb7a6186ef4a8$export$db77ccec0bb4ccac = $8e4fb7a6186ef4a8$var$b;
$8e4fb7a6186ef4a8$export$8392c0c9d3dcbd35 = $8e4fb7a6186ef4a8$var$l;
$8e4fb7a6186ef4a8$export$ffb0004e005737fa = $8e4fb7a6186ef4a8$var$d;
$8e4fb7a6186ef4a8$export$b624eff549462981 = $8e4fb7a6186ef4a8$var$q;
$8e4fb7a6186ef4a8$export$7897aa7841a5380c = $8e4fb7a6186ef4a8$var$p;
$8e4fb7a6186ef4a8$export$602eac185826482c = $8e4fb7a6186ef4a8$var$c;
$8e4fb7a6186ef4a8$export$e2c29f18771995cb = $8e4fb7a6186ef4a8$var$f;
$8e4fb7a6186ef4a8$export$5f8d39834fd61797 = $8e4fb7a6186ef4a8$var$e;
$8e4fb7a6186ef4a8$export$74bf444e3cd11ea5 = $8e4fb7a6186ef4a8$var$m;
$8e4fb7a6186ef4a8$export$998bcd577473dd93 = $8e4fb7a6186ef4a8$var$n;
$8e4fb7a6186ef4a8$export$92387174baf9b227 = function() {
    return !1;
};
$8e4fb7a6186ef4a8$export$ec112efeb987d9c6 = function() {
    return !1;
};
$8e4fb7a6186ef4a8$export$b706b080d889d2c9 = function(a) {
    return $8e4fb7a6186ef4a8$var$v(a) === $8e4fb7a6186ef4a8$var$h;
};
$8e4fb7a6186ef4a8$export$5be5a87408f70ddc = function(a) {
    return $8e4fb7a6186ef4a8$var$v(a) === $8e4fb7a6186ef4a8$var$g;
};
$8e4fb7a6186ef4a8$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $8e4fb7a6186ef4a8$var$b;
};
$8e4fb7a6186ef4a8$export$455c2e768291efa6 = function(a) {
    return $8e4fb7a6186ef4a8$var$v(a) === $8e4fb7a6186ef4a8$var$l;
};
$8e4fb7a6186ef4a8$export$9522e17588c12572 = function(a) {
    return $8e4fb7a6186ef4a8$var$v(a) === $8e4fb7a6186ef4a8$var$d;
};
$8e4fb7a6186ef4a8$export$2110ac352bb060b9 = function(a) {
    return $8e4fb7a6186ef4a8$var$v(a) === $8e4fb7a6186ef4a8$var$q;
};
$8e4fb7a6186ef4a8$export$56885ab8b9c456ab = function(a) {
    return $8e4fb7a6186ef4a8$var$v(a) === $8e4fb7a6186ef4a8$var$p;
};
$8e4fb7a6186ef4a8$export$d927fcb6adf8f9de = function(a) {
    return $8e4fb7a6186ef4a8$var$v(a) === $8e4fb7a6186ef4a8$var$c;
};
$8e4fb7a6186ef4a8$export$b82d16f27459e05a = function(a) {
    return $8e4fb7a6186ef4a8$var$v(a) === $8e4fb7a6186ef4a8$var$f;
};
$8e4fb7a6186ef4a8$export$522c17b4f5e123e8 = function(a) {
    return $8e4fb7a6186ef4a8$var$v(a) === $8e4fb7a6186ef4a8$var$e;
};
$8e4fb7a6186ef4a8$export$1aabd8a0274ecfd6 = function(a) {
    return $8e4fb7a6186ef4a8$var$v(a) === $8e4fb7a6186ef4a8$var$m;
};
$8e4fb7a6186ef4a8$export$3d6c20d97e46b957 = function(a) {
    return $8e4fb7a6186ef4a8$var$v(a) === $8e4fb7a6186ef4a8$var$n;
};
$8e4fb7a6186ef4a8$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $8e4fb7a6186ef4a8$var$d || a === $8e4fb7a6186ef4a8$var$f || a === $8e4fb7a6186ef4a8$var$e || a === $8e4fb7a6186ef4a8$var$m || a === $8e4fb7a6186ef4a8$var$n || a === $8e4fb7a6186ef4a8$var$t || "object" === typeof a && null !== a && (a.$$typeof === $8e4fb7a6186ef4a8$var$q || a.$$typeof === $8e4fb7a6186ef4a8$var$p || a.$$typeof === $8e4fb7a6186ef4a8$var$g || a.$$typeof === $8e4fb7a6186ef4a8$var$h || a.$$typeof === $8e4fb7a6186ef4a8$var$l || a.$$typeof === $8e4fb7a6186ef4a8$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$8e4fb7a6186ef4a8$export$f5bbd400c2f4426f = $8e4fb7a6186ef4a8$var$v;

});

parcelRegister("ase04", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "clsx", () => $4944fe05cfdb1e2e$export$4f5d2d50c9deca37);
$parcel$export(module.exports, "default", () => $4944fe05cfdb1e2e$export$2e2bcd8739ae039);
function $4944fe05cfdb1e2e$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $4944fe05cfdb1e2e$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $4944fe05cfdb1e2e$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $4944fe05cfdb1e2e$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $4944fe05cfdb1e2e$export$2e2bcd8739ae039 = $4944fe05cfdb1e2e$export$4f5d2d50c9deca37;

});

parcelRegister("iy6bE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "IGNORE_CLASS_NAME", () => $d810338c48d01b0a$export$e2911fc69bd3195e);
$parcel$export(module.exports, "default", () => $d810338c48d01b0a$export$2e2bcd8739ae039);

var $8NFma = parcelRequire("8NFma");

var $2pmb0 = parcelRequire("2pmb0");
function $d810338c48d01b0a$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $d810338c48d01b0a$var$_setPrototypeOf(subClass, superClass);
}
function $d810338c48d01b0a$var$_setPrototypeOf(o, p) {
    $d810338c48d01b0a$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $d810338c48d01b0a$var$_setPrototypeOf(o, p);
}
function $d810338c48d01b0a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $d810338c48d01b0a$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
} /**
 * Check whether some DOM node is our Component's node.
 */ 
function $d810338c48d01b0a$var$isNodeFound(current, componentNode, ignoreClass) {
    if (current === componentNode) return true;
     // SVG <use/> elements do not technically reside in the rendered DOM, so
    // they do not have classList directly, but they offer a link to their
    // corresponding element, which can have classList. This extra check is for
    // that case.
    // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
    // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17
    if (current.correspondingElement) return current.correspondingElement.classList.contains(ignoreClass);
    return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */ function $d810338c48d01b0a$var$findHighest(current, componentNode, ignoreClass) {
    if (current === componentNode) return true;
     // If source=local then this event came from 'somewhere'
    // inside and should be ignored. We could handle this with
    // a layered approach, too, but that requires going back to
    // thinking in terms of Dom node nesting, running counter
    // to React's 'you shouldn't care about the DOM' philosophy.
    // Also cover shadowRoot node by checking current.host
    while(current.parentNode || current.host){
        // Only check normal node without shadowRoot
        if (current.parentNode && $d810338c48d01b0a$var$isNodeFound(current, componentNode, ignoreClass)) return true;
        current = current.parentNode || current.host;
    }
    return current;
}
/**
 * Check if the browser scrollbar was clicked
 */ function $d810338c48d01b0a$var$clickedScrollbar(evt) {
    return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
} // ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var $d810338c48d01b0a$var$testPassiveEventSupport = function testPassiveEventSupport() {
    if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') return;
    var passive = false;
    var options = Object.defineProperty({}, 'passive', {
        get: function get() {
            passive = true;
        }
    });
    var noop = function noop() {};
    window.addEventListener('testPassiveEventSupport', noop, options);
    window.removeEventListener('testPassiveEventSupport', noop, options);
    return passive;
};
function $d810338c48d01b0a$var$autoInc(seed) {
    if (seed === void 0) seed = 0;
    return function() {
        return ++seed;
    };
}
var $d810338c48d01b0a$var$uid = $d810338c48d01b0a$var$autoInc();
var $d810338c48d01b0a$var$passiveEventSupport;
var $d810338c48d01b0a$var$handlersMap = {};
var $d810338c48d01b0a$var$enabledInstances = {};
var $d810338c48d01b0a$var$touchEvents = [
    'touchstart',
    'touchmove'
];
var $d810338c48d01b0a$export$e2911fc69bd3195e = 'ignore-react-onclickoutside';
/**
 * Options for addEventHandler and removeEventHandler
 */ function $d810338c48d01b0a$var$getEventHandlerOptions(instance, eventName) {
    var handlerOptions = {};
    var isTouchEvent = $d810338c48d01b0a$var$touchEvents.indexOf(eventName) !== -1;
    if (isTouchEvent && $d810338c48d01b0a$var$passiveEventSupport) handlerOptions.passive = !instance.props.preventDefault;
    return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */ function $d810338c48d01b0a$var$onClickOutsideHOC(WrappedComponent, config) {
    var _class, _temp;
    var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    return _temp = _class = /*#__PURE__*/ function(_Component) {
        $d810338c48d01b0a$var$_inheritsLoose(onClickOutside, _Component);
        function onClickOutside(props) {
            var _this;
            _this = _Component.call(this, props) || this;
            _this.__outsideClickHandler = function(event) {
                if (typeof _this.__clickOutsideHandlerProp === 'function') {
                    _this.__clickOutsideHandlerProp(event);
                    return;
                }
                var instance = _this.getInstance();
                if (typeof instance.props.handleClickOutside === 'function') {
                    instance.props.handleClickOutside(event);
                    return;
                }
                if (typeof instance.handleClickOutside === 'function') {
                    instance.handleClickOutside(event);
                    return;
                }
                throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
            };
            _this.__getComponentNode = function() {
                var instance = _this.getInstance();
                if (config && typeof config.setClickOutsideRef === 'function') return config.setClickOutsideRef()(instance);
                if (typeof instance.setClickOutsideRef === 'function') return instance.setClickOutsideRef();
                return (0, $2pmb0.findDOMNode)(instance);
            };
            _this.enableOnClickOutside = function() {
                if (typeof document === 'undefined' || $d810338c48d01b0a$var$enabledInstances[_this._uid]) return;
                if (typeof $d810338c48d01b0a$var$passiveEventSupport === 'undefined') $d810338c48d01b0a$var$passiveEventSupport = $d810338c48d01b0a$var$testPassiveEventSupport();
                $d810338c48d01b0a$var$enabledInstances[_this._uid] = true;
                var events = _this.props.eventTypes;
                if (!events.forEach) events = [
                    events
                ];
                $d810338c48d01b0a$var$handlersMap[_this._uid] = function(event) {
                    if (_this.componentNode === null) return;
                    if (_this.initTimeStamp > event.timeStamp) return;
                    if (_this.props.preventDefault) event.preventDefault();
                    if (_this.props.stopPropagation) event.stopPropagation();
                    if (_this.props.excludeScrollbar && $d810338c48d01b0a$var$clickedScrollbar(event)) return;
                    var current = event.composed && event.composedPath && event.composedPath().shift() || event.target;
                    if ($d810338c48d01b0a$var$findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) return;
                    _this.__outsideClickHandler(event);
                };
                events.forEach(function(eventName) {
                    document.addEventListener(eventName, $d810338c48d01b0a$var$handlersMap[_this._uid], $d810338c48d01b0a$var$getEventHandlerOptions($d810338c48d01b0a$var$_assertThisInitialized(_this), eventName));
                });
            };
            _this.disableOnClickOutside = function() {
                delete $d810338c48d01b0a$var$enabledInstances[_this._uid];
                var fn = $d810338c48d01b0a$var$handlersMap[_this._uid];
                if (fn && typeof document !== 'undefined') {
                    var events = _this.props.eventTypes;
                    if (!events.forEach) events = [
                        events
                    ];
                    events.forEach(function(eventName) {
                        return document.removeEventListener(eventName, fn, $d810338c48d01b0a$var$getEventHandlerOptions($d810338c48d01b0a$var$_assertThisInitialized(_this), eventName));
                    });
                    delete $d810338c48d01b0a$var$handlersMap[_this._uid];
                }
            };
            _this.getRef = function(ref) {
                return _this.instanceRef = ref;
            };
            _this._uid = $d810338c48d01b0a$var$uid();
            _this.initTimeStamp = performance.now();
            return _this;
        }
        /**
     * Access the WrappedComponent's instance.
     */ var _proto = onClickOutside.prototype;
        _proto.getInstance = function getInstance() {
            if (WrappedComponent.prototype && !WrappedComponent.prototype.isReactComponent) return this;
            var ref = this.instanceRef;
            return ref.getInstance ? ref.getInstance() : ref;
        };
        /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */ _proto.componentDidMount = function componentDidMount() {
            // If we are in an environment without a DOM such
            // as shallow rendering or snapshots then we exit
            // early to prevent any unhandled errors being thrown.
            if (typeof document === 'undefined' || !document.createElement) return;
            var instance = this.getInstance();
            if (config && typeof config.handleClickOutside === 'function') {
                this.__clickOutsideHandlerProp = config.handleClickOutside(instance);
                if (typeof this.__clickOutsideHandlerProp !== 'function') throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
            }
            this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside
            if (this.props.disableOnClickOutside) return;
            this.enableOnClickOutside();
        };
        _proto.componentDidUpdate = function componentDidUpdate() {
            this.componentNode = this.__getComponentNode();
        } /**
     * Remove all document's event listeners for this component
     */ ;
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.disableOnClickOutside();
        } /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */ ;
        /**
     * Pass-through render
     */ _proto.render = function render() {
            // eslint-disable-next-line no-unused-vars
            var _this$props = this.props;
            _this$props.excludeScrollbar;
            var props = $d810338c48d01b0a$var$_objectWithoutPropertiesLoose(_this$props, [
                "excludeScrollbar"
            ]);
            if (WrappedComponent.prototype && WrappedComponent.prototype.isReactComponent) props.ref = this.getRef;
            else props.wrappedRef = this.getRef;
            props.disableOnClickOutside = this.disableOnClickOutside;
            props.enableOnClickOutside = this.enableOnClickOutside;
            return (0, $8NFma.createElement)(WrappedComponent, props);
        };
        return onClickOutside;
    }((0, $8NFma.Component)), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
        eventTypes: [
            'mousedown',
            'touchstart'
        ],
        excludeScrollbar: config && config.excludeScrollbar || false,
        outsideClickIgnoreClass: $d810338c48d01b0a$export$e2911fc69bd3195e,
        preventDefault: false,
        stopPropagation: false
    }, _class.getClass = function() {
        return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
    }, _temp;
}
var $d810338c48d01b0a$export$2e2bcd8739ae039 = $d810338c48d01b0a$var$onClickOutsideHOC;

});

parcelRegister("l4b73", function(module, exports) {

$parcel$export(module.exports, "addDays", () => $f562977a5bac0984$export$dd412b56f1e4d8aa, (v) => $f562977a5bac0984$export$dd412b56f1e4d8aa = v);
var $f562977a5bac0984$export$dd412b56f1e4d8aa;
"use strict";
$f562977a5bac0984$export$dd412b56f1e4d8aa = $f562977a5bac0984$var$addDays;

var $7yyQt = parcelRequire("7yyQt");

var $cMvsU = parcelRequire("cMvsU");
/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of days to be added.
 *
 * @returns The new date with the days added
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */ function $f562977a5bac0984$var$addDays(date, amount) {
    const _date = (0, $7yyQt.toDate)(date);
    if (isNaN(amount)) return (0, $cMvsU.constructFrom)(date, NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return _date;
    _date.setDate(_date.getDate() + amount);
    return _date;
}

});
parcelRegister("7yyQt", function(module, exports) {

$parcel$export(module.exports, "toDate", () => $5806bcec89744c32$export$e67a095c620b86fe, (v) => $5806bcec89744c32$export$e67a095c620b86fe = v);
var $5806bcec89744c32$export$e67a095c620b86fe;
"use strict";
$5806bcec89744c32$export$e67a095c620b86fe = $5806bcec89744c32$var$toDate;
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ function $5806bcec89744c32$var$toDate(argument) {
    const argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || typeof argument === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new argument.constructor(+argument);
    else if (typeof argument === "number" || argStr === "[object Number]" || typeof argument === "string" || argStr === "[object String]") // TODO: Can we get rid of as?
    return new Date(argument);
    else // TODO: Can we get rid of as?
    return new Date(NaN);
}

});

parcelRegister("cMvsU", function(module, exports) {

$parcel$export(module.exports, "constructFrom", () => $94e2600e6614cc67$export$ead8a1812b171991, (v) => $94e2600e6614cc67$export$ead8a1812b171991 = v);
var $94e2600e6614cc67$export$ead8a1812b171991;
"use strict";
$94e2600e6614cc67$export$ead8a1812b171991 = $94e2600e6614cc67$var$constructFrom;
/**
 * @name constructFrom
 * @category Generic Helpers
 * @summary Constructs a date using the reference date and the value
 *
 * @description
 * The function constructs a new date using the constructor from the reference
 * date and the given value. It helps to build generic functions that accept
 * date extensions.
 *
 * It defaults to `Date` if the passed reference date is a number or a string.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 * @param value - The value to create the date
 *
 * @returns Date initialized using the given date and value
 *
 * @example
 * import { constructFrom } from 'date-fns'
 *
 * // A function that clones a date preserving the original type
 * function cloneDate<DateType extends Date(date: DateType): DateType {
 *   return constructFrom(
 *     date, // Use contrustor from the given date
 *     date.getTime() // Use the date value to create a new date
 *   )
 * }
 */ function $94e2600e6614cc67$var$constructFrom(date, value) {
    if (date instanceof Date) return new date.constructor(value);
    else return new Date(value);
}

});


parcelRegister("afGQf", function(module, exports) {

$parcel$export(module.exports, "addHours", () => $776c8997d647c338$export$4a4306ad4fa0e5e6, (v) => $776c8997d647c338$export$4a4306ad4fa0e5e6 = v);
var $776c8997d647c338$export$4a4306ad4fa0e5e6;
"use strict";
$776c8997d647c338$export$4a4306ad4fa0e5e6 = $776c8997d647c338$var$addHours;

var $iF7VK = parcelRequire("iF7VK");

var $9uNOU = parcelRequire("9uNOU");
/**
 * @name addHours
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of hours to be added.
 *
 * @returns The new date with the hours added
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * const result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */ function $776c8997d647c338$var$addHours(date, amount) {
    return (0, $iF7VK.addMilliseconds)(date, amount * $9uNOU.millisecondsInHour);
}

});
parcelRegister("iF7VK", function(module, exports) {

$parcel$export(module.exports, "addMilliseconds", () => $d962352315874c28$export$baf757aaf0c95c94, (v) => $d962352315874c28$export$baf757aaf0c95c94 = v);
var $d962352315874c28$export$baf757aaf0c95c94;
"use strict";
$d962352315874c28$export$baf757aaf0c95c94 = $d962352315874c28$var$addMilliseconds;

var $7yyQt = parcelRequire("7yyQt");

var $cMvsU = parcelRequire("cMvsU");
/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of milliseconds to be added.
 *
 * @returns The new date with the milliseconds added
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */ function $d962352315874c28$var$addMilliseconds(date, amount) {
    const timestamp = +(0, $7yyQt.toDate)(date);
    return (0, $cMvsU.constructFrom)(date, timestamp + amount);
}

});

parcelRegister("9uNOU", function(module, exports) {

$parcel$export(module.exports, "millisecondsInWeek", () => $6e9d8fa85a388a89$export$4fad13613e88edc8, (v) => $6e9d8fa85a388a89$export$4fad13613e88edc8 = v);
$parcel$export(module.exports, "millisecondsInSecond", () => $6e9d8fa85a388a89$export$397c2d5776aa9055, (v) => $6e9d8fa85a388a89$export$397c2d5776aa9055 = v);
$parcel$export(module.exports, "millisecondsInMinute", () => $6e9d8fa85a388a89$export$91246f0b9bd9beff, (v) => $6e9d8fa85a388a89$export$91246f0b9bd9beff = v);
$parcel$export(module.exports, "millisecondsInHour", () => $6e9d8fa85a388a89$export$7f72910d6dfd237a, (v) => $6e9d8fa85a388a89$export$7f72910d6dfd237a = v);
$parcel$export(module.exports, "millisecondsInDay", () => $6e9d8fa85a388a89$export$b76b1809a2898f9a, (v) => $6e9d8fa85a388a89$export$b76b1809a2898f9a = v);
var $6e9d8fa85a388a89$export$7271e9e3478110d1;
var $6e9d8fa85a388a89$export$34804a017b31e2fe;
var $6e9d8fa85a388a89$export$be1dccf2de902d31;
var $6e9d8fa85a388a89$export$8e6600bbdee7dabb;
var $6e9d8fa85a388a89$export$a77c1a7ebebe2a5a;
var $6e9d8fa85a388a89$export$698aec755e92c695;
var $6e9d8fa85a388a89$export$815a9362476d2fe3;
var $6e9d8fa85a388a89$export$4db7641526e3241f;
var $6e9d8fa85a388a89$export$80d7e435f744f319;
var $6e9d8fa85a388a89$export$3c58128db900d44e;
var $6e9d8fa85a388a89$export$3633035e63cee86a;
var $6e9d8fa85a388a89$export$ab7da2ccd1075c38;
var $6e9d8fa85a388a89$export$f2f5ae5a8e2d8f9f;
var $6e9d8fa85a388a89$export$2423174df8cd3cd2;
var $6e9d8fa85a388a89$export$4dec998e48f9c246;
var $6e9d8fa85a388a89$export$4fad13613e88edc8;
var $6e9d8fa85a388a89$export$397c2d5776aa9055;
var $6e9d8fa85a388a89$export$91246f0b9bd9beff;
var $6e9d8fa85a388a89$export$7f72910d6dfd237a;
var $6e9d8fa85a388a89$export$b76b1809a2898f9a;
var $6e9d8fa85a388a89$export$81caae6e1cc7a622;
var $6e9d8fa85a388a89$export$3913210603d8e9ae;
var $6e9d8fa85a388a89$export$dfd9b671c89acc8e;
"use strict";
$6e9d8fa85a388a89$export$7271e9e3478110d1 = $6e9d8fa85a388a89$export$34804a017b31e2fe = $6e9d8fa85a388a89$export$be1dccf2de902d31 = $6e9d8fa85a388a89$export$8e6600bbdee7dabb = $6e9d8fa85a388a89$export$a77c1a7ebebe2a5a = $6e9d8fa85a388a89$export$698aec755e92c695 = $6e9d8fa85a388a89$export$815a9362476d2fe3 = $6e9d8fa85a388a89$export$4db7641526e3241f = $6e9d8fa85a388a89$export$80d7e435f744f319 = $6e9d8fa85a388a89$export$3c58128db900d44e = $6e9d8fa85a388a89$export$3633035e63cee86a = $6e9d8fa85a388a89$export$ab7da2ccd1075c38 = $6e9d8fa85a388a89$export$f2f5ae5a8e2d8f9f = $6e9d8fa85a388a89$export$2423174df8cd3cd2 = $6e9d8fa85a388a89$export$4dec998e48f9c246 = $6e9d8fa85a388a89$export$4fad13613e88edc8 = $6e9d8fa85a388a89$export$397c2d5776aa9055 = $6e9d8fa85a388a89$export$91246f0b9bd9beff = $6e9d8fa85a388a89$export$7f72910d6dfd237a = $6e9d8fa85a388a89$export$b76b1809a2898f9a = $6e9d8fa85a388a89$export$81caae6e1cc7a622 = $6e9d8fa85a388a89$export$3913210603d8e9ae = $6e9d8fa85a388a89$export$dfd9b671c89acc8e = void 0; /**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ 
/**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ const $6e9d8fa85a388a89$var$daysInWeek = $6e9d8fa85a388a89$export$dfd9b671c89acc8e = 7;
/**
 * @constant
 * @name daysInYear
 * @summary Days in 1 year.
 *
 * @description
 * How many days in a year.
 *
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 */ const $6e9d8fa85a388a89$var$daysInYear = $6e9d8fa85a388a89$export$3913210603d8e9ae = 365.2425;
/**
 * @constant
 * @name maxTime
 * @summary Maximum allowed time.
 *
 * @example
 * import { maxTime } from "date-fns/constants";
 *
 * const isValid = 8640000000000001 <= maxTime;
 * //=> false
 *
 * new Date(8640000000000001);
 * //=> Invalid Date
 */ const $6e9d8fa85a388a89$var$maxTime = $6e9d8fa85a388a89$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
/**
 * @constant
 * @name minTime
 * @summary Minimum allowed time.
 *
 * @example
 * import { minTime } from "date-fns/constants";
 *
 * const isValid = -8640000000000001 >= minTime;
 * //=> false
 *
 * new Date(-8640000000000001)
 * //=> Invalid Date
 */ const $6e9d8fa85a388a89$var$minTime = $6e9d8fa85a388a89$export$4dec998e48f9c246 = -$6e9d8fa85a388a89$var$maxTime;
/**
 * @constant
 * @name millisecondsInWeek
 * @summary Milliseconds in 1 week.
 */ const $6e9d8fa85a388a89$var$millisecondsInWeek = $6e9d8fa85a388a89$export$4fad13613e88edc8 = 604800000;
/**
 * @constant
 * @name millisecondsInDay
 * @summary Milliseconds in 1 day.
 */ const $6e9d8fa85a388a89$var$millisecondsInDay = $6e9d8fa85a388a89$export$b76b1809a2898f9a = 86400000;
/**
 * @constant
 * @name millisecondsInMinute
 * @summary Milliseconds in 1 minute
 */ const $6e9d8fa85a388a89$var$millisecondsInMinute = $6e9d8fa85a388a89$export$91246f0b9bd9beff = 60000;
/**
 * @constant
 * @name millisecondsInHour
 * @summary Milliseconds in 1 hour
 */ const $6e9d8fa85a388a89$var$millisecondsInHour = $6e9d8fa85a388a89$export$7f72910d6dfd237a = 3600000;
/**
 * @constant
 * @name millisecondsInSecond
 * @summary Milliseconds in 1 second
 */ const $6e9d8fa85a388a89$var$millisecondsInSecond = $6e9d8fa85a388a89$export$397c2d5776aa9055 = 1000;
/**
 * @constant
 * @name minutesInYear
 * @summary Minutes in 1 year.
 */ const $6e9d8fa85a388a89$var$minutesInYear = $6e9d8fa85a388a89$export$3633035e63cee86a = 525600;
/**
 * @constant
 * @name minutesInMonth
 * @summary Minutes in 1 month.
 */ const $6e9d8fa85a388a89$var$minutesInMonth = $6e9d8fa85a388a89$export$ab7da2ccd1075c38 = 43200;
/**
 * @constant
 * @name minutesInDay
 * @summary Minutes in 1 day.
 */ const $6e9d8fa85a388a89$var$minutesInDay = $6e9d8fa85a388a89$export$2423174df8cd3cd2 = 1440;
/**
 * @constant
 * @name minutesInHour
 * @summary Minutes in 1 hour.
 */ const $6e9d8fa85a388a89$var$minutesInHour = $6e9d8fa85a388a89$export$f2f5ae5a8e2d8f9f = 60;
/**
 * @constant
 * @name monthsInQuarter
 * @summary Months in 1 quarter.
 */ const $6e9d8fa85a388a89$var$monthsInQuarter = $6e9d8fa85a388a89$export$3c58128db900d44e = 3;
/**
 * @constant
 * @name monthsInYear
 * @summary Months in 1 year.
 */ const $6e9d8fa85a388a89$var$monthsInYear = $6e9d8fa85a388a89$export$80d7e435f744f319 = 12;
/**
 * @constant
 * @name quartersInYear
 * @summary Quarters in 1 year
 */ const $6e9d8fa85a388a89$var$quartersInYear = $6e9d8fa85a388a89$export$4db7641526e3241f = 4;
/**
 * @constant
 * @name secondsInHour
 * @summary Seconds in 1 hour.
 */ const $6e9d8fa85a388a89$var$secondsInHour = $6e9d8fa85a388a89$export$698aec755e92c695 = 3600;
/**
 * @constant
 * @name secondsInMinute
 * @summary Seconds in 1 minute.
 */ const $6e9d8fa85a388a89$var$secondsInMinute = $6e9d8fa85a388a89$export$a77c1a7ebebe2a5a = 60;
/**
 * @constant
 * @name secondsInDay
 * @summary Seconds in 1 day.
 */ const $6e9d8fa85a388a89$var$secondsInDay = $6e9d8fa85a388a89$export$815a9362476d2fe3 = $6e9d8fa85a388a89$var$secondsInHour * 24;
/**
 * @constant
 * @name secondsInWeek
 * @summary Seconds in 1 week.
 */ const $6e9d8fa85a388a89$var$secondsInWeek = $6e9d8fa85a388a89$export$34804a017b31e2fe = $6e9d8fa85a388a89$var$secondsInDay * 7;
/**
 * @constant
 * @name secondsInYear
 * @summary Seconds in 1 year.
 */ const $6e9d8fa85a388a89$var$secondsInYear = $6e9d8fa85a388a89$export$7271e9e3478110d1 = $6e9d8fa85a388a89$var$secondsInDay * $6e9d8fa85a388a89$var$daysInYear;
/**
 * @constant
 * @name secondsInMonth
 * @summary Seconds in 1 month
 */ const $6e9d8fa85a388a89$var$secondsInMonth = $6e9d8fa85a388a89$export$8e6600bbdee7dabb = $6e9d8fa85a388a89$var$secondsInYear / 12;
/**
 * @constant
 * @name secondsInQuarter
 * @summary Seconds in 1 quarter.
 */ const $6e9d8fa85a388a89$var$secondsInQuarter = $6e9d8fa85a388a89$export$be1dccf2de902d31 = $6e9d8fa85a388a89$var$secondsInMonth * 3;

});


parcelRegister("iIzcA", function(module, exports) {

$parcel$export(module.exports, "addMinutes", () => $da07a47066bdb9ee$export$2287e3d29250119e, (v) => $da07a47066bdb9ee$export$2287e3d29250119e = v);
var $da07a47066bdb9ee$export$2287e3d29250119e;
"use strict";
$da07a47066bdb9ee$export$2287e3d29250119e = $da07a47066bdb9ee$var$addMinutes;

var $iF7VK = parcelRequire("iF7VK");

var $9uNOU = parcelRequire("9uNOU");
/**
 * @name addMinutes
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of minutes to be added.
 *
 * @returns The new date with the minutes added
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * const result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */ function $da07a47066bdb9ee$var$addMinutes(date, amount) {
    return (0, $iF7VK.addMilliseconds)(date, amount * $9uNOU.millisecondsInMinute);
}

});

parcelRegister("1YUHS", function(module, exports) {

$parcel$export(module.exports, "addMonths", () => $171761cf899530ac$export$17c93e242b2d3a22, (v) => $171761cf899530ac$export$17c93e242b2d3a22 = v);
var $171761cf899530ac$export$17c93e242b2d3a22;
"use strict";
$171761cf899530ac$export$17c93e242b2d3a22 = $171761cf899530ac$var$addMonths;

var $7yyQt = parcelRequire("7yyQt");

var $cMvsU = parcelRequire("cMvsU");
/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of months to be added.
 *
 * @returns The new date with the months added
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 *
 * // Add one month to 30 January 2023:
 * const result = addMonths(new Date(2023, 0, 30), 1)
 * //=> Tue Feb 28 2023 00:00:00
 */ function $171761cf899530ac$var$addMonths(date, amount) {
    const _date = (0, $7yyQt.toDate)(date);
    if (isNaN(amount)) return (0, $cMvsU.constructFrom)(date, NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return _date;
    const dayOfMonth = _date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    const endOfDesiredMonth = (0, $cMvsU.constructFrom)(date, _date.getTime());
    endOfDesiredMonth.setMonth(_date.getMonth() + amount + 1, 0);
    const daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        _date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return _date;
    }
}

});

parcelRegister("ieLCh", function(module, exports) {

$parcel$export(module.exports, "addQuarters", () => $d46e786e79a943e0$export$c252a41d0fbed2ce, (v) => $d46e786e79a943e0$export$c252a41d0fbed2ce = v);
var $d46e786e79a943e0$export$c252a41d0fbed2ce;
"use strict";
$d46e786e79a943e0$export$c252a41d0fbed2ce = $d46e786e79a943e0$var$addQuarters;

var $1YUHS = parcelRequire("1YUHS");
/**
 * @name addQuarters
 * @category Quarter Helpers
 * @summary Add the specified number of year quarters to the given date.
 *
 * @description
 * Add the specified number of year quarters to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of quarters to be added.
 *
 * @returns The new date with the quarters added
 *
 * @example
 * // Add 1 quarter to 1 September 2014:
 * const result = addQuarters(new Date(2014, 8, 1), 1)
 * //=> Mon Dec 01 2014 00:00:00
 */ function $d46e786e79a943e0$var$addQuarters(date, amount) {
    const months = amount * 3;
    return (0, $1YUHS.addMonths)(date, months);
}

});

parcelRegister("dn1OK", function(module, exports) {

$parcel$export(module.exports, "addSeconds", () => $9bbed549b6c0cd32$export$3cb31b0df13be68, (v) => $9bbed549b6c0cd32$export$3cb31b0df13be68 = v);
var $9bbed549b6c0cd32$export$3cb31b0df13be68;
"use strict";
$9bbed549b6c0cd32$export$3cb31b0df13be68 = $9bbed549b6c0cd32$var$addSeconds;

var $iF7VK = parcelRequire("iF7VK");
/**
 * @name addSeconds
 * @category Second Helpers
 * @summary Add the specified number of seconds to the given date.
 *
 * @description
 * Add the specified number of seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of seconds to be added.
 *
 * @returns The new date with the seconds added
 *
 * @example
 * // Add 30 seconds to 10 July 2014 12:45:00:
 * const result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:45:30
 */ function $9bbed549b6c0cd32$var$addSeconds(date, amount) {
    return (0, $iF7VK.addMilliseconds)(date, amount * 1000);
}

});

parcelRegister("2jgJV", function(module, exports) {

$parcel$export(module.exports, "addWeeks", () => $1aea574647ae6107$export$ef501a2bb4f3ee6b, (v) => $1aea574647ae6107$export$ef501a2bb4f3ee6b = v);
var $1aea574647ae6107$export$ef501a2bb4f3ee6b;
"use strict";
$1aea574647ae6107$export$ef501a2bb4f3ee6b = $1aea574647ae6107$var$addWeeks;

var $l4b73 = parcelRequire("l4b73");
/**
 * @name addWeeks
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of weeks to be added.
 *
 * @returns The new date with the weeks added
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * const result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */ function $1aea574647ae6107$var$addWeeks(date, amount) {
    const days = amount * 7;
    return (0, $l4b73.addDays)(date, days);
}

});

parcelRegister("1mchh", function(module, exports) {

$parcel$export(module.exports, "addYears", () => $0fd15e9d8250f2b1$export$3d83eec43f4ea476, (v) => $0fd15e9d8250f2b1$export$3d83eec43f4ea476 = v);
var $0fd15e9d8250f2b1$export$3d83eec43f4ea476;
"use strict";
$0fd15e9d8250f2b1$export$3d83eec43f4ea476 = $0fd15e9d8250f2b1$var$addYears;

var $1YUHS = parcelRequire("1YUHS");
/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of years to be added.
 *
 * @returns The new date with the years added
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */ function $0fd15e9d8250f2b1$var$addYears(date, amount) {
    return (0, $1YUHS.addMonths)(date, amount * 12);
}

});

parcelRegister("fD3hg", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarDays", () => $b60d0a59df25f16c$export$4a02e9c37dab4871, (v) => $b60d0a59df25f16c$export$4a02e9c37dab4871 = v);
var $b60d0a59df25f16c$export$4a02e9c37dab4871;
"use strict";
$b60d0a59df25f16c$export$4a02e9c37dab4871 = $b60d0a59df25f16c$var$differenceInCalendarDays;

var $9uNOU = parcelRequire("9uNOU");

var $kdTO4 = parcelRequire("kdTO4");

var $gr9Oc = parcelRequire("gr9Oc");
/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar days
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */ function $b60d0a59df25f16c$var$differenceInCalendarDays(dateLeft, dateRight) {
    const startOfDayLeft = (0, $kdTO4.startOfDay)(dateLeft);
    const startOfDayRight = (0, $kdTO4.startOfDay)(dateRight);
    const timestampLeft = +startOfDayLeft - (0, $gr9Oc.getTimezoneOffsetInMilliseconds)(startOfDayLeft);
    const timestampRight = +startOfDayRight - (0, $gr9Oc.getTimezoneOffsetInMilliseconds)(startOfDayRight);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a day is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((timestampLeft - timestampRight) / $9uNOU.millisecondsInDay);
}

});
parcelRegister("kdTO4", function(module, exports) {

$parcel$export(module.exports, "startOfDay", () => $eb904f8e2d8bb2b8$export$63fa379ae8a9ba2, (v) => $eb904f8e2d8bb2b8$export$63fa379ae8a9ba2 = v);
var $eb904f8e2d8bb2b8$export$63fa379ae8a9ba2;
"use strict";
$eb904f8e2d8bb2b8$export$63fa379ae8a9ba2 = $eb904f8e2d8bb2b8$var$startOfDay;

var $7yyQt = parcelRequire("7yyQt");
/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a day
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */ function $eb904f8e2d8bb2b8$var$startOfDay(date) {
    const _date = (0, $7yyQt.toDate)(date);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});

parcelRegister("gr9Oc", function(module, exports) {

$parcel$export(module.exports, "getTimezoneOffsetInMilliseconds", () => $bf76c6c68c67552d$export$113002b5eff6e430, (v) => $bf76c6c68c67552d$export$113002b5eff6e430 = v);
var $bf76c6c68c67552d$export$113002b5eff6e430;
"use strict";
$bf76c6c68c67552d$export$113002b5eff6e430 = $bf76c6c68c67552d$var$getTimezoneOffsetInMilliseconds;

var $7yyQt = parcelRequire("7yyQt");
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $bf76c6c68c67552d$var$getTimezoneOffsetInMilliseconds(date) {
    const _date = (0, $7yyQt.toDate)(date);
    const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}

});


parcelRegister("ewRVG", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarMonths", () => $a93de31f4953d013$export$489984ac7c996389, (v) => $a93de31f4953d013$export$489984ac7c996389 = v);
var $a93de31f4953d013$export$489984ac7c996389;
"use strict";
$a93de31f4953d013$export$489984ac7c996389 = $a93de31f4953d013$var$differenceInCalendarMonths;

var $7yyQt = parcelRequire("7yyQt");
/**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar months
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */ function $a93de31f4953d013$var$differenceInCalendarMonths(dateLeft, dateRight) {
    const _dateLeft = (0, $7yyQt.toDate)(dateLeft);
    const _dateRight = (0, $7yyQt.toDate)(dateRight);
    const yearDiff = _dateLeft.getFullYear() - _dateRight.getFullYear();
    const monthDiff = _dateLeft.getMonth() - _dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}

});

parcelRegister("8Farc", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarQuarters", () => $64ea3fcb2a0a0e88$export$f62ae9fb13958c7a, (v) => $64ea3fcb2a0a0e88$export$f62ae9fb13958c7a = v);
var $64ea3fcb2a0a0e88$export$f62ae9fb13958c7a;
"use strict";
$64ea3fcb2a0a0e88$export$f62ae9fb13958c7a = $64ea3fcb2a0a0e88$var$differenceInCalendarQuarters;

var $lyYEL = parcelRequire("lyYEL");

var $7yyQt = parcelRequire("7yyQt");
/**
 * @name differenceInCalendarQuarters
 * @category Quarter Helpers
 * @summary Get the number of calendar quarters between the given dates.
 *
 * @description
 * Get the number of calendar quarters between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date

 * @returns The number of calendar quarters
 *
 * @example
 * // How many calendar quarters are between 31 December 2013 and 2 July 2014?
 * const result = differenceInCalendarQuarters(
 *   new Date(2014, 6, 2),
 *   new Date(2013, 11, 31)
 * )
 * //=> 3
 */ function $64ea3fcb2a0a0e88$var$differenceInCalendarQuarters(dateLeft, dateRight) {
    const _dateLeft = (0, $7yyQt.toDate)(dateLeft);
    const _dateRight = (0, $7yyQt.toDate)(dateRight);
    const yearDiff = _dateLeft.getFullYear() - _dateRight.getFullYear();
    const quarterDiff = (0, $lyYEL.getQuarter)(_dateLeft) - (0, $lyYEL.getQuarter)(_dateRight);
    return yearDiff * 4 + quarterDiff;
}

});
parcelRegister("lyYEL", function(module, exports) {

$parcel$export(module.exports, "getQuarter", () => $fb2bd3118a0b6b86$export$de90a4bb31c25221, (v) => $fb2bd3118a0b6b86$export$de90a4bb31c25221 = v);
var $fb2bd3118a0b6b86$export$de90a4bb31c25221;
"use strict";
$fb2bd3118a0b6b86$export$de90a4bb31c25221 = $fb2bd3118a0b6b86$var$getQuarter;

var $7yyQt = parcelRequire("7yyQt");
/**
 * @name getQuarter
 * @category Quarter Helpers
 * @summary Get the year quarter of the given date.
 *
 * @description
 * Get the year quarter of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The quarter
 *
 * @example
 * // Which quarter is 2 July 2014?
 * const result = getQuarter(new Date(2014, 6, 2))
 * //=> 3
 */ function $fb2bd3118a0b6b86$var$getQuarter(date) {
    const _date = (0, $7yyQt.toDate)(date);
    const quarter = Math.trunc(_date.getMonth() / 3) + 1;
    return quarter;
}

});


parcelRegister("gD5RP", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarYears", () => $c1b4d6f0a3d32751$export$c06dce8b38891685, (v) => $c1b4d6f0a3d32751$export$c06dce8b38891685 = v);
var $c1b4d6f0a3d32751$export$c06dce8b38891685;
"use strict";
$c1b4d6f0a3d32751$export$c06dce8b38891685 = $c1b4d6f0a3d32751$var$differenceInCalendarYears;

var $7yyQt = parcelRequire("7yyQt");
/**
 * @name differenceInCalendarYears
 * @category Year Helpers
 * @summary Get the number of calendar years between the given dates.
 *
 * @description
 * Get the number of calendar years between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date

 * @returns The number of calendar years
 *
 * @example
 * // How many calendar years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInCalendarYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */ function $c1b4d6f0a3d32751$var$differenceInCalendarYears(dateLeft, dateRight) {
    const _dateLeft = (0, $7yyQt.toDate)(dateLeft);
    const _dateRight = (0, $7yyQt.toDate)(dateRight);
    return _dateLeft.getFullYear() - _dateRight.getFullYear();
}

});

parcelRegister("8jKFG", function(module, exports) {

$parcel$export(module.exports, "endOfDay", () => $60e44d01eb85bdc4$export$eb9a03f0e9aa6cea, (v) => $60e44d01eb85bdc4$export$eb9a03f0e9aa6cea = v);
var $60e44d01eb85bdc4$export$eb9a03f0e9aa6cea;
"use strict";
$60e44d01eb85bdc4$export$eb9a03f0e9aa6cea = $60e44d01eb85bdc4$var$endOfDay;

var $7yyQt = parcelRequire("7yyQt");
/**
 * @name endOfDay
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a day
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */ function $60e44d01eb85bdc4$var$endOfDay(date) {
    const _date = (0, $7yyQt.toDate)(date);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

});

parcelRegister("lhOVV", function(module, exports) {

$parcel$export(module.exports, "endOfMonth", () => $f7f2b1d039dfeb2d$export$a2258d9c4118825c, (v) => $f7f2b1d039dfeb2d$export$a2258d9c4118825c = v);
var $f7f2b1d039dfeb2d$export$a2258d9c4118825c;
"use strict";
$f7f2b1d039dfeb2d$export$a2258d9c4118825c = $f7f2b1d039dfeb2d$var$endOfMonth;

var $7yyQt = parcelRequire("7yyQt");
/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a month
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */ function $f7f2b1d039dfeb2d$var$endOfMonth(date) {
    const _date = (0, $7yyQt.toDate)(date);
    const month = _date.getMonth();
    _date.setFullYear(_date.getFullYear(), month + 1, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

});

parcelRegister("7hfjh", function(module, exports) {

$parcel$export(module.exports, "endOfWeek", () => $54c5ff31ac2edebd$export$ef8b6d9133084f4e, (v) => $54c5ff31ac2edebd$export$ef8b6d9133084f4e = v);
var $54c5ff31ac2edebd$export$ef8b6d9133084f4e;
"use strict";
$54c5ff31ac2edebd$export$ef8b6d9133084f4e = $54c5ff31ac2edebd$var$endOfWeek;

var $7yyQt = parcelRequire("7yyQt");

var $aK3iq = parcelRequire("aK3iq");
/**
 * The {@link endOfWeek} function options.
 */ /**
 * @name endOfWeek
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The end of a week
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 23:59:59.999
 */ function $54c5ff31ac2edebd$var$endOfWeek(date, options) {
    const defaultOptions = (0, $aK3iq.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $7yyQt.toDate)(date);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    _date.setDate(_date.getDate() + diff);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

});
parcelRegister("aK3iq", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", () => $7d20c1ccd7dd6a35$export$430a3269e24b912e, (v) => $7d20c1ccd7dd6a35$export$430a3269e24b912e = v);
var $7d20c1ccd7dd6a35$export$430a3269e24b912e;
var $7d20c1ccd7dd6a35$export$95365be1b0704abc;
"use strict";
$7d20c1ccd7dd6a35$export$430a3269e24b912e = $7d20c1ccd7dd6a35$var$getDefaultOptions;
$7d20c1ccd7dd6a35$export$95365be1b0704abc = $7d20c1ccd7dd6a35$var$setDefaultOptions;
let $7d20c1ccd7dd6a35$var$defaultOptions = {};
function $7d20c1ccd7dd6a35$var$getDefaultOptions() {
    return $7d20c1ccd7dd6a35$var$defaultOptions;
}
function $7d20c1ccd7dd6a35$var$setDefaultOptions(newOptions) {
    $7d20c1ccd7dd6a35$var$defaultOptions = newOptions;
}

});


parcelRegister("kUlnb", function(module, exports) {

$parcel$export(module.exports, "endOfYear", () => $f3899dd016cb5248$export$8b7aa55c66d5569e, (v) => $f3899dd016cb5248$export$8b7aa55c66d5569e = v);
var $f3899dd016cb5248$export$8b7aa55c66d5569e;
"use strict";
$f3899dd016cb5248$export$8b7aa55c66d5569e = $f3899dd016cb5248$var$endOfYear;

var $7yyQt = parcelRequire("7yyQt");
/**
 * @name endOfYear
 * @category Year Helpers
 * @summary Return the end of a year for the given date.
 *
 * @description
 * Return the end of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a year
 *
 * @example
 * // The end of a year for 2 September 2014 11:55:00:
 * const result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 23:59:59.999
 */ function $f3899dd016cb5248$var$endOfYear(date) {
    const _date = (0, $7yyQt.toDate)(date);
    const year = _date.getFullYear();
    _date.setFullYear(year + 1, 0, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

});

parcelRegister("i1DkS", function(module, exports) {
"use strict";
module.exports.format = module.exports.formatDate = $d1f6d53b6dcbe5f6$var$format;
Object.defineProperty(module.exports, "formatters", {
    enumerable: true,
    get: function() {
        return $eg22F.formatters;
    }
});
Object.defineProperty(module.exports, "longFormatters", {
    enumerable: true,
    get: function() {
        return $dPmGw.longFormatters;
    }
});

var $l7lPu = parcelRequire("l7lPu");

var $aK3iq = parcelRequire("aK3iq");

var $eg22F = parcelRequire("eg22F");

var $dPmGw = parcelRequire("dPmGw");

var $bWEgL = parcelRequire("bWEgL");

var $5ujzY = parcelRequire("5ujzY");

var $7yyQt = parcelRequire("7yyQt");
// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $d1f6d53b6dcbe5f6$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $d1f6d53b6dcbe5f6$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $d1f6d53b6dcbe5f6$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $d1f6d53b6dcbe5f6$var$doubleQuoteRegExp = /''/g;
const $d1f6d53b6dcbe5f6$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * The {@link format} function options.
 */ /**
 * @name format
 * @alias formatDate
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear](https://date-fns.org/docs/getISOWeekYear)
 *    and [getWeekYear](https://date-fns.org/docs/getWeekYear)).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param format - The string of tokens
 * @param options - An object with options
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `localize` property
 * @throws `options.locale` must contain `formatLong` property
 * @throws use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */ function $d1f6d53b6dcbe5f6$var$format(date, formatStr, options) {
    const defaultOptions = (0, $aK3iq.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? $l7lPu.defaultLocale;
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const originalDate = (0, $7yyQt.toDate)(date);
    if (!(0, $5ujzY.isValid)(originalDate)) throw new RangeError("Invalid time value");
    let parts = formatStr.match($d1f6d53b6dcbe5f6$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            const longFormatter = $dPmGw.longFormatters[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($d1f6d53b6dcbe5f6$var$formattingTokensRegExp).map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return {
            isToken: false,
            value: "'"
        };
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return {
            isToken: false,
            value: $d1f6d53b6dcbe5f6$var$cleanEscapedString(substring)
        };
        if ($eg22F.formatters[firstCharacter]) return {
            isToken: true,
            value: substring
        };
        if (firstCharacter.match($d1f6d53b6dcbe5f6$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return {
            isToken: false,
            value: substring
        };
    });
    // invoke localize preprocessor (only for french locales at the moment)
    if (locale.localize.preprocessor) parts = locale.localize.preprocessor(originalDate, parts);
    const formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    return parts.map((part)=>{
        if (!part.isToken) return part.value;
        const token = part.value;
        if (!options?.useAdditionalWeekYearTokens && (0, $bWEgL.isProtectedWeekYearToken)(token) || !options?.useAdditionalDayOfYearTokens && (0, $bWEgL.isProtectedDayOfYearToken)(token)) (0, $bWEgL.warnOrThrowProtectedError)(token, formatStr, String(date));
        const formatter = $eg22F.formatters[token[0]];
        return formatter(originalDate, token, locale.localize, formatterOptions);
    }).join("");
}
function $d1f6d53b6dcbe5f6$var$cleanEscapedString(input) {
    const matched = input.match($d1f6d53b6dcbe5f6$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($d1f6d53b6dcbe5f6$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("l7lPu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "defaultLocale", {
    enumerable: true,
    get: function() {
        return $j9YzS.enUS;
    }
});

var $j9YzS = parcelRequire("j9YzS");

});
parcelRegister("j9YzS", function(module, exports) {

$parcel$export(module.exports, "enUS", () => $df2dd90e7c50f6a9$export$137380d9ce54f7f, (v) => $df2dd90e7c50f6a9$export$137380d9ce54f7f = v);
var $df2dd90e7c50f6a9$export$137380d9ce54f7f;
"use strict";
$df2dd90e7c50f6a9$export$137380d9ce54f7f = void 0;

var $fjnJQ = parcelRequire("fjnJQ");

var $475dX = parcelRequire("475dX");

var $bZZxd = parcelRequire("bZZxd");

var $gdDoQ = parcelRequire("gdDoQ");

var $aXQXD = parcelRequire("aXQXD");
/**
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp](https://github.com/kossnocorp)
 * @author Lesha Koss [@leshakoss](https://github.com/leshakoss)
 */ const $df2dd90e7c50f6a9$var$enUS = $df2dd90e7c50f6a9$export$137380d9ce54f7f = {
    code: "en-US",
    formatDistance: $fjnJQ.formatDistance,
    formatLong: $475dX.formatLong,
    formatRelative: $bZZxd.formatRelative,
    localize: $gdDoQ.localize,
    match: $aXQXD.match,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("fjnJQ", function(module, exports) {

$parcel$export(module.exports, "formatDistance", () => $b25b0b5411c28ac7$export$2c14ff85d6318973, (v) => $b25b0b5411c28ac7$export$2c14ff85d6318973 = v);
var $b25b0b5411c28ac7$export$2c14ff85d6318973;
"use strict";
$b25b0b5411c28ac7$export$2c14ff85d6318973 = void 0;
const $b25b0b5411c28ac7$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
const $b25b0b5411c28ac7$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $b25b0b5411c28ac7$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
$b25b0b5411c28ac7$export$2c14ff85d6318973 = $b25b0b5411c28ac7$var$formatDistance;

});

parcelRegister("475dX", function(module, exports) {

$parcel$export(module.exports, "formatLong", () => $2febde47bb98bab0$export$cbf60ecb96cbb82f, (v) => $2febde47bb98bab0$export$cbf60ecb96cbb82f = v);
var $2febde47bb98bab0$export$cbf60ecb96cbb82f;
"use strict";
$2febde47bb98bab0$export$cbf60ecb96cbb82f = void 0;

var $cF8nj = parcelRequire("cF8nj");
const $2febde47bb98bab0$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $2febde47bb98bab0$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $2febde47bb98bab0$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $2febde47bb98bab0$var$formatLong = $2febde47bb98bab0$export$cbf60ecb96cbb82f = {
    date: (0, $cF8nj.buildFormatLongFn)({
        formats: $2febde47bb98bab0$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $cF8nj.buildFormatLongFn)({
        formats: $2febde47bb98bab0$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $cF8nj.buildFormatLongFn)({
        formats: $2febde47bb98bab0$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});
parcelRegister("cF8nj", function(module, exports) {

$parcel$export(module.exports, "buildFormatLongFn", () => $937fcf7e723dd6d7$export$38e44e97ce4dbb7d, (v) => $937fcf7e723dd6d7$export$38e44e97ce4dbb7d = v);
var $937fcf7e723dd6d7$export$38e44e97ce4dbb7d;
"use strict";
$937fcf7e723dd6d7$export$38e44e97ce4dbb7d = $937fcf7e723dd6d7$var$buildFormatLongFn;
function $937fcf7e723dd6d7$var$buildFormatLongFn(args) {
    return (options = {})=>{
        // TODO: Remove String()
        const width = options.width ? String(options.width) : args.defaultWidth;
        const format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

});


parcelRegister("bZZxd", function(module, exports) {

$parcel$export(module.exports, "formatRelative", () => $8bc51fb51fb6cd5f$export$8fbbfd65594f46a0, (v) => $8bc51fb51fb6cd5f$export$8fbbfd65594f46a0 = v);
var $8bc51fb51fb6cd5f$export$8fbbfd65594f46a0;
"use strict";
$8bc51fb51fb6cd5f$export$8fbbfd65594f46a0 = void 0;
const $8bc51fb51fb6cd5f$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
const $8bc51fb51fb6cd5f$var$formatRelative = (token, _date, _baseDate, _options)=>$8bc51fb51fb6cd5f$var$formatRelativeLocale[token];
$8bc51fb51fb6cd5f$export$8fbbfd65594f46a0 = $8bc51fb51fb6cd5f$var$formatRelative;

});

parcelRegister("gdDoQ", function(module, exports) {

$parcel$export(module.exports, "localize", () => $bcec6c2f03a4d00e$export$b3bd0bc58e36cd63, (v) => $bcec6c2f03a4d00e$export$b3bd0bc58e36cd63 = v);
var $bcec6c2f03a4d00e$export$b3bd0bc58e36cd63;
"use strict";
$bcec6c2f03a4d00e$export$b3bd0bc58e36cd63 = void 0;

var $i0e32 = parcelRequire("i0e32");
const $bcec6c2f03a4d00e$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
const $bcec6c2f03a4d00e$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $bcec6c2f03a4d00e$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
const $bcec6c2f03a4d00e$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
const $bcec6c2f03a4d00e$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
const $bcec6c2f03a4d00e$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
const $bcec6c2f03a4d00e$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
const $bcec6c2f03a4d00e$var$localize = $bcec6c2f03a4d00e$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $bcec6c2f03a4d00e$var$ordinalNumber,
    era: (0, $i0e32.buildLocalizeFn)({
        values: $bcec6c2f03a4d00e$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $i0e32.buildLocalizeFn)({
        values: $bcec6c2f03a4d00e$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $i0e32.buildLocalizeFn)({
        values: $bcec6c2f03a4d00e$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $i0e32.buildLocalizeFn)({
        values: $bcec6c2f03a4d00e$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $i0e32.buildLocalizeFn)({
        values: $bcec6c2f03a4d00e$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $bcec6c2f03a4d00e$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});
parcelRegister("i0e32", function(module, exports) {

$parcel$export(module.exports, "buildLocalizeFn", () => $d1b31fbcf71c7062$export$63596d6ee8878b25, (v) => $d1b31fbcf71c7062$export$63596d6ee8878b25 = v);
var $d1b31fbcf71c7062$export$63596d6ee8878b25;
"use strict";
$d1b31fbcf71c7062$export$63596d6ee8878b25 = $d1b31fbcf71c7062$var$buildLocalizeFn; /* eslint-disable no-unused-vars */ 
/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ function $d1b31fbcf71c7062$var$buildLocalizeFn(args) {
    return (value, options)=>{
        const context = options?.context ? String(options.context) : "standalone";
        let valuesArray;
        if (context === "formatting" && args.formattingValues) {
            const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            const width = options?.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            const defaultWidth = args.defaultWidth;
            const width = options?.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width] || args.values[defaultWidth];
        }
        const index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

});


parcelRegister("aXQXD", function(module, exports) {

$parcel$export(module.exports, "match", () => $7fb87efbf3834a7c$export$4659b591c19bdf3d, (v) => $7fb87efbf3834a7c$export$4659b591c19bdf3d = v);
var $7fb87efbf3834a7c$export$4659b591c19bdf3d;
"use strict";
$7fb87efbf3834a7c$export$4659b591c19bdf3d = void 0;

var $4VX5I = parcelRequire("4VX5I");

var $k6RNN = parcelRequire("k6RNN");
const $7fb87efbf3834a7c$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $7fb87efbf3834a7c$var$parseOrdinalNumberPattern = /\d+/i;
const $7fb87efbf3834a7c$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
const $7fb87efbf3834a7c$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const $7fb87efbf3834a7c$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
const $7fb87efbf3834a7c$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $7fb87efbf3834a7c$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const $7fb87efbf3834a7c$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $7fb87efbf3834a7c$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const $7fb87efbf3834a7c$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $7fb87efbf3834a7c$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const $7fb87efbf3834a7c$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const $7fb87efbf3834a7c$var$match = $7fb87efbf3834a7c$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $k6RNN.buildMatchPatternFn)({
        matchPattern: $7fb87efbf3834a7c$var$matchOrdinalNumberPattern,
        parsePattern: $7fb87efbf3834a7c$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $4VX5I.buildMatchFn)({
        matchPatterns: $7fb87efbf3834a7c$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7fb87efbf3834a7c$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $4VX5I.buildMatchFn)({
        matchPatterns: $7fb87efbf3834a7c$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7fb87efbf3834a7c$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $4VX5I.buildMatchFn)({
        matchPatterns: $7fb87efbf3834a7c$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7fb87efbf3834a7c$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $4VX5I.buildMatchFn)({
        matchPatterns: $7fb87efbf3834a7c$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7fb87efbf3834a7c$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $4VX5I.buildMatchFn)({
        matchPatterns: $7fb87efbf3834a7c$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $7fb87efbf3834a7c$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});
parcelRegister("4VX5I", function(module, exports) {

$parcel$export(module.exports, "buildMatchFn", () => $397a5297d63bb64f$export$1430a0f35710914d, (v) => $397a5297d63bb64f$export$1430a0f35710914d = v);
var $397a5297d63bb64f$export$1430a0f35710914d;
"use strict";
$397a5297d63bb64f$export$1430a0f35710914d = $397a5297d63bb64f$var$buildMatchFn;
function $397a5297d63bb64f$var$buildMatchFn(args) {
    return (string, options = {})=>{
        const width = options.width;
        const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        const matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        const key = Array.isArray(parsePatterns) ? $397a5297d63bb64f$var$findIndex(parsePatterns, (pattern)=>pattern.test(matchedString)) : $397a5297d63bb64f$var$findKey(parsePatterns, (pattern)=>pattern.test(matchedString));
        let value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $397a5297d63bb64f$var$findKey(object, predicate) {
    for(const key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $397a5297d63bb64f$var$findIndex(array, predicate) {
    for(let key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

});

parcelRegister("k6RNN", function(module, exports) {

$parcel$export(module.exports, "buildMatchPatternFn", () => $ea3e1a3193098a99$export$fdaf2fd6d7edde95, (v) => $ea3e1a3193098a99$export$fdaf2fd6d7edde95 = v);
var $ea3e1a3193098a99$export$fdaf2fd6d7edde95;
"use strict";
$ea3e1a3193098a99$export$fdaf2fd6d7edde95 = $ea3e1a3193098a99$var$buildMatchPatternFn;
function $ea3e1a3193098a99$var$buildMatchPatternFn(args) {
    return (string, options = {})=>{
        const matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

});




parcelRegister("eg22F", function(module, exports) {

$parcel$export(module.exports, "formatters", () => $a61424cc6e7370c5$export$fe98a034cfb96d55, (v) => $a61424cc6e7370c5$export$fe98a034cfb96d55 = v);
var $a61424cc6e7370c5$export$fe98a034cfb96d55;
"use strict";
$a61424cc6e7370c5$export$fe98a034cfb96d55 = void 0;

var $iQCjQ = parcelRequire("iQCjQ");

var $h6qsS = parcelRequire("h6qsS");

var $e1RaR = parcelRequire("e1RaR");

var $5bAu7 = parcelRequire("5bAu7");

var $dFij3 = parcelRequire("dFij3");

var $9jrRw = parcelRequire("9jrRw");

var $l3957 = parcelRequire("l3957");
const $a61424cc6e7370c5$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ const $a61424cc6e7370c5$var$formatters = $a61424cc6e7370c5$export$fe98a034cfb96d55 = {
    // Era
    G: function(date, token, localize) {
        const era = date.getFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            const signedYear = date.getFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            const year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return $l3957.lightFormatters.y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        const signedWeekYear = (0, $dFij3.getWeekYear)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            const twoDigitYear = weekYear % 100;
            return (0, $9jrRw.addLeadingZeros)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $9jrRw.addLeadingZeros)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        const isoWeekYear = (0, $e1RaR.getISOWeekYear)(date);
        // Padding
        return (0, $9jrRw.addLeadingZeros)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        const year = date.getFullYear();
        return (0, $9jrRw.addLeadingZeros)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $9jrRw.addLeadingZeros)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $9jrRw.addLeadingZeros)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            case "M":
            case "MM":
                return $l3957.lightFormatters.M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $9jrRw.addLeadingZeros)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        const week = (0, $5bAu7.getWeek)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $9jrRw.addLeadingZeros)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        const isoWeek = (0, $h6qsS.getISOWeek)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $9jrRw.addLeadingZeros)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getDate(), {
            unit: "date"
        });
        return $l3957.lightFormatters.d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        const dayOfYear = (0, $iQCjQ.getDayOfYear)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $9jrRw.addLeadingZeros)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $9jrRw.addLeadingZeros)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $9jrRw.addLeadingZeros)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $9jrRw.addLeadingZeros)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        const hours = date.getHours();
        const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $a61424cc6e7370c5$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $a61424cc6e7370c5$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $a61424cc6e7370c5$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $a61424cc6e7370c5$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $a61424cc6e7370c5$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $a61424cc6e7370c5$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === "ho") {
            let hours = date.getHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return $l3957.lightFormatters.h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getHours(), {
            unit: "hour"
        });
        return $l3957.lightFormatters.H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        const hours = date.getHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $9jrRw.addLeadingZeros)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        let hours = date.getHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $9jrRw.addLeadingZeros)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getMinutes(), {
            unit: "minute"
        });
        return $l3957.lightFormatters.m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getSeconds(), {
            unit: "second"
        });
        return $l3957.lightFormatters.s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return $l3957.lightFormatters.S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $a61424cc6e7370c5$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return $a61424cc6e7370c5$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $a61424cc6e7370c5$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $a61424cc6e7370c5$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return $a61424cc6e7370c5$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $a61424cc6e7370c5$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $a61424cc6e7370c5$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $a61424cc6e7370c5$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $a61424cc6e7370c5$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $a61424cc6e7370c5$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize) {
        const timestamp = Math.trunc(date.getTime() / 1000);
        return (0, $9jrRw.addLeadingZeros)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize) {
        const timestamp = date.getTime();
        return (0, $9jrRw.addLeadingZeros)(timestamp, token.length);
    }
};
function $a61424cc6e7370c5$var$formatTimezoneShort(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = Math.trunc(absOffset / 60);
    const minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + (0, $9jrRw.addLeadingZeros)(minutes, 2);
}
function $a61424cc6e7370c5$var$formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        const sign = offset > 0 ? "-" : "+";
        return sign + (0, $9jrRw.addLeadingZeros)(Math.abs(offset) / 60, 2);
    }
    return $a61424cc6e7370c5$var$formatTimezone(offset, delimiter);
}
function $a61424cc6e7370c5$var$formatTimezone(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = (0, $9jrRw.addLeadingZeros)(Math.trunc(absOffset / 60), 2);
    const minutes = (0, $9jrRw.addLeadingZeros)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}

});
parcelRegister("iQCjQ", function(module, exports) {

$parcel$export(module.exports, "getDayOfYear", () => $db8aceab23c59713$export$d3b42cd8452deec, (v) => $db8aceab23c59713$export$d3b42cd8452deec = v);
var $db8aceab23c59713$export$d3b42cd8452deec;
"use strict";
$db8aceab23c59713$export$d3b42cd8452deec = $db8aceab23c59713$var$getDayOfYear;

var $fD3hg = parcelRequire("fD3hg");

var $9FGIH = parcelRequire("9FGIH");

var $7yyQt = parcelRequire("7yyQt");
/**
 * @name getDayOfYear
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of year
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * const result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */ function $db8aceab23c59713$var$getDayOfYear(date) {
    const _date = (0, $7yyQt.toDate)(date);
    const diff = (0, $fD3hg.differenceInCalendarDays)(_date, (0, $9FGIH.startOfYear)(_date));
    const dayOfYear = diff + 1;
    return dayOfYear;
}

});
parcelRegister("9FGIH", function(module, exports) {

$parcel$export(module.exports, "startOfYear", () => $70a914b2bfa6cf87$export$f91e89d3d0406102, (v) => $70a914b2bfa6cf87$export$f91e89d3d0406102 = v);
var $70a914b2bfa6cf87$export$f91e89d3d0406102;
"use strict";
$70a914b2bfa6cf87$export$f91e89d3d0406102 = $70a914b2bfa6cf87$var$startOfYear;

var $7yyQt = parcelRequire("7yyQt");

var $cMvsU = parcelRequire("cMvsU");
/**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a year
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */ function $70a914b2bfa6cf87$var$startOfYear(date) {
    const cleanDate = (0, $7yyQt.toDate)(date);
    const _date = (0, $cMvsU.constructFrom)(date, 0);
    _date.setFullYear(cleanDate.getFullYear(), 0, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});


parcelRegister("h6qsS", function(module, exports) {

$parcel$export(module.exports, "getISOWeek", () => $c7378692dfd4ab30$export$7cabdc5698b63e2f, (v) => $c7378692dfd4ab30$export$7cabdc5698b63e2f = v);
var $c7378692dfd4ab30$export$7cabdc5698b63e2f;
"use strict";
$c7378692dfd4ab30$export$7cabdc5698b63e2f = $c7378692dfd4ab30$var$getISOWeek;

var $9uNOU = parcelRequire("9uNOU");

var $lo97E = parcelRequire("lo97E");

var $1G94m = parcelRequire("1G94m");

var $7yyQt = parcelRequire("7yyQt");
/**
 * @name getISOWeek
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The ISO week
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * const result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */ function $c7378692dfd4ab30$var$getISOWeek(date) {
    const _date = (0, $7yyQt.toDate)(date);
    const diff = +(0, $lo97E.startOfISOWeek)(_date) - +(0, $1G94m.startOfISOWeekYear)(_date);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / $9uNOU.millisecondsInWeek) + 1;
}

});
parcelRegister("lo97E", function(module, exports) {

$parcel$export(module.exports, "startOfISOWeek", () => $f922ea67b098f800$export$6173213f95a4431e, (v) => $f922ea67b098f800$export$6173213f95a4431e = v);
var $f922ea67b098f800$export$6173213f95a4431e;
"use strict";
$f922ea67b098f800$export$6173213f95a4431e = $f922ea67b098f800$var$startOfISOWeek;

var $2cZ4R = parcelRequire("2cZ4R");
/**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an ISO week
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * const result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */ function $f922ea67b098f800$var$startOfISOWeek(date) {
    return (0, $2cZ4R.startOfWeek)(date, {
        weekStartsOn: 1
    });
}

});
parcelRegister("2cZ4R", function(module, exports) {

$parcel$export(module.exports, "startOfWeek", () => $19bc147add1de659$export$42c81a444fbfb5d4, (v) => $19bc147add1de659$export$42c81a444fbfb5d4 = v);
var $19bc147add1de659$export$42c81a444fbfb5d4;
"use strict";
$19bc147add1de659$export$42c81a444fbfb5d4 = $19bc147add1de659$var$startOfWeek;

var $7yyQt = parcelRequire("7yyQt");

var $aK3iq = parcelRequire("aK3iq");
/**
 * The {@link startOfWeek} function options.
 */ /**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */ function $19bc147add1de659$var$startOfWeek(date, options) {
    const defaultOptions = (0, $aK3iq.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $7yyQt.toDate)(date);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});


parcelRegister("1G94m", function(module, exports) {

$parcel$export(module.exports, "startOfISOWeekYear", () => $1390bfa921613bda$export$236bdfa374eb69a9, (v) => $1390bfa921613bda$export$236bdfa374eb69a9 = v);
var $1390bfa921613bda$export$236bdfa374eb69a9;
"use strict";
$1390bfa921613bda$export$236bdfa374eb69a9 = $1390bfa921613bda$var$startOfISOWeekYear;

var $e1RaR = parcelRequire("e1RaR");

var $lo97E = parcelRequire("lo97E");

var $cMvsU = parcelRequire("cMvsU");
/**
 * @name startOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an ISO week-numbering year
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */ function $1390bfa921613bda$var$startOfISOWeekYear(date) {
    const year = (0, $e1RaR.getISOWeekYear)(date);
    const fourthOfJanuary = (0, $cMvsU.constructFrom)(date, 0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    return (0, $lo97E.startOfISOWeek)(fourthOfJanuary);
}

});
parcelRegister("e1RaR", function(module, exports) {

$parcel$export(module.exports, "getISOWeekYear", () => $a36a67fbf4e7f789$export$3dbc52535f6f8fcc, (v) => $a36a67fbf4e7f789$export$3dbc52535f6f8fcc = v);
var $a36a67fbf4e7f789$export$3dbc52535f6f8fcc;
"use strict";
$a36a67fbf4e7f789$export$3dbc52535f6f8fcc = $a36a67fbf4e7f789$var$getISOWeekYear;

var $cMvsU = parcelRequire("cMvsU");

var $lo97E = parcelRequire("lo97E");

var $7yyQt = parcelRequire("7yyQt");
/**
 * @name getISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The ISO week-numbering year
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * const result = getISOWeekYear(new Date(2005, 0, 2))
 * //=> 2004
 */ function $a36a67fbf4e7f789$var$getISOWeekYear(date) {
    const _date = (0, $7yyQt.toDate)(date);
    const year = _date.getFullYear();
    const fourthOfJanuaryOfNextYear = (0, $cMvsU.constructFrom)(date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $lo97E.startOfISOWeek)(fourthOfJanuaryOfNextYear);
    const fourthOfJanuaryOfThisYear = (0, $cMvsU.constructFrom)(date, 0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $lo97E.startOfISOWeek)(fourthOfJanuaryOfThisYear);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("5bAu7", function(module, exports) {

$parcel$export(module.exports, "getWeek", () => $3c6a47f4b80291d0$export$efe19b760242b2fc, (v) => $3c6a47f4b80291d0$export$efe19b760242b2fc = v);
var $3c6a47f4b80291d0$export$efe19b760242b2fc;
"use strict";
$3c6a47f4b80291d0$export$efe19b760242b2fc = $3c6a47f4b80291d0$var$getWeek;

var $9uNOU = parcelRequire("9uNOU");

var $2cZ4R = parcelRequire("2cZ4R");

var $9oCza = parcelRequire("9oCza");

var $7yyQt = parcelRequire("7yyQt");
/**
 * The {@link getWeek} function options.
 */ /**
 * @name getWeek
 * @category Week Helpers
 * @summary Get the local week index of the given date.
 *
 * @description
 * Get the local week index of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options
 *
 * @returns The week
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005 with default options?
 * const result = getWeek(new Date(2005, 0, 2))
 * //=> 2
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January?
 * const result = getWeek(new Date(2005, 0, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> 53
 */ function $3c6a47f4b80291d0$var$getWeek(date, options) {
    const _date = (0, $7yyQt.toDate)(date);
    const diff = +(0, $2cZ4R.startOfWeek)(_date, options) - +(0, $9oCza.startOfWeekYear)(_date, options);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / $9uNOU.millisecondsInWeek) + 1;
}

});
parcelRegister("9oCza", function(module, exports) {

$parcel$export(module.exports, "startOfWeekYear", () => $6d7445628bc657f6$export$bb7b45bb8e74da0f, (v) => $6d7445628bc657f6$export$bb7b45bb8e74da0f = v);
var $6d7445628bc657f6$export$bb7b45bb8e74da0f;
"use strict";
$6d7445628bc657f6$export$bb7b45bb8e74da0f = $6d7445628bc657f6$var$startOfWeekYear;

var $cMvsU = parcelRequire("cMvsU");

var $dFij3 = parcelRequire("dFij3");

var $2cZ4R = parcelRequire("2cZ4R");

var $aK3iq = parcelRequire("aK3iq");
/**
 * The {@link startOfWeekYear} function options.
 */ /**
 * @name startOfWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Return the start of a local week-numbering year for the given date.
 *
 * @description
 * Return the start of a local week-numbering year.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week-numbering year
 *
 * @example
 * // The start of an a week-numbering year for 2 July 2005 with default settings:
 * const result = startOfWeekYear(new Date(2005, 6, 2))
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // The start of a week-numbering year for 2 July 2005
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = startOfWeekYear(new Date(2005, 6, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Mon Jan 03 2005 00:00:00
 */ function $6d7445628bc657f6$var$startOfWeekYear(date, options) {
    const defaultOptions = (0, $aK3iq.getDefaultOptions)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const year = (0, $dFij3.getWeekYear)(date, options);
    const firstWeek = (0, $cMvsU.constructFrom)(date, 0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    const _date = (0, $2cZ4R.startOfWeek)(firstWeek, options);
    return _date;
}

});
parcelRegister("dFij3", function(module, exports) {

$parcel$export(module.exports, "getWeekYear", () => $9f2d4df197546c06$export$12d572480ceb6e58, (v) => $9f2d4df197546c06$export$12d572480ceb6e58 = v);
var $9f2d4df197546c06$export$12d572480ceb6e58;
"use strict";
$9f2d4df197546c06$export$12d572480ceb6e58 = $9f2d4df197546c06$var$getWeekYear;

var $cMvsU = parcelRequire("cMvsU");

var $2cZ4R = parcelRequire("2cZ4R");

var $7yyQt = parcelRequire("7yyQt");

var $aK3iq = parcelRequire("aK3iq");
/**
 * The {@link getWeekYear} function options.
 */ /**
 * @name getWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Get the local week-numbering year of the given date.
 *
 * @description
 * Get the local week-numbering year of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The local week-numbering year
 *
 * @example
 * // Which week numbering year is 26 December 2004 with the default settings?
 * const result = getWeekYear(new Date(2004, 11, 26))
 * //=> 2005
 *
 * @example
 * // Which week numbering year is 26 December 2004 if week starts on Saturday?
 * const result = getWeekYear(new Date(2004, 11, 26), { weekStartsOn: 6 })
 * //=> 2004
 *
 * @example
 * // Which week numbering year is 26 December 2004 if the first week contains 4 January?
 * const result = getWeekYear(new Date(2004, 11, 26), { firstWeekContainsDate: 4 })
 * //=> 2004
 */ function $9f2d4df197546c06$var$getWeekYear(date, options) {
    const _date = (0, $7yyQt.toDate)(date);
    const year = _date.getFullYear();
    const defaultOptions = (0, $aK3iq.getDefaultOptions)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const firstWeekOfNextYear = (0, $cMvsU.constructFrom)(date, 0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $2cZ4R.startOfWeek)(firstWeekOfNextYear, options);
    const firstWeekOfThisYear = (0, $cMvsU.constructFrom)(date, 0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $2cZ4R.startOfWeek)(firstWeekOfThisYear, options);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("9jrRw", function(module, exports) {

$parcel$export(module.exports, "addLeadingZeros", () => $6c7b80446273fbf1$export$c8306e720e213c0f, (v) => $6c7b80446273fbf1$export$c8306e720e213c0f = v);
var $6c7b80446273fbf1$export$c8306e720e213c0f;
"use strict";
$6c7b80446273fbf1$export$c8306e720e213c0f = $6c7b80446273fbf1$var$addLeadingZeros;
function $6c7b80446273fbf1$var$addLeadingZeros(number, targetLength) {
    const sign = number < 0 ? "-" : "";
    const output = Math.abs(number).toString().padStart(targetLength, "0");
    return sign + output;
}

});

parcelRegister("l3957", function(module, exports) {

$parcel$export(module.exports, "lightFormatters", () => $f530ec37dbf8665a$export$b0d4b338e1516f13, (v) => $f530ec37dbf8665a$export$b0d4b338e1516f13 = v);
var $f530ec37dbf8665a$export$b0d4b338e1516f13;
"use strict";
$f530ec37dbf8665a$export$b0d4b338e1516f13 = void 0;

var $9jrRw = parcelRequire("9jrRw");
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ const $f530ec37dbf8665a$var$lightFormatters = $f530ec37dbf8665a$export$b0d4b338e1516f13 = {
    // Year
    y (date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        const signedYear = date.getFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $9jrRw.addLeadingZeros)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M (date, token) {
        const month = date.getMonth();
        return token === "M" ? String(month + 1) : (0, $9jrRw.addLeadingZeros)(month + 1, 2);
    },
    // Day of the month
    d (date, token) {
        return (0, $9jrRw.addLeadingZeros)(date.getDate(), token.length);
    },
    // AM or PM
    a (date, token) {
        const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h (date, token) {
        return (0, $9jrRw.addLeadingZeros)(date.getHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H (date, token) {
        return (0, $9jrRw.addLeadingZeros)(date.getHours(), token.length);
    },
    // Minute
    m (date, token) {
        return (0, $9jrRw.addLeadingZeros)(date.getMinutes(), token.length);
    },
    // Second
    s (date, token) {
        return (0, $9jrRw.addLeadingZeros)(date.getSeconds(), token.length);
    },
    // Fraction of second
    S (date, token) {
        const numberOfDigits = token.length;
        const milliseconds = date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $9jrRw.addLeadingZeros)(fractionalSeconds, token.length);
    }
};

});


parcelRegister("dPmGw", function(module, exports) {

$parcel$export(module.exports, "longFormatters", () => $a111a280e7a3f1fa$export$70cc8fd02856fd58, (v) => $a111a280e7a3f1fa$export$70cc8fd02856fd58 = v);
var $a111a280e7a3f1fa$export$70cc8fd02856fd58;
"use strict";
$a111a280e7a3f1fa$export$70cc8fd02856fd58 = void 0;
const $a111a280e7a3f1fa$var$dateLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
const $a111a280e7a3f1fa$var$timeLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
const $a111a280e7a3f1fa$var$dateTimeLongFormatter = (pattern, formatLong)=>{
    const matchResult = pattern.match(/(P+)(p+)?/) || [];
    const datePattern = matchResult[1];
    const timePattern = matchResult[2];
    if (!timePattern) return $a111a280e7a3f1fa$var$dateLongFormatter(pattern, formatLong);
    let dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $a111a280e7a3f1fa$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $a111a280e7a3f1fa$var$timeLongFormatter(timePattern, formatLong));
};
const $a111a280e7a3f1fa$var$longFormatters = $a111a280e7a3f1fa$export$70cc8fd02856fd58 = {
    p: $a111a280e7a3f1fa$var$timeLongFormatter,
    P: $a111a280e7a3f1fa$var$dateTimeLongFormatter
};

});

parcelRegister("bWEgL", function(module, exports) {

$parcel$export(module.exports, "isProtectedDayOfYearToken", () => $8b24592752d42d9c$export$c6cc36aa33304772, (v) => $8b24592752d42d9c$export$c6cc36aa33304772 = v);
$parcel$export(module.exports, "isProtectedWeekYearToken", () => $8b24592752d42d9c$export$c6b49d6dceb604a1, (v) => $8b24592752d42d9c$export$c6b49d6dceb604a1 = v);
$parcel$export(module.exports, "warnOrThrowProtectedError", () => $8b24592752d42d9c$export$f5f38f90ecaaf879, (v) => $8b24592752d42d9c$export$f5f38f90ecaaf879 = v);
var $8b24592752d42d9c$export$c6cc36aa33304772;
var $8b24592752d42d9c$export$c6b49d6dceb604a1;
var $8b24592752d42d9c$export$f5f38f90ecaaf879;
"use strict";
$8b24592752d42d9c$export$c6cc36aa33304772 = $8b24592752d42d9c$var$isProtectedDayOfYearToken;
$8b24592752d42d9c$export$c6b49d6dceb604a1 = $8b24592752d42d9c$var$isProtectedWeekYearToken;
$8b24592752d42d9c$export$f5f38f90ecaaf879 = $8b24592752d42d9c$var$warnOrThrowProtectedError;
const $8b24592752d42d9c$var$dayOfYearTokenRE = /^D+$/;
const $8b24592752d42d9c$var$weekYearTokenRE = /^Y+$/;
const $8b24592752d42d9c$var$throwTokens = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function $8b24592752d42d9c$var$isProtectedDayOfYearToken(token) {
    return $8b24592752d42d9c$var$dayOfYearTokenRE.test(token);
}
function $8b24592752d42d9c$var$isProtectedWeekYearToken(token) {
    return $8b24592752d42d9c$var$weekYearTokenRE.test(token);
}
function $8b24592752d42d9c$var$warnOrThrowProtectedError(token, format, input) {
    const _message = $8b24592752d42d9c$var$message(token, format, input);
    console.warn(_message);
    if ($8b24592752d42d9c$var$throwTokens.includes(token)) throw new RangeError(_message);
}
function $8b24592752d42d9c$var$message(token, format, input) {
    const subject = token[0] === "Y" ? "years" : "days of the month";
    return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}

});

parcelRegister("5ujzY", function(module, exports) {

$parcel$export(module.exports, "isValid", () => $3feef11dde2315db$export$1ea939691cdc45b8, (v) => $3feef11dde2315db$export$1ea939691cdc45b8 = v);
var $3feef11dde2315db$export$1ea939691cdc45b8;
"use strict";
$3feef11dde2315db$export$1ea939691cdc45b8 = $3feef11dde2315db$var$isValid;

var $51jqk = parcelRequire("51jqk");

var $7yyQt = parcelRequire("7yyQt");
/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate](https://date-fns.org/docs/toDate)
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is valid
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */ function $3feef11dde2315db$var$isValid(date) {
    if (!(0, $51jqk.isDate)(date) && typeof date !== "number") return false;
    const _date = (0, $7yyQt.toDate)(date);
    return !isNaN(Number(_date));
}

});
parcelRegister("51jqk", function(module, exports) {

$parcel$export(module.exports, "isDate", () => $3a7c1ce5b86d595e$export$871608497c498473, (v) => $3a7c1ce5b86d595e$export$871608497c498473 = v);
var $3a7c1ce5b86d595e$export$871608497c498473;
"use strict";
$3a7c1ce5b86d595e$export$871608497c498473 = $3a7c1ce5b86d595e$var$isDate; /**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ 
function $3a7c1ce5b86d595e$var$isDate(value) {
    return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}

});



parcelRegister("3YS3k", function(module, exports) {

$parcel$export(module.exports, "getDate", () => $2e60e772992ff572$export$aa350b96d91cd94, (v) => $2e60e772992ff572$export$aa350b96d91cd94 = v);
var $2e60e772992ff572$export$aa350b96d91cd94;
"use strict";
$2e60e772992ff572$export$aa350b96d91cd94 = $2e60e772992ff572$var$getDate;

var $7yyQt = parcelRequire("7yyQt");
/**
 * @name getDate
 * @category Day Helpers
 * @summary Get the day of the month of the given date.
 *
 * @description
 * Get the day of the month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of month
 *
 * @example
 * // Which day of the month is 29 February 2012?
 * const result = getDate(new Date(2012, 1, 29))
 * //=> 29
 */ function $2e60e772992ff572$var$getDate(date) {
    const _date = (0, $7yyQt.toDate)(date);
    const dayOfMonth = _date.getDate();
    return dayOfMonth;
}

});

parcelRegister("11Qi3", function(module, exports) {

$parcel$export(module.exports, "getDay", () => $0bfe722decc8530a$export$1b64bc9c5306ed54, (v) => $0bfe722decc8530a$export$1b64bc9c5306ed54 = v);
var $0bfe722decc8530a$export$1b64bc9c5306ed54;
"use strict";
$0bfe722decc8530a$export$1b64bc9c5306ed54 = $0bfe722decc8530a$var$getDay;

var $7yyQt = parcelRequire("7yyQt");
/**
 * @name getDay
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of week, 0 represents Sunday
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * const result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */ function $0bfe722decc8530a$var$getDay(date) {
    const _date = (0, $7yyQt.toDate)(date);
    const day = _date.getDay();
    return day;
}

});

parcelRegister("1U5fu", function(module, exports) {

$parcel$export(module.exports, "getHours", () => $162f17b1bec5697d$export$257b40f71c07d58f, (v) => $162f17b1bec5697d$export$257b40f71c07d58f = v);
var $162f17b1bec5697d$export$257b40f71c07d58f;
"use strict";
$162f17b1bec5697d$export$257b40f71c07d58f = $162f17b1bec5697d$var$getHours;

var $7yyQt = parcelRequire("7yyQt");
/**
 * @name getHours
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The hours
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * const result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */ function $162f17b1bec5697d$var$getHours(date) {
    const _date = (0, $7yyQt.toDate)(date);
    const hours = _date.getHours();
    return hours;
}

});

parcelRegister("d6CyT", function(module, exports) {

$parcel$export(module.exports, "getMinutes", () => $98a9bf7798b2a00d$export$b7f1bc3ea3ac4145, (v) => $98a9bf7798b2a00d$export$b7f1bc3ea3ac4145 = v);
var $98a9bf7798b2a00d$export$b7f1bc3ea3ac4145;
"use strict";
$98a9bf7798b2a00d$export$b7f1bc3ea3ac4145 = $98a9bf7798b2a00d$var$getMinutes;

var $7yyQt = parcelRequire("7yyQt");
/**
 * @name getMinutes
 * @category Minute Helpers
 * @summary Get the minutes of the given date.
 *
 * @description
 * Get the minutes of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The minutes
 *
 * @example
 * // Get the minutes of 29 February 2012 11:45:05:
 * const result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 45
 */ function $98a9bf7798b2a00d$var$getMinutes(date) {
    const _date = (0, $7yyQt.toDate)(date);
    const minutes = _date.getMinutes();
    return minutes;
}

});

parcelRegister("dEe92", function(module, exports) {

$parcel$export(module.exports, "getMonth", () => $9ef9fba11b4db36b$export$6ce1b5acc29cb53b, (v) => $9ef9fba11b4db36b$export$6ce1b5acc29cb53b = v);
var $9ef9fba11b4db36b$export$6ce1b5acc29cb53b;
"use strict";
$9ef9fba11b4db36b$export$6ce1b5acc29cb53b = $9ef9fba11b4db36b$var$getMonth;

var $7yyQt = parcelRequire("7yyQt");
/**
 * @name getMonth
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The month index (0-11)
 *
 * @example
 * // Which month is 29 February 2012?
 * const result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */ function $9ef9fba11b4db36b$var$getMonth(date) {
    const _date = (0, $7yyQt.toDate)(date);
    const month = _date.getMonth();
    return month;
}

});

parcelRegister("gxKq4", function(module, exports) {

$parcel$export(module.exports, "getSeconds", () => $c0b3bc5f5b4b24c9$export$5e9417507ff28427, (v) => $c0b3bc5f5b4b24c9$export$5e9417507ff28427 = v);
var $c0b3bc5f5b4b24c9$export$5e9417507ff28427;
"use strict";
$c0b3bc5f5b4b24c9$export$5e9417507ff28427 = $c0b3bc5f5b4b24c9$var$getSeconds;

var $7yyQt = parcelRequire("7yyQt");
/**
 * @name getSeconds
 * @category Second Helpers
 * @summary Get the seconds of the given date.
 *
 * @description
 * Get the seconds of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The seconds
 *
 * @example
 * // Get the seconds of 29 February 2012 11:45:05.123:
 * const result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 5
 */ function $c0b3bc5f5b4b24c9$var$getSeconds(date) {
    const _date = (0, $7yyQt.toDate)(date);
    const seconds = _date.getSeconds();
    return seconds;
}

});

parcelRegister("52BGz", function(module, exports) {

$parcel$export(module.exports, "getTime", () => $3aba5f3d67b9e278$export$1428f42a7de81803, (v) => $3aba5f3d67b9e278$export$1428f42a7de81803 = v);
var $3aba5f3d67b9e278$export$1428f42a7de81803;
"use strict";
$3aba5f3d67b9e278$export$1428f42a7de81803 = $3aba5f3d67b9e278$var$getTime;

var $7yyQt = parcelRequire("7yyQt");
/**
 * @name getTime
 * @category Timestamp Helpers
 * @summary Get the milliseconds timestamp of the given date.
 *
 * @description
 * Get the milliseconds timestamp of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The timestamp
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05.123:
 * const result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 1330515905123
 */ function $3aba5f3d67b9e278$var$getTime(date) {
    const _date = (0, $7yyQt.toDate)(date);
    const timestamp = _date.getTime();
    return timestamp;
}

});

parcelRegister("85ki6", function(module, exports) {

$parcel$export(module.exports, "getYear", () => $5e2e87bef624964f$export$5846dc2d57a5c860, (v) => $5e2e87bef624964f$export$5846dc2d57a5c860 = v);
var $5e2e87bef624964f$export$5846dc2d57a5c860;
"use strict";
$5e2e87bef624964f$export$5846dc2d57a5c860 = $5e2e87bef624964f$var$getYear;

var $7yyQt = parcelRequire("7yyQt");
/**
 * @name getYear
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The year
 *
 * @example
 * // Which year is 2 July 2014?
 * const result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */ function $5e2e87bef624964f$var$getYear(date) {
    return (0, $7yyQt.toDate)(date).getFullYear();
}

});

parcelRegister("7ScgT", function(module, exports) {

$parcel$export(module.exports, "isAfter", () => $5bb7186b6b4fac74$export$e4de839670987035, (v) => $5bb7186b6b4fac74$export$e4de839670987035 = v);
var $5bb7186b6b4fac74$export$e4de839670987035;
"use strict";
$5bb7186b6b4fac74$export$e4de839670987035 = $5bb7186b6b4fac74$var$isAfter;

var $7yyQt = parcelRequire("7yyQt");
/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date that should be after the other one to return true
 * @param dateToCompare - The date to compare with
 *
 * @returns The first date is after the second date
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */ function $5bb7186b6b4fac74$var$isAfter(date, dateToCompare) {
    const _date = (0, $7yyQt.toDate)(date);
    const _dateToCompare = (0, $7yyQt.toDate)(dateToCompare);
    return _date.getTime() > _dateToCompare.getTime();
}

});

parcelRegister("kfiXO", function(module, exports) {

$parcel$export(module.exports, "isBefore", () => $ebd3eb2e72c9062a$export$5c007e10c6929c95, (v) => $ebd3eb2e72c9062a$export$5c007e10c6929c95 = v);
var $ebd3eb2e72c9062a$export$5c007e10c6929c95;
"use strict";
$ebd3eb2e72c9062a$export$5c007e10c6929c95 = $ebd3eb2e72c9062a$var$isBefore;

var $7yyQt = parcelRequire("7yyQt");
/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date that should be before the other one to return true
 * @param dateToCompare - The date to compare with
 *
 * @returns The first date is before the second date
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * const result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */ function $ebd3eb2e72c9062a$var$isBefore(date, dateToCompare) {
    const _date = (0, $7yyQt.toDate)(date);
    const _dateToCompare = (0, $7yyQt.toDate)(dateToCompare);
    return +_date < +_dateToCompare;
}

});

parcelRegister("iQyIl", function(module, exports) {

$parcel$export(module.exports, "isEqual", () => $db8802d7b0b29f2e$export$248d38f6296296c5, (v) => $db8802d7b0b29f2e$export$248d38f6296296c5 = v);
var $db8802d7b0b29f2e$export$248d38f6296296c5;
"use strict";
$db8802d7b0b29f2e$export$248d38f6296296c5 = $db8802d7b0b29f2e$var$isEqual;

var $7yyQt = parcelRequire("7yyQt");
/**
 * @name isEqual
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to compare
 * @param dateRight - The second date to compare
 *
 * @returns The dates are equal
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * const result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0),
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */ function $db8802d7b0b29f2e$var$isEqual(leftDate, rightDate) {
    const _dateLeft = (0, $7yyQt.toDate)(leftDate);
    const _dateRight = (0, $7yyQt.toDate)(rightDate);
    return +_dateLeft === +_dateRight;
}

});

parcelRegister("4IEfZ", function(module, exports) {

$parcel$export(module.exports, "isSameDay", () => $36fa7fa6d6f0ee85$export$ea39ec197993aef0, (v) => $36fa7fa6d6f0ee85$export$ea39ec197993aef0 = v);
var $36fa7fa6d6f0ee85$export$ea39ec197993aef0;
"use strict";
$36fa7fa6d6f0ee85$export$ea39ec197993aef0 = $36fa7fa6d6f0ee85$var$isSameDay;

var $kdTO4 = parcelRequire("kdTO4");
/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check

 * @returns The dates are in the same day (and year and month)
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 *
 * @example
 * // Are 4 September and 4 October in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 *
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */ function $36fa7fa6d6f0ee85$var$isSameDay(dateLeft, dateRight) {
    const dateLeftStartOfDay = (0, $kdTO4.startOfDay)(dateLeft);
    const dateRightStartOfDay = (0, $kdTO4.startOfDay)(dateRight);
    return +dateLeftStartOfDay === +dateRightStartOfDay;
}

});

parcelRegister("1lTi8", function(module, exports) {

$parcel$export(module.exports, "isSameMonth", () => $0fc2a4580773c301$export$a18c89cbd24170ff, (v) => $0fc2a4580773c301$export$a18c89cbd24170ff = v);
var $0fc2a4580773c301$export$a18c89cbd24170ff;
"use strict";
$0fc2a4580773c301$export$a18c89cbd24170ff = $0fc2a4580773c301$var$isSameMonth;

var $7yyQt = parcelRequire("7yyQt");
/**
 * @name isSameMonth
 * @category Month Helpers
 * @summary Are the given dates in the same month (and year)?
 *
 * @description
 * Are the given dates in the same month (and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same month (and year)
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 *
 * @example
 * // Are 2 September 2014 and 25 September 2015 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
 * //=> false
 */ function $0fc2a4580773c301$var$isSameMonth(dateLeft, dateRight) {
    const _dateLeft = (0, $7yyQt.toDate)(dateLeft);
    const _dateRight = (0, $7yyQt.toDate)(dateRight);
    return _dateLeft.getFullYear() === _dateRight.getFullYear() && _dateLeft.getMonth() === _dateRight.getMonth();
}

});

parcelRegister("jiRfE", function(module, exports) {

$parcel$export(module.exports, "isSameQuarter", () => $e0d901694f91a84a$export$5c60e4190867161c, (v) => $e0d901694f91a84a$export$5c60e4190867161c = v);
var $e0d901694f91a84a$export$5c60e4190867161c;
"use strict";
$e0d901694f91a84a$export$5c60e4190867161c = $e0d901694f91a84a$var$isSameQuarter;

var $jMRxa = parcelRequire("jMRxa");
/**
 * @name isSameQuarter
 * @category Quarter Helpers
 * @summary Are the given dates in the same quarter (and year)?
 *
 * @description
 * Are the given dates in the same quarter (and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check

 * @returns The dates are in the same quarter (and year)
 *
 * @example
 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2014, 2, 8))
 * //=> true
 *
 * @example
 * // Are 1 January 2014 and 1 January 2015 in the same quarter?
 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2015, 0, 1))
 * //=> false
 */ function $e0d901694f91a84a$var$isSameQuarter(dateLeft, dateRight) {
    const dateLeftStartOfQuarter = (0, $jMRxa.startOfQuarter)(dateLeft);
    const dateRightStartOfQuarter = (0, $jMRxa.startOfQuarter)(dateRight);
    return +dateLeftStartOfQuarter === +dateRightStartOfQuarter;
}

});
parcelRegister("jMRxa", function(module, exports) {

$parcel$export(module.exports, "startOfQuarter", () => $e67c06c1cc60b504$export$69be7267a042ecb3, (v) => $e67c06c1cc60b504$export$69be7267a042ecb3 = v);
var $e67c06c1cc60b504$export$69be7267a042ecb3;
"use strict";
$e67c06c1cc60b504$export$69be7267a042ecb3 = $e67c06c1cc60b504$var$startOfQuarter;

var $7yyQt = parcelRequire("7yyQt");
/**
 * @name startOfQuarter
 * @category Quarter Helpers
 * @summary Return the start of a year quarter for the given date.
 *
 * @description
 * Return the start of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a quarter
 *
 * @example
 * // The start of a quarter for 2 September 2014 11:55:00:
 * const result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Jul 01 2014 00:00:00
 */ function $e67c06c1cc60b504$var$startOfQuarter(date) {
    const _date = (0, $7yyQt.toDate)(date);
    const currentMonth = _date.getMonth();
    const month = currentMonth - currentMonth % 3;
    _date.setMonth(month, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});


parcelRegister("50Nv4", function(module, exports) {

$parcel$export(module.exports, "isSameYear", () => $3a63598db9da5f1c$export$5841f9eb9773f25f, (v) => $3a63598db9da5f1c$export$5841f9eb9773f25f = v);
var $3a63598db9da5f1c$export$5841f9eb9773f25f;
"use strict";
$3a63598db9da5f1c$export$5841f9eb9773f25f = $3a63598db9da5f1c$var$isSameYear;

var $7yyQt = parcelRequire("7yyQt");
/**
 * @name isSameYear
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same year
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * const result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */ function $3a63598db9da5f1c$var$isSameYear(dateLeft, dateRight) {
    const _dateLeft = (0, $7yyQt.toDate)(dateLeft);
    const _dateRight = (0, $7yyQt.toDate)(dateRight);
    return _dateLeft.getFullYear() === _dateRight.getFullYear();
}

});

parcelRegister("2bLfr", function(module, exports) {

$parcel$export(module.exports, "isWithinInterval", () => $198142539796f4cf$export$d7deef7a3738e19d, (v) => $198142539796f4cf$export$d7deef7a3738e19d = v);
var $198142539796f4cf$export$d7deef7a3738e19d;
"use strict";
$198142539796f4cf$export$d7deef7a3738e19d = $198142539796f4cf$var$isWithinInterval;

var $7yyQt = parcelRequire("7yyQt");
/**
 * @name isWithinInterval
 * @category Interval Helpers
 * @summary Is the given date within the interval?
 *
 * @description
 * Is the given date within the interval? (Including start and end.)
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param interval - The interval to check
 *
 * @returns The date is within the interval
 *
 * @example
 * // For the date within the interval:
 * isWithinInterval(new Date(2014, 0, 3), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> true
 *
 * @example
 * // For the date outside of the interval:
 * isWithinInterval(new Date(2014, 0, 10), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> false
 *
 * @example
 * // For date equal to interval start:
 * isWithinInterval(date, { start, end: date })
 * // => true
 *
 * @example
 * // For date equal to interval end:
 * isWithinInterval(date, { start: date, end })
 * // => true
 */ function $198142539796f4cf$var$isWithinInterval(date, interval) {
    const time = +(0, $7yyQt.toDate)(date);
    const [startTime, endTime] = [
        +(0, $7yyQt.toDate)(interval.start),
        +(0, $7yyQt.toDate)(interval.end)
    ].sort((a, b)=>a - b);
    return time >= startTime && time <= endTime;
}

});

parcelRegister("hI4mr", function(module, exports) {

$parcel$export(module.exports, "max", () => $ce49edb67934ff5b$export$8960430cfd85939f, (v) => $ce49edb67934ff5b$export$8960430cfd85939f = v);
var $ce49edb67934ff5b$export$8960430cfd85939f;
"use strict";
$ce49edb67934ff5b$export$8960430cfd85939f = $ce49edb67934ff5b$var$max;

var $7yyQt = parcelRequire("7yyQt");
/**
 * @name max
 * @category Common Helpers
 * @summary Return the latest of the given dates.
 *
 * @description
 * Return the latest of the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dates - The dates to compare
 *
 * @returns The latest of the dates
 *
 * @example
 * // Which of these dates is the latest?
 * const result = max([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Sun Jul 02 1995 00:00:00
 */ function $ce49edb67934ff5b$var$max(dates) {
    let result;
    dates.forEach(function(dirtyDate) {
        const currentDate = (0, $7yyQt.toDate)(dirtyDate);
        if (result === undefined || result < currentDate || isNaN(Number(currentDate))) result = currentDate;
    });
    return result || new Date(NaN);
}

});

parcelRegister("1yGut", function(module, exports) {

$parcel$export(module.exports, "min", () => $1229ed2d0348bcce$export$96ec731ed4dcb222, (v) => $1229ed2d0348bcce$export$96ec731ed4dcb222 = v);
var $1229ed2d0348bcce$export$96ec731ed4dcb222;
"use strict";
$1229ed2d0348bcce$export$96ec731ed4dcb222 = $1229ed2d0348bcce$var$min;

var $7yyQt = parcelRequire("7yyQt");
/**
 * @name min
 * @category Common Helpers
 * @summary Returns the earliest of the given dates.
 *
 * @description
 * Returns the earliest of the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dates - The dates to compare
 *
 * @returns The earliest of the dates
 *
 * @example
 * // Which of these dates is the earliest?
 * const result = min([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Wed Feb 11 1987 00:00:00
 */ function $1229ed2d0348bcce$var$min(dates) {
    let result;
    dates.forEach((dirtyDate)=>{
        const date = (0, $7yyQt.toDate)(dirtyDate);
        if (!result || result > date || isNaN(+date)) result = date;
    });
    return result || new Date(NaN);
}

});

parcelRegister("hEUsU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "longFormatters", {
    enumerable: true,
    get: function() {
        return $dPmGw.longFormatters;
    }
});
module.exports.parse = $cdb1f8eb83af40fb$var$parse;
Object.defineProperty(module.exports, "parsers", {
    enumerable: true,
    get: function() {
        return $kyQ90.parsers;
    }
});

var $cMvsU = parcelRequire("cMvsU");

var $hZQ2B = parcelRequire("hZQ2B");

var $l7lPu = parcelRequire("l7lPu");

var $7yyQt = parcelRequire("7yyQt");

var $dPmGw = parcelRequire("dPmGw");

var $bWEgL = parcelRequire("bWEgL");

var $kyQ90 = parcelRequire("kyQ90");

var $5F8wQ = parcelRequire("5F8wQ");
// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874
/**
 * The {@link parse} function options.
 */ // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $cdb1f8eb83af40fb$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $cdb1f8eb83af40fb$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $cdb1f8eb83af40fb$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $cdb1f8eb83af40fb$var$doubleQuoteRegExp = /''/g;
const $cdb1f8eb83af40fb$var$notWhitespaceRegExp = /\S/;
const $cdb1f8eb83af40fb$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format string.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * parse('23 AM', 'HH a', new Date())
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `parse` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
 *
 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
 *
 *    while `uu` will just assign the year as is:
 *
 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
 *
 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear](https://date-fns.org/docs/setISOWeekYear)
 *    and [setWeekYear](https://date-fns.org/docs/setWeekYear)).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be assigned to the date in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
 *
 * `referenceDate` must be passed for correct work of the function.
 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateStr - The string to parse
 * @param formatStr - The string of tokens
 * @param referenceDate - defines values missing from the parsed dateString
 * @param options - An object with options.
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @returns The parsed date
 *
 * @throws `options.locale` must contain `match` property
 * @throws use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
 *   locale: eo
 * })
 * //=> Sun Feb 28 2010 00:00:00
 */ function $cdb1f8eb83af40fb$var$parse(dateStr, formatStr, referenceDate, options) {
    const defaultOptions = (0, $hZQ2B.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? $l7lPu.defaultLocale;
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    if (formatStr === "") {
        if (dateStr === "") return (0, $7yyQt.toDate)(referenceDate);
        else return (0, $cMvsU.constructFrom)(referenceDate, NaN);
    }
    const subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    const setters = [
        new $5F8wQ.DateToSystemTimezoneSetter()
    ];
    const tokens = formatStr.match($cdb1f8eb83af40fb$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter in $dPmGw.longFormatters) {
            const longFormatter = $dPmGw.longFormatters[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($cdb1f8eb83af40fb$var$formattingTokensRegExp);
    const usedTokens = [];
    for (let token of tokens){
        if (!options?.useAdditionalWeekYearTokens && (0, $bWEgL.isProtectedWeekYearToken)(token)) (0, $bWEgL.warnOrThrowProtectedError)(token, formatStr, dateStr);
        if (!options?.useAdditionalDayOfYearTokens && (0, $bWEgL.isProtectedDayOfYearToken)(token)) (0, $bWEgL.warnOrThrowProtectedError)(token, formatStr, dateStr);
        const firstCharacter = token[0];
        const parser = $kyQ90.parsers[firstCharacter];
        if (parser) {
            const { incompatibleTokens: incompatibleTokens } = parser;
            if (Array.isArray(incompatibleTokens)) {
                const incompatibleToken = usedTokens.find((usedToken)=>incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter);
                if (incompatibleToken) throw new RangeError(`The format string mustn't contain \`${incompatibleToken.fullToken}\` and \`${token}\` at the same time`);
            } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) throw new RangeError(`The format string mustn't contain \`${token}\` and any other token at the same time`);
            usedTokens.push({
                token: firstCharacter,
                fullToken: token
            });
            const parseResult = parser.run(dateStr, token, locale.match, subFnOptions);
            if (!parseResult) return (0, $cMvsU.constructFrom)(referenceDate, NaN);
            setters.push(parseResult.setter);
            dateStr = parseResult.rest;
        } else {
            if (firstCharacter.match($cdb1f8eb83af40fb$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
            // Replace two single quote characters with one single quote character
            if (token === "''") token = "'";
            else if (firstCharacter === "'") token = $cdb1f8eb83af40fb$var$cleanEscapedString(token);
            // Cut token from string, or, if string doesn't match the token, return Invalid Date
            if (dateStr.indexOf(token) === 0) dateStr = dateStr.slice(token.length);
            else return (0, $cMvsU.constructFrom)(referenceDate, NaN);
        }
    }
    // Check if the remaining input contains something other than whitespace
    if (dateStr.length > 0 && $cdb1f8eb83af40fb$var$notWhitespaceRegExp.test(dateStr)) return (0, $cMvsU.constructFrom)(referenceDate, NaN);
    const uniquePrioritySetters = setters.map((setter)=>setter.priority).sort((a, b)=>b - a).filter((priority, index, array)=>array.indexOf(priority) === index).map((priority)=>setters.filter((setter)=>setter.priority === priority).sort((a, b)=>b.subPriority - a.subPriority)).map((setterArray)=>setterArray[0]);
    let date = (0, $7yyQt.toDate)(referenceDate);
    if (isNaN(date.getTime())) return (0, $cMvsU.constructFrom)(referenceDate, NaN);
    const flags = {};
    for (const setter of uniquePrioritySetters){
        if (!setter.validate(date, subFnOptions)) return (0, $cMvsU.constructFrom)(referenceDate, NaN);
        const result = setter.set(date, flags, subFnOptions);
        // Result is tuple (date, flags)
        if (Array.isArray(result)) {
            date = result[0];
            Object.assign(flags, result[1]);
        // Result is date
        } else date = result;
    }
    return (0, $cMvsU.constructFrom)(referenceDate, date);
}
function $cdb1f8eb83af40fb$var$cleanEscapedString(input) {
    return input.match($cdb1f8eb83af40fb$var$escapedStringRegExp)[1].replace($cdb1f8eb83af40fb$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("hZQ2B", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", () => $d1a080689c5f0d40$export$430a3269e24b912e, (v) => $d1a080689c5f0d40$export$430a3269e24b912e = v);
var $d1a080689c5f0d40$export$430a3269e24b912e;
"use strict";
$d1a080689c5f0d40$export$430a3269e24b912e = $d1a080689c5f0d40$var$getDefaultOptions;

var $aK3iq = parcelRequire("aK3iq");
/**
 * @name getDefaultOptions
 * @category Common Helpers
 * @summary Get default options.
 * @pure false
 *
 * @description
 * Returns an object that contains defaults for
 * `options.locale`, `options.weekStartsOn` and `options.firstWeekContainsDate`
 * arguments for all functions.
 *
 * You can change these with [setDefaultOptions](https://date-fns.org/docs/setDefaultOptions).
 *
 * @returns The default options
 *
 * @example
 * const result = getDefaultOptions()
 * //=> {}
 *
 * @example
 * setDefaultOptions({ weekStarsOn: 1, firstWeekContainsDate: 4 })
 * const result = getDefaultOptions()
 * //=> { weekStarsOn: 1, firstWeekContainsDate: 4 }
 */ function $d1a080689c5f0d40$var$getDefaultOptions() {
    return Object.assign({}, (0, $aK3iq.getDefaultOptions)());
}

});

parcelRegister("kyQ90", function(module, exports) {

$parcel$export(module.exports, "parsers", () => $ef7f6e5e784e4fa2$export$19131010e7fd8373, (v) => $ef7f6e5e784e4fa2$export$19131010e7fd8373 = v);
var $ef7f6e5e784e4fa2$export$19131010e7fd8373;
"use strict";
$ef7f6e5e784e4fa2$export$19131010e7fd8373 = void 0;

var $gYJvl = parcelRequire("gYJvl");

var $lOPt9 = parcelRequire("lOPt9");

var $iuMX8 = parcelRequire("iuMX8");

var $lxRRW = parcelRequire("lxRRW");

var $4VNBj = parcelRequire("4VNBj");

var $d65Ic = parcelRequire("d65Ic");

var $8hfUv = parcelRequire("8hfUv");

var $4v5XY = parcelRequire("4v5XY");

var $5zQDp = parcelRequire("5zQDp");

var $6b0Fv = parcelRequire("6b0Fv");

var $8mlbV = parcelRequire("8mlbV");

var $kkkIm = parcelRequire("kkkIm");

var $77gCq = parcelRequire("77gCq");

var $8WFYu = parcelRequire("8WFYu");

var $kAilI = parcelRequire("kAilI");

var $9pDxV = parcelRequire("9pDxV");

var $lMRin = parcelRequire("lMRin");

var $iVSU6 = parcelRequire("iVSU6");

var $dPgdM = parcelRequire("dPgdM");

var $cvBnR = parcelRequire("cvBnR");

var $5tYXu = parcelRequire("5tYXu");

var $fokkr = parcelRequire("fokkr");

var $2za9d = parcelRequire("2za9d");

var $avR9g = parcelRequire("avR9g");

var $bYQdH = parcelRequire("bYQdH");

var $7bXdY = parcelRequire("7bXdY");

var $aXzb2 = parcelRequire("aXzb2");

var $g3ovD = parcelRequire("g3ovD");

var $45yr2 = parcelRequire("45yr2");

var $h7Gs6 = parcelRequire("h7Gs6");

var $5WTeF = parcelRequire("5WTeF");
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any -- It's ok, we want any here
const $ef7f6e5e784e4fa2$var$parsers = $ef7f6e5e784e4fa2$export$19131010e7fd8373 = {
    G: new $gYJvl.EraParser(),
    y: new $lOPt9.YearParser(),
    Y: new $iuMX8.LocalWeekYearParser(),
    R: new $lxRRW.ISOWeekYearParser(),
    u: new $4VNBj.ExtendedYearParser(),
    Q: new $d65Ic.QuarterParser(),
    q: new $8hfUv.StandAloneQuarterParser(),
    M: new $4v5XY.MonthParser(),
    L: new $5zQDp.StandAloneMonthParser(),
    w: new $6b0Fv.LocalWeekParser(),
    I: new $8mlbV.ISOWeekParser(),
    d: new $kkkIm.DateParser(),
    D: new $77gCq.DayOfYearParser(),
    E: new $8WFYu.DayParser(),
    e: new $kAilI.LocalDayParser(),
    c: new $9pDxV.StandAloneLocalDayParser(),
    i: new $lMRin.ISODayParser(),
    a: new $iVSU6.AMPMParser(),
    b: new $dPgdM.AMPMMidnightParser(),
    B: new $cvBnR.DayPeriodParser(),
    h: new $5tYXu.Hour1to12Parser(),
    H: new $fokkr.Hour0to23Parser(),
    K: new $2za9d.Hour0To11Parser(),
    k: new $avR9g.Hour1To24Parser(),
    m: new $bYQdH.MinuteParser(),
    s: new $7bXdY.SecondParser(),
    S: new $aXzb2.FractionOfSecondParser(),
    X: new $g3ovD.ISOTimezoneWithZParser(),
    x: new $45yr2.ISOTimezoneParser(),
    t: new $h7Gs6.TimestampSecondsParser(),
    T: new $5WTeF.TimestampMillisecondsParser()
};

});
parcelRegister("gYJvl", function(module, exports) {

$parcel$export(module.exports, "EraParser", () => $c5c58c2bcedebbf1$export$8e5a1d3f85a9688, (v) => $c5c58c2bcedebbf1$export$8e5a1d3f85a9688 = v);
var $c5c58c2bcedebbf1$export$8e5a1d3f85a9688;
"use strict";
$c5c58c2bcedebbf1$export$8e5a1d3f85a9688 = void 0;

var $46xuD = parcelRequire("46xuD");
class $c5c58c2bcedebbf1$var$EraParser extends $46xuD.Parser {
    priority = 140;
    parse(dateString, token, match) {
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
            // A, B
            case "GGGGG":
                return match.era(dateString, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return match.era(dateString, {
                    width: "wide"
                }) || match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
        }
    }
    set(date, flags, value) {
        flags.era = value;
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "R",
        "u",
        "t",
        "T"
    ];
}
$c5c58c2bcedebbf1$export$8e5a1d3f85a9688 = $c5c58c2bcedebbf1$var$EraParser;

});
parcelRegister("46xuD", function(module, exports) {

$parcel$export(module.exports, "Parser", () => $2fd1b3fa9f226a10$export$7acfa6ed01010e37, (v) => $2fd1b3fa9f226a10$export$7acfa6ed01010e37 = v);
var $2fd1b3fa9f226a10$export$7acfa6ed01010e37;
"use strict";
$2fd1b3fa9f226a10$export$7acfa6ed01010e37 = void 0;

var $5F8wQ = parcelRequire("5F8wQ");
class $2fd1b3fa9f226a10$var$Parser {
    run(dateString, token, match, options) {
        const result = this.parse(dateString, token, match, options);
        if (!result) return null;
        return {
            setter: new $5F8wQ.ValueSetter(result.value, this.validate, this.set, this.priority, this.subPriority),
            rest: result.rest
        };
    }
    validate(_utcDate, _value, _options) {
        return true;
    }
}
$2fd1b3fa9f226a10$export$7acfa6ed01010e37 = $2fd1b3fa9f226a10$var$Parser;

});
parcelRegister("5F8wQ", function(module, exports) {

$parcel$export(module.exports, "ValueSetter", () => $41f765bb200d544a$export$9a09e32dd4990fd5, (v) => $41f765bb200d544a$export$9a09e32dd4990fd5 = v);
$parcel$export(module.exports, "DateToSystemTimezoneSetter", () => $41f765bb200d544a$export$5aaf7ff7f09ea4ee, (v) => $41f765bb200d544a$export$5aaf7ff7f09ea4ee = v);
var $41f765bb200d544a$export$9a09e32dd4990fd5;
var $41f765bb200d544a$export$81d53e3678089a6;
var $41f765bb200d544a$export$5aaf7ff7f09ea4ee;
"use strict";
$41f765bb200d544a$export$9a09e32dd4990fd5 = $41f765bb200d544a$export$81d53e3678089a6 = $41f765bb200d544a$export$5aaf7ff7f09ea4ee = void 0;

var $gfF2L = parcelRequire("gfF2L");

var $cMvsU = parcelRequire("cMvsU");
const $41f765bb200d544a$var$TIMEZONE_UNIT_PRIORITY = 10;
class $41f765bb200d544a$var$Setter {
    subPriority = 0;
    validate(_utcDate, _options) {
        return true;
    }
}
$41f765bb200d544a$export$81d53e3678089a6 = $41f765bb200d544a$var$Setter;
class $41f765bb200d544a$var$ValueSetter extends $41f765bb200d544a$var$Setter {
    constructor(value, validateValue, setValue, priority, subPriority){
        super();
        this.value = value;
        this.validateValue = validateValue;
        this.setValue = setValue;
        this.priority = priority;
        if (subPriority) this.subPriority = subPriority;
    }
    validate(date, options) {
        return this.validateValue(date, this.value, options);
    }
    set(date, flags, options) {
        return this.setValue(date, flags, this.value, options);
    }
}
$41f765bb200d544a$export$9a09e32dd4990fd5 = $41f765bb200d544a$var$ValueSetter;
class $41f765bb200d544a$var$DateToSystemTimezoneSetter extends $41f765bb200d544a$var$Setter {
    priority = $41f765bb200d544a$var$TIMEZONE_UNIT_PRIORITY;
    subPriority = -1;
    set(date, flags) {
        if (flags.timestampIsSet) return date;
        return (0, $cMvsU.constructFrom)(date, (0, $gfF2L.transpose)(date, Date));
    }
}
$41f765bb200d544a$export$5aaf7ff7f09ea4ee = $41f765bb200d544a$var$DateToSystemTimezoneSetter;

});
parcelRegister("gfF2L", function(module, exports) {

$parcel$export(module.exports, "transpose", () => $bd4de27a1b5e78ee$export$9cb09a71b7d66923, (v) => $bd4de27a1b5e78ee$export$9cb09a71b7d66923 = v);
var $bd4de27a1b5e78ee$export$9cb09a71b7d66923;
"use strict";
$bd4de27a1b5e78ee$export$9cb09a71b7d66923 = $bd4de27a1b5e78ee$var$transpose;

var $cMvsU = parcelRequire("cMvsU");
/**
 * @name transpose
 * @category Generic Helpers
 * @summary Transpose the date to the given constructor.
 *
 * @description
 * The function transposes the date to the given constructor. It helps you
 * to transpose the date in the system time zone to say `UTCDate` or any other
 * date extension.
 *
 * @typeParam DateInputType - The input `Date` type derived from the passed argument.
 * @typeParam DateOutputType - The output `Date` type derived from the passed constructor.
 *
 * @param fromDate - The date to use values from
 * @param constructor - The date constructor to use
 *
 * @returns Date transposed to the given constructor
 *
 * @example
 * // Create July 10, 2022 00:00 in locale time zone
 * const date = new Date(2022, 6, 10)
 * //=> 'Sun Jul 10 2022 00:00:00 GMT+0800 (Singapore Standard Time)'
 *
 * @example
 * // Transpose the date to July 10, 2022 00:00 in UTC
 * transpose(date, UTCDate)
 * //=> 'Sun Jul 10 2022 00:00:00 GMT+0000 (Coordinated Universal Time)'
 */ function $bd4de27a1b5e78ee$var$transpose(fromDate, constructor) {
    const date = constructor instanceof Date ? (0, $cMvsU.constructFrom)(constructor, 0) : new constructor(0);
    date.setFullYear(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate());
    date.setHours(fromDate.getHours(), fromDate.getMinutes(), fromDate.getSeconds(), fromDate.getMilliseconds());
    return date;
}

});




parcelRegister("lOPt9", function(module, exports) {

$parcel$export(module.exports, "YearParser", () => $fe26312ae949d7e7$export$48d352de7cd4a988, (v) => $fe26312ae949d7e7$export$48d352de7cd4a988 = v);
var $fe26312ae949d7e7$export$48d352de7cd4a988;
"use strict";
$fe26312ae949d7e7$export$48d352de7cd4a988 = void 0;

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
// From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
// | Year     |     y | yy |   yyy |  yyyy | yyyyy |
// |----------|-------|----|-------|-------|-------|
// | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
// | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
// | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
// | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
// | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
class $fe26312ae949d7e7$var$YearParser extends $46xuD.Parser {
    priority = 130;
    incompatibleTokens = [
        "Y",
        "R",
        "u",
        "w",
        "I",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year: year,
                isTwoDigitYear: token === "yy"
            });
        switch(token){
            case "y":
                return (0, $d7zOS.mapValue)((0, $d7zOS.parseNDigits)(4, dateString), valueCallback);
            case "yo":
                return (0, $d7zOS.mapValue)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, $d7zOS.mapValue)((0, $d7zOS.parseNDigits)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value) {
        const currentYear = date.getFullYear();
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, $d7zOS.normalizeTwoDigitYear)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, 1);
            date.setHours(0, 0, 0, 0);
            return date;
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
}
$fe26312ae949d7e7$export$48d352de7cd4a988 = $fe26312ae949d7e7$var$YearParser;

});
parcelRegister("d7zOS", function(module, exports) {

$parcel$export(module.exports, "dayPeriodEnumToHours", () => $98d7b6d1a647224d$export$fb506d2676e7f207, (v) => $98d7b6d1a647224d$export$fb506d2676e7f207 = v);
$parcel$export(module.exports, "isLeapYearIndex", () => $98d7b6d1a647224d$export$3d50627710b84d75, (v) => $98d7b6d1a647224d$export$3d50627710b84d75 = v);
$parcel$export(module.exports, "mapValue", () => $98d7b6d1a647224d$export$4f84e3a82c7b538, (v) => $98d7b6d1a647224d$export$4f84e3a82c7b538 = v);
$parcel$export(module.exports, "normalizeTwoDigitYear", () => $98d7b6d1a647224d$export$29126f735cbf69f7, (v) => $98d7b6d1a647224d$export$29126f735cbf69f7 = v);
$parcel$export(module.exports, "parseAnyDigitsSigned", () => $98d7b6d1a647224d$export$d931c43c4608a164, (v) => $98d7b6d1a647224d$export$d931c43c4608a164 = v);
$parcel$export(module.exports, "parseNDigits", () => $98d7b6d1a647224d$export$513bb01536146ab6, (v) => $98d7b6d1a647224d$export$513bb01536146ab6 = v);
$parcel$export(module.exports, "parseNDigitsSigned", () => $98d7b6d1a647224d$export$2c9307b2e29c533c, (v) => $98d7b6d1a647224d$export$2c9307b2e29c533c = v);
$parcel$export(module.exports, "parseNumericPattern", () => $98d7b6d1a647224d$export$cc7cc9e2a3ff9388, (v) => $98d7b6d1a647224d$export$cc7cc9e2a3ff9388 = v);
$parcel$export(module.exports, "parseTimezonePattern", () => $98d7b6d1a647224d$export$6497f4c0ecdfba8e, (v) => $98d7b6d1a647224d$export$6497f4c0ecdfba8e = v);
var $98d7b6d1a647224d$export$fb506d2676e7f207;
var $98d7b6d1a647224d$export$3d50627710b84d75;
var $98d7b6d1a647224d$export$4f84e3a82c7b538;
var $98d7b6d1a647224d$export$29126f735cbf69f7;
var $98d7b6d1a647224d$export$d931c43c4608a164;
var $98d7b6d1a647224d$export$513bb01536146ab6;
var $98d7b6d1a647224d$export$2c9307b2e29c533c;
var $98d7b6d1a647224d$export$cc7cc9e2a3ff9388;
var $98d7b6d1a647224d$export$6497f4c0ecdfba8e;
"use strict";
$98d7b6d1a647224d$export$fb506d2676e7f207 = $98d7b6d1a647224d$var$dayPeriodEnumToHours;
$98d7b6d1a647224d$export$3d50627710b84d75 = $98d7b6d1a647224d$var$isLeapYearIndex;
$98d7b6d1a647224d$export$4f84e3a82c7b538 = $98d7b6d1a647224d$var$mapValue;
$98d7b6d1a647224d$export$29126f735cbf69f7 = $98d7b6d1a647224d$var$normalizeTwoDigitYear;
$98d7b6d1a647224d$export$d931c43c4608a164 = $98d7b6d1a647224d$var$parseAnyDigitsSigned;
$98d7b6d1a647224d$export$513bb01536146ab6 = $98d7b6d1a647224d$var$parseNDigits;
$98d7b6d1a647224d$export$2c9307b2e29c533c = $98d7b6d1a647224d$var$parseNDigitsSigned;
$98d7b6d1a647224d$export$cc7cc9e2a3ff9388 = $98d7b6d1a647224d$var$parseNumericPattern;
$98d7b6d1a647224d$export$6497f4c0ecdfba8e = $98d7b6d1a647224d$var$parseTimezonePattern;

var $9uNOU = parcelRequire("9uNOU");

var $eIicH = parcelRequire("eIicH");
function $98d7b6d1a647224d$var$mapValue(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $98d7b6d1a647224d$var$parseNumericPattern(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $98d7b6d1a647224d$var$parseTimezonePattern(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === "Z") return {
        value: 0,
        rest: dateString.slice(1)
    };
    const sign = matchResult[1] === "+" ? 1 : -1;
    const hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    const minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    const seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * $9uNOU.millisecondsInHour + minutes * $9uNOU.millisecondsInMinute + seconds * $9uNOU.millisecondsInSecond),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $98d7b6d1a647224d$var$parseAnyDigitsSigned(dateString) {
    return $98d7b6d1a647224d$var$parseNumericPattern($eIicH.numericPatterns.anyDigitsSigned, dateString);
}
function $98d7b6d1a647224d$var$parseNDigits(n, dateString) {
    switch(n){
        case 1:
            return $98d7b6d1a647224d$var$parseNumericPattern($eIicH.numericPatterns.singleDigit, dateString);
        case 2:
            return $98d7b6d1a647224d$var$parseNumericPattern($eIicH.numericPatterns.twoDigits, dateString);
        case 3:
            return $98d7b6d1a647224d$var$parseNumericPattern($eIicH.numericPatterns.threeDigits, dateString);
        case 4:
            return $98d7b6d1a647224d$var$parseNumericPattern($eIicH.numericPatterns.fourDigits, dateString);
        default:
            return $98d7b6d1a647224d$var$parseNumericPattern(new RegExp("^\\d{1," + n + "}"), dateString);
    }
}
function $98d7b6d1a647224d$var$parseNDigitsSigned(n, dateString) {
    switch(n){
        case 1:
            return $98d7b6d1a647224d$var$parseNumericPattern($eIicH.numericPatterns.singleDigitSigned, dateString);
        case 2:
            return $98d7b6d1a647224d$var$parseNumericPattern($eIicH.numericPatterns.twoDigitsSigned, dateString);
        case 3:
            return $98d7b6d1a647224d$var$parseNumericPattern($eIicH.numericPatterns.threeDigitsSigned, dateString);
        case 4:
            return $98d7b6d1a647224d$var$parseNumericPattern($eIicH.numericPatterns.fourDigitsSigned, dateString);
        default:
            return $98d7b6d1a647224d$var$parseNumericPattern(new RegExp("^-?\\d{1," + n + "}"), dateString);
    }
}
function $98d7b6d1a647224d$var$dayPeriodEnumToHours(dayPeriod) {
    switch(dayPeriod){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function $98d7b6d1a647224d$var$normalizeTwoDigitYear(twoDigitYear, currentYear) {
    const isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    const absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    let result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        const rangeEnd = absCurrentYear + 50;
        const rangeEndCentury = Math.trunc(rangeEnd / 100) * 100;
        const isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $98d7b6d1a647224d$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

});
parcelRegister("eIicH", function(module, exports) {

$parcel$export(module.exports, "timezonePatterns", () => $ab634ba02f4ef166$export$a7ee192b982af9c1, (v) => $ab634ba02f4ef166$export$a7ee192b982af9c1 = v);
$parcel$export(module.exports, "numericPatterns", () => $ab634ba02f4ef166$export$c123ee06d9da8480, (v) => $ab634ba02f4ef166$export$c123ee06d9da8480 = v);
var $ab634ba02f4ef166$export$a7ee192b982af9c1;
var $ab634ba02f4ef166$export$c123ee06d9da8480;
"use strict";
$ab634ba02f4ef166$export$a7ee192b982af9c1 = $ab634ba02f4ef166$export$c123ee06d9da8480 = void 0;
const $ab634ba02f4ef166$var$numericPatterns = $ab634ba02f4ef166$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    date: /^(3[0-1]|[0-2]?\d)/,
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    week: /^(5[0-3]|[0-4]?\d)/,
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    hour11h: /^(1[0-1]|0?\d)/,
    hour12h: /^(1[0-2]|0?\d)/,
    minute: /^[0-5]?\d/,
    second: /^[0-5]?\d/,
    singleDigit: /^\d/,
    twoDigits: /^\d{1,2}/,
    threeDigits: /^\d{1,3}/,
    fourDigits: /^\d{1,4}/,
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    twoDigitsSigned: /^-?\d{1,2}/,
    threeDigitsSigned: /^-?\d{1,3}/,
    fourDigitsSigned: /^-?\d{1,4}/
};
const $ab634ba02f4ef166$var$timezonePatterns = $ab634ba02f4ef166$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

});



parcelRegister("iuMX8", function(module, exports) {

$parcel$export(module.exports, "LocalWeekYearParser", () => $d771005d0eb7eeef$export$b8ef38dfcf05d5db, (v) => $d771005d0eb7eeef$export$b8ef38dfcf05d5db = v);
var $d771005d0eb7eeef$export$b8ef38dfcf05d5db;
"use strict";
$d771005d0eb7eeef$export$b8ef38dfcf05d5db = void 0;

var $dFij3 = parcelRequire("dFij3");

var $2cZ4R = parcelRequire("2cZ4R");

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
// Local week-numbering year
class $d771005d0eb7eeef$var$LocalWeekYearParser extends $46xuD.Parser {
    priority = 130;
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year: year,
                isTwoDigitYear: token === "YY"
            });
        switch(token){
            case "Y":
                return (0, $d7zOS.mapValue)((0, $d7zOS.parseNDigits)(4, dateString), valueCallback);
            case "Yo":
                return (0, $d7zOS.mapValue)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, $d7zOS.mapValue)((0, $d7zOS.parseNDigits)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value, options) {
        const currentYear = (0, $dFij3.getWeekYear)(date, options);
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, $d7zOS.normalizeTwoDigitYear)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
            date.setHours(0, 0, 0, 0);
            return (0, $2cZ4R.startOfWeek)(date, options);
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, options.firstWeekContainsDate);
        date.setHours(0, 0, 0, 0);
        return (0, $2cZ4R.startOfWeek)(date, options);
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
    ];
}
$d771005d0eb7eeef$export$b8ef38dfcf05d5db = $d771005d0eb7eeef$var$LocalWeekYearParser;

});

parcelRegister("lxRRW", function(module, exports) {

$parcel$export(module.exports, "ISOWeekYearParser", () => $faf6774c01432c8e$export$951d1df011fde06f, (v) => $faf6774c01432c8e$export$951d1df011fde06f = v);
var $faf6774c01432c8e$export$951d1df011fde06f;
"use strict";
$faf6774c01432c8e$export$951d1df011fde06f = void 0;

var $lo97E = parcelRequire("lo97E");

var $cMvsU = parcelRequire("cMvsU");

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
// ISO week-numbering year
class $faf6774c01432c8e$var$ISOWeekYearParser extends $46xuD.Parser {
    priority = 130;
    parse(dateString, token) {
        if (token === "R") return (0, $d7zOS.parseNDigitsSigned)(4, dateString);
        return (0, $d7zOS.parseNDigitsSigned)(token.length, dateString);
    }
    set(date, _flags, value) {
        const firstWeekOfYear = (0, $cMvsU.constructFrom)(date, 0);
        firstWeekOfYear.setFullYear(value, 0, 4);
        firstWeekOfYear.setHours(0, 0, 0, 0);
        return (0, $lo97E.startOfISOWeek)(firstWeekOfYear);
    }
    incompatibleTokens = [
        "G",
        "y",
        "Y",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
    ];
}
$faf6774c01432c8e$export$951d1df011fde06f = $faf6774c01432c8e$var$ISOWeekYearParser;

});

parcelRegister("4VNBj", function(module, exports) {

$parcel$export(module.exports, "ExtendedYearParser", () => $3972f5f650221d84$export$bad9d2ea38e8f1a, (v) => $3972f5f650221d84$export$bad9d2ea38e8f1a = v);
var $3972f5f650221d84$export$bad9d2ea38e8f1a;
"use strict";
$3972f5f650221d84$export$bad9d2ea38e8f1a = void 0;

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
class $3972f5f650221d84$var$ExtendedYearParser extends $46xuD.Parser {
    priority = 130;
    parse(dateString, token) {
        if (token === "u") return (0, $d7zOS.parseNDigitsSigned)(4, dateString);
        return (0, $d7zOS.parseNDigitsSigned)(token.length, dateString);
    }
    set(date, _flags, value) {
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "G",
        "y",
        "Y",
        "R",
        "w",
        "I",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$3972f5f650221d84$export$bad9d2ea38e8f1a = $3972f5f650221d84$var$ExtendedYearParser;

});

parcelRegister("d65Ic", function(module, exports) {

$parcel$export(module.exports, "QuarterParser", () => $98904429aa0b094e$export$5cb0f701186dde1d, (v) => $98904429aa0b094e$export$5cb0f701186dde1d = v);
var $98904429aa0b094e$export$5cb0f701186dde1d;
"use strict";
$98904429aa0b094e$export$5cb0f701186dde1d = void 0;

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
class $98904429aa0b094e$var$QuarterParser extends $46xuD.Parser {
    priority = 120;
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "Q":
            case "QQ":
                return (0, $d7zOS.parseNDigits)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$98904429aa0b094e$export$5cb0f701186dde1d = $98904429aa0b094e$var$QuarterParser;

});

parcelRegister("8hfUv", function(module, exports) {

$parcel$export(module.exports, "StandAloneQuarterParser", () => $606c40b7cb50bbb6$export$300c0c2990e20e6d, (v) => $606c40b7cb50bbb6$export$300c0c2990e20e6d = v);
var $606c40b7cb50bbb6$export$300c0c2990e20e6d;
"use strict";
$606c40b7cb50bbb6$export$300c0c2990e20e6d = void 0;

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
class $606c40b7cb50bbb6$var$StandAloneQuarterParser extends $46xuD.Parser {
    priority = 120;
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "q":
            case "qq":
                return (0, $d7zOS.parseNDigits)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$606c40b7cb50bbb6$export$300c0c2990e20e6d = $606c40b7cb50bbb6$var$StandAloneQuarterParser;

});

parcelRegister("4v5XY", function(module, exports) {

$parcel$export(module.exports, "MonthParser", () => $346eaf77891cc3e0$export$400dd8b40ef138a3, (v) => $346eaf77891cc3e0$export$400dd8b40ef138a3 = v);
var $346eaf77891cc3e0$export$400dd8b40ef138a3;
"use strict";
$346eaf77891cc3e0$export$400dd8b40ef138a3 = void 0;

var $eIicH = parcelRequire("eIicH");

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
class $346eaf77891cc3e0$var$MonthParser extends $46xuD.Parser {
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "L",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
    priority = 110;
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "M":
                return (0, $d7zOS.mapValue)((0, $d7zOS.parseNumericPattern)($eIicH.numericPatterns.month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "MM":
                return (0, $d7zOS.mapValue)((0, $d7zOS.parseNDigits)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return (0, $d7zOS.mapValue)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "MMM":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
}
$346eaf77891cc3e0$export$400dd8b40ef138a3 = $346eaf77891cc3e0$var$MonthParser;

});

parcelRegister("5zQDp", function(module, exports) {

$parcel$export(module.exports, "StandAloneMonthParser", () => $40f90cc8b2f5c9e4$export$1d7eaa53eaa5deba, (v) => $40f90cc8b2f5c9e4$export$1d7eaa53eaa5deba = v);
var $40f90cc8b2f5c9e4$export$1d7eaa53eaa5deba;
"use strict";
$40f90cc8b2f5c9e4$export$1d7eaa53eaa5deba = void 0;

var $eIicH = parcelRequire("eIicH");

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
class $40f90cc8b2f5c9e4$var$StandAloneMonthParser extends $46xuD.Parser {
    priority = 110;
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return (0, $d7zOS.mapValue)((0, $d7zOS.parseNumericPattern)($eIicH.numericPatterns.month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "LL":
                return (0, $d7zOS.mapValue)((0, $d7zOS.parseNDigits)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return (0, $d7zOS.mapValue)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "LLL":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$40f90cc8b2f5c9e4$export$1d7eaa53eaa5deba = $40f90cc8b2f5c9e4$var$StandAloneMonthParser;

});

parcelRegister("6b0Fv", function(module, exports) {

$parcel$export(module.exports, "LocalWeekParser", () => $47f449e66c13a265$export$c4005ffc174e07c0, (v) => $47f449e66c13a265$export$c4005ffc174e07c0 = v);
var $47f449e66c13a265$export$c4005ffc174e07c0;
"use strict";
$47f449e66c13a265$export$c4005ffc174e07c0 = void 0;

var $1hURb = parcelRequire("1hURb");

var $2cZ4R = parcelRequire("2cZ4R");

var $eIicH = parcelRequire("eIicH");

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
// Local week of year
class $47f449e66c13a265$var$LocalWeekParser extends $46xuD.Parser {
    priority = 100;
    parse(dateString, token, match) {
        switch(token){
            case "w":
                return (0, $d7zOS.parseNumericPattern)($eIicH.numericPatterns.week, dateString);
            case "wo":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, $d7zOS.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value, options) {
        return (0, $2cZ4R.startOfWeek)((0, $1hURb.setWeek)(date, value, options), options);
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
    ];
}
$47f449e66c13a265$export$c4005ffc174e07c0 = $47f449e66c13a265$var$LocalWeekParser;

});
parcelRegister("1hURb", function(module, exports) {

$parcel$export(module.exports, "setWeek", () => $0f037b8b4b46fb5c$export$4b3066ce4afafd88, (v) => $0f037b8b4b46fb5c$export$4b3066ce4afafd88 = v);
var $0f037b8b4b46fb5c$export$4b3066ce4afafd88;
"use strict";
$0f037b8b4b46fb5c$export$4b3066ce4afafd88 = $0f037b8b4b46fb5c$var$setWeek;

var $5bAu7 = parcelRequire("5bAu7");

var $7yyQt = parcelRequire("7yyQt");
/**
 * The {@link setWeek} function options.
 */ /**
 * @name setWeek
 * @category Week Helpers
 * @summary Set the local week to the given date.
 *
 * @description
 * Set the local week to the given date, saving the weekday number.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param week - The week of the new date
 * @param options - An object with options
 *
 * @returns The new date with the local week set
 *
 * @example
 * // Set the 1st week to 2 January 2005 with default options:
 * const result = setWeek(new Date(2005, 0, 2), 1)
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // Set the 1st week to 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January:
 * const result = setWeek(new Date(2005, 0, 2), 1, {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Sun Jan 4 2004 00:00:00
 */ function $0f037b8b4b46fb5c$var$setWeek(date, week, options) {
    const _date = (0, $7yyQt.toDate)(date);
    const diff = (0, $5bAu7.getWeek)(_date, options) - week;
    _date.setDate(_date.getDate() - diff * 7);
    return _date;
}

});


parcelRegister("8mlbV", function(module, exports) {

$parcel$export(module.exports, "ISOWeekParser", () => $6160d0faa8efda89$export$6fc8dbedd560a6af, (v) => $6160d0faa8efda89$export$6fc8dbedd560a6af = v);
var $6160d0faa8efda89$export$6fc8dbedd560a6af;
"use strict";
$6160d0faa8efda89$export$6fc8dbedd560a6af = void 0;

var $9JXfi = parcelRequire("9JXfi");

var $lo97E = parcelRequire("lo97E");

var $eIicH = parcelRequire("eIicH");

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
// ISO week of year
class $6160d0faa8efda89$var$ISOWeekParser extends $46xuD.Parser {
    priority = 100;
    parse(dateString, token, match) {
        switch(token){
            case "I":
                return (0, $d7zOS.parseNumericPattern)($eIicH.numericPatterns.week, dateString);
            case "Io":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, $d7zOS.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value) {
        return (0, $lo97E.startOfISOWeek)((0, $9JXfi.setISOWeek)(date, value));
    }
    incompatibleTokens = [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
    ];
}
$6160d0faa8efda89$export$6fc8dbedd560a6af = $6160d0faa8efda89$var$ISOWeekParser;

});
parcelRegister("9JXfi", function(module, exports) {

$parcel$export(module.exports, "setISOWeek", () => $7176460089065355$export$6542bebf6be94082, (v) => $7176460089065355$export$6542bebf6be94082 = v);
var $7176460089065355$export$6542bebf6be94082;
"use strict";
$7176460089065355$export$6542bebf6be94082 = $7176460089065355$var$setISOWeek;

var $h6qsS = parcelRequire("h6qsS");

var $7yyQt = parcelRequire("7yyQt");
/**
 * @name setISOWeek
 * @category ISO Week Helpers
 * @summary Set the ISO week to the given date.
 *
 * @description
 * Set the ISO week to the given date, saving the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param week - The ISO week of the new date
 *
 * @returns The new date with the ISO week set
 *
 * @example
 * // Set the 53rd ISO week to 7 August 2004:
 * const result = setISOWeek(new Date(2004, 7, 7), 53)
 * //=> Sat Jan 01 2005 00:00:00
 */ function $7176460089065355$var$setISOWeek(date, week) {
    const _date = (0, $7yyQt.toDate)(date);
    const diff = (0, $h6qsS.getISOWeek)(_date) - week;
    _date.setDate(_date.getDate() - diff * 7);
    return _date;
}

});


parcelRegister("kkkIm", function(module, exports) {

$parcel$export(module.exports, "DateParser", () => $ecc5be5b264591cb$export$e8d4b28a20981dd2, (v) => $ecc5be5b264591cb$export$e8d4b28a20981dd2 = v);
var $ecc5be5b264591cb$export$e8d4b28a20981dd2;
"use strict";
$ecc5be5b264591cb$export$e8d4b28a20981dd2 = void 0;

var $eIicH = parcelRequire("eIicH");

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
const $ecc5be5b264591cb$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
const $ecc5be5b264591cb$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
// Day of the month
class $ecc5be5b264591cb$var$DateParser extends $46xuD.Parser {
    priority = 90;
    subPriority = 1;
    parse(dateString, token, match) {
        switch(token){
            case "d":
                return (0, $d7zOS.parseNumericPattern)($eIicH.numericPatterns.date, dateString);
            case "do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, $d7zOS.parseNDigits)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, $d7zOS.isLeapYearIndex)(year);
        const month = date.getMonth();
        if (isLeapYear) return value >= 1 && value <= $ecc5be5b264591cb$var$DAYS_IN_MONTH_LEAP_YEAR[month];
        else return value >= 1 && value <= $ecc5be5b264591cb$var$DAYS_IN_MONTH[month];
    }
    set(date, _flags, value) {
        date.setDate(value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$ecc5be5b264591cb$export$e8d4b28a20981dd2 = $ecc5be5b264591cb$var$DateParser;

});

parcelRegister("77gCq", function(module, exports) {

$parcel$export(module.exports, "DayOfYearParser", () => $52e613ff70efeac9$export$6cfe0d613455f615, (v) => $52e613ff70efeac9$export$6cfe0d613455f615 = v);
var $52e613ff70efeac9$export$6cfe0d613455f615;
"use strict";
$52e613ff70efeac9$export$6cfe0d613455f615 = void 0;

var $eIicH = parcelRequire("eIicH");

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
class $52e613ff70efeac9$var$DayOfYearParser extends $46xuD.Parser {
    priority = 90;
    subpriority = 1;
    parse(dateString, token, match) {
        switch(token){
            case "D":
            case "DD":
                return (0, $d7zOS.parseNumericPattern)($eIicH.numericPatterns.dayOfYear, dateString);
            case "Do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, $d7zOS.parseNDigits)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, $d7zOS.isLeapYearIndex)(year);
        if (isLeapYear) return value >= 1 && value <= 366;
        else return value >= 1 && value <= 365;
    }
    set(date, _flags, value) {
        date.setMonth(0, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "E",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$52e613ff70efeac9$export$6cfe0d613455f615 = $52e613ff70efeac9$var$DayOfYearParser;

});

parcelRegister("8WFYu", function(module, exports) {

$parcel$export(module.exports, "DayParser", () => $68344ccfc1ac5f7d$export$1b03c8b76262f7bd, (v) => $68344ccfc1ac5f7d$export$1b03c8b76262f7bd = v);
var $68344ccfc1ac5f7d$export$1b03c8b76262f7bd;
"use strict";
$68344ccfc1ac5f7d$export$1b03c8b76262f7bd = void 0;

var $fi8ek = parcelRequire("fi8ek");

var $46xuD = parcelRequire("46xuD");
// Day of week
class $68344ccfc1ac5f7d$var$DayParser extends $46xuD.Parser {
    priority = 90;
    parse(dateString, token, match) {
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $fi8ek.setDay)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$68344ccfc1ac5f7d$export$1b03c8b76262f7bd = $68344ccfc1ac5f7d$var$DayParser;

});
parcelRegister("fi8ek", function(module, exports) {

$parcel$export(module.exports, "setDay", () => $b21eebce3582ac56$export$b04fdcda82decc6c, (v) => $b21eebce3582ac56$export$b04fdcda82decc6c = v);
var $b21eebce3582ac56$export$b04fdcda82decc6c;
"use strict";
$b21eebce3582ac56$export$b04fdcda82decc6c = $b21eebce3582ac56$var$setDay;

var $l4b73 = parcelRequire("l4b73");

var $7yyQt = parcelRequire("7yyQt");

var $aK3iq = parcelRequire("aK3iq");
/**
 * The {@link setDay} function options.
 */ /**
 * @name setDay
 * @category Weekday Helpers
 * @summary Set the day of the week to the given date.
 *
 * @description
 * Set the day of the week to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param day - The day of the week of the new date
 * @param options - An object with options.
 *
 * @returns The new date with the day of the week set
 *
 * @example
 * // Set week day to Sunday, with the default weekStartsOn of Sunday:
 * const result = setDay(new Date(2014, 8, 1), 0)
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Set week day to Sunday, with a weekStartsOn of Monday:
 * const result = setDay(new Date(2014, 8, 1), 0, { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 00:00:00
 */ function $b21eebce3582ac56$var$setDay(date, day, options) {
    const defaultOptions = (0, $aK3iq.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $7yyQt.toDate)(date);
    const currentDay = _date.getDay();
    const remainder = day % 7;
    const dayIndex = (remainder + 7) % 7;
    const delta = 7 - weekStartsOn;
    const diff = day < 0 || day > 6 ? day - (currentDay + delta) % 7 : (dayIndex + delta) % 7 - (currentDay + delta) % 7;
    return (0, $l4b73.addDays)(_date, diff);
}

});


parcelRegister("kAilI", function(module, exports) {

$parcel$export(module.exports, "LocalDayParser", () => $efc5673231dedfdd$export$44d1c127ab42c480, (v) => $efc5673231dedfdd$export$44d1c127ab42c480 = v);
var $efc5673231dedfdd$export$44d1c127ab42c480;
"use strict";
$efc5673231dedfdd$export$44d1c127ab42c480 = void 0;

var $fi8ek = parcelRequire("fi8ek");

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
// Local day of week
class $efc5673231dedfdd$var$LocalDayParser extends $46xuD.Parser {
    priority = 90;
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "e":
            case "ee":
                return (0, $d7zOS.mapValue)((0, $d7zOS.parseNDigits)(token.length, dateString), valueCallback);
            // 3rd
            case "eo":
                return (0, $d7zOS.mapValue)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "eee":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $fi8ek.setDay)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "c",
        "t",
        "T"
    ];
}
$efc5673231dedfdd$export$44d1c127ab42c480 = $efc5673231dedfdd$var$LocalDayParser;

});

parcelRegister("9pDxV", function(module, exports) {

$parcel$export(module.exports, "StandAloneLocalDayParser", () => $6da51fe9d8b20690$export$e447a647caaaec1d, (v) => $6da51fe9d8b20690$export$e447a647caaaec1d = v);
var $6da51fe9d8b20690$export$e447a647caaaec1d;
"use strict";
$6da51fe9d8b20690$export$e447a647caaaec1d = void 0;

var $fi8ek = parcelRequire("fi8ek");

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
// Stand-alone local day of week
class $6da51fe9d8b20690$var$StandAloneLocalDayParser extends $46xuD.Parser {
    priority = 90;
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "c":
            case "cc":
                return (0, $d7zOS.mapValue)((0, $d7zOS.parseNDigits)(token.length, dateString), valueCallback);
            // 3rd
            case "co":
                return (0, $d7zOS.mapValue)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "ccc":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $fi8ek.setDay)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "e",
        "t",
        "T"
    ];
}
$6da51fe9d8b20690$export$e447a647caaaec1d = $6da51fe9d8b20690$var$StandAloneLocalDayParser;

});

parcelRegister("lMRin", function(module, exports) {

$parcel$export(module.exports, "ISODayParser", () => $fdc76c097f6cd68b$export$693fb1e525095b2a, (v) => $fdc76c097f6cd68b$export$693fb1e525095b2a = v);
var $fdc76c097f6cd68b$export$693fb1e525095b2a;
"use strict";
$fdc76c097f6cd68b$export$693fb1e525095b2a = void 0;

var $dc6tA = parcelRequire("dc6tA");

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
// ISO day of week
class $fdc76c097f6cd68b$var$ISODayParser extends $46xuD.Parser {
    priority = 90;
    parse(dateString, token, match) {
        const valueCallback = (value)=>{
            if (value === 0) return 7;
            return value;
        };
        switch(token){
            // 2
            case "i":
            case "ii":
                return (0, $d7zOS.parseNDigits)(token.length, dateString);
            // 2nd
            case "io":
                return match.ordinalNumber(dateString, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return (0, $d7zOS.mapValue)(match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // T
            case "iiiii":
                return (0, $d7zOS.mapValue)(match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tu
            case "iiiiii":
                return (0, $d7zOS.mapValue)(match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tuesday
            case "iiii":
            default:
                return (0, $d7zOS.mapValue)(match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 7;
    }
    set(date, _flags, value) {
        date = (0, $dc6tA.setISODay)(date, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "E",
        "e",
        "c",
        "t",
        "T"
    ];
}
$fdc76c097f6cd68b$export$693fb1e525095b2a = $fdc76c097f6cd68b$var$ISODayParser;

});
parcelRegister("dc6tA", function(module, exports) {

$parcel$export(module.exports, "setISODay", () => $99b16b62472d13b2$export$1fd9df65adb0d1aa, (v) => $99b16b62472d13b2$export$1fd9df65adb0d1aa = v);
var $99b16b62472d13b2$export$1fd9df65adb0d1aa;
"use strict";
$99b16b62472d13b2$export$1fd9df65adb0d1aa = $99b16b62472d13b2$var$setISODay;

var $l4b73 = parcelRequire("l4b73");

var $1Ki1g = parcelRequire("1Ki1g");

var $7yyQt = parcelRequire("7yyQt");
/**
 * @name setISODay
 * @category Weekday Helpers
 * @summary Set the day of the ISO week to the given date.
 *
 * @description
 * Set the day of the ISO week to the given date.
 * ISO week starts with Monday.
 * 7 is the index of Sunday, 1 is the index of Monday etc.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param day - The day of the ISO week of the new date
 *
 * @returns The new date with the day of the ISO week set
 *
 * @example
 * // Set Sunday to 1 September 2014:
 * const result = setISODay(new Date(2014, 8, 1), 7)
 * //=> Sun Sep 07 2014 00:00:00
 */ function $99b16b62472d13b2$var$setISODay(date, day) {
    const _date = (0, $7yyQt.toDate)(date);
    const currentDay = (0, $1Ki1g.getISODay)(_date);
    const diff = day - currentDay;
    return (0, $l4b73.addDays)(_date, diff);
}

});
parcelRegister("1Ki1g", function(module, exports) {

$parcel$export(module.exports, "getISODay", () => $14581097cfa3b846$export$c514f4c1a8ed5e9e, (v) => $14581097cfa3b846$export$c514f4c1a8ed5e9e = v);
var $14581097cfa3b846$export$c514f4c1a8ed5e9e;
"use strict";
$14581097cfa3b846$export$c514f4c1a8ed5e9e = $14581097cfa3b846$var$getISODay;

var $7yyQt = parcelRequire("7yyQt");
/**
 * @name getISODay
 * @category Weekday Helpers
 * @summary Get the day of the ISO week of the given date.
 *
 * @description
 * Get the day of the ISO week of the given date,
 * which is 7 for Sunday, 1 for Monday etc.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of ISO week
 *
 * @example
 * // Which day of the ISO week is 26 February 2012?
 * const result = getISODay(new Date(2012, 1, 26))
 * //=> 7
 */ function $14581097cfa3b846$var$getISODay(date) {
    const _date = (0, $7yyQt.toDate)(date);
    let day = _date.getDay();
    if (day === 0) day = 7;
    return day;
}

});



parcelRegister("iVSU6", function(module, exports) {

$parcel$export(module.exports, "AMPMParser", () => $dc88239c6feac6f3$export$8d1e08492351df91, (v) => $dc88239c6feac6f3$export$8d1e08492351df91 = v);
var $dc88239c6feac6f3$export$8d1e08492351df91;
"use strict";
$dc88239c6feac6f3$export$8d1e08492351df91 = void 0;

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
class $dc88239c6feac6f3$var$AMPMParser extends $46xuD.Parser {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "a":
            case "aa":
            case "aaa":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaaa":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $d7zOS.dayPeriodEnumToHours)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "b",
        "B",
        "H",
        "k",
        "t",
        "T"
    ];
}
$dc88239c6feac6f3$export$8d1e08492351df91 = $dc88239c6feac6f3$var$AMPMParser;

});

parcelRegister("dPgdM", function(module, exports) {

$parcel$export(module.exports, "AMPMMidnightParser", () => $a10c9f024d5ae86e$export$73ca2bd0a17d273, (v) => $a10c9f024d5ae86e$export$73ca2bd0a17d273 = v);
var $a10c9f024d5ae86e$export$73ca2bd0a17d273;
"use strict";
$a10c9f024d5ae86e$export$73ca2bd0a17d273 = void 0;

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
class $a10c9f024d5ae86e$var$AMPMMidnightParser extends $46xuD.Parser {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "b":
            case "bb":
            case "bbb":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbbb":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $d7zOS.dayPeriodEnumToHours)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "B",
        "H",
        "k",
        "t",
        "T"
    ];
}
$a10c9f024d5ae86e$export$73ca2bd0a17d273 = $a10c9f024d5ae86e$var$AMPMMidnightParser;

});

parcelRegister("cvBnR", function(module, exports) {

$parcel$export(module.exports, "DayPeriodParser", () => $91b560efdd3bae18$export$bb9212adf05373db, (v) => $91b560efdd3bae18$export$bb9212adf05373db = v);
var $91b560efdd3bae18$export$bb9212adf05373db;
"use strict";
$91b560efdd3bae18$export$bb9212adf05373db = void 0;

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
// in the morning, in the afternoon, in the evening, at night
class $91b560efdd3bae18$var$DayPeriodParser extends $46xuD.Parser {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBBB":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $d7zOS.dayPeriodEnumToHours)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "t",
        "T"
    ];
}
$91b560efdd3bae18$export$bb9212adf05373db = $91b560efdd3bae18$var$DayPeriodParser;

});

parcelRegister("5tYXu", function(module, exports) {

$parcel$export(module.exports, "Hour1to12Parser", () => $3fdef242ab121039$export$8a04050a727a1756, (v) => $3fdef242ab121039$export$8a04050a727a1756 = v);
var $3fdef242ab121039$export$8a04050a727a1756;
"use strict";
$3fdef242ab121039$export$8a04050a727a1756 = void 0;

var $eIicH = parcelRequire("eIicH");

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
class $3fdef242ab121039$var$Hour1to12Parser extends $46xuD.Parser {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "h":
                return (0, $d7zOS.parseNumericPattern)($eIicH.numericPatterns.hour12h, dateString);
            case "ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $d7zOS.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 12;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else if (!isPM && value === 12) date.setHours(0, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "H",
        "K",
        "k",
        "t",
        "T"
    ];
}
$3fdef242ab121039$export$8a04050a727a1756 = $3fdef242ab121039$var$Hour1to12Parser;

});

parcelRegister("fokkr", function(module, exports) {

$parcel$export(module.exports, "Hour0to23Parser", () => $b348ddc307375f53$export$e56f4dea2c3e56dd, (v) => $b348ddc307375f53$export$e56f4dea2c3e56dd = v);
var $b348ddc307375f53$export$e56f4dea2c3e56dd;
"use strict";
$b348ddc307375f53$export$e56f4dea2c3e56dd = void 0;

var $eIicH = parcelRequire("eIicH");

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
class $b348ddc307375f53$var$Hour0to23Parser extends $46xuD.Parser {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "H":
                return (0, $d7zOS.parseNumericPattern)($eIicH.numericPatterns.hour23h, dateString);
            case "Ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $d7zOS.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 23;
    }
    set(date, _flags, value) {
        date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "h",
        "K",
        "k",
        "t",
        "T"
    ];
}
$b348ddc307375f53$export$e56f4dea2c3e56dd = $b348ddc307375f53$var$Hour0to23Parser;

});

parcelRegister("2za9d", function(module, exports) {

$parcel$export(module.exports, "Hour0To11Parser", () => $1de6b8c9767b7cf2$export$cbbe855312f87d77, (v) => $1de6b8c9767b7cf2$export$cbbe855312f87d77 = v);
var $1de6b8c9767b7cf2$export$cbbe855312f87d77;
"use strict";
$1de6b8c9767b7cf2$export$cbbe855312f87d77 = void 0;

var $eIicH = parcelRequire("eIicH");

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
class $1de6b8c9767b7cf2$var$Hour0To11Parser extends $46xuD.Parser {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "K":
                return (0, $d7zOS.parseNumericPattern)($eIicH.numericPatterns.hour11h, dateString);
            case "Ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $d7zOS.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "h",
        "H",
        "k",
        "t",
        "T"
    ];
}
$1de6b8c9767b7cf2$export$cbbe855312f87d77 = $1de6b8c9767b7cf2$var$Hour0To11Parser;

});

parcelRegister("avR9g", function(module, exports) {

$parcel$export(module.exports, "Hour1To24Parser", () => $7a7606d1d349befa$export$6008046d2b34b6a5, (v) => $7a7606d1d349befa$export$6008046d2b34b6a5 = v);
var $7a7606d1d349befa$export$6008046d2b34b6a5;
"use strict";
$7a7606d1d349befa$export$6008046d2b34b6a5 = void 0;

var $eIicH = parcelRequire("eIicH");

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
class $7a7606d1d349befa$var$Hour1To24Parser extends $46xuD.Parser {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "k":
                return (0, $d7zOS.parseNumericPattern)($eIicH.numericPatterns.hour24h, dateString);
            case "ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $d7zOS.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 24;
    }
    set(date, _flags, value) {
        const hours = value <= 24 ? value % 24 : value;
        date.setHours(hours, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "h",
        "H",
        "K",
        "t",
        "T"
    ];
}
$7a7606d1d349befa$export$6008046d2b34b6a5 = $7a7606d1d349befa$var$Hour1To24Parser;

});

parcelRegister("bYQdH", function(module, exports) {

$parcel$export(module.exports, "MinuteParser", () => $8b8dce150b01caf0$export$2b52670d9e2be53, (v) => $8b8dce150b01caf0$export$2b52670d9e2be53 = v);
var $8b8dce150b01caf0$export$2b52670d9e2be53;
"use strict";
$8b8dce150b01caf0$export$2b52670d9e2be53 = void 0;

var $eIicH = parcelRequire("eIicH");

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
class $8b8dce150b01caf0$var$MinuteParser extends $46xuD.Parser {
    priority = 60;
    parse(dateString, token, match) {
        switch(token){
            case "m":
                return (0, $d7zOS.parseNumericPattern)($eIicH.numericPatterns.minute, dateString);
            case "mo":
                return match.ordinalNumber(dateString, {
                    unit: "minute"
                });
            default:
                return (0, $d7zOS.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setMinutes(value, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}
$8b8dce150b01caf0$export$2b52670d9e2be53 = $8b8dce150b01caf0$var$MinuteParser;

});

parcelRegister("7bXdY", function(module, exports) {

$parcel$export(module.exports, "SecondParser", () => $53c7803a7379f0da$export$94d46d540cf1366a, (v) => $53c7803a7379f0da$export$94d46d540cf1366a = v);
var $53c7803a7379f0da$export$94d46d540cf1366a;
"use strict";
$53c7803a7379f0da$export$94d46d540cf1366a = void 0;

var $eIicH = parcelRequire("eIicH");

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
class $53c7803a7379f0da$var$SecondParser extends $46xuD.Parser {
    priority = 50;
    parse(dateString, token, match) {
        switch(token){
            case "s":
                return (0, $d7zOS.parseNumericPattern)($eIicH.numericPatterns.second, dateString);
            case "so":
                return match.ordinalNumber(dateString, {
                    unit: "second"
                });
            default:
                return (0, $d7zOS.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setSeconds(value, 0);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}
$53c7803a7379f0da$export$94d46d540cf1366a = $53c7803a7379f0da$var$SecondParser;

});

parcelRegister("aXzb2", function(module, exports) {

$parcel$export(module.exports, "FractionOfSecondParser", () => $7faab384a61dd982$export$b8e6f8b2d70893b1, (v) => $7faab384a61dd982$export$b8e6f8b2d70893b1 = v);
var $7faab384a61dd982$export$b8e6f8b2d70893b1;
"use strict";
$7faab384a61dd982$export$b8e6f8b2d70893b1 = void 0;

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
class $7faab384a61dd982$var$FractionOfSecondParser extends $46xuD.Parser {
    priority = 30;
    parse(dateString, token) {
        const valueCallback = (value)=>Math.trunc(value * Math.pow(10, -token.length + 3));
        return (0, $d7zOS.mapValue)((0, $d7zOS.parseNDigits)(token.length, dateString), valueCallback);
    }
    set(date, _flags, value) {
        date.setMilliseconds(value);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}
$7faab384a61dd982$export$b8e6f8b2d70893b1 = $7faab384a61dd982$var$FractionOfSecondParser;

});

parcelRegister("g3ovD", function(module, exports) {

$parcel$export(module.exports, "ISOTimezoneWithZParser", () => $bafff02f6dd76726$export$104d901d49fea29b, (v) => $bafff02f6dd76726$export$104d901d49fea29b = v);
var $bafff02f6dd76726$export$104d901d49fea29b;
"use strict";
$bafff02f6dd76726$export$104d901d49fea29b = void 0;

var $cMvsU = parcelRequire("cMvsU");

var $gr9Oc = parcelRequire("gr9Oc");

var $eIicH = parcelRequire("eIicH");

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
// Timezone (ISO-8601. +00:00 is `'Z'`)
class $bafff02f6dd76726$var$ISOTimezoneWithZParser extends $46xuD.Parser {
    priority = 10;
    parse(dateString, token) {
        switch(token){
            case "X":
                return (0, $d7zOS.parseTimezonePattern)($eIicH.timezonePatterns.basicOptionalMinutes, dateString);
            case "XX":
                return (0, $d7zOS.parseTimezonePattern)($eIicH.timezonePatterns.basic, dateString);
            case "XXXX":
                return (0, $d7zOS.parseTimezonePattern)($eIicH.timezonePatterns.basicOptionalSeconds, dateString);
            case "XXXXX":
                return (0, $d7zOS.parseTimezonePattern)($eIicH.timezonePatterns.extendedOptionalSeconds, dateString);
            case "XXX":
            default:
                return (0, $d7zOS.parseTimezonePattern)($eIicH.timezonePatterns.extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, $cMvsU.constructFrom)(date, date.getTime() - (0, $gr9Oc.getTimezoneOffsetInMilliseconds)(date) - value);
    }
    incompatibleTokens = [
        "t",
        "T",
        "x"
    ];
}
$bafff02f6dd76726$export$104d901d49fea29b = $bafff02f6dd76726$var$ISOTimezoneWithZParser;

});

parcelRegister("45yr2", function(module, exports) {

$parcel$export(module.exports, "ISOTimezoneParser", () => $2fa25724cac045ce$export$12910e5204b52b9, (v) => $2fa25724cac045ce$export$12910e5204b52b9 = v);
var $2fa25724cac045ce$export$12910e5204b52b9;
"use strict";
$2fa25724cac045ce$export$12910e5204b52b9 = void 0;

var $cMvsU = parcelRequire("cMvsU");

var $gr9Oc = parcelRequire("gr9Oc");

var $eIicH = parcelRequire("eIicH");

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
// Timezone (ISO-8601)
class $2fa25724cac045ce$var$ISOTimezoneParser extends $46xuD.Parser {
    priority = 10;
    parse(dateString, token) {
        switch(token){
            case "x":
                return (0, $d7zOS.parseTimezonePattern)($eIicH.timezonePatterns.basicOptionalMinutes, dateString);
            case "xx":
                return (0, $d7zOS.parseTimezonePattern)($eIicH.timezonePatterns.basic, dateString);
            case "xxxx":
                return (0, $d7zOS.parseTimezonePattern)($eIicH.timezonePatterns.basicOptionalSeconds, dateString);
            case "xxxxx":
                return (0, $d7zOS.parseTimezonePattern)($eIicH.timezonePatterns.extendedOptionalSeconds, dateString);
            case "xxx":
            default:
                return (0, $d7zOS.parseTimezonePattern)($eIicH.timezonePatterns.extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, $cMvsU.constructFrom)(date, date.getTime() - (0, $gr9Oc.getTimezoneOffsetInMilliseconds)(date) - value);
    }
    incompatibleTokens = [
        "t",
        "T",
        "X"
    ];
}
$2fa25724cac045ce$export$12910e5204b52b9 = $2fa25724cac045ce$var$ISOTimezoneParser;

});

parcelRegister("h7Gs6", function(module, exports) {

$parcel$export(module.exports, "TimestampSecondsParser", () => $03378c78aec26a94$export$2cd8bf877a05e96, (v) => $03378c78aec26a94$export$2cd8bf877a05e96 = v);
var $03378c78aec26a94$export$2cd8bf877a05e96;
"use strict";
$03378c78aec26a94$export$2cd8bf877a05e96 = void 0;

var $cMvsU = parcelRequire("cMvsU");

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
class $03378c78aec26a94$var$TimestampSecondsParser extends $46xuD.Parser {
    priority = 40;
    parse(dateString) {
        return (0, $d7zOS.parseAnyDigitsSigned)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, $cMvsU.constructFrom)(date, value * 1000),
            {
                timestampIsSet: true
            }
        ];
    }
    incompatibleTokens = "*";
}
$03378c78aec26a94$export$2cd8bf877a05e96 = $03378c78aec26a94$var$TimestampSecondsParser;

});

parcelRegister("5WTeF", function(module, exports) {

$parcel$export(module.exports, "TimestampMillisecondsParser", () => $454d372c89c9485d$export$6d8f69c6906d6368, (v) => $454d372c89c9485d$export$6d8f69c6906d6368 = v);
var $454d372c89c9485d$export$6d8f69c6906d6368;
"use strict";
$454d372c89c9485d$export$6d8f69c6906d6368 = void 0;

var $cMvsU = parcelRequire("cMvsU");

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
class $454d372c89c9485d$var$TimestampMillisecondsParser extends $46xuD.Parser {
    priority = 20;
    parse(dateString) {
        return (0, $d7zOS.parseAnyDigitsSigned)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, $cMvsU.constructFrom)(date, value),
            {
                timestampIsSet: true
            }
        ];
    }
    incompatibleTokens = "*";
}
$454d372c89c9485d$export$6d8f69c6906d6368 = $454d372c89c9485d$var$TimestampMillisecondsParser;

});



parcelRegister("aNBww", function(module, exports) {

$parcel$export(module.exports, "parseISO", () => $7dcb966690c372e6$export$4393d2ccbbedb219, (v) => $7dcb966690c372e6$export$4393d2ccbbedb219 = v);
var $7dcb966690c372e6$export$4393d2ccbbedb219;
"use strict";
$7dcb966690c372e6$export$4393d2ccbbedb219 = $7dcb966690c372e6$var$parseISO;

var $9uNOU = parcelRequire("9uNOU");
/**
 * The {@link parseISO} function options.
 */ /**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 * @param options - An object with options
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * const result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * const result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */ function $7dcb966690c372e6$var$parseISO(argument, options) {
    const additionalDigits = options?.additionalDigits ?? 2;
    const dateStrings = $7dcb966690c372e6$var$splitDateString(argument);
    let date;
    if (dateStrings.date) {
        const parseYearResult = $7dcb966690c372e6$var$parseYear(dateStrings.date, additionalDigits);
        date = $7dcb966690c372e6$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    const timestamp = date.getTime();
    let time = 0;
    let offset;
    if (dateStrings.time) {
        time = $7dcb966690c372e6$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $7dcb966690c372e6$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        const dirtyDate = new Date(timestamp + time);
        // JS parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        const result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
const $7dcb966690c372e6$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
const $7dcb966690c372e6$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
const $7dcb966690c372e6$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
const $7dcb966690c372e6$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $7dcb966690c372e6$var$splitDateString(dateString) {
    const dateStrings = {};
    const array = dateString.split($7dcb966690c372e6$var$patterns.dateTimeDelimiter);
    let timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($7dcb966690c372e6$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($7dcb966690c372e6$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        const token = $7dcb966690c372e6$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], "");
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $7dcb966690c372e6$var$parseYear(dateString, additionalDigits) {
    const regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
    const captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ""
    };
    const year = captures[1] ? parseInt(captures[1]) : null;
    const century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $7dcb966690c372e6$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    const captures = dateString.match($7dcb966690c372e6$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    const isWeekDate = !!captures[4];
    const dayOfYear = $7dcb966690c372e6$var$parseDateUnit(captures[1]);
    const month = $7dcb966690c372e6$var$parseDateUnit(captures[2]) - 1;
    const day = $7dcb966690c372e6$var$parseDateUnit(captures[3]);
    const week = $7dcb966690c372e6$var$parseDateUnit(captures[4]);
    const dayOfWeek = $7dcb966690c372e6$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$7dcb966690c372e6$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $7dcb966690c372e6$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        const date = new Date(0);
        if (!$7dcb966690c372e6$var$validateDate(year, month, day) || !$7dcb966690c372e6$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $7dcb966690c372e6$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $7dcb966690c372e6$var$parseTime(timeString) {
    const captures = timeString.match($7dcb966690c372e6$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    const hours = $7dcb966690c372e6$var$parseTimeUnit(captures[1]);
    const minutes = $7dcb966690c372e6$var$parseTimeUnit(captures[2]);
    const seconds = $7dcb966690c372e6$var$parseTimeUnit(captures[3]);
    if (!$7dcb966690c372e6$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * $9uNOU.millisecondsInHour + minutes * $9uNOU.millisecondsInMinute + seconds * 1000;
}
function $7dcb966690c372e6$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(",", ".")) || 0;
}
function $7dcb966690c372e6$var$parseTimezone(timezoneString) {
    if (timezoneString === "Z") return 0;
    const captures = timezoneString.match($7dcb966690c372e6$var$timezoneRegex);
    if (!captures) return 0;
    const sign = captures[1] === "+" ? -1 : 1;
    const hours = parseInt(captures[2]);
    const minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$7dcb966690c372e6$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * $9uNOU.millisecondsInHour + minutes * $9uNOU.millisecondsInMinute);
}
function $7dcb966690c372e6$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    const date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    const fourthOfJanuaryDay = date.getUTCDay() || 7;
    const diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
const $7dcb966690c372e6$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $7dcb966690c372e6$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $7dcb966690c372e6$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($7dcb966690c372e6$var$daysInMonths[month] || ($7dcb966690c372e6$var$isLeapYearIndex(year) ? 29 : 28));
}
function $7dcb966690c372e6$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($7dcb966690c372e6$var$isLeapYearIndex(year) ? 366 : 365);
}
function $7dcb966690c372e6$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $7dcb966690c372e6$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $7dcb966690c372e6$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

});

parcelRegister("1cAmv", function(module, exports) {

$parcel$export(module.exports, "set", () => $0e031e25b34345b3$export$adaa4cf7ef1b65be, (v) => $0e031e25b34345b3$export$adaa4cf7ef1b65be = v);
var $0e031e25b34345b3$export$adaa4cf7ef1b65be;
"use strict";
$0e031e25b34345b3$export$adaa4cf7ef1b65be = $0e031e25b34345b3$var$set;

var $cMvsU = parcelRequire("cMvsU");

var $14fnZ = parcelRequire("14fnZ");

var $7yyQt = parcelRequire("7yyQt");
/**
 * @name set
 * @category Common Helpers
 * @summary Set date values to a given date.
 *
 * @description
 * Set date values to a given date.
 *
 * Sets time values to date from object `values`.
 * A value is not set if it is undefined or null or doesn't exist in `values`.
 *
 * Note about bundle size: `set` does not internally use `setX` functions from date-fns but instead opts
 * to use native `Date#setX` methods. If you use this function, you may not want to include the
 * other `setX` functions that date-fns provides if you are concerned about the bundle size.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param values - The date values to be set
 *
 * @returns The new date with options set
 *
 * @example
 * // Transform 1 September 2014 into 20 October 2015 in a single line:
 * const result = set(new Date(2014, 8, 20), { year: 2015, month: 9, date: 20 })
 * //=> Tue Oct 20 2015 00:00:00
 *
 * @example
 * // Set 12 PM to 1 September 2014 01:23:45 to 1 September 2014 12:00:00:
 * const result = set(new Date(2014, 8, 1, 1, 23, 45), { hours: 12 })
 * //=> Mon Sep 01 2014 12:23:45
 */ function $0e031e25b34345b3$var$set(date, values) {
    let _date = (0, $7yyQt.toDate)(date);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(+_date)) return (0, $cMvsU.constructFrom)(date, NaN);
    if (values.year != null) _date.setFullYear(values.year);
    if (values.month != null) _date = (0, $14fnZ.setMonth)(_date, values.month);
    if (values.date != null) _date.setDate(values.date);
    if (values.hours != null) _date.setHours(values.hours);
    if (values.minutes != null) _date.setMinutes(values.minutes);
    if (values.seconds != null) _date.setSeconds(values.seconds);
    if (values.milliseconds != null) _date.setMilliseconds(values.milliseconds);
    return _date;
}

});
parcelRegister("14fnZ", function(module, exports) {

$parcel$export(module.exports, "setMonth", () => $0c7219838c4c8f84$export$63264690f8e36790, (v) => $0c7219838c4c8f84$export$63264690f8e36790 = v);
var $0c7219838c4c8f84$export$63264690f8e36790;
"use strict";
$0c7219838c4c8f84$export$63264690f8e36790 = $0c7219838c4c8f84$var$setMonth;

var $cMvsU = parcelRequire("cMvsU");

var $8dcjk = parcelRequire("8dcjk");

var $7yyQt = parcelRequire("7yyQt");
/**
 * @name setMonth
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param month - The month index to set (0-11)
 *
 * @returns The new date with the month set
 *
 * @example
 * // Set February to 1 September 2014:
 * const result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */ function $0c7219838c4c8f84$var$setMonth(date, month) {
    const _date = (0, $7yyQt.toDate)(date);
    const year = _date.getFullYear();
    const day = _date.getDate();
    const dateWithDesiredMonth = (0, $cMvsU.constructFrom)(date, 0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    const daysInMonth = (0, $8dcjk.getDaysInMonth)(dateWithDesiredMonth);
    // Set the last day of the new month
    // if the original date was the last day of the longer month
    _date.setMonth(month, Math.min(day, daysInMonth));
    return _date;
}

});
parcelRegister("8dcjk", function(module, exports) {

$parcel$export(module.exports, "getDaysInMonth", () => $5fa9164c983d15c3$export$f645ddd439eb259d, (v) => $5fa9164c983d15c3$export$f645ddd439eb259d = v);
var $5fa9164c983d15c3$export$f645ddd439eb259d;
"use strict";
$5fa9164c983d15c3$export$f645ddd439eb259d = $5fa9164c983d15c3$var$getDaysInMonth;

var $7yyQt = parcelRequire("7yyQt");

var $cMvsU = parcelRequire("cMvsU");
/**
 * @name getDaysInMonth
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The number of days in a month
 *
 * @example
 * // How many days are in February 2000?
 * const result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */ function $5fa9164c983d15c3$var$getDaysInMonth(date) {
    const _date = (0, $7yyQt.toDate)(date);
    const year = _date.getFullYear();
    const monthIndex = _date.getMonth();
    const lastDayOfMonth = (0, $cMvsU.constructFrom)(date, 0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}

});



parcelRegister("c13vl", function(module, exports) {

$parcel$export(module.exports, "setHours", () => $8bf84bf53a04799e$export$f86b797a4659b781, (v) => $8bf84bf53a04799e$export$f86b797a4659b781 = v);
var $8bf84bf53a04799e$export$f86b797a4659b781;
"use strict";
$8bf84bf53a04799e$export$f86b797a4659b781 = $8bf84bf53a04799e$var$setHours;

var $7yyQt = parcelRequire("7yyQt");
/**
 * @name setHours
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param hours - The hours of the new date
 *
 * @returns The new date with the hours set
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * const result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */ function $8bf84bf53a04799e$var$setHours(date, hours) {
    const _date = (0, $7yyQt.toDate)(date);
    _date.setHours(hours);
    return _date;
}

});

parcelRegister("drvhi", function(module, exports) {

$parcel$export(module.exports, "setMinutes", () => $9c960f2400febf48$export$ad569bf1c79ea89d, (v) => $9c960f2400febf48$export$ad569bf1c79ea89d = v);
var $9c960f2400febf48$export$ad569bf1c79ea89d;
"use strict";
$9c960f2400febf48$export$ad569bf1c79ea89d = $9c960f2400febf48$var$setMinutes;

var $7yyQt = parcelRequire("7yyQt");
/**
 * @name setMinutes
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param minutes - The minutes of the new date
 *
 * @returns The new date with the minutes set
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * const result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */ function $9c960f2400febf48$var$setMinutes(date, minutes) {
    const _date = (0, $7yyQt.toDate)(date);
    _date.setMinutes(minutes);
    return _date;
}

});

parcelRegister("k8wSb", function(module, exports) {

$parcel$export(module.exports, "setQuarter", () => $ea8e0de07f0abe19$export$8924d1de7efe1755, (v) => $ea8e0de07f0abe19$export$8924d1de7efe1755 = v);
var $ea8e0de07f0abe19$export$8924d1de7efe1755;
"use strict";
$ea8e0de07f0abe19$export$8924d1de7efe1755 = $ea8e0de07f0abe19$var$setQuarter;

var $14fnZ = parcelRequire("14fnZ");

var $7yyQt = parcelRequire("7yyQt");
/**
 * @name setQuarter
 * @category Quarter Helpers
 * @summary Set the year quarter to the given date.
 *
 * @description
 * Set the year quarter to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param quarter - The quarter of the new date
 *
 * @returns The new date with the quarter set
 *
 * @example
 * // Set the 2nd quarter to 2 July 2014:
 * const result = setQuarter(new Date(2014, 6, 2), 2)
 * //=> Wed Apr 02 2014 00:00:00
 */ function $ea8e0de07f0abe19$var$setQuarter(date, quarter) {
    const _date = (0, $7yyQt.toDate)(date);
    const oldQuarter = Math.trunc(_date.getMonth() / 3) + 1;
    const diff = quarter - oldQuarter;
    return (0, $14fnZ.setMonth)(_date, _date.getMonth() + diff * 3);
}

});

parcelRegister("g5D6y", function(module, exports) {

$parcel$export(module.exports, "setSeconds", () => $bb6b7258e924e769$export$aec44746644cbf43, (v) => $bb6b7258e924e769$export$aec44746644cbf43 = v);
var $bb6b7258e924e769$export$aec44746644cbf43;
"use strict";
$bb6b7258e924e769$export$aec44746644cbf43 = $bb6b7258e924e769$var$setSeconds;

var $7yyQt = parcelRequire("7yyQt");
/**
 * @name setSeconds
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param seconds - The seconds of the new date
 *
 * @returns The new date with the seconds set
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * const result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */ function $bb6b7258e924e769$var$setSeconds(date, seconds) {
    const _date = (0, $7yyQt.toDate)(date);
    _date.setSeconds(seconds);
    return _date;
}

});

parcelRegister("hkGXQ", function(module, exports) {

$parcel$export(module.exports, "setYear", () => $c9e5a1bbdcf3ebc3$export$a8408b6c5639cab7, (v) => $c9e5a1bbdcf3ebc3$export$a8408b6c5639cab7 = v);
var $c9e5a1bbdcf3ebc3$export$a8408b6c5639cab7;
"use strict";
$c9e5a1bbdcf3ebc3$export$a8408b6c5639cab7 = $c9e5a1bbdcf3ebc3$var$setYear;

var $cMvsU = parcelRequire("cMvsU");

var $7yyQt = parcelRequire("7yyQt");
/**
 * @name setYear
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param year - The year of the new date
 *
 * @returns The new date with the year set
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * const result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */ function $c9e5a1bbdcf3ebc3$var$setYear(date, year) {
    const _date = (0, $7yyQt.toDate)(date);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(+_date)) return (0, $cMvsU.constructFrom)(date, NaN);
    _date.setFullYear(year);
    return _date;
}

});

parcelRegister("d15Zh", function(module, exports) {

$parcel$export(module.exports, "startOfMonth", () => $97a0034df0672fa6$export$a5a3b454ada2268e, (v) => $97a0034df0672fa6$export$a5a3b454ada2268e = v);
var $97a0034df0672fa6$export$a5a3b454ada2268e;
"use strict";
$97a0034df0672fa6$export$a5a3b454ada2268e = $97a0034df0672fa6$var$startOfMonth;

var $7yyQt = parcelRequire("7yyQt");
/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a month
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */ function $97a0034df0672fa6$var$startOfMonth(date) {
    const _date = (0, $7yyQt.toDate)(date);
    _date.setDate(1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});

parcelRegister("6PGPz", function(module, exports) {

$parcel$export(module.exports, "subDays", () => $4f98bacdf9102af0$export$70823084e2deb1ea, (v) => $4f98bacdf9102af0$export$70823084e2deb1ea = v);
var $4f98bacdf9102af0$export$70823084e2deb1ea;
"use strict";
$4f98bacdf9102af0$export$70823084e2deb1ea = $4f98bacdf9102af0$var$subDays;

var $l4b73 = parcelRequire("l4b73");
/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of days to be subtracted.
 *
 * @returns The new date with the days subtracted
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * const result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */ function $4f98bacdf9102af0$var$subDays(date, amount) {
    return (0, $l4b73.addDays)(date, -amount);
}

});

parcelRegister("9i2HO", function(module, exports) {

$parcel$export(module.exports, "subMonths", () => $6c37e4ccf1cd6d68$export$73d1c15a21f9fae5, (v) => $6c37e4ccf1cd6d68$export$73d1c15a21f9fae5 = v);
var $6c37e4ccf1cd6d68$export$73d1c15a21f9fae5;
"use strict";
$6c37e4ccf1cd6d68$export$73d1c15a21f9fae5 = $6c37e4ccf1cd6d68$var$subMonths;

var $1YUHS = parcelRequire("1YUHS");
/**
 * @name subMonths
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of months to be subtracted.
 *
 * @returns The new date with the months subtracted
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * const result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */ function $6c37e4ccf1cd6d68$var$subMonths(date, amount) {
    return (0, $1YUHS.addMonths)(date, -amount);
}

});

parcelRegister("iRpsV", function(module, exports) {

$parcel$export(module.exports, "subQuarters", () => $dbb0ee297087199a$export$a31bfeeeee80cce6, (v) => $dbb0ee297087199a$export$a31bfeeeee80cce6 = v);
var $dbb0ee297087199a$export$a31bfeeeee80cce6;
"use strict";
$dbb0ee297087199a$export$a31bfeeeee80cce6 = $dbb0ee297087199a$var$subQuarters;

var $ieLCh = parcelRequire("ieLCh");
/**
 * @name subQuarters
 * @category Quarter Helpers
 * @summary Subtract the specified number of year quarters from the given date.
 *
 * @description
 * Subtract the specified number of year quarters from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of quarters to be subtracted.
 *
 * @returns The new date with the quarters subtracted
 *
 * @example
 * // Subtract 3 quarters from 1 September 2014:
 * const result = subQuarters(new Date(2014, 8, 1), 3)
 * //=> Sun Dec 01 2013 00:00:00
 */ function $dbb0ee297087199a$var$subQuarters(date, amount) {
    return (0, $ieLCh.addQuarters)(date, -amount);
}

});

parcelRegister("7KMpi", function(module, exports) {

$parcel$export(module.exports, "subWeeks", () => $5a5260e56e3f5a0d$export$b4d8ae6376193efb, (v) => $5a5260e56e3f5a0d$export$b4d8ae6376193efb = v);
var $5a5260e56e3f5a0d$export$b4d8ae6376193efb;
"use strict";
$5a5260e56e3f5a0d$export$b4d8ae6376193efb = $5a5260e56e3f5a0d$var$subWeeks;

var $2jgJV = parcelRequire("2jgJV");
/**
 * @name subWeeks
 * @category Week Helpers
 * @summary Subtract the specified number of weeks from the given date.
 *
 * @description
 * Subtract the specified number of weeks from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of weeks to be subtracted.
 *
 * @returns The new date with the weeks subtracted
 *
 * @example
 * // Subtract 4 weeks from 1 September 2014:
 * const result = subWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Aug 04 2014 00:00:00
 */ function $5a5260e56e3f5a0d$var$subWeeks(date, amount) {
    return (0, $2jgJV.addWeeks)(date, -amount);
}

});

parcelRegister("jT5xJ", function(module, exports) {

$parcel$export(module.exports, "subYears", () => $e7a7741b50155761$export$14867687ff6c92e2, (v) => $e7a7741b50155761$export$14867687ff6c92e2 = v);
var $e7a7741b50155761$export$14867687ff6c92e2;
"use strict";
$e7a7741b50155761$export$14867687ff6c92e2 = $e7a7741b50155761$var$subYears;

var $1mchh = parcelRequire("1mchh");
/**
 * @name subYears
 * @category Year Helpers
 * @summary Subtract the specified number of years from the given date.
 *
 * @description
 * Subtract the specified number of years from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of years to be subtracted.
 *
 * @returns The new date with the years subtracted
 *
 * @example
 * // Subtract 5 years from 1 September 2014:
 * const result = subYears(new Date(2014, 8, 1), 5)
 * //=> Tue Sep 01 2009 00:00:00
 */ function $e7a7741b50155761$var$subYears(date, amount) {
    return (0, $1mchh.addYears)(date, -amount);
}

});

parcelRegister("dXIky", function(module, exports) {

$parcel$export(module.exports, "useMergeRefs", () => $a2a32c30b64f04ab$export$74665b213cb5c4cf);
$parcel$export(module.exports, "FloatingList", () => $a2a32c30b64f04ab$export$ffe15b0e64951704);
$parcel$export(module.exports, "useListItem", () => $a2a32c30b64f04ab$export$dcdc7ff5149f7d1a);
$parcel$export(module.exports, "Composite", () => $a2a32c30b64f04ab$export$43586241d9db0c6d);
$parcel$export(module.exports, "CompositeItem", () => $a2a32c30b64f04ab$export$ef1ef7a3a43ace8e);
$parcel$export(module.exports, "useId", () => $a2a32c30b64f04ab$export$f680877a34711e37);
$parcel$export(module.exports, "FloatingArrow", () => $a2a32c30b64f04ab$export$33511391554732bc);
$parcel$export(module.exports, "useFloatingParentNodeId", () => $a2a32c30b64f04ab$export$165209eae06d3488);
$parcel$export(module.exports, "useFloatingTree", () => $a2a32c30b64f04ab$export$db0c2a7c7a2a4f69);
$parcel$export(module.exports, "useFloatingNodeId", () => $a2a32c30b64f04ab$export$9b136e0e758a42f4);
$parcel$export(module.exports, "FloatingNode", () => $a2a32c30b64f04ab$export$ca00a83b5b253862);
$parcel$export(module.exports, "FloatingTree", () => $a2a32c30b64f04ab$export$587b60129641c4c8);
$parcel$export(module.exports, "useHover", () => $a2a32c30b64f04ab$export$ae780daf29e6d456);
$parcel$export(module.exports, "useDelayGroupContext", () => $a2a32c30b64f04ab$export$e2411914b150383d);
$parcel$export(module.exports, "FloatingDelayGroup", () => $a2a32c30b64f04ab$export$718279509ff1e241);
$parcel$export(module.exports, "useDelayGroup", () => $a2a32c30b64f04ab$export$560fc8be89c8b4a8);
$parcel$export(module.exports, "useFloatingPortalNode", () => $a2a32c30b64f04ab$export$ac107512f3c5cca6);
$parcel$export(module.exports, "FloatingPortal", () => $a2a32c30b64f04ab$export$31fa5d718fa2ac09);
$parcel$export(module.exports, "FloatingFocusManager", () => $a2a32c30b64f04ab$export$8aeee49171ded61a);
$parcel$export(module.exports, "FloatingOverlay", () => $a2a32c30b64f04ab$export$a35954495955337b);
$parcel$export(module.exports, "useClick", () => $a2a32c30b64f04ab$export$98524f11226063fc);
$parcel$export(module.exports, "useClientPoint", () => $a2a32c30b64f04ab$export$7fe170a73a621816);
$parcel$export(module.exports, "useDismiss", () => $a2a32c30b64f04ab$export$fcdf1ba5fafc089b);
$parcel$export(module.exports, "useFloatingRootContext", () => $a2a32c30b64f04ab$export$1df81146f8ad8e4c);
$parcel$export(module.exports, "useFloating", () => $a2a32c30b64f04ab$export$4e02a5c1d08bac65);
$parcel$export(module.exports, "useFocus", () => $a2a32c30b64f04ab$export$f8168d8dd8fd66e6);
$parcel$export(module.exports, "useInteractions", () => $a2a32c30b64f04ab$export$a519f7794e446ddd);
$parcel$export(module.exports, "useListNavigation", () => $a2a32c30b64f04ab$export$b5d22cac4ad33f40);
$parcel$export(module.exports, "useRole", () => $a2a32c30b64f04ab$export$f66572793fa256a1);
$parcel$export(module.exports, "useTransitionStatus", () => $a2a32c30b64f04ab$export$b2ef21706733f7e5);
$parcel$export(module.exports, "useTransitionStyles", () => $a2a32c30b64f04ab$export$769fba13884bc2f4);
$parcel$export(module.exports, "useTypeahead", () => $a2a32c30b64f04ab$export$d8d674d50b73ba93);
$parcel$export(module.exports, "inner", () => $a2a32c30b64f04ab$export$4ae363f1d88fb658);
$parcel$export(module.exports, "useInnerOffset", () => $a2a32c30b64f04ab$export$3d74b0dda7cc82ff);
$parcel$export(module.exports, "safePolygon", () => $a2a32c30b64f04ab$export$7484214ab62358d2);
$parcel$export(module.exports, "arrow", () => (parcelRequire("eqxtD")).arrow);
$parcel$export(module.exports, "autoPlacement", () => (parcelRequire("eqxtD")).autoPlacement);
$parcel$export(module.exports, "autoUpdate", () => (parcelRequire("8i2T6")).autoUpdate);
$parcel$export(module.exports, "computePosition", () => (parcelRequire("8i2T6")).computePosition);
$parcel$export(module.exports, "detectOverflow", () => (parcelRequire("8i2T6")).detectOverflow);
$parcel$export(module.exports, "flip", () => (parcelRequire("eqxtD")).flip);
$parcel$export(module.exports, "getOverflowAncestors", () => (parcelRequire("1D9S2")).getOverflowAncestors);
$parcel$export(module.exports, "hide", () => (parcelRequire("eqxtD")).hide);
$parcel$export(module.exports, "inline", () => (parcelRequire("eqxtD")).inline);
$parcel$export(module.exports, "limitShift", () => (parcelRequire("eqxtD")).limitShift);
$parcel$export(module.exports, "offset", () => (parcelRequire("eqxtD")).offset);
$parcel$export(module.exports, "platform", () => (parcelRequire("8i2T6")).platform);
$parcel$export(module.exports, "shift", () => (parcelRequire("eqxtD")).shift);
$parcel$export(module.exports, "size", () => (parcelRequire("eqxtD")).size);

var $8NFma = parcelRequire("8NFma");

var $hn8gG = parcelRequire("hn8gG");

var $Euxde = parcelRequire("Euxde");

var $1D9S2 = parcelRequire("1D9S2");

var $6X8j6 = parcelRequire("6X8j6");

var $2pmb0 = parcelRequire("2pmb0");

var $eqxtD = parcelRequire("eqxtD");
var $8i2T6 = parcelRequire("8i2T6");
var $8i2T6 = parcelRequire("8i2T6");
var $1D9S2 = parcelRequire("1D9S2");
/**
 * Merges an array of refs into a single memoized callback ref or `null`.
 * @see https://floating-ui.com/docs/react-utils#usemergerefs
 */ function $a2a32c30b64f04ab$export$74665b213cb5c4cf(refs) {
    return $8NFma.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (value)=>{
            refs.forEach((ref)=>{
                if (typeof ref === 'function') ref(value);
                else if (ref != null) ref.current = value;
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}
// https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379
const $a2a32c30b64f04ab$var$SafeReact = {
    ...$8NFma
};
const $a2a32c30b64f04ab$var$useInsertionEffect = $a2a32c30b64f04ab$var$SafeReact.useInsertionEffect;
const $a2a32c30b64f04ab$var$useSafeInsertionEffect = $a2a32c30b64f04ab$var$useInsertionEffect || ((fn)=>fn());
function $a2a32c30b64f04ab$var$useEffectEvent(callback) {
    const ref = $8NFma.useRef(()=>{});
    $a2a32c30b64f04ab$var$useSafeInsertionEffect(()=>{
        ref.current = callback;
    });
    return $8NFma.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current == null ? void 0 : ref.current(...args);
    }, []);
}
const $a2a32c30b64f04ab$var$ARROW_UP = 'ArrowUp';
const $a2a32c30b64f04ab$var$ARROW_DOWN = 'ArrowDown';
const $a2a32c30b64f04ab$var$ARROW_LEFT = 'ArrowLeft';
const $a2a32c30b64f04ab$var$ARROW_RIGHT = 'ArrowRight';
function $a2a32c30b64f04ab$var$isDifferentRow(index, cols, prevRow) {
    return Math.floor(index / cols) !== prevRow;
}
function $a2a32c30b64f04ab$var$isIndexOutOfBounds(listRef, index) {
    return index < 0 || index >= listRef.current.length;
}
function $a2a32c30b64f04ab$var$getMinIndex(listRef, disabledIndices) {
    return $a2a32c30b64f04ab$var$findNonDisabledIndex(listRef, {
        disabledIndices: disabledIndices
    });
}
function $a2a32c30b64f04ab$var$getMaxIndex(listRef, disabledIndices) {
    return $a2a32c30b64f04ab$var$findNonDisabledIndex(listRef, {
        decrement: true,
        startingIndex: listRef.current.length,
        disabledIndices: disabledIndices
    });
}
function $a2a32c30b64f04ab$var$findNonDisabledIndex(listRef, _temp) {
    let { startingIndex: startingIndex = -1, decrement: decrement = false, disabledIndices: disabledIndices, amount: amount = 1 } = _temp === void 0 ? {} : _temp;
    const list = listRef.current;
    let index = startingIndex;
    do index += decrement ? -amount : amount;
    while (index >= 0 && index <= list.length - 1 && $a2a32c30b64f04ab$var$isDisabled(list, index, disabledIndices));
    return index;
}
function $a2a32c30b64f04ab$var$getGridNavigatedIndex(elementsRef, _ref) {
    let { event: event, orientation: orientation, loop: loop, cols: cols, disabledIndices: disabledIndices, minIndex: minIndex, maxIndex: maxIndex, prevIndex: prevIndex, stopEvent: stop = false } = _ref;
    let nextIndex = prevIndex;
    if (event.key === $a2a32c30b64f04ab$var$ARROW_UP) {
        stop && (0, $hn8gG.stopEvent)(event);
        if (prevIndex === -1) nextIndex = maxIndex;
        else {
            nextIndex = $a2a32c30b64f04ab$var$findNonDisabledIndex(elementsRef, {
                startingIndex: nextIndex,
                amount: cols,
                decrement: true,
                disabledIndices: disabledIndices
            });
            if (loop && (prevIndex - cols < minIndex || nextIndex < 0)) {
                const col = prevIndex % cols;
                const maxCol = maxIndex % cols;
                const offset = maxIndex - (maxCol - col);
                if (maxCol === col) nextIndex = maxIndex;
                else nextIndex = maxCol > col ? offset : offset - cols;
            }
        }
        if ($a2a32c30b64f04ab$var$isIndexOutOfBounds(elementsRef, nextIndex)) nextIndex = prevIndex;
    }
    if (event.key === $a2a32c30b64f04ab$var$ARROW_DOWN) {
        stop && (0, $hn8gG.stopEvent)(event);
        if (prevIndex === -1) nextIndex = minIndex;
        else {
            nextIndex = $a2a32c30b64f04ab$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex,
                amount: cols,
                disabledIndices: disabledIndices
            });
            if (loop && prevIndex + cols > maxIndex) nextIndex = $a2a32c30b64f04ab$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex % cols - cols,
                amount: cols,
                disabledIndices: disabledIndices
            });
        }
        if ($a2a32c30b64f04ab$var$isIndexOutOfBounds(elementsRef, nextIndex)) nextIndex = prevIndex;
    }
    // Remains on the same row/column.
    if (orientation === 'both') {
        const prevRow = (0, $Euxde.floor)(prevIndex / cols);
        if (event.key === $a2a32c30b64f04ab$var$ARROW_RIGHT) {
            stop && (0, $hn8gG.stopEvent)(event);
            if (prevIndex % cols !== cols - 1) {
                nextIndex = $a2a32c30b64f04ab$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex,
                    disabledIndices: disabledIndices
                });
                if (loop && $a2a32c30b64f04ab$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = $a2a32c30b64f04ab$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex - prevIndex % cols - 1,
                    disabledIndices: disabledIndices
                });
            } else if (loop) nextIndex = $a2a32c30b64f04ab$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            if ($a2a32c30b64f04ab$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        if (event.key === $a2a32c30b64f04ab$var$ARROW_LEFT) {
            stop && (0, $hn8gG.stopEvent)(event);
            if (prevIndex % cols !== 0) {
                nextIndex = $a2a32c30b64f04ab$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex,
                    decrement: true,
                    disabledIndices: disabledIndices
                });
                if (loop && $a2a32c30b64f04ab$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = $a2a32c30b64f04ab$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex + (cols - prevIndex % cols),
                    decrement: true,
                    disabledIndices: disabledIndices
                });
            } else if (loop) nextIndex = $a2a32c30b64f04ab$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex + (cols - prevIndex % cols),
                decrement: true,
                disabledIndices: disabledIndices
            });
            if ($a2a32c30b64f04ab$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        const lastRow = (0, $Euxde.floor)(maxIndex / cols) === prevRow;
        if ($a2a32c30b64f04ab$var$isIndexOutOfBounds(elementsRef, nextIndex)) {
            if (loop && lastRow) nextIndex = event.key === $a2a32c30b64f04ab$var$ARROW_LEFT ? maxIndex : $a2a32c30b64f04ab$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            else nextIndex = prevIndex;
        }
    }
    return nextIndex;
}
/** For each cell index, gets the item index that occupies that cell */ function $a2a32c30b64f04ab$var$buildCellMap(sizes, cols, dense) {
    const cellMap = [];
    let startIndex = 0;
    sizes.forEach((_ref2, index)=>{
        let { width: width, height: height } = _ref2;
        let itemPlaced = false;
        if (dense) startIndex = 0;
        while(!itemPlaced){
            const targetCells = [];
            for(let i = 0; i < width; i++)for(let j = 0; j < height; j++)targetCells.push(startIndex + i + j * cols);
            if (startIndex % cols + width <= cols && targetCells.every((cell)=>cellMap[cell] == null)) {
                targetCells.forEach((cell)=>{
                    cellMap[cell] = index;
                });
                itemPlaced = true;
            } else startIndex++;
        }
    });
    // convert into a non-sparse array
    return [
        ...cellMap
    ];
}
/** Gets cell index of an item's corner or -1 when index is -1. */ function $a2a32c30b64f04ab$var$getCellIndexOfCorner(index, sizes, cellMap, cols, corner) {
    if (index === -1) return -1;
    const firstCellIndex = cellMap.indexOf(index);
    const sizeItem = sizes[index];
    switch(corner){
        case 'tl':
            return firstCellIndex;
        case 'tr':
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + sizeItem.width - 1;
        case 'bl':
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + (sizeItem.height - 1) * cols;
        case 'br':
            return cellMap.lastIndexOf(index);
    }
}
/** Gets all cell indices that correspond to the specified indices */ function $a2a32c30b64f04ab$var$getCellIndices(indices, cellMap) {
    return cellMap.flatMap((index, cellIndex)=>indices.includes(index) ? [
            cellIndex
        ] : []);
}
function $a2a32c30b64f04ab$var$isDisabled(list, index, disabledIndices) {
    if (disabledIndices) return disabledIndices.includes(index);
    const element = list[index];
    return element == null || element.hasAttribute('disabled') || element.getAttribute('aria-disabled') === 'true';
}
let $a2a32c30b64f04ab$var$rafId = 0;
function $a2a32c30b64f04ab$var$enqueueFocus(el, options) {
    if (options === void 0) options = {};
    const { preventScroll: preventScroll = false, cancelPrevious: cancelPrevious = true, sync: sync = false } = options;
    cancelPrevious && cancelAnimationFrame($a2a32c30b64f04ab$var$rafId);
    const exec = ()=>el == null ? void 0 : el.focus({
            preventScroll: preventScroll
        });
    if (sync) exec();
    else $a2a32c30b64f04ab$var$rafId = requestAnimationFrame(exec);
}
var $a2a32c30b64f04ab$var$index = typeof document !== 'undefined' ? (0, $8NFma.useLayoutEffect) : (0, $8NFma.useEffect);
function $a2a32c30b64f04ab$var$sortByDocumentPosition(a, b) {
    const position = a.compareDocumentPosition(b);
    if (position & Node.DOCUMENT_POSITION_FOLLOWING || position & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
    if (position & Node.DOCUMENT_POSITION_PRECEDING || position & Node.DOCUMENT_POSITION_CONTAINS) return 1;
    return 0;
}
function $a2a32c30b64f04ab$var$areMapsEqual(map1, map2) {
    if (map1.size !== map2.size) return false;
    for (const [key, value] of map1.entries()){
        if (value !== map2.get(key)) return false;
    }
    return true;
}
const $a2a32c30b64f04ab$var$FloatingListContext = /*#__PURE__*/ $8NFma.createContext({
    register: ()=>{},
    unregister: ()=>{},
    map: /*#__PURE__*/ new Map(),
    elementsRef: {
        current: []
    }
});
/**
 * Provides context for a list of items within the floating element.
 * @see https://floating-ui.com/docs/FloatingList
 */ function $a2a32c30b64f04ab$export$ffe15b0e64951704(props) {
    const { children: children, elementsRef: elementsRef, labelsRef: labelsRef } = props;
    const [map, setMap] = $8NFma.useState(()=>new Map());
    const register = $8NFma.useCallback((node)=>{
        setMap((prevMap)=>new Map(prevMap).set(node, null));
    }, []);
    const unregister = $8NFma.useCallback((node)=>{
        setMap((prevMap)=>{
            const map = new Map(prevMap);
            map.delete(node);
            return map;
        });
    }, []);
    $a2a32c30b64f04ab$var$index(()=>{
        const newMap = new Map(map);
        const nodes = Array.from(newMap.keys()).sort($a2a32c30b64f04ab$var$sortByDocumentPosition);
        nodes.forEach((node, index)=>{
            newMap.set(node, index);
        });
        if (!$a2a32c30b64f04ab$var$areMapsEqual(map, newMap)) setMap(newMap);
    }, [
        map
    ]);
    return /*#__PURE__*/ $8NFma.createElement($a2a32c30b64f04ab$var$FloatingListContext.Provider, {
        value: $8NFma.useMemo(()=>({
                register: register,
                unregister: unregister,
                map: map,
                elementsRef: elementsRef,
                labelsRef: labelsRef
            }), [
            register,
            unregister,
            map,
            elementsRef,
            labelsRef
        ])
    }, children);
}
/**
 * Used to register a list item and its index (DOM position) in the
 * `FloatingList`.
 * @see https://floating-ui.com/docs/FloatingList#uselistitem
 */ function $a2a32c30b64f04ab$export$dcdc7ff5149f7d1a(props) {
    if (props === void 0) props = {};
    const { label: label } = props;
    const { register: register, unregister: unregister, map: map, elementsRef: elementsRef, labelsRef: labelsRef } = $8NFma.useContext($a2a32c30b64f04ab$var$FloatingListContext);
    const [index$1, setIndex] = $8NFma.useState(null);
    const componentRef = $8NFma.useRef(null);
    const ref = $8NFma.useCallback((node)=>{
        componentRef.current = node;
        if (index$1 !== null) {
            elementsRef.current[index$1] = node;
            if (labelsRef) {
                var _node$textContent;
                const isLabelDefined = label !== undefined;
                labelsRef.current[index$1] = isLabelDefined ? label : (_node$textContent = node == null ? void 0 : node.textContent) != null ? _node$textContent : null;
            }
        }
    }, [
        index$1,
        elementsRef,
        labelsRef,
        label
    ]);
    $a2a32c30b64f04ab$var$index(()=>{
        const node = componentRef.current;
        if (node) {
            register(node);
            return ()=>{
                unregister(node);
            };
        }
    }, [
        register,
        unregister
    ]);
    $a2a32c30b64f04ab$var$index(()=>{
        const index = componentRef.current ? map.get(componentRef.current) : null;
        if (index != null) setIndex(index);
    }, [
        map
    ]);
    return $8NFma.useMemo(()=>({
            ref: ref,
            index: index$1 == null ? -1 : index$1
        }), [
        index$1,
        ref
    ]);
}
function $a2a32c30b64f04ab$var$renderJsx(render, computedProps) {
    if (typeof render === 'function') return render(computedProps);
    if (render) return /*#__PURE__*/ $8NFma.cloneElement(render, computedProps);
    return /*#__PURE__*/ $8NFma.createElement("div", computedProps);
}
const $a2a32c30b64f04ab$var$CompositeContext = /*#__PURE__*/ $8NFma.createContext({
    activeIndex: 0,
    onNavigate: ()=>{}
});
const $a2a32c30b64f04ab$var$horizontalKeys = [
    $a2a32c30b64f04ab$var$ARROW_LEFT,
    $a2a32c30b64f04ab$var$ARROW_RIGHT
];
const $a2a32c30b64f04ab$var$verticalKeys = [
    $a2a32c30b64f04ab$var$ARROW_UP,
    $a2a32c30b64f04ab$var$ARROW_DOWN
];
const $a2a32c30b64f04ab$var$allKeys = [
    ...$a2a32c30b64f04ab$var$horizontalKeys,
    ...$a2a32c30b64f04ab$var$verticalKeys
];
/**
 * Creates a single tab stop whose items are navigated by arrow keys, which
 * provides list navigation outside of floating element contexts.
 *
 * This is useful to enable navigation of a list of items that aren’t part of a
 * floating element. A menubar is an example of a composite, with each reference
 * element being an item.
 * @see https://floating-ui.com/docs/Composite
 */ const $a2a32c30b64f04ab$export$43586241d9db0c6d = /*#__PURE__*/ $8NFma.forwardRef(function Composite(props, forwardedRef) {
    const { render: render, orientation: orientation = 'both', loop: loop = true, cols: cols = 1, disabledIndices: disabledIndices, activeIndex: externalActiveIndex, onNavigate: externalSetActiveIndex, itemSizes: itemSizes, dense: dense = false, ...domProps } = props;
    const [internalActiveIndex, internalSetActiveIndex] = $8NFma.useState(0);
    const activeIndex = externalActiveIndex != null ? externalActiveIndex : internalActiveIndex;
    const onNavigate = $a2a32c30b64f04ab$var$useEffectEvent(externalSetActiveIndex != null ? externalSetActiveIndex : internalSetActiveIndex);
    const elementsRef = $8NFma.useRef([]);
    const renderElementProps = render && typeof render !== 'function' ? render.props : {};
    const contextValue = $8NFma.useMemo(()=>({
            activeIndex: activeIndex,
            onNavigate: onNavigate
        }), [
        activeIndex,
        onNavigate
    ]);
    const isGrid = cols > 1;
    function handleKeyDown(event) {
        if (!$a2a32c30b64f04ab$var$allKeys.includes(event.key)) return;
        let nextIndex = activeIndex;
        const minIndex = $a2a32c30b64f04ab$var$getMinIndex(elementsRef, disabledIndices);
        const maxIndex = $a2a32c30b64f04ab$var$getMaxIndex(elementsRef, disabledIndices);
        if (isGrid) {
            const sizes = itemSizes || Array.from({
                length: elementsRef.current.length
            }, ()=>({
                    width: 1,
                    height: 1
                }));
            // To calculate movements on the grid, we use hypothetical cell indices
            // as if every item was 1x1, then convert back to real indices.
            const cellMap = $a2a32c30b64f04ab$var$buildCellMap(sizes, cols, dense);
            const minGridIndex = cellMap.findIndex((index)=>index != null && !$a2a32c30b64f04ab$var$isDisabled(elementsRef.current, index, disabledIndices));
            // last enabled index
            const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex)=>index != null && !$a2a32c30b64f04ab$var$isDisabled(elementsRef.current, index, disabledIndices) ? cellIndex : foundIndex, -1);
            const maybeNextIndex = cellMap[$a2a32c30b64f04ab$var$getGridNavigatedIndex({
                current: cellMap.map((itemIndex)=>itemIndex ? elementsRef.current[itemIndex] : null)
            }, {
                event: event,
                orientation: orientation,
                loop: loop,
                cols: cols,
                // treat undefined (empty grid spaces) as disabled indices so we
                // don't end up in them
                disabledIndices: $a2a32c30b64f04ab$var$getCellIndices([
                    ...disabledIndices || elementsRef.current.map((_, index)=>$a2a32c30b64f04ab$var$isDisabled(elementsRef.current, index) ? index : undefined),
                    undefined
                ], cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: $a2a32c30b64f04ab$var$getCellIndexOfCorner(activeIndex > maxIndex ? minIndex : activeIndex, sizes, cellMap, cols, // use a corner matching the edge closest to the direction we're
                // moving in so we don't end up in the same item. Prefer
                // top/left over bottom/right.
                event.key === $a2a32c30b64f04ab$var$ARROW_DOWN ? 'bl' : event.key === $a2a32c30b64f04ab$var$ARROW_RIGHT ? 'tr' : 'tl')
            })];
            if (maybeNextIndex != null) nextIndex = maybeNextIndex;
        }
        const toEndKeys = {
            horizontal: [
                $a2a32c30b64f04ab$var$ARROW_RIGHT
            ],
            vertical: [
                $a2a32c30b64f04ab$var$ARROW_DOWN
            ],
            both: [
                $a2a32c30b64f04ab$var$ARROW_RIGHT,
                $a2a32c30b64f04ab$var$ARROW_DOWN
            ]
        }[orientation];
        const toStartKeys = {
            horizontal: [
                $a2a32c30b64f04ab$var$ARROW_LEFT
            ],
            vertical: [
                $a2a32c30b64f04ab$var$ARROW_UP
            ],
            both: [
                $a2a32c30b64f04ab$var$ARROW_LEFT,
                $a2a32c30b64f04ab$var$ARROW_UP
            ]
        }[orientation];
        const preventedKeys = isGrid ? $a2a32c30b64f04ab$var$allKeys : ({
            horizontal: $a2a32c30b64f04ab$var$horizontalKeys,
            vertical: $a2a32c30b64f04ab$var$verticalKeys,
            both: $a2a32c30b64f04ab$var$allKeys
        })[orientation];
        if (nextIndex === activeIndex && [
            ...toEndKeys,
            ...toStartKeys
        ].includes(event.key)) {
            if (loop && nextIndex === maxIndex && toEndKeys.includes(event.key)) nextIndex = minIndex;
            else if (loop && nextIndex === minIndex && toStartKeys.includes(event.key)) nextIndex = maxIndex;
            else nextIndex = $a2a32c30b64f04ab$var$findNonDisabledIndex(elementsRef, {
                startingIndex: nextIndex,
                decrement: toStartKeys.includes(event.key),
                disabledIndices: disabledIndices
            });
        }
        if (nextIndex !== activeIndex && !$a2a32c30b64f04ab$var$isIndexOutOfBounds(elementsRef, nextIndex)) {
            event.stopPropagation();
            if (preventedKeys.includes(event.key)) event.preventDefault();
            onNavigate(nextIndex);
            // Wait for FocusManager `returnFocus` to execute.
            queueMicrotask(()=>{
                $a2a32c30b64f04ab$var$enqueueFocus(elementsRef.current[nextIndex]);
            });
        }
    }
    const computedProps = {
        ...domProps,
        ...renderElementProps,
        ref: forwardedRef,
        'aria-orientation': orientation === 'both' ? undefined : orientation,
        onKeyDown (e) {
            domProps.onKeyDown == null || domProps.onKeyDown(e);
            renderElementProps.onKeyDown == null || renderElementProps.onKeyDown(e);
            handleKeyDown(e);
        }
    };
    return /*#__PURE__*/ $8NFma.createElement($a2a32c30b64f04ab$var$CompositeContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ $8NFma.createElement($a2a32c30b64f04ab$export$ffe15b0e64951704, {
        elementsRef: elementsRef
    }, $a2a32c30b64f04ab$var$renderJsx(render, computedProps)));
});
/**
 * @see https://floating-ui.com/docs/Composite
 */ const $a2a32c30b64f04ab$export$ef1ef7a3a43ace8e = /*#__PURE__*/ $8NFma.forwardRef(function CompositeItem(props, forwardedRef) {
    const { render: render, ...domProps } = props;
    const renderElementProps = render && typeof render !== 'function' ? render.props : {};
    const { activeIndex: activeIndex, onNavigate: onNavigate } = $8NFma.useContext($a2a32c30b64f04ab$var$CompositeContext);
    const { ref: ref, index: index } = $a2a32c30b64f04ab$export$dcdc7ff5149f7d1a();
    const mergedRef = $a2a32c30b64f04ab$export$74665b213cb5c4cf([
        ref,
        forwardedRef,
        renderElementProps.ref
    ]);
    const isActive = activeIndex === index;
    const computedProps = {
        ...domProps,
        ...renderElementProps,
        ref: mergedRef,
        tabIndex: isActive ? 0 : -1,
        'data-active': isActive ? '' : undefined,
        onFocus (e) {
            domProps.onFocus == null || domProps.onFocus(e);
            renderElementProps.onFocus == null || renderElementProps.onFocus(e);
            onNavigate(index);
        }
    };
    return $a2a32c30b64f04ab$var$renderJsx(render, computedProps);
});
function $a2a32c30b64f04ab$var$_extends() {
    $a2a32c30b64f04ab$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a2a32c30b64f04ab$var$_extends.apply(this, arguments);
}
let $a2a32c30b64f04ab$var$serverHandoffComplete = false;
let $a2a32c30b64f04ab$var$count = 0;
const $a2a32c30b64f04ab$var$genId = ()=>// on <React 18
    "floating-ui-" + Math.random().toString(36).slice(2, 6) + $a2a32c30b64f04ab$var$count++;
function $a2a32c30b64f04ab$var$useFloatingId() {
    const [id, setId] = $8NFma.useState(()=>$a2a32c30b64f04ab$var$serverHandoffComplete ? $a2a32c30b64f04ab$var$genId() : undefined);
    $a2a32c30b64f04ab$var$index(()=>{
        if (id == null) setId($a2a32c30b64f04ab$var$genId());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $8NFma.useEffect(()=>{
        $a2a32c30b64f04ab$var$serverHandoffComplete = true;
    }, []);
    return id;
}
const $a2a32c30b64f04ab$var$useReactId = $a2a32c30b64f04ab$var$SafeReact.useId;
/**
 * Uses React 18's built-in `useId()` when available, or falls back to a
 * slightly less performant (requiring a double render) implementation for
 * earlier React versions.
 * @see https://floating-ui.com/docs/react-utils#useid
 */ const $a2a32c30b64f04ab$export$f680877a34711e37 = $a2a32c30b64f04ab$var$useReactId || $a2a32c30b64f04ab$var$useFloatingId;
let $a2a32c30b64f04ab$var$devMessageSet;
function $a2a32c30b64f04ab$var$warn() {
    var _devMessageSet;
    for(var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++)messages[_key] = arguments[_key];
    const message = "Floating UI: " + messages.join(' ');
    if (!((_devMessageSet = $a2a32c30b64f04ab$var$devMessageSet) != null && _devMessageSet.has(message))) {
        var _devMessageSet2;
        (_devMessageSet2 = $a2a32c30b64f04ab$var$devMessageSet) == null || _devMessageSet2.add(message);
        console.warn(message);
    }
}
function $a2a32c30b64f04ab$var$error() {
    var _devMessageSet3;
    for(var _len2 = arguments.length, messages = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)messages[_key2] = arguments[_key2];
    const message = "Floating UI: " + messages.join(' ');
    if (!((_devMessageSet3 = $a2a32c30b64f04ab$var$devMessageSet) != null && _devMessageSet3.has(message))) {
        var _devMessageSet4;
        (_devMessageSet4 = $a2a32c30b64f04ab$var$devMessageSet) == null || _devMessageSet4.add(message);
        console.error(message);
    }
}
/**
 * Renders a pointing arrow triangle.
 * @see https://floating-ui.com/docs/FloatingArrow
 */ const $a2a32c30b64f04ab$export$33511391554732bc = /*#__PURE__*/ $8NFma.forwardRef(function FloatingArrow(props, ref) {
    const { context: { placement: placement, elements: { floating: floating }, middlewareData: { arrow: arrow, shift: shift } }, width: width = 14, height: height = 7, tipRadius: tipRadius = 0, strokeWidth: strokeWidth = 0, staticOffset: staticOffset, stroke: stroke, d: d, style: { transform: transform, ...restStyle } = {}, ...rest } = props;
    const clipPathId = $a2a32c30b64f04ab$export$f680877a34711e37();
    const [isRTL, setIsRTL] = $8NFma.useState(false);
    // https://github.com/floating-ui/floating-ui/issues/2932
    $a2a32c30b64f04ab$var$index(()=>{
        if (!floating) return;
        const isRTL = (0, $1D9S2.getComputedStyle)(floating).direction === 'rtl';
        if (isRTL) setIsRTL(true);
    }, [
        floating
    ]);
    if (!floating) return null;
    const [side, alignment] = placement.split('-');
    const isVerticalSide = side === 'top' || side === 'bottom';
    let computedStaticOffset = staticOffset;
    if (isVerticalSide && shift != null && shift.x || !isVerticalSide && shift != null && shift.y) computedStaticOffset = null;
    // Strokes must be double the border width, this ensures the stroke's width
    // works as you'd expect.
    const computedStrokeWidth = strokeWidth * 2;
    const halfStrokeWidth = computedStrokeWidth / 2;
    const svgX = width / 2 * (tipRadius / -8 + 1);
    const svgY = height / 2 * tipRadius / 4;
    const isCustomShape = !!d;
    const yOffsetProp = computedStaticOffset && alignment === 'end' ? 'bottom' : 'top';
    let xOffsetProp = computedStaticOffset && alignment === 'end' ? 'right' : 'left';
    if (computedStaticOffset && isRTL) xOffsetProp = alignment === 'end' ? 'left' : 'right';
    const arrowX = (arrow == null ? void 0 : arrow.x) != null ? computedStaticOffset || arrow.x : '';
    const arrowY = (arrow == null ? void 0 : arrow.y) != null ? computedStaticOffset || arrow.y : '';
    const dValue = d || 'M0,0' + (" H" + width) + (" L" + (width - svgX) + "," + (height - svgY)) + (" Q" + width / 2 + "," + height + " " + svgX + "," + (height - svgY)) + ' Z';
    const rotation = {
        top: isCustomShape ? 'rotate(180deg)' : '',
        left: isCustomShape ? 'rotate(90deg)' : 'rotate(-90deg)',
        bottom: isCustomShape ? '' : 'rotate(180deg)',
        right: isCustomShape ? 'rotate(-90deg)' : 'rotate(90deg)'
    }[side];
    return /*#__PURE__*/ $8NFma.createElement("svg", $a2a32c30b64f04ab$var$_extends({}, rest, {
        "aria-hidden": true,
        ref: ref,
        width: isCustomShape ? width : width + computedStrokeWidth,
        height: width,
        viewBox: "0 0 " + width + " " + (height > width ? height : width),
        style: {
            position: 'absolute',
            pointerEvents: 'none',
            [xOffsetProp]: arrowX,
            [yOffsetProp]: arrowY,
            [side]: isVerticalSide || isCustomShape ? '100%' : "calc(100% - " + computedStrokeWidth / 2 + "px)",
            transform: [
                rotation,
                transform
            ].filter((t)=>!!t).join(' '),
            ...restStyle
        }
    }), computedStrokeWidth > 0 && /*#__PURE__*/ $8NFma.createElement("path", {
        clipPath: "url(#" + clipPathId + ")",
        fill: "none",
        stroke: stroke,
        strokeWidth: computedStrokeWidth + (d ? 0 : 1),
        d: dValue
    }), /*#__PURE__*/ $8NFma.createElement("path", {
        stroke: computedStrokeWidth && !d ? rest.fill : 'none',
        d: dValue
    }), /*#__PURE__*/ $8NFma.createElement("clipPath", {
        id: clipPathId
    }, /*#__PURE__*/ $8NFma.createElement("rect", {
        x: -halfStrokeWidth,
        y: halfStrokeWidth * (isCustomShape ? -1 : 1),
        width: width + computedStrokeWidth,
        height: width
    })));
});
function $a2a32c30b64f04ab$var$createPubSub() {
    const map = new Map();
    return {
        emit (event, data) {
            var _map$get;
            (_map$get = map.get(event)) == null || _map$get.forEach((handler)=>handler(data));
        },
        on (event, listener) {
            map.set(event, [
                ...map.get(event) || [],
                listener
            ]);
        },
        off (event, listener) {
            var _map$get2;
            map.set(event, ((_map$get2 = map.get(event)) == null ? void 0 : _map$get2.filter((l)=>l !== listener)) || []);
        }
    };
}
const $a2a32c30b64f04ab$var$FloatingNodeContext = /*#__PURE__*/ $8NFma.createContext(null);
const $a2a32c30b64f04ab$var$FloatingTreeContext = /*#__PURE__*/ $8NFma.createContext(null);
/**
 * Returns the parent node id for nested floating elements, if available.
 * Returns `null` for top-level floating elements.
 */ const $a2a32c30b64f04ab$export$165209eae06d3488 = ()=>{
    var _React$useContext;
    return ((_React$useContext = $8NFma.useContext($a2a32c30b64f04ab$var$FloatingNodeContext)) == null ? void 0 : _React$useContext.id) || null;
};
/**
 * Returns the nearest floating tree context, if available.
 */ const $a2a32c30b64f04ab$export$db0c2a7c7a2a4f69 = ()=>$8NFma.useContext($a2a32c30b64f04ab$var$FloatingTreeContext);
/**
 * Registers a node into the `FloatingTree`, returning its id.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $a2a32c30b64f04ab$export$9b136e0e758a42f4(customParentId) {
    const id = $a2a32c30b64f04ab$export$f680877a34711e37();
    const tree = $a2a32c30b64f04ab$export$db0c2a7c7a2a4f69();
    const reactParentId = $a2a32c30b64f04ab$export$165209eae06d3488();
    const parentId = customParentId || reactParentId;
    $a2a32c30b64f04ab$var$index(()=>{
        const node = {
            id: id,
            parentId: parentId
        };
        tree == null || tree.addNode(node);
        return ()=>{
            tree == null || tree.removeNode(node);
        };
    }, [
        tree,
        id,
        parentId
    ]);
    return id;
}
/**
 * Provides parent node context for nested floating elements.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $a2a32c30b64f04ab$export$ca00a83b5b253862(props) {
    const { children: children, id: id } = props;
    const parentId = $a2a32c30b64f04ab$export$165209eae06d3488();
    return /*#__PURE__*/ $8NFma.createElement($a2a32c30b64f04ab$var$FloatingNodeContext.Provider, {
        value: $8NFma.useMemo(()=>({
                id: id,
                parentId: parentId
            }), [
            id,
            parentId
        ])
    }, children);
}
/**
 * Provides context for nested floating elements when they are not children of
 * each other on the DOM.
 * This is not necessary in all cases, except when there must be explicit communication between parent and child floating elements. It is necessary for:
 * - The `bubbles` option in the `useDismiss()` Hook
 * - Nested virtual list navigation
 * - Nested floating elements that each open on hover
 * - Custom communication between parent and child floating elements
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $a2a32c30b64f04ab$export$587b60129641c4c8(props) {
    const { children: children } = props;
    const nodesRef = $8NFma.useRef([]);
    const addNode = $8NFma.useCallback((node)=>{
        nodesRef.current = [
            ...nodesRef.current,
            node
        ];
    }, []);
    const removeNode = $8NFma.useCallback((node)=>{
        nodesRef.current = nodesRef.current.filter((n)=>n !== node);
    }, []);
    const events = $8NFma.useState(()=>$a2a32c30b64f04ab$var$createPubSub())[0];
    return /*#__PURE__*/ $8NFma.createElement($a2a32c30b64f04ab$var$FloatingTreeContext.Provider, {
        value: $8NFma.useMemo(()=>({
                nodesRef: nodesRef,
                addNode: addNode,
                removeNode: removeNode,
                events: events
            }), [
            addNode,
            removeNode,
            events
        ])
    }, children);
}
function $a2a32c30b64f04ab$var$createAttribute(name) {
    return "data-floating-ui-" + name;
}
function $a2a32c30b64f04ab$var$useLatestRef(value) {
    const ref = (0, $8NFma.useRef)(value);
    $a2a32c30b64f04ab$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
const $a2a32c30b64f04ab$var$safePolygonIdentifier = /*#__PURE__*/ $a2a32c30b64f04ab$var$createAttribute('safe-polygon');
function $a2a32c30b64f04ab$var$getDelay(value, prop, pointerType) {
    if (pointerType && !(0, $hn8gG.isMouseLikePointerType)(pointerType)) return 0;
    if (typeof value === 'number') return value;
    return value == null ? void 0 : value[prop];
}
/**
 * Opens the floating element while hovering over the reference element, like
 * CSS `:hover`.
 * @see https://floating-ui.com/docs/useHover
 */ function $a2a32c30b64f04ab$export$ae780daf29e6d456(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, dataRef: dataRef, events: events, elements: elements } = context;
    const { enabled: enabled = true, delay: delay = 0, handleClose: handleClose = null, mouseOnly: mouseOnly = false, restMs: restMs = 0, move: move = true } = props;
    const tree = $a2a32c30b64f04ab$export$db0c2a7c7a2a4f69();
    const parentId = $a2a32c30b64f04ab$export$165209eae06d3488();
    const handleCloseRef = $a2a32c30b64f04ab$var$useLatestRef(handleClose);
    const delayRef = $a2a32c30b64f04ab$var$useLatestRef(delay);
    const openRef = $a2a32c30b64f04ab$var$useLatestRef(open);
    const pointerTypeRef = $8NFma.useRef();
    const timeoutRef = $8NFma.useRef(-1);
    const handlerRef = $8NFma.useRef();
    const restTimeoutRef = $8NFma.useRef(-1);
    const blockMouseMoveRef = $8NFma.useRef(true);
    const performedPointerEventsMutationRef = $8NFma.useRef(false);
    const unbindMouseMoveRef = $8NFma.useRef(()=>{});
    const restTimeoutPendingRef = $8NFma.useRef(false);
    const isHoverOpen = $8NFma.useCallback(()=>{
        var _dataRef$current$open;
        const type = (_dataRef$current$open = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open.type;
        return (type == null ? void 0 : type.includes('mouse')) && type !== 'mousedown';
    }, [
        dataRef
    ]);
    // When closing before opening, clear the delay timeouts to cancel it
    // from showing.
    $8NFma.useEffect(()=>{
        if (!enabled) return;
        function onOpenChange(_ref) {
            let { open: open } = _ref;
            if (!open) {
                clearTimeout(timeoutRef.current);
                clearTimeout(restTimeoutRef.current);
                blockMouseMoveRef.current = true;
                restTimeoutPendingRef.current = false;
            }
        }
        events.on('openchange', onOpenChange);
        return ()=>{
            events.off('openchange', onOpenChange);
        };
    }, [
        enabled,
        events
    ]);
    $8NFma.useEffect(()=>{
        if (!enabled) return;
        if (!handleCloseRef.current) return;
        if (!open) return;
        function onLeave(event) {
            if (isHoverOpen()) onOpenChange(false, event, 'hover');
        }
        const html = (0, $hn8gG.getDocument)(elements.floating).documentElement;
        html.addEventListener('mouseleave', onLeave);
        return ()=>{
            html.removeEventListener('mouseleave', onLeave);
        };
    }, [
        elements.floating,
        open,
        onOpenChange,
        enabled,
        handleCloseRef,
        isHoverOpen
    ]);
    const closeWithDelay = $8NFma.useCallback(function(event, runElseBranch, reason) {
        if (runElseBranch === void 0) runElseBranch = true;
        if (reason === void 0) reason = 'hover';
        const closeDelay = $a2a32c30b64f04ab$var$getDelay(delayRef.current, 'close', pointerTypeRef.current);
        if (closeDelay && !handlerRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = window.setTimeout(()=>onOpenChange(false, event, reason), closeDelay);
        } else if (runElseBranch) {
            clearTimeout(timeoutRef.current);
            onOpenChange(false, event, reason);
        }
    }, [
        delayRef,
        onOpenChange
    ]);
    const cleanupMouseMoveHandler = $a2a32c30b64f04ab$var$useEffectEvent(()=>{
        unbindMouseMoveRef.current();
        handlerRef.current = undefined;
    });
    const clearPointerEvents = $a2a32c30b64f04ab$var$useEffectEvent(()=>{
        if (performedPointerEventsMutationRef.current) {
            const body = (0, $hn8gG.getDocument)(elements.floating).body;
            body.style.pointerEvents = '';
            body.removeAttribute($a2a32c30b64f04ab$var$safePolygonIdentifier);
            performedPointerEventsMutationRef.current = false;
        }
    });
    // Registering the mouse events on the reference directly to bypass React's
    // delegation system. If the cursor was on a disabled element and then entered
    // the reference (no gap), `mouseenter` doesn't fire in the delegation system.
    $8NFma.useEffect(()=>{
        if (!enabled) return;
        function isClickLikeOpenEvent() {
            return dataRef.current.openEvent ? [
                'click',
                'mousedown'
            ].includes(dataRef.current.openEvent.type) : false;
        }
        function onMouseEnter(event) {
            clearTimeout(timeoutRef.current);
            blockMouseMoveRef.current = false;
            if (mouseOnly && !(0, $hn8gG.isMouseLikePointerType)(pointerTypeRef.current) || restMs > 0 && !$a2a32c30b64f04ab$var$getDelay(delayRef.current, 'open')) return;
            const openDelay = $a2a32c30b64f04ab$var$getDelay(delayRef.current, 'open', pointerTypeRef.current);
            if (openDelay) timeoutRef.current = window.setTimeout(()=>{
                if (!openRef.current) onOpenChange(true, event, 'hover');
            }, openDelay);
            else onOpenChange(true, event, 'hover');
        }
        function onMouseLeave(event) {
            if (isClickLikeOpenEvent()) return;
            unbindMouseMoveRef.current();
            const doc = (0, $hn8gG.getDocument)(elements.floating);
            clearTimeout(restTimeoutRef.current);
            restTimeoutPendingRef.current = false;
            if (handleCloseRef.current && dataRef.current.floatingContext) {
                // Prevent clearing `onScrollMouseLeave` timeout.
                if (!open) clearTimeout(timeoutRef.current);
                handlerRef.current = handleCloseRef.current({
                    ...dataRef.current.floatingContext,
                    tree: tree,
                    x: event.clientX,
                    y: event.clientY,
                    onClose () {
                        clearPointerEvents();
                        cleanupMouseMoveHandler();
                        closeWithDelay(event, true, 'safe-polygon');
                    }
                });
                const handler = handlerRef.current;
                doc.addEventListener('mousemove', handler);
                unbindMouseMoveRef.current = ()=>{
                    doc.removeEventListener('mousemove', handler);
                };
                return;
            }
            // Allow interactivity without `safePolygon` on touch devices. With a
            // pointer, a short close delay is an alternative, so it should work
            // consistently.
            const shouldClose = pointerTypeRef.current === 'touch' ? !(0, $hn8gG.contains)(elements.floating, event.relatedTarget) : true;
            if (shouldClose) closeWithDelay(event);
        }
        // Ensure the floating element closes after scrolling even if the pointer
        // did not move.
        // https://github.com/floating-ui/floating-ui/discussions/1692
        function onScrollMouseLeave(event) {
            if (isClickLikeOpenEvent()) return;
            if (!dataRef.current.floatingContext) return;
            handleCloseRef.current == null || handleCloseRef.current({
                ...dataRef.current.floatingContext,
                tree: tree,
                x: event.clientX,
                y: event.clientY,
                onClose () {
                    clearPointerEvents();
                    cleanupMouseMoveHandler();
                    closeWithDelay(event);
                }
            })(event);
        }
        if ((0, $1D9S2.isElement)(elements.domReference)) {
            var _elements$floating;
            const ref = elements.domReference;
            open && ref.addEventListener('mouseleave', onScrollMouseLeave);
            (_elements$floating = elements.floating) == null || _elements$floating.addEventListener('mouseleave', onScrollMouseLeave);
            move && ref.addEventListener('mousemove', onMouseEnter, {
                once: true
            });
            ref.addEventListener('mouseenter', onMouseEnter);
            ref.addEventListener('mouseleave', onMouseLeave);
            return ()=>{
                var _elements$floating2;
                open && ref.removeEventListener('mouseleave', onScrollMouseLeave);
                (_elements$floating2 = elements.floating) == null || _elements$floating2.removeEventListener('mouseleave', onScrollMouseLeave);
                move && ref.removeEventListener('mousemove', onMouseEnter);
                ref.removeEventListener('mouseenter', onMouseEnter);
                ref.removeEventListener('mouseleave', onMouseLeave);
            };
        }
    }, [
        elements,
        enabled,
        context,
        mouseOnly,
        restMs,
        move,
        closeWithDelay,
        cleanupMouseMoveHandler,
        clearPointerEvents,
        onOpenChange,
        open,
        openRef,
        tree,
        delayRef,
        handleCloseRef,
        dataRef
    ]);
    // Block pointer-events of every element other than the reference and floating
    // while the floating element is open and has a `handleClose` handler. Also
    // handles nested floating elements.
    // https://github.com/floating-ui/floating-ui/issues/1722
    $a2a32c30b64f04ab$var$index(()=>{
        var _handleCloseRef$curre;
        if (!enabled) return;
        if (open && (_handleCloseRef$curre = handleCloseRef.current) != null && _handleCloseRef$curre.__options.blockPointerEvents && isHoverOpen()) {
            performedPointerEventsMutationRef.current = true;
            const floatingEl = elements.floating;
            if ((0, $1D9S2.isElement)(elements.domReference) && floatingEl) {
                var _tree$nodesRef$curren;
                const body = (0, $hn8gG.getDocument)(elements.floating).body;
                body.setAttribute($a2a32c30b64f04ab$var$safePolygonIdentifier, '');
                const ref = elements.domReference;
                const parentFloating = tree == null || (_tree$nodesRef$curren = tree.nodesRef.current.find((node)=>node.id === parentId)) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.context) == null ? void 0 : _tree$nodesRef$curren.elements.floating;
                if (parentFloating) parentFloating.style.pointerEvents = '';
                body.style.pointerEvents = 'none';
                ref.style.pointerEvents = 'auto';
                floatingEl.style.pointerEvents = 'auto';
                return ()=>{
                    body.style.pointerEvents = '';
                    ref.style.pointerEvents = '';
                    floatingEl.style.pointerEvents = '';
                };
            }
        }
    }, [
        enabled,
        open,
        parentId,
        elements,
        tree,
        handleCloseRef,
        isHoverOpen
    ]);
    $a2a32c30b64f04ab$var$index(()=>{
        if (!open) {
            pointerTypeRef.current = undefined;
            restTimeoutPendingRef.current = false;
            cleanupMouseMoveHandler();
            clearPointerEvents();
        }
    }, [
        open,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    $8NFma.useEffect(()=>{
        return ()=>{
            cleanupMouseMoveHandler();
            clearTimeout(timeoutRef.current);
            clearTimeout(restTimeoutRef.current);
            clearPointerEvents();
        };
    }, [
        enabled,
        elements.domReference,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    const reference = $8NFma.useMemo(()=>{
        function setPointerRef(event) {
            pointerTypeRef.current = event.pointerType;
        }
        return {
            onPointerDown: setPointerRef,
            onPointerEnter: setPointerRef,
            onMouseMove (event) {
                const { nativeEvent: nativeEvent } = event;
                function handleMouseMove() {
                    if (!blockMouseMoveRef.current && !openRef.current) onOpenChange(true, nativeEvent, 'hover');
                }
                if (mouseOnly && !(0, $hn8gG.isMouseLikePointerType)(pointerTypeRef.current)) return;
                if (open || restMs === 0) return;
                // Ignore insignificant movements to account for tremors.
                if (restTimeoutPendingRef.current && event.movementX ** 2 + event.movementY ** 2 < 2) return;
                clearTimeout(restTimeoutRef.current);
                if (pointerTypeRef.current === 'touch') handleMouseMove();
                else {
                    restTimeoutPendingRef.current = true;
                    restTimeoutRef.current = window.setTimeout(handleMouseMove, restMs);
                }
            }
        };
    }, [
        mouseOnly,
        onOpenChange,
        open,
        openRef,
        restMs
    ]);
    const floating = $8NFma.useMemo(()=>({
            onMouseEnter () {
                clearTimeout(timeoutRef.current);
            },
            onMouseLeave (event) {
                closeWithDelay(event.nativeEvent, false);
            }
        }), [
        closeWithDelay
    ]);
    return $8NFma.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
const $a2a32c30b64f04ab$var$NOOP = ()=>{};
const $a2a32c30b64f04ab$var$FloatingDelayGroupContext = /*#__PURE__*/ $8NFma.createContext({
    delay: 0,
    initialDelay: 0,
    timeoutMs: 0,
    currentId: null,
    setCurrentId: $a2a32c30b64f04ab$var$NOOP,
    setState: $a2a32c30b64f04ab$var$NOOP,
    isInstantPhase: false
});
/**
 * @deprecated
 * Use the return value of `useDelayGroup()` instead.
 */ const $a2a32c30b64f04ab$export$e2411914b150383d = ()=>$8NFma.useContext($a2a32c30b64f04ab$var$FloatingDelayGroupContext);
/**
 * Provides context for a group of floating elements that should share a
 * `delay`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $a2a32c30b64f04ab$export$718279509ff1e241(props) {
    const { children: children, delay: delay, timeoutMs: timeoutMs = 0 } = props;
    const [state, setState] = $8NFma.useReducer((prev, next)=>({
            ...prev,
            ...next
        }), {
        delay: delay,
        timeoutMs: timeoutMs,
        initialDelay: delay,
        currentId: null,
        isInstantPhase: false
    });
    const initialCurrentIdRef = $8NFma.useRef(null);
    const setCurrentId = $8NFma.useCallback((currentId)=>{
        setState({
            currentId: currentId
        });
    }, []);
    $a2a32c30b64f04ab$var$index(()=>{
        if (state.currentId) {
            if (initialCurrentIdRef.current === null) initialCurrentIdRef.current = state.currentId;
            else if (!state.isInstantPhase) setState({
                isInstantPhase: true
            });
        } else {
            if (state.isInstantPhase) setState({
                isInstantPhase: false
            });
            initialCurrentIdRef.current = null;
        }
    }, [
        state.currentId,
        state.isInstantPhase
    ]);
    return /*#__PURE__*/ $8NFma.createElement($a2a32c30b64f04ab$var$FloatingDelayGroupContext.Provider, {
        value: $8NFma.useMemo(()=>({
                ...state,
                setState: setState,
                setCurrentId: setCurrentId
            }), [
            state,
            setCurrentId
        ])
    }, children);
}
/**
 * Enables grouping when called inside a component that's a child of a
 * `FloatingDelayGroup`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $a2a32c30b64f04ab$export$560fc8be89c8b4a8(context, options) {
    if (options === void 0) options = {};
    const { open: open, onOpenChange: onOpenChange, floatingId: floatingId } = context;
    const { id: optionId, enabled: enabled = true } = options;
    const id = optionId != null ? optionId : floatingId;
    const groupContext = $a2a32c30b64f04ab$export$e2411914b150383d();
    const { currentId: currentId, setCurrentId: setCurrentId, initialDelay: initialDelay, setState: setState, timeoutMs: timeoutMs } = groupContext;
    $a2a32c30b64f04ab$var$index(()=>{
        if (!enabled) return;
        if (!currentId) return;
        setState({
            delay: {
                open: 1,
                close: $a2a32c30b64f04ab$var$getDelay(initialDelay, 'close')
            }
        });
        if (currentId !== id) onOpenChange(false);
    }, [
        enabled,
        id,
        onOpenChange,
        setState,
        currentId,
        initialDelay
    ]);
    $a2a32c30b64f04ab$var$index(()=>{
        function unset() {
            onOpenChange(false);
            setState({
                delay: initialDelay,
                currentId: null
            });
        }
        if (!enabled) return;
        if (!currentId) return;
        if (!open && currentId === id) {
            if (timeoutMs) {
                const timeout = window.setTimeout(unset, timeoutMs);
                return ()=>{
                    clearTimeout(timeout);
                };
            }
            unset();
        }
    }, [
        enabled,
        open,
        setState,
        currentId,
        id,
        onOpenChange,
        initialDelay,
        timeoutMs
    ]);
    $a2a32c30b64f04ab$var$index(()=>{
        if (!enabled) return;
        if (setCurrentId === $a2a32c30b64f04ab$var$NOOP || !open) return;
        setCurrentId(id);
    }, [
        enabled,
        open,
        setCurrentId,
        id
    ]);
    return groupContext;
}
function $a2a32c30b64f04ab$var$getAncestors(nodes, id) {
    var _nodes$find;
    let allAncestors = [];
    let currentParentId = (_nodes$find = nodes.find((node)=>node.id === id)) == null ? void 0 : _nodes$find.parentId;
    while(currentParentId){
        const currentNode = nodes.find((node)=>node.id === currentParentId);
        currentParentId = currentNode == null ? void 0 : currentNode.parentId;
        if (currentNode) allAncestors = allAncestors.concat(currentNode);
    }
    return allAncestors;
}
function $a2a32c30b64f04ab$var$getChildren(nodes, id) {
    let allChildren = nodes.filter((node)=>{
        var _node$context;
        return node.parentId === id && ((_node$context = node.context) == null ? void 0 : _node$context.open);
    });
    let currentChildren = allChildren;
    while(currentChildren.length){
        currentChildren = nodes.filter((node)=>{
            var _currentChildren;
            return (_currentChildren = currentChildren) == null ? void 0 : _currentChildren.some((n)=>{
                var _node$context2;
                return node.parentId === n.id && ((_node$context2 = node.context) == null ? void 0 : _node$context2.open);
            });
        });
        allChildren = allChildren.concat(currentChildren);
    }
    return allChildren;
}
function $a2a32c30b64f04ab$var$getDeepestNode(nodes, id) {
    let deepestNodeId;
    let maxDepth = -1;
    function findDeepest(nodeId, depth) {
        if (depth > maxDepth) {
            deepestNodeId = nodeId;
            maxDepth = depth;
        }
        const children = $a2a32c30b64f04ab$var$getChildren(nodes, nodeId);
        children.forEach((child)=>{
            findDeepest(child.id, depth + 1);
        });
    }
    findDeepest(id, 0);
    return nodes.find((node)=>node.id === deepestNodeId);
}
// Modified to add conditional `aria-hidden` support:
// https://github.com/theKashey/aria-hidden/blob/9220c8f4a4fd35f63bee5510a9f41a37264382d4/src/index.ts
let $a2a32c30b64f04ab$var$counterMap = /*#__PURE__*/ new WeakMap();
let $a2a32c30b64f04ab$var$uncontrolledElementsSet = /*#__PURE__*/ new WeakSet();
let $a2a32c30b64f04ab$var$markerMap = {};
let $a2a32c30b64f04ab$var$lockCount$1 = 0;
const $a2a32c30b64f04ab$var$supportsInert = ()=>typeof HTMLElement !== 'undefined' && 'inert' in HTMLElement.prototype;
const $a2a32c30b64f04ab$var$unwrapHost = (node)=>node && (node.host || $a2a32c30b64f04ab$var$unwrapHost(node.parentNode));
const $a2a32c30b64f04ab$var$correctElements = (parent, targets)=>targets.map((target)=>{
        if (parent.contains(target)) return target;
        const correctedTarget = $a2a32c30b64f04ab$var$unwrapHost(target);
        if (parent.contains(correctedTarget)) return correctedTarget;
        return null;
    }).filter((x)=>x != null);
function $a2a32c30b64f04ab$var$applyAttributeToOthers(uncorrectedAvoidElements, body, ariaHidden, inert) {
    const markerName = 'data-floating-ui-inert';
    const controlAttribute = inert ? 'inert' : ariaHidden ? 'aria-hidden' : null;
    const avoidElements = $a2a32c30b64f04ab$var$correctElements(body, uncorrectedAvoidElements);
    const elementsToKeep = new Set();
    const elementsToStop = new Set(avoidElements);
    const hiddenElements = [];
    if (!$a2a32c30b64f04ab$var$markerMap[markerName]) $a2a32c30b64f04ab$var$markerMap[markerName] = new WeakMap();
    const markerCounter = $a2a32c30b64f04ab$var$markerMap[markerName];
    avoidElements.forEach(keep);
    deep(body);
    elementsToKeep.clear();
    function keep(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        el.parentNode && keep(el.parentNode);
    }
    function deep(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        [].forEach.call(parent.children, (node)=>{
            if ((0, $1D9S2.getNodeName)(node) === 'script') return;
            if (elementsToKeep.has(node)) deep(node);
            else {
                const attr = controlAttribute ? node.getAttribute(controlAttribute) : null;
                const alreadyHidden = attr !== null && attr !== 'false';
                const counterValue = ($a2a32c30b64f04ab$var$counterMap.get(node) || 0) + 1;
                const markerValue = (markerCounter.get(node) || 0) + 1;
                $a2a32c30b64f04ab$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenElements.push(node);
                if (counterValue === 1 && alreadyHidden) $a2a32c30b64f04ab$var$uncontrolledElementsSet.add(node);
                if (markerValue === 1) node.setAttribute(markerName, '');
                if (!alreadyHidden && controlAttribute) node.setAttribute(controlAttribute, 'true');
            }
        });
    }
    $a2a32c30b64f04ab$var$lockCount$1++;
    return ()=>{
        hiddenElements.forEach((element)=>{
            const counterValue = ($a2a32c30b64f04ab$var$counterMap.get(element) || 0) - 1;
            const markerValue = (markerCounter.get(element) || 0) - 1;
            $a2a32c30b64f04ab$var$counterMap.set(element, counterValue);
            markerCounter.set(element, markerValue);
            if (!counterValue) {
                if (!$a2a32c30b64f04ab$var$uncontrolledElementsSet.has(element) && controlAttribute) element.removeAttribute(controlAttribute);
                $a2a32c30b64f04ab$var$uncontrolledElementsSet.delete(element);
            }
            if (!markerValue) element.removeAttribute(markerName);
        });
        $a2a32c30b64f04ab$var$lockCount$1--;
        if (!$a2a32c30b64f04ab$var$lockCount$1) {
            $a2a32c30b64f04ab$var$counterMap = new WeakMap();
            $a2a32c30b64f04ab$var$counterMap = new WeakMap();
            $a2a32c30b64f04ab$var$uncontrolledElementsSet = new WeakSet();
            $a2a32c30b64f04ab$var$markerMap = {};
        }
    };
}
function $a2a32c30b64f04ab$var$markOthers(avoidElements, ariaHidden, inert) {
    if (ariaHidden === void 0) ariaHidden = false;
    if (inert === void 0) inert = false;
    const body = (0, $hn8gG.getDocument)(avoidElements[0]).body;
    return $a2a32c30b64f04ab$var$applyAttributeToOthers(avoidElements.concat(Array.from(body.querySelectorAll('[aria-live]'))), body, ariaHidden, inert);
}
const $a2a32c30b64f04ab$var$getTabbableOptions = ()=>({
        getShadowRoot: true,
        displayCheck: // JSDOM does not support the `tabbable` library. To solve this we can
        // check if `ResizeObserver` is a real function (not polyfilled), which
        // determines if the current environment is JSDOM-like.
        typeof ResizeObserver === 'function' && ResizeObserver.toString().includes('[native code]') ? 'full' : 'none'
    });
function $a2a32c30b64f04ab$var$getTabbableIn(container, direction) {
    const allTabbable = (0, $6X8j6.tabbable)(container, $a2a32c30b64f04ab$var$getTabbableOptions());
    if (direction === 'prev') allTabbable.reverse();
    const activeIndex = allTabbable.indexOf((0, $hn8gG.activeElement)((0, $hn8gG.getDocument)(container)));
    const nextTabbableElements = allTabbable.slice(activeIndex + 1);
    return nextTabbableElements[0];
}
function $a2a32c30b64f04ab$var$getNextTabbable() {
    return $a2a32c30b64f04ab$var$getTabbableIn(document.body, 'next');
}
function $a2a32c30b64f04ab$var$getPreviousTabbable() {
    return $a2a32c30b64f04ab$var$getTabbableIn(document.body, 'prev');
}
function $a2a32c30b64f04ab$var$isOutsideEvent(event, container) {
    const containerElement = container || event.currentTarget;
    const relatedTarget = event.relatedTarget;
    return !relatedTarget || !(0, $hn8gG.contains)(containerElement, relatedTarget);
}
function $a2a32c30b64f04ab$var$disableFocusInside(container) {
    const tabbableElements = (0, $6X8j6.tabbable)(container, $a2a32c30b64f04ab$var$getTabbableOptions());
    tabbableElements.forEach((element)=>{
        element.dataset.tabindex = element.getAttribute('tabindex') || '';
        element.setAttribute('tabindex', '-1');
    });
}
function $a2a32c30b64f04ab$var$enableFocusInside(container) {
    const elements = container.querySelectorAll('[data-tabindex]');
    elements.forEach((element)=>{
        const tabindex = element.dataset.tabindex;
        delete element.dataset.tabindex;
        if (tabindex) element.setAttribute('tabindex', tabindex);
        else element.removeAttribute('tabindex');
    });
}
// See Diego Haz's Sandbox for making this logic work well on Safari/iOS:
// https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/FocusTrap.tsx
const $a2a32c30b64f04ab$var$HIDDEN_STYLES = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'fixed',
    whiteSpace: 'nowrap',
    width: '1px',
    top: 0,
    left: 0
};
let $a2a32c30b64f04ab$var$timeoutId;
function $a2a32c30b64f04ab$var$setActiveElementOnTab(event) {
    if (event.key === 'Tab') {
        event.target;
        clearTimeout($a2a32c30b64f04ab$var$timeoutId);
    }
}
const $a2a32c30b64f04ab$var$FocusGuard = /*#__PURE__*/ $8NFma.forwardRef(function FocusGuard(props, ref) {
    const [role, setRole] = $8NFma.useState();
    $a2a32c30b64f04ab$var$index(()=>{
        if ((0, $hn8gG.isSafari)()) // Unlike other screen readers such as NVDA and JAWS, the virtual cursor
        // on VoiceOver does trigger the onFocus event, so we can use the focus
        // trap element. On Safari, only buttons trigger the onFocus event.
        // NB: "group" role in the Sandbox no longer appears to work, must be a
        // button role.
        setRole('button');
        document.addEventListener('keydown', $a2a32c30b64f04ab$var$setActiveElementOnTab);
        return ()=>{
            document.removeEventListener('keydown', $a2a32c30b64f04ab$var$setActiveElementOnTab);
        };
    }, []);
    const restProps = {
        ref: ref,
        tabIndex: 0,
        role: // Role is only for VoiceOver
        role,
        'aria-hidden': role ? undefined : true,
        [$a2a32c30b64f04ab$var$createAttribute('focus-guard')]: '',
        style: $a2a32c30b64f04ab$var$HIDDEN_STYLES
    };
    return /*#__PURE__*/ $8NFma.createElement("span", $a2a32c30b64f04ab$var$_extends({}, props, restProps));
});
const $a2a32c30b64f04ab$var$PortalContext = /*#__PURE__*/ $8NFma.createContext(null);
const $a2a32c30b64f04ab$var$attr = /*#__PURE__*/ $a2a32c30b64f04ab$var$createAttribute('portal');
/**
 * @see https://floating-ui.com/docs/FloatingPortal#usefloatingportalnode
 */ function $a2a32c30b64f04ab$export$ac107512f3c5cca6(props) {
    if (props === void 0) props = {};
    const { id: id, root: root } = props;
    const uniqueId = $a2a32c30b64f04ab$export$f680877a34711e37();
    const portalContext = $a2a32c30b64f04ab$var$usePortalContext();
    const [portalNode, setPortalNode] = $8NFma.useState(null);
    const portalNodeRef = $8NFma.useRef(null);
    $a2a32c30b64f04ab$var$index(()=>{
        return ()=>{
            portalNode == null || portalNode.remove();
            // Allow the subsequent layout effects to create a new node on updates.
            // The portal node will still be cleaned up on unmount.
            // https://github.com/floating-ui/floating-ui/issues/2454
            queueMicrotask(()=>{
                portalNodeRef.current = null;
            });
        };
    }, [
        portalNode
    ]);
    $a2a32c30b64f04ab$var$index(()=>{
        // Wait for the uniqueId to be generated before creating the portal node in
        // React <18 (using `useFloatingId` instead of the native `useId`).
        // https://github.com/floating-ui/floating-ui/issues/2778
        if (!uniqueId) return;
        if (portalNodeRef.current) return;
        const existingIdRoot = id ? document.getElementById(id) : null;
        if (!existingIdRoot) return;
        const subRoot = document.createElement('div');
        subRoot.id = uniqueId;
        subRoot.setAttribute($a2a32c30b64f04ab$var$attr, '');
        existingIdRoot.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        uniqueId
    ]);
    $a2a32c30b64f04ab$var$index(()=>{
        // Wait for the root to exist before creating the portal node. The root must
        // be stored in state, not a ref, for this to work reactively.
        if (root === null) return;
        if (!uniqueId) return;
        if (portalNodeRef.current) return;
        let container = root || (portalContext == null ? void 0 : portalContext.portalNode);
        if (container && !(0, $1D9S2.isElement)(container)) container = container.current;
        container = container || document.body;
        let idWrapper = null;
        if (id) {
            idWrapper = document.createElement('div');
            idWrapper.id = id;
            container.appendChild(idWrapper);
        }
        const subRoot = document.createElement('div');
        subRoot.id = uniqueId;
        subRoot.setAttribute($a2a32c30b64f04ab$var$attr, '');
        container = idWrapper || container;
        container.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        root,
        uniqueId,
        portalContext
    ]);
    return portalNode;
}
/**
 * Portals the floating element into a given container element — by default,
 * outside of the app root and into the body.
 * This is necessary to ensure the floating element can appear outside any
 * potential parent containers that cause clipping (such as `overflow: hidden`),
 * while retaining its location in the React tree.
 * @see https://floating-ui.com/docs/FloatingPortal
 */ function $a2a32c30b64f04ab$export$31fa5d718fa2ac09(props) {
    const { children: children, id: id, root: root, preserveTabOrder: preserveTabOrder = true } = props;
    const portalNode = $a2a32c30b64f04ab$export$ac107512f3c5cca6({
        id: id,
        root: root
    });
    const [focusManagerState, setFocusManagerState] = $8NFma.useState(null);
    const beforeOutsideRef = $8NFma.useRef(null);
    const afterOutsideRef = $8NFma.useRef(null);
    const beforeInsideRef = $8NFma.useRef(null);
    const afterInsideRef = $8NFma.useRef(null);
    const modal = focusManagerState == null ? void 0 : focusManagerState.modal;
    const open = focusManagerState == null ? void 0 : focusManagerState.open;
    const shouldRenderGuards = // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!focusManagerState && // Guards are only for non-modal focus management.
    !focusManagerState.modal && // Don't render if unmount is transitioning.
    focusManagerState.open && preserveTabOrder && !!(root || portalNode);
    // https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/TabbablePortal.tsx
    $8NFma.useEffect(()=>{
        if (!portalNode || !preserveTabOrder || modal) return;
        // Make sure elements inside the portal element are tabbable only when the
        // portal has already been focused, either by tabbing into a focus trap
        // element outside or using the mouse.
        function onFocus(event) {
            if (portalNode && $a2a32c30b64f04ab$var$isOutsideEvent(event)) {
                const focusing = event.type === 'focusin';
                const manageFocus = focusing ? $a2a32c30b64f04ab$var$enableFocusInside : $a2a32c30b64f04ab$var$disableFocusInside;
                manageFocus(portalNode);
            }
        }
        // Listen to the event on the capture phase so they run before the focus
        // trap elements onFocus prop is called.
        portalNode.addEventListener('focusin', onFocus, true);
        portalNode.addEventListener('focusout', onFocus, true);
        return ()=>{
            portalNode.removeEventListener('focusin', onFocus, true);
            portalNode.removeEventListener('focusout', onFocus, true);
        };
    }, [
        portalNode,
        preserveTabOrder,
        modal
    ]);
    $8NFma.useEffect(()=>{
        if (!portalNode) return;
        if (open) return;
        $a2a32c30b64f04ab$var$enableFocusInside(portalNode);
    }, [
        open,
        portalNode
    ]);
    return /*#__PURE__*/ $8NFma.createElement($a2a32c30b64f04ab$var$PortalContext.Provider, {
        value: $8NFma.useMemo(()=>({
                preserveTabOrder: preserveTabOrder,
                beforeOutsideRef: beforeOutsideRef,
                afterOutsideRef: afterOutsideRef,
                beforeInsideRef: beforeInsideRef,
                afterInsideRef: afterInsideRef,
                portalNode: portalNode,
                setFocusManagerState: setFocusManagerState
            }), [
            preserveTabOrder,
            portalNode
        ])
    }, shouldRenderGuards && portalNode && /*#__PURE__*/ $8NFma.createElement($a2a32c30b64f04ab$var$FocusGuard, {
        "data-type": "outside",
        ref: beforeOutsideRef,
        onFocus: (event)=>{
            if ($a2a32c30b64f04ab$var$isOutsideEvent(event, portalNode)) {
                var _beforeInsideRef$curr;
                (_beforeInsideRef$curr = beforeInsideRef.current) == null || _beforeInsideRef$curr.focus();
            } else {
                const prevTabbable = $a2a32c30b64f04ab$var$getPreviousTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
                prevTabbable == null || prevTabbable.focus();
            }
        }
    }), shouldRenderGuards && portalNode && /*#__PURE__*/ $8NFma.createElement("span", {
        "aria-owns": portalNode.id,
        style: $a2a32c30b64f04ab$var$HIDDEN_STYLES
    }), portalNode && /*#__PURE__*/ $2pmb0.createPortal(children, portalNode), shouldRenderGuards && portalNode && /*#__PURE__*/ $8NFma.createElement($a2a32c30b64f04ab$var$FocusGuard, {
        "data-type": "outside",
        ref: afterOutsideRef,
        onFocus: (event)=>{
            if ($a2a32c30b64f04ab$var$isOutsideEvent(event, portalNode)) {
                var _afterInsideRef$curre;
                (_afterInsideRef$curre = afterInsideRef.current) == null || _afterInsideRef$curre.focus();
            } else {
                const nextTabbable = $a2a32c30b64f04ab$var$getNextTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
                nextTabbable == null || nextTabbable.focus();
                (focusManagerState == null ? void 0 : focusManagerState.closeOnFocusOut) && (focusManagerState == null || focusManagerState.onOpenChange(false, event.nativeEvent, 'focus-out'));
            }
        }
    }));
}
const $a2a32c30b64f04ab$var$usePortalContext = ()=>$8NFma.useContext($a2a32c30b64f04ab$var$PortalContext);
const $a2a32c30b64f04ab$var$FOCUSABLE_ATTRIBUTE = 'data-floating-ui-focusable';
function $a2a32c30b64f04ab$var$getFloatingFocusElement(floatingElement) {
    if (!floatingElement) return null;
    // Try to find the element that has `{...getFloatingProps()}` spread on it.
    // This indicates the floating element is acting as a positioning wrapper, and
    // so focus should be managed on the child element with the event handlers and
    // aria props.
    return floatingElement.hasAttribute($a2a32c30b64f04ab$var$FOCUSABLE_ATTRIBUTE) ? floatingElement : floatingElement.querySelector("[" + $a2a32c30b64f04ab$var$FOCUSABLE_ATTRIBUTE + "]") || floatingElement;
}
const $a2a32c30b64f04ab$var$LIST_LIMIT = 20;
let $a2a32c30b64f04ab$var$previouslyFocusedElements = [];
function $a2a32c30b64f04ab$var$addPreviouslyFocusedElement(element) {
    $a2a32c30b64f04ab$var$previouslyFocusedElements = $a2a32c30b64f04ab$var$previouslyFocusedElements.filter((el)=>el.isConnected);
    let tabbableEl = element;
    if (!tabbableEl || (0, $1D9S2.getNodeName)(tabbableEl) === 'body') return;
    if (!(0, $6X8j6.isTabbable)(tabbableEl, $a2a32c30b64f04ab$var$getTabbableOptions())) {
        const tabbableChild = (0, $6X8j6.tabbable)(tabbableEl, $a2a32c30b64f04ab$var$getTabbableOptions())[0];
        if (tabbableChild) tabbableEl = tabbableChild;
    }
    $a2a32c30b64f04ab$var$previouslyFocusedElements.push(tabbableEl);
    if ($a2a32c30b64f04ab$var$previouslyFocusedElements.length > $a2a32c30b64f04ab$var$LIST_LIMIT) $a2a32c30b64f04ab$var$previouslyFocusedElements = $a2a32c30b64f04ab$var$previouslyFocusedElements.slice(-$a2a32c30b64f04ab$var$LIST_LIMIT);
}
function $a2a32c30b64f04ab$var$getPreviouslyFocusedElement() {
    return $a2a32c30b64f04ab$var$previouslyFocusedElements.slice().reverse().find((el)=>el.isConnected);
}
const $a2a32c30b64f04ab$var$VisuallyHiddenDismiss = /*#__PURE__*/ $8NFma.forwardRef(function VisuallyHiddenDismiss(props, ref) {
    return /*#__PURE__*/ $8NFma.createElement("button", $a2a32c30b64f04ab$var$_extends({}, props, {
        type: "button",
        ref: ref,
        tabIndex: -1,
        style: $a2a32c30b64f04ab$var$HIDDEN_STYLES
    }));
});
/**
 * Provides focus management for the floating element.
 * @see https://floating-ui.com/docs/FloatingFocusManager
 */ function $a2a32c30b64f04ab$export$8aeee49171ded61a(props) {
    const { context: context, children: children, disabled: disabled = false, order: order = [
        'content'
    ], guards: _guards = true, initialFocus: initialFocus = 0, returnFocus: returnFocus = true, restoreFocus: restoreFocus = false, modal: modal = true, visuallyHiddenDismiss: visuallyHiddenDismiss = false, closeOnFocusOut: closeOnFocusOut = true } = props;
    const { open: open, refs: refs, nodeId: nodeId, onOpenChange: onOpenChange, events: events, dataRef: dataRef, floatingId: floatingId, elements: { domReference: domReference, floating: floating } } = context;
    const ignoreInitialFocus = typeof initialFocus === 'number' && initialFocus < 0;
    // If the reference is a combobox and is typeable (e.g. input/textarea),
    // there are different focus semantics. The guards should not be rendered, but
    // aria-hidden should be applied to all nodes still. Further, the visually
    // hidden dismiss button should only appear at the end of the list, not the
    // start.
    const isUntrappedTypeableCombobox = (0, $hn8gG.isTypeableCombobox)(domReference) && ignoreInitialFocus;
    // Force the guards to be rendered if the `inert` attribute is not supported.
    const guards = $a2a32c30b64f04ab$var$supportsInert() ? _guards : true;
    const orderRef = $a2a32c30b64f04ab$var$useLatestRef(order);
    const initialFocusRef = $a2a32c30b64f04ab$var$useLatestRef(initialFocus);
    const returnFocusRef = $a2a32c30b64f04ab$var$useLatestRef(returnFocus);
    const tree = $a2a32c30b64f04ab$export$db0c2a7c7a2a4f69();
    const portalContext = $a2a32c30b64f04ab$var$usePortalContext();
    const startDismissButtonRef = $8NFma.useRef(null);
    const endDismissButtonRef = $8NFma.useRef(null);
    const preventReturnFocusRef = $8NFma.useRef(false);
    const isPointerDownRef = $8NFma.useRef(false);
    const tabbableIndexRef = $8NFma.useRef(-1);
    const isInsidePortal = portalContext != null;
    const floatingFocusElement = $a2a32c30b64f04ab$var$getFloatingFocusElement(floating);
    const getTabbableContent = $a2a32c30b64f04ab$var$useEffectEvent(function(container) {
        if (container === void 0) container = floatingFocusElement;
        return container ? (0, $6X8j6.tabbable)(container, $a2a32c30b64f04ab$var$getTabbableOptions()) : [];
    });
    const getTabbableElements = $a2a32c30b64f04ab$var$useEffectEvent((container)=>{
        const content = getTabbableContent(container);
        return orderRef.current.map((type)=>{
            if (domReference && type === 'reference') return domReference;
            if (floatingFocusElement && type === 'floating') return floatingFocusElement;
            return content;
        }).filter(Boolean).flat();
    });
    $8NFma.useEffect(()=>{
        preventReturnFocusRef.current = false;
    }, [
        disabled
    ]);
    $8NFma.useEffect(()=>{
        if (disabled) return;
        if (!modal) return;
        function onKeyDown(event) {
            if (event.key === 'Tab') {
                // The focus guards have nothing to focus, so we need to stop the event.
                if ((0, $hn8gG.contains)(floatingFocusElement, (0, $hn8gG.activeElement)((0, $hn8gG.getDocument)(floatingFocusElement))) && getTabbableContent().length === 0 && !isUntrappedTypeableCombobox) (0, $hn8gG.stopEvent)(event);
                const els = getTabbableElements();
                const target = (0, $hn8gG.getTarget)(event);
                if (orderRef.current[0] === 'reference' && target === domReference) {
                    (0, $hn8gG.stopEvent)(event);
                    if (event.shiftKey) $a2a32c30b64f04ab$var$enqueueFocus(els[els.length - 1]);
                    else $a2a32c30b64f04ab$var$enqueueFocus(els[1]);
                }
                if (orderRef.current[1] === 'floating' && target === floatingFocusElement && event.shiftKey) {
                    (0, $hn8gG.stopEvent)(event);
                    $a2a32c30b64f04ab$var$enqueueFocus(els[0]);
                }
            }
        }
        const doc = (0, $hn8gG.getDocument)(floatingFocusElement);
        doc.addEventListener('keydown', onKeyDown);
        return ()=>{
            doc.removeEventListener('keydown', onKeyDown);
        };
    }, [
        disabled,
        domReference,
        floatingFocusElement,
        modal,
        orderRef,
        isUntrappedTypeableCombobox,
        getTabbableContent,
        getTabbableElements
    ]);
    $8NFma.useEffect(()=>{
        if (disabled) return;
        if (!floating) return;
        function handleFocusIn(event) {
            const target = (0, $hn8gG.getTarget)(event);
            const tabbableContent = getTabbableContent();
            const tabbableIndex = tabbableContent.indexOf(target);
            if (tabbableIndex !== -1) tabbableIndexRef.current = tabbableIndex;
        }
        floating.addEventListener('focusin', handleFocusIn);
        return ()=>{
            floating.removeEventListener('focusin', handleFocusIn);
        };
    }, [
        disabled,
        floating,
        getTabbableContent
    ]);
    $8NFma.useEffect(()=>{
        if (disabled) return;
        if (!closeOnFocusOut) return;
        // In Safari, buttons lose focus when pressing them.
        function handlePointerDown() {
            isPointerDownRef.current = true;
            setTimeout(()=>{
                isPointerDownRef.current = false;
            });
        }
        function handleFocusOutside(event) {
            const relatedTarget = event.relatedTarget;
            queueMicrotask(()=>{
                const movedToUnrelatedNode = !((0, $hn8gG.contains)(domReference, relatedTarget) || (0, $hn8gG.contains)(floating, relatedTarget) || (0, $hn8gG.contains)(relatedTarget, floating) || (0, $hn8gG.contains)(portalContext == null ? void 0 : portalContext.portalNode, relatedTarget) || relatedTarget != null && relatedTarget.hasAttribute($a2a32c30b64f04ab$var$createAttribute('focus-guard')) || tree && ($a2a32c30b64f04ab$var$getChildren(tree.nodesRef.current, nodeId).find((node)=>{
                    var _node$context, _node$context2;
                    return (0, $hn8gG.contains)((_node$context = node.context) == null ? void 0 : _node$context.elements.floating, relatedTarget) || (0, $hn8gG.contains)((_node$context2 = node.context) == null ? void 0 : _node$context2.elements.domReference, relatedTarget);
                }) || $a2a32c30b64f04ab$var$getAncestors(tree.nodesRef.current, nodeId).find((node)=>{
                    var _node$context3, _node$context4;
                    return ((_node$context3 = node.context) == null ? void 0 : _node$context3.elements.floating) === relatedTarget || ((_node$context4 = node.context) == null ? void 0 : _node$context4.elements.domReference) === relatedTarget;
                })));
                // Restore focus to the previous tabbable element index to prevent
                // focus from being lost outside the floating tree.
                if (restoreFocus && movedToUnrelatedNode && (0, $hn8gG.activeElement)((0, $hn8gG.getDocument)(floatingFocusElement)) === (0, $hn8gG.getDocument)(floatingFocusElement).body) {
                    // Let `FloatingPortal` effect knows that focus is still inside the
                    // floating tree.
                    if ((0, $1D9S2.isHTMLElement)(floatingFocusElement)) floatingFocusElement.focus();
                    const prevTabbableIndex = tabbableIndexRef.current;
                    const tabbableContent = getTabbableContent();
                    const nodeToFocus = tabbableContent[prevTabbableIndex] || tabbableContent[tabbableContent.length - 1] || floatingFocusElement;
                    if ((0, $1D9S2.isHTMLElement)(nodeToFocus)) nodeToFocus.focus();
                }
                // Focus did not move inside the floating tree, and there are no tabbable
                // portal guards to handle closing.
                if ((isUntrappedTypeableCombobox ? true : !modal) && relatedTarget && movedToUnrelatedNode && !isPointerDownRef.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
                relatedTarget !== $a2a32c30b64f04ab$var$getPreviouslyFocusedElement()) {
                    preventReturnFocusRef.current = true;
                    onOpenChange(false, event, 'focus-out');
                }
            });
        }
        if (floating && (0, $1D9S2.isHTMLElement)(domReference)) {
            domReference.addEventListener('focusout', handleFocusOutside);
            domReference.addEventListener('pointerdown', handlePointerDown);
            floating.addEventListener('focusout', handleFocusOutside);
            return ()=>{
                domReference.removeEventListener('focusout', handleFocusOutside);
                domReference.removeEventListener('pointerdown', handlePointerDown);
                floating.removeEventListener('focusout', handleFocusOutside);
            };
        }
    }, [
        disabled,
        domReference,
        floating,
        floatingFocusElement,
        modal,
        nodeId,
        tree,
        portalContext,
        onOpenChange,
        closeOnFocusOut,
        restoreFocus,
        getTabbableContent,
        isUntrappedTypeableCombobox
    ]);
    $8NFma.useEffect(()=>{
        var _portalContext$portal;
        if (disabled) return;
        // Don't hide portals nested within the parent portal.
        const portalNodes = Array.from((portalContext == null || (_portalContext$portal = portalContext.portalNode) == null ? void 0 : _portalContext$portal.querySelectorAll("[" + $a2a32c30b64f04ab$var$createAttribute('portal') + "]")) || []);
        if (floating) {
            const insideElements = [
                floating,
                ...portalNodes,
                startDismissButtonRef.current,
                endDismissButtonRef.current,
                orderRef.current.includes('reference') || isUntrappedTypeableCombobox ? domReference : null
            ].filter((x)=>x != null);
            const cleanup = modal || isUntrappedTypeableCombobox ? $a2a32c30b64f04ab$var$markOthers(insideElements, guards, !guards) : $a2a32c30b64f04ab$var$markOthers(insideElements);
            return ()=>{
                cleanup();
            };
        }
    }, [
        disabled,
        domReference,
        floating,
        modal,
        orderRef,
        portalContext,
        isUntrappedTypeableCombobox,
        guards
    ]);
    $a2a32c30b64f04ab$var$index(()=>{
        if (disabled || !(0, $1D9S2.isHTMLElement)(floatingFocusElement)) return;
        const doc = (0, $hn8gG.getDocument)(floatingFocusElement);
        const previouslyFocusedElement = (0, $hn8gG.activeElement)(doc);
        // Wait for any layout effect state setters to execute to set `tabIndex`.
        queueMicrotask(()=>{
            const focusableElements = getTabbableElements(floatingFocusElement);
            const initialFocusValue = initialFocusRef.current;
            const elToFocus = (typeof initialFocusValue === 'number' ? focusableElements[initialFocusValue] : initialFocusValue.current) || floatingFocusElement;
            const focusAlreadyInsideFloatingEl = (0, $hn8gG.contains)(floatingFocusElement, previouslyFocusedElement);
            if (!ignoreInitialFocus && !focusAlreadyInsideFloatingEl && open) $a2a32c30b64f04ab$var$enqueueFocus(elToFocus, {
                preventScroll: elToFocus === floatingFocusElement
            });
        });
    }, [
        disabled,
        open,
        floatingFocusElement,
        ignoreInitialFocus,
        getTabbableElements,
        initialFocusRef
    ]);
    $a2a32c30b64f04ab$var$index(()=>{
        if (disabled || !floatingFocusElement) return;
        let preventReturnFocusScroll = false;
        const doc = (0, $hn8gG.getDocument)(floatingFocusElement);
        const previouslyFocusedElement = (0, $hn8gG.activeElement)(doc);
        const contextData = dataRef.current;
        let openEvent = contextData.openEvent;
        $a2a32c30b64f04ab$var$addPreviouslyFocusedElement(previouslyFocusedElement);
        // Dismissing via outside press should always ignore `returnFocus` to
        // prevent unwanted scrolling.
        function onOpenChange(_ref) {
            let { open: open, reason: reason, event: event, nested: nested } = _ref;
            if (open) openEvent = event;
            if (reason === 'escape-key' && refs.domReference.current) $a2a32c30b64f04ab$var$addPreviouslyFocusedElement(refs.domReference.current);
            if (reason === 'hover' && event.type === 'mouseleave') preventReturnFocusRef.current = true;
            if (reason !== 'outside-press') return;
            if (nested) {
                preventReturnFocusRef.current = false;
                preventReturnFocusScroll = true;
            } else preventReturnFocusRef.current = !((0, $hn8gG.isVirtualClick)(event) || (0, $hn8gG.isVirtualPointerEvent)(event));
        }
        events.on('openchange', onOpenChange);
        const fallbackEl = doc.createElement('span');
        fallbackEl.setAttribute('tabindex', '-1');
        fallbackEl.setAttribute('aria-hidden', 'true');
        Object.assign(fallbackEl.style, $a2a32c30b64f04ab$var$HIDDEN_STYLES);
        if (isInsidePortal && domReference) domReference.insertAdjacentElement('afterend', fallbackEl);
        function getReturnElement() {
            if (typeof returnFocusRef.current === 'boolean') return $a2a32c30b64f04ab$var$getPreviouslyFocusedElement() || fallbackEl;
            return returnFocusRef.current.current || fallbackEl;
        }
        return ()=>{
            events.off('openchange', onOpenChange);
            const activeEl = (0, $hn8gG.activeElement)(doc);
            const isFocusInsideFloatingTree = (0, $hn8gG.contains)(floating, activeEl) || tree && $a2a32c30b64f04ab$var$getChildren(tree.nodesRef.current, nodeId).some((node)=>{
                var _node$context5;
                return (0, $hn8gG.contains)((_node$context5 = node.context) == null ? void 0 : _node$context5.elements.floating, activeEl);
            });
            const shouldFocusReference = isFocusInsideFloatingTree || openEvent && [
                'click',
                'mousedown'
            ].includes(openEvent.type);
            if (shouldFocusReference && refs.domReference.current) $a2a32c30b64f04ab$var$addPreviouslyFocusedElement(refs.domReference.current);
            const returnElement = getReturnElement();
            queueMicrotask(()=>{
                if (// eslint-disable-next-line react-hooks/exhaustive-deps
                returnFocusRef.current && !preventReturnFocusRef.current && (0, $1D9S2.isHTMLElement)(returnElement) && // If the focus moved somewhere else after mount, avoid returning focus
                // since it likely entered a different element which should be
                // respected: https://github.com/floating-ui/floating-ui/issues/2607
                (returnElement !== activeEl && activeEl !== doc.body ? isFocusInsideFloatingTree : true)) returnElement.focus({
                    preventScroll: preventReturnFocusScroll
                });
                fallbackEl.remove();
            });
        };
    }, [
        disabled,
        floating,
        floatingFocusElement,
        returnFocusRef,
        dataRef,
        refs,
        events,
        tree,
        nodeId,
        isInsidePortal,
        domReference
    ]);
    // Synchronize the `context` & `modal` value to the FloatingPortal context.
    // It will decide whether or not it needs to render its own guards.
    $a2a32c30b64f04ab$var$index(()=>{
        if (disabled) return;
        if (!portalContext) return;
        portalContext.setFocusManagerState({
            modal: modal,
            closeOnFocusOut: closeOnFocusOut,
            open: open,
            onOpenChange: onOpenChange,
            refs: refs
        });
        return ()=>{
            portalContext.setFocusManagerState(null);
        };
    }, [
        disabled,
        portalContext,
        modal,
        open,
        onOpenChange,
        refs,
        closeOnFocusOut
    ]);
    $a2a32c30b64f04ab$var$index(()=>{
        if (disabled) return;
        if (!floatingFocusElement) return;
        if (typeof MutationObserver !== 'function') return;
        if (ignoreInitialFocus) return;
        const handleMutation = ()=>{
            const tabIndex = floatingFocusElement.getAttribute('tabindex');
            const tabbableContent = getTabbableContent();
            const activeEl = (0, $hn8gG.activeElement)((0, $hn8gG.getDocument)(floating));
            const tabbableIndex = tabbableContent.indexOf(activeEl);
            if (tabbableIndex !== -1) tabbableIndexRef.current = tabbableIndex;
            if (orderRef.current.includes('floating') || activeEl !== refs.domReference.current && tabbableContent.length === 0) {
                if (tabIndex !== '0') floatingFocusElement.setAttribute('tabindex', '0');
            } else if (tabIndex !== '-1') floatingFocusElement.setAttribute('tabindex', '-1');
        };
        handleMutation();
        const observer = new MutationObserver(handleMutation);
        observer.observe(floatingFocusElement, {
            childList: true,
            subtree: true,
            attributes: true
        });
        return ()=>{
            observer.disconnect();
        };
    }, [
        disabled,
        floating,
        floatingFocusElement,
        refs,
        orderRef,
        getTabbableContent,
        ignoreInitialFocus
    ]);
    function renderDismissButton(location) {
        if (disabled || !visuallyHiddenDismiss || !modal) return null;
        return /*#__PURE__*/ $8NFma.createElement($a2a32c30b64f04ab$var$VisuallyHiddenDismiss, {
            ref: location === 'start' ? startDismissButtonRef : endDismissButtonRef,
            onClick: (event)=>onOpenChange(false, event.nativeEvent)
        }, typeof visuallyHiddenDismiss === 'string' ? visuallyHiddenDismiss : 'Dismiss');
    }
    const shouldRenderGuards = !disabled && guards && (modal ? !isUntrappedTypeableCombobox : true) && (isInsidePortal || modal);
    return /*#__PURE__*/ $8NFma.createElement($8NFma.Fragment, null, shouldRenderGuards && /*#__PURE__*/ $8NFma.createElement($a2a32c30b64f04ab$var$FocusGuard, {
        "data-type": "inside",
        ref: portalContext == null ? void 0 : portalContext.beforeInsideRef,
        onFocus: (event)=>{
            if (modal) {
                const els = getTabbableElements();
                $a2a32c30b64f04ab$var$enqueueFocus(order[0] === 'reference' ? els[0] : els[els.length - 1]);
            } else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                preventReturnFocusRef.current = false;
                if ($a2a32c30b64f04ab$var$isOutsideEvent(event, portalContext.portalNode)) {
                    const nextTabbable = $a2a32c30b64f04ab$var$getNextTabbable() || domReference;
                    nextTabbable == null || nextTabbable.focus();
                } else {
                    var _portalContext$before;
                    (_portalContext$before = portalContext.beforeOutsideRef.current) == null || _portalContext$before.focus();
                }
            }
        }
    }), !isUntrappedTypeableCombobox && renderDismissButton('start'), children, renderDismissButton('end'), shouldRenderGuards && /*#__PURE__*/ $8NFma.createElement($a2a32c30b64f04ab$var$FocusGuard, {
        "data-type": "inside",
        ref: portalContext == null ? void 0 : portalContext.afterInsideRef,
        onFocus: (event)=>{
            if (modal) $a2a32c30b64f04ab$var$enqueueFocus(getTabbableElements()[0]);
            else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                if (closeOnFocusOut) preventReturnFocusRef.current = true;
                if ($a2a32c30b64f04ab$var$isOutsideEvent(event, portalContext.portalNode)) {
                    const prevTabbable = $a2a32c30b64f04ab$var$getPreviousTabbable() || domReference;
                    prevTabbable == null || prevTabbable.focus();
                } else {
                    var _portalContext$afterO;
                    (_portalContext$afterO = portalContext.afterOutsideRef.current) == null || _portalContext$afterO.focus();
                }
            }
        }
    }));
}
let $a2a32c30b64f04ab$var$lockCount = 0;
function $a2a32c30b64f04ab$var$enableScrollLock() {
    const isIOS = /iP(hone|ad|od)|iOS/.test((0, $hn8gG.getPlatform)());
    const bodyStyle = document.body.style;
    // RTL <body> scrollbar
    const scrollbarX = Math.round(document.documentElement.getBoundingClientRect().left) + document.documentElement.scrollLeft;
    const paddingProp = scrollbarX ? 'paddingLeft' : 'paddingRight';
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    const scrollX = bodyStyle.left ? parseFloat(bodyStyle.left) : window.scrollX;
    const scrollY = bodyStyle.top ? parseFloat(bodyStyle.top) : window.scrollY;
    bodyStyle.overflow = 'hidden';
    if (scrollbarWidth) bodyStyle[paddingProp] = scrollbarWidth + "px";
    // Only iOS doesn't respect `overflow: hidden` on document.body, and this
    // technique has fewer side effects.
    if (isIOS) {
        var _window$visualViewpor, _window$visualViewpor2;
        // iOS 12 does not support `visualViewport`.
        const offsetLeft = ((_window$visualViewpor = window.visualViewport) == null ? void 0 : _window$visualViewpor.offsetLeft) || 0;
        const offsetTop = ((_window$visualViewpor2 = window.visualViewport) == null ? void 0 : _window$visualViewpor2.offsetTop) || 0;
        Object.assign(bodyStyle, {
            position: 'fixed',
            top: -(scrollY - Math.floor(offsetTop)) + "px",
            left: -(scrollX - Math.floor(offsetLeft)) + "px",
            right: '0'
        });
    }
    return ()=>{
        Object.assign(bodyStyle, {
            overflow: '',
            [paddingProp]: ''
        });
        if (isIOS) {
            Object.assign(bodyStyle, {
                position: '',
                top: '',
                left: '',
                right: ''
            });
            window.scrollTo(scrollX, scrollY);
        }
    };
}
let $a2a32c30b64f04ab$var$cleanup = ()=>{};
/**
 * Provides base styling for a fixed overlay element to dim content or block
 * pointer events behind a floating element.
 * It's a regular `<div>`, so it can be styled via any CSS solution you prefer.
 * @see https://floating-ui.com/docs/FloatingOverlay
 */ const $a2a32c30b64f04ab$export$a35954495955337b = /*#__PURE__*/ $8NFma.forwardRef(function FloatingOverlay(props, ref) {
    const { lockScroll: lockScroll = false, ...rest } = props;
    $a2a32c30b64f04ab$var$index(()=>{
        if (!lockScroll) return;
        $a2a32c30b64f04ab$var$lockCount++;
        if ($a2a32c30b64f04ab$var$lockCount === 1) $a2a32c30b64f04ab$var$cleanup = $a2a32c30b64f04ab$var$enableScrollLock();
        return ()=>{
            $a2a32c30b64f04ab$var$lockCount--;
            if ($a2a32c30b64f04ab$var$lockCount === 0) $a2a32c30b64f04ab$var$cleanup();
        };
    }, [
        lockScroll
    ]);
    return /*#__PURE__*/ $8NFma.createElement("div", $a2a32c30b64f04ab$var$_extends({
        ref: ref
    }, rest, {
        style: {
            position: 'fixed',
            overflow: 'auto',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...rest.style
        }
    }));
});
function $a2a32c30b64f04ab$var$isButtonTarget(event) {
    return (0, $1D9S2.isHTMLElement)(event.target) && event.target.tagName === 'BUTTON';
}
function $a2a32c30b64f04ab$var$isSpaceIgnored(element) {
    return (0, $hn8gG.isTypeableElement)(element);
}
/**
 * Opens or closes the floating element when clicking the reference element.
 * @see https://floating-ui.com/docs/useClick
 */ function $a2a32c30b64f04ab$export$98524f11226063fc(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, dataRef: dataRef, elements: { domReference: domReference } } = context;
    const { enabled: enabled = true, event: eventOption = 'click', toggle: toggle = true, ignoreMouse: ignoreMouse = false, keyboardHandlers: keyboardHandlers = true } = props;
    const pointerTypeRef = $8NFma.useRef();
    const didKeyDownRef = $8NFma.useRef(false);
    const reference = $8NFma.useMemo(()=>({
            onPointerDown (event) {
                pointerTypeRef.current = event.pointerType;
            },
            onMouseDown (event) {
                const pointerType = pointerTypeRef.current;
                // Ignore all buttons except for the "main" button.
                // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
                if (event.button !== 0) return;
                if (eventOption === 'click') return;
                if ((0, $hn8gG.isMouseLikePointerType)(pointerType, true) && ignoreMouse) return;
                if (open && toggle && (dataRef.current.openEvent ? dataRef.current.openEvent.type === 'mousedown' : true)) onOpenChange(false, event.nativeEvent, 'click');
                else {
                    // Prevent stealing focus from the floating element
                    event.preventDefault();
                    onOpenChange(true, event.nativeEvent, 'click');
                }
            },
            onClick (event) {
                const pointerType = pointerTypeRef.current;
                if (eventOption === 'mousedown' && pointerTypeRef.current) {
                    pointerTypeRef.current = undefined;
                    return;
                }
                if ((0, $hn8gG.isMouseLikePointerType)(pointerType, true) && ignoreMouse) return;
                if (open && toggle && (dataRef.current.openEvent ? dataRef.current.openEvent.type === 'click' : true)) onOpenChange(false, event.nativeEvent, 'click');
                else onOpenChange(true, event.nativeEvent, 'click');
            },
            onKeyDown (event) {
                pointerTypeRef.current = undefined;
                if (event.defaultPrevented || !keyboardHandlers || $a2a32c30b64f04ab$var$isButtonTarget(event)) return;
                if (event.key === ' ' && !$a2a32c30b64f04ab$var$isSpaceIgnored(domReference)) {
                    // Prevent scrolling
                    event.preventDefault();
                    didKeyDownRef.current = true;
                }
                if (event.key === 'Enter') {
                    if (open && toggle) onOpenChange(false, event.nativeEvent, 'click');
                    else onOpenChange(true, event.nativeEvent, 'click');
                }
            },
            onKeyUp (event) {
                if (event.defaultPrevented || !keyboardHandlers || $a2a32c30b64f04ab$var$isButtonTarget(event) || $a2a32c30b64f04ab$var$isSpaceIgnored(domReference)) return;
                if (event.key === ' ' && didKeyDownRef.current) {
                    didKeyDownRef.current = false;
                    if (open && toggle) onOpenChange(false, event.nativeEvent, 'click');
                    else onOpenChange(true, event.nativeEvent, 'click');
                }
            }
        }), [
        dataRef,
        domReference,
        eventOption,
        ignoreMouse,
        keyboardHandlers,
        onOpenChange,
        open,
        toggle
    ]);
    return $8NFma.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
function $a2a32c30b64f04ab$var$createVirtualElement(domElement, data) {
    let offsetX = null;
    let offsetY = null;
    let isAutoUpdateEvent = false;
    return {
        contextElement: domElement || undefined,
        getBoundingClientRect () {
            var _data$dataRef$current;
            const domRect = (domElement == null ? void 0 : domElement.getBoundingClientRect()) || {
                width: 0,
                height: 0,
                x: 0,
                y: 0
            };
            const isXAxis = data.axis === 'x' || data.axis === 'both';
            const isYAxis = data.axis === 'y' || data.axis === 'both';
            const canTrackCursorOnAutoUpdate = [
                'mouseenter',
                'mousemove'
            ].includes(((_data$dataRef$current = data.dataRef.current.openEvent) == null ? void 0 : _data$dataRef$current.type) || '') && data.pointerType !== 'touch';
            let width = domRect.width;
            let height = domRect.height;
            let x = domRect.x;
            let y = domRect.y;
            if (offsetX == null && data.x && isXAxis) offsetX = domRect.x - data.x;
            if (offsetY == null && data.y && isYAxis) offsetY = domRect.y - data.y;
            x -= offsetX || 0;
            y -= offsetY || 0;
            width = 0;
            height = 0;
            if (!isAutoUpdateEvent || canTrackCursorOnAutoUpdate) {
                width = data.axis === 'y' ? domRect.width : 0;
                height = data.axis === 'x' ? domRect.height : 0;
                x = isXAxis && data.x != null ? data.x : x;
                y = isYAxis && data.y != null ? data.y : y;
            } else if (isAutoUpdateEvent && !canTrackCursorOnAutoUpdate) {
                height = data.axis === 'x' ? domRect.height : height;
                width = data.axis === 'y' ? domRect.width : width;
            }
            isAutoUpdateEvent = true;
            return {
                width: width,
                height: height,
                x: x,
                y: y,
                top: y,
                right: x + width,
                bottom: y + height,
                left: x
            };
        }
    };
}
function $a2a32c30b64f04ab$var$isMouseBasedEvent(event) {
    return event != null && event.clientX != null;
}
/**
 * Positions the floating element relative to a client point (in the viewport),
 * such as the mouse position. By default, it follows the mouse cursor.
 * @see https://floating-ui.com/docs/useClientPoint
 */ function $a2a32c30b64f04ab$export$7fe170a73a621816(context, props) {
    if (props === void 0) props = {};
    const { open: open, dataRef: dataRef, elements: { floating: floating, domReference: domReference }, refs: refs } = context;
    const { enabled: enabled = true, axis: axis = 'both', x: x = null, y: y = null } = props;
    const initialRef = $8NFma.useRef(false);
    const cleanupListenerRef = $8NFma.useRef(null);
    const [pointerType, setPointerType] = $8NFma.useState();
    const [reactive, setReactive] = $8NFma.useState([]);
    const setReference = $a2a32c30b64f04ab$var$useEffectEvent((x, y)=>{
        if (initialRef.current) return;
        // Prevent setting if the open event was not a mouse-like one
        // (e.g. focus to open, then hover over the reference element).
        // Only apply if the event exists.
        if (dataRef.current.openEvent && !$a2a32c30b64f04ab$var$isMouseBasedEvent(dataRef.current.openEvent)) return;
        refs.setPositionReference($a2a32c30b64f04ab$var$createVirtualElement(domReference, {
            x: x,
            y: y,
            axis: axis,
            dataRef: dataRef,
            pointerType: pointerType
        }));
    });
    const handleReferenceEnterOrMove = $a2a32c30b64f04ab$var$useEffectEvent((event)=>{
        if (x != null || y != null) return;
        if (!open) setReference(event.clientX, event.clientY);
        else if (!cleanupListenerRef.current) // If there's no cleanup, there's no listener, but we want to ensure
        // we add the listener if the cursor landed on the floating element and
        // then back on the reference (i.e. it's interactive).
        setReactive([]);
    });
    // If the pointer is a mouse-like pointer, we want to continue following the
    // mouse even if the floating element is transitioning out. On touch
    // devices, this is undesirable because the floating element will move to
    // the dismissal touch point.
    const openCheck = (0, $hn8gG.isMouseLikePointerType)(pointerType) ? floating : open;
    const addListener = $8NFma.useCallback(()=>{
        // Explicitly specified `x`/`y` coordinates shouldn't add a listener.
        if (!openCheck || !enabled || x != null || y != null) return;
        const win = (0, $1D9S2.getWindow)(floating);
        function handleMouseMove(event) {
            const target = (0, $hn8gG.getTarget)(event);
            if (!(0, $hn8gG.contains)(floating, target)) setReference(event.clientX, event.clientY);
            else {
                win.removeEventListener('mousemove', handleMouseMove);
                cleanupListenerRef.current = null;
            }
        }
        if (!dataRef.current.openEvent || $a2a32c30b64f04ab$var$isMouseBasedEvent(dataRef.current.openEvent)) {
            win.addEventListener('mousemove', handleMouseMove);
            const cleanup = ()=>{
                win.removeEventListener('mousemove', handleMouseMove);
                cleanupListenerRef.current = null;
            };
            cleanupListenerRef.current = cleanup;
            return cleanup;
        }
        refs.setPositionReference(domReference);
    }, [
        openCheck,
        enabled,
        x,
        y,
        floating,
        dataRef,
        refs,
        domReference,
        setReference
    ]);
    $8NFma.useEffect(()=>{
        return addListener();
    }, [
        addListener,
        reactive
    ]);
    $8NFma.useEffect(()=>{
        if (enabled && !floating) initialRef.current = false;
    }, [
        enabled,
        floating
    ]);
    $8NFma.useEffect(()=>{
        if (!enabled && open) initialRef.current = true;
    }, [
        enabled,
        open
    ]);
    $a2a32c30b64f04ab$var$index(()=>{
        if (enabled && (x != null || y != null)) {
            initialRef.current = false;
            setReference(x, y);
        }
    }, [
        enabled,
        x,
        y,
        setReference
    ]);
    const reference = $8NFma.useMemo(()=>{
        function setPointerTypeRef(_ref) {
            let { pointerType: pointerType } = _ref;
            setPointerType(pointerType);
        }
        return {
            onPointerDown: setPointerTypeRef,
            onPointerEnter: setPointerTypeRef,
            onMouseMove: handleReferenceEnterOrMove,
            onMouseEnter: handleReferenceEnterOrMove
        };
    }, [
        handleReferenceEnterOrMove
    ]);
    return $8NFma.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
const $a2a32c30b64f04ab$var$bubbleHandlerKeys = {
    pointerdown: 'onPointerDown',
    mousedown: 'onMouseDown',
    click: 'onClick'
};
const $a2a32c30b64f04ab$var$captureHandlerKeys = {
    pointerdown: 'onPointerDownCapture',
    mousedown: 'onMouseDownCapture',
    click: 'onClickCapture'
};
const $a2a32c30b64f04ab$var$normalizeProp = (normalizable)=>{
    var _normalizable$escapeK, _normalizable$outside;
    return {
        escapeKey: typeof normalizable === 'boolean' ? normalizable : (_normalizable$escapeK = normalizable == null ? void 0 : normalizable.escapeKey) != null ? _normalizable$escapeK : false,
        outsidePress: typeof normalizable === 'boolean' ? normalizable : (_normalizable$outside = normalizable == null ? void 0 : normalizable.outsidePress) != null ? _normalizable$outside : true
    };
};
/**
 * Closes the floating element when a dismissal is requested — by default, when
 * the user presses the `escape` key or outside of the floating element.
 * @see https://floating-ui.com/docs/useDismiss
 */ function $a2a32c30b64f04ab$export$fcdf1ba5fafc089b(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, elements: elements, dataRef: dataRef } = context;
    const { enabled: enabled = true, escapeKey: escapeKey = true, outsidePress: unstable_outsidePress = true, outsidePressEvent: outsidePressEvent = 'pointerdown', referencePress: referencePress = false, referencePressEvent: referencePressEvent = 'pointerdown', ancestorScroll: ancestorScroll = false, bubbles: bubbles, capture: capture } = props;
    const tree = $a2a32c30b64f04ab$export$db0c2a7c7a2a4f69();
    const outsidePressFn = $a2a32c30b64f04ab$var$useEffectEvent(typeof unstable_outsidePress === 'function' ? unstable_outsidePress : ()=>false);
    const outsidePress = typeof unstable_outsidePress === 'function' ? outsidePressFn : unstable_outsidePress;
    const insideReactTreeRef = $8NFma.useRef(false);
    const endedOrStartedInsideRef = $8NFma.useRef(false);
    const { escapeKey: escapeKeyBubbles, outsidePress: outsidePressBubbles } = $a2a32c30b64f04ab$var$normalizeProp(bubbles);
    const { escapeKey: escapeKeyCapture, outsidePress: outsidePressCapture } = $a2a32c30b64f04ab$var$normalizeProp(capture);
    const isComposingRef = $8NFma.useRef(false);
    const closeOnEscapeKeyDown = $a2a32c30b64f04ab$var$useEffectEvent((event)=>{
        var _dataRef$current$floa;
        if (!open || !enabled || !escapeKey || event.key !== 'Escape') return;
        // Wait until IME is settled. Pressing `Escape` while composing should
        // close the compose menu, but not the floating element.
        if (isComposingRef.current) return;
        const nodeId = (_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.nodeId;
        const children = tree ? $a2a32c30b64f04ab$var$getChildren(tree.nodesRef.current, nodeId) : [];
        if (!escapeKeyBubbles) {
            event.stopPropagation();
            if (children.length > 0) {
                let shouldDismiss = true;
                children.forEach((child)=>{
                    var _child$context;
                    if ((_child$context = child.context) != null && _child$context.open && !child.context.dataRef.current.__escapeKeyBubbles) {
                        shouldDismiss = false;
                        return;
                    }
                });
                if (!shouldDismiss) return;
            }
        }
        onOpenChange(false, (0, $hn8gG.isReactEvent)(event) ? event.nativeEvent : event, 'escape-key');
    });
    const closeOnEscapeKeyDownCapture = $a2a32c30b64f04ab$var$useEffectEvent((event)=>{
        var _getTarget2;
        const callback = ()=>{
            var _getTarget;
            closeOnEscapeKeyDown(event);
            (_getTarget = (0, $hn8gG.getTarget)(event)) == null || _getTarget.removeEventListener('keydown', callback);
        };
        (_getTarget2 = (0, $hn8gG.getTarget)(event)) == null || _getTarget2.addEventListener('keydown', callback);
    });
    const closeOnPressOutside = $a2a32c30b64f04ab$var$useEffectEvent((event)=>{
        var _dataRef$current$floa2;
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = insideReactTreeRef.current;
        insideReactTreeRef.current = false;
        // When click outside is lazy (`click` event), handle dragging.
        // Don't close if:
        // - The click started inside the floating element.
        // - The click ended inside the floating element.
        const endedOrStartedInside = endedOrStartedInsideRef.current;
        endedOrStartedInsideRef.current = false;
        if (outsidePressEvent === 'click' && endedOrStartedInside) return;
        if (insideReactTree) return;
        if (typeof outsidePress === 'function' && !outsidePress(event)) return;
        const target = (0, $hn8gG.getTarget)(event);
        const inertSelector = "[" + $a2a32c30b64f04ab$var$createAttribute('inert') + "]";
        const markers = (0, $hn8gG.getDocument)(elements.floating).querySelectorAll(inertSelector);
        let targetRootAncestor = (0, $1D9S2.isElement)(target) ? target : null;
        while(targetRootAncestor && !(0, $1D9S2.isLastTraversableNode)(targetRootAncestor)){
            const nextParent = (0, $1D9S2.getParentNode)(targetRootAncestor);
            if ((0, $1D9S2.isLastTraversableNode)(nextParent) || !(0, $1D9S2.isElement)(nextParent)) break;
            targetRootAncestor = nextParent;
        }
        // Check if the click occurred on a third-party element injected after the
        // floating element rendered.
        if (markers.length && (0, $1D9S2.isElement)(target) && !(0, $hn8gG.isRootElement)(target) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
        !(0, $hn8gG.contains)(target, elements.floating) && // If the target root element contains none of the markers, then the
        // element was injected after the floating element rendered.
        Array.from(markers).every((marker)=>!(0, $hn8gG.contains)(targetRootAncestor, marker))) return;
        // Check if the click occurred on the scrollbar
        if ((0, $1D9S2.isHTMLElement)(target) && floating) {
            // In Firefox, `target.scrollWidth > target.clientWidth` for inline
            // elements.
            const canScrollX = target.clientWidth > 0 && target.scrollWidth > target.clientWidth;
            const canScrollY = target.clientHeight > 0 && target.scrollHeight > target.clientHeight;
            let xCond = canScrollY && event.offsetX > target.clientWidth;
            // In some browsers it is possible to change the <body> (or window)
            // scrollbar to the left side, but is very rare and is difficult to
            // check for. Plus, for modal dialogs with backdrops, it is more
            // important that the backdrop is checked but not so much the window.
            if (canScrollY) {
                const isRTL = (0, $1D9S2.getComputedStyle)(target).direction === 'rtl';
                if (isRTL) xCond = event.offsetX <= target.offsetWidth - target.clientWidth;
            }
            if (xCond || canScrollX && event.offsetY > target.clientHeight) return;
        }
        const nodeId = (_dataRef$current$floa2 = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa2.nodeId;
        const targetIsInsideChildren = tree && $a2a32c30b64f04ab$var$getChildren(tree.nodesRef.current, nodeId).some((node)=>{
            var _node$context;
            return (0, $hn8gG.isEventTargetWithin)(event, (_node$context = node.context) == null ? void 0 : _node$context.elements.floating);
        });
        if ((0, $hn8gG.isEventTargetWithin)(event, elements.floating) || (0, $hn8gG.isEventTargetWithin)(event, elements.domReference) || targetIsInsideChildren) return;
        const children = tree ? $a2a32c30b64f04ab$var$getChildren(tree.nodesRef.current, nodeId) : [];
        if (children.length > 0) {
            let shouldDismiss = true;
            children.forEach((child)=>{
                var _child$context2;
                if ((_child$context2 = child.context) != null && _child$context2.open && !child.context.dataRef.current.__outsidePressBubbles) {
                    shouldDismiss = false;
                    return;
                }
            });
            if (!shouldDismiss) return;
        }
        onOpenChange(false, event, 'outside-press');
    });
    const closeOnPressOutsideCapture = $a2a32c30b64f04ab$var$useEffectEvent((event)=>{
        var _getTarget4;
        const callback = ()=>{
            var _getTarget3;
            closeOnPressOutside(event);
            (_getTarget3 = (0, $hn8gG.getTarget)(event)) == null || _getTarget3.removeEventListener(outsidePressEvent, callback);
        };
        (_getTarget4 = (0, $hn8gG.getTarget)(event)) == null || _getTarget4.addEventListener(outsidePressEvent, callback);
    });
    $8NFma.useEffect(()=>{
        if (!open || !enabled) return;
        dataRef.current.__escapeKeyBubbles = escapeKeyBubbles;
        dataRef.current.__outsidePressBubbles = outsidePressBubbles;
        let compositionTimeout = -1;
        function onScroll(event) {
            onOpenChange(false, event, 'ancestor-scroll');
        }
        function handleCompositionStart() {
            window.clearTimeout(compositionTimeout);
            isComposingRef.current = true;
        }
        function handleCompositionEnd() {
            // Safari fires `compositionend` before `keydown`, so we need to wait
            // until the next tick to set `isComposing` to `false`.
            // https://bugs.webkit.org/show_bug.cgi?id=165004
            compositionTimeout = window.setTimeout(()=>{
                isComposingRef.current = false;
            }, // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
            // Only apply to WebKit for the test to remain 0ms.
            (0, $1D9S2.isWebKit)() ? 5 : 0);
        }
        const doc = (0, $hn8gG.getDocument)(elements.floating);
        if (escapeKey) {
            doc.addEventListener('keydown', escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
            doc.addEventListener('compositionstart', handleCompositionStart);
            doc.addEventListener('compositionend', handleCompositionEnd);
        }
        outsidePress && doc.addEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
        let ancestors = [];
        if (ancestorScroll) {
            if ((0, $1D9S2.isElement)(elements.domReference)) ancestors = (0, $1D9S2.getOverflowAncestors)(elements.domReference);
            if ((0, $1D9S2.isElement)(elements.floating)) ancestors = ancestors.concat((0, $1D9S2.getOverflowAncestors)(elements.floating));
            if (!(0, $1D9S2.isElement)(elements.reference) && elements.reference && elements.reference.contextElement) ancestors = ancestors.concat((0, $1D9S2.getOverflowAncestors)(elements.reference.contextElement));
        }
        // Ignore the visual viewport for scrolling dismissal (allow pinch-zoom)
        ancestors = ancestors.filter((ancestor)=>{
            var _doc$defaultView;
            return ancestor !== ((_doc$defaultView = doc.defaultView) == null ? void 0 : _doc$defaultView.visualViewport);
        });
        ancestors.forEach((ancestor)=>{
            ancestor.addEventListener('scroll', onScroll, {
                passive: true
            });
        });
        return ()=>{
            if (escapeKey) {
                doc.removeEventListener('keydown', escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
                doc.removeEventListener('compositionstart', handleCompositionStart);
                doc.removeEventListener('compositionend', handleCompositionEnd);
            }
            outsidePress && doc.removeEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
            ancestors.forEach((ancestor)=>{
                ancestor.removeEventListener('scroll', onScroll);
            });
            window.clearTimeout(compositionTimeout);
        };
    }, [
        dataRef,
        elements,
        escapeKey,
        outsidePress,
        outsidePressEvent,
        open,
        onOpenChange,
        ancestorScroll,
        enabled,
        escapeKeyBubbles,
        outsidePressBubbles,
        closeOnEscapeKeyDown,
        escapeKeyCapture,
        closeOnEscapeKeyDownCapture,
        closeOnPressOutside,
        outsidePressCapture,
        closeOnPressOutsideCapture
    ]);
    $8NFma.useEffect(()=>{
        insideReactTreeRef.current = false;
    }, [
        outsidePress,
        outsidePressEvent
    ]);
    const reference = $8NFma.useMemo(()=>({
            onKeyDown: closeOnEscapeKeyDown,
            [$a2a32c30b64f04ab$var$bubbleHandlerKeys[referencePressEvent]]: (event)=>{
                if (referencePress) onOpenChange(false, event.nativeEvent, 'reference-press');
            }
        }), [
        closeOnEscapeKeyDown,
        onOpenChange,
        referencePress,
        referencePressEvent
    ]);
    const floating = $8NFma.useMemo(()=>({
            onKeyDown: closeOnEscapeKeyDown,
            onMouseDown () {
                endedOrStartedInsideRef.current = true;
            },
            onMouseUp () {
                endedOrStartedInsideRef.current = true;
            },
            [$a2a32c30b64f04ab$var$captureHandlerKeys[outsidePressEvent]]: ()=>{
                insideReactTreeRef.current = true;
            }
        }), [
        closeOnEscapeKeyDown,
        outsidePressEvent
    ]);
    return $8NFma.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
function $a2a32c30b64f04ab$export$1df81146f8ad8e4c(options) {
    const { open: open = false, onOpenChange: onOpenChangeProp, elements: elementsProp } = options;
    const floatingId = $a2a32c30b64f04ab$export$f680877a34711e37();
    const dataRef = $8NFma.useRef({});
    const [events] = $8NFma.useState(()=>$a2a32c30b64f04ab$var$createPubSub());
    const nested = $a2a32c30b64f04ab$export$165209eae06d3488() != null;
    const [positionReference, setPositionReference] = $8NFma.useState(elementsProp.reference);
    const onOpenChange = $a2a32c30b64f04ab$var$useEffectEvent((open, event, reason)=>{
        dataRef.current.openEvent = open ? event : undefined;
        events.emit('openchange', {
            open: open,
            event: event,
            reason: reason,
            nested: nested
        });
        onOpenChangeProp == null || onOpenChangeProp(open, event, reason);
    });
    const refs = $8NFma.useMemo(()=>({
            setPositionReference: setPositionReference
        }), []);
    const elements = $8NFma.useMemo(()=>({
            reference: positionReference || elementsProp.reference || null,
            floating: elementsProp.floating || null,
            domReference: elementsProp.reference
        }), [
        positionReference,
        elementsProp.reference,
        elementsProp.floating
    ]);
    return $8NFma.useMemo(()=>({
            dataRef: dataRef,
            open: open,
            onOpenChange: onOpenChange,
            elements: elements,
            events: events,
            floatingId: floatingId,
            refs: refs
        }), [
        open,
        onOpenChange,
        elements,
        events,
        floatingId,
        refs
    ]);
}
/**
 * Provides data to position a floating element and context to add interactions.
 * @see https://floating-ui.com/docs/useFloating
 */ function $a2a32c30b64f04ab$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { nodeId: nodeId } = options;
    const internalRootContext = $a2a32c30b64f04ab$export$1df81146f8ad8e4c({
        ...options,
        elements: {
            reference: null,
            floating: null,
            ...options.elements
        }
    });
    const rootContext = options.rootContext || internalRootContext;
    const computedElements = rootContext.elements;
    const [_domReference, setDomReference] = $8NFma.useState(null);
    const [positionReference, _setPositionReference] = $8NFma.useState(null);
    const optionDomReference = computedElements == null ? void 0 : computedElements.domReference;
    const domReference = optionDomReference || _domReference;
    const domReferenceRef = $8NFma.useRef(null);
    const tree = $a2a32c30b64f04ab$export$db0c2a7c7a2a4f69();
    $a2a32c30b64f04ab$var$index(()=>{
        if (domReference) domReferenceRef.current = domReference;
    }, [
        domReference
    ]);
    const position = (0, $eqxtD.useFloating)({
        ...options,
        elements: {
            ...computedElements,
            ...positionReference && {
                reference: positionReference
            }
        }
    });
    const setPositionReference = $8NFma.useCallback((node)=>{
        const computedPositionReference = (0, $1D9S2.isElement)(node) ? {
            getBoundingClientRect: ()=>node.getBoundingClientRect(),
            contextElement: node
        } : node;
        // Store the positionReference in state if the DOM reference is specified externally via the
        // `elements.reference` option. This ensures that it won't be overridden on future renders.
        _setPositionReference(computedPositionReference);
        position.refs.setReference(computedPositionReference);
    }, [
        position.refs
    ]);
    const setReference = $8NFma.useCallback((node)=>{
        if ((0, $1D9S2.isElement)(node) || node === null) {
            domReferenceRef.current = node;
            setDomReference(node);
        }
        // Backwards-compatibility for passing a virtual element to `reference`
        // after it has set the DOM reference.
        if ((0, $1D9S2.isElement)(position.refs.reference.current) || position.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
        // `null` to support `positionReference` + an unstable `reference`
        // callback ref.
        node !== null && !(0, $1D9S2.isElement)(node)) position.refs.setReference(node);
    }, [
        position.refs
    ]);
    const refs = $8NFma.useMemo(()=>({
            ...position.refs,
            setReference: setReference,
            setPositionReference: setPositionReference,
            domReference: domReferenceRef
        }), [
        position.refs,
        setReference,
        setPositionReference
    ]);
    const elements = $8NFma.useMemo(()=>({
            ...position.elements,
            domReference: domReference
        }), [
        position.elements,
        domReference
    ]);
    const context = $8NFma.useMemo(()=>({
            ...position,
            ...rootContext,
            refs: refs,
            elements: elements,
            nodeId: nodeId
        }), [
        position,
        refs,
        elements,
        nodeId,
        rootContext
    ]);
    $a2a32c30b64f04ab$var$index(()=>{
        rootContext.dataRef.current.floatingContext = context;
        const node = tree == null ? void 0 : tree.nodesRef.current.find((node)=>node.id === nodeId);
        if (node) node.context = context;
    });
    return $8NFma.useMemo(()=>({
            ...position,
            context: context,
            refs: refs,
            elements: elements
        }), [
        position,
        refs,
        elements,
        context
    ]);
}
/**
 * Opens the floating element while the reference element has focus, like CSS
 * `:focus`.
 * @see https://floating-ui.com/docs/useFocus
 */ function $a2a32c30b64f04ab$export$f8168d8dd8fd66e6(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, events: events, dataRef: dataRef, elements: elements } = context;
    const { enabled: enabled = true, visibleOnly: visibleOnly = true } = props;
    const blockFocusRef = $8NFma.useRef(false);
    const timeoutRef = $8NFma.useRef();
    const keyboardModalityRef = $8NFma.useRef(true);
    $8NFma.useEffect(()=>{
        if (!enabled) return;
        const win = (0, $1D9S2.getWindow)(elements.domReference);
        // If the reference was focused and the user left the tab/window, and the
        // floating element was not open, the focus should be blocked when they
        // return to the tab/window.
        function onBlur() {
            if (!open && (0, $1D9S2.isHTMLElement)(elements.domReference) && elements.domReference === (0, $hn8gG.activeElement)((0, $hn8gG.getDocument)(elements.domReference))) blockFocusRef.current = true;
        }
        function onKeyDown() {
            keyboardModalityRef.current = true;
        }
        win.addEventListener('blur', onBlur);
        win.addEventListener('keydown', onKeyDown, true);
        return ()=>{
            win.removeEventListener('blur', onBlur);
            win.removeEventListener('keydown', onKeyDown, true);
        };
    }, [
        elements.domReference,
        open,
        enabled
    ]);
    $8NFma.useEffect(()=>{
        if (!enabled) return;
        function onOpenChange(_ref) {
            let { reason: reason } = _ref;
            if (reason === 'reference-press' || reason === 'escape-key') blockFocusRef.current = true;
        }
        events.on('openchange', onOpenChange);
        return ()=>{
            events.off('openchange', onOpenChange);
        };
    }, [
        events,
        enabled
    ]);
    $8NFma.useEffect(()=>{
        return ()=>{
            clearTimeout(timeoutRef.current);
        };
    }, []);
    const reference = $8NFma.useMemo(()=>({
            onPointerDown (event) {
                if ((0, $hn8gG.isVirtualPointerEvent)(event.nativeEvent)) return;
                keyboardModalityRef.current = false;
            },
            onMouseLeave () {
                blockFocusRef.current = false;
            },
            onFocus (event) {
                if (blockFocusRef.current) return;
                const target = (0, $hn8gG.getTarget)(event.nativeEvent);
                if (visibleOnly && (0, $1D9S2.isElement)(target)) try {
                    // Mac Safari unreliably matches `:focus-visible` on the reference
                    // if focus was outside the page initially - use the fallback
                    // instead.
                    if ((0, $hn8gG.isSafari)() && (0, $hn8gG.isMac)()) throw Error();
                    if (!target.matches(':focus-visible')) return;
                } catch (e) {
                    // Old browsers will throw an error when using `:focus-visible`.
                    if (!keyboardModalityRef.current && !(0, $hn8gG.isTypeableElement)(target)) return;
                }
                onOpenChange(true, event.nativeEvent, 'focus');
            },
            onBlur (event) {
                blockFocusRef.current = false;
                const relatedTarget = event.relatedTarget;
                const nativeEvent = event.nativeEvent;
                // Hit the non-modal focus management portal guard. Focus will be
                // moved into the floating element immediately after.
                const movedToFocusGuard = (0, $1D9S2.isElement)(relatedTarget) && relatedTarget.hasAttribute($a2a32c30b64f04ab$var$createAttribute('focus-guard')) && relatedTarget.getAttribute('data-type') === 'outside';
                // Wait for the window blur listener to fire.
                timeoutRef.current = window.setTimeout(()=>{
                    var _dataRef$current$floa;
                    const activeEl = (0, $hn8gG.activeElement)(elements.domReference ? elements.domReference.ownerDocument : document);
                    // Focus left the page, keep it open.
                    if (!relatedTarget && activeEl === elements.domReference) return;
                    // When focusing the reference element (e.g. regular click), then
                    // clicking into the floating element, prevent it from hiding.
                    // Note: it must be focusable, e.g. `tabindex="-1"`.
                    // We can not rely on relatedTarget to point to the correct element
                    // as it will only point to the shadow host of the newly focused element
                    // and not the element that actually has received focus if it is located
                    // inside a shadow root.
                    if ((0, $hn8gG.contains)((_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.refs.floating.current, activeEl) || (0, $hn8gG.contains)(elements.domReference, activeEl) || movedToFocusGuard) return;
                    onOpenChange(false, nativeEvent, 'focus');
                });
            }
        }), [
        dataRef,
        elements.domReference,
        onOpenChange,
        visibleOnly
    ]);
    return $8NFma.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
const $a2a32c30b64f04ab$var$ACTIVE_KEY = 'active';
const $a2a32c30b64f04ab$var$SELECTED_KEY = 'selected';
function $a2a32c30b64f04ab$var$mergeProps(userProps, propsList, elementKey) {
    const map = new Map();
    const isItem = elementKey === 'item';
    let domUserProps = userProps;
    if (isItem && userProps) {
        const { [$a2a32c30b64f04ab$var$ACTIVE_KEY]: _, [$a2a32c30b64f04ab$var$SELECTED_KEY]: __, ...validProps } = userProps;
        domUserProps = validProps;
    }
    return {
        ...elementKey === 'floating' && {
            tabIndex: -1,
            [$a2a32c30b64f04ab$var$FOCUSABLE_ATTRIBUTE]: ''
        },
        ...domUserProps,
        ...propsList.map((value)=>{
            const propsOrGetProps = value ? value[elementKey] : null;
            if (typeof propsOrGetProps === 'function') return userProps ? propsOrGetProps(userProps) : null;
            return propsOrGetProps;
        }).concat(userProps).reduce((acc, props)=>{
            if (!props) return acc;
            Object.entries(props).forEach((_ref)=>{
                let [key, value] = _ref;
                if (isItem && [
                    $a2a32c30b64f04ab$var$ACTIVE_KEY,
                    $a2a32c30b64f04ab$var$SELECTED_KEY
                ].includes(key)) return;
                if (key.indexOf('on') === 0) {
                    if (!map.has(key)) map.set(key, []);
                    if (typeof value === 'function') {
                        var _map$get;
                        (_map$get = map.get(key)) == null || _map$get.push(value);
                        acc[key] = function() {
                            var _map$get2;
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                            return (_map$get2 = map.get(key)) == null ? void 0 : _map$get2.map((fn)=>fn(...args)).find((val)=>val !== undefined);
                        };
                    }
                } else acc[key] = value;
            });
            return acc;
        }, {})
    };
}
/**
 * Merges an array of interaction hooks' props into prop getters, allowing
 * event handler functions to be composed together without overwriting one
 * another.
 * @see https://floating-ui.com/docs/useInteractions
 */ function $a2a32c30b64f04ab$export$a519f7794e446ddd(propsList) {
    if (propsList === void 0) propsList = [];
    const referenceDeps = propsList.map((key)=>key == null ? void 0 : key.reference);
    const floatingDeps = propsList.map((key)=>key == null ? void 0 : key.floating);
    const itemDeps = propsList.map((key)=>key == null ? void 0 : key.item);
    const getReferenceProps = $8NFma.useCallback((userProps)=>$a2a32c30b64f04ab$var$mergeProps(userProps, propsList, 'reference'), // eslint-disable-next-line react-hooks/exhaustive-deps
    referenceDeps);
    const getFloatingProps = $8NFma.useCallback((userProps)=>$a2a32c30b64f04ab$var$mergeProps(userProps, propsList, 'floating'), // eslint-disable-next-line react-hooks/exhaustive-deps
    floatingDeps);
    const getItemProps = $8NFma.useCallback((userProps)=>$a2a32c30b64f04ab$var$mergeProps(userProps, propsList, 'item'), // eslint-disable-next-line react-hooks/exhaustive-deps
    itemDeps);
    return $8NFma.useMemo(()=>({
            getReferenceProps: getReferenceProps,
            getFloatingProps: getFloatingProps,
            getItemProps: getItemProps
        }), [
        getReferenceProps,
        getFloatingProps,
        getItemProps
    ]);
}
let $a2a32c30b64f04ab$var$isPreventScrollSupported = false;
function $a2a32c30b64f04ab$var$doSwitch(orientation, vertical, horizontal) {
    switch(orientation){
        case 'vertical':
            return vertical;
        case 'horizontal':
            return horizontal;
        default:
            return vertical || horizontal;
    }
}
function $a2a32c30b64f04ab$var$isMainOrientationKey(key, orientation) {
    const vertical = key === $a2a32c30b64f04ab$var$ARROW_UP || key === $a2a32c30b64f04ab$var$ARROW_DOWN;
    const horizontal = key === $a2a32c30b64f04ab$var$ARROW_LEFT || key === $a2a32c30b64f04ab$var$ARROW_RIGHT;
    return $a2a32c30b64f04ab$var$doSwitch(orientation, vertical, horizontal);
}
function $a2a32c30b64f04ab$var$isMainOrientationToEndKey(key, orientation, rtl) {
    const vertical = key === $a2a32c30b64f04ab$var$ARROW_DOWN;
    const horizontal = rtl ? key === $a2a32c30b64f04ab$var$ARROW_LEFT : key === $a2a32c30b64f04ab$var$ARROW_RIGHT;
    return $a2a32c30b64f04ab$var$doSwitch(orientation, vertical, horizontal) || key === 'Enter' || key === ' ' || key === '';
}
function $a2a32c30b64f04ab$var$isCrossOrientationOpenKey(key, orientation, rtl) {
    const vertical = rtl ? key === $a2a32c30b64f04ab$var$ARROW_LEFT : key === $a2a32c30b64f04ab$var$ARROW_RIGHT;
    const horizontal = key === $a2a32c30b64f04ab$var$ARROW_DOWN;
    return $a2a32c30b64f04ab$var$doSwitch(orientation, vertical, horizontal);
}
function $a2a32c30b64f04ab$var$isCrossOrientationCloseKey(key, orientation, rtl) {
    const vertical = rtl ? key === $a2a32c30b64f04ab$var$ARROW_RIGHT : key === $a2a32c30b64f04ab$var$ARROW_LEFT;
    const horizontal = key === $a2a32c30b64f04ab$var$ARROW_UP;
    return $a2a32c30b64f04ab$var$doSwitch(orientation, vertical, horizontal);
}
/**
 * Adds arrow key-based navigation of a list of items, either using real DOM
 * focus or virtual focus.
 * @see https://floating-ui.com/docs/useListNavigation
 */ function $a2a32c30b64f04ab$export$b5d22cac4ad33f40(context, props) {
    const { open: open, onOpenChange: onOpenChange, elements: elements } = context;
    const { listRef: listRef, activeIndex: activeIndex, onNavigate: unstable_onNavigate = ()=>{}, enabled: enabled = true, selectedIndex: selectedIndex = null, allowEscape: allowEscape = false, loop: loop = false, nested: nested = false, rtl: rtl = false, virtual: virtual = false, focusItemOnOpen: focusItemOnOpen = 'auto', focusItemOnHover: focusItemOnHover = true, openOnArrowKeyDown: openOnArrowKeyDown = true, disabledIndices: disabledIndices, orientation: orientation = 'vertical', cols: cols = 1, scrollItemIntoView: scrollItemIntoView = true, virtualItemRef: virtualItemRef, itemSizes: itemSizes, dense: dense = false } = props;
    const floatingFocusElement = $a2a32c30b64f04ab$var$getFloatingFocusElement(elements.floating);
    const floatingFocusElementRef = $a2a32c30b64f04ab$var$useLatestRef(floatingFocusElement);
    const parentId = $a2a32c30b64f04ab$export$165209eae06d3488();
    const tree = $a2a32c30b64f04ab$export$db0c2a7c7a2a4f69();
    const onNavigate = $a2a32c30b64f04ab$var$useEffectEvent(unstable_onNavigate);
    const typeableComboboxReference = (0, $hn8gG.isTypeableCombobox)(elements.domReference);
    const focusItemOnOpenRef = $8NFma.useRef(focusItemOnOpen);
    const indexRef = $8NFma.useRef(selectedIndex != null ? selectedIndex : -1);
    const keyRef = $8NFma.useRef(null);
    const isPointerModalityRef = $8NFma.useRef(true);
    const previousOnNavigateRef = $8NFma.useRef(onNavigate);
    const previousMountedRef = $8NFma.useRef(!!elements.floating);
    const previousOpenRef = $8NFma.useRef(open);
    const forceSyncFocus = $8NFma.useRef(false);
    const forceScrollIntoViewRef = $8NFma.useRef(false);
    const disabledIndicesRef = $a2a32c30b64f04ab$var$useLatestRef(disabledIndices);
    const latestOpenRef = $a2a32c30b64f04ab$var$useLatestRef(open);
    const scrollItemIntoViewRef = $a2a32c30b64f04ab$var$useLatestRef(scrollItemIntoView);
    const selectedIndexRef = $a2a32c30b64f04ab$var$useLatestRef(selectedIndex);
    const [activeId, setActiveId] = $8NFma.useState();
    const [virtualId, setVirtualId] = $8NFma.useState();
    const focusItem = $a2a32c30b64f04ab$var$useEffectEvent(function(listRef, indexRef, forceScrollIntoView) {
        if (forceScrollIntoView === void 0) forceScrollIntoView = false;
        function runFocus(item) {
            if (virtual) {
                setActiveId(item.id);
                tree == null || tree.events.emit('virtualfocus', item);
                if (virtualItemRef) virtualItemRef.current = item;
            } else $a2a32c30b64f04ab$var$enqueueFocus(item, {
                preventScroll: true,
                // Mac Safari does not move the virtual cursor unless the focus call
                // is sync. However, for the very first focus call, we need to wait
                // for the position to be ready in order to prevent unwanted
                // scrolling. This means the virtual cursor will not move to the first
                // item when first opening the floating element, but will on
                // subsequent calls. `preventScroll` is supported in modern Safari,
                // so we can use that instead.
                // iOS Safari must be async or the first item will not be focused.
                sync: (0, $hn8gG.isMac)() && (0, $hn8gG.isSafari)() ? $a2a32c30b64f04ab$var$isPreventScrollSupported || forceSyncFocus.current : false
            });
        }
        const initialItem = listRef.current[indexRef.current];
        if (initialItem) runFocus(initialItem);
        requestAnimationFrame(()=>{
            const waitedItem = listRef.current[indexRef.current] || initialItem;
            if (!waitedItem) return;
            if (!initialItem) runFocus(waitedItem);
            const scrollIntoViewOptions = scrollItemIntoViewRef.current;
            const shouldScrollIntoView = scrollIntoViewOptions && item && (forceScrollIntoView || !isPointerModalityRef.current);
            if (shouldScrollIntoView) // JSDOM doesn't support `.scrollIntoView()` but it's widely supported
            // by all browsers.
            waitedItem.scrollIntoView == null || waitedItem.scrollIntoView(typeof scrollIntoViewOptions === 'boolean' ? {
                block: 'nearest',
                inline: 'nearest'
            } : scrollIntoViewOptions);
        });
    });
    $a2a32c30b64f04ab$var$index(()=>{
        document.createElement('div').focus({
            get preventScroll () {
                $a2a32c30b64f04ab$var$isPreventScrollSupported = true;
                return false;
            }
        });
    }, []);
    // Sync `selectedIndex` to be the `activeIndex` upon opening the floating
    // element. Also, reset `activeIndex` upon closing the floating element.
    $a2a32c30b64f04ab$var$index(()=>{
        if (!enabled) return;
        if (open && elements.floating) {
            if (focusItemOnOpenRef.current && selectedIndex != null) {
                // Regardless of the pointer modality, we want to ensure the selected
                // item comes into view when the floating element is opened.
                forceScrollIntoViewRef.current = true;
                indexRef.current = selectedIndex;
                onNavigate(selectedIndex);
            }
        } else if (previousMountedRef.current) {
            // Since the user can specify `onNavigate` conditionally
            // (onNavigate: open ? setActiveIndex : setSelectedIndex),
            // we store and call the previous function.
            indexRef.current = -1;
            previousOnNavigateRef.current(null);
        }
    }, [
        enabled,
        open,
        elements.floating,
        selectedIndex,
        onNavigate
    ]);
    // Sync `activeIndex` to be the focused item while the floating element is
    // open.
    $a2a32c30b64f04ab$var$index(()=>{
        if (!enabled) return;
        if (open && elements.floating) {
            if (activeIndex == null) {
                forceSyncFocus.current = false;
                if (selectedIndexRef.current != null) return;
                // Reset while the floating element was open (e.g. the list changed).
                if (previousMountedRef.current) {
                    indexRef.current = -1;
                    focusItem(listRef, indexRef);
                }
                // Initial sync.
                if ((!previousOpenRef.current || !previousMountedRef.current) && focusItemOnOpenRef.current && (keyRef.current != null || focusItemOnOpenRef.current === true && keyRef.current == null)) {
                    let runs = 0;
                    const waitForListPopulated = ()=>{
                        if (listRef.current[0] == null) {
                            // Avoid letting the browser paint if possible on the first try,
                            // otherwise use rAF. Don't try more than twice, since something
                            // is wrong otherwise.
                            if (runs < 2) {
                                const scheduler = runs ? requestAnimationFrame : queueMicrotask;
                                scheduler(waitForListPopulated);
                            }
                            runs++;
                        } else {
                            indexRef.current = keyRef.current == null || $a2a32c30b64f04ab$var$isMainOrientationToEndKey(keyRef.current, orientation, rtl) || nested ? $a2a32c30b64f04ab$var$getMinIndex(listRef, disabledIndicesRef.current) : $a2a32c30b64f04ab$var$getMaxIndex(listRef, disabledIndicesRef.current);
                            keyRef.current = null;
                            onNavigate(indexRef.current);
                        }
                    };
                    waitForListPopulated();
                }
            } else if (!$a2a32c30b64f04ab$var$isIndexOutOfBounds(listRef, activeIndex)) {
                indexRef.current = activeIndex;
                focusItem(listRef, indexRef, forceScrollIntoViewRef.current);
                forceScrollIntoViewRef.current = false;
            }
        }
    }, [
        enabled,
        open,
        elements.floating,
        activeIndex,
        selectedIndexRef,
        nested,
        listRef,
        orientation,
        rtl,
        onNavigate,
        focusItem,
        disabledIndicesRef
    ]);
    // Ensure the parent floating element has focus when a nested child closes
    // to allow arrow key navigation to work after the pointer leaves the child.
    $a2a32c30b64f04ab$var$index(()=>{
        var _nodes$find;
        if (!enabled || elements.floating || !tree || virtual || !previousMountedRef.current) return;
        const nodes = tree.nodesRef.current;
        const parent = (_nodes$find = nodes.find((node)=>node.id === parentId)) == null || (_nodes$find = _nodes$find.context) == null ? void 0 : _nodes$find.elements.floating;
        const activeEl = (0, $hn8gG.activeElement)((0, $hn8gG.getDocument)(elements.floating));
        const treeContainsActiveEl = nodes.some((node)=>node.context && (0, $hn8gG.contains)(node.context.elements.floating, activeEl));
        if (parent && !treeContainsActiveEl && isPointerModalityRef.current) parent.focus({
            preventScroll: true
        });
    }, [
        enabled,
        elements.floating,
        tree,
        parentId,
        virtual
    ]);
    $a2a32c30b64f04ab$var$index(()=>{
        if (!enabled) return;
        if (!tree) return;
        if (!virtual) return;
        if (parentId) return;
        function handleVirtualFocus(item) {
            setVirtualId(item.id);
            if (virtualItemRef) virtualItemRef.current = item;
        }
        tree.events.on('virtualfocus', handleVirtualFocus);
        return ()=>{
            tree.events.off('virtualfocus', handleVirtualFocus);
        };
    }, [
        enabled,
        tree,
        virtual,
        parentId,
        virtualItemRef
    ]);
    $a2a32c30b64f04ab$var$index(()=>{
        previousOnNavigateRef.current = onNavigate;
        previousMountedRef.current = !!elements.floating;
    });
    $a2a32c30b64f04ab$var$index(()=>{
        if (!open) keyRef.current = null;
    }, [
        open
    ]);
    $a2a32c30b64f04ab$var$index(()=>{
        previousOpenRef.current = open;
    }, [
        open
    ]);
    const hasActiveIndex = activeIndex != null;
    const item = $8NFma.useMemo(()=>{
        function syncCurrentTarget(currentTarget) {
            if (!open) return;
            const index = listRef.current.indexOf(currentTarget);
            if (index !== -1) onNavigate(index);
        }
        const props = {
            onFocus (_ref) {
                let { currentTarget: currentTarget } = _ref;
                syncCurrentTarget(currentTarget);
            },
            onClick: (_ref2)=>{
                let { currentTarget: currentTarget } = _ref2;
                return currentTarget.focus({
                    preventScroll: true
                });
            },
            // Safari
            ...focusItemOnHover && {
                onMouseMove (_ref3) {
                    let { currentTarget: currentTarget } = _ref3;
                    syncCurrentTarget(currentTarget);
                },
                onPointerLeave (_ref4) {
                    let { pointerType: pointerType } = _ref4;
                    if (!isPointerModalityRef.current || pointerType === 'touch') return;
                    indexRef.current = -1;
                    focusItem(listRef, indexRef);
                    onNavigate(null);
                    if (!virtual) $a2a32c30b64f04ab$var$enqueueFocus(floatingFocusElementRef.current, {
                        preventScroll: true
                    });
                }
            }
        };
        return props;
    }, [
        open,
        floatingFocusElementRef,
        focusItem,
        focusItemOnHover,
        listRef,
        onNavigate,
        virtual
    ]);
    const commonOnKeyDown = $a2a32c30b64f04ab$var$useEffectEvent((event)=>{
        isPointerModalityRef.current = false;
        forceSyncFocus.current = true;
        // When composing a character, Chrome fires ArrowDown twice. Firefox/Safari
        // don't appear to suffer from this. `event.isComposing` is avoided due to
        // Safari not supporting it properly (although it's not needed in the first
        // place for Safari, just avoiding any possible issues).
        if (event.which === 229) return;
        // If the floating element is animating out, ignore navigation. Otherwise,
        // the `activeIndex` gets set to 0 despite not being open so the next time
        // the user ArrowDowns, the first item won't be focused.
        if (!latestOpenRef.current && event.currentTarget === floatingFocusElementRef.current) return;
        if (nested && $a2a32c30b64f04ab$var$isCrossOrientationCloseKey(event.key, orientation, rtl)) {
            (0, $hn8gG.stopEvent)(event);
            onOpenChange(false, event.nativeEvent, 'list-navigation');
            if ((0, $1D9S2.isHTMLElement)(elements.domReference)) {
                if (virtual) tree == null || tree.events.emit('virtualfocus', elements.domReference);
                else elements.domReference.focus();
            }
            return;
        }
        const currentIndex = indexRef.current;
        const minIndex = $a2a32c30b64f04ab$var$getMinIndex(listRef, disabledIndices);
        const maxIndex = $a2a32c30b64f04ab$var$getMaxIndex(listRef, disabledIndices);
        if (!typeableComboboxReference) {
            if (event.key === 'Home') {
                (0, $hn8gG.stopEvent)(event);
                indexRef.current = minIndex;
                onNavigate(indexRef.current);
            }
            if (event.key === 'End') {
                (0, $hn8gG.stopEvent)(event);
                indexRef.current = maxIndex;
                onNavigate(indexRef.current);
            }
        }
        // Grid navigation.
        if (cols > 1) {
            const sizes = itemSizes || Array.from({
                length: listRef.current.length
            }, ()=>({
                    width: 1,
                    height: 1
                }));
            // To calculate movements on the grid, we use hypothetical cell indices
            // as if every item was 1x1, then convert back to real indices.
            const cellMap = $a2a32c30b64f04ab$var$buildCellMap(sizes, cols, dense);
            const minGridIndex = cellMap.findIndex((index)=>index != null && !$a2a32c30b64f04ab$var$isDisabled(listRef.current, index, disabledIndices));
            // last enabled index
            const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex)=>index != null && !$a2a32c30b64f04ab$var$isDisabled(listRef.current, index, disabledIndices) ? cellIndex : foundIndex, -1);
            const index = cellMap[$a2a32c30b64f04ab$var$getGridNavigatedIndex({
                current: cellMap.map((itemIndex)=>itemIndex != null ? listRef.current[itemIndex] : null)
            }, {
                event: event,
                orientation: orientation,
                loop: loop,
                cols: cols,
                // treat undefined (empty grid spaces) as disabled indices so we
                // don't end up in them
                disabledIndices: $a2a32c30b64f04ab$var$getCellIndices([
                    ...disabledIndices || listRef.current.map((_, index)=>$a2a32c30b64f04ab$var$isDisabled(listRef.current, index) ? index : undefined),
                    undefined
                ], cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: $a2a32c30b64f04ab$var$getCellIndexOfCorner(indexRef.current > maxIndex ? minIndex : indexRef.current, sizes, cellMap, cols, // use a corner matching the edge closest to the direction
                // we're moving in so we don't end up in the same item. Prefer
                // top/left over bottom/right.
                event.key === $a2a32c30b64f04ab$var$ARROW_DOWN ? 'bl' : event.key === $a2a32c30b64f04ab$var$ARROW_RIGHT ? 'tr' : 'tl'),
                stopEvent: true
            })];
            if (index != null) {
                indexRef.current = index;
                onNavigate(indexRef.current);
            }
            if (orientation === 'both') return;
        }
        if ($a2a32c30b64f04ab$var$isMainOrientationKey(event.key, orientation)) {
            (0, $hn8gG.stopEvent)(event);
            // Reset the index if no item is focused.
            if (open && !virtual && (0, $hn8gG.activeElement)(event.currentTarget.ownerDocument) === event.currentTarget) {
                indexRef.current = $a2a32c30b64f04ab$var$isMainOrientationToEndKey(event.key, orientation, rtl) ? minIndex : maxIndex;
                onNavigate(indexRef.current);
                return;
            }
            if ($a2a32c30b64f04ab$var$isMainOrientationToEndKey(event.key, orientation, rtl)) {
                if (loop) indexRef.current = currentIndex >= maxIndex ? allowEscape && currentIndex !== listRef.current.length ? -1 : minIndex : $a2a32c30b64f04ab$var$findNonDisabledIndex(listRef, {
                    startingIndex: currentIndex,
                    disabledIndices: disabledIndices
                });
                else indexRef.current = Math.min(maxIndex, $a2a32c30b64f04ab$var$findNonDisabledIndex(listRef, {
                    startingIndex: currentIndex,
                    disabledIndices: disabledIndices
                }));
            } else if (loop) indexRef.current = currentIndex <= minIndex ? allowEscape && currentIndex !== -1 ? listRef.current.length : maxIndex : $a2a32c30b64f04ab$var$findNonDisabledIndex(listRef, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices: disabledIndices
            });
            else indexRef.current = Math.max(minIndex, $a2a32c30b64f04ab$var$findNonDisabledIndex(listRef, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices: disabledIndices
            }));
            if ($a2a32c30b64f04ab$var$isIndexOutOfBounds(listRef, indexRef.current)) onNavigate(null);
            else onNavigate(indexRef.current);
        }
    });
    const ariaActiveDescendantProp = $8NFma.useMemo(()=>{
        return virtual && open && hasActiveIndex && {
            'aria-activedescendant': virtualId || activeId
        };
    }, [
        virtual,
        open,
        hasActiveIndex,
        virtualId,
        activeId
    ]);
    const floating = $8NFma.useMemo(()=>{
        return {
            'aria-orientation': orientation === 'both' ? undefined : orientation,
            ...!(0, $hn8gG.isTypeableCombobox)(elements.domReference) && ariaActiveDescendantProp,
            onKeyDown: commonOnKeyDown,
            onPointerMove () {
                isPointerModalityRef.current = true;
            }
        };
    }, [
        ariaActiveDescendantProp,
        commonOnKeyDown,
        elements.domReference,
        orientation
    ]);
    const reference = $8NFma.useMemo(()=>{
        function checkVirtualMouse(event) {
            if (focusItemOnOpen === 'auto' && (0, $hn8gG.isVirtualClick)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        function checkVirtualPointer(event) {
            // `pointerdown` fires first, reset the state then perform the checks.
            focusItemOnOpenRef.current = focusItemOnOpen;
            if (focusItemOnOpen === 'auto' && (0, $hn8gG.isVirtualPointerEvent)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        return {
            ...ariaActiveDescendantProp,
            onKeyDown (event) {
                isPointerModalityRef.current = false;
                const isArrowKey = event.key.startsWith('Arrow');
                const isHomeOrEndKey = [
                    'Home',
                    'End'
                ].includes(event.key);
                const isMoveKey = isArrowKey || isHomeOrEndKey;
                const isCrossOpenKey = $a2a32c30b64f04ab$var$isCrossOrientationOpenKey(event.key, orientation, rtl);
                const isCrossCloseKey = $a2a32c30b64f04ab$var$isCrossOrientationCloseKey(event.key, orientation, rtl);
                const isMainKey = $a2a32c30b64f04ab$var$isMainOrientationKey(event.key, orientation);
                const isNavigationKey = (nested ? isCrossOpenKey : isMainKey) || event.key === 'Enter' || event.key.trim() === '';
                if (virtual && open) {
                    const rootNode = tree == null ? void 0 : tree.nodesRef.current.find((node)=>node.parentId == null);
                    const deepestNode = tree && rootNode ? $a2a32c30b64f04ab$var$getDeepestNode(tree.nodesRef.current, rootNode.id) : null;
                    if (isMoveKey && deepestNode && virtualItemRef) {
                        const eventObject = new KeyboardEvent('keydown', {
                            key: event.key,
                            bubbles: true
                        });
                        if (isCrossOpenKey || isCrossCloseKey) {
                            var _deepestNode$context, _deepestNode$context2;
                            const isCurrentTarget = ((_deepestNode$context = deepestNode.context) == null ? void 0 : _deepestNode$context.elements.domReference) === event.currentTarget;
                            const dispatchItem = isCrossCloseKey && !isCurrentTarget ? (_deepestNode$context2 = deepestNode.context) == null ? void 0 : _deepestNode$context2.elements.domReference : isCrossOpenKey ? listRef.current.find((item)=>(item == null ? void 0 : item.id) === activeId) : null;
                            if (dispatchItem) {
                                (0, $hn8gG.stopEvent)(event);
                                dispatchItem.dispatchEvent(eventObject);
                                setVirtualId(undefined);
                            }
                        }
                        if ((isMainKey || isHomeOrEndKey) && deepestNode.context) {
                            if (deepestNode.context.open && deepestNode.parentId && event.currentTarget !== deepestNode.context.elements.domReference) {
                                var _deepestNode$context$;
                                (0, $hn8gG.stopEvent)(event);
                                (_deepestNode$context$ = deepestNode.context.elements.domReference) == null || _deepestNode$context$.dispatchEvent(eventObject);
                                return;
                            }
                        }
                    }
                    return commonOnKeyDown(event);
                }
                // If a floating element should not open on arrow key down, avoid
                // setting `activeIndex` while it's closed.
                if (!open && !openOnArrowKeyDown && isArrowKey) return;
                if (isNavigationKey) keyRef.current = nested && isMainKey ? null : event.key;
                if (nested) {
                    if (isCrossOpenKey) {
                        (0, $hn8gG.stopEvent)(event);
                        if (open) {
                            indexRef.current = $a2a32c30b64f04ab$var$getMinIndex(listRef, disabledIndicesRef.current);
                            onNavigate(indexRef.current);
                        } else onOpenChange(true, event.nativeEvent, 'list-navigation');
                    }
                    return;
                }
                if (isMainKey) {
                    if (selectedIndex != null) indexRef.current = selectedIndex;
                    (0, $hn8gG.stopEvent)(event);
                    if (!open && openOnArrowKeyDown) onOpenChange(true, event.nativeEvent, 'list-navigation');
                    else commonOnKeyDown(event);
                    if (open) onNavigate(indexRef.current);
                }
            },
            onFocus () {
                if (open && !virtual) onNavigate(null);
            },
            onPointerDown: checkVirtualPointer,
            onMouseDown: checkVirtualMouse,
            onClick: checkVirtualMouse
        };
    }, [
        activeId,
        ariaActiveDescendantProp,
        commonOnKeyDown,
        disabledIndicesRef,
        focusItemOnOpen,
        listRef,
        nested,
        onNavigate,
        onOpenChange,
        open,
        openOnArrowKeyDown,
        orientation,
        rtl,
        selectedIndex,
        tree,
        virtual,
        virtualItemRef
    ]);
    return $8NFma.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating,
            item: item
        } : {}, [
        enabled,
        reference,
        floating,
        item
    ]);
}
const $a2a32c30b64f04ab$var$componentRoleToAriaRoleMap = /*#__PURE__*/ new Map([
    [
        'select',
        'listbox'
    ],
    [
        'combobox',
        'listbox'
    ],
    [
        'label',
        false
    ]
]);
/**
 * Adds base screen reader props to the reference and floating elements for a
 * given floating element `role`.
 * @see https://floating-ui.com/docs/useRole
 */ function $a2a32c30b64f04ab$export$f66572793fa256a1(context, props) {
    var _componentRoleToAriaR;
    if (props === void 0) props = {};
    const { open: open, floatingId: floatingId } = context;
    const { enabled: enabled = true, role: role = 'dialog' } = props;
    const ariaRole = (_componentRoleToAriaR = $a2a32c30b64f04ab$var$componentRoleToAriaRoleMap.get(role)) != null ? _componentRoleToAriaR : role;
    const referenceId = $a2a32c30b64f04ab$export$f680877a34711e37();
    const parentId = $a2a32c30b64f04ab$export$165209eae06d3488();
    const isNested = parentId != null;
    const reference = $8NFma.useMemo(()=>{
        if (ariaRole === 'tooltip' || role === 'label') return {
            ["aria-" + (role === 'label' ? 'labelledby' : 'describedby')]: open ? floatingId : undefined
        };
        return {
            'aria-expanded': open ? 'true' : 'false',
            'aria-haspopup': ariaRole === 'alertdialog' ? 'dialog' : ariaRole,
            'aria-controls': open ? floatingId : undefined,
            ...ariaRole === 'listbox' && {
                role: 'combobox'
            },
            ...ariaRole === 'menu' && {
                id: referenceId
            },
            ...ariaRole === 'menu' && isNested && {
                role: 'menuitem'
            },
            ...role === 'select' && {
                'aria-autocomplete': 'none'
            },
            ...role === 'combobox' && {
                'aria-autocomplete': 'list'
            }
        };
    }, [
        ariaRole,
        floatingId,
        isNested,
        open,
        referenceId,
        role
    ]);
    const floating = $8NFma.useMemo(()=>{
        const floatingProps = {
            id: floatingId,
            ...ariaRole && {
                role: ariaRole
            }
        };
        if (ariaRole === 'tooltip' || role === 'label') return floatingProps;
        return {
            ...floatingProps,
            ...ariaRole === 'menu' && {
                'aria-labelledby': referenceId
            }
        };
    }, [
        ariaRole,
        floatingId,
        referenceId,
        role
    ]);
    const item = $8NFma.useCallback((_ref)=>{
        let { active: active, selected: selected } = _ref;
        const commonProps = {
            role: 'option',
            ...active && {
                id: floatingId + "-option"
            }
        };
        // For `menu`, we are unable to tell if the item is a `menuitemradio`
        // or `menuitemcheckbox`. For backwards-compatibility reasons, also
        // avoid defaulting to `menuitem` as it may overwrite custom role props.
        switch(role){
            case 'select':
                return {
                    ...commonProps,
                    'aria-selected': active && selected
                };
            case 'combobox':
                return {
                    ...commonProps,
                    ...active && {
                        'aria-selected': true
                    }
                };
        }
        return {};
    }, [
        floatingId,
        role
    ]);
    return $8NFma.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating,
            item: item
        } : {}, [
        enabled,
        reference,
        floating,
        item
    ]);
}
// Converts a JS style key like `backgroundColor` to a CSS transition-property
// like `background-color`.
const $a2a32c30b64f04ab$var$camelCaseToKebabCase = (str)=>str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs)=>(ofs ? '-' : '') + $.toLowerCase());
function $a2a32c30b64f04ab$var$execWithArgsOrReturn(valueOrFn, args) {
    return typeof valueOrFn === 'function' ? valueOrFn(args) : valueOrFn;
}
function $a2a32c30b64f04ab$var$useDelayUnmount(open, durationMs) {
    const [isMounted, setIsMounted] = $8NFma.useState(open);
    if (open && !isMounted) setIsMounted(true);
    $8NFma.useEffect(()=>{
        if (!open && isMounted) {
            const timeout = setTimeout(()=>setIsMounted(false), durationMs);
            return ()=>clearTimeout(timeout);
        }
    }, [
        open,
        isMounted,
        durationMs
    ]);
    return isMounted;
}
/**
 * Provides a status string to apply CSS transitions to a floating element,
 * correctly handling placement-aware transitions.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstatus
 */ function $a2a32c30b64f04ab$export$b2ef21706733f7e5(context, props) {
    if (props === void 0) props = {};
    const { open: open, elements: { floating: floating } } = context;
    const { duration: duration = 250 } = props;
    const isNumberDuration = typeof duration === 'number';
    const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    const [status, setStatus] = $8NFma.useState('unmounted');
    const isMounted = $a2a32c30b64f04ab$var$useDelayUnmount(open, closeDuration);
    if (!isMounted && status === 'close') setStatus('unmounted');
    $a2a32c30b64f04ab$var$index(()=>{
        if (!floating) return;
        if (open) {
            setStatus('initial');
            const frame = requestAnimationFrame(()=>{
                setStatus('open');
            });
            return ()=>{
                cancelAnimationFrame(frame);
            };
        }
        setStatus('close');
    }, [
        open,
        floating
    ]);
    return {
        isMounted: isMounted,
        status: status
    };
}
/**
 * Provides styles to apply CSS transitions to a floating element, correctly
 * handling placement-aware transitions. Wrapper around `useTransitionStatus`.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstyles
 */ function $a2a32c30b64f04ab$export$769fba13884bc2f4(context, props) {
    if (props === void 0) props = {};
    const { initial: unstable_initial = {
        opacity: 0
    }, open: unstable_open, close: unstable_close, common: unstable_common, duration: duration = 250 } = props;
    const placement = context.placement;
    const side = placement.split('-')[0];
    const fnArgs = $8NFma.useMemo(()=>({
            side: side,
            placement: placement
        }), [
        side,
        placement
    ]);
    const isNumberDuration = typeof duration === 'number';
    const openDuration = (isNumberDuration ? duration : duration.open) || 0;
    const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    const [styles, setStyles] = $8NFma.useState(()=>({
            ...$a2a32c30b64f04ab$var$execWithArgsOrReturn(unstable_common, fnArgs),
            ...$a2a32c30b64f04ab$var$execWithArgsOrReturn(unstable_initial, fnArgs)
        }));
    const { isMounted: isMounted, status: status } = $a2a32c30b64f04ab$export$b2ef21706733f7e5(context, {
        duration: duration
    });
    const initialRef = $a2a32c30b64f04ab$var$useLatestRef(unstable_initial);
    const openRef = $a2a32c30b64f04ab$var$useLatestRef(unstable_open);
    const closeRef = $a2a32c30b64f04ab$var$useLatestRef(unstable_close);
    const commonRef = $a2a32c30b64f04ab$var$useLatestRef(unstable_common);
    $a2a32c30b64f04ab$var$index(()=>{
        const initialStyles = $a2a32c30b64f04ab$var$execWithArgsOrReturn(initialRef.current, fnArgs);
        const closeStyles = $a2a32c30b64f04ab$var$execWithArgsOrReturn(closeRef.current, fnArgs);
        const commonStyles = $a2a32c30b64f04ab$var$execWithArgsOrReturn(commonRef.current, fnArgs);
        const openStyles = $a2a32c30b64f04ab$var$execWithArgsOrReturn(openRef.current, fnArgs) || Object.keys(initialStyles).reduce((acc, key)=>{
            acc[key] = '';
            return acc;
        }, {});
        if (status === 'initial') setStyles((styles)=>({
                transitionProperty: styles.transitionProperty,
                ...commonStyles,
                ...initialStyles
            }));
        if (status === 'open') setStyles({
            transitionProperty: Object.keys(openStyles).map($a2a32c30b64f04ab$var$camelCaseToKebabCase).join(','),
            transitionDuration: openDuration + "ms",
            ...commonStyles,
            ...openStyles
        });
        if (status === 'close') {
            const styles = closeStyles || initialStyles;
            setStyles({
                transitionProperty: Object.keys(styles).map($a2a32c30b64f04ab$var$camelCaseToKebabCase).join(','),
                transitionDuration: closeDuration + "ms",
                ...commonStyles,
                ...styles
            });
        }
    }, [
        closeDuration,
        closeRef,
        initialRef,
        openRef,
        commonRef,
        openDuration,
        status,
        fnArgs
    ]);
    return {
        isMounted: isMounted,
        styles: styles
    };
}
/**
 * Provides a matching callback that can be used to focus an item as the user
 * types, often used in tandem with `useListNavigation()`.
 * @see https://floating-ui.com/docs/useTypeahead
 */ function $a2a32c30b64f04ab$export$d8d674d50b73ba93(context, props) {
    var _ref;
    const { open: open, dataRef: dataRef } = context;
    const { listRef: listRef, activeIndex: activeIndex, onMatch: unstable_onMatch, onTypingChange: unstable_onTypingChange, enabled: enabled = true, findMatch: findMatch = null, resetMs: resetMs = 750, ignoreKeys: ignoreKeys = [], selectedIndex: selectedIndex = null } = props;
    const timeoutIdRef = $8NFma.useRef();
    const stringRef = $8NFma.useRef('');
    const prevIndexRef = $8NFma.useRef((_ref = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref : -1);
    const matchIndexRef = $8NFma.useRef(null);
    const onMatch = $a2a32c30b64f04ab$var$useEffectEvent(unstable_onMatch);
    const onTypingChange = $a2a32c30b64f04ab$var$useEffectEvent(unstable_onTypingChange);
    const findMatchRef = $a2a32c30b64f04ab$var$useLatestRef(findMatch);
    const ignoreKeysRef = $a2a32c30b64f04ab$var$useLatestRef(ignoreKeys);
    $a2a32c30b64f04ab$var$index(()=>{
        if (open) {
            clearTimeout(timeoutIdRef.current);
            matchIndexRef.current = null;
            stringRef.current = '';
        }
    }, [
        open
    ]);
    $a2a32c30b64f04ab$var$index(()=>{
        // Sync arrow key navigation but not typeahead navigation.
        if (open && stringRef.current === '') {
            var _ref2;
            prevIndexRef.current = (_ref2 = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref2 : -1;
        }
    }, [
        open,
        selectedIndex,
        activeIndex
    ]);
    const setTypingChange = $a2a32c30b64f04ab$var$useEffectEvent((value)=>{
        if (value) {
            if (!dataRef.current.typing) {
                dataRef.current.typing = value;
                onTypingChange(value);
            }
        } else if (dataRef.current.typing) {
            dataRef.current.typing = value;
            onTypingChange(value);
        }
    });
    const onKeyDown = $a2a32c30b64f04ab$var$useEffectEvent((event)=>{
        function getMatchingIndex(list, orderedList, string) {
            const str = findMatchRef.current ? findMatchRef.current(orderedList, string) : orderedList.find((text)=>(text == null ? void 0 : text.toLocaleLowerCase().indexOf(string.toLocaleLowerCase())) === 0);
            return str ? list.indexOf(str) : -1;
        }
        const listContent = listRef.current;
        if (stringRef.current.length > 0 && stringRef.current[0] !== ' ') {
            if (getMatchingIndex(listContent, listContent, stringRef.current) === -1) setTypingChange(false);
            else if (event.key === ' ') (0, $hn8gG.stopEvent)(event);
        }
        if (listContent == null || ignoreKeysRef.current.includes(event.key) || // Character key.
        event.key.length !== 1 || // Modifier key.
        event.ctrlKey || event.metaKey || event.altKey) return;
        if (open && event.key !== ' ') {
            (0, $hn8gG.stopEvent)(event);
            setTypingChange(true);
        }
        // Bail out if the list contains a word like "llama" or "aaron". TODO:
        // allow it in this case, too.
        const allowRapidSuccessionOfFirstLetter = listContent.every((text)=>{
            var _text$, _text$2;
            return text ? ((_text$ = text[0]) == null ? void 0 : _text$.toLocaleLowerCase()) !== ((_text$2 = text[1]) == null ? void 0 : _text$2.toLocaleLowerCase()) : true;
        });
        // Allows the user to cycle through items that start with the same letter
        // in rapid succession.
        if (allowRapidSuccessionOfFirstLetter && stringRef.current === event.key) {
            stringRef.current = '';
            prevIndexRef.current = matchIndexRef.current;
        }
        stringRef.current += event.key;
        clearTimeout(timeoutIdRef.current);
        timeoutIdRef.current = setTimeout(()=>{
            stringRef.current = '';
            prevIndexRef.current = matchIndexRef.current;
            setTypingChange(false);
        }, resetMs);
        const prevIndex = prevIndexRef.current;
        const index = getMatchingIndex(listContent, [
            ...listContent.slice((prevIndex || 0) + 1),
            ...listContent.slice(0, (prevIndex || 0) + 1)
        ], stringRef.current);
        if (index !== -1) {
            onMatch(index);
            matchIndexRef.current = index;
        } else if (event.key !== ' ') {
            stringRef.current = '';
            setTypingChange(false);
        }
    });
    const reference = $8NFma.useMemo(()=>({
            onKeyDown: onKeyDown
        }), [
        onKeyDown
    ]);
    const floating = $8NFma.useMemo(()=>{
        return {
            onKeyDown: onKeyDown,
            onKeyUp (event) {
                if (event.key === ' ') setTypingChange(false);
            }
        };
    }, [
        onKeyDown,
        setTypingChange
    ]);
    return $8NFma.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
function $a2a32c30b64f04ab$var$getArgsWithCustomFloatingHeight(state, height) {
    return {
        ...state,
        rects: {
            ...state.rects,
            floating: {
                ...state.rects.floating,
                height: height
            }
        }
    };
}
/**
 * Positions the floating element such that an inner element inside of it is
 * anchored to the reference element.
 * @see https://floating-ui.com/docs/inner
 */ const $a2a32c30b64f04ab$export$4ae363f1d88fb658 = (props)=>({
        name: 'inner',
        options: props,
        async fn (state) {
            const { listRef: listRef, overflowRef: overflowRef, onFallbackChange: onFallbackChange, offset: innerOffset = 0, index: index = 0, minItemsVisible: minItemsVisible = 4, referenceOverflowThreshold: referenceOverflowThreshold = 0, scrollRef: scrollRef, ...detectOverflowOptions } = (0, $Euxde.evaluate)(props, state);
            const { rects: rects, elements: { floating: floating } } = state;
            const item = listRef.current[index];
            const scrollEl = (scrollRef == null ? void 0 : scrollRef.current) || floating;
            // Valid combinations:
            // 1. Floating element is the scrollRef and has a border (default)
            // 2. Floating element is not the scrollRef, floating element has a border
            // 3. Floating element is not the scrollRef, scrollRef has a border
            // Floating > {...getFloatingProps()} wrapper > scrollRef > items is not
            // allowed as VoiceOver doesn't work.
            const clientTop = floating.clientTop || scrollEl.clientTop;
            const floatingIsBordered = floating.clientTop !== 0;
            const scrollElIsBordered = scrollEl.clientTop !== 0;
            const floatingIsScrollEl = floating === scrollEl;
            if (!item) return {};
            const nextArgs = {
                ...state,
                ...await (0, $eqxtD.offset)(-item.offsetTop - floating.clientTop - rects.reference.height / 2 - item.offsetHeight / 2 - innerOffset).fn(state)
            };
            const overflow = await (0, $8i2T6.detectOverflow)($a2a32c30b64f04ab$var$getArgsWithCustomFloatingHeight(nextArgs, scrollEl.scrollHeight + clientTop + floating.clientTop), detectOverflowOptions);
            const refOverflow = await (0, $8i2T6.detectOverflow)(nextArgs, {
                ...detectOverflowOptions,
                elementContext: 'reference'
            });
            const diffY = (0, $Euxde.max)(0, overflow.top);
            const nextY = nextArgs.y + diffY;
            const isScrollable = scrollEl.scrollHeight > scrollEl.clientHeight;
            const rounder = isScrollable ? (v)=>v : (0, $Euxde.round);
            const maxHeight = rounder((0, $Euxde.max)(0, scrollEl.scrollHeight + (floatingIsBordered && floatingIsScrollEl || scrollElIsBordered ? clientTop * 2 : 0) - diffY - (0, $Euxde.max)(0, overflow.bottom)));
            scrollEl.style.maxHeight = maxHeight + "px";
            scrollEl.scrollTop = diffY;
            // There is not enough space, fallback to standard anchored positioning
            if (onFallbackChange) {
                const shouldFallback = scrollEl.offsetHeight < item.offsetHeight * (0, $Euxde.min)(minItemsVisible, listRef.current.length) - 1 || refOverflow.top >= -referenceOverflowThreshold || refOverflow.bottom >= -referenceOverflowThreshold;
                $2pmb0.flushSync(()=>onFallbackChange(shouldFallback));
            }
            if (overflowRef) overflowRef.current = await (0, $8i2T6.detectOverflow)($a2a32c30b64f04ab$var$getArgsWithCustomFloatingHeight({
                ...nextArgs,
                y: nextY
            }, scrollEl.offsetHeight + clientTop + floating.clientTop), detectOverflowOptions);
            return {
                y: nextY
            };
        }
    });
/**
 * Changes the `inner` middleware's `offset` upon a `wheel` event to
 * expand the floating element's height, revealing more list items.
 * @see https://floating-ui.com/docs/inner
 */ function $a2a32c30b64f04ab$export$3d74b0dda7cc82ff(context, props) {
    const { open: open, elements: elements } = context;
    const { enabled: enabled = true, overflowRef: overflowRef, scrollRef: scrollRef, onChange: unstable_onChange } = props;
    const onChange = $a2a32c30b64f04ab$var$useEffectEvent(unstable_onChange);
    const controlledScrollingRef = $8NFma.useRef(false);
    const prevScrollTopRef = $8NFma.useRef(null);
    const initialOverflowRef = $8NFma.useRef(null);
    $8NFma.useEffect(()=>{
        if (!enabled) return;
        function onWheel(e) {
            if (e.ctrlKey || !el || overflowRef.current == null) return;
            const dY = e.deltaY;
            const isAtTop = overflowRef.current.top >= -0.5;
            const isAtBottom = overflowRef.current.bottom >= -0.5;
            const remainingScroll = el.scrollHeight - el.clientHeight;
            const sign = dY < 0 ? -1 : 1;
            const method = dY < 0 ? 'max' : 'min';
            if (el.scrollHeight <= el.clientHeight) return;
            if (!isAtTop && dY > 0 || !isAtBottom && dY < 0) {
                e.preventDefault();
                $2pmb0.flushSync(()=>{
                    onChange((d)=>d + Math[method](dY, remainingScroll * sign));
                });
            } else if (/firefox/i.test((0, $hn8gG.getUserAgent)())) // Needed to propagate scrolling during momentum scrolling phase once
            // it gets limited by the boundary. UX improvement, not critical.
            el.scrollTop += dY;
        }
        const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
        if (open && el) {
            el.addEventListener('wheel', onWheel);
            // Wait for the position to be ready.
            requestAnimationFrame(()=>{
                prevScrollTopRef.current = el.scrollTop;
                if (overflowRef.current != null) initialOverflowRef.current = {
                    ...overflowRef.current
                };
            });
            return ()=>{
                prevScrollTopRef.current = null;
                initialOverflowRef.current = null;
                el.removeEventListener('wheel', onWheel);
            };
        }
    }, [
        enabled,
        open,
        elements.floating,
        overflowRef,
        scrollRef,
        onChange
    ]);
    const floating = $8NFma.useMemo(()=>({
            onKeyDown () {
                controlledScrollingRef.current = true;
            },
            onWheel () {
                controlledScrollingRef.current = false;
            },
            onPointerMove () {
                controlledScrollingRef.current = false;
            },
            onScroll () {
                const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
                if (!overflowRef.current || !el || !controlledScrollingRef.current) return;
                if (prevScrollTopRef.current !== null) {
                    const scrollDiff = el.scrollTop - prevScrollTopRef.current;
                    if (overflowRef.current.bottom < -0.5 && scrollDiff < -1 || overflowRef.current.top < -0.5 && scrollDiff > 1) $2pmb0.flushSync(()=>onChange((d)=>d + scrollDiff));
                }
                // [Firefox] Wait for the height change to have been applied.
                requestAnimationFrame(()=>{
                    prevScrollTopRef.current = el.scrollTop;
                });
            }
        }), [
        elements.floating,
        onChange,
        overflowRef,
        scrollRef
    ]);
    return $8NFma.useMemo(()=>enabled ? {
            floating: floating
        } : {}, [
        enabled,
        floating
    ]);
}
function $a2a32c30b64f04ab$var$isPointInPolygon(point, polygon) {
    const [x, y] = point;
    let isInside = false;
    const length = polygon.length;
    for(let i = 0, j = length - 1; i < length; j = i++){
        const [xi, yi] = polygon[i] || [
            0,
            0
        ];
        const [xj, yj] = polygon[j] || [
            0,
            0
        ];
        const intersect = yi >= y !== yj >= y && x <= (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) isInside = !isInside;
    }
    return isInside;
}
function $a2a32c30b64f04ab$var$isInside(point, rect) {
    return point[0] >= rect.x && point[0] <= rect.x + rect.width && point[1] >= rect.y && point[1] <= rect.y + rect.height;
}
/**
 * Generates a safe polygon area that the user can traverse without closing the
 * floating element once leaving the reference element.
 * @see https://floating-ui.com/docs/useHover#safepolygon
 */ function $a2a32c30b64f04ab$export$7484214ab62358d2(options) {
    if (options === void 0) options = {};
    const { buffer: buffer = 0.5, blockPointerEvents: blockPointerEvents = false, requireIntent: requireIntent = true } = options;
    let timeoutId;
    let hasLanded = false;
    let lastX = null;
    let lastY = null;
    let lastCursorTime = performance.now();
    function getCursorSpeed(x, y) {
        const currentTime = performance.now();
        const elapsedTime = currentTime - lastCursorTime;
        if (lastX === null || lastY === null || elapsedTime === 0) {
            lastX = x;
            lastY = y;
            lastCursorTime = currentTime;
            return null;
        }
        const deltaX = x - lastX;
        const deltaY = y - lastY;
        const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
        const speed = distance / elapsedTime; // px / ms
        lastX = x;
        lastY = y;
        lastCursorTime = currentTime;
        return speed;
    }
    const fn = (_ref)=>{
        let { x: x, y: y, placement: placement, elements: elements, onClose: onClose, nodeId: nodeId, tree: tree } = _ref;
        return function onMouseMove(event) {
            function close() {
                clearTimeout(timeoutId);
                onClose();
            }
            clearTimeout(timeoutId);
            if (!elements.domReference || !elements.floating || placement == null || x == null || y == null) return;
            const { clientX: clientX, clientY: clientY } = event;
            const clientPoint = [
                clientX,
                clientY
            ];
            const target = (0, $hn8gG.getTarget)(event);
            const isLeave = event.type === 'mouseleave';
            const isOverFloatingEl = (0, $hn8gG.contains)(elements.floating, target);
            const isOverReferenceEl = (0, $hn8gG.contains)(elements.domReference, target);
            const refRect = elements.domReference.getBoundingClientRect();
            const rect = elements.floating.getBoundingClientRect();
            const side = placement.split('-')[0];
            const cursorLeaveFromRight = x > rect.right - rect.width / 2;
            const cursorLeaveFromBottom = y > rect.bottom - rect.height / 2;
            const isOverReferenceRect = $a2a32c30b64f04ab$var$isInside(clientPoint, refRect);
            const isFloatingWider = rect.width > refRect.width;
            const isFloatingTaller = rect.height > refRect.height;
            const left = (isFloatingWider ? refRect : rect).left;
            const right = (isFloatingWider ? refRect : rect).right;
            const top = (isFloatingTaller ? refRect : rect).top;
            const bottom = (isFloatingTaller ? refRect : rect).bottom;
            if (isOverFloatingEl) {
                hasLanded = true;
                if (!isLeave) return;
            }
            if (isOverReferenceEl) hasLanded = false;
            if (isOverReferenceEl && !isLeave) {
                hasLanded = true;
                return;
            }
            // Prevent overlapping floating element from being stuck in an open-close
            // loop: https://github.com/floating-ui/floating-ui/issues/1910
            if (isLeave && (0, $1D9S2.isElement)(event.relatedTarget) && (0, $hn8gG.contains)(elements.floating, event.relatedTarget)) return;
            // If any nested child is open, abort.
            if (tree && $a2a32c30b64f04ab$var$getChildren(tree.nodesRef.current, nodeId).some((_ref2)=>{
                let { context: context } = _ref2;
                return context == null ? void 0 : context.open;
            })) return;
            // If the pointer is leaving from the opposite side, the "buffer" logic
            // creates a point where the floating element remains open, but should be
            // ignored.
            // A constant of 1 handles floating point rounding errors.
            if (side === 'top' && y >= refRect.bottom - 1 || side === 'bottom' && y <= refRect.top + 1 || side === 'left' && x >= refRect.right - 1 || side === 'right' && x <= refRect.left + 1) return close();
            // Ignore when the cursor is within the rectangular trough between the
            // two elements. Since the triangle is created from the cursor point,
            // which can start beyond the ref element's edge, traversing back and
            // forth from the ref to the floating element can cause it to close. This
            // ensures it always remains open in that case.
            let rectPoly = [];
            switch(side){
                case 'top':
                    rectPoly = [
                        [
                            left,
                            refRect.top + 1
                        ],
                        [
                            left,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            refRect.top + 1
                        ]
                    ];
                    break;
                case 'bottom':
                    rectPoly = [
                        [
                            left,
                            rect.top + 1
                        ],
                        [
                            left,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            rect.top + 1
                        ]
                    ];
                    break;
                case 'left':
                    rectPoly = [
                        [
                            rect.right - 1,
                            bottom
                        ],
                        [
                            rect.right - 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            bottom
                        ]
                    ];
                    break;
                case 'right':
                    rectPoly = [
                        [
                            refRect.right - 1,
                            bottom
                        ],
                        [
                            refRect.right - 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            bottom
                        ]
                    ];
                    break;
            }
            function getPolygon(_ref3) {
                let [x, y] = _ref3;
                switch(side){
                    case 'top':
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.bottom - buffer : isFloatingWider ? rect.bottom - buffer : rect.top
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.bottom - buffer : rect.top : rect.bottom - buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case 'bottom':
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.top + buffer : isFloatingWider ? rect.top + buffer : rect.bottom
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.top + buffer : rect.bottom : rect.top + buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case 'left':
                        {
                            const cursorPointOne = [
                                x + buffer + 1,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x + buffer + 1,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.right - buffer : isFloatingTaller ? rect.right - buffer : rect.left,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.right - buffer : rect.left : rect.right - buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                ...commonPoints,
                                cursorPointOne,
                                cursorPointTwo
                            ];
                        }
                    case 'right':
                        {
                            const cursorPointOne = [
                                x - buffer,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x - buffer,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.left + buffer : isFloatingTaller ? rect.left + buffer : rect.right,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.left + buffer : rect.right : rect.left + buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                }
            }
            if ($a2a32c30b64f04ab$var$isPointInPolygon([
                clientX,
                clientY
            ], rectPoly)) return;
            if (hasLanded && !isOverReferenceRect) return close();
            if (!isLeave && requireIntent) {
                const cursorSpeed = getCursorSpeed(event.clientX, event.clientY);
                const cursorSpeedThreshold = 0.1;
                if (cursorSpeed !== null && cursorSpeed < cursorSpeedThreshold) return close();
            }
            if (!$a2a32c30b64f04ab$var$isPointInPolygon([
                clientX,
                clientY
            ], getPolygon([
                x,
                y
            ]))) close();
            else if (!hasLanded && requireIntent) timeoutId = window.setTimeout(close, 40);
        };
    };
    fn.__options = {
        blockPointerEvents: blockPointerEvents
    };
    return fn;
}

});
parcelRegister("hn8gG", function(module, exports) {

$parcel$export(module.exports, "activeElement", () => $ca5aff85a2f3333d$export$da980962bd2147a4);
$parcel$export(module.exports, "contains", () => $ca5aff85a2f3333d$export$2344b14b097df817);
$parcel$export(module.exports, "getPlatform", () => $ca5aff85a2f3333d$export$867a782338812cb4);
$parcel$export(module.exports, "getUserAgent", () => $ca5aff85a2f3333d$export$7935961ef7719cb0);
$parcel$export(module.exports, "isVirtualClick", () => $ca5aff85a2f3333d$export$60278871457622de);
$parcel$export(module.exports, "isVirtualPointerEvent", () => $ca5aff85a2f3333d$export$29bf1b5f2c56cf63);
$parcel$export(module.exports, "isSafari", () => $ca5aff85a2f3333d$export$95df08bae54cb4df);
$parcel$export(module.exports, "isMac", () => $ca5aff85a2f3333d$export$9ac100e40613ea10);
$parcel$export(module.exports, "isMouseLikePointerType", () => $ca5aff85a2f3333d$export$81cf264172d31e51);
$parcel$export(module.exports, "isReactEvent", () => $ca5aff85a2f3333d$export$94781ce41a161222);
$parcel$export(module.exports, "isRootElement", () => $ca5aff85a2f3333d$export$7b296c28e0fa3aed);
$parcel$export(module.exports, "getDocument", () => $ca5aff85a2f3333d$export$f65ca476c09acec0);
$parcel$export(module.exports, "isEventTargetWithin", () => $ca5aff85a2f3333d$export$43c3154d5bf2c6c2);
$parcel$export(module.exports, "getTarget", () => $ca5aff85a2f3333d$export$c22522a4dfa48e9c);
$parcel$export(module.exports, "isTypeableElement", () => $ca5aff85a2f3333d$export$42ad131c32f0fb8d);
$parcel$export(module.exports, "stopEvent", () => $ca5aff85a2f3333d$export$7ae4cd3a66c1e050);
$parcel$export(module.exports, "isTypeableCombobox", () => $ca5aff85a2f3333d$export$259ba5ae38188551);

var $1D9S2 = parcelRequire("1D9S2");
function $ca5aff85a2f3333d$export$da980962bd2147a4(doc) {
    let activeElement = doc.activeElement;
    while(((_activeElement = activeElement) == null || (_activeElement = _activeElement.shadowRoot) == null ? void 0 : _activeElement.activeElement) != null){
        var _activeElement;
        activeElement = activeElement.shadowRoot.activeElement;
    }
    return activeElement;
}
function $ca5aff85a2f3333d$export$2344b14b097df817(parent, child) {
    if (!parent || !child) return false;
    const rootNode = child.getRootNode == null ? void 0 : child.getRootNode();
    // First, attempt with faster native method
    if (parent.contains(child)) return true;
    // then fallback to custom implementation with Shadow DOM support
    if (rootNode && (0, $1D9S2.isShadowRoot)(rootNode)) {
        let next = child;
        while(next){
            if (parent === next) return true;
            // @ts-ignore
            next = next.parentNode || next.host;
        }
    }
    // Give up, the result is false
    return false;
}
// Avoid Chrome DevTools blue warning.
function $ca5aff85a2f3333d$export$867a782338812cb4() {
    const uaData = navigator.userAgentData;
    if (uaData != null && uaData.platform) return uaData.platform;
    return navigator.platform;
}
function $ca5aff85a2f3333d$export$7935961ef7719cb0() {
    const uaData = navigator.userAgentData;
    if (uaData && Array.isArray(uaData.brands)) return uaData.brands.map((_ref)=>{
        let { brand: brand, version: version } = _ref;
        return brand + "/" + version;
    }).join(' ');
    return navigator.userAgent;
}
// License: https://github.com/adobe/react-spectrum/blob/b35d5c02fe900badccd0cf1a8f23bb593419f238/packages/@react-aria/utils/src/isVirtualEvent.ts
function $ca5aff85a2f3333d$export$60278871457622de(event) {
    // FIXME: Firefox is now emitting a deprecation warning for `mozInputSource`.
    // Try to find a workaround for this. `react-aria` source still has the check.
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    if ($ca5aff85a2f3333d$export$a11b0059900ceec8() && event.pointerType) return event.type === 'click' && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function $ca5aff85a2f3333d$export$29bf1b5f2c56cf63(event) {
    if ($ca5aff85a2f3333d$export$c8f880a2d81914c4()) return false;
    return !$ca5aff85a2f3333d$export$a11b0059900ceec8() && event.width === 0 && event.height === 0 || $ca5aff85a2f3333d$export$a11b0059900ceec8() && event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'mouse' || // iOS VoiceOver returns 0.333• for width/height.
    event.width < 1 && event.height < 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'touch';
}
function $ca5aff85a2f3333d$export$95df08bae54cb4df() {
    // Chrome DevTools does not complain about navigator.vendor
    return /apple/i.test(navigator.vendor);
}
function $ca5aff85a2f3333d$export$a11b0059900ceec8() {
    const re = /android/i;
    return re.test($ca5aff85a2f3333d$export$867a782338812cb4()) || re.test($ca5aff85a2f3333d$export$7935961ef7719cb0());
}
function $ca5aff85a2f3333d$export$9ac100e40613ea10() {
    return $ca5aff85a2f3333d$export$867a782338812cb4().toLowerCase().startsWith('mac') && !navigator.maxTouchPoints;
}
function $ca5aff85a2f3333d$export$c8f880a2d81914c4() {
    return $ca5aff85a2f3333d$export$7935961ef7719cb0().includes('jsdom/');
}
function $ca5aff85a2f3333d$export$81cf264172d31e51(pointerType, strict) {
    // On some Linux machines with Chromium, mouse inputs return a `pointerType`
    // of "pen": https://github.com/floating-ui/floating-ui/issues/2015
    const values = [
        'mouse',
        'pen'
    ];
    if (!strict) values.push('', undefined);
    return values.includes(pointerType);
}
function $ca5aff85a2f3333d$export$94781ce41a161222(event) {
    return 'nativeEvent' in event;
}
function $ca5aff85a2f3333d$export$7b296c28e0fa3aed(element) {
    return element.matches('html,body');
}
function $ca5aff85a2f3333d$export$f65ca476c09acec0(node) {
    return (node == null ? void 0 : node.ownerDocument) || document;
}
function $ca5aff85a2f3333d$export$43c3154d5bf2c6c2(event, node) {
    if (node == null) return false;
    if ('composedPath' in event) return event.composedPath().includes(node);
    // TS thinks `event` is of type never as it assumes all browsers support composedPath, but browsers without shadow dom don't
    const e = event;
    return e.target != null && node.contains(e.target);
}
function $ca5aff85a2f3333d$export$c22522a4dfa48e9c(event) {
    if ('composedPath' in event) return event.composedPath()[0];
    // TS thinks `event` is of type never as it assumes all browsers support
    // `composedPath()`, but browsers without shadow DOM don't.
    return event.target;
}
const $ca5aff85a2f3333d$export$78b3d091ff376bc = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function $ca5aff85a2f3333d$export$42ad131c32f0fb8d(element) {
    return (0, $1D9S2.isHTMLElement)(element) && element.matches($ca5aff85a2f3333d$export$78b3d091ff376bc);
}
function $ca5aff85a2f3333d$export$7ae4cd3a66c1e050(event) {
    event.preventDefault();
    event.stopPropagation();
}
function $ca5aff85a2f3333d$export$259ba5ae38188551(element) {
    if (!element) return false;
    return element.getAttribute('role') === 'combobox' && $ca5aff85a2f3333d$export$42ad131c32f0fb8d(element);
}

});
parcelRegister("1D9S2", function(module, exports) {

$parcel$export(module.exports, "getNodeName", () => $1301171352b69415$export$651544f548703224);
$parcel$export(module.exports, "getWindow", () => $1301171352b69415$export$38b2d434cce3ea22);
$parcel$export(module.exports, "getDocumentElement", () => $1301171352b69415$export$e495491855dc5418);
$parcel$export(module.exports, "isElement", () => $1301171352b69415$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $1301171352b69415$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $1301171352b69415$export$af51f0f06c0f328a);
$parcel$export(module.exports, "isOverflowElement", () => $1301171352b69415$export$989e911fa9af580a);
$parcel$export(module.exports, "getComputedStyle", () => $1301171352b69415$export$3735103072e4a80);
$parcel$export(module.exports, "isTableElement", () => $1301171352b69415$export$71535ffaa902797f);
$parcel$export(module.exports, "isTopLayer", () => $1301171352b69415$export$89e651af02346cd4);
$parcel$export(module.exports, "isContainingBlock", () => $1301171352b69415$export$d6c4e8150c35fed1);
$parcel$export(module.exports, "isWebKit", () => $1301171352b69415$export$78551043582a6a98);
$parcel$export(module.exports, "getContainingBlock", () => $1301171352b69415$export$940d8225183e1404);
$parcel$export(module.exports, "getParentNode", () => $1301171352b69415$export$4e12058fc4d51d56);
$parcel$export(module.exports, "isLastTraversableNode", () => $1301171352b69415$export$d1162fb0b6d4cd51);
$parcel$export(module.exports, "getNodeScroll", () => $1301171352b69415$export$dc8fc79fa2800137);
$parcel$export(module.exports, "getOverflowAncestors", () => $1301171352b69415$export$3b57c1601291186b);
$parcel$export(module.exports, "getFrameElement", () => $1301171352b69415$export$7bf1f8740e3e34af);
function $1301171352b69415$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $1301171352b69415$export$651544f548703224(node) {
    if ($1301171352b69415$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $1301171352b69415$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $1301171352b69415$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($1301171352b69415$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $1301171352b69415$export$8ee0fc9ee280b4ee(value) {
    if (!$1301171352b69415$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $1301171352b69415$export$38b2d434cce3ea22(value).Node;
}
function $1301171352b69415$export$45a5e7f76e0caa8d(value) {
    if (!$1301171352b69415$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $1301171352b69415$export$38b2d434cce3ea22(value).Element;
}
function $1301171352b69415$export$1b3bfaa9684536aa(value) {
    if (!$1301171352b69415$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $1301171352b69415$export$38b2d434cce3ea22(value).HTMLElement;
}
function $1301171352b69415$export$af51f0f06c0f328a(value) {
    if (!$1301171352b69415$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $1301171352b69415$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $1301171352b69415$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $1301171352b69415$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        'inline',
        'contents'
    ].includes(display);
}
function $1301171352b69415$export$71535ffaa902797f(element) {
    return [
        'table',
        'td',
        'th'
    ].includes($1301171352b69415$export$651544f548703224(element));
}
function $1301171352b69415$export$89e651af02346cd4(element) {
    return [
        ':popover-open',
        ':modal'
    ].some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $1301171352b69415$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $1301171352b69415$export$78551043582a6a98();
    const css = $1301171352b69415$export$45a5e7f76e0caa8d(elementOrCss) ? $1301171352b69415$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== 'none' || css.perspective !== 'none' || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || [
        'transform',
        'perspective',
        'filter'
    ].some((value)=>(css.willChange || '').includes(value)) || [
        'paint',
        'layout',
        'strict',
        'content'
    ].some((value)=>(css.contain || '').includes(value));
}
function $1301171352b69415$export$940d8225183e1404(element) {
    let currentNode = $1301171352b69415$export$4e12058fc4d51d56(element);
    while($1301171352b69415$export$1b3bfaa9684536aa(currentNode) && !$1301171352b69415$export$d1162fb0b6d4cd51(currentNode)){
        if ($1301171352b69415$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($1301171352b69415$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $1301171352b69415$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $1301171352b69415$export$78551043582a6a98() {
    if (typeof CSS === 'undefined' || !CSS.supports) return false;
    return CSS.supports('-webkit-backdrop-filter', 'none');
}
function $1301171352b69415$export$d1162fb0b6d4cd51(node) {
    return [
        'html',
        'body',
        '#document'
    ].includes($1301171352b69415$export$651544f548703224(node));
}
function $1301171352b69415$export$3735103072e4a80(element) {
    return $1301171352b69415$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $1301171352b69415$export$dc8fc79fa2800137(element) {
    if ($1301171352b69415$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $1301171352b69415$export$4e12058fc4d51d56(node) {
    if ($1301171352b69415$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $1301171352b69415$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $1301171352b69415$export$e495491855dc5418(node);
    return $1301171352b69415$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $1301171352b69415$export$7cd01a57c8ca906c(node) {
    const parentNode = $1301171352b69415$export$4e12058fc4d51d56(node);
    if ($1301171352b69415$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($1301171352b69415$export$1b3bfaa9684536aa(parentNode) && $1301171352b69415$export$989e911fa9af580a(parentNode)) return parentNode;
    return $1301171352b69415$export$7cd01a57c8ca906c(parentNode);
}
function $1301171352b69415$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $1301171352b69415$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $1301171352b69415$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $1301171352b69415$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $1301171352b69415$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $1301171352b69415$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $1301171352b69415$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $1301171352b69415$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

});


parcelRegister("Euxde", function(module, exports) {

$parcel$export(module.exports, "sides", () => $079b6c18061715d9$export$832b6fa47fa053d2);
$parcel$export(module.exports, "placements", () => $079b6c18061715d9$export$803cd8101b6c182b);
$parcel$export(module.exports, "min", () => $079b6c18061715d9$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $079b6c18061715d9$export$8960430cfd85939f);
$parcel$export(module.exports, "round", () => $079b6c18061715d9$export$2077e0241d6afd3c);
$parcel$export(module.exports, "floor", () => $079b6c18061715d9$export$a3fe094919f356fd);
$parcel$export(module.exports, "createCoords", () => $079b6c18061715d9$export$a397704b5e280835);
$parcel$export(module.exports, "clamp", () => $079b6c18061715d9$export$7d15b64cf5a3a4c4);
$parcel$export(module.exports, "evaluate", () => $079b6c18061715d9$export$fef61f332f2c0afc);
$parcel$export(module.exports, "getSide", () => $079b6c18061715d9$export$3c915306cb7fc97a);
$parcel$export(module.exports, "getAlignment", () => $079b6c18061715d9$export$f0989780f32bfcda);
$parcel$export(module.exports, "getOppositeAxis", () => $079b6c18061715d9$export$8a000a963141ac32);
$parcel$export(module.exports, "getAxisLength", () => $079b6c18061715d9$export$320bd9d53520c68a);
$parcel$export(module.exports, "getSideAxis", () => $079b6c18061715d9$export$f28e8f882010718a);
$parcel$export(module.exports, "getAlignmentAxis", () => $079b6c18061715d9$export$2b57e0052a6d6d4c);
$parcel$export(module.exports, "getAlignmentSides", () => $079b6c18061715d9$export$be42861551f17911);
$parcel$export(module.exports, "getOppositePlacement", () => $079b6c18061715d9$export$9c5e28bad23365fa);
$parcel$export(module.exports, "getExpandedPlacements", () => $079b6c18061715d9$export$496432a3699e50b1);
$parcel$export(module.exports, "getOppositeAlignmentPlacement", () => $079b6c18061715d9$export$2b182c584985588b);
$parcel$export(module.exports, "getOppositeAxisPlacements", () => $079b6c18061715d9$export$a9b6fb18fd92c3ec);
$parcel$export(module.exports, "getPaddingObject", () => $079b6c18061715d9$export$598c291c29bc2e71);
$parcel$export(module.exports, "rectToClientRect", () => $079b6c18061715d9$export$ee05aea0aeecbad4);
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $079b6c18061715d9$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $079b6c18061715d9$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $079b6c18061715d9$export$803cd8101b6c182b = /*#__PURE__*/ $079b6c18061715d9$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $079b6c18061715d9$export$27b07d8a310ed8b5[0], side + "-" + $079b6c18061715d9$export$27b07d8a310ed8b5[1]), []);
const $079b6c18061715d9$export$96ec731ed4dcb222 = Math.min;
const $079b6c18061715d9$export$8960430cfd85939f = Math.max;
const $079b6c18061715d9$export$2077e0241d6afd3c = Math.round;
const $079b6c18061715d9$export$a3fe094919f356fd = Math.floor;
const $079b6c18061715d9$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $079b6c18061715d9$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
const $079b6c18061715d9$var$oppositeAlignmentMap = {
    start: 'end',
    end: 'start'
};
function $079b6c18061715d9$export$7d15b64cf5a3a4c4(start, value, end) {
    return $079b6c18061715d9$export$8960430cfd85939f(start, $079b6c18061715d9$export$96ec731ed4dcb222(value, end));
}
function $079b6c18061715d9$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $079b6c18061715d9$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $079b6c18061715d9$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $079b6c18061715d9$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $079b6c18061715d9$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $079b6c18061715d9$export$f28e8f882010718a(placement) {
    return [
        'top',
        'bottom'
    ].includes($079b6c18061715d9$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
}
function $079b6c18061715d9$export$2b57e0052a6d6d4c(placement) {
    return $079b6c18061715d9$export$8a000a963141ac32($079b6c18061715d9$export$f28e8f882010718a(placement));
}
function $079b6c18061715d9$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $079b6c18061715d9$export$f0989780f32bfcda(placement);
    const alignmentAxis = $079b6c18061715d9$export$2b57e0052a6d6d4c(placement);
    const length = $079b6c18061715d9$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $079b6c18061715d9$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $079b6c18061715d9$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $079b6c18061715d9$export$496432a3699e50b1(placement) {
    const oppositePlacement = $079b6c18061715d9$export$9c5e28bad23365fa(placement);
    return [
        $079b6c18061715d9$export$2b182c584985588b(placement),
        oppositePlacement,
        $079b6c18061715d9$export$2b182c584985588b(oppositePlacement)
    ];
}
function $079b6c18061715d9$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$079b6c18061715d9$var$oppositeAlignmentMap[alignment]);
}
function $079b6c18061715d9$var$getSideList(side, isStart, rtl) {
    const lr = [
        'left',
        'right'
    ];
    const rl = [
        'right',
        'left'
    ];
    const tb = [
        'top',
        'bottom'
    ];
    const bt = [
        'bottom',
        'top'
    ];
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case 'left':
        case 'right':
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $079b6c18061715d9$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $079b6c18061715d9$export$f0989780f32bfcda(placement);
    let list = $079b6c18061715d9$var$getSideList($079b6c18061715d9$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($079b6c18061715d9$export$2b182c584985588b));
    }
    return list;
}
function $079b6c18061715d9$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$079b6c18061715d9$var$oppositeSideMap[side]);
}
function $079b6c18061715d9$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $079b6c18061715d9$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $079b6c18061715d9$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $079b6c18061715d9$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}

});

parcelRegister("6X8j6", function(module, exports) {

$parcel$export(module.exports, "tabbable", () => $50feb264d5622a99$export$17100aea90429aa7);
$parcel$export(module.exports, "isTabbable", () => $50feb264d5622a99$export$bebd5a1431fec25d);
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/ // NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
// CAREFUL: JSDom does not support `:not([inert] *)` as a selector; using it causes
//  the entire query to fail, resulting in no nodes found, which will break a lot
//  of things... so we have to rely on JS to identify nodes inside an inert container
var $50feb264d5622a99$var$candidateSelectors = [
    'input:not([inert])',
    'select:not([inert])',
    'textarea:not([inert])',
    'a[href]:not([inert])',
    'button:not([inert])',
    '[tabindex]:not(slot):not([inert])',
    'audio[controls]:not([inert])',
    'video[controls]:not([inert])',
    '[contenteditable]:not([contenteditable="false"]):not([inert])',
    'details>summary:first-of-type:not([inert])',
    'details:not([inert])'
];
var $50feb264d5622a99$var$candidateSelector = /* #__PURE__ */ $50feb264d5622a99$var$candidateSelectors.join(',');
var $50feb264d5622a99$var$NoElement = typeof Element === 'undefined';
var $50feb264d5622a99$var$matches = $50feb264d5622a99$var$NoElement ? function() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var $50feb264d5622a99$var$getRootNode = !$50feb264d5622a99$var$NoElement && Element.prototype.getRootNode ? function(element) {
    var _element$getRootNode;
    return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function(element) {
    return element === null || element === void 0 ? void 0 : element.ownerDocument;
};
/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Element} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */ var $50feb264d5622a99$var$isInert = function isInert(node, lookUp) {
    var _node$getAttribute;
    if (lookUp === void 0) lookUp = true;
    // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
    //  JS API property; we have to check the attribute, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's an active element
    var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, 'inert');
    var inert = inertAtt === '' || inertAtt === 'true';
    // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
    //  if it weren't for `matches()` not being a function on shadow roots; the following
    //  code works for any kind of node
    // CAREFUL: JSDom does not appear to support certain selectors like `:not([inert] *)`
    //  so it likely would not support `:is([inert] *)` either...
    var result = inert || lookUp && node && isInert(node.parentNode); // recursive
    return result;
};
/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */ var $50feb264d5622a99$var$isContentEditable = function isContentEditable(node) {
    var _node$getAttribute2;
    // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
    //  to use the attribute directly to check for this, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's a non-editable element
    var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, 'contenteditable');
    return attValue === '' || attValue === 'true';
};
/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */ var $50feb264d5622a99$var$getCandidates = function getCandidates(el, includeContainer, filter) {
    // even if `includeContainer=false`, we still have to check it for inertness because
    //  if it's inert, all its children are inert
    if ($50feb264d5622a99$var$isInert(el)) return [];
    var candidates = Array.prototype.slice.apply(el.querySelectorAll($50feb264d5622a99$var$candidateSelector));
    if (includeContainer && $50feb264d5622a99$var$matches.call(el, $50feb264d5622a99$var$candidateSelector)) candidates.unshift(el);
    candidates = candidates.filter(filter);
    return candidates;
};
/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */ /**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */ /**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */ /**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */ /**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */ var $50feb264d5622a99$var$getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while(elementsToCheck.length){
        var element = elementsToCheck.shift();
        if ($50feb264d5622a99$var$isInert(element, false)) continue;
        if (element.tagName === 'SLOT') {
            // add shadow dom slot scope (slot itself cannot be focusable)
            var assigned = element.assignedElements();
            var content = assigned.length ? assigned : element.children;
            var nestedCandidates = getCandidatesIteratively(content, true, options);
            if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
            else candidates.push({
                scopeParent: element,
                candidates: nestedCandidates
            });
        } else {
            // check candidate element
            var validCandidate = $50feb264d5622a99$var$matches.call(element, $50feb264d5622a99$var$candidateSelector);
            if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
            // iterate over shadow content if possible
            var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
            typeof options.getShadowRoot === 'function' && options.getShadowRoot(element);
            // no inert look up because we're already drilling down and checking for inertness
            //  on the way down, so all containers to this root node should have already been
            //  vetted as non-inert
            var validShadowRoot = !$50feb264d5622a99$var$isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
            if (shadowRoot && validShadowRoot) {
                // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
                //  shadow exists, so look at light dom children as fallback BUT create a scope for any
                //  child candidates found because they're likely slotted elements (elements that are
                //  children of the web component element (which has the shadow), in the light dom, but
                //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
                //  _after_ we return from this recursive call
                var _nestedCandidates = getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                else candidates.push({
                    scopeParent: element,
                    candidates: _nestedCandidates
                });
            } else // there's not shadow so just dig into the element's (light dom) children
            //  __without__ giving the element special scope treatment
            elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
    }
    return candidates;
};
/**
 * @private
 * Determines if the node has an explicitly specified `tabindex` attribute.
 * @param {HTMLElement} node
 * @returns {boolean} True if so; false if not.
 */ var $50feb264d5622a99$var$hasTabIndex = function hasTabIndex(node) {
    return !isNaN(parseInt(node.getAttribute('tabindex'), 10));
};
/**
 * Determine the tab index of a given node.
 * @param {HTMLElement} node
 * @returns {number} Tab order (negative, 0, or positive number).
 * @throws {Error} If `node` is falsy.
 */ var $50feb264d5622a99$export$a4672efddb4181b8 = function getTabIndex(node) {
    if (!node) throw new Error('No node provided');
    if (node.tabIndex < 0) {
        // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
        // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
        // yet they are still part of the regular tab order; in FF, they get a default
        // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
        // order, consider their tab index to be 0.
        // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
        // so if they don't have a tabindex attribute specifically set, assume it's 0.
        if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || $50feb264d5622a99$var$isContentEditable(node)) && !$50feb264d5622a99$var$hasTabIndex(node)) return 0;
    }
    return node.tabIndex;
};
/**
 * Determine the tab index of a given node __for sort order purposes__.
 * @param {HTMLElement} node
 * @param {boolean} [isScope] True for a custom element with shadow root or slot that, by default,
 *  has tabIndex -1, but needs to be sorted by document order in order for its content to be
 *  inserted into the correct sort position.
 * @returns {number} Tab order (negative, 0, or positive number).
 */ var $50feb264d5622a99$var$getSortOrderTabIndex = function getSortOrderTabIndex(node, isScope) {
    var tabIndex = $50feb264d5622a99$export$a4672efddb4181b8(node);
    if (tabIndex < 0 && isScope && !$50feb264d5622a99$var$hasTabIndex(node)) return 0;
    return tabIndex;
};
var $50feb264d5622a99$var$sortOrderedTabbables = function sortOrderedTabbables(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var $50feb264d5622a99$var$isInput = function isInput(node) {
    return node.tagName === 'INPUT';
};
var $50feb264d5622a99$var$isHiddenInput = function isHiddenInput(node) {
    return $50feb264d5622a99$var$isInput(node) && node.type === 'hidden';
};
var $50feb264d5622a99$var$isDetailsWithSummary = function isDetailsWithSummary(node) {
    var r = node.tagName === 'DETAILS' && Array.prototype.slice.apply(node.children).some(function(child) {
        return child.tagName === 'SUMMARY';
    });
    return r;
};
var $50feb264d5622a99$var$getCheckedRadio = function getCheckedRadio(nodes, form) {
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i].checked && nodes[i].form === form) return nodes[i];
    }
};
var $50feb264d5622a99$var$isTabbableRadio = function isTabbableRadio(node) {
    if (!node.name) return true;
    var radioScope = node.form || $50feb264d5622a99$var$getRootNode(node);
    var queryRadios = function queryRadios(name) {
        return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function') radioSet = queryRadios(window.CSS.escape(node.name));
    else try {
        radioSet = queryRadios(node.name);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s', err.message);
        return false;
    }
    var checked = $50feb264d5622a99$var$getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
};
var $50feb264d5622a99$var$isRadio = function isRadio(node) {
    return $50feb264d5622a99$var$isInput(node) && node.type === 'radio';
};
var $50feb264d5622a99$var$isNonTabbableRadio = function isNonTabbableRadio(node) {
    return $50feb264d5622a99$var$isRadio(node) && !$50feb264d5622a99$var$isTabbableRadio(node);
};
// determines if a node is ultimately attached to the window's document
var $50feb264d5622a99$var$isNodeAttached = function isNodeAttached(node) {
    var _nodeRoot;
    // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
    //  (but NOT _the_ document; see second 'If' comment below for more).
    // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
    //  is attached, and the one we need to check if it's in the document or not (because the
    //  shadow, and all nodes it contains, is never considered in the document since shadows
    //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
    //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
    //  visibility, including all the nodes it contains). The host could be any normal node,
    //  or a custom element (i.e. web component). Either way, that's the one that is considered
    //  part of the document, not the shadow root, nor any of its children (i.e. the node being
    //  tested).
    // To further complicate things, we have to look all the way up until we find a shadow HOST
    //  that is attached (or find none) because the node might be in nested shadows...
    // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
    //  document (per the docs) and while it's a Document-type object, that document does not
    //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
    //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
    //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
    //  node is actually detached.
    // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
    //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
    //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
    //  `ownerDocument` will be `null`, hence the optional chaining on it.
    var nodeRoot = node && $50feb264d5622a99$var$getRootNode(node);
    var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;
    // in some cases, a detached node will return itself as the root instead of a document or
    //  shadow root object, in which case, we shouldn't try to look further up the host chain
    var attached = false;
    if (nodeRoot && nodeRoot !== node) {
        var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
        attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
        while(!attached && nodeRootHost){
            var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
            // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
            //  which means we need to get the host's host and check if that parent host is contained
            //  in (i.e. attached to) the document
            nodeRoot = $50feb264d5622a99$var$getRootNode(nodeRootHost);
            nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
            attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
        }
    }
    return attached;
};
var $50feb264d5622a99$var$isZeroArea = function isZeroArea(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
};
var $50feb264d5622a99$var$isHidden = function isHidden(node, _ref) {
    var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
    // NOTE: visibility will be `undefined` if node is detached from the document
    //  (see notes about this further down), which means we will consider it visible
    //  (this is legacy behavior from a very long way back)
    // NOTE: we check this regardless of `displayCheck="none"` because this is a
    //  _visibility_ check, not a _display_ check
    if (getComputedStyle(node).visibility === 'hidden') return true;
    var isDirectSummary = $50feb264d5622a99$var$matches.call(node, 'details>summary:first-of-type');
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if ($50feb264d5622a99$var$matches.call(nodeUnderDetails, 'details:not([open]) *')) return true;
    if (!displayCheck || displayCheck === 'full' || displayCheck === 'legacy-full') {
        if (typeof getShadowRoot === 'function') {
            // figure out if we should consider the node to be in an undisclosed shadow and use the
            //  'non-zero-area' fallback
            var originalNode = node;
            while(node){
                var parentElement = node.parentElement;
                var rootNode = $50feb264d5622a99$var$getRootNode(node);
                if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
                ) // node has an undisclosed shadow which means we can only treat it as a black box, so we
                //  fall back to a non-zero-area test
                return $50feb264d5622a99$var$isZeroArea(node);
                else if (node.assignedSlot) // iterate up slot
                node = node.assignedSlot;
                else if (!parentElement && rootNode !== node.ownerDocument) // cross shadow boundary
                node = rootNode.host;
                else // iterate up normal dom
                node = parentElement;
            }
            node = originalNode;
        }
        // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
        //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
        //  it might be a falsy value, which means shadow DOM support is disabled
        // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
        //  now we can just test to see if it would normally be visible or not, provided it's
        //  attached to the main document.
        // NOTE: We must consider case where node is inside a shadow DOM and given directly to
        //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.
        if ($50feb264d5622a99$var$isNodeAttached(node)) // this works wherever the node is: if there's at least one client rect, it's
        //  somehow displayed; it also covers the CSS 'display: contents' case where the
        //  node itself is hidden in place of its contents; and there's no need to search
        //  up the hierarchy either
        return !node.getClientRects().length;
        // Else, the node isn't attached to the document, which means the `getClientRects()`
        //  API will __always__ return zero rects (this can happen, for example, if React
        //  is used to render nodes onto a detached tree, as confirmed in this thread:
        //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
        //
        // It also means that even window.getComputedStyle(node).display will return `undefined`
        //  because styles are only computed for nodes that are in the document.
        //
        // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
        //  somehow. Though it was never stated officially, anyone who has ever used tabbable
        //  APIs on nodes in detached containers has actually implicitly used tabbable in what
        //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
        //  considering __everything__ to be visible because of the innability to determine styles.
        //
        // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
        //  nodes as visible with the 'none' fallback.__
        if (displayCheck !== 'legacy-full') return true; // hidden
    // else, fallback to 'none' mode and consider the node visible
    } else if (displayCheck === 'non-zero-area') // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return $50feb264d5622a99$var$isZeroArea(node);
    // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
    //  it's visible
    return false;
};
// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var $50feb264d5622a99$var$isDisabledFromFieldset = function isDisabledFromFieldset(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
        var parentNode = node.parentElement;
        // check if `node` is contained in a disabled <fieldset>
        while(parentNode){
            if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
                // look for the first <legend> among the children of the disabled <fieldset>
                for(var i = 0; i < parentNode.children.length; i++){
                    var child = parentNode.children.item(i);
                    // when the first <legend> (in document order) is found
                    if (child.tagName === 'LEGEND') // if its parent <fieldset> is not nested in another disabled <fieldset>,
                    // return whether `node` is a descendant of its first <legend>
                    return $50feb264d5622a99$var$matches.call(parentNode, 'fieldset[disabled] *') ? true : !child.contains(node);
                }
                // the disabled <fieldset> containing `node` has no <legend>
                return true;
            }
            parentNode = parentNode.parentElement;
        }
    }
    // else, node's tabbable/focusable state should not be affected by a fieldset's
    //  enabled/disabled state
    return false;
};
var $50feb264d5622a99$var$isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
    if (node.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
    //  because we're limited in the type of selectors we can use in JSDom (see related
    //  note related to `candidateSelectors`)
    $50feb264d5622a99$var$isInert(node) || $50feb264d5622a99$var$isHiddenInput(node) || $50feb264d5622a99$var$isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
    $50feb264d5622a99$var$isDetailsWithSummary(node) || $50feb264d5622a99$var$isDisabledFromFieldset(node)) return false;
    return true;
};
var $50feb264d5622a99$var$isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
    if ($50feb264d5622a99$var$isNonTabbableRadio(node) || $50feb264d5622a99$export$a4672efddb4181b8(node) < 0 || !$50feb264d5622a99$var$isNodeMatchingSelectorFocusable(options, node)) return false;
    return true;
};
var $50feb264d5622a99$var$isValidShadowRootTabbable = function isValidShadowRootTabbable(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute('tabindex'), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) return true;
    // If a custom element has an explicit negative tabindex,
    // browsers will not allow tab targeting said element's children.
    return false;
};
/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */ var $50feb264d5622a99$var$sortByOrder = function sortByOrder(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function(item, i) {
        var isScope = !!item.scopeParent;
        var element = isScope ? item.scopeParent : item;
        var candidateTabindex = $50feb264d5622a99$var$getSortOrderTabIndex(element, isScope);
        var elements = isScope ? sortByOrder(item.candidates) : element;
        if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
        else orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            item: item,
            isScope: isScope,
            content: elements
        });
    });
    return orderedTabbables.sort($50feb264d5622a99$var$sortOrderedTabbables).reduce(function(acc, sortable) {
        sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
        return acc;
    }, []).concat(regularTabbables);
};
var $50feb264d5622a99$export$17100aea90429aa7 = function tabbable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $50feb264d5622a99$var$getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $50feb264d5622a99$var$isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: $50feb264d5622a99$var$isValidShadowRootTabbable
    });
    else candidates = $50feb264d5622a99$var$getCandidates(container, options.includeContainer, $50feb264d5622a99$var$isNodeMatchingSelectorTabbable.bind(null, options));
    return $50feb264d5622a99$var$sortByOrder(candidates);
};
var $50feb264d5622a99$export$ecc6d1fcdff4f700 = function focusable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $50feb264d5622a99$var$getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $50feb264d5622a99$var$isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
    });
    else candidates = $50feb264d5622a99$var$getCandidates(container, options.includeContainer, $50feb264d5622a99$var$isNodeMatchingSelectorFocusable.bind(null, options));
    return candidates;
};
var $50feb264d5622a99$export$bebd5a1431fec25d = function isTabbable(node, options) {
    options = options || {};
    if (!node) throw new Error('No node provided');
    if ($50feb264d5622a99$var$matches.call(node, $50feb264d5622a99$var$candidateSelector) === false) return false;
    return $50feb264d5622a99$var$isNodeMatchingSelectorTabbable(options, node);
};
var $50feb264d5622a99$var$focusableCandidateSelector = /* #__PURE__ */ $50feb264d5622a99$var$candidateSelectors.concat('iframe').join(',');
var $50feb264d5622a99$export$4c063cf1350e6fed = function isFocusable(node, options) {
    options = options || {};
    if (!node) throw new Error('No node provided');
    if ($50feb264d5622a99$var$matches.call(node, $50feb264d5622a99$var$focusableCandidateSelector) === false) return false;
    return $50feb264d5622a99$var$isNodeMatchingSelectorFocusable(options, node);
};

});

parcelRegister("eqxtD", function(module, exports) {

$parcel$export(module.exports, "useFloating", () => $a80d76388d068913$export$4e02a5c1d08bac65);
$parcel$export(module.exports, "offset", () => $a80d76388d068913$export$cc800923e997bb8);
$parcel$export(module.exports, "shift", () => $a80d76388d068913$export$fba63a578e423eb);
$parcel$export(module.exports, "limitShift", () => $a80d76388d068913$export$7bf07e38f3dc4b69);
$parcel$export(module.exports, "flip", () => $a80d76388d068913$export$8a83211c878a3f1f);
$parcel$export(module.exports, "size", () => $a80d76388d068913$export$346677f925de839c);
$parcel$export(module.exports, "autoPlacement", () => $a80d76388d068913$export$91fb6ecbd551914);
$parcel$export(module.exports, "hide", () => $a80d76388d068913$export$fe8985bb6374093c);
$parcel$export(module.exports, "inline", () => $a80d76388d068913$export$18c8ad048e32c7d5);
$parcel$export(module.exports, "arrow", () => $a80d76388d068913$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "computePosition", () => (parcelRequire("8i2T6")).computePosition);

var $8i2T6 = parcelRequire("8i2T6");
var $1D9S2 = parcelRequire("1D9S2");

var $8NFma = parcelRequire("8NFma");

var $2pmb0 = parcelRequire("2pmb0");
var $a80d76388d068913$var$index = typeof document !== 'undefined' ? (0, $8NFma.useLayoutEffect) : (0, $8NFma.useEffect);
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $a80d76388d068913$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === 'function' && a.toString() === b.toString()) return true;
    let length;
    let i;
    let keys;
    if (a && b && typeof a === 'object') {
        if (Array.isArray(a)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$a80d76388d068913$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            if (!$a80d76388d068913$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function $a80d76388d068913$var$getDPR(element) {
    if (typeof window === 'undefined') return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $a80d76388d068913$var$roundByDPR(element, value) {
    const dpr = $a80d76388d068913$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $a80d76388d068913$var$useLatestRef(value) {
    const ref = $8NFma.useRef(value);
    $a80d76388d068913$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function $a80d76388d068913$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform, elements: { reference: externalReference, floating: externalFloating } = {}, transform: transform = true, whileElementsMounted: whileElementsMounted, open: open } = options;
    const [data, setData] = $8NFma.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = $8NFma.useState(middleware);
    if (!$a80d76388d068913$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = $8NFma.useState(null);
    const [_floating, _setFloating] = $8NFma.useState(null);
    const setReference = $8NFma.useCallback((node)=>{
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    const setFloating = $8NFma.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = $8NFma.useRef(null);
    const floatingRef = $8NFma.useRef(null);
    const dataRef = $8NFma.useRef(data);
    const hasWhileElementsMounted = whileElementsMounted != null;
    const whileElementsMountedRef = $a80d76388d068913$var$useLatestRef(whileElementsMounted);
    const platformRef = $a80d76388d068913$var$useLatestRef(platform);
    const openRef = $a80d76388d068913$var$useLatestRef(open);
    const update = $8NFma.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $8i2T6.computePosition)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                // The floating element's position may be recomputed while it's closed
                // but still mounted (such as when transitioning out). To ensure
                // `isPositioned` will be `false` initially on the next open, avoid
                // setting it to `true` when `open === false` (must be specified).
                isPositioned: openRef.current !== false
            };
            if (isMountedRef.current && !$a80d76388d068913$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $2pmb0.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef,
        openRef
    ]);
    $a80d76388d068913$var$index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = $8NFma.useRef(false);
    $a80d76388d068913$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    $a80d76388d068913$var$index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef,
        hasWhileElementsMounted
    ]);
    const refs = $8NFma.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = $8NFma.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = $8NFma.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = $a80d76388d068913$var$roundByDPR(elements.floating, data.x);
        const y = $a80d76388d068913$var$roundByDPR(elements.floating, data.y);
        if (transform) return {
            ...initialStyles,
            transform: "translate(" + x + "px, " + y + "px)",
            ...$a80d76388d068913$var$getDPR(elements.floating) >= 1.5 && {
                willChange: 'transform'
            }
        };
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return $8NFma.useMemo(()=>({
            ...data,
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $a80d76388d068913$var$arrow$1 = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, 'current');
    }
    return {
        name: 'arrow',
        options: options,
        fn (state) {
            const { element: element, padding: padding } = typeof options === 'function' ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, $8i2T6.arrow)({
                    element: element.current,
                    padding: padding
                }).fn(state);
                return {};
            }
            if (element) return (0, $8i2T6.arrow)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
};
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $a80d76388d068913$export$cc800923e997bb8 = (options, deps)=>({
        ...(0, $8i2T6.offset)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $a80d76388d068913$export$fba63a578e423eb = (options, deps)=>({
        ...(0, $8i2T6.shift)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $a80d76388d068913$export$7bf07e38f3dc4b69 = (options, deps)=>({
        ...(0, $8i2T6.limitShift)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $a80d76388d068913$export$8a83211c878a3f1f = (options, deps)=>({
        ...(0, $8i2T6.flip)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $a80d76388d068913$export$346677f925de839c = (options, deps)=>({
        ...(0, $8i2T6.size)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $a80d76388d068913$export$91fb6ecbd551914 = (options, deps)=>({
        ...(0, $8i2T6.autoPlacement)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $a80d76388d068913$export$fe8985bb6374093c = (options, deps)=>({
        ...(0, $8i2T6.hide)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $a80d76388d068913$export$18c8ad048e32c7d5 = (options, deps)=>({
        ...(0, $8i2T6.inline)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $a80d76388d068913$export$f2120bbfa5450bd2 = (options, deps)=>({
        ...$a80d76388d068913$var$arrow$1(options),
        options: [
            options,
            deps
        ]
    });

});
parcelRegister("8i2T6", function(module, exports) {

$parcel$export(module.exports, "platform", () => $60923e9f3f841413$export$722a64dea1b767dc);
$parcel$export(module.exports, "autoUpdate", () => $60923e9f3f841413$export$deee3a793edee05f);
$parcel$export(module.exports, "detectOverflow", () => $60923e9f3f841413$export$37b6bde19b108ecc);
$parcel$export(module.exports, "offset", () => $60923e9f3f841413$export$cc800923e997bb8);
$parcel$export(module.exports, "autoPlacement", () => $60923e9f3f841413$export$91fb6ecbd551914);
$parcel$export(module.exports, "shift", () => $60923e9f3f841413$export$fba63a578e423eb);
$parcel$export(module.exports, "flip", () => $60923e9f3f841413$export$8a83211c878a3f1f);
$parcel$export(module.exports, "size", () => $60923e9f3f841413$export$346677f925de839c);
$parcel$export(module.exports, "hide", () => $60923e9f3f841413$export$fe8985bb6374093c);
$parcel$export(module.exports, "arrow", () => $60923e9f3f841413$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "inline", () => $60923e9f3f841413$export$18c8ad048e32c7d5);
$parcel$export(module.exports, "limitShift", () => $60923e9f3f841413$export$7bf07e38f3dc4b69);
$parcel$export(module.exports, "computePosition", () => $60923e9f3f841413$export$48a53dcb22e581d0);
$parcel$export(module.exports, "getOverflowAncestors", () => (parcelRequire("1D9S2")).getOverflowAncestors);

var $E7rjD = parcelRequire("E7rjD");
var $Euxde = parcelRequire("Euxde");

var $Euxde = parcelRequire("Euxde");

var $1D9S2 = parcelRequire("1D9S2");
function $60923e9f3f841413$var$getCssDimensions(element) {
    const css = (0, $1D9S2.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $1D9S2.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $Euxde.round)(width) !== offsetWidth || (0, $Euxde.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $60923e9f3f841413$var$unwrapElement(element) {
    return !(0, $1D9S2.isElement)(element) ? element.contextElement : element;
}
function $60923e9f3f841413$var$getScale(element) {
    const domElement = $60923e9f3f841413$var$unwrapElement(element);
    if (!(0, $1D9S2.isHTMLElement)(domElement)) return (0, $Euxde.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $60923e9f3f841413$var$getCssDimensions(domElement);
    let x = ($ ? (0, $Euxde.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $Euxde.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $60923e9f3f841413$var$noOffsets = /*#__PURE__*/ (0, $Euxde.createCoords)(0);
function $60923e9f3f841413$var$getVisualOffsets(element) {
    const win = (0, $1D9S2.getWindow)(element);
    if (!(0, $1D9S2.isWebKit)() || !win.visualViewport) return $60923e9f3f841413$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $60923e9f3f841413$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $1D9S2.getWindow)(element)) return false;
    return isFixed;
}
function $60923e9f3f841413$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $60923e9f3f841413$var$unwrapElement(element);
    let scale = (0, $Euxde.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $1D9S2.isElement)(offsetParent)) scale = $60923e9f3f841413$var$getScale(offsetParent);
        } else scale = $60923e9f3f841413$var$getScale(element);
    }
    const visualOffsets = $60923e9f3f841413$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $60923e9f3f841413$var$getVisualOffsets(domElement) : (0, $Euxde.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $1D9S2.getWindow)(domElement);
        const offsetWin = offsetParent && (0, $1D9S2.isElement)(offsetParent) ? (0, $1D9S2.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $1D9S2.getFrameElement)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $60923e9f3f841413$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $1D9S2.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $1D9S2.getWindow)(currentIFrame);
            currentIFrame = (0, $1D9S2.getFrameElement)(currentWin);
        }
    }
    return (0, $Euxde.rectToClientRect)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $60923e9f3f841413$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $1D9S2.getNodeScroll)(element).scrollLeft;
    if (!rect) return $60923e9f3f841413$var$getBoundingClientRect((0, $1D9S2.getDocumentElement)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $60923e9f3f841413$var$getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
    if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : // RTL <body> scrollbar.
    $60923e9f3f841413$var$getWindowScrollBarX(documentElement, htmlRect));
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $60923e9f3f841413$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $1D9S2.getDocumentElement)(offsetParent);
    const topLayer = elements ? (0, $1D9S2.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $Euxde.createCoords)(1);
    const offsets = (0, $Euxde.createCoords)(0);
    const isOffsetParentAnElement = (0, $1D9S2.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $1D9S2.getNodeName)(offsetParent) !== 'body' || (0, $1D9S2.isOverflowElement)(documentElement)) scroll = (0, $1D9S2.getNodeScroll)(offsetParent);
        if ((0, $1D9S2.isHTMLElement)(offsetParent)) {
            const offsetRect = $60923e9f3f841413$var$getBoundingClientRect(offsetParent);
            scale = $60923e9f3f841413$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $60923e9f3f841413$var$getHTMLOffset(documentElement, scroll, true) : (0, $Euxde.createCoords)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $60923e9f3f841413$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $60923e9f3f841413$var$getDocumentRect(element) {
    const html = (0, $1D9S2.getDocumentElement)(element);
    const scroll = (0, $1D9S2.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, $Euxde.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $Euxde.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $60923e9f3f841413$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $1D9S2.getComputedStyle)(body).direction === 'rtl') x += (0, $Euxde.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $60923e9f3f841413$var$getViewportRect(element, strategy) {
    const win = (0, $1D9S2.getWindow)(element);
    const html = (0, $1D9S2.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $1D9S2.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $60923e9f3f841413$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $60923e9f3f841413$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $1D9S2.isHTMLElement)(element) ? $60923e9f3f841413$var$getScale(element) : (0, $Euxde.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $60923e9f3f841413$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $60923e9f3f841413$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $60923e9f3f841413$var$getDocumentRect((0, $1D9S2.getDocumentElement)(element));
    else if ((0, $1D9S2.isElement)(clippingAncestor)) rect = $60923e9f3f841413$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $60923e9f3f841413$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $Euxde.rectToClientRect)(rect);
}
function $60923e9f3f841413$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $1D9S2.getParentNode)(element);
    if (parentNode === stopNode || !(0, $1D9S2.isElement)(parentNode) || (0, $1D9S2.isLastTraversableNode)(parentNode)) return false;
    return (0, $1D9S2.getComputedStyle)(parentNode).position === 'fixed' || $60923e9f3f841413$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $60923e9f3f841413$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $1D9S2.getOverflowAncestors)(element, [], false).filter((el)=>(0, $1D9S2.isElement)(el) && (0, $1D9S2.getNodeName)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $1D9S2.getComputedStyle)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $1D9S2.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $1D9S2.isElement)(currentNode) && !(0, $1D9S2.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, $1D9S2.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, $1D9S2.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && [
            'absolute',
            'fixed'
        ].includes(currentContainingBlockComputedStyle.position) || (0, $1D9S2.isOverflowElement)(currentNode) && !currentNodeIsContaining && $60923e9f3f841413$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $1D9S2.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $60923e9f3f841413$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $1D9S2.isTopLayer)(element) ? [] : $60923e9f3f841413$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $60923e9f3f841413$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $Euxde.max)(rect.top, accRect.top);
        accRect.right = (0, $Euxde.min)(rect.right, accRect.right);
        accRect.bottom = (0, $Euxde.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $Euxde.max)(rect.left, accRect.left);
        return accRect;
    }, $60923e9f3f841413$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $60923e9f3f841413$var$getDimensions(element) {
    const { width: width, height: height } = $60923e9f3f841413$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $60923e9f3f841413$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $1D9S2.isHTMLElement)(offsetParent);
    const documentElement = (0, $1D9S2.getDocumentElement)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $60923e9f3f841413$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $Euxde.createCoords)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $1D9S2.getNodeName)(offsetParent) !== 'body' || (0, $1D9S2.isOverflowElement)(documentElement)) scroll = (0, $1D9S2.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $60923e9f3f841413$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
        // Firefox with layout.scrollbar.side = 3 in about:config to test this.
        offsets.x = $60923e9f3f841413$var$getWindowScrollBarX(documentElement);
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $60923e9f3f841413$var$getHTMLOffset(documentElement, scroll) : (0, $Euxde.createCoords)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $60923e9f3f841413$var$isStaticPositioned(element) {
    return (0, $1D9S2.getComputedStyle)(element).position === 'static';
}
function $60923e9f3f841413$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $1D9S2.isHTMLElement)(element) || (0, $1D9S2.getComputedStyle)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $1D9S2.getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $60923e9f3f841413$var$getOffsetParent(element, polyfill) {
    const win = (0, $1D9S2.getWindow)(element);
    if ((0, $1D9S2.isTopLayer)(element)) return win;
    if (!(0, $1D9S2.isHTMLElement)(element)) {
        let svgOffsetParent = (0, $1D9S2.getParentNode)(element);
        while(svgOffsetParent && !(0, $1D9S2.isLastTraversableNode)(svgOffsetParent)){
            if ((0, $1D9S2.isElement)(svgOffsetParent) && !$60923e9f3f841413$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $1D9S2.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $60923e9f3f841413$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $1D9S2.isTableElement)(offsetParent) && $60923e9f3f841413$var$isStaticPositioned(offsetParent))offsetParent = $60923e9f3f841413$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $1D9S2.isLastTraversableNode)(offsetParent) && $60923e9f3f841413$var$isStaticPositioned(offsetParent) && !(0, $1D9S2.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, $1D9S2.getContainingBlock)(element) || win;
}
const $60923e9f3f841413$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $60923e9f3f841413$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $60923e9f3f841413$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $60923e9f3f841413$var$isRTL(element) {
    return (0, $1D9S2.getComputedStyle)(element).direction === 'rtl';
}
const $60923e9f3f841413$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $60923e9f3f841413$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $1D9S2.getDocumentElement,
    getClippingRect: $60923e9f3f841413$var$getClippingRect,
    getOffsetParent: $60923e9f3f841413$var$getOffsetParent,
    getElementRects: $60923e9f3f841413$var$getElementRects,
    getClientRects: $60923e9f3f841413$var$getClientRects,
    getDimensions: $60923e9f3f841413$var$getDimensions,
    getScale: $60923e9f3f841413$var$getScale,
    isElement: $1D9S2.isElement,
    isRTL: $60923e9f3f841413$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $60923e9f3f841413$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $1D9S2.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $Euxde.floor)(top);
        const insetRight = (0, $Euxde.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, $Euxde.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, $Euxde.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $Euxde.max)(0, (0, $Euxde.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $60923e9f3f841413$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $60923e9f3f841413$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $1D9S2.getOverflowAncestors)(referenceEl) : [],
        ...(0, $1D9S2.getOverflowAncestors)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $60923e9f3f841413$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $60923e9f3f841413$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $60923e9f3f841413$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $60923e9f3f841413$export$37b6bde19b108ecc = (0, $E7rjD.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $60923e9f3f841413$export$cc800923e997bb8 = (0, $E7rjD.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $60923e9f3f841413$export$91fb6ecbd551914 = (0, $E7rjD.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $60923e9f3f841413$export$fba63a578e423eb = (0, $E7rjD.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $60923e9f3f841413$export$8a83211c878a3f1f = (0, $E7rjD.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $60923e9f3f841413$export$346677f925de839c = (0, $E7rjD.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $60923e9f3f841413$export$fe8985bb6374093c = (0, $E7rjD.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $60923e9f3f841413$export$f2120bbfa5450bd2 = (0, $E7rjD.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $60923e9f3f841413$export$18c8ad048e32c7d5 = (0, $E7rjD.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $60923e9f3f841413$export$7bf07e38f3dc4b69 = (0, $E7rjD.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $60923e9f3f841413$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $60923e9f3f841413$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $E7rjD.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};

});
parcelRegister("E7rjD", function(module, exports) {

$parcel$export(module.exports, "computePosition", () => $078981e2e5df035a$export$48a53dcb22e581d0);
$parcel$export(module.exports, "detectOverflow", () => $078981e2e5df035a$export$37b6bde19b108ecc);
$parcel$export(module.exports, "arrow", () => $078981e2e5df035a$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "autoPlacement", () => $078981e2e5df035a$export$91fb6ecbd551914);
$parcel$export(module.exports, "flip", () => $078981e2e5df035a$export$8a83211c878a3f1f);
$parcel$export(module.exports, "hide", () => $078981e2e5df035a$export$fe8985bb6374093c);
$parcel$export(module.exports, "inline", () => $078981e2e5df035a$export$18c8ad048e32c7d5);
$parcel$export(module.exports, "offset", () => $078981e2e5df035a$export$cc800923e997bb8);
$parcel$export(module.exports, "shift", () => $078981e2e5df035a$export$fba63a578e423eb);
$parcel$export(module.exports, "limitShift", () => $078981e2e5df035a$export$7bf07e38f3dc4b69);
$parcel$export(module.exports, "size", () => $078981e2e5df035a$export$346677f925de839c);
$parcel$export(module.exports, "rectToClientRect", () => (parcelRequire("Euxde")).rectToClientRect);

var $Euxde = parcelRequire("Euxde");
function $078981e2e5df035a$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $Euxde.getSideAxis)(placement);
    const alignmentAxis = (0, $Euxde.getAlignmentAxis)(placement);
    const alignLength = (0, $Euxde.getAxisLength)(alignmentAxis);
    const side = (0, $Euxde.getSide)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $Euxde.getAlignment)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $078981e2e5df035a$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $078981e2e5df035a$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $078981e2e5df035a$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $078981e2e5df035a$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $Euxde.evaluate)(options, state);
    const paddingObject = (0, $Euxde.getPaddingObject)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $Euxde.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $Euxde.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $078981e2e5df035a$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $Euxde.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $Euxde.getPaddingObject)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $Euxde.getAlignmentAxis)(placement);
            const length = (0, $Euxde.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $Euxde.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $Euxde.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $Euxde.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $Euxde.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $078981e2e5df035a$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $Euxde.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $Euxde.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $Euxde.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $Euxde.getAlignment)(placement) === alignment || (autoAlignment ? (0, $Euxde.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $078981e2e5df035a$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $Euxde.placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $Euxde.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $Euxde.placements) ? $078981e2e5df035a$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $078981e2e5df035a$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $Euxde.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $Euxde.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $Euxde.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $Euxde.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $078981e2e5df035a$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $Euxde.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $Euxde.getSide)(placement);
            const initialSideAxis = (0, $Euxde.getSideAxis)(initialPlacement);
            const isBasePlacement = (0, $Euxde.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $Euxde.getOppositePlacement)(initialPlacement)
            ] : (0, $Euxde.getExpandedPlacements)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $Euxde.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $078981e2e5df035a$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $Euxde.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $Euxde.getSideAxis)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $078981e2e5df035a$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $078981e2e5df035a$var$isAnySideFullyClipped(overflow) {
    return (0, $Euxde.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $078981e2e5df035a$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $Euxde.evaluate)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await $078981e2e5df035a$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $078981e2e5df035a$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $078981e2e5df035a$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await $078981e2e5df035a$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $078981e2e5df035a$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $078981e2e5df035a$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $078981e2e5df035a$var$getBoundingRect(rects) {
    const minX = (0, $Euxde.min)(...rects.map((rect)=>rect.left));
    const minY = (0, $Euxde.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, $Euxde.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, $Euxde.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $078981e2e5df035a$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $Euxde.rectToClientRect)($078981e2e5df035a$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $078981e2e5df035a$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $Euxde.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $078981e2e5df035a$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $Euxde.rectToClientRect)($078981e2e5df035a$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $Euxde.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $Euxde.getSideAxis)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $Euxde.getSide)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $Euxde.getSide)(placement) === 'left';
                    const maxRight = (0, $Euxde.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $Euxde.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $078981e2e5df035a$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $Euxde.getSide)(placement);
    const alignment = (0, $Euxde.getAlignment)(placement);
    const isVertical = (0, $Euxde.getSideAxis)(placement) === 'y';
    const mainAxisMulti = [
        'left',
        'top'
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $Euxde.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $078981e2e5df035a$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $078981e2e5df035a$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $078981e2e5df035a$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $Euxde.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $078981e2e5df035a$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $Euxde.getSideAxis)((0, $Euxde.getSide)(placement));
            const mainAxis = (0, $Euxde.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $Euxde.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $Euxde.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $078981e2e5df035a$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $Euxde.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $Euxde.getSideAxis)(placement);
            const mainAxis = (0, $Euxde.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $Euxde.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = [
                    'top',
                    'left'
                ].includes((0, $Euxde.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $078981e2e5df035a$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $Euxde.evaluate)(options, state);
            const overflow = await $078981e2e5df035a$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $Euxde.getSide)(placement);
            const alignment = (0, $Euxde.getAlignment)(placement);
            const isYAxis = (0, $Euxde.getSideAxis)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $Euxde.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $Euxde.min)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $Euxde.max)(overflow.left, 0);
                const xMax = (0, $Euxde.max)(overflow.right, 0);
                const yMin = (0, $Euxde.max)(overflow.top, 0);
                const yMax = (0, $Euxde.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $Euxde.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $Euxde.max)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

});




parcelRegister("hnBya", function(module, exports) {
typeof navigator !== "undefined" && function(global, factory) {
    module.exports = factory();
}(this, function() {
    'use strict';
    var svgNS = 'http://www.w3.org/2000/svg';
    var locationHref = '';
    var _useWebWorker = false;
    var initialDefaultFrame = -999999;
    var setWebWorker = function setWebWorker(flag) {
        _useWebWorker = !!flag;
    };
    var getWebWorker = function getWebWorker() {
        return _useWebWorker;
    };
    var setLocationHref = function setLocationHref(value) {
        locationHref = value;
    };
    var getLocationHref = function getLocationHref() {
        return locationHref;
    };
    function createTag(type) {
        // return {appendChild:function(){},setAttribute:function(){},style:{}}
        return document.createElement(type);
    }
    function extendPrototype(sources, destination) {
        var i;
        var len = sources.length;
        var sourcePrototype;
        for(i = 0; i < len; i += 1){
            sourcePrototype = sources[i].prototype;
            for(var attr in sourcePrototype)if (Object.prototype.hasOwnProperty.call(sourcePrototype, attr)) destination.prototype[attr] = sourcePrototype[attr];
        }
    }
    function getDescriptor(object, prop) {
        return Object.getOwnPropertyDescriptor(object, prop);
    }
    function createProxyFunction(prototype) {
        function ProxyFunction() {}
        ProxyFunction.prototype = prototype;
        return ProxyFunction;
    }
    // import Howl from '../../3rd_party/howler';
    var audioControllerFactory = function() {
        function AudioController(audioFactory) {
            this.audios = [];
            this.audioFactory = audioFactory;
            this._volume = 1;
            this._isMuted = false;
        }
        AudioController.prototype = {
            addAudio: function addAudio(audio) {
                this.audios.push(audio);
            },
            pause: function pause() {
                var i;
                var len = this.audios.length;
                for(i = 0; i < len; i += 1)this.audios[i].pause();
            },
            resume: function resume() {
                var i;
                var len = this.audios.length;
                for(i = 0; i < len; i += 1)this.audios[i].resume();
            },
            setRate: function setRate(rateValue) {
                var i;
                var len = this.audios.length;
                for(i = 0; i < len; i += 1)this.audios[i].setRate(rateValue);
            },
            createAudio: function createAudio(assetPath) {
                if (this.audioFactory) return this.audioFactory(assetPath);
                if (window.Howl) return new window.Howl({
                    src: [
                        assetPath
                    ]
                });
                return {
                    isPlaying: false,
                    play: function play() {
                        this.isPlaying = true;
                    },
                    seek: function seek() {
                        this.isPlaying = false;
                    },
                    playing: function playing() {},
                    rate: function rate() {},
                    setVolume: function setVolume() {}
                };
            },
            setAudioFactory: function setAudioFactory(audioFactory) {
                this.audioFactory = audioFactory;
            },
            setVolume: function setVolume(value) {
                this._volume = value;
                this._updateVolume();
            },
            mute: function mute() {
                this._isMuted = true;
                this._updateVolume();
            },
            unmute: function unmute() {
                this._isMuted = false;
                this._updateVolume();
            },
            getVolume: function getVolume() {
                return this._volume;
            },
            _updateVolume: function _updateVolume() {
                var i;
                var len = this.audios.length;
                for(i = 0; i < len; i += 1)this.audios[i].volume(this._volume * (this._isMuted ? 0 : 1));
            }
        };
        return function() {
            return new AudioController();
        };
    }();
    var createTypedArray = function() {
        function createRegularArray(type, len) {
            var i = 0;
            var arr = [];
            var value;
            switch(type){
                case 'int16':
                case 'uint8c':
                    value = 1;
                    break;
                default:
                    value = 1.1;
                    break;
            }
            for(i = 0; i < len; i += 1)arr.push(value);
            return arr;
        }
        function createTypedArrayFactory(type, len) {
            if (type === 'float32') return new Float32Array(len);
            if (type === 'int16') return new Int16Array(len);
            if (type === 'uint8c') return new Uint8ClampedArray(len);
            return createRegularArray(type, len);
        }
        if (typeof Uint8ClampedArray === 'function' && typeof Float32Array === 'function') return createTypedArrayFactory;
        return createRegularArray;
    }();
    function createSizedArray(len) {
        return Array.apply(null, {
            length: len
        });
    }
    function _typeof$6(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$6 = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof$6 = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof$6(obj);
    }
    var subframeEnabled = true;
    var expressionsPlugin = null;
    var expressionsInterfaces = null;
    var idPrefix$1 = '';
    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    var _shouldRoundValues = false;
    var bmPow = Math.pow;
    var bmSqrt = Math.sqrt;
    var bmFloor = Math.floor;
    var bmMax = Math.max;
    var bmMin = Math.min;
    var BMMath = {};
    (function() {
        var propertyNames = [
            'abs',
            'acos',
            'acosh',
            'asin',
            'asinh',
            'atan',
            'atanh',
            'atan2',
            'ceil',
            'cbrt',
            'expm1',
            'clz32',
            'cos',
            'cosh',
            'exp',
            'floor',
            'fround',
            'hypot',
            'imul',
            'log',
            'log1p',
            'log2',
            'log10',
            'max',
            'min',
            'pow',
            'random',
            'round',
            'sign',
            'sin',
            'sinh',
            'sqrt',
            'tan',
            'tanh',
            'trunc',
            'E',
            'LN10',
            'LN2',
            'LOG10E',
            'LOG2E',
            'PI',
            'SQRT1_2',
            'SQRT2'
        ];
        var i;
        var len = propertyNames.length;
        for(i = 0; i < len; i += 1)BMMath[propertyNames[i]] = Math[propertyNames[i]];
    })();
    function ProjectInterface$1() {
        return {};
    }
    BMMath.random = Math.random;
    BMMath.abs = function(val) {
        var tOfVal = _typeof$6(val);
        if (tOfVal === 'object' && val.length) {
            var absArr = createSizedArray(val.length);
            var i;
            var len = val.length;
            for(i = 0; i < len; i += 1)absArr[i] = Math.abs(val[i]);
            return absArr;
        }
        return Math.abs(val);
    };
    var defaultCurveSegments = 150;
    var degToRads = Math.PI / 180;
    var roundCorner = 0.5519;
    function roundValues(flag) {
        _shouldRoundValues = !!flag;
    }
    function bmRnd(value) {
        if (_shouldRoundValues) return Math.round(value);
        return value;
    }
    function styleDiv(element) {
        element.style.position = 'absolute';
        element.style.top = 0;
        element.style.left = 0;
        element.style.display = 'block';
        element.style.transformOrigin = '0 0';
        element.style.webkitTransformOrigin = '0 0';
        element.style.backfaceVisibility = 'visible';
        element.style.webkitBackfaceVisibility = 'visible';
        element.style.transformStyle = 'preserve-3d';
        element.style.webkitTransformStyle = 'preserve-3d';
        element.style.mozTransformStyle = 'preserve-3d';
    }
    function BMEnterFrameEvent(type, currentTime, totalTime, frameMultiplier) {
        this.type = type;
        this.currentTime = currentTime;
        this.totalTime = totalTime;
        this.direction = frameMultiplier < 0 ? -1 : 1;
    }
    function BMCompleteEvent(type, frameMultiplier) {
        this.type = type;
        this.direction = frameMultiplier < 0 ? -1 : 1;
    }
    function BMCompleteLoopEvent(type, totalLoops, currentLoop, frameMultiplier) {
        this.type = type;
        this.currentLoop = currentLoop;
        this.totalLoops = totalLoops;
        this.direction = frameMultiplier < 0 ? -1 : 1;
    }
    function BMSegmentStartEvent(type, firstFrame, totalFrames) {
        this.type = type;
        this.firstFrame = firstFrame;
        this.totalFrames = totalFrames;
    }
    function BMDestroyEvent(type, target) {
        this.type = type;
        this.target = target;
    }
    function BMRenderFrameErrorEvent(nativeError, currentTime) {
        this.type = 'renderFrameError';
        this.nativeError = nativeError;
        this.currentTime = currentTime;
    }
    function BMConfigErrorEvent(nativeError) {
        this.type = 'configError';
        this.nativeError = nativeError;
    }
    function BMAnimationConfigErrorEvent(type, nativeError) {
        this.type = type;
        this.nativeError = nativeError;
    }
    var createElementID = function() {
        var _count = 0;
        return function createID() {
            _count += 1;
            return idPrefix$1 + '__lottie_element_' + _count;
        };
    }();
    function HSVtoRGB(h, s, v) {
        var r;
        var g;
        var b;
        var i;
        var f;
        var p;
        var q;
        var t;
        i = Math.floor(h * 6);
        f = h * 6 - i;
        p = v * (1 - s);
        q = v * (1 - f * s);
        t = v * (1 - (1 - f) * s);
        switch(i % 6){
            case 0:
                r = v;
                g = t;
                b = p;
                break;
            case 1:
                r = q;
                g = v;
                b = p;
                break;
            case 2:
                r = p;
                g = v;
                b = t;
                break;
            case 3:
                r = p;
                g = q;
                b = v;
                break;
            case 4:
                r = t;
                g = p;
                b = v;
                break;
            case 5:
                r = v;
                g = p;
                b = q;
                break;
            default:
                break;
        }
        return [
            r,
            g,
            b
        ];
    }
    function RGBtoHSV(r, g, b) {
        var max = Math.max(r, g, b);
        var min = Math.min(r, g, b);
        var d = max - min;
        var h;
        var s = max === 0 ? 0 : d / max;
        var v = max / 255;
        switch(max){
            case min:
                h = 0;
                break;
            case r:
                h = g - b + d * (g < b ? 6 : 0);
                h /= 6 * d;
                break;
            case g:
                h = b - r + d * 2;
                h /= 6 * d;
                break;
            case b:
                h = r - g + d * 4;
                h /= 6 * d;
                break;
            default:
                break;
        }
        return [
            h,
            s,
            v
        ];
    }
    function addSaturationToRGB(color, offset) {
        var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
        hsv[1] += offset;
        if (hsv[1] > 1) hsv[1] = 1;
        else if (hsv[1] <= 0) hsv[1] = 0;
        return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
    }
    function addBrightnessToRGB(color, offset) {
        var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
        hsv[2] += offset;
        if (hsv[2] > 1) hsv[2] = 1;
        else if (hsv[2] < 0) hsv[2] = 0;
        return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
    }
    function addHueToRGB(color, offset) {
        var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
        hsv[0] += offset / 360;
        if (hsv[0] > 1) hsv[0] -= 1;
        else if (hsv[0] < 0) hsv[0] += 1;
        return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
    }
    var rgbToHex = function() {
        var colorMap = [];
        var i;
        var hex;
        for(i = 0; i < 256; i += 1){
            hex = i.toString(16);
            colorMap[i] = hex.length === 1 ? '0' + hex : hex;
        }
        return function(r, g, b) {
            if (r < 0) r = 0;
            if (g < 0) g = 0;
            if (b < 0) b = 0;
            return '#' + colorMap[r] + colorMap[g] + colorMap[b];
        };
    }();
    var setSubframeEnabled = function setSubframeEnabled(flag) {
        subframeEnabled = !!flag;
    };
    var getSubframeEnabled = function getSubframeEnabled() {
        return subframeEnabled;
    };
    var setExpressionsPlugin = function setExpressionsPlugin(value) {
        expressionsPlugin = value;
    };
    var getExpressionsPlugin = function getExpressionsPlugin() {
        return expressionsPlugin;
    };
    var setExpressionInterfaces = function setExpressionInterfaces(value) {
        expressionsInterfaces = value;
    };
    var getExpressionInterfaces = function getExpressionInterfaces() {
        return expressionsInterfaces;
    };
    var setDefaultCurveSegments = function setDefaultCurveSegments(value) {
        defaultCurveSegments = value;
    };
    var getDefaultCurveSegments = function getDefaultCurveSegments() {
        return defaultCurveSegments;
    };
    var setIdPrefix = function setIdPrefix(value) {
        idPrefix$1 = value;
    };
    var getIdPrefix = function getIdPrefix() {
        return idPrefix$1;
    };
    function createNS(type) {
        // return {appendChild:function(){},setAttribute:function(){},style:{}}
        return document.createElementNS(svgNS, type);
    }
    function _typeof$5(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$5 = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof$5 = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof$5(obj);
    }
    var dataManager = function() {
        var _counterId = 1;
        var processes = [];
        var workerFn;
        var workerInstance;
        var workerProxy = {
            onmessage: function onmessage() {},
            postMessage: function postMessage(path) {
                workerFn({
                    data: path
                });
            }
        };
        var _workerSelf = {
            postMessage: function postMessage(data) {
                workerProxy.onmessage({
                    data: data
                });
            }
        };
        function createWorker(fn) {
            if (window.Worker && window.Blob && getWebWorker()) {
                var blob = new Blob([
                    'var _workerSelf = self; self.onmessage = ',
                    fn.toString()
                ], {
                    type: 'text/javascript'
                }); // var blob = new Blob(['self.onmessage = ', fn.toString()], { type: 'text/javascript' });
                var url = URL.createObjectURL(blob);
                return new Worker(url);
            }
            workerFn = fn;
            return workerProxy;
        }
        function setupWorker() {
            if (!workerInstance) {
                workerInstance = createWorker(function workerStart(e) {
                    function dataFunctionManager() {
                        function completeLayers(layers, comps) {
                            var layerData;
                            var i;
                            var len = layers.length;
                            var j;
                            var jLen;
                            var k;
                            var kLen;
                            for(i = 0; i < len; i += 1){
                                layerData = layers[i];
                                if ('ks' in layerData && !layerData.completed) {
                                    layerData.completed = true;
                                    if (layerData.hasMask) {
                                        var maskProps = layerData.masksProperties;
                                        jLen = maskProps.length;
                                        for(j = 0; j < jLen; j += 1)if (maskProps[j].pt.k.i) convertPathsToAbsoluteValues(maskProps[j].pt.k);
                                        else {
                                            kLen = maskProps[j].pt.k.length;
                                            for(k = 0; k < kLen; k += 1){
                                                if (maskProps[j].pt.k[k].s) convertPathsToAbsoluteValues(maskProps[j].pt.k[k].s[0]);
                                                if (maskProps[j].pt.k[k].e) convertPathsToAbsoluteValues(maskProps[j].pt.k[k].e[0]);
                                            }
                                        }
                                    }
                                    if (layerData.ty === 0) {
                                        layerData.layers = findCompLayers(layerData.refId, comps);
                                        completeLayers(layerData.layers, comps);
                                    } else if (layerData.ty === 4) completeShapes(layerData.shapes);
                                    else if (layerData.ty === 5) completeText(layerData);
                                }
                            }
                        }
                        function completeChars(chars, assets) {
                            if (chars) {
                                var i = 0;
                                var len = chars.length;
                                for(i = 0; i < len; i += 1)if (chars[i].t === 1) {
                                    // var compData = findComp(chars[i].data.refId, assets);
                                    chars[i].data.layers = findCompLayers(chars[i].data.refId, assets); // chars[i].data.ip = 0;
                                    // chars[i].data.op = 99999;
                                    // chars[i].data.st = 0;
                                    // chars[i].data.sr = 1;
                                    // chars[i].w = compData.w;
                                    // chars[i].data.ks = {
                                    //   a: { k: [0, 0, 0], a: 0 },
                                    //   p: { k: [0, -compData.h, 0], a: 0 },
                                    //   r: { k: 0, a: 0 },
                                    //   s: { k: [100, 100], a: 0 },
                                    //   o: { k: 100, a: 0 },
                                    // };
                                    completeLayers(chars[i].data.layers, assets);
                                }
                            }
                        }
                        function findComp(id, comps) {
                            var i = 0;
                            var len = comps.length;
                            while(i < len){
                                if (comps[i].id === id) return comps[i];
                                i += 1;
                            }
                            return null;
                        }
                        function findCompLayers(id, comps) {
                            var comp = findComp(id, comps);
                            if (comp) {
                                if (!comp.layers.__used) {
                                    comp.layers.__used = true;
                                    return comp.layers;
                                }
                                return JSON.parse(JSON.stringify(comp.layers));
                            }
                            return null;
                        }
                        function completeShapes(arr) {
                            var i;
                            var len = arr.length;
                            var j;
                            var jLen;
                            for(i = len - 1; i >= 0; i -= 1){
                                if (arr[i].ty === 'sh') {
                                    if (arr[i].ks.k.i) convertPathsToAbsoluteValues(arr[i].ks.k);
                                    else {
                                        jLen = arr[i].ks.k.length;
                                        for(j = 0; j < jLen; j += 1){
                                            if (arr[i].ks.k[j].s) convertPathsToAbsoluteValues(arr[i].ks.k[j].s[0]);
                                            if (arr[i].ks.k[j].e) convertPathsToAbsoluteValues(arr[i].ks.k[j].e[0]);
                                        }
                                    }
                                } else if (arr[i].ty === 'gr') completeShapes(arr[i].it);
                            }
                        }
                        function convertPathsToAbsoluteValues(path) {
                            var i;
                            var len = path.i.length;
                            for(i = 0; i < len; i += 1){
                                path.i[i][0] += path.v[i][0];
                                path.i[i][1] += path.v[i][1];
                                path.o[i][0] += path.v[i][0];
                                path.o[i][1] += path.v[i][1];
                            }
                        }
                        function checkVersion(minimum, animVersionString) {
                            var animVersion = animVersionString ? animVersionString.split('.') : [
                                100,
                                100,
                                100
                            ];
                            if (minimum[0] > animVersion[0]) return true;
                            if (animVersion[0] > minimum[0]) return false;
                            if (minimum[1] > animVersion[1]) return true;
                            if (animVersion[1] > minimum[1]) return false;
                            if (minimum[2] > animVersion[2]) return true;
                            if (animVersion[2] > minimum[2]) return false;
                            return null;
                        }
                        var checkText = function() {
                            var minimumVersion = [
                                4,
                                4,
                                14
                            ];
                            function updateTextLayer(textLayer) {
                                var documentData = textLayer.t.d;
                                textLayer.t.d = {
                                    k: [
                                        {
                                            s: documentData,
                                            t: 0
                                        }
                                    ]
                                };
                            }
                            function iterateLayers(layers) {
                                var i;
                                var len = layers.length;
                                for(i = 0; i < len; i += 1)if (layers[i].ty === 5) updateTextLayer(layers[i]);
                            }
                            return function(animationData) {
                                if (checkVersion(minimumVersion, animationData.v)) {
                                    iterateLayers(animationData.layers);
                                    if (animationData.assets) {
                                        var i;
                                        var len = animationData.assets.length;
                                        for(i = 0; i < len; i += 1)if (animationData.assets[i].layers) iterateLayers(animationData.assets[i].layers);
                                    }
                                }
                            };
                        }();
                        var checkChars = function() {
                            var minimumVersion = [
                                4,
                                7,
                                99
                            ];
                            return function(animationData) {
                                if (animationData.chars && !checkVersion(minimumVersion, animationData.v)) {
                                    var i;
                                    var len = animationData.chars.length;
                                    for(i = 0; i < len; i += 1){
                                        var charData = animationData.chars[i];
                                        if (charData.data && charData.data.shapes) {
                                            completeShapes(charData.data.shapes);
                                            charData.data.ip = 0;
                                            charData.data.op = 99999;
                                            charData.data.st = 0;
                                            charData.data.sr = 1;
                                            charData.data.ks = {
                                                p: {
                                                    k: [
                                                        0,
                                                        0
                                                    ],
                                                    a: 0
                                                },
                                                s: {
                                                    k: [
                                                        100,
                                                        100
                                                    ],
                                                    a: 0
                                                },
                                                a: {
                                                    k: [
                                                        0,
                                                        0
                                                    ],
                                                    a: 0
                                                },
                                                r: {
                                                    k: 0,
                                                    a: 0
                                                },
                                                o: {
                                                    k: 100,
                                                    a: 0
                                                }
                                            };
                                            if (!animationData.chars[i].t) {
                                                charData.data.shapes.push({
                                                    ty: 'no'
                                                });
                                                charData.data.shapes[0].it.push({
                                                    p: {
                                                        k: [
                                                            0,
                                                            0
                                                        ],
                                                        a: 0
                                                    },
                                                    s: {
                                                        k: [
                                                            100,
                                                            100
                                                        ],
                                                        a: 0
                                                    },
                                                    a: {
                                                        k: [
                                                            0,
                                                            0
                                                        ],
                                                        a: 0
                                                    },
                                                    r: {
                                                        k: 0,
                                                        a: 0
                                                    },
                                                    o: {
                                                        k: 100,
                                                        a: 0
                                                    },
                                                    sk: {
                                                        k: 0,
                                                        a: 0
                                                    },
                                                    sa: {
                                                        k: 0,
                                                        a: 0
                                                    },
                                                    ty: 'tr'
                                                });
                                            }
                                        }
                                    }
                                }
                            };
                        }();
                        var checkPathProperties = function() {
                            var minimumVersion = [
                                5,
                                7,
                                15
                            ];
                            function updateTextLayer(textLayer) {
                                var pathData = textLayer.t.p;
                                if (typeof pathData.a === 'number') pathData.a = {
                                    a: 0,
                                    k: pathData.a
                                };
                                if (typeof pathData.p === 'number') pathData.p = {
                                    a: 0,
                                    k: pathData.p
                                };
                                if (typeof pathData.r === 'number') pathData.r = {
                                    a: 0,
                                    k: pathData.r
                                };
                            }
                            function iterateLayers(layers) {
                                var i;
                                var len = layers.length;
                                for(i = 0; i < len; i += 1)if (layers[i].ty === 5) updateTextLayer(layers[i]);
                            }
                            return function(animationData) {
                                if (checkVersion(minimumVersion, animationData.v)) {
                                    iterateLayers(animationData.layers);
                                    if (animationData.assets) {
                                        var i;
                                        var len = animationData.assets.length;
                                        for(i = 0; i < len; i += 1)if (animationData.assets[i].layers) iterateLayers(animationData.assets[i].layers);
                                    }
                                }
                            };
                        }();
                        var checkColors = function() {
                            var minimumVersion = [
                                4,
                                1,
                                9
                            ];
                            function iterateShapes(shapes) {
                                var i;
                                var len = shapes.length;
                                var j;
                                var jLen;
                                for(i = 0; i < len; i += 1){
                                    if (shapes[i].ty === 'gr') iterateShapes(shapes[i].it);
                                    else if (shapes[i].ty === 'fl' || shapes[i].ty === 'st') {
                                        if (shapes[i].c.k && shapes[i].c.k[0].i) {
                                            jLen = shapes[i].c.k.length;
                                            for(j = 0; j < jLen; j += 1){
                                                if (shapes[i].c.k[j].s) {
                                                    shapes[i].c.k[j].s[0] /= 255;
                                                    shapes[i].c.k[j].s[1] /= 255;
                                                    shapes[i].c.k[j].s[2] /= 255;
                                                    shapes[i].c.k[j].s[3] /= 255;
                                                }
                                                if (shapes[i].c.k[j].e) {
                                                    shapes[i].c.k[j].e[0] /= 255;
                                                    shapes[i].c.k[j].e[1] /= 255;
                                                    shapes[i].c.k[j].e[2] /= 255;
                                                    shapes[i].c.k[j].e[3] /= 255;
                                                }
                                            }
                                        } else {
                                            shapes[i].c.k[0] /= 255;
                                            shapes[i].c.k[1] /= 255;
                                            shapes[i].c.k[2] /= 255;
                                            shapes[i].c.k[3] /= 255;
                                        }
                                    }
                                }
                            }
                            function iterateLayers(layers) {
                                var i;
                                var len = layers.length;
                                for(i = 0; i < len; i += 1)if (layers[i].ty === 4) iterateShapes(layers[i].shapes);
                            }
                            return function(animationData) {
                                if (checkVersion(minimumVersion, animationData.v)) {
                                    iterateLayers(animationData.layers);
                                    if (animationData.assets) {
                                        var i;
                                        var len = animationData.assets.length;
                                        for(i = 0; i < len; i += 1)if (animationData.assets[i].layers) iterateLayers(animationData.assets[i].layers);
                                    }
                                }
                            };
                        }();
                        var checkShapes = function() {
                            var minimumVersion = [
                                4,
                                4,
                                18
                            ];
                            function completeClosingShapes(arr) {
                                var i;
                                var len = arr.length;
                                var j;
                                var jLen;
                                for(i = len - 1; i >= 0; i -= 1){
                                    if (arr[i].ty === 'sh') {
                                        if (arr[i].ks.k.i) arr[i].ks.k.c = arr[i].closed;
                                        else {
                                            jLen = arr[i].ks.k.length;
                                            for(j = 0; j < jLen; j += 1){
                                                if (arr[i].ks.k[j].s) arr[i].ks.k[j].s[0].c = arr[i].closed;
                                                if (arr[i].ks.k[j].e) arr[i].ks.k[j].e[0].c = arr[i].closed;
                                            }
                                        }
                                    } else if (arr[i].ty === 'gr') completeClosingShapes(arr[i].it);
                                }
                            }
                            function iterateLayers(layers) {
                                var layerData;
                                var i;
                                var len = layers.length;
                                var j;
                                var jLen;
                                var k;
                                var kLen;
                                for(i = 0; i < len; i += 1){
                                    layerData = layers[i];
                                    if (layerData.hasMask) {
                                        var maskProps = layerData.masksProperties;
                                        jLen = maskProps.length;
                                        for(j = 0; j < jLen; j += 1)if (maskProps[j].pt.k.i) maskProps[j].pt.k.c = maskProps[j].cl;
                                        else {
                                            kLen = maskProps[j].pt.k.length;
                                            for(k = 0; k < kLen; k += 1){
                                                if (maskProps[j].pt.k[k].s) maskProps[j].pt.k[k].s[0].c = maskProps[j].cl;
                                                if (maskProps[j].pt.k[k].e) maskProps[j].pt.k[k].e[0].c = maskProps[j].cl;
                                            }
                                        }
                                    }
                                    if (layerData.ty === 4) completeClosingShapes(layerData.shapes);
                                }
                            }
                            return function(animationData) {
                                if (checkVersion(minimumVersion, animationData.v)) {
                                    iterateLayers(animationData.layers);
                                    if (animationData.assets) {
                                        var i;
                                        var len = animationData.assets.length;
                                        for(i = 0; i < len; i += 1)if (animationData.assets[i].layers) iterateLayers(animationData.assets[i].layers);
                                    }
                                }
                            };
                        }();
                        function completeData(animationData) {
                            if (animationData.__complete) return;
                            checkColors(animationData);
                            checkText(animationData);
                            checkChars(animationData);
                            checkPathProperties(animationData);
                            checkShapes(animationData);
                            completeLayers(animationData.layers, animationData.assets);
                            completeChars(animationData.chars, animationData.assets);
                            animationData.__complete = true;
                        }
                        function completeText(data) {
                            data.t.a.length === 0 && data.t.p;
                        }
                        var moduleOb = {};
                        moduleOb.completeData = completeData;
                        moduleOb.checkColors = checkColors;
                        moduleOb.checkChars = checkChars;
                        moduleOb.checkPathProperties = checkPathProperties;
                        moduleOb.checkShapes = checkShapes;
                        moduleOb.completeLayers = completeLayers;
                        return moduleOb;
                    }
                    if (!_workerSelf.dataManager) _workerSelf.dataManager = dataFunctionManager();
                    if (!_workerSelf.assetLoader) _workerSelf.assetLoader = function() {
                        function formatResponse(xhr) {
                            // using typeof doubles the time of execution of this method,
                            // so if available, it's better to use the header to validate the type
                            var contentTypeHeader = xhr.getResponseHeader('content-type');
                            if (contentTypeHeader && xhr.responseType === 'json' && contentTypeHeader.indexOf('json') !== -1) return xhr.response;
                            if (xhr.response && _typeof$5(xhr.response) === 'object') return xhr.response;
                            if (xhr.response && typeof xhr.response === 'string') return JSON.parse(xhr.response);
                            if (xhr.responseText) return JSON.parse(xhr.responseText);
                            return null;
                        }
                        function loadAsset(path, fullPath, callback, errorCallback) {
                            var response;
                            var xhr = new XMLHttpRequest(); // set responseType after calling open or IE will break.
                            try {
                                // This crashes on Android WebView prior to KitKat
                                xhr.responseType = 'json';
                            } catch (err) {} // eslint-disable-line no-empty
                            xhr.onreadystatechange = function() {
                                if (xhr.readyState === 4) {
                                    if (xhr.status === 200) {
                                        response = formatResponse(xhr);
                                        callback(response);
                                    } else try {
                                        response = formatResponse(xhr);
                                        callback(response);
                                    } catch (err) {
                                        if (errorCallback) errorCallback(err);
                                    }
                                }
                            };
                            try {
                                // Hack to workaround banner validation
                                xhr.open([
                                    'G',
                                    'E',
                                    'T'
                                ].join(''), path, true);
                            } catch (error) {
                                // Hack to workaround banner validation
                                xhr.open([
                                    'G',
                                    'E',
                                    'T'
                                ].join(''), fullPath + '/' + path, true);
                            }
                            xhr.send();
                        }
                        return {
                            load: loadAsset
                        };
                    }();
                    if (e.data.type === 'loadAnimation') _workerSelf.assetLoader.load(e.data.path, e.data.fullPath, function(data) {
                        _workerSelf.dataManager.completeData(data);
                        _workerSelf.postMessage({
                            id: e.data.id,
                            payload: data,
                            status: 'success'
                        });
                    }, function() {
                        _workerSelf.postMessage({
                            id: e.data.id,
                            status: 'error'
                        });
                    });
                    else if (e.data.type === 'complete') {
                        var animation = e.data.animation;
                        _workerSelf.dataManager.completeData(animation);
                        _workerSelf.postMessage({
                            id: e.data.id,
                            payload: animation,
                            status: 'success'
                        });
                    } else if (e.data.type === 'loadData') _workerSelf.assetLoader.load(e.data.path, e.data.fullPath, function(data) {
                        _workerSelf.postMessage({
                            id: e.data.id,
                            payload: data,
                            status: 'success'
                        });
                    }, function() {
                        _workerSelf.postMessage({
                            id: e.data.id,
                            status: 'error'
                        });
                    });
                });
                workerInstance.onmessage = function(event) {
                    var data = event.data;
                    var id = data.id;
                    var process = processes[id];
                    processes[id] = null;
                    if (data.status === 'success') process.onComplete(data.payload);
                    else if (process.onError) process.onError();
                };
            }
        }
        function createProcess(onComplete, onError) {
            _counterId += 1;
            var id = 'processId_' + _counterId;
            processes[id] = {
                onComplete: onComplete,
                onError: onError
            };
            return id;
        }
        function loadAnimation(path, onComplete, onError) {
            setupWorker();
            var processId = createProcess(onComplete, onError);
            workerInstance.postMessage({
                type: 'loadAnimation',
                path: path,
                fullPath: window.location.origin + window.location.pathname,
                id: processId
            });
        }
        function loadData(path, onComplete, onError) {
            setupWorker();
            var processId = createProcess(onComplete, onError);
            workerInstance.postMessage({
                type: 'loadData',
                path: path,
                fullPath: window.location.origin + window.location.pathname,
                id: processId
            });
        }
        function completeAnimation(anim, onComplete, onError) {
            setupWorker();
            var processId = createProcess(onComplete, onError);
            workerInstance.postMessage({
                type: 'complete',
                animation: anim,
                id: processId
            });
        }
        return {
            loadAnimation: loadAnimation,
            loadData: loadData,
            completeAnimation: completeAnimation
        };
    }();
    var ImagePreloader = function() {
        var proxyImage = function() {
            var canvas = createTag('canvas');
            canvas.width = 1;
            canvas.height = 1;
            var ctx = canvas.getContext('2d');
            ctx.fillStyle = 'rgba(0,0,0,0)';
            ctx.fillRect(0, 0, 1, 1);
            return canvas;
        }();
        function imageLoaded() {
            this.loadedAssets += 1;
            if (this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages) {
                if (this.imagesLoadedCb) this.imagesLoadedCb(null);
            }
        }
        function footageLoaded() {
            this.loadedFootagesCount += 1;
            if (this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages) {
                if (this.imagesLoadedCb) this.imagesLoadedCb(null);
            }
        }
        function getAssetsPath(assetData, assetsPath, originalPath) {
            var path = '';
            if (assetData.e) path = assetData.p;
            else if (assetsPath) {
                var imagePath = assetData.p;
                if (imagePath.indexOf('images/') !== -1) imagePath = imagePath.split('/')[1];
                path = assetsPath + imagePath;
            } else {
                path = originalPath;
                path += assetData.u ? assetData.u : '';
                path += assetData.p;
            }
            return path;
        }
        function testImageLoaded(img) {
            var _count = 0;
            var intervalId = setInterval((function() {
                var box = img.getBBox();
                if (box.width || _count > 500) {
                    this._imageLoaded();
                    clearInterval(intervalId);
                }
                _count += 1;
            }).bind(this), 50);
        }
        function createImageData(assetData) {
            var path = getAssetsPath(assetData, this.assetsPath, this.path);
            var img = createNS('image');
            if (isSafari) this.testImageLoaded(img);
            else img.addEventListener('load', this._imageLoaded, false);
            img.addEventListener('error', (function() {
                ob.img = proxyImage;
                this._imageLoaded();
            }).bind(this), false);
            img.setAttributeNS('http://www.w3.org/1999/xlink', 'href', path);
            if (this._elementHelper.append) this._elementHelper.append(img);
            else this._elementHelper.appendChild(img);
            var ob = {
                img: img,
                assetData: assetData
            };
            return ob;
        }
        function createImgData(assetData) {
            var path = getAssetsPath(assetData, this.assetsPath, this.path);
            var img = createTag('img');
            img.crossOrigin = 'anonymous';
            img.addEventListener('load', this._imageLoaded, false);
            img.addEventListener('error', (function() {
                ob.img = proxyImage;
                this._imageLoaded();
            }).bind(this), false);
            img.src = path;
            var ob = {
                img: img,
                assetData: assetData
            };
            return ob;
        }
        function createFootageData(data) {
            var ob = {
                assetData: data
            };
            var path = getAssetsPath(data, this.assetsPath, this.path);
            dataManager.loadData(path, (function(footageData) {
                ob.img = footageData;
                this._footageLoaded();
            }).bind(this), (function() {
                ob.img = {};
                this._footageLoaded();
            }).bind(this));
            return ob;
        }
        function loadAssets(assets, cb) {
            this.imagesLoadedCb = cb;
            var i;
            var len = assets.length;
            for(i = 0; i < len; i += 1)if (!assets[i].layers) {
                if (!assets[i].t || assets[i].t === 'seq') {
                    this.totalImages += 1;
                    this.images.push(this._createImageData(assets[i]));
                } else if (assets[i].t === 3) {
                    this.totalFootages += 1;
                    this.images.push(this.createFootageData(assets[i]));
                }
            }
        }
        function setPath(path) {
            this.path = path || '';
        }
        function setAssetsPath(path) {
            this.assetsPath = path || '';
        }
        function getAsset(assetData) {
            var i = 0;
            var len = this.images.length;
            while(i < len){
                if (this.images[i].assetData === assetData) return this.images[i].img;
                i += 1;
            }
            return null;
        }
        function destroy() {
            this.imagesLoadedCb = null;
            this.images.length = 0;
        }
        function loadedImages() {
            return this.totalImages === this.loadedAssets;
        }
        function loadedFootages() {
            return this.totalFootages === this.loadedFootagesCount;
        }
        function setCacheType(type, elementHelper) {
            if (type === 'svg') {
                this._elementHelper = elementHelper;
                this._createImageData = this.createImageData.bind(this);
            } else this._createImageData = this.createImgData.bind(this);
        }
        function ImagePreloaderFactory() {
            this._imageLoaded = imageLoaded.bind(this);
            this._footageLoaded = footageLoaded.bind(this);
            this.testImageLoaded = testImageLoaded.bind(this);
            this.createFootageData = createFootageData.bind(this);
            this.assetsPath = '';
            this.path = '';
            this.totalImages = 0;
            this.totalFootages = 0;
            this.loadedAssets = 0;
            this.loadedFootagesCount = 0;
            this.imagesLoadedCb = null;
            this.images = [];
        }
        ImagePreloaderFactory.prototype = {
            loadAssets: loadAssets,
            setAssetsPath: setAssetsPath,
            setPath: setPath,
            loadedImages: loadedImages,
            loadedFootages: loadedFootages,
            destroy: destroy,
            getAsset: getAsset,
            createImgData: createImgData,
            createImageData: createImageData,
            imageLoaded: imageLoaded,
            footageLoaded: footageLoaded,
            setCacheType: setCacheType
        };
        return ImagePreloaderFactory;
    }();
    function BaseEvent() {}
    BaseEvent.prototype = {
        triggerEvent: function triggerEvent(eventName, args) {
            if (this._cbs[eventName]) {
                var callbacks = this._cbs[eventName];
                for(var i = 0; i < callbacks.length; i += 1)callbacks[i](args);
            }
        },
        addEventListener: function addEventListener(eventName, callback) {
            if (!this._cbs[eventName]) this._cbs[eventName] = [];
            this._cbs[eventName].push(callback);
            return (function() {
                this.removeEventListener(eventName, callback);
            }).bind(this);
        },
        removeEventListener: function removeEventListener(eventName, callback) {
            if (!callback) this._cbs[eventName] = null;
            else if (this._cbs[eventName]) {
                var i = 0;
                var len = this._cbs[eventName].length;
                while(i < len){
                    if (this._cbs[eventName][i] === callback) {
                        this._cbs[eventName].splice(i, 1);
                        i -= 1;
                        len -= 1;
                    }
                    i += 1;
                }
                if (!this._cbs[eventName].length) this._cbs[eventName] = null;
            }
        }
    };
    var markerParser = function() {
        function parsePayloadLines(payload) {
            var lines = payload.split('\r\n');
            var keys = {};
            var line;
            var keysCount = 0;
            for(var i = 0; i < lines.length; i += 1){
                line = lines[i].split(':');
                if (line.length === 2) {
                    keys[line[0]] = line[1].trim();
                    keysCount += 1;
                }
            }
            if (keysCount === 0) throw new Error();
            return keys;
        }
        return function(_markers) {
            var markers = [];
            for(var i = 0; i < _markers.length; i += 1){
                var _marker = _markers[i];
                var markerData = {
                    time: _marker.tm,
                    duration: _marker.dr
                };
                try {
                    markerData.payload = JSON.parse(_markers[i].cm);
                } catch (_) {
                    try {
                        markerData.payload = parsePayloadLines(_markers[i].cm);
                    } catch (__) {
                        markerData.payload = {
                            name: _markers[i].cm
                        };
                    }
                }
                markers.push(markerData);
            }
            return markers;
        };
    }();
    var ProjectInterface = function() {
        function registerComposition(comp) {
            this.compositions.push(comp);
        }
        return function() {
            function _thisProjectFunction(name) {
                var i = 0;
                var len = this.compositions.length;
                while(i < len){
                    if (this.compositions[i].data && this.compositions[i].data.nm === name) {
                        if (this.compositions[i].prepareFrame && this.compositions[i].data.xt) this.compositions[i].prepareFrame(this.currentFrame);
                        return this.compositions[i].compInterface;
                    }
                    i += 1;
                }
                return null;
            }
            _thisProjectFunction.compositions = [];
            _thisProjectFunction.currentFrame = 0;
            _thisProjectFunction.registerComposition = registerComposition;
            return _thisProjectFunction;
        };
    }();
    var renderers = {};
    var registerRenderer = function registerRenderer(key, value) {
        renderers[key] = value;
    };
    function getRenderer(key) {
        return renderers[key];
    }
    function getRegisteredRenderer() {
        // Returns canvas by default for compatibility
        if (renderers.canvas) return 'canvas';
         // Returns any renderer that is registered
        for(var key in renderers){
            if (renderers[key]) return key;
        }
        return '';
    }
    function _typeof$4(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$4 = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof$4 = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof$4(obj);
    }
    var AnimationItem = function AnimationItem() {
        this._cbs = [];
        this.name = '';
        this.path = '';
        this.isLoaded = false;
        this.currentFrame = 0;
        this.currentRawFrame = 0;
        this.firstFrame = 0;
        this.totalFrames = 0;
        this.frameRate = 0;
        this.frameMult = 0;
        this.playSpeed = 1;
        this.playDirection = 1;
        this.playCount = 0;
        this.animationData = {};
        this.assets = [];
        this.isPaused = true;
        this.autoplay = false;
        this.loop = true;
        this.renderer = null;
        this.animationID = createElementID();
        this.assetsPath = '';
        this.timeCompleted = 0;
        this.segmentPos = 0;
        this.isSubframeEnabled = getSubframeEnabled();
        this.segments = [];
        this._idle = true;
        this._completedLoop = false;
        this.projectInterface = ProjectInterface();
        this.imagePreloader = new ImagePreloader();
        this.audioController = audioControllerFactory();
        this.markers = [];
        this.configAnimation = this.configAnimation.bind(this);
        this.onSetupError = this.onSetupError.bind(this);
        this.onSegmentComplete = this.onSegmentComplete.bind(this);
        this.drawnFrameEvent = new BMEnterFrameEvent('drawnFrame', 0, 0, 0);
        this.expressionsPlugin = getExpressionsPlugin();
    };
    extendPrototype([
        BaseEvent
    ], AnimationItem);
    AnimationItem.prototype.setParams = function(params) {
        if (params.wrapper || params.container) this.wrapper = params.wrapper || params.container;
        var animType = 'svg';
        if (params.animType) animType = params.animType;
        else if (params.renderer) animType = params.renderer;
        var RendererClass = getRenderer(animType);
        this.renderer = new RendererClass(this, params.rendererSettings);
        this.imagePreloader.setCacheType(animType, this.renderer.globalData.defs);
        this.renderer.setProjectInterface(this.projectInterface);
        this.animType = animType;
        if (params.loop === '' || params.loop === null || params.loop === undefined || params.loop === true) this.loop = true;
        else if (params.loop === false) this.loop = false;
        else this.loop = parseInt(params.loop, 10);
        this.autoplay = 'autoplay' in params ? params.autoplay : true;
        this.name = params.name ? params.name : '';
        this.autoloadSegments = Object.prototype.hasOwnProperty.call(params, 'autoloadSegments') ? params.autoloadSegments : true;
        this.assetsPath = params.assetsPath;
        this.initialSegment = params.initialSegment;
        if (params.audioFactory) this.audioController.setAudioFactory(params.audioFactory);
        if (params.animationData) this.setupAnimation(params.animationData);
        else if (params.path) {
            if (params.path.lastIndexOf('\\') !== -1) this.path = params.path.substr(0, params.path.lastIndexOf('\\') + 1);
            else this.path = params.path.substr(0, params.path.lastIndexOf('/') + 1);
            this.fileName = params.path.substr(params.path.lastIndexOf('/') + 1);
            this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf('.json'));
            dataManager.loadAnimation(params.path, this.configAnimation, this.onSetupError);
        }
    };
    AnimationItem.prototype.onSetupError = function() {
        this.trigger('data_failed');
    };
    AnimationItem.prototype.setupAnimation = function(data) {
        dataManager.completeAnimation(data, this.configAnimation);
    };
    AnimationItem.prototype.setData = function(wrapper, animationData) {
        if (animationData) {
            if (_typeof$4(animationData) !== 'object') animationData = JSON.parse(animationData);
        }
        var params = {
            wrapper: wrapper,
            animationData: animationData
        };
        var wrapperAttributes = wrapper.attributes;
        params.path = wrapperAttributes.getNamedItem('data-animation-path') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-animation-path').value : wrapperAttributes.getNamedItem('data-bm-path') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-path').value : wrapperAttributes.getNamedItem('bm-path') ? wrapperAttributes.getNamedItem('bm-path').value : '';
        params.animType = wrapperAttributes.getNamedItem('data-anim-type') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-anim-type').value : wrapperAttributes.getNamedItem('data-bm-type') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-type').value : wrapperAttributes.getNamedItem('bm-type') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('bm-type').value : wrapperAttributes.getNamedItem('data-bm-renderer') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-renderer').value : wrapperAttributes.getNamedItem('bm-renderer') ? wrapperAttributes.getNamedItem('bm-renderer').value : getRegisteredRenderer() || 'canvas';
        var loop = wrapperAttributes.getNamedItem('data-anim-loop') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-anim-loop').value : wrapperAttributes.getNamedItem('data-bm-loop') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-loop').value : wrapperAttributes.getNamedItem('bm-loop') ? wrapperAttributes.getNamedItem('bm-loop').value : '';
        if (loop === 'false') params.loop = false;
        else if (loop === 'true') params.loop = true;
        else if (loop !== '') params.loop = parseInt(loop, 10);
        var autoplay = wrapperAttributes.getNamedItem('data-anim-autoplay') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-anim-autoplay').value : wrapperAttributes.getNamedItem('data-bm-autoplay') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-autoplay').value : wrapperAttributes.getNamedItem('bm-autoplay') ? wrapperAttributes.getNamedItem('bm-autoplay').value : true;
        params.autoplay = autoplay !== 'false';
        params.name = wrapperAttributes.getNamedItem('data-name') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-name').value : wrapperAttributes.getNamedItem('data-bm-name') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-name').value : wrapperAttributes.getNamedItem('bm-name') ? wrapperAttributes.getNamedItem('bm-name').value : '';
        var prerender = wrapperAttributes.getNamedItem('data-anim-prerender') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-anim-prerender').value : wrapperAttributes.getNamedItem('data-bm-prerender') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-prerender').value : wrapperAttributes.getNamedItem('bm-prerender') ? wrapperAttributes.getNamedItem('bm-prerender').value : '';
        if (prerender === 'false') params.prerender = false;
        if (!params.path) this.trigger('destroy');
        else this.setParams(params);
    };
    AnimationItem.prototype.includeLayers = function(data) {
        if (data.op > this.animationData.op) {
            this.animationData.op = data.op;
            this.totalFrames = Math.floor(data.op - this.animationData.ip);
        }
        var layers = this.animationData.layers;
        var i;
        var len = layers.length;
        var newLayers = data.layers;
        var j;
        var jLen = newLayers.length;
        for(j = 0; j < jLen; j += 1){
            i = 0;
            while(i < len){
                if (layers[i].id === newLayers[j].id) {
                    layers[i] = newLayers[j];
                    break;
                }
                i += 1;
            }
        }
        if (data.chars || data.fonts) {
            this.renderer.globalData.fontManager.addChars(data.chars);
            this.renderer.globalData.fontManager.addFonts(data.fonts, this.renderer.globalData.defs);
        }
        if (data.assets) {
            len = data.assets.length;
            for(i = 0; i < len; i += 1)this.animationData.assets.push(data.assets[i]);
        }
        this.animationData.__complete = false;
        dataManager.completeAnimation(this.animationData, this.onSegmentComplete);
    };
    AnimationItem.prototype.onSegmentComplete = function(data) {
        this.animationData = data;
        var expressionsPlugin = getExpressionsPlugin();
        if (expressionsPlugin) expressionsPlugin.initExpressions(this);
        this.loadNextSegment();
    };
    AnimationItem.prototype.loadNextSegment = function() {
        var segments = this.animationData.segments;
        if (!segments || segments.length === 0 || !this.autoloadSegments) {
            this.trigger('data_ready');
            this.timeCompleted = this.totalFrames;
            return;
        }
        var segment = segments.shift();
        this.timeCompleted = segment.time * this.frameRate;
        var segmentPath = this.path + this.fileName + '_' + this.segmentPos + '.json';
        this.segmentPos += 1;
        dataManager.loadData(segmentPath, this.includeLayers.bind(this), (function() {
            this.trigger('data_failed');
        }).bind(this));
    };
    AnimationItem.prototype.loadSegments = function() {
        var segments = this.animationData.segments;
        if (!segments) this.timeCompleted = this.totalFrames;
        this.loadNextSegment();
    };
    AnimationItem.prototype.imagesLoaded = function() {
        this.trigger('loaded_images');
        this.checkLoaded();
    };
    AnimationItem.prototype.preloadImages = function() {
        this.imagePreloader.setAssetsPath(this.assetsPath);
        this.imagePreloader.setPath(this.path);
        this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
    };
    AnimationItem.prototype.configAnimation = function(animData) {
        if (!this.renderer) return;
        try {
            this.animationData = animData;
            if (this.initialSegment) {
                this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]);
                this.firstFrame = Math.round(this.initialSegment[0]);
            } else {
                this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip);
                this.firstFrame = Math.round(this.animationData.ip);
            }
            this.renderer.configAnimation(animData);
            if (!animData.assets) animData.assets = [];
            this.assets = this.animationData.assets;
            this.frameRate = this.animationData.fr;
            this.frameMult = this.animationData.fr / 1000;
            this.renderer.searchExtraCompositions(animData.assets);
            this.markers = markerParser(animData.markers || []);
            this.trigger('config_ready');
            this.preloadImages();
            this.loadSegments();
            this.updaFrameModifier();
            this.waitForFontsLoaded();
            if (this.isPaused) this.audioController.pause();
        } catch (error) {
            this.triggerConfigError(error);
        }
    };
    AnimationItem.prototype.waitForFontsLoaded = function() {
        if (!this.renderer) return;
        if (this.renderer.globalData.fontManager.isLoaded) this.checkLoaded();
        else setTimeout(this.waitForFontsLoaded.bind(this), 20);
    };
    AnimationItem.prototype.checkLoaded = function() {
        if (!this.isLoaded && this.renderer.globalData.fontManager.isLoaded && (this.imagePreloader.loadedImages() || this.renderer.rendererType !== 'canvas') && this.imagePreloader.loadedFootages()) {
            this.isLoaded = true;
            var expressionsPlugin = getExpressionsPlugin();
            if (expressionsPlugin) expressionsPlugin.initExpressions(this);
            this.renderer.initItems();
            setTimeout((function() {
                this.trigger('DOMLoaded');
            }).bind(this), 0);
            this.gotoFrame();
            if (this.autoplay) this.play();
        }
    };
    AnimationItem.prototype.resize = function(width, height) {
        // Adding this validation for backwards compatibility in case an event object was being passed down
        var _width = typeof width === 'number' ? width : undefined;
        var _height = typeof height === 'number' ? height : undefined;
        this.renderer.updateContainerSize(_width, _height);
    };
    AnimationItem.prototype.setSubframe = function(flag) {
        this.isSubframeEnabled = !!flag;
    };
    AnimationItem.prototype.gotoFrame = function() {
        this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame; // eslint-disable-line no-bitwise
        if (this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted) this.currentFrame = this.timeCompleted;
        this.trigger('enterFrame');
        this.renderFrame();
        this.trigger('drawnFrame');
    };
    AnimationItem.prototype.renderFrame = function() {
        if (this.isLoaded === false || !this.renderer) return;
        try {
            if (this.expressionsPlugin) this.expressionsPlugin.resetFrame();
            this.renderer.renderFrame(this.currentFrame + this.firstFrame);
        } catch (error) {
            this.triggerRenderFrameError(error);
        }
    };
    AnimationItem.prototype.play = function(name) {
        if (name && this.name !== name) return;
        if (this.isPaused === true) {
            this.isPaused = false;
            this.trigger('_play');
            this.audioController.resume();
            if (this._idle) {
                this._idle = false;
                this.trigger('_active');
            }
        }
    };
    AnimationItem.prototype.pause = function(name) {
        if (name && this.name !== name) return;
        if (this.isPaused === false) {
            this.isPaused = true;
            this.trigger('_pause');
            this._idle = true;
            this.trigger('_idle');
            this.audioController.pause();
        }
    };
    AnimationItem.prototype.togglePause = function(name) {
        if (name && this.name !== name) return;
        if (this.isPaused === true) this.play();
        else this.pause();
    };
    AnimationItem.prototype.stop = function(name) {
        if (name && this.name !== name) return;
        this.pause();
        this.playCount = 0;
        this._completedLoop = false;
        this.setCurrentRawFrameValue(0);
    };
    AnimationItem.prototype.getMarkerData = function(markerName) {
        var marker;
        for(var i = 0; i < this.markers.length; i += 1){
            marker = this.markers[i];
            if (marker.payload && marker.payload.name === markerName) return marker;
        }
        return null;
    };
    AnimationItem.prototype.goToAndStop = function(value, isFrame, name) {
        if (name && this.name !== name) return;
        var numValue = Number(value);
        if (isNaN(numValue)) {
            var marker = this.getMarkerData(value);
            if (marker) this.goToAndStop(marker.time, true);
        } else if (isFrame) this.setCurrentRawFrameValue(value);
        else this.setCurrentRawFrameValue(value * this.frameModifier);
        this.pause();
    };
    AnimationItem.prototype.goToAndPlay = function(value, isFrame, name) {
        if (name && this.name !== name) return;
        var numValue = Number(value);
        if (isNaN(numValue)) {
            var marker = this.getMarkerData(value);
            if (marker) {
                if (!marker.duration) this.goToAndStop(marker.time, true);
                else this.playSegments([
                    marker.time,
                    marker.time + marker.duration
                ], true);
            }
        } else this.goToAndStop(numValue, isFrame, name);
        this.play();
    };
    AnimationItem.prototype.advanceTime = function(value) {
        if (this.isPaused === true || this.isLoaded === false) return;
        var nextValue = this.currentRawFrame + value * this.frameModifier;
        var _isComplete = false; // Checking if nextValue > totalFrames - 1 for addressing non looping and looping animations.
        // If animation won't loop, it should stop at totalFrames - 1. If it will loop it should complete the last frame and then loop.
        if (nextValue >= this.totalFrames - 1 && this.frameModifier > 0) {
            if (!this.loop || this.playCount === this.loop) {
                if (!this.checkSegments(nextValue > this.totalFrames ? nextValue % this.totalFrames : 0)) {
                    _isComplete = true;
                    nextValue = this.totalFrames - 1;
                }
            } else if (nextValue >= this.totalFrames) {
                this.playCount += 1;
                if (!this.checkSegments(nextValue % this.totalFrames)) {
                    this.setCurrentRawFrameValue(nextValue % this.totalFrames);
                    this._completedLoop = true;
                    this.trigger('loopComplete');
                }
            } else this.setCurrentRawFrameValue(nextValue);
        } else if (nextValue < 0) {
            if (!this.checkSegments(nextValue % this.totalFrames)) {
                if (this.loop && !(this.playCount-- <= 0 && this.loop !== true)) {
                    // eslint-disable-line no-plusplus
                    this.setCurrentRawFrameValue(this.totalFrames + nextValue % this.totalFrames);
                    if (!this._completedLoop) this._completedLoop = true;
                    else this.trigger('loopComplete');
                } else {
                    _isComplete = true;
                    nextValue = 0;
                }
            }
        } else this.setCurrentRawFrameValue(nextValue);
        if (_isComplete) {
            this.setCurrentRawFrameValue(nextValue);
            this.pause();
            this.trigger('complete');
        }
    };
    AnimationItem.prototype.adjustSegment = function(arr, offset) {
        this.playCount = 0;
        if (arr[1] < arr[0]) {
            if (this.frameModifier > 0) {
                if (this.playSpeed < 0) this.setSpeed(-this.playSpeed);
                else this.setDirection(-1);
            }
            this.totalFrames = arr[0] - arr[1];
            this.timeCompleted = this.totalFrames;
            this.firstFrame = arr[1];
            this.setCurrentRawFrameValue(this.totalFrames - 0.001 - offset);
        } else if (arr[1] > arr[0]) {
            if (this.frameModifier < 0) {
                if (this.playSpeed < 0) this.setSpeed(-this.playSpeed);
                else this.setDirection(1);
            }
            this.totalFrames = arr[1] - arr[0];
            this.timeCompleted = this.totalFrames;
            this.firstFrame = arr[0];
            this.setCurrentRawFrameValue(0.001 + offset);
        }
        this.trigger('segmentStart');
    };
    AnimationItem.prototype.setSegment = function(init, end) {
        var pendingFrame = -1;
        if (this.isPaused) {
            if (this.currentRawFrame + this.firstFrame < init) pendingFrame = init;
            else if (this.currentRawFrame + this.firstFrame > end) pendingFrame = end - init;
        }
        this.firstFrame = init;
        this.totalFrames = end - init;
        this.timeCompleted = this.totalFrames;
        if (pendingFrame !== -1) this.goToAndStop(pendingFrame, true);
    };
    AnimationItem.prototype.playSegments = function(arr, forceFlag) {
        if (forceFlag) this.segments.length = 0;
        if (_typeof$4(arr[0]) === 'object') {
            var i;
            var len = arr.length;
            for(i = 0; i < len; i += 1)this.segments.push(arr[i]);
        } else this.segments.push(arr);
        if (this.segments.length && forceFlag) this.adjustSegment(this.segments.shift(), 0);
        if (this.isPaused) this.play();
    };
    AnimationItem.prototype.resetSegments = function(forceFlag) {
        this.segments.length = 0;
        this.segments.push([
            this.animationData.ip,
            this.animationData.op
        ]);
        if (forceFlag) this.checkSegments(0);
    };
    AnimationItem.prototype.checkSegments = function(offset) {
        if (this.segments.length) {
            this.adjustSegment(this.segments.shift(), offset);
            return true;
        }
        return false;
    };
    AnimationItem.prototype.destroy = function(name) {
        if (name && this.name !== name || !this.renderer) return;
        this.renderer.destroy();
        this.imagePreloader.destroy();
        this.trigger('destroy');
        this._cbs = null;
        this.onEnterFrame = null;
        this.onLoopComplete = null;
        this.onComplete = null;
        this.onSegmentStart = null;
        this.onDestroy = null;
        this.renderer = null;
        this.expressionsPlugin = null;
        this.imagePreloader = null;
        this.projectInterface = null;
    };
    AnimationItem.prototype.setCurrentRawFrameValue = function(value) {
        this.currentRawFrame = value;
        this.gotoFrame();
    };
    AnimationItem.prototype.setSpeed = function(val) {
        this.playSpeed = val;
        this.updaFrameModifier();
    };
    AnimationItem.prototype.setDirection = function(val) {
        this.playDirection = val < 0 ? -1 : 1;
        this.updaFrameModifier();
    };
    AnimationItem.prototype.setLoop = function(isLooping) {
        this.loop = isLooping;
    };
    AnimationItem.prototype.setVolume = function(val, name) {
        if (name && this.name !== name) return;
        this.audioController.setVolume(val);
    };
    AnimationItem.prototype.getVolume = function() {
        return this.audioController.getVolume();
    };
    AnimationItem.prototype.mute = function(name) {
        if (name && this.name !== name) return;
        this.audioController.mute();
    };
    AnimationItem.prototype.unmute = function(name) {
        if (name && this.name !== name) return;
        this.audioController.unmute();
    };
    AnimationItem.prototype.updaFrameModifier = function() {
        this.frameModifier = this.frameMult * this.playSpeed * this.playDirection;
        this.audioController.setRate(this.playSpeed * this.playDirection);
    };
    AnimationItem.prototype.getPath = function() {
        return this.path;
    };
    AnimationItem.prototype.getAssetsPath = function(assetData) {
        var path = '';
        if (assetData.e) path = assetData.p;
        else if (this.assetsPath) {
            var imagePath = assetData.p;
            if (imagePath.indexOf('images/') !== -1) imagePath = imagePath.split('/')[1];
            path = this.assetsPath + imagePath;
        } else {
            path = this.path;
            path += assetData.u ? assetData.u : '';
            path += assetData.p;
        }
        return path;
    };
    AnimationItem.prototype.getAssetData = function(id) {
        var i = 0;
        var len = this.assets.length;
        while(i < len){
            if (id === this.assets[i].id) return this.assets[i];
            i += 1;
        }
        return null;
    };
    AnimationItem.prototype.hide = function() {
        this.renderer.hide();
    };
    AnimationItem.prototype.show = function() {
        this.renderer.show();
    };
    AnimationItem.prototype.getDuration = function(isFrame) {
        return isFrame ? this.totalFrames : this.totalFrames / this.frameRate;
    };
    AnimationItem.prototype.updateDocumentData = function(path, documentData, index) {
        try {
            var element = this.renderer.getElementByPath(path);
            element.updateDocumentData(documentData, index);
        } catch (error) {}
    };
    AnimationItem.prototype.trigger = function(name) {
        if (this._cbs && this._cbs[name]) switch(name){
            case 'enterFrame':
                this.triggerEvent(name, new BMEnterFrameEvent(name, this.currentFrame, this.totalFrames, this.frameModifier));
                break;
            case 'drawnFrame':
                this.drawnFrameEvent.currentTime = this.currentFrame;
                this.drawnFrameEvent.totalTime = this.totalFrames;
                this.drawnFrameEvent.direction = this.frameModifier;
                this.triggerEvent(name, this.drawnFrameEvent);
                break;
            case 'loopComplete':
                this.triggerEvent(name, new BMCompleteLoopEvent(name, this.loop, this.playCount, this.frameMult));
                break;
            case 'complete':
                this.triggerEvent(name, new BMCompleteEvent(name, this.frameMult));
                break;
            case 'segmentStart':
                this.triggerEvent(name, new BMSegmentStartEvent(name, this.firstFrame, this.totalFrames));
                break;
            case 'destroy':
                this.triggerEvent(name, new BMDestroyEvent(name, this));
                break;
            default:
                this.triggerEvent(name);
        }
        if (name === 'enterFrame' && this.onEnterFrame) this.onEnterFrame.call(this, new BMEnterFrameEvent(name, this.currentFrame, this.totalFrames, this.frameMult));
        if (name === 'loopComplete' && this.onLoopComplete) this.onLoopComplete.call(this, new BMCompleteLoopEvent(name, this.loop, this.playCount, this.frameMult));
        if (name === 'complete' && this.onComplete) this.onComplete.call(this, new BMCompleteEvent(name, this.frameMult));
        if (name === 'segmentStart' && this.onSegmentStart) this.onSegmentStart.call(this, new BMSegmentStartEvent(name, this.firstFrame, this.totalFrames));
        if (name === 'destroy' && this.onDestroy) this.onDestroy.call(this, new BMDestroyEvent(name, this));
    };
    AnimationItem.prototype.triggerRenderFrameError = function(nativeError) {
        var error = new BMRenderFrameErrorEvent(nativeError, this.currentFrame);
        this.triggerEvent('error', error);
        if (this.onError) this.onError.call(this, error);
    };
    AnimationItem.prototype.triggerConfigError = function(nativeError) {
        var error = new BMConfigErrorEvent(nativeError, this.currentFrame);
        this.triggerEvent('error', error);
        if (this.onError) this.onError.call(this, error);
    };
    var animationManager = function() {
        var moduleOb = {};
        var registeredAnimations = [];
        var initTime = 0;
        var len = 0;
        var playingAnimationsNum = 0;
        var _stopped = true;
        var _isFrozen = false;
        function removeElement(ev) {
            var i = 0;
            var animItem = ev.target;
            while(i < len){
                if (registeredAnimations[i].animation === animItem) {
                    registeredAnimations.splice(i, 1);
                    i -= 1;
                    len -= 1;
                    if (!animItem.isPaused) subtractPlayingCount();
                }
                i += 1;
            }
        }
        function registerAnimation(element, animationData) {
            if (!element) return null;
            var i = 0;
            while(i < len){
                if (registeredAnimations[i].elem === element && registeredAnimations[i].elem !== null) return registeredAnimations[i].animation;
                i += 1;
            }
            var animItem = new AnimationItem();
            setupAnimation(animItem, element);
            animItem.setData(element, animationData);
            return animItem;
        }
        function getRegisteredAnimations() {
            var i;
            var lenAnims = registeredAnimations.length;
            var animations = [];
            for(i = 0; i < lenAnims; i += 1)animations.push(registeredAnimations[i].animation);
            return animations;
        }
        function addPlayingCount() {
            playingAnimationsNum += 1;
            activate();
        }
        function subtractPlayingCount() {
            playingAnimationsNum -= 1;
        }
        function setupAnimation(animItem, element) {
            animItem.addEventListener('destroy', removeElement);
            animItem.addEventListener('_active', addPlayingCount);
            animItem.addEventListener('_idle', subtractPlayingCount);
            registeredAnimations.push({
                elem: element,
                animation: animItem
            });
            len += 1;
        }
        function loadAnimation(params) {
            var animItem = new AnimationItem();
            setupAnimation(animItem, null);
            animItem.setParams(params);
            return animItem;
        }
        function setSpeed(val, animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.setSpeed(val, animation);
        }
        function setDirection(val, animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.setDirection(val, animation);
        }
        function play(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.play(animation);
        }
        function resume(nowTime) {
            var elapsedTime = nowTime - initTime;
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.advanceTime(elapsedTime);
            initTime = nowTime;
            if (playingAnimationsNum && !_isFrozen) window.requestAnimationFrame(resume);
            else _stopped = true;
        }
        function first(nowTime) {
            initTime = nowTime;
            window.requestAnimationFrame(resume);
        }
        function pause(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.pause(animation);
        }
        function goToAndStop(value, isFrame, animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.goToAndStop(value, isFrame, animation);
        }
        function stop(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.stop(animation);
        }
        function togglePause(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.togglePause(animation);
        }
        function destroy(animation) {
            var i;
            for(i = len - 1; i >= 0; i -= 1)registeredAnimations[i].animation.destroy(animation);
        }
        function searchAnimations(animationData, standalone, renderer) {
            var animElements = [].concat([].slice.call(document.getElementsByClassName('lottie')), [].slice.call(document.getElementsByClassName('bodymovin')));
            var i;
            var lenAnims = animElements.length;
            for(i = 0; i < lenAnims; i += 1){
                if (renderer) animElements[i].setAttribute('data-bm-type', renderer);
                registerAnimation(animElements[i], animationData);
            }
            if (standalone && lenAnims === 0) {
                if (!renderer) renderer = 'svg';
                var body = document.getElementsByTagName('body')[0];
                body.innerText = '';
                var div = createTag('div');
                div.style.width = '100%';
                div.style.height = '100%';
                div.setAttribute('data-bm-type', renderer);
                body.appendChild(div);
                registerAnimation(div, animationData);
            }
        }
        function resize() {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.resize();
        }
        function activate() {
            if (!_isFrozen && playingAnimationsNum) {
                if (_stopped) {
                    window.requestAnimationFrame(first);
                    _stopped = false;
                }
            }
        }
        function freeze() {
            _isFrozen = true;
        }
        function unfreeze() {
            _isFrozen = false;
            activate();
        }
        function setVolume(val, animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.setVolume(val, animation);
        }
        function mute(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.mute(animation);
        }
        function unmute(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.unmute(animation);
        }
        moduleOb.registerAnimation = registerAnimation;
        moduleOb.loadAnimation = loadAnimation;
        moduleOb.setSpeed = setSpeed;
        moduleOb.setDirection = setDirection;
        moduleOb.play = play;
        moduleOb.pause = pause;
        moduleOb.stop = stop;
        moduleOb.togglePause = togglePause;
        moduleOb.searchAnimations = searchAnimations;
        moduleOb.resize = resize; // moduleOb.start = start;
        moduleOb.goToAndStop = goToAndStop;
        moduleOb.destroy = destroy;
        moduleOb.freeze = freeze;
        moduleOb.unfreeze = unfreeze;
        moduleOb.setVolume = setVolume;
        moduleOb.mute = mute;
        moduleOb.unmute = unmute;
        moduleOb.getRegisteredAnimations = getRegisteredAnimations;
        return moduleOb;
    }();
    /* eslint-disable */ var BezierFactory = function() {
        /**
       * BezierEasing - use bezier curve for transition easing function
       * by Gaëtan Renaudeau 2014 - 2015 – MIT License
       *
       * Credits: is based on Firefox's nsSMILKeySpline.cpp
       * Usage:
       * var spline = BezierEasing([ 0.25, 0.1, 0.25, 1.0 ])
       * spline.get(x) => returns the easing value | x must be in [0, 1] range
       *
       */ var ob = {};
        ob.getBezierEasing = getBezierEasing;
        var beziers = {};
        function getBezierEasing(a, b, c, d, nm) {
            var str = nm || ('bez_' + a + '_' + b + '_' + c + '_' + d).replace(/\./g, 'p');
            if (beziers[str]) return beziers[str];
            var bezEasing = new BezierEasing([
                a,
                b,
                c,
                d
            ]);
            beziers[str] = bezEasing;
            return bezEasing;
        } // These values are established by empiricism with tests (tradeoff: performance VS precision)
        var NEWTON_ITERATIONS = 4;
        var NEWTON_MIN_SLOPE = 0.001;
        var SUBDIVISION_PRECISION = 0.0000001;
        var SUBDIVISION_MAX_ITERATIONS = 10;
        var kSplineTableSize = 11;
        var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
        var float32ArraySupported = typeof Float32Array === 'function';
        function A(aA1, aA2) {
            return 1.0 - 3.0 * aA2 + 3.0 * aA1;
        }
        function B(aA1, aA2) {
            return 3.0 * aA2 - 6.0 * aA1;
        }
        function C(aA1) {
            return 3.0 * aA1;
        } // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
        function calcBezier(aT, aA1, aA2) {
            return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
        } // Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
        function getSlope(aT, aA1, aA2) {
            return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
        }
        function binarySubdivide(aX, aA, aB, mX1, mX2) {
            var currentX, currentT, i = 0;
            do {
                currentT = aA + (aB - aA) / 2.0;
                currentX = calcBezier(currentT, mX1, mX2) - aX;
                if (currentX > 0.0) aB = currentT;
                else aA = currentT;
            }while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
            return currentT;
        }
        function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
            for(var i = 0; i < NEWTON_ITERATIONS; ++i){
                var currentSlope = getSlope(aGuessT, mX1, mX2);
                if (currentSlope === 0.0) return aGuessT;
                var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
                aGuessT -= currentX / currentSlope;
            }
            return aGuessT;
        }
        /**
       * points is an array of [ mX1, mY1, mX2, mY2 ]
       */ function BezierEasing(points) {
            this._p = points;
            this._mSampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
            this._precomputed = false;
            this.get = this.get.bind(this);
        }
        BezierEasing.prototype = {
            get: function get(x) {
                var mX1 = this._p[0], mY1 = this._p[1], mX2 = this._p[2], mY2 = this._p[3];
                if (!this._precomputed) this._precompute();
                if (mX1 === mY1 && mX2 === mY2) return x; // linear
                // Because JavaScript number are imprecise, we should guarantee the extremes are right.
                if (x === 0) return 0;
                if (x === 1) return 1;
                return calcBezier(this._getTForX(x), mY1, mY2);
            },
            // Private part
            _precompute: function _precompute() {
                var mX1 = this._p[0], mY1 = this._p[1], mX2 = this._p[2], mY2 = this._p[3];
                this._precomputed = true;
                if (mX1 !== mY1 || mX2 !== mY2) this._calcSampleValues();
            },
            _calcSampleValues: function _calcSampleValues() {
                var mX1 = this._p[0], mX2 = this._p[2];
                for(var i = 0; i < kSplineTableSize; ++i)this._mSampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
            },
            /**
           * getTForX chose the fastest heuristic to determine the percentage value precisely from a given X projection.
           */ _getTForX: function _getTForX(aX) {
                var mX1 = this._p[0], mX2 = this._p[2], mSampleValues = this._mSampleValues;
                var intervalStart = 0.0;
                var currentSample = 1;
                var lastSample = kSplineTableSize - 1;
                for(; currentSample !== lastSample && mSampleValues[currentSample] <= aX; ++currentSample)intervalStart += kSampleStepSize;
                --currentSample; // Interpolate to provide an initial guess for t
                var dist = (aX - mSampleValues[currentSample]) / (mSampleValues[currentSample + 1] - mSampleValues[currentSample]);
                var guessForT = intervalStart + dist * kSampleStepSize;
                var initialSlope = getSlope(guessForT, mX1, mX2);
                if (initialSlope >= NEWTON_MIN_SLOPE) return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
                if (initialSlope === 0.0) return guessForT;
                return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
            }
        };
        return ob;
    }();
    var pooling = function() {
        function _double(arr) {
            return arr.concat(createSizedArray(arr.length));
        }
        return {
            "double": _double
        };
    }();
    var poolFactory = function() {
        return function(initialLength, _create, _release) {
            var _length = 0;
            var _maxLength = initialLength;
            var pool = createSizedArray(_maxLength);
            var ob = {
                newElement: newElement,
                release: release
            };
            function newElement() {
                var element;
                if (_length) {
                    _length -= 1;
                    element = pool[_length];
                } else element = _create();
                return element;
            }
            function release(element) {
                if (_length === _maxLength) {
                    pool = pooling["double"](pool);
                    _maxLength *= 2;
                }
                if (_release) _release(element);
                pool[_length] = element;
                _length += 1;
            }
            return ob;
        };
    }();
    var bezierLengthPool = function() {
        function create() {
            return {
                addedLength: 0,
                percents: createTypedArray('float32', getDefaultCurveSegments()),
                lengths: createTypedArray('float32', getDefaultCurveSegments())
            };
        }
        return poolFactory(8, create);
    }();
    var segmentsLengthPool = function() {
        function create() {
            return {
                lengths: [],
                totalLength: 0
            };
        }
        function release(element) {
            var i;
            var len = element.lengths.length;
            for(i = 0; i < len; i += 1)bezierLengthPool.release(element.lengths[i]);
            element.lengths.length = 0;
        }
        return poolFactory(8, create, release);
    }();
    function bezFunction() {
        var math = Math;
        function pointOnLine2D(x1, y1, x2, y2, x3, y3) {
            var det1 = x1 * y2 + y1 * x3 + x2 * y3 - x3 * y2 - y3 * x1 - x2 * y1;
            return det1 > -0.001 && det1 < 0.001;
        }
        function pointOnLine3D(x1, y1, z1, x2, y2, z2, x3, y3, z3) {
            if (z1 === 0 && z2 === 0 && z3 === 0) return pointOnLine2D(x1, y1, x2, y2, x3, y3);
            var dist1 = math.sqrt(math.pow(x2 - x1, 2) + math.pow(y2 - y1, 2) + math.pow(z2 - z1, 2));
            var dist2 = math.sqrt(math.pow(x3 - x1, 2) + math.pow(y3 - y1, 2) + math.pow(z3 - z1, 2));
            var dist3 = math.sqrt(math.pow(x3 - x2, 2) + math.pow(y3 - y2, 2) + math.pow(z3 - z2, 2));
            var diffDist;
            if (dist1 > dist2) {
                if (dist1 > dist3) diffDist = dist1 - dist2 - dist3;
                else diffDist = dist3 - dist2 - dist1;
            } else if (dist3 > dist2) diffDist = dist3 - dist2 - dist1;
            else diffDist = dist2 - dist1 - dist3;
            return diffDist > -0.0001 && diffDist < 0.0001;
        }
        var getBezierLength = function() {
            return function(pt1, pt2, pt3, pt4) {
                var curveSegments = getDefaultCurveSegments();
                var k;
                var i;
                var len;
                var ptCoord;
                var perc;
                var addedLength = 0;
                var ptDistance;
                var point = [];
                var lastPoint = [];
                var lengthData = bezierLengthPool.newElement();
                len = pt3.length;
                for(k = 0; k < curveSegments; k += 1){
                    perc = k / (curveSegments - 1);
                    ptDistance = 0;
                    for(i = 0; i < len; i += 1){
                        ptCoord = bmPow(1 - perc, 3) * pt1[i] + 3 * bmPow(1 - perc, 2) * perc * pt3[i] + 3 * (1 - perc) * bmPow(perc, 2) * pt4[i] + bmPow(perc, 3) * pt2[i];
                        point[i] = ptCoord;
                        if (lastPoint[i] !== null) ptDistance += bmPow(point[i] - lastPoint[i], 2);
                        lastPoint[i] = point[i];
                    }
                    if (ptDistance) {
                        ptDistance = bmSqrt(ptDistance);
                        addedLength += ptDistance;
                    }
                    lengthData.percents[k] = perc;
                    lengthData.lengths[k] = addedLength;
                }
                lengthData.addedLength = addedLength;
                return lengthData;
            };
        }();
        function getSegmentsLength(shapeData) {
            var segmentsLength = segmentsLengthPool.newElement();
            var closed = shapeData.c;
            var pathV = shapeData.v;
            var pathO = shapeData.o;
            var pathI = shapeData.i;
            var i;
            var len = shapeData._length;
            var lengths = segmentsLength.lengths;
            var totalLength = 0;
            for(i = 0; i < len - 1; i += 1){
                lengths[i] = getBezierLength(pathV[i], pathV[i + 1], pathO[i], pathI[i + 1]);
                totalLength += lengths[i].addedLength;
            }
            if (closed && len) {
                lengths[i] = getBezierLength(pathV[i], pathV[0], pathO[i], pathI[0]);
                totalLength += lengths[i].addedLength;
            }
            segmentsLength.totalLength = totalLength;
            return segmentsLength;
        }
        function BezierData(length) {
            this.segmentLength = 0;
            this.points = new Array(length);
        }
        function PointData(partial, point) {
            this.partialLength = partial;
            this.point = point;
        }
        var buildBezierData = function() {
            var storedData = {};
            return function(pt1, pt2, pt3, pt4) {
                var bezierName = (pt1[0] + '_' + pt1[1] + '_' + pt2[0] + '_' + pt2[1] + '_' + pt3[0] + '_' + pt3[1] + '_' + pt4[0] + '_' + pt4[1]).replace(/\./g, 'p');
                if (!storedData[bezierName]) {
                    var curveSegments = getDefaultCurveSegments();
                    var k;
                    var i;
                    var len;
                    var ptCoord;
                    var perc;
                    var addedLength = 0;
                    var ptDistance;
                    var point;
                    var lastPoint = null;
                    if (pt1.length === 2 && (pt1[0] !== pt2[0] || pt1[1] !== pt2[1]) && pointOnLine2D(pt1[0], pt1[1], pt2[0], pt2[1], pt1[0] + pt3[0], pt1[1] + pt3[1]) && pointOnLine2D(pt1[0], pt1[1], pt2[0], pt2[1], pt2[0] + pt4[0], pt2[1] + pt4[1])) curveSegments = 2;
                    var bezierData = new BezierData(curveSegments);
                    len = pt3.length;
                    for(k = 0; k < curveSegments; k += 1){
                        point = createSizedArray(len);
                        perc = k / (curveSegments - 1);
                        ptDistance = 0;
                        for(i = 0; i < len; i += 1){
                            ptCoord = bmPow(1 - perc, 3) * pt1[i] + 3 * bmPow(1 - perc, 2) * perc * (pt1[i] + pt3[i]) + 3 * (1 - perc) * bmPow(perc, 2) * (pt2[i] + pt4[i]) + bmPow(perc, 3) * pt2[i];
                            point[i] = ptCoord;
                            if (lastPoint !== null) ptDistance += bmPow(point[i] - lastPoint[i], 2);
                        }
                        ptDistance = bmSqrt(ptDistance);
                        addedLength += ptDistance;
                        bezierData.points[k] = new PointData(ptDistance, point);
                        lastPoint = point;
                    }
                    bezierData.segmentLength = addedLength;
                    storedData[bezierName] = bezierData;
                }
                return storedData[bezierName];
            };
        }();
        function getDistancePerc(perc, bezierData) {
            var percents = bezierData.percents;
            var lengths = bezierData.lengths;
            var len = percents.length;
            var initPos = bmFloor((len - 1) * perc);
            var lengthPos = perc * bezierData.addedLength;
            var lPerc = 0;
            if (initPos === len - 1 || initPos === 0 || lengthPos === lengths[initPos]) return percents[initPos];
            var dir = lengths[initPos] > lengthPos ? -1 : 1;
            var flag = true;
            while(flag){
                if (lengths[initPos] <= lengthPos && lengths[initPos + 1] > lengthPos) {
                    lPerc = (lengthPos - lengths[initPos]) / (lengths[initPos + 1] - lengths[initPos]);
                    flag = false;
                } else initPos += dir;
                if (initPos < 0 || initPos >= len - 1) {
                    // FIX for TypedArrays that don't store floating point values with enough accuracy
                    if (initPos === len - 1) return percents[initPos];
                    flag = false;
                }
            }
            return percents[initPos] + (percents[initPos + 1] - percents[initPos]) * lPerc;
        }
        function getPointInSegment(pt1, pt2, pt3, pt4, percent, bezierData) {
            var t1 = getDistancePerc(percent, bezierData);
            var u1 = 1 - t1;
            var ptX = math.round((u1 * u1 * u1 * pt1[0] + (t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1) * pt3[0] + (t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1) * pt4[0] + t1 * t1 * t1 * pt2[0]) * 1000) / 1000;
            var ptY = math.round((u1 * u1 * u1 * pt1[1] + (t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1) * pt3[1] + (t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1) * pt4[1] + t1 * t1 * t1 * pt2[1]) * 1000) / 1000;
            return [
                ptX,
                ptY
            ];
        }
        var bezierSegmentPoints = createTypedArray('float32', 8);
        function getNewSegment(pt1, pt2, pt3, pt4, startPerc, endPerc, bezierData) {
            if (startPerc < 0) startPerc = 0;
            else if (startPerc > 1) startPerc = 1;
            var t0 = getDistancePerc(startPerc, bezierData);
            endPerc = endPerc > 1 ? 1 : endPerc;
            var t1 = getDistancePerc(endPerc, bezierData);
            var i;
            var len = pt1.length;
            var u0 = 1 - t0;
            var u1 = 1 - t1;
            var u0u0u0 = u0 * u0 * u0;
            var t0u0u0_3 = t0 * u0 * u0 * 3; // eslint-disable-line camelcase
            var t0t0u0_3 = t0 * t0 * u0 * 3; // eslint-disable-line camelcase
            var t0t0t0 = t0 * t0 * t0; //
            var u0u0u1 = u0 * u0 * u1;
            var t0u0u1_3 = t0 * u0 * u1 + u0 * t0 * u1 + u0 * u0 * t1; // eslint-disable-line camelcase
            var t0t0u1_3 = t0 * t0 * u1 + u0 * t0 * t1 + t0 * u0 * t1; // eslint-disable-line camelcase
            var t0t0t1 = t0 * t0 * t1; //
            var u0u1u1 = u0 * u1 * u1;
            var t0u1u1_3 = t0 * u1 * u1 + u0 * t1 * u1 + u0 * u1 * t1; // eslint-disable-line camelcase
            var t0t1u1_3 = t0 * t1 * u1 + u0 * t1 * t1 + t0 * u1 * t1; // eslint-disable-line camelcase
            var t0t1t1 = t0 * t1 * t1; //
            var u1u1u1 = u1 * u1 * u1;
            var t1u1u1_3 = t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1; // eslint-disable-line camelcase
            var t1t1u1_3 = t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1; // eslint-disable-line camelcase
            var t1t1t1 = t1 * t1 * t1;
            for(i = 0; i < len; i += 1){
                bezierSegmentPoints[i * 4] = math.round((u0u0u0 * pt1[i] + t0u0u0_3 * pt3[i] + t0t0u0_3 * pt4[i] + t0t0t0 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
                bezierSegmentPoints[i * 4 + 1] = math.round((u0u0u1 * pt1[i] + t0u0u1_3 * pt3[i] + t0t0u1_3 * pt4[i] + t0t0t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
                bezierSegmentPoints[i * 4 + 2] = math.round((u0u1u1 * pt1[i] + t0u1u1_3 * pt3[i] + t0t1u1_3 * pt4[i] + t0t1t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
                bezierSegmentPoints[i * 4 + 3] = math.round((u1u1u1 * pt1[i] + t1u1u1_3 * pt3[i] + t1t1u1_3 * pt4[i] + t1t1t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
            }
            return bezierSegmentPoints;
        }
        return {
            getSegmentsLength: getSegmentsLength,
            getNewSegment: getNewSegment,
            getPointInSegment: getPointInSegment,
            buildBezierData: buildBezierData,
            pointOnLine2D: pointOnLine2D,
            pointOnLine3D: pointOnLine3D
        };
    }
    var bez = bezFunction();
    var initFrame = initialDefaultFrame;
    var mathAbs = Math.abs;
    function interpolateValue(frameNum, caching) {
        var offsetTime = this.offsetTime;
        var newValue;
        if (this.propType === 'multidimensional') newValue = createTypedArray('float32', this.pv.length);
        var iterationIndex = caching.lastIndex;
        var i = iterationIndex;
        var len = this.keyframes.length - 1;
        var flag = true;
        var keyData;
        var nextKeyData;
        var keyframeMetadata;
        while(flag){
            keyData = this.keyframes[i];
            nextKeyData = this.keyframes[i + 1];
            if (i === len - 1 && frameNum >= nextKeyData.t - offsetTime) {
                if (keyData.h) keyData = nextKeyData;
                iterationIndex = 0;
                break;
            }
            if (nextKeyData.t - offsetTime > frameNum) {
                iterationIndex = i;
                break;
            }
            if (i < len - 1) i += 1;
            else {
                iterationIndex = 0;
                flag = false;
            }
        }
        keyframeMetadata = this.keyframesMetadata[i] || {};
        var k;
        var kLen;
        var perc;
        var jLen;
        var j;
        var fnc;
        var nextKeyTime = nextKeyData.t - offsetTime;
        var keyTime = keyData.t - offsetTime;
        var endValue;
        if (keyData.to) {
            if (!keyframeMetadata.bezierData) keyframeMetadata.bezierData = bez.buildBezierData(keyData.s, nextKeyData.s || keyData.e, keyData.to, keyData.ti);
            var bezierData = keyframeMetadata.bezierData;
            if (frameNum >= nextKeyTime || frameNum < keyTime) {
                var ind = frameNum >= nextKeyTime ? bezierData.points.length - 1 : 0;
                kLen = bezierData.points[ind].point.length;
                for(k = 0; k < kLen; k += 1)newValue[k] = bezierData.points[ind].point[k];
                 // caching._lastKeyframeIndex = -1;
            } else {
                if (keyframeMetadata.__fnct) fnc = keyframeMetadata.__fnct;
                else {
                    fnc = BezierFactory.getBezierEasing(keyData.o.x, keyData.o.y, keyData.i.x, keyData.i.y, keyData.n).get;
                    keyframeMetadata.__fnct = fnc;
                }
                perc = fnc((frameNum - keyTime) / (nextKeyTime - keyTime));
                var distanceInLine = bezierData.segmentLength * perc;
                var segmentPerc;
                var addedLength = caching.lastFrame < frameNum && caching._lastKeyframeIndex === i ? caching._lastAddedLength : 0;
                j = caching.lastFrame < frameNum && caching._lastKeyframeIndex === i ? caching._lastPoint : 0;
                flag = true;
                jLen = bezierData.points.length;
                while(flag){
                    addedLength += bezierData.points[j].partialLength;
                    if (distanceInLine === 0 || perc === 0 || j === bezierData.points.length - 1) {
                        kLen = bezierData.points[j].point.length;
                        for(k = 0; k < kLen; k += 1)newValue[k] = bezierData.points[j].point[k];
                        break;
                    } else if (distanceInLine >= addedLength && distanceInLine < addedLength + bezierData.points[j + 1].partialLength) {
                        segmentPerc = (distanceInLine - addedLength) / bezierData.points[j + 1].partialLength;
                        kLen = bezierData.points[j].point.length;
                        for(k = 0; k < kLen; k += 1)newValue[k] = bezierData.points[j].point[k] + (bezierData.points[j + 1].point[k] - bezierData.points[j].point[k]) * segmentPerc;
                        break;
                    }
                    if (j < jLen - 1) j += 1;
                    else flag = false;
                }
                caching._lastPoint = j;
                caching._lastAddedLength = addedLength - bezierData.points[j].partialLength;
                caching._lastKeyframeIndex = i;
            }
        } else {
            var outX;
            var outY;
            var inX;
            var inY;
            var keyValue;
            len = keyData.s.length;
            endValue = nextKeyData.s || keyData.e;
            if (this.sh && keyData.h !== 1) {
                if (frameNum >= nextKeyTime) {
                    newValue[0] = endValue[0];
                    newValue[1] = endValue[1];
                    newValue[2] = endValue[2];
                } else if (frameNum <= keyTime) {
                    newValue[0] = keyData.s[0];
                    newValue[1] = keyData.s[1];
                    newValue[2] = keyData.s[2];
                } else {
                    var quatStart = createQuaternion(keyData.s);
                    var quatEnd = createQuaternion(endValue);
                    var time = (frameNum - keyTime) / (nextKeyTime - keyTime);
                    quaternionToEuler(newValue, slerp(quatStart, quatEnd, time));
                }
            } else for(i = 0; i < len; i += 1){
                if (keyData.h !== 1) {
                    if (frameNum >= nextKeyTime) perc = 1;
                    else if (frameNum < keyTime) perc = 0;
                    else {
                        if (keyData.o.x.constructor === Array) {
                            if (!keyframeMetadata.__fnct) keyframeMetadata.__fnct = [];
                            if (!keyframeMetadata.__fnct[i]) {
                                outX = keyData.o.x[i] === undefined ? keyData.o.x[0] : keyData.o.x[i];
                                outY = keyData.o.y[i] === undefined ? keyData.o.y[0] : keyData.o.y[i];
                                inX = keyData.i.x[i] === undefined ? keyData.i.x[0] : keyData.i.x[i];
                                inY = keyData.i.y[i] === undefined ? keyData.i.y[0] : keyData.i.y[i];
                                fnc = BezierFactory.getBezierEasing(outX, outY, inX, inY).get;
                                keyframeMetadata.__fnct[i] = fnc;
                            } else fnc = keyframeMetadata.__fnct[i];
                        } else if (!keyframeMetadata.__fnct) {
                            outX = keyData.o.x;
                            outY = keyData.o.y;
                            inX = keyData.i.x;
                            inY = keyData.i.y;
                            fnc = BezierFactory.getBezierEasing(outX, outY, inX, inY).get;
                            keyData.keyframeMetadata = fnc;
                        } else fnc = keyframeMetadata.__fnct;
                        perc = fnc((frameNum - keyTime) / (nextKeyTime - keyTime));
                    }
                }
                endValue = nextKeyData.s || keyData.e;
                keyValue = keyData.h === 1 ? keyData.s[i] : keyData.s[i] + (endValue[i] - keyData.s[i]) * perc;
                if (this.propType === 'multidimensional') newValue[i] = keyValue;
                else newValue = keyValue;
            }
        }
        caching.lastIndex = iterationIndex;
        return newValue;
    } // based on @Toji's https://github.com/toji/gl-matrix/
    function slerp(a, b, t) {
        var out = [];
        var ax = a[0];
        var ay = a[1];
        var az = a[2];
        var aw = a[3];
        var bx = b[0];
        var by = b[1];
        var bz = b[2];
        var bw = b[3];
        var omega;
        var cosom;
        var sinom;
        var scale0;
        var scale1;
        cosom = ax * bx + ay * by + az * bz + aw * bw;
        if (cosom < 0.0) {
            cosom = -cosom;
            bx = -bx;
            by = -by;
            bz = -bz;
            bw = -bw;
        }
        if (1.0 - cosom > 0.000001) {
            omega = Math.acos(cosom);
            sinom = Math.sin(omega);
            scale0 = Math.sin((1.0 - t) * omega) / sinom;
            scale1 = Math.sin(t * omega) / sinom;
        } else {
            scale0 = 1.0 - t;
            scale1 = t;
        }
        out[0] = scale0 * ax + scale1 * bx;
        out[1] = scale0 * ay + scale1 * by;
        out[2] = scale0 * az + scale1 * bz;
        out[3] = scale0 * aw + scale1 * bw;
        return out;
    }
    function quaternionToEuler(out, quat) {
        var qx = quat[0];
        var qy = quat[1];
        var qz = quat[2];
        var qw = quat[3];
        var heading = Math.atan2(2 * qy * qw - 2 * qx * qz, 1 - 2 * qy * qy - 2 * qz * qz);
        var attitude = Math.asin(2 * qx * qy + 2 * qz * qw);
        var bank = Math.atan2(2 * qx * qw - 2 * qy * qz, 1 - 2 * qx * qx - 2 * qz * qz);
        out[0] = heading / degToRads;
        out[1] = attitude / degToRads;
        out[2] = bank / degToRads;
    }
    function createQuaternion(values) {
        var heading = values[0] * degToRads;
        var attitude = values[1] * degToRads;
        var bank = values[2] * degToRads;
        var c1 = Math.cos(heading / 2);
        var c2 = Math.cos(attitude / 2);
        var c3 = Math.cos(bank / 2);
        var s1 = Math.sin(heading / 2);
        var s2 = Math.sin(attitude / 2);
        var s3 = Math.sin(bank / 2);
        var w = c1 * c2 * c3 - s1 * s2 * s3;
        var x = s1 * s2 * c3 + c1 * c2 * s3;
        var y = s1 * c2 * c3 + c1 * s2 * s3;
        var z = c1 * s2 * c3 - s1 * c2 * s3;
        return [
            x,
            y,
            z,
            w
        ];
    }
    function getValueAtCurrentTime() {
        var frameNum = this.comp.renderedFrame - this.offsetTime;
        var initTime = this.keyframes[0].t - this.offsetTime;
        var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
        if (!(frameNum === this._caching.lastFrame || this._caching.lastFrame !== initFrame && (this._caching.lastFrame >= endTime && frameNum >= endTime || this._caching.lastFrame < initTime && frameNum < initTime))) {
            if (this._caching.lastFrame >= frameNum) {
                this._caching._lastKeyframeIndex = -1;
                this._caching.lastIndex = 0;
            }
            var renderResult = this.interpolateValue(frameNum, this._caching);
            this.pv = renderResult;
        }
        this._caching.lastFrame = frameNum;
        return this.pv;
    }
    function setVValue(val) {
        var multipliedValue;
        if (this.propType === 'unidimensional') {
            multipliedValue = val * this.mult;
            if (mathAbs(this.v - multipliedValue) > 0.00001) {
                this.v = multipliedValue;
                this._mdf = true;
            }
        } else {
            var i = 0;
            var len = this.v.length;
            while(i < len){
                multipliedValue = val[i] * this.mult;
                if (mathAbs(this.v[i] - multipliedValue) > 0.00001) {
                    this.v[i] = multipliedValue;
                    this._mdf = true;
                }
                i += 1;
            }
        }
    }
    function processEffectsSequence() {
        if (this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) return;
        if (this.lock) {
            this.setVValue(this.pv);
            return;
        }
        this.lock = true;
        this._mdf = this._isFirstFrame;
        var i;
        var len = this.effectsSequence.length;
        var finalValue = this.kf ? this.pv : this.data.k;
        for(i = 0; i < len; i += 1)finalValue = this.effectsSequence[i](finalValue);
        this.setVValue(finalValue);
        this._isFirstFrame = false;
        this.lock = false;
        this.frameId = this.elem.globalData.frameId;
    }
    function addEffect(effectFunction) {
        this.effectsSequence.push(effectFunction);
        this.container.addDynamicProperty(this);
    }
    function ValueProperty(elem, data, mult, container) {
        this.propType = 'unidimensional';
        this.mult = mult || 1;
        this.data = data;
        this.v = mult ? data.k * mult : data.k;
        this.pv = data.k;
        this._mdf = false;
        this.elem = elem;
        this.container = container;
        this.comp = elem.comp;
        this.k = false;
        this.kf = false;
        this.vel = 0;
        this.effectsSequence = [];
        this._isFirstFrame = true;
        this.getValue = processEffectsSequence;
        this.setVValue = setVValue;
        this.addEffect = addEffect;
    }
    function MultiDimensionalProperty(elem, data, mult, container) {
        this.propType = 'multidimensional';
        this.mult = mult || 1;
        this.data = data;
        this._mdf = false;
        this.elem = elem;
        this.container = container;
        this.comp = elem.comp;
        this.k = false;
        this.kf = false;
        this.frameId = -1;
        var i;
        var len = data.k.length;
        this.v = createTypedArray('float32', len);
        this.pv = createTypedArray('float32', len);
        this.vel = createTypedArray('float32', len);
        for(i = 0; i < len; i += 1){
            this.v[i] = data.k[i] * this.mult;
            this.pv[i] = data.k[i];
        }
        this._isFirstFrame = true;
        this.effectsSequence = [];
        this.getValue = processEffectsSequence;
        this.setVValue = setVValue;
        this.addEffect = addEffect;
    }
    function KeyframedValueProperty(elem, data, mult, container) {
        this.propType = 'unidimensional';
        this.keyframes = data.k;
        this.keyframesMetadata = [];
        this.offsetTime = elem.data.st;
        this.frameId = -1;
        this._caching = {
            lastFrame: initFrame,
            lastIndex: 0,
            value: 0,
            _lastKeyframeIndex: -1
        };
        this.k = true;
        this.kf = true;
        this.data = data;
        this.mult = mult || 1;
        this.elem = elem;
        this.container = container;
        this.comp = elem.comp;
        this.v = initFrame;
        this.pv = initFrame;
        this._isFirstFrame = true;
        this.getValue = processEffectsSequence;
        this.setVValue = setVValue;
        this.interpolateValue = interpolateValue;
        this.effectsSequence = [
            getValueAtCurrentTime.bind(this)
        ];
        this.addEffect = addEffect;
    }
    function KeyframedMultidimensionalProperty(elem, data, mult, container) {
        this.propType = 'multidimensional';
        var i;
        var len = data.k.length;
        var s;
        var e;
        var to;
        var ti;
        for(i = 0; i < len - 1; i += 1)if (data.k[i].to && data.k[i].s && data.k[i + 1] && data.k[i + 1].s) {
            s = data.k[i].s;
            e = data.k[i + 1].s;
            to = data.k[i].to;
            ti = data.k[i].ti;
            if (s.length === 2 && !(s[0] === e[0] && s[1] === e[1]) && bez.pointOnLine2D(s[0], s[1], e[0], e[1], s[0] + to[0], s[1] + to[1]) && bez.pointOnLine2D(s[0], s[1], e[0], e[1], e[0] + ti[0], e[1] + ti[1]) || s.length === 3 && !(s[0] === e[0] && s[1] === e[1] && s[2] === e[2]) && bez.pointOnLine3D(s[0], s[1], s[2], e[0], e[1], e[2], s[0] + to[0], s[1] + to[1], s[2] + to[2]) && bez.pointOnLine3D(s[0], s[1], s[2], e[0], e[1], e[2], e[0] + ti[0], e[1] + ti[1], e[2] + ti[2])) {
                data.k[i].to = null;
                data.k[i].ti = null;
            }
            if (s[0] === e[0] && s[1] === e[1] && to[0] === 0 && to[1] === 0 && ti[0] === 0 && ti[1] === 0) {
                if (s.length === 2 || s[2] === e[2] && to[2] === 0 && ti[2] === 0) {
                    data.k[i].to = null;
                    data.k[i].ti = null;
                }
            }
        }
        this.effectsSequence = [
            getValueAtCurrentTime.bind(this)
        ];
        this.data = data;
        this.keyframes = data.k;
        this.keyframesMetadata = [];
        this.offsetTime = elem.data.st;
        this.k = true;
        this.kf = true;
        this._isFirstFrame = true;
        this.mult = mult || 1;
        this.elem = elem;
        this.container = container;
        this.comp = elem.comp;
        this.getValue = processEffectsSequence;
        this.setVValue = setVValue;
        this.interpolateValue = interpolateValue;
        this.frameId = -1;
        var arrLen = data.k[0].s.length;
        this.v = createTypedArray('float32', arrLen);
        this.pv = createTypedArray('float32', arrLen);
        for(i = 0; i < arrLen; i += 1){
            this.v[i] = initFrame;
            this.pv[i] = initFrame;
        }
        this._caching = {
            lastFrame: initFrame,
            lastIndex: 0,
            value: createTypedArray('float32', arrLen)
        };
        this.addEffect = addEffect;
    }
    var PropertyFactory = function() {
        function getProp(elem, data, type, mult, container) {
            if (data.sid) data = elem.globalData.slotManager.getProp(data);
            var p;
            if (!data.k.length) p = new ValueProperty(elem, data, mult, container);
            else if (typeof data.k[0] === 'number') p = new MultiDimensionalProperty(elem, data, mult, container);
            else switch(type){
                case 0:
                    p = new KeyframedValueProperty(elem, data, mult, container);
                    break;
                case 1:
                    p = new KeyframedMultidimensionalProperty(elem, data, mult, container);
                    break;
                default:
                    break;
            }
            if (p.effectsSequence.length) container.addDynamicProperty(p);
            return p;
        }
        var ob = {
            getProp: getProp
        };
        return ob;
    }();
    function DynamicPropertyContainer() {}
    DynamicPropertyContainer.prototype = {
        addDynamicProperty: function addDynamicProperty(prop) {
            if (this.dynamicProperties.indexOf(prop) === -1) {
                this.dynamicProperties.push(prop);
                this.container.addDynamicProperty(this);
                this._isAnimated = true;
            }
        },
        iterateDynamicProperties: function iterateDynamicProperties() {
            this._mdf = false;
            var i;
            var len = this.dynamicProperties.length;
            for(i = 0; i < len; i += 1){
                this.dynamicProperties[i].getValue();
                if (this.dynamicProperties[i]._mdf) this._mdf = true;
            }
        },
        initDynamicPropertyContainer: function initDynamicPropertyContainer(container) {
            this.container = container;
            this.dynamicProperties = [];
            this._mdf = false;
            this._isAnimated = false;
        }
    };
    var pointPool = function() {
        function create() {
            return createTypedArray('float32', 2);
        }
        return poolFactory(8, create);
    }();
    function ShapePath() {
        this.c = false;
        this._length = 0;
        this._maxLength = 8;
        this.v = createSizedArray(this._maxLength);
        this.o = createSizedArray(this._maxLength);
        this.i = createSizedArray(this._maxLength);
    }
    ShapePath.prototype.setPathData = function(closed, len) {
        this.c = closed;
        this.setLength(len);
        var i = 0;
        while(i < len){
            this.v[i] = pointPool.newElement();
            this.o[i] = pointPool.newElement();
            this.i[i] = pointPool.newElement();
            i += 1;
        }
    };
    ShapePath.prototype.setLength = function(len) {
        while(this._maxLength < len)this.doubleArrayLength();
        this._length = len;
    };
    ShapePath.prototype.doubleArrayLength = function() {
        this.v = this.v.concat(createSizedArray(this._maxLength));
        this.i = this.i.concat(createSizedArray(this._maxLength));
        this.o = this.o.concat(createSizedArray(this._maxLength));
        this._maxLength *= 2;
    };
    ShapePath.prototype.setXYAt = function(x, y, type, pos, replace) {
        var arr;
        this._length = Math.max(this._length, pos + 1);
        if (this._length >= this._maxLength) this.doubleArrayLength();
        switch(type){
            case 'v':
                arr = this.v;
                break;
            case 'i':
                arr = this.i;
                break;
            case 'o':
                arr = this.o;
                break;
            default:
                arr = [];
                break;
        }
        if (!arr[pos] || arr[pos] && !replace) arr[pos] = pointPool.newElement();
        arr[pos][0] = x;
        arr[pos][1] = y;
    };
    ShapePath.prototype.setTripleAt = function(vX, vY, oX, oY, iX, iY, pos, replace) {
        this.setXYAt(vX, vY, 'v', pos, replace);
        this.setXYAt(oX, oY, 'o', pos, replace);
        this.setXYAt(iX, iY, 'i', pos, replace);
    };
    ShapePath.prototype.reverse = function() {
        var newPath = new ShapePath();
        newPath.setPathData(this.c, this._length);
        var vertices = this.v;
        var outPoints = this.o;
        var inPoints = this.i;
        var init = 0;
        if (this.c) {
            newPath.setTripleAt(vertices[0][0], vertices[0][1], inPoints[0][0], inPoints[0][1], outPoints[0][0], outPoints[0][1], 0, false);
            init = 1;
        }
        var cnt = this._length - 1;
        var len = this._length;
        var i;
        for(i = init; i < len; i += 1){
            newPath.setTripleAt(vertices[cnt][0], vertices[cnt][1], inPoints[cnt][0], inPoints[cnt][1], outPoints[cnt][0], outPoints[cnt][1], i, false);
            cnt -= 1;
        }
        return newPath;
    };
    ShapePath.prototype.length = function() {
        return this._length;
    };
    var shapePool = function() {
        function create() {
            return new ShapePath();
        }
        function release(shapePath) {
            var len = shapePath._length;
            var i;
            for(i = 0; i < len; i += 1){
                pointPool.release(shapePath.v[i]);
                pointPool.release(shapePath.i[i]);
                pointPool.release(shapePath.o[i]);
                shapePath.v[i] = null;
                shapePath.i[i] = null;
                shapePath.o[i] = null;
            }
            shapePath._length = 0;
            shapePath.c = false;
        }
        function clone(shape) {
            var cloned = factory.newElement();
            var i;
            var len = shape._length === undefined ? shape.v.length : shape._length;
            cloned.setLength(len);
            cloned.c = shape.c;
            for(i = 0; i < len; i += 1)cloned.setTripleAt(shape.v[i][0], shape.v[i][1], shape.o[i][0], shape.o[i][1], shape.i[i][0], shape.i[i][1], i);
            return cloned;
        }
        var factory = poolFactory(4, create, release);
        factory.clone = clone;
        return factory;
    }();
    function ShapeCollection() {
        this._length = 0;
        this._maxLength = 4;
        this.shapes = createSizedArray(this._maxLength);
    }
    ShapeCollection.prototype.addShape = function(shapeData) {
        if (this._length === this._maxLength) {
            this.shapes = this.shapes.concat(createSizedArray(this._maxLength));
            this._maxLength *= 2;
        }
        this.shapes[this._length] = shapeData;
        this._length += 1;
    };
    ShapeCollection.prototype.releaseShapes = function() {
        var i;
        for(i = 0; i < this._length; i += 1)shapePool.release(this.shapes[i]);
        this._length = 0;
    };
    var shapeCollectionPool = function() {
        var ob = {
            newShapeCollection: newShapeCollection,
            release: release
        };
        var _length = 0;
        var _maxLength = 4;
        var pool = createSizedArray(_maxLength);
        function newShapeCollection() {
            var shapeCollection;
            if (_length) {
                _length -= 1;
                shapeCollection = pool[_length];
            } else shapeCollection = new ShapeCollection();
            return shapeCollection;
        }
        function release(shapeCollection) {
            var i;
            var len = shapeCollection._length;
            for(i = 0; i < len; i += 1)shapePool.release(shapeCollection.shapes[i]);
            shapeCollection._length = 0;
            if (_length === _maxLength) {
                pool = pooling["double"](pool);
                _maxLength *= 2;
            }
            pool[_length] = shapeCollection;
            _length += 1;
        }
        return ob;
    }();
    var ShapePropertyFactory = function() {
        var initFrame = -999999;
        function interpolateShape(frameNum, previousValue, caching) {
            var iterationIndex = caching.lastIndex;
            var keyPropS;
            var keyPropE;
            var isHold;
            var j;
            var k;
            var jLen;
            var kLen;
            var perc;
            var vertexValue;
            var kf = this.keyframes;
            if (frameNum < kf[0].t - this.offsetTime) {
                keyPropS = kf[0].s[0];
                isHold = true;
                iterationIndex = 0;
            } else if (frameNum >= kf[kf.length - 1].t - this.offsetTime) {
                keyPropS = kf[kf.length - 1].s ? kf[kf.length - 1].s[0] : kf[kf.length - 2].e[0];
                /* if(kf[kf.length - 1].s){
                  keyPropS = kf[kf.length - 1].s[0];
              }else{
                  keyPropS = kf[kf.length - 2].e[0];
              } */ isHold = true;
            } else {
                var i = iterationIndex;
                var len = kf.length - 1;
                var flag = true;
                var keyData;
                var nextKeyData;
                var keyframeMetadata;
                while(flag){
                    keyData = kf[i];
                    nextKeyData = kf[i + 1];
                    if (nextKeyData.t - this.offsetTime > frameNum) break;
                    if (i < len - 1) i += 1;
                    else flag = false;
                }
                keyframeMetadata = this.keyframesMetadata[i] || {};
                isHold = keyData.h === 1;
                iterationIndex = i;
                if (!isHold) {
                    if (frameNum >= nextKeyData.t - this.offsetTime) perc = 1;
                    else if (frameNum < keyData.t - this.offsetTime) perc = 0;
                    else {
                        var fnc;
                        if (keyframeMetadata.__fnct) fnc = keyframeMetadata.__fnct;
                        else {
                            fnc = BezierFactory.getBezierEasing(keyData.o.x, keyData.o.y, keyData.i.x, keyData.i.y).get;
                            keyframeMetadata.__fnct = fnc;
                        }
                        perc = fnc((frameNum - (keyData.t - this.offsetTime)) / (nextKeyData.t - this.offsetTime - (keyData.t - this.offsetTime)));
                    }
                    keyPropE = nextKeyData.s ? nextKeyData.s[0] : keyData.e[0];
                }
                keyPropS = keyData.s[0];
            }
            jLen = previousValue._length;
            kLen = keyPropS.i[0].length;
            caching.lastIndex = iterationIndex;
            for(j = 0; j < jLen; j += 1)for(k = 0; k < kLen; k += 1){
                vertexValue = isHold ? keyPropS.i[j][k] : keyPropS.i[j][k] + (keyPropE.i[j][k] - keyPropS.i[j][k]) * perc;
                previousValue.i[j][k] = vertexValue;
                vertexValue = isHold ? keyPropS.o[j][k] : keyPropS.o[j][k] + (keyPropE.o[j][k] - keyPropS.o[j][k]) * perc;
                previousValue.o[j][k] = vertexValue;
                vertexValue = isHold ? keyPropS.v[j][k] : keyPropS.v[j][k] + (keyPropE.v[j][k] - keyPropS.v[j][k]) * perc;
                previousValue.v[j][k] = vertexValue;
            }
        }
        function interpolateShapeCurrentTime() {
            var frameNum = this.comp.renderedFrame - this.offsetTime;
            var initTime = this.keyframes[0].t - this.offsetTime;
            var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
            var lastFrame = this._caching.lastFrame;
            if (!(lastFrame !== initFrame && (lastFrame < initTime && frameNum < initTime || lastFrame > endTime && frameNum > endTime))) {
                /// /
                this._caching.lastIndex = lastFrame < frameNum ? this._caching.lastIndex : 0;
                this.interpolateShape(frameNum, this.pv, this._caching); /// /
            }
            this._caching.lastFrame = frameNum;
            return this.pv;
        }
        function resetShape() {
            this.paths = this.localShapeCollection;
        }
        function shapesEqual(shape1, shape2) {
            if (shape1._length !== shape2._length || shape1.c !== shape2.c) return false;
            var i;
            var len = shape1._length;
            for(i = 0; i < len; i += 1){
                if (shape1.v[i][0] !== shape2.v[i][0] || shape1.v[i][1] !== shape2.v[i][1] || shape1.o[i][0] !== shape2.o[i][0] || shape1.o[i][1] !== shape2.o[i][1] || shape1.i[i][0] !== shape2.i[i][0] || shape1.i[i][1] !== shape2.i[i][1]) return false;
            }
            return true;
        }
        function setVValue(newPath) {
            if (!shapesEqual(this.v, newPath)) {
                this.v = shapePool.clone(newPath);
                this.localShapeCollection.releaseShapes();
                this.localShapeCollection.addShape(this.v);
                this._mdf = true;
                this.paths = this.localShapeCollection;
            }
        }
        function processEffectsSequence() {
            if (this.elem.globalData.frameId === this.frameId) return;
            if (!this.effectsSequence.length) {
                this._mdf = false;
                return;
            }
            if (this.lock) {
                this.setVValue(this.pv);
                return;
            }
            this.lock = true;
            this._mdf = false;
            var finalValue;
            if (this.kf) finalValue = this.pv;
            else if (this.data.ks) finalValue = this.data.ks.k;
            else finalValue = this.data.pt.k;
            var i;
            var len = this.effectsSequence.length;
            for(i = 0; i < len; i += 1)finalValue = this.effectsSequence[i](finalValue);
            this.setVValue(finalValue);
            this.lock = false;
            this.frameId = this.elem.globalData.frameId;
        }
        function ShapeProperty(elem, data, type) {
            this.propType = 'shape';
            this.comp = elem.comp;
            this.container = elem;
            this.elem = elem;
            this.data = data;
            this.k = false;
            this.kf = false;
            this._mdf = false;
            var pathData = type === 3 ? data.pt.k : data.ks.k;
            this.v = shapePool.clone(pathData);
            this.pv = shapePool.clone(this.v);
            this.localShapeCollection = shapeCollectionPool.newShapeCollection();
            this.paths = this.localShapeCollection;
            this.paths.addShape(this.v);
            this.reset = resetShape;
            this.effectsSequence = [];
        }
        function addEffect(effectFunction) {
            this.effectsSequence.push(effectFunction);
            this.container.addDynamicProperty(this);
        }
        ShapeProperty.prototype.interpolateShape = interpolateShape;
        ShapeProperty.prototype.getValue = processEffectsSequence;
        ShapeProperty.prototype.setVValue = setVValue;
        ShapeProperty.prototype.addEffect = addEffect;
        function KeyframedShapeProperty(elem, data, type) {
            this.propType = 'shape';
            this.comp = elem.comp;
            this.elem = elem;
            this.container = elem;
            this.offsetTime = elem.data.st;
            this.keyframes = type === 3 ? data.pt.k : data.ks.k;
            this.keyframesMetadata = [];
            this.k = true;
            this.kf = true;
            var len = this.keyframes[0].s[0].i.length;
            this.v = shapePool.newElement();
            this.v.setPathData(this.keyframes[0].s[0].c, len);
            this.pv = shapePool.clone(this.v);
            this.localShapeCollection = shapeCollectionPool.newShapeCollection();
            this.paths = this.localShapeCollection;
            this.paths.addShape(this.v);
            this.lastFrame = initFrame;
            this.reset = resetShape;
            this._caching = {
                lastFrame: initFrame,
                lastIndex: 0
            };
            this.effectsSequence = [
                interpolateShapeCurrentTime.bind(this)
            ];
        }
        KeyframedShapeProperty.prototype.getValue = processEffectsSequence;
        KeyframedShapeProperty.prototype.interpolateShape = interpolateShape;
        KeyframedShapeProperty.prototype.setVValue = setVValue;
        KeyframedShapeProperty.prototype.addEffect = addEffect;
        var EllShapeProperty = function() {
            var cPoint = roundCorner;
            function EllShapePropertyFactory(elem, data) {
                this.v = shapePool.newElement();
                this.v.setPathData(true, 4);
                this.localShapeCollection = shapeCollectionPool.newShapeCollection();
                this.paths = this.localShapeCollection;
                this.localShapeCollection.addShape(this.v);
                this.d = data.d;
                this.elem = elem;
                this.comp = elem.comp;
                this.frameId = -1;
                this.initDynamicPropertyContainer(elem);
                this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
                this.s = PropertyFactory.getProp(elem, data.s, 1, 0, this);
                if (this.dynamicProperties.length) this.k = true;
                else {
                    this.k = false;
                    this.convertEllToPath();
                }
            }
            EllShapePropertyFactory.prototype = {
                reset: resetShape,
                getValue: function getValue() {
                    if (this.elem.globalData.frameId === this.frameId) return;
                    this.frameId = this.elem.globalData.frameId;
                    this.iterateDynamicProperties();
                    if (this._mdf) this.convertEllToPath();
                },
                convertEllToPath: function convertEllToPath() {
                    var p0 = this.p.v[0];
                    var p1 = this.p.v[1];
                    var s0 = this.s.v[0] / 2;
                    var s1 = this.s.v[1] / 2;
                    var _cw = this.d !== 3;
                    var _v = this.v;
                    _v.v[0][0] = p0;
                    _v.v[0][1] = p1 - s1;
                    _v.v[1][0] = _cw ? p0 + s0 : p0 - s0;
                    _v.v[1][1] = p1;
                    _v.v[2][0] = p0;
                    _v.v[2][1] = p1 + s1;
                    _v.v[3][0] = _cw ? p0 - s0 : p0 + s0;
                    _v.v[3][1] = p1;
                    _v.i[0][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
                    _v.i[0][1] = p1 - s1;
                    _v.i[1][0] = _cw ? p0 + s0 : p0 - s0;
                    _v.i[1][1] = p1 - s1 * cPoint;
                    _v.i[2][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
                    _v.i[2][1] = p1 + s1;
                    _v.i[3][0] = _cw ? p0 - s0 : p0 + s0;
                    _v.i[3][1] = p1 + s1 * cPoint;
                    _v.o[0][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
                    _v.o[0][1] = p1 - s1;
                    _v.o[1][0] = _cw ? p0 + s0 : p0 - s0;
                    _v.o[1][1] = p1 + s1 * cPoint;
                    _v.o[2][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
                    _v.o[2][1] = p1 + s1;
                    _v.o[3][0] = _cw ? p0 - s0 : p0 + s0;
                    _v.o[3][1] = p1 - s1 * cPoint;
                }
            };
            extendPrototype([
                DynamicPropertyContainer
            ], EllShapePropertyFactory);
            return EllShapePropertyFactory;
        }();
        var StarShapeProperty = function() {
            function StarShapePropertyFactory(elem, data) {
                this.v = shapePool.newElement();
                this.v.setPathData(true, 0);
                this.elem = elem;
                this.comp = elem.comp;
                this.data = data;
                this.frameId = -1;
                this.d = data.d;
                this.initDynamicPropertyContainer(elem);
                if (data.sy === 1) {
                    this.ir = PropertyFactory.getProp(elem, data.ir, 0, 0, this);
                    this.is = PropertyFactory.getProp(elem, data.is, 0, 0.01, this);
                    this.convertToPath = this.convertStarToPath;
                } else this.convertToPath = this.convertPolygonToPath;
                this.pt = PropertyFactory.getProp(elem, data.pt, 0, 0, this);
                this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
                this.r = PropertyFactory.getProp(elem, data.r, 0, degToRads, this);
                this.or = PropertyFactory.getProp(elem, data.or, 0, 0, this);
                this.os = PropertyFactory.getProp(elem, data.os, 0, 0.01, this);
                this.localShapeCollection = shapeCollectionPool.newShapeCollection();
                this.localShapeCollection.addShape(this.v);
                this.paths = this.localShapeCollection;
                if (this.dynamicProperties.length) this.k = true;
                else {
                    this.k = false;
                    this.convertToPath();
                }
            }
            StarShapePropertyFactory.prototype = {
                reset: resetShape,
                getValue: function getValue() {
                    if (this.elem.globalData.frameId === this.frameId) return;
                    this.frameId = this.elem.globalData.frameId;
                    this.iterateDynamicProperties();
                    if (this._mdf) this.convertToPath();
                },
                convertStarToPath: function convertStarToPath() {
                    var numPts = Math.floor(this.pt.v) * 2;
                    var angle = Math.PI * 2 / numPts;
                    /* this.v.v.length = numPts;
                  this.v.i.length = numPts;
                  this.v.o.length = numPts; */ var longFlag = true;
                    var longRad = this.or.v;
                    var shortRad = this.ir.v;
                    var longRound = this.os.v;
                    var shortRound = this.is.v;
                    var longPerimSegment = 2 * Math.PI * longRad / (numPts * 2);
                    var shortPerimSegment = 2 * Math.PI * shortRad / (numPts * 2);
                    var i;
                    var rad;
                    var roundness;
                    var perimSegment;
                    var currentAng = -Math.PI / 2;
                    currentAng += this.r.v;
                    var dir = this.data.d === 3 ? -1 : 1;
                    this.v._length = 0;
                    for(i = 0; i < numPts; i += 1){
                        rad = longFlag ? longRad : shortRad;
                        roundness = longFlag ? longRound : shortRound;
                        perimSegment = longFlag ? longPerimSegment : shortPerimSegment;
                        var x = rad * Math.cos(currentAng);
                        var y = rad * Math.sin(currentAng);
                        var ox = x === 0 && y === 0 ? 0 : y / Math.sqrt(x * x + y * y);
                        var oy = x === 0 && y === 0 ? 0 : -x / Math.sqrt(x * x + y * y);
                        x += +this.p.v[0];
                        y += +this.p.v[1];
                        this.v.setTripleAt(x, y, x - ox * perimSegment * roundness * dir, y - oy * perimSegment * roundness * dir, x + ox * perimSegment * roundness * dir, y + oy * perimSegment * roundness * dir, i, true);
                        /* this.v.v[i] = [x,y];
                      this.v.i[i] = [x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir];
                      this.v.o[i] = [x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir];
                      this.v._length = numPts; */ longFlag = !longFlag;
                        currentAng += angle * dir;
                    }
                },
                convertPolygonToPath: function convertPolygonToPath() {
                    var numPts = Math.floor(this.pt.v);
                    var angle = Math.PI * 2 / numPts;
                    var rad = this.or.v;
                    var roundness = this.os.v;
                    var perimSegment = 2 * Math.PI * rad / (numPts * 4);
                    var i;
                    var currentAng = -Math.PI * 0.5;
                    var dir = this.data.d === 3 ? -1 : 1;
                    currentAng += this.r.v;
                    this.v._length = 0;
                    for(i = 0; i < numPts; i += 1){
                        var x = rad * Math.cos(currentAng);
                        var y = rad * Math.sin(currentAng);
                        var ox = x === 0 && y === 0 ? 0 : y / Math.sqrt(x * x + y * y);
                        var oy = x === 0 && y === 0 ? 0 : -x / Math.sqrt(x * x + y * y);
                        x += +this.p.v[0];
                        y += +this.p.v[1];
                        this.v.setTripleAt(x, y, x - ox * perimSegment * roundness * dir, y - oy * perimSegment * roundness * dir, x + ox * perimSegment * roundness * dir, y + oy * perimSegment * roundness * dir, i, true);
                        currentAng += angle * dir;
                    }
                    this.paths.length = 0;
                    this.paths[0] = this.v;
                }
            };
            extendPrototype([
                DynamicPropertyContainer
            ], StarShapePropertyFactory);
            return StarShapePropertyFactory;
        }();
        var RectShapeProperty = function() {
            function RectShapePropertyFactory(elem, data) {
                this.v = shapePool.newElement();
                this.v.c = true;
                this.localShapeCollection = shapeCollectionPool.newShapeCollection();
                this.localShapeCollection.addShape(this.v);
                this.paths = this.localShapeCollection;
                this.elem = elem;
                this.comp = elem.comp;
                this.frameId = -1;
                this.d = data.d;
                this.initDynamicPropertyContainer(elem);
                this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
                this.s = PropertyFactory.getProp(elem, data.s, 1, 0, this);
                this.r = PropertyFactory.getProp(elem, data.r, 0, 0, this);
                if (this.dynamicProperties.length) this.k = true;
                else {
                    this.k = false;
                    this.convertRectToPath();
                }
            }
            RectShapePropertyFactory.prototype = {
                convertRectToPath: function convertRectToPath() {
                    var p0 = this.p.v[0];
                    var p1 = this.p.v[1];
                    var v0 = this.s.v[0] / 2;
                    var v1 = this.s.v[1] / 2;
                    var round = bmMin(v0, v1, this.r.v);
                    var cPoint = round * (1 - roundCorner);
                    this.v._length = 0;
                    if (this.d === 2 || this.d === 1) {
                        this.v.setTripleAt(p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + cPoint, 0, true);
                        this.v.setTripleAt(p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - cPoint, p0 + v0, p1 + v1 - round, 1, true);
                        if (round !== 0) {
                            this.v.setTripleAt(p0 + v0 - round, p1 + v1, p0 + v0 - round, p1 + v1, p0 + v0 - cPoint, p1 + v1, 2, true);
                            this.v.setTripleAt(p0 - v0 + round, p1 + v1, p0 - v0 + cPoint, p1 + v1, p0 - v0 + round, p1 + v1, 3, true);
                            this.v.setTripleAt(p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - cPoint, 4, true);
                            this.v.setTripleAt(p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + cPoint, p0 - v0, p1 - v1 + round, 5, true);
                            this.v.setTripleAt(p0 - v0 + round, p1 - v1, p0 - v0 + round, p1 - v1, p0 - v0 + cPoint, p1 - v1, 6, true);
                            this.v.setTripleAt(p0 + v0 - round, p1 - v1, p0 + v0 - cPoint, p1 - v1, p0 + v0 - round, p1 - v1, 7, true);
                        } else {
                            this.v.setTripleAt(p0 - v0, p1 + v1, p0 - v0 + cPoint, p1 + v1, p0 - v0, p1 + v1, 2);
                            this.v.setTripleAt(p0 - v0, p1 - v1, p0 - v0, p1 - v1 + cPoint, p0 - v0, p1 - v1, 3);
                        }
                    } else {
                        this.v.setTripleAt(p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + cPoint, p0 + v0, p1 - v1 + round, 0, true);
                        if (round !== 0) {
                            this.v.setTripleAt(p0 + v0 - round, p1 - v1, p0 + v0 - round, p1 - v1, p0 + v0 - cPoint, p1 - v1, 1, true);
                            this.v.setTripleAt(p0 - v0 + round, p1 - v1, p0 - v0 + cPoint, p1 - v1, p0 - v0 + round, p1 - v1, 2, true);
                            this.v.setTripleAt(p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + cPoint, 3, true);
                            this.v.setTripleAt(p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - cPoint, p0 - v0, p1 + v1 - round, 4, true);
                            this.v.setTripleAt(p0 - v0 + round, p1 + v1, p0 - v0 + round, p1 + v1, p0 - v0 + cPoint, p1 + v1, 5, true);
                            this.v.setTripleAt(p0 + v0 - round, p1 + v1, p0 + v0 - cPoint, p1 + v1, p0 + v0 - round, p1 + v1, 6, true);
                            this.v.setTripleAt(p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - cPoint, 7, true);
                        } else {
                            this.v.setTripleAt(p0 - v0, p1 - v1, p0 - v0 + cPoint, p1 - v1, p0 - v0, p1 - v1, 1, true);
                            this.v.setTripleAt(p0 - v0, p1 + v1, p0 - v0, p1 + v1 - cPoint, p0 - v0, p1 + v1, 2, true);
                            this.v.setTripleAt(p0 + v0, p1 + v1, p0 + v0 - cPoint, p1 + v1, p0 + v0, p1 + v1, 3, true);
                        }
                    }
                },
                getValue: function getValue() {
                    if (this.elem.globalData.frameId === this.frameId) return;
                    this.frameId = this.elem.globalData.frameId;
                    this.iterateDynamicProperties();
                    if (this._mdf) this.convertRectToPath();
                },
                reset: resetShape
            };
            extendPrototype([
                DynamicPropertyContainer
            ], RectShapePropertyFactory);
            return RectShapePropertyFactory;
        }();
        function getShapeProp(elem, data, type) {
            var prop;
            if (type === 3 || type === 4) {
                var dataProp = type === 3 ? data.pt : data.ks;
                var keys = dataProp.k;
                if (keys.length) prop = new KeyframedShapeProperty(elem, data, type);
                else prop = new ShapeProperty(elem, data, type);
            } else if (type === 5) prop = new RectShapeProperty(elem, data);
            else if (type === 6) prop = new EllShapeProperty(elem, data);
            else if (type === 7) prop = new StarShapeProperty(elem, data);
            if (prop.k) elem.addDynamicProperty(prop);
            return prop;
        }
        function getConstructorFunction() {
            return ShapeProperty;
        }
        function getKeyframedConstructorFunction() {
            return KeyframedShapeProperty;
        }
        var ob = {};
        ob.getShapeProp = getShapeProp;
        ob.getConstructorFunction = getConstructorFunction;
        ob.getKeyframedConstructorFunction = getKeyframedConstructorFunction;
        return ob;
    }();
    /*!
   Transformation Matrix v2.0
   (c) Epistemex 2014-2015
   www.epistemex.com
   By Ken Fyrstenberg
   Contributions by leeoniya.
   License: MIT, header required.
   */ /**
   * 2D transformation matrix object initialized with identity matrix.
   *
   * The matrix can synchronize a canvas context by supplying the context
   * as an argument, or later apply current absolute transform to an
   * existing context.
   *
   * All values are handled as floating point values.
   *
   * @param {CanvasRenderingContext2D} [context] - Optional context to sync with Matrix
   * @prop {number} a - scale x
   * @prop {number} b - shear y
   * @prop {number} c - shear x
   * @prop {number} d - scale y
   * @prop {number} e - translate x
   * @prop {number} f - translate y
   * @prop {CanvasRenderingContext2D|null} [context=null] - set or get current canvas context
   * @constructor
   */ var Matrix = function() {
        var _cos = Math.cos;
        var _sin = Math.sin;
        var _tan = Math.tan;
        var _rnd = Math.round;
        function reset() {
            this.props[0] = 1;
            this.props[1] = 0;
            this.props[2] = 0;
            this.props[3] = 0;
            this.props[4] = 0;
            this.props[5] = 1;
            this.props[6] = 0;
            this.props[7] = 0;
            this.props[8] = 0;
            this.props[9] = 0;
            this.props[10] = 1;
            this.props[11] = 0;
            this.props[12] = 0;
            this.props[13] = 0;
            this.props[14] = 0;
            this.props[15] = 1;
            return this;
        }
        function rotate(angle) {
            if (angle === 0) return this;
            var mCos = _cos(angle);
            var mSin = _sin(angle);
            return this._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }
        function rotateX(angle) {
            if (angle === 0) return this;
            var mCos = _cos(angle);
            var mSin = _sin(angle);
            return this._t(1, 0, 0, 0, 0, mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1);
        }
        function rotateY(angle) {
            if (angle === 0) return this;
            var mCos = _cos(angle);
            var mSin = _sin(angle);
            return this._t(mCos, 0, mSin, 0, 0, 1, 0, 0, -mSin, 0, mCos, 0, 0, 0, 0, 1);
        }
        function rotateZ(angle) {
            if (angle === 0) return this;
            var mCos = _cos(angle);
            var mSin = _sin(angle);
            return this._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }
        function shear(sx, sy) {
            return this._t(1, sy, sx, 1, 0, 0);
        }
        function skew(ax, ay) {
            return this.shear(_tan(ax), _tan(ay));
        }
        function skewFromAxis(ax, angle) {
            var mCos = _cos(angle);
            var mSin = _sin(angle);
            return this._t(mCos, mSin, 0, 0, -mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, _tan(ax), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); // return this._t(mCos, mSin, -mSin, mCos, 0, 0)._t(1, 0, _tan(ax), 1, 0, 0)._t(mCos, -mSin, mSin, mCos, 0, 0);
        }
        function scale(sx, sy, sz) {
            if (!sz && sz !== 0) sz = 1;
            if (sx === 1 && sy === 1 && sz === 1) return this;
            return this._t(sx, 0, 0, 0, 0, sy, 0, 0, 0, 0, sz, 0, 0, 0, 0, 1);
        }
        function setTransform(a, b, c, d, e, f, g, h, i, j, k, l, m, n, o, p) {
            this.props[0] = a;
            this.props[1] = b;
            this.props[2] = c;
            this.props[3] = d;
            this.props[4] = e;
            this.props[5] = f;
            this.props[6] = g;
            this.props[7] = h;
            this.props[8] = i;
            this.props[9] = j;
            this.props[10] = k;
            this.props[11] = l;
            this.props[12] = m;
            this.props[13] = n;
            this.props[14] = o;
            this.props[15] = p;
            return this;
        }
        function translate(tx, ty, tz) {
            tz = tz || 0;
            if (tx !== 0 || ty !== 0 || tz !== 0) return this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, tx, ty, tz, 1);
            return this;
        }
        function transform(a2, b2, c2, d2, e2, f2, g2, h2, i2, j2, k2, l2, m2, n2, o2, p2) {
            var _p = this.props;
            if (a2 === 1 && b2 === 0 && c2 === 0 && d2 === 0 && e2 === 0 && f2 === 1 && g2 === 0 && h2 === 0 && i2 === 0 && j2 === 0 && k2 === 1 && l2 === 0) {
                // NOTE: commenting this condition because TurboFan deoptimizes code when present
                // if(m2 !== 0 || n2 !== 0 || o2 !== 0){
                _p[12] = _p[12] * a2 + _p[15] * m2;
                _p[13] = _p[13] * f2 + _p[15] * n2;
                _p[14] = _p[14] * k2 + _p[15] * o2;
                _p[15] *= p2; // }
                this._identityCalculated = false;
                return this;
            }
            var a1 = _p[0];
            var b1 = _p[1];
            var c1 = _p[2];
            var d1 = _p[3];
            var e1 = _p[4];
            var f1 = _p[5];
            var g1 = _p[6];
            var h1 = _p[7];
            var i1 = _p[8];
            var j1 = _p[9];
            var k1 = _p[10];
            var l1 = _p[11];
            var m1 = _p[12];
            var n1 = _p[13];
            var o1 = _p[14];
            var p1 = _p[15];
            /* matrix order (canvas compatible):
           * ace
           * bdf
           * 001
           */ _p[0] = a1 * a2 + b1 * e2 + c1 * i2 + d1 * m2;
            _p[1] = a1 * b2 + b1 * f2 + c1 * j2 + d1 * n2;
            _p[2] = a1 * c2 + b1 * g2 + c1 * k2 + d1 * o2;
            _p[3] = a1 * d2 + b1 * h2 + c1 * l2 + d1 * p2;
            _p[4] = e1 * a2 + f1 * e2 + g1 * i2 + h1 * m2;
            _p[5] = e1 * b2 + f1 * f2 + g1 * j2 + h1 * n2;
            _p[6] = e1 * c2 + f1 * g2 + g1 * k2 + h1 * o2;
            _p[7] = e1 * d2 + f1 * h2 + g1 * l2 + h1 * p2;
            _p[8] = i1 * a2 + j1 * e2 + k1 * i2 + l1 * m2;
            _p[9] = i1 * b2 + j1 * f2 + k1 * j2 + l1 * n2;
            _p[10] = i1 * c2 + j1 * g2 + k1 * k2 + l1 * o2;
            _p[11] = i1 * d2 + j1 * h2 + k1 * l2 + l1 * p2;
            _p[12] = m1 * a2 + n1 * e2 + o1 * i2 + p1 * m2;
            _p[13] = m1 * b2 + n1 * f2 + o1 * j2 + p1 * n2;
            _p[14] = m1 * c2 + n1 * g2 + o1 * k2 + p1 * o2;
            _p[15] = m1 * d2 + n1 * h2 + o1 * l2 + p1 * p2;
            this._identityCalculated = false;
            return this;
        }
        function multiply(matrix) {
            var matrixProps = matrix.props;
            return this.transform(matrixProps[0], matrixProps[1], matrixProps[2], matrixProps[3], matrixProps[4], matrixProps[5], matrixProps[6], matrixProps[7], matrixProps[8], matrixProps[9], matrixProps[10], matrixProps[11], matrixProps[12], matrixProps[13], matrixProps[14], matrixProps[15]);
        }
        function isIdentity() {
            if (!this._identityCalculated) {
                this._identity = !(this.props[0] !== 1 || this.props[1] !== 0 || this.props[2] !== 0 || this.props[3] !== 0 || this.props[4] !== 0 || this.props[5] !== 1 || this.props[6] !== 0 || this.props[7] !== 0 || this.props[8] !== 0 || this.props[9] !== 0 || this.props[10] !== 1 || this.props[11] !== 0 || this.props[12] !== 0 || this.props[13] !== 0 || this.props[14] !== 0 || this.props[15] !== 1);
                this._identityCalculated = true;
            }
            return this._identity;
        }
        function equals(matr) {
            var i = 0;
            while(i < 16){
                if (matr.props[i] !== this.props[i]) return false;
                i += 1;
            }
            return true;
        }
        function clone(matr) {
            var i;
            for(i = 0; i < 16; i += 1)matr.props[i] = this.props[i];
            return matr;
        }
        function cloneFromProps(props) {
            var i;
            for(i = 0; i < 16; i += 1)this.props[i] = props[i];
        }
        function applyToPoint(x, y, z) {
            return {
                x: x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],
                y: x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],
                z: x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]
            };
        /* return {
           x: x * me.a + y * me.c + me.e,
           y: x * me.b + y * me.d + me.f
           }; */ }
        function applyToX(x, y, z) {
            return x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12];
        }
        function applyToY(x, y, z) {
            return x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13];
        }
        function applyToZ(x, y, z) {
            return x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14];
        }
        function getInverseMatrix() {
            var determinant = this.props[0] * this.props[5] - this.props[1] * this.props[4];
            var a = this.props[5] / determinant;
            var b = -this.props[1] / determinant;
            var c = -this.props[4] / determinant;
            var d = this.props[0] / determinant;
            var e = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / determinant;
            var f = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / determinant;
            var inverseMatrix = new Matrix();
            inverseMatrix.props[0] = a;
            inverseMatrix.props[1] = b;
            inverseMatrix.props[4] = c;
            inverseMatrix.props[5] = d;
            inverseMatrix.props[12] = e;
            inverseMatrix.props[13] = f;
            return inverseMatrix;
        }
        function inversePoint(pt) {
            var inverseMatrix = this.getInverseMatrix();
            return inverseMatrix.applyToPointArray(pt[0], pt[1], pt[2] || 0);
        }
        function inversePoints(pts) {
            var i;
            var len = pts.length;
            var retPts = [];
            for(i = 0; i < len; i += 1)retPts[i] = inversePoint(pts[i]);
            return retPts;
        }
        function applyToTriplePoints(pt1, pt2, pt3) {
            var arr = createTypedArray('float32', 6);
            if (this.isIdentity()) {
                arr[0] = pt1[0];
                arr[1] = pt1[1];
                arr[2] = pt2[0];
                arr[3] = pt2[1];
                arr[4] = pt3[0];
                arr[5] = pt3[1];
            } else {
                var p0 = this.props[0];
                var p1 = this.props[1];
                var p4 = this.props[4];
                var p5 = this.props[5];
                var p12 = this.props[12];
                var p13 = this.props[13];
                arr[0] = pt1[0] * p0 + pt1[1] * p4 + p12;
                arr[1] = pt1[0] * p1 + pt1[1] * p5 + p13;
                arr[2] = pt2[0] * p0 + pt2[1] * p4 + p12;
                arr[3] = pt2[0] * p1 + pt2[1] * p5 + p13;
                arr[4] = pt3[0] * p0 + pt3[1] * p4 + p12;
                arr[5] = pt3[0] * p1 + pt3[1] * p5 + p13;
            }
            return arr;
        }
        function applyToPointArray(x, y, z) {
            var arr;
            if (this.isIdentity()) arr = [
                x,
                y,
                z
            ];
            else arr = [
                x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],
                x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],
                x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]
            ];
            return arr;
        }
        function applyToPointStringified(x, y) {
            if (this.isIdentity()) return x + ',' + y;
            var _p = this.props;
            return Math.round((x * _p[0] + y * _p[4] + _p[12]) * 100) / 100 + ',' + Math.round((x * _p[1] + y * _p[5] + _p[13]) * 100) / 100;
        }
        function toCSS() {
            // Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
            /* if(this.isIdentity()) {
              return '';
          } */ var i = 0;
            var props = this.props;
            var cssValue = 'matrix3d(';
            var v = 10000;
            while(i < 16){
                cssValue += _rnd(props[i] * v) / v;
                cssValue += i === 15 ? ')' : ',';
                i += 1;
            }
            return cssValue;
        }
        function roundMatrixProperty(val) {
            var v = 10000;
            if (val < 0.000001 && val > 0 || val > -0.000001 && val < 0) return _rnd(val * v) / v;
            return val;
        }
        function to2dCSS() {
            // Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
            /* if(this.isIdentity()) {
              return '';
          } */ var props = this.props;
            var _a = roundMatrixProperty(props[0]);
            var _b = roundMatrixProperty(props[1]);
            var _c = roundMatrixProperty(props[4]);
            var _d = roundMatrixProperty(props[5]);
            var _e = roundMatrixProperty(props[12]);
            var _f = roundMatrixProperty(props[13]);
            return 'matrix(' + _a + ',' + _b + ',' + _c + ',' + _d + ',' + _e + ',' + _f + ')';
        }
        return function() {
            this.reset = reset;
            this.rotate = rotate;
            this.rotateX = rotateX;
            this.rotateY = rotateY;
            this.rotateZ = rotateZ;
            this.skew = skew;
            this.skewFromAxis = skewFromAxis;
            this.shear = shear;
            this.scale = scale;
            this.setTransform = setTransform;
            this.translate = translate;
            this.transform = transform;
            this.multiply = multiply;
            this.applyToPoint = applyToPoint;
            this.applyToX = applyToX;
            this.applyToY = applyToY;
            this.applyToZ = applyToZ;
            this.applyToPointArray = applyToPointArray;
            this.applyToTriplePoints = applyToTriplePoints;
            this.applyToPointStringified = applyToPointStringified;
            this.toCSS = toCSS;
            this.to2dCSS = to2dCSS;
            this.clone = clone;
            this.cloneFromProps = cloneFromProps;
            this.equals = equals;
            this.inversePoints = inversePoints;
            this.inversePoint = inversePoint;
            this.getInverseMatrix = getInverseMatrix;
            this._t = this.transform;
            this.isIdentity = isIdentity;
            this._identity = true;
            this._identityCalculated = false;
            this.props = createTypedArray('float32', 16);
            this.reset();
        };
    }();
    function _typeof$3(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$3 = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof$3 = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof$3(obj);
    }
    var lottie = {};
    var standalone = '__[STANDALONE]__';
    var animationData = '__[ANIMATIONDATA]__';
    var renderer = '';
    function setLocation(href) {
        setLocationHref(href);
    }
    function searchAnimations() {
        if (standalone === true) animationManager.searchAnimations(animationData, standalone, renderer);
        else animationManager.searchAnimations();
    }
    function setSubframeRendering(flag) {
        setSubframeEnabled(flag);
    }
    function setPrefix(prefix) {
        setIdPrefix(prefix);
    }
    function loadAnimation(params) {
        if (standalone === true) params.animationData = JSON.parse(animationData);
        return animationManager.loadAnimation(params);
    }
    function setQuality(value) {
        if (typeof value === 'string') switch(value){
            case 'high':
                setDefaultCurveSegments(200);
                break;
            default:
            case 'medium':
                setDefaultCurveSegments(50);
                break;
            case 'low':
                setDefaultCurveSegments(10);
                break;
        }
        else if (!isNaN(value) && value > 1) setDefaultCurveSegments(value);
        if (getDefaultCurveSegments() >= 50) roundValues(false);
        else roundValues(true);
    }
    function inBrowser() {
        return typeof navigator !== 'undefined';
    }
    function installPlugin(type, plugin) {
        if (type === 'expressions') setExpressionsPlugin(plugin);
    }
    function getFactory(name) {
        switch(name){
            case 'propertyFactory':
                return PropertyFactory;
            case 'shapePropertyFactory':
                return ShapePropertyFactory;
            case 'matrix':
                return Matrix;
            default:
                return null;
        }
    }
    lottie.play = animationManager.play;
    lottie.pause = animationManager.pause;
    lottie.setLocationHref = setLocation;
    lottie.togglePause = animationManager.togglePause;
    lottie.setSpeed = animationManager.setSpeed;
    lottie.setDirection = animationManager.setDirection;
    lottie.stop = animationManager.stop;
    lottie.searchAnimations = searchAnimations;
    lottie.registerAnimation = animationManager.registerAnimation;
    lottie.loadAnimation = loadAnimation;
    lottie.setSubframeRendering = setSubframeRendering;
    lottie.resize = animationManager.resize; // lottie.start = start;
    lottie.goToAndStop = animationManager.goToAndStop;
    lottie.destroy = animationManager.destroy;
    lottie.setQuality = setQuality;
    lottie.inBrowser = inBrowser;
    lottie.installPlugin = installPlugin;
    lottie.freeze = animationManager.freeze;
    lottie.unfreeze = animationManager.unfreeze;
    lottie.setVolume = animationManager.setVolume;
    lottie.mute = animationManager.mute;
    lottie.unmute = animationManager.unmute;
    lottie.getRegisteredAnimations = animationManager.getRegisteredAnimations;
    lottie.useWebWorker = setWebWorker;
    lottie.setIDPrefix = setPrefix;
    lottie.__getFactory = getFactory;
    lottie.version = '5.12.2';
    function checkReady() {
        if (document.readyState === 'complete') {
            clearInterval(readyStateCheckInterval);
            searchAnimations();
        }
    }
    function getQueryVariable(variable) {
        var vars = queryString.split('&');
        for(var i = 0; i < vars.length; i += 1){
            var pair = vars[i].split('=');
            if (decodeURIComponent(pair[0]) == variable) // eslint-disable-line eqeqeq
            return decodeURIComponent(pair[1]);
        }
        return null;
    }
    var queryString = '';
    if (standalone) {
        var scripts = document.getElementsByTagName('script');
        var index = scripts.length - 1;
        var myScript = scripts[index] || {
            src: ''
        };
        queryString = myScript.src ? myScript.src.replace(/^[^\?]+\??/, '') : ''; // eslint-disable-line no-useless-escape
        renderer = getQueryVariable('renderer');
    }
    var readyStateCheckInterval = setInterval(checkReady, 100); // this adds bodymovin to the window object for backwards compatibility
    try {
        if (!(_typeof$3(exports) === 'object' && true) && !(typeof define === 'function' && define.amd // eslint-disable-line no-undef
        )) window.bodymovin = lottie;
    } catch (err) {}
    var ShapeModifiers = function() {
        var ob = {};
        var modifiers = {};
        ob.registerModifier = registerModifier;
        ob.getModifier = getModifier;
        function registerModifier(nm, factory) {
            if (!modifiers[nm]) modifiers[nm] = factory;
        }
        function getModifier(nm, elem, data) {
            return new modifiers[nm](elem, data);
        }
        return ob;
    }();
    function ShapeModifier() {}
    ShapeModifier.prototype.initModifierProperties = function() {};
    ShapeModifier.prototype.addShapeToModifier = function() {};
    ShapeModifier.prototype.addShape = function(data) {
        if (!this.closed) {
            // Adding shape to dynamic properties. It covers the case where a shape has no effects applied, to reset it's _mdf state on every tick.
            data.sh.container.addDynamicProperty(data.sh);
            var shapeData = {
                shape: data.sh,
                data: data,
                localShapeCollection: shapeCollectionPool.newShapeCollection()
            };
            this.shapes.push(shapeData);
            this.addShapeToModifier(shapeData);
            if (this._isAnimated) data.setAsAnimated();
        }
    };
    ShapeModifier.prototype.init = function(elem, data) {
        this.shapes = [];
        this.elem = elem;
        this.initDynamicPropertyContainer(elem);
        this.initModifierProperties(elem, data);
        this.frameId = initialDefaultFrame;
        this.closed = false;
        this.k = false;
        if (this.dynamicProperties.length) this.k = true;
        else this.getValue(true);
    };
    ShapeModifier.prototype.processKeys = function() {
        if (this.elem.globalData.frameId === this.frameId) return;
        this.frameId = this.elem.globalData.frameId;
        this.iterateDynamicProperties();
    };
    extendPrototype([
        DynamicPropertyContainer
    ], ShapeModifier);
    function TrimModifier() {}
    extendPrototype([
        ShapeModifier
    ], TrimModifier);
    TrimModifier.prototype.initModifierProperties = function(elem, data) {
        this.s = PropertyFactory.getProp(elem, data.s, 0, 0.01, this);
        this.e = PropertyFactory.getProp(elem, data.e, 0, 0.01, this);
        this.o = PropertyFactory.getProp(elem, data.o, 0, 0, this);
        this.sValue = 0;
        this.eValue = 0;
        this.getValue = this.processKeys;
        this.m = data.m;
        this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
    };
    TrimModifier.prototype.addShapeToModifier = function(shapeData) {
        shapeData.pathsData = [];
    };
    TrimModifier.prototype.calculateShapeEdges = function(s, e, shapeLength, addedLength, totalModifierLength) {
        var segments = [];
        if (e <= 1) segments.push({
            s: s,
            e: e
        });
        else if (s >= 1) segments.push({
            s: s - 1,
            e: e - 1
        });
        else {
            segments.push({
                s: s,
                e: 1
            });
            segments.push({
                s: 0,
                e: e - 1
            });
        }
        var shapeSegments = [];
        var i;
        var len = segments.length;
        var segmentOb;
        for(i = 0; i < len; i += 1){
            segmentOb = segments[i];
            if (!(segmentOb.e * totalModifierLength < addedLength || segmentOb.s * totalModifierLength > addedLength + shapeLength)) {
                var shapeS;
                var shapeE;
                if (segmentOb.s * totalModifierLength <= addedLength) shapeS = 0;
                else shapeS = (segmentOb.s * totalModifierLength - addedLength) / shapeLength;
                if (segmentOb.e * totalModifierLength >= addedLength + shapeLength) shapeE = 1;
                else shapeE = (segmentOb.e * totalModifierLength - addedLength) / shapeLength;
                shapeSegments.push([
                    shapeS,
                    shapeE
                ]);
            }
        }
        if (!shapeSegments.length) shapeSegments.push([
            0,
            0
        ]);
        return shapeSegments;
    };
    TrimModifier.prototype.releasePathsData = function(pathsData) {
        var i;
        var len = pathsData.length;
        for(i = 0; i < len; i += 1)segmentsLengthPool.release(pathsData[i]);
        pathsData.length = 0;
        return pathsData;
    };
    TrimModifier.prototype.processShapes = function(_isFirstFrame) {
        var s;
        var e;
        if (this._mdf || _isFirstFrame) {
            var o = this.o.v % 360 / 360;
            if (o < 0) o += 1;
            if (this.s.v > 1) s = 1 + o;
            else if (this.s.v < 0) s = 0 + o;
            else s = this.s.v + o;
            if (this.e.v > 1) e = 1 + o;
            else if (this.e.v < 0) e = 0 + o;
            else e = this.e.v + o;
            if (s > e) {
                var _s = s;
                s = e;
                e = _s;
            }
            s = Math.round(s * 10000) * 0.0001;
            e = Math.round(e * 10000) * 0.0001;
            this.sValue = s;
            this.eValue = e;
        } else {
            s = this.sValue;
            e = this.eValue;
        }
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var pathsData;
        var pathData;
        var totalShapeLength;
        var totalModifierLength = 0;
        if (e === s) for(i = 0; i < len; i += 1){
            this.shapes[i].localShapeCollection.releaseShapes();
            this.shapes[i].shape._mdf = true;
            this.shapes[i].shape.paths = this.shapes[i].localShapeCollection;
            if (this._mdf) this.shapes[i].pathsData.length = 0;
        }
        else if (!(e === 1 && s === 0 || e === 0 && s === 1)) {
            var segments = [];
            var shapeData;
            var localShapeCollection;
            for(i = 0; i < len; i += 1){
                shapeData = this.shapes[i]; // if shape hasn't changed and trim properties haven't changed, cached previous path can be used
                if (!shapeData.shape._mdf && !this._mdf && !_isFirstFrame && this.m !== 2) shapeData.shape.paths = shapeData.localShapeCollection;
                else {
                    shapePaths = shapeData.shape.paths;
                    jLen = shapePaths._length;
                    totalShapeLength = 0;
                    if (!shapeData.shape._mdf && shapeData.pathsData.length) totalShapeLength = shapeData.totalShapeLength;
                    else {
                        pathsData = this.releasePathsData(shapeData.pathsData);
                        for(j = 0; j < jLen; j += 1){
                            pathData = bez.getSegmentsLength(shapePaths.shapes[j]);
                            pathsData.push(pathData);
                            totalShapeLength += pathData.totalLength;
                        }
                        shapeData.totalShapeLength = totalShapeLength;
                        shapeData.pathsData = pathsData;
                    }
                    totalModifierLength += totalShapeLength;
                    shapeData.shape._mdf = true;
                }
            }
            var shapeS = s;
            var shapeE = e;
            var addedLength = 0;
            var edges;
            for(i = len - 1; i >= 0; i -= 1){
                shapeData = this.shapes[i];
                if (shapeData.shape._mdf) {
                    localShapeCollection = shapeData.localShapeCollection;
                    localShapeCollection.releaseShapes(); // if m === 2 means paths are trimmed individually so edges need to be found for this specific shape relative to whoel group
                    if (this.m === 2 && len > 1) {
                        edges = this.calculateShapeEdges(s, e, shapeData.totalShapeLength, addedLength, totalModifierLength);
                        addedLength += shapeData.totalShapeLength;
                    } else edges = [
                        [
                            shapeS,
                            shapeE
                        ]
                    ];
                    jLen = edges.length;
                    for(j = 0; j < jLen; j += 1){
                        shapeS = edges[j][0];
                        shapeE = edges[j][1];
                        segments.length = 0;
                        if (shapeE <= 1) segments.push({
                            s: shapeData.totalShapeLength * shapeS,
                            e: shapeData.totalShapeLength * shapeE
                        });
                        else if (shapeS >= 1) segments.push({
                            s: shapeData.totalShapeLength * (shapeS - 1),
                            e: shapeData.totalShapeLength * (shapeE - 1)
                        });
                        else {
                            segments.push({
                                s: shapeData.totalShapeLength * shapeS,
                                e: shapeData.totalShapeLength
                            });
                            segments.push({
                                s: 0,
                                e: shapeData.totalShapeLength * (shapeE - 1)
                            });
                        }
                        var newShapesData = this.addShapes(shapeData, segments[0]);
                        if (segments[0].s !== segments[0].e) {
                            if (segments.length > 1) {
                                var lastShapeInCollection = shapeData.shape.paths.shapes[shapeData.shape.paths._length - 1];
                                if (lastShapeInCollection.c) {
                                    var lastShape = newShapesData.pop();
                                    this.addPaths(newShapesData, localShapeCollection);
                                    newShapesData = this.addShapes(shapeData, segments[1], lastShape);
                                } else {
                                    this.addPaths(newShapesData, localShapeCollection);
                                    newShapesData = this.addShapes(shapeData, segments[1]);
                                }
                            }
                            this.addPaths(newShapesData, localShapeCollection);
                        }
                    }
                    shapeData.shape.paths = localShapeCollection;
                }
            }
        } else if (this._mdf) for(i = 0; i < len; i += 1){
            // Releasign Trim Cached paths data when no trim applied in case shapes are modified inbetween.
            // Don't remove this even if it's losing cached info.
            this.shapes[i].pathsData.length = 0;
            this.shapes[i].shape._mdf = true;
        }
    };
    TrimModifier.prototype.addPaths = function(newPaths, localShapeCollection) {
        var i;
        var len = newPaths.length;
        for(i = 0; i < len; i += 1)localShapeCollection.addShape(newPaths[i]);
    };
    TrimModifier.prototype.addSegment = function(pt1, pt2, pt3, pt4, shapePath, pos, newShape) {
        shapePath.setXYAt(pt2[0], pt2[1], 'o', pos);
        shapePath.setXYAt(pt3[0], pt3[1], 'i', pos + 1);
        if (newShape) shapePath.setXYAt(pt1[0], pt1[1], 'v', pos);
        shapePath.setXYAt(pt4[0], pt4[1], 'v', pos + 1);
    };
    TrimModifier.prototype.addSegmentFromArray = function(points, shapePath, pos, newShape) {
        shapePath.setXYAt(points[1], points[5], 'o', pos);
        shapePath.setXYAt(points[2], points[6], 'i', pos + 1);
        if (newShape) shapePath.setXYAt(points[0], points[4], 'v', pos);
        shapePath.setXYAt(points[3], points[7], 'v', pos + 1);
    };
    TrimModifier.prototype.addShapes = function(shapeData, shapeSegment, shapePath) {
        var pathsData = shapeData.pathsData;
        var shapePaths = shapeData.shape.paths.shapes;
        var i;
        var len = shapeData.shape.paths._length;
        var j;
        var jLen;
        var addedLength = 0;
        var currentLengthData;
        var segmentCount;
        var lengths;
        var segment;
        var shapes = [];
        var initPos;
        var newShape = true;
        if (!shapePath) {
            shapePath = shapePool.newElement();
            segmentCount = 0;
            initPos = 0;
        } else {
            segmentCount = shapePath._length;
            initPos = shapePath._length;
        }
        shapes.push(shapePath);
        for(i = 0; i < len; i += 1){
            lengths = pathsData[i].lengths;
            shapePath.c = shapePaths[i].c;
            jLen = shapePaths[i].c ? lengths.length : lengths.length + 1;
            for(j = 1; j < jLen; j += 1){
                currentLengthData = lengths[j - 1];
                if (addedLength + currentLengthData.addedLength < shapeSegment.s) {
                    addedLength += currentLengthData.addedLength;
                    shapePath.c = false;
                } else if (addedLength > shapeSegment.e) {
                    shapePath.c = false;
                    break;
                } else {
                    if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + currentLengthData.addedLength) {
                        this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[j], shapePaths[i].v[j], shapePath, segmentCount, newShape);
                        newShape = false;
                    } else {
                        segment = bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[j], shapePaths[i].o[j - 1], shapePaths[i].i[j], (shapeSegment.s - addedLength) / currentLengthData.addedLength, (shapeSegment.e - addedLength) / currentLengthData.addedLength, lengths[j - 1]);
                        this.addSegmentFromArray(segment, shapePath, segmentCount, newShape); // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);
                        newShape = false;
                        shapePath.c = false;
                    }
                    addedLength += currentLengthData.addedLength;
                    segmentCount += 1;
                }
            }
            if (shapePaths[i].c && lengths.length) {
                currentLengthData = lengths[j - 1];
                if (addedLength <= shapeSegment.e) {
                    var segmentLength = lengths[j - 1].addedLength;
                    if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + segmentLength) {
                        this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[0], shapePaths[i].v[0], shapePath, segmentCount, newShape);
                        newShape = false;
                    } else {
                        segment = bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[0], shapePaths[i].o[j - 1], shapePaths[i].i[0], (shapeSegment.s - addedLength) / segmentLength, (shapeSegment.e - addedLength) / segmentLength, lengths[j - 1]);
                        this.addSegmentFromArray(segment, shapePath, segmentCount, newShape); // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);
                        newShape = false;
                        shapePath.c = false;
                    }
                } else shapePath.c = false;
                addedLength += currentLengthData.addedLength;
                segmentCount += 1;
            }
            if (shapePath._length) {
                shapePath.setXYAt(shapePath.v[initPos][0], shapePath.v[initPos][1], 'i', initPos);
                shapePath.setXYAt(shapePath.v[shapePath._length - 1][0], shapePath.v[shapePath._length - 1][1], 'o', shapePath._length - 1);
            }
            if (addedLength > shapeSegment.e) break;
            if (i < len - 1) {
                shapePath = shapePool.newElement();
                newShape = true;
                shapes.push(shapePath);
                segmentCount = 0;
            }
        }
        return shapes;
    };
    function PuckerAndBloatModifier() {}
    extendPrototype([
        ShapeModifier
    ], PuckerAndBloatModifier);
    PuckerAndBloatModifier.prototype.initModifierProperties = function(elem, data) {
        this.getValue = this.processKeys;
        this.amount = PropertyFactory.getProp(elem, data.a, 0, null, this);
        this._isAnimated = !!this.amount.effectsSequence.length;
    };
    PuckerAndBloatModifier.prototype.processPath = function(path, amount) {
        var percent = amount / 100;
        var centerPoint = [
            0,
            0
        ];
        var pathLength = path._length;
        var i = 0;
        for(i = 0; i < pathLength; i += 1){
            centerPoint[0] += path.v[i][0];
            centerPoint[1] += path.v[i][1];
        }
        centerPoint[0] /= pathLength;
        centerPoint[1] /= pathLength;
        var clonedPath = shapePool.newElement();
        clonedPath.c = path.c;
        var vX;
        var vY;
        var oX;
        var oY;
        var iX;
        var iY;
        for(i = 0; i < pathLength; i += 1){
            vX = path.v[i][0] + (centerPoint[0] - path.v[i][0]) * percent;
            vY = path.v[i][1] + (centerPoint[1] - path.v[i][1]) * percent;
            oX = path.o[i][0] + (centerPoint[0] - path.o[i][0]) * -percent;
            oY = path.o[i][1] + (centerPoint[1] - path.o[i][1]) * -percent;
            iX = path.i[i][0] + (centerPoint[0] - path.i[i][0]) * -percent;
            iY = path.i[i][1] + (centerPoint[1] - path.i[i][1]) * -percent;
            clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, i);
        }
        return clonedPath;
    };
    PuckerAndBloatModifier.prototype.processShapes = function(_isFirstFrame) {
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var amount = this.amount.v;
        if (amount !== 0) {
            var shapeData;
            var localShapeCollection;
            for(i = 0; i < len; i += 1){
                shapeData = this.shapes[i];
                localShapeCollection = shapeData.localShapeCollection;
                if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
                    localShapeCollection.releaseShapes();
                    shapeData.shape._mdf = true;
                    shapePaths = shapeData.shape.paths.shapes;
                    jLen = shapeData.shape.paths._length;
                    for(j = 0; j < jLen; j += 1)localShapeCollection.addShape(this.processPath(shapePaths[j], amount));
                }
                shapeData.shape.paths = shapeData.localShapeCollection;
            }
        }
        if (!this.dynamicProperties.length) this._mdf = false;
    };
    var TransformPropertyFactory = function() {
        var defaultVector = [
            0,
            0
        ];
        function applyToMatrix(mat) {
            var _mdf = this._mdf;
            this.iterateDynamicProperties();
            this._mdf = this._mdf || _mdf;
            if (this.a) mat.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
            if (this.s) mat.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
            if (this.sk) mat.skewFromAxis(-this.sk.v, this.sa.v);
            if (this.r) mat.rotate(-this.r.v);
            else mat.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
            if (this.data.p.s) {
                if (this.data.p.z) mat.translate(this.px.v, this.py.v, -this.pz.v);
                else mat.translate(this.px.v, this.py.v, 0);
            } else mat.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
        }
        function processKeys(forceRender) {
            if (this.elem.globalData.frameId === this.frameId) return;
            if (this._isDirty) {
                this.precalculateMatrix();
                this._isDirty = false;
            }
            this.iterateDynamicProperties();
            if (this._mdf || forceRender) {
                var frameRate;
                this.v.cloneFromProps(this.pre.props);
                if (this.appliedTransformations < 1) this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
                if (this.appliedTransformations < 2) this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
                if (this.sk && this.appliedTransformations < 3) this.v.skewFromAxis(-this.sk.v, this.sa.v);
                if (this.r && this.appliedTransformations < 4) this.v.rotate(-this.r.v);
                else if (!this.r && this.appliedTransformations < 4) this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
                if (this.autoOriented) {
                    var v1;
                    var v2;
                    frameRate = this.elem.globalData.frameRate;
                    if (this.p && this.p.keyframes && this.p.getValueAtTime) {
                        if (this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t) {
                            v1 = this.p.getValueAtTime((this.p.keyframes[0].t + 0.01) / frameRate, 0);
                            v2 = this.p.getValueAtTime(this.p.keyframes[0].t / frameRate, 0);
                        } else if (this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t) {
                            v1 = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / frameRate, 0);
                            v2 = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - 0.05) / frameRate, 0);
                        } else {
                            v1 = this.p.pv;
                            v2 = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - 0.01) / frameRate, this.p.offsetTime);
                        }
                    } else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
                        v1 = [];
                        v2 = [];
                        var px = this.px;
                        var py = this.py;
                        if (px._caching.lastFrame + px.offsetTime <= px.keyframes[0].t) {
                            v1[0] = px.getValueAtTime((px.keyframes[0].t + 0.01) / frameRate, 0);
                            v1[1] = py.getValueAtTime((py.keyframes[0].t + 0.01) / frameRate, 0);
                            v2[0] = px.getValueAtTime(px.keyframes[0].t / frameRate, 0);
                            v2[1] = py.getValueAtTime(py.keyframes[0].t / frameRate, 0);
                        } else if (px._caching.lastFrame + px.offsetTime >= px.keyframes[px.keyframes.length - 1].t) {
                            v1[0] = px.getValueAtTime(px.keyframes[px.keyframes.length - 1].t / frameRate, 0);
                            v1[1] = py.getValueAtTime(py.keyframes[py.keyframes.length - 1].t / frameRate, 0);
                            v2[0] = px.getValueAtTime((px.keyframes[px.keyframes.length - 1].t - 0.01) / frameRate, 0);
                            v2[1] = py.getValueAtTime((py.keyframes[py.keyframes.length - 1].t - 0.01) / frameRate, 0);
                        } else {
                            v1 = [
                                px.pv,
                                py.pv
                            ];
                            v2[0] = px.getValueAtTime((px._caching.lastFrame + px.offsetTime - 0.01) / frameRate, px.offsetTime);
                            v2[1] = py.getValueAtTime((py._caching.lastFrame + py.offsetTime - 0.01) / frameRate, py.offsetTime);
                        }
                    } else {
                        v2 = defaultVector;
                        v1 = v2;
                    }
                    this.v.rotate(-Math.atan2(v1[1] - v2[1], v1[0] - v2[0]));
                }
                if (this.data.p && this.data.p.s) {
                    if (this.data.p.z) this.v.translate(this.px.v, this.py.v, -this.pz.v);
                    else this.v.translate(this.px.v, this.py.v, 0);
                } else this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
            }
            this.frameId = this.elem.globalData.frameId;
        }
        function precalculateMatrix() {
            this.appliedTransformations = 0;
            this.pre.reset();
            if (!this.a.effectsSequence.length) {
                this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
                this.appliedTransformations = 1;
            } else return;
            if (!this.s.effectsSequence.length) {
                this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
                this.appliedTransformations = 2;
            } else return;
            if (this.sk) {
                if (!this.sk.effectsSequence.length && !this.sa.effectsSequence.length) {
                    this.pre.skewFromAxis(-this.sk.v, this.sa.v);
                    this.appliedTransformations = 3;
                } else return;
            }
            if (this.r) {
                if (!this.r.effectsSequence.length) {
                    this.pre.rotate(-this.r.v);
                    this.appliedTransformations = 4;
                }
            } else if (!this.rz.effectsSequence.length && !this.ry.effectsSequence.length && !this.rx.effectsSequence.length && !this.or.effectsSequence.length) {
                this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
                this.appliedTransformations = 4;
            }
        }
        function autoOrient() {
        // var prevP = this.getValueAtTime();
        }
        function addDynamicProperty(prop) {
            this._addDynamicProperty(prop);
            this.elem.addDynamicProperty(prop);
            this._isDirty = true;
        }
        function TransformProperty(elem, data, container) {
            this.elem = elem;
            this.frameId = -1;
            this.propType = 'transform';
            this.data = data;
            this.v = new Matrix(); // Precalculated matrix with non animated properties
            this.pre = new Matrix();
            this.appliedTransformations = 0;
            this.initDynamicPropertyContainer(container || elem);
            if (data.p && data.p.s) {
                this.px = PropertyFactory.getProp(elem, data.p.x, 0, 0, this);
                this.py = PropertyFactory.getProp(elem, data.p.y, 0, 0, this);
                if (data.p.z) this.pz = PropertyFactory.getProp(elem, data.p.z, 0, 0, this);
            } else this.p = PropertyFactory.getProp(elem, data.p || {
                k: [
                    0,
                    0,
                    0
                ]
            }, 1, 0, this);
            if (data.rx) {
                this.rx = PropertyFactory.getProp(elem, data.rx, 0, degToRads, this);
                this.ry = PropertyFactory.getProp(elem, data.ry, 0, degToRads, this);
                this.rz = PropertyFactory.getProp(elem, data.rz, 0, degToRads, this);
                if (data.or.k[0].ti) {
                    var i;
                    var len = data.or.k.length;
                    for(i = 0; i < len; i += 1){
                        data.or.k[i].to = null;
                        data.or.k[i].ti = null;
                    }
                }
                this.or = PropertyFactory.getProp(elem, data.or, 1, degToRads, this); // sh Indicates it needs to be capped between -180 and 180
                this.or.sh = true;
            } else this.r = PropertyFactory.getProp(elem, data.r || {
                k: 0
            }, 0, degToRads, this);
            if (data.sk) {
                this.sk = PropertyFactory.getProp(elem, data.sk, 0, degToRads, this);
                this.sa = PropertyFactory.getProp(elem, data.sa, 0, degToRads, this);
            }
            this.a = PropertyFactory.getProp(elem, data.a || {
                k: [
                    0,
                    0,
                    0
                ]
            }, 1, 0, this);
            this.s = PropertyFactory.getProp(elem, data.s || {
                k: [
                    100,
                    100,
                    100
                ]
            }, 1, 0.01, this); // Opacity is not part of the transform properties, that's why it won't use this.dynamicProperties. That way transforms won't get updated if opacity changes.
            if (data.o) this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, elem);
            else this.o = {
                _mdf: false,
                v: 1
            };
            this._isDirty = true;
            if (!this.dynamicProperties.length) this.getValue(true);
        }
        TransformProperty.prototype = {
            applyToMatrix: applyToMatrix,
            getValue: processKeys,
            precalculateMatrix: precalculateMatrix,
            autoOrient: autoOrient
        };
        extendPrototype([
            DynamicPropertyContainer
        ], TransformProperty);
        TransformProperty.prototype.addDynamicProperty = addDynamicProperty;
        TransformProperty.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty;
        function getTransformProperty(elem, data, container) {
            return new TransformProperty(elem, data, container);
        }
        return {
            getTransformProperty: getTransformProperty
        };
    }();
    function RepeaterModifier() {}
    extendPrototype([
        ShapeModifier
    ], RepeaterModifier);
    RepeaterModifier.prototype.initModifierProperties = function(elem, data) {
        this.getValue = this.processKeys;
        this.c = PropertyFactory.getProp(elem, data.c, 0, null, this);
        this.o = PropertyFactory.getProp(elem, data.o, 0, null, this);
        this.tr = TransformPropertyFactory.getTransformProperty(elem, data.tr, this);
        this.so = PropertyFactory.getProp(elem, data.tr.so, 0, 0.01, this);
        this.eo = PropertyFactory.getProp(elem, data.tr.eo, 0, 0.01, this);
        this.data = data;
        if (!this.dynamicProperties.length) this.getValue(true);
        this._isAnimated = !!this.dynamicProperties.length;
        this.pMatrix = new Matrix();
        this.rMatrix = new Matrix();
        this.sMatrix = new Matrix();
        this.tMatrix = new Matrix();
        this.matrix = new Matrix();
    };
    RepeaterModifier.prototype.applyTransforms = function(pMatrix, rMatrix, sMatrix, transform, perc, inv) {
        var dir = inv ? -1 : 1;
        var scaleX = transform.s.v[0] + (1 - transform.s.v[0]) * (1 - perc);
        var scaleY = transform.s.v[1] + (1 - transform.s.v[1]) * (1 - perc);
        pMatrix.translate(transform.p.v[0] * dir * perc, transform.p.v[1] * dir * perc, transform.p.v[2]);
        rMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
        rMatrix.rotate(-transform.r.v * dir * perc);
        rMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
        sMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
        sMatrix.scale(inv ? 1 / scaleX : scaleX, inv ? 1 / scaleY : scaleY);
        sMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
    };
    RepeaterModifier.prototype.init = function(elem, arr, pos, elemsData) {
        this.elem = elem;
        this.arr = arr;
        this.pos = pos;
        this.elemsData = elemsData;
        this._currentCopies = 0;
        this._elements = [];
        this._groups = [];
        this.frameId = -1;
        this.initDynamicPropertyContainer(elem);
        this.initModifierProperties(elem, arr[pos]);
        while(pos > 0){
            pos -= 1; // this._elements.unshift(arr.splice(pos,1)[0]);
            this._elements.unshift(arr[pos]);
        }
        if (this.dynamicProperties.length) this.k = true;
        else this.getValue(true);
    };
    RepeaterModifier.prototype.resetElements = function(elements) {
        var i;
        var len = elements.length;
        for(i = 0; i < len; i += 1){
            elements[i]._processed = false;
            if (elements[i].ty === 'gr') this.resetElements(elements[i].it);
        }
    };
    RepeaterModifier.prototype.cloneElements = function(elements) {
        var newElements = JSON.parse(JSON.stringify(elements));
        this.resetElements(newElements);
        return newElements;
    };
    RepeaterModifier.prototype.changeGroupRender = function(elements, renderFlag) {
        var i;
        var len = elements.length;
        for(i = 0; i < len; i += 1){
            elements[i]._render = renderFlag;
            if (elements[i].ty === 'gr') this.changeGroupRender(elements[i].it, renderFlag);
        }
    };
    RepeaterModifier.prototype.processShapes = function(_isFirstFrame) {
        var items;
        var itemsTransform;
        var i;
        var dir;
        var cont;
        var hasReloaded = false;
        if (this._mdf || _isFirstFrame) {
            var copies = Math.ceil(this.c.v);
            if (this._groups.length < copies) {
                while(this._groups.length < copies){
                    var group = {
                        it: this.cloneElements(this._elements),
                        ty: 'gr'
                    };
                    group.it.push({
                        a: {
                            a: 0,
                            ix: 1,
                            k: [
                                0,
                                0
                            ]
                        },
                        nm: 'Transform',
                        o: {
                            a: 0,
                            ix: 7,
                            k: 100
                        },
                        p: {
                            a: 0,
                            ix: 2,
                            k: [
                                0,
                                0
                            ]
                        },
                        r: {
                            a: 1,
                            ix: 6,
                            k: [
                                {
                                    s: 0,
                                    e: 0,
                                    t: 0
                                },
                                {
                                    s: 0,
                                    e: 0,
                                    t: 1
                                }
                            ]
                        },
                        s: {
                            a: 0,
                            ix: 3,
                            k: [
                                100,
                                100
                            ]
                        },
                        sa: {
                            a: 0,
                            ix: 5,
                            k: 0
                        },
                        sk: {
                            a: 0,
                            ix: 4,
                            k: 0
                        },
                        ty: 'tr'
                    });
                    this.arr.splice(0, 0, group);
                    this._groups.splice(0, 0, group);
                    this._currentCopies += 1;
                }
                this.elem.reloadShapes();
                hasReloaded = true;
            }
            cont = 0;
            var renderFlag;
            for(i = 0; i <= this._groups.length - 1; i += 1){
                renderFlag = cont < copies;
                this._groups[i]._render = renderFlag;
                this.changeGroupRender(this._groups[i].it, renderFlag);
                if (!renderFlag) {
                    var elems = this.elemsData[i].it;
                    var transformData = elems[elems.length - 1];
                    if (transformData.transform.op.v !== 0) {
                        transformData.transform.op._mdf = true;
                        transformData.transform.op.v = 0;
                    } else transformData.transform.op._mdf = false;
                }
                cont += 1;
            }
            this._currentCopies = copies; /// /
            var offset = this.o.v;
            var offsetModulo = offset % 1;
            var roundOffset = offset > 0 ? Math.floor(offset) : Math.ceil(offset);
            var pProps = this.pMatrix.props;
            var rProps = this.rMatrix.props;
            var sProps = this.sMatrix.props;
            this.pMatrix.reset();
            this.rMatrix.reset();
            this.sMatrix.reset();
            this.tMatrix.reset();
            this.matrix.reset();
            var iteration = 0;
            if (offset > 0) {
                while(iteration < roundOffset){
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
                    iteration += 1;
                }
                if (offsetModulo) {
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, offsetModulo, false);
                    iteration += offsetModulo;
                }
            } else if (offset < 0) {
                while(iteration > roundOffset){
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, true);
                    iteration -= 1;
                }
                if (offsetModulo) {
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -offsetModulo, true);
                    iteration -= offsetModulo;
                }
            }
            i = this.data.m === 1 ? 0 : this._currentCopies - 1;
            dir = this.data.m === 1 ? 1 : -1;
            cont = this._currentCopies;
            var j;
            var jLen;
            while(cont){
                items = this.elemsData[i].it;
                itemsTransform = items[items.length - 1].transform.mProps.v.props;
                jLen = itemsTransform.length;
                items[items.length - 1].transform.mProps._mdf = true;
                items[items.length - 1].transform.op._mdf = true;
                items[items.length - 1].transform.op.v = this._currentCopies === 1 ? this.so.v : this.so.v + (this.eo.v - this.so.v) * (i / (this._currentCopies - 1));
                if (iteration !== 0) {
                    if (i !== 0 && dir === 1 || i !== this._currentCopies - 1 && dir === -1) this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
                    this.matrix.transform(rProps[0], rProps[1], rProps[2], rProps[3], rProps[4], rProps[5], rProps[6], rProps[7], rProps[8], rProps[9], rProps[10], rProps[11], rProps[12], rProps[13], rProps[14], rProps[15]);
                    this.matrix.transform(sProps[0], sProps[1], sProps[2], sProps[3], sProps[4], sProps[5], sProps[6], sProps[7], sProps[8], sProps[9], sProps[10], sProps[11], sProps[12], sProps[13], sProps[14], sProps[15]);
                    this.matrix.transform(pProps[0], pProps[1], pProps[2], pProps[3], pProps[4], pProps[5], pProps[6], pProps[7], pProps[8], pProps[9], pProps[10], pProps[11], pProps[12], pProps[13], pProps[14], pProps[15]);
                    for(j = 0; j < jLen; j += 1)itemsTransform[j] = this.matrix.props[j];
                    this.matrix.reset();
                } else {
                    this.matrix.reset();
                    for(j = 0; j < jLen; j += 1)itemsTransform[j] = this.matrix.props[j];
                }
                iteration += 1;
                cont -= 1;
                i += dir;
            }
        } else {
            cont = this._currentCopies;
            i = 0;
            dir = 1;
            while(cont){
                items = this.elemsData[i].it;
                itemsTransform = items[items.length - 1].transform.mProps.v.props;
                items[items.length - 1].transform.mProps._mdf = false;
                items[items.length - 1].transform.op._mdf = false;
                cont -= 1;
                i += dir;
            }
        }
        return hasReloaded;
    };
    RepeaterModifier.prototype.addShape = function() {};
    function RoundCornersModifier() {}
    extendPrototype([
        ShapeModifier
    ], RoundCornersModifier);
    RoundCornersModifier.prototype.initModifierProperties = function(elem, data) {
        this.getValue = this.processKeys;
        this.rd = PropertyFactory.getProp(elem, data.r, 0, null, this);
        this._isAnimated = !!this.rd.effectsSequence.length;
    };
    RoundCornersModifier.prototype.processPath = function(path, round) {
        var clonedPath = shapePool.newElement();
        clonedPath.c = path.c;
        var i;
        var len = path._length;
        var currentV;
        var currentI;
        var currentO;
        var closerV;
        var distance;
        var newPosPerc;
        var index = 0;
        var vX;
        var vY;
        var oX;
        var oY;
        var iX;
        var iY;
        for(i = 0; i < len; i += 1){
            currentV = path.v[i];
            currentO = path.o[i];
            currentI = path.i[i];
            if (currentV[0] === currentO[0] && currentV[1] === currentO[1] && currentV[0] === currentI[0] && currentV[1] === currentI[1]) {
                if ((i === 0 || i === len - 1) && !path.c) {
                    clonedPath.setTripleAt(currentV[0], currentV[1], currentO[0], currentO[1], currentI[0], currentI[1], index);
                    /* clonedPath.v[index] = currentV;
                  clonedPath.o[index] = currentO;
                  clonedPath.i[index] = currentI; */ index += 1;
                } else {
                    if (i === 0) closerV = path.v[len - 1];
                    else closerV = path.v[i - 1];
                    distance = Math.sqrt(Math.pow(currentV[0] - closerV[0], 2) + Math.pow(currentV[1] - closerV[1], 2));
                    newPosPerc = distance ? Math.min(distance / 2, round) / distance : 0;
                    iX = currentV[0] + (closerV[0] - currentV[0]) * newPosPerc;
                    vX = iX;
                    iY = currentV[1] - (currentV[1] - closerV[1]) * newPosPerc;
                    vY = iY;
                    oX = vX - (vX - currentV[0]) * roundCorner;
                    oY = vY - (vY - currentV[1]) * roundCorner;
                    clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, index);
                    index += 1;
                    if (i === len - 1) closerV = path.v[0];
                    else closerV = path.v[i + 1];
                    distance = Math.sqrt(Math.pow(currentV[0] - closerV[0], 2) + Math.pow(currentV[1] - closerV[1], 2));
                    newPosPerc = distance ? Math.min(distance / 2, round) / distance : 0;
                    oX = currentV[0] + (closerV[0] - currentV[0]) * newPosPerc;
                    vX = oX;
                    oY = currentV[1] + (closerV[1] - currentV[1]) * newPosPerc;
                    vY = oY;
                    iX = vX - (vX - currentV[0]) * roundCorner;
                    iY = vY - (vY - currentV[1]) * roundCorner;
                    clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, index);
                    index += 1;
                }
            } else {
                clonedPath.setTripleAt(path.v[i][0], path.v[i][1], path.o[i][0], path.o[i][1], path.i[i][0], path.i[i][1], index);
                index += 1;
            }
        }
        return clonedPath;
    };
    RoundCornersModifier.prototype.processShapes = function(_isFirstFrame) {
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var rd = this.rd.v;
        if (rd !== 0) {
            var shapeData;
            var localShapeCollection;
            for(i = 0; i < len; i += 1){
                shapeData = this.shapes[i];
                localShapeCollection = shapeData.localShapeCollection;
                if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
                    localShapeCollection.releaseShapes();
                    shapeData.shape._mdf = true;
                    shapePaths = shapeData.shape.paths.shapes;
                    jLen = shapeData.shape.paths._length;
                    for(j = 0; j < jLen; j += 1)localShapeCollection.addShape(this.processPath(shapePaths[j], rd));
                }
                shapeData.shape.paths = shapeData.localShapeCollection;
            }
        }
        if (!this.dynamicProperties.length) this._mdf = false;
    };
    function floatEqual(a, b) {
        return Math.abs(a - b) * 100000 <= Math.min(Math.abs(a), Math.abs(b));
    }
    function floatZero(f) {
        return Math.abs(f) <= 0.00001;
    }
    function lerp(p0, p1, amount) {
        return p0 * (1 - amount) + p1 * amount;
    }
    function lerpPoint(p0, p1, amount) {
        return [
            lerp(p0[0], p1[0], amount),
            lerp(p0[1], p1[1], amount)
        ];
    }
    function quadRoots(a, b, c) {
        // no root
        if (a === 0) return [];
        var s = b * b - 4 * a * c; // Complex roots
        if (s < 0) return [];
        var singleRoot = -b / (2 * a); // 1 root
        if (s === 0) return [
            singleRoot
        ];
        var delta = Math.sqrt(s) / (2 * a); // 2 roots
        return [
            singleRoot - delta,
            singleRoot + delta
        ];
    }
    function polynomialCoefficients(p0, p1, p2, p3) {
        return [
            -p0 + 3 * p1 - 3 * p2 + p3,
            3 * p0 - 6 * p1 + 3 * p2,
            -3 * p0 + 3 * p1,
            p0
        ];
    }
    function singlePoint(p) {
        return new PolynomialBezier(p, p, p, p, false);
    }
    function PolynomialBezier(p0, p1, p2, p3, linearize) {
        if (linearize && pointEqual(p0, p1)) p1 = lerpPoint(p0, p3, 1 / 3);
        if (linearize && pointEqual(p2, p3)) p2 = lerpPoint(p0, p3, 2 / 3);
        var coeffx = polynomialCoefficients(p0[0], p1[0], p2[0], p3[0]);
        var coeffy = polynomialCoefficients(p0[1], p1[1], p2[1], p3[1]);
        this.a = [
            coeffx[0],
            coeffy[0]
        ];
        this.b = [
            coeffx[1],
            coeffy[1]
        ];
        this.c = [
            coeffx[2],
            coeffy[2]
        ];
        this.d = [
            coeffx[3],
            coeffy[3]
        ];
        this.points = [
            p0,
            p1,
            p2,
            p3
        ];
    }
    PolynomialBezier.prototype.point = function(t) {
        return [
            ((this.a[0] * t + this.b[0]) * t + this.c[0]) * t + this.d[0],
            ((this.a[1] * t + this.b[1]) * t + this.c[1]) * t + this.d[1]
        ];
    };
    PolynomialBezier.prototype.derivative = function(t) {
        return [
            (3 * t * this.a[0] + 2 * this.b[0]) * t + this.c[0],
            (3 * t * this.a[1] + 2 * this.b[1]) * t + this.c[1]
        ];
    };
    PolynomialBezier.prototype.tangentAngle = function(t) {
        var p = this.derivative(t);
        return Math.atan2(p[1], p[0]);
    };
    PolynomialBezier.prototype.normalAngle = function(t) {
        var p = this.derivative(t);
        return Math.atan2(p[0], p[1]);
    };
    PolynomialBezier.prototype.inflectionPoints = function() {
        var denom = this.a[1] * this.b[0] - this.a[0] * this.b[1];
        if (floatZero(denom)) return [];
        var tcusp = -0.5 * (this.a[1] * this.c[0] - this.a[0] * this.c[1]) / denom;
        var square = tcusp * tcusp - 1 / 3 * (this.b[1] * this.c[0] - this.b[0] * this.c[1]) / denom;
        if (square < 0) return [];
        var root = Math.sqrt(square);
        if (floatZero(root)) {
            if (root > 0 && root < 1) return [
                tcusp
            ];
            return [];
        }
        return [
            tcusp - root,
            tcusp + root
        ].filter(function(r) {
            return r > 0 && r < 1;
        });
    };
    PolynomialBezier.prototype.split = function(t) {
        if (t <= 0) return [
            singlePoint(this.points[0]),
            this
        ];
        if (t >= 1) return [
            this,
            singlePoint(this.points[this.points.length - 1])
        ];
        var p10 = lerpPoint(this.points[0], this.points[1], t);
        var p11 = lerpPoint(this.points[1], this.points[2], t);
        var p12 = lerpPoint(this.points[2], this.points[3], t);
        var p20 = lerpPoint(p10, p11, t);
        var p21 = lerpPoint(p11, p12, t);
        var p3 = lerpPoint(p20, p21, t);
        return [
            new PolynomialBezier(this.points[0], p10, p20, p3, true),
            new PolynomialBezier(p3, p21, p12, this.points[3], true)
        ];
    };
    function extrema(bez, comp) {
        var min = bez.points[0][comp];
        var max = bez.points[bez.points.length - 1][comp];
        if (min > max) {
            var e = max;
            max = min;
            min = e;
        } // Derivative roots to find min/max
        var f = quadRoots(3 * bez.a[comp], 2 * bez.b[comp], bez.c[comp]);
        for(var i = 0; i < f.length; i += 1)if (f[i] > 0 && f[i] < 1) {
            var val = bez.point(f[i])[comp];
            if (val < min) min = val;
            else if (val > max) max = val;
        }
        return {
            min: min,
            max: max
        };
    }
    PolynomialBezier.prototype.bounds = function() {
        return {
            x: extrema(this, 0),
            y: extrema(this, 1)
        };
    };
    PolynomialBezier.prototype.boundingBox = function() {
        var bounds = this.bounds();
        return {
            left: bounds.x.min,
            right: bounds.x.max,
            top: bounds.y.min,
            bottom: bounds.y.max,
            width: bounds.x.max - bounds.x.min,
            height: bounds.y.max - bounds.y.min,
            cx: (bounds.x.max + bounds.x.min) / 2,
            cy: (bounds.y.max + bounds.y.min) / 2
        };
    };
    function intersectData(bez, t1, t2) {
        var box = bez.boundingBox();
        return {
            cx: box.cx,
            cy: box.cy,
            width: box.width,
            height: box.height,
            bez: bez,
            t: (t1 + t2) / 2,
            t1: t1,
            t2: t2
        };
    }
    function splitData(data) {
        var split = data.bez.split(0.5);
        return [
            intersectData(split[0], data.t1, data.t),
            intersectData(split[1], data.t, data.t2)
        ];
    }
    function boxIntersect(b1, b2) {
        return Math.abs(b1.cx - b2.cx) * 2 < b1.width + b2.width && Math.abs(b1.cy - b2.cy) * 2 < b1.height + b2.height;
    }
    function intersectsImpl(d1, d2, depth, tolerance, intersections, maxRecursion) {
        if (!boxIntersect(d1, d2)) return;
        if (depth >= maxRecursion || d1.width <= tolerance && d1.height <= tolerance && d2.width <= tolerance && d2.height <= tolerance) {
            intersections.push([
                d1.t,
                d2.t
            ]);
            return;
        }
        var d1s = splitData(d1);
        var d2s = splitData(d2);
        intersectsImpl(d1s[0], d2s[0], depth + 1, tolerance, intersections, maxRecursion);
        intersectsImpl(d1s[0], d2s[1], depth + 1, tolerance, intersections, maxRecursion);
        intersectsImpl(d1s[1], d2s[0], depth + 1, tolerance, intersections, maxRecursion);
        intersectsImpl(d1s[1], d2s[1], depth + 1, tolerance, intersections, maxRecursion);
    }
    PolynomialBezier.prototype.intersections = function(other, tolerance, maxRecursion) {
        if (tolerance === undefined) tolerance = 2;
        if (maxRecursion === undefined) maxRecursion = 7;
        var intersections = [];
        intersectsImpl(intersectData(this, 0, 1), intersectData(other, 0, 1), 0, tolerance, intersections, maxRecursion);
        return intersections;
    };
    PolynomialBezier.shapeSegment = function(shapePath, index) {
        var nextIndex = (index + 1) % shapePath.length();
        return new PolynomialBezier(shapePath.v[index], shapePath.o[index], shapePath.i[nextIndex], shapePath.v[nextIndex], true);
    };
    PolynomialBezier.shapeSegmentInverted = function(shapePath, index) {
        var nextIndex = (index + 1) % shapePath.length();
        return new PolynomialBezier(shapePath.v[nextIndex], shapePath.i[nextIndex], shapePath.o[index], shapePath.v[index], true);
    };
    function crossProduct(a, b) {
        return [
            a[1] * b[2] - a[2] * b[1],
            a[2] * b[0] - a[0] * b[2],
            a[0] * b[1] - a[1] * b[0]
        ];
    }
    function lineIntersection(start1, end1, start2, end2) {
        var v1 = [
            start1[0],
            start1[1],
            1
        ];
        var v2 = [
            end1[0],
            end1[1],
            1
        ];
        var v3 = [
            start2[0],
            start2[1],
            1
        ];
        var v4 = [
            end2[0],
            end2[1],
            1
        ];
        var r = crossProduct(crossProduct(v1, v2), crossProduct(v3, v4));
        if (floatZero(r[2])) return null;
        return [
            r[0] / r[2],
            r[1] / r[2]
        ];
    }
    function polarOffset(p, angle, length) {
        return [
            p[0] + Math.cos(angle) * length,
            p[1] - Math.sin(angle) * length
        ];
    }
    function pointDistance(p1, p2) {
        return Math.hypot(p1[0] - p2[0], p1[1] - p2[1]);
    }
    function pointEqual(p1, p2) {
        return floatEqual(p1[0], p2[0]) && floatEqual(p1[1], p2[1]);
    }
    function ZigZagModifier() {}
    extendPrototype([
        ShapeModifier
    ], ZigZagModifier);
    ZigZagModifier.prototype.initModifierProperties = function(elem, data) {
        this.getValue = this.processKeys;
        this.amplitude = PropertyFactory.getProp(elem, data.s, 0, null, this);
        this.frequency = PropertyFactory.getProp(elem, data.r, 0, null, this);
        this.pointsType = PropertyFactory.getProp(elem, data.pt, 0, null, this);
        this._isAnimated = this.amplitude.effectsSequence.length !== 0 || this.frequency.effectsSequence.length !== 0 || this.pointsType.effectsSequence.length !== 0;
    };
    function setPoint(outputBezier, point, angle, direction, amplitude, outAmplitude, inAmplitude) {
        var angO = angle - Math.PI / 2;
        var angI = angle + Math.PI / 2;
        var px = point[0] + Math.cos(angle) * direction * amplitude;
        var py = point[1] - Math.sin(angle) * direction * amplitude;
        outputBezier.setTripleAt(px, py, px + Math.cos(angO) * outAmplitude, py - Math.sin(angO) * outAmplitude, px + Math.cos(angI) * inAmplitude, py - Math.sin(angI) * inAmplitude, outputBezier.length());
    }
    function getPerpendicularVector(pt1, pt2) {
        var vector = [
            pt2[0] - pt1[0],
            pt2[1] - pt1[1]
        ];
        var rot = -Math.PI * 0.5;
        var rotatedVector = [
            Math.cos(rot) * vector[0] - Math.sin(rot) * vector[1],
            Math.sin(rot) * vector[0] + Math.cos(rot) * vector[1]
        ];
        return rotatedVector;
    }
    function getProjectingAngle(path, cur) {
        var prevIndex = cur === 0 ? path.length() - 1 : cur - 1;
        var nextIndex = (cur + 1) % path.length();
        var prevPoint = path.v[prevIndex];
        var nextPoint = path.v[nextIndex];
        var pVector = getPerpendicularVector(prevPoint, nextPoint);
        return Math.atan2(0, 1) - Math.atan2(pVector[1], pVector[0]);
    }
    function zigZagCorner(outputBezier, path, cur, amplitude, frequency, pointType, direction) {
        var angle = getProjectingAngle(path, cur);
        var point = path.v[cur % path._length];
        var prevPoint = path.v[cur === 0 ? path._length - 1 : cur - 1];
        var nextPoint = path.v[(cur + 1) % path._length];
        var prevDist = pointType === 2 ? Math.sqrt(Math.pow(point[0] - prevPoint[0], 2) + Math.pow(point[1] - prevPoint[1], 2)) : 0;
        var nextDist = pointType === 2 ? Math.sqrt(Math.pow(point[0] - nextPoint[0], 2) + Math.pow(point[1] - nextPoint[1], 2)) : 0;
        setPoint(outputBezier, path.v[cur % path._length], angle, direction, amplitude, nextDist / ((frequency + 1) * 2), prevDist / ((frequency + 1) * 2), pointType);
    }
    function zigZagSegment(outputBezier, segment, amplitude, frequency, pointType, direction) {
        for(var i = 0; i < frequency; i += 1){
            var t = (i + 1) / (frequency + 1);
            var dist = pointType === 2 ? Math.sqrt(Math.pow(segment.points[3][0] - segment.points[0][0], 2) + Math.pow(segment.points[3][1] - segment.points[0][1], 2)) : 0;
            var angle = segment.normalAngle(t);
            var point = segment.point(t);
            setPoint(outputBezier, point, angle, direction, amplitude, dist / ((frequency + 1) * 2), dist / ((frequency + 1) * 2), pointType);
            direction = -direction;
        }
        return direction;
    }
    ZigZagModifier.prototype.processPath = function(path, amplitude, frequency, pointType) {
        var count = path._length;
        var clonedPath = shapePool.newElement();
        clonedPath.c = path.c;
        if (!path.c) count -= 1;
        if (count === 0) return clonedPath;
        var direction = -1;
        var segment = PolynomialBezier.shapeSegment(path, 0);
        zigZagCorner(clonedPath, path, 0, amplitude, frequency, pointType, direction);
        for(var i = 0; i < count; i += 1){
            direction = zigZagSegment(clonedPath, segment, amplitude, frequency, pointType, -direction);
            if (i === count - 1 && !path.c) segment = null;
            else segment = PolynomialBezier.shapeSegment(path, (i + 1) % count);
            zigZagCorner(clonedPath, path, i + 1, amplitude, frequency, pointType, direction);
        }
        return clonedPath;
    };
    ZigZagModifier.prototype.processShapes = function(_isFirstFrame) {
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var amplitude = this.amplitude.v;
        var frequency = Math.max(0, Math.round(this.frequency.v));
        var pointType = this.pointsType.v;
        if (amplitude !== 0) {
            var shapeData;
            var localShapeCollection;
            for(i = 0; i < len; i += 1){
                shapeData = this.shapes[i];
                localShapeCollection = shapeData.localShapeCollection;
                if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
                    localShapeCollection.releaseShapes();
                    shapeData.shape._mdf = true;
                    shapePaths = shapeData.shape.paths.shapes;
                    jLen = shapeData.shape.paths._length;
                    for(j = 0; j < jLen; j += 1)localShapeCollection.addShape(this.processPath(shapePaths[j], amplitude, frequency, pointType));
                }
                shapeData.shape.paths = shapeData.localShapeCollection;
            }
        }
        if (!this.dynamicProperties.length) this._mdf = false;
    };
    function linearOffset(p1, p2, amount) {
        var angle = Math.atan2(p2[0] - p1[0], p2[1] - p1[1]);
        return [
            polarOffset(p1, angle, amount),
            polarOffset(p2, angle, amount)
        ];
    }
    function offsetSegment(segment, amount) {
        var p0;
        var p1a;
        var p1b;
        var p2b;
        var p2a;
        var p3;
        var e;
        e = linearOffset(segment.points[0], segment.points[1], amount);
        p0 = e[0];
        p1a = e[1];
        e = linearOffset(segment.points[1], segment.points[2], amount);
        p1b = e[0];
        p2b = e[1];
        e = linearOffset(segment.points[2], segment.points[3], amount);
        p2a = e[0];
        p3 = e[1];
        var p1 = lineIntersection(p0, p1a, p1b, p2b);
        if (p1 === null) p1 = p1a;
        var p2 = lineIntersection(p2a, p3, p1b, p2b);
        if (p2 === null) p2 = p2a;
        return new PolynomialBezier(p0, p1, p2, p3);
    }
    function joinLines(outputBezier, seg1, seg2, lineJoin, miterLimit) {
        var p0 = seg1.points[3];
        var p1 = seg2.points[0]; // Bevel
        if (lineJoin === 3) return p0; // Connected, they don't need a joint
        if (pointEqual(p0, p1)) return p0; // Round
        if (lineJoin === 2) {
            var angleOut = -seg1.tangentAngle(1);
            var angleIn = -seg2.tangentAngle(0) + Math.PI;
            var center = lineIntersection(p0, polarOffset(p0, angleOut + Math.PI / 2, 100), p1, polarOffset(p1, angleOut + Math.PI / 2, 100));
            var radius = center ? pointDistance(center, p0) : pointDistance(p0, p1) / 2;
            var tan = polarOffset(p0, angleOut, 2 * radius * roundCorner);
            outputBezier.setXYAt(tan[0], tan[1], 'o', outputBezier.length() - 1);
            tan = polarOffset(p1, angleIn, 2 * radius * roundCorner);
            outputBezier.setTripleAt(p1[0], p1[1], p1[0], p1[1], tan[0], tan[1], outputBezier.length());
            return p1;
        } // Miter
        var t0 = pointEqual(p0, seg1.points[2]) ? seg1.points[0] : seg1.points[2];
        var t1 = pointEqual(p1, seg2.points[1]) ? seg2.points[3] : seg2.points[1];
        var intersection = lineIntersection(t0, p0, p1, t1);
        if (intersection && pointDistance(intersection, p0) < miterLimit) {
            outputBezier.setTripleAt(intersection[0], intersection[1], intersection[0], intersection[1], intersection[0], intersection[1], outputBezier.length());
            return intersection;
        }
        return p0;
    }
    function getIntersection(a, b) {
        var intersect = a.intersections(b);
        if (intersect.length && floatEqual(intersect[0][0], 1)) intersect.shift();
        if (intersect.length) return intersect[0];
        return null;
    }
    function pruneSegmentIntersection(a, b) {
        var outa = a.slice();
        var outb = b.slice();
        var intersect = getIntersection(a[a.length - 1], b[0]);
        if (intersect) {
            outa[a.length - 1] = a[a.length - 1].split(intersect[0])[0];
            outb[0] = b[0].split(intersect[1])[1];
        }
        if (a.length > 1 && b.length > 1) {
            intersect = getIntersection(a[0], b[b.length - 1]);
            if (intersect) return [
                [
                    a[0].split(intersect[0])[0]
                ],
                [
                    b[b.length - 1].split(intersect[1])[1]
                ]
            ];
        }
        return [
            outa,
            outb
        ];
    }
    function pruneIntersections(segments) {
        var e;
        for(var i = 1; i < segments.length; i += 1){
            e = pruneSegmentIntersection(segments[i - 1], segments[i]);
            segments[i - 1] = e[0];
            segments[i] = e[1];
        }
        if (segments.length > 1) {
            e = pruneSegmentIntersection(segments[segments.length - 1], segments[0]);
            segments[segments.length - 1] = e[0];
            segments[0] = e[1];
        }
        return segments;
    }
    function offsetSegmentSplit(segment, amount) {
        /*
      We split each bezier segment into smaller pieces based
      on inflection points, this ensures the control point
      polygon is convex.
        (A cubic bezier can have none, one, or two inflection points)
    */ var flex = segment.inflectionPoints();
        var left;
        var right;
        var split;
        var mid;
        if (flex.length === 0) return [
            offsetSegment(segment, amount)
        ];
        if (flex.length === 1 || floatEqual(flex[1], 1)) {
            split = segment.split(flex[0]);
            left = split[0];
            right = split[1];
            return [
                offsetSegment(left, amount),
                offsetSegment(right, amount)
            ];
        }
        split = segment.split(flex[0]);
        left = split[0];
        var t = (flex[1] - flex[0]) / (1 - flex[0]);
        split = split[1].split(t);
        mid = split[0];
        right = split[1];
        return [
            offsetSegment(left, amount),
            offsetSegment(mid, amount),
            offsetSegment(right, amount)
        ];
    }
    function OffsetPathModifier() {}
    extendPrototype([
        ShapeModifier
    ], OffsetPathModifier);
    OffsetPathModifier.prototype.initModifierProperties = function(elem, data) {
        this.getValue = this.processKeys;
        this.amount = PropertyFactory.getProp(elem, data.a, 0, null, this);
        this.miterLimit = PropertyFactory.getProp(elem, data.ml, 0, null, this);
        this.lineJoin = data.lj;
        this._isAnimated = this.amount.effectsSequence.length !== 0;
    };
    OffsetPathModifier.prototype.processPath = function(inputBezier, amount, lineJoin, miterLimit) {
        var outputBezier = shapePool.newElement();
        outputBezier.c = inputBezier.c;
        var count = inputBezier.length();
        if (!inputBezier.c) count -= 1;
        var i;
        var j;
        var segment;
        var multiSegments = [];
        for(i = 0; i < count; i += 1){
            segment = PolynomialBezier.shapeSegment(inputBezier, i);
            multiSegments.push(offsetSegmentSplit(segment, amount));
        }
        if (!inputBezier.c) for(i = count - 1; i >= 0; i -= 1){
            segment = PolynomialBezier.shapeSegmentInverted(inputBezier, i);
            multiSegments.push(offsetSegmentSplit(segment, amount));
        }
        multiSegments = pruneIntersections(multiSegments); // Add bezier segments to the output and apply line joints
        var lastPoint = null;
        var lastSeg = null;
        for(i = 0; i < multiSegments.length; i += 1){
            var multiSegment = multiSegments[i];
            if (lastSeg) lastPoint = joinLines(outputBezier, lastSeg, multiSegment[0], lineJoin, miterLimit);
            lastSeg = multiSegment[multiSegment.length - 1];
            for(j = 0; j < multiSegment.length; j += 1){
                segment = multiSegment[j];
                if (lastPoint && pointEqual(segment.points[0], lastPoint)) outputBezier.setXYAt(segment.points[1][0], segment.points[1][1], 'o', outputBezier.length() - 1);
                else outputBezier.setTripleAt(segment.points[0][0], segment.points[0][1], segment.points[1][0], segment.points[1][1], segment.points[0][0], segment.points[0][1], outputBezier.length());
                outputBezier.setTripleAt(segment.points[3][0], segment.points[3][1], segment.points[3][0], segment.points[3][1], segment.points[2][0], segment.points[2][1], outputBezier.length());
                lastPoint = segment.points[3];
            }
        }
        if (multiSegments.length) joinLines(outputBezier, lastSeg, multiSegments[0][0], lineJoin, miterLimit);
        return outputBezier;
    };
    OffsetPathModifier.prototype.processShapes = function(_isFirstFrame) {
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var amount = this.amount.v;
        var miterLimit = this.miterLimit.v;
        var lineJoin = this.lineJoin;
        if (amount !== 0) {
            var shapeData;
            var localShapeCollection;
            for(i = 0; i < len; i += 1){
                shapeData = this.shapes[i];
                localShapeCollection = shapeData.localShapeCollection;
                if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
                    localShapeCollection.releaseShapes();
                    shapeData.shape._mdf = true;
                    shapePaths = shapeData.shape.paths.shapes;
                    jLen = shapeData.shape.paths._length;
                    for(j = 0; j < jLen; j += 1)localShapeCollection.addShape(this.processPath(shapePaths[j], amount, lineJoin, miterLimit));
                }
                shapeData.shape.paths = shapeData.localShapeCollection;
            }
        }
        if (!this.dynamicProperties.length) this._mdf = false;
    };
    function getFontProperties(fontData) {
        var styles = fontData.fStyle ? fontData.fStyle.split(' ') : [];
        var fWeight = 'normal';
        var fStyle = 'normal';
        var len = styles.length;
        var styleName;
        for(var i = 0; i < len; i += 1){
            styleName = styles[i].toLowerCase();
            switch(styleName){
                case 'italic':
                    fStyle = 'italic';
                    break;
                case 'bold':
                    fWeight = '700';
                    break;
                case 'black':
                    fWeight = '900';
                    break;
                case 'medium':
                    fWeight = '500';
                    break;
                case 'regular':
                case 'normal':
                    fWeight = '400';
                    break;
                case 'light':
                case 'thin':
                    fWeight = '200';
                    break;
                default:
                    break;
            }
        }
        return {
            style: fStyle,
            weight: fontData.fWeight || fWeight
        };
    }
    var FontManager = function() {
        var maxWaitingTime = 5000;
        var emptyChar = {
            w: 0,
            size: 0,
            shapes: [],
            data: {
                shapes: []
            }
        };
        var combinedCharacters = []; // Hindi characters
        combinedCharacters = combinedCharacters.concat([
            2304,
            2305,
            2306,
            2307,
            2362,
            2363,
            2364,
            2364,
            2366,
            2367,
            2368,
            2369,
            2370,
            2371,
            2372,
            2373,
            2374,
            2375,
            2376,
            2377,
            2378,
            2379,
            2380,
            2381,
            2382,
            2383,
            2387,
            2388,
            2389,
            2390,
            2391,
            2402,
            2403
        ]);
        var BLACK_FLAG_CODE_POINT = 127988;
        var CANCEL_TAG_CODE_POINT = 917631;
        var A_TAG_CODE_POINT = 917601;
        var Z_TAG_CODE_POINT = 917626;
        var VARIATION_SELECTOR_16_CODE_POINT = 65039;
        var ZERO_WIDTH_JOINER_CODE_POINT = 8205;
        var REGIONAL_CHARACTER_A_CODE_POINT = 127462;
        var REGIONAL_CHARACTER_Z_CODE_POINT = 127487;
        var surrogateModifiers = [
            'd83cdffb',
            'd83cdffc',
            'd83cdffd',
            'd83cdffe',
            'd83cdfff'
        ];
        function trimFontOptions(font) {
            var familyArray = font.split(',');
            var i;
            var len = familyArray.length;
            var enabledFamilies = [];
            for(i = 0; i < len; i += 1)if (familyArray[i] !== 'sans-serif' && familyArray[i] !== 'monospace') enabledFamilies.push(familyArray[i]);
            return enabledFamilies.join(',');
        }
        function setUpNode(font, family) {
            var parentNode = createTag('span'); // Node is invisible to screen readers.
            parentNode.setAttribute('aria-hidden', true);
            parentNode.style.fontFamily = family;
            var node = createTag('span'); // Characters that vary significantly among different fonts
            node.innerText = 'giItT1WQy@!-/#'; // Visible - so we can measure it - but not on the screen
            parentNode.style.position = 'absolute';
            parentNode.style.left = '-10000px';
            parentNode.style.top = '-10000px'; // Large font size makes even subtle changes obvious
            parentNode.style.fontSize = '300px'; // Reset any font properties
            parentNode.style.fontVariant = 'normal';
            parentNode.style.fontStyle = 'normal';
            parentNode.style.fontWeight = 'normal';
            parentNode.style.letterSpacing = '0';
            parentNode.appendChild(node);
            document.body.appendChild(parentNode); // Remember width with no applied web font
            var width = node.offsetWidth;
            node.style.fontFamily = trimFontOptions(font) + ', ' + family;
            return {
                node: node,
                w: width,
                parent: parentNode
            };
        }
        function checkLoadedFonts() {
            var i;
            var len = this.fonts.length;
            var node;
            var w;
            var loadedCount = len;
            for(i = 0; i < len; i += 1){
                if (this.fonts[i].loaded) loadedCount -= 1;
                else if (this.fonts[i].fOrigin === 'n' || this.fonts[i].origin === 0) this.fonts[i].loaded = true;
                else {
                    node = this.fonts[i].monoCase.node;
                    w = this.fonts[i].monoCase.w;
                    if (node.offsetWidth !== w) {
                        loadedCount -= 1;
                        this.fonts[i].loaded = true;
                    } else {
                        node = this.fonts[i].sansCase.node;
                        w = this.fonts[i].sansCase.w;
                        if (node.offsetWidth !== w) {
                            loadedCount -= 1;
                            this.fonts[i].loaded = true;
                        }
                    }
                    if (this.fonts[i].loaded) {
                        this.fonts[i].sansCase.parent.parentNode.removeChild(this.fonts[i].sansCase.parent);
                        this.fonts[i].monoCase.parent.parentNode.removeChild(this.fonts[i].monoCase.parent);
                    }
                }
            }
            if (loadedCount !== 0 && Date.now() - this.initTime < maxWaitingTime) setTimeout(this.checkLoadedFontsBinded, 20);
            else setTimeout(this.setIsLoadedBinded, 10);
        }
        function createHelper(fontData, def) {
            var engine = document.body && def ? 'svg' : 'canvas';
            var helper;
            var fontProps = getFontProperties(fontData);
            if (engine === 'svg') {
                var tHelper = createNS('text');
                tHelper.style.fontSize = '100px'; // tHelper.style.fontFamily = fontData.fFamily;
                tHelper.setAttribute('font-family', fontData.fFamily);
                tHelper.setAttribute('font-style', fontProps.style);
                tHelper.setAttribute('font-weight', fontProps.weight);
                tHelper.textContent = '1';
                if (fontData.fClass) {
                    tHelper.style.fontFamily = 'inherit';
                    tHelper.setAttribute('class', fontData.fClass);
                } else tHelper.style.fontFamily = fontData.fFamily;
                def.appendChild(tHelper);
                helper = tHelper;
            } else {
                var tCanvasHelper = new OffscreenCanvas(500, 500).getContext('2d');
                tCanvasHelper.font = fontProps.style + ' ' + fontProps.weight + ' 100px ' + fontData.fFamily;
                helper = tCanvasHelper;
            }
            function measure(text) {
                if (engine === 'svg') {
                    helper.textContent = text;
                    return helper.getComputedTextLength();
                }
                return helper.measureText(text).width;
            }
            return {
                measureText: measure
            };
        }
        function addFonts(fontData, defs) {
            if (!fontData) {
                this.isLoaded = true;
                return;
            }
            if (this.chars) {
                this.isLoaded = true;
                this.fonts = fontData.list;
                return;
            }
            if (!document.body) {
                this.isLoaded = true;
                fontData.list.forEach(function(data) {
                    data.helper = createHelper(data);
                    data.cache = {};
                });
                this.fonts = fontData.list;
                return;
            }
            var fontArr = fontData.list;
            var i;
            var len = fontArr.length;
            var _pendingFonts = len;
            for(i = 0; i < len; i += 1){
                var shouldLoadFont = true;
                var loadedSelector;
                var j;
                fontArr[i].loaded = false;
                fontArr[i].monoCase = setUpNode(fontArr[i].fFamily, 'monospace');
                fontArr[i].sansCase = setUpNode(fontArr[i].fFamily, 'sans-serif');
                if (!fontArr[i].fPath) {
                    fontArr[i].loaded = true;
                    _pendingFonts -= 1;
                } else if (fontArr[i].fOrigin === 'p' || fontArr[i].origin === 3) {
                    loadedSelector = document.querySelectorAll('style[f-forigin="p"][f-family="' + fontArr[i].fFamily + '"], style[f-origin="3"][f-family="' + fontArr[i].fFamily + '"]');
                    if (loadedSelector.length > 0) shouldLoadFont = false;
                    if (shouldLoadFont) {
                        var s = createTag('style');
                        s.setAttribute('f-forigin', fontArr[i].fOrigin);
                        s.setAttribute('f-origin', fontArr[i].origin);
                        s.setAttribute('f-family', fontArr[i].fFamily);
                        s.type = 'text/css';
                        s.innerText = '@font-face {font-family: ' + fontArr[i].fFamily + "; font-style: normal; src: url('" + fontArr[i].fPath + "');}";
                        defs.appendChild(s);
                    }
                } else if (fontArr[i].fOrigin === 'g' || fontArr[i].origin === 1) {
                    loadedSelector = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]');
                    for(j = 0; j < loadedSelector.length; j += 1)if (loadedSelector[j].href.indexOf(fontArr[i].fPath) !== -1) // Font is already loaded
                    shouldLoadFont = false;
                    if (shouldLoadFont) {
                        var l = createTag('link');
                        l.setAttribute('f-forigin', fontArr[i].fOrigin);
                        l.setAttribute('f-origin', fontArr[i].origin);
                        l.type = 'text/css';
                        l.rel = 'stylesheet';
                        l.href = fontArr[i].fPath;
                        document.body.appendChild(l);
                    }
                } else if (fontArr[i].fOrigin === 't' || fontArr[i].origin === 2) {
                    loadedSelector = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]');
                    for(j = 0; j < loadedSelector.length; j += 1)if (fontArr[i].fPath === loadedSelector[j].src) // Font is already loaded
                    shouldLoadFont = false;
                    if (shouldLoadFont) {
                        var sc = createTag('link');
                        sc.setAttribute('f-forigin', fontArr[i].fOrigin);
                        sc.setAttribute('f-origin', fontArr[i].origin);
                        sc.setAttribute('rel', 'stylesheet');
                        sc.setAttribute('href', fontArr[i].fPath);
                        defs.appendChild(sc);
                    }
                }
                fontArr[i].helper = createHelper(fontArr[i], defs);
                fontArr[i].cache = {};
                this.fonts.push(fontArr[i]);
            }
            if (_pendingFonts === 0) this.isLoaded = true;
            else // On some cases even if the font is loaded, it won't load correctly when measuring text on canvas.
            // Adding this timeout seems to fix it
            setTimeout(this.checkLoadedFonts.bind(this), 100);
        }
        function addChars(chars) {
            if (!chars) return;
            if (!this.chars) this.chars = [];
            var i;
            var len = chars.length;
            var j;
            var jLen = this.chars.length;
            var found;
            for(i = 0; i < len; i += 1){
                j = 0;
                found = false;
                while(j < jLen){
                    if (this.chars[j].style === chars[i].style && this.chars[j].fFamily === chars[i].fFamily && this.chars[j].ch === chars[i].ch) found = true;
                    j += 1;
                }
                if (!found) {
                    this.chars.push(chars[i]);
                    jLen += 1;
                }
            }
        }
        function getCharData(_char, style, font) {
            var i = 0;
            var len = this.chars.length;
            while(i < len){
                if (this.chars[i].ch === _char && this.chars[i].style === style && this.chars[i].fFamily === font) return this.chars[i];
                i += 1;
            }
            if ((typeof _char === 'string' && _char.charCodeAt(0) !== 13 || !_char) && console && console.warn // eslint-disable-line no-console
             && !this._warned) {
                this._warned = true;
                console.warn('Missing character from exported characters list: ', _char, style, font); // eslint-disable-line no-console
            }
            return emptyChar;
        }
        function measureText(_char2, fontName, size) {
            var fontData = this.getFontByName(fontName); // Using the char instead of char.charCodeAt(0)
            // to avoid collisions between equal chars
            var index = _char2;
            if (!fontData.cache[index]) {
                var tHelper = fontData.helper;
                if (_char2 === ' ') {
                    var doubleSize = tHelper.measureText('|' + _char2 + '|');
                    var singleSize = tHelper.measureText('||');
                    fontData.cache[index] = (doubleSize - singleSize) / 100;
                } else fontData.cache[index] = tHelper.measureText(_char2) / 100;
            }
            return fontData.cache[index] * size;
        }
        function getFontByName(name) {
            var i = 0;
            var len = this.fonts.length;
            while(i < len){
                if (this.fonts[i].fName === name) return this.fonts[i];
                i += 1;
            }
            return this.fonts[0];
        }
        function getCodePoint(string) {
            var codePoint = 0;
            var first = string.charCodeAt(0);
            if (first >= 0xD800 && first <= 0xDBFF) {
                var second = string.charCodeAt(1);
                if (second >= 0xDC00 && second <= 0xDFFF) codePoint = (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
            }
            return codePoint;
        } // Skin tone modifiers
        function isModifier(firstCharCode, secondCharCode) {
            var sum = firstCharCode.toString(16) + secondCharCode.toString(16);
            return surrogateModifiers.indexOf(sum) !== -1;
        }
        function isZeroWidthJoiner(charCode) {
            return charCode === ZERO_WIDTH_JOINER_CODE_POINT;
        } // This codepoint may change the appearance of the preceding character.
        // If that is a symbol, dingbat or emoji, U+FE0F forces it to be rendered
        // as a colorful image as compared to a monochrome text variant.
        function isVariationSelector(charCode) {
            return charCode === VARIATION_SELECTOR_16_CODE_POINT;
        } // The regional indicator symbols are a set of 26 alphabetic Unicode
        /// characters (A–Z) intended to be used to encode ISO 3166-1 alpha-2
        // two-letter country codes in a way that allows optional special treatment.
        function isRegionalCode(string) {
            var codePoint = getCodePoint(string);
            if (codePoint >= REGIONAL_CHARACTER_A_CODE_POINT && codePoint <= REGIONAL_CHARACTER_Z_CODE_POINT) return true;
            return false;
        } // Some Emoji implementations represent combinations of
        // two “regional indicator” letters as a single flag symbol.
        function isFlagEmoji(string) {
            return isRegionalCode(string.substr(0, 2)) && isRegionalCode(string.substr(2, 2));
        }
        function isCombinedCharacter(_char3) {
            return combinedCharacters.indexOf(_char3) !== -1;
        } // Regional flags start with a BLACK_FLAG_CODE_POINT
        // folowed by 5 chars in the TAG range
        // and end with a CANCEL_TAG_CODE_POINT
        function isRegionalFlag(text, index) {
            var codePoint = getCodePoint(text.substr(index, 2));
            if (codePoint !== BLACK_FLAG_CODE_POINT) return false;
            var count = 0;
            index += 2;
            while(count < 5){
                codePoint = getCodePoint(text.substr(index, 2));
                if (codePoint < A_TAG_CODE_POINT || codePoint > Z_TAG_CODE_POINT) return false;
                count += 1;
                index += 2;
            }
            return getCodePoint(text.substr(index, 2)) === CANCEL_TAG_CODE_POINT;
        }
        function setIsLoaded() {
            this.isLoaded = true;
        }
        var Font = function Font() {
            this.fonts = [];
            this.chars = null;
            this.typekitLoaded = 0;
            this.isLoaded = false;
            this._warned = false;
            this.initTime = Date.now();
            this.setIsLoadedBinded = this.setIsLoaded.bind(this);
            this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this);
        };
        Font.isModifier = isModifier;
        Font.isZeroWidthJoiner = isZeroWidthJoiner;
        Font.isFlagEmoji = isFlagEmoji;
        Font.isRegionalCode = isRegionalCode;
        Font.isCombinedCharacter = isCombinedCharacter;
        Font.isRegionalFlag = isRegionalFlag;
        Font.isVariationSelector = isVariationSelector;
        Font.BLACK_FLAG_CODE_POINT = BLACK_FLAG_CODE_POINT;
        var fontPrototype = {
            addChars: addChars,
            addFonts: addFonts,
            getCharData: getCharData,
            getFontByName: getFontByName,
            measureText: measureText,
            checkLoadedFonts: checkLoadedFonts,
            setIsLoaded: setIsLoaded
        };
        Font.prototype = fontPrototype;
        return Font;
    }();
    function SlotManager(animationData) {
        this.animationData = animationData;
    }
    SlotManager.prototype.getProp = function(data) {
        if (this.animationData.slots && this.animationData.slots[data.sid]) return Object.assign(data, this.animationData.slots[data.sid].p);
        return data;
    };
    function slotFactory(animationData) {
        return new SlotManager(animationData);
    }
    function RenderableElement() {}
    RenderableElement.prototype = {
        initRenderable: function initRenderable() {
            // layer's visibility related to inpoint and outpoint. Rename isVisible to isInRange
            this.isInRange = false; // layer's display state
            this.hidden = false; // If layer's transparency equals 0, it can be hidden
            this.isTransparent = false; // list of animated components
            this.renderableComponents = [];
        },
        addRenderableComponent: function addRenderableComponent(component) {
            if (this.renderableComponents.indexOf(component) === -1) this.renderableComponents.push(component);
        },
        removeRenderableComponent: function removeRenderableComponent(component) {
            if (this.renderableComponents.indexOf(component) !== -1) this.renderableComponents.splice(this.renderableComponents.indexOf(component), 1);
        },
        prepareRenderableFrame: function prepareRenderableFrame(num) {
            this.checkLayerLimits(num);
        },
        checkTransparency: function checkTransparency() {
            if (this.finalTransform.mProp.o.v <= 0) {
                if (!this.isTransparent && this.globalData.renderConfig.hideOnTransparent) {
                    this.isTransparent = true;
                    this.hide();
                }
            } else if (this.isTransparent) {
                this.isTransparent = false;
                this.show();
            }
        },
        /**
       * @function
       * Initializes frame related properties.
       *
       * @param {number} num
       * current frame number in Layer's time
       *
       */ checkLayerLimits: function checkLayerLimits(num) {
            if (this.data.ip - this.data.st <= num && this.data.op - this.data.st > num) {
                if (this.isInRange !== true) {
                    this.globalData._mdf = true;
                    this._mdf = true;
                    this.isInRange = true;
                    this.show();
                }
            } else if (this.isInRange !== false) {
                this.globalData._mdf = true;
                this.isInRange = false;
                this.hide();
            }
        },
        renderRenderable: function renderRenderable() {
            var i;
            var len = this.renderableComponents.length;
            for(i = 0; i < len; i += 1)this.renderableComponents[i].renderFrame(this._isFirstFrame);
        /* this.maskManager.renderFrame(this.finalTransform.mat);
          this.renderableEffectsManager.renderFrame(this._isFirstFrame); */ },
        sourceRectAtTime: function sourceRectAtTime() {
            return {
                top: 0,
                left: 0,
                width: 100,
                height: 100
            };
        },
        getLayerSize: function getLayerSize() {
            if (this.data.ty === 5) return {
                w: this.data.textData.width,
                h: this.data.textData.height
            };
            return {
                w: this.data.width,
                h: this.data.height
            };
        }
    };
    var getBlendMode = function() {
        var blendModeEnums = {
            0: 'source-over',
            1: 'multiply',
            2: 'screen',
            3: 'overlay',
            4: 'darken',
            5: 'lighten',
            6: 'color-dodge',
            7: 'color-burn',
            8: 'hard-light',
            9: 'soft-light',
            10: 'difference',
            11: 'exclusion',
            12: 'hue',
            13: 'saturation',
            14: 'color',
            15: 'luminosity'
        };
        return function(mode) {
            return blendModeEnums[mode] || '';
        };
    }();
    function SliderEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
    }
    function AngleEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
    }
    function ColorEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 1, 0, container);
    }
    function PointEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 1, 0, container);
    }
    function LayerIndexEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
    }
    function MaskIndexEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
    }
    function CheckboxEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
    }
    function NoValueEffect() {
        this.p = {};
    }
    function EffectsManager(data, element) {
        var effects = data.ef || [];
        this.effectElements = [];
        var i;
        var len = effects.length;
        var effectItem;
        for(i = 0; i < len; i += 1){
            effectItem = new GroupEffect(effects[i], element);
            this.effectElements.push(effectItem);
        }
    }
    function GroupEffect(data, element) {
        this.init(data, element);
    }
    extendPrototype([
        DynamicPropertyContainer
    ], GroupEffect);
    GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties;
    GroupEffect.prototype.init = function(data, element) {
        this.data = data;
        this.effectElements = [];
        this.initDynamicPropertyContainer(element);
        var i;
        var len = this.data.ef.length;
        var eff;
        var effects = this.data.ef;
        for(i = 0; i < len; i += 1){
            eff = null;
            switch(effects[i].ty){
                case 0:
                    eff = new SliderEffect(effects[i], element, this);
                    break;
                case 1:
                    eff = new AngleEffect(effects[i], element, this);
                    break;
                case 2:
                    eff = new ColorEffect(effects[i], element, this);
                    break;
                case 3:
                    eff = new PointEffect(effects[i], element, this);
                    break;
                case 4:
                case 7:
                    eff = new CheckboxEffect(effects[i], element, this);
                    break;
                case 10:
                    eff = new LayerIndexEffect(effects[i], element, this);
                    break;
                case 11:
                    eff = new MaskIndexEffect(effects[i], element, this);
                    break;
                case 5:
                    eff = new EffectsManager(effects[i], element, this);
                    break;
                // case 6:
                default:
                    eff = new NoValueEffect(effects[i], element, this);
                    break;
            }
            if (eff) this.effectElements.push(eff);
        }
    };
    function BaseElement() {}
    BaseElement.prototype = {
        checkMasks: function checkMasks() {
            if (!this.data.hasMask) return false;
            var i = 0;
            var len = this.data.masksProperties.length;
            while(i < len){
                if (this.data.masksProperties[i].mode !== 'n' && this.data.masksProperties[i].cl !== false) return true;
                i += 1;
            }
            return false;
        },
        initExpressions: function initExpressions() {
            var expressionsInterfaces = getExpressionInterfaces();
            if (!expressionsInterfaces) return;
            var LayerExpressionInterface = expressionsInterfaces('layer');
            var EffectsExpressionInterface = expressionsInterfaces('effects');
            var ShapeExpressionInterface = expressionsInterfaces('shape');
            var TextExpressionInterface = expressionsInterfaces('text');
            var CompExpressionInterface = expressionsInterfaces('comp');
            this.layerInterface = LayerExpressionInterface(this);
            if (this.data.hasMask && this.maskManager) this.layerInterface.registerMaskInterface(this.maskManager);
            var effectsInterface = EffectsExpressionInterface.createEffectsInterface(this, this.layerInterface);
            this.layerInterface.registerEffectsInterface(effectsInterface);
            if (this.data.ty === 0 || this.data.xt) this.compInterface = CompExpressionInterface(this);
            else if (this.data.ty === 4) {
                this.layerInterface.shapeInterface = ShapeExpressionInterface(this.shapesData, this.itemsData, this.layerInterface);
                this.layerInterface.content = this.layerInterface.shapeInterface;
            } else if (this.data.ty === 5) {
                this.layerInterface.textInterface = TextExpressionInterface(this);
                this.layerInterface.text = this.layerInterface.textInterface;
            }
        },
        setBlendMode: function setBlendMode() {
            var blendModeValue = getBlendMode(this.data.bm);
            var elem = this.baseElement || this.layerElement;
            elem.style['mix-blend-mode'] = blendModeValue;
        },
        initBaseData: function initBaseData(data, globalData, comp) {
            this.globalData = globalData;
            this.comp = comp;
            this.data = data;
            this.layerId = createElementID(); // Stretch factor for old animations missing this property.
            if (!this.data.sr) this.data.sr = 1;
             // effects manager
            this.effectsManager = new EffectsManager(this.data, this, this.dynamicProperties);
        },
        getType: function getType() {
            return this.type;
        },
        sourceRectAtTime: function sourceRectAtTime() {}
    };
    /**
   * @file
   * Handles element's layer frame update.
   * Checks layer in point and out point
   *
   */ function FrameElement() {}
    FrameElement.prototype = {
        /**
       * @function
       * Initializes frame related properties.
       *
       */ initFrame: function initFrame() {
            // set to true when inpoint is rendered
            this._isFirstFrame = false; // list of animated properties
            this.dynamicProperties = []; // If layer has been modified in current tick this will be true
            this._mdf = false;
        },
        /**
       * @function
       * Calculates all dynamic values
       *
       * @param {number} num
       * current frame number in Layer's time
       * @param {boolean} isVisible
       * if layers is currently in range
       *
       */ prepareProperties: function prepareProperties(num, isVisible) {
            var i;
            var len = this.dynamicProperties.length;
            for(i = 0; i < len; i += 1)if (isVisible || this._isParent && this.dynamicProperties[i].propType === 'transform') {
                this.dynamicProperties[i].getValue();
                if (this.dynamicProperties[i]._mdf) {
                    this.globalData._mdf = true;
                    this._mdf = true;
                }
            }
        },
        addDynamicProperty: function addDynamicProperty(prop) {
            if (this.dynamicProperties.indexOf(prop) === -1) this.dynamicProperties.push(prop);
        }
    };
    function FootageElement(data, globalData, comp) {
        this.initFrame();
        this.initRenderable();
        this.assetData = globalData.getAssetData(data.refId);
        this.footageData = globalData.imageLoader.getAsset(this.assetData);
        this.initBaseData(data, globalData, comp);
    }
    FootageElement.prototype.prepareFrame = function() {};
    extendPrototype([
        RenderableElement,
        BaseElement,
        FrameElement
    ], FootageElement);
    FootageElement.prototype.getBaseElement = function() {
        return null;
    };
    FootageElement.prototype.renderFrame = function() {};
    FootageElement.prototype.destroy = function() {};
    FootageElement.prototype.initExpressions = function() {
        var expressionsInterfaces = getExpressionInterfaces();
        if (!expressionsInterfaces) return;
        var FootageInterface = expressionsInterfaces('footage');
        this.layerInterface = FootageInterface(this);
    };
    FootageElement.prototype.getFootageData = function() {
        return this.footageData;
    };
    function AudioElement(data, globalData, comp) {
        this.initFrame();
        this.initRenderable();
        this.assetData = globalData.getAssetData(data.refId);
        this.initBaseData(data, globalData, comp);
        this._isPlaying = false;
        this._canPlay = false;
        var assetPath = this.globalData.getAssetsPath(this.assetData);
        this.audio = this.globalData.audioController.createAudio(assetPath);
        this._currentTime = 0;
        this.globalData.audioController.addAudio(this);
        this._volumeMultiplier = 1;
        this._volume = 1;
        this._previousVolume = null;
        this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
            _placeholder: true
        };
        this.lv = PropertyFactory.getProp(this, data.au && data.au.lv ? data.au.lv : {
            k: [
                100
            ]
        }, 1, 0.01, this);
    }
    AudioElement.prototype.prepareFrame = function(num) {
        this.prepareRenderableFrame(num, true);
        this.prepareProperties(num, true);
        if (!this.tm._placeholder) {
            var timeRemapped = this.tm.v;
            this._currentTime = timeRemapped;
        } else this._currentTime = num / this.data.sr;
        this._volume = this.lv.v[0];
        var totalVolume = this._volume * this._volumeMultiplier;
        if (this._previousVolume !== totalVolume) {
            this._previousVolume = totalVolume;
            this.audio.volume(totalVolume);
        }
    };
    extendPrototype([
        RenderableElement,
        BaseElement,
        FrameElement
    ], AudioElement);
    AudioElement.prototype.renderFrame = function() {
        if (this.isInRange && this._canPlay) {
            if (!this._isPlaying) {
                this.audio.play();
                this.audio.seek(this._currentTime / this.globalData.frameRate);
                this._isPlaying = true;
            } else if (!this.audio.playing() || Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > 0.1) this.audio.seek(this._currentTime / this.globalData.frameRate);
        }
    };
    AudioElement.prototype.show = function() {};
    AudioElement.prototype.hide = function() {
        this.audio.pause();
        this._isPlaying = false;
    };
    AudioElement.prototype.pause = function() {
        this.audio.pause();
        this._isPlaying = false;
        this._canPlay = false;
    };
    AudioElement.prototype.resume = function() {
        this._canPlay = true;
    };
    AudioElement.prototype.setRate = function(rateValue) {
        this.audio.rate(rateValue);
    };
    AudioElement.prototype.volume = function(volumeValue) {
        this._volumeMultiplier = volumeValue;
        this._previousVolume = volumeValue * this._volume;
        this.audio.volume(this._previousVolume);
    };
    AudioElement.prototype.getBaseElement = function() {
        return null;
    };
    AudioElement.prototype.destroy = function() {};
    AudioElement.prototype.sourceRectAtTime = function() {};
    AudioElement.prototype.initExpressions = function() {};
    function BaseRenderer() {}
    BaseRenderer.prototype.checkLayers = function(num) {
        var i;
        var len = this.layers.length;
        var data;
        this.completeLayers = true;
        for(i = len - 1; i >= 0; i -= 1){
            if (!this.elements[i]) {
                data = this.layers[i];
                if (data.ip - data.st <= num - this.layers[i].st && data.op - data.st > num - this.layers[i].st) this.buildItem(i);
            }
            this.completeLayers = this.elements[i] ? this.completeLayers : false;
        }
        this.checkPendingElements();
    };
    BaseRenderer.prototype.createItem = function(layer) {
        switch(layer.ty){
            case 2:
                return this.createImage(layer);
            case 0:
                return this.createComp(layer);
            case 1:
                return this.createSolid(layer);
            case 3:
                return this.createNull(layer);
            case 4:
                return this.createShape(layer);
            case 5:
                return this.createText(layer);
            case 6:
                return this.createAudio(layer);
            case 13:
                return this.createCamera(layer);
            case 15:
                return this.createFootage(layer);
            default:
                return this.createNull(layer);
        }
    };
    BaseRenderer.prototype.createCamera = function() {
        throw new Error('You\'re using a 3d camera. Try the html renderer.');
    };
    BaseRenderer.prototype.createAudio = function(data) {
        return new AudioElement(data, this.globalData, this);
    };
    BaseRenderer.prototype.createFootage = function(data) {
        return new FootageElement(data, this.globalData, this);
    };
    BaseRenderer.prototype.buildAllItems = function() {
        var i;
        var len = this.layers.length;
        for(i = 0; i < len; i += 1)this.buildItem(i);
        this.checkPendingElements();
    };
    BaseRenderer.prototype.includeLayers = function(newLayers) {
        this.completeLayers = false;
        var i;
        var len = newLayers.length;
        var j;
        var jLen = this.layers.length;
        for(i = 0; i < len; i += 1){
            j = 0;
            while(j < jLen){
                if (this.layers[j].id === newLayers[i].id) {
                    this.layers[j] = newLayers[i];
                    break;
                }
                j += 1;
            }
        }
    };
    BaseRenderer.prototype.setProjectInterface = function(pInterface) {
        this.globalData.projectInterface = pInterface;
    };
    BaseRenderer.prototype.initItems = function() {
        if (!this.globalData.progressiveLoad) this.buildAllItems();
    };
    BaseRenderer.prototype.buildElementParenting = function(element, parentName, hierarchy) {
        var elements = this.elements;
        var layers = this.layers;
        var i = 0;
        var len = layers.length;
        while(i < len){
            if (layers[i].ind == parentName) {
                // eslint-disable-line eqeqeq
                if (!elements[i] || elements[i] === true) {
                    this.buildItem(i);
                    this.addPendingElement(element);
                } else {
                    hierarchy.push(elements[i]);
                    elements[i].setAsParent();
                    if (layers[i].parent !== undefined) this.buildElementParenting(element, layers[i].parent, hierarchy);
                    else element.setHierarchy(hierarchy);
                }
            }
            i += 1;
        }
    };
    BaseRenderer.prototype.addPendingElement = function(element) {
        this.pendingElements.push(element);
    };
    BaseRenderer.prototype.searchExtraCompositions = function(assets) {
        var i;
        var len = assets.length;
        for(i = 0; i < len; i += 1)if (assets[i].xt) {
            var comp = this.createComp(assets[i]);
            comp.initExpressions();
            this.globalData.projectInterface.registerComposition(comp);
        }
    };
    BaseRenderer.prototype.getElementById = function(ind) {
        var i;
        var len = this.elements.length;
        for(i = 0; i < len; i += 1){
            if (this.elements[i].data.ind === ind) return this.elements[i];
        }
        return null;
    };
    BaseRenderer.prototype.getElementByPath = function(path) {
        var pathValue = path.shift();
        var element;
        if (typeof pathValue === 'number') element = this.elements[pathValue];
        else {
            var i;
            var len = this.elements.length;
            for(i = 0; i < len; i += 1)if (this.elements[i].data.nm === pathValue) {
                element = this.elements[i];
                break;
            }
        }
        if (path.length === 0) return element;
        return element.getElementByPath(path);
    };
    BaseRenderer.prototype.setupGlobalData = function(animData, fontsContainer) {
        this.globalData.fontManager = new FontManager();
        this.globalData.slotManager = slotFactory(animData);
        this.globalData.fontManager.addChars(animData.chars);
        this.globalData.fontManager.addFonts(animData.fonts, fontsContainer);
        this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem);
        this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem);
        this.globalData.imageLoader = this.animationItem.imagePreloader;
        this.globalData.audioController = this.animationItem.audioController;
        this.globalData.frameId = 0;
        this.globalData.frameRate = animData.fr;
        this.globalData.nm = animData.nm;
        this.globalData.compSize = {
            w: animData.w,
            h: animData.h
        };
    };
    var effectTypes = {
        TRANSFORM_EFFECT: 'transformEFfect'
    };
    function TransformElement() {}
    TransformElement.prototype = {
        initTransform: function initTransform() {
            var mat = new Matrix();
            this.finalTransform = {
                mProp: this.data.ks ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : {
                    o: 0
                },
                _matMdf: false,
                _localMatMdf: false,
                _opMdf: false,
                mat: mat,
                localMat: mat,
                localOpacity: 1
            };
            if (this.data.ao) this.finalTransform.mProp.autoOriented = true;
             // TODO: check TYPE 11: Guided elements
            this.data.ty;
        },
        renderTransform: function renderTransform() {
            this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame;
            this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame;
            if (this.hierarchy) {
                var mat;
                var finalMat = this.finalTransform.mat;
                var i = 0;
                var len = this.hierarchy.length; // Checking if any of the transformation matrices in the hierarchy chain has changed.
                if (!this.finalTransform._matMdf) while(i < len){
                    if (this.hierarchy[i].finalTransform.mProp._mdf) {
                        this.finalTransform._matMdf = true;
                        break;
                    }
                    i += 1;
                }
                if (this.finalTransform._matMdf) {
                    mat = this.finalTransform.mProp.v.props;
                    finalMat.cloneFromProps(mat);
                    for(i = 0; i < len; i += 1)finalMat.multiply(this.hierarchy[i].finalTransform.mProp.v);
                }
            }
            if (this.finalTransform._matMdf) this.finalTransform._localMatMdf = this.finalTransform._matMdf;
            if (this.finalTransform._opMdf) this.finalTransform.localOpacity = this.finalTransform.mProp.o.v;
        },
        renderLocalTransform: function renderLocalTransform() {
            if (this.localTransforms) {
                var i = 0;
                var len = this.localTransforms.length;
                this.finalTransform._localMatMdf = this.finalTransform._matMdf;
                if (!this.finalTransform._localMatMdf || !this.finalTransform._opMdf) while(i < len){
                    if (this.localTransforms[i]._mdf) this.finalTransform._localMatMdf = true;
                    if (this.localTransforms[i]._opMdf && !this.finalTransform._opMdf) {
                        this.finalTransform.localOpacity = this.finalTransform.mProp.o.v;
                        this.finalTransform._opMdf = true;
                    }
                    i += 1;
                }
                if (this.finalTransform._localMatMdf) {
                    var localMat = this.finalTransform.localMat;
                    this.localTransforms[0].matrix.clone(localMat);
                    for(i = 1; i < len; i += 1){
                        var lmat = this.localTransforms[i].matrix;
                        localMat.multiply(lmat);
                    }
                    localMat.multiply(this.finalTransform.mat);
                }
                if (this.finalTransform._opMdf) {
                    var localOp = this.finalTransform.localOpacity;
                    for(i = 0; i < len; i += 1)localOp *= this.localTransforms[i].opacity * 0.01;
                    this.finalTransform.localOpacity = localOp;
                }
            }
        },
        searchEffectTransforms: function searchEffectTransforms() {
            if (this.renderableEffectsManager) {
                var transformEffects = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
                if (transformEffects.length) {
                    this.localTransforms = [];
                    this.finalTransform.localMat = new Matrix();
                    var i = 0;
                    var len = transformEffects.length;
                    for(i = 0; i < len; i += 1)this.localTransforms.push(transformEffects[i]);
                }
            }
        },
        globalToLocal: function globalToLocal(pt) {
            var transforms = [];
            transforms.push(this.finalTransform);
            var flag = true;
            var comp = this.comp;
            while(flag)if (comp.finalTransform) {
                if (comp.data.hasMask) transforms.splice(0, 0, comp.finalTransform);
                comp = comp.comp;
            } else flag = false;
            var i;
            var len = transforms.length;
            var ptNew;
            for(i = 0; i < len; i += 1){
                ptNew = transforms[i].mat.applyToPointArray(0, 0, 0); // ptNew = transforms[i].mat.applyToPointArray(pt[0],pt[1],pt[2]);
                pt = [
                    pt[0] - ptNew[0],
                    pt[1] - ptNew[1],
                    0
                ];
            }
            return pt;
        },
        mHelper: new Matrix()
    };
    function MaskElement(data, element, globalData) {
        this.data = data;
        this.element = element;
        this.globalData = globalData;
        this.storedData = [];
        this.masksProperties = this.data.masksProperties || [];
        this.maskElement = null;
        var defs = this.globalData.defs;
        var i;
        var len = this.masksProperties ? this.masksProperties.length : 0;
        this.viewData = createSizedArray(len);
        this.solidPath = '';
        var path;
        var properties = this.masksProperties;
        var count = 0;
        var currentMasks = [];
        var j;
        var jLen;
        var layerId = createElementID();
        var rect;
        var expansor;
        var feMorph;
        var x;
        var maskType = 'clipPath';
        var maskRef = 'clip-path';
        for(i = 0; i < len; i += 1){
            if (properties[i].mode !== 'a' && properties[i].mode !== 'n' || properties[i].inv || properties[i].o.k !== 100 || properties[i].o.x) {
                maskType = 'mask';
                maskRef = 'mask';
            }
            if ((properties[i].mode === 's' || properties[i].mode === 'i') && count === 0) {
                rect = createNS('rect');
                rect.setAttribute('fill', '#ffffff');
                rect.setAttribute('width', this.element.comp.data.w || 0);
                rect.setAttribute('height', this.element.comp.data.h || 0);
                currentMasks.push(rect);
            } else rect = null;
            path = createNS('path');
            if (properties[i].mode === 'n') {
                // TODO move this to a factory or to a constructor
                this.viewData[i] = {
                    op: PropertyFactory.getProp(this.element, properties[i].o, 0, 0.01, this.element),
                    prop: ShapePropertyFactory.getShapeProp(this.element, properties[i], 3),
                    elem: path,
                    lastPath: ''
                };
                defs.appendChild(path);
            } else {
                count += 1;
                path.setAttribute('fill', properties[i].mode === 's' ? '#000000' : '#ffffff');
                path.setAttribute('clip-rule', 'nonzero');
                var filterID;
                if (properties[i].x.k !== 0) {
                    maskType = 'mask';
                    maskRef = 'mask';
                    x = PropertyFactory.getProp(this.element, properties[i].x, 0, null, this.element);
                    filterID = createElementID();
                    expansor = createNS('filter');
                    expansor.setAttribute('id', filterID);
                    feMorph = createNS('feMorphology');
                    feMorph.setAttribute('operator', 'erode');
                    feMorph.setAttribute('in', 'SourceGraphic');
                    feMorph.setAttribute('radius', '0');
                    expansor.appendChild(feMorph);
                    defs.appendChild(expansor);
                    path.setAttribute('stroke', properties[i].mode === 's' ? '#000000' : '#ffffff');
                } else {
                    feMorph = null;
                    x = null;
                } // TODO move this to a factory or to a constructor
                this.storedData[i] = {
                    elem: path,
                    x: x,
                    expan: feMorph,
                    lastPath: '',
                    lastOperator: '',
                    filterId: filterID,
                    lastRadius: 0
                };
                if (properties[i].mode === 'i') {
                    jLen = currentMasks.length;
                    var g = createNS('g');
                    for(j = 0; j < jLen; j += 1)g.appendChild(currentMasks[j]);
                    var mask = createNS('mask');
                    mask.setAttribute('mask-type', 'alpha');
                    mask.setAttribute('id', layerId + '_' + count);
                    mask.appendChild(path);
                    defs.appendChild(mask);
                    g.setAttribute('mask', 'url(' + getLocationHref() + '#' + layerId + '_' + count + ')');
                    currentMasks.length = 0;
                    currentMasks.push(g);
                } else currentMasks.push(path);
                if (properties[i].inv && !this.solidPath) this.solidPath = this.createLayerSolidPath();
                 // TODO move this to a factory or to a constructor
                this.viewData[i] = {
                    elem: path,
                    lastPath: '',
                    op: PropertyFactory.getProp(this.element, properties[i].o, 0, 0.01, this.element),
                    prop: ShapePropertyFactory.getShapeProp(this.element, properties[i], 3),
                    invRect: rect
                };
                if (!this.viewData[i].prop.k) this.drawPath(properties[i], this.viewData[i].prop.v, this.viewData[i]);
            }
        }
        this.maskElement = createNS(maskType);
        len = currentMasks.length;
        for(i = 0; i < len; i += 1)this.maskElement.appendChild(currentMasks[i]);
        if (count > 0) {
            this.maskElement.setAttribute('id', layerId);
            this.element.maskedElement.setAttribute(maskRef, 'url(' + getLocationHref() + '#' + layerId + ')');
            defs.appendChild(this.maskElement);
        }
        if (this.viewData.length) this.element.addRenderableComponent(this);
    }
    MaskElement.prototype.getMaskProperty = function(pos) {
        return this.viewData[pos].prop;
    };
    MaskElement.prototype.renderFrame = function(isFirstFrame) {
        var finalMat = this.element.finalTransform.mat;
        var i;
        var len = this.masksProperties.length;
        for(i = 0; i < len; i += 1){
            if (this.viewData[i].prop._mdf || isFirstFrame) this.drawPath(this.masksProperties[i], this.viewData[i].prop.v, this.viewData[i]);
            if (this.viewData[i].op._mdf || isFirstFrame) this.viewData[i].elem.setAttribute('fill-opacity', this.viewData[i].op.v);
            if (this.masksProperties[i].mode !== 'n') {
                if (this.viewData[i].invRect && (this.element.finalTransform.mProp._mdf || isFirstFrame)) this.viewData[i].invRect.setAttribute('transform', finalMat.getInverseMatrix().to2dCSS());
                if (this.storedData[i].x && (this.storedData[i].x._mdf || isFirstFrame)) {
                    var feMorph = this.storedData[i].expan;
                    if (this.storedData[i].x.v < 0) {
                        if (this.storedData[i].lastOperator !== 'erode') {
                            this.storedData[i].lastOperator = 'erode';
                            this.storedData[i].elem.setAttribute('filter', 'url(' + getLocationHref() + '#' + this.storedData[i].filterId + ')');
                        }
                        feMorph.setAttribute('radius', -this.storedData[i].x.v);
                    } else {
                        if (this.storedData[i].lastOperator !== 'dilate') {
                            this.storedData[i].lastOperator = 'dilate';
                            this.storedData[i].elem.setAttribute('filter', null);
                        }
                        this.storedData[i].elem.setAttribute('stroke-width', this.storedData[i].x.v * 2);
                    }
                }
            }
        }
    };
    MaskElement.prototype.getMaskelement = function() {
        return this.maskElement;
    };
    MaskElement.prototype.createLayerSolidPath = function() {
        var path = 'M0,0 ';
        path += ' h' + this.globalData.compSize.w;
        path += ' v' + this.globalData.compSize.h;
        path += ' h-' + this.globalData.compSize.w;
        path += ' v-' + this.globalData.compSize.h + ' ';
        return path;
    };
    MaskElement.prototype.drawPath = function(pathData, pathNodes, viewData) {
        var pathString = ' M' + pathNodes.v[0][0] + ',' + pathNodes.v[0][1];
        var i;
        var len;
        len = pathNodes._length;
        for(i = 1; i < len; i += 1)// pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[i][0]+','+pathNodes.i[i][1] + " "+pathNodes.v[i][0]+','+pathNodes.v[i][1];
        pathString += ' C' + pathNodes.o[i - 1][0] + ',' + pathNodes.o[i - 1][1] + ' ' + pathNodes.i[i][0] + ',' + pathNodes.i[i][1] + ' ' + pathNodes.v[i][0] + ',' + pathNodes.v[i][1];
         // pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[0][0]+','+pathNodes.i[0][1] + " "+pathNodes.v[0][0]+','+pathNodes.v[0][1];
        if (pathNodes.c && len > 1) pathString += ' C' + pathNodes.o[i - 1][0] + ',' + pathNodes.o[i - 1][1] + ' ' + pathNodes.i[0][0] + ',' + pathNodes.i[0][1] + ' ' + pathNodes.v[0][0] + ',' + pathNodes.v[0][1];
         // pathNodes.__renderedString = pathString;
        if (viewData.lastPath !== pathString) {
            var pathShapeValue = '';
            if (viewData.elem) {
                if (pathNodes.c) pathShapeValue = pathData.inv ? this.solidPath + pathString : pathString;
                viewData.elem.setAttribute('d', pathShapeValue);
            }
            viewData.lastPath = pathString;
        }
    };
    MaskElement.prototype.destroy = function() {
        this.element = null;
        this.globalData = null;
        this.maskElement = null;
        this.data = null;
        this.masksProperties = null;
    };
    var filtersFactory = function() {
        var ob = {};
        ob.createFilter = createFilter;
        ob.createAlphaToLuminanceFilter = createAlphaToLuminanceFilter;
        function createFilter(filId, skipCoordinates) {
            var fil = createNS('filter');
            fil.setAttribute('id', filId);
            if (skipCoordinates !== true) {
                fil.setAttribute('filterUnits', 'objectBoundingBox');
                fil.setAttribute('x', '0%');
                fil.setAttribute('y', '0%');
                fil.setAttribute('width', '100%');
                fil.setAttribute('height', '100%');
            }
            return fil;
        }
        function createAlphaToLuminanceFilter() {
            var feColorMatrix = createNS('feColorMatrix');
            feColorMatrix.setAttribute('type', 'matrix');
            feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
            feColorMatrix.setAttribute('values', '0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1');
            return feColorMatrix;
        }
        return ob;
    }();
    var featureSupport = function() {
        var ob = {
            maskType: true,
            svgLumaHidden: true,
            offscreenCanvas: typeof OffscreenCanvas !== 'undefined'
        };
        if (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) ob.maskType = false;
        if (/firefox/i.test(navigator.userAgent)) ob.svgLumaHidden = false;
        return ob;
    }();
    var registeredEffects$1 = {};
    var idPrefix = 'filter_result_';
    function SVGEffects(elem) {
        var i;
        var source = 'SourceGraphic';
        var len = elem.data.ef ? elem.data.ef.length : 0;
        var filId = createElementID();
        var fil = filtersFactory.createFilter(filId, true);
        var count = 0;
        this.filters = [];
        var filterManager;
        for(i = 0; i < len; i += 1){
            filterManager = null;
            var type = elem.data.ef[i].ty;
            if (registeredEffects$1[type]) {
                var Effect = registeredEffects$1[type].effect;
                filterManager = new Effect(fil, elem.effectsManager.effectElements[i], elem, idPrefix + count, source);
                source = idPrefix + count;
                if (registeredEffects$1[type].countsAsEffect) count += 1;
            }
            if (filterManager) this.filters.push(filterManager);
        }
        if (count) {
            elem.globalData.defs.appendChild(fil);
            elem.layerElement.setAttribute('filter', 'url(' + getLocationHref() + '#' + filId + ')');
        }
        if (this.filters.length) elem.addRenderableComponent(this);
    }
    SVGEffects.prototype.renderFrame = function(_isFirstFrame) {
        var i;
        var len = this.filters.length;
        for(i = 0; i < len; i += 1)this.filters[i].renderFrame(_isFirstFrame);
    };
    SVGEffects.prototype.getEffects = function(type) {
        var i;
        var len = this.filters.length;
        var effects = [];
        for(i = 0; i < len; i += 1)if (this.filters[i].type === type) effects.push(this.filters[i]);
        return effects;
    };
    function registerEffect$1(id, effect, countsAsEffect) {
        registeredEffects$1[id] = {
            effect: effect,
            countsAsEffect: countsAsEffect
        };
    }
    function SVGBaseElement() {}
    SVGBaseElement.prototype = {
        initRendererElement: function initRendererElement() {
            this.layerElement = createNS('g');
        },
        createContainerElements: function createContainerElements() {
            this.matteElement = createNS('g');
            this.transformedElement = this.layerElement;
            this.maskedElement = this.layerElement;
            this._sizeChanged = false;
            var layerElementParent = null; // If this layer acts as a mask for the following layer
            if (this.data.td) {
                this.matteMasks = {};
                var gg = createNS('g');
                gg.setAttribute('id', this.layerId);
                gg.appendChild(this.layerElement);
                layerElementParent = gg;
                this.globalData.defs.appendChild(gg);
            } else if (this.data.tt) {
                this.matteElement.appendChild(this.layerElement);
                layerElementParent = this.matteElement;
                this.baseElement = this.matteElement;
            } else this.baseElement = this.layerElement;
            if (this.data.ln) this.layerElement.setAttribute('id', this.data.ln);
            if (this.data.cl) this.layerElement.setAttribute('class', this.data.cl);
             // Clipping compositions to hide content that exceeds boundaries. If collapsed transformations is on, component should not be clipped
            if (this.data.ty === 0 && !this.data.hd) {
                var cp = createNS('clipPath');
                var pt = createNS('path');
                pt.setAttribute('d', 'M0,0 L' + this.data.w + ',0 L' + this.data.w + ',' + this.data.h + ' L0,' + this.data.h + 'z');
                var clipId = createElementID();
                cp.setAttribute('id', clipId);
                cp.appendChild(pt);
                this.globalData.defs.appendChild(cp);
                if (this.checkMasks()) {
                    var cpGroup = createNS('g');
                    cpGroup.setAttribute('clip-path', 'url(' + getLocationHref() + '#' + clipId + ')');
                    cpGroup.appendChild(this.layerElement);
                    this.transformedElement = cpGroup;
                    if (layerElementParent) layerElementParent.appendChild(this.transformedElement);
                    else this.baseElement = this.transformedElement;
                } else this.layerElement.setAttribute('clip-path', 'url(' + getLocationHref() + '#' + clipId + ')');
            }
            if (this.data.bm !== 0) this.setBlendMode();
        },
        renderElement: function renderElement() {
            if (this.finalTransform._localMatMdf) this.transformedElement.setAttribute('transform', this.finalTransform.localMat.to2dCSS());
            if (this.finalTransform._opMdf) this.transformedElement.setAttribute('opacity', this.finalTransform.localOpacity);
        },
        destroyBaseElement: function destroyBaseElement() {
            this.layerElement = null;
            this.matteElement = null;
            this.maskManager.destroy();
        },
        getBaseElement: function getBaseElement() {
            if (this.data.hd) return null;
            return this.baseElement;
        },
        createRenderableComponents: function createRenderableComponents() {
            this.maskManager = new MaskElement(this.data, this, this.globalData);
            this.renderableEffectsManager = new SVGEffects(this);
            this.searchEffectTransforms();
        },
        getMatte: function getMatte(matteType) {
            // This should not be a common case. But for backward compatibility, we'll create the matte object.
            // It solves animations that have two consecutive layers marked as matte masks.
            // Which is an undefined behavior in AE.
            if (!this.matteMasks) this.matteMasks = {};
            if (!this.matteMasks[matteType]) {
                var id = this.layerId + '_' + matteType;
                var filId;
                var fil;
                var useElement;
                var gg;
                if (matteType === 1 || matteType === 3) {
                    var masker = createNS('mask');
                    masker.setAttribute('id', id);
                    masker.setAttribute('mask-type', matteType === 3 ? 'luminance' : 'alpha');
                    useElement = createNS('use');
                    useElement.setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#' + this.layerId);
                    masker.appendChild(useElement);
                    this.globalData.defs.appendChild(masker);
                    if (!featureSupport.maskType && matteType === 1) {
                        masker.setAttribute('mask-type', 'luminance');
                        filId = createElementID();
                        fil = filtersFactory.createFilter(filId);
                        this.globalData.defs.appendChild(fil);
                        fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
                        gg = createNS('g');
                        gg.appendChild(useElement);
                        masker.appendChild(gg);
                        gg.setAttribute('filter', 'url(' + getLocationHref() + '#' + filId + ')');
                    }
                } else if (matteType === 2) {
                    var maskGroup = createNS('mask');
                    maskGroup.setAttribute('id', id);
                    maskGroup.setAttribute('mask-type', 'alpha');
                    var maskGrouper = createNS('g');
                    maskGroup.appendChild(maskGrouper);
                    filId = createElementID();
                    fil = filtersFactory.createFilter(filId); /// /
                    var feCTr = createNS('feComponentTransfer');
                    feCTr.setAttribute('in', 'SourceGraphic');
                    fil.appendChild(feCTr);
                    var feFunc = createNS('feFuncA');
                    feFunc.setAttribute('type', 'table');
                    feFunc.setAttribute('tableValues', '1.0 0.0');
                    feCTr.appendChild(feFunc); /// /
                    this.globalData.defs.appendChild(fil);
                    var alphaRect = createNS('rect');
                    alphaRect.setAttribute('width', this.comp.data.w);
                    alphaRect.setAttribute('height', this.comp.data.h);
                    alphaRect.setAttribute('x', '0');
                    alphaRect.setAttribute('y', '0');
                    alphaRect.setAttribute('fill', '#ffffff');
                    alphaRect.setAttribute('opacity', '0');
                    maskGrouper.setAttribute('filter', 'url(' + getLocationHref() + '#' + filId + ')');
                    maskGrouper.appendChild(alphaRect);
                    useElement = createNS('use');
                    useElement.setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#' + this.layerId);
                    maskGrouper.appendChild(useElement);
                    if (!featureSupport.maskType) {
                        maskGroup.setAttribute('mask-type', 'luminance');
                        fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
                        gg = createNS('g');
                        maskGrouper.appendChild(alphaRect);
                        gg.appendChild(this.layerElement);
                        maskGrouper.appendChild(gg);
                    }
                    this.globalData.defs.appendChild(maskGroup);
                }
                this.matteMasks[matteType] = id;
            }
            return this.matteMasks[matteType];
        },
        setMatte: function setMatte(id) {
            if (!this.matteElement) return;
            this.matteElement.setAttribute('mask', 'url(' + getLocationHref() + '#' + id + ')');
        }
    };
    /**
   * @file
   * Handles AE's layer parenting property.
   *
   */ function HierarchyElement() {}
    HierarchyElement.prototype = {
        /**
       * @function
       * Initializes hierarchy properties
       *
       */ initHierarchy: function initHierarchy() {
            // element's parent list
            this.hierarchy = []; // if element is parent of another layer _isParent will be true
            this._isParent = false;
            this.checkParenting();
        },
        /**
       * @function
       * Sets layer's hierarchy.
       * @param {array} hierarch
       * layer's parent list
       *
       */ setHierarchy: function setHierarchy(hierarchy) {
            this.hierarchy = hierarchy;
        },
        /**
       * @function
       * Sets layer as parent.
       *
       */ setAsParent: function setAsParent() {
            this._isParent = true;
        },
        /**
       * @function
       * Searches layer's parenting chain
       *
       */ checkParenting: function checkParenting() {
            if (this.data.parent !== undefined) this.comp.buildElementParenting(this, this.data.parent, []);
        }
    };
    function RenderableDOMElement() {}
    (function() {
        var _prototype = {
            initElement: function initElement(data, globalData, comp) {
                this.initFrame();
                this.initBaseData(data, globalData, comp);
                this.initTransform(data, globalData, comp);
                this.initHierarchy();
                this.initRenderable();
                this.initRendererElement();
                this.createContainerElements();
                this.createRenderableComponents();
                this.createContent();
                this.hide();
            },
            hide: function hide() {
                // console.log('HIDE', this);
                if (!this.hidden && (!this.isInRange || this.isTransparent)) {
                    var elem = this.baseElement || this.layerElement;
                    elem.style.display = 'none';
                    this.hidden = true;
                }
            },
            show: function show() {
                // console.log('SHOW', this);
                if (this.isInRange && !this.isTransparent) {
                    if (!this.data.hd) {
                        var elem = this.baseElement || this.layerElement;
                        elem.style.display = 'block';
                    }
                    this.hidden = false;
                    this._isFirstFrame = true;
                }
            },
            renderFrame: function renderFrame() {
                // If it is exported as hidden (data.hd === true) no need to render
                // If it is not visible no need to render
                if (this.data.hd || this.hidden) return;
                this.renderTransform();
                this.renderRenderable();
                this.renderLocalTransform();
                this.renderElement();
                this.renderInnerContent();
                if (this._isFirstFrame) this._isFirstFrame = false;
            },
            renderInnerContent: function renderInnerContent() {},
            prepareFrame: function prepareFrame(num) {
                this._mdf = false;
                this.prepareRenderableFrame(num);
                this.prepareProperties(num, this.isInRange);
                this.checkTransparency();
            },
            destroy: function destroy() {
                this.innerElem = null;
                this.destroyBaseElement();
            }
        };
        extendPrototype([
            RenderableElement,
            createProxyFunction(_prototype)
        ], RenderableDOMElement);
    })();
    function IImageElement(data, globalData, comp) {
        this.assetData = globalData.getAssetData(data.refId);
        if (this.assetData && this.assetData.sid) this.assetData = globalData.slotManager.getProp(this.assetData);
        this.initElement(data, globalData, comp);
        this.sourceRect = {
            top: 0,
            left: 0,
            width: this.assetData.w,
            height: this.assetData.h
        };
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        SVGBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement
    ], IImageElement);
    IImageElement.prototype.createContent = function() {
        var assetPath = this.globalData.getAssetsPath(this.assetData);
        this.innerElem = createNS('image');
        this.innerElem.setAttribute('width', this.assetData.w + 'px');
        this.innerElem.setAttribute('height', this.assetData.h + 'px');
        this.innerElem.setAttribute('preserveAspectRatio', this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio);
        this.innerElem.setAttributeNS('http://www.w3.org/1999/xlink', 'href', assetPath);
        this.layerElement.appendChild(this.innerElem);
    };
    IImageElement.prototype.sourceRectAtTime = function() {
        return this.sourceRect;
    };
    function ProcessedElement(element, position) {
        this.elem = element;
        this.pos = position;
    }
    function IShapeElement() {}
    IShapeElement.prototype = {
        addShapeToModifiers: function addShapeToModifiers(data) {
            var i;
            var len = this.shapeModifiers.length;
            for(i = 0; i < len; i += 1)this.shapeModifiers[i].addShape(data);
        },
        isShapeInAnimatedModifiers: function isShapeInAnimatedModifiers(data) {
            var i = 0;
            var len = this.shapeModifiers.length;
            while(i < len){
                if (this.shapeModifiers[i].isAnimatedWithShape(data)) return true;
            }
            return false;
        },
        renderModifiers: function renderModifiers() {
            if (!this.shapeModifiers.length) return;
            var i;
            var len = this.shapes.length;
            for(i = 0; i < len; i += 1)this.shapes[i].sh.reset();
            len = this.shapeModifiers.length;
            var shouldBreakProcess;
            for(i = len - 1; i >= 0; i -= 1){
                shouldBreakProcess = this.shapeModifiers[i].processShapes(this._isFirstFrame); // workaround to fix cases where a repeater resets the shape so the following processes get called twice
                // TODO: find a better solution for this
                if (shouldBreakProcess) break;
            }
        },
        searchProcessedElement: function searchProcessedElement(elem) {
            var elements = this.processedElements;
            var i = 0;
            var len = elements.length;
            while(i < len){
                if (elements[i].elem === elem) return elements[i].pos;
                i += 1;
            }
            return 0;
        },
        addProcessedElement: function addProcessedElement(elem, pos) {
            var elements = this.processedElements;
            var i = elements.length;
            while(i){
                i -= 1;
                if (elements[i].elem === elem) {
                    elements[i].pos = pos;
                    return;
                }
            }
            elements.push(new ProcessedElement(elem, pos));
        },
        prepareFrame: function prepareFrame(num) {
            this.prepareRenderableFrame(num);
            this.prepareProperties(num, this.isInRange);
        }
    };
    var lineCapEnum = {
        1: 'butt',
        2: 'round',
        3: 'square'
    };
    var lineJoinEnum = {
        1: 'miter',
        2: 'round',
        3: 'bevel'
    };
    function SVGShapeData(transformers, level, shape) {
        this.caches = [];
        this.styles = [];
        this.transformers = transformers;
        this.lStr = '';
        this.sh = shape;
        this.lvl = level; // TODO find if there are some cases where _isAnimated can be false.
        // For now, since shapes add up with other shapes. They have to be calculated every time.
        // One way of finding out is checking if all styles associated to this shape depend only of this shape
        this._isAnimated = !!shape.k; // TODO: commenting this for now since all shapes are animated
        var i = 0;
        var len = transformers.length;
        while(i < len){
            if (transformers[i].mProps.dynamicProperties.length) {
                this._isAnimated = true;
                break;
            }
            i += 1;
        }
    }
    SVGShapeData.prototype.setAsAnimated = function() {
        this._isAnimated = true;
    };
    function SVGStyleData(data, level) {
        this.data = data;
        this.type = data.ty;
        this.d = '';
        this.lvl = level;
        this._mdf = false;
        this.closed = data.hd === true;
        this.pElem = createNS('path');
        this.msElem = null;
    }
    SVGStyleData.prototype.reset = function() {
        this.d = '';
        this._mdf = false;
    };
    function DashProperty(elem, data, renderer, container) {
        this.elem = elem;
        this.frameId = -1;
        this.dataProps = createSizedArray(data.length);
        this.renderer = renderer;
        this.k = false;
        this.dashStr = '';
        this.dashArray = createTypedArray('float32', data.length ? data.length - 1 : 0);
        this.dashoffset = createTypedArray('float32', 1);
        this.initDynamicPropertyContainer(container);
        var i;
        var len = data.length || 0;
        var prop;
        for(i = 0; i < len; i += 1){
            prop = PropertyFactory.getProp(elem, data[i].v, 0, 0, this);
            this.k = prop.k || this.k;
            this.dataProps[i] = {
                n: data[i].n,
                p: prop
            };
        }
        if (!this.k) this.getValue(true);
        this._isAnimated = this.k;
    }
    DashProperty.prototype.getValue = function(forceRender) {
        if (this.elem.globalData.frameId === this.frameId && !forceRender) return;
        this.frameId = this.elem.globalData.frameId;
        this.iterateDynamicProperties();
        this._mdf = this._mdf || forceRender;
        if (this._mdf) {
            var i = 0;
            var len = this.dataProps.length;
            if (this.renderer === 'svg') this.dashStr = '';
            for(i = 0; i < len; i += 1)if (this.dataProps[i].n !== 'o') {
                if (this.renderer === 'svg') this.dashStr += ' ' + this.dataProps[i].p.v;
                else this.dashArray[i] = this.dataProps[i].p.v;
            } else this.dashoffset[0] = this.dataProps[i].p.v;
        }
    };
    extendPrototype([
        DynamicPropertyContainer
    ], DashProperty);
    function SVGStrokeStyleData(elem, data, styleOb) {
        this.initDynamicPropertyContainer(elem);
        this.getValue = this.iterateDynamicProperties;
        this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
        this.w = PropertyFactory.getProp(elem, data.w, 0, null, this);
        this.d = new DashProperty(elem, data.d || {}, 'svg', this);
        this.c = PropertyFactory.getProp(elem, data.c, 1, 255, this);
        this.style = styleOb;
        this._isAnimated = !!this._isAnimated;
    }
    extendPrototype([
        DynamicPropertyContainer
    ], SVGStrokeStyleData);
    function SVGFillStyleData(elem, data, styleOb) {
        this.initDynamicPropertyContainer(elem);
        this.getValue = this.iterateDynamicProperties;
        this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
        this.c = PropertyFactory.getProp(elem, data.c, 1, 255, this);
        this.style = styleOb;
    }
    extendPrototype([
        DynamicPropertyContainer
    ], SVGFillStyleData);
    function SVGNoStyleData(elem, data, styleOb) {
        this.initDynamicPropertyContainer(elem);
        this.getValue = this.iterateDynamicProperties;
        this.style = styleOb;
    }
    extendPrototype([
        DynamicPropertyContainer
    ], SVGNoStyleData);
    function GradientProperty(elem, data, container) {
        this.data = data;
        this.c = createTypedArray('uint8c', data.p * 4);
        var cLength = data.k.k[0].s ? data.k.k[0].s.length - data.p * 4 : data.k.k.length - data.p * 4;
        this.o = createTypedArray('float32', cLength);
        this._cmdf = false;
        this._omdf = false;
        this._collapsable = this.checkCollapsable();
        this._hasOpacity = cLength;
        this.initDynamicPropertyContainer(container);
        this.prop = PropertyFactory.getProp(elem, data.k, 1, null, this);
        this.k = this.prop.k;
        this.getValue(true);
    }
    GradientProperty.prototype.comparePoints = function(values, points) {
        var i = 0;
        var len = this.o.length / 2;
        var diff;
        while(i < len){
            diff = Math.abs(values[i * 4] - values[points * 4 + i * 2]);
            if (diff > 0.01) return false;
            i += 1;
        }
        return true;
    };
    GradientProperty.prototype.checkCollapsable = function() {
        if (this.o.length / 2 !== this.c.length / 4) return false;
        if (this.data.k.k[0].s) {
            var i = 0;
            var len = this.data.k.k.length;
            while(i < len){
                if (!this.comparePoints(this.data.k.k[i].s, this.data.p)) return false;
                i += 1;
            }
        } else if (!this.comparePoints(this.data.k.k, this.data.p)) return false;
        return true;
    };
    GradientProperty.prototype.getValue = function(forceRender) {
        this.prop.getValue();
        this._mdf = false;
        this._cmdf = false;
        this._omdf = false;
        if (this.prop._mdf || forceRender) {
            var i;
            var len = this.data.p * 4;
            var mult;
            var val;
            for(i = 0; i < len; i += 1){
                mult = i % 4 === 0 ? 100 : 255;
                val = Math.round(this.prop.v[i] * mult);
                if (this.c[i] !== val) {
                    this.c[i] = val;
                    this._cmdf = !forceRender;
                }
            }
            if (this.o.length) {
                len = this.prop.v.length;
                for(i = this.data.p * 4; i < len; i += 1){
                    mult = i % 2 === 0 ? 100 : 1;
                    val = i % 2 === 0 ? Math.round(this.prop.v[i] * 100) : this.prop.v[i];
                    if (this.o[i - this.data.p * 4] !== val) {
                        this.o[i - this.data.p * 4] = val;
                        this._omdf = !forceRender;
                    }
                }
            }
            this._mdf = !forceRender;
        }
    };
    extendPrototype([
        DynamicPropertyContainer
    ], GradientProperty);
    function SVGGradientFillStyleData(elem, data, styleOb) {
        this.initDynamicPropertyContainer(elem);
        this.getValue = this.iterateDynamicProperties;
        this.initGradientData(elem, data, styleOb);
    }
    SVGGradientFillStyleData.prototype.initGradientData = function(elem, data, styleOb) {
        this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
        this.s = PropertyFactory.getProp(elem, data.s, 1, null, this);
        this.e = PropertyFactory.getProp(elem, data.e, 1, null, this);
        this.h = PropertyFactory.getProp(elem, data.h || {
            k: 0
        }, 0, 0.01, this);
        this.a = PropertyFactory.getProp(elem, data.a || {
            k: 0
        }, 0, degToRads, this);
        this.g = new GradientProperty(elem, data.g, this);
        this.style = styleOb;
        this.stops = [];
        this.setGradientData(styleOb.pElem, data);
        this.setGradientOpacity(data, styleOb);
        this._isAnimated = !!this._isAnimated;
    };
    SVGGradientFillStyleData.prototype.setGradientData = function(pathElement, data) {
        var gradientId = createElementID();
        var gfill = createNS(data.t === 1 ? 'linearGradient' : 'radialGradient');
        gfill.setAttribute('id', gradientId);
        gfill.setAttribute('spreadMethod', 'pad');
        gfill.setAttribute('gradientUnits', 'userSpaceOnUse');
        var stops = [];
        var stop;
        var j;
        var jLen;
        jLen = data.g.p * 4;
        for(j = 0; j < jLen; j += 4){
            stop = createNS('stop');
            gfill.appendChild(stop);
            stops.push(stop);
        }
        pathElement.setAttribute(data.ty === 'gf' ? 'fill' : 'stroke', 'url(' + getLocationHref() + '#' + gradientId + ')');
        this.gf = gfill;
        this.cst = stops;
    };
    SVGGradientFillStyleData.prototype.setGradientOpacity = function(data, styleOb) {
        if (this.g._hasOpacity && !this.g._collapsable) {
            var stop;
            var j;
            var jLen;
            var mask = createNS('mask');
            var maskElement = createNS('path');
            mask.appendChild(maskElement);
            var opacityId = createElementID();
            var maskId = createElementID();
            mask.setAttribute('id', maskId);
            var opFill = createNS(data.t === 1 ? 'linearGradient' : 'radialGradient');
            opFill.setAttribute('id', opacityId);
            opFill.setAttribute('spreadMethod', 'pad');
            opFill.setAttribute('gradientUnits', 'userSpaceOnUse');
            jLen = data.g.k.k[0].s ? data.g.k.k[0].s.length : data.g.k.k.length;
            var stops = this.stops;
            for(j = data.g.p * 4; j < jLen; j += 2){
                stop = createNS('stop');
                stop.setAttribute('stop-color', 'rgb(255,255,255)');
                opFill.appendChild(stop);
                stops.push(stop);
            }
            maskElement.setAttribute(data.ty === 'gf' ? 'fill' : 'stroke', 'url(' + getLocationHref() + '#' + opacityId + ')');
            if (data.ty === 'gs') {
                maskElement.setAttribute('stroke-linecap', lineCapEnum[data.lc || 2]);
                maskElement.setAttribute('stroke-linejoin', lineJoinEnum[data.lj || 2]);
                if (data.lj === 1) maskElement.setAttribute('stroke-miterlimit', data.ml);
            }
            this.of = opFill;
            this.ms = mask;
            this.ost = stops;
            this.maskId = maskId;
            styleOb.msElem = maskElement;
        }
    };
    extendPrototype([
        DynamicPropertyContainer
    ], SVGGradientFillStyleData);
    function SVGGradientStrokeStyleData(elem, data, styleOb) {
        this.initDynamicPropertyContainer(elem);
        this.getValue = this.iterateDynamicProperties;
        this.w = PropertyFactory.getProp(elem, data.w, 0, null, this);
        this.d = new DashProperty(elem, data.d || {}, 'svg', this);
        this.initGradientData(elem, data, styleOb);
        this._isAnimated = !!this._isAnimated;
    }
    extendPrototype([
        SVGGradientFillStyleData,
        DynamicPropertyContainer
    ], SVGGradientStrokeStyleData);
    function ShapeGroupData() {
        this.it = [];
        this.prevViewData = [];
        this.gr = createNS('g');
    }
    function SVGTransformData(mProps, op, container) {
        this.transform = {
            mProps: mProps,
            op: op,
            container: container
        };
        this.elements = [];
        this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
    }
    var buildShapeString = function buildShapeString(pathNodes, length, closed, mat) {
        if (length === 0) return '';
        var _o = pathNodes.o;
        var _i = pathNodes.i;
        var _v = pathNodes.v;
        var i;
        var shapeString = ' M' + mat.applyToPointStringified(_v[0][0], _v[0][1]);
        for(i = 1; i < length; i += 1)shapeString += ' C' + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + ' ' + mat.applyToPointStringified(_i[i][0], _i[i][1]) + ' ' + mat.applyToPointStringified(_v[i][0], _v[i][1]);
        if (closed && length) {
            shapeString += ' C' + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + ' ' + mat.applyToPointStringified(_i[0][0], _i[0][1]) + ' ' + mat.applyToPointStringified(_v[0][0], _v[0][1]);
            shapeString += 'z';
        }
        return shapeString;
    };
    var SVGElementsRenderer = function() {
        var _identityMatrix = new Matrix();
        var _matrixHelper = new Matrix();
        var ob = {
            createRenderFunction: createRenderFunction
        };
        function createRenderFunction(data) {
            switch(data.ty){
                case 'fl':
                    return renderFill;
                case 'gf':
                    return renderGradient;
                case 'gs':
                    return renderGradientStroke;
                case 'st':
                    return renderStroke;
                case 'sh':
                case 'el':
                case 'rc':
                case 'sr':
                    return renderPath;
                case 'tr':
                    return renderContentTransform;
                case 'no':
                    return renderNoop;
                default:
                    return null;
            }
        }
        function renderContentTransform(styleData, itemData, isFirstFrame) {
            if (isFirstFrame || itemData.transform.op._mdf) itemData.transform.container.setAttribute('opacity', itemData.transform.op.v);
            if (isFirstFrame || itemData.transform.mProps._mdf) itemData.transform.container.setAttribute('transform', itemData.transform.mProps.v.to2dCSS());
        }
        function renderNoop() {}
        function renderPath(styleData, itemData, isFirstFrame) {
            var j;
            var jLen;
            var pathStringTransformed;
            var redraw;
            var pathNodes;
            var l;
            var lLen = itemData.styles.length;
            var lvl = itemData.lvl;
            var paths;
            var mat;
            var iterations;
            var k;
            for(l = 0; l < lLen; l += 1){
                redraw = itemData.sh._mdf || isFirstFrame;
                if (itemData.styles[l].lvl < lvl) {
                    mat = _matrixHelper.reset();
                    iterations = lvl - itemData.styles[l].lvl;
                    k = itemData.transformers.length - 1;
                    while(!redraw && iterations > 0){
                        redraw = itemData.transformers[k].mProps._mdf || redraw;
                        iterations -= 1;
                        k -= 1;
                    }
                    if (redraw) {
                        iterations = lvl - itemData.styles[l].lvl;
                        k = itemData.transformers.length - 1;
                        while(iterations > 0){
                            mat.multiply(itemData.transformers[k].mProps.v);
                            iterations -= 1;
                            k -= 1;
                        }
                    }
                } else mat = _identityMatrix;
                paths = itemData.sh.paths;
                jLen = paths._length;
                if (redraw) {
                    pathStringTransformed = '';
                    for(j = 0; j < jLen; j += 1){
                        pathNodes = paths.shapes[j];
                        if (pathNodes && pathNodes._length) pathStringTransformed += buildShapeString(pathNodes, pathNodes._length, pathNodes.c, mat);
                    }
                    itemData.caches[l] = pathStringTransformed;
                } else pathStringTransformed = itemData.caches[l];
                itemData.styles[l].d += styleData.hd === true ? '' : pathStringTransformed;
                itemData.styles[l]._mdf = redraw || itemData.styles[l]._mdf;
            }
        }
        function renderFill(styleData, itemData, isFirstFrame) {
            var styleElem = itemData.style;
            if (itemData.c._mdf || isFirstFrame) styleElem.pElem.setAttribute('fill', 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')');
            if (itemData.o._mdf || isFirstFrame) styleElem.pElem.setAttribute('fill-opacity', itemData.o.v);
        }
        function renderGradientStroke(styleData, itemData, isFirstFrame) {
            renderGradient(styleData, itemData, isFirstFrame);
            renderStroke(styleData, itemData, isFirstFrame);
        }
        function renderGradient(styleData, itemData, isFirstFrame) {
            var gfill = itemData.gf;
            var hasOpacity = itemData.g._hasOpacity;
            var pt1 = itemData.s.v;
            var pt2 = itemData.e.v;
            if (itemData.o._mdf || isFirstFrame) {
                var attr = styleData.ty === 'gf' ? 'fill-opacity' : 'stroke-opacity';
                itemData.style.pElem.setAttribute(attr, itemData.o.v);
            }
            if (itemData.s._mdf || isFirstFrame) {
                var attr1 = styleData.t === 1 ? 'x1' : 'cx';
                var attr2 = attr1 === 'x1' ? 'y1' : 'cy';
                gfill.setAttribute(attr1, pt1[0]);
                gfill.setAttribute(attr2, pt1[1]);
                if (hasOpacity && !itemData.g._collapsable) {
                    itemData.of.setAttribute(attr1, pt1[0]);
                    itemData.of.setAttribute(attr2, pt1[1]);
                }
            }
            var stops;
            var i;
            var len;
            var stop;
            if (itemData.g._cmdf || isFirstFrame) {
                stops = itemData.cst;
                var cValues = itemData.g.c;
                len = stops.length;
                for(i = 0; i < len; i += 1){
                    stop = stops[i];
                    stop.setAttribute('offset', cValues[i * 4] + '%');
                    stop.setAttribute('stop-color', 'rgb(' + cValues[i * 4 + 1] + ',' + cValues[i * 4 + 2] + ',' + cValues[i * 4 + 3] + ')');
                }
            }
            if (hasOpacity && (itemData.g._omdf || isFirstFrame)) {
                var oValues = itemData.g.o;
                if (itemData.g._collapsable) stops = itemData.cst;
                else stops = itemData.ost;
                len = stops.length;
                for(i = 0; i < len; i += 1){
                    stop = stops[i];
                    if (!itemData.g._collapsable) stop.setAttribute('offset', oValues[i * 2] + '%');
                    stop.setAttribute('stop-opacity', oValues[i * 2 + 1]);
                }
            }
            if (styleData.t === 1) {
                if (itemData.e._mdf || isFirstFrame) {
                    gfill.setAttribute('x2', pt2[0]);
                    gfill.setAttribute('y2', pt2[1]);
                    if (hasOpacity && !itemData.g._collapsable) {
                        itemData.of.setAttribute('x2', pt2[0]);
                        itemData.of.setAttribute('y2', pt2[1]);
                    }
                }
            } else {
                var rad;
                if (itemData.s._mdf || itemData.e._mdf || isFirstFrame) {
                    rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
                    gfill.setAttribute('r', rad);
                    if (hasOpacity && !itemData.g._collapsable) itemData.of.setAttribute('r', rad);
                }
                if (itemData.e._mdf || itemData.h._mdf || itemData.a._mdf || isFirstFrame) {
                    if (!rad) rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
                    var ang = Math.atan2(pt2[1] - pt1[1], pt2[0] - pt1[0]);
                    var percent = itemData.h.v;
                    if (percent >= 1) percent = 0.99;
                    else if (percent <= -1) percent = -0.99;
                    var dist = rad * percent;
                    var x = Math.cos(ang + itemData.a.v) * dist + pt1[0];
                    var y = Math.sin(ang + itemData.a.v) * dist + pt1[1];
                    gfill.setAttribute('fx', x);
                    gfill.setAttribute('fy', y);
                    if (hasOpacity && !itemData.g._collapsable) {
                        itemData.of.setAttribute('fx', x);
                        itemData.of.setAttribute('fy', y);
                    }
                } // gfill.setAttribute('fy','200');
            }
        }
        function renderStroke(styleData, itemData, isFirstFrame) {
            var styleElem = itemData.style;
            var d = itemData.d;
            if (d && (d._mdf || isFirstFrame) && d.dashStr) {
                styleElem.pElem.setAttribute('stroke-dasharray', d.dashStr);
                styleElem.pElem.setAttribute('stroke-dashoffset', d.dashoffset[0]);
            }
            if (itemData.c && (itemData.c._mdf || isFirstFrame)) styleElem.pElem.setAttribute('stroke', 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')');
            if (itemData.o._mdf || isFirstFrame) styleElem.pElem.setAttribute('stroke-opacity', itemData.o.v);
            if (itemData.w._mdf || isFirstFrame) {
                styleElem.pElem.setAttribute('stroke-width', itemData.w.v);
                if (styleElem.msElem) styleElem.msElem.setAttribute('stroke-width', itemData.w.v);
            }
        }
        return ob;
    }();
    function SVGShapeElement(data, globalData, comp) {
        // List of drawable elements
        this.shapes = []; // Full shape data
        this.shapesData = data.shapes; // List of styles that will be applied to shapes
        this.stylesList = []; // List of modifiers that will be applied to shapes
        this.shapeModifiers = []; // List of items in shape tree
        this.itemsData = []; // List of items in previous shape tree
        this.processedElements = []; // List of animated components
        this.animatedContents = [];
        this.initElement(data, globalData, comp); // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
        // List of elements that have been created
        this.prevViewData = []; // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        SVGBaseElement,
        IShapeElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement
    ], SVGShapeElement);
    SVGShapeElement.prototype.initSecondaryElement = function() {};
    SVGShapeElement.prototype.identityMatrix = new Matrix();
    SVGShapeElement.prototype.buildExpressionInterface = function() {};
    SVGShapeElement.prototype.createContent = function() {
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], true);
        this.filterUniqueShapes();
    };
    /*
  This method searches for multiple shapes that affect a single element and one of them is animated
  */ SVGShapeElement.prototype.filterUniqueShapes = function() {
        var i;
        var len = this.shapes.length;
        var shape;
        var j;
        var jLen = this.stylesList.length;
        var style;
        var tempShapes = [];
        var areAnimated = false;
        for(j = 0; j < jLen; j += 1){
            style = this.stylesList[j];
            areAnimated = false;
            tempShapes.length = 0;
            for(i = 0; i < len; i += 1){
                shape = this.shapes[i];
                if (shape.styles.indexOf(style) !== -1) {
                    tempShapes.push(shape);
                    areAnimated = shape._isAnimated || areAnimated;
                }
            }
            if (tempShapes.length > 1 && areAnimated) this.setShapesAsAnimated(tempShapes);
        }
    };
    SVGShapeElement.prototype.setShapesAsAnimated = function(shapes) {
        var i;
        var len = shapes.length;
        for(i = 0; i < len; i += 1)shapes[i].setAsAnimated();
    };
    SVGShapeElement.prototype.createStyleElement = function(data, level) {
        // TODO: prevent drawing of hidden styles
        var elementData;
        var styleOb = new SVGStyleData(data, level);
        var pathElement = styleOb.pElem;
        if (data.ty === 'st') elementData = new SVGStrokeStyleData(this, data, styleOb);
        else if (data.ty === 'fl') elementData = new SVGFillStyleData(this, data, styleOb);
        else if (data.ty === 'gf' || data.ty === 'gs') {
            var GradientConstructor = data.ty === 'gf' ? SVGGradientFillStyleData : SVGGradientStrokeStyleData;
            elementData = new GradientConstructor(this, data, styleOb);
            this.globalData.defs.appendChild(elementData.gf);
            if (elementData.maskId) {
                this.globalData.defs.appendChild(elementData.ms);
                this.globalData.defs.appendChild(elementData.of);
                pathElement.setAttribute('mask', 'url(' + getLocationHref() + '#' + elementData.maskId + ')');
            }
        } else if (data.ty === 'no') elementData = new SVGNoStyleData(this, data, styleOb);
        if (data.ty === 'st' || data.ty === 'gs') {
            pathElement.setAttribute('stroke-linecap', lineCapEnum[data.lc || 2]);
            pathElement.setAttribute('stroke-linejoin', lineJoinEnum[data.lj || 2]);
            pathElement.setAttribute('fill-opacity', '0');
            if (data.lj === 1) pathElement.setAttribute('stroke-miterlimit', data.ml);
        }
        if (data.r === 2) pathElement.setAttribute('fill-rule', 'evenodd');
        if (data.ln) pathElement.setAttribute('id', data.ln);
        if (data.cl) pathElement.setAttribute('class', data.cl);
        if (data.bm) pathElement.style['mix-blend-mode'] = getBlendMode(data.bm);
        this.stylesList.push(styleOb);
        this.addToAnimatedContents(data, elementData);
        return elementData;
    };
    SVGShapeElement.prototype.createGroupElement = function(data) {
        var elementData = new ShapeGroupData();
        if (data.ln) elementData.gr.setAttribute('id', data.ln);
        if (data.cl) elementData.gr.setAttribute('class', data.cl);
        if (data.bm) elementData.gr.style['mix-blend-mode'] = getBlendMode(data.bm);
        return elementData;
    };
    SVGShapeElement.prototype.createTransformElement = function(data, container) {
        var transformProperty = TransformPropertyFactory.getTransformProperty(this, data, this);
        var elementData = new SVGTransformData(transformProperty, transformProperty.o, container);
        this.addToAnimatedContents(data, elementData);
        return elementData;
    };
    SVGShapeElement.prototype.createShapeElement = function(data, ownTransformers, level) {
        var ty = 4;
        if (data.ty === 'rc') ty = 5;
        else if (data.ty === 'el') ty = 6;
        else if (data.ty === 'sr') ty = 7;
        var shapeProperty = ShapePropertyFactory.getShapeProp(this, data, ty, this);
        var elementData = new SVGShapeData(ownTransformers, level, shapeProperty);
        this.shapes.push(elementData);
        this.addShapeToModifiers(elementData);
        this.addToAnimatedContents(data, elementData);
        return elementData;
    };
    SVGShapeElement.prototype.addToAnimatedContents = function(data, element) {
        var i = 0;
        var len = this.animatedContents.length;
        while(i < len){
            if (this.animatedContents[i].element === element) return;
            i += 1;
        }
        this.animatedContents.push({
            fn: SVGElementsRenderer.createRenderFunction(data),
            element: element,
            data: data
        });
    };
    SVGShapeElement.prototype.setElementStyles = function(elementData) {
        var arr = elementData.styles;
        var j;
        var jLen = this.stylesList.length;
        for(j = 0; j < jLen; j += 1)if (!this.stylesList[j].closed) arr.push(this.stylesList[j]);
    };
    SVGShapeElement.prototype.reloadShapes = function() {
        this._isFirstFrame = true;
        var i;
        var len = this.itemsData.length;
        for(i = 0; i < len; i += 1)this.prevViewData[i] = this.itemsData[i];
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], true);
        this.filterUniqueShapes();
        len = this.dynamicProperties.length;
        for(i = 0; i < len; i += 1)this.dynamicProperties[i].getValue();
        this.renderModifiers();
    };
    SVGShapeElement.prototype.searchShapes = function(arr, itemsData, prevViewData, container, level, transformers, render) {
        var ownTransformers = [].concat(transformers);
        var i;
        var len = arr.length - 1;
        var j;
        var jLen;
        var ownStyles = [];
        var ownModifiers = [];
        var currentTransform;
        var modifier;
        var processedPos;
        for(i = len; i >= 0; i -= 1){
            processedPos = this.searchProcessedElement(arr[i]);
            if (!processedPos) arr[i]._render = render;
            else itemsData[i] = prevViewData[processedPos - 1];
            if (arr[i].ty === 'fl' || arr[i].ty === 'st' || arr[i].ty === 'gf' || arr[i].ty === 'gs' || arr[i].ty === 'no') {
                if (!processedPos) itemsData[i] = this.createStyleElement(arr[i], level);
                else itemsData[i].style.closed = false;
                if (arr[i]._render) {
                    if (itemsData[i].style.pElem.parentNode !== container) container.appendChild(itemsData[i].style.pElem);
                }
                ownStyles.push(itemsData[i].style);
            } else if (arr[i].ty === 'gr') {
                if (!processedPos) itemsData[i] = this.createGroupElement(arr[i]);
                else {
                    jLen = itemsData[i].it.length;
                    for(j = 0; j < jLen; j += 1)itemsData[i].prevViewData[j] = itemsData[i].it[j];
                }
                this.searchShapes(arr[i].it, itemsData[i].it, itemsData[i].prevViewData, itemsData[i].gr, level + 1, ownTransformers, render);
                if (arr[i]._render) {
                    if (itemsData[i].gr.parentNode !== container) container.appendChild(itemsData[i].gr);
                }
            } else if (arr[i].ty === 'tr') {
                if (!processedPos) itemsData[i] = this.createTransformElement(arr[i], container);
                currentTransform = itemsData[i].transform;
                ownTransformers.push(currentTransform);
            } else if (arr[i].ty === 'sh' || arr[i].ty === 'rc' || arr[i].ty === 'el' || arr[i].ty === 'sr') {
                if (!processedPos) itemsData[i] = this.createShapeElement(arr[i], ownTransformers, level);
                this.setElementStyles(itemsData[i]);
            } else if (arr[i].ty === 'tm' || arr[i].ty === 'rd' || arr[i].ty === 'ms' || arr[i].ty === 'pb' || arr[i].ty === 'zz' || arr[i].ty === 'op') {
                if (!processedPos) {
                    modifier = ShapeModifiers.getModifier(arr[i].ty);
                    modifier.init(this, arr[i]);
                    itemsData[i] = modifier;
                    this.shapeModifiers.push(modifier);
                } else {
                    modifier = itemsData[i];
                    modifier.closed = false;
                }
                ownModifiers.push(modifier);
            } else if (arr[i].ty === 'rp') {
                if (!processedPos) {
                    modifier = ShapeModifiers.getModifier(arr[i].ty);
                    itemsData[i] = modifier;
                    modifier.init(this, arr, i, itemsData);
                    this.shapeModifiers.push(modifier);
                    render = false;
                } else {
                    modifier = itemsData[i];
                    modifier.closed = true;
                }
                ownModifiers.push(modifier);
            }
            this.addProcessedElement(arr[i], i + 1);
        }
        len = ownStyles.length;
        for(i = 0; i < len; i += 1)ownStyles[i].closed = true;
        len = ownModifiers.length;
        for(i = 0; i < len; i += 1)ownModifiers[i].closed = true;
    };
    SVGShapeElement.prototype.renderInnerContent = function() {
        this.renderModifiers();
        var i;
        var len = this.stylesList.length;
        for(i = 0; i < len; i += 1)this.stylesList[i].reset();
        this.renderShape();
        for(i = 0; i < len; i += 1)if (this.stylesList[i]._mdf || this._isFirstFrame) {
            if (this.stylesList[i].msElem) {
                this.stylesList[i].msElem.setAttribute('d', this.stylesList[i].d); // Adding M0 0 fixes same mask bug on all browsers
                this.stylesList[i].d = 'M0 0' + this.stylesList[i].d;
            }
            this.stylesList[i].pElem.setAttribute('d', this.stylesList[i].d || 'M0 0');
        }
    };
    SVGShapeElement.prototype.renderShape = function() {
        var i;
        var len = this.animatedContents.length;
        var animatedContent;
        for(i = 0; i < len; i += 1){
            animatedContent = this.animatedContents[i];
            if ((this._isFirstFrame || animatedContent.element._isAnimated) && animatedContent.data !== true) animatedContent.fn(animatedContent.data, animatedContent.element, this._isFirstFrame);
        }
    };
    SVGShapeElement.prototype.destroy = function() {
        this.destroyBaseElement();
        this.shapesData = null;
        this.itemsData = null;
    };
    function LetterProps(o, sw, sc, fc, m, p) {
        this.o = o;
        this.sw = sw;
        this.sc = sc;
        this.fc = fc;
        this.m = m;
        this.p = p;
        this._mdf = {
            o: true,
            sw: !!sw,
            sc: !!sc,
            fc: !!fc,
            m: true,
            p: true
        };
    }
    LetterProps.prototype.update = function(o, sw, sc, fc, m, p) {
        this._mdf.o = false;
        this._mdf.sw = false;
        this._mdf.sc = false;
        this._mdf.fc = false;
        this._mdf.m = false;
        this._mdf.p = false;
        var updated = false;
        if (this.o !== o) {
            this.o = o;
            this._mdf.o = true;
            updated = true;
        }
        if (this.sw !== sw) {
            this.sw = sw;
            this._mdf.sw = true;
            updated = true;
        }
        if (this.sc !== sc) {
            this.sc = sc;
            this._mdf.sc = true;
            updated = true;
        }
        if (this.fc !== fc) {
            this.fc = fc;
            this._mdf.fc = true;
            updated = true;
        }
        if (this.m !== m) {
            this.m = m;
            this._mdf.m = true;
            updated = true;
        }
        if (p.length && (this.p[0] !== p[0] || this.p[1] !== p[1] || this.p[4] !== p[4] || this.p[5] !== p[5] || this.p[12] !== p[12] || this.p[13] !== p[13])) {
            this.p = p;
            this._mdf.p = true;
            updated = true;
        }
        return updated;
    };
    function TextProperty(elem, data) {
        this._frameId = initialDefaultFrame;
        this.pv = '';
        this.v = '';
        this.kf = false;
        this._isFirstFrame = true;
        this._mdf = false;
        if (data.d && data.d.sid) data.d = elem.globalData.slotManager.getProp(data.d);
        this.data = data;
        this.elem = elem;
        this.comp = this.elem.comp;
        this.keysIndex = 0;
        this.canResize = false;
        this.minimumFontSize = 1;
        this.effectsSequence = [];
        this.currentData = {
            ascent: 0,
            boxWidth: this.defaultBoxWidth,
            f: '',
            fStyle: '',
            fWeight: '',
            fc: '',
            j: '',
            justifyOffset: '',
            l: [],
            lh: 0,
            lineWidths: [],
            ls: '',
            of: '',
            s: '',
            sc: '',
            sw: 0,
            t: 0,
            tr: 0,
            sz: 0,
            ps: null,
            fillColorAnim: false,
            strokeColorAnim: false,
            strokeWidthAnim: false,
            yOffset: 0,
            finalSize: 0,
            finalText: [],
            finalLineHeight: 0,
            __complete: false
        };
        this.copyData(this.currentData, this.data.d.k[0].s);
        if (!this.searchProperty()) this.completeTextData(this.currentData);
    }
    TextProperty.prototype.defaultBoxWidth = [
        0,
        0
    ];
    TextProperty.prototype.copyData = function(obj, data) {
        for(var s in data)if (Object.prototype.hasOwnProperty.call(data, s)) obj[s] = data[s];
        return obj;
    };
    TextProperty.prototype.setCurrentData = function(data) {
        if (!data.__complete) this.completeTextData(data);
        this.currentData = data;
        this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth;
        this._mdf = true;
    };
    TextProperty.prototype.searchProperty = function() {
        return this.searchKeyframes();
    };
    TextProperty.prototype.searchKeyframes = function() {
        this.kf = this.data.d.k.length > 1;
        if (this.kf) this.addEffect(this.getKeyframeValue.bind(this));
        return this.kf;
    };
    TextProperty.prototype.addEffect = function(effectFunction) {
        this.effectsSequence.push(effectFunction);
        this.elem.addDynamicProperty(this);
    };
    TextProperty.prototype.getValue = function(_finalValue) {
        if ((this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) && !_finalValue) return;
        this.currentData.t = this.data.d.k[this.keysIndex].s.t;
        var currentValue = this.currentData;
        var currentIndex = this.keysIndex;
        if (this.lock) {
            this.setCurrentData(this.currentData);
            return;
        }
        this.lock = true;
        this._mdf = false;
        var i;
        var len = this.effectsSequence.length;
        var finalValue = _finalValue || this.data.d.k[this.keysIndex].s;
        for(i = 0; i < len; i += 1)// Checking if index changed to prevent creating a new object every time the expression updates.
        if (currentIndex !== this.keysIndex) finalValue = this.effectsSequence[i](finalValue, finalValue.t);
        else finalValue = this.effectsSequence[i](this.currentData, finalValue.t);
        if (currentValue !== finalValue) this.setCurrentData(finalValue);
        this.v = this.currentData;
        this.pv = this.v;
        this.lock = false;
        this.frameId = this.elem.globalData.frameId;
    };
    TextProperty.prototype.getKeyframeValue = function() {
        var textKeys = this.data.d.k;
        var frameNum = this.elem.comp.renderedFrame;
        var i = 0;
        var len = textKeys.length;
        while(i <= len - 1){
            if (i === len - 1 || textKeys[i + 1].t > frameNum) break;
            i += 1;
        }
        if (this.keysIndex !== i) this.keysIndex = i;
        return this.data.d.k[this.keysIndex].s;
    };
    TextProperty.prototype.buildFinalText = function(text) {
        var charactersArray = [];
        var i = 0;
        var len = text.length;
        var charCode;
        var secondCharCode;
        var shouldCombine = false;
        var shouldCombineNext = false;
        var currentChars = '';
        while(i < len){
            shouldCombine = shouldCombineNext;
            shouldCombineNext = false;
            charCode = text.charCodeAt(i);
            currentChars = text.charAt(i);
            if (FontManager.isCombinedCharacter(charCode)) shouldCombine = true; // It's a potential surrogate pair (this is the High surrogate)
            else if (charCode >= 0xD800 && charCode <= 0xDBFF) {
                if (FontManager.isRegionalFlag(text, i)) currentChars = text.substr(i, 14);
                else {
                    secondCharCode = text.charCodeAt(i + 1); // It's a surrogate pair (this is the Low surrogate)
                    if (secondCharCode >= 0xDC00 && secondCharCode <= 0xDFFF) {
                        if (FontManager.isModifier(charCode, secondCharCode)) {
                            currentChars = text.substr(i, 2);
                            shouldCombine = true;
                        } else if (FontManager.isFlagEmoji(text.substr(i, 4))) currentChars = text.substr(i, 4);
                        else currentChars = text.substr(i, 2);
                    }
                }
            } else if (charCode > 0xDBFF) {
                secondCharCode = text.charCodeAt(i + 1);
                if (FontManager.isVariationSelector(charCode)) shouldCombine = true;
            } else if (FontManager.isZeroWidthJoiner(charCode)) {
                shouldCombine = true;
                shouldCombineNext = true;
            }
            if (shouldCombine) {
                charactersArray[charactersArray.length - 1] += currentChars;
                shouldCombine = false;
            } else charactersArray.push(currentChars);
            i += currentChars.length;
        }
        return charactersArray;
    };
    TextProperty.prototype.completeTextData = function(documentData) {
        documentData.__complete = true;
        var fontManager = this.elem.globalData.fontManager;
        var data = this.data;
        var letters = [];
        var i;
        var len;
        var newLineFlag;
        var index = 0;
        var val;
        var anchorGrouping = data.m.g;
        var currentSize = 0;
        var currentPos = 0;
        var currentLine = 0;
        var lineWidths = [];
        var lineWidth = 0;
        var maxLineWidth = 0;
        var j;
        var jLen;
        var fontData = fontManager.getFontByName(documentData.f);
        var charData;
        var cLength = 0;
        var fontProps = getFontProperties(fontData);
        documentData.fWeight = fontProps.weight;
        documentData.fStyle = fontProps.style;
        documentData.finalSize = documentData.s;
        documentData.finalText = this.buildFinalText(documentData.t);
        len = documentData.finalText.length;
        documentData.finalLineHeight = documentData.lh;
        var trackingOffset = documentData.tr / 1000 * documentData.finalSize;
        var charCode;
        if (documentData.sz) {
            var flag = true;
            var boxWidth = documentData.sz[0];
            var boxHeight = documentData.sz[1];
            var currentHeight;
            var finalText;
            while(flag){
                finalText = this.buildFinalText(documentData.t);
                currentHeight = 0;
                lineWidth = 0;
                len = finalText.length;
                trackingOffset = documentData.tr / 1000 * documentData.finalSize;
                var lastSpaceIndex = -1;
                for(i = 0; i < len; i += 1){
                    charCode = finalText[i].charCodeAt(0);
                    newLineFlag = false;
                    if (finalText[i] === ' ') lastSpaceIndex = i;
                    else if (charCode === 13 || charCode === 3) {
                        lineWidth = 0;
                        newLineFlag = true;
                        currentHeight += documentData.finalLineHeight || documentData.finalSize * 1.2;
                    }
                    if (fontManager.chars) {
                        charData = fontManager.getCharData(finalText[i], fontData.fStyle, fontData.fFamily);
                        cLength = newLineFlag ? 0 : charData.w * documentData.finalSize / 100;
                    } else // tCanvasHelper.font = documentData.s + 'px '+ fontData.fFamily;
                    cLength = fontManager.measureText(finalText[i], documentData.f, documentData.finalSize);
                    if (lineWidth + cLength > boxWidth && finalText[i] !== ' ') {
                        if (lastSpaceIndex === -1) len += 1;
                        else i = lastSpaceIndex;
                        currentHeight += documentData.finalLineHeight || documentData.finalSize * 1.2;
                        finalText.splice(i, lastSpaceIndex === i ? 1 : 0, '\r'); // finalText = finalText.substr(0,i) + "\r" + finalText.substr(i === lastSpaceIndex ? i + 1 : i);
                        lastSpaceIndex = -1;
                        lineWidth = 0;
                    } else {
                        lineWidth += cLength;
                        lineWidth += trackingOffset;
                    }
                }
                currentHeight += fontData.ascent * documentData.finalSize / 100;
                if (this.canResize && documentData.finalSize > this.minimumFontSize && boxHeight < currentHeight) {
                    documentData.finalSize -= 1;
                    documentData.finalLineHeight = documentData.finalSize * documentData.lh / documentData.s;
                } else {
                    documentData.finalText = finalText;
                    len = documentData.finalText.length;
                    flag = false;
                }
            }
        }
        lineWidth = -trackingOffset;
        cLength = 0;
        var uncollapsedSpaces = 0;
        var currentChar;
        for(i = 0; i < len; i += 1){
            newLineFlag = false;
            currentChar = documentData.finalText[i];
            charCode = currentChar.charCodeAt(0);
            if (charCode === 13 || charCode === 3) {
                uncollapsedSpaces = 0;
                lineWidths.push(lineWidth);
                maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
                lineWidth = -2 * trackingOffset;
                val = '';
                newLineFlag = true;
                currentLine += 1;
            } else val = currentChar;
            if (fontManager.chars) {
                charData = fontManager.getCharData(currentChar, fontData.fStyle, fontManager.getFontByName(documentData.f).fFamily);
                cLength = newLineFlag ? 0 : charData.w * documentData.finalSize / 100;
            } else // var charWidth = fontManager.measureText(val, documentData.f, documentData.finalSize);
            // tCanvasHelper.font = documentData.finalSize + 'px '+ fontManager.getFontByName(documentData.f).fFamily;
            cLength = fontManager.measureText(val, documentData.f, documentData.finalSize);
             //
            if (currentChar === ' ') uncollapsedSpaces += cLength + trackingOffset;
            else {
                lineWidth += cLength + trackingOffset + uncollapsedSpaces;
                uncollapsedSpaces = 0;
            }
            letters.push({
                l: cLength,
                an: cLength,
                add: currentSize,
                n: newLineFlag,
                anIndexes: [],
                val: val,
                line: currentLine,
                animatorJustifyOffset: 0
            });
            if (anchorGrouping == 2) {
                // eslint-disable-line eqeqeq
                currentSize += cLength;
                if (val === '' || val === ' ' || i === len - 1) {
                    if (val === '' || val === ' ') currentSize -= cLength;
                    while(currentPos <= i){
                        letters[currentPos].an = currentSize;
                        letters[currentPos].ind = index;
                        letters[currentPos].extra = cLength;
                        currentPos += 1;
                    }
                    index += 1;
                    currentSize = 0;
                }
            } else if (anchorGrouping == 3) {
                // eslint-disable-line eqeqeq
                currentSize += cLength;
                if (val === '' || i === len - 1) {
                    if (val === '') currentSize -= cLength;
                    while(currentPos <= i){
                        letters[currentPos].an = currentSize;
                        letters[currentPos].ind = index;
                        letters[currentPos].extra = cLength;
                        currentPos += 1;
                    }
                    currentSize = 0;
                    index += 1;
                }
            } else {
                letters[index].ind = index;
                letters[index].extra = 0;
                index += 1;
            }
        }
        documentData.l = letters;
        maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
        lineWidths.push(lineWidth);
        if (documentData.sz) {
            documentData.boxWidth = documentData.sz[0];
            documentData.justifyOffset = 0;
        } else {
            documentData.boxWidth = maxLineWidth;
            switch(documentData.j){
                case 1:
                    documentData.justifyOffset = -documentData.boxWidth;
                    break;
                case 2:
                    documentData.justifyOffset = -documentData.boxWidth / 2;
                    break;
                default:
                    documentData.justifyOffset = 0;
            }
        }
        documentData.lineWidths = lineWidths;
        var animators = data.a;
        var animatorData;
        var letterData;
        jLen = animators.length;
        var based;
        var ind;
        var indexes = [];
        for(j = 0; j < jLen; j += 1){
            animatorData = animators[j];
            if (animatorData.a.sc) documentData.strokeColorAnim = true;
            if (animatorData.a.sw) documentData.strokeWidthAnim = true;
            if (animatorData.a.fc || animatorData.a.fh || animatorData.a.fs || animatorData.a.fb) documentData.fillColorAnim = true;
            ind = 0;
            based = animatorData.s.b;
            for(i = 0; i < len; i += 1){
                letterData = letters[i];
                letterData.anIndexes[j] = ind;
                if (based == 1 && letterData.val !== '' || based == 2 && letterData.val !== '' && letterData.val !== ' ' || based == 3 && (letterData.n || letterData.val == ' ' || i == len - 1) || based == 4 && (letterData.n || i == len - 1)) {
                    // eslint-disable-line eqeqeq
                    if (animatorData.s.rn === 1) indexes.push(ind);
                    ind += 1;
                }
            }
            data.a[j].s.totalChars = ind;
            var currentInd = -1;
            var newInd;
            if (animatorData.s.rn === 1) for(i = 0; i < len; i += 1){
                letterData = letters[i];
                if (currentInd != letterData.anIndexes[j]) {
                    // eslint-disable-line eqeqeq
                    currentInd = letterData.anIndexes[j];
                    newInd = indexes.splice(Math.floor(Math.random() * indexes.length), 1)[0];
                }
                letterData.anIndexes[j] = newInd;
            }
        }
        documentData.yOffset = documentData.finalLineHeight || documentData.finalSize * 1.2;
        documentData.ls = documentData.ls || 0;
        documentData.ascent = fontData.ascent * documentData.finalSize / 100;
    };
    TextProperty.prototype.updateDocumentData = function(newData, index) {
        index = index === undefined ? this.keysIndex : index;
        var dData = this.copyData({}, this.data.d.k[index].s);
        dData = this.copyData(dData, newData);
        this.data.d.k[index].s = dData;
        this.recalculate(index);
        this.setCurrentData(dData);
        this.elem.addDynamicProperty(this);
    };
    TextProperty.prototype.recalculate = function(index) {
        var dData = this.data.d.k[index].s;
        dData.__complete = false;
        this.keysIndex = 0;
        this._isFirstFrame = true;
        this.getValue(dData);
    };
    TextProperty.prototype.canResizeFont = function(_canResize) {
        this.canResize = _canResize;
        this.recalculate(this.keysIndex);
        this.elem.addDynamicProperty(this);
    };
    TextProperty.prototype.setMinimumFontSize = function(_fontValue) {
        this.minimumFontSize = Math.floor(_fontValue) || 1;
        this.recalculate(this.keysIndex);
        this.elem.addDynamicProperty(this);
    };
    var TextSelectorProp = function() {
        var max = Math.max;
        var min = Math.min;
        var floor = Math.floor;
        function TextSelectorPropFactory(elem, data) {
            this._currentTextLength = -1;
            this.k = false;
            this.data = data;
            this.elem = elem;
            this.comp = elem.comp;
            this.finalS = 0;
            this.finalE = 0;
            this.initDynamicPropertyContainer(elem);
            this.s = PropertyFactory.getProp(elem, data.s || {
                k: 0
            }, 0, 0, this);
            if ('e' in data) this.e = PropertyFactory.getProp(elem, data.e, 0, 0, this);
            else this.e = {
                v: 100
            };
            this.o = PropertyFactory.getProp(elem, data.o || {
                k: 0
            }, 0, 0, this);
            this.xe = PropertyFactory.getProp(elem, data.xe || {
                k: 0
            }, 0, 0, this);
            this.ne = PropertyFactory.getProp(elem, data.ne || {
                k: 0
            }, 0, 0, this);
            this.sm = PropertyFactory.getProp(elem, data.sm || {
                k: 100
            }, 0, 0, this);
            this.a = PropertyFactory.getProp(elem, data.a, 0, 0.01, this);
            if (!this.dynamicProperties.length) this.getValue();
        }
        TextSelectorPropFactory.prototype = {
            getMult: function getMult(ind) {
                if (this._currentTextLength !== this.elem.textProperty.currentData.l.length) this.getValue();
                var x1 = 0;
                var y1 = 0;
                var x2 = 1;
                var y2 = 1;
                if (this.ne.v > 0) x1 = this.ne.v / 100.0;
                else y1 = -this.ne.v / 100.0;
                if (this.xe.v > 0) x2 = 1.0 - this.xe.v / 100.0;
                else y2 = 1.0 + this.xe.v / 100.0;
                var easer = BezierFactory.getBezierEasing(x1, y1, x2, y2).get;
                var mult = 0;
                var s = this.finalS;
                var e = this.finalE;
                var type = this.data.sh;
                if (type === 2) {
                    if (e === s) mult = ind >= e ? 1 : 0;
                    else mult = max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
                    mult = easer(mult);
                } else if (type === 3) {
                    if (e === s) mult = ind >= e ? 0 : 1;
                    else mult = 1 - max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
                    mult = easer(mult);
                } else if (type === 4) {
                    if (e === s) mult = 0;
                    else {
                        mult = max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
                        if (mult < 0.5) mult *= 2;
                        else mult = 1 - 2 * (mult - 0.5);
                    }
                    mult = easer(mult);
                } else if (type === 5) {
                    if (e === s) mult = 0;
                    else {
                        var tot = e - s;
                        /* ind += 0.5;
                      mult = -4/(tot*tot)*(ind*ind)+(4/tot)*ind; */ ind = min(max(0, ind + 0.5 - s), e - s);
                        var x = -tot / 2 + ind;
                        var a = tot / 2;
                        mult = Math.sqrt(1 - x * x / (a * a));
                    }
                    mult = easer(mult);
                } else if (type === 6) {
                    if (e === s) mult = 0;
                    else {
                        ind = min(max(0, ind + 0.5 - s), e - s);
                        mult = (1 + Math.cos(Math.PI + Math.PI * 2 * ind / (e - s))) / 2; // eslint-disable-line
                    }
                    mult = easer(mult);
                } else {
                    if (ind >= floor(s)) {
                        if (ind - s < 0) mult = max(0, min(min(e, 1) - (s - ind), 1));
                        else mult = max(0, min(e - ind, 1));
                    }
                    mult = easer(mult);
                } // Smoothness implementation.
                // The smoothness represents a reduced range of the original [0; 1] range.
                // if smoothness is 25%, the new range will be [0.375; 0.625]
                // Steps are:
                // - find the lower value of the new range (threshold)
                // - if multiplier is smaller than that value, floor it to 0
                // - if it is larger,
                //     - subtract the threshold
                //     - divide it by the smoothness (this will return the range to [0; 1])
                // Note: If it doesn't work on some scenarios, consider applying it before the easer.
                if (this.sm.v !== 100) {
                    var smoothness = this.sm.v * 0.01;
                    if (smoothness === 0) smoothness = 0.00000001;
                    var threshold = 0.5 - smoothness * 0.5;
                    if (mult < threshold) mult = 0;
                    else {
                        mult = (mult - threshold) / smoothness;
                        if (mult > 1) mult = 1;
                    }
                }
                return mult * this.a.v;
            },
            getValue: function getValue(newCharsFlag) {
                this.iterateDynamicProperties();
                this._mdf = newCharsFlag || this._mdf;
                this._currentTextLength = this.elem.textProperty.currentData.l.length || 0;
                if (newCharsFlag && this.data.r === 2) this.e.v = this._currentTextLength;
                var divisor = this.data.r === 2 ? 1 : 100 / this.data.totalChars;
                var o = this.o.v / divisor;
                var s = this.s.v / divisor + o;
                var e = this.e.v / divisor + o;
                if (s > e) {
                    var _s = s;
                    s = e;
                    e = _s;
                }
                this.finalS = s;
                this.finalE = e;
            }
        };
        extendPrototype([
            DynamicPropertyContainer
        ], TextSelectorPropFactory);
        function getTextSelectorProp(elem, data, arr) {
            return new TextSelectorPropFactory(elem, data, arr);
        }
        return {
            getTextSelectorProp: getTextSelectorProp
        };
    }();
    function TextAnimatorDataProperty(elem, animatorProps, container) {
        var defaultData = {
            propType: false
        };
        var getProp = PropertyFactory.getProp;
        var textAnimatorAnimatables = animatorProps.a;
        this.a = {
            r: textAnimatorAnimatables.r ? getProp(elem, textAnimatorAnimatables.r, 0, degToRads, container) : defaultData,
            rx: textAnimatorAnimatables.rx ? getProp(elem, textAnimatorAnimatables.rx, 0, degToRads, container) : defaultData,
            ry: textAnimatorAnimatables.ry ? getProp(elem, textAnimatorAnimatables.ry, 0, degToRads, container) : defaultData,
            sk: textAnimatorAnimatables.sk ? getProp(elem, textAnimatorAnimatables.sk, 0, degToRads, container) : defaultData,
            sa: textAnimatorAnimatables.sa ? getProp(elem, textAnimatorAnimatables.sa, 0, degToRads, container) : defaultData,
            s: textAnimatorAnimatables.s ? getProp(elem, textAnimatorAnimatables.s, 1, 0.01, container) : defaultData,
            a: textAnimatorAnimatables.a ? getProp(elem, textAnimatorAnimatables.a, 1, 0, container) : defaultData,
            o: textAnimatorAnimatables.o ? getProp(elem, textAnimatorAnimatables.o, 0, 0.01, container) : defaultData,
            p: textAnimatorAnimatables.p ? getProp(elem, textAnimatorAnimatables.p, 1, 0, container) : defaultData,
            sw: textAnimatorAnimatables.sw ? getProp(elem, textAnimatorAnimatables.sw, 0, 0, container) : defaultData,
            sc: textAnimatorAnimatables.sc ? getProp(elem, textAnimatorAnimatables.sc, 1, 0, container) : defaultData,
            fc: textAnimatorAnimatables.fc ? getProp(elem, textAnimatorAnimatables.fc, 1, 0, container) : defaultData,
            fh: textAnimatorAnimatables.fh ? getProp(elem, textAnimatorAnimatables.fh, 0, 0, container) : defaultData,
            fs: textAnimatorAnimatables.fs ? getProp(elem, textAnimatorAnimatables.fs, 0, 0.01, container) : defaultData,
            fb: textAnimatorAnimatables.fb ? getProp(elem, textAnimatorAnimatables.fb, 0, 0.01, container) : defaultData,
            t: textAnimatorAnimatables.t ? getProp(elem, textAnimatorAnimatables.t, 0, 0, container) : defaultData
        };
        this.s = TextSelectorProp.getTextSelectorProp(elem, animatorProps.s, container);
        this.s.t = animatorProps.s.t;
    }
    function TextAnimatorProperty(textData, renderType, elem) {
        this._isFirstFrame = true;
        this._hasMaskedPath = false;
        this._frameId = -1;
        this._textData = textData;
        this._renderType = renderType;
        this._elem = elem;
        this._animatorsData = createSizedArray(this._textData.a.length);
        this._pathData = {};
        this._moreOptions = {
            alignment: {}
        };
        this.renderedLetters = [];
        this.lettersChangedFlag = false;
        this.initDynamicPropertyContainer(elem);
    }
    TextAnimatorProperty.prototype.searchProperties = function() {
        var i;
        var len = this._textData.a.length;
        var animatorProps;
        var getProp = PropertyFactory.getProp;
        for(i = 0; i < len; i += 1){
            animatorProps = this._textData.a[i];
            this._animatorsData[i] = new TextAnimatorDataProperty(this._elem, animatorProps, this);
        }
        if (this._textData.p && 'm' in this._textData.p) {
            this._pathData = {
                a: getProp(this._elem, this._textData.p.a, 0, 0, this),
                f: getProp(this._elem, this._textData.p.f, 0, 0, this),
                l: getProp(this._elem, this._textData.p.l, 0, 0, this),
                r: getProp(this._elem, this._textData.p.r, 0, 0, this),
                p: getProp(this._elem, this._textData.p.p, 0, 0, this),
                m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
            };
            this._hasMaskedPath = true;
        } else this._hasMaskedPath = false;
        this._moreOptions.alignment = getProp(this._elem, this._textData.m.a, 1, 0, this);
    };
    TextAnimatorProperty.prototype.getMeasures = function(documentData, lettersChangedFlag) {
        this.lettersChangedFlag = lettersChangedFlag;
        if (!this._mdf && !this._isFirstFrame && !lettersChangedFlag && (!this._hasMaskedPath || !this._pathData.m._mdf)) return;
        this._isFirstFrame = false;
        var alignment = this._moreOptions.alignment.v;
        var animators = this._animatorsData;
        var textData = this._textData;
        var matrixHelper = this.mHelper;
        var renderType = this._renderType;
        var renderedLettersCount = this.renderedLetters.length;
        var xPos;
        var yPos;
        var i;
        var len;
        var letters = documentData.l;
        var pathInfo;
        var currentLength;
        var currentPoint;
        var segmentLength;
        var flag;
        var pointInd;
        var segmentInd;
        var prevPoint;
        var points;
        var segments;
        var partialLength;
        var totalLength;
        var perc;
        var tanAngle;
        var mask;
        if (this._hasMaskedPath) {
            mask = this._pathData.m;
            if (!this._pathData.n || this._pathData._mdf) {
                var paths = mask.v;
                if (this._pathData.r.v) paths = paths.reverse();
                 // TODO: release bezier data cached from previous pathInfo: this._pathData.pi
                pathInfo = {
                    tLength: 0,
                    segments: []
                };
                len = paths._length - 1;
                var bezierData;
                totalLength = 0;
                for(i = 0; i < len; i += 1){
                    bezierData = bez.buildBezierData(paths.v[i], paths.v[i + 1], [
                        paths.o[i][0] - paths.v[i][0],
                        paths.o[i][1] - paths.v[i][1]
                    ], [
                        paths.i[i + 1][0] - paths.v[i + 1][0],
                        paths.i[i + 1][1] - paths.v[i + 1][1]
                    ]);
                    pathInfo.tLength += bezierData.segmentLength;
                    pathInfo.segments.push(bezierData);
                    totalLength += bezierData.segmentLength;
                }
                i = len;
                if (mask.v.c) {
                    bezierData = bez.buildBezierData(paths.v[i], paths.v[0], [
                        paths.o[i][0] - paths.v[i][0],
                        paths.o[i][1] - paths.v[i][1]
                    ], [
                        paths.i[0][0] - paths.v[0][0],
                        paths.i[0][1] - paths.v[0][1]
                    ]);
                    pathInfo.tLength += bezierData.segmentLength;
                    pathInfo.segments.push(bezierData);
                    totalLength += bezierData.segmentLength;
                }
                this._pathData.pi = pathInfo;
            }
            pathInfo = this._pathData.pi;
            currentLength = this._pathData.f.v;
            segmentInd = 0;
            pointInd = 1;
            segmentLength = 0;
            flag = true;
            segments = pathInfo.segments;
            if (currentLength < 0 && mask.v.c) {
                if (pathInfo.tLength < Math.abs(currentLength)) currentLength = -Math.abs(currentLength) % pathInfo.tLength;
                segmentInd = segments.length - 1;
                points = segments[segmentInd].points;
                pointInd = points.length - 1;
                while(currentLength < 0){
                    currentLength += points[pointInd].partialLength;
                    pointInd -= 1;
                    if (pointInd < 0) {
                        segmentInd -= 1;
                        points = segments[segmentInd].points;
                        pointInd = points.length - 1;
                    }
                }
            }
            points = segments[segmentInd].points;
            prevPoint = points[pointInd - 1];
            currentPoint = points[pointInd];
            partialLength = currentPoint.partialLength;
        }
        len = letters.length;
        xPos = 0;
        yPos = 0;
        var yOff = documentData.finalSize * 1.2 * 0.714;
        var firstLine = true;
        var animatorProps;
        var animatorSelector;
        var j;
        var jLen;
        var letterValue;
        jLen = animators.length;
        var mult;
        var ind = -1;
        var offf;
        var xPathPos;
        var yPathPos;
        var initPathPos = currentLength;
        var initSegmentInd = segmentInd;
        var initPointInd = pointInd;
        var currentLine = -1;
        var elemOpacity;
        var sc;
        var sw;
        var fc;
        var k;
        var letterSw;
        var letterSc;
        var letterFc;
        var letterM = '';
        var letterP = this.defaultPropsArray;
        var letterO; //
        if (documentData.j === 2 || documentData.j === 1) {
            var animatorJustifyOffset = 0;
            var animatorFirstCharOffset = 0;
            var justifyOffsetMult = documentData.j === 2 ? -0.5 : -1;
            var lastIndex = 0;
            var isNewLine = true;
            for(i = 0; i < len; i += 1)if (letters[i].n) {
                if (animatorJustifyOffset) animatorJustifyOffset += animatorFirstCharOffset;
                while(lastIndex < i){
                    letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
                    lastIndex += 1;
                }
                animatorJustifyOffset = 0;
                isNewLine = true;
            } else {
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    if (animatorProps.t.propType) {
                        if (isNewLine && documentData.j === 2) animatorFirstCharOffset += animatorProps.t.v * justifyOffsetMult;
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                        if (mult.length) animatorJustifyOffset += animatorProps.t.v * mult[0] * justifyOffsetMult;
                        else animatorJustifyOffset += animatorProps.t.v * mult * justifyOffsetMult;
                    }
                }
                isNewLine = false;
            }
            if (animatorJustifyOffset) animatorJustifyOffset += animatorFirstCharOffset;
            while(lastIndex < i){
                letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
                lastIndex += 1;
            }
        } //
        for(i = 0; i < len; i += 1){
            matrixHelper.reset();
            elemOpacity = 1;
            if (letters[i].n) {
                xPos = 0;
                yPos += documentData.yOffset;
                yPos += firstLine ? 1 : 0;
                currentLength = initPathPos;
                firstLine = false;
                if (this._hasMaskedPath) {
                    segmentInd = initSegmentInd;
                    pointInd = initPointInd;
                    points = segments[segmentInd].points;
                    prevPoint = points[pointInd - 1];
                    currentPoint = points[pointInd];
                    partialLength = currentPoint.partialLength;
                    segmentLength = 0;
                }
                letterM = '';
                letterFc = '';
                letterSw = '';
                letterO = '';
                letterP = this.defaultPropsArray;
            } else {
                if (this._hasMaskedPath) {
                    if (currentLine !== letters[i].line) {
                        switch(documentData.j){
                            case 1:
                                currentLength += totalLength - documentData.lineWidths[letters[i].line];
                                break;
                            case 2:
                                currentLength += (totalLength - documentData.lineWidths[letters[i].line]) / 2;
                                break;
                            default:
                                break;
                        }
                        currentLine = letters[i].line;
                    }
                    if (ind !== letters[i].ind) {
                        if (letters[ind]) currentLength += letters[ind].extra;
                        currentLength += letters[i].an / 2;
                        ind = letters[i].ind;
                    }
                    currentLength += alignment[0] * letters[i].an * 0.005;
                    var animatorOffset = 0;
                    for(j = 0; j < jLen; j += 1){
                        animatorProps = animators[j].a;
                        if (animatorProps.p.propType) {
                            animatorSelector = animators[j].s;
                            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                            if (mult.length) animatorOffset += animatorProps.p.v[0] * mult[0];
                            else animatorOffset += animatorProps.p.v[0] * mult;
                        }
                        if (animatorProps.a.propType) {
                            animatorSelector = animators[j].s;
                            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                            if (mult.length) animatorOffset += animatorProps.a.v[0] * mult[0];
                            else animatorOffset += animatorProps.a.v[0] * mult;
                        }
                    }
                    flag = true; // Force alignment only works with a single line for now
                    if (this._pathData.a.v) {
                        currentLength = letters[0].an * 0.5 + (totalLength - this._pathData.f.v - letters[0].an * 0.5 - letters[letters.length - 1].an * 0.5) * ind / (len - 1);
                        currentLength += this._pathData.f.v;
                    }
                    while(flag){
                        if (segmentLength + partialLength >= currentLength + animatorOffset || !points) {
                            perc = (currentLength + animatorOffset - segmentLength) / currentPoint.partialLength;
                            xPathPos = prevPoint.point[0] + (currentPoint.point[0] - prevPoint.point[0]) * perc;
                            yPathPos = prevPoint.point[1] + (currentPoint.point[1] - prevPoint.point[1]) * perc;
                            matrixHelper.translate(-alignment[0] * letters[i].an * 0.005, -(alignment[1] * yOff) * 0.01);
                            flag = false;
                        } else if (points) {
                            segmentLength += currentPoint.partialLength;
                            pointInd += 1;
                            if (pointInd >= points.length) {
                                pointInd = 0;
                                segmentInd += 1;
                                if (!segments[segmentInd]) {
                                    if (mask.v.c) {
                                        pointInd = 0;
                                        segmentInd = 0;
                                        points = segments[segmentInd].points;
                                    } else {
                                        segmentLength -= currentPoint.partialLength;
                                        points = null;
                                    }
                                } else points = segments[segmentInd].points;
                            }
                            if (points) {
                                prevPoint = currentPoint;
                                currentPoint = points[pointInd];
                                partialLength = currentPoint.partialLength;
                            }
                        }
                    }
                    offf = letters[i].an / 2 - letters[i].add;
                    matrixHelper.translate(-offf, 0, 0);
                } else {
                    offf = letters[i].an / 2 - letters[i].add;
                    matrixHelper.translate(-offf, 0, 0); // Grouping alignment
                    matrixHelper.translate(-alignment[0] * letters[i].an * 0.005, -alignment[1] * yOff * 0.01, 0);
                }
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    if (animatorProps.t.propType) {
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars); // This condition is to prevent applying tracking to first character in each line. Might be better to use a boolean "isNewLine"
                        if (xPos !== 0 || documentData.j !== 0) {
                            if (this._hasMaskedPath) {
                                if (mult.length) currentLength += animatorProps.t.v * mult[0];
                                else currentLength += animatorProps.t.v * mult;
                            } else if (mult.length) xPos += animatorProps.t.v * mult[0];
                            else xPos += animatorProps.t.v * mult;
                        }
                    }
                }
                if (documentData.strokeWidthAnim) sw = documentData.sw || 0;
                if (documentData.strokeColorAnim) {
                    if (documentData.sc) sc = [
                        documentData.sc[0],
                        documentData.sc[1],
                        documentData.sc[2]
                    ];
                    else sc = [
                        0,
                        0,
                        0
                    ];
                }
                if (documentData.fillColorAnim && documentData.fc) fc = [
                    documentData.fc[0],
                    documentData.fc[1],
                    documentData.fc[2]
                ];
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    if (animatorProps.a.propType) {
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                        if (mult.length) matrixHelper.translate(-animatorProps.a.v[0] * mult[0], -animatorProps.a.v[1] * mult[1], animatorProps.a.v[2] * mult[2]);
                        else matrixHelper.translate(-animatorProps.a.v[0] * mult, -animatorProps.a.v[1] * mult, animatorProps.a.v[2] * mult);
                    }
                }
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    if (animatorProps.s.propType) {
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                        if (mult.length) matrixHelper.scale(1 + (animatorProps.s.v[0] - 1) * mult[0], 1 + (animatorProps.s.v[1] - 1) * mult[1], 1);
                        else matrixHelper.scale(1 + (animatorProps.s.v[0] - 1) * mult, 1 + (animatorProps.s.v[1] - 1) * mult, 1);
                    }
                }
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    animatorSelector = animators[j].s;
                    mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                    if (animatorProps.sk.propType) {
                        if (mult.length) matrixHelper.skewFromAxis(-animatorProps.sk.v * mult[0], animatorProps.sa.v * mult[1]);
                        else matrixHelper.skewFromAxis(-animatorProps.sk.v * mult, animatorProps.sa.v * mult);
                    }
                    if (animatorProps.r.propType) {
                        if (mult.length) matrixHelper.rotateZ(-animatorProps.r.v * mult[2]);
                        else matrixHelper.rotateZ(-animatorProps.r.v * mult);
                    }
                    if (animatorProps.ry.propType) {
                        if (mult.length) matrixHelper.rotateY(animatorProps.ry.v * mult[1]);
                        else matrixHelper.rotateY(animatorProps.ry.v * mult);
                    }
                    if (animatorProps.rx.propType) {
                        if (mult.length) matrixHelper.rotateX(animatorProps.rx.v * mult[0]);
                        else matrixHelper.rotateX(animatorProps.rx.v * mult);
                    }
                    if (animatorProps.o.propType) {
                        if (mult.length) elemOpacity += (animatorProps.o.v * mult[0] - elemOpacity) * mult[0];
                        else elemOpacity += (animatorProps.o.v * mult - elemOpacity) * mult;
                    }
                    if (documentData.strokeWidthAnim && animatorProps.sw.propType) {
                        if (mult.length) sw += animatorProps.sw.v * mult[0];
                        else sw += animatorProps.sw.v * mult;
                    }
                    if (documentData.strokeColorAnim && animatorProps.sc.propType) {
                        for(k = 0; k < 3; k += 1)if (mult.length) sc[k] += (animatorProps.sc.v[k] - sc[k]) * mult[0];
                        else sc[k] += (animatorProps.sc.v[k] - sc[k]) * mult;
                    }
                    if (documentData.fillColorAnim && documentData.fc) {
                        if (animatorProps.fc.propType) {
                            for(k = 0; k < 3; k += 1)if (mult.length) fc[k] += (animatorProps.fc.v[k] - fc[k]) * mult[0];
                            else fc[k] += (animatorProps.fc.v[k] - fc[k]) * mult;
                        }
                        if (animatorProps.fh.propType) {
                            if (mult.length) fc = addHueToRGB(fc, animatorProps.fh.v * mult[0]);
                            else fc = addHueToRGB(fc, animatorProps.fh.v * mult);
                        }
                        if (animatorProps.fs.propType) {
                            if (mult.length) fc = addSaturationToRGB(fc, animatorProps.fs.v * mult[0]);
                            else fc = addSaturationToRGB(fc, animatorProps.fs.v * mult);
                        }
                        if (animatorProps.fb.propType) {
                            if (mult.length) fc = addBrightnessToRGB(fc, animatorProps.fb.v * mult[0]);
                            else fc = addBrightnessToRGB(fc, animatorProps.fb.v * mult);
                        }
                    }
                }
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    if (animatorProps.p.propType) {
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                        if (this._hasMaskedPath) {
                            if (mult.length) matrixHelper.translate(0, animatorProps.p.v[1] * mult[0], -animatorProps.p.v[2] * mult[1]);
                            else matrixHelper.translate(0, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
                        } else if (mult.length) matrixHelper.translate(animatorProps.p.v[0] * mult[0], animatorProps.p.v[1] * mult[1], -animatorProps.p.v[2] * mult[2]);
                        else matrixHelper.translate(animatorProps.p.v[0] * mult, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
                    }
                }
                if (documentData.strokeWidthAnim) letterSw = sw < 0 ? 0 : sw;
                if (documentData.strokeColorAnim) letterSc = 'rgb(' + Math.round(sc[0] * 255) + ',' + Math.round(sc[1] * 255) + ',' + Math.round(sc[2] * 255) + ')';
                if (documentData.fillColorAnim && documentData.fc) letterFc = 'rgb(' + Math.round(fc[0] * 255) + ',' + Math.round(fc[1] * 255) + ',' + Math.round(fc[2] * 255) + ')';
                if (this._hasMaskedPath) {
                    matrixHelper.translate(0, -documentData.ls);
                    matrixHelper.translate(0, alignment[1] * yOff * 0.01 + yPos, 0);
                    if (this._pathData.p.v) {
                        tanAngle = (currentPoint.point[1] - prevPoint.point[1]) / (currentPoint.point[0] - prevPoint.point[0]);
                        var rot = Math.atan(tanAngle) * 180 / Math.PI;
                        if (currentPoint.point[0] < prevPoint.point[0]) rot += 180;
                        matrixHelper.rotate(-rot * Math.PI / 180);
                    }
                    matrixHelper.translate(xPathPos, yPathPos, 0);
                    currentLength -= alignment[0] * letters[i].an * 0.005;
                    if (letters[i + 1] && ind !== letters[i + 1].ind) {
                        currentLength += letters[i].an / 2;
                        currentLength += documentData.tr * 0.001 * documentData.finalSize;
                    }
                } else {
                    matrixHelper.translate(xPos, yPos, 0);
                    if (documentData.ps) // matrixHelper.translate(documentData.ps[0],documentData.ps[1],0);
                    matrixHelper.translate(documentData.ps[0], documentData.ps[1] + documentData.ascent, 0);
                    switch(documentData.j){
                        case 1:
                            matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]), 0, 0);
                            break;
                        case 2:
                            matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]) / 2, 0, 0);
                            break;
                        default:
                            break;
                    }
                    matrixHelper.translate(0, -documentData.ls);
                    matrixHelper.translate(offf, 0, 0);
                    matrixHelper.translate(alignment[0] * letters[i].an * 0.005, alignment[1] * yOff * 0.01, 0);
                    xPos += letters[i].l + documentData.tr * 0.001 * documentData.finalSize;
                }
                if (renderType === 'html') letterM = matrixHelper.toCSS();
                else if (renderType === 'svg') letterM = matrixHelper.to2dCSS();
                else letterP = [
                    matrixHelper.props[0],
                    matrixHelper.props[1],
                    matrixHelper.props[2],
                    matrixHelper.props[3],
                    matrixHelper.props[4],
                    matrixHelper.props[5],
                    matrixHelper.props[6],
                    matrixHelper.props[7],
                    matrixHelper.props[8],
                    matrixHelper.props[9],
                    matrixHelper.props[10],
                    matrixHelper.props[11],
                    matrixHelper.props[12],
                    matrixHelper.props[13],
                    matrixHelper.props[14],
                    matrixHelper.props[15]
                ];
                letterO = elemOpacity;
            }
            if (renderedLettersCount <= i) {
                letterValue = new LetterProps(letterO, letterSw, letterSc, letterFc, letterM, letterP);
                this.renderedLetters.push(letterValue);
                renderedLettersCount += 1;
                this.lettersChangedFlag = true;
            } else {
                letterValue = this.renderedLetters[i];
                this.lettersChangedFlag = letterValue.update(letterO, letterSw, letterSc, letterFc, letterM, letterP) || this.lettersChangedFlag;
            }
        }
    };
    TextAnimatorProperty.prototype.getValue = function() {
        if (this._elem.globalData.frameId === this._frameId) return;
        this._frameId = this._elem.globalData.frameId;
        this.iterateDynamicProperties();
    };
    TextAnimatorProperty.prototype.mHelper = new Matrix();
    TextAnimatorProperty.prototype.defaultPropsArray = [];
    extendPrototype([
        DynamicPropertyContainer
    ], TextAnimatorProperty);
    function ITextElement() {}
    ITextElement.prototype.initElement = function(data, globalData, comp) {
        this.lettersChangedFlag = true;
        this.initFrame();
        this.initBaseData(data, globalData, comp);
        this.textProperty = new TextProperty(this, data.t, this.dynamicProperties);
        this.textAnimator = new TextAnimatorProperty(data.t, this.renderType, this);
        this.initTransform(data, globalData, comp);
        this.initHierarchy();
        this.initRenderable();
        this.initRendererElement();
        this.createContainerElements();
        this.createRenderableComponents();
        this.createContent();
        this.hide();
        this.textAnimator.searchProperties(this.dynamicProperties);
    };
    ITextElement.prototype.prepareFrame = function(num) {
        this._mdf = false;
        this.prepareRenderableFrame(num);
        this.prepareProperties(num, this.isInRange);
    };
    ITextElement.prototype.createPathShape = function(matrixHelper, shapes) {
        var j;
        var jLen = shapes.length;
        var pathNodes;
        var shapeStr = '';
        for(j = 0; j < jLen; j += 1)if (shapes[j].ty === 'sh') {
            pathNodes = shapes[j].ks.k;
            shapeStr += buildShapeString(pathNodes, pathNodes.i.length, true, matrixHelper);
        }
        return shapeStr;
    };
    ITextElement.prototype.updateDocumentData = function(newData, index) {
        this.textProperty.updateDocumentData(newData, index);
    };
    ITextElement.prototype.canResizeFont = function(_canResize) {
        this.textProperty.canResizeFont(_canResize);
    };
    ITextElement.prototype.setMinimumFontSize = function(_fontSize) {
        this.textProperty.setMinimumFontSize(_fontSize);
    };
    ITextElement.prototype.applyTextPropertiesToMatrix = function(documentData, matrixHelper, lineNumber, xPos, yPos) {
        if (documentData.ps) matrixHelper.translate(documentData.ps[0], documentData.ps[1] + documentData.ascent, 0);
        matrixHelper.translate(0, -documentData.ls, 0);
        switch(documentData.j){
            case 1:
                matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]), 0, 0);
                break;
            case 2:
                matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]) / 2, 0, 0);
                break;
            default:
                break;
        }
        matrixHelper.translate(xPos, yPos, 0);
    };
    ITextElement.prototype.buildColor = function(colorData) {
        return 'rgb(' + Math.round(colorData[0] * 255) + ',' + Math.round(colorData[1] * 255) + ',' + Math.round(colorData[2] * 255) + ')';
    };
    ITextElement.prototype.emptyProp = new LetterProps();
    ITextElement.prototype.destroy = function() {};
    ITextElement.prototype.validateText = function() {
        if (this.textProperty._mdf || this.textProperty._isFirstFrame) {
            this.buildNewText();
            this.textProperty._isFirstFrame = false;
            this.textProperty._mdf = false;
        }
    };
    var emptyShapeData = {
        shapes: []
    };
    function SVGTextLottieElement(data, globalData, comp) {
        this.textSpans = [];
        this.renderType = 'svg';
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        SVGBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement,
        ITextElement
    ], SVGTextLottieElement);
    SVGTextLottieElement.prototype.createContent = function() {
        if (this.data.singleShape && !this.globalData.fontManager.chars) this.textContainer = createNS('text');
    };
    SVGTextLottieElement.prototype.buildTextContents = function(textArray) {
        var i = 0;
        var len = textArray.length;
        var textContents = [];
        var currentTextContent = '';
        while(i < len){
            if (textArray[i] === String.fromCharCode(13) || textArray[i] === String.fromCharCode(3)) {
                textContents.push(currentTextContent);
                currentTextContent = '';
            } else currentTextContent += textArray[i];
            i += 1;
        }
        textContents.push(currentTextContent);
        return textContents;
    };
    SVGTextLottieElement.prototype.buildShapeData = function(data, scale) {
        // data should probably be cloned to apply scale separately to each instance of a text on different layers
        // but since text internal content gets only rendered once and then it's never rerendered,
        // it's probably safe not to clone data and reuse always the same instance even if the object is mutated.
        // Avoiding cloning is preferred since cloning each character shape data is expensive
        if (data.shapes && data.shapes.length) {
            var shape = data.shapes[0];
            if (shape.it) {
                var shapeItem = shape.it[shape.it.length - 1];
                if (shapeItem.s) {
                    shapeItem.s.k[0] = scale;
                    shapeItem.s.k[1] = scale;
                }
            }
        }
        return data;
    };
    SVGTextLottieElement.prototype.buildNewText = function() {
        this.addDynamicProperty(this);
        var i;
        var len;
        var documentData = this.textProperty.currentData;
        this.renderedLetters = createSizedArray(documentData ? documentData.l.length : 0);
        if (documentData.fc) this.layerElement.setAttribute('fill', this.buildColor(documentData.fc));
        else this.layerElement.setAttribute('fill', 'rgba(0,0,0,0)');
        if (documentData.sc) {
            this.layerElement.setAttribute('stroke', this.buildColor(documentData.sc));
            this.layerElement.setAttribute('stroke-width', documentData.sw);
        }
        this.layerElement.setAttribute('font-size', documentData.finalSize);
        var fontData = this.globalData.fontManager.getFontByName(documentData.f);
        if (fontData.fClass) this.layerElement.setAttribute('class', fontData.fClass);
        else {
            this.layerElement.setAttribute('font-family', fontData.fFamily);
            var fWeight = documentData.fWeight;
            var fStyle = documentData.fStyle;
            this.layerElement.setAttribute('font-style', fStyle);
            this.layerElement.setAttribute('font-weight', fWeight);
        }
        this.layerElement.setAttribute('aria-label', documentData.t);
        var letters = documentData.l || [];
        var usesGlyphs = !!this.globalData.fontManager.chars;
        len = letters.length;
        var tSpan;
        var matrixHelper = this.mHelper;
        var shapeStr = '';
        var singleShape = this.data.singleShape;
        var xPos = 0;
        var yPos = 0;
        var firstLine = true;
        var trackingOffset = documentData.tr * 0.001 * documentData.finalSize;
        if (singleShape && !usesGlyphs && !documentData.sz) {
            var tElement = this.textContainer;
            var justify = 'start';
            switch(documentData.j){
                case 1:
                    justify = 'end';
                    break;
                case 2:
                    justify = 'middle';
                    break;
                default:
                    justify = 'start';
                    break;
            }
            tElement.setAttribute('text-anchor', justify);
            tElement.setAttribute('letter-spacing', trackingOffset);
            var textContent = this.buildTextContents(documentData.finalText);
            len = textContent.length;
            yPos = documentData.ps ? documentData.ps[1] + documentData.ascent : 0;
            for(i = 0; i < len; i += 1){
                tSpan = this.textSpans[i].span || createNS('tspan');
                tSpan.textContent = textContent[i];
                tSpan.setAttribute('x', 0);
                tSpan.setAttribute('y', yPos);
                tSpan.style.display = 'inherit';
                tElement.appendChild(tSpan);
                if (!this.textSpans[i]) this.textSpans[i] = {
                    span: null,
                    glyph: null
                };
                this.textSpans[i].span = tSpan;
                yPos += documentData.finalLineHeight;
            }
            this.layerElement.appendChild(tElement);
        } else {
            var cachedSpansLength = this.textSpans.length;
            var charData;
            for(i = 0; i < len; i += 1){
                if (!this.textSpans[i]) this.textSpans[i] = {
                    span: null,
                    childSpan: null,
                    glyph: null
                };
                if (!usesGlyphs || !singleShape || i === 0) {
                    tSpan = cachedSpansLength > i ? this.textSpans[i].span : createNS(usesGlyphs ? 'g' : 'text');
                    if (cachedSpansLength <= i) {
                        tSpan.setAttribute('stroke-linecap', 'butt');
                        tSpan.setAttribute('stroke-linejoin', 'round');
                        tSpan.setAttribute('stroke-miterlimit', '4');
                        this.textSpans[i].span = tSpan;
                        if (usesGlyphs) {
                            var childSpan = createNS('g');
                            tSpan.appendChild(childSpan);
                            this.textSpans[i].childSpan = childSpan;
                        }
                        this.textSpans[i].span = tSpan;
                        this.layerElement.appendChild(tSpan);
                    }
                    tSpan.style.display = 'inherit';
                }
                matrixHelper.reset();
                if (singleShape) {
                    if (letters[i].n) {
                        xPos = -trackingOffset;
                        yPos += documentData.yOffset;
                        yPos += firstLine ? 1 : 0;
                        firstLine = false;
                    }
                    this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
                    xPos += letters[i].l || 0; // xPos += letters[i].val === ' ' ? 0 : trackingOffset;
                    xPos += trackingOffset;
                }
                if (usesGlyphs) {
                    charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
                    var glyphElement; // t === 1 means the character has been replaced with an animated shaped
                    if (charData.t === 1) glyphElement = new SVGCompElement(charData.data, this.globalData, this);
                    else {
                        var data = emptyShapeData;
                        if (charData.data && charData.data.shapes) data = this.buildShapeData(charData.data, documentData.finalSize);
                        glyphElement = new SVGShapeElement(data, this.globalData, this);
                    }
                    if (this.textSpans[i].glyph) {
                        var glyph = this.textSpans[i].glyph;
                        this.textSpans[i].childSpan.removeChild(glyph.layerElement);
                        glyph.destroy();
                    }
                    this.textSpans[i].glyph = glyphElement;
                    glyphElement._debug = true;
                    glyphElement.prepareFrame(0);
                    glyphElement.renderFrame();
                    this.textSpans[i].childSpan.appendChild(glyphElement.layerElement); // when using animated shapes, the layer will be scaled instead of replacing the internal scale
                    // this might have issues with strokes and might need a different solution
                    if (charData.t === 1) this.textSpans[i].childSpan.setAttribute('transform', 'scale(' + documentData.finalSize / 100 + ',' + documentData.finalSize / 100 + ')');
                } else {
                    if (singleShape) tSpan.setAttribute('transform', 'translate(' + matrixHelper.props[12] + ',' + matrixHelper.props[13] + ')');
                    tSpan.textContent = letters[i].val;
                    tSpan.setAttributeNS('http://www.w3.org/XML/1998/namespace', 'xml:space', 'preserve');
                } //
            }
            if (singleShape && tSpan) tSpan.setAttribute('d', shapeStr);
        }
        while(i < this.textSpans.length){
            this.textSpans[i].span.style.display = 'none';
            i += 1;
        }
        this._sizeChanged = true;
    };
    SVGTextLottieElement.prototype.sourceRectAtTime = function() {
        this.prepareFrame(this.comp.renderedFrame - this.data.st);
        this.renderInnerContent();
        if (this._sizeChanged) {
            this._sizeChanged = false;
            var textBox = this.layerElement.getBBox();
            this.bbox = {
                top: textBox.y,
                left: textBox.x,
                width: textBox.width,
                height: textBox.height
            };
        }
        return this.bbox;
    };
    SVGTextLottieElement.prototype.getValue = function() {
        var i;
        var len = this.textSpans.length;
        var glyphElement;
        this.renderedFrame = this.comp.renderedFrame;
        for(i = 0; i < len; i += 1){
            glyphElement = this.textSpans[i].glyph;
            if (glyphElement) {
                glyphElement.prepareFrame(this.comp.renderedFrame - this.data.st);
                if (glyphElement._mdf) this._mdf = true;
            }
        }
    };
    SVGTextLottieElement.prototype.renderInnerContent = function() {
        this.validateText();
        if (!this.data.singleShape || this._mdf) {
            this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
            if (this.lettersChangedFlag || this.textAnimator.lettersChangedFlag) {
                this._sizeChanged = true;
                var i;
                var len;
                var renderedLetters = this.textAnimator.renderedLetters;
                var letters = this.textProperty.currentData.l;
                len = letters.length;
                var renderedLetter;
                var textSpan;
                var glyphElement;
                for(i = 0; i < len; i += 1)if (!letters[i].n) {
                    renderedLetter = renderedLetters[i];
                    textSpan = this.textSpans[i].span;
                    glyphElement = this.textSpans[i].glyph;
                    if (glyphElement) glyphElement.renderFrame();
                    if (renderedLetter._mdf.m) textSpan.setAttribute('transform', renderedLetter.m);
                    if (renderedLetter._mdf.o) textSpan.setAttribute('opacity', renderedLetter.o);
                    if (renderedLetter._mdf.sw) textSpan.setAttribute('stroke-width', renderedLetter.sw);
                    if (renderedLetter._mdf.sc) textSpan.setAttribute('stroke', renderedLetter.sc);
                    if (renderedLetter._mdf.fc) textSpan.setAttribute('fill', renderedLetter.fc);
                }
            }
        }
    };
    function ISolidElement(data, globalData, comp) {
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        IImageElement
    ], ISolidElement);
    ISolidElement.prototype.createContent = function() {
        var rect = createNS('rect'); /// /rect.style.width = this.data.sw;
        /// /rect.style.height = this.data.sh;
        /// /rect.style.fill = this.data.sc;
        rect.setAttribute('width', this.data.sw);
        rect.setAttribute('height', this.data.sh);
        rect.setAttribute('fill', this.data.sc);
        this.layerElement.appendChild(rect);
    };
    function NullElement(data, globalData, comp) {
        this.initFrame();
        this.initBaseData(data, globalData, comp);
        this.initFrame();
        this.initTransform(data, globalData, comp);
        this.initHierarchy();
    }
    NullElement.prototype.prepareFrame = function(num) {
        this.prepareProperties(num, true);
    };
    NullElement.prototype.renderFrame = function() {};
    NullElement.prototype.getBaseElement = function() {
        return null;
    };
    NullElement.prototype.destroy = function() {};
    NullElement.prototype.sourceRectAtTime = function() {};
    NullElement.prototype.hide = function() {};
    extendPrototype([
        BaseElement,
        TransformElement,
        HierarchyElement,
        FrameElement
    ], NullElement);
    function SVGRendererBase() {}
    extendPrototype([
        BaseRenderer
    ], SVGRendererBase);
    SVGRendererBase.prototype.createNull = function(data) {
        return new NullElement(data, this.globalData, this);
    };
    SVGRendererBase.prototype.createShape = function(data) {
        return new SVGShapeElement(data, this.globalData, this);
    };
    SVGRendererBase.prototype.createText = function(data) {
        return new SVGTextLottieElement(data, this.globalData, this);
    };
    SVGRendererBase.prototype.createImage = function(data) {
        return new IImageElement(data, this.globalData, this);
    };
    SVGRendererBase.prototype.createSolid = function(data) {
        return new ISolidElement(data, this.globalData, this);
    };
    SVGRendererBase.prototype.configAnimation = function(animData) {
        this.svgElement.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
        this.svgElement.setAttribute('xmlns:xlink', 'http://www.w3.org/1999/xlink');
        if (this.renderConfig.viewBoxSize) this.svgElement.setAttribute('viewBox', this.renderConfig.viewBoxSize);
        else this.svgElement.setAttribute('viewBox', '0 0 ' + animData.w + ' ' + animData.h);
        if (!this.renderConfig.viewBoxOnly) {
            this.svgElement.setAttribute('width', animData.w);
            this.svgElement.setAttribute('height', animData.h);
            this.svgElement.style.width = '100%';
            this.svgElement.style.height = '100%';
            this.svgElement.style.transform = 'translate3d(0,0,0)';
            this.svgElement.style.contentVisibility = this.renderConfig.contentVisibility;
        }
        if (this.renderConfig.width) this.svgElement.setAttribute('width', this.renderConfig.width);
        if (this.renderConfig.height) this.svgElement.setAttribute('height', this.renderConfig.height);
        if (this.renderConfig.className) this.svgElement.setAttribute('class', this.renderConfig.className);
        if (this.renderConfig.id) this.svgElement.setAttribute('id', this.renderConfig.id);
        if (this.renderConfig.focusable !== undefined) this.svgElement.setAttribute('focusable', this.renderConfig.focusable);
        this.svgElement.setAttribute('preserveAspectRatio', this.renderConfig.preserveAspectRatio); // this.layerElement.style.transform = 'translate3d(0,0,0)';
        // this.layerElement.style.transformOrigin = this.layerElement.style.mozTransformOrigin = this.layerElement.style.webkitTransformOrigin = this.layerElement.style['-webkit-transform'] = "0px 0px 0px";
        this.animationItem.wrapper.appendChild(this.svgElement); // Mask animation
        var defs = this.globalData.defs;
        this.setupGlobalData(animData, defs);
        this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
        this.data = animData;
        var maskElement = createNS('clipPath');
        var rect = createNS('rect');
        rect.setAttribute('width', animData.w);
        rect.setAttribute('height', animData.h);
        rect.setAttribute('x', 0);
        rect.setAttribute('y', 0);
        var maskId = createElementID();
        maskElement.setAttribute('id', maskId);
        maskElement.appendChild(rect);
        this.layerElement.setAttribute('clip-path', 'url(' + getLocationHref() + '#' + maskId + ')');
        defs.appendChild(maskElement);
        this.layers = animData.layers;
        this.elements = createSizedArray(animData.layers.length);
    };
    SVGRendererBase.prototype.destroy = function() {
        if (this.animationItem.wrapper) this.animationItem.wrapper.innerText = '';
        this.layerElement = null;
        this.globalData.defs = null;
        var i;
        var len = this.layers ? this.layers.length : 0;
        for(i = 0; i < len; i += 1)if (this.elements[i] && this.elements[i].destroy) this.elements[i].destroy();
        this.elements.length = 0;
        this.destroyed = true;
        this.animationItem = null;
    };
    SVGRendererBase.prototype.updateContainerSize = function() {};
    SVGRendererBase.prototype.findIndexByInd = function(ind) {
        var i = 0;
        var len = this.layers.length;
        for(i = 0; i < len; i += 1){
            if (this.layers[i].ind === ind) return i;
        }
        return -1;
    };
    SVGRendererBase.prototype.buildItem = function(pos) {
        var elements = this.elements;
        if (elements[pos] || this.layers[pos].ty === 99) return;
        elements[pos] = true;
        var element = this.createItem(this.layers[pos]);
        elements[pos] = element;
        if (getExpressionsPlugin()) {
            if (this.layers[pos].ty === 0) this.globalData.projectInterface.registerComposition(element);
            element.initExpressions();
        }
        this.appendElementInPos(element, pos);
        if (this.layers[pos].tt) {
            var elementIndex = 'tp' in this.layers[pos] ? this.findIndexByInd(this.layers[pos].tp) : pos - 1;
            if (elementIndex === -1) return;
            if (!this.elements[elementIndex] || this.elements[elementIndex] === true) {
                this.buildItem(elementIndex);
                this.addPendingElement(element);
            } else {
                var matteElement = elements[elementIndex];
                var matteMask = matteElement.getMatte(this.layers[pos].tt);
                element.setMatte(matteMask);
            }
        }
    };
    SVGRendererBase.prototype.checkPendingElements = function() {
        while(this.pendingElements.length){
            var element = this.pendingElements.pop();
            element.checkParenting();
            if (element.data.tt) {
                var i = 0;
                var len = this.elements.length;
                while(i < len){
                    if (this.elements[i] === element) {
                        var elementIndex = 'tp' in element.data ? this.findIndexByInd(element.data.tp) : i - 1;
                        var matteElement = this.elements[elementIndex];
                        var matteMask = matteElement.getMatte(this.layers[i].tt);
                        element.setMatte(matteMask);
                        break;
                    }
                    i += 1;
                }
            }
        }
    };
    SVGRendererBase.prototype.renderFrame = function(num) {
        if (this.renderedFrame === num || this.destroyed) return;
        if (num === null) num = this.renderedFrame;
        else this.renderedFrame = num;
         // console.log('-------');
        // console.log('FRAME ',num);
        this.globalData.frameNum = num;
        this.globalData.frameId += 1;
        this.globalData.projectInterface.currentFrame = num;
        this.globalData._mdf = false;
        var i;
        var len = this.layers.length;
        if (!this.completeLayers) this.checkLayers(num);
        for(i = len - 1; i >= 0; i -= 1)if (this.completeLayers || this.elements[i]) this.elements[i].prepareFrame(num - this.layers[i].st);
        if (this.globalData._mdf) {
            for(i = 0; i < len; i += 1)if (this.completeLayers || this.elements[i]) this.elements[i].renderFrame();
        }
    };
    SVGRendererBase.prototype.appendElementInPos = function(element, pos) {
        var newElement = element.getBaseElement();
        if (!newElement) return;
        var i = 0;
        var nextElement;
        while(i < pos){
            if (this.elements[i] && this.elements[i] !== true && this.elements[i].getBaseElement()) nextElement = this.elements[i].getBaseElement();
            i += 1;
        }
        if (nextElement) this.layerElement.insertBefore(newElement, nextElement);
        else this.layerElement.appendChild(newElement);
    };
    SVGRendererBase.prototype.hide = function() {
        this.layerElement.style.display = 'none';
    };
    SVGRendererBase.prototype.show = function() {
        this.layerElement.style.display = 'block';
    };
    function ICompElement() {}
    extendPrototype([
        BaseElement,
        TransformElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement
    ], ICompElement);
    ICompElement.prototype.initElement = function(data, globalData, comp) {
        this.initFrame();
        this.initBaseData(data, globalData, comp);
        this.initTransform(data, globalData, comp);
        this.initRenderable();
        this.initHierarchy();
        this.initRendererElement();
        this.createContainerElements();
        this.createRenderableComponents();
        if (this.data.xt || !globalData.progressiveLoad) this.buildAllItems();
        this.hide();
    };
    /* ICompElement.prototype.hide = function(){
      if(!this.hidden){
          this.hideElement();
          var i,len = this.elements.length;
          for( i = 0; i < len; i+=1 ){
              if(this.elements[i]){
                  this.elements[i].hide();
              }
          }
      }
  }; */ ICompElement.prototype.prepareFrame = function(num) {
        this._mdf = false;
        this.prepareRenderableFrame(num);
        this.prepareProperties(num, this.isInRange);
        if (!this.isInRange && !this.data.xt) return;
        if (!this.tm._placeholder) {
            var timeRemapped = this.tm.v;
            if (timeRemapped === this.data.op) timeRemapped = this.data.op - 1;
            this.renderedFrame = timeRemapped;
        } else this.renderedFrame = num / this.data.sr;
        var i;
        var len = this.elements.length;
        if (!this.completeLayers) this.checkLayers(this.renderedFrame);
         // This iteration needs to be backwards because of how expressions connect between each other
        for(i = len - 1; i >= 0; i -= 1)if (this.completeLayers || this.elements[i]) {
            this.elements[i].prepareFrame(this.renderedFrame - this.layers[i].st);
            if (this.elements[i]._mdf) this._mdf = true;
        }
    };
    ICompElement.prototype.renderInnerContent = function() {
        var i;
        var len = this.layers.length;
        for(i = 0; i < len; i += 1)if (this.completeLayers || this.elements[i]) this.elements[i].renderFrame();
    };
    ICompElement.prototype.setElements = function(elems) {
        this.elements = elems;
    };
    ICompElement.prototype.getElements = function() {
        return this.elements;
    };
    ICompElement.prototype.destroyElements = function() {
        var i;
        var len = this.layers.length;
        for(i = 0; i < len; i += 1)if (this.elements[i]) this.elements[i].destroy();
    };
    ICompElement.prototype.destroy = function() {
        this.destroyElements();
        this.destroyBaseElement();
    };
    function SVGCompElement(data, globalData, comp) {
        this.layers = data.layers;
        this.supports3d = true;
        this.completeLayers = false;
        this.pendingElements = [];
        this.elements = this.layers ? createSizedArray(this.layers.length) : [];
        this.initElement(data, globalData, comp);
        this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
            _placeholder: true
        };
    }
    extendPrototype([
        SVGRendererBase,
        ICompElement,
        SVGBaseElement
    ], SVGCompElement);
    SVGCompElement.prototype.createComp = function(data) {
        return new SVGCompElement(data, this.globalData, this);
    };
    function SVGRenderer(animationItem, config) {
        this.animationItem = animationItem;
        this.layers = null;
        this.renderedFrame = -1;
        this.svgElement = createNS('svg');
        var ariaLabel = '';
        if (config && config.title) {
            var titleElement = createNS('title');
            var titleId = createElementID();
            titleElement.setAttribute('id', titleId);
            titleElement.textContent = config.title;
            this.svgElement.appendChild(titleElement);
            ariaLabel += titleId;
        }
        if (config && config.description) {
            var descElement = createNS('desc');
            var descId = createElementID();
            descElement.setAttribute('id', descId);
            descElement.textContent = config.description;
            this.svgElement.appendChild(descElement);
            ariaLabel += ' ' + descId;
        }
        if (ariaLabel) this.svgElement.setAttribute('aria-labelledby', ariaLabel);
        var defs = createNS('defs');
        this.svgElement.appendChild(defs);
        var maskElement = createNS('g');
        this.svgElement.appendChild(maskElement);
        this.layerElement = maskElement;
        this.renderConfig = {
            preserveAspectRatio: config && config.preserveAspectRatio || 'xMidYMid meet',
            imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
            contentVisibility: config && config.contentVisibility || 'visible',
            progressiveLoad: config && config.progressiveLoad || false,
            hideOnTransparent: !(config && config.hideOnTransparent === false),
            viewBoxOnly: config && config.viewBoxOnly || false,
            viewBoxSize: config && config.viewBoxSize || false,
            className: config && config.className || '',
            id: config && config.id || '',
            focusable: config && config.focusable,
            filterSize: {
                width: config && config.filterSize && config.filterSize.width || '100%',
                height: config && config.filterSize && config.filterSize.height || '100%',
                x: config && config.filterSize && config.filterSize.x || '0%',
                y: config && config.filterSize && config.filterSize.y || '0%'
            },
            width: config && config.width,
            height: config && config.height,
            runExpressions: !config || config.runExpressions === undefined || config.runExpressions
        };
        this.globalData = {
            _mdf: false,
            frameNum: -1,
            defs: defs,
            renderConfig: this.renderConfig
        };
        this.elements = [];
        this.pendingElements = [];
        this.destroyed = false;
        this.rendererType = 'svg';
    }
    extendPrototype([
        SVGRendererBase
    ], SVGRenderer);
    SVGRenderer.prototype.createComp = function(data) {
        return new SVGCompElement(data, this.globalData, this);
    };
    function ShapeTransformManager() {
        this.sequences = {};
        this.sequenceList = [];
        this.transform_key_count = 0;
    }
    ShapeTransformManager.prototype = {
        addTransformSequence: function addTransformSequence(transforms) {
            var i;
            var len = transforms.length;
            var key = '_';
            for(i = 0; i < len; i += 1)key += transforms[i].transform.key + '_';
            var sequence = this.sequences[key];
            if (!sequence) {
                sequence = {
                    transforms: [].concat(transforms),
                    finalTransform: new Matrix(),
                    _mdf: false
                };
                this.sequences[key] = sequence;
                this.sequenceList.push(sequence);
            }
            return sequence;
        },
        processSequence: function processSequence(sequence, isFirstFrame) {
            var i = 0;
            var len = sequence.transforms.length;
            var _mdf = isFirstFrame;
            while(i < len && !isFirstFrame){
                if (sequence.transforms[i].transform.mProps._mdf) {
                    _mdf = true;
                    break;
                }
                i += 1;
            }
            if (_mdf) {
                sequence.finalTransform.reset();
                for(i = len - 1; i >= 0; i -= 1)sequence.finalTransform.multiply(sequence.transforms[i].transform.mProps.v);
            }
            sequence._mdf = _mdf;
        },
        processSequences: function processSequences(isFirstFrame) {
            var i;
            var len = this.sequenceList.length;
            for(i = 0; i < len; i += 1)this.processSequence(this.sequenceList[i], isFirstFrame);
        },
        getNewKey: function getNewKey() {
            this.transform_key_count += 1;
            return '_' + this.transform_key_count;
        }
    };
    var lumaLoader = function lumaLoader() {
        var id = '__lottie_element_luma_buffer';
        var lumaBuffer = null;
        var lumaBufferCtx = null;
        var svg = null; // This alternate solution has a slight delay before the filter is applied, resulting in a flicker on the first frame.
        // Keeping this here for reference, and in the future, if offscreen canvas supports url filters, this can be used.
        // For now, neither of them work for offscreen canvas, so canvas workers can't support the luma track matte mask.
        // Naming it solution 2 to mark the extra comment lines.
        /*
    var svgString = [
      '<svg xmlns="http://www.w3.org/2000/svg">',
      '<filter id="' + id + '">',
      '<feColorMatrix type="matrix" color-interpolation-filters="sRGB" values="',
      '0.3, 0.3, 0.3, 0, 0, ',
      '0.3, 0.3, 0.3, 0, 0, ',
      '0.3, 0.3, 0.3, 0, 0, ',
      '0.3, 0.3, 0.3, 0, 0',
      '"/>',
      '</filter>',
      '</svg>',
    ].join('');
    var blob = new Blob([svgString], { type: 'image/svg+xml' });
    var url = URL.createObjectURL(blob);
    */ function createLumaSvgFilter() {
            var _svg = createNS('svg');
            var fil = createNS('filter');
            var matrix = createNS('feColorMatrix');
            fil.setAttribute('id', id);
            matrix.setAttribute('type', 'matrix');
            matrix.setAttribute('color-interpolation-filters', 'sRGB');
            matrix.setAttribute('values', '0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0');
            fil.appendChild(matrix);
            _svg.appendChild(fil);
            _svg.setAttribute('id', id + '_svg');
            if (featureSupport.svgLumaHidden) _svg.style.display = 'none';
            return _svg;
        }
        function loadLuma() {
            if (!lumaBuffer) {
                svg = createLumaSvgFilter();
                document.body.appendChild(svg);
                lumaBuffer = createTag('canvas');
                lumaBufferCtx = lumaBuffer.getContext('2d'); // lumaBufferCtx.filter = `url('${url}#__lottie_element_luma_buffer')`; // part of solution 2
                lumaBufferCtx.filter = 'url(#' + id + ')';
                lumaBufferCtx.fillStyle = 'rgba(0,0,0,0)';
                lumaBufferCtx.fillRect(0, 0, 1, 1);
            }
        }
        function getLuma(canvas) {
            if (!lumaBuffer) loadLuma();
            lumaBuffer.width = canvas.width;
            lumaBuffer.height = canvas.height; // lumaBufferCtx.filter = `url('${url}#__lottie_element_luma_buffer')`; // part of solution 2
            lumaBufferCtx.filter = 'url(#' + id + ')';
            return lumaBuffer;
        }
        return {
            load: loadLuma,
            get: getLuma
        };
    };
    function createCanvas(width, height) {
        if (featureSupport.offscreenCanvas) return new OffscreenCanvas(width, height);
        var canvas = createTag('canvas');
        canvas.width = width;
        canvas.height = height;
        return canvas;
    }
    var assetLoader = function() {
        return {
            loadLumaCanvas: lumaLoader.load,
            getLumaCanvas: lumaLoader.get,
            createCanvas: createCanvas
        };
    }();
    var registeredEffects = {};
    function CVEffects(elem) {
        var i;
        var len = elem.data.ef ? elem.data.ef.length : 0;
        this.filters = [];
        var filterManager;
        for(i = 0; i < len; i += 1){
            filterManager = null;
            var type = elem.data.ef[i].ty;
            if (registeredEffects[type]) {
                var Effect = registeredEffects[type].effect;
                filterManager = new Effect(elem.effectsManager.effectElements[i], elem);
            }
            if (filterManager) this.filters.push(filterManager);
        }
        if (this.filters.length) elem.addRenderableComponent(this);
    }
    CVEffects.prototype.renderFrame = function(_isFirstFrame) {
        var i;
        var len = this.filters.length;
        for(i = 0; i < len; i += 1)this.filters[i].renderFrame(_isFirstFrame);
    };
    CVEffects.prototype.getEffects = function(type) {
        var i;
        var len = this.filters.length;
        var effects = [];
        for(i = 0; i < len; i += 1)if (this.filters[i].type === type) effects.push(this.filters[i]);
        return effects;
    };
    function registerEffect(id, effect) {
        registeredEffects[id] = {
            effect: effect
        };
    }
    function CVMaskElement(data, element) {
        this.data = data;
        this.element = element;
        this.masksProperties = this.data.masksProperties || [];
        this.viewData = createSizedArray(this.masksProperties.length);
        var i;
        var len = this.masksProperties.length;
        var hasMasks = false;
        for(i = 0; i < len; i += 1){
            if (this.masksProperties[i].mode !== 'n') hasMasks = true;
            this.viewData[i] = ShapePropertyFactory.getShapeProp(this.element, this.masksProperties[i], 3);
        }
        this.hasMasks = hasMasks;
        if (hasMasks) this.element.addRenderableComponent(this);
    }
    CVMaskElement.prototype.renderFrame = function() {
        if (!this.hasMasks) return;
        var transform = this.element.finalTransform.mat;
        var ctx = this.element.canvasContext;
        var i;
        var len = this.masksProperties.length;
        var pt;
        var pts;
        var data;
        ctx.beginPath();
        for(i = 0; i < len; i += 1)if (this.masksProperties[i].mode !== 'n') {
            if (this.masksProperties[i].inv) {
                ctx.moveTo(0, 0);
                ctx.lineTo(this.element.globalData.compSize.w, 0);
                ctx.lineTo(this.element.globalData.compSize.w, this.element.globalData.compSize.h);
                ctx.lineTo(0, this.element.globalData.compSize.h);
                ctx.lineTo(0, 0);
            }
            data = this.viewData[i].v;
            pt = transform.applyToPointArray(data.v[0][0], data.v[0][1], 0);
            ctx.moveTo(pt[0], pt[1]);
            var j;
            var jLen = data._length;
            for(j = 1; j < jLen; j += 1){
                pts = transform.applyToTriplePoints(data.o[j - 1], data.i[j], data.v[j]);
                ctx.bezierCurveTo(pts[0], pts[1], pts[2], pts[3], pts[4], pts[5]);
            }
            pts = transform.applyToTriplePoints(data.o[j - 1], data.i[0], data.v[0]);
            ctx.bezierCurveTo(pts[0], pts[1], pts[2], pts[3], pts[4], pts[5]);
        }
        this.element.globalData.renderer.save(true);
        ctx.clip();
    };
    CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty;
    CVMaskElement.prototype.destroy = function() {
        this.element = null;
    };
    function CVBaseElement() {}
    var operationsMap = {
        1: 'source-in',
        2: 'source-out',
        3: 'source-in',
        4: 'source-out'
    };
    CVBaseElement.prototype = {
        createElements: function createElements() {},
        initRendererElement: function initRendererElement() {},
        createContainerElements: function createContainerElements() {
            // If the layer is masked we will use two buffers to store each different states of the drawing
            // This solution is not ideal for several reason. But unfortunately, because of the recursive
            // nature of the render tree, it's the only simple way to make sure one inner mask doesn't override an outer mask.
            // TODO: try to reduce the size of these buffers to the size of the composition contaning the layer
            // It might be challenging because the layer most likely is transformed in some way
            if (this.data.tt >= 1) {
                this.buffers = [];
                var canvasContext = this.globalData.canvasContext;
                var bufferCanvas = assetLoader.createCanvas(canvasContext.canvas.width, canvasContext.canvas.height);
                this.buffers.push(bufferCanvas);
                var bufferCanvas2 = assetLoader.createCanvas(canvasContext.canvas.width, canvasContext.canvas.height);
                this.buffers.push(bufferCanvas2);
                if (this.data.tt >= 3 && !document._isProxy) assetLoader.loadLumaCanvas();
            }
            this.canvasContext = this.globalData.canvasContext;
            this.transformCanvas = this.globalData.transformCanvas;
            this.renderableEffectsManager = new CVEffects(this);
            this.searchEffectTransforms();
        },
        createContent: function createContent() {},
        setBlendMode: function setBlendMode() {
            var globalData = this.globalData;
            if (globalData.blendMode !== this.data.bm) {
                globalData.blendMode = this.data.bm;
                var blendModeValue = getBlendMode(this.data.bm);
                globalData.canvasContext.globalCompositeOperation = blendModeValue;
            }
        },
        createRenderableComponents: function createRenderableComponents() {
            this.maskManager = new CVMaskElement(this.data, this);
            this.transformEffects = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
        },
        hideElement: function hideElement() {
            if (!this.hidden && (!this.isInRange || this.isTransparent)) this.hidden = true;
        },
        showElement: function showElement() {
            if (this.isInRange && !this.isTransparent) {
                this.hidden = false;
                this._isFirstFrame = true;
                this.maskManager._isFirstFrame = true;
            }
        },
        clearCanvas: function clearCanvas(canvasContext) {
            canvasContext.clearRect(this.transformCanvas.tx, this.transformCanvas.ty, this.transformCanvas.w * this.transformCanvas.sx, this.transformCanvas.h * this.transformCanvas.sy);
        },
        prepareLayer: function prepareLayer() {
            if (this.data.tt >= 1) {
                var buffer = this.buffers[0];
                var bufferCtx = buffer.getContext('2d');
                this.clearCanvas(bufferCtx); // on the first buffer we store the current state of the global drawing
                bufferCtx.drawImage(this.canvasContext.canvas, 0, 0); // The next four lines are to clear the canvas
                // TODO: Check if there is a way to clear the canvas without resetting the transform
                this.currentTransform = this.canvasContext.getTransform();
                this.canvasContext.setTransform(1, 0, 0, 1, 0, 0);
                this.clearCanvas(this.canvasContext);
                this.canvasContext.setTransform(this.currentTransform);
            }
        },
        exitLayer: function exitLayer() {
            if (this.data.tt >= 1) {
                var buffer = this.buffers[1]; // On the second buffer we store the current state of the global drawing
                // that only contains the content of this layer
                // (if it is a composition, it also includes the nested layers)
                var bufferCtx = buffer.getContext('2d');
                this.clearCanvas(bufferCtx);
                bufferCtx.drawImage(this.canvasContext.canvas, 0, 0); // We clear the canvas again
                this.canvasContext.setTransform(1, 0, 0, 1, 0, 0);
                this.clearCanvas(this.canvasContext);
                this.canvasContext.setTransform(this.currentTransform); // We draw the mask
                var mask = this.comp.getElementById('tp' in this.data ? this.data.tp : this.data.ind - 1);
                mask.renderFrame(true); // We draw the second buffer (that contains the content of this layer)
                this.canvasContext.setTransform(1, 0, 0, 1, 0, 0); // If the mask is a Luma matte, we need to do two extra painting operations
                // the _isProxy check is to avoid drawing a fake canvas in workers that will throw an error
                if (this.data.tt >= 3 && !document._isProxy) {
                    // We copy the painted mask to a buffer that has a color matrix filter applied to it
                    // that applies the rgb values to the alpha channel
                    var lumaBuffer = assetLoader.getLumaCanvas(this.canvasContext.canvas);
                    var lumaBufferCtx = lumaBuffer.getContext('2d');
                    lumaBufferCtx.drawImage(this.canvasContext.canvas, 0, 0);
                    this.clearCanvas(this.canvasContext); // we repaint the context with the mask applied to it
                    this.canvasContext.drawImage(lumaBuffer, 0, 0);
                }
                this.canvasContext.globalCompositeOperation = operationsMap[this.data.tt];
                this.canvasContext.drawImage(buffer, 0, 0); // We finally draw the first buffer (that contains the content of the global drawing)
                // We use destination-over to draw the global drawing below the current layer
                this.canvasContext.globalCompositeOperation = 'destination-over';
                this.canvasContext.drawImage(this.buffers[0], 0, 0);
                this.canvasContext.setTransform(this.currentTransform); // We reset the globalCompositeOperation to source-over, the standard type of operation
                this.canvasContext.globalCompositeOperation = 'source-over';
            }
        },
        renderFrame: function renderFrame(forceRender) {
            if (this.hidden || this.data.hd) return;
            if (this.data.td === 1 && !forceRender) return;
            this.renderTransform();
            this.renderRenderable();
            this.renderLocalTransform();
            this.setBlendMode();
            var forceRealStack = this.data.ty === 0;
            this.prepareLayer();
            this.globalData.renderer.save(forceRealStack);
            this.globalData.renderer.ctxTransform(this.finalTransform.localMat.props);
            this.globalData.renderer.ctxOpacity(this.finalTransform.localOpacity);
            this.renderInnerContent();
            this.globalData.renderer.restore(forceRealStack);
            this.exitLayer();
            if (this.maskManager.hasMasks) this.globalData.renderer.restore(true);
            if (this._isFirstFrame) this._isFirstFrame = false;
        },
        destroy: function destroy() {
            this.canvasContext = null;
            this.data = null;
            this.globalData = null;
            this.maskManager.destroy();
        },
        mHelper: new Matrix()
    };
    CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement;
    CVBaseElement.prototype.show = CVBaseElement.prototype.showElement;
    function CVShapeData(element, data, styles, transformsManager) {
        this.styledShapes = [];
        this.tr = [
            0,
            0,
            0,
            0,
            0,
            0
        ];
        var ty = 4;
        if (data.ty === 'rc') ty = 5;
        else if (data.ty === 'el') ty = 6;
        else if (data.ty === 'sr') ty = 7;
        this.sh = ShapePropertyFactory.getShapeProp(element, data, ty, element);
        var i;
        var len = styles.length;
        var styledShape;
        for(i = 0; i < len; i += 1)if (!styles[i].closed) {
            styledShape = {
                transforms: transformsManager.addTransformSequence(styles[i].transforms),
                trNodes: []
            };
            this.styledShapes.push(styledShape);
            styles[i].elements.push(styledShape);
        }
    }
    CVShapeData.prototype.setAsAnimated = SVGShapeData.prototype.setAsAnimated;
    function CVShapeElement(data, globalData, comp) {
        this.shapes = [];
        this.shapesData = data.shapes;
        this.stylesList = [];
        this.itemsData = [];
        this.prevViewData = [];
        this.shapeModifiers = [];
        this.processedElements = [];
        this.transformsManager = new ShapeTransformManager();
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        CVBaseElement,
        IShapeElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], CVShapeElement);
    CVShapeElement.prototype.initElement = RenderableDOMElement.prototype.initElement;
    CVShapeElement.prototype.transformHelper = {
        opacity: 1,
        _opMdf: false
    };
    CVShapeElement.prototype.dashResetter = [];
    CVShapeElement.prototype.createContent = function() {
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, true, []);
    };
    CVShapeElement.prototype.createStyleElement = function(data, transforms) {
        var styleElem = {
            data: data,
            type: data.ty,
            preTransforms: this.transformsManager.addTransformSequence(transforms),
            transforms: [],
            elements: [],
            closed: data.hd === true
        };
        var elementData = {};
        if (data.ty === 'fl' || data.ty === 'st') {
            elementData.c = PropertyFactory.getProp(this, data.c, 1, 255, this);
            if (!elementData.c.k) styleElem.co = 'rgb(' + bmFloor(elementData.c.v[0]) + ',' + bmFloor(elementData.c.v[1]) + ',' + bmFloor(elementData.c.v[2]) + ')';
        } else if (data.ty === 'gf' || data.ty === 'gs') {
            elementData.s = PropertyFactory.getProp(this, data.s, 1, null, this);
            elementData.e = PropertyFactory.getProp(this, data.e, 1, null, this);
            elementData.h = PropertyFactory.getProp(this, data.h || {
                k: 0
            }, 0, 0.01, this);
            elementData.a = PropertyFactory.getProp(this, data.a || {
                k: 0
            }, 0, degToRads, this);
            elementData.g = new GradientProperty(this, data.g, this);
        }
        elementData.o = PropertyFactory.getProp(this, data.o, 0, 0.01, this);
        if (data.ty === 'st' || data.ty === 'gs') {
            styleElem.lc = lineCapEnum[data.lc || 2];
            styleElem.lj = lineJoinEnum[data.lj || 2];
            if (data.lj == 1) // eslint-disable-line eqeqeq
            styleElem.ml = data.ml;
            elementData.w = PropertyFactory.getProp(this, data.w, 0, null, this);
            if (!elementData.w.k) styleElem.wi = elementData.w.v;
            if (data.d) {
                var d = new DashProperty(this, data.d, 'canvas', this);
                elementData.d = d;
                if (!elementData.d.k) {
                    styleElem.da = elementData.d.dashArray;
                    styleElem["do"] = elementData.d.dashoffset[0];
                }
            }
        } else styleElem.r = data.r === 2 ? 'evenodd' : 'nonzero';
        this.stylesList.push(styleElem);
        elementData.style = styleElem;
        return elementData;
    };
    CVShapeElement.prototype.createGroupElement = function() {
        var elementData = {
            it: [],
            prevViewData: []
        };
        return elementData;
    };
    CVShapeElement.prototype.createTransformElement = function(data) {
        var elementData = {
            transform: {
                opacity: 1,
                _opMdf: false,
                key: this.transformsManager.getNewKey(),
                op: PropertyFactory.getProp(this, data.o, 0, 0.01, this),
                mProps: TransformPropertyFactory.getTransformProperty(this, data, this)
            }
        };
        return elementData;
    };
    CVShapeElement.prototype.createShapeElement = function(data) {
        var elementData = new CVShapeData(this, data, this.stylesList, this.transformsManager);
        this.shapes.push(elementData);
        this.addShapeToModifiers(elementData);
        return elementData;
    };
    CVShapeElement.prototype.reloadShapes = function() {
        this._isFirstFrame = true;
        var i;
        var len = this.itemsData.length;
        for(i = 0; i < len; i += 1)this.prevViewData[i] = this.itemsData[i];
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, true, []);
        len = this.dynamicProperties.length;
        for(i = 0; i < len; i += 1)this.dynamicProperties[i].getValue();
        this.renderModifiers();
        this.transformsManager.processSequences(this._isFirstFrame);
    };
    CVShapeElement.prototype.addTransformToStyleList = function(transform) {
        var i;
        var len = this.stylesList.length;
        for(i = 0; i < len; i += 1)if (!this.stylesList[i].closed) this.stylesList[i].transforms.push(transform);
    };
    CVShapeElement.prototype.removeTransformFromStyleList = function() {
        var i;
        var len = this.stylesList.length;
        for(i = 0; i < len; i += 1)if (!this.stylesList[i].closed) this.stylesList[i].transforms.pop();
    };
    CVShapeElement.prototype.closeStyles = function(styles) {
        var i;
        var len = styles.length;
        for(i = 0; i < len; i += 1)styles[i].closed = true;
    };
    CVShapeElement.prototype.searchShapes = function(arr, itemsData, prevViewData, shouldRender, transforms) {
        var i;
        var len = arr.length - 1;
        var j;
        var jLen;
        var ownStyles = [];
        var ownModifiers = [];
        var processedPos;
        var modifier;
        var currentTransform;
        var ownTransforms = [].concat(transforms);
        for(i = len; i >= 0; i -= 1){
            processedPos = this.searchProcessedElement(arr[i]);
            if (!processedPos) arr[i]._shouldRender = shouldRender;
            else itemsData[i] = prevViewData[processedPos - 1];
            if (arr[i].ty === 'fl' || arr[i].ty === 'st' || arr[i].ty === 'gf' || arr[i].ty === 'gs') {
                if (!processedPos) itemsData[i] = this.createStyleElement(arr[i], ownTransforms);
                else itemsData[i].style.closed = false;
                ownStyles.push(itemsData[i].style);
            } else if (arr[i].ty === 'gr') {
                if (!processedPos) itemsData[i] = this.createGroupElement(arr[i]);
                else {
                    jLen = itemsData[i].it.length;
                    for(j = 0; j < jLen; j += 1)itemsData[i].prevViewData[j] = itemsData[i].it[j];
                }
                this.searchShapes(arr[i].it, itemsData[i].it, itemsData[i].prevViewData, shouldRender, ownTransforms);
            } else if (arr[i].ty === 'tr') {
                if (!processedPos) {
                    currentTransform = this.createTransformElement(arr[i]);
                    itemsData[i] = currentTransform;
                }
                ownTransforms.push(itemsData[i]);
                this.addTransformToStyleList(itemsData[i]);
            } else if (arr[i].ty === 'sh' || arr[i].ty === 'rc' || arr[i].ty === 'el' || arr[i].ty === 'sr') {
                if (!processedPos) itemsData[i] = this.createShapeElement(arr[i]);
            } else if (arr[i].ty === 'tm' || arr[i].ty === 'rd' || arr[i].ty === 'pb' || arr[i].ty === 'zz' || arr[i].ty === 'op') {
                if (!processedPos) {
                    modifier = ShapeModifiers.getModifier(arr[i].ty);
                    modifier.init(this, arr[i]);
                    itemsData[i] = modifier;
                    this.shapeModifiers.push(modifier);
                } else {
                    modifier = itemsData[i];
                    modifier.closed = false;
                }
                ownModifiers.push(modifier);
            } else if (arr[i].ty === 'rp') {
                if (!processedPos) {
                    modifier = ShapeModifiers.getModifier(arr[i].ty);
                    itemsData[i] = modifier;
                    modifier.init(this, arr, i, itemsData);
                    this.shapeModifiers.push(modifier);
                    shouldRender = false;
                } else {
                    modifier = itemsData[i];
                    modifier.closed = true;
                }
                ownModifiers.push(modifier);
            }
            this.addProcessedElement(arr[i], i + 1);
        }
        this.removeTransformFromStyleList();
        this.closeStyles(ownStyles);
        len = ownModifiers.length;
        for(i = 0; i < len; i += 1)ownModifiers[i].closed = true;
    };
    CVShapeElement.prototype.renderInnerContent = function() {
        this.transformHelper.opacity = 1;
        this.transformHelper._opMdf = false;
        this.renderModifiers();
        this.transformsManager.processSequences(this._isFirstFrame);
        this.renderShape(this.transformHelper, this.shapesData, this.itemsData, true);
    };
    CVShapeElement.prototype.renderShapeTransform = function(parentTransform, groupTransform) {
        if (parentTransform._opMdf || groupTransform.op._mdf || this._isFirstFrame) {
            groupTransform.opacity = parentTransform.opacity;
            groupTransform.opacity *= groupTransform.op.v;
            groupTransform._opMdf = true;
        }
    };
    CVShapeElement.prototype.drawLayer = function() {
        var i;
        var len = this.stylesList.length;
        var j;
        var jLen;
        var k;
        var kLen;
        var elems;
        var nodes;
        var renderer = this.globalData.renderer;
        var ctx = this.globalData.canvasContext;
        var type;
        var currentStyle;
        for(i = 0; i < len; i += 1){
            currentStyle = this.stylesList[i];
            type = currentStyle.type; // Skipping style when
            // Stroke width equals 0
            // style should not be rendered (extra unused repeaters)
            // current opacity equals 0
            // global opacity equals 0
            if (!((type === 'st' || type === 'gs') && currentStyle.wi === 0 || !currentStyle.data._shouldRender || currentStyle.coOp === 0 || this.globalData.currentGlobalAlpha === 0)) {
                renderer.save();
                elems = currentStyle.elements;
                if (type === 'st' || type === 'gs') {
                    renderer.ctxStrokeStyle(type === 'st' ? currentStyle.co : currentStyle.grd); // ctx.strokeStyle = type === 'st' ? currentStyle.co : currentStyle.grd;
                    renderer.ctxLineWidth(currentStyle.wi); // ctx.lineWidth = currentStyle.wi;
                    renderer.ctxLineCap(currentStyle.lc); // ctx.lineCap = currentStyle.lc;
                    renderer.ctxLineJoin(currentStyle.lj); // ctx.lineJoin = currentStyle.lj;
                    renderer.ctxMiterLimit(currentStyle.ml || 0); // ctx.miterLimit = currentStyle.ml || 0;
                } else renderer.ctxFillStyle(type === 'fl' ? currentStyle.co : currentStyle.grd); // ctx.fillStyle = type === 'fl' ? currentStyle.co : currentStyle.grd;
                renderer.ctxOpacity(currentStyle.coOp);
                if (type !== 'st' && type !== 'gs') ctx.beginPath();
                renderer.ctxTransform(currentStyle.preTransforms.finalTransform.props);
                jLen = elems.length;
                for(j = 0; j < jLen; j += 1){
                    if (type === 'st' || type === 'gs') {
                        ctx.beginPath();
                        if (currentStyle.da) {
                            ctx.setLineDash(currentStyle.da);
                            ctx.lineDashOffset = currentStyle["do"];
                        }
                    }
                    nodes = elems[j].trNodes;
                    kLen = nodes.length;
                    for(k = 0; k < kLen; k += 1){
                        if (nodes[k].t === 'm') ctx.moveTo(nodes[k].p[0], nodes[k].p[1]);
                        else if (nodes[k].t === 'c') ctx.bezierCurveTo(nodes[k].pts[0], nodes[k].pts[1], nodes[k].pts[2], nodes[k].pts[3], nodes[k].pts[4], nodes[k].pts[5]);
                        else ctx.closePath();
                    }
                    if (type === 'st' || type === 'gs') {
                        // ctx.stroke();
                        renderer.ctxStroke();
                        if (currentStyle.da) ctx.setLineDash(this.dashResetter);
                    }
                }
                if (type !== 'st' && type !== 'gs') // ctx.fill(currentStyle.r);
                this.globalData.renderer.ctxFill(currentStyle.r);
                renderer.restore();
            }
        }
    };
    CVShapeElement.prototype.renderShape = function(parentTransform, items, data, isMain) {
        var i;
        var len = items.length - 1;
        var groupTransform;
        groupTransform = parentTransform;
        for(i = len; i >= 0; i -= 1){
            if (items[i].ty === 'tr') {
                groupTransform = data[i].transform;
                this.renderShapeTransform(parentTransform, groupTransform);
            } else if (items[i].ty === 'sh' || items[i].ty === 'el' || items[i].ty === 'rc' || items[i].ty === 'sr') this.renderPath(items[i], data[i]);
            else if (items[i].ty === 'fl') this.renderFill(items[i], data[i], groupTransform);
            else if (items[i].ty === 'st') this.renderStroke(items[i], data[i], groupTransform);
            else if (items[i].ty === 'gf' || items[i].ty === 'gs') this.renderGradientFill(items[i], data[i], groupTransform);
            else if (items[i].ty === 'gr') this.renderShape(groupTransform, items[i].it, data[i].it);
            else items[i].ty;
        }
        if (isMain) this.drawLayer();
    };
    CVShapeElement.prototype.renderStyledShape = function(styledShape, shape) {
        if (this._isFirstFrame || shape._mdf || styledShape.transforms._mdf) {
            var shapeNodes = styledShape.trNodes;
            var paths = shape.paths;
            var i;
            var len;
            var j;
            var jLen = paths._length;
            shapeNodes.length = 0;
            var groupTransformMat = styledShape.transforms.finalTransform;
            for(j = 0; j < jLen; j += 1){
                var pathNodes = paths.shapes[j];
                if (pathNodes && pathNodes.v) {
                    len = pathNodes._length;
                    for(i = 1; i < len; i += 1){
                        if (i === 1) shapeNodes.push({
                            t: 'm',
                            p: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
                        });
                        shapeNodes.push({
                            t: 'c',
                            pts: groupTransformMat.applyToTriplePoints(pathNodes.o[i - 1], pathNodes.i[i], pathNodes.v[i])
                        });
                    }
                    if (len === 1) shapeNodes.push({
                        t: 'm',
                        p: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
                    });
                    if (pathNodes.c && len) {
                        shapeNodes.push({
                            t: 'c',
                            pts: groupTransformMat.applyToTriplePoints(pathNodes.o[i - 1], pathNodes.i[0], pathNodes.v[0])
                        });
                        shapeNodes.push({
                            t: 'z'
                        });
                    }
                }
            }
            styledShape.trNodes = shapeNodes;
        }
    };
    CVShapeElement.prototype.renderPath = function(pathData, itemData) {
        if (pathData.hd !== true && pathData._shouldRender) {
            var i;
            var len = itemData.styledShapes.length;
            for(i = 0; i < len; i += 1)this.renderStyledShape(itemData.styledShapes[i], itemData.sh);
        }
    };
    CVShapeElement.prototype.renderFill = function(styleData, itemData, groupTransform) {
        var styleElem = itemData.style;
        if (itemData.c._mdf || this._isFirstFrame) styleElem.co = 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')';
        if (itemData.o._mdf || groupTransform._opMdf || this._isFirstFrame) styleElem.coOp = itemData.o.v * groupTransform.opacity;
    };
    CVShapeElement.prototype.renderGradientFill = function(styleData, itemData, groupTransform) {
        var styleElem = itemData.style;
        var grd;
        if (!styleElem.grd || itemData.g._mdf || itemData.s._mdf || itemData.e._mdf || styleData.t !== 1 && (itemData.h._mdf || itemData.a._mdf)) {
            var ctx = this.globalData.canvasContext;
            var pt1 = itemData.s.v;
            var pt2 = itemData.e.v;
            if (styleData.t === 1) grd = ctx.createLinearGradient(pt1[0], pt1[1], pt2[0], pt2[1]);
            else {
                var rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
                var ang = Math.atan2(pt2[1] - pt1[1], pt2[0] - pt1[0]);
                var percent = itemData.h.v;
                if (percent >= 1) percent = 0.99;
                else if (percent <= -1) percent = -0.99;
                var dist = rad * percent;
                var x = Math.cos(ang + itemData.a.v) * dist + pt1[0];
                var y = Math.sin(ang + itemData.a.v) * dist + pt1[1];
                grd = ctx.createRadialGradient(x, y, 0, pt1[0], pt1[1], rad);
            }
            var i;
            var len = styleData.g.p;
            var cValues = itemData.g.c;
            var opacity = 1;
            for(i = 0; i < len; i += 1){
                if (itemData.g._hasOpacity && itemData.g._collapsable) opacity = itemData.g.o[i * 2 + 1];
                grd.addColorStop(cValues[i * 4] / 100, 'rgba(' + cValues[i * 4 + 1] + ',' + cValues[i * 4 + 2] + ',' + cValues[i * 4 + 3] + ',' + opacity + ')');
            }
            styleElem.grd = grd;
        }
        styleElem.coOp = itemData.o.v * groupTransform.opacity;
    };
    CVShapeElement.prototype.renderStroke = function(styleData, itemData, groupTransform) {
        var styleElem = itemData.style;
        var d = itemData.d;
        if (d && (d._mdf || this._isFirstFrame)) {
            styleElem.da = d.dashArray;
            styleElem["do"] = d.dashoffset[0];
        }
        if (itemData.c._mdf || this._isFirstFrame) styleElem.co = 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')';
        if (itemData.o._mdf || groupTransform._opMdf || this._isFirstFrame) styleElem.coOp = itemData.o.v * groupTransform.opacity;
        if (itemData.w._mdf || this._isFirstFrame) styleElem.wi = itemData.w.v;
    };
    CVShapeElement.prototype.destroy = function() {
        this.shapesData = null;
        this.globalData = null;
        this.canvasContext = null;
        this.stylesList.length = 0;
        this.itemsData.length = 0;
    };
    function CVTextElement(data, globalData, comp) {
        this.textSpans = [];
        this.yOffset = 0;
        this.fillColorAnim = false;
        this.strokeColorAnim = false;
        this.strokeWidthAnim = false;
        this.stroke = false;
        this.fill = false;
        this.justifyOffset = 0;
        this.currentRender = null;
        this.renderType = 'canvas';
        this.values = {
            fill: 'rgba(0,0,0,0)',
            stroke: 'rgba(0,0,0,0)',
            sWidth: 0,
            fValue: ''
        };
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        CVBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableElement,
        ITextElement
    ], CVTextElement);
    CVTextElement.prototype.tHelper = createTag('canvas').getContext('2d');
    CVTextElement.prototype.buildNewText = function() {
        var documentData = this.textProperty.currentData;
        this.renderedLetters = createSizedArray(documentData.l ? documentData.l.length : 0);
        var hasFill = false;
        if (documentData.fc) {
            hasFill = true;
            this.values.fill = this.buildColor(documentData.fc);
        } else this.values.fill = 'rgba(0,0,0,0)';
        this.fill = hasFill;
        var hasStroke = false;
        if (documentData.sc) {
            hasStroke = true;
            this.values.stroke = this.buildColor(documentData.sc);
            this.values.sWidth = documentData.sw;
        }
        var fontData = this.globalData.fontManager.getFontByName(documentData.f);
        var i;
        var len;
        var letters = documentData.l;
        var matrixHelper = this.mHelper;
        this.stroke = hasStroke;
        this.values.fValue = documentData.finalSize + 'px ' + this.globalData.fontManager.getFontByName(documentData.f).fFamily;
        len = documentData.finalText.length; // this.tHelper.font = this.values.fValue;
        var charData;
        var shapeData;
        var k;
        var kLen;
        var shapes;
        var j;
        var jLen;
        var pathNodes;
        var commands;
        var pathArr;
        var singleShape = this.data.singleShape;
        var trackingOffset = documentData.tr * 0.001 * documentData.finalSize;
        var xPos = 0;
        var yPos = 0;
        var firstLine = true;
        var cnt = 0;
        for(i = 0; i < len; i += 1){
            charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
            shapeData = charData && charData.data || {};
            matrixHelper.reset();
            if (singleShape && letters[i].n) {
                xPos = -trackingOffset;
                yPos += documentData.yOffset;
                yPos += firstLine ? 1 : 0;
                firstLine = false;
            }
            shapes = shapeData.shapes ? shapeData.shapes[0].it : [];
            jLen = shapes.length;
            matrixHelper.scale(documentData.finalSize / 100, documentData.finalSize / 100);
            if (singleShape) this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
            commands = createSizedArray(jLen - 1);
            var commandsCounter = 0;
            for(j = 0; j < jLen; j += 1)if (shapes[j].ty === 'sh') {
                kLen = shapes[j].ks.k.i.length;
                pathNodes = shapes[j].ks.k;
                pathArr = [];
                for(k = 1; k < kLen; k += 1){
                    if (k === 1) pathArr.push(matrixHelper.applyToX(pathNodes.v[0][0], pathNodes.v[0][1], 0), matrixHelper.applyToY(pathNodes.v[0][0], pathNodes.v[0][1], 0));
                    pathArr.push(matrixHelper.applyToX(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToY(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToX(pathNodes.i[k][0], pathNodes.i[k][1], 0), matrixHelper.applyToY(pathNodes.i[k][0], pathNodes.i[k][1], 0), matrixHelper.applyToX(pathNodes.v[k][0], pathNodes.v[k][1], 0), matrixHelper.applyToY(pathNodes.v[k][0], pathNodes.v[k][1], 0));
                }
                pathArr.push(matrixHelper.applyToX(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToY(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToX(pathNodes.i[0][0], pathNodes.i[0][1], 0), matrixHelper.applyToY(pathNodes.i[0][0], pathNodes.i[0][1], 0), matrixHelper.applyToX(pathNodes.v[0][0], pathNodes.v[0][1], 0), matrixHelper.applyToY(pathNodes.v[0][0], pathNodes.v[0][1], 0));
                commands[commandsCounter] = pathArr;
                commandsCounter += 1;
            }
            if (singleShape) {
                xPos += letters[i].l;
                xPos += trackingOffset;
            }
            if (this.textSpans[cnt]) this.textSpans[cnt].elem = commands;
            else this.textSpans[cnt] = {
                elem: commands
            };
            cnt += 1;
        }
    };
    CVTextElement.prototype.renderInnerContent = function() {
        this.validateText();
        var ctx = this.canvasContext;
        ctx.font = this.values.fValue;
        this.globalData.renderer.ctxLineCap('butt'); // ctx.lineCap = 'butt';
        this.globalData.renderer.ctxLineJoin('miter'); // ctx.lineJoin = 'miter';
        this.globalData.renderer.ctxMiterLimit(4); // ctx.miterLimit = 4;
        if (!this.data.singleShape) this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
        var i;
        var len;
        var j;
        var jLen;
        var k;
        var kLen;
        var renderedLetters = this.textAnimator.renderedLetters;
        var letters = this.textProperty.currentData.l;
        len = letters.length;
        var renderedLetter;
        var lastFill = null;
        var lastStroke = null;
        var lastStrokeW = null;
        var commands;
        var pathArr;
        var renderer = this.globalData.renderer;
        for(i = 0; i < len; i += 1)if (!letters[i].n) {
            renderedLetter = renderedLetters[i];
            if (renderedLetter) {
                renderer.save();
                renderer.ctxTransform(renderedLetter.p);
                renderer.ctxOpacity(renderedLetter.o);
            }
            if (this.fill) {
                if (renderedLetter && renderedLetter.fc) {
                    if (lastFill !== renderedLetter.fc) {
                        renderer.ctxFillStyle(renderedLetter.fc);
                        lastFill = renderedLetter.fc; // ctx.fillStyle = renderedLetter.fc;
                    }
                } else if (lastFill !== this.values.fill) {
                    lastFill = this.values.fill;
                    renderer.ctxFillStyle(this.values.fill); // ctx.fillStyle = this.values.fill;
                }
                commands = this.textSpans[i].elem;
                jLen = commands.length;
                this.globalData.canvasContext.beginPath();
                for(j = 0; j < jLen; j += 1){
                    pathArr = commands[j];
                    kLen = pathArr.length;
                    this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);
                    for(k = 2; k < kLen; k += 6)this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
                }
                this.globalData.canvasContext.closePath();
                renderer.ctxFill(); // this.globalData.canvasContext.fill();
            /// ctx.fillText(this.textSpans[i].val,0,0);
            }
            if (this.stroke) {
                if (renderedLetter && renderedLetter.sw) {
                    if (lastStrokeW !== renderedLetter.sw) {
                        lastStrokeW = renderedLetter.sw;
                        renderer.ctxLineWidth(renderedLetter.sw); // ctx.lineWidth = renderedLetter.sw;
                    }
                } else if (lastStrokeW !== this.values.sWidth) {
                    lastStrokeW = this.values.sWidth;
                    renderer.ctxLineWidth(this.values.sWidth); // ctx.lineWidth = this.values.sWidth;
                }
                if (renderedLetter && renderedLetter.sc) {
                    if (lastStroke !== renderedLetter.sc) {
                        lastStroke = renderedLetter.sc;
                        renderer.ctxStrokeStyle(renderedLetter.sc); // ctx.strokeStyle = renderedLetter.sc;
                    }
                } else if (lastStroke !== this.values.stroke) {
                    lastStroke = this.values.stroke;
                    renderer.ctxStrokeStyle(this.values.stroke); // ctx.strokeStyle = this.values.stroke;
                }
                commands = this.textSpans[i].elem;
                jLen = commands.length;
                this.globalData.canvasContext.beginPath();
                for(j = 0; j < jLen; j += 1){
                    pathArr = commands[j];
                    kLen = pathArr.length;
                    this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);
                    for(k = 2; k < kLen; k += 6)this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
                }
                this.globalData.canvasContext.closePath();
                renderer.ctxStroke(); // this.globalData.canvasContext.stroke();
            /// ctx.strokeText(letters[i].val,0,0);
            }
            if (renderedLetter) this.globalData.renderer.restore();
        }
    };
    function CVImageElement(data, globalData, comp) {
        this.assetData = globalData.getAssetData(data.refId);
        this.img = globalData.imageLoader.getAsset(this.assetData);
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        CVBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], CVImageElement);
    CVImageElement.prototype.initElement = SVGShapeElement.prototype.initElement;
    CVImageElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame;
    CVImageElement.prototype.createContent = function() {
        if (this.img.width && (this.assetData.w !== this.img.width || this.assetData.h !== this.img.height)) {
            var canvas = createTag('canvas');
            canvas.width = this.assetData.w;
            canvas.height = this.assetData.h;
            var ctx = canvas.getContext('2d');
            var imgW = this.img.width;
            var imgH = this.img.height;
            var imgRel = imgW / imgH;
            var canvasRel = this.assetData.w / this.assetData.h;
            var widthCrop;
            var heightCrop;
            var par = this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio;
            if (imgRel > canvasRel && par === 'xMidYMid slice' || imgRel < canvasRel && par !== 'xMidYMid slice') {
                heightCrop = imgH;
                widthCrop = heightCrop * canvasRel;
            } else {
                widthCrop = imgW;
                heightCrop = widthCrop / canvasRel;
            }
            ctx.drawImage(this.img, (imgW - widthCrop) / 2, (imgH - heightCrop) / 2, widthCrop, heightCrop, 0, 0, this.assetData.w, this.assetData.h);
            this.img = canvas;
        }
    };
    CVImageElement.prototype.renderInnerContent = function() {
        this.canvasContext.drawImage(this.img, 0, 0);
    };
    CVImageElement.prototype.destroy = function() {
        this.img = null;
    };
    function CVSolidElement(data, globalData, comp) {
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        CVBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], CVSolidElement);
    CVSolidElement.prototype.initElement = SVGShapeElement.prototype.initElement;
    CVSolidElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame;
    CVSolidElement.prototype.renderInnerContent = function() {
        // var ctx = this.canvasContext;
        this.globalData.renderer.ctxFillStyle(this.data.sc); // ctx.fillStyle = this.data.sc;
        this.globalData.renderer.ctxFillRect(0, 0, this.data.sw, this.data.sh); // ctx.fillRect(0, 0, this.data.sw, this.data.sh);
    //
    };
    function CanvasRendererBase() {}
    extendPrototype([
        BaseRenderer
    ], CanvasRendererBase);
    CanvasRendererBase.prototype.createShape = function(data) {
        return new CVShapeElement(data, this.globalData, this);
    };
    CanvasRendererBase.prototype.createText = function(data) {
        return new CVTextElement(data, this.globalData, this);
    };
    CanvasRendererBase.prototype.createImage = function(data) {
        return new CVImageElement(data, this.globalData, this);
    };
    CanvasRendererBase.prototype.createSolid = function(data) {
        return new CVSolidElement(data, this.globalData, this);
    };
    CanvasRendererBase.prototype.createNull = SVGRenderer.prototype.createNull;
    CanvasRendererBase.prototype.ctxTransform = function(props) {
        if (props[0] === 1 && props[1] === 0 && props[4] === 0 && props[5] === 1 && props[12] === 0 && props[13] === 0) return;
        this.canvasContext.transform(props[0], props[1], props[4], props[5], props[12], props[13]);
    };
    CanvasRendererBase.prototype.ctxOpacity = function(op) {
        this.canvasContext.globalAlpha *= op < 0 ? 0 : op;
    };
    CanvasRendererBase.prototype.ctxFillStyle = function(value) {
        this.canvasContext.fillStyle = value;
    };
    CanvasRendererBase.prototype.ctxStrokeStyle = function(value) {
        this.canvasContext.strokeStyle = value;
    };
    CanvasRendererBase.prototype.ctxLineWidth = function(value) {
        this.canvasContext.lineWidth = value;
    };
    CanvasRendererBase.prototype.ctxLineCap = function(value) {
        this.canvasContext.lineCap = value;
    };
    CanvasRendererBase.prototype.ctxLineJoin = function(value) {
        this.canvasContext.lineJoin = value;
    };
    CanvasRendererBase.prototype.ctxMiterLimit = function(value) {
        this.canvasContext.miterLimit = value;
    };
    CanvasRendererBase.prototype.ctxFill = function(rule) {
        this.canvasContext.fill(rule);
    };
    CanvasRendererBase.prototype.ctxFillRect = function(x, y, w, h) {
        this.canvasContext.fillRect(x, y, w, h);
    };
    CanvasRendererBase.prototype.ctxStroke = function() {
        this.canvasContext.stroke();
    };
    CanvasRendererBase.prototype.reset = function() {
        if (!this.renderConfig.clearCanvas) {
            this.canvasContext.restore();
            return;
        }
        this.contextData.reset();
    };
    CanvasRendererBase.prototype.save = function() {
        this.canvasContext.save();
    };
    CanvasRendererBase.prototype.restore = function(actionFlag) {
        if (!this.renderConfig.clearCanvas) {
            this.canvasContext.restore();
            return;
        }
        if (actionFlag) this.globalData.blendMode = 'source-over';
        this.contextData.restore(actionFlag);
    };
    CanvasRendererBase.prototype.configAnimation = function(animData) {
        if (this.animationItem.wrapper) {
            this.animationItem.container = createTag('canvas');
            var containerStyle = this.animationItem.container.style;
            containerStyle.width = '100%';
            containerStyle.height = '100%';
            var origin = '0px 0px 0px';
            containerStyle.transformOrigin = origin;
            containerStyle.mozTransformOrigin = origin;
            containerStyle.webkitTransformOrigin = origin;
            containerStyle['-webkit-transform'] = origin;
            containerStyle.contentVisibility = this.renderConfig.contentVisibility;
            this.animationItem.wrapper.appendChild(this.animationItem.container);
            this.canvasContext = this.animationItem.container.getContext('2d');
            if (this.renderConfig.className) this.animationItem.container.setAttribute('class', this.renderConfig.className);
            if (this.renderConfig.id) this.animationItem.container.setAttribute('id', this.renderConfig.id);
        } else this.canvasContext = this.renderConfig.context;
        this.contextData.setContext(this.canvasContext);
        this.data = animData;
        this.layers = animData.layers;
        this.transformCanvas = {
            w: animData.w,
            h: animData.h,
            sx: 0,
            sy: 0,
            tx: 0,
            ty: 0
        };
        this.setupGlobalData(animData, document.body);
        this.globalData.canvasContext = this.canvasContext;
        this.globalData.renderer = this;
        this.globalData.isDashed = false;
        this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
        this.globalData.transformCanvas = this.transformCanvas;
        this.elements = createSizedArray(animData.layers.length);
        this.updateContainerSize();
    };
    CanvasRendererBase.prototype.updateContainerSize = function(width, height) {
        this.reset();
        var elementWidth;
        var elementHeight;
        if (width) {
            elementWidth = width;
            elementHeight = height;
            this.canvasContext.canvas.width = elementWidth;
            this.canvasContext.canvas.height = elementHeight;
        } else {
            if (this.animationItem.wrapper && this.animationItem.container) {
                elementWidth = this.animationItem.wrapper.offsetWidth;
                elementHeight = this.animationItem.wrapper.offsetHeight;
            } else {
                elementWidth = this.canvasContext.canvas.width;
                elementHeight = this.canvasContext.canvas.height;
            }
            this.canvasContext.canvas.width = elementWidth * this.renderConfig.dpr;
            this.canvasContext.canvas.height = elementHeight * this.renderConfig.dpr;
        }
        var elementRel;
        var animationRel;
        if (this.renderConfig.preserveAspectRatio.indexOf('meet') !== -1 || this.renderConfig.preserveAspectRatio.indexOf('slice') !== -1) {
            var par = this.renderConfig.preserveAspectRatio.split(' ');
            var fillType = par[1] || 'meet';
            var pos = par[0] || 'xMidYMid';
            var xPos = pos.substr(0, 4);
            var yPos = pos.substr(4);
            elementRel = elementWidth / elementHeight;
            animationRel = this.transformCanvas.w / this.transformCanvas.h;
            if (animationRel > elementRel && fillType === 'meet' || animationRel < elementRel && fillType === 'slice') {
                this.transformCanvas.sx = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
                this.transformCanvas.sy = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
            } else {
                this.transformCanvas.sx = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
                this.transformCanvas.sy = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
            }
            if (xPos === 'xMid' && (animationRel < elementRel && fillType === 'meet' || animationRel > elementRel && fillType === 'slice')) this.transformCanvas.tx = (elementWidth - this.transformCanvas.w * (elementHeight / this.transformCanvas.h)) / 2 * this.renderConfig.dpr;
            else if (xPos === 'xMax' && (animationRel < elementRel && fillType === 'meet' || animationRel > elementRel && fillType === 'slice')) this.transformCanvas.tx = (elementWidth - this.transformCanvas.w * (elementHeight / this.transformCanvas.h)) * this.renderConfig.dpr;
            else this.transformCanvas.tx = 0;
            if (yPos === 'YMid' && (animationRel > elementRel && fillType === 'meet' || animationRel < elementRel && fillType === 'slice')) this.transformCanvas.ty = (elementHeight - this.transformCanvas.h * (elementWidth / this.transformCanvas.w)) / 2 * this.renderConfig.dpr;
            else if (yPos === 'YMax' && (animationRel > elementRel && fillType === 'meet' || animationRel < elementRel && fillType === 'slice')) this.transformCanvas.ty = (elementHeight - this.transformCanvas.h * (elementWidth / this.transformCanvas.w)) * this.renderConfig.dpr;
            else this.transformCanvas.ty = 0;
        } else if (this.renderConfig.preserveAspectRatio === 'none') {
            this.transformCanvas.sx = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
            this.transformCanvas.sy = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
            this.transformCanvas.tx = 0;
            this.transformCanvas.ty = 0;
        } else {
            this.transformCanvas.sx = this.renderConfig.dpr;
            this.transformCanvas.sy = this.renderConfig.dpr;
            this.transformCanvas.tx = 0;
            this.transformCanvas.ty = 0;
        }
        this.transformCanvas.props = [
            this.transformCanvas.sx,
            0,
            0,
            0,
            0,
            this.transformCanvas.sy,
            0,
            0,
            0,
            0,
            1,
            0,
            this.transformCanvas.tx,
            this.transformCanvas.ty,
            0,
            1
        ];
        /* var i, len = this.elements.length;
      for(i=0;i<len;i+=1){
          if(this.elements[i] && this.elements[i].data.ty === 0){
              this.elements[i].resize(this.globalData.transformCanvas);
          }
      } */ this.ctxTransform(this.transformCanvas.props);
        this.canvasContext.beginPath();
        this.canvasContext.rect(0, 0, this.transformCanvas.w, this.transformCanvas.h);
        this.canvasContext.closePath();
        this.canvasContext.clip();
        this.renderFrame(this.renderedFrame, true);
    };
    CanvasRendererBase.prototype.destroy = function() {
        if (this.renderConfig.clearCanvas && this.animationItem.wrapper) this.animationItem.wrapper.innerText = '';
        var i;
        var len = this.layers ? this.layers.length : 0;
        for(i = len - 1; i >= 0; i -= 1)if (this.elements[i] && this.elements[i].destroy) this.elements[i].destroy();
        this.elements.length = 0;
        this.globalData.canvasContext = null;
        this.animationItem.container = null;
        this.destroyed = true;
    };
    CanvasRendererBase.prototype.renderFrame = function(num, forceRender) {
        if (this.renderedFrame === num && this.renderConfig.clearCanvas === true && !forceRender || this.destroyed || num === -1) return;
        this.renderedFrame = num;
        this.globalData.frameNum = num - this.animationItem._isFirstFrame;
        this.globalData.frameId += 1;
        this.globalData._mdf = !this.renderConfig.clearCanvas || forceRender;
        this.globalData.projectInterface.currentFrame = num; // console.log('--------');
        // console.log('NEW: ',num);
        var i;
        var len = this.layers.length;
        if (!this.completeLayers) this.checkLayers(num);
        for(i = len - 1; i >= 0; i -= 1)if (this.completeLayers || this.elements[i]) this.elements[i].prepareFrame(num - this.layers[i].st);
        if (this.globalData._mdf) {
            if (this.renderConfig.clearCanvas === true) this.canvasContext.clearRect(0, 0, this.transformCanvas.w, this.transformCanvas.h);
            else this.save();
            for(i = len - 1; i >= 0; i -= 1)if (this.completeLayers || this.elements[i]) this.elements[i].renderFrame();
            if (this.renderConfig.clearCanvas !== true) this.restore();
        }
    };
    CanvasRendererBase.prototype.buildItem = function(pos) {
        var elements = this.elements;
        if (elements[pos] || this.layers[pos].ty === 99) return;
        var element = this.createItem(this.layers[pos], this, this.globalData);
        elements[pos] = element;
        element.initExpressions();
    /* if(this.layers[pos].ty === 0){
          element.resize(this.globalData.transformCanvas);
      } */ };
    CanvasRendererBase.prototype.checkPendingElements = function() {
        while(this.pendingElements.length){
            var element = this.pendingElements.pop();
            element.checkParenting();
        }
    };
    CanvasRendererBase.prototype.hide = function() {
        this.animationItem.container.style.display = 'none';
    };
    CanvasRendererBase.prototype.show = function() {
        this.animationItem.container.style.display = 'block';
    };
    function CanvasContext() {
        this.opacity = -1;
        this.transform = createTypedArray('float32', 16);
        this.fillStyle = '';
        this.strokeStyle = '';
        this.lineWidth = '';
        this.lineCap = '';
        this.lineJoin = '';
        this.miterLimit = '';
        this.id = Math.random();
    }
    function CVContextData() {
        this.stack = [];
        this.cArrPos = 0;
        this.cTr = new Matrix();
        var i;
        var len = 15;
        for(i = 0; i < len; i += 1){
            var canvasContext = new CanvasContext();
            this.stack[i] = canvasContext;
        }
        this._length = len;
        this.nativeContext = null;
        this.transformMat = new Matrix();
        this.currentOpacity = 1; //
        this.currentFillStyle = '';
        this.appliedFillStyle = ''; //
        this.currentStrokeStyle = '';
        this.appliedStrokeStyle = ''; //
        this.currentLineWidth = '';
        this.appliedLineWidth = ''; //
        this.currentLineCap = '';
        this.appliedLineCap = ''; //
        this.currentLineJoin = '';
        this.appliedLineJoin = ''; //
        this.appliedMiterLimit = '';
        this.currentMiterLimit = '';
    }
    CVContextData.prototype.duplicate = function() {
        var newLength = this._length * 2;
        var i = 0;
        for(i = this._length; i < newLength; i += 1)this.stack[i] = new CanvasContext();
        this._length = newLength;
    };
    CVContextData.prototype.reset = function() {
        this.cArrPos = 0;
        this.cTr.reset();
        this.stack[this.cArrPos].opacity = 1;
    };
    CVContextData.prototype.restore = function(forceRestore) {
        this.cArrPos -= 1;
        var currentContext = this.stack[this.cArrPos];
        var transform = currentContext.transform;
        var i;
        var arr = this.cTr.props;
        for(i = 0; i < 16; i += 1)arr[i] = transform[i];
        if (forceRestore) {
            this.nativeContext.restore();
            var prevStack = this.stack[this.cArrPos + 1];
            this.appliedFillStyle = prevStack.fillStyle;
            this.appliedStrokeStyle = prevStack.strokeStyle;
            this.appliedLineWidth = prevStack.lineWidth;
            this.appliedLineCap = prevStack.lineCap;
            this.appliedLineJoin = prevStack.lineJoin;
            this.appliedMiterLimit = prevStack.miterLimit;
        }
        this.nativeContext.setTransform(transform[0], transform[1], transform[4], transform[5], transform[12], transform[13]);
        if (forceRestore || currentContext.opacity !== -1 && this.currentOpacity !== currentContext.opacity) {
            this.nativeContext.globalAlpha = currentContext.opacity;
            this.currentOpacity = currentContext.opacity;
        }
        this.currentFillStyle = currentContext.fillStyle;
        this.currentStrokeStyle = currentContext.strokeStyle;
        this.currentLineWidth = currentContext.lineWidth;
        this.currentLineCap = currentContext.lineCap;
        this.currentLineJoin = currentContext.lineJoin;
        this.currentMiterLimit = currentContext.miterLimit;
    };
    CVContextData.prototype.save = function(saveOnNativeFlag) {
        if (saveOnNativeFlag) this.nativeContext.save();
        var props = this.cTr.props;
        if (this._length <= this.cArrPos) this.duplicate();
        var currentStack = this.stack[this.cArrPos];
        var i;
        for(i = 0; i < 16; i += 1)currentStack.transform[i] = props[i];
        this.cArrPos += 1;
        var newStack = this.stack[this.cArrPos];
        newStack.opacity = currentStack.opacity;
        newStack.fillStyle = currentStack.fillStyle;
        newStack.strokeStyle = currentStack.strokeStyle;
        newStack.lineWidth = currentStack.lineWidth;
        newStack.lineCap = currentStack.lineCap;
        newStack.lineJoin = currentStack.lineJoin;
        newStack.miterLimit = currentStack.miterLimit;
    };
    CVContextData.prototype.setOpacity = function(value) {
        this.stack[this.cArrPos].opacity = value;
    };
    CVContextData.prototype.setContext = function(value) {
        this.nativeContext = value;
    };
    CVContextData.prototype.fillStyle = function(value) {
        if (this.stack[this.cArrPos].fillStyle !== value) {
            this.currentFillStyle = value;
            this.stack[this.cArrPos].fillStyle = value;
        }
    };
    CVContextData.prototype.strokeStyle = function(value) {
        if (this.stack[this.cArrPos].strokeStyle !== value) {
            this.currentStrokeStyle = value;
            this.stack[this.cArrPos].strokeStyle = value;
        }
    };
    CVContextData.prototype.lineWidth = function(value) {
        if (this.stack[this.cArrPos].lineWidth !== value) {
            this.currentLineWidth = value;
            this.stack[this.cArrPos].lineWidth = value;
        }
    };
    CVContextData.prototype.lineCap = function(value) {
        if (this.stack[this.cArrPos].lineCap !== value) {
            this.currentLineCap = value;
            this.stack[this.cArrPos].lineCap = value;
        }
    };
    CVContextData.prototype.lineJoin = function(value) {
        if (this.stack[this.cArrPos].lineJoin !== value) {
            this.currentLineJoin = value;
            this.stack[this.cArrPos].lineJoin = value;
        }
    };
    CVContextData.prototype.miterLimit = function(value) {
        if (this.stack[this.cArrPos].miterLimit !== value) {
            this.currentMiterLimit = value;
            this.stack[this.cArrPos].miterLimit = value;
        }
    };
    CVContextData.prototype.transform = function(props) {
        this.transformMat.cloneFromProps(props); // Taking the last transform value from the stored stack of transforms
        var currentTransform = this.cTr; // Applying the last transform value after the new transform to respect the order of transformations
        this.transformMat.multiply(currentTransform); // Storing the new transformed value in the stored transform
        currentTransform.cloneFromProps(this.transformMat.props);
        var trProps = currentTransform.props; // Applying the new transform to the canvas
        this.nativeContext.setTransform(trProps[0], trProps[1], trProps[4], trProps[5], trProps[12], trProps[13]);
    };
    CVContextData.prototype.opacity = function(op) {
        var currentOpacity = this.stack[this.cArrPos].opacity;
        currentOpacity *= op < 0 ? 0 : op;
        if (this.stack[this.cArrPos].opacity !== currentOpacity) {
            if (this.currentOpacity !== op) {
                this.nativeContext.globalAlpha = op;
                this.currentOpacity = op;
            }
            this.stack[this.cArrPos].opacity = currentOpacity;
        }
    };
    CVContextData.prototype.fill = function(rule) {
        if (this.appliedFillStyle !== this.currentFillStyle) {
            this.appliedFillStyle = this.currentFillStyle;
            this.nativeContext.fillStyle = this.appliedFillStyle;
        }
        this.nativeContext.fill(rule);
    };
    CVContextData.prototype.fillRect = function(x, y, w, h) {
        if (this.appliedFillStyle !== this.currentFillStyle) {
            this.appliedFillStyle = this.currentFillStyle;
            this.nativeContext.fillStyle = this.appliedFillStyle;
        }
        this.nativeContext.fillRect(x, y, w, h);
    };
    CVContextData.prototype.stroke = function() {
        if (this.appliedStrokeStyle !== this.currentStrokeStyle) {
            this.appliedStrokeStyle = this.currentStrokeStyle;
            this.nativeContext.strokeStyle = this.appliedStrokeStyle;
        }
        if (this.appliedLineWidth !== this.currentLineWidth) {
            this.appliedLineWidth = this.currentLineWidth;
            this.nativeContext.lineWidth = this.appliedLineWidth;
        }
        if (this.appliedLineCap !== this.currentLineCap) {
            this.appliedLineCap = this.currentLineCap;
            this.nativeContext.lineCap = this.appliedLineCap;
        }
        if (this.appliedLineJoin !== this.currentLineJoin) {
            this.appliedLineJoin = this.currentLineJoin;
            this.nativeContext.lineJoin = this.appliedLineJoin;
        }
        if (this.appliedMiterLimit !== this.currentMiterLimit) {
            this.appliedMiterLimit = this.currentMiterLimit;
            this.nativeContext.miterLimit = this.appliedMiterLimit;
        }
        this.nativeContext.stroke();
    };
    function CVCompElement(data, globalData, comp) {
        this.completeLayers = false;
        this.layers = data.layers;
        this.pendingElements = [];
        this.elements = createSizedArray(this.layers.length);
        this.initElement(data, globalData, comp);
        this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
            _placeholder: true
        };
    }
    extendPrototype([
        CanvasRendererBase,
        ICompElement,
        CVBaseElement
    ], CVCompElement);
    CVCompElement.prototype.renderInnerContent = function() {
        var ctx = this.canvasContext;
        ctx.beginPath();
        ctx.moveTo(0, 0);
        ctx.lineTo(this.data.w, 0);
        ctx.lineTo(this.data.w, this.data.h);
        ctx.lineTo(0, this.data.h);
        ctx.lineTo(0, 0);
        ctx.clip();
        var i;
        var len = this.layers.length;
        for(i = len - 1; i >= 0; i -= 1)if (this.completeLayers || this.elements[i]) this.elements[i].renderFrame();
    };
    CVCompElement.prototype.destroy = function() {
        var i;
        var len = this.layers.length;
        for(i = len - 1; i >= 0; i -= 1)if (this.elements[i]) this.elements[i].destroy();
        this.layers = null;
        this.elements = null;
    };
    CVCompElement.prototype.createComp = function(data) {
        return new CVCompElement(data, this.globalData, this);
    };
    function CanvasRenderer(animationItem, config) {
        this.animationItem = animationItem;
        this.renderConfig = {
            clearCanvas: config && config.clearCanvas !== undefined ? config.clearCanvas : true,
            context: config && config.context || null,
            progressiveLoad: config && config.progressiveLoad || false,
            preserveAspectRatio: config && config.preserveAspectRatio || 'xMidYMid meet',
            imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
            contentVisibility: config && config.contentVisibility || 'visible',
            className: config && config.className || '',
            id: config && config.id || '',
            runExpressions: !config || config.runExpressions === undefined || config.runExpressions
        };
        this.renderConfig.dpr = config && config.dpr || 1;
        if (this.animationItem.wrapper) this.renderConfig.dpr = config && config.dpr || window.devicePixelRatio || 1;
        this.renderedFrame = -1;
        this.globalData = {
            frameNum: -1,
            _mdf: false,
            renderConfig: this.renderConfig,
            currentGlobalAlpha: -1
        };
        this.contextData = new CVContextData();
        this.elements = [];
        this.pendingElements = [];
        this.transformMat = new Matrix();
        this.completeLayers = false;
        this.rendererType = 'canvas';
        if (this.renderConfig.clearCanvas) {
            this.ctxTransform = this.contextData.transform.bind(this.contextData);
            this.ctxOpacity = this.contextData.opacity.bind(this.contextData);
            this.ctxFillStyle = this.contextData.fillStyle.bind(this.contextData);
            this.ctxStrokeStyle = this.contextData.strokeStyle.bind(this.contextData);
            this.ctxLineWidth = this.contextData.lineWidth.bind(this.contextData);
            this.ctxLineCap = this.contextData.lineCap.bind(this.contextData);
            this.ctxLineJoin = this.contextData.lineJoin.bind(this.contextData);
            this.ctxMiterLimit = this.contextData.miterLimit.bind(this.contextData);
            this.ctxFill = this.contextData.fill.bind(this.contextData);
            this.ctxFillRect = this.contextData.fillRect.bind(this.contextData);
            this.ctxStroke = this.contextData.stroke.bind(this.contextData);
            this.save = this.contextData.save.bind(this.contextData);
        }
    }
    extendPrototype([
        CanvasRendererBase
    ], CanvasRenderer);
    CanvasRenderer.prototype.createComp = function(data) {
        return new CVCompElement(data, this.globalData, this);
    };
    function HBaseElement() {}
    HBaseElement.prototype = {
        checkBlendMode: function checkBlendMode() {},
        initRendererElement: function initRendererElement() {
            this.baseElement = createTag(this.data.tg || 'div');
            if (this.data.hasMask) {
                this.svgElement = createNS('svg');
                this.layerElement = createNS('g');
                this.maskedElement = this.layerElement;
                this.svgElement.appendChild(this.layerElement);
                this.baseElement.appendChild(this.svgElement);
            } else this.layerElement = this.baseElement;
            styleDiv(this.baseElement);
        },
        createContainerElements: function createContainerElements() {
            this.renderableEffectsManager = new CVEffects(this);
            this.transformedElement = this.baseElement;
            this.maskedElement = this.layerElement;
            if (this.data.ln) this.layerElement.setAttribute('id', this.data.ln);
            if (this.data.cl) this.layerElement.setAttribute('class', this.data.cl);
            if (this.data.bm !== 0) this.setBlendMode();
        },
        renderElement: function renderElement() {
            var transformedElementStyle = this.transformedElement ? this.transformedElement.style : {};
            if (this.finalTransform._matMdf) {
                var matrixValue = this.finalTransform.mat.toCSS();
                transformedElementStyle.transform = matrixValue;
                transformedElementStyle.webkitTransform = matrixValue;
            }
            if (this.finalTransform._opMdf) transformedElementStyle.opacity = this.finalTransform.mProp.o.v;
        },
        renderFrame: function renderFrame() {
            // If it is exported as hidden (data.hd === true) no need to render
            // If it is not visible no need to render
            if (this.data.hd || this.hidden) return;
            this.renderTransform();
            this.renderRenderable();
            this.renderElement();
            this.renderInnerContent();
            if (this._isFirstFrame) this._isFirstFrame = false;
        },
        destroy: function destroy() {
            this.layerElement = null;
            this.transformedElement = null;
            if (this.matteElement) this.matteElement = null;
            if (this.maskManager) {
                this.maskManager.destroy();
                this.maskManager = null;
            }
        },
        createRenderableComponents: function createRenderableComponents() {
            this.maskManager = new MaskElement(this.data, this, this.globalData);
        },
        addEffects: function addEffects() {},
        setMatte: function setMatte() {}
    };
    HBaseElement.prototype.getBaseElement = SVGBaseElement.prototype.getBaseElement;
    HBaseElement.prototype.destroyBaseElement = HBaseElement.prototype.destroy;
    HBaseElement.prototype.buildElementParenting = BaseRenderer.prototype.buildElementParenting;
    function HSolidElement(data, globalData, comp) {
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        HBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement
    ], HSolidElement);
    HSolidElement.prototype.createContent = function() {
        var rect;
        if (this.data.hasMask) {
            rect = createNS('rect');
            rect.setAttribute('width', this.data.sw);
            rect.setAttribute('height', this.data.sh);
            rect.setAttribute('fill', this.data.sc);
            this.svgElement.setAttribute('width', this.data.sw);
            this.svgElement.setAttribute('height', this.data.sh);
        } else {
            rect = createTag('div');
            rect.style.width = this.data.sw + 'px';
            rect.style.height = this.data.sh + 'px';
            rect.style.backgroundColor = this.data.sc;
        }
        this.layerElement.appendChild(rect);
    };
    function HShapeElement(data, globalData, comp) {
        // List of drawable elements
        this.shapes = []; // Full shape data
        this.shapesData = data.shapes; // List of styles that will be applied to shapes
        this.stylesList = []; // List of modifiers that will be applied to shapes
        this.shapeModifiers = []; // List of items in shape tree
        this.itemsData = []; // List of items in previous shape tree
        this.processedElements = []; // List of animated components
        this.animatedContents = [];
        this.shapesContainer = createNS('g');
        this.initElement(data, globalData, comp); // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
        // List of elements that have been created
        this.prevViewData = [];
        this.currentBBox = {
            x: 999999,
            y: -999999,
            h: 0,
            w: 0
        };
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        HSolidElement,
        SVGShapeElement,
        HBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], HShapeElement);
    HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderInnerContent;
    HShapeElement.prototype.createContent = function() {
        var cont;
        this.baseElement.style.fontSize = 0;
        if (this.data.hasMask) {
            this.layerElement.appendChild(this.shapesContainer);
            cont = this.svgElement;
        } else {
            cont = createNS('svg');
            var size = this.comp.data ? this.comp.data : this.globalData.compSize;
            cont.setAttribute('width', size.w);
            cont.setAttribute('height', size.h);
            cont.appendChild(this.shapesContainer);
            this.layerElement.appendChild(cont);
        }
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.shapesContainer, 0, [], true);
        this.filterUniqueShapes();
        this.shapeCont = cont;
    };
    HShapeElement.prototype.getTransformedPoint = function(transformers, point) {
        var i;
        var len = transformers.length;
        for(i = 0; i < len; i += 1)point = transformers[i].mProps.v.applyToPointArray(point[0], point[1], 0);
        return point;
    };
    HShapeElement.prototype.calculateShapeBoundingBox = function(item, boundingBox) {
        var shape = item.sh.v;
        var transformers = item.transformers;
        var i;
        var len = shape._length;
        var vPoint;
        var oPoint;
        var nextIPoint;
        var nextVPoint;
        if (len <= 1) return;
        for(i = 0; i < len - 1; i += 1){
            vPoint = this.getTransformedPoint(transformers, shape.v[i]);
            oPoint = this.getTransformedPoint(transformers, shape.o[i]);
            nextIPoint = this.getTransformedPoint(transformers, shape.i[i + 1]);
            nextVPoint = this.getTransformedPoint(transformers, shape.v[i + 1]);
            this.checkBounds(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox);
        }
        if (shape.c) {
            vPoint = this.getTransformedPoint(transformers, shape.v[i]);
            oPoint = this.getTransformedPoint(transformers, shape.o[i]);
            nextIPoint = this.getTransformedPoint(transformers, shape.i[0]);
            nextVPoint = this.getTransformedPoint(transformers, shape.v[0]);
            this.checkBounds(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox);
        }
    };
    HShapeElement.prototype.checkBounds = function(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox) {
        this.getBoundsOfCurve(vPoint, oPoint, nextIPoint, nextVPoint);
        var bounds = this.shapeBoundingBox;
        boundingBox.x = bmMin(bounds.left, boundingBox.x);
        boundingBox.xMax = bmMax(bounds.right, boundingBox.xMax);
        boundingBox.y = bmMin(bounds.top, boundingBox.y);
        boundingBox.yMax = bmMax(bounds.bottom, boundingBox.yMax);
    };
    HShapeElement.prototype.shapeBoundingBox = {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
    };
    HShapeElement.prototype.tempBoundingBox = {
        x: 0,
        xMax: 0,
        y: 0,
        yMax: 0,
        width: 0,
        height: 0
    };
    HShapeElement.prototype.getBoundsOfCurve = function(p0, p1, p2, p3) {
        var bounds = [
            [
                p0[0],
                p3[0]
            ],
            [
                p0[1],
                p3[1]
            ]
        ];
        for(var a, b, c, t, b2ac, t1, t2, i = 0; i < 2; ++i){
            // eslint-disable-line no-plusplus
            b = 6 * p0[i] - 12 * p1[i] + 6 * p2[i];
            a = -3 * p0[i] + 9 * p1[i] - 9 * p2[i] + 3 * p3[i];
            c = 3 * p1[i] - 3 * p0[i];
            b |= 0; // eslint-disable-line no-bitwise
            a |= 0; // eslint-disable-line no-bitwise
            c |= 0; // eslint-disable-line no-bitwise
            if (a === 0 && b === 0) ;
            else if (a === 0) {
                t = -c / b;
                if (t > 0 && t < 1) bounds[i].push(this.calculateF(t, p0, p1, p2, p3, i));
            } else {
                b2ac = b * b - 4 * c * a;
                if (b2ac >= 0) {
                    t1 = (-b + bmSqrt(b2ac)) / (2 * a);
                    if (t1 > 0 && t1 < 1) bounds[i].push(this.calculateF(t1, p0, p1, p2, p3, i));
                    t2 = (-b - bmSqrt(b2ac)) / (2 * a);
                    if (t2 > 0 && t2 < 1) bounds[i].push(this.calculateF(t2, p0, p1, p2, p3, i));
                }
            }
        }
        this.shapeBoundingBox.left = bmMin.apply(null, bounds[0]);
        this.shapeBoundingBox.top = bmMin.apply(null, bounds[1]);
        this.shapeBoundingBox.right = bmMax.apply(null, bounds[0]);
        this.shapeBoundingBox.bottom = bmMax.apply(null, bounds[1]);
    };
    HShapeElement.prototype.calculateF = function(t, p0, p1, p2, p3, i) {
        return bmPow(1 - t, 3) * p0[i] + 3 * bmPow(1 - t, 2) * t * p1[i] + 3 * (1 - t) * bmPow(t, 2) * p2[i] + bmPow(t, 3) * p3[i];
    };
    HShapeElement.prototype.calculateBoundingBox = function(itemsData, boundingBox) {
        var i;
        var len = itemsData.length;
        for(i = 0; i < len; i += 1){
            if (itemsData[i] && itemsData[i].sh) this.calculateShapeBoundingBox(itemsData[i], boundingBox);
            else if (itemsData[i] && itemsData[i].it) this.calculateBoundingBox(itemsData[i].it, boundingBox);
            else if (itemsData[i] && itemsData[i].style && itemsData[i].w) this.expandStrokeBoundingBox(itemsData[i].w, boundingBox);
        }
    };
    HShapeElement.prototype.expandStrokeBoundingBox = function(widthProperty, boundingBox) {
        var width = 0;
        if (widthProperty.keyframes) {
            for(var i = 0; i < widthProperty.keyframes.length; i += 1){
                var kfw = widthProperty.keyframes[i].s;
                if (kfw > width) width = kfw;
            }
            width *= widthProperty.mult;
        } else width = widthProperty.v * widthProperty.mult;
        boundingBox.x -= width;
        boundingBox.xMax += width;
        boundingBox.y -= width;
        boundingBox.yMax += width;
    };
    HShapeElement.prototype.currentBoxContains = function(box) {
        return this.currentBBox.x <= box.x && this.currentBBox.y <= box.y && this.currentBBox.width + this.currentBBox.x >= box.x + box.width && this.currentBBox.height + this.currentBBox.y >= box.y + box.height;
    };
    HShapeElement.prototype.renderInnerContent = function() {
        this._renderShapeFrame();
        if (!this.hidden && (this._isFirstFrame || this._mdf)) {
            var tempBoundingBox = this.tempBoundingBox;
            var max = 999999;
            tempBoundingBox.x = max;
            tempBoundingBox.xMax = -max;
            tempBoundingBox.y = max;
            tempBoundingBox.yMax = -max;
            this.calculateBoundingBox(this.itemsData, tempBoundingBox);
            tempBoundingBox.width = tempBoundingBox.xMax < tempBoundingBox.x ? 0 : tempBoundingBox.xMax - tempBoundingBox.x;
            tempBoundingBox.height = tempBoundingBox.yMax < tempBoundingBox.y ? 0 : tempBoundingBox.yMax - tempBoundingBox.y; // var tempBoundingBox = this.shapeCont.getBBox();
            if (this.currentBoxContains(tempBoundingBox)) return;
            var changed = false;
            if (this.currentBBox.w !== tempBoundingBox.width) {
                this.currentBBox.w = tempBoundingBox.width;
                this.shapeCont.setAttribute('width', tempBoundingBox.width);
                changed = true;
            }
            if (this.currentBBox.h !== tempBoundingBox.height) {
                this.currentBBox.h = tempBoundingBox.height;
                this.shapeCont.setAttribute('height', tempBoundingBox.height);
                changed = true;
            }
            if (changed || this.currentBBox.x !== tempBoundingBox.x || this.currentBBox.y !== tempBoundingBox.y) {
                this.currentBBox.w = tempBoundingBox.width;
                this.currentBBox.h = tempBoundingBox.height;
                this.currentBBox.x = tempBoundingBox.x;
                this.currentBBox.y = tempBoundingBox.y;
                this.shapeCont.setAttribute('viewBox', this.currentBBox.x + ' ' + this.currentBBox.y + ' ' + this.currentBBox.w + ' ' + this.currentBBox.h);
                var shapeStyle = this.shapeCont.style;
                var shapeTransform = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
                shapeStyle.transform = shapeTransform;
                shapeStyle.webkitTransform = shapeTransform;
            }
        }
    };
    function HTextElement(data, globalData, comp) {
        this.textSpans = [];
        this.textPaths = [];
        this.currentBBox = {
            x: 999999,
            y: -999999,
            h: 0,
            w: 0
        };
        this.renderType = 'svg';
        this.isMasked = false;
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        HBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement,
        ITextElement
    ], HTextElement);
    HTextElement.prototype.createContent = function() {
        this.isMasked = this.checkMasks();
        if (this.isMasked) {
            this.renderType = 'svg';
            this.compW = this.comp.data.w;
            this.compH = this.comp.data.h;
            this.svgElement.setAttribute('width', this.compW);
            this.svgElement.setAttribute('height', this.compH);
            var g = createNS('g');
            this.maskedElement.appendChild(g);
            this.innerElem = g;
        } else {
            this.renderType = 'html';
            this.innerElem = this.layerElement;
        }
        this.checkParenting();
    };
    HTextElement.prototype.buildNewText = function() {
        var documentData = this.textProperty.currentData;
        this.renderedLetters = createSizedArray(documentData.l ? documentData.l.length : 0);
        var innerElemStyle = this.innerElem.style;
        var textColor = documentData.fc ? this.buildColor(documentData.fc) : 'rgba(0,0,0,0)';
        innerElemStyle.fill = textColor;
        innerElemStyle.color = textColor;
        if (documentData.sc) {
            innerElemStyle.stroke = this.buildColor(documentData.sc);
            innerElemStyle.strokeWidth = documentData.sw + 'px';
        }
        var fontData = this.globalData.fontManager.getFontByName(documentData.f);
        if (!this.globalData.fontManager.chars) {
            innerElemStyle.fontSize = documentData.finalSize + 'px';
            innerElemStyle.lineHeight = documentData.finalSize + 'px';
            if (fontData.fClass) this.innerElem.className = fontData.fClass;
            else {
                innerElemStyle.fontFamily = fontData.fFamily;
                var fWeight = documentData.fWeight;
                var fStyle = documentData.fStyle;
                innerElemStyle.fontStyle = fStyle;
                innerElemStyle.fontWeight = fWeight;
            }
        }
        var i;
        var len;
        var letters = documentData.l;
        len = letters.length;
        var tSpan;
        var tParent;
        var tCont;
        var matrixHelper = this.mHelper;
        var shapes;
        var shapeStr = '';
        var cnt = 0;
        for(i = 0; i < len; i += 1){
            if (this.globalData.fontManager.chars) {
                if (!this.textPaths[cnt]) {
                    tSpan = createNS('path');
                    tSpan.setAttribute('stroke-linecap', lineCapEnum[1]);
                    tSpan.setAttribute('stroke-linejoin', lineJoinEnum[2]);
                    tSpan.setAttribute('stroke-miterlimit', '4');
                } else tSpan = this.textPaths[cnt];
                if (!this.isMasked) {
                    if (this.textSpans[cnt]) {
                        tParent = this.textSpans[cnt];
                        tCont = tParent.children[0];
                    } else {
                        tParent = createTag('div');
                        tParent.style.lineHeight = 0;
                        tCont = createNS('svg');
                        tCont.appendChild(tSpan);
                        styleDiv(tParent);
                    }
                }
            } else if (!this.isMasked) {
                if (this.textSpans[cnt]) {
                    tParent = this.textSpans[cnt];
                    tSpan = this.textPaths[cnt];
                } else {
                    tParent = createTag('span');
                    styleDiv(tParent);
                    tSpan = createTag('span');
                    styleDiv(tSpan);
                    tParent.appendChild(tSpan);
                }
            } else tSpan = this.textPaths[cnt] ? this.textPaths[cnt] : createNS('text');
             // tSpan.setAttribute('visibility', 'hidden');
            if (this.globalData.fontManager.chars) {
                var charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
                var shapeData;
                if (charData) shapeData = charData.data;
                else shapeData = null;
                matrixHelper.reset();
                if (shapeData && shapeData.shapes && shapeData.shapes.length) {
                    shapes = shapeData.shapes[0].it;
                    matrixHelper.scale(documentData.finalSize / 100, documentData.finalSize / 100);
                    shapeStr = this.createPathShape(matrixHelper, shapes);
                    tSpan.setAttribute('d', shapeStr);
                }
                if (!this.isMasked) {
                    this.innerElem.appendChild(tParent);
                    if (shapeData && shapeData.shapes) {
                        // document.body.appendChild is needed to get exact measure of shape
                        document.body.appendChild(tCont);
                        var boundingBox = tCont.getBBox();
                        tCont.setAttribute('width', boundingBox.width + 2);
                        tCont.setAttribute('height', boundingBox.height + 2);
                        tCont.setAttribute('viewBox', boundingBox.x - 1 + ' ' + (boundingBox.y - 1) + ' ' + (boundingBox.width + 2) + ' ' + (boundingBox.height + 2));
                        var tContStyle = tCont.style;
                        var tContTranslation = 'translate(' + (boundingBox.x - 1) + 'px,' + (boundingBox.y - 1) + 'px)';
                        tContStyle.transform = tContTranslation;
                        tContStyle.webkitTransform = tContTranslation;
                        letters[i].yOffset = boundingBox.y - 1;
                    } else {
                        tCont.setAttribute('width', 1);
                        tCont.setAttribute('height', 1);
                    }
                    tParent.appendChild(tCont);
                } else this.innerElem.appendChild(tSpan);
            } else {
                tSpan.textContent = letters[i].val;
                tSpan.setAttributeNS('http://www.w3.org/XML/1998/namespace', 'xml:space', 'preserve');
                if (!this.isMasked) {
                    this.innerElem.appendChild(tParent); //
                    var tStyle = tSpan.style;
                    var tSpanTranslation = 'translate3d(0,' + -documentData.finalSize / 1.2 + 'px,0)';
                    tStyle.transform = tSpanTranslation;
                    tStyle.webkitTransform = tSpanTranslation;
                } else this.innerElem.appendChild(tSpan);
            } //
            if (!this.isMasked) this.textSpans[cnt] = tParent;
            else this.textSpans[cnt] = tSpan;
            this.textSpans[cnt].style.display = 'block';
            this.textPaths[cnt] = tSpan;
            cnt += 1;
        }
        while(cnt < this.textSpans.length){
            this.textSpans[cnt].style.display = 'none';
            cnt += 1;
        }
    };
    HTextElement.prototype.renderInnerContent = function() {
        this.validateText();
        var svgStyle;
        if (this.data.singleShape) {
            if (!this._isFirstFrame && !this.lettersChangedFlag) return;
            if (this.isMasked && this.finalTransform._matMdf) {
                // Todo Benchmark if using this is better than getBBox
                this.svgElement.setAttribute('viewBox', -this.finalTransform.mProp.p.v[0] + ' ' + -this.finalTransform.mProp.p.v[1] + ' ' + this.compW + ' ' + this.compH);
                svgStyle = this.svgElement.style;
                var translation = 'translate(' + -this.finalTransform.mProp.p.v[0] + 'px,' + -this.finalTransform.mProp.p.v[1] + 'px)';
                svgStyle.transform = translation;
                svgStyle.webkitTransform = translation;
            }
        }
        this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
        if (!this.lettersChangedFlag && !this.textAnimator.lettersChangedFlag) return;
        var i;
        var len;
        var count = 0;
        var renderedLetters = this.textAnimator.renderedLetters;
        var letters = this.textProperty.currentData.l;
        len = letters.length;
        var renderedLetter;
        var textSpan;
        var textPath;
        for(i = 0; i < len; i += 1)if (letters[i].n) count += 1;
        else {
            textSpan = this.textSpans[i];
            textPath = this.textPaths[i];
            renderedLetter = renderedLetters[count];
            count += 1;
            if (renderedLetter._mdf.m) {
                if (!this.isMasked) {
                    textSpan.style.webkitTransform = renderedLetter.m;
                    textSpan.style.transform = renderedLetter.m;
                } else textSpan.setAttribute('transform', renderedLetter.m);
            } /// /textSpan.setAttribute('opacity',renderedLetter.o);
            textSpan.style.opacity = renderedLetter.o;
            if (renderedLetter.sw && renderedLetter._mdf.sw) textPath.setAttribute('stroke-width', renderedLetter.sw);
            if (renderedLetter.sc && renderedLetter._mdf.sc) textPath.setAttribute('stroke', renderedLetter.sc);
            if (renderedLetter.fc && renderedLetter._mdf.fc) {
                textPath.setAttribute('fill', renderedLetter.fc);
                textPath.style.color = renderedLetter.fc;
            }
        }
        if (this.innerElem.getBBox && !this.hidden && (this._isFirstFrame || this._mdf)) {
            var boundingBox = this.innerElem.getBBox();
            if (this.currentBBox.w !== boundingBox.width) {
                this.currentBBox.w = boundingBox.width;
                this.svgElement.setAttribute('width', boundingBox.width);
            }
            if (this.currentBBox.h !== boundingBox.height) {
                this.currentBBox.h = boundingBox.height;
                this.svgElement.setAttribute('height', boundingBox.height);
            }
            var margin = 1;
            if (this.currentBBox.w !== boundingBox.width + margin * 2 || this.currentBBox.h !== boundingBox.height + margin * 2 || this.currentBBox.x !== boundingBox.x - margin || this.currentBBox.y !== boundingBox.y - margin) {
                this.currentBBox.w = boundingBox.width + margin * 2;
                this.currentBBox.h = boundingBox.height + margin * 2;
                this.currentBBox.x = boundingBox.x - margin;
                this.currentBBox.y = boundingBox.y - margin;
                this.svgElement.setAttribute('viewBox', this.currentBBox.x + ' ' + this.currentBBox.y + ' ' + this.currentBBox.w + ' ' + this.currentBBox.h);
                svgStyle = this.svgElement.style;
                var svgTransform = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
                svgStyle.transform = svgTransform;
                svgStyle.webkitTransform = svgTransform;
            }
        }
    };
    function HCameraElement(data, globalData, comp) {
        this.initFrame();
        this.initBaseData(data, globalData, comp);
        this.initHierarchy();
        var getProp = PropertyFactory.getProp;
        this.pe = getProp(this, data.pe, 0, 0, this);
        if (data.ks.p.s) {
            this.px = getProp(this, data.ks.p.x, 1, 0, this);
            this.py = getProp(this, data.ks.p.y, 1, 0, this);
            this.pz = getProp(this, data.ks.p.z, 1, 0, this);
        } else this.p = getProp(this, data.ks.p, 1, 0, this);
        if (data.ks.a) this.a = getProp(this, data.ks.a, 1, 0, this);
        if (data.ks.or.k.length && data.ks.or.k[0].to) {
            var i;
            var len = data.ks.or.k.length;
            for(i = 0; i < len; i += 1){
                data.ks.or.k[i].to = null;
                data.ks.or.k[i].ti = null;
            }
        }
        this.or = getProp(this, data.ks.or, 1, degToRads, this);
        this.or.sh = true;
        this.rx = getProp(this, data.ks.rx, 0, degToRads, this);
        this.ry = getProp(this, data.ks.ry, 0, degToRads, this);
        this.rz = getProp(this, data.ks.rz, 0, degToRads, this);
        this.mat = new Matrix();
        this._prevMat = new Matrix();
        this._isFirstFrame = true; // TODO: find a better way to make the HCamera element to be compatible with the LayerInterface and TransformInterface.
        this.finalTransform = {
            mProp: this
        };
    }
    extendPrototype([
        BaseElement,
        FrameElement,
        HierarchyElement
    ], HCameraElement);
    HCameraElement.prototype.setup = function() {
        var i;
        var len = this.comp.threeDElements.length;
        var comp;
        var perspectiveStyle;
        var containerStyle;
        for(i = 0; i < len; i += 1){
            // [perspectiveElem,container]
            comp = this.comp.threeDElements[i];
            if (comp.type === '3d') {
                perspectiveStyle = comp.perspectiveElem.style;
                containerStyle = comp.container.style;
                var perspective = this.pe.v + 'px';
                var origin = '0px 0px 0px';
                var matrix = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
                perspectiveStyle.perspective = perspective;
                perspectiveStyle.webkitPerspective = perspective;
                containerStyle.transformOrigin = origin;
                containerStyle.mozTransformOrigin = origin;
                containerStyle.webkitTransformOrigin = origin;
                perspectiveStyle.transform = matrix;
                perspectiveStyle.webkitTransform = matrix;
            }
        }
    };
    HCameraElement.prototype.createElements = function() {};
    HCameraElement.prototype.hide = function() {};
    HCameraElement.prototype.renderFrame = function() {
        var _mdf = this._isFirstFrame;
        var i;
        var len;
        if (this.hierarchy) {
            len = this.hierarchy.length;
            for(i = 0; i < len; i += 1)_mdf = this.hierarchy[i].finalTransform.mProp._mdf || _mdf;
        }
        if (_mdf || this.pe._mdf || this.p && this.p._mdf || this.px && (this.px._mdf || this.py._mdf || this.pz._mdf) || this.rx._mdf || this.ry._mdf || this.rz._mdf || this.or._mdf || this.a && this.a._mdf) {
            this.mat.reset();
            if (this.hierarchy) {
                len = this.hierarchy.length - 1;
                for(i = len; i >= 0; i -= 1){
                    var mTransf = this.hierarchy[i].finalTransform.mProp;
                    this.mat.translate(-mTransf.p.v[0], -mTransf.p.v[1], mTransf.p.v[2]);
                    this.mat.rotateX(-mTransf.or.v[0]).rotateY(-mTransf.or.v[1]).rotateZ(mTransf.or.v[2]);
                    this.mat.rotateX(-mTransf.rx.v).rotateY(-mTransf.ry.v).rotateZ(mTransf.rz.v);
                    this.mat.scale(1 / mTransf.s.v[0], 1 / mTransf.s.v[1], 1 / mTransf.s.v[2]);
                    this.mat.translate(mTransf.a.v[0], mTransf.a.v[1], mTransf.a.v[2]);
                }
            }
            if (this.p) this.mat.translate(-this.p.v[0], -this.p.v[1], this.p.v[2]);
            else this.mat.translate(-this.px.v, -this.py.v, this.pz.v);
            if (this.a) {
                var diffVector;
                if (this.p) diffVector = [
                    this.p.v[0] - this.a.v[0],
                    this.p.v[1] - this.a.v[1],
                    this.p.v[2] - this.a.v[2]
                ];
                else diffVector = [
                    this.px.v - this.a.v[0],
                    this.py.v - this.a.v[1],
                    this.pz.v - this.a.v[2]
                ];
                var mag = Math.sqrt(Math.pow(diffVector[0], 2) + Math.pow(diffVector[1], 2) + Math.pow(diffVector[2], 2)); // var lookDir = getNormalizedPoint(getDiffVector(this.a.v,this.p.v));
                var lookDir = [
                    diffVector[0] / mag,
                    diffVector[1] / mag,
                    diffVector[2] / mag
                ];
                var lookLengthOnXZ = Math.sqrt(lookDir[2] * lookDir[2] + lookDir[0] * lookDir[0]);
                var mRotationX = Math.atan2(lookDir[1], lookLengthOnXZ);
                var mRotationY = Math.atan2(lookDir[0], -lookDir[2]);
                this.mat.rotateY(mRotationY).rotateX(-mRotationX);
            }
            this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v);
            this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]);
            this.mat.translate(this.globalData.compSize.w / 2, this.globalData.compSize.h / 2, 0);
            this.mat.translate(0, 0, this.pe.v);
            var hasMatrixChanged = !this._prevMat.equals(this.mat);
            if ((hasMatrixChanged || this.pe._mdf) && this.comp.threeDElements) {
                len = this.comp.threeDElements.length;
                var comp;
                var perspectiveStyle;
                var containerStyle;
                for(i = 0; i < len; i += 1){
                    comp = this.comp.threeDElements[i];
                    if (comp.type === '3d') {
                        if (hasMatrixChanged) {
                            var matValue = this.mat.toCSS();
                            containerStyle = comp.container.style;
                            containerStyle.transform = matValue;
                            containerStyle.webkitTransform = matValue;
                        }
                        if (this.pe._mdf) {
                            perspectiveStyle = comp.perspectiveElem.style;
                            perspectiveStyle.perspective = this.pe.v + 'px';
                            perspectiveStyle.webkitPerspective = this.pe.v + 'px';
                        }
                    }
                }
                this.mat.clone(this._prevMat);
            }
        }
        this._isFirstFrame = false;
    };
    HCameraElement.prototype.prepareFrame = function(num) {
        this.prepareProperties(num, true);
    };
    HCameraElement.prototype.destroy = function() {};
    HCameraElement.prototype.getBaseElement = function() {
        return null;
    };
    function HImageElement(data, globalData, comp) {
        this.assetData = globalData.getAssetData(data.refId);
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        HBaseElement,
        HSolidElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], HImageElement);
    HImageElement.prototype.createContent = function() {
        var assetPath = this.globalData.getAssetsPath(this.assetData);
        var img = new Image();
        if (this.data.hasMask) {
            this.imageElem = createNS('image');
            this.imageElem.setAttribute('width', this.assetData.w + 'px');
            this.imageElem.setAttribute('height', this.assetData.h + 'px');
            this.imageElem.setAttributeNS('http://www.w3.org/1999/xlink', 'href', assetPath);
            this.layerElement.appendChild(this.imageElem);
            this.baseElement.setAttribute('width', this.assetData.w);
            this.baseElement.setAttribute('height', this.assetData.h);
        } else this.layerElement.appendChild(img);
        img.crossOrigin = 'anonymous';
        img.src = assetPath;
        if (this.data.ln) this.baseElement.setAttribute('id', this.data.ln);
    };
    function HybridRendererBase(animationItem, config) {
        this.animationItem = animationItem;
        this.layers = null;
        this.renderedFrame = -1;
        this.renderConfig = {
            className: config && config.className || '',
            imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
            hideOnTransparent: !(config && config.hideOnTransparent === false),
            filterSize: {
                width: config && config.filterSize && config.filterSize.width || '400%',
                height: config && config.filterSize && config.filterSize.height || '400%',
                x: config && config.filterSize && config.filterSize.x || '-100%',
                y: config && config.filterSize && config.filterSize.y || '-100%'
            }
        };
        this.globalData = {
            _mdf: false,
            frameNum: -1,
            renderConfig: this.renderConfig
        };
        this.pendingElements = [];
        this.elements = [];
        this.threeDElements = [];
        this.destroyed = false;
        this.camera = null;
        this.supports3d = true;
        this.rendererType = 'html';
    }
    extendPrototype([
        BaseRenderer
    ], HybridRendererBase);
    HybridRendererBase.prototype.buildItem = SVGRenderer.prototype.buildItem;
    HybridRendererBase.prototype.checkPendingElements = function() {
        while(this.pendingElements.length){
            var element = this.pendingElements.pop();
            element.checkParenting();
        }
    };
    HybridRendererBase.prototype.appendElementInPos = function(element, pos) {
        var newDOMElement = element.getBaseElement();
        if (!newDOMElement) return;
        var layer = this.layers[pos];
        if (!layer.ddd || !this.supports3d) {
            if (this.threeDElements) this.addTo3dContainer(newDOMElement, pos);
            else {
                var i = 0;
                var nextDOMElement;
                var nextLayer;
                var tmpDOMElement;
                while(i < pos){
                    if (this.elements[i] && this.elements[i] !== true && this.elements[i].getBaseElement) {
                        nextLayer = this.elements[i];
                        tmpDOMElement = this.layers[i].ddd ? this.getThreeDContainerByPos(i) : nextLayer.getBaseElement();
                        nextDOMElement = tmpDOMElement || nextDOMElement;
                    }
                    i += 1;
                }
                if (nextDOMElement) {
                    if (!layer.ddd || !this.supports3d) this.layerElement.insertBefore(newDOMElement, nextDOMElement);
                } else if (!layer.ddd || !this.supports3d) this.layerElement.appendChild(newDOMElement);
            }
        } else this.addTo3dContainer(newDOMElement, pos);
    };
    HybridRendererBase.prototype.createShape = function(data) {
        if (!this.supports3d) return new SVGShapeElement(data, this.globalData, this);
        return new HShapeElement(data, this.globalData, this);
    };
    HybridRendererBase.prototype.createText = function(data) {
        if (!this.supports3d) return new SVGTextLottieElement(data, this.globalData, this);
        return new HTextElement(data, this.globalData, this);
    };
    HybridRendererBase.prototype.createCamera = function(data) {
        this.camera = new HCameraElement(data, this.globalData, this);
        return this.camera;
    };
    HybridRendererBase.prototype.createImage = function(data) {
        if (!this.supports3d) return new IImageElement(data, this.globalData, this);
        return new HImageElement(data, this.globalData, this);
    };
    HybridRendererBase.prototype.createSolid = function(data) {
        if (!this.supports3d) return new ISolidElement(data, this.globalData, this);
        return new HSolidElement(data, this.globalData, this);
    };
    HybridRendererBase.prototype.createNull = SVGRenderer.prototype.createNull;
    HybridRendererBase.prototype.getThreeDContainerByPos = function(pos) {
        var i = 0;
        var len = this.threeDElements.length;
        while(i < len){
            if (this.threeDElements[i].startPos <= pos && this.threeDElements[i].endPos >= pos) return this.threeDElements[i].perspectiveElem;
            i += 1;
        }
        return null;
    };
    HybridRendererBase.prototype.createThreeDContainer = function(pos, type) {
        var perspectiveElem = createTag('div');
        var style;
        var containerStyle;
        styleDiv(perspectiveElem);
        var container = createTag('div');
        styleDiv(container);
        if (type === '3d') {
            style = perspectiveElem.style;
            style.width = this.globalData.compSize.w + 'px';
            style.height = this.globalData.compSize.h + 'px';
            var center = '50% 50%';
            style.webkitTransformOrigin = center;
            style.mozTransformOrigin = center;
            style.transformOrigin = center;
            containerStyle = container.style;
            var matrix = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
            containerStyle.transform = matrix;
            containerStyle.webkitTransform = matrix;
        }
        perspectiveElem.appendChild(container); // this.resizerElem.appendChild(perspectiveElem);
        var threeDContainerData = {
            container: container,
            perspectiveElem: perspectiveElem,
            startPos: pos,
            endPos: pos,
            type: type
        };
        this.threeDElements.push(threeDContainerData);
        return threeDContainerData;
    };
    HybridRendererBase.prototype.build3dContainers = function() {
        var i;
        var len = this.layers.length;
        var lastThreeDContainerData;
        var currentContainer = '';
        for(i = 0; i < len; i += 1)if (this.layers[i].ddd && this.layers[i].ty !== 3) {
            if (currentContainer !== '3d') {
                currentContainer = '3d';
                lastThreeDContainerData = this.createThreeDContainer(i, '3d');
            }
            lastThreeDContainerData.endPos = Math.max(lastThreeDContainerData.endPos, i);
        } else {
            if (currentContainer !== '2d') {
                currentContainer = '2d';
                lastThreeDContainerData = this.createThreeDContainer(i, '2d');
            }
            lastThreeDContainerData.endPos = Math.max(lastThreeDContainerData.endPos, i);
        }
        len = this.threeDElements.length;
        for(i = len - 1; i >= 0; i -= 1)this.resizerElem.appendChild(this.threeDElements[i].perspectiveElem);
    };
    HybridRendererBase.prototype.addTo3dContainer = function(elem, pos) {
        var i = 0;
        var len = this.threeDElements.length;
        while(i < len){
            if (pos <= this.threeDElements[i].endPos) {
                var j = this.threeDElements[i].startPos;
                var nextElement;
                while(j < pos){
                    if (this.elements[j] && this.elements[j].getBaseElement) nextElement = this.elements[j].getBaseElement();
                    j += 1;
                }
                if (nextElement) this.threeDElements[i].container.insertBefore(elem, nextElement);
                else this.threeDElements[i].container.appendChild(elem);
                break;
            }
            i += 1;
        }
    };
    HybridRendererBase.prototype.configAnimation = function(animData) {
        var resizerElem = createTag('div');
        var wrapper = this.animationItem.wrapper;
        var style = resizerElem.style;
        style.width = animData.w + 'px';
        style.height = animData.h + 'px';
        this.resizerElem = resizerElem;
        styleDiv(resizerElem);
        style.transformStyle = 'flat';
        style.mozTransformStyle = 'flat';
        style.webkitTransformStyle = 'flat';
        if (this.renderConfig.className) resizerElem.setAttribute('class', this.renderConfig.className);
        wrapper.appendChild(resizerElem);
        style.overflow = 'hidden';
        var svg = createNS('svg');
        svg.setAttribute('width', '1');
        svg.setAttribute('height', '1');
        styleDiv(svg);
        this.resizerElem.appendChild(svg);
        var defs = createNS('defs');
        svg.appendChild(defs);
        this.data = animData; // Mask animation
        this.setupGlobalData(animData, svg);
        this.globalData.defs = defs;
        this.layers = animData.layers;
        this.layerElement = this.resizerElem;
        this.build3dContainers();
        this.updateContainerSize();
    };
    HybridRendererBase.prototype.destroy = function() {
        if (this.animationItem.wrapper) this.animationItem.wrapper.innerText = '';
        this.animationItem.container = null;
        this.globalData.defs = null;
        var i;
        var len = this.layers ? this.layers.length : 0;
        for(i = 0; i < len; i += 1)if (this.elements[i] && this.elements[i].destroy) this.elements[i].destroy();
        this.elements.length = 0;
        this.destroyed = true;
        this.animationItem = null;
    };
    HybridRendererBase.prototype.updateContainerSize = function() {
        var elementWidth = this.animationItem.wrapper.offsetWidth;
        var elementHeight = this.animationItem.wrapper.offsetHeight;
        var elementRel = elementWidth / elementHeight;
        var animationRel = this.globalData.compSize.w / this.globalData.compSize.h;
        var sx;
        var sy;
        var tx;
        var ty;
        if (animationRel > elementRel) {
            sx = elementWidth / this.globalData.compSize.w;
            sy = elementWidth / this.globalData.compSize.w;
            tx = 0;
            ty = (elementHeight - this.globalData.compSize.h * (elementWidth / this.globalData.compSize.w)) / 2;
        } else {
            sx = elementHeight / this.globalData.compSize.h;
            sy = elementHeight / this.globalData.compSize.h;
            tx = (elementWidth - this.globalData.compSize.w * (elementHeight / this.globalData.compSize.h)) / 2;
            ty = 0;
        }
        var style = this.resizerElem.style;
        style.webkitTransform = 'matrix3d(' + sx + ',0,0,0,0,' + sy + ',0,0,0,0,1,0,' + tx + ',' + ty + ',0,1)';
        style.transform = style.webkitTransform;
    };
    HybridRendererBase.prototype.renderFrame = SVGRenderer.prototype.renderFrame;
    HybridRendererBase.prototype.hide = function() {
        this.resizerElem.style.display = 'none';
    };
    HybridRendererBase.prototype.show = function() {
        this.resizerElem.style.display = 'block';
    };
    HybridRendererBase.prototype.initItems = function() {
        this.buildAllItems();
        if (this.camera) this.camera.setup();
        else {
            var cWidth = this.globalData.compSize.w;
            var cHeight = this.globalData.compSize.h;
            var i;
            var len = this.threeDElements.length;
            for(i = 0; i < len; i += 1){
                var style = this.threeDElements[i].perspectiveElem.style;
                style.webkitPerspective = Math.sqrt(Math.pow(cWidth, 2) + Math.pow(cHeight, 2)) + 'px';
                style.perspective = style.webkitPerspective;
            }
        }
    };
    HybridRendererBase.prototype.searchExtraCompositions = function(assets) {
        var i;
        var len = assets.length;
        var floatingContainer = createTag('div');
        for(i = 0; i < len; i += 1)if (assets[i].xt) {
            var comp = this.createComp(assets[i], floatingContainer, this.globalData.comp, null);
            comp.initExpressions();
            this.globalData.projectInterface.registerComposition(comp);
        }
    };
    function HCompElement(data, globalData, comp) {
        this.layers = data.layers;
        this.supports3d = !data.hasMask;
        this.completeLayers = false;
        this.pendingElements = [];
        this.elements = this.layers ? createSizedArray(this.layers.length) : [];
        this.initElement(data, globalData, comp);
        this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
            _placeholder: true
        };
    }
    extendPrototype([
        HybridRendererBase,
        ICompElement,
        HBaseElement
    ], HCompElement);
    HCompElement.prototype._createBaseContainerElements = HCompElement.prototype.createContainerElements;
    HCompElement.prototype.createContainerElements = function() {
        this._createBaseContainerElements(); // divElement.style.clip = 'rect(0px, '+this.data.w+'px, '+this.data.h+'px, 0px)';
        if (this.data.hasMask) {
            this.svgElement.setAttribute('width', this.data.w);
            this.svgElement.setAttribute('height', this.data.h);
            this.transformedElement = this.baseElement;
        } else this.transformedElement = this.layerElement;
    };
    HCompElement.prototype.addTo3dContainer = function(elem, pos) {
        var j = 0;
        var nextElement;
        while(j < pos){
            if (this.elements[j] && this.elements[j].getBaseElement) nextElement = this.elements[j].getBaseElement();
            j += 1;
        }
        if (nextElement) this.layerElement.insertBefore(elem, nextElement);
        else this.layerElement.appendChild(elem);
    };
    HCompElement.prototype.createComp = function(data) {
        if (!this.supports3d) return new SVGCompElement(data, this.globalData, this);
        return new HCompElement(data, this.globalData, this);
    };
    function HybridRenderer(animationItem, config) {
        this.animationItem = animationItem;
        this.layers = null;
        this.renderedFrame = -1;
        this.renderConfig = {
            className: config && config.className || '',
            imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
            hideOnTransparent: !(config && config.hideOnTransparent === false),
            filterSize: {
                width: config && config.filterSize && config.filterSize.width || '400%',
                height: config && config.filterSize && config.filterSize.height || '400%',
                x: config && config.filterSize && config.filterSize.x || '-100%',
                y: config && config.filterSize && config.filterSize.y || '-100%'
            },
            runExpressions: !config || config.runExpressions === undefined || config.runExpressions
        };
        this.globalData = {
            _mdf: false,
            frameNum: -1,
            renderConfig: this.renderConfig
        };
        this.pendingElements = [];
        this.elements = [];
        this.threeDElements = [];
        this.destroyed = false;
        this.camera = null;
        this.supports3d = true;
        this.rendererType = 'html';
    }
    extendPrototype([
        HybridRendererBase
    ], HybridRenderer);
    HybridRenderer.prototype.createComp = function(data) {
        if (!this.supports3d) return new SVGCompElement(data, this.globalData, this);
        return new HCompElement(data, this.globalData, this);
    };
    var CompExpressionInterface = function() {
        return function(comp) {
            function _thisLayerFunction(name) {
                var i = 0;
                var len = comp.layers.length;
                while(i < len){
                    if (comp.layers[i].nm === name || comp.layers[i].ind === name) return comp.elements[i].layerInterface;
                    i += 1;
                }
                return null; // return {active:false};
            }
            Object.defineProperty(_thisLayerFunction, '_name', {
                value: comp.data.nm
            });
            _thisLayerFunction.layer = _thisLayerFunction;
            _thisLayerFunction.pixelAspect = 1;
            _thisLayerFunction.height = comp.data.h || comp.globalData.compSize.h;
            _thisLayerFunction.width = comp.data.w || comp.globalData.compSize.w;
            _thisLayerFunction.pixelAspect = 1;
            _thisLayerFunction.frameDuration = 1 / comp.globalData.frameRate;
            _thisLayerFunction.displayStartTime = 0;
            _thisLayerFunction.numLayers = comp.layers.length;
            return _thisLayerFunction;
        };
    }();
    function _typeof$2(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$2 = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof$2 = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof$2(obj);
    }
    /* eslint-disable */ /*
   Copyright 2014 David Bau.

   Permission is hereby granted, free of charge, to any person obtaining
   a copy of this software and associated documentation files (the
   "Software"), to deal in the Software without restriction, including
   without limitation the rights to use, copy, modify, merge, publish,
   distribute, sublicense, and/or sell copies of the Software, and to
   permit persons to whom the Software is furnished to do so, subject to
   the following conditions:

   The above copyright notice and this permission notice shall be
   included in all copies or substantial portions of the Software.

   THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
   EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
   MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
   IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
   CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
   TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
   SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

   */ function seedRandom(pool, math) {
        //
        // The following constants are related to IEEE 754 limits.
        //
        var global = this, width = 256, // each RC4 output is 0 <= x < 256
        chunks = 6, // at least six RC4 outputs for each double
        digits = 52, // there are 52 significant digits in a double
        rngname = 'random', // rngname: name for Math.random and Math.seedrandom
        startdenom = math.pow(width, chunks), significance = math.pow(2, digits), overflow = significance * 2, mask = width - 1, nodecrypto; // node.js crypto module, initialized at the bottom.
        //
        // seedrandom()
        // This is the seedrandom function described above.
        //
        function seedrandom(seed, options, callback) {
            var key = [];
            options = options === true ? {
                entropy: true
            } : options || {}; // Flatten the seed string or build one from local entropy if needed.
            var shortseed = mixkey(flatten(options.entropy ? [
                seed,
                tostring(pool)
            ] : seed === null ? autoseed() : seed, 3), key); // Use the seed to initialize an ARC4 generator.
            var arc4 = new ARC4(key); // This function returns a random double in [0, 1) that contains
            // randomness in every bit of the mantissa of the IEEE 754 value.
            var prng = function prng() {
                var n = arc4.g(chunks), // Start with a numerator n < 2 ^ 48
                d = startdenom, //   and denominator d = 2 ^ 48.
                x = 0; //   and no 'extra last byte'.
                while(n < significance){
                    // Fill up all significant digits by
                    n = (n + x) * width; //   shifting numerator and
                    d *= width; //   denominator and generating a
                    x = arc4.g(1); //   new least-significant-byte.
                }
                while(n >= overflow){
                    // To avoid rounding up, before adding
                    n /= 2; //   last byte, shift everything
                    d /= 2; //   right using integer math until
                    x >>>= 1; //   we have exactly the desired bits.
                }
                return (n + x) / d; // Form the number within [0, 1).
            };
            prng.int32 = function() {
                return arc4.g(4) | 0;
            };
            prng.quick = function() {
                return arc4.g(4) / 0x100000000;
            };
            prng["double"] = prng; // Mix the randomness into accumulated entropy.
            mixkey(tostring(arc4.S), pool); // Calling convention: what to return as a function of prng, seed, is_math.
            return (options.pass || callback || function(prng, seed, is_math_call, state) {
                if (state) {
                    // Load the arc4 state from the given state if it has an S array.
                    if (state.S) copy(state, arc4);
                     // Only provide the .state method if requested via options.state.
                    prng.state = function() {
                        return copy(arc4, {});
                    };
                } // If called as a method of Math (Math.seedrandom()), mutate
                // Math.random because that is how seedrandom.js has worked since v1.0.
                if (is_math_call) {
                    math[rngname] = prng;
                    return seed;
                } else return prng;
            })(prng, shortseed, 'global' in options ? options.global : this == math, options.state);
        }
        math['seed' + rngname] = seedrandom; //
        // ARC4
        //
        // An ARC4 implementation.  The constructor takes a key in the form of
        // an array of at most (width) integers that should be 0 <= x < (width).
        //
        // The g(count) method returns a pseudorandom integer that concatenates
        // the next (count) outputs from ARC4.  Its return value is a number x
        // that is in the range 0 <= x < (width ^ count).
        //
        function ARC4(key) {
            var t, keylen = key.length, me = this, i = 0, j = me.i = me.j = 0, s = me.S = []; // The empty key [] is treated as [0].
            if (!keylen) key = [
                keylen++
            ];
             // Set up S using the standard key scheduling algorithm.
            while(i < width)s[i] = i++;
            for(i = 0; i < width; i++){
                s[i] = s[j = mask & j + key[i % keylen] + (t = s[i])];
                s[j] = t;
            } // The "g" method returns the next (count) outputs as one number.
            me.g = function(count) {
                // Using instance members instead of closure state nearly doubles speed.
                var t, r = 0, i = me.i, j = me.j, s = me.S;
                while(count--){
                    t = s[i = mask & i + 1];
                    r = r * width + s[mask & (s[i] = s[j = mask & j + t]) + (s[j] = t)];
                }
                me.i = i;
                me.j = j;
                return r; // For robust unpredictability, the function call below automatically
            // discards an initial batch of values.  This is called RC4-drop[256].
            // See http://google.com/search?q=rsa+fluhrer+response&btnI
            };
        } //
        // copy()
        // Copies internal state of ARC4 to or from a plain object.
        //
        function copy(f, t) {
            t.i = f.i;
            t.j = f.j;
            t.S = f.S.slice();
            return t;
        } //
        // flatten()
        // Converts an object tree to nested arrays of strings.
        //
        function flatten(obj, depth) {
            var result = [], typ = _typeof$2(obj), prop;
            if (depth && typ == 'object') {
                for(prop in obj)try {
                    result.push(flatten(obj[prop], depth - 1));
                } catch (e) {}
            }
            return result.length ? result : typ == 'string' ? obj : obj + '\0';
        } //
        // mixkey()
        // Mixes a string seed into a key that is an array of integers, and
        // returns a shortened string seed that is equivalent to the result key.
        //
        function mixkey(seed, key) {
            var stringseed = seed + '', smear, j = 0;
            while(j < stringseed.length)key[mask & j] = mask & (smear ^= key[mask & j] * 19) + stringseed.charCodeAt(j++);
            return tostring(key);
        } //
        // autoseed()
        // Returns an object for autoseeding, using window.crypto and Node crypto
        // module if available.
        //
        function autoseed() {
            try {
                if (nodecrypto) return tostring(nodecrypto.randomBytes(width));
                var out = new Uint8Array(width);
                (global.crypto || global.msCrypto).getRandomValues(out);
                return tostring(out);
            } catch (e) {
                var browser = global.navigator, plugins = browser && browser.plugins;
                return [
                    +new Date(),
                    global,
                    plugins,
                    global.screen,
                    tostring(pool)
                ];
            }
        } //
        // tostring()
        // Converts an array of charcodes to a string
        //
        function tostring(a) {
            return String.fromCharCode.apply(0, a);
        } //
        // When seedrandom.js is loaded, we immediately mix a few bits
        // from the built-in RNG into the entropy pool.  Because we do
        // not want to interfere with deterministic PRNG state later,
        // seedrandom will not call math.random on its own again after
        // initialization.
        //
        mixkey(math.random(), pool); //
    // Nodejs and AMD support: export the implementation as a module using
    // either convention.
    //
    // End anonymous scope, and pass initial values.
    }
    function initialize$2(BMMath) {
        seedRandom([], BMMath);
    }
    var propTypes = {
        SHAPE: 'shape'
    };
    function _typeof$1(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$1 = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof$1 = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof$1(obj);
    }
    var ExpressionManager = function() {
        'use strict';
        var ob = {};
        var Math1 = BMMath;
        var window1 = null;
        var document1 = null;
        var XMLHttpRequest1 = null;
        var fetch = null;
        var frames = null;
        var _lottieGlobal = {};
        initialize$2(BMMath);
        function resetFrame() {
            _lottieGlobal = {};
        }
        function $bm_isInstanceOfArray(arr) {
            return arr.constructor === Array || arr.constructor === Float32Array;
        }
        function isNumerable(tOfV, v) {
            return tOfV === 'number' || v instanceof Number || tOfV === 'boolean' || tOfV === 'string';
        }
        function $bm_neg(a) {
            var tOfA = _typeof$1(a);
            if (tOfA === 'number' || a instanceof Number || tOfA === 'boolean') return -a;
            if ($bm_isInstanceOfArray(a)) {
                var i;
                var lenA = a.length;
                var retArr = [];
                for(i = 0; i < lenA; i += 1)retArr[i] = -a[i];
                return retArr;
            }
            if (a.propType) return a.v;
            return -a;
        }
        var easeInBez = BezierFactory.getBezierEasing(0.333, 0, 0.833, 0.833, 'easeIn').get;
        var easeOutBez = BezierFactory.getBezierEasing(0.167, 0.167, 0.667, 1, 'easeOut').get;
        var easeInOutBez = BezierFactory.getBezierEasing(0.33, 0, 0.667, 1, 'easeInOut').get;
        function sum(a, b) {
            var tOfA = _typeof$1(a);
            var tOfB = _typeof$1(b);
            if (isNumerable(tOfA, a) && isNumerable(tOfB, b) || tOfA === 'string' || tOfB === 'string') return a + b;
            if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
                a = a.slice(0);
                a[0] += b;
                return a;
            }
            if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
                b = b.slice(0);
                b[0] = a + b[0];
                return b;
            }
            if ($bm_isInstanceOfArray(a) && $bm_isInstanceOfArray(b)) {
                var i = 0;
                var lenA = a.length;
                var lenB = b.length;
                var retArr = [];
                while(i < lenA || i < lenB){
                    if ((typeof a[i] === 'number' || a[i] instanceof Number) && (typeof b[i] === 'number' || b[i] instanceof Number)) retArr[i] = a[i] + b[i];
                    else retArr[i] = b[i] === undefined ? a[i] : a[i] || b[i];
                    i += 1;
                }
                return retArr;
            }
            return 0;
        }
        var add = sum;
        function sub(a, b) {
            var tOfA = _typeof$1(a);
            var tOfB = _typeof$1(b);
            if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) {
                if (tOfA === 'string') a = parseInt(a, 10);
                if (tOfB === 'string') b = parseInt(b, 10);
                return a - b;
            }
            if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
                a = a.slice(0);
                a[0] -= b;
                return a;
            }
            if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
                b = b.slice(0);
                b[0] = a - b[0];
                return b;
            }
            if ($bm_isInstanceOfArray(a) && $bm_isInstanceOfArray(b)) {
                var i = 0;
                var lenA = a.length;
                var lenB = b.length;
                var retArr = [];
                while(i < lenA || i < lenB){
                    if ((typeof a[i] === 'number' || a[i] instanceof Number) && (typeof b[i] === 'number' || b[i] instanceof Number)) retArr[i] = a[i] - b[i];
                    else retArr[i] = b[i] === undefined ? a[i] : a[i] || b[i];
                    i += 1;
                }
                return retArr;
            }
            return 0;
        }
        function mul(a, b) {
            var tOfA = _typeof$1(a);
            var tOfB = _typeof$1(b);
            var arr;
            if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) return a * b;
            var i;
            var len;
            if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
                len = a.length;
                arr = createTypedArray('float32', len);
                for(i = 0; i < len; i += 1)arr[i] = a[i] * b;
                return arr;
            }
            if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
                len = b.length;
                arr = createTypedArray('float32', len);
                for(i = 0; i < len; i += 1)arr[i] = a * b[i];
                return arr;
            }
            return 0;
        }
        function div(a, b) {
            var tOfA = _typeof$1(a);
            var tOfB = _typeof$1(b);
            var arr;
            if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) return a / b;
            var i;
            var len;
            if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
                len = a.length;
                arr = createTypedArray('float32', len);
                for(i = 0; i < len; i += 1)arr[i] = a[i] / b;
                return arr;
            }
            if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
                len = b.length;
                arr = createTypedArray('float32', len);
                for(i = 0; i < len; i += 1)arr[i] = a / b[i];
                return arr;
            }
            return 0;
        }
        function mod(a, b) {
            if (typeof a === 'string') a = parseInt(a, 10);
            if (typeof b === 'string') b = parseInt(b, 10);
            return a % b;
        }
        var $bm_sum = sum;
        var $bm_sub = sub;
        var $bm_mul = mul;
        var $bm_div = div;
        var $bm_mod = mod;
        function clamp(num, min, max) {
            if (min > max) {
                var mm = max;
                max = min;
                min = mm;
            }
            return Math1.min(Math1.max(num, min), max);
        }
        function radiansToDegrees(val) {
            return val / degToRads;
        }
        var radians_to_degrees = radiansToDegrees;
        function degreesToRadians(val) {
            return val * degToRads;
        }
        var degrees_to_radians = radiansToDegrees;
        var helperLengthArray = [
            0,
            0,
            0,
            0,
            0,
            0
        ];
        function length(arr1, arr2) {
            if (typeof arr1 === 'number' || arr1 instanceof Number) {
                arr2 = arr2 || 0;
                return Math1.abs(arr1 - arr2);
            }
            if (!arr2) arr2 = helperLengthArray;
            var i;
            var len = Math1.min(arr1.length, arr2.length);
            var addedLength = 0;
            for(i = 0; i < len; i += 1)addedLength += Math1.pow(arr2[i] - arr1[i], 2);
            return Math1.sqrt(addedLength);
        }
        function normalize(vec) {
            return div(vec, length(vec));
        }
        function rgbToHsl(val) {
            var r = val[0];
            var g = val[1];
            var b = val[2];
            var max = Math1.max(r, g, b);
            var min = Math1.min(r, g, b);
            var h;
            var s;
            var l = (max + min) / 2;
            if (max === min) {
                h = 0; // achromatic
                s = 0; // achromatic
            } else {
                var d = max - min;
                s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
                switch(max){
                    case r:
                        h = (g - b) / d + (g < b ? 6 : 0);
                        break;
                    case g:
                        h = (b - r) / d + 2;
                        break;
                    case b:
                        h = (r - g) / d + 4;
                        break;
                    default:
                        break;
                }
                h /= 6;
            }
            return [
                h,
                s,
                l,
                val[3]
            ];
        }
        function hue2rgb(p, q, t) {
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 1 / 6) return p + (q - p) * 6 * t;
            if (t < 0.5) return q;
            if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
            return p;
        }
        function hslToRgb(val) {
            var h = val[0];
            var s = val[1];
            var l = val[2];
            var r;
            var g;
            var b;
            if (s === 0) {
                r = l; // achromatic
                b = l; // achromatic
                g = l; // achromatic
            } else {
                var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
                var p = 2 * l - q;
                r = hue2rgb(p, q, h + 1 / 3);
                g = hue2rgb(p, q, h);
                b = hue2rgb(p, q, h - 1 / 3);
            }
            return [
                r,
                g,
                b,
                val[3]
            ];
        }
        function linear(t, tMin, tMax, value1, value2) {
            if (value1 === undefined || value2 === undefined) {
                value1 = tMin;
                value2 = tMax;
                tMin = 0;
                tMax = 1;
            }
            if (tMax < tMin) {
                var _tMin = tMax;
                tMax = tMin;
                tMin = _tMin;
            }
            if (t <= tMin) return value1;
            if (t >= tMax) return value2;
            var perc = tMax === tMin ? 0 : (t - tMin) / (tMax - tMin);
            if (!value1.length) return value1 + (value2 - value1) * perc;
            var i;
            var len = value1.length;
            var arr = createTypedArray('float32', len);
            for(i = 0; i < len; i += 1)arr[i] = value1[i] + (value2[i] - value1[i]) * perc;
            return arr;
        }
        function random(min, max) {
            if (max === undefined) {
                if (min === undefined) {
                    min = 0;
                    max = 1;
                } else {
                    max = min;
                    min = undefined;
                }
            }
            if (max.length) {
                var i;
                var len = max.length;
                if (!min) min = createTypedArray('float32', len);
                var arr = createTypedArray('float32', len);
                var rnd = BMMath.random();
                for(i = 0; i < len; i += 1)arr[i] = min[i] + rnd * (max[i] - min[i]);
                return arr;
            }
            if (min === undefined) min = 0;
            var rndm = BMMath.random();
            return min + rndm * (max - min);
        }
        function createPath(points, inTangents, outTangents, closed) {
            var i;
            var len = points.length;
            var path = shapePool.newElement();
            path.setPathData(!!closed, len);
            var arrPlaceholder = [
                0,
                0
            ];
            var inVertexPoint;
            var outVertexPoint;
            for(i = 0; i < len; i += 1){
                inVertexPoint = inTangents && inTangents[i] ? inTangents[i] : arrPlaceholder;
                outVertexPoint = outTangents && outTangents[i] ? outTangents[i] : arrPlaceholder;
                path.setTripleAt(points[i][0], points[i][1], outVertexPoint[0] + points[i][0], outVertexPoint[1] + points[i][1], inVertexPoint[0] + points[i][0], inVertexPoint[1] + points[i][1], i, true);
            }
            return path;
        }
        function initiateExpression(elem, data, property) {
            // Bail out if we don't want expressions
            function noOp(_value) {
                return _value;
            }
            if (!elem.globalData.renderConfig.runExpressions) return noOp;
            var val = data.x;
            var needsVelocity = /velocity(?![\w\d])/.test(val);
            var _needsRandom = val.indexOf('random') !== -1;
            var elemType = elem.data.ty;
            var transform;
            var $bm_transform;
            var content;
            var effect;
            var thisProperty = property;
            thisProperty.valueAtTime = thisProperty.getValueAtTime;
            Object.defineProperty(thisProperty, 'value', {
                get: function get() {
                    return thisProperty.v;
                }
            });
            elem.comp.frameDuration = 1 / elem.comp.globalData.frameRate;
            elem.comp.displayStartTime = 0;
            var inPoint = elem.data.ip / elem.comp.globalData.frameRate;
            var outPoint = elem.data.op / elem.comp.globalData.frameRate;
            var width = elem.data.sw ? elem.data.sw : 0;
            var height = elem.data.sh ? elem.data.sh : 0;
            var name = elem.data.nm;
            var loopIn;
            var loop_in;
            var loopOut;
            var loop_out;
            var smooth;
            var toWorld;
            var fromWorld;
            var fromComp;
            var toComp;
            var fromCompToSurface;
            var position;
            var rotation;
            var anchorPoint;
            var scale;
            var thisLayer;
            var thisComp;
            var mask;
            var valueAtTime;
            var velocityAtTime;
            var scoped_bm_rt; // val = val.replace(/(\\?"|')((http)(s)?(:\/))?\/.*?(\\?"|')/g, "\"\""); // deter potential network calls
            var expression_function = eval('[function _expression_function(){' + val + ';scoped_bm_rt=$bm_rt}]')[0]; // eslint-disable-line no-eval
            var numKeys = property.kf ? data.k.length : 0;
            var active = !this.data || this.data.hd !== true;
            var wiggle = (function wiggle(freq, amp) {
                var iWiggle;
                var j;
                var lenWiggle = this.pv.length ? this.pv.length : 1;
                var addedAmps = createTypedArray('float32', lenWiggle);
                freq = 5;
                var iterations = Math1.floor(time * freq);
                iWiggle = 0;
                j = 0;
                while(iWiggle < iterations){
                    // var rnd = BMMath.random();
                    for(j = 0; j < lenWiggle; j += 1)addedAmps[j] += -amp + amp * 2 * BMMath.random(); // addedAmps[j] += -amp + amp*2*rnd;
                    iWiggle += 1;
                } // var rnd2 = BMMath.random();
                var periods = time * freq;
                var perc = periods - Math1.floor(periods);
                var arr = createTypedArray('float32', lenWiggle);
                if (lenWiggle > 1) {
                    for(j = 0; j < lenWiggle; j += 1)arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp * 2 * BMMath.random()) * perc; // arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp*2*rnd)*perc;
                    return arr;
                }
                return this.pv + addedAmps[0] + (-amp + amp * 2 * BMMath.random()) * perc;
            }).bind(this);
            if (thisProperty.loopIn) {
                loopIn = thisProperty.loopIn.bind(thisProperty);
                loop_in = loopIn;
            }
            if (thisProperty.loopOut) {
                loopOut = thisProperty.loopOut.bind(thisProperty);
                loop_out = loopOut;
            }
            if (thisProperty.smooth) smooth = thisProperty.smooth.bind(thisProperty);
            function loopInDuration(type, duration) {
                return loopIn(type, duration, true);
            }
            function loopOutDuration(type, duration) {
                return loopOut(type, duration, true);
            }
            if (this.getValueAtTime) valueAtTime = this.getValueAtTime.bind(this);
            if (this.getVelocityAtTime) velocityAtTime = this.getVelocityAtTime.bind(this);
            var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface);
            function lookAt(elem1, elem2) {
                var fVec = [
                    elem2[0] - elem1[0],
                    elem2[1] - elem1[1],
                    elem2[2] - elem1[2]
                ];
                var pitch = Math1.atan2(fVec[0], Math1.sqrt(fVec[1] * fVec[1] + fVec[2] * fVec[2])) / degToRads;
                var yaw = -Math1.atan2(fVec[1], fVec[2]) / degToRads;
                return [
                    yaw,
                    pitch,
                    0
                ];
            }
            function easeOut(t, tMin, tMax, val1, val2) {
                return applyEase(easeOutBez, t, tMin, tMax, val1, val2);
            }
            function easeIn(t, tMin, tMax, val1, val2) {
                return applyEase(easeInBez, t, tMin, tMax, val1, val2);
            }
            function ease(t, tMin, tMax, val1, val2) {
                return applyEase(easeInOutBez, t, tMin, tMax, val1, val2);
            }
            function applyEase(fn, t, tMin, tMax, val1, val2) {
                if (val1 === undefined) {
                    val1 = tMin;
                    val2 = tMax;
                } else t = (t - tMin) / (tMax - tMin);
                if (t > 1) t = 1;
                else if (t < 0) t = 0;
                var mult = fn(t);
                if ($bm_isInstanceOfArray(val1)) {
                    var iKey;
                    var lenKey = val1.length;
                    var arr = createTypedArray('float32', lenKey);
                    for(iKey = 0; iKey < lenKey; iKey += 1)arr[iKey] = (val2[iKey] - val1[iKey]) * mult + val1[iKey];
                    return arr;
                }
                return (val2 - val1) * mult + val1;
            }
            function nearestKey(time) {
                var iKey;
                var lenKey = data.k.length;
                var index;
                var keyTime;
                if (!data.k.length || typeof data.k[0] === 'number') {
                    index = 0;
                    keyTime = 0;
                } else {
                    index = -1;
                    time *= elem.comp.globalData.frameRate;
                    if (time < data.k[0].t) {
                        index = 1;
                        keyTime = data.k[0].t;
                    } else {
                        for(iKey = 0; iKey < lenKey - 1; iKey += 1){
                            if (time === data.k[iKey].t) {
                                index = iKey + 1;
                                keyTime = data.k[iKey].t;
                                break;
                            } else if (time > data.k[iKey].t && time < data.k[iKey + 1].t) {
                                if (time - data.k[iKey].t > data.k[iKey + 1].t - time) {
                                    index = iKey + 2;
                                    keyTime = data.k[iKey + 1].t;
                                } else {
                                    index = iKey + 1;
                                    keyTime = data.k[iKey].t;
                                }
                                break;
                            }
                        }
                        if (index === -1) {
                            index = iKey + 1;
                            keyTime = data.k[iKey].t;
                        }
                    }
                }
                var obKey = {};
                obKey.index = index;
                obKey.time = keyTime / elem.comp.globalData.frameRate;
                return obKey;
            }
            function key(ind) {
                var obKey;
                var iKey;
                var lenKey;
                if (!data.k.length || typeof data.k[0] === 'number') throw new Error('The property has no keyframe at index ' + ind);
                ind -= 1;
                obKey = {
                    time: data.k[ind].t / elem.comp.globalData.frameRate,
                    value: []
                };
                var arr = Object.prototype.hasOwnProperty.call(data.k[ind], 's') ? data.k[ind].s : data.k[ind - 1].e;
                lenKey = arr.length;
                for(iKey = 0; iKey < lenKey; iKey += 1){
                    obKey[iKey] = arr[iKey];
                    obKey.value[iKey] = arr[iKey];
                }
                return obKey;
            }
            function framesToTime(fr, fps) {
                if (!fps) fps = elem.comp.globalData.frameRate;
                return fr / fps;
            }
            function timeToFrames(t, fps) {
                if (!t && t !== 0) t = time;
                if (!fps) fps = elem.comp.globalData.frameRate;
                return t * fps;
            }
            function seedRandom(seed) {
                BMMath.seedrandom(randSeed + seed);
            }
            function sourceRectAtTime() {
                return elem.sourceRectAtTime();
            }
            function substring(init, end) {
                if (typeof value === 'string') {
                    if (end === undefined) return value.substring(init);
                    return value.substring(init, end);
                }
                return '';
            }
            function substr(init, end) {
                if (typeof value === 'string') {
                    if (end === undefined) return value.substr(init);
                    return value.substr(init, end);
                }
                return '';
            }
            function posterizeTime(framesPerSecond) {
                time = framesPerSecond === 0 ? 0 : Math1.floor(time * framesPerSecond) / framesPerSecond;
                value = valueAtTime(time);
            }
            var time;
            var velocity;
            var value;
            var text;
            var textIndex;
            var textTotal;
            var selectorValue;
            var index = elem.data.ind;
            var hasParent = !!(elem.hierarchy && elem.hierarchy.length);
            var parent;
            var randSeed = Math1.floor(Math1.random() * 1000000);
            var globalData = elem.globalData;
            function executeExpression(_value) {
                // globalData.pushExpression();
                value = _value;
                if (this.frameExpressionId === elem.globalData.frameId && this.propType !== 'textSelector') return value;
                if (this.propType === 'textSelector') {
                    textIndex = this.textIndex;
                    textTotal = this.textTotal;
                    selectorValue = this.selectorValue;
                }
                if (!thisLayer) {
                    text = elem.layerInterface.text;
                    thisLayer = elem.layerInterface;
                    thisComp = elem.comp.compInterface;
                    toWorld = thisLayer.toWorld.bind(thisLayer);
                    fromWorld = thisLayer.fromWorld.bind(thisLayer);
                    fromComp = thisLayer.fromComp.bind(thisLayer);
                    toComp = thisLayer.toComp.bind(thisLayer);
                    mask = thisLayer.mask ? thisLayer.mask.bind(thisLayer) : null;
                    fromCompToSurface = fromComp;
                }
                if (!transform) {
                    transform = elem.layerInterface('ADBE Transform Group');
                    $bm_transform = transform;
                    if (transform) anchorPoint = transform.anchorPoint;
                }
                if (elemType === 4 && !content) content = thisLayer('ADBE Root Vectors Group');
                if (!effect) effect = thisLayer(4);
                hasParent = !!(elem.hierarchy && elem.hierarchy.length);
                if (hasParent && !parent) parent = elem.hierarchy[0].layerInterface;
                time = this.comp.renderedFrame / this.comp.globalData.frameRate;
                if (_needsRandom) seedRandom(randSeed + time);
                if (needsVelocity) velocity = velocityAtTime(time);
                expression_function();
                this.frameExpressionId = elem.globalData.frameId; // TODO: Check if it's possible to return on ShapeInterface the .v value
                // Changed this to a ternary operation because Rollup failed compiling it correctly
                scoped_bm_rt = scoped_bm_rt.propType === propTypes.SHAPE ? scoped_bm_rt.v : scoped_bm_rt;
                return scoped_bm_rt;
            } // Bundlers will see these as dead code and unless we reference them
            executeExpression.__preventDeadCodeRemoval = [
                $bm_transform,
                anchorPoint,
                time,
                velocity,
                inPoint,
                outPoint,
                width,
                height,
                name,
                loop_in,
                loop_out,
                smooth,
                toComp,
                fromCompToSurface,
                toWorld,
                fromWorld,
                mask,
                position,
                rotation,
                scale,
                thisComp,
                numKeys,
                active,
                wiggle,
                loopInDuration,
                loopOutDuration,
                comp,
                lookAt,
                easeOut,
                easeIn,
                ease,
                nearestKey,
                key,
                text,
                textIndex,
                textTotal,
                selectorValue,
                framesToTime,
                timeToFrames,
                sourceRectAtTime,
                substring,
                substr,
                posterizeTime,
                index,
                globalData
            ];
            return executeExpression;
        }
        ob.initiateExpression = initiateExpression;
        ob.__preventDeadCodeRemoval = [
            window1,
            document1,
            XMLHttpRequest1,
            fetch,
            frames,
            $bm_neg,
            add,
            $bm_sum,
            $bm_sub,
            $bm_mul,
            $bm_div,
            $bm_mod,
            clamp,
            radians_to_degrees,
            degreesToRadians,
            degrees_to_radians,
            normalize,
            rgbToHsl,
            hslToRgb,
            linear,
            random,
            createPath,
            _lottieGlobal
        ];
        ob.resetFrame = resetFrame;
        return ob;
    }();
    var Expressions = function() {
        var ob = {};
        ob.initExpressions = initExpressions;
        ob.resetFrame = ExpressionManager.resetFrame;
        function initExpressions(animation) {
            var stackCount = 0;
            var registers = [];
            function pushExpression() {
                stackCount += 1;
            }
            function popExpression() {
                stackCount -= 1;
                if (stackCount === 0) releaseInstances();
            }
            function registerExpressionProperty(expression) {
                if (registers.indexOf(expression) === -1) registers.push(expression);
            }
            function releaseInstances() {
                var i;
                var len = registers.length;
                for(i = 0; i < len; i += 1)registers[i].release();
                registers.length = 0;
            }
            animation.renderer.compInterface = CompExpressionInterface(animation.renderer);
            animation.renderer.globalData.projectInterface.registerComposition(animation.renderer);
            animation.renderer.globalData.pushExpression = pushExpression;
            animation.renderer.globalData.popExpression = popExpression;
            animation.renderer.globalData.registerExpressionProperty = registerExpressionProperty;
        }
        return ob;
    }();
    var MaskManagerInterface = function() {
        function MaskInterface(mask, data) {
            this._mask = mask;
            this._data = data;
        }
        Object.defineProperty(MaskInterface.prototype, 'maskPath', {
            get: function get() {
                if (this._mask.prop.k) this._mask.prop.getValue();
                return this._mask.prop;
            }
        });
        Object.defineProperty(MaskInterface.prototype, 'maskOpacity', {
            get: function get() {
                if (this._mask.op.k) this._mask.op.getValue();
                return this._mask.op.v * 100;
            }
        });
        var MaskManager = function MaskManager(maskManager) {
            var _masksInterfaces = createSizedArray(maskManager.viewData.length);
            var i;
            var len = maskManager.viewData.length;
            for(i = 0; i < len; i += 1)_masksInterfaces[i] = new MaskInterface(maskManager.viewData[i], maskManager.masksProperties[i]);
            var maskFunction = function maskFunction(name) {
                i = 0;
                while(i < len){
                    if (maskManager.masksProperties[i].nm === name) return _masksInterfaces[i];
                    i += 1;
                }
                return null;
            };
            return maskFunction;
        };
        return MaskManager;
    }();
    var ExpressionPropertyInterface = function() {
        var defaultUnidimensionalValue = {
            pv: 0,
            v: 0,
            mult: 1
        };
        var defaultMultidimensionalValue = {
            pv: [
                0,
                0,
                0
            ],
            v: [
                0,
                0,
                0
            ],
            mult: 1
        };
        function completeProperty(expressionValue, property, type) {
            Object.defineProperty(expressionValue, 'velocity', {
                get: function get() {
                    return property.getVelocityAtTime(property.comp.currentFrame);
                }
            });
            expressionValue.numKeys = property.keyframes ? property.keyframes.length : 0;
            expressionValue.key = function(pos) {
                if (!expressionValue.numKeys) return 0;
                var value = '';
                if ('s' in property.keyframes[pos - 1]) value = property.keyframes[pos - 1].s;
                else if ('e' in property.keyframes[pos - 2]) value = property.keyframes[pos - 2].e;
                else value = property.keyframes[pos - 2].s;
                var valueProp = type === 'unidimensional' ? new Number(value) : Object.assign({}, value); // eslint-disable-line no-new-wrappers
                valueProp.time = property.keyframes[pos - 1].t / property.elem.comp.globalData.frameRate;
                valueProp.value = type === 'unidimensional' ? value[0] : value;
                return valueProp;
            };
            expressionValue.valueAtTime = property.getValueAtTime;
            expressionValue.speedAtTime = property.getSpeedAtTime;
            expressionValue.velocityAtTime = property.getVelocityAtTime;
            expressionValue.propertyGroup = property.propertyGroup;
        }
        function UnidimensionalPropertyInterface(property) {
            if (!property || !('pv' in property)) property = defaultUnidimensionalValue;
            var mult = 1 / property.mult;
            var val = property.pv * mult;
            var expressionValue = new Number(val); // eslint-disable-line no-new-wrappers
            expressionValue.value = val;
            completeProperty(expressionValue, property, 'unidimensional');
            return function() {
                if (property.k) property.getValue();
                val = property.v * mult;
                if (expressionValue.value !== val) {
                    expressionValue = new Number(val); // eslint-disable-line no-new-wrappers
                    expressionValue.value = val;
                    completeProperty(expressionValue, property, 'unidimensional');
                }
                return expressionValue;
            };
        }
        function MultidimensionalPropertyInterface(property) {
            if (!property || !('pv' in property)) property = defaultMultidimensionalValue;
            var mult = 1 / property.mult;
            var len = property.data && property.data.l || property.pv.length;
            var expressionValue = createTypedArray('float32', len);
            var arrValue = createTypedArray('float32', len);
            expressionValue.value = arrValue;
            completeProperty(expressionValue, property, 'multidimensional');
            return function() {
                if (property.k) property.getValue();
                for(var i = 0; i < len; i += 1){
                    arrValue[i] = property.v[i] * mult;
                    expressionValue[i] = arrValue[i];
                }
                return expressionValue;
            };
        } // TODO: try to avoid using this getter
        function defaultGetter() {
            return defaultUnidimensionalValue;
        }
        return function(property) {
            if (!property) return defaultGetter;
            if (property.propType === 'unidimensional') return UnidimensionalPropertyInterface(property);
            return MultidimensionalPropertyInterface(property);
        };
    }();
    var TransformExpressionInterface = function() {
        return function(transform) {
            function _thisFunction(name) {
                switch(name){
                    case 'scale':
                    case 'Scale':
                    case 'ADBE Scale':
                    case 6:
                        return _thisFunction.scale;
                    case 'rotation':
                    case 'Rotation':
                    case 'ADBE Rotation':
                    case 'ADBE Rotate Z':
                    case 10:
                        return _thisFunction.rotation;
                    case 'ADBE Rotate X':
                        return _thisFunction.xRotation;
                    case 'ADBE Rotate Y':
                        return _thisFunction.yRotation;
                    case 'position':
                    case 'Position':
                    case 'ADBE Position':
                    case 2:
                        return _thisFunction.position;
                    case 'ADBE Position_0':
                        return _thisFunction.xPosition;
                    case 'ADBE Position_1':
                        return _thisFunction.yPosition;
                    case 'ADBE Position_2':
                        return _thisFunction.zPosition;
                    case 'anchorPoint':
                    case 'AnchorPoint':
                    case 'Anchor Point':
                    case 'ADBE AnchorPoint':
                    case 1:
                        return _thisFunction.anchorPoint;
                    case 'opacity':
                    case 'Opacity':
                    case 11:
                        return _thisFunction.opacity;
                    default:
                        return null;
                }
            }
            Object.defineProperty(_thisFunction, 'rotation', {
                get: ExpressionPropertyInterface(transform.r || transform.rz)
            });
            Object.defineProperty(_thisFunction, 'zRotation', {
                get: ExpressionPropertyInterface(transform.rz || transform.r)
            });
            Object.defineProperty(_thisFunction, 'xRotation', {
                get: ExpressionPropertyInterface(transform.rx)
            });
            Object.defineProperty(_thisFunction, 'yRotation', {
                get: ExpressionPropertyInterface(transform.ry)
            });
            Object.defineProperty(_thisFunction, 'scale', {
                get: ExpressionPropertyInterface(transform.s)
            });
            var _px;
            var _py;
            var _pz;
            var _transformFactory;
            if (transform.p) _transformFactory = ExpressionPropertyInterface(transform.p);
            else {
                _px = ExpressionPropertyInterface(transform.px);
                _py = ExpressionPropertyInterface(transform.py);
                if (transform.pz) _pz = ExpressionPropertyInterface(transform.pz);
            }
            Object.defineProperty(_thisFunction, 'position', {
                get: function get() {
                    if (transform.p) return _transformFactory();
                    return [
                        _px(),
                        _py(),
                        _pz ? _pz() : 0
                    ];
                }
            });
            Object.defineProperty(_thisFunction, 'xPosition', {
                get: ExpressionPropertyInterface(transform.px)
            });
            Object.defineProperty(_thisFunction, 'yPosition', {
                get: ExpressionPropertyInterface(transform.py)
            });
            Object.defineProperty(_thisFunction, 'zPosition', {
                get: ExpressionPropertyInterface(transform.pz)
            });
            Object.defineProperty(_thisFunction, 'anchorPoint', {
                get: ExpressionPropertyInterface(transform.a)
            });
            Object.defineProperty(_thisFunction, 'opacity', {
                get: ExpressionPropertyInterface(transform.o)
            });
            Object.defineProperty(_thisFunction, 'skew', {
                get: ExpressionPropertyInterface(transform.sk)
            });
            Object.defineProperty(_thisFunction, 'skewAxis', {
                get: ExpressionPropertyInterface(transform.sa)
            });
            Object.defineProperty(_thisFunction, 'orientation', {
                get: ExpressionPropertyInterface(transform.or)
            });
            return _thisFunction;
        };
    }();
    var LayerExpressionInterface = function() {
        function getMatrix(time) {
            var toWorldMat = new Matrix();
            if (time !== undefined) {
                var propMatrix = this._elem.finalTransform.mProp.getValueAtTime(time);
                propMatrix.clone(toWorldMat);
            } else {
                var transformMat = this._elem.finalTransform.mProp;
                transformMat.applyToMatrix(toWorldMat);
            }
            return toWorldMat;
        }
        function toWorldVec(arr, time) {
            var toWorldMat = this.getMatrix(time);
            toWorldMat.props[12] = 0;
            toWorldMat.props[13] = 0;
            toWorldMat.props[14] = 0;
            return this.applyPoint(toWorldMat, arr);
        }
        function toWorld(arr, time) {
            var toWorldMat = this.getMatrix(time);
            return this.applyPoint(toWorldMat, arr);
        }
        function fromWorldVec(arr, time) {
            var toWorldMat = this.getMatrix(time);
            toWorldMat.props[12] = 0;
            toWorldMat.props[13] = 0;
            toWorldMat.props[14] = 0;
            return this.invertPoint(toWorldMat, arr);
        }
        function fromWorld(arr, time) {
            var toWorldMat = this.getMatrix(time);
            return this.invertPoint(toWorldMat, arr);
        }
        function applyPoint(matrix, arr) {
            if (this._elem.hierarchy && this._elem.hierarchy.length) {
                var i;
                var len = this._elem.hierarchy.length;
                for(i = 0; i < len; i += 1)this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(matrix);
            }
            return matrix.applyToPointArray(arr[0], arr[1], arr[2] || 0);
        }
        function invertPoint(matrix, arr) {
            if (this._elem.hierarchy && this._elem.hierarchy.length) {
                var i;
                var len = this._elem.hierarchy.length;
                for(i = 0; i < len; i += 1)this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(matrix);
            }
            return matrix.inversePoint(arr);
        }
        function fromComp(arr) {
            var toWorldMat = new Matrix();
            toWorldMat.reset();
            this._elem.finalTransform.mProp.applyToMatrix(toWorldMat);
            if (this._elem.hierarchy && this._elem.hierarchy.length) {
                var i;
                var len = this._elem.hierarchy.length;
                for(i = 0; i < len; i += 1)this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(toWorldMat);
                return toWorldMat.inversePoint(arr);
            }
            return toWorldMat.inversePoint(arr);
        }
        function sampleImage() {
            return [
                1,
                1,
                1,
                1
            ];
        }
        return function(elem) {
            var transformInterface;
            function _registerMaskInterface(maskManager) {
                _thisLayerFunction.mask = new MaskManagerInterface(maskManager, elem);
            }
            function _registerEffectsInterface(effects) {
                _thisLayerFunction.effect = effects;
            }
            function _thisLayerFunction(name) {
                switch(name){
                    case 'ADBE Root Vectors Group':
                    case 'Contents':
                    case 2:
                        return _thisLayerFunction.shapeInterface;
                    case 1:
                    case 6:
                    case 'Transform':
                    case 'transform':
                    case 'ADBE Transform Group':
                        return transformInterface;
                    case 4:
                    case 'ADBE Effect Parade':
                    case 'effects':
                    case 'Effects':
                        return _thisLayerFunction.effect;
                    case 'ADBE Text Properties':
                        return _thisLayerFunction.textInterface;
                    default:
                        return null;
                }
            }
            _thisLayerFunction.getMatrix = getMatrix;
            _thisLayerFunction.invertPoint = invertPoint;
            _thisLayerFunction.applyPoint = applyPoint;
            _thisLayerFunction.toWorld = toWorld;
            _thisLayerFunction.toWorldVec = toWorldVec;
            _thisLayerFunction.fromWorld = fromWorld;
            _thisLayerFunction.fromWorldVec = fromWorldVec;
            _thisLayerFunction.toComp = toWorld;
            _thisLayerFunction.fromComp = fromComp;
            _thisLayerFunction.sampleImage = sampleImage;
            _thisLayerFunction.sourceRectAtTime = elem.sourceRectAtTime.bind(elem);
            _thisLayerFunction._elem = elem;
            transformInterface = TransformExpressionInterface(elem.finalTransform.mProp);
            var anchorPointDescriptor = getDescriptor(transformInterface, 'anchorPoint');
            Object.defineProperties(_thisLayerFunction, {
                hasParent: {
                    get: function get() {
                        return elem.hierarchy.length;
                    }
                },
                parent: {
                    get: function get() {
                        return elem.hierarchy[0].layerInterface;
                    }
                },
                rotation: getDescriptor(transformInterface, 'rotation'),
                scale: getDescriptor(transformInterface, 'scale'),
                position: getDescriptor(transformInterface, 'position'),
                opacity: getDescriptor(transformInterface, 'opacity'),
                anchorPoint: anchorPointDescriptor,
                anchor_point: anchorPointDescriptor,
                transform: {
                    get: function get() {
                        return transformInterface;
                    }
                },
                active: {
                    get: function get() {
                        return elem.isInRange;
                    }
                }
            });
            _thisLayerFunction.startTime = elem.data.st;
            _thisLayerFunction.index = elem.data.ind;
            _thisLayerFunction.source = elem.data.refId;
            _thisLayerFunction.height = elem.data.ty === 0 ? elem.data.h : 100;
            _thisLayerFunction.width = elem.data.ty === 0 ? elem.data.w : 100;
            _thisLayerFunction.inPoint = elem.data.ip / elem.comp.globalData.frameRate;
            _thisLayerFunction.outPoint = elem.data.op / elem.comp.globalData.frameRate;
            _thisLayerFunction._name = elem.data.nm;
            _thisLayerFunction.registerMaskInterface = _registerMaskInterface;
            _thisLayerFunction.registerEffectsInterface = _registerEffectsInterface;
            return _thisLayerFunction;
        };
    }();
    var propertyGroupFactory = function() {
        return function(interfaceFunction, parentPropertyGroup) {
            return function(val) {
                val = val === undefined ? 1 : val;
                if (val <= 0) return interfaceFunction;
                return parentPropertyGroup(val - 1);
            };
        };
    }();
    var PropertyInterface = function() {
        return function(propertyName, propertyGroup) {
            var interfaceFunction = {
                _name: propertyName
            };
            function _propertyGroup(val) {
                val = val === undefined ? 1 : val;
                if (val <= 0) return interfaceFunction;
                return propertyGroup(val - 1);
            }
            return _propertyGroup;
        };
    }();
    var EffectsExpressionInterface = function() {
        var ob = {
            createEffectsInterface: createEffectsInterface
        };
        function createEffectsInterface(elem, propertyGroup) {
            if (elem.effectsManager) {
                var effectElements = [];
                var effectsData = elem.data.ef;
                var i;
                var len = elem.effectsManager.effectElements.length;
                for(i = 0; i < len; i += 1)effectElements.push(createGroupInterface(effectsData[i], elem.effectsManager.effectElements[i], propertyGroup, elem));
                var effects = elem.data.ef || [];
                var groupInterface = function groupInterface(name) {
                    i = 0;
                    len = effects.length;
                    while(i < len){
                        if (name === effects[i].nm || name === effects[i].mn || name === effects[i].ix) return effectElements[i];
                        i += 1;
                    }
                    return null;
                };
                Object.defineProperty(groupInterface, 'numProperties', {
                    get: function get() {
                        return effects.length;
                    }
                });
                return groupInterface;
            }
            return null;
        }
        function createGroupInterface(data, elements, propertyGroup, elem) {
            function groupInterface(name) {
                var effects = data.ef;
                var i = 0;
                var len = effects.length;
                while(i < len){
                    if (name === effects[i].nm || name === effects[i].mn || name === effects[i].ix) {
                        if (effects[i].ty === 5) return effectElements[i];
                        return effectElements[i]();
                    }
                    i += 1;
                }
                throw new Error();
            }
            var _propertyGroup = propertyGroupFactory(groupInterface, propertyGroup);
            var effectElements = [];
            var i;
            var len = data.ef.length;
            for(i = 0; i < len; i += 1)if (data.ef[i].ty === 5) effectElements.push(createGroupInterface(data.ef[i], elements.effectElements[i], elements.effectElements[i].propertyGroup, elem));
            else effectElements.push(createValueInterface(elements.effectElements[i], data.ef[i].ty, elem, _propertyGroup));
            if (data.mn === 'ADBE Color Control') Object.defineProperty(groupInterface, 'color', {
                get: function get() {
                    return effectElements[0]();
                }
            });
            Object.defineProperties(groupInterface, {
                numProperties: {
                    get: function get() {
                        return data.np;
                    }
                },
                _name: {
                    value: data.nm
                },
                propertyGroup: {
                    value: _propertyGroup
                }
            });
            groupInterface.enabled = data.en !== 0;
            groupInterface.active = groupInterface.enabled;
            return groupInterface;
        }
        function createValueInterface(element, type, elem, propertyGroup) {
            var expressionProperty = ExpressionPropertyInterface(element.p);
            function interfaceFunction() {
                if (type === 10) return elem.comp.compInterface(element.p.v);
                return expressionProperty();
            }
            if (element.p.setGroupProperty) element.p.setGroupProperty(PropertyInterface('', propertyGroup));
            return interfaceFunction;
        }
        return ob;
    }();
    var ShapePathInterface = function() {
        return function pathInterfaceFactory(shape, view, propertyGroup) {
            var prop = view.sh;
            function interfaceFunction(val) {
                if (val === 'Shape' || val === 'shape' || val === 'Path' || val === 'path' || val === 'ADBE Vector Shape' || val === 2) return interfaceFunction.path;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            prop.setGroupProperty(PropertyInterface('Path', _propertyGroup));
            Object.defineProperties(interfaceFunction, {
                path: {
                    get: function get() {
                        if (prop.k) prop.getValue();
                        return prop;
                    }
                },
                shape: {
                    get: function get() {
                        if (prop.k) prop.getValue();
                        return prop;
                    }
                },
                _name: {
                    value: shape.nm
                },
                ix: {
                    value: shape.ix
                },
                propertyIndex: {
                    value: shape.ix
                },
                mn: {
                    value: shape.mn
                },
                propertyGroup: {
                    value: propertyGroup
                }
            });
            return interfaceFunction;
        };
    }();
    var ShapeExpressionInterface = function() {
        function iterateElements(shapes, view, propertyGroup) {
            var arr = [];
            var i;
            var len = shapes ? shapes.length : 0;
            for(i = 0; i < len; i += 1){
                if (shapes[i].ty === 'gr') arr.push(groupInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'fl') arr.push(fillInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'st') arr.push(strokeInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'tm') arr.push(trimInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'tr') ;
                else if (shapes[i].ty === 'el') arr.push(ellipseInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'sr') arr.push(starInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'sh') arr.push(ShapePathInterface(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'rc') arr.push(rectInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'rd') arr.push(roundedInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'rp') arr.push(repeaterInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'gf') arr.push(gradientFillInterfaceFactory(shapes[i], view[i], propertyGroup));
                else arr.push(defaultInterfaceFactory(shapes[i], view[i], propertyGroup));
            }
            return arr;
        }
        function contentsInterfaceFactory(shape, view, propertyGroup) {
            var interfaces;
            var interfaceFunction = function _interfaceFunction(value) {
                var i = 0;
                var len = interfaces.length;
                while(i < len){
                    if (interfaces[i]._name === value || interfaces[i].mn === value || interfaces[i].propertyIndex === value || interfaces[i].ix === value || interfaces[i].ind === value) return interfaces[i];
                    i += 1;
                }
                if (typeof value === 'number') return interfaces[value - 1];
                return null;
            };
            interfaceFunction.propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            interfaces = iterateElements(shape.it, view.it, interfaceFunction.propertyGroup);
            interfaceFunction.numProperties = interfaces.length;
            var transformInterface = transformInterfaceFactory(shape.it[shape.it.length - 1], view.it[view.it.length - 1], interfaceFunction.propertyGroup);
            interfaceFunction.transform = transformInterface;
            interfaceFunction.propertyIndex = shape.cix;
            interfaceFunction._name = shape.nm;
            return interfaceFunction;
        }
        function groupInterfaceFactory(shape, view, propertyGroup) {
            var interfaceFunction = function _interfaceFunction(value) {
                switch(value){
                    case 'ADBE Vectors Group':
                    case 'Contents':
                    case 2:
                        return interfaceFunction.content;
                    // Not necessary for now. Keeping them here in case a new case appears
                    // case 'ADBE Vector Transform Group':
                    // case 3:
                    default:
                        return interfaceFunction.transform;
                }
            };
            interfaceFunction.propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            var content = contentsInterfaceFactory(shape, view, interfaceFunction.propertyGroup);
            var transformInterface = transformInterfaceFactory(shape.it[shape.it.length - 1], view.it[view.it.length - 1], interfaceFunction.propertyGroup);
            interfaceFunction.content = content;
            interfaceFunction.transform = transformInterface;
            Object.defineProperty(interfaceFunction, '_name', {
                get: function get() {
                    return shape.nm;
                }
            }); // interfaceFunction.content = interfaceFunction;
            interfaceFunction.numProperties = shape.np;
            interfaceFunction.propertyIndex = shape.ix;
            interfaceFunction.nm = shape.nm;
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        function fillInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(val) {
                if (val === 'Color' || val === 'color') return interfaceFunction.color;
                if (val === 'Opacity' || val === 'opacity') return interfaceFunction.opacity;
                return null;
            }
            Object.defineProperties(interfaceFunction, {
                color: {
                    get: ExpressionPropertyInterface(view.c)
                },
                opacity: {
                    get: ExpressionPropertyInterface(view.o)
                },
                _name: {
                    value: shape.nm
                },
                mn: {
                    value: shape.mn
                }
            });
            view.c.setGroupProperty(PropertyInterface('Color', propertyGroup));
            view.o.setGroupProperty(PropertyInterface('Opacity', propertyGroup));
            return interfaceFunction;
        }
        function gradientFillInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(val) {
                if (val === 'Start Point' || val === 'start point') return interfaceFunction.startPoint;
                if (val === 'End Point' || val === 'end point') return interfaceFunction.endPoint;
                if (val === 'Opacity' || val === 'opacity') return interfaceFunction.opacity;
                return null;
            }
            Object.defineProperties(interfaceFunction, {
                startPoint: {
                    get: ExpressionPropertyInterface(view.s)
                },
                endPoint: {
                    get: ExpressionPropertyInterface(view.e)
                },
                opacity: {
                    get: ExpressionPropertyInterface(view.o)
                },
                type: {
                    get: function get() {
                        return 'a';
                    }
                },
                _name: {
                    value: shape.nm
                },
                mn: {
                    value: shape.mn
                }
            });
            view.s.setGroupProperty(PropertyInterface('Start Point', propertyGroup));
            view.e.setGroupProperty(PropertyInterface('End Point', propertyGroup));
            view.o.setGroupProperty(PropertyInterface('Opacity', propertyGroup));
            return interfaceFunction;
        }
        function defaultInterfaceFactory() {
            function interfaceFunction() {
                return null;
            }
            return interfaceFunction;
        }
        function strokeInterfaceFactory(shape, view, propertyGroup) {
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            var _dashPropertyGroup = propertyGroupFactory(dashOb, _propertyGroup);
            function addPropertyToDashOb(i) {
                Object.defineProperty(dashOb, shape.d[i].nm, {
                    get: ExpressionPropertyInterface(view.d.dataProps[i].p)
                });
            }
            var i;
            var len = shape.d ? shape.d.length : 0;
            var dashOb = {};
            for(i = 0; i < len; i += 1){
                addPropertyToDashOb(i);
                view.d.dataProps[i].p.setGroupProperty(_dashPropertyGroup);
            }
            function interfaceFunction(val) {
                if (val === 'Color' || val === 'color') return interfaceFunction.color;
                if (val === 'Opacity' || val === 'opacity') return interfaceFunction.opacity;
                if (val === 'Stroke Width' || val === 'stroke width') return interfaceFunction.strokeWidth;
                return null;
            }
            Object.defineProperties(interfaceFunction, {
                color: {
                    get: ExpressionPropertyInterface(view.c)
                },
                opacity: {
                    get: ExpressionPropertyInterface(view.o)
                },
                strokeWidth: {
                    get: ExpressionPropertyInterface(view.w)
                },
                dash: {
                    get: function get() {
                        return dashOb;
                    }
                },
                _name: {
                    value: shape.nm
                },
                mn: {
                    value: shape.mn
                }
            });
            view.c.setGroupProperty(PropertyInterface('Color', _propertyGroup));
            view.o.setGroupProperty(PropertyInterface('Opacity', _propertyGroup));
            view.w.setGroupProperty(PropertyInterface('Stroke Width', _propertyGroup));
            return interfaceFunction;
        }
        function trimInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(val) {
                if (val === shape.e.ix || val === 'End' || val === 'end') return interfaceFunction.end;
                if (val === shape.s.ix) return interfaceFunction.start;
                if (val === shape.o.ix) return interfaceFunction.offset;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            interfaceFunction.propertyIndex = shape.ix;
            view.s.setGroupProperty(PropertyInterface('Start', _propertyGroup));
            view.e.setGroupProperty(PropertyInterface('End', _propertyGroup));
            view.o.setGroupProperty(PropertyInterface('Offset', _propertyGroup));
            interfaceFunction.propertyIndex = shape.ix;
            interfaceFunction.propertyGroup = propertyGroup;
            Object.defineProperties(interfaceFunction, {
                start: {
                    get: ExpressionPropertyInterface(view.s)
                },
                end: {
                    get: ExpressionPropertyInterface(view.e)
                },
                offset: {
                    get: ExpressionPropertyInterface(view.o)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        function transformInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(value) {
                if (shape.a.ix === value || value === 'Anchor Point') return interfaceFunction.anchorPoint;
                if (shape.o.ix === value || value === 'Opacity') return interfaceFunction.opacity;
                if (shape.p.ix === value || value === 'Position') return interfaceFunction.position;
                if (shape.r.ix === value || value === 'Rotation' || value === 'ADBE Vector Rotation') return interfaceFunction.rotation;
                if (shape.s.ix === value || value === 'Scale') return interfaceFunction.scale;
                if (shape.sk && shape.sk.ix === value || value === 'Skew') return interfaceFunction.skew;
                if (shape.sa && shape.sa.ix === value || value === 'Skew Axis') return interfaceFunction.skewAxis;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            view.transform.mProps.o.setGroupProperty(PropertyInterface('Opacity', _propertyGroup));
            view.transform.mProps.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
            view.transform.mProps.a.setGroupProperty(PropertyInterface('Anchor Point', _propertyGroup));
            view.transform.mProps.s.setGroupProperty(PropertyInterface('Scale', _propertyGroup));
            view.transform.mProps.r.setGroupProperty(PropertyInterface('Rotation', _propertyGroup));
            if (view.transform.mProps.sk) {
                view.transform.mProps.sk.setGroupProperty(PropertyInterface('Skew', _propertyGroup));
                view.transform.mProps.sa.setGroupProperty(PropertyInterface('Skew Angle', _propertyGroup));
            }
            view.transform.op.setGroupProperty(PropertyInterface('Opacity', _propertyGroup));
            Object.defineProperties(interfaceFunction, {
                opacity: {
                    get: ExpressionPropertyInterface(view.transform.mProps.o)
                },
                position: {
                    get: ExpressionPropertyInterface(view.transform.mProps.p)
                },
                anchorPoint: {
                    get: ExpressionPropertyInterface(view.transform.mProps.a)
                },
                scale: {
                    get: ExpressionPropertyInterface(view.transform.mProps.s)
                },
                rotation: {
                    get: ExpressionPropertyInterface(view.transform.mProps.r)
                },
                skew: {
                    get: ExpressionPropertyInterface(view.transform.mProps.sk)
                },
                skewAxis: {
                    get: ExpressionPropertyInterface(view.transform.mProps.sa)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.ty = 'tr';
            interfaceFunction.mn = shape.mn;
            interfaceFunction.propertyGroup = propertyGroup;
            return interfaceFunction;
        }
        function ellipseInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(value) {
                if (shape.p.ix === value) return interfaceFunction.position;
                if (shape.s.ix === value) return interfaceFunction.size;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            interfaceFunction.propertyIndex = shape.ix;
            var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
            prop.s.setGroupProperty(PropertyInterface('Size', _propertyGroup));
            prop.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
            Object.defineProperties(interfaceFunction, {
                size: {
                    get: ExpressionPropertyInterface(prop.s)
                },
                position: {
                    get: ExpressionPropertyInterface(prop.p)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        function starInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(value) {
                if (shape.p.ix === value) return interfaceFunction.position;
                if (shape.r.ix === value) return interfaceFunction.rotation;
                if (shape.pt.ix === value) return interfaceFunction.points;
                if (shape.or.ix === value || value === 'ADBE Vector Star Outer Radius') return interfaceFunction.outerRadius;
                if (shape.os.ix === value) return interfaceFunction.outerRoundness;
                if (shape.ir && (shape.ir.ix === value || value === 'ADBE Vector Star Inner Radius')) return interfaceFunction.innerRadius;
                if (shape.is && shape.is.ix === value) return interfaceFunction.innerRoundness;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
            interfaceFunction.propertyIndex = shape.ix;
            prop.or.setGroupProperty(PropertyInterface('Outer Radius', _propertyGroup));
            prop.os.setGroupProperty(PropertyInterface('Outer Roundness', _propertyGroup));
            prop.pt.setGroupProperty(PropertyInterface('Points', _propertyGroup));
            prop.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
            prop.r.setGroupProperty(PropertyInterface('Rotation', _propertyGroup));
            if (shape.ir) {
                prop.ir.setGroupProperty(PropertyInterface('Inner Radius', _propertyGroup));
                prop.is.setGroupProperty(PropertyInterface('Inner Roundness', _propertyGroup));
            }
            Object.defineProperties(interfaceFunction, {
                position: {
                    get: ExpressionPropertyInterface(prop.p)
                },
                rotation: {
                    get: ExpressionPropertyInterface(prop.r)
                },
                points: {
                    get: ExpressionPropertyInterface(prop.pt)
                },
                outerRadius: {
                    get: ExpressionPropertyInterface(prop.or)
                },
                outerRoundness: {
                    get: ExpressionPropertyInterface(prop.os)
                },
                innerRadius: {
                    get: ExpressionPropertyInterface(prop.ir)
                },
                innerRoundness: {
                    get: ExpressionPropertyInterface(prop.is)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        function rectInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(value) {
                if (shape.p.ix === value) return interfaceFunction.position;
                if (shape.r.ix === value) return interfaceFunction.roundness;
                if (shape.s.ix === value || value === 'Size' || value === 'ADBE Vector Rect Size') return interfaceFunction.size;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
            interfaceFunction.propertyIndex = shape.ix;
            prop.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
            prop.s.setGroupProperty(PropertyInterface('Size', _propertyGroup));
            prop.r.setGroupProperty(PropertyInterface('Rotation', _propertyGroup));
            Object.defineProperties(interfaceFunction, {
                position: {
                    get: ExpressionPropertyInterface(prop.p)
                },
                roundness: {
                    get: ExpressionPropertyInterface(prop.r)
                },
                size: {
                    get: ExpressionPropertyInterface(prop.s)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        function roundedInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(value) {
                if (shape.r.ix === value || value === 'Round Corners 1') return interfaceFunction.radius;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            var prop = view;
            interfaceFunction.propertyIndex = shape.ix;
            prop.rd.setGroupProperty(PropertyInterface('Radius', _propertyGroup));
            Object.defineProperties(interfaceFunction, {
                radius: {
                    get: ExpressionPropertyInterface(prop.rd)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        function repeaterInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(value) {
                if (shape.c.ix === value || value === 'Copies') return interfaceFunction.copies;
                if (shape.o.ix === value || value === 'Offset') return interfaceFunction.offset;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            var prop = view;
            interfaceFunction.propertyIndex = shape.ix;
            prop.c.setGroupProperty(PropertyInterface('Copies', _propertyGroup));
            prop.o.setGroupProperty(PropertyInterface('Offset', _propertyGroup));
            Object.defineProperties(interfaceFunction, {
                copies: {
                    get: ExpressionPropertyInterface(prop.c)
                },
                offset: {
                    get: ExpressionPropertyInterface(prop.o)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        return function(shapes, view, propertyGroup) {
            var interfaces;
            function _interfaceFunction(value) {
                if (typeof value === 'number') {
                    value = value === undefined ? 1 : value;
                    if (value === 0) return propertyGroup;
                    return interfaces[value - 1];
                }
                var i = 0;
                var len = interfaces.length;
                while(i < len){
                    if (interfaces[i]._name === value) return interfaces[i];
                    i += 1;
                }
                return null;
            }
            function parentGroupWrapper() {
                return propertyGroup;
            }
            _interfaceFunction.propertyGroup = propertyGroupFactory(_interfaceFunction, parentGroupWrapper);
            interfaces = iterateElements(shapes, view, _interfaceFunction.propertyGroup);
            _interfaceFunction.numProperties = interfaces.length;
            _interfaceFunction._name = 'Contents';
            return _interfaceFunction;
        };
    }();
    var TextExpressionInterface = function() {
        return function(elem) {
            var _sourceText;
            function _thisLayerFunction(name) {
                switch(name){
                    case 'ADBE Text Document':
                        return _thisLayerFunction.sourceText;
                    default:
                        return null;
                }
            }
            Object.defineProperty(_thisLayerFunction, 'sourceText', {
                get: function get() {
                    elem.textProperty.getValue();
                    var stringValue = elem.textProperty.currentData.t;
                    if (!_sourceText || stringValue !== _sourceText.value) {
                        _sourceText = new String(stringValue); // eslint-disable-line no-new-wrappers
                        // If stringValue is an empty string, eval returns undefined, so it has to be returned as a String primitive
                        _sourceText.value = stringValue || new String(stringValue); // eslint-disable-line no-new-wrappers
                        Object.defineProperty(_sourceText, 'style', {
                            get: function get() {
                                return {
                                    fillColor: elem.textProperty.currentData.fc
                                };
                            }
                        });
                    }
                    return _sourceText;
                }
            });
            return _thisLayerFunction;
        };
    }();
    function _typeof(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof1(obj) {
            return typeof obj;
        };
        else _typeof = function _typeof1(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof(obj);
    }
    var FootageInterface = function() {
        var outlineInterfaceFactory = function outlineInterfaceFactory(elem) {
            var currentPropertyName = '';
            var currentProperty = elem.getFootageData();
            function init() {
                currentPropertyName = '';
                currentProperty = elem.getFootageData();
                return searchProperty;
            }
            function searchProperty(value) {
                if (currentProperty[value]) {
                    currentPropertyName = value;
                    currentProperty = currentProperty[value];
                    if (_typeof(currentProperty) === 'object') return searchProperty;
                    return currentProperty;
                }
                var propertyNameIndex = value.indexOf(currentPropertyName);
                if (propertyNameIndex !== -1) {
                    var index = parseInt(value.substr(propertyNameIndex + currentPropertyName.length), 10);
                    currentProperty = currentProperty[index];
                    if (_typeof(currentProperty) === 'object') return searchProperty;
                    return currentProperty;
                }
                return '';
            }
            return init;
        };
        var dataInterfaceFactory = function dataInterfaceFactory(elem) {
            function interfaceFunction(value) {
                if (value === 'Outline') return interfaceFunction.outlineInterface();
                return null;
            }
            interfaceFunction._name = 'Outline';
            interfaceFunction.outlineInterface = outlineInterfaceFactory(elem);
            return interfaceFunction;
        };
        return function(elem) {
            function _interfaceFunction(value) {
                if (value === 'Data') return _interfaceFunction.dataInterface;
                return null;
            }
            _interfaceFunction._name = 'Data';
            _interfaceFunction.dataInterface = dataInterfaceFactory(elem);
            return _interfaceFunction;
        };
    }();
    var interfaces = {
        layer: LayerExpressionInterface,
        effects: EffectsExpressionInterface,
        comp: CompExpressionInterface,
        shape: ShapeExpressionInterface,
        text: TextExpressionInterface,
        footage: FootageInterface
    };
    function getInterface(type) {
        return interfaces[type] || null;
    }
    var expressionHelpers = function() {
        function searchExpressions(elem, data, prop) {
            if (data.x) {
                prop.k = true;
                prop.x = true;
                prop.initiateExpression = ExpressionManager.initiateExpression;
                prop.effectsSequence.push(prop.initiateExpression(elem, data, prop).bind(prop));
            }
        }
        function getValueAtTime(frameNum) {
            frameNum *= this.elem.globalData.frameRate;
            frameNum -= this.offsetTime;
            if (frameNum !== this._cachingAtTime.lastFrame) {
                this._cachingAtTime.lastIndex = this._cachingAtTime.lastFrame < frameNum ? this._cachingAtTime.lastIndex : 0;
                this._cachingAtTime.value = this.interpolateValue(frameNum, this._cachingAtTime);
                this._cachingAtTime.lastFrame = frameNum;
            }
            return this._cachingAtTime.value;
        }
        function getSpeedAtTime(frameNum) {
            var delta = -0.01;
            var v1 = this.getValueAtTime(frameNum);
            var v2 = this.getValueAtTime(frameNum + delta);
            var speed = 0;
            if (v1.length) {
                var i;
                for(i = 0; i < v1.length; i += 1)speed += Math.pow(v2[i] - v1[i], 2);
                speed = Math.sqrt(speed) * 100;
            } else speed = 0;
            return speed;
        }
        function getVelocityAtTime(frameNum) {
            if (this.vel !== undefined) return this.vel;
            var delta = -0.001; // frameNum += this.elem.data.st;
            var v1 = this.getValueAtTime(frameNum);
            var v2 = this.getValueAtTime(frameNum + delta);
            var velocity;
            if (v1.length) {
                velocity = createTypedArray('float32', v1.length);
                var i;
                for(i = 0; i < v1.length; i += 1)// removing frameRate
                // if needed, don't add it here
                // velocity[i] = this.elem.globalData.frameRate*((v2[i] - v1[i])/delta);
                velocity[i] = (v2[i] - v1[i]) / delta;
            } else velocity = (v2 - v1) / delta;
            return velocity;
        }
        function getStaticValueAtTime() {
            return this.pv;
        }
        function setGroupProperty(propertyGroup) {
            this.propertyGroup = propertyGroup;
        }
        return {
            searchExpressions: searchExpressions,
            getSpeedAtTime: getSpeedAtTime,
            getVelocityAtTime: getVelocityAtTime,
            getValueAtTime: getValueAtTime,
            getStaticValueAtTime: getStaticValueAtTime,
            setGroupProperty: setGroupProperty
        };
    }();
    function addPropertyDecorator() {
        function loopOut(type, duration, durationFlag) {
            if (!this.k || !this.keyframes) return this.pv;
            type = type ? type.toLowerCase() : '';
            var currentFrame = this.comp.renderedFrame;
            var keyframes = this.keyframes;
            var lastKeyFrame = keyframes[keyframes.length - 1].t;
            if (currentFrame <= lastKeyFrame) return this.pv;
            var cycleDuration;
            var firstKeyFrame;
            if (!durationFlag) {
                if (!duration || duration > keyframes.length - 1) duration = keyframes.length - 1;
                firstKeyFrame = keyframes[keyframes.length - 1 - duration].t;
                cycleDuration = lastKeyFrame - firstKeyFrame;
            } else {
                if (!duration) cycleDuration = Math.max(0, lastKeyFrame - this.elem.data.ip);
                else cycleDuration = Math.abs(lastKeyFrame - this.elem.comp.globalData.frameRate * duration);
                firstKeyFrame = lastKeyFrame - cycleDuration;
            }
            var i;
            var len;
            var ret;
            if (type === 'pingpong') {
                var iterations = Math.floor((currentFrame - firstKeyFrame) / cycleDuration);
                if (iterations % 2 !== 0) return this.getValueAtTime((cycleDuration - (currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
            } else if (type === 'offset') {
                var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
                var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
                var current = this.getValueAtTime(((currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
                var repeats = Math.floor((currentFrame - firstKeyFrame) / cycleDuration);
                if (this.pv.length) {
                    ret = new Array(initV.length);
                    len = ret.length;
                    for(i = 0; i < len; i += 1)ret[i] = (endV[i] - initV[i]) * repeats + current[i];
                    return ret;
                }
                return (endV - initV) * repeats + current;
            } else if (type === 'continue') {
                var lastValue = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
                var nextLastValue = this.getValueAtTime((lastKeyFrame - 0.001) / this.comp.globalData.frameRate, 0);
                if (this.pv.length) {
                    ret = new Array(lastValue.length);
                    len = ret.length;
                    for(i = 0; i < len; i += 1)ret[i] = lastValue[i] + (lastValue[i] - nextLastValue[i]) * ((currentFrame - lastKeyFrame) / this.comp.globalData.frameRate) / 0.0005; // eslint-disable-line
                    return ret;
                }
                return lastValue + (lastValue - nextLastValue) * ((currentFrame - lastKeyFrame) / 0.001);
            }
            return this.getValueAtTime(((currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
        }
        function loopIn(type, duration, durationFlag) {
            if (!this.k) return this.pv;
            type = type ? type.toLowerCase() : '';
            var currentFrame = this.comp.renderedFrame;
            var keyframes = this.keyframes;
            var firstKeyFrame = keyframes[0].t;
            if (currentFrame >= firstKeyFrame) return this.pv;
            var cycleDuration;
            var lastKeyFrame;
            if (!durationFlag) {
                if (!duration || duration > keyframes.length - 1) duration = keyframes.length - 1;
                lastKeyFrame = keyframes[duration].t;
                cycleDuration = lastKeyFrame - firstKeyFrame;
            } else {
                if (!duration) cycleDuration = Math.max(0, this.elem.data.op - firstKeyFrame);
                else cycleDuration = Math.abs(this.elem.comp.globalData.frameRate * duration);
                lastKeyFrame = firstKeyFrame + cycleDuration;
            }
            var i;
            var len;
            var ret;
            if (type === 'pingpong') {
                var iterations = Math.floor((firstKeyFrame - currentFrame) / cycleDuration);
                if (iterations % 2 === 0) return this.getValueAtTime(((firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
            } else if (type === 'offset') {
                var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
                var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
                var current = this.getValueAtTime((cycleDuration - (firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0);
                var repeats = Math.floor((firstKeyFrame - currentFrame) / cycleDuration) + 1;
                if (this.pv.length) {
                    ret = new Array(initV.length);
                    len = ret.length;
                    for(i = 0; i < len; i += 1)ret[i] = current[i] - (endV[i] - initV[i]) * repeats;
                    return ret;
                }
                return current - (endV - initV) * repeats;
            } else if (type === 'continue') {
                var firstValue = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
                var nextFirstValue = this.getValueAtTime((firstKeyFrame + 0.001) / this.comp.globalData.frameRate, 0);
                if (this.pv.length) {
                    ret = new Array(firstValue.length);
                    len = ret.length;
                    for(i = 0; i < len; i += 1)ret[i] = firstValue[i] + (firstValue[i] - nextFirstValue[i]) * (firstKeyFrame - currentFrame) / 0.001;
                    return ret;
                }
                return firstValue + (firstValue - nextFirstValue) * (firstKeyFrame - currentFrame) / 0.001;
            }
            return this.getValueAtTime((cycleDuration - ((firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame)) / this.comp.globalData.frameRate, 0); // eslint-disable-line
        }
        function smooth(width, samples) {
            if (!this.k) return this.pv;
            width = (width || 0.4) * 0.5;
            samples = Math.floor(samples || 5);
            if (samples <= 1) return this.pv;
            var currentTime = this.comp.renderedFrame / this.comp.globalData.frameRate;
            var initFrame = currentTime - width;
            var endFrame = currentTime + width;
            var sampleFrequency = samples > 1 ? (endFrame - initFrame) / (samples - 1) : 1;
            var i = 0;
            var j = 0;
            var value;
            if (this.pv.length) value = createTypedArray('float32', this.pv.length);
            else value = 0;
            var sampleValue;
            while(i < samples){
                sampleValue = this.getValueAtTime(initFrame + i * sampleFrequency);
                if (this.pv.length) for(j = 0; j < this.pv.length; j += 1)value[j] += sampleValue[j];
                else value += sampleValue;
                i += 1;
            }
            if (this.pv.length) for(j = 0; j < this.pv.length; j += 1)value[j] /= samples;
            else value /= samples;
            return value;
        }
        function getTransformValueAtTime(time) {
            if (!this._transformCachingAtTime) this._transformCachingAtTime = {
                v: new Matrix()
            };
             /// /
            var matrix = this._transformCachingAtTime.v;
            matrix.cloneFromProps(this.pre.props);
            if (this.appliedTransformations < 1) {
                var anchor = this.a.getValueAtTime(time);
                matrix.translate(-anchor[0] * this.a.mult, -anchor[1] * this.a.mult, anchor[2] * this.a.mult);
            }
            if (this.appliedTransformations < 2) {
                var scale = this.s.getValueAtTime(time);
                matrix.scale(scale[0] * this.s.mult, scale[1] * this.s.mult, scale[2] * this.s.mult);
            }
            if (this.sk && this.appliedTransformations < 3) {
                var skew = this.sk.getValueAtTime(time);
                var skewAxis = this.sa.getValueAtTime(time);
                matrix.skewFromAxis(-skew * this.sk.mult, skewAxis * this.sa.mult);
            }
            if (this.r && this.appliedTransformations < 4) {
                var rotation = this.r.getValueAtTime(time);
                matrix.rotate(-rotation * this.r.mult);
            } else if (!this.r && this.appliedTransformations < 4) {
                var rotationZ = this.rz.getValueAtTime(time);
                var rotationY = this.ry.getValueAtTime(time);
                var rotationX = this.rx.getValueAtTime(time);
                var orientation = this.or.getValueAtTime(time);
                matrix.rotateZ(-rotationZ * this.rz.mult).rotateY(rotationY * this.ry.mult).rotateX(rotationX * this.rx.mult).rotateZ(-orientation[2] * this.or.mult).rotateY(orientation[1] * this.or.mult).rotateX(orientation[0] * this.or.mult);
            }
            if (this.data.p && this.data.p.s) {
                var positionX = this.px.getValueAtTime(time);
                var positionY = this.py.getValueAtTime(time);
                if (this.data.p.z) {
                    var positionZ = this.pz.getValueAtTime(time);
                    matrix.translate(positionX * this.px.mult, positionY * this.py.mult, -positionZ * this.pz.mult);
                } else matrix.translate(positionX * this.px.mult, positionY * this.py.mult, 0);
            } else {
                var position = this.p.getValueAtTime(time);
                matrix.translate(position[0] * this.p.mult, position[1] * this.p.mult, -position[2] * this.p.mult);
            }
            return matrix; /// /
        }
        function getTransformStaticValueAtTime() {
            return this.v.clone(new Matrix());
        }
        var getTransformProperty = TransformPropertyFactory.getTransformProperty;
        TransformPropertyFactory.getTransformProperty = function(elem, data, container) {
            var prop = getTransformProperty(elem, data, container);
            if (prop.dynamicProperties.length) prop.getValueAtTime = getTransformValueAtTime.bind(prop);
            else prop.getValueAtTime = getTransformStaticValueAtTime.bind(prop);
            prop.setGroupProperty = expressionHelpers.setGroupProperty;
            return prop;
        };
        var propertyGetProp = PropertyFactory.getProp;
        PropertyFactory.getProp = function(elem, data, type, mult, container) {
            var prop = propertyGetProp(elem, data, type, mult, container); // prop.getVelocityAtTime = getVelocityAtTime;
            // prop.loopOut = loopOut;
            // prop.loopIn = loopIn;
            if (prop.kf) prop.getValueAtTime = expressionHelpers.getValueAtTime.bind(prop);
            else prop.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(prop);
            prop.setGroupProperty = expressionHelpers.setGroupProperty;
            prop.loopOut = loopOut;
            prop.loopIn = loopIn;
            prop.smooth = smooth;
            prop.getVelocityAtTime = expressionHelpers.getVelocityAtTime.bind(prop);
            prop.getSpeedAtTime = expressionHelpers.getSpeedAtTime.bind(prop);
            prop.numKeys = data.a === 1 ? data.k.length : 0;
            prop.propertyIndex = data.ix;
            var value = 0;
            if (type !== 0) value = createTypedArray('float32', data.a === 1 ? data.k[0].s.length : data.k.length);
            prop._cachingAtTime = {
                lastFrame: initialDefaultFrame,
                lastIndex: 0,
                value: value
            };
            expressionHelpers.searchExpressions(elem, data, prop);
            if (prop.k) container.addDynamicProperty(prop);
            return prop;
        };
        function getShapeValueAtTime(frameNum) {
            // For now this caching object is created only when needed instead of creating it when the shape is initialized.
            if (!this._cachingAtTime) this._cachingAtTime = {
                shapeValue: shapePool.clone(this.pv),
                lastIndex: 0,
                lastTime: initialDefaultFrame
            };
            frameNum *= this.elem.globalData.frameRate;
            frameNum -= this.offsetTime;
            if (frameNum !== this._cachingAtTime.lastTime) {
                this._cachingAtTime.lastIndex = this._cachingAtTime.lastTime < frameNum ? this._caching.lastIndex : 0;
                this._cachingAtTime.lastTime = frameNum;
                this.interpolateShape(frameNum, this._cachingAtTime.shapeValue, this._cachingAtTime);
            }
            return this._cachingAtTime.shapeValue;
        }
        var ShapePropertyConstructorFunction = ShapePropertyFactory.getConstructorFunction();
        var KeyframedShapePropertyConstructorFunction = ShapePropertyFactory.getKeyframedConstructorFunction();
        function ShapeExpressions() {}
        ShapeExpressions.prototype = {
            vertices: function vertices(prop, time) {
                if (this.k) this.getValue();
                var shapePath = this.v;
                if (time !== undefined) shapePath = this.getValueAtTime(time, 0);
                var i;
                var len = shapePath._length;
                var vertices = shapePath[prop];
                var points = shapePath.v;
                var arr = createSizedArray(len);
                for(i = 0; i < len; i += 1)if (prop === 'i' || prop === 'o') arr[i] = [
                    vertices[i][0] - points[i][0],
                    vertices[i][1] - points[i][1]
                ];
                else arr[i] = [
                    vertices[i][0],
                    vertices[i][1]
                ];
                return arr;
            },
            points: function points(time) {
                return this.vertices('v', time);
            },
            inTangents: function inTangents(time) {
                return this.vertices('i', time);
            },
            outTangents: function outTangents(time) {
                return this.vertices('o', time);
            },
            isClosed: function isClosed() {
                return this.v.c;
            },
            pointOnPath: function pointOnPath(perc, time) {
                var shapePath = this.v;
                if (time !== undefined) shapePath = this.getValueAtTime(time, 0);
                if (!this._segmentsLength) this._segmentsLength = bez.getSegmentsLength(shapePath);
                var segmentsLength = this._segmentsLength;
                var lengths = segmentsLength.lengths;
                var lengthPos = segmentsLength.totalLength * perc;
                var i = 0;
                var len = lengths.length;
                var accumulatedLength = 0;
                var pt;
                while(i < len){
                    if (accumulatedLength + lengths[i].addedLength > lengthPos) {
                        var initIndex = i;
                        var endIndex = shapePath.c && i === len - 1 ? 0 : i + 1;
                        var segmentPerc = (lengthPos - accumulatedLength) / lengths[i].addedLength;
                        pt = bez.getPointInSegment(shapePath.v[initIndex], shapePath.v[endIndex], shapePath.o[initIndex], shapePath.i[endIndex], segmentPerc, lengths[i]);
                        break;
                    } else accumulatedLength += lengths[i].addedLength;
                    i += 1;
                }
                if (!pt) pt = shapePath.c ? [
                    shapePath.v[0][0],
                    shapePath.v[0][1]
                ] : [
                    shapePath.v[shapePath._length - 1][0],
                    shapePath.v[shapePath._length - 1][1]
                ];
                return pt;
            },
            vectorOnPath: function vectorOnPath(perc, time, vectorType) {
                // perc doesn't use triple equality because it can be a Number object as well as a primitive.
                if (perc == 1) // eslint-disable-line eqeqeq
                perc = this.v.c;
                else if (perc == 0) // eslint-disable-line eqeqeq
                perc = 0.999;
                var pt1 = this.pointOnPath(perc, time);
                var pt2 = this.pointOnPath(perc + 0.001, time);
                var xLength = pt2[0] - pt1[0];
                var yLength = pt2[1] - pt1[1];
                var magnitude = Math.sqrt(Math.pow(xLength, 2) + Math.pow(yLength, 2));
                if (magnitude === 0) return [
                    0,
                    0
                ];
                var unitVector = vectorType === 'tangent' ? [
                    xLength / magnitude,
                    yLength / magnitude
                ] : [
                    -yLength / magnitude,
                    xLength / magnitude
                ];
                return unitVector;
            },
            tangentOnPath: function tangentOnPath(perc, time) {
                return this.vectorOnPath(perc, time, 'tangent');
            },
            normalOnPath: function normalOnPath(perc, time) {
                return this.vectorOnPath(perc, time, 'normal');
            },
            setGroupProperty: expressionHelpers.setGroupProperty,
            getValueAtTime: expressionHelpers.getStaticValueAtTime
        };
        extendPrototype([
            ShapeExpressions
        ], ShapePropertyConstructorFunction);
        extendPrototype([
            ShapeExpressions
        ], KeyframedShapePropertyConstructorFunction);
        KeyframedShapePropertyConstructorFunction.prototype.getValueAtTime = getShapeValueAtTime;
        KeyframedShapePropertyConstructorFunction.prototype.initiateExpression = ExpressionManager.initiateExpression;
        var propertyGetShapeProp = ShapePropertyFactory.getShapeProp;
        ShapePropertyFactory.getShapeProp = function(elem, data, type, arr, trims) {
            var prop = propertyGetShapeProp(elem, data, type, arr, trims);
            prop.propertyIndex = data.ix;
            prop.lock = false;
            if (type === 3) expressionHelpers.searchExpressions(elem, data.pt, prop);
            else if (type === 4) expressionHelpers.searchExpressions(elem, data.ks, prop);
            if (prop.k) elem.addDynamicProperty(prop);
            return prop;
        };
    }
    function initialize$1() {
        addPropertyDecorator();
    }
    function addDecorator() {
        function searchExpressions() {
            if (this.data.d.x) {
                this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem, this.data.d, this);
                this.addEffect(this.getExpressionValue.bind(this));
                return true;
            }
            return null;
        }
        TextProperty.prototype.getExpressionValue = function(currentValue, text) {
            var newValue = this.calculateExpression(text);
            if (currentValue.t !== newValue) {
                var newData = {};
                this.copyData(newData, currentValue);
                newData.t = newValue.toString();
                newData.__complete = false;
                return newData;
            }
            return currentValue;
        };
        TextProperty.prototype.searchProperty = function() {
            var isKeyframed = this.searchKeyframes();
            var hasExpressions = this.searchExpressions();
            this.kf = isKeyframed || hasExpressions;
            return this.kf;
        };
        TextProperty.prototype.searchExpressions = searchExpressions;
    }
    function initialize() {
        addDecorator();
    }
    function SVGComposableEffect() {}
    SVGComposableEffect.prototype = {
        createMergeNode: function createMergeNode(resultId, ins) {
            var feMerge = createNS('feMerge');
            feMerge.setAttribute('result', resultId);
            var feMergeNode;
            var i;
            for(i = 0; i < ins.length; i += 1){
                feMergeNode = createNS('feMergeNode');
                feMergeNode.setAttribute('in', ins[i]);
                feMerge.appendChild(feMergeNode);
                feMerge.appendChild(feMergeNode);
            }
            return feMerge;
        }
    };
    var linearFilterValue = '0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0';
    function SVGTintFilter(filter, filterManager, elem, id, source) {
        this.filterManager = filterManager;
        var feColorMatrix = createNS('feColorMatrix');
        feColorMatrix.setAttribute('type', 'matrix');
        feColorMatrix.setAttribute('color-interpolation-filters', 'linearRGB');
        feColorMatrix.setAttribute('values', linearFilterValue + ' 1 0');
        this.linearFilter = feColorMatrix;
        feColorMatrix.setAttribute('result', id + '_tint_1');
        filter.appendChild(feColorMatrix);
        feColorMatrix = createNS('feColorMatrix');
        feColorMatrix.setAttribute('type', 'matrix');
        feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
        feColorMatrix.setAttribute('values', '1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');
        feColorMatrix.setAttribute('result', id + '_tint_2');
        filter.appendChild(feColorMatrix);
        this.matrixFilter = feColorMatrix;
        var feMerge = this.createMergeNode(id, [
            source,
            id + '_tint_1',
            id + '_tint_2'
        ]);
        filter.appendChild(feMerge);
    }
    extendPrototype([
        SVGComposableEffect
    ], SVGTintFilter);
    SVGTintFilter.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
            var colorBlack = this.filterManager.effectElements[0].p.v;
            var colorWhite = this.filterManager.effectElements[1].p.v;
            var opacity = this.filterManager.effectElements[2].p.v / 100;
            this.linearFilter.setAttribute('values', linearFilterValue + ' ' + opacity + ' 0');
            this.matrixFilter.setAttribute('values', colorWhite[0] - colorBlack[0] + ' 0 0 0 ' + colorBlack[0] + ' ' + (colorWhite[1] - colorBlack[1]) + ' 0 0 0 ' + colorBlack[1] + ' ' + (colorWhite[2] - colorBlack[2]) + ' 0 0 0 ' + colorBlack[2] + ' 0 0 0 1 0');
        }
    };
    function SVGFillFilter(filter, filterManager, elem, id) {
        this.filterManager = filterManager;
        var feColorMatrix = createNS('feColorMatrix');
        feColorMatrix.setAttribute('type', 'matrix');
        feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
        feColorMatrix.setAttribute('values', '1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');
        feColorMatrix.setAttribute('result', id);
        filter.appendChild(feColorMatrix);
        this.matrixFilter = feColorMatrix;
    }
    SVGFillFilter.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
            var color = this.filterManager.effectElements[2].p.v;
            var opacity = this.filterManager.effectElements[6].p.v;
            this.matrixFilter.setAttribute('values', '0 0 0 0 ' + color[0] + ' 0 0 0 0 ' + color[1] + ' 0 0 0 0 ' + color[2] + ' 0 0 0 ' + opacity + ' 0');
        }
    };
    function SVGStrokeEffect(fil, filterManager, elem) {
        this.initialized = false;
        this.filterManager = filterManager;
        this.elem = elem;
        this.paths = [];
    }
    SVGStrokeEffect.prototype.initialize = function() {
        var elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
        var path;
        var groupPath;
        var i;
        var len;
        if (this.filterManager.effectElements[1].p.v === 1) {
            len = this.elem.maskManager.masksProperties.length;
            i = 0;
        } else {
            i = this.filterManager.effectElements[0].p.v - 1;
            len = i + 1;
        }
        groupPath = createNS('g');
        groupPath.setAttribute('fill', 'none');
        groupPath.setAttribute('stroke-linecap', 'round');
        groupPath.setAttribute('stroke-dashoffset', 1);
        for(i; i < len; i += 1){
            path = createNS('path');
            groupPath.appendChild(path);
            this.paths.push({
                p: path,
                m: i
            });
        }
        if (this.filterManager.effectElements[10].p.v === 3) {
            var mask = createNS('mask');
            var id = createElementID();
            mask.setAttribute('id', id);
            mask.setAttribute('mask-type', 'alpha');
            mask.appendChild(groupPath);
            this.elem.globalData.defs.appendChild(mask);
            var g = createNS('g');
            g.setAttribute('mask', 'url(' + getLocationHref() + '#' + id + ')');
            while(elemChildren[0])g.appendChild(elemChildren[0]);
            this.elem.layerElement.appendChild(g);
            this.masker = mask;
            groupPath.setAttribute('stroke', '#fff');
        } else if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
            if (this.filterManager.effectElements[10].p.v === 2) {
                elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
                while(elemChildren.length)this.elem.layerElement.removeChild(elemChildren[0]);
            }
            this.elem.layerElement.appendChild(groupPath);
            this.elem.layerElement.removeAttribute('mask');
            groupPath.setAttribute('stroke', '#fff');
        }
        this.initialized = true;
        this.pathMasker = groupPath;
    };
    SVGStrokeEffect.prototype.renderFrame = function(forceRender) {
        if (!this.initialized) this.initialize();
        var i;
        var len = this.paths.length;
        var mask;
        var path;
        for(i = 0; i < len; i += 1)if (this.paths[i].m !== -1) {
            mask = this.elem.maskManager.viewData[this.paths[i].m];
            path = this.paths[i].p;
            if (forceRender || this.filterManager._mdf || mask.prop._mdf) path.setAttribute('d', mask.lastPath);
            if (forceRender || this.filterManager.effectElements[9].p._mdf || this.filterManager.effectElements[4].p._mdf || this.filterManager.effectElements[7].p._mdf || this.filterManager.effectElements[8].p._mdf || mask.prop._mdf) {
                var dasharrayValue;
                if (this.filterManager.effectElements[7].p.v !== 0 || this.filterManager.effectElements[8].p.v !== 100) {
                    var s = Math.min(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01;
                    var e = Math.max(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01;
                    var l = path.getTotalLength();
                    dasharrayValue = '0 0 0 ' + l * s + ' ';
                    var lineLength = l * (e - s);
                    var segment = 1 + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01;
                    var units = Math.floor(lineLength / segment);
                    var j;
                    for(j = 0; j < units; j += 1)dasharrayValue += '1 ' + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01 + ' ';
                    dasharrayValue += '0 ' + l * 10 + ' 0 0';
                } else dasharrayValue = '1 ' + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01;
                path.setAttribute('stroke-dasharray', dasharrayValue);
            }
        }
        if (forceRender || this.filterManager.effectElements[4].p._mdf) this.pathMasker.setAttribute('stroke-width', this.filterManager.effectElements[4].p.v * 2);
        if (forceRender || this.filterManager.effectElements[6].p._mdf) this.pathMasker.setAttribute('opacity', this.filterManager.effectElements[6].p.v);
        if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
            if (forceRender || this.filterManager.effectElements[3].p._mdf) {
                var color = this.filterManager.effectElements[3].p.v;
                this.pathMasker.setAttribute('stroke', 'rgb(' + bmFloor(color[0] * 255) + ',' + bmFloor(color[1] * 255) + ',' + bmFloor(color[2] * 255) + ')');
            }
        }
    };
    function SVGTritoneFilter(filter, filterManager, elem, id) {
        this.filterManager = filterManager;
        var feColorMatrix = createNS('feColorMatrix');
        feColorMatrix.setAttribute('type', 'matrix');
        feColorMatrix.setAttribute('color-interpolation-filters', 'linearRGB');
        feColorMatrix.setAttribute('values', '0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0');
        filter.appendChild(feColorMatrix);
        var feComponentTransfer = createNS('feComponentTransfer');
        feComponentTransfer.setAttribute('color-interpolation-filters', 'sRGB');
        feComponentTransfer.setAttribute('result', id);
        this.matrixFilter = feComponentTransfer;
        var feFuncR = createNS('feFuncR');
        feFuncR.setAttribute('type', 'table');
        feComponentTransfer.appendChild(feFuncR);
        this.feFuncR = feFuncR;
        var feFuncG = createNS('feFuncG');
        feFuncG.setAttribute('type', 'table');
        feComponentTransfer.appendChild(feFuncG);
        this.feFuncG = feFuncG;
        var feFuncB = createNS('feFuncB');
        feFuncB.setAttribute('type', 'table');
        feComponentTransfer.appendChild(feFuncB);
        this.feFuncB = feFuncB;
        filter.appendChild(feComponentTransfer);
    }
    SVGTritoneFilter.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
            var color1 = this.filterManager.effectElements[0].p.v;
            var color2 = this.filterManager.effectElements[1].p.v;
            var color3 = this.filterManager.effectElements[2].p.v;
            var tableR = color3[0] + ' ' + color2[0] + ' ' + color1[0];
            var tableG = color3[1] + ' ' + color2[1] + ' ' + color1[1];
            var tableB = color3[2] + ' ' + color2[2] + ' ' + color1[2];
            this.feFuncR.setAttribute('tableValues', tableR);
            this.feFuncG.setAttribute('tableValues', tableG);
            this.feFuncB.setAttribute('tableValues', tableB);
        }
    };
    function SVGProLevelsFilter(filter, filterManager, elem, id) {
        this.filterManager = filterManager;
        var effectElements = this.filterManager.effectElements;
        var feComponentTransfer = createNS('feComponentTransfer'); // Red
        if (effectElements[10].p.k || effectElements[10].p.v !== 0 || effectElements[11].p.k || effectElements[11].p.v !== 1 || effectElements[12].p.k || effectElements[12].p.v !== 1 || effectElements[13].p.k || effectElements[13].p.v !== 0 || effectElements[14].p.k || effectElements[14].p.v !== 1) this.feFuncR = this.createFeFunc('feFuncR', feComponentTransfer);
         // Green
        if (effectElements[17].p.k || effectElements[17].p.v !== 0 || effectElements[18].p.k || effectElements[18].p.v !== 1 || effectElements[19].p.k || effectElements[19].p.v !== 1 || effectElements[20].p.k || effectElements[20].p.v !== 0 || effectElements[21].p.k || effectElements[21].p.v !== 1) this.feFuncG = this.createFeFunc('feFuncG', feComponentTransfer);
         // Blue
        if (effectElements[24].p.k || effectElements[24].p.v !== 0 || effectElements[25].p.k || effectElements[25].p.v !== 1 || effectElements[26].p.k || effectElements[26].p.v !== 1 || effectElements[27].p.k || effectElements[27].p.v !== 0 || effectElements[28].p.k || effectElements[28].p.v !== 1) this.feFuncB = this.createFeFunc('feFuncB', feComponentTransfer);
         // Alpha
        if (effectElements[31].p.k || effectElements[31].p.v !== 0 || effectElements[32].p.k || effectElements[32].p.v !== 1 || effectElements[33].p.k || effectElements[33].p.v !== 1 || effectElements[34].p.k || effectElements[34].p.v !== 0 || effectElements[35].p.k || effectElements[35].p.v !== 1) this.feFuncA = this.createFeFunc('feFuncA', feComponentTransfer);
         // RGB
        if (this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA) {
            feComponentTransfer.setAttribute('color-interpolation-filters', 'sRGB');
            filter.appendChild(feComponentTransfer);
        }
        if (effectElements[3].p.k || effectElements[3].p.v !== 0 || effectElements[4].p.k || effectElements[4].p.v !== 1 || effectElements[5].p.k || effectElements[5].p.v !== 1 || effectElements[6].p.k || effectElements[6].p.v !== 0 || effectElements[7].p.k || effectElements[7].p.v !== 1) {
            feComponentTransfer = createNS('feComponentTransfer');
            feComponentTransfer.setAttribute('color-interpolation-filters', 'sRGB');
            feComponentTransfer.setAttribute('result', id);
            filter.appendChild(feComponentTransfer);
            this.feFuncRComposed = this.createFeFunc('feFuncR', feComponentTransfer);
            this.feFuncGComposed = this.createFeFunc('feFuncG', feComponentTransfer);
            this.feFuncBComposed = this.createFeFunc('feFuncB', feComponentTransfer);
        }
    }
    SVGProLevelsFilter.prototype.createFeFunc = function(type, feComponentTransfer) {
        var feFunc = createNS(type);
        feFunc.setAttribute('type', 'table');
        feComponentTransfer.appendChild(feFunc);
        return feFunc;
    };
    SVGProLevelsFilter.prototype.getTableValue = function(inputBlack, inputWhite, gamma, outputBlack, outputWhite) {
        var cnt = 0;
        var segments = 256;
        var perc;
        var min = Math.min(inputBlack, inputWhite);
        var max = Math.max(inputBlack, inputWhite);
        var table = Array.call(null, {
            length: segments
        });
        var colorValue;
        var pos = 0;
        var outputDelta = outputWhite - outputBlack;
        var inputDelta = inputWhite - inputBlack;
        while(cnt <= 256){
            perc = cnt / 256;
            if (perc <= min) colorValue = inputDelta < 0 ? outputWhite : outputBlack;
            else if (perc >= max) colorValue = inputDelta < 0 ? outputBlack : outputWhite;
            else colorValue = outputBlack + outputDelta * Math.pow((perc - inputBlack) / inputDelta, 1 / gamma);
            table[pos] = colorValue;
            pos += 1;
            cnt += 256 / (segments - 1);
        }
        return table.join(' ');
    };
    SVGProLevelsFilter.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
            var val;
            var effectElements = this.filterManager.effectElements;
            if (this.feFuncRComposed && (forceRender || effectElements[3].p._mdf || effectElements[4].p._mdf || effectElements[5].p._mdf || effectElements[6].p._mdf || effectElements[7].p._mdf)) {
                val = this.getTableValue(effectElements[3].p.v, effectElements[4].p.v, effectElements[5].p.v, effectElements[6].p.v, effectElements[7].p.v);
                this.feFuncRComposed.setAttribute('tableValues', val);
                this.feFuncGComposed.setAttribute('tableValues', val);
                this.feFuncBComposed.setAttribute('tableValues', val);
            }
            if (this.feFuncR && (forceRender || effectElements[10].p._mdf || effectElements[11].p._mdf || effectElements[12].p._mdf || effectElements[13].p._mdf || effectElements[14].p._mdf)) {
                val = this.getTableValue(effectElements[10].p.v, effectElements[11].p.v, effectElements[12].p.v, effectElements[13].p.v, effectElements[14].p.v);
                this.feFuncR.setAttribute('tableValues', val);
            }
            if (this.feFuncG && (forceRender || effectElements[17].p._mdf || effectElements[18].p._mdf || effectElements[19].p._mdf || effectElements[20].p._mdf || effectElements[21].p._mdf)) {
                val = this.getTableValue(effectElements[17].p.v, effectElements[18].p.v, effectElements[19].p.v, effectElements[20].p.v, effectElements[21].p.v);
                this.feFuncG.setAttribute('tableValues', val);
            }
            if (this.feFuncB && (forceRender || effectElements[24].p._mdf || effectElements[25].p._mdf || effectElements[26].p._mdf || effectElements[27].p._mdf || effectElements[28].p._mdf)) {
                val = this.getTableValue(effectElements[24].p.v, effectElements[25].p.v, effectElements[26].p.v, effectElements[27].p.v, effectElements[28].p.v);
                this.feFuncB.setAttribute('tableValues', val);
            }
            if (this.feFuncA && (forceRender || effectElements[31].p._mdf || effectElements[32].p._mdf || effectElements[33].p._mdf || effectElements[34].p._mdf || effectElements[35].p._mdf)) {
                val = this.getTableValue(effectElements[31].p.v, effectElements[32].p.v, effectElements[33].p.v, effectElements[34].p.v, effectElements[35].p.v);
                this.feFuncA.setAttribute('tableValues', val);
            }
        }
    };
    function SVGDropShadowEffect(filter, filterManager, elem, id, source) {
        var globalFilterSize = filterManager.container.globalData.renderConfig.filterSize;
        var filterSize = filterManager.data.fs || globalFilterSize;
        filter.setAttribute('x', filterSize.x || globalFilterSize.x);
        filter.setAttribute('y', filterSize.y || globalFilterSize.y);
        filter.setAttribute('width', filterSize.width || globalFilterSize.width);
        filter.setAttribute('height', filterSize.height || globalFilterSize.height);
        this.filterManager = filterManager;
        var feGaussianBlur = createNS('feGaussianBlur');
        feGaussianBlur.setAttribute('in', 'SourceAlpha');
        feGaussianBlur.setAttribute('result', id + '_drop_shadow_1');
        feGaussianBlur.setAttribute('stdDeviation', '0');
        this.feGaussianBlur = feGaussianBlur;
        filter.appendChild(feGaussianBlur);
        var feOffset = createNS('feOffset');
        feOffset.setAttribute('dx', '25');
        feOffset.setAttribute('dy', '0');
        feOffset.setAttribute('in', id + '_drop_shadow_1');
        feOffset.setAttribute('result', id + '_drop_shadow_2');
        this.feOffset = feOffset;
        filter.appendChild(feOffset);
        var feFlood = createNS('feFlood');
        feFlood.setAttribute('flood-color', '#00ff00');
        feFlood.setAttribute('flood-opacity', '1');
        feFlood.setAttribute('result', id + '_drop_shadow_3');
        this.feFlood = feFlood;
        filter.appendChild(feFlood);
        var feComposite = createNS('feComposite');
        feComposite.setAttribute('in', id + '_drop_shadow_3');
        feComposite.setAttribute('in2', id + '_drop_shadow_2');
        feComposite.setAttribute('operator', 'in');
        feComposite.setAttribute('result', id + '_drop_shadow_4');
        filter.appendChild(feComposite);
        var feMerge = this.createMergeNode(id, [
            id + '_drop_shadow_4',
            source
        ]);
        filter.appendChild(feMerge); //
    }
    extendPrototype([
        SVGComposableEffect
    ], SVGDropShadowEffect);
    SVGDropShadowEffect.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
            if (forceRender || this.filterManager.effectElements[4].p._mdf) this.feGaussianBlur.setAttribute('stdDeviation', this.filterManager.effectElements[4].p.v / 4);
            if (forceRender || this.filterManager.effectElements[0].p._mdf) {
                var col = this.filterManager.effectElements[0].p.v;
                this.feFlood.setAttribute('flood-color', rgbToHex(Math.round(col[0] * 255), Math.round(col[1] * 255), Math.round(col[2] * 255)));
            }
            if (forceRender || this.filterManager.effectElements[1].p._mdf) this.feFlood.setAttribute('flood-opacity', this.filterManager.effectElements[1].p.v / 255);
            if (forceRender || this.filterManager.effectElements[2].p._mdf || this.filterManager.effectElements[3].p._mdf) {
                var distance = this.filterManager.effectElements[3].p.v;
                var angle = (this.filterManager.effectElements[2].p.v - 90) * degToRads;
                var x = distance * Math.cos(angle);
                var y = distance * Math.sin(angle);
                this.feOffset.setAttribute('dx', x);
                this.feOffset.setAttribute('dy', y);
            }
        }
    };
    var _svgMatteSymbols = [];
    function SVGMatte3Effect(filterElem, filterManager, elem) {
        this.initialized = false;
        this.filterManager = filterManager;
        this.filterElem = filterElem;
        this.elem = elem;
        elem.matteElement = createNS('g');
        elem.matteElement.appendChild(elem.layerElement);
        elem.matteElement.appendChild(elem.transformedElement);
        elem.baseElement = elem.matteElement;
    }
    SVGMatte3Effect.prototype.findSymbol = function(mask) {
        var i = 0;
        var len = _svgMatteSymbols.length;
        while(i < len){
            if (_svgMatteSymbols[i] === mask) return _svgMatteSymbols[i];
            i += 1;
        }
        return null;
    };
    SVGMatte3Effect.prototype.replaceInParent = function(mask, symbolId) {
        var parentNode = mask.layerElement.parentNode;
        if (!parentNode) return;
        var children = parentNode.children;
        var i = 0;
        var len = children.length;
        while(i < len){
            if (children[i] === mask.layerElement) break;
            i += 1;
        }
        var nextChild;
        if (i <= len - 2) nextChild = children[i + 1];
        var useElem = createNS('use');
        useElem.setAttribute('href', '#' + symbolId);
        if (nextChild) parentNode.insertBefore(useElem, nextChild);
        else parentNode.appendChild(useElem);
    };
    SVGMatte3Effect.prototype.setElementAsMask = function(elem, mask) {
        if (!this.findSymbol(mask)) {
            var symbolId = createElementID();
            var masker = createNS('mask');
            masker.setAttribute('id', mask.layerId);
            masker.setAttribute('mask-type', 'alpha');
            _svgMatteSymbols.push(mask);
            var defs = elem.globalData.defs;
            defs.appendChild(masker);
            var symbol = createNS('symbol');
            symbol.setAttribute('id', symbolId);
            this.replaceInParent(mask, symbolId);
            symbol.appendChild(mask.layerElement);
            defs.appendChild(symbol);
            var useElem = createNS('use');
            useElem.setAttribute('href', '#' + symbolId);
            masker.appendChild(useElem);
            mask.data.hd = false;
            mask.show();
        }
        elem.setMatte(mask.layerId);
    };
    SVGMatte3Effect.prototype.initialize = function() {
        var ind = this.filterManager.effectElements[0].p.v;
        var elements = this.elem.comp.elements;
        var i = 0;
        var len = elements.length;
        while(i < len){
            if (elements[i] && elements[i].data.ind === ind) this.setElementAsMask(this.elem, elements[i]);
            i += 1;
        }
        this.initialized = true;
    };
    SVGMatte3Effect.prototype.renderFrame = function() {
        if (!this.initialized) this.initialize();
    };
    function SVGGaussianBlurEffect(filter, filterManager, elem, id) {
        // Outset the filter region by 100% on all sides to accommodate blur expansion.
        filter.setAttribute('x', '-100%');
        filter.setAttribute('y', '-100%');
        filter.setAttribute('width', '300%');
        filter.setAttribute('height', '300%');
        this.filterManager = filterManager;
        var feGaussianBlur = createNS('feGaussianBlur');
        feGaussianBlur.setAttribute('result', id);
        filter.appendChild(feGaussianBlur);
        this.feGaussianBlur = feGaussianBlur;
    }
    SVGGaussianBlurEffect.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
            // Empirical value, matching AE's blur appearance.
            var kBlurrinessToSigma = 0.3;
            var sigma = this.filterManager.effectElements[0].p.v * kBlurrinessToSigma; // Dimensions mapping:
            //
            //   1 -> horizontal & vertical
            //   2 -> horizontal only
            //   3 -> vertical only
            //
            var dimensions = this.filterManager.effectElements[1].p.v;
            var sigmaX = dimensions == 3 ? 0 : sigma; // eslint-disable-line eqeqeq
            var sigmaY = dimensions == 2 ? 0 : sigma; // eslint-disable-line eqeqeq
            this.feGaussianBlur.setAttribute('stdDeviation', sigmaX + ' ' + sigmaY); // Repeat edges mapping:
            //
            //   0 -> off -> duplicate
            //   1 -> on  -> wrap
            var edgeMode = this.filterManager.effectElements[2].p.v == 1 ? 'wrap' : 'duplicate'; // eslint-disable-line eqeqeq
            this.feGaussianBlur.setAttribute('edgeMode', edgeMode);
        }
    };
    function TransformEffect() {}
    TransformEffect.prototype.init = function(effectsManager) {
        this.effectsManager = effectsManager;
        this.type = effectTypes.TRANSFORM_EFFECT;
        this.matrix = new Matrix();
        this.opacity = -1;
        this._mdf = false;
        this._opMdf = false;
    };
    TransformEffect.prototype.renderFrame = function(forceFrame) {
        this._opMdf = false;
        this._mdf = false;
        if (forceFrame || this.effectsManager._mdf) {
            var effectElements = this.effectsManager.effectElements;
            var anchor = effectElements[0].p.v;
            var position = effectElements[1].p.v;
            var isUniformScale = effectElements[2].p.v === 1;
            var scaleHeight = effectElements[3].p.v;
            var scaleWidth = isUniformScale ? scaleHeight : effectElements[4].p.v;
            var skew = effectElements[5].p.v;
            var skewAxis = effectElements[6].p.v;
            var rotation = effectElements[7].p.v;
            this.matrix.reset();
            this.matrix.translate(-anchor[0], -anchor[1], anchor[2]);
            this.matrix.scale(scaleWidth * 0.01, scaleHeight * 0.01, 1);
            this.matrix.rotate(-rotation * degToRads);
            this.matrix.skewFromAxis(-skew * degToRads, (skewAxis + 90) * degToRads);
            this.matrix.translate(position[0], position[1], 0);
            this._mdf = true;
            if (this.opacity !== effectElements[8].p.v) {
                this.opacity = effectElements[8].p.v;
                this._opMdf = true;
            }
        }
    };
    function SVGTransformEffect(_, filterManager) {
        this.init(filterManager);
    }
    extendPrototype([
        TransformEffect
    ], SVGTransformEffect);
    function CVTransformEffect(effectsManager) {
        this.init(effectsManager);
    }
    extendPrototype([
        TransformEffect
    ], CVTransformEffect);
    registerRenderer('canvas', CanvasRenderer);
    registerRenderer('html', HybridRenderer);
    registerRenderer('svg', SVGRenderer); // Registering shape modifiers
    ShapeModifiers.registerModifier('tm', TrimModifier);
    ShapeModifiers.registerModifier('pb', PuckerAndBloatModifier);
    ShapeModifiers.registerModifier('rp', RepeaterModifier);
    ShapeModifiers.registerModifier('rd', RoundCornersModifier);
    ShapeModifiers.registerModifier('zz', ZigZagModifier);
    ShapeModifiers.registerModifier('op', OffsetPathModifier); // Registering expression plugin
    setExpressionsPlugin(Expressions);
    setExpressionInterfaces(getInterface);
    initialize$1();
    initialize(); // Registering svg effects
    registerEffect$1(20, SVGTintFilter, true);
    registerEffect$1(21, SVGFillFilter, true);
    registerEffect$1(22, SVGStrokeEffect, false);
    registerEffect$1(23, SVGTritoneFilter, true);
    registerEffect$1(24, SVGProLevelsFilter, true);
    registerEffect$1(25, SVGDropShadowEffect, true);
    registerEffect$1(28, SVGMatte3Effect, false);
    registerEffect$1(29, SVGGaussianBlurEffect, true);
    registerEffect$1(35, SVGTransformEffect, false);
    registerEffect(35, CVTransformEffect);
    return lottie;
});

});

parcelRegister("aPsqN", function(module, exports) {

var $eiolq = parcelRequire("eiolq");
var $7e24b8a6387f7479$require$mod10 = $eiolq.mod10;
var $7e24b8a6387f7479$require$mod11 = $eiolq.mod11;
// @see https://www.bankgirot.se/globalassets/dokument/anvandarmanualer/bankernaskontonummeruppbyggnad_anvandarmanual_sv.pdf
const $7e24b8a6387f7479$var$banks = [
    {
        name: 'Svea Bank',
        regex: /^966[0-9]{8}$/,
        type: 1,
        comment: 2
    },
    {
        name: 'Aion Bank SA',
        regex: /^958[0-9]{8}$/,
        type: 1,
        comment: 1
    },
    {
        name: 'Avanza Bank',
        regex: /^95[5-6][0-9]{8}$/,
        type: 1,
        comment: 2
    },
    {
        name: 'BlueStep Finans',
        regex: /^968[0-9]{8}$/,
        type: 1,
        comment: 1
    },
    {
        name: 'BNP Paribas SA',
        regex: /^947[0-9]{8}$/,
        type: 1,
        comment: 2
    },
    {
        name: 'Citibank',
        regex: /^904[0-9]{8}$/,
        type: 1,
        comment: 2
    },
    {
        name: 'Danske Bank',
        regex: /^1[2-3][0-9][0-9]{8}$/,
        type: 1,
        comment: 1
    },
    {
        name: 'Danske Bank',
        regex: /^24[0-9][0-9]{8}$/,
        type: 1,
        comment: 1
    },
    {
        name: 'DNB Bank',
        regex: /^(919|926)[0-9]{8}$/,
        type: 1,
        comment: 2
    },
    {
        name: 'Ekobanken',
        regex: /^970[0-9]{8}$/,
        type: 1,
        comment: 2
    },
    {
        name: 'Erik Penser',
        regex: /^959[0-9]{8}$/,
        type: 1,
        comment: 2
    },
    {
        name: 'Forex Bank',
        regex: /^94[0-4][0-9]{8}$/,
        type: 1,
        comment: 1
    },
    {
        name: 'Ica Banken',
        regex: /^927[0-9]{8}$/,
        type: 1,
        comment: 1
    },
    {
        name: 'IKANO Bank',
        regex: /^917[0-9]{8}$/,
        type: 1,
        comment: 1
    },
    {
        name: 'JAK Medlemsbank',
        regex: /^967[0-9]{8}$/,
        type: 1,
        comment: 2
    },
    {
        name: 'Klarna Bank',
        regex: /^978[0-9]{8}$/,
        type: 1,
        comment: 2
    },
    {
        name: 'Landshypotek',
        regex: /^939[0-9]{8}$/,
        type: 1,
        comment: 2
    },
    {
        name: 'Lunar Bank A/S',
        regex: /^971[0-9]{8}$/,
        type: 1,
        comment: 2
    },
    {
        name: "L\xe5n & Spar Bank Sverige",
        regex: /^963[0-9]{8}$/,
        type: 1,
        comment: 1
    },
    {
        name: "L\xe4nsf\xf6rs\xe4kringar Bank",
        regex: /^(340|906)[0-9]{8}$/,
        type: 1,
        comment: 1
    },
    {
        name: "L\xe4nsf\xf6rs\xe4kringar Bank",
        regex: /^902[0-9]{8}$/,
        type: 1,
        comment: 2
    },
    {
        name: 'Marginalen Bank',
        regex: /^923[0-9]{8}$/,
        type: 1,
        comment: 1
    },
    {
        name: 'MedMera Bank',
        regex: /^965[0-9]{8}$/,
        type: 1,
        comment: 2
    },
    {
        name: 'Multitude Bank plc',
        regex: /^907[0-9]{8}$/,
        type: 1,
        comment: 1
    },
    {
        name: 'Nordax Bank',
        regex: /^964[0-9]{8}$/,
        type: 1,
        comment: 2
    },
    {
        name: 'Nordea',
        regex: /^11[0-9]{9}$/,
        type: 1,
        comment: 1
    },
    {
        name: 'Nordea',
        regex: /^(1[4-9][0-9]{9}$|20[0-9]{9}$)/,
        type: 1,
        comment: 1
    },
    {
        name: 'Nordea',
        regex: /^(?!3300)(3[0-3][0-9]{9}$)/,
        type: 1,
        comment: 1
    },
    {
        name: 'Nordea',
        regex: /^(?!3782)(3[4-9][1-9][0-9]{8}$)/,
        type: 1,
        comment: 1
    },
    {
        name: 'Nordea',
        regex: /^4[0-9]{10}$/,
        type: 1,
        comment: 2
    },
    {
        name: 'Nordnet Bank',
        regex: /^910[0-9]{8}$/,
        type: 1,
        comment: 2
    },
    {
        name: 'Northmill Bank',
        regex: /^975[0-9]{8}$/,
        type: 1,
        comment: 2
    },
    {
        name: 'Resurs Bank',
        regex: /^928[0-9]{8}$/,
        type: 1,
        comment: 1
    },
    {
        name: "Riksg\xe4lden",
        regex: /^988[0-9]{8}$/,
        type: 1,
        comment: 2
    },
    {
        name: 'Santander Consumer Bank',
        regex: /^946[0-9]{8}$/,
        type: 1,
        comment: 1
    },
    {
        name: 'SBAB',
        regex: /^925[0-9]{8}$/,
        type: 1,
        comment: 1
    },
    {
        name: 'SEB',
        regex: /^5[0-9]{10}$/,
        type: 1,
        comment: 1
    },
    {
        name: 'SEB',
        regex: /^912[0-4][0-9]{7}$/,
        type: 1,
        comment: 1
    },
    {
        name: 'SEB',
        regex: /^91[3-4][0-9]{8}$/,
        type: 1,
        comment: 1
    },
    {
        name: 'Skandiabanken',
        regex: /^91[5-6][0-9]{8}$/,
        type: 1,
        comment: 2
    },
    {
        name: 'Swedbank',
        regex: /^7[0-9]{10}$/,
        type: 1,
        comment: 1
    },
    {
        name: "\xc5landsbanken Sverige AB",
        regex: /^23[0-9]{9}$/,
        type: 1,
        comment: 2
    },
    {
        name: 'Danske Bank',
        regex: /^918[0-9]{11}$/,
        type: 2,
        comment: 1,
        mod10: true
    },
    {
        name: 'Handelsbanken',
        regex: /^6[0-9]{12}$/,
        type: 2,
        comment: 2
    },
    {
        name: 'Nordea/Plusgirot',
        regex: /^(95[0-4]|996)[0-9]{8,11}$/,
        type: 2,
        comment: 3,
        mod10: true
    },
    {
        name: 'Nordea Personkonto',
        regex: /^(3300|3782)[0-9]{10}$/,
        type: 2,
        comment: 1,
        mod10: true
    },
    {
        name: "Riksg\xe4lden",
        regex: /^989[0-9]{11}$/,
        type: 2,
        comment: 1,
        mod10: true
    },
    {
        name: 'Sparbanken Syd',
        regex: /^957[0-9]{11}$/,
        type: 2,
        comment: 1,
        mod10: true
    },
    {
        name: 'Swedbank',
        regex: /^8[0-9]{10,14}$/,
        type: 2,
        comment: 3,
        mod10: true,
        clen: 5
    },
    {
        name: "Swedbank fd. Sparbanken \xd6resund",
        regex: /^93[0-4][0-9]{11}$/,
        type: 2,
        comment: 1,
        mod10: true
    },
    {
        // Note: Bankgirot is not included in their own documentation for Swedish bank account numbers.
        name: 'Bankgirot',
        regex: /^9900[0-9]{7,8}$/,
        mod10: true
    }
];
/**
 * Validates bank account number against given bank.
 *
 * @param {string} number
 * @param {object} bank
 * @returns {boolean|object}
 */ function $7e24b8a6387f7479$var$validate(number, bank) {
    const clen = bank.clen ? bank.clen : 4;
    const clearing = number.slice(0, clen);
    const accnum = number.slice(clen);
    // Only check type 1 with comment 1 & 2, otherwise full account number excl. clearing is checked.
    const digits = bank.type === 1 && bank.comment === 1 ? clearing.slice(1) + accnum : bank.type === 1 && bank.comment === 2 ? clearing + accnum : accnum;
    const valid = bank.mod10 ? $7e24b8a6387f7479$require$mod10(digits) : $7e24b8a6387f7479$require$mod11(digits);
    if (!valid) return false;
    return {
        bank: bank.name,
        clearing: clearing,
        number: accnum
    };
}
/**
 * Validate Swedish bank account number.
 *
 * @param {string|number} account
 * @returns {boolean|object}
 */ module.exports = function(account) {
    const number = String(account).replace(/\D/g, '');
    for(let i in $7e24b8a6387f7479$var$banks){
        if ($7e24b8a6387f7479$var$banks[i].regex.test(number)) return $7e24b8a6387f7479$var$validate(number, $7e24b8a6387f7479$var$banks[i]);
    }
    return false;
};

});
parcelRegister("eiolq", function(module, exports) {

$parcel$export(module.exports, "mod10", () => $a685a17123f77b12$export$d6ed7b8be48716b0, (v) => $a685a17123f77b12$export$d6ed7b8be48716b0 = v);
$parcel$export(module.exports, "mod11", () => $a685a17123f77b12$export$9008564049c28318, (v) => $a685a17123f77b12$export$9008564049c28318 = v);
/**
 * Mod-10 method validation.
 *
 * @param {string} number
 * @returns {boolean}
 */ var $a685a17123f77b12$export$d6ed7b8be48716b0;
/**
 * Mod-11 method validation.
 *
 * @param {string} number
 * @returns {boolean}
 */ var $a685a17123f77b12$export$9008564049c28318;
$a685a17123f77b12$export$d6ed7b8be48716b0 = function(number) {
    const reversed = number.split('').reverse();
    let sum = 0;
    reversed.forEach((digit, i)=>{
        let product = parseInt(i % 2 === 0 ? digit : 2 * digit);
        sum += product > 9 ? product - 9 : product;
    });
    return sum > 0 && sum % 10 === 0;
};
$a685a17123f77b12$export$9008564049c28318 = function(number) {
    const reversed = number.split('').reverse();
    let sum = 0;
    reversed.forEach((digit, i)=>{
        let factor = i % 10 + 1;
        sum += parseInt(factor * digit);
    });
    return sum > 0 && sum % 11 === 0;
};

});


var $4f9260958d0c217b$exports = {};


(parcelRequire("kI8SP")).register((parcelRequire("hIarR")).getBundleURL('37CdW'), JSON.parse("[\"37CdW\",\"MyPagesApp.js\",\"8sb9j\",\"done-circle.1ea9006c.svg\",\"5rM4R\",\"BankID.04adb032.svg\"]"));

/*
 * This is the entry point for all signed in (My pages) related functionality
 */ // libs
var $13f4c0370d7de649$exports = {};
'use strict';

$13f4c0370d7de649$exports = (parcelRequire("89wqa"));


parcelRequire("8NFma");
parcelRequire("2pmb0");
var $503937b663c395c4$export$882461b6382ed46c;
var $503937b663c395c4$export$757ceba2d55c277e;
'use strict';

var $2pmb0 = parcelRequire("2pmb0");
var $503937b663c395c4$var$i;
$503937b663c395c4$export$882461b6382ed46c = $2pmb0.createRoot;
$503937b663c395c4$export$757ceba2d55c277e = $2pmb0.hydrateRoot;


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $c106e002a49a00cb$var$extendStatics = function(d, b) {
    $c106e002a49a00cb$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $c106e002a49a00cb$var$extendStatics(d, b);
};
function $c106e002a49a00cb$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $c106e002a49a00cb$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $c106e002a49a00cb$export$18ce0697a983be9b = function() {
    $c106e002a49a00cb$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c106e002a49a00cb$export$18ce0697a983be9b.apply(this, arguments);
};
function $c106e002a49a00cb$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $c106e002a49a00cb$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $c106e002a49a00cb$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $c106e002a49a00cb$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $c106e002a49a00cb$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $c106e002a49a00cb$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $c106e002a49a00cb$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $c106e002a49a00cb$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $c106e002a49a00cb$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $c106e002a49a00cb$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $c106e002a49a00cb$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $c106e002a49a00cb$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $c106e002a49a00cb$export$45d3717a4c69092e(o, m, p);
}
function $c106e002a49a00cb$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $c106e002a49a00cb$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $c106e002a49a00cb$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($c106e002a49a00cb$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $c106e002a49a00cb$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $c106e002a49a00cb$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $c106e002a49a00cb$export$10c90e4f7922046c(v) {
    return this instanceof $c106e002a49a00cb$export$10c90e4f7922046c ? (this.v = v, this) : new $c106e002a49a00cb$export$10c90e4f7922046c(v);
}
function $c106e002a49a00cb$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $c106e002a49a00cb$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $c106e002a49a00cb$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $c106e002a49a00cb$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $c106e002a49a00cb$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $c106e002a49a00cb$export$19a8beecd37a4c45 === "function" ? $c106e002a49a00cb$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $c106e002a49a00cb$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $c106e002a49a00cb$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $c106e002a49a00cb$var$ownKeys = function(o) {
    $c106e002a49a00cb$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $c106e002a49a00cb$var$ownKeys(o);
};
function $c106e002a49a00cb$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $c106e002a49a00cb$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $c106e002a49a00cb$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $c106e002a49a00cb$var$__setModuleDefault(result, mod);
    return result;
}
function $c106e002a49a00cb$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $c106e002a49a00cb$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $c106e002a49a00cb$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $c106e002a49a00cb$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $c106e002a49a00cb$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $c106e002a49a00cb$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $c106e002a49a00cb$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $c106e002a49a00cb$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $c106e002a49a00cb$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $c106e002a49a00cb$export$2e2bcd8739ae039 = {
    __extends: $c106e002a49a00cb$export$a8ba968b8961cb8a,
    __assign: $c106e002a49a00cb$export$18ce0697a983be9b,
    __rest: $c106e002a49a00cb$export$3c9a16f847548506,
    __decorate: $c106e002a49a00cb$export$29e00dfd3077644b,
    __param: $c106e002a49a00cb$export$d5ad3fd78186038f,
    __esDecorate: $c106e002a49a00cb$export$3a84e1ae4e97e9b0,
    __runInitializers: $c106e002a49a00cb$export$d831c04e792af3d,
    __propKey: $c106e002a49a00cb$export$6a2a36740a146cb8,
    __setFunctionName: $c106e002a49a00cb$export$d1a06452d3489bc7,
    __metadata: $c106e002a49a00cb$export$f1db080c865becb9,
    __awaiter: $c106e002a49a00cb$export$1050f835b63b671e,
    __generator: $c106e002a49a00cb$export$67ebef60e6f28a6,
    __createBinding: $c106e002a49a00cb$export$45d3717a4c69092e,
    __exportStar: $c106e002a49a00cb$export$f33643c0debef087,
    __values: $c106e002a49a00cb$export$19a8beecd37a4c45,
    __read: $c106e002a49a00cb$export$8d051b38c9118094,
    __spread: $c106e002a49a00cb$export$afc72e2116322959,
    __spreadArrays: $c106e002a49a00cb$export$6388937ca91ccae8,
    __spreadArray: $c106e002a49a00cb$export$1216008129fb82ed,
    __await: $c106e002a49a00cb$export$10c90e4f7922046c,
    __asyncGenerator: $c106e002a49a00cb$export$e427f37a30a4de9b,
    __asyncDelegator: $c106e002a49a00cb$export$bbd80228419bb833,
    __asyncValues: $c106e002a49a00cb$export$e3b29a3d6162315f,
    __makeTemplateObject: $c106e002a49a00cb$export$4fb47efe1390b86f,
    __importStar: $c106e002a49a00cb$export$c21735bcef00d192,
    __importDefault: $c106e002a49a00cb$export$da59b14a69baef04,
    __classPrivateFieldGet: $c106e002a49a00cb$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $c106e002a49a00cb$export$d40a35129aaff81f,
    __classPrivateFieldIn: $c106e002a49a00cb$export$81fdc39f203e4e04,
    __addDisposableResource: $c106e002a49a00cb$export$88ac25d8e944e405,
    __disposeResources: $c106e002a49a00cb$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $c106e002a49a00cb$export$889dfb5d17574b0b
};


function $9c0e0b6377fc4bc5$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


// eslint-disable-next-line no-undef
var $22d0df0057910800$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $22d0df0057910800$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $9c0e0b6377fc4bc5$export$2e2bcd8739ae039)(function(prop) {
    return $22d0df0057910800$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});



var $8NFma = parcelRequire("8NFma");
var $ee39632639537d25$exports = {};
//
$ee39632639537d25$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


var $e36f1de21b27a557$export$71ad59f2e432cfe8 = "-ms-";
var $e36f1de21b27a557$export$2c0f367103c8d01c = "-moz-";
var $e36f1de21b27a557$export$39dfd62a25e0fe93 = "-webkit-";
var $e36f1de21b27a557$export$a29989082612d0d9 = "comm";
var $e36f1de21b27a557$export$aa3a2e812ca8570d = "rule";
var $e36f1de21b27a557$export$527d108ccf083c2b = "decl";
var $e36f1de21b27a557$export$d3d35020fa5b54f0 = "@page";
var $e36f1de21b27a557$export$500415a86c544f73 = "@media";
var $e36f1de21b27a557$export$a763edbf796b780a = "@import";
var $e36f1de21b27a557$export$2790aeb8b4e5c826 = "@charset";
var $e36f1de21b27a557$export$1cc683e23b84b133 = "@viewport";
var $e36f1de21b27a557$export$9447a5efea57e862 = "@supports";
var $e36f1de21b27a557$export$ef011b4e114b1fba = "@document";
var $e36f1de21b27a557$export$6aad947bda0f3f46 = "@namespace";
var $e36f1de21b27a557$export$b44a8529a35fcb60 = "@keyframes";
var $e36f1de21b27a557$export$2c16de31893252e6 = "@font-face";
var $e36f1de21b27a557$export$3d846dd52e150c6f = "@counter-style";
var $e36f1de21b27a557$export$22314bfbb57653fe = "@font-feature-values";
var $e36f1de21b27a557$export$d773506282b3cfe6 = "@layer";
var $e36f1de21b27a557$export$1c5a554c78c0cd12 = "@scope";
var $e36f1de21b27a557$export$2335f513bbd82c6d = Math.abs;
var $e36f1de21b27a557$export$6788812c4e6611e6 = String.fromCharCode;
var $e36f1de21b27a557$export$e6e34fd1f2686227 = Object.assign;
function $e36f1de21b27a557$export$d6af199866bfb566(e, r) {
    return $e36f1de21b27a557$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $e36f1de21b27a557$export$a9db5e087081082d(e, 0)) << 2 ^ $e36f1de21b27a557$export$a9db5e087081082d(e, 1)) << 2 ^ $e36f1de21b27a557$export$a9db5e087081082d(e, 2)) << 2 ^ $e36f1de21b27a557$export$a9db5e087081082d(e, 3) : 0;
}
function $e36f1de21b27a557$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $e36f1de21b27a557$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $e36f1de21b27a557$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $e36f1de21b27a557$export$f8e21b1e77979a08(e, r, a) {
    return e.indexOf(r, a);
}
function $e36f1de21b27a557$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $e36f1de21b27a557$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $e36f1de21b27a557$export$36776f635604f274(e) {
    return e.length;
}
function $e36f1de21b27a557$export$f9084667e487ed46(e) {
    return e.length;
}
function $e36f1de21b27a557$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $e36f1de21b27a557$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
function $e36f1de21b27a557$export$3dea766d36a8935f(e, r) {
    return e.filter(function(e) {
        return !$e36f1de21b27a557$export$4659b591c19bdf3d(e, r);
    });
}
var $e36f1de21b27a557$export$53f1d5ea8de3d7c = 1;
var $e36f1de21b27a557$export$4e0c71f277ca26b3 = 1;
var $e36f1de21b27a557$export$f24224f1c91d8156 = 0;
var $e36f1de21b27a557$export$5880b8b5730aff45 = 0;
var $e36f1de21b27a557$export$c0306caf338ac095 = 0;
var $e36f1de21b27a557$export$30a86d91af8ff6e6 = "";
function $e36f1de21b27a557$export$35059013cd4a06db(e, r, a, n, c, s, t, u) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $e36f1de21b27a557$export$53f1d5ea8de3d7c,
        column: $e36f1de21b27a557$export$4e0c71f277ca26b3,
        length: t,
        return: "",
        siblings: u
    };
}
function $e36f1de21b27a557$export$784d13d8ee351f07(e, r) {
    return $e36f1de21b27a557$export$e6e34fd1f2686227($e36f1de21b27a557$export$35059013cd4a06db("", null, null, "", null, null, 0, e.siblings), e, {
        length: -e.length
    }, r);
}
function $e36f1de21b27a557$export$590e8b2c435046d9(e) {
    while(e.root)e = $e36f1de21b27a557$export$784d13d8ee351f07(e.root, {
        children: [
            e
        ]
    });
    $e36f1de21b27a557$export$10d8903dec122b9d(e, e.siblings);
}
function $e36f1de21b27a557$export$eba6f6f03b0a92e7() {
    return $e36f1de21b27a557$export$c0306caf338ac095;
}
function $e36f1de21b27a557$export$232faf9add678146() {
    $e36f1de21b27a557$export$c0306caf338ac095 = $e36f1de21b27a557$export$5880b8b5730aff45 > 0 ? $e36f1de21b27a557$export$a9db5e087081082d($e36f1de21b27a557$export$30a86d91af8ff6e6, --$e36f1de21b27a557$export$5880b8b5730aff45) : 0;
    if ($e36f1de21b27a557$export$4e0c71f277ca26b3--, $e36f1de21b27a557$export$c0306caf338ac095 === 10) $e36f1de21b27a557$export$4e0c71f277ca26b3 = 1, $e36f1de21b27a557$export$53f1d5ea8de3d7c--;
    return $e36f1de21b27a557$export$c0306caf338ac095;
}
function $e36f1de21b27a557$export$48cfd1e771a65c4f() {
    $e36f1de21b27a557$export$c0306caf338ac095 = $e36f1de21b27a557$export$5880b8b5730aff45 < $e36f1de21b27a557$export$f24224f1c91d8156 ? $e36f1de21b27a557$export$a9db5e087081082d($e36f1de21b27a557$export$30a86d91af8ff6e6, $e36f1de21b27a557$export$5880b8b5730aff45++) : 0;
    if ($e36f1de21b27a557$export$4e0c71f277ca26b3++, $e36f1de21b27a557$export$c0306caf338ac095 === 10) $e36f1de21b27a557$export$4e0c71f277ca26b3 = 1, $e36f1de21b27a557$export$53f1d5ea8de3d7c++;
    return $e36f1de21b27a557$export$c0306caf338ac095;
}
function $e36f1de21b27a557$export$4d3fb11e950abb9e() {
    return $e36f1de21b27a557$export$a9db5e087081082d($e36f1de21b27a557$export$30a86d91af8ff6e6, $e36f1de21b27a557$export$5880b8b5730aff45);
}
function $e36f1de21b27a557$export$e88cb2efb12ae807() {
    return $e36f1de21b27a557$export$5880b8b5730aff45;
}
function $e36f1de21b27a557$export$58adb3bec8346d0f(e, r) {
    return $e36f1de21b27a557$export$2f35ab04d2335697($e36f1de21b27a557$export$30a86d91af8ff6e6, e, r);
}
function $e36f1de21b27a557$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $e36f1de21b27a557$export$2de70f21292aac9e(e) {
    return $e36f1de21b27a557$export$53f1d5ea8de3d7c = $e36f1de21b27a557$export$4e0c71f277ca26b3 = 1, $e36f1de21b27a557$export$f24224f1c91d8156 = $e36f1de21b27a557$export$36776f635604f274($e36f1de21b27a557$export$30a86d91af8ff6e6 = e), $e36f1de21b27a557$export$5880b8b5730aff45 = 0, [];
}
function $e36f1de21b27a557$export$45918ac1574455b1(e) {
    return $e36f1de21b27a557$export$30a86d91af8ff6e6 = "", e;
}
function $e36f1de21b27a557$export$410ac95b9ec204b8(e) {
    return $e36f1de21b27a557$export$87c2784dc9fc4ab($e36f1de21b27a557$export$58adb3bec8346d0f($e36f1de21b27a557$export$5880b8b5730aff45 - 1, $e36f1de21b27a557$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $e36f1de21b27a557$export$660b2ee2d4fb4eff(e) {
    return $e36f1de21b27a557$export$45918ac1574455b1($e36f1de21b27a557$export$5f8c09e3ae6f64e1($e36f1de21b27a557$export$2de70f21292aac9e(e)));
}
function $e36f1de21b27a557$export$7af1228ff777d175(e) {
    while($e36f1de21b27a557$export$c0306caf338ac095 = $e36f1de21b27a557$export$4d3fb11e950abb9e())if ($e36f1de21b27a557$export$c0306caf338ac095 < 33) $e36f1de21b27a557$export$48cfd1e771a65c4f();
    else break;
    return $e36f1de21b27a557$export$9e1725a4cfeada27(e) > 2 || $e36f1de21b27a557$export$9e1725a4cfeada27($e36f1de21b27a557$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $e36f1de21b27a557$export$5f8c09e3ae6f64e1(e) {
    while($e36f1de21b27a557$export$48cfd1e771a65c4f())switch($e36f1de21b27a557$export$9e1725a4cfeada27($e36f1de21b27a557$export$c0306caf338ac095)){
        case 0:
            $e36f1de21b27a557$export$10d8903dec122b9d($e36f1de21b27a557$export$c2ab62c7bf24634($e36f1de21b27a557$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $e36f1de21b27a557$export$10d8903dec122b9d($e36f1de21b27a557$export$410ac95b9ec204b8($e36f1de21b27a557$export$c0306caf338ac095), e);
            break;
        default:
            $e36f1de21b27a557$export$10d8903dec122b9d($e36f1de21b27a557$export$6788812c4e6611e6($e36f1de21b27a557$export$c0306caf338ac095), e);
    }
    return e;
}
function $e36f1de21b27a557$export$955ba06d119e085e(e, r) {
    while(--r && $e36f1de21b27a557$export$48cfd1e771a65c4f())if ($e36f1de21b27a557$export$c0306caf338ac095 < 48 || $e36f1de21b27a557$export$c0306caf338ac095 > 102 || $e36f1de21b27a557$export$c0306caf338ac095 > 57 && $e36f1de21b27a557$export$c0306caf338ac095 < 65 || $e36f1de21b27a557$export$c0306caf338ac095 > 70 && $e36f1de21b27a557$export$c0306caf338ac095 < 97) break;
    return $e36f1de21b27a557$export$58adb3bec8346d0f(e, $e36f1de21b27a557$export$e88cb2efb12ae807() + (r < 6 && $e36f1de21b27a557$export$4d3fb11e950abb9e() == 32 && $e36f1de21b27a557$export$48cfd1e771a65c4f() == 32));
}
function $e36f1de21b27a557$export$c889f2fcc19dbf12(e) {
    while($e36f1de21b27a557$export$48cfd1e771a65c4f())switch($e36f1de21b27a557$export$c0306caf338ac095){
        case e:
            return $e36f1de21b27a557$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $e36f1de21b27a557$export$c889f2fcc19dbf12($e36f1de21b27a557$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $e36f1de21b27a557$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $e36f1de21b27a557$export$48cfd1e771a65c4f();
            break;
    }
    return $e36f1de21b27a557$export$5880b8b5730aff45;
}
function $e36f1de21b27a557$export$4254d4e2b3745c4c(e, r) {
    while($e36f1de21b27a557$export$48cfd1e771a65c4f())if (e + $e36f1de21b27a557$export$c0306caf338ac095 === 57) break;
    else if (e + $e36f1de21b27a557$export$c0306caf338ac095 === 84 && $e36f1de21b27a557$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $e36f1de21b27a557$export$58adb3bec8346d0f(r, $e36f1de21b27a557$export$5880b8b5730aff45 - 1) + "*" + $e36f1de21b27a557$export$6788812c4e6611e6(e === 47 ? e : $e36f1de21b27a557$export$48cfd1e771a65c4f());
}
function $e36f1de21b27a557$export$c2ab62c7bf24634(e) {
    while(!$e36f1de21b27a557$export$9e1725a4cfeada27($e36f1de21b27a557$export$4d3fb11e950abb9e()))$e36f1de21b27a557$export$48cfd1e771a65c4f();
    return $e36f1de21b27a557$export$58adb3bec8346d0f(e, $e36f1de21b27a557$export$5880b8b5730aff45);
}
function $e36f1de21b27a557$export$ef7acd7185315e22(e) {
    return $e36f1de21b27a557$export$45918ac1574455b1($e36f1de21b27a557$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $e36f1de21b27a557$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $e36f1de21b27a557$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var p = 0;
    var v = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var g = 0;
    var k = "";
    var x = c;
    var y = s;
    var j = n;
    var z = k;
    while(w)switch(h = g, g = $e36f1de21b27a557$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $e36f1de21b27a557$export$a9db5e087081082d(z, l - 1) == 58) {
                if ($e36f1de21b27a557$export$f8e21b1e77979a08(z += $e36f1de21b27a557$export$77ad94ebf1c2b9ed($e36f1de21b27a557$export$410ac95b9ec204b8(g), "&", "&\f"), "&\f", $e36f1de21b27a557$export$2335f513bbd82c6d(f ? u[f - 1] : 0)) != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            z += $e36f1de21b27a557$export$410ac95b9ec204b8(g);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            z += $e36f1de21b27a557$export$7af1228ff777d175(h);
            break;
        case 92:
            z += $e36f1de21b27a557$export$955ba06d119e085e($e36f1de21b27a557$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($e36f1de21b27a557$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $e36f1de21b27a557$export$10d8903dec122b9d($e36f1de21b27a557$export$4a34f930e789283c($e36f1de21b27a557$export$4254d4e2b3745c4c($e36f1de21b27a557$export$48cfd1e771a65c4f(), $e36f1de21b27a557$export$e88cb2efb12ae807()), r, a, i), i);
                    if (($e36f1de21b27a557$export$9e1725a4cfeada27(h || 1) == 5 || $e36f1de21b27a557$export$9e1725a4cfeada27($e36f1de21b27a557$export$4d3fb11e950abb9e() || 1) == 5) && $e36f1de21b27a557$export$36776f635604f274(z) && $e36f1de21b27a557$export$2f35ab04d2335697(z, -1, void 0) !== " ") z += " ";
                    break;
                default:
                    z += "/";
            }
            break;
        case 123 * b:
            u[f++] = $e36f1de21b27a557$export$36776f635604f274(z) * d;
        case 125 * b:
        case 59:
        case 0:
            switch(g){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) z = $e36f1de21b27a557$export$77ad94ebf1c2b9ed(z, /\f/g, "");
                    if (v > 0 && ($e36f1de21b27a557$export$36776f635604f274(z) - l || b === 0 && h === 47)) $e36f1de21b27a557$export$10d8903dec122b9d(v > 32 ? $e36f1de21b27a557$export$f8483753829ec8f3(z + ";", n, a, l - 1, i) : $e36f1de21b27a557$export$f8483753829ec8f3($e36f1de21b27a557$export$77ad94ebf1c2b9ed(z, " ", "") + ";", n, a, l - 2, i), i);
                    break;
                case 59:
                    z += ";";
                default:
                    $e36f1de21b27a557$export$10d8903dec122b9d(j = $e36f1de21b27a557$export$3307ffa7023ede1e(z, r, a, f, o, c, u, k, x = [], y = [], l, s), s);
                    if (g === 123) {
                        if (o === 0) $e36f1de21b27a557$export$98e6a39c04603d36(z, r, j, j, x, s, l, u, y);
                        else switch(p === 99 && $e36f1de21b27a557$export$a9db5e087081082d(z, 3) === 110 ? 100 : p){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $e36f1de21b27a557$export$98e6a39c04603d36(e, j, j, n && $e36f1de21b27a557$export$10d8903dec122b9d($e36f1de21b27a557$export$3307ffa7023ede1e(e, j, j, 0, 0, c, u, k, c, x = [], l, y), y), c, y, l, u, n ? x : y);
                                break;
                            default:
                                $e36f1de21b27a557$export$98e6a39c04603d36(z, j, j, j, [
                                    ""
                                ], y, 0, u, y);
                        }
                    }
            }
            f = o = v = 0, b = d = 1, k = z = "", l = t;
            break;
        case 58:
            l = 1 + $e36f1de21b27a557$export$36776f635604f274(z), v = h;
        default:
            if (b < 1) {
                if (g == 123) --b;
                else if (g == 125 && b++ == 0 && $e36f1de21b27a557$export$232faf9add678146() == 125) continue;
            }
            switch(z += $e36f1de21b27a557$export$6788812c4e6611e6(g), g * b){
                case 38:
                    d = o > 0 ? 1 : (z += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($e36f1de21b27a557$export$36776f635604f274(z) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($e36f1de21b27a557$export$4d3fb11e950abb9e() === 45) z += $e36f1de21b27a557$export$410ac95b9ec204b8($e36f1de21b27a557$export$48cfd1e771a65c4f());
                    p = $e36f1de21b27a557$export$4d3fb11e950abb9e(), o = l = $e36f1de21b27a557$export$36776f635604f274(k = z += $e36f1de21b27a557$export$c2ab62c7bf24634($e36f1de21b27a557$export$e88cb2efb12ae807())), g++;
                    break;
                case 45:
                    if (h === 45 && $e36f1de21b27a557$export$36776f635604f274(z) == 2) b = 0;
            }
    }
    return s;
}
function $e36f1de21b27a557$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l, p) {
    var v = s - 1;
    var h = s === 0 ? t : [
        ""
    ];
    var b = $e36f1de21b27a557$export$f9084667e487ed46(h);
    for(var w = 0, d = 0, g = 0; w < n; ++w)for(var k = 0, m = $e36f1de21b27a557$export$2f35ab04d2335697(e, v + 1, v = $e36f1de21b27a557$export$2335f513bbd82c6d(d = u[w])), x = e; k < b; ++k)if (x = $e36f1de21b27a557$export$87c2784dc9fc4ab(d > 0 ? h[k] + " " + m : $e36f1de21b27a557$export$77ad94ebf1c2b9ed(m, /&\f/g, h[k]))) f[g++] = x;
    return $e36f1de21b27a557$export$35059013cd4a06db(e, r, a, s === 0 ? $e36f1de21b27a557$export$aa3a2e812ca8570d : i, f, o, l, p);
}
function $e36f1de21b27a557$export$4a34f930e789283c(e, r, a, c) {
    return $e36f1de21b27a557$export$35059013cd4a06db(e, r, a, $e36f1de21b27a557$export$a29989082612d0d9, $e36f1de21b27a557$export$6788812c4e6611e6($e36f1de21b27a557$export$eba6f6f03b0a92e7()), $e36f1de21b27a557$export$2f35ab04d2335697(e, 2, -2), 0, c);
}
function $e36f1de21b27a557$export$f8483753829ec8f3(e, r, a, n, c) {
    return $e36f1de21b27a557$export$35059013cd4a06db(e, r, a, $e36f1de21b27a557$export$527d108ccf083c2b, $e36f1de21b27a557$export$2f35ab04d2335697(e, 0, n), $e36f1de21b27a557$export$2f35ab04d2335697(e, n + 1, -1), n, c);
}
function $e36f1de21b27a557$export$82e9f45cca5ba907(n, c, s) {
    switch($e36f1de21b27a557$export$d6af199866bfb566(n, c)){
        case 5103:
            return $e36f1de21b27a557$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
            return $e36f1de21b27a557$export$39dfd62a25e0fe93 + n + n;
        case 4855:
            return $e36f1de21b27a557$export$39dfd62a25e0fe93 + n.replace("add", "source-over").replace("substract", "source-out").replace("intersect", "source-in").replace("exclude", "xor") + n;
        case 4789:
            return $e36f1de21b27a557$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $e36f1de21b27a557$export$39dfd62a25e0fe93 + n + $e36f1de21b27a557$export$2c0f367103c8d01c + n + $e36f1de21b27a557$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($e36f1de21b27a557$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $e36f1de21b27a557$export$39dfd62a25e0fe93 + n + $e36f1de21b27a557$export$71ad59f2e432cfe8 + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $e36f1de21b27a557$export$39dfd62a25e0fe93 + n + $e36f1de21b27a557$export$71ad59f2e432cfe8 + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $e36f1de21b27a557$export$39dfd62a25e0fe93 + n + $e36f1de21b27a557$export$71ad59f2e432cfe8 + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $e36f1de21b27a557$export$39dfd62a25e0fe93 + n + $e36f1de21b27a557$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $e36f1de21b27a557$export$39dfd62a25e0fe93 + n + $e36f1de21b27a557$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $e36f1de21b27a557$export$39dfd62a25e0fe93 + n + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $e36f1de21b27a557$export$39dfd62a25e0fe93 + "box-$1$2" + $e36f1de21b27a557$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $e36f1de21b27a557$export$39dfd62a25e0fe93 + n + $e36f1de21b27a557$export$71ad59f2e432cfe8 + "flex-item-" + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$e36f1de21b27a557$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $e36f1de21b27a557$export$71ad59f2e432cfe8 + "grid-row-" + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $e36f1de21b27a557$export$39dfd62a25e0fe93 + n + $e36f1de21b27a557$export$71ad59f2e432cfe8 + "flex-line-pack" + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $e36f1de21b27a557$export$39dfd62a25e0fe93 + n + $e36f1de21b27a557$export$71ad59f2e432cfe8 + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $e36f1de21b27a557$export$39dfd62a25e0fe93 + n + $e36f1de21b27a557$export$71ad59f2e432cfe8 + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $e36f1de21b27a557$export$39dfd62a25e0fe93 + "box-" + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, "-grow", "") + $e36f1de21b27a557$export$39dfd62a25e0fe93 + n + $e36f1de21b27a557$export$71ad59f2e432cfe8 + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $e36f1de21b27a557$export$39dfd62a25e0fe93 + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $e36f1de21b27a557$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $e36f1de21b27a557$export$77ad94ebf1c2b9ed($e36f1de21b27a557$export$77ad94ebf1c2b9ed($e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $e36f1de21b27a557$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $e36f1de21b27a557$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $e36f1de21b27a557$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $e36f1de21b27a557$export$77ad94ebf1c2b9ed($e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $e36f1de21b27a557$export$39dfd62a25e0fe93 + "box-pack:$3" + $e36f1de21b27a557$export$71ad59f2e432cfe8 + "flex-pack:$3"), /space-between/, "justify") + $e36f1de21b27a557$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$e36f1de21b27a557$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $e36f1de21b27a557$export$71ad59f2e432cfe8 + "grid-column-align" + $e36f1de21b27a557$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $e36f1de21b27a557$export$71ad59f2e432cfe8 + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $e36f1de21b27a557$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$e36f1de21b27a557$export$f8e21b1e77979a08(n + (s = s[c].value), "span", 0) ? n : $e36f1de21b27a557$export$71ad59f2e432cfe8 + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $e36f1de21b27a557$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$e36f1de21b27a557$export$f8e21b1e77979a08(s, "span", 0) ? $e36f1de21b27a557$export$4659b591c19bdf3d(s, /\d+/) : +$e36f1de21b27a557$export$4659b591c19bdf3d(s, /\d+/) - +$e36f1de21b27a557$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $e36f1de21b27a557$export$71ad59f2e432cfe8 + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $e36f1de21b27a557$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $e36f1de21b27a557$export$71ad59f2e432cfe8 + $e36f1de21b27a557$export$77ad94ebf1c2b9ed($e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $e36f1de21b27a557$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($e36f1de21b27a557$export$36776f635604f274(n) - 1 - c > 6) switch($e36f1de21b27a557$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($e36f1de21b27a557$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $e36f1de21b27a557$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $e36f1de21b27a557$export$2c0f367103c8d01c + ($e36f1de21b27a557$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$e36f1de21b27a557$export$f8e21b1e77979a08(n, "stretch", 0) ? $e36f1de21b27a557$export$82e9f45cca5ba907($e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $e36f1de21b27a557$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $e36f1de21b27a557$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($e36f1de21b27a557$export$a9db5e087081082d(n, c + 6) === 121) return $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, ":", ":" + $e36f1de21b27a557$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($e36f1de21b27a557$export$a9db5e087081082d(n, $e36f1de21b27a557$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $e36f1de21b27a557$export$39dfd62a25e0fe93 + ($e36f1de21b27a557$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $e36f1de21b27a557$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $e36f1de21b27a557$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, ":", ":" + $e36f1de21b27a557$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $e36f1de21b27a557$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    for(var n = 0; n < e.length; n++)a += r(e[n], n, e, r) || "";
    return a;
}
function $e36f1de21b27a557$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $e36f1de21b27a557$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $e36f1de21b27a557$export$a763edbf796b780a:
        case $e36f1de21b27a557$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $e36f1de21b27a557$export$a29989082612d0d9:
            return "";
        case $e36f1de21b27a557$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $e36f1de21b27a557$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $e36f1de21b27a557$export$aa3a2e812ca8570d:
            if (!$e36f1de21b27a557$export$36776f635604f274(e.value = e.props.join(","))) return "";
    }
    return $e36f1de21b27a557$export$36776f635604f274(a = $e36f1de21b27a557$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $e36f1de21b27a557$export$5a7767152ae0305f(e) {
    var r = $e36f1de21b27a557$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $e36f1de21b27a557$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $e36f1de21b27a557$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $e36f1de21b27a557$export$527d108ccf083c2b:
                n.return = $e36f1de21b27a557$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $e36f1de21b27a557$export$b44a8529a35fcb60:
                return $e36f1de21b27a557$export$dfdc1655ccc5b9cb([
                    $e36f1de21b27a557$export$784d13d8ee351f07(n, {
                        value: $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $e36f1de21b27a557$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $e36f1de21b27a557$export$aa3a2e812ca8570d:
                if (n.length) return $e36f1de21b27a557$export$1be1fc439b849fdf(u = n.props, function(c) {
                    switch($e36f1de21b27a557$export$4659b591c19bdf3d(c, i = /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            $e36f1de21b27a557$export$590e8b2c435046d9($e36f1de21b27a557$export$784d13d8ee351f07(n, {
                                props: [
                                    $e36f1de21b27a557$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $e36f1de21b27a557$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $e36f1de21b27a557$export$590e8b2c435046d9($e36f1de21b27a557$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $e36f1de21b27a557$export$e6e34fd1f2686227(n, {
                                props: $e36f1de21b27a557$export$3dea766d36a8935f(u, i)
                            });
                            break;
                        case "::placeholder":
                            $e36f1de21b27a557$export$590e8b2c435046d9($e36f1de21b27a557$export$784d13d8ee351f07(n, {
                                props: [
                                    $e36f1de21b27a557$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $e36f1de21b27a557$export$39dfd62a25e0fe93 + "input-$1")
                                ]
                            }));
                            $e36f1de21b27a557$export$590e8b2c435046d9($e36f1de21b27a557$export$784d13d8ee351f07(n, {
                                props: [
                                    $e36f1de21b27a557$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $e36f1de21b27a557$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $e36f1de21b27a557$export$590e8b2c435046d9($e36f1de21b27a557$export$784d13d8ee351f07(n, {
                                props: [
                                    $e36f1de21b27a557$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $e36f1de21b27a557$export$71ad59f2e432cfe8 + "input-$1")
                                ]
                            }));
                            $e36f1de21b27a557$export$590e8b2c435046d9($e36f1de21b27a557$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $e36f1de21b27a557$export$e6e34fd1f2686227(n, {
                                props: $e36f1de21b27a557$export$3dea766d36a8935f(u, i)
                            });
                            break;
                    }
                    return "";
                });
        }
    }
}
function $e36f1de21b27a557$export$76a88f7de6507443(e) {
    switch(e.type){
        case $e36f1de21b27a557$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $e36f1de21b27a557$export$1be1fc439b849fdf($e36f1de21b27a557$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($e36f1de21b27a557$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $e36f1de21b27a557$export$2f35ab04d2335697(r, 1, $e36f1de21b27a557$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $e36f1de21b27a557$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $e36f1de21b27a557$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $e36f1de21b27a557$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $d38c40c43cea0c69$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};


var $d3c1734dacb01657$exports = {};
// shim for using process in browser
var $d3c1734dacb01657$var$process = $d3c1734dacb01657$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $d3c1734dacb01657$var$cachedSetTimeout;
var $d3c1734dacb01657$var$cachedClearTimeout;
function $d3c1734dacb01657$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $d3c1734dacb01657$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $d3c1734dacb01657$var$cachedSetTimeout = setTimeout;
        else $d3c1734dacb01657$var$cachedSetTimeout = $d3c1734dacb01657$var$defaultSetTimout;
    } catch (e) {
        $d3c1734dacb01657$var$cachedSetTimeout = $d3c1734dacb01657$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $d3c1734dacb01657$var$cachedClearTimeout = clearTimeout;
        else $d3c1734dacb01657$var$cachedClearTimeout = $d3c1734dacb01657$var$defaultClearTimeout;
    } catch (e) {
        $d3c1734dacb01657$var$cachedClearTimeout = $d3c1734dacb01657$var$defaultClearTimeout;
    }
})();
function $d3c1734dacb01657$var$runTimeout(fun) {
    if ($d3c1734dacb01657$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($d3c1734dacb01657$var$cachedSetTimeout === $d3c1734dacb01657$var$defaultSetTimout || !$d3c1734dacb01657$var$cachedSetTimeout) && setTimeout) {
        $d3c1734dacb01657$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d3c1734dacb01657$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $d3c1734dacb01657$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $d3c1734dacb01657$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $d3c1734dacb01657$var$runClearTimeout(marker) {
    if ($d3c1734dacb01657$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($d3c1734dacb01657$var$cachedClearTimeout === $d3c1734dacb01657$var$defaultClearTimeout || !$d3c1734dacb01657$var$cachedClearTimeout) && clearTimeout) {
        $d3c1734dacb01657$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d3c1734dacb01657$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $d3c1734dacb01657$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $d3c1734dacb01657$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $d3c1734dacb01657$var$queue = [];
var $d3c1734dacb01657$var$draining = false;
var $d3c1734dacb01657$var$currentQueue;
var $d3c1734dacb01657$var$queueIndex = -1;
function $d3c1734dacb01657$var$cleanUpNextTick() {
    if (!$d3c1734dacb01657$var$draining || !$d3c1734dacb01657$var$currentQueue) return;
    $d3c1734dacb01657$var$draining = false;
    if ($d3c1734dacb01657$var$currentQueue.length) $d3c1734dacb01657$var$queue = $d3c1734dacb01657$var$currentQueue.concat($d3c1734dacb01657$var$queue);
    else $d3c1734dacb01657$var$queueIndex = -1;
    if ($d3c1734dacb01657$var$queue.length) $d3c1734dacb01657$var$drainQueue();
}
function $d3c1734dacb01657$var$drainQueue() {
    if ($d3c1734dacb01657$var$draining) return;
    var timeout = $d3c1734dacb01657$var$runTimeout($d3c1734dacb01657$var$cleanUpNextTick);
    $d3c1734dacb01657$var$draining = true;
    var len = $d3c1734dacb01657$var$queue.length;
    while(len){
        $d3c1734dacb01657$var$currentQueue = $d3c1734dacb01657$var$queue;
        $d3c1734dacb01657$var$queue = [];
        while(++$d3c1734dacb01657$var$queueIndex < len)if ($d3c1734dacb01657$var$currentQueue) $d3c1734dacb01657$var$currentQueue[$d3c1734dacb01657$var$queueIndex].run();
        $d3c1734dacb01657$var$queueIndex = -1;
        len = $d3c1734dacb01657$var$queue.length;
    }
    $d3c1734dacb01657$var$currentQueue = null;
    $d3c1734dacb01657$var$draining = false;
    $d3c1734dacb01657$var$runClearTimeout(timeout);
}
$d3c1734dacb01657$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $d3c1734dacb01657$var$queue.push(new $d3c1734dacb01657$var$Item(fun, args));
    if ($d3c1734dacb01657$var$queue.length === 1 && !$d3c1734dacb01657$var$draining) $d3c1734dacb01657$var$runTimeout($d3c1734dacb01657$var$drainQueue);
};
// v8 likes predictible objects
function $d3c1734dacb01657$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$d3c1734dacb01657$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$d3c1734dacb01657$var$process.title = 'browser';
$d3c1734dacb01657$var$process.browser = true;
$d3c1734dacb01657$var$process.env = {};
$d3c1734dacb01657$var$process.argv = [];
$d3c1734dacb01657$var$process.version = ''; // empty string to avoid regexp issues
$d3c1734dacb01657$var$process.versions = {};
function $d3c1734dacb01657$var$noop() {}
$d3c1734dacb01657$var$process.on = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.addListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.once = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.off = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.removeListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.removeAllListeners = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.emit = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.prependListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.prependOnceListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.listeners = function(name) {
    return [];
};
$d3c1734dacb01657$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$d3c1734dacb01657$var$process.cwd = function() {
    return '/';
};
$d3c1734dacb01657$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$d3c1734dacb01657$var$process.umask = function() {
    return 0;
};


var $65e706775ff71837$var$f = ("undefined" != typeof $d3c1734dacb01657$exports && void 0 !== $d3c1734dacb01657$exports.env && undefined, "data-styled"), $65e706775ff71837$export$83d89fbfd8236492 = "6.0.5", $65e706775ff71837$var$y = "undefined" != typeof window && "HTMLElement" in window, $65e706775ff71837$var$v = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : ("undefined" != typeof $d3c1734dacb01657$exports && $d3c1734dacb01657$exports.env, "undefined" != typeof $d3c1734dacb01657$exports && $d3c1734dacb01657$exports.env, false)), $65e706775ff71837$var$g = {}, $65e706775ff71837$var$S = /invalid hook call/i, $65e706775ff71837$var$w = new Set, $65e706775ff71837$var$b = function(t, n) {
    var o, s, i, a, e;
}, $65e706775ff71837$var$E = Object.freeze([]), $65e706775ff71837$var$N = Object.freeze({});
function $65e706775ff71837$var$P(e, t, n) {
    return void 0 === n && (n = $65e706775ff71837$var$N), e.theme !== n.theme && e.theme || t || n.theme;
}
var $65e706775ff71837$var$_ = new Set([
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "use",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
]), $65e706775ff71837$var$C = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $65e706775ff71837$var$I = /(^-|-$)/g;
function $65e706775ff71837$var$A(e) {
    return e.replace($65e706775ff71837$var$C, "-").replace($65e706775ff71837$var$I, "");
}
var $65e706775ff71837$var$O = /(a)(d)/gi, $65e706775ff71837$var$D = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $65e706775ff71837$var$R(e) {
    var t, n = "";
    for(t = Math.abs(e); t > 52; t = t / 52 | 0)n = $65e706775ff71837$var$D(t % 52) + n;
    return ($65e706775ff71837$var$D(t % 52) + n).replace($65e706775ff71837$var$O, "$1-$2");
}
var $65e706775ff71837$var$T, $65e706775ff71837$var$k = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $65e706775ff71837$var$j = function(e) {
    return $65e706775ff71837$var$k(5381, e);
};
function $65e706775ff71837$var$x(e) {
    return $65e706775ff71837$var$R($65e706775ff71837$var$j(e) >>> 0);
}
function $65e706775ff71837$var$V(e) {
    return (0, e.displayName) || e.name || "Component";
}
function $65e706775ff71837$var$M(e) {
    return "string" == typeof e && true;
}
var $65e706775ff71837$var$F = "function" == typeof Symbol && Symbol.for, $65e706775ff71837$var$$ = $65e706775ff71837$var$F ? Symbol.for("react.memo") : 60115, $65e706775ff71837$var$z = $65e706775ff71837$var$F ? Symbol.for("react.forward_ref") : 60112, $65e706775ff71837$var$B = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
}, $65e706775ff71837$var$L = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
}, $65e706775ff71837$var$G = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
}, $65e706775ff71837$var$Y = (($65e706775ff71837$var$T = {})[$65e706775ff71837$var$z] = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
}, $65e706775ff71837$var$T[$65e706775ff71837$var$$] = $65e706775ff71837$var$G, $65e706775ff71837$var$T);
function $65e706775ff71837$var$W(e) {
    var t;
    return ("type" in (t = e) && t.type.$$typeof) === $65e706775ff71837$var$$ ? $65e706775ff71837$var$G : "$$typeof" in e ? $65e706775ff71837$var$Y[e.$$typeof] : $65e706775ff71837$var$B;
}
var $65e706775ff71837$var$q = Object.defineProperty, $65e706775ff71837$var$H = Object.getOwnPropertyNames, $65e706775ff71837$var$U = Object.getOwnPropertySymbols, $65e706775ff71837$var$J = Object.getOwnPropertyDescriptor, $65e706775ff71837$var$X = Object.getPrototypeOf, $65e706775ff71837$var$Z = Object.prototype;
function $65e706775ff71837$var$K(e, t, n) {
    if ("string" != typeof t) {
        if ($65e706775ff71837$var$Z) {
            var o = $65e706775ff71837$var$X(t);
            o && o !== $65e706775ff71837$var$Z && $65e706775ff71837$var$K(e, o, n);
        }
        var r = $65e706775ff71837$var$H(t);
        $65e706775ff71837$var$U && (r = r.concat($65e706775ff71837$var$U(t)));
        for(var s = $65e706775ff71837$var$W(e), i = $65e706775ff71837$var$W(t), a = 0; a < r.length; ++a){
            var c = r[a];
            if (!(c in $65e706775ff71837$var$L || n && n[c] || i && c in i || s && c in s)) {
                var l = $65e706775ff71837$var$J(t, c);
                try {
                    $65e706775ff71837$var$q(e, c, l);
                } catch (e) {}
            }
        }
    }
    return e;
}
function $65e706775ff71837$var$Q(e) {
    return "function" == typeof e;
}
function $65e706775ff71837$export$7ba318d8d2f06c76(e) {
    return "object" == typeof e && "styledComponentId" in e;
}
function $65e706775ff71837$var$te(e, t) {
    return e && t ? "".concat(e, " ").concat(t) : e || t || "";
}
function $65e706775ff71837$var$ne(e, t) {
    if (0 === e.length) return "";
    for(var n = e[0], o = 1; o < e.length; o++)n += t ? t + e[o] : e[o];
    return n;
}
function $65e706775ff71837$var$oe(e) {
    return null !== e && "object" == typeof e && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function $65e706775ff71837$var$re(e, t, n) {
    if (void 0 === n && (n = !1), !n && !$65e706775ff71837$var$oe(e) && !Array.isArray(e)) return t;
    if (Array.isArray(t)) for(var o = 0; o < t.length; o++)e[o] = $65e706775ff71837$var$re(e[o], t[o]);
    else if ($65e706775ff71837$var$oe(t)) for(var o in t)e[o] = $65e706775ff71837$var$re(e[o], t[o]);
    return e;
}
function $65e706775ff71837$var$se(e, t) {
    Object.defineProperty(e, "toString", {
        value: t
    });
}
var $65e706775ff71837$var$ie = {};
function $65e706775ff71837$var$ae() {
    for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
    for(var n = e[0], o = [], r = 1, s = e.length; r < s; r += 1)o.push(e[r]);
    return o.forEach(function(e) {
        n = n.replace(/%[a-z]/, e);
    }), n;
}
function $65e706775ff71837$var$ce(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    return new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t, " for more information.").concat(n.length > 0 ? " Args: ".concat(n.join(", ")) : ""));
}
var $65e706775ff71837$var$le = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    return e.prototype.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, e.prototype.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, o = n.length, r = o; e >= r;)if ((r <<= 1) < 0) throw $65e706775ff71837$var$ce(16, "".concat(e));
            this.groupSizes = new Uint32Array(r), this.groupSizes.set(n), this.length = r;
            for(var s = o; s < r; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = (s = 0, t.length); s < a; s++)this.tag.insertRule(i, t[s]) && (this.groupSizes[e]++, i++);
    }, e.prototype.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), o = n + t;
            this.groupSizes[e] = 0;
            for(var r = n; r < o; r++)this.tag.deleteRule(n);
        }
    }, e.prototype.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], o = this.indexOfGroup(e), r = o + n, s = o; s < r; s++)t += "".concat(this.tag.getRule(s)).concat("/*!sc*/\n");
        return t;
    }, e;
}(), $65e706775ff71837$var$ue = new Map, $65e706775ff71837$var$pe = new Map, $65e706775ff71837$var$de = 1, $65e706775ff71837$var$he = function(e) {
    if ($65e706775ff71837$var$ue.has(e)) return $65e706775ff71837$var$ue.get(e);
    for(; $65e706775ff71837$var$pe.has($65e706775ff71837$var$de);)$65e706775ff71837$var$de++;
    var t = $65e706775ff71837$var$de++;
    return $65e706775ff71837$var$ue.set(e, t), $65e706775ff71837$var$pe.set(t, e), t;
}, $65e706775ff71837$var$fe = function(e, t) {
    $65e706775ff71837$var$ue.set(e, t), $65e706775ff71837$var$pe.set(t, e);
}, $65e706775ff71837$var$me = "style[".concat($65e706775ff71837$var$f, "][").concat("data-styled-version", '="').concat("6.0.5", '"]'), $65e706775ff71837$var$ye = new RegExp("^".concat($65e706775ff71837$var$f, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), $65e706775ff71837$var$ve = function(e, t, n) {
    for(var o, r = n.split(","), s = 0, i = r.length; s < i; s++)(o = r[s]) && e.registerName(t, o);
}, $65e706775ff71837$var$ge = function(e, t) {
    for(var n, o = (null !== (n = t.textContent) && void 0 !== n ? n : "").split("/*!sc*/\n"), r = [], s = 0, i = o.length; s < i; s++){
        var a = o[s].trim();
        if (a) {
            var c = a.match($65e706775ff71837$var$ye);
            if (c) {
                var l = 0 | parseInt(c[1], 10), u = c[2];
                0 !== l && ($65e706775ff71837$var$fe(u, l), $65e706775ff71837$var$ve(e, u, c[3]), e.getTag().insertRules(l, r)), r.length = 0;
            } else r.push(a);
        }
    }
};
function $65e706775ff71837$var$Se() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}
var $65e706775ff71837$var$we = function(e) {
    var t = document.head, n = e || t, o = document.createElement("style"), r = function(e) {
        var t = Array.from(e.querySelectorAll("style[".concat($65e706775ff71837$var$f, "]")));
        return t[t.length - 1];
    }(n), s = void 0 !== r ? r.nextSibling : null;
    o.setAttribute($65e706775ff71837$var$f, "active"), o.setAttribute("data-styled-version", "6.0.5");
    var i = $65e706775ff71837$var$Se();
    return i && o.setAttribute("nonce", i), n.insertBefore(o, s), o;
}, $65e706775ff71837$var$be = function() {
    function e(e) {
        this.element = $65e706775ff71837$var$we(e), this.element.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, o = t.length; n < o; n++){
                var r = t[n];
                if (r.ownerNode === e) return r;
            }
            throw $65e706775ff71837$var$ce(17);
        }(this.element), this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, e.prototype.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, e.prototype.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return t && t.cssText ? t.cssText : "";
    }, e;
}(), $65e706775ff71837$var$Ee = function() {
    function e(e) {
        this.element = $65e706775ff71837$var$we(e), this.nodes = this.element.childNodes, this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t);
            return this.element.insertBefore(n, this.nodes[e] || null), this.length++, !0;
        }
        return !1;
    }, e.prototype.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $65e706775ff71837$var$Ne = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, e.prototype.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $65e706775ff71837$var$Pe = $65e706775ff71837$var$y, $65e706775ff71837$var$_e = {
    isServer: !$65e706775ff71837$var$y,
    useCSSOMInjection: !$65e706775ff71837$var$v
}, $65e706775ff71837$var$Ce = function() {
    function e(e, n, o) {
        void 0 === e && (e = $65e706775ff71837$var$N), void 0 === n && (n = {});
        var r = this;
        this.options = (0, $c106e002a49a00cb$export$18ce0697a983be9b)((0, $c106e002a49a00cb$export$18ce0697a983be9b)({}, $65e706775ff71837$var$_e), e), this.gs = n, this.names = new Map(o), this.server = !!e.isServer, !this.server && $65e706775ff71837$var$y && $65e706775ff71837$var$Pe && ($65e706775ff71837$var$Pe = !1, function(e) {
            for(var t = document.querySelectorAll($65e706775ff71837$var$me), n = 0, o = t.length; n < o; n++){
                var r = t[n];
                r && "active" !== r.getAttribute($65e706775ff71837$var$f) && ($65e706775ff71837$var$ge(e, r), r.parentNode && r.parentNode.removeChild(r));
            }
        }(this)), $65e706775ff71837$var$se(this, function() {
            return function(e) {
                for(var t = e.getTag(), n = t.length, o = "", r = function(n) {
                    var r = function(e) {
                        return $65e706775ff71837$var$pe.get(e);
                    }(n);
                    if (void 0 === r) return "continue";
                    var s = e.names.get(r), i = t.getGroup(n);
                    if (void 0 === s || 0 === i.length) return "continue";
                    var a = "".concat($65e706775ff71837$var$f, ".g").concat(n, '[id="').concat(r, '"]'), c = "";
                    void 0 !== s && s.forEach(function(e) {
                        e.length > 0 && (c += "".concat(e, ","));
                    }), o += "".concat(i).concat(a, '{content:"').concat(c, '"}').concat("/*!sc*/\n");
                }, s = 0; s < n; s++)r(s);
                return o;
            }(r);
        });
    }
    return e.registerId = function(e) {
        return $65e706775ff71837$var$he(e);
    }, e.prototype.reconstructWithOptions = function(n, o) {
        return void 0 === o && (o = !0), new e((0, $c106e002a49a00cb$export$18ce0697a983be9b)((0, $c106e002a49a00cb$export$18ce0697a983be9b)({}, this.options), n), this.gs, o && this.names || void 0);
    }, e.prototype.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, e.prototype.getTag = function() {
        var e;
        return this.tag || (this.tag = (e = function(e) {
            var t = e.useCSSOMInjection, n = e.target;
            return e.isServer ? new $65e706775ff71837$var$Ne(n) : t ? new $65e706775ff71837$var$be(n) : new $65e706775ff71837$var$Ee(n);
        }(this.options), new $65e706775ff71837$var$le(e)));
    }, e.prototype.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, e.prototype.registerName = function(e, t) {
        if ($65e706775ff71837$var$he(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, e.prototype.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($65e706775ff71837$var$he(e), n);
    }, e.prototype.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, e.prototype.clearRules = function(e) {
        this.getTag().clearGroup($65e706775ff71837$var$he(e)), this.clearNames(e);
    }, e.prototype.clearTag = function() {
        this.tag = void 0;
    }, e;
}(), $65e706775ff71837$var$Ie = /&/g, $65e706775ff71837$var$Ae = /^\s*\/\/.*$/gm;
function $65e706775ff71837$var$Oe(e, t) {
    return e.map(function(e) {
        return "rule" === e.type && (e.value = "".concat(t, " ").concat(e.value), e.value = e.value.replaceAll(",", ",".concat(t, " ")), e.props = e.props.map(function(e) {
            return "".concat(t, " ").concat(e);
        })), Array.isArray(e.children) && "@keyframes" !== e.type && (e.children = $65e706775ff71837$var$Oe(e.children, t)), e;
    });
}
function $65e706775ff71837$var$De(e) {
    var t, n, o, r = void 0 === e ? $65e706775ff71837$var$N : e, s = r.options, i = void 0 === s ? $65e706775ff71837$var$N : s, a = r.plugins, c = void 0 === a ? $65e706775ff71837$var$E : a, l = function(e, o, r) {
        return r === n || r.startsWith(n) && r.endsWith(n) && r.replaceAll(n, "").length > 0 ? ".".concat(t) : e;
    }, u = c.slice();
    u.push(function(e) {
        e.type === $e36f1de21b27a557$export$aa3a2e812ca8570d && e.value.includes("&") && (e.props[0] = e.props[0].replace($65e706775ff71837$var$Ie, n).replace(o, l));
    }), i.prefix && u.push($e36f1de21b27a557$export$e08c7d021b829b7a), u.push($e36f1de21b27a557$export$fac44ee5b035f737);
    var p = function(e, r, s, a) {
        void 0 === r && (r = ""), void 0 === s && (s = ""), void 0 === a && (a = "&"), t = a, n = r, o = new RegExp("\\".concat(n, "\\b"), "g");
        var c = e.replace($65e706775ff71837$var$Ae, ""), l = $e36f1de21b27a557$export$ef7acd7185315e22(s || r ? "".concat(s, " ").concat(r, " { ").concat(c, " }") : c);
        i.namespace && (l = $65e706775ff71837$var$Oe(l, i.namespace));
        var p = [];
        return $e36f1de21b27a557$export$dfdc1655ccc5b9cb(l, $e36f1de21b27a557$export$5a7767152ae0305f(u.concat($e36f1de21b27a557$export$38bcb760f1d4871c(function(e) {
            return p.push(e);
        })))), p;
    };
    return p.hash = c.length ? c.reduce(function(e, t) {
        return t.name || $65e706775ff71837$var$ce(15), $65e706775ff71837$var$k(e, t.name);
    }, 5381).toString() : "", p;
}
var $65e706775ff71837$var$Re = new $65e706775ff71837$var$Ce, $65e706775ff71837$var$Te = $65e706775ff71837$var$De(), $65e706775ff71837$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createContext({
    shouldForwardProp: void 0,
    styleSheet: $65e706775ff71837$var$Re,
    stylis: $65e706775ff71837$var$Te
}), $65e706775ff71837$export$91317688fc694efa = $65e706775ff71837$export$8c190ef828af4c86.Consumer, $65e706775ff71837$var$xe = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createContext(void 0);
function $65e706775ff71837$var$Ve() {
    return (0, $8NFma.useContext)($65e706775ff71837$export$8c190ef828af4c86);
}
function $65e706775ff71837$export$a473771da2f0ff7c(e) {
    var t = (0, $8NFma.useState)(e.stylisPlugins), n = t[0], r = t[1], c = $65e706775ff71837$var$Ve().styleSheet, l = (0, $8NFma.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target,
        c
    ]), u = (0, $8NFma.useMemo)(function() {
        return $65e706775ff71837$var$De({
            options: {
                namespace: e.namespace,
                prefix: e.enableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.enableVendorPrefixes,
        e.namespace,
        n
    ]);
    return (0, $8NFma.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($ee39632639537d25$exports)))(n, e.stylisPlugins) || r(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement($65e706775ff71837$export$8c190ef828af4c86.Provider, {
        value: {
            shouldForwardProp: e.shouldForwardProp,
            styleSheet: l,
            stylis: u
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement($65e706775ff71837$var$xe.Provider, {
        value: u
    }, e.children));
}
var $65e706775ff71837$var$Fe = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $65e706775ff71837$var$Te);
            var o = n.name + t.hash;
            e.hasNameForId(n.id, o) || e.insertRules(n.id, o, t(n.rules, o, "@keyframes"));
        }, this.name = e, this.id = "sc-keyframes-".concat(e), this.rules = t, $65e706775ff71837$var$se(this, function() {
            throw $65e706775ff71837$var$ce(12, String(n.name));
        });
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $65e706775ff71837$var$Te), this.name + e.hash;
    }, e;
}(), $65e706775ff71837$var$$e = function(e) {
    return e >= "A" && e <= "Z";
};
function $65e706775ff71837$var$ze(e) {
    for(var t = "", n = 0; n < e.length; n++){
        var o = e[n];
        if (1 === n && "-" === o && "-" === e[0]) return e;
        $65e706775ff71837$var$$e(o) ? t += "-" + o.toLowerCase() : t += o;
    }
    return t.startsWith("ms-") ? "-" + t : t;
}
var $65e706775ff71837$var$Be = function(e) {
    return null == e || !1 === e || "" === e;
}, $65e706775ff71837$var$Le = function(t) {
    var n, o, r = [];
    for(var s in t){
        var i = t[s];
        t.hasOwnProperty(s) && !$65e706775ff71837$var$Be(i) && (Array.isArray(i) && i.isCss || $65e706775ff71837$var$Q(i) ? r.push("".concat($65e706775ff71837$var$ze(s), ":"), i, ";") : $65e706775ff71837$var$oe(i) ? r.push.apply(r, (0, $c106e002a49a00cb$export$1216008129fb82ed)((0, $c106e002a49a00cb$export$1216008129fb82ed)([
            "".concat(s, " {")
        ], $65e706775ff71837$var$Le(i), !1), [
            "}"
        ], !1)) : r.push("".concat($65e706775ff71837$var$ze(s), ": ").concat((n = s, null == (o = i) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || n in (0, $d38c40c43cea0c69$export$2e2bcd8739ae039) || n.startsWith("--") ? String(o).trim() : "".concat(o, "px")), ";")));
    }
    return r;
};
function $65e706775ff71837$var$Ge(e, t, n, o) {
    if ($65e706775ff71837$var$Be(e)) return [];
    if ($65e706775ff71837$export$7ba318d8d2f06c76(e)) return [
        ".".concat(e.styledComponentId)
    ];
    if ($65e706775ff71837$var$Q(e)) {
        if (!$65e706775ff71837$var$Q(s = e) || s.prototype && s.prototype.isReactComponent || !t) return [
            e
        ];
        var r = e(t);
        return $65e706775ff71837$var$Ge(r, t, n, o);
    }
    var s;
    return e instanceof $65e706775ff71837$var$Fe ? n ? (e.inject(n, o), [
        e.getName(o)
    ]) : [
        e
    ] : $65e706775ff71837$var$oe(e) ? $65e706775ff71837$var$Le(e) : Array.isArray(e) ? Array.prototype.concat.apply($65e706775ff71837$var$E, e.map(function(e) {
        return $65e706775ff71837$var$Ge(e, t, n, o);
    })) : [
        e.toString()
    ];
}
function $65e706775ff71837$var$Ye(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($65e706775ff71837$var$Q(n) && !$65e706775ff71837$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $65e706775ff71837$var$We = $65e706775ff71837$var$j("6.0.5"), $65e706775ff71837$var$qe = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $65e706775ff71837$var$Ye(e), this.componentId = t, this.baseHash = $65e706775ff71837$var$k($65e706775ff71837$var$We, t), this.baseStyle = n, $65e706775ff71837$var$Ce.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var o = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, t, n) : "";
        if (this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(this.componentId, this.staticRulesId)) o = $65e706775ff71837$var$te(o, this.staticRulesId);
            else {
                var r = $65e706775ff71837$var$ne($65e706775ff71837$var$Ge(this.rules, e, t, n)), s = $65e706775ff71837$var$R($65e706775ff71837$var$k(this.baseHash, r) >>> 0);
                if (!t.hasNameForId(this.componentId, s)) {
                    var i = n(r, ".".concat(s), void 0, this.componentId);
                    t.insertRules(this.componentId, s, i);
                }
                o = $65e706775ff71837$var$te(o, s), this.staticRulesId = s;
            }
        } else {
            for(var a = $65e706775ff71837$var$k(this.baseHash, n.hash), c = "", l = 0; l < this.rules.length; l++){
                var u = this.rules[l];
                if ("string" == typeof u) c += u;
                else if (u) {
                    var p = $65e706775ff71837$var$ne($65e706775ff71837$var$Ge(u, e, t, n));
                    a = $65e706775ff71837$var$k(a, p), c += p;
                }
            }
            if (c) {
                var d = $65e706775ff71837$var$R(a >>> 0);
                t.hasNameForId(this.componentId, d) || t.insertRules(this.componentId, d, n(c, ".".concat(d), void 0, this.componentId)), o = $65e706775ff71837$var$te(o, d);
            }
        }
        return o;
    }, e;
}(), $65e706775ff71837$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createContext(void 0), $65e706775ff71837$export$b631efc24e9d5e2f = $65e706775ff71837$export$2c657da244d00bd6.Consumer;
function $65e706775ff71837$export$93d4e7f90805808f() {
    var e = (0, $8NFma.useContext)($65e706775ff71837$export$2c657da244d00bd6);
    if (!e) throw $65e706775ff71837$var$ce(18);
    return e;
}
function $65e706775ff71837$export$d8964aec282183a3(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useContext($65e706775ff71837$export$2c657da244d00bd6), r = (0, $8NFma.useMemo)(function() {
        return function(e, n) {
            if (!e) throw $65e706775ff71837$var$ce(14);
            if ($65e706775ff71837$var$Q(e)) {
                var o = e(n);
                return o;
            }
            if (Array.isArray(e) || "object" != typeof e) throw $65e706775ff71837$var$ce(8);
            return n ? (0, $c106e002a49a00cb$export$18ce0697a983be9b)((0, $c106e002a49a00cb$export$18ce0697a983be9b)({}, n), e) : e;
        }(e.theme, n);
    }, [
        e.theme,
        n
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement($65e706775ff71837$export$2c657da244d00bd6.Provider, {
        value: r
    }, e.children) : null;
}
var $65e706775ff71837$var$Ze = {}, $65e706775ff71837$var$Ke = new Set;
function $65e706775ff71837$var$Qe(e, r, s) {
    var i = $65e706775ff71837$export$7ba318d8d2f06c76(e), a = e, c = !$65e706775ff71837$var$M(e), p = r.attrs, d = void 0 === p ? $65e706775ff71837$var$E : p, h = r.componentId, f = void 0 === h ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $65e706775ff71837$var$A(e);
        $65e706775ff71837$var$Ze[n] = ($65e706775ff71837$var$Ze[n] || 0) + 1;
        var o = "".concat(n, "-").concat($65e706775ff71837$var$x("6.0.5" + n + $65e706775ff71837$var$Ze[n]));
        return t ? "".concat(t, "-").concat(o) : o;
    }(r.displayName, r.parentComponentId) : h, m = r.displayName, y = void 0 === m ? function(e) {
        return $65e706775ff71837$var$M(e) ? "styled.".concat(e) : "Styled(".concat($65e706775ff71837$var$V(e), ")");
    }(e) : m, v = r.displayName && r.componentId ? "".concat($65e706775ff71837$var$A(r.displayName), "-").concat(r.componentId) : r.componentId || f, g = i && a.attrs ? a.attrs.concat(d).filter(Boolean) : d, S = r.shouldForwardProp;
    if (i && a.shouldForwardProp) {
        var w = a.shouldForwardProp;
        if (r.shouldForwardProp) {
            var C = r.shouldForwardProp;
            S = function(e, t) {
                return w(e, t) && C(e, t);
            };
        } else S = w;
    }
    var I = new $65e706775ff71837$var$qe(s, v, i ? a.componentStyle : void 0);
    function O(e, r) {
        return function(e, r, s) {
            var i = e.attrs, a = e.componentStyle, c = e.defaultProps, p = e.foldedComponentIds, d = e.styledComponentId, h = e.target, f = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useContext($65e706775ff71837$export$2c657da244d00bd6), m = $65e706775ff71837$var$Ve(), y = e.shouldForwardProp || m.shouldForwardProp;
            var v = function(e, n, o) {
                for(var r, s = (0, $c106e002a49a00cb$export$18ce0697a983be9b)((0, $c106e002a49a00cb$export$18ce0697a983be9b)({}, n), {
                    className: void 0,
                    theme: o
                }), i = 0; i < e.length; i += 1){
                    var a = $65e706775ff71837$var$Q(r = e[i]) ? r(s) : r;
                    for(var c in a)s[c] = "className" === c ? $65e706775ff71837$var$te(s[c], a[c]) : "style" === c ? (0, $c106e002a49a00cb$export$18ce0697a983be9b)((0, $c106e002a49a00cb$export$18ce0697a983be9b)({}, s[c]), a[c]) : a[c];
                }
                return n.className && (s.className = $65e706775ff71837$var$te(s.className, n.className)), s;
            }(i, r, $65e706775ff71837$var$P(r, f, c) || $65e706775ff71837$var$N), g = v.as || h, S = {};
            for(var w in v)void 0 === v[w] || "$" === w[0] || "as" === w || "theme" === w || ("forwardedAs" === w ? S.as = v.forwardedAs : y && !y(w, g) || (S[w] = v[w], y));
            var b = function(e, t) {
                var n = $65e706775ff71837$var$Ve(), o = e.generateAndInjectStyles(t, n.styleSheet, n.stylis);
                return o;
            }(a, v);
            var E = $65e706775ff71837$var$te(p, d);
            return b && (E += " " + b), v.className && (E += " " + v.className), S[$65e706775ff71837$var$M(g) && !$65e706775ff71837$var$_.has(g) ? "class" : "className"] = E, S.ref = s, (0, $8NFma.createElement)(g, S);
        }(D, e, r);
    }
    var D = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).forwardRef(O);
    return D.attrs = g, D.componentStyle = I, D.shouldForwardProp = S, D.foldedComponentIds = i ? $65e706775ff71837$var$te(a.foldedComponentIds, a.styledComponentId) : "", D.styledComponentId = v, D.target = i ? a.target : e, Object.defineProperty(D, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(e) {
            this._foldedDefaultProps = i ? function(e) {
                for(var t = [], n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
                for(var o = 0, r = t; o < r.length; o++)$65e706775ff71837$var$re(e, r[o], !0);
                return e;
            }({}, a.defaultProps, e) : e;
        }
    }), $65e706775ff71837$var$se(D, function() {
        return ".".concat(D.styledComponentId);
    }), c && $65e706775ff71837$var$K(D, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0
    }), D;
}
function $65e706775ff71837$var$et(e, t) {
    for(var n = [
        e[0]
    ], o = 0, r = t.length; o < r; o += 1)n.push(t[o], e[o + 1]);
    return n;
}
var $65e706775ff71837$var$tt = function(e) {
    return Object.assign(e, {
        isCss: !0
    });
};
function $65e706775ff71837$export$dbf350e5966cf602(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    if ($65e706775ff71837$var$Q(t) || $65e706775ff71837$var$oe(t)) {
        var r = t;
        return $65e706775ff71837$var$tt($65e706775ff71837$var$Ge($65e706775ff71837$var$et($65e706775ff71837$var$E, (0, $c106e002a49a00cb$export$1216008129fb82ed)([
            r
        ], n, !0))));
    }
    var s = t;
    return 0 === n.length && 1 === s.length && "string" == typeof s[0] ? $65e706775ff71837$var$Ge(s) : $65e706775ff71837$var$tt($65e706775ff71837$var$Ge($65e706775ff71837$var$et(s, n)));
}
function $65e706775ff71837$var$ot(n, o, r) {
    if (void 0 === r && (r = $65e706775ff71837$var$N), !o) throw $65e706775ff71837$var$ce(1, o);
    var s = function(t) {
        for(var s = [], i = 1; i < arguments.length; i++)s[i - 1] = arguments[i];
        return n(o, r, $65e706775ff71837$export$dbf350e5966cf602.apply(void 0, (0, $c106e002a49a00cb$export$1216008129fb82ed)([
            t
        ], s, !1)));
    };
    return s.attrs = function(e) {
        return $65e706775ff71837$var$ot(n, o, (0, $c106e002a49a00cb$export$18ce0697a983be9b)((0, $c106e002a49a00cb$export$18ce0697a983be9b)({}, r), {
            attrs: Array.prototype.concat(r.attrs, e).filter(Boolean)
        }));
    }, s.withConfig = function(e) {
        return $65e706775ff71837$var$ot(n, o, (0, $c106e002a49a00cb$export$18ce0697a983be9b)((0, $c106e002a49a00cb$export$18ce0697a983be9b)({}, r), e));
    }, s;
}
var $65e706775ff71837$var$rt = function(e) {
    return $65e706775ff71837$var$ot($65e706775ff71837$var$Qe, e);
}, $65e706775ff71837$export$2e2bcd8739ae039 = $65e706775ff71837$var$rt;
$65e706775ff71837$var$_.forEach(function(e) {
    $65e706775ff71837$export$2e2bcd8739ae039[e] = $65e706775ff71837$var$rt(e);
});
var $65e706775ff71837$var$it = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $65e706775ff71837$var$Ye(e), $65e706775ff71837$var$Ce.registerId(this.componentId + 1);
    }
    return e.prototype.createStyles = function(e, t, n, o) {
        var r = o($65e706775ff71837$var$ne($65e706775ff71837$var$Ge(this.rules, t, n, o)), ""), s = this.componentId + e;
        n.insertRules(s, s, r);
    }, e.prototype.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, e.prototype.renderStyles = function(e, t, n, o) {
        e > 2 && $65e706775ff71837$var$Ce.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, o);
    }, e;
}();
function $65e706775ff71837$export$f0f03736edb61697(n) {
    for(var r = [], s = 1; s < arguments.length; s++)r[s - 1] = arguments[s];
    var i = $65e706775ff71837$export$dbf350e5966cf602.apply(void 0, (0, $c106e002a49a00cb$export$1216008129fb82ed)([
        n
    ], r, !1)), a = "sc-global-".concat($65e706775ff71837$var$x(JSON.stringify(i))), c = new $65e706775ff71837$var$it(i, a);
    var l = function(e) {
        var t = $65e706775ff71837$var$Ve(), n = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useContext($65e706775ff71837$export$2c657da244d00bd6), r = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useRef(t.styleSheet.allocateGSInstance(a)).current;
        return t.styleSheet.server && u(r, e, t.styleSheet, n, t.stylis), (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useLayoutEffect(function() {
            if (!t.styleSheet.server) return u(r, e, t.styleSheet, n, t.stylis), function() {
                return c.removeStyles(r, t.styleSheet);
            };
        }, [
            r,
            e,
            t.styleSheet,
            n,
            t.stylis
        ]), null;
    };
    function u(e, n, o, r, s) {
        if (c.isStatic) c.renderStyles(e, $65e706775ff71837$var$g, o, s);
        else {
            var i = (0, $c106e002a49a00cb$export$18ce0697a983be9b)((0, $c106e002a49a00cb$export$18ce0697a983be9b)({}, n), {
                theme: $65e706775ff71837$var$P(n, r, l.defaultProps)
            });
            c.renderStyles(e, i, o, s);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).memo(l);
}
function $65e706775ff71837$export$d25ddfdf17c3ad3e(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    var r = $65e706775ff71837$var$ne($65e706775ff71837$export$dbf350e5966cf602.apply(void 0, (0, $c106e002a49a00cb$export$1216008129fb82ed)([
        t
    ], n, !1))), s = $65e706775ff71837$var$x(r);
    return new $65e706775ff71837$var$Fe(s, r);
}
function $65e706775ff71837$export$e8748c6a27b910dc(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).forwardRef(function(n, r) {
        var s = $65e706775ff71837$var$P(n, (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useContext($65e706775ff71837$export$2c657da244d00bd6), e.defaultProps);
        return (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement(e, (0, $c106e002a49a00cb$export$18ce0697a983be9b)({}, n, {
            theme: s,
            ref: r
        }));
    });
    return $65e706775ff71837$var$K(n, e);
}
var $65e706775ff71837$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString(), n = $65e706775ff71837$var$Se(), o = $65e706775ff71837$var$ne([
                n && 'nonce="'.concat(n, '"'),
                "".concat($65e706775ff71837$var$f, '="true"'),
                "".concat("data-styled-version", '="').concat("6.0.5", '"')
            ].filter(Boolean), " ");
            return "<style ".concat(o, ">").concat(t, "</style>");
        }, this.getStyleTags = function() {
            if (e.sealed) throw $65e706775ff71837$var$ce(2);
            return e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var n;
            if (e.sealed) throw $65e706775ff71837$var$ce(2);
            var r = ((n = {})[$65e706775ff71837$var$f] = "", n["data-styled-version"] = "6.0.5", n.dangerouslySetInnerHTML = {
                __html: e.instance.toString()
            }, n), s = $65e706775ff71837$var$Se();
            return s && (r.nonce = s), [
                (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("style", (0, $c106e002a49a00cb$export$18ce0697a983be9b)({}, r, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $65e706775ff71837$var$Ce({
            isServer: !0
        }), this.sealed = !1;
    }
    return e.prototype.collectStyles = function(e) {
        if (this.sealed) throw $65e706775ff71837$var$ce(2);
        return (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement($65e706775ff71837$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, e.prototype.interleaveWithNodeStream = function(e) {
        throw $65e706775ff71837$var$ce(3);
    }, e;
}(), $65e706775ff71837$export$5c87cfe6c475f500 = {
    StyleSheet: $65e706775ff71837$var$Ce,
    mainSheet: $65e706775ff71837$var$Re
};
var $65e706775ff71837$var$dt = "__sc-".concat($65e706775ff71837$var$f, "__");



var $8NFma = parcelRequire("8NFma");
var $e7dc2a3713e13569$exports = {};
'use strict';

$e7dc2a3713e13569$exports = (parcelRequire("eZfYi"));


var $5a4066412ccab0c1$var$__defProp = Object.defineProperty;
var $5a4066412ccab0c1$var$__defProps = Object.defineProperties;
var $5a4066412ccab0c1$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $5a4066412ccab0c1$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $5a4066412ccab0c1$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $5a4066412ccab0c1$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $5a4066412ccab0c1$var$__defNormalProp = (obj, key, value)=>key in obj ? $5a4066412ccab0c1$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $5a4066412ccab0c1$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($5a4066412ccab0c1$var$__hasOwnProp.call(b, prop)) $5a4066412ccab0c1$var$__defNormalProp(a, prop, b[prop]);
    if ($5a4066412ccab0c1$var$__getOwnPropSymbols) {
        for (var prop of $5a4066412ccab0c1$var$__getOwnPropSymbols(b))if ($5a4066412ccab0c1$var$__propIsEnum.call(b, prop)) $5a4066412ccab0c1$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $5a4066412ccab0c1$var$__spreadProps = (a, b)=>$5a4066412ccab0c1$var$__defProps(a, $5a4066412ccab0c1$var$__getOwnPropDescs(b));
var $5a4066412ccab0c1$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($5a4066412ccab0c1$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $5a4066412ccab0c1$var$__getOwnPropSymbols) {
        for (var prop of $5a4066412ccab0c1$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $5a4066412ccab0c1$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $5a4066412ccab0c1$var$React = // prettier-ignore
// @ts-ignore
"default" in $8NFma ? $8NFma["default"] : $8NFma;
// src/components/Context.ts
var $5a4066412ccab0c1$var$ContextKey = Symbol.for(`react-redux-context`);
var $5a4066412ccab0c1$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $5a4066412ccab0c1$var$getContext() {
    var _a;
    if (!$5a4066412ccab0c1$var$React.createContext) return {};
    const contextMap = (_a = $5a4066412ccab0c1$var$gT[$5a4066412ccab0c1$var$ContextKey]) != null ? _a : $5a4066412ccab0c1$var$gT[$5a4066412ccab0c1$var$ContextKey] = /* @__PURE__ */ new Map();
    let realContext = contextMap.get($5a4066412ccab0c1$var$React.createContext);
    if (!realContext) {
        realContext = $5a4066412ccab0c1$var$React.createContext(null);
        contextMap.set($5a4066412ccab0c1$var$React.createContext, realContext);
    }
    return realContext;
}
var $5a4066412ccab0c1$export$cc80c08dc91f1c00 = /* @__PURE__ */ $5a4066412ccab0c1$var$getContext();
// src/utils/useSyncExternalStore.ts
var $5a4066412ccab0c1$var$notInitialized = ()=>{
    throw new Error("uSES not initialized!");
};
// src/hooks/useReduxContext.ts
function $5a4066412ccab0c1$var$createReduxContextHook(context = $5a4066412ccab0c1$export$cc80c08dc91f1c00) {
    return function useReduxContext2() {
        const contextValue = $5a4066412ccab0c1$var$React.useContext(context);
        return contextValue;
    };
}
var $5a4066412ccab0c1$var$useReduxContext = /* @__PURE__ */ $5a4066412ccab0c1$var$createReduxContextHook();
// src/hooks/useSelector.ts
var $5a4066412ccab0c1$var$useSyncExternalStoreWithSelector = $5a4066412ccab0c1$var$notInitialized;
var $5a4066412ccab0c1$var$initializeUseSelector = (fn)=>{
    $5a4066412ccab0c1$var$useSyncExternalStoreWithSelector = fn;
};
var $5a4066412ccab0c1$var$refEquality = (a, b)=>a === b;
function $5a4066412ccab0c1$export$2b53f90d2bd1cbfb(context = $5a4066412ccab0c1$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $5a4066412ccab0c1$export$cc80c08dc91f1c00 ? $5a4066412ccab0c1$var$useReduxContext : $5a4066412ccab0c1$var$createReduxContextHook(context);
    const useSelector2 = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn: equalityFn = $5a4066412ccab0c1$var$refEquality, devModeChecks: devModeChecks = {} } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: stabilityCheck, identityFunctionCheck: identityFunctionCheck } = useReduxContext2();
        const firstRun = $5a4066412ccab0c1$var$React.useRef(true);
        const wrappedSelector = $5a4066412ccab0c1$var$React.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector,
            stabilityCheck,
            devModeChecks.stabilityCheck
        ]);
        const selectedState = $5a4066412ccab0c1$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $5a4066412ccab0c1$var$React.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: ()=>useSelector2
    });
    return useSelector2;
}
var $5a4066412ccab0c1$export$2105062e25df4afe = /* @__PURE__ */ $5a4066412ccab0c1$export$2b53f90d2bd1cbfb();
// src/utils/react-is.ts
var $5a4066412ccab0c1$var$REACT_ELEMENT_TYPE = Symbol.for("react.element");
var $5a4066412ccab0c1$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
var $5a4066412ccab0c1$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
var $5a4066412ccab0c1$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
var $5a4066412ccab0c1$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler");
var $5a4066412ccab0c1$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider");
var $5a4066412ccab0c1$var$REACT_CONTEXT_TYPE = Symbol.for("react.context");
var $5a4066412ccab0c1$var$REACT_SERVER_CONTEXT_TYPE = Symbol.for("react.server_context");
var $5a4066412ccab0c1$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
var $5a4066412ccab0c1$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
var $5a4066412ccab0c1$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
var $5a4066412ccab0c1$var$REACT_MEMO_TYPE = Symbol.for("react.memo");
var $5a4066412ccab0c1$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
var $5a4066412ccab0c1$var$REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
var $5a4066412ccab0c1$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
var $5a4066412ccab0c1$var$ForwardRef = $5a4066412ccab0c1$var$REACT_FORWARD_REF_TYPE;
var $5a4066412ccab0c1$var$Memo = $5a4066412ccab0c1$var$REACT_MEMO_TYPE;
function $5a4066412ccab0c1$var$isValidElementType(type) {
    if (typeof type === "string" || typeof type === "function") return true;
    if (type === $5a4066412ccab0c1$var$REACT_FRAGMENT_TYPE || type === $5a4066412ccab0c1$var$REACT_PROFILER_TYPE || type === $5a4066412ccab0c1$var$REACT_STRICT_MODE_TYPE || type === $5a4066412ccab0c1$var$REACT_SUSPENSE_TYPE || type === $5a4066412ccab0c1$var$REACT_SUSPENSE_LIST_TYPE || type === $5a4066412ccab0c1$var$REACT_OFFSCREEN_TYPE) return true;
    if (typeof type === "object" && type !== null) {
        if (type.$$typeof === $5a4066412ccab0c1$var$REACT_LAZY_TYPE || type.$$typeof === $5a4066412ccab0c1$var$REACT_MEMO_TYPE || type.$$typeof === $5a4066412ccab0c1$var$REACT_PROVIDER_TYPE || type.$$typeof === $5a4066412ccab0c1$var$REACT_CONTEXT_TYPE || type.$$typeof === $5a4066412ccab0c1$var$REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
        // types supported by any Flight configuration anywhere since
        // we don't know which Flight build this will end up being used
        // with.
        type.$$typeof === $5a4066412ccab0c1$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) return true;
    }
    return false;
}
function $5a4066412ccab0c1$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const $$typeof = object.$$typeof;
        switch($$typeof){
            case $5a4066412ccab0c1$var$REACT_ELEMENT_TYPE:
                {
                    const type = object.type;
                    switch(type){
                        case $5a4066412ccab0c1$var$REACT_FRAGMENT_TYPE:
                        case $5a4066412ccab0c1$var$REACT_PROFILER_TYPE:
                        case $5a4066412ccab0c1$var$REACT_STRICT_MODE_TYPE:
                        case $5a4066412ccab0c1$var$REACT_SUSPENSE_TYPE:
                        case $5a4066412ccab0c1$var$REACT_SUSPENSE_LIST_TYPE:
                            return type;
                        default:
                            {
                                const $$typeofType = type && type.$$typeof;
                                switch($$typeofType){
                                    case $5a4066412ccab0c1$var$REACT_SERVER_CONTEXT_TYPE:
                                    case $5a4066412ccab0c1$var$REACT_CONTEXT_TYPE:
                                    case $5a4066412ccab0c1$var$REACT_FORWARD_REF_TYPE:
                                    case $5a4066412ccab0c1$var$REACT_LAZY_TYPE:
                                    case $5a4066412ccab0c1$var$REACT_MEMO_TYPE:
                                    case $5a4066412ccab0c1$var$REACT_PROVIDER_TYPE:
                                        return $$typeofType;
                                    default:
                                        return $$typeof;
                                }
                            }
                    }
                }
            case $5a4066412ccab0c1$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
    return void 0;
}
function $5a4066412ccab0c1$var$isContextConsumer(object) {
    return $5a4066412ccab0c1$var$typeOf(object) === $5a4066412ccab0c1$var$REACT_CONTEXT_TYPE;
}
function $5a4066412ccab0c1$var$isMemo(object) {
    return $5a4066412ccab0c1$var$typeOf(object) === $5a4066412ccab0c1$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $5a4066412ccab0c1$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $5a4066412ccab0c1$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $5a4066412ccab0c1$var$warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $5a4066412ccab0c1$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $5a4066412ccab0c1$var$verify(mapStateToProps, "mapStateToProps");
    $5a4066412ccab0c1$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $5a4066412ccab0c1$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $5a4066412ccab0c1$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $5a4066412ccab0c1$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _b, options = $5a4066412ccab0c1$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $5a4066412ccab0c1$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $5a4066412ccab0c1$var$bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $5a4066412ccab0c1$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $5a4066412ccab0c1$var$verifyPlainObject(value, displayName, methodName) {
    if (!$5a4066412ccab0c1$var$isPlainObject(value)) $5a4066412ccab0c1$var$warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function $5a4066412ccab0c1$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $5a4066412ccab0c1$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $5a4066412ccab0c1$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $5a4066412ccab0c1$var$getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $5a4066412ccab0c1$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $5a4066412ccab0c1$var$createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function $5a4066412ccab0c1$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $5a4066412ccab0c1$var$wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        $5a4066412ccab0c1$var$bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? $5a4066412ccab0c1$var$wrapMapToPropsConstant((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $5a4066412ccab0c1$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $5a4066412ccab0c1$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $5a4066412ccab0c1$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $5a4066412ccab0c1$var$wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    $5a4066412ccab0c1$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $5a4066412ccab0c1$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $5a4066412ccab0c1$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $5a4066412ccab0c1$var$__spreadValues($5a4066412ccab0c1$var$__spreadValues($5a4066412ccab0c1$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $5a4066412ccab0c1$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $5a4066412ccab0c1$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>$5a4066412ccab0c1$var$defaultMergeProps : typeof mergeProps === "function" ? $5a4066412ccab0c1$var$wrapMergePropsFunc(mergeProps) : $5a4066412ccab0c1$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $5a4066412ccab0c1$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $5a4066412ccab0c1$var$createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            $5a4066412ccab0c1$var$defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $5a4066412ccab0c1$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $5a4066412ccab0c1$var$createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = $5a4066412ccab0c1$var$nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $5a4066412ccab0c1$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $5a4066412ccab0c1$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $5a4066412ccab0c1$var$canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $5a4066412ccab0c1$var$isReactNative = typeof navigator !== "undefined" && navigator.product === "ReactNative";
var $5a4066412ccab0c1$var$useIsomorphicLayoutEffect = $5a4066412ccab0c1$var$canUseDOM || $5a4066412ccab0c1$var$isReactNative ? $5a4066412ccab0c1$var$React.useLayoutEffect : $5a4066412ccab0c1$var$React.useEffect;
// src/utils/shallowEqual.ts
function $5a4066412ccab0c1$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $5a4066412ccab0c1$export$d36bdfa510afb180(objA, objB) {
    if ($5a4066412ccab0c1$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$5a4066412ccab0c1$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $5a4066412ccab0c1$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $5a4066412ccab0c1$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $5a4066412ccab0c1$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $5a4066412ccab0c1$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $5a4066412ccab0c1$var$TYPE_STATICS = {
    [$5a4066412ccab0c1$var$ForwardRef]: $5a4066412ccab0c1$var$FORWARD_REF_STATICS,
    [$5a4066412ccab0c1$var$Memo]: $5a4066412ccab0c1$var$MEMO_STATICS
};
function $5a4066412ccab0c1$var$getStatics(component) {
    if ($5a4066412ccab0c1$var$isMemo(component)) return $5a4066412ccab0c1$var$MEMO_STATICS;
    return $5a4066412ccab0c1$var$TYPE_STATICS[component["$$typeof"]] || $5a4066412ccab0c1$var$REACT_STATICS;
}
var $5a4066412ccab0c1$var$defineProperty = Object.defineProperty;
var $5a4066412ccab0c1$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $5a4066412ccab0c1$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $5a4066412ccab0c1$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $5a4066412ccab0c1$var$getPrototypeOf = Object.getPrototypeOf;
var $5a4066412ccab0c1$var$objectPrototype = Object.prototype;
function $5a4066412ccab0c1$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($5a4066412ccab0c1$var$objectPrototype) {
            const inheritedComponent = $5a4066412ccab0c1$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $5a4066412ccab0c1$var$objectPrototype) $5a4066412ccab0c1$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = $5a4066412ccab0c1$var$getOwnPropertyNames(sourceComponent);
        if ($5a4066412ccab0c1$var$getOwnPropertySymbols) keys = keys.concat($5a4066412ccab0c1$var$getOwnPropertySymbols(sourceComponent));
        const targetStatics = $5a4066412ccab0c1$var$getStatics(targetComponent);
        const sourceStatics = $5a4066412ccab0c1$var$getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!$5a4066412ccab0c1$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = $5a4066412ccab0c1$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $5a4066412ccab0c1$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/connect.tsx
var $5a4066412ccab0c1$var$useSyncExternalStore = $5a4066412ccab0c1$var$notInitialized;
var $5a4066412ccab0c1$var$initializeConnect = (fn)=>{
    $5a4066412ccab0c1$var$useSyncExternalStore = fn;
};
var $5a4066412ccab0c1$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $5a4066412ccab0c1$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $5a4066412ccab0c1$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $5a4066412ccab0c1$var$useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function $5a4066412ccab0c1$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $5a4066412ccab0c1$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $5a4066412ccab0c1$var$strictEqual(a, b) {
    return a === b;
}
var $5a4066412ccab0c1$var$hasWarnedAboutDeprecatedPureOption = false;
function $5a4066412ccab0c1$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $5a4066412ccab0c1$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = $5a4066412ccab0c1$export$d36bdfa510afb180, areStatePropsEqual: areStatePropsEqual = $5a4066412ccab0c1$export$d36bdfa510afb180, areMergedPropsEqual: areMergedPropsEqual = $5a4066412ccab0c1$export$d36bdfa510afb180, forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = $5a4066412ccab0c1$export$cc80c08dc91f1c00 } = {}) {
    const Context = context;
    const initMapStateToProps = $5a4066412ccab0c1$var$mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = $5a4066412ccab0c1$var$mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = $5a4066412ccab0c1$var$mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $5a4066412ccab0c1$var$React.useMemo(()=>{
                const _a = props, { reactReduxForwardedRef: reactReduxForwardedRef2 } = _a, wrapperProps2 = $5a4066412ccab0c1$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = $5a4066412ccab0c1$var$React.useMemo(()=>{
                let ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = $5a4066412ccab0c1$var$React.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $5a4066412ccab0c1$var$React.useMemo(()=>{
                return $5a4066412ccab0c1$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $5a4066412ccab0c1$var$React.useMemo(()=>{
                if (!shouldHandleStateChanges) return $5a4066412ccab0c1$var$NO_SUBSCRIPTION_ARRAY;
                const subscription2 = $5a4066412ccab0c1$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = $5a4066412ccab0c1$var$React.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return $5a4066412ccab0c1$var$__spreadProps($5a4066412ccab0c1$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = $5a4066412ccab0c1$var$React.useRef(void 0);
            const lastWrapperProps = $5a4066412ccab0c1$var$React.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $5a4066412ccab0c1$var$React.useRef(void 0);
            const renderIsScheduled = $5a4066412ccab0c1$var$React.useRef(false);
            const isMounted = $5a4066412ccab0c1$var$React.useRef(false);
            const latestSubscriptionCallbackError = $5a4066412ccab0c1$var$React.useRef(void 0);
            $5a4066412ccab0c1$var$useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $5a4066412ccab0c1$var$React.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = $5a4066412ccab0c1$var$React.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $5a4066412ccab0c1$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $5a4066412ccab0c1$var$useIsomorphicLayoutEffectWithArgs($5a4066412ccab0c1$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $5a4066412ccab0c1$var$useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            $5a4066412ccab0c1$var$useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = $5a4066412ccab0c1$var$React.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ $5a4066412ccab0c1$var$React.createElement(WrappedComponent, $5a4066412ccab0c1$var$__spreadProps($5a4066412ccab0c1$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = $5a4066412ccab0c1$var$React.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ $5a4066412ccab0c1$var$React.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $5a4066412ccab0c1$var$React.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $5a4066412ccab0c1$var$React.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $5a4066412ccab0c1$var$React.createElement(Connect, $5a4066412ccab0c1$var$__spreadProps($5a4066412ccab0c1$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $5a4066412ccab0c1$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $5a4066412ccab0c1$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $5a4066412ccab0c1$export$64605811ab45167f = $5a4066412ccab0c1$var$connect;
// src/components/Provider.tsx
function $5a4066412ccab0c1$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = "once", identityFunctionCheck: identityFunctionCheck = "once" }) {
    const contextValue = $5a4066412ccab0c1$var$React.useMemo(()=>{
        const subscription = $5a4066412ccab0c1$var$createSubscription(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : void 0,
            stabilityCheck: stabilityCheck,
            identityFunctionCheck: identityFunctionCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        identityFunctionCheck
    ]);
    const previousState = $5a4066412ccab0c1$var$React.useMemo(()=>store.getState(), [
        store
    ]);
    $5a4066412ccab0c1$var$useIsomorphicLayoutEffect(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || $5a4066412ccab0c1$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $5a4066412ccab0c1$var$React.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $5a4066412ccab0c1$export$2881499e37b75b9a = $5a4066412ccab0c1$var$Provider;
// src/hooks/useStore.ts
function $5a4066412ccab0c1$export$671dba69185d0304(context = $5a4066412ccab0c1$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $5a4066412ccab0c1$export$cc80c08dc91f1c00 ? $5a4066412ccab0c1$var$useReduxContext : // @ts-ignore
    $5a4066412ccab0c1$var$createReduxContextHook(context);
    const useStore2 = ()=>{
        const { store: store } = useReduxContext2();
        return store;
    };
    Object.assign(useStore2, {
        withTypes: ()=>useStore2
    });
    return useStore2;
}
var $5a4066412ccab0c1$export$6ccbb43953eebf8 = /* @__PURE__ */ $5a4066412ccab0c1$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $5a4066412ccab0c1$export$bc9b55530897c558(context = $5a4066412ccab0c1$export$cc80c08dc91f1c00) {
    const useStore2 = context === $5a4066412ccab0c1$export$cc80c08dc91f1c00 ? $5a4066412ccab0c1$export$6ccbb43953eebf8 : $5a4066412ccab0c1$export$671dba69185d0304(context);
    const useDispatch2 = ()=>{
        const store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: ()=>useDispatch2
    });
    return useDispatch2;
}
var $5a4066412ccab0c1$export$8ad76b76a4c905f8 = /* @__PURE__ */ $5a4066412ccab0c1$export$bc9b55530897c558();
// src/exports.ts
var $5a4066412ccab0c1$export$712ea50be43a7858 = $5a4066412ccab0c1$var$defaultNoopBatch;
// src/index.ts
$5a4066412ccab0c1$var$initializeUseSelector((0, $e7dc2a3713e13569$exports.useSyncExternalStoreWithSelector));
$5a4066412ccab0c1$var$initializeConnect($8NFma.useSyncExternalStore);



var $YChVI = parcelRequire("YChVI");
var $a654dbec3be83818$exports = {};
//! moment.js locale configuration
//! locale : Swedish [sv]
//! author : Jens Alm : https://github.com/ulmus

(function(global, factory) {
    factory((parcelRequire("YChVI")));
})($a654dbec3be83818$exports, function(moment) {
    'use strict';
    //! moment.js locale configuration
    var sv = moment.defineLocale('sv', {
        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: "s\xf6ndag_m\xe5ndag_tisdag_onsdag_torsdag_fredag_l\xf6rdag".split('_'),
        weekdaysShort: "s\xf6n_m\xe5n_tis_ons_tor_fre_l\xf6r".split('_'),
        weekdaysMin: "s\xf6_m\xe5_ti_on_to_fr_l\xf6".split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd D MMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Idag] LT',
            nextDay: '[Imorgon] LT',
            lastDay: "[Ig\xe5r] LT",
            nextWeek: "[P\xe5] dddd LT",
            lastWeek: '[I] dddd[s] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'om %s',
            past: "f\xf6r %s sedan",
            s: "n\xe5gra sekunder",
            ss: '%d sekunder',
            m: 'en minut',
            mm: '%d minuter',
            h: 'en timme',
            hh: '%d timmar',
            d: 'en dag',
            dd: '%d dagar',
            M: "en m\xe5nad",
            MM: "%d m\xe5nader",
            y: "ett \xe5r",
            yy: "%d \xe5r"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
        ordinal: function(number) {
            var b = number % 10, output = ~~(number % 100 / 10) === 1 ? ':e' : b === 1 ? ':a' : b === 2 ? ':a' : b === 3 ? ':e' : ':e';
            return number + output;
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    return sv;
});




var $8NFma = parcelRequire("8NFma");
var $b0c83d16b421d7f5$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b0c83d16b421d7f5$var$ReactIs, $b0c83d16b421d7f5$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$b0c83d16b421d7f5$exports = (parcelRequire("6DzO8"))();




var $8NFma = parcelRequire("8NFma");

var $8NFma = parcelRequire("8NFma");
/**
 * @public
 */ const $c6897e5fa3e365aa$export$22a697fb29aac98d = (0, $8NFma.createContext)({
    transformPagePoint: (p)=>p,
    isStatic: false,
    reducedMotion: "never"
});



var $8NFma = parcelRequire("8NFma");
const $20f5839e8a8fdec7$export$2285bbca2c666415 = (0, $8NFma.createContext)({});



var $8NFma = parcelRequire("8NFma");

var $8NFma = parcelRequire("8NFma");
/**
 * @public
 */ const $7a24fabcbe07cfd9$export$f224e4635b6f8ce2 = (0, $8NFma.createContext)(null);




var $8NFma = parcelRequire("8NFma");
const $4e6fb092a41bfb82$export$4e09c449d6c407f7 = typeof document !== "undefined";


const $ba41941b3a1a751e$export$700979bc83e7db82 = (0, $4e6fb092a41bfb82$export$4e09c449d6c407f7) ? (0, $8NFma.useLayoutEffect) : (0, $8NFma.useEffect);



var $8NFma = parcelRequire("8NFma");
const $2daff1e8821a69a8$export$40f10139ecf1f171 = (0, $8NFma.createContext)({
    strict: false
});



function $adc9e136d997800d$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement) {
    const { visualElement: parent } = (0, $8NFma.useContext)((0, $20f5839e8a8fdec7$export$2285bbca2c666415));
    const lazyContext = (0, $8NFma.useContext)((0, $2daff1e8821a69a8$export$40f10139ecf1f171));
    const presenceContext = (0, $8NFma.useContext)((0, $7a24fabcbe07cfd9$export$f224e4635b6f8ce2));
    const reducedMotionConfig = (0, $8NFma.useContext)((0, $c6897e5fa3e365aa$export$22a697fb29aac98d)).reducedMotion;
    const visualElementRef = (0, $8NFma.useRef)();
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: props,
        presenceContext: presenceContext,
        blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
        reducedMotionConfig: reducedMotionConfig
    });
    const visualElement = visualElementRef.current;
    (0, $8NFma.useInsertionEffect)(()=>{
        visualElement && visualElement.update(props, presenceContext);
    });
    (0, $ba41941b3a1a751e$export$700979bc83e7db82)(()=>{
        visualElement && visualElement.render();
    });
    (0, $8NFma.useEffect)(()=>{
        visualElement && visualElement.updateFeatures();
    });
    /**
     * Ideally this function would always run in a useEffect.
     *
     * However, if we have optimised appear animations to handoff from,
     * it needs to happen synchronously to ensure there's no flash of
     * incorrect styles in the event of a hydration error.
     *
     * So if we detect a situtation where optimised appear animations
     * are running, we use useLayoutEffect to trigger animations.
     */ const useAnimateChangesEffect = window.HandoffAppearAnimations ? (0, $ba41941b3a1a751e$export$700979bc83e7db82) : (0, $8NFma.useEffect);
    useAnimateChangesEffect(()=>{
        if (visualElement && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    return visualElement;
}



var $8NFma = parcelRequire("8NFma");
function $8bac730267ed8b61$export$dedd81df7bc1307(ref) {
    return typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}


/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $b1d7322931054921$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $8NFma.useCallback)((instance)=>{
        instance && visualState.mount && visualState.mount(instance);
        if (visualElement) instance ? visualElement.mount(instance) : visualElement.unmount();
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $8bac730267ed8b61$export$dedd81df7bc1307)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}



var $8NFma = parcelRequire("8NFma");

/**
 * Decides if the supplied variable is variant label
 */ function $33e95f2e5351c1c0$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}


function $8941743539d0f878$export$aa71198ceeaf53ce(v) {
    return typeof v === "object" && typeof v.start === "function";
}



const $db4213190228bc95$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const $db4213190228bc95$export$1405a65085f40b9 = [
    "initial",
    ...$db4213190228bc95$export$16e45afcc206d3a8
];


function $c4d8b2907c7e2211$export$4b3c3bd8d910d78d(props) {
    return (0, $8941743539d0f878$export$aa71198ceeaf53ce)(props.animate) || (0, $db4213190228bc95$export$1405a65085f40b9).some((name)=>(0, $33e95f2e5351c1c0$export$720b90e312cea233)(props[name]));
}
function $c4d8b2907c7e2211$export$ce46fa4165cdec40(props) {
    return Boolean($c4d8b2907c7e2211$export$4b3c3bd8d910d78d(props) || props.variants);
}


function $f03cfc3290c8ceca$export$12fc32fc096a04a3(props, context) {
    if ((0, $c4d8b2907c7e2211$export$4b3c3bd8d910d78d)(props)) {
        const { initial: initial, animate: animate } = props;
        return {
            initial: initial === false || (0, $33e95f2e5351c1c0$export$720b90e312cea233)(initial) ? initial : undefined,
            animate: (0, $33e95f2e5351c1c0$export$720b90e312cea233)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}


function $ea51fe08d092c5c0$export$c5638d843b37a176(props) {
    const { initial: initial, animate: animate } = (0, $f03cfc3290c8ceca$export$12fc32fc096a04a3)(props, (0, $8NFma.useContext)((0, $20f5839e8a8fdec7$export$2285bbca2c666415)));
    return (0, $8NFma.useMemo)(()=>({
            initial: initial,
            animate: animate
        }), [
        $ea51fe08d092c5c0$var$variantLabelsAsDependency(initial),
        $ea51fe08d092c5c0$var$variantLabelsAsDependency(animate)
    ]);
}
function $ea51fe08d092c5c0$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}


const $1de64697b9c13d22$var$featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
const $1de64697b9c13d22$export$65570e08d843624d = {};
for(const key in $1de64697b9c13d22$var$featureProps)$1de64697b9c13d22$export$65570e08d843624d[key] = {
    isEnabled: (props)=>$1de64697b9c13d22$var$featureProps[key].some((name)=>!!props[name])
};


function $e5f1eff7aac7b1de$export$449561ec5703cdc8(features) {
    for(const key in features)(0, $1de64697b9c13d22$export$65570e08d843624d)[key] = {
        ...(0, $1de64697b9c13d22$export$65570e08d843624d)[key],
        ...features[key]
    };
}




var $8NFma = parcelRequire("8NFma");
const $1af765e09ca06198$export$a3579ca508007a95 = (0, $8NFma.createContext)({});




var $8NFma = parcelRequire("8NFma");
/**
 * Internal, exported only for usage in Framer
 */ const $db7280e5d3034edc$export$da5f7b802957459a = (0, $8NFma.createContext)({});


const $cf3232b9adf9ae28$export$28e2e4cce424ae23 = Symbol.for("motionComponentSymbol");


/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $b030745d33f27814$export$46b7e4b9dc6110c3({ preloadedFeatures: preloadedFeatures, createVisualElement: createVisualElement, useRender: useRender, useVisualState: useVisualState, Component: Component }) {
    preloadedFeatures && (0, $e5f1eff7aac7b1de$export$449561ec5703cdc8)(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */ let MeasureLayout;
        const configAndProps = {
            ...(0, $8NFma.useContext)((0, $c6897e5fa3e365aa$export$22a697fb29aac98d)),
            ...props,
            layoutId: $b030745d33f27814$var$useLayoutId(props)
        };
        const { isStatic: isStatic } = configAndProps;
        const context = (0, $ea51fe08d092c5c0$export$c5638d843b37a176)(props);
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && (0, $4e6fb092a41bfb82$export$4e09c449d6c407f7)) {
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $adc9e136d997800d$export$dc0335d73ab0b115)(Component, visualState, configAndProps, createVisualElement);
            /**
             * Load Motion gesture and animation features. These are rendered as renderless
             * components so each feature can optionally make use of React lifecycle methods.
             */ const initialLayoutGroupConfig = (0, $8NFma.useContext)((0, $db7280e5d3034edc$export$da5f7b802957459a));
            const isStrict = (0, $8NFma.useContext)((0, $2daff1e8821a69a8$export$40f10139ecf1f171)).strict;
            if (context.visualElement) MeasureLayout = context.visualElement.loadFeatures(// Note: Pass the full new combined props to correctly re-render dynamic feature components.
            configAndProps, isStrict, preloadedFeatures, initialLayoutGroupConfig);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return $8NFma.createElement((0, $20f5839e8a8fdec7$export$2285bbca2c666415).Provider, {
            value: context
        }, MeasureLayout && context.visualElement ? $8NFma.createElement(MeasureLayout, {
            visualElement: context.visualElement,
            ...configAndProps
        }) : null, useRender(Component, props, (0, $b1d7322931054921$export$c684914703d321fd)(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement));
    }
    const ForwardRefComponent = (0, $8NFma.forwardRef)(MotionComponent);
    ForwardRefComponent[0, $cf3232b9adf9ae28$export$28e2e4cce424ae23] = Component;
    return ForwardRefComponent;
}
function $b030745d33f27814$var$useLayoutId({ layoutId: layoutId }) {
    const layoutGroupId = (0, $8NFma.useContext)((0, $1af765e09ca06198$export$a3579ca508007a95)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}



/**
 * Convert any React component into a `motion` component. The provided component
 * **must** use `React.forwardRef` to the underlying DOM component you want to animate.
 *
 * ```jsx
 * const Component = React.forwardRef((props, ref) => {
 *   return <div ref={ref} />
 * })
 *
 * const MotionComponent = motion(Component)
 * ```
 *
 * @public
 */ function $9a825e4d76c73dad$export$a28d6df673050e18(createConfig) {
    function custom(Component, customMotionComponentConfig = {}) {
        return (0, $b030745d33f27814$export$46b7e4b9dc6110c3)(createConfig(Component, customMotionComponentConfig));
    }
    if (typeof Proxy === "undefined") return custom;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ const componentCache = new Map();
    return new Proxy(custom, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: (_target, key)=>{
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, custom(key));
            return componentCache.get(key);
        }
    });
}


/**
 * We keep these listed seperately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ const $621959f3cde31010$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];


function $b4d5c6204542c379$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $621959f3cde31010$export$40209c4c512158e6).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/.test(Component)) return true;
    return false;
}



var $8NFma = parcelRequire("8NFma");

var $8NFma = parcelRequire("8NFma");
const $4fdff83f42bd104a$export$91ddd985b97788d1 = {};
function $4fdff83f42bd104a$export$de9e7791c71225fd(correctors) {
    Object.assign($4fdff83f42bd104a$export$91ddd985b97788d1, correctors);
}


/**
 * Generate a list of every possible transform key.
 */ const $ca5c3ae346f46e59$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ const $ca5c3ae346f46e59$export$7b42a0094fb00b6e = new Set($ca5c3ae346f46e59$export$280dc01950909d86);


function $74fcf1b780d3e5e5$export$6d27ce8e3de1c3cf(key, { layout: layout, layoutId: layoutId }) {
    return (0, $ca5c3ae346f46e59$export$7b42a0094fb00b6e).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $4fdff83f42bd104a$export$91ddd985b97788d1)[key] || key === "opacity");
}


const $56c5f751f01a3bad$export$605d60a2578142d3 = (value)=>Boolean(value && value.getVelocity);



const $59c1bcec37ba2c70$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const $59c1bcec37ba2c70$var$numTransforms = (0, $ca5c3ae346f46e59$export$280dc01950909d86).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $59c1bcec37ba2c70$export$bdc96e0d5c8f914(transform, { enableHardwareAcceleration: enableHardwareAcceleration = true, allowTransformNone: allowTransformNone = true }, transformIsDefault, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < $59c1bcec37ba2c70$var$numTransforms; i++){
        const key = (0, $ca5c3ae346f46e59$export$280dc01950909d86)[i];
        if (transform[key] !== undefined) {
            const transformName = $59c1bcec37ba2c70$var$translateAlias[key] || key;
            transformString += `${transformName}(${transform[key]}) `;
        }
    }
    if (enableHardwareAcceleration && !transform.z) transformString += "translateZ(0)";
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (allowTransformNone && transformIsDefault) transformString = "none";
    return transformString;
}


const $96385673d2db5539$var$checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const $96385673d2db5539$export$9de1236619d9e756 = $96385673d2db5539$var$checkStringStartsWith("--");
const $96385673d2db5539$export$31f9caa2600b5723 = $96385673d2db5539$var$checkStringStartsWith("var(--");
const $96385673d2db5539$export$f7c0a352d8ef6313 = /var\s*\(\s*--[\w-]+(\s*,\s*(?:(?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)+)?\s*\)/g;



/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $139b96ee96d0b5b7$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};


const $e6730597558a14cb$export$7d15b64cf5a3a4c4 = (min, max, v)=>Math.min(Math.max(v, min), max);


const $561ee22ed5cc3453$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $561ee22ed5cc3453$export$58f0f39f63f3cf42 = {
    ...$561ee22ed5cc3453$export$98e628dec113755e,
    transform: (v)=>(0, $e6730597558a14cb$export$7d15b64cf5a3a4c4)(0, 1, v)
};
const $561ee22ed5cc3453$export$dcdf75081b88279d = {
    ...$561ee22ed5cc3453$export$98e628dec113755e,
    default: 1
};


/**
 * TODO: When we move from string as a source of truth to data models
 * everything in this folder should probably be referred to as models vs types
 */ // If this number is a decimal, make it just five decimal places
// to avoid exponents
const $14c98a115b9ff356$export$83d2e9e3e4ee39ed = (v)=>Math.round(v * 100000) / 100000;
const $14c98a115b9ff356$export$2444ca58c08448e4 = /(-)?([\d]*\.?[\d])+/g;
const $14c98a115b9ff356$export$740b69c5fad25dba = /(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))/gi;
const $14c98a115b9ff356$export$ed808ff6ecd39e8d = /^(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))$/i;
function $14c98a115b9ff356$export$844ec244b1367d54(v) {
    return typeof v === "string";
}


const $ecde22e9cf283015$var$createUnitType = (unit)=>({
        test: (v)=>(0, $14c98a115b9ff356$export$844ec244b1367d54)(v) && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $ecde22e9cf283015$export$41fc368e1a942b97 = $ecde22e9cf283015$var$createUnitType("deg");
const $ecde22e9cf283015$export$626336c2cd4b14de = $ecde22e9cf283015$var$createUnitType("%");
const $ecde22e9cf283015$export$91c0eda1d06bf008 = $ecde22e9cf283015$var$createUnitType("px");
const $ecde22e9cf283015$export$f91e8c45a95a32f2 = $ecde22e9cf283015$var$createUnitType("vh");
const $ecde22e9cf283015$export$aed3d7b7d206c196 = $ecde22e9cf283015$var$createUnitType("vw");
const $ecde22e9cf283015$export$44e2e1705876d7ed = {
    ...$ecde22e9cf283015$export$626336c2cd4b14de,
    parse: (v)=>$ecde22e9cf283015$export$626336c2cd4b14de.parse(v) / 100,
    transform: (v)=>$ecde22e9cf283015$export$626336c2cd4b14de.transform(v * 100)
};



const $99982600e3dc7b18$export$7d260a2a5f8bc19e = {
    ...(0, $561ee22ed5cc3453$export$98e628dec113755e),
    transform: Math.round
};


const $12409a37b914f32f$export$eec14432cd1cb67b = {
    // Border props
    borderWidth: (0, $ecde22e9cf283015$export$91c0eda1d06bf008),
    borderTopWidth: (0, $ecde22e9cf283015$export$91c0eda1d06bf008),
    borderRightWidth: (0, $ecde22e9cf283015$export$91c0eda1d06bf008),
    borderBottomWidth: (0, $ecde22e9cf283015$export$91c0eda1d06bf008),
    borderLeftWidth: (0, $ecde22e9cf283015$export$91c0eda1d06bf008),
    borderRadius: (0, $ecde22e9cf283015$export$91c0eda1d06bf008),
    radius: (0, $ecde22e9cf283015$export$91c0eda1d06bf008),
    borderTopLeftRadius: (0, $ecde22e9cf283015$export$91c0eda1d06bf008),
    borderTopRightRadius: (0, $ecde22e9cf283015$export$91c0eda1d06bf008),
    borderBottomRightRadius: (0, $ecde22e9cf283015$export$91c0eda1d06bf008),
    borderBottomLeftRadius: (0, $ecde22e9cf283015$export$91c0eda1d06bf008),
    // Positioning props
    width: (0, $ecde22e9cf283015$export$91c0eda1d06bf008),
    maxWidth: (0, $ecde22e9cf283015$export$91c0eda1d06bf008),
    height: (0, $ecde22e9cf283015$export$91c0eda1d06bf008),
    maxHeight: (0, $ecde22e9cf283015$export$91c0eda1d06bf008),
    size: (0, $ecde22e9cf283015$export$91c0eda1d06bf008),
    top: (0, $ecde22e9cf283015$export$91c0eda1d06bf008),
    right: (0, $ecde22e9cf283015$export$91c0eda1d06bf008),
    bottom: (0, $ecde22e9cf283015$export$91c0eda1d06bf008),
    left: (0, $ecde22e9cf283015$export$91c0eda1d06bf008),
    // Spacing props
    padding: (0, $ecde22e9cf283015$export$91c0eda1d06bf008),
    paddingTop: (0, $ecde22e9cf283015$export$91c0eda1d06bf008),
    paddingRight: (0, $ecde22e9cf283015$export$91c0eda1d06bf008),
    paddingBottom: (0, $ecde22e9cf283015$export$91c0eda1d06bf008),
    paddingLeft: (0, $ecde22e9cf283015$export$91c0eda1d06bf008),
    margin: (0, $ecde22e9cf283015$export$91c0eda1d06bf008),
    marginTop: (0, $ecde22e9cf283015$export$91c0eda1d06bf008),
    marginRight: (0, $ecde22e9cf283015$export$91c0eda1d06bf008),
    marginBottom: (0, $ecde22e9cf283015$export$91c0eda1d06bf008),
    marginLeft: (0, $ecde22e9cf283015$export$91c0eda1d06bf008),
    // Transform props
    rotate: (0, $ecde22e9cf283015$export$41fc368e1a942b97),
    rotateX: (0, $ecde22e9cf283015$export$41fc368e1a942b97),
    rotateY: (0, $ecde22e9cf283015$export$41fc368e1a942b97),
    rotateZ: (0, $ecde22e9cf283015$export$41fc368e1a942b97),
    scale: $561ee22ed5cc3453$export$dcdf75081b88279d,
    scaleX: (0, $561ee22ed5cc3453$export$dcdf75081b88279d),
    scaleY: (0, $561ee22ed5cc3453$export$dcdf75081b88279d),
    scaleZ: (0, $561ee22ed5cc3453$export$dcdf75081b88279d),
    skew: (0, $ecde22e9cf283015$export$41fc368e1a942b97),
    skewX: (0, $ecde22e9cf283015$export$41fc368e1a942b97),
    skewY: (0, $ecde22e9cf283015$export$41fc368e1a942b97),
    distance: (0, $ecde22e9cf283015$export$91c0eda1d06bf008),
    translateX: (0, $ecde22e9cf283015$export$91c0eda1d06bf008),
    translateY: (0, $ecde22e9cf283015$export$91c0eda1d06bf008),
    translateZ: (0, $ecde22e9cf283015$export$91c0eda1d06bf008),
    x: (0, $ecde22e9cf283015$export$91c0eda1d06bf008),
    y: (0, $ecde22e9cf283015$export$91c0eda1d06bf008),
    z: (0, $ecde22e9cf283015$export$91c0eda1d06bf008),
    perspective: (0, $ecde22e9cf283015$export$91c0eda1d06bf008),
    transformPerspective: (0, $ecde22e9cf283015$export$91c0eda1d06bf008),
    opacity: (0, $561ee22ed5cc3453$export$58f0f39f63f3cf42),
    originX: (0, $ecde22e9cf283015$export$44e2e1705876d7ed),
    originY: (0, $ecde22e9cf283015$export$44e2e1705876d7ed),
    originZ: (0, $ecde22e9cf283015$export$91c0eda1d06bf008),
    // Misc
    zIndex: (0, $99982600e3dc7b18$export$7d260a2a5f8bc19e),
    // SVG
    fillOpacity: (0, $561ee22ed5cc3453$export$58f0f39f63f3cf42),
    strokeOpacity: (0, $561ee22ed5cc3453$export$58f0f39f63f3cf42),
    numOctaves: (0, $99982600e3dc7b18$export$7d260a2a5f8bc19e)
};


function $6bc0775b95155db5$export$bb517f8b40f8e99d(state, latestValues, options, transformTemplate) {
    const { style: style, vars: vars, transform: transform, transformOrigin: transformOrigin } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    // Does the calculated transform essentially equal "none"?
    let transformIsNone = true;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept seperately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        /**
         * If this is a CSS variable we don't do any further processing.
         */ if ((0, $96385673d2db5539$export$9de1236619d9e756)(key)) {
            vars[key] = value;
            continue;
        }
        // Convert the value to its default value type, ie 0 -> "0px"
        const valueType = (0, $12409a37b914f32f$export$eec14432cd1cb67b)[key];
        const valueAsType = (0, $139b96ee96d0b5b7$export$453ef540a9a1bd6b)(value, valueType);
        if ((0, $ca5c3ae346f46e59$export$7b42a0094fb00b6e).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            transform[key] = valueAsType;
            // If we already know we have a non-default transform, early return
            if (!transformIsNone) continue;
            // Otherwise check to see if this is a default transform
            if (value !== (valueType.default || 0)) transformIsNone = false;
        } else if (key.startsWith("origin")) {
            // If this is a transform origin, flag and enable further transform-origin processing
            hasTransformOrigin = true;
            transformOrigin[key] = valueAsType;
        } else style[key] = valueAsType;
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $59c1bcec37ba2c70$export$bdc96e0d5c8f914)(state.transform, options, transformIsNone, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX: originX = "50%", originY: originY = "50%", originZ: originZ = 0 } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}


const $b45a42e9d7efaf7b$export$8940b483cf52eeda = ()=>({
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {}
    });


function $e15a7ed64fbc9390$export$40dafdb8630c956b(target, source, props) {
    for(const key in source)if (!(0, $56c5f751f01a3bad$export$605d60a2578142d3)(source[key]) && !(0, $74fcf1b780d3e5e5$export$6d27ce8e3de1c3cf)(key, props)) target[key] = source[key];
}
function $e15a7ed64fbc9390$var$useInitialMotionValues({ transformTemplate: transformTemplate }, visualState, isStatic) {
    return (0, $8NFma.useMemo)(()=>{
        const state = (0, $b45a42e9d7efaf7b$export$8940b483cf52eeda)();
        (0, $6bc0775b95155db5$export$bb517f8b40f8e99d)(state, visualState, {
            enableHardwareAcceleration: !isStatic
        }, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function $e15a7ed64fbc9390$var$useStyle(props, visualState, isStatic) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $e15a7ed64fbc9390$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $e15a7ed64fbc9390$var$useInitialMotionValues(props, visualState, isStatic));
    return props.transformValues ? props.transformValues(style) : style;
}
function $e15a7ed64fbc9390$export$57be0a314572d87d(props, visualState, isStatic) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = $e15a7ed64fbc9390$var$useStyle(props, visualState, isStatic);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) htmlProps.tabIndex = 0;
    htmlProps.style = style;
    return htmlProps;
}


/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ const $0c69aec9fa176b7f$var$validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "transformValues",
    "custom",
    "inherit",
    "onLayoutAnimationStart",
    "onLayoutAnimationComplete",
    "onLayoutMeasure",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "ignoreStrict",
    "viewport"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $0c69aec9fa176b7f$export$2f9c46555243bf04(key) {
    return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || $0c69aec9fa176b7f$var$validMotionProps.has(key);
}


let $29f44e7c8bd84b95$var$shouldForward = (key)=>!(0, $0c69aec9fa176b7f$export$2f9c46555243bf04)(key);
function $29f44e7c8bd84b95$export$59d6962c470509a5(isValidProp) {
    if (!isValidProp) return;
    // Explicitly filter our events
    $29f44e7c8bd84b95$var$shouldForward = (key)=>key.startsWith("on") ? !(0, $0c69aec9fa176b7f$export$2f9c46555243bf04)(key) : isValidProp(key);
}

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ $29f44e7c8bd84b95$export$59d6962c470509a5((parcelRequire("iFFi9")).default);
} catch (_a) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $29f44e7c8bd84b95$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for(const key in props){
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */ if (key === "values" && typeof props.values === "object") continue;
        if ($29f44e7c8bd84b95$var$shouldForward(key) || forwardMotionProps === true && (0, $0c69aec9fa176b7f$export$2f9c46555243bf04)(key) || !isDom && !(0, $0c69aec9fa176b7f$export$2f9c46555243bf04)(key) || // If trying to use native HTML drag events, forward drag listeners
        props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    }
    return filteredProps;
}




var $8NFma = parcelRequire("8NFma");



function $5204464d85f13767$var$calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : (0, $ecde22e9cf283015$export$91c0eda1d06bf008).transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function $5204464d85f13767$export$d4fbcfc8e5472155(dimensions, originX, originY) {
    const pxOriginX = $5204464d85f13767$var$calcOrigin(originX, dimensions.x, dimensions.width);
    const pxOriginY = $5204464d85f13767$var$calcOrigin(originY, dimensions.y, dimensions.height);
    return `${pxOriginX} ${pxOriginY}`;
}



const $357af48cffdf5537$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $357af48cffdf5537$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $357af48cffdf5537$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $357af48cffdf5537$var$dashKeys : $357af48cffdf5537$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $ecde22e9cf283015$export$91c0eda1d06bf008).transform(-offset);
    // Build the dash array
    const pathLength = (0, $ecde22e9cf283015$export$91c0eda1d06bf008).transform(length);
    const pathSpacing = (0, $ecde22e9cf283015$export$91c0eda1d06bf008).transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}


/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function $77100f389af05a7f$export$5475d24f125d7053(state, { attrX: attrX, attrY: attrY, attrScale: attrScale, originX: originX, originY: originY, pathLength: pathLength, pathSpacing: pathSpacing = 1, pathOffset: pathOffset = 0, // This is object creation, which we try to avoid per-frame.
...latest }, options, isSVGTag, transformTemplate) {
    (0, $6bc0775b95155db5$export$bb517f8b40f8e99d)(state, latest, options, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs, style: style, dimensions: dimensions } = state;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = (0, $5204464d85f13767$export$d4fbcfc8e5472155)(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $357af48cffdf5537$export$311b43f666da1d82)(attrs, pathLength, pathSpacing, pathOffset, false);
}



const $69b21dad9904e665$export$41be8b43e1c4d4f9 = ()=>({
        ...(0, $b45a42e9d7efaf7b$export$8940b483cf52eeda)(),
        attrs: {}
    });


const $8009848b0f810604$export$6328ce7565ea1049 = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";


function $baa01a4f8aa0844b$export$84309c4f53cb1bd5(props, visualState, _isStatic, Component) {
    const visualProps = (0, $8NFma.useMemo)(()=>{
        const state = (0, $69b21dad9904e665$export$41be8b43e1c4d4f9)();
        (0, $77100f389af05a7f$export$5475d24f125d7053)(state, visualState, {
            enableHardwareAcceleration: false
        }, (0, $8009848b0f810604$export$6328ce7565ea1049)(Component), props.transformTemplate);
        return {
            ...state.attrs,
            style: {
                ...state.style
            }
        };
    }, [
        visualState
    ]);
    if (props.style) {
        const rawStyles = {};
        (0, $e15a7ed64fbc9390$export$40dafdb8630c956b)(rawStyles, props.style, props);
        visualProps.style = {
            ...rawStyles,
            ...visualProps.style
        };
    }
    return visualProps;
}



function $c0267186899211ef$export$5d29104eefd89cc8(forwardMotionProps = false) {
    const useRender = (Component, props, ref, { latestValues: latestValues }, isStatic)=>{
        const useVisualProps = (0, $b4d5c6204542c379$export$88f3fc2fd3766989)(Component) ? (0, $baa01a4f8aa0844b$export$84309c4f53cb1bd5) : (0, $e15a7ed64fbc9390$export$57be0a314572d87d);
        const visualProps = useVisualProps(props, latestValues, isStatic, Component);
        const filteredProps = (0, $29f44e7c8bd84b95$export$d697c39a2985a4c)(props, typeof Component === "string", forwardMotionProps);
        const elementProps = {
            ...filteredProps,
            ...visualProps,
            ref: ref
        };
        /**
         * If component has been handed a motion value as its child,
         * memoise its initial value and render that. Subsequent updates
         * will be handled by the onChange handler
         */ const { children: children } = props;
        const renderedChildren = (0, $8NFma.useMemo)(()=>(0, $56c5f751f01a3bad$export$605d60a2578142d3)(children) ? children.get() : children, [
            children
        ]);
        return (0, $8NFma.createElement)(Component, {
            ...elementProps,
            children: renderedChildren
        });
    };
    return useRender;
}


/**
 * Convert camelCase to dash-case properties.
 */ const $64d13cd8bd24d1b3$export$9fd24a634729c672 = (str)=>str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();


function $4897080e77be3535$export$1a32bf6229c258c0(element, { style: style, vars: vars }, styleProp, projection) {
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for(const key in vars)element.style.setProperty(key, vars[key]);
}


/**
 * A set of attribute names that are always read/written as camel case.
 */ const $03996e6affc7ae07$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);


function $f4c34eeabc0a0368$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $4897080e77be3535$export$1a32bf6229c258c0)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $03996e6affc7ae07$export$28931db5d57958e5).has(key) ? (0, $64d13cd8bd24d1b3$export$9fd24a634729c672)(key) : key, renderState.attrs[key]);
}





function $37e7cb925f50d74f$export$16da615486abaa45(props, prevProps) {
    const { style: style } = props;
    const newValues = {};
    for(const key in style)if ((0, $56c5f751f01a3bad$export$605d60a2578142d3)(style[key]) || prevProps.style && (0, $56c5f751f01a3bad$export$605d60a2578142d3)(prevProps.style[key]) || (0, $74fcf1b780d3e5e5$export$6d27ce8e3de1c3cf)(key, props)) newValues[key] = style[key];
    return newValues;
}



function $f15ca6b0d702ad3b$export$16da615486abaa45(props, prevProps) {
    const newValues = (0, $37e7cb925f50d74f$export$16da615486abaa45)(props, prevProps);
    for(const key in props)if ((0, $56c5f751f01a3bad$export$605d60a2578142d3)(props[key]) || (0, $56c5f751f01a3bad$export$605d60a2578142d3)(prevProps[key])) {
        const targetKey = (0, $ca5c3ae346f46e59$export$280dc01950909d86).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}



var $8NFma = parcelRequire("8NFma");


function $318b02a1e1f48ccb$export$d68f140c4d9b48bc(props, definition, custom, currentValues = {}, currentVelocity = {}) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") definition = definition(custom !== undefined ? custom : props.custom, currentValues, currentVelocity);
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") definition = definition(custom !== undefined ? custom : props.custom, currentValues, currentVelocity);
    return definition;
}



var $8NFma = parcelRequire("8NFma");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $d40915b962da1eaf$export$fe4300aa8eebea86(init) {
    const ref = (0, $8NFma.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}


const $0d0309bb748c55b8$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};


const $b82cb19c2a0bb263$export$2f308ad9864b3ac9 = (v)=>{
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
const $b82cb19c2a0bb263$export$5485128c47bd48bb = (v)=>{
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $0d0309bb748c55b8$export$9153ad4c4999f4a0)(v) ? v[v.length - 1] || 0 : v;
};



/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function $69a92c324366a6b4$export$fcc2206ecb6d74b(value) {
    const unwrappedValue = (0, $56c5f751f01a3bad$export$605d60a2578142d3)(value) ? value.get() : value;
    return (0, $b82cb19c2a0bb263$export$2f308ad9864b3ac9)(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}




function $e6af9f64d654eb7a$var$makeState({ scrapeMotionValuesFromProps: scrapeMotionValuesFromProps, createRenderState: createRenderState, onMount: onMount }, props, context, presenceContext) {
    const state = {
        latestValues: $e6af9f64d654eb7a$var$makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    if (onMount) state.mount = (instance)=>onMount(props, instance, state);
    return state;
}
const $e6af9f64d654eb7a$export$e91e107bc6d03a8e = (config)=>(props, isStatic)=>{
        const context = (0, $8NFma.useContext)((0, $20f5839e8a8fdec7$export$2285bbca2c666415));
        const presenceContext = (0, $8NFma.useContext)((0, $7a24fabcbe07cfd9$export$f224e4635b6f8ce2));
        const make = ()=>$e6af9f64d654eb7a$var$makeState(config, props, context, presenceContext);
        return isStatic ? make() : (0, $d40915b962da1eaf$export$fe4300aa8eebea86)(make);
    };
function $e6af9f64d654eb7a$var$makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    const values = {};
    const motionValues = scrapeMotionValues(props, {});
    for(const key in motionValues)values[key] = (0, $69a92c324366a6b4$export$fcc2206ecb6d74b)(motionValues[key]);
    let { initial: initial, animate: animate } = props;
    const isControllingVariants$1 = (0, $c4d8b2907c7e2211$export$4b3c3bd8d910d78d)(props);
    const isVariantNode$1 = (0, $c4d8b2907c7e2211$export$ce46fa4165cdec40)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $8941743539d0f878$export$aa71198ceeaf53ce)(variantToSet)) {
        const list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        list.forEach((definition)=>{
            const resolved = (0, $318b02a1e1f48ccb$export$d68f140c4d9b48bc)(props, definition);
            if (!resolved) return;
            const { transitionEnd: transitionEnd, transition: transition, ...target } = resolved;
            for(const key in target){
                let valueTarget = target[key];
                if (Array.isArray(valueTarget)) {
                    /**
                     * Take final keyframe if the initial animation is blocked because
                     * we want to initialise at the end of that blocked animation.
                     */ const index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                    valueTarget = valueTarget[index];
                }
                if (valueTarget !== null) values[key] = valueTarget;
            }
            for(const key in transitionEnd)values[key] = transitionEnd[key];
        });
    }
    return values;
}





const $32ca9efa885ee4b2$export$44dabd3fae512e85 = {
    useVisualState: (0, $e6af9f64d654eb7a$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: (0, $f15ca6b0d702ad3b$export$16da615486abaa45),
        createRenderState: (0, $69b21dad9904e665$export$41be8b43e1c4d4f9),
        onMount: (props, instance, { renderState: renderState, latestValues: latestValues })=>{
            try {
                renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
            } catch (e) {
                // Most likely trying to measure an unrendered element under Firefox
                renderState.dimensions = {
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0
                };
            }
            (0, $77100f389af05a7f$export$5475d24f125d7053)(renderState, latestValues, {
                enableHardwareAcceleration: false
            }, (0, $8009848b0f810604$export$6328ce7565ea1049)(instance.tagName), props.transformTemplate);
            (0, $f4c34eeabc0a0368$export$c5f8399d19a7394b)(instance, renderState);
        }
    })
};





const $d73a5be063e18faa$export$e13ea21d87ea57c8 = {
    useVisualState: (0, $e6af9f64d654eb7a$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: $37e7cb925f50d74f$export$16da615486abaa45,
        createRenderState: (0, $b45a42e9d7efaf7b$export$8940b483cf52eeda)
    })
};


function $c21ef8d8f121db35$export$732916c0e88175fb(Component, { forwardMotionProps: forwardMotionProps = false }, preloadedFeatures, createVisualElement) {
    const baseConfig = (0, $b4d5c6204542c379$export$88f3fc2fd3766989)(Component) ? (0, $32ca9efa885ee4b2$export$44dabd3fae512e85) : (0, $d73a5be063e18faa$export$e13ea21d87ea57c8);
    return {
        ...baseConfig,
        preloadedFeatures: preloadedFeatures,
        useRender: (0, $c0267186899211ef$export$5d29104eefd89cc8)(forwardMotionProps),
        createVisualElement: createVisualElement,
        Component: Component
    };
}


function $105610e7777eba77$export$b1d829ddf82884aa(target, eventName, handler, options = {
    passive: true
}) {
    target.addEventListener(eventName, handler, options);
    return ()=>target.removeEventListener(eventName, handler);
}


const $df317c8f51249b7a$export$a4cf9c8a4b063a6e = (event)=>{
    if (event.pointerType === "mouse") return typeof event.button !== "number" || event.button <= 0;
    else /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */ return event.isPrimary !== false;
};


function $24dec86077a8e170$export$12f84bb882d06e1a(event, pointType = "page") {
    return {
        point: {
            x: event[pointType + "X"],
            y: event[pointType + "Y"]
        }
    };
}
const $24dec86077a8e170$export$c404e80f92c98d29 = (handler)=>{
    return (event)=>(0, $df317c8f51249b7a$export$a4cf9c8a4b063a6e)(event) && handler(event, $24dec86077a8e170$export$12f84bb882d06e1a(event));
};


function $ab731bc0caef970f$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $105610e7777eba77$export$b1d829ddf82884aa)(target, eventName, (0, $24dec86077a8e170$export$c404e80f92c98d29)(handler), options);
}


/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ const $0a4e85080bbf1ab0$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $0a4e85080bbf1ab0$export$a4627e546088548d = (...transformers)=>transformers.reduce($0a4e85080bbf1ab0$var$combineFunctions);


function $29a887a49c5e1406$export$518c5fc2dcb7974b(name) {
    let lock = null;
    return ()=>{
        const openLock = ()=>{
            lock = null;
        };
        if (lock === null) {
            lock = name;
            return openLock;
        }
        return false;
    };
}
const $29a887a49c5e1406$var$globalHorizontalLock = $29a887a49c5e1406$export$518c5fc2dcb7974b("dragHorizontal");
const $29a887a49c5e1406$var$globalVerticalLock = $29a887a49c5e1406$export$518c5fc2dcb7974b("dragVertical");
function $29a887a49c5e1406$export$2b7959ed03c1a3fe(drag) {
    let lock = false;
    if (drag === "y") lock = $29a887a49c5e1406$var$globalVerticalLock();
    else if (drag === "x") lock = $29a887a49c5e1406$var$globalHorizontalLock();
    else {
        const openHorizontal = $29a887a49c5e1406$var$globalHorizontalLock();
        const openVertical = $29a887a49c5e1406$var$globalVerticalLock();
        if (openHorizontal && openVertical) lock = ()=>{
            openHorizontal();
            openVertical();
        };
        else {
            // Release the locks because we don't use them
            if (openHorizontal) openHorizontal();
            if (openVertical) openVertical();
        }
    }
    return lock;
}
function $29a887a49c5e1406$export$1b3dd616664938e4() {
    // Check the gesture lock - if we get it, it means no drag gesture is active
    // and we can safely fire the tap gesture.
    const openGestureLock = $29a887a49c5e1406$export$2b7959ed03c1a3fe(true);
    if (!openGestureLock) return true;
    openGestureLock();
    return false;
}


class $2bff128c5f01d94e$export$6e91cf7616333d5 {
    constructor(node){
        this.isMounted = false;
        this.node = node;
    }
    update() {}
}


const $6c31de3ed15607ce$export$8793edee2d425525 = (any)=>any;


function $7eeeb6b6a13f9c8e$export$b995e5e85f5c8289(runNextFrame) {
    /**
     * We create and reuse two arrays, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let toRun = [];
    let toRunNextFrame = [];
    /**
     *
     */ let numToRun = 0;
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const buffer = addToCurrentFrame ? toRun : toRunNextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            // If the buffer doesn't already contain this callback, add it
            if (buffer.indexOf(callback) === -1) {
                buffer.push(callback);
                // If we're adding it to the currently running buffer, update its measured size
                if (addToCurrentFrame && isProcessing) numToRun = toRun.length;
            }
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            const index = toRunNextFrame.indexOf(callback);
            if (index !== -1) toRunNextFrame.splice(index, 1);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [toRun, toRunNextFrame] = [
                toRunNextFrame,
                toRun
            ];
            // Clear the next frame list
            toRunNextFrame.length = 0;
            // Execute this frame
            numToRun = toRun.length;
            if (numToRun) for(let i = 0; i < numToRun; i++){
                const callback = toRun[i];
                callback(frameData);
                if (toKeepAlive.has(callback)) {
                    step.schedule(callback);
                    runNextFrame();
                }
            }
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}


const $3d40fdb1cd4cc1b4$export$71ecace0a033b35a = [
    "prepare",
    "read",
    "update",
    "preRender",
    "render",
    "postRender"
];
const $3d40fdb1cd4cc1b4$var$maxElapsed = 40;
function $3d40fdb1cd4cc1b4$export$510b0596a933801a(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0,
        timestamp: 0,
        isProcessing: false
    };
    const steps = $3d40fdb1cd4cc1b4$export$71ecace0a033b35a.reduce((acc, key)=>{
        acc[key] = (0, $7eeeb6b6a13f9c8e$export$b995e5e85f5c8289)(()=>runNextFrame = true);
        return acc;
    }, {});
    const processStep = (stepId)=>steps[stepId].process(state);
    const processBatch = (timestamp)=>{
        runNextFrame = false;
        state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, $3d40fdb1cd4cc1b4$var$maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        $3d40fdb1cd4cc1b4$export$71ecace0a033b35a.forEach(processStep);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = ()=>{
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    const schedule = $3d40fdb1cd4cc1b4$export$71ecace0a033b35a.reduce((acc, key)=>{
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false)=>{
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process)=>$3d40fdb1cd4cc1b4$export$71ecace0a033b35a.forEach((key)=>steps[key].cancel(process));
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}


const { schedule: $1abd9a21e276f8f7$export$2cef06c20297c17d, cancel: $1abd9a21e276f8f7$export$ec99c0ef4978dccb, state: $1abd9a21e276f8f7$export$fff89137e9e818ce, steps: $1abd9a21e276f8f7$export$be3f796aed065412 } = (0, $3d40fdb1cd4cc1b4$export$510b0596a933801a)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, $6c31de3ed15607ce$export$8793edee2d425525), true);


function $1d003e4aad7511b1$var$addHoverEvent(node, isActive) {
    const eventName = "pointer" + (isActive ? "enter" : "leave");
    const callbackName = "onHover" + (isActive ? "Start" : "End");
    const handleEvent = (event, info)=>{
        if (event.type === "touch" || (0, $29a887a49c5e1406$export$1b3dd616664938e4)()) return;
        const props = node.getProps();
        if (node.animationState && props.whileHover) node.animationState.setActive("whileHover", isActive);
        if (props[callbackName]) (0, $1abd9a21e276f8f7$export$2cef06c20297c17d).update(()=>props[callbackName](event, info));
    };
    return (0, $ab731bc0caef970f$export$fcff2e64e6676b81)(node.current, eventName, handleEvent, {
        passive: !node.getProps()[callbackName]
    });
}
class $1d003e4aad7511b1$export$93a81ea037eac456 extends (0, $2bff128c5f01d94e$export$6e91cf7616333d5) {
    mount() {
        this.unmount = (0, $0a4e85080bbf1ab0$export$a4627e546088548d)($1d003e4aad7511b1$var$addHoverEvent(this.node, true), $1d003e4aad7511b1$var$addHoverEvent(this.node, false));
    }
    unmount() {}
}





class $5caa8f0c73d9801e$export$d4826db40d47595b extends (0, $2bff128c5f01d94e$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.isActive = false;
    }
    onFocus() {
        let isFocusVisible = false;
        /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */ try {
            isFocusVisible = this.node.current.matches(":focus-visible");
        } catch (e) {
            isFocusVisible = true;
        }
        if (!isFocusVisible || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", true);
        this.isActive = true;
    }
    onBlur() {
        if (!this.isActive || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", false);
        this.isActive = false;
    }
    mount() {
        this.unmount = (0, $0a4e85080bbf1ab0$export$a4627e546088548d)((0, $105610e7777eba77$export$b1d829ddf82884aa)(this.node.current, "focus", ()=>this.onFocus()), (0, $105610e7777eba77$export$b1d829ddf82884aa)(this.node.current, "blur", ()=>this.onBlur()));
    }
    unmount() {}
}








/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ const $69a4167b812fcef5$export$e841ada32ff745b = (parent, child)=>{
    if (!child) return false;
    else if (parent === child) return true;
    else return $69a4167b812fcef5$export$e841ada32ff745b(parent, child.parentElement);
};




function $5556f974238648c2$var$fireSyntheticPointerEvent(name, handler) {
    if (!handler) return;
    const syntheticPointerEvent = new PointerEvent("pointer" + name);
    handler(syntheticPointerEvent, (0, $24dec86077a8e170$export$12f84bb882d06e1a)(syntheticPointerEvent));
}
class $5556f974238648c2$export$f026abdbba7f0c9e extends (0, $2bff128c5f01d94e$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.removeStartListeners = (0, $6c31de3ed15607ce$export$8793edee2d425525);
        this.removeEndListeners = (0, $6c31de3ed15607ce$export$8793edee2d425525);
        this.removeAccessibleListeners = (0, $6c31de3ed15607ce$export$8793edee2d425525);
        this.startPointerPress = (startEvent, startInfo)=>{
            this.removeEndListeners();
            if (this.isPressing) return;
            const props = this.node.getProps();
            const endPointerPress = (endEvent, endInfo)=>{
                if (!this.checkPressEnd()) return;
                const { onTap: onTap, onTapCancel: onTapCancel } = this.node.getProps();
                (0, $1abd9a21e276f8f7$export$2cef06c20297c17d).update(()=>{
                    /**
                     * We only count this as a tap gesture if the event.target is the same
                     * as, or a child of, this component's element
                     */ !(0, $69a4167b812fcef5$export$e841ada32ff745b)(this.node.current, endEvent.target) ? onTapCancel && onTapCancel(endEvent, endInfo) : onTap && onTap(endEvent, endInfo);
                });
            };
            const removePointerUpListener = (0, $ab731bc0caef970f$export$fcff2e64e6676b81)(window, "pointerup", endPointerPress, {
                passive: !(props.onTap || props["onPointerUp"])
            });
            const removePointerCancelListener = (0, $ab731bc0caef970f$export$fcff2e64e6676b81)(window, "pointercancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo), {
                passive: !(props.onTapCancel || props["onPointerCancel"])
            });
            this.removeEndListeners = (0, $0a4e85080bbf1ab0$export$a4627e546088548d)(removePointerUpListener, removePointerCancelListener);
            this.startPress(startEvent, startInfo);
        };
        this.startAccessiblePress = ()=>{
            const handleKeydown = (keydownEvent)=>{
                if (keydownEvent.key !== "Enter" || this.isPressing) return;
                const handleKeyup = (keyupEvent)=>{
                    if (keyupEvent.key !== "Enter" || !this.checkPressEnd()) return;
                    $5556f974238648c2$var$fireSyntheticPointerEvent("up", (event, info)=>{
                        const { onTap: onTap } = this.node.getProps();
                        if (onTap) (0, $1abd9a21e276f8f7$export$2cef06c20297c17d).update(()=>onTap(event, info));
                    });
                };
                this.removeEndListeners();
                this.removeEndListeners = (0, $105610e7777eba77$export$b1d829ddf82884aa)(this.node.current, "keyup", handleKeyup);
                $5556f974238648c2$var$fireSyntheticPointerEvent("down", (event, info)=>{
                    this.startPress(event, info);
                });
            };
            const removeKeydownListener = (0, $105610e7777eba77$export$b1d829ddf82884aa)(this.node.current, "keydown", handleKeydown);
            const handleBlur = ()=>{
                if (!this.isPressing) return;
                $5556f974238648c2$var$fireSyntheticPointerEvent("cancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo));
            };
            const removeBlurListener = (0, $105610e7777eba77$export$b1d829ddf82884aa)(this.node.current, "blur", handleBlur);
            this.removeAccessibleListeners = (0, $0a4e85080bbf1ab0$export$a4627e546088548d)(removeKeydownListener, removeBlurListener);
        };
    }
    startPress(event, info) {
        this.isPressing = true;
        const { onTapStart: onTapStart, whileTap: whileTap } = this.node.getProps();
        /**
         * Ensure we trigger animations before firing event callback
         */ if (whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", true);
        if (onTapStart) (0, $1abd9a21e276f8f7$export$2cef06c20297c17d).update(()=>onTapStart(event, info));
    }
    checkPressEnd() {
        this.removeEndListeners();
        this.isPressing = false;
        const props = this.node.getProps();
        if (props.whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", false);
        return !(0, $29a887a49c5e1406$export$1b3dd616664938e4)();
    }
    cancelPress(event, info) {
        if (!this.checkPressEnd()) return;
        const { onTapCancel: onTapCancel } = this.node.getProps();
        if (onTapCancel) (0, $1abd9a21e276f8f7$export$2cef06c20297c17d).update(()=>onTapCancel(event, info));
    }
    mount() {
        const props = this.node.getProps();
        const removePointerListener = (0, $ab731bc0caef970f$export$fcff2e64e6676b81)(this.node.current, "pointerdown", this.startPointerPress, {
            passive: !(props.onTapStart || props["onPointerStart"])
        });
        const removeFocusListener = (0, $105610e7777eba77$export$b1d829ddf82884aa)(this.node.current, "focus", this.startAccessiblePress);
        this.removeStartListeners = (0, $0a4e85080bbf1ab0$export$a4627e546088548d)(removePointerListener, removeFocusListener);
    }
    unmount() {
        this.removeStartListeners();
        this.removeEndListeners();
        this.removeAccessibleListeners();
    }
}



/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ const $99912f3e5aab1a69$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ const $99912f3e5aab1a69$var$observers = new WeakMap();
const $99912f3e5aab1a69$var$fireObserverCallback = (entry)=>{
    const callback = $99912f3e5aab1a69$var$observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const $99912f3e5aab1a69$var$fireAllObserverCallbacks = (entries)=>{
    entries.forEach($99912f3e5aab1a69$var$fireObserverCallback);
};
function $99912f3e5aab1a69$var$initIntersectionObserver({ root: root, ...options }) {
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$99912f3e5aab1a69$var$observers.has(lookupRoot)) $99912f3e5aab1a69$var$observers.set(lookupRoot, {});
    const rootObservers = $99912f3e5aab1a69$var$observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($99912f3e5aab1a69$var$fireAllObserverCallbacks, {
        root: root,
        ...options
    });
    return rootObservers[key];
}
function $99912f3e5aab1a69$export$b2bcd62fb7925aa5(element, options, callback) {
    const rootInteresectionObserver = $99912f3e5aab1a69$var$initIntersectionObserver(options);
    $99912f3e5aab1a69$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return ()=>{
        $99912f3e5aab1a69$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}


const $9790f53ad8321f10$var$thresholdNames = {
    some: 0,
    all: 1
};
class $9790f53ad8321f10$export$150851c8cc2f0c72 extends (0, $2bff128c5f01d94e$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.hasEnteredView = false;
        this.isInView = false;
    }
    startObserver() {
        this.unmount();
        const { viewport: viewport = {} } = this.node.getProps();
        const { root: root, margin: rootMargin, amount: amount = "some", once: once } = viewport;
        const options = {
            root: root ? root.current : undefined,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : $9790f53ad8321f10$var$thresholdNames[amount]
        };
        const onIntersectionUpdate = (entry)=>{
            const { isIntersecting: isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (this.isInView === isIntersecting) return;
            this.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && this.hasEnteredView) return;
            else if (isIntersecting) this.hasEnteredView = true;
            if (this.node.animationState) this.node.animationState.setActive("whileInView", isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ const { onViewportEnter: onViewportEnter, onViewportLeave: onViewportLeave } = this.node.getProps();
            const callback = isIntersecting ? onViewportEnter : onViewportLeave;
            callback && callback(entry);
        };
        return (0, $99912f3e5aab1a69$export$b2bcd62fb7925aa5)(this.node.current, options, onIntersectionUpdate);
    }
    mount() {
        this.startObserver();
    }
    update() {
        if (typeof IntersectionObserver === "undefined") return;
        const { props: props, prevProps: prevProps } = this.node;
        const hasOptionsChanged = [
            "amount",
            "margin",
            "root"
        ].some($9790f53ad8321f10$var$hasViewportOptionChanged(props, prevProps));
        if (hasOptionsChanged) this.startObserver();
    }
    unmount() {}
}
function $9790f53ad8321f10$var$hasViewportOptionChanged({ viewport: viewport = {} }, { viewport: prevViewport = {} } = {}) {
    return (name)=>viewport[name] !== prevViewport[name];
}


const $78bbaacfde380b3d$export$e5b72898e5a201f1 = {
    inView: {
        Feature: (0, $9790f53ad8321f10$export$150851c8cc2f0c72)
    },
    tap: {
        Feature: (0, $5556f974238648c2$export$f026abdbba7f0c9e)
    },
    focus: {
        Feature: (0, $5caa8f0c73d9801e$export$d4826db40d47595b)
    },
    hover: {
        Feature: (0, $1d003e4aad7511b1$export$93a81ea037eac456)
    }
};





function $265fdbc950bad8ff$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    const prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(let i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}




/**
 * Creates an object containing the latest state of every MotionValue on a VisualElement
 */ function $7efa14736b19fa31$var$getCurrent(visualElement) {
    const current = {};
    visualElement.values.forEach((value, key)=>current[key] = value.get());
    return current;
}
/**
 * Creates an object containing the latest velocity of every MotionValue on a VisualElement
 */ function $7efa14736b19fa31$var$getVelocity(visualElement) {
    const velocity = {};
    visualElement.values.forEach((value, key)=>velocity[key] = value.getVelocity());
    return velocity;
}
function $7efa14736b19fa31$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, $318b02a1e1f48ccb$export$d68f140c4d9b48bc)(props, definition, custom !== undefined ? custom : props.custom, $7efa14736b19fa31$var$getCurrent(visualElement), $7efa14736b19fa31$var$getVelocity(visualElement));
}






const $56d7ce45107a9e18$export$ed7b8fa9dbf0105d = "framerAppearId";
const $56d7ce45107a9e18$export$8592e1c077c890a6 = "data-" + (0, $64d13cd8bd24d1b3$export$9fd24a634729c672)($56d7ce45107a9e18$export$ed7b8fa9dbf0105d);



let $bcebfc2a15d8948d$export$491112666e282270 = (0, $6c31de3ed15607ce$export$8793edee2d425525);
let $bcebfc2a15d8948d$export$f5708dca728d7177 = (0, $6c31de3ed15607ce$export$8793edee2d425525);
var $bcebfc2a15d8948d$var$check, $bcebfc2a15d8948d$var$message, $bcebfc2a15d8948d$var$check1, $bcebfc2a15d8948d$var$message1;


/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ const $2d38dea89524a236$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;
const $2d38dea89524a236$export$f64c3bfbc58eec0f = (milliseconds)=>milliseconds / 1000;


const $066ba9021fabbfae$export$888a3d84909f9e3d = {
    current: false
};


const $afc787530a777dee$export$ff43f99925d7366b = (easing)=>Array.isArray(easing) && typeof easing[0] === "number";


function $4938d2c5d2391151$export$fcdd8f3f2160beda(easing) {
    return Boolean(!easing || typeof easing === "string" && $4938d2c5d2391151$export$2cf569f5e2221176[easing] || (0, $afc787530a777dee$export$ff43f99925d7366b)(easing) || Array.isArray(easing) && easing.every($4938d2c5d2391151$export$fcdd8f3f2160beda));
}
const $4938d2c5d2391151$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;
const $4938d2c5d2391151$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: $4938d2c5d2391151$export$2523b8f0bd8f44cb([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: $4938d2c5d2391151$export$2523b8f0bd8f44cb([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: $4938d2c5d2391151$export$2523b8f0bd8f44cb([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: $4938d2c5d2391151$export$2523b8f0bd8f44cb([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};
function $4938d2c5d2391151$export$916ea73bcd3a6030(easing) {
    if (!easing) return undefined;
    return (0, $afc787530a777dee$export$ff43f99925d7366b)(easing) ? $4938d2c5d2391151$export$2523b8f0bd8f44cb(easing) : Array.isArray(easing) ? easing.map($4938d2c5d2391151$export$916ea73bcd3a6030) : $4938d2c5d2391151$export$2cf569f5e2221176[easing];
}


function $a0b2320bae19d497$export$c76cd972d26986f9(element, valueName, keyframes, { delay: delay = 0, duration: duration, repeat: repeat = 0, repeatType: repeatType = "loop", ease: ease, times: times } = {}) {
    const keyframeOptions = {
        [valueName]: keyframes
    };
    if (times) keyframeOptions.offset = times;
    const easing = (0, $4938d2c5d2391151$export$916ea73bcd3a6030)(ease);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    return element.animate(keyframeOptions, {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    });
}



function $6f6e1d21e3fd7e09$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }) {
    const index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : keyframes.length - 1;
    return keyframes[index];
}



/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $235155eee5add906$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $235155eee5add906$var$subdivisionPrecision = 0.0000001;
const $235155eee5add906$var$subdivisionMaxIterations = 12;
function $235155eee5add906$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $235155eee5add906$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $235155eee5add906$var$subdivisionPrecision && ++i < $235155eee5add906$var$subdivisionMaxIterations);
    return currentT;
}
function $235155eee5add906$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $6c31de3ed15607ce$export$8793edee2d425525;
    const getTForX = (aX)=>$235155eee5add906$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $235155eee5add906$var$calcBezier(getTForX(t), mY1, mY2);
}


const $8495fc3a467d0ae5$export$929e5a82286172a6 = (0, $235155eee5add906$export$2c575fa1d20488bd)(0.42, 0, 1, 1);
const $8495fc3a467d0ae5$export$57636bb43b1ccbb0 = (0, $235155eee5add906$export$2c575fa1d20488bd)(0, 0, 0.58, 1);
const $8495fc3a467d0ae5$export$c07234257a03d5e9 = (0, $235155eee5add906$export$2c575fa1d20488bd)(0.42, 0, 0.58, 1);


const $8f3425ef1747e47c$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};






// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const $89c3c3f3cbb58e95$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;


// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const $4bdd09c0b116fc22$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);


const $fc6c39d65ec3a73f$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $fc6c39d65ec3a73f$export$c8d67a19199d1a50 = (0, $4bdd09c0b116fc22$export$2c07eeff45156d4d)($fc6c39d65ec3a73f$export$e444123e42d03385);
const $fc6c39d65ec3a73f$export$30d3455eee55bed5 = (0, $89c3c3f3cbb58e95$export$f946554fb8aeaf0d)($fc6c39d65ec3a73f$export$c8d67a19199d1a50);





const $277b64edcb1da508$export$77edfce482316a60 = (0, $235155eee5add906$export$2c575fa1d20488bd)(0.33, 1.53, 0.69, 0.99);
const $277b64edcb1da508$export$b01116c84cdfe1a2 = (0, $4bdd09c0b116fc22$export$2c07eeff45156d4d)($277b64edcb1da508$export$77edfce482316a60);
const $277b64edcb1da508$export$ddc5fd596f6c71b2 = (0, $89c3c3f3cbb58e95$export$f946554fb8aeaf0d)($277b64edcb1da508$export$b01116c84cdfe1a2);



const $423466186e572d99$export$6b0af63b873d419e = (p)=>(p *= 2) < 1 ? 0.5 * (0, $277b64edcb1da508$export$b01116c84cdfe1a2)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));


const $8a1cad10b225ab42$var$easingLookup = {
    linear: (0, $6c31de3ed15607ce$export$8793edee2d425525),
    easeIn: $8495fc3a467d0ae5$export$929e5a82286172a6,
    easeInOut: $8495fc3a467d0ae5$export$c07234257a03d5e9,
    easeOut: $8495fc3a467d0ae5$export$57636bb43b1ccbb0,
    circIn: $fc6c39d65ec3a73f$export$e444123e42d03385,
    circInOut: $fc6c39d65ec3a73f$export$30d3455eee55bed5,
    circOut: $fc6c39d65ec3a73f$export$c8d67a19199d1a50,
    backIn: $277b64edcb1da508$export$b01116c84cdfe1a2,
    backInOut: $277b64edcb1da508$export$ddc5fd596f6c71b2,
    backOut: $277b64edcb1da508$export$77edfce482316a60,
    anticipate: $423466186e572d99$export$6b0af63b873d419e
};
const $8a1cad10b225ab42$export$ef97fe084f156ca4 = (definition)=>{
    if (Array.isArray(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $bcebfc2a15d8948d$export$f5708dca728d7177)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
        const [x1, y1, x2, y2] = definition;
        return (0, $235155eee5add906$export$2c575fa1d20488bd)(x1, y1, x2, y2);
    } else if (typeof definition === "string") {
        // Else lookup from table
        (0, $bcebfc2a15d8948d$export$f5708dca728d7177)($8a1cad10b225ab42$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`);
        return $8a1cad10b225ab42$var$easingLookup[definition];
    }
    return definition;
};








/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const $f64f14cf45b5a17f$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean((0, $14c98a115b9ff356$export$844ec244b1367d54)(v) && (0, $14c98a115b9ff356$export$ed808ff6ecd39e8d).test(v) && v.startsWith(type) || testProp && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $f64f14cf45b5a17f$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (!(0, $14c98a115b9ff356$export$844ec244b1367d54)(v)) return v;
        const [a, b, c, alpha] = v.match((0, $14c98a115b9ff356$export$2444ca58c08448e4));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };


const $5a32dc6c22c76c92$var$clampRgbUnit = (v)=>(0, $e6730597558a14cb$export$7d15b64cf5a3a4c4)(0, 255, v);
const $5a32dc6c22c76c92$export$7a99c86b5b1f4c9e = {
    ...(0, $561ee22ed5cc3453$export$98e628dec113755e),
    transform: (v)=>Math.round($5a32dc6c22c76c92$var$clampRgbUnit(v))
};
const $5a32dc6c22c76c92$export$4e46ac54fc82cf3b = {
    test: (0, $f64f14cf45b5a17f$export$2c8400d58aca05e)("rgb", "red"),
    parse: (0, $f64f14cf45b5a17f$export$73d6f35be992df24)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $5a32dc6c22c76c92$export$7a99c86b5b1f4c9e.transform(red) + ", " + $5a32dc6c22c76c92$export$7a99c86b5b1f4c9e.transform(green) + ", " + $5a32dc6c22c76c92$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $14c98a115b9ff356$export$83d2e9e3e4ee39ed)((0, $561ee22ed5cc3453$export$58f0f39f63f3cf42).transform(alpha$1)) + ")"
};



function $5c503d8d6dd795f6$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $5c503d8d6dd795f6$export$834dfc94dde4b3d8 = {
    test: (0, $f64f14cf45b5a17f$export$2c8400d58aca05e)("#"),
    parse: $5c503d8d6dd795f6$var$parseHex,
    transform: (0, $5a32dc6c22c76c92$export$4e46ac54fc82cf3b).transform
};






const $ee1eb1b01210f37a$export$810b04175080204c = {
    test: (0, $f64f14cf45b5a17f$export$2c8400d58aca05e)("hsl", "hue"),
    parse: (0, $f64f14cf45b5a17f$export$73d6f35be992df24)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $ecde22e9cf283015$export$626336c2cd4b14de).transform((0, $14c98a115b9ff356$export$83d2e9e3e4ee39ed)(saturation)) + ", " + (0, $ecde22e9cf283015$export$626336c2cd4b14de).transform((0, $14c98a115b9ff356$export$83d2e9e3e4ee39ed)(lightness)) + ", " + (0, $14c98a115b9ff356$export$83d2e9e3e4ee39ed)((0, $561ee22ed5cc3453$export$58f0f39f63f3cf42).transform(alpha$1)) + ")";
    }
};



const $807a62e4f8772b4c$export$35e9368ef982300f = {
    test: (v)=>(0, $5a32dc6c22c76c92$export$4e46ac54fc82cf3b).test(v) || (0, $5c503d8d6dd795f6$export$834dfc94dde4b3d8).test(v) || (0, $ee1eb1b01210f37a$export$810b04175080204c).test(v),
    parse: (v)=>{
        if ((0, $5a32dc6c22c76c92$export$4e46ac54fc82cf3b).test(v)) return (0, $5a32dc6c22c76c92$export$4e46ac54fc82cf3b).parse(v);
        else if ((0, $ee1eb1b01210f37a$export$810b04175080204c).test(v)) return (0, $ee1eb1b01210f37a$export$810b04175080204c).parse(v);
        else return (0, $5c503d8d6dd795f6$export$834dfc94dde4b3d8).parse(v);
    },
    transform: (v)=>{
        return (0, $14c98a115b9ff356$export$844ec244b1367d54)(v) ? v : v.hasOwnProperty("red") ? (0, $5a32dc6c22c76c92$export$4e46ac54fc82cf3b).transform(v) : (0, $ee1eb1b01210f37a$export$810b04175080204c).transform(v);
    }
};



/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ const $523387644f7b98c2$export$2c9e8a9632a706b2 = (from, to, progress)=>-progress * from + progress * to + from;




// Adapted from https://gist.github.com/mjackson/5311256
function $1734fdd1605a8685$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $1734fdd1605a8685$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $1734fdd1605a8685$var$hueToRgb(p, q, hue + 1 / 3);
        green = $1734fdd1605a8685$var$hueToRgb(p, q, hue);
        blue = $1734fdd1605a8685$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}





// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const $87fc2eb1402f9696$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    return Math.sqrt(Math.max(0, v * (to * to - fromExpo) + fromExpo));
};
const $87fc2eb1402f9696$var$colorTypes = [
    (0, $5c503d8d6dd795f6$export$834dfc94dde4b3d8),
    (0, $5a32dc6c22c76c92$export$4e46ac54fc82cf3b),
    (0, $ee1eb1b01210f37a$export$810b04175080204c)
];
const $87fc2eb1402f9696$var$getColorType = (v)=>$87fc2eb1402f9696$var$colorTypes.find((type)=>type.test(v));
function $87fc2eb1402f9696$var$asRGBA(color) {
    const type = $87fc2eb1402f9696$var$getColorType(color);
    (0, $bcebfc2a15d8948d$export$f5708dca728d7177)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`);
    let model = type.parse(color);
    if (type === (0, $ee1eb1b01210f37a$export$810b04175080204c)) // TODO Remove this cast - needed since Framer Motion's stricter typing
    model = (0, $1734fdd1605a8685$export$6ae64dbcd6bfc33e)(model);
    return model;
}
const $87fc2eb1402f9696$export$51e568cf5c039bac = (from, to)=>{
    const fromRGBA = $87fc2eb1402f9696$var$asRGBA(from);
    const toRGBA = $87fc2eb1402f9696$var$asRGBA(to);
    const blended = {
        ...fromRGBA
    };
    return (v)=>{
        blended.red = $87fc2eb1402f9696$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $87fc2eb1402f9696$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $87fc2eb1402f9696$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $523387644f7b98c2$export$2c9e8a9632a706b2)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $5a32dc6c22c76c92$export$4e46ac54fc82cf3b).transform(blended);
    };
};












function $0f730cf17d9cdef4$var$test(v) {
    var _a, _b;
    return isNaN(v) && (0, $14c98a115b9ff356$export$844ec244b1367d54)(v) && (((_a = v.match((0, $14c98a115b9ff356$export$2444ca58c08448e4))) === null || _a === void 0 ? void 0 : _a.length) || 0) + (((_b = v.match((0, $14c98a115b9ff356$export$740b69c5fad25dba))) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0;
}
const $0f730cf17d9cdef4$var$cssVarTokeniser = {
    regex: (0, $96385673d2db5539$export$f7c0a352d8ef6313),
    countKey: "Vars",
    token: "${v}",
    parse: (0, $6c31de3ed15607ce$export$8793edee2d425525)
};
const $0f730cf17d9cdef4$var$colorTokeniser = {
    regex: (0, $14c98a115b9ff356$export$740b69c5fad25dba),
    countKey: "Colors",
    token: "${c}",
    parse: (0, $807a62e4f8772b4c$export$35e9368ef982300f).parse
};
const $0f730cf17d9cdef4$var$numberTokeniser = {
    regex: (0, $14c98a115b9ff356$export$2444ca58c08448e4),
    countKey: "Numbers",
    token: "${n}",
    parse: (0, $561ee22ed5cc3453$export$98e628dec113755e).parse
};
function $0f730cf17d9cdef4$var$tokenise(info, { regex: regex, countKey: countKey, token: token, parse: parse }) {
    const matches = info.tokenised.match(regex);
    if (!matches) return;
    info["num" + countKey] = matches.length;
    info.tokenised = info.tokenised.replace(regex, token);
    info.values.push(...matches.map(parse));
}
function $0f730cf17d9cdef4$export$b61fc7c44bf646d5(value) {
    const originalValue = value.toString();
    const info = {
        value: originalValue,
        tokenised: originalValue,
        values: [],
        numVars: 0,
        numColors: 0,
        numNumbers: 0
    };
    if (info.value.includes("var(--")) $0f730cf17d9cdef4$var$tokenise(info, $0f730cf17d9cdef4$var$cssVarTokeniser);
    $0f730cf17d9cdef4$var$tokenise(info, $0f730cf17d9cdef4$var$colorTokeniser);
    $0f730cf17d9cdef4$var$tokenise(info, $0f730cf17d9cdef4$var$numberTokeniser);
    return info;
}
function $0f730cf17d9cdef4$var$parseComplexValue(v) {
    return $0f730cf17d9cdef4$export$b61fc7c44bf646d5(v).values;
}
function $0f730cf17d9cdef4$var$createTransformer(source) {
    const { values: values, numColors: numColors, numVars: numVars, tokenised: tokenised } = $0f730cf17d9cdef4$export$b61fc7c44bf646d5(source);
    const numValues = values.length;
    return (v)=>{
        let output = tokenised;
        for(let i = 0; i < numValues; i++){
            if (i < numVars) output = output.replace($0f730cf17d9cdef4$var$cssVarTokeniser.token, v[i]);
            else if (i < numVars + numColors) output = output.replace($0f730cf17d9cdef4$var$colorTokeniser.token, (0, $807a62e4f8772b4c$export$35e9368ef982300f).transform(v[i]));
            else output = output.replace($0f730cf17d9cdef4$var$numberTokeniser.token, (0, $14c98a115b9ff356$export$83d2e9e3e4ee39ed)(v[i]));
        }
        return output;
    };
}
const $0f730cf17d9cdef4$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : v;
function $0f730cf17d9cdef4$var$getAnimatableNone(v) {
    const parsed = $0f730cf17d9cdef4$var$parseComplexValue(v);
    const transformer = $0f730cf17d9cdef4$var$createTransformer(v);
    return transformer(parsed.map($0f730cf17d9cdef4$var$convertNumbersToZero));
}
const $0f730cf17d9cdef4$export$83a0e34f1302825b = {
    test: $0f730cf17d9cdef4$var$test,
    parse: $0f730cf17d9cdef4$var$parseComplexValue,
    createTransformer: $0f730cf17d9cdef4$var$createTransformer,
    getAnimatableNone: $0f730cf17d9cdef4$var$getAnimatableNone
};


const $6f601fe4721f926f$var$mixImmediate = (origin, target)=>(p)=>`${p > 0 ? target : origin}`;
function $6f601fe4721f926f$var$getMixer(origin, target) {
    if (typeof origin === "number") return (v)=>(0, $523387644f7b98c2$export$2c9e8a9632a706b2)(origin, target, v);
    else if ((0, $807a62e4f8772b4c$export$35e9368ef982300f).test(origin)) return (0, $87fc2eb1402f9696$export$51e568cf5c039bac)(origin, target);
    else return origin.startsWith("var(") ? $6f601fe4721f926f$var$mixImmediate(origin, target) : $6f601fe4721f926f$export$65516310a87d8205(origin, target);
}
const $6f601fe4721f926f$export$3bbefa2f402845c4 = (from, to)=>{
    const output = [
        ...from
    ];
    const numValues = output.length;
    const blendValue = from.map((fromThis, i)=>$6f601fe4721f926f$var$getMixer(fromThis, to[i]));
    return (v)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](v);
        return output;
    };
};
const $6f601fe4721f926f$export$ebc23b6840c51ba1 = (origin, target)=>{
    const output = {
        ...origin,
        ...target
    };
    const blendValue = {};
    for(const key in output)if (origin[key] !== undefined && target[key] !== undefined) blendValue[key] = $6f601fe4721f926f$var$getMixer(origin[key], target[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
};
const $6f601fe4721f926f$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $0f730cf17d9cdef4$export$83a0e34f1302825b).createTransformer(target);
    const originStats = (0, $0f730cf17d9cdef4$export$b61fc7c44bf646d5)(origin);
    const targetStats = (0, $0f730cf17d9cdef4$export$b61fc7c44bf646d5)(target);
    const canInterpolate = originStats.numVars === targetStats.numVars && originStats.numColors === targetStats.numColors && originStats.numNumbers >= targetStats.numNumbers;
    if (canInterpolate) return (0, $0a4e85080bbf1ab0$export$a4627e546088548d)($6f601fe4721f926f$export$3bbefa2f402845c4(originStats.values, targetStats.values), template);
    else {
        (0, $bcebfc2a15d8948d$export$491112666e282270)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return $6f601fe4721f926f$var$mixImmediate(origin, target);
    }
};



/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ const $22a0644f7d6d6502$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};



const $708c0403431268bd$var$mixNumber = (from, to)=>(p)=>(0, $523387644f7b98c2$export$2c9e8a9632a706b2)(from, to, p);
function $708c0403431268bd$var$detectMixerFactory(v) {
    if (typeof v === "number") return $708c0403431268bd$var$mixNumber;
    else if (typeof v === "string") return (0, $807a62e4f8772b4c$export$35e9368ef982300f).test(v) ? (0, $87fc2eb1402f9696$export$51e568cf5c039bac) : (0, $6f601fe4721f926f$export$65516310a87d8205);
    else if (Array.isArray(v)) return 0, $6f601fe4721f926f$export$3bbefa2f402845c4;
    else if (typeof v === "object") return 0, $6f601fe4721f926f$export$ebc23b6840c51ba1;
    return $708c0403431268bd$var$mixNumber;
}
function $708c0403431268bd$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || $708c0403431268bd$var$detectMixerFactory(output[0]);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || (0, $6c31de3ed15607ce$export$8793edee2d425525) : ease;
            mixer = (0, $0a4e85080bbf1ab0$export$a4627e546088548d)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revist this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $708c0403431268bd$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $bcebfc2a15d8948d$export$f5708dca728d7177)(inputLength === output.length, "Both input and output ranges must be the same length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return ()=>output[0];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = $708c0403431268bd$var$createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, $22a0644f7d6d6502$export$504d7abb21fa8c9)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, $e6730597558a14cb$export$7d15b64cf5a3a4c4)(input[0], input[inputLength - 1], v)) : interpolator;
}




function $71578deb1ba1378d$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $22a0644f7d6d6502$export$504d7abb21fa8c9)(0, remaining, i);
        offset.push((0, $523387644f7b98c2$export$2c9e8a9632a706b2)(min, 1, offsetProgress));
    }
}


function $c96708dd3e5a507c$export$24dbcec0b26e6d9d(arr) {
    const offset = [
        0
    ];
    (0, $71578deb1ba1378d$export$dafee61230cf05c6)(offset, arr.length - 1);
    return offset;
}


function $ef7d1e67de14f578$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}


function $57e81e72247cd1c5$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $8495fc3a467d0ae5$export$c07234257a03d5e9)).splice(0, values.length - 1);
}
function $57e81e72247cd1c5$export$d25ddfdf17c3ad3e({ duration: duration = 300, keyframes: keyframeValues, times: times, ease: ease = "easeInOut" }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, $8f3425ef1747e47c$export$216948827bbdc797)(ease) ? ease.map((0, $8a1cad10b225ab42$export$ef97fe084f156ca4)) : (0, $8a1cad10b225ab42$export$ef97fe084f156ca4)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, $ef7d1e67de14f578$export$2a91b4e3a4539316)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $c96708dd3e5a507c$export$24dbcec0b26e6d9d)(keyframeValues), duration);
    const mapTimeToKeyframe = (0, $708c0403431268bd$export$89e29e4ab65e70a9)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $57e81e72247cd1c5$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: (t)=>{
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}



/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $aa8209e354dc6adc$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}


const $e721eab5ac61a666$var$velocitySampleDuration = 5; // ms
function $e721eab5ac61a666$export$854187271d233eb5(resolveValue, t, current) {
    const prevT = Math.max(t - $e721eab5ac61a666$var$velocitySampleDuration, 0);
    return (0, $aa8209e354dc6adc$export$eab0632f7ad4f9d7)(current - resolveValue(prevT), t - prevT);
}





const $c91d4967da518c9a$var$safeMin = 0.001;
const $c91d4967da518c9a$export$a3cdb76e84ee608e = 0.01;
const $c91d4967da518c9a$export$1824b851fad8862b = 10.0;
const $c91d4967da518c9a$export$ff08f2d53484465 = 0.05;
const $c91d4967da518c9a$export$201ca48e54038115 = 1;
function $c91d4967da518c9a$export$b15f158dc6d6f458({ duration: duration = 800, bounce: bounce = 0.25, velocity: velocity = 0, mass: mass = 1 }) {
    let envelope;
    let derivative;
    (0, $bcebfc2a15d8948d$export$491112666e282270)(duration <= (0, $2d38dea89524a236$export$fc3e7e8557f8c8c7)($c91d4967da518c9a$export$1824b851fad8862b), "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $e6730597558a14cb$export$7d15b64cf5a3a4c4)($c91d4967da518c9a$export$ff08f2d53484465, $c91d4967da518c9a$export$201ca48e54038115, dampingRatio);
    duration = (0, $e6730597558a14cb$export$7d15b64cf5a3a4c4)($c91d4967da518c9a$export$a3cdb76e84ee608e, $c91d4967da518c9a$export$1824b851fad8862b, (0, $2d38dea89524a236$export$f64c3bfbc58eec0f)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $c91d4967da518c9a$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $c91d4967da518c9a$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $c91d4967da518c9a$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $c91d4967da518c9a$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$c91d4967da518c9a$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $c91d4967da518c9a$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $2d38dea89524a236$export$fc3e7e8557f8c8c7)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: 100,
        damping: 10,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $c91d4967da518c9a$var$rootIterations = 12;
function $c91d4967da518c9a$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $c91d4967da518c9a$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $c91d4967da518c9a$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}


const $ac4b7d1937589e0a$var$durationKeys = [
    "duration",
    "bounce"
];
const $ac4b7d1937589e0a$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $ac4b7d1937589e0a$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $ac4b7d1937589e0a$var$getSpringOptions(options) {
    let springOptions = {
        velocity: 0.0,
        stiffness: 100,
        damping: 10,
        mass: 1.0,
        isResolvedFromDuration: false,
        ...options
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!$ac4b7d1937589e0a$var$isSpringType(options, $ac4b7d1937589e0a$var$physicsKeys) && $ac4b7d1937589e0a$var$isSpringType(options, $ac4b7d1937589e0a$var$durationKeys)) {
        const derived = (0, $c91d4967da518c9a$export$b15f158dc6d6f458)(options);
        springOptions = {
            ...springOptions,
            ...derived,
            velocity: 0.0,
            mass: 1.0
        };
        springOptions.isResolvedFromDuration = true;
    }
    return springOptions;
}
function $ac4b7d1937589e0a$export$b36281d89752ae66({ keyframes: keyframes, restDelta: restDelta, restSpeed: restSpeed, ...options }) {
    const origin = keyframes[0];
    const target = keyframes[keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness: stiffness, damping: damping, mass: mass, velocity: velocity, duration: duration, isResolvedFromDuration: isResolvedFromDuration } = $ac4b7d1937589e0a$var$getSpringOptions(options);
    const initialVelocity = velocity ? -(0, $2d38dea89524a236$export$f64c3bfbc58eec0f)(velocity) : 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = (0, $2d38dea89524a236$export$f64c3bfbc58eec0f)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? 0.01 : 2);
    restDelta || (restDelta = isGranularScale ? 0.005 : 0.5);
    let resolveSpring;
    if (dampingRatio < 1) {
        const angularFreq = (0, $c91d4967da518c9a$export$5f679887c3a78b15)(undampedAngularFreq, dampingRatio);
        // Underdamped spring
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) // Critically damped spring
    resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
    else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
    }
    return {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = initialVelocity;
                if (t !== 0) {
                    /**
                     * We only need to calculate velocity for under-damped springs
                     * as over- and critically-damped springs can't overshoot, so
                     * checking only for displacement is enough.
                     */ if (dampingRatio < 1) currentVelocity = (0, $e721eab5ac61a666$export$854187271d233eb5)(resolveSpring, t, current);
                    else currentVelocity = 0;
                }
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        }
    };
}




function $a7d2f3244a54f35a$export$ee3ff3a17106998({ keyframes: keyframes, velocity: velocity = 0.0, power: power = 0.8, timeConstant: timeConstant = 325, bounceDamping: bounceDamping = 10, bounceStiffness: bounceStiffness = 500, modifyTarget: modifyTarget, min: min, max: max, restDelta: restDelta = 0.5, restSpeed: restSpeed }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin
    };
    const isOutOfBounds = (v)=>min !== undefined && v < min || max !== undefined && v > max;
    const nearestBoundary = (v)=>{
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    const calcDelta = (t)=>-amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t)=>target + calcDelta(t);
    const applyFriction = (t)=>{
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t)=>{
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $ac4b7d1937589e0a$export$b36281d89752ae66)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $e721eab5ac61a666$export$854187271d233eb5)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t)=>{
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t > timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}



const $bcc66488a3535e3d$export$c1033964b5ad7fef = (update)=>{
    const passTimestamp = ({ timestamp: timestamp })=>update(timestamp);
    return {
        start: ()=>(0, $1abd9a21e276f8f7$export$2cef06c20297c17d).update(passTimestamp, true),
        stop: ()=>(0, $1abd9a21e276f8f7$export$ec99c0ef4978dccb)(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: ()=>(0, $1abd9a21e276f8f7$export$fff89137e9e818ce).isProcessing ? (0, $1abd9a21e276f8f7$export$fff89137e9e818ce).timestamp : performance.now()
    };
};





/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $7bb90c890c7a40c9$export$f4ff70a5b4808fd8 = 20000;
function $7bb90c890c7a40c9$export$cbdd6b3d40ea54e2(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while(!state.done && duration < $7bb90c890c7a40c9$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $7bb90c890c7a40c9$export$f4ff70a5b4808fd8 ? Infinity : duration;
}


const $c02100a880ef99c6$var$types = {
    decay: (0, $a7d2f3244a54f35a$export$ee3ff3a17106998),
    inertia: $a7d2f3244a54f35a$export$ee3ff3a17106998,
    tween: (0, $57e81e72247cd1c5$export$d25ddfdf17c3ad3e),
    keyframes: (0, $57e81e72247cd1c5$export$d25ddfdf17c3ad3e),
    spring: $ac4b7d1937589e0a$export$b36281d89752ae66
};
/**
 * Animate a single value on the main thread.
 *
 * This function is written, where functionality overlaps,
 * to be largely spec-compliant with WAAPI to allow fungibility
 * between the two.
 */ function $c02100a880ef99c6$export$ee9b76de7353d815({ autoplay: autoplay = true, delay: delay = 0, driver: driver = (0, $bcc66488a3535e3d$export$c1033964b5ad7fef), keyframes: keyframes$1, type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType = "loop", onPlay: onPlay, onStop: onStop, onComplete: onComplete, onUpdate: onUpdate, ...options }) {
    let speed = 1;
    let hasStopped = false;
    let resolveFinishedPromise;
    let currentFinishedPromise;
    /**
     * Resolve the current Promise every time we enter the
     * finished state. This is WAAPI-compatible behaviour.
     */ const updateFinishedPromise = ()=>{
        currentFinishedPromise = new Promise((resolve)=>{
            resolveFinishedPromise = resolve;
        });
    };
    // Create the first finished promise
    updateFinishedPromise();
    let animationDriver;
    const generatorFactory = $c02100a880ef99c6$var$types[type] || (0, $57e81e72247cd1c5$export$d25ddfdf17c3ad3e);
    /**
     * If this isn't the keyframes generator and we've been provided
     * strings as keyframes, we need to interpolate these.
     * TODO: Support velocity for units and complex value types/
     */ let mapNumbersToKeyframes;
    if (generatorFactory !== (0, $57e81e72247cd1c5$export$d25ddfdf17c3ad3e) && typeof keyframes$1[0] !== "number") {
        mapNumbersToKeyframes = (0, $708c0403431268bd$export$89e29e4ab65e70a9)([
            0,
            100
        ], keyframes$1, {
            clamp: false
        });
        keyframes$1 = [
            0,
            100
        ];
    }
    const generator = generatorFactory({
        ...options,
        keyframes: keyframes$1
    });
    let mirroredGenerator;
    if (repeatType === "mirror") mirroredGenerator = generatorFactory({
        ...options,
        keyframes: [
            ...keyframes$1
        ].reverse(),
        velocity: -(options.velocity || 0)
    });
    let playState = "idle";
    let holdTime = null;
    let startTime = null;
    let cancelTime = null;
    /**
     * If duration is undefined and we have repeat options,
     * we need to calculate a duration from the generator.
     *
     * We set it to the generator itself to cache the duration.
     * Any timeline resolver will need to have already precalculated
     * the duration by this step.
     */ if (generator.calculatedDuration === null && repeat) generator.calculatedDuration = (0, $7bb90c890c7a40c9$export$cbdd6b3d40ea54e2)(generator);
    const { calculatedDuration: calculatedDuration } = generator;
    let resolvedDuration = Infinity;
    let totalDuration = Infinity;
    if (calculatedDuration !== null) {
        resolvedDuration = calculatedDuration + repeatDelay;
        totalDuration = resolvedDuration * (repeat + 1) - repeatDelay;
    }
    let currentTime = 0;
    const tick = (timestamp)=>{
        if (startTime === null) return;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (speed > 0) startTime = Math.min(startTime, timestamp);
        if (speed < 0) startTime = Math.min(timestamp - totalDuration / speed, startTime);
        if (holdTime !== null) currentTime = holdTime;
        else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        currentTime = Math.round(timestamp - startTime) * speed;
        // Rebase on delay
        const timeWithoutDelay = currentTime - delay * (speed >= 0 ? 1 : -1);
        const isInDelayPhase = speed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        currentTime = Math.max(timeWithoutDelay, 0);
        /**
         * If this animation has finished, set the current time
         * to the total duration.
         */ if (playState === "finished" && holdTime === null) currentTime = totalDuration;
        let elapsed = currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = currentTime / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const iterationIsOdd = Boolean(currentIteration % 2);
            if (iterationIsOdd) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
            }
            let p = (0, $e6730597558a14cb$export$7d15b64cf5a3a4c4)(0, 1, iterationProgress);
            if (currentTime > totalDuration) p = repeatType === "reverse" && iterationIsOdd ? 1 : 0;
            elapsed = p * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ const state = isInDelayPhase ? {
            done: false,
            value: keyframes$1[0]
        } : frameGenerator.next(elapsed);
        if (mapNumbersToKeyframes) state.value = mapNumbersToKeyframes(state.value);
        let { done: done } = state;
        if (!isInDelayPhase && calculatedDuration !== null) done = speed >= 0 ? currentTime >= totalDuration : currentTime <= 0;
        const isAnimationFinished = holdTime === null && (playState === "finished" || playState === "running" && done);
        if (onUpdate) onUpdate(state.value);
        if (isAnimationFinished) finish();
        return state;
    };
    const stopAnimationDriver = ()=>{
        animationDriver && animationDriver.stop();
        animationDriver = undefined;
    };
    const cancel = ()=>{
        playState = "idle";
        stopAnimationDriver();
        resolveFinishedPromise();
        updateFinishedPromise();
        startTime = cancelTime = null;
    };
    const finish = ()=>{
        playState = "finished";
        onComplete && onComplete();
        stopAnimationDriver();
        resolveFinishedPromise();
    };
    const play = ()=>{
        if (hasStopped) return;
        if (!animationDriver) animationDriver = driver(tick);
        const now = animationDriver.now();
        onPlay && onPlay();
        if (holdTime !== null) startTime = now - holdTime;
        else if (!startTime || playState === "finished") startTime = now;
        if (playState === "finished") updateFinishedPromise();
        cancelTime = startTime;
        holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ playState = "running";
        animationDriver.start();
    };
    if (autoplay) play();
    const controls = {
        then (resolve, reject) {
            return currentFinishedPromise.then(resolve, reject);
        },
        get time () {
            return (0, $2d38dea89524a236$export$f64c3bfbc58eec0f)(currentTime);
        },
        set time (newTime){
            newTime = (0, $2d38dea89524a236$export$fc3e7e8557f8c8c7)(newTime);
            currentTime = newTime;
            if (holdTime !== null || !animationDriver || speed === 0) holdTime = newTime;
            else startTime = animationDriver.now() - newTime / speed;
        },
        get duration () {
            const duration = generator.calculatedDuration === null ? (0, $7bb90c890c7a40c9$export$cbdd6b3d40ea54e2)(generator) : generator.calculatedDuration;
            return (0, $2d38dea89524a236$export$f64c3bfbc58eec0f)(duration);
        },
        get speed () {
            return speed;
        },
        set speed (newSpeed){
            if (newSpeed === speed || !animationDriver) return;
            speed = newSpeed;
            controls.time = (0, $2d38dea89524a236$export$f64c3bfbc58eec0f)(currentTime);
        },
        get state () {
            return playState;
        },
        play: play,
        pause: ()=>{
            playState = "paused";
            holdTime = currentTime;
        },
        stop: ()=>{
            hasStopped = true;
            if (playState === "idle") return;
            playState = "idle";
            onStop && onStop();
            cancel();
        },
        cancel: ()=>{
            if (cancelTime !== null) tick(cancelTime);
            cancel();
        },
        complete: ()=>{
            playState = "finished";
        },
        sample: (elapsed)=>{
            startTime = 0;
            return tick(elapsed);
        }
    };
    return controls;
}



function $3866d2f7f520d558$export$7c73462e0d25e514(callback) {
    let result;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}




const $3e52db8400c95ad2$var$supportsWaapi = (0, $3866d2f7f520d558$export$7c73462e0d25e514)(()=>Object.hasOwnProperty.call(Element.prototype, "animate"));
/**
 * A list of values that can be hardware-accelerated.
 */ const $3e52db8400c95ad2$var$acceleratedValues = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform",
    "backgroundColor"
]);
/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const $3e52db8400c95ad2$var$sampleDelta = 10; //ms
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $3e52db8400c95ad2$var$maxDuration = 20000;
const $3e52db8400c95ad2$var$requiresPregeneratedKeyframes = (valueName, options)=>options.type === "spring" || valueName === "backgroundColor" || !(0, $4938d2c5d2391151$export$fcdd8f3f2160beda)(options.ease);
function $3e52db8400c95ad2$export$4d5d9557ab897126(value, valueName, { onUpdate: onUpdate, onComplete: onComplete, ...options }) {
    const canAccelerateAnimation = $3e52db8400c95ad2$var$supportsWaapi() && $3e52db8400c95ad2$var$acceleratedValues.has(valueName) && !options.repeatDelay && options.repeatType !== "mirror" && options.damping !== 0 && options.type !== "inertia";
    if (!canAccelerateAnimation) return false;
    /**
     * TODO: Unify with js/index
     */ let hasStopped = false;
    let resolveFinishedPromise;
    let currentFinishedPromise;
    /**
     * Resolve the current Promise every time we enter the
     * finished state. This is WAAPI-compatible behaviour.
     */ const updateFinishedPromise = ()=>{
        currentFinishedPromise = new Promise((resolve)=>{
            resolveFinishedPromise = resolve;
        });
    };
    // Create the first finished promise
    updateFinishedPromise();
    let { keyframes: keyframes, duration: duration = 300, ease: ease, times: times } = options;
    /**
     * If this animation needs pre-generated keyframes then generate.
     */ if ($3e52db8400c95ad2$var$requiresPregeneratedKeyframes(valueName, options)) {
        const sampleAnimation = (0, $c02100a880ef99c6$export$ee9b76de7353d815)({
            ...options,
            repeat: 0,
            delay: 0
        });
        let state = {
            done: false,
            value: keyframes[0]
        };
        const pregeneratedKeyframes = [];
        /**
         * Bail after 20 seconds of pre-generated keyframes as it's likely
         * we're heading for an infinite loop.
         */ let t = 0;
        while(!state.done && t < $3e52db8400c95ad2$var$maxDuration){
            state = sampleAnimation.sample(t);
            pregeneratedKeyframes.push(state.value);
            t += $3e52db8400c95ad2$var$sampleDelta;
        }
        times = undefined;
        keyframes = pregeneratedKeyframes;
        duration = t - $3e52db8400c95ad2$var$sampleDelta;
        ease = "linear";
    }
    const animation = (0, $a0b2320bae19d497$export$c76cd972d26986f9)(value.owner.current, valueName, keyframes, {
        ...options,
        duration: duration,
        /**
         * This function is currently not called if ease is provided
         * as a function so the cast is safe.
         *
         * However it would be possible for a future refinement to port
         * in easing pregeneration from Motion One for browsers that
         * support the upcoming `linear()` easing function.
         */ ease: ease,
        times: times
    });
    const cancelAnimation = ()=>animation.cancel();
    const safeCancel = ()=>{
        (0, $1abd9a21e276f8f7$export$2cef06c20297c17d).update(cancelAnimation);
        resolveFinishedPromise();
        updateFinishedPromise();
    };
    /**
     * Prefer the `onfinish` prop as it's more widely supported than
     * the `finished` promise.
     *
     * Here, we synchronously set the provided MotionValue to the end
     * keyframe. If we didn't, when the WAAPI animation is finished it would
     * be removed from the element which would then revert to its old styles.
     */ animation.onfinish = ()=>{
        value.set((0, $6f6e1d21e3fd7e09$export$14de59408fad90b)(keyframes, options));
        onComplete && onComplete();
        safeCancel();
    };
    /**
     * Animation interrupt callback.
     */ const controls = {
        then (resolve, reject) {
            return currentFinishedPromise.then(resolve, reject);
        },
        attachTimeline (timeline) {
            animation.timeline = timeline;
            animation.onfinish = null;
            return 0, $6c31de3ed15607ce$export$8793edee2d425525;
        },
        get time () {
            return (0, $2d38dea89524a236$export$f64c3bfbc58eec0f)(animation.currentTime || 0);
        },
        set time (newTime){
            animation.currentTime = (0, $2d38dea89524a236$export$fc3e7e8557f8c8c7)(newTime);
        },
        get speed () {
            return animation.playbackRate;
        },
        set speed (newSpeed){
            animation.playbackRate = newSpeed;
        },
        get duration () {
            return (0, $2d38dea89524a236$export$f64c3bfbc58eec0f)(duration);
        },
        play: ()=>{
            if (hasStopped) return;
            animation.play();
            /**
             * Cancel any pending cancel tasks
             */ (0, $1abd9a21e276f8f7$export$ec99c0ef4978dccb)(cancelAnimation);
        },
        pause: ()=>animation.pause(),
        stop: ()=>{
            hasStopped = true;
            if (animation.playState === "idle") return;
            /**
             * WAAPI doesn't natively have any interruption capabilities.
             *
             * Rather than read commited styles back out of the DOM, we can
             * create a renderless JS animation and sample it twice to calculate
             * its current value, "previous" value, and therefore allow
             * Motion to calculate velocity for any subsequent animation.
             */ const { currentTime: currentTime } = animation;
            if (currentTime) {
                const sampleAnimation = (0, $c02100a880ef99c6$export$ee9b76de7353d815)({
                    ...options,
                    autoplay: false
                });
                value.setWithVelocity(sampleAnimation.sample(currentTime - $3e52db8400c95ad2$var$sampleDelta).value, sampleAnimation.sample(currentTime).value, $3e52db8400c95ad2$var$sampleDelta);
            }
            safeCancel();
        },
        complete: ()=>animation.finish(),
        cancel: safeCancel
    };
    return controls;
}




function $c9407f0f3c93963b$export$6f34fc8ef6c42b70({ keyframes: keyframes, delay: delay, onUpdate: onUpdate, onComplete: onComplete }) {
    const setValue = ()=>{
        onUpdate && onUpdate(keyframes[keyframes.length - 1]);
        onComplete && onComplete();
        /**
         * TODO: As this API grows it could make sense to always return
         * animateValue. This will be a bigger project as animateValue
         * is frame-locked whereas this function resolves instantly.
         * This is a behavioural change and also has ramifications regarding
         * assumptions within tests.
         */ return {
            time: 0,
            speed: 1,
            duration: 0,
            play: (0, $6c31de3ed15607ce$export$8793edee2d425525),
            pause: (0, $6c31de3ed15607ce$export$8793edee2d425525),
            stop: (0, $6c31de3ed15607ce$export$8793edee2d425525),
            then: (resolve)=>{
                resolve();
                return Promise.resolve();
            },
            cancel: (0, $6c31de3ed15607ce$export$8793edee2d425525),
            complete: (0, $6c31de3ed15607ce$export$8793edee2d425525)
        };
    };
    return delay ? (0, $c02100a880ef99c6$export$ee9b76de7353d815)({
        keyframes: [
            0,
            1
        ],
        duration: 0,
        delay: delay,
        onComplete: setValue
    }) : setValue();
}



const $1807772d6913a56f$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const $1807772d6913a56f$var$criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $1807772d6913a56f$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const $1807772d6913a56f$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const $1807772d6913a56f$export$262124b154b9f1c0 = (valueKey, { keyframes: keyframes })=>{
    if (keyframes.length > 2) return $1807772d6913a56f$var$keyframesTransition;
    else if ((0, $ca5c3ae346f46e59$export$7b42a0094fb00b6e).has(valueKey)) return valueKey.startsWith("scale") ? $1807772d6913a56f$var$criticallyDampedSpring(keyframes[1]) : $1807772d6913a56f$var$underDampedSpring;
    return $1807772d6913a56f$var$ease;
};



/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $ac24b49c3a1ad020$export$65676b58b122bc38 = (key, value)=>{
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (key === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $0f730cf17d9cdef4$export$83a0e34f1302825b).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};





/**
 * Properties that should default to 1 or 100%
 */ const $bb1d2d1d8c68b6f2$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $bb1d2d1d8c68b6f2$var$applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $14c98a115b9ff356$export$2444ca58c08448e4)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $bb1d2d1d8c68b6f2$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $bb1d2d1d8c68b6f2$var$functionRegex = /([a-z-]*)\(.*?\)/g;
const $bb1d2d1d8c68b6f2$export$3dea766d36a8935f = {
    ...(0, $0f730cf17d9cdef4$export$83a0e34f1302825b),
    getAnimatableNone: (v)=>{
        const functions = v.match($bb1d2d1d8c68b6f2$var$functionRegex);
        return functions ? functions.map($bb1d2d1d8c68b6f2$var$applyDefaultFilter).join(" ") : v;
    }
};





/**
 * A map of default value types for common values
 */ const $67678bc8be638c06$export$98cd7c72c5a731fb = {
    ...(0, $12409a37b914f32f$export$eec14432cd1cb67b),
    color: // Color props
    $807a62e4f8772b4c$export$35e9368ef982300f,
    backgroundColor: (0, $807a62e4f8772b4c$export$35e9368ef982300f),
    outlineColor: (0, $807a62e4f8772b4c$export$35e9368ef982300f),
    fill: (0, $807a62e4f8772b4c$export$35e9368ef982300f),
    stroke: (0, $807a62e4f8772b4c$export$35e9368ef982300f),
    // Border props
    borderColor: (0, $807a62e4f8772b4c$export$35e9368ef982300f),
    borderTopColor: (0, $807a62e4f8772b4c$export$35e9368ef982300f),
    borderRightColor: (0, $807a62e4f8772b4c$export$35e9368ef982300f),
    borderBottomColor: (0, $807a62e4f8772b4c$export$35e9368ef982300f),
    borderLeftColor: (0, $807a62e4f8772b4c$export$35e9368ef982300f),
    filter: $bb1d2d1d8c68b6f2$export$3dea766d36a8935f,
    WebkitFilter: (0, $bb1d2d1d8c68b6f2$export$3dea766d36a8935f)
};
/**
 * Gets the default ValueType for the provided value key
 */ const $67678bc8be638c06$export$67d1babe0338d23b = (key)=>$67678bc8be638c06$export$98cd7c72c5a731fb[key];


function $88b1cc5092be3b44$export$cea0cedcb94873b5(key, value) {
    let defaultValueType = (0, $67678bc8be638c06$export$67d1babe0338d23b)(key);
    if (defaultValueType !== (0, $bb1d2d1d8c68b6f2$export$3dea766d36a8935f)) defaultValueType = (0, $0f730cf17d9cdef4$export$83a0e34f1302825b);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}



/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $09984675e0cd40a3$export$ade84c85e44a6cb1 = (v)=>/^0[^.\s]+$/.test(v);


function $40a61792c037887b$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $09984675e0cd40a3$export$ade84c85e44a6cb1)(value);
}


function $dc78045a190a22aa$export$b2b5e866b2fbf2ec(value, valueName, target, transition) {
    const isTargetAnimatable = (0, $ac24b49c3a1ad020$export$65676b58b122bc38)(valueName, target);
    let keyframes;
    if (Array.isArray(target)) keyframes = [
        ...target
    ];
    else keyframes = [
        null,
        target
    ];
    const defaultOrigin = transition.from !== undefined ? transition.from : value.get();
    let animatableTemplateValue = undefined;
    const noneKeyframeIndexes = [];
    for(let i = 0; i < keyframes.length; i++){
        /**
         * Fill null/wildcard keyframes
         */ if (keyframes[i] === null) keyframes[i] = i === 0 ? defaultOrigin : keyframes[i - 1];
        if ((0, $40a61792c037887b$export$e56af863d5645d5f)(keyframes[i])) noneKeyframeIndexes.push(i);
        // TODO: Clean this conditional, it works for now
        if (typeof keyframes[i] === "string" && keyframes[i] !== "none" && keyframes[i] !== "0") animatableTemplateValue = keyframes[i];
    }
    if (isTargetAnimatable && noneKeyframeIndexes.length && animatableTemplateValue) for(let i = 0; i < noneKeyframeIndexes.length; i++){
        const index = noneKeyframeIndexes[i];
        keyframes[index] = (0, $88b1cc5092be3b44$export$cea0cedcb94873b5)(valueName, animatableTemplateValue);
    }
    return keyframes;
}


/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $805c9cc606559c5c$export$ca8e47dc8ed5a9d7({ when: when, delay: _delay, delayChildren: delayChildren, staggerChildren: staggerChildren, staggerDirection: staggerDirection, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, from: from, elapsed: elapsed, ...transition }) {
    return !!Object.keys(transition).length;
}
function $805c9cc606559c5c$export$7c1391340308742e(transition, key) {
    return transition[key] || transition["default"] || transition;
}



const $567a733505d98c06$export$90b3dfc33ff3548 = (valueName, value, target, transition = {})=>{
    return (onComplete)=>{
        const valueTransition = (0, $805c9cc606559c5c$export$7c1391340308742e)(transition, valueName) || {};
        /**
         * Most transition values are currently completely overwritten by value-specific
         * transitions. In the future it'd be nicer to blend these transitions. But for now
         * delay actually does inherit from the root transition if not value-specific.
         */ const delay = valueTransition.delay || transition.delay || 0;
        /**
         * Elapsed isn't a public transition option but can be passed through from
         * optimized appear effects in milliseconds.
         */ let { elapsed: elapsed = 0 } = transition;
        elapsed = elapsed - (0, $2d38dea89524a236$export$fc3e7e8557f8c8c7)(delay);
        const keyframes = (0, $dc78045a190a22aa$export$b2b5e866b2fbf2ec)(value, valueName, target, valueTransition);
        /**
         * Check if we're able to animate between the start and end keyframes,
         * and throw a warning if we're attempting to animate between one that's
         * animatable and another that isn't.
         */ const originKeyframe = keyframes[0];
        const targetKeyframe = keyframes[keyframes.length - 1];
        const isOriginAnimatable = (0, $ac24b49c3a1ad020$export$65676b58b122bc38)(valueName, originKeyframe);
        const isTargetAnimatable = (0, $ac24b49c3a1ad020$export$65676b58b122bc38)(valueName, targetKeyframe);
        (0, $bcebfc2a15d8948d$export$491112666e282270)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${valueName} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
        let options = {
            keyframes: keyframes,
            velocity: value.getVelocity(),
            ease: "easeOut",
            ...valueTransition,
            delay: -elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            }
        };
        /**
         * If there's no transition defined for this value, we can generate
         * unqiue transition settings for this value.
         */ if (!(0, $805c9cc606559c5c$export$ca8e47dc8ed5a9d7)(valueTransition)) options = {
            ...options,
            ...(0, $1807772d6913a56f$export$262124b154b9f1c0)(valueName, options)
        };
        /**
         * Both WAAPI and our internal animation functions use durations
         * as defined by milliseconds, while our external API defines them
         * as seconds.
         */ if (options.duration) options.duration = (0, $2d38dea89524a236$export$fc3e7e8557f8c8c7)(options.duration);
        if (options.repeatDelay) options.repeatDelay = (0, $2d38dea89524a236$export$fc3e7e8557f8c8c7)(options.repeatDelay);
        if (!isOriginAnimatable || !isTargetAnimatable || (0, $066ba9021fabbfae$export$888a3d84909f9e3d).current || valueTransition.type === false) /**
             * If we can't animate this value, or the global instant animation flag is set,
             * or this is simply defined as an instant transition, return an instant transition.
             */ return (0, $c9407f0f3c93963b$export$6f34fc8ef6c42b70)((0, $066ba9021fabbfae$export$888a3d84909f9e3d).current ? {
            ...options,
            delay: 0
        } : options);
        /**
         * Animate via WAAPI if possible.
         */ if (value.owner && value.owner.current instanceof HTMLElement && !value.owner.getProps().onUpdate) {
            const acceleratedAnimation = (0, $3e52db8400c95ad2$export$4d5d9557ab897126)(value, valueName, options);
            if (acceleratedAnimation) return acceleratedAnimation;
        }
        /**
         * If we didn't create an accelerated animation, create a JS animation
         */ return (0, $c02100a880ef99c6$export$ee9b76de7353d815)(options);
    };
};



function $2d5ab3a3cea3faff$export$98397f3adbf6259f(value) {
    return Boolean((0, $56c5f751f01a3bad$export$605d60a2578142d3)(value) && value.add);
}


/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $00cc39cdc155a599$export$65583ed5a868f2d9 = (v)=>/^\-?\d*\.?\d+$/.test(v);




function $560e5a2c215d9315$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $560e5a2c215d9315$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $560e5a2c215d9315$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}


class $a6375dce0ad778ec$export$e7dff9482a5fd23c {
    constructor(){
        this.subscriptions = [];
    }
    add(handler) {
        (0, $560e5a2c215d9315$export$20e507e47fae79fd)(this.subscriptions, handler);
        return ()=>(0, $560e5a2c215d9315$export$fe2d9b4e03920b4c)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}





const $33b71ad0065b86cf$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $33b71ad0065b86cf$export$8cea36d14ee64562 {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */ constructor(init, options = {}){
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */ this.version = "10.15.0";
        /**
         * Duration, in milliseconds, since last updating frame.
         *
         * @internal
         */ this.timeDelta = 0;
        /**
         * Timestamp of the last time this `MotionValue` was updated.
         *
         * @internal
         */ this.lastUpdated = 0;
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = false;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v, render = true)=>{
            this.prev = this.current;
            this.current = v;
            // Update timestamp
            const { delta: delta, timestamp: timestamp } = (0, $1abd9a21e276f8f7$export$fff89137e9e818ce);
            if (this.lastUpdated !== timestamp) {
                this.timeDelta = delta;
                this.lastUpdated = timestamp;
                (0, $1abd9a21e276f8f7$export$2cef06c20297c17d).postRender(this.scheduleVelocityCheck);
            }
            // Update update subscribers
            if (this.prev !== this.current && this.events.change) this.events.change.notify(this.current);
            // Update velocity subscribers
            if (this.events.velocityChange) this.events.velocityChange.notify(this.getVelocity());
            // Update render subscribers
            if (render && this.events.renderRequest) this.events.renderRequest.notify(this.current);
        };
        /**
         * Schedule a velocity check for the next frame.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.scheduleVelocityCheck = ()=>(0, $1abd9a21e276f8f7$export$2cef06c20297c17d).postRender(this.velocityCheck);
        /**
         * Updates `prev` with `current` if the value hasn't been updated this frame.
         * This ensures velocity calculations return `0`.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.velocityCheck = ({ timestamp: timestamp })=>{
            if (timestamp !== this.lastUpdated) {
                this.prev = this.current;
                if (this.events.velocityChange) this.events.velocityChange.notify(this.getVelocity());
            }
        };
        this.hasAnimated = false;
        this.prev = this.current = init;
        this.canTrackVelocity = $33b71ad0065b86cf$var$isFloat(this.current);
        this.owner = options.owner;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $a6375dce0ad778ec$export$e7dff9482a5fd23c)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $1abd9a21e276f8f7$export$2cef06c20297c17d).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v, render = true) {
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = prev;
        this.timeDelta = delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v) {
        this.updateAndNotify(v);
        this.prev = v;
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        // This could be isFloat(this.prev) && isFloat(this.current), but that would be wasteful
        return this.canTrackVelocity ? (0, $aa8209e354dc6adc$export$eab0632f7ad4f9d7)(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta) : 0;
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
}
function $33b71ad0065b86cf$export$ce8bdc721e76545f(init, options) {
    return new $33b71ad0065b86cf$export$8cea36d14ee64562(init, options);
}








/**
 * Tests a provided value against a ValueType
 */ const $822684b2d80b1256$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);


/**
 * ValueType for "auto"
 */ const $8c261c6e411fbb94$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};


/**
 * A list of value types commonly used for dimensions
 */ const $a8226391f55e88e8$export$d176691c1998a1f5 = [
    (0, $561ee22ed5cc3453$export$98e628dec113755e),
    (0, $ecde22e9cf283015$export$91c0eda1d06bf008),
    (0, $ecde22e9cf283015$export$626336c2cd4b14de),
    (0, $ecde22e9cf283015$export$41fc368e1a942b97),
    (0, $ecde22e9cf283015$export$aed3d7b7d206c196),
    (0, $ecde22e9cf283015$export$f91e8c45a95a32f2),
    (0, $8c261c6e411fbb94$export$dfb5619354ba860)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $a8226391f55e88e8$export$eefdd52e3ccae428 = (v)=>$a8226391f55e88e8$export$d176691c1998a1f5.find((0, $822684b2d80b1256$export$6eae4d0a6a7ca7cd)(v));



/**
 * A list of all ValueTypes
 */ const $f8f95312f18d395f$var$valueTypes = [
    ...(0, $a8226391f55e88e8$export$d176691c1998a1f5),
    (0, $807a62e4f8772b4c$export$35e9368ef982300f),
    (0, $0f730cf17d9cdef4$export$83a0e34f1302825b)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $f8f95312f18d395f$export$950e7e59ea1ffed7 = (v)=>$f8f95312f18d395f$var$valueTypes.find((0, $822684b2d80b1256$export$6eae4d0a6a7ca7cd)(v));



/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $ce7c85a117778f2d$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $33b71ad0065b86cf$export$ce8bdc721e76545f)(value));
}
function $ce7c85a117778f2d$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $7efa14736b19fa31$export$7b1b1c981f4f0558)(visualElement, definition);
    let { transitionEnd: transitionEnd = {}, transition: transition = {}, ...target } = resolved ? visualElement.makeTargetAnimatable(resolved, false) : {};
    target = {
        ...target,
        ...transitionEnd
    };
    for(const key in target){
        const value = (0, $b82cb19c2a0bb263$export$5485128c47bd48bb)(target[key]);
        $ce7c85a117778f2d$var$setMotionValue(visualElement, key, value);
    }
}
function $ce7c85a117778f2d$var$setVariants(visualElement, variantLabels) {
    const reversedLabels = [
        ...variantLabels
    ].reverse();
    reversedLabels.forEach((key)=>{
        const variant = visualElement.getVariant(key);
        variant && $ce7c85a117778f2d$export$1f61c53461aff4a5(visualElement, variant);
        if (visualElement.variantChildren) visualElement.variantChildren.forEach((child)=>{
            $ce7c85a117778f2d$var$setVariants(child, variantLabels);
        });
    });
}
function $ce7c85a117778f2d$export$b7771d60d308862f(visualElement, definition) {
    if (Array.isArray(definition)) return $ce7c85a117778f2d$var$setVariants(visualElement, definition);
    else if (typeof definition === "string") return $ce7c85a117778f2d$var$setVariants(visualElement, [
        definition
    ]);
    else $ce7c85a117778f2d$export$1f61c53461aff4a5(visualElement, definition);
}
function $ce7c85a117778f2d$export$6afbed164019a54c(visualElement, target, origin) {
    var _a, _b;
    const newValueKeys = Object.keys(target).filter((key)=>!visualElement.hasValue(key));
    const numNewValues = newValueKeys.length;
    if (!numNewValues) return;
    for(let i = 0; i < numNewValues; i++){
        const key = newValueKeys[i];
        const targetValue = target[key];
        let value = null;
        /**
         * If the target is a series of keyframes, we can use the first value
         * in the array. If this first value is null, we'll still need to read from the DOM.
         */ if (Array.isArray(targetValue)) value = targetValue[0];
        /**
         * If the target isn't keyframes, or the first keyframe was null, we need to
         * first check if an origin value was explicitly defined in the transition as "from",
         * if not read the value from the DOM. As an absolute fallback, take the defined target value.
         */ if (value === null) value = (_b = (_a = origin[key]) !== null && _a !== void 0 ? _a : visualElement.readValue(key)) !== null && _b !== void 0 ? _b : target[key];
        /**
         * If value is still undefined or null, ignore it. Preferably this would throw,
         * but this was causing issues in Framer.
         */ if (value === undefined || value === null) continue;
        if (typeof value === "string" && ((0, $00cc39cdc155a599$export$65583ed5a868f2d9)(value) || (0, $09984675e0cd40a3$export$ade84c85e44a6cb1)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
        value = parseFloat(value);
        else if (!(0, $f8f95312f18d395f$export$950e7e59ea1ffed7)(value) && (0, $0f730cf17d9cdef4$export$83a0e34f1302825b).test(targetValue)) value = (0, $88b1cc5092be3b44$export$cea0cedcb94873b5)(key, targetValue);
        visualElement.addValue(key, (0, $33b71ad0065b86cf$export$ce8bdc721e76545f)(value, {
            owner: visualElement
        }));
        if (origin[key] === undefined) origin[key] = value;
        if (value !== null) visualElement.setBaseTarget(key, value);
    }
}
function $ce7c85a117778f2d$export$c3befe8e18686628(key, transition) {
    if (!transition) return;
    const valueTransition = transition[key] || transition["default"] || transition;
    return valueTransition.from;
}
function $ce7c85a117778f2d$export$5a759dc7a1cfb72a(target, transition, visualElement) {
    const origin = {};
    for(const key in target){
        const transitionOrigin = $ce7c85a117778f2d$export$c3befe8e18686628(key, transition);
        if (transitionOrigin !== undefined) origin[key] = transitionOrigin;
        else {
            const value = visualElement.getValue(key);
            if (value) origin[key] = value.get();
        }
    }
    return origin;
}



/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $cf1b1579b00c1362$var$shouldBlockAnimation({ protectedKeys: protectedKeys, needsAnimating: needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $cf1b1579b00c1362$export$68cacfeee78d98d2(visualElement, definition, { delay: delay = 0, transitionOverride: transitionOverride, type: type } = {}) {
    let { transition: transition = visualElement.getDefaultTransition(), transitionEnd: transitionEnd, ...target } = visualElement.makeTargetAnimatable(definition);
    const willChange = visualElement.getValue("willChange");
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    for(const key in target){
        const value = visualElement.getValue(key);
        const valueTarget = target[key];
        if (!value || valueTarget === undefined || animationTypeState && $cf1b1579b00c1362$var$shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = {
            delay: delay,
            elapsed: 0,
            ...transition
        };
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ if (window.HandoffAppearAnimations && !value.hasAnimated) {
            const appearId = visualElement.getProps()[0, $56d7ce45107a9e18$export$8592e1c077c890a6];
            if (appearId) valueTransition.elapsed = window.HandoffAppearAnimations(appearId, key, value, (0, $1abd9a21e276f8f7$export$2cef06c20297c17d));
        }
        value.start((0, $567a733505d98c06$export$90b3dfc33ff3548)(key, value, valueTarget, visualElement.shouldReduceMotion && (0, $ca5c3ae346f46e59$export$7b42a0094fb00b6e).has(key) ? {
            type: false
        } : valueTransition));
        const animation = value.animation;
        if ((0, $2d5ab3a3cea3faff$export$98397f3adbf6259f)(willChange)) {
            willChange.add(key);
            animation.then(()=>willChange.remove(key));
        }
        animations.push(animation);
    }
    if (transitionEnd) Promise.all(animations).then(()=>{
        transitionEnd && (0, $ce7c85a117778f2d$export$1f61c53461aff4a5)(visualElement, transitionEnd);
    });
    return animations;
}




function $b2ec6cfe8850d01a$export$4709dc300705b2af(visualElement, variant, options = {}) {
    const resolved = (0, $7efa14736b19fa31$export$7b1b1c981f4f0558)(visualElement, variant, options.custom);
    let { transition: transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getAnimation = resolved ? ()=>Promise.all((0, $cf1b1579b00c1362$export$68cacfeee78d98d2)(visualElement, resolved, options)) : ()=>Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0)=>{
        const { delayChildren: delayChildren = 0, staggerChildren: staggerChildren, staggerDirection: staggerDirection } = transition;
        return $b2ec6cfe8850d01a$var$animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
    } : ()=>Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ const { when: when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ];
        return first().then(()=>last());
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
function $b2ec6cfe8850d01a$var$animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    const generateStaggerDuration = staggerDirection === 1 ? (i = 0)=>i * staggerChildren : (i = 0)=>maxStaggerDuration - i * staggerChildren;
    Array.from(visualElement.variantChildren).sort($b2ec6cfe8850d01a$export$523a0bedf33ad781).forEach((child, i)=>{
        child.notify("AnimationStart", variant);
        animations.push($b2ec6cfe8850d01a$export$4709dc300705b2af(child, variant, {
            ...options,
            delay: delayChildren + generateStaggerDuration(i)
        }).then(()=>child.notify("AnimationComplete", variant)));
    });
    return Promise.all(animations);
}
function $b2ec6cfe8850d01a$export$523a0bedf33ad781(a, b) {
    return a.sortNodePosition(b);
}


function $044d89b145201204$export$ff62cf473653f109(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant)=>(0, $b2ec6cfe8850d01a$export$4709dc300705b2af)(visualElement, variant, options));
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = (0, $b2ec6cfe8850d01a$export$4709dc300705b2af)(visualElement, definition, options);
    else {
        const resolvedDefinition = typeof definition === "function" ? (0, $7efa14736b19fa31$export$7b1b1c981f4f0558)(visualElement, definition, options.custom) : definition;
        animation = Promise.all((0, $cf1b1579b00c1362$export$68cacfeee78d98d2)(visualElement, resolvedDefinition, options));
    }
    return animation.then(()=>visualElement.notify("AnimationComplete", definition));
}


const $b079947979d34971$var$reversePriorityOrder = [
    ...(0, $db4213190228bc95$export$16e45afcc206d3a8)
].reverse();
const $b079947979d34971$var$numAnimationTypes = (0, $db4213190228bc95$export$16e45afcc206d3a8).length;
function $b079947979d34971$var$animateList(visualElement) {
    return (animations)=>Promise.all(animations.map(({ animation: animation, options: options })=>(0, $044d89b145201204$export$ff62cf473653f109)(visualElement, animation, options)));
}
function $b079947979d34971$export$bb53502b7a672aa8(visualElement) {
    let animate = $b079947979d34971$var$animateList(visualElement);
    const state = $b079947979d34971$var$createState();
    let isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ const buildResolvedTypeValues = (acc, definition)=>{
        const resolved = (0, $7efa14736b19fa31$export$7b1b1c981f4f0558)(visualElement, definition);
        if (resolved) {
            const { transition: transition, transitionEnd: transitionEnd, ...target } = resolved;
            acc = {
                ...acc,
                ...target,
                ...transitionEnd
            };
        }
        return acc;
    };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(options, changedActiveType) {
        const props = visualElement.getProps();
        const context = visualElement.getVariantContext(true) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(let i = 0; i < $b079947979d34971$var$numAnimationTypes; i++){
            const type = $b079947979d34971$var$reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = (0, $33e95f2e5351c1c0$export$720b90e312cea233)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */ if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = {
                ...encounteredKeys
            };
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $8941743539d0f878$export$aa71198ceeaf53ce)(prop) || typeof prop === "boolean") continue;
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ const variantDidChange = $b079947979d34971$export$68651800594fd43c(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ const definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ let resolvedValues = definitionList.reduce(buildResolvedTypeValues, {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ const { prevResolvedValues: prevResolvedValues = {} } = typeState;
            const allKeys = {
                ...prevResolvedValues,
                ...resolvedValues
            };
            const markToAnimate = (key)=>{
                shouldAnimateType = true;
                removedKeys.delete(key);
                typeState.needsAnimating[key] = true;
            };
            for(const key in allKeys){
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ if (next !== prev) {
                    /**
                     * If both values are keyframes, we need to shallow compare them to
                     * detect whether any value has changed. If it has, we animate it.
                     */ if ((0, $0d0309bb748c55b8$export$9153ad4c4999f4a0)(next) && (0, $0d0309bb748c55b8$export$9153ad4c4999f4a0)(prev)) {
                        if (!(0, $265fdbc950bad8ff$export$90e866afbd6b9f1a)(next, prev) || variantDidChange) markToAnimate(key);
                        else /**
                             * If it hasn't changed, we want to ensure it doesn't animate by
                             * adding it to the list of protected keys.
                             */ typeState.protectedKeys[key] = true;
                    } else if (next !== undefined) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */ if (typeState.isActive) encounteredKeys = {
                ...encounteredKeys,
                ...resolvedValues
            };
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to hard-block animations
             * TODO: Test as this should probably still handle animations triggered
             * by removed values?
             */ if (shouldAnimateType && !isInherited) animations.push(...definitionList.map((animation)=>({
                    animation: animation,
                    options: {
                        type: type,
                        ...options
                    }
                })));
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            const fallbackAnimation = {};
            removedKeys.forEach((key)=>{
                const fallbackTarget = visualElement.getBaseTarget(key);
                if (fallbackTarget !== undefined) fallbackAnimation[key] = fallbackTarget;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender && props.initial === false && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive, options) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach((child)=>{
            var _a;
            return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        const animations = animateChanges(options, type);
        for(const key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: ()=>state
    };
}
function $b079947979d34971$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, $265fdbc950bad8ff$export$90e866afbd6b9f1a)(next, prev);
    return false;
}
function $b079947979d34971$var$createTypeState(isActive = false) {
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $b079947979d34971$var$createState() {
    return {
        animate: $b079947979d34971$var$createTypeState(true),
        whileInView: $b079947979d34971$var$createTypeState(),
        whileHover: $b079947979d34971$var$createTypeState(),
        whileTap: $b079947979d34971$var$createTypeState(),
        whileDrag: $b079947979d34971$var$createTypeState(),
        whileFocus: $b079947979d34971$var$createTypeState(),
        exit: $b079947979d34971$var$createTypeState()
    };
}



class $bdfce0176f2f6e54$export$b45b3fe5caabdca extends (0, $2bff128c5f01d94e$export$6e91cf7616333d5) {
    /**
     * We dynamically generate the AnimationState manager as it contains a reference
     * to the underlying animation library. We only want to load that if we load this,
     * so people can optionally code split it out using the `m` component.
     */ constructor(node){
        super(node);
        node.animationState || (node.animationState = (0, $b079947979d34971$export$bb53502b7a672aa8)(node));
    }
    updateAnimationControlsSubscription() {
        const { animate: animate } = this.node.getProps();
        this.unmount();
        if ((0, $8941743539d0f878$export$aa71198ceeaf53ce)(animate)) this.unmount = animate.subscribe(this.node);
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */ mount() {
        this.updateAnimationControlsSubscription();
    }
    update() {
        const { animate: animate } = this.node.getProps();
        const { animate: prevAnimate } = this.node.prevProps || {};
        if (animate !== prevAnimate) this.updateAnimationControlsSubscription();
    }
    unmount() {}
}



let $b0455ce46319afbf$var$id = 0;
class $b0455ce46319afbf$export$4989d1eb6104cc6c extends (0, $2bff128c5f01d94e$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.id = $b0455ce46319afbf$var$id++;
    }
    update() {
        if (!this.node.presenceContext) return;
        const { isPresent: isPresent, onExitComplete: onExitComplete, custom: custom } = this.node.presenceContext;
        const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
        if (!this.node.animationState || isPresent === prevIsPresent) return;
        const exitAnimation = this.node.animationState.setActive("exit", !isPresent, {
            custom: custom !== null && custom !== void 0 ? custom : this.node.getProps().custom
        });
        if (onExitComplete && !isPresent) exitAnimation.then(()=>onExitComplete(this.id));
    }
    mount() {
        const { register: register } = this.node.presenceContext || {};
        if (register) this.unmount = register(this.id);
    }
    unmount() {}
}


const $e2d1ec617b1ce2aa$export$7f9953c70dacfd7f = {
    animation: {
        Feature: (0, $bdfce0176f2f6e54$export$b45b3fe5caabdca)
    },
    exit: {
        Feature: (0, $b0455ce46319afbf$export$4989d1eb6104cc6c)
    }
};









const $7876cfdf9a80cd24$export$9f17032d917177de = (a, b)=>Math.abs(a - b);
function $7876cfdf9a80cd24$export$503a1d513f12e38b(a, b) {
    // Multi-dimensional
    const xDelta = $7876cfdf9a80cd24$export$9f17032d917177de(a.x, b.x);
    const yDelta = $7876cfdf9a80cd24$export$9f17032d917177de(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}




/**
 * @internal
 */ class $cbf74c09179d2213$export$d9c66232c9c4689c {
    constructor(event, handlers, { transformPagePoint: transformPagePoint } = {}){
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        this.updatePoint = ()=>{
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const info = $cbf74c09179d2213$var$getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            const isDistancePastThreshold = (0, $7876cfdf9a80cd24$export$503a1d513f12e38b)(info.offset, {
                x: 0,
                y: 0
            }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold) return;
            const { point: point } = info;
            const { timestamp: timestamp } = (0, $1abd9a21e276f8f7$export$fff89137e9e818ce);
            this.history.push({
                ...point,
                timestamp: timestamp
            });
            const { onStart: onStart, onMove: onMove } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info)=>{
            this.lastMoveEvent = event;
            this.lastMoveEventInfo = $cbf74c09179d2213$var$transformPoint(info, this.transformPagePoint);
            // Throttle mouse move event to once per frame
            (0, $1abd9a21e276f8f7$export$2cef06c20297c17d).update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info)=>{
            this.end();
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const { onEnd: onEnd, onSessionEnd: onSessionEnd } = this.handlers;
            const panInfo = $cbf74c09179d2213$var$getPanInfo(event.type === "pointercancel" ? this.lastMoveEventInfo : $cbf74c09179d2213$var$transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!(0, $df317c8f51249b7a$export$a4cf9c8a4b063a6e)(event)) return;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        const info = (0, $24dec86077a8e170$export$12f84bb882d06e1a)(event);
        const initialInfo = $cbf74c09179d2213$var$transformPoint(info, this.transformPagePoint);
        const { point: point } = initialInfo;
        const { timestamp: timestamp } = (0, $1abd9a21e276f8f7$export$fff89137e9e818ce);
        this.history = [
            {
                ...point,
                timestamp: timestamp
            }
        ];
        const { onSessionStart: onSessionStart } = handlers;
        onSessionStart && onSessionStart(event, $cbf74c09179d2213$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $0a4e85080bbf1ab0$export$a4627e546088548d)((0, $ab731bc0caef970f$export$fcff2e64e6676b81)(window, "pointermove", this.handlePointerMove), (0, $ab731bc0caef970f$export$fcff2e64e6676b81)(window, "pointerup", this.handlePointerUp), (0, $ab731bc0caef970f$export$fcff2e64e6676b81)(window, "pointercancel", this.handlePointerUp));
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        (0, $1abd9a21e276f8f7$export$ec99c0ef4978dccb)(this.updatePoint);
    }
}
function $cbf74c09179d2213$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $cbf74c09179d2213$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $cbf74c09179d2213$var$getPanInfo({ point: point }, history) {
    return {
        point: point,
        delta: $cbf74c09179d2213$var$subtractPoint(point, $cbf74c09179d2213$var$lastDevicePoint(history)),
        offset: $cbf74c09179d2213$var$subtractPoint(point, $cbf74c09179d2213$var$startDevicePoint(history)),
        velocity: $cbf74c09179d2213$var$getVelocity(history, 0.1)
    };
}
function $cbf74c09179d2213$var$startDevicePoint(history) {
    return history[0];
}
function $cbf74c09179d2213$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $cbf74c09179d2213$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = $cbf74c09179d2213$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $2d38dea89524a236$export$fc3e7e8557f8c8c7)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    const time = (0, $2d38dea89524a236$export$f64c3bfbc58eec0f)(lastPoint.timestamp - timestampedPoint.timestamp);
    if (time === 0) return {
        x: 0,
        y: 0
    };
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}







function $fb864feed65dd055$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $fb864feed65dd055$export$28d0384c4b79bde2(value, target = 0, maxDistance = 0.01) {
    return Math.abs(value - target) <= maxDistance;
}
function $fb864feed65dd055$export$e90fc1ae5e3e48ed(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = (0, $523387644f7b98c2$export$2c9e8a9632a706b2)(source.min, source.max, delta.origin);
    delta.scale = $fb864feed65dd055$export$c1c127004b72a37(target) / $fb864feed65dd055$export$c1c127004b72a37(source);
    if ($fb864feed65dd055$export$28d0384c4b79bde2(delta.scale, 1, 0.0001) || isNaN(delta.scale)) delta.scale = 1;
    delta.translate = (0, $523387644f7b98c2$export$2c9e8a9632a706b2)(target.min, target.max, delta.origin) - delta.originPoint;
    if ($fb864feed65dd055$export$28d0384c4b79bde2(delta.translate) || isNaN(delta.translate)) delta.translate = 0;
}
function $fb864feed65dd055$export$c0d25e96fc67d310(delta, source, target, origin) {
    $fb864feed65dd055$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin ? origin.originX : undefined);
    $fb864feed65dd055$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function $fb864feed65dd055$export$cabef5b392704b41(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + $fb864feed65dd055$export$c1c127004b72a37(relative);
}
function $fb864feed65dd055$export$426154f9d100f99(target, relative, parent) {
    $fb864feed65dd055$export$cabef5b392704b41(target.x, relative.x, parent.x);
    $fb864feed65dd055$export$cabef5b392704b41(target.y, relative.y, parent.y);
}
function $fb864feed65dd055$export$ecd3d3bef81102c3(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + $fb864feed65dd055$export$c1c127004b72a37(layout);
}
function $fb864feed65dd055$export$2785bfcc929c5650(target, layout, parent) {
    $fb864feed65dd055$export$ecd3d3bef81102c3(target.x, layout.x, parent.x);
    $fb864feed65dd055$export$ecd3d3bef81102c3(target.y, layout.y, parent.y);
}




/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $d33855b3a8b91f10$export$b3c764d3fca3ffe3(point, { min: min, max: max }, elastic) {
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $523387644f7b98c2$export$2c9e8a9632a706b2)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $523387644f7b98c2$export$2c9e8a9632a706b2)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $d33855b3a8b91f10$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $d33855b3a8b91f10$export$4e9195bf7793bc78(layoutBox, { top: top, left: left, bottom: bottom, right: right }) {
    return {
        x: $d33855b3a8b91f10$export$690c180aa5775042(layoutBox.x, left, right),
        y: $d33855b3a8b91f10$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $d33855b3a8b91f10$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) [min, max] = [
        max,
        min
    ];
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $d33855b3a8b91f10$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $d33855b3a8b91f10$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $d33855b3a8b91f10$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $d33855b3a8b91f10$export$13abbfca044ca46d(source, target) {
    let origin = 0.5;
    const sourceLength = (0, $fb864feed65dd055$export$c1c127004b72a37)(source);
    const targetLength = (0, $fb864feed65dd055$export$c1c127004b72a37)(target);
    if (targetLength > sourceLength) origin = (0, $22a0644f7d6d6502$export$504d7abb21fa8c9)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $22a0644f7d6d6502$export$504d7abb21fa8c9)(source.min, source.max - targetLength, target.min);
    return (0, $e6730597558a14cb$export$7d15b64cf5a3a4c4)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $d33855b3a8b91f10$export$e9672cc4c36a8b87(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
const $d33855b3a8b91f10$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $d33855b3a8b91f10$export$7c5eaef8f4723d22(dragElastic = $d33855b3a8b91f10$export$a3366d3bac43a742) {
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $d33855b3a8b91f10$export$a3366d3bac43a742;
    return {
        x: $d33855b3a8b91f10$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $d33855b3a8b91f10$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $d33855b3a8b91f10$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $d33855b3a8b91f10$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $d33855b3a8b91f10$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $d33855b3a8b91f10$export$bbbc10b82e6c0afb(dragElastic, label) {
    return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}


const $200bf4b8ec180084$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $200bf4b8ec180084$export$3d227df54007d73a = ()=>({
        x: $200bf4b8ec180084$export$ff25708b37f72782(),
        y: $200bf4b8ec180084$export$ff25708b37f72782()
    });
const $200bf4b8ec180084$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $200bf4b8ec180084$export$6459fc9e86be362e = ()=>({
        x: $200bf4b8ec180084$export$6db76765312617ac(),
        y: $200bf4b8ec180084$export$6db76765312617ac()
    });


function $5821f44b6b7dbf7a$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}


/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $58f6fb935053526e$export$d3955c6a8f65a36b({ top: top, left: left, right: right, bottom: bottom }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $58f6fb935053526e$export$b6b9cd4198191a47({ x: x, y: y }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $58f6fb935053526e$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}



function $9a0da4f30a85b12c$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $9a0da4f30a85b12c$export$bdf30dca883ea463({ scale: scale, scaleX: scaleX, scaleY: scaleY }) {
    return !$9a0da4f30a85b12c$var$isIdentityScale(scale) || !$9a0da4f30a85b12c$var$isIdentityScale(scaleX) || !$9a0da4f30a85b12c$var$isIdentityScale(scaleY);
}
function $9a0da4f30a85b12c$export$a545127cf1fbb600(values) {
    return $9a0da4f30a85b12c$export$bdf30dca883ea463(values) || $9a0da4f30a85b12c$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY;
}
function $9a0da4f30a85b12c$export$bf80f5f8f4dc327f(values) {
    return $9a0da4f30a85b12c$var$is2DTranslate(values.x) || $9a0da4f30a85b12c$var$is2DTranslate(values.y);
}
function $9a0da4f30a85b12c$var$is2DTranslate(value) {
    return value && value !== "0%";
}


/**
 * Scales a point based on a factor and an originPoint
 */ function $f3e92f72e92b4bea$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $f3e92f72e92b4bea$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $f3e92f72e92b4bea$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $f3e92f72e92b4bea$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $f3e92f72e92b4bea$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $f3e92f72e92b4bea$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $f3e92f72e92b4bea$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $f3e92f72e92b4bea$export$d80074982803af5c(box, { x: x, y: y }) {
    $f3e92f72e92b4bea$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $f3e92f72e92b4bea$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $f3e92f72e92b4bea$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const instance = node.instance;
        if (instance && instance.style && instance.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $f3e92f72e92b4bea$export$58b16271041fbfb(box, {
            x: -node.scroll.offset.x,
            y: -node.scroll.offset.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $f3e92f72e92b4bea$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $9a0da4f30a85b12c$export$a545127cf1fbb600)(node.latestValues)) $f3e92f72e92b4bea$export$58b16271041fbfb(box, node.latestValues);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ treeScale.x = $f3e92f72e92b4bea$var$snapToDefault(treeScale.x);
    treeScale.y = $f3e92f72e92b4bea$var$snapToDefault(treeScale.y);
}
function $f3e92f72e92b4bea$var$snapToDefault(scale) {
    if (Number.isInteger(scale)) return scale;
    return scale > 1.0000000000001 || scale < 0.999999999999 ? scale : 1;
}
function $f3e92f72e92b4bea$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $f3e92f72e92b4bea$export$625f1dd140a2f5e7(axis, transforms, [key, scaleKey, originKey]) {
    const axisOrigin = transforms[originKey] !== undefined ? transforms[originKey] : 0.5;
    const originPoint = (0, $523387644f7b98c2$export$2c9e8a9632a706b2)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $f3e92f72e92b4bea$export$e8e3a712e9ebf422(axis, transforms[key], transforms[scaleKey], originPoint, transforms.scale);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $f3e92f72e92b4bea$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $f3e92f72e92b4bea$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $f3e92f72e92b4bea$export$58b16271041fbfb(box, transform) {
    $f3e92f72e92b4bea$export$625f1dd140a2f5e7(box.x, transform, $f3e92f72e92b4bea$var$xKeys);
    $f3e92f72e92b4bea$export$625f1dd140a2f5e7(box.y, transform, $f3e92f72e92b4bea$var$yKeys);
}


function $809eff0c312625c3$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $58f6fb935053526e$export$d3955c6a8f65a36b)((0, $58f6fb935053526e$export$21543fb75483a50)(instance.getBoundingClientRect(), transformPoint));
}
function $809eff0c312625c3$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $809eff0c312625c3$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll } = rootProjectionNode;
    if (scroll) {
        (0, $f3e92f72e92b4bea$export$a807a5ce5ebb3895)(viewportBox.x, scroll.offset.x);
        (0, $f3e92f72e92b4bea$export$a807a5ce5ebb3895)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}










const $6938cb4e7db70676$export$f0a15892c27dc07c = new WeakMap();
/**
 *
 */ // let latestPointerEvent: PointerEvent
class $6938cb4e7db70676$export$86bff71f18910307 {
    constructor(visualElement){
        // This is a reference to the global drag gesture lock, ensuring only one component
        // can "capture" the drag of one or both axes.
        // TODO: Look into moving this into pansession?
        this.openGlobalLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $200bf4b8ec180084$export$6459fc9e86be362e)();
        this.visualElement = visualElement;
    }
    start(originEvent, { snapToCursor: snapToCursor = false } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */ const { presenceContext: presenceContext } = this.visualElement;
        if (presenceContext && presenceContext.isPresent === false) return;
        const onSessionStart = (event)=>{
            // Stop any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            this.stopAnimation();
            if (snapToCursor) this.snapToCursor((0, $24dec86077a8e170$export$12f84bb882d06e1a)(event, "page").point);
        };
        const onStart = (event, info)=>{
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag: drag, dragPropagation: dragPropagation, onDragStart: onDragStart } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openGlobalLock) this.openGlobalLock();
                this.openGlobalLock = (0, $29a887a49c5e1406$export$2b7959ed03c1a3fe)(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openGlobalLock) return;
            }
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */ (0, $5821f44b6b7dbf7a$export$b789de563eb43b1)((axis)=>{
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, $ecde22e9cf283015$export$626336c2cd4b14de).test(current)) {
                    const { projection: projection } = this.visualElement;
                    if (projection && projection.layout) {
                        const measuredAxis = projection.layout.layoutBox[axis];
                        if (measuredAxis) {
                            const length = (0, $fb864feed65dd055$export$c1c127004b72a37)(measuredAxis);
                            current = length * (parseFloat(current) / 100);
                        }
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            if (onDragStart) (0, $1abd9a21e276f8f7$export$2cef06c20297c17d).update(()=>onDragStart(event, info), false, true);
            const { animationState: animationState } = this.visualElement;
            animationState && animationState.setActive("whileDrag", true);
        };
        const onMove = (event, info)=>{
            // latestPointerEvent = event
            const { dragPropagation: dragPropagation, dragDirectionLock: dragDirectionLock, onDirectionLock: onDirectionLock, onDrag: onDrag } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openGlobalLock) return;
            const { offset: offset } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = $6938cb4e7db70676$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) onDirectionLock && onDirectionLock(this.currentDirection);
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */ onDrag && onDrag(event, info);
        };
        const onSessionEnd = (event, info)=>this.stop(event, info);
        this.panSession = new (0, $cbf74c09179d2213$export$d9c66232c9c4689c)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint()
        });
    }
    stop(event, info) {
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging) return;
        const { velocity: velocity } = info;
        this.startAnimation(velocity);
        const { onDragEnd: onDragEnd } = this.getProps();
        if (onDragEnd) (0, $1abd9a21e276f8f7$export$2cef06c20297c17d).update(()=>onDragEnd(event, info));
    }
    cancel() {
        this.isDragging = false;
        const { projection: projection, animationState: animationState } = this.visualElement;
        if (projection) projection.isAnimationBlocked = false;
        this.panSession && this.panSession.end();
        this.panSession = undefined;
        const { dragPropagation: dragPropagation } = this.getProps();
        if (!dragPropagation && this.openGlobalLock) {
            this.openGlobalLock();
            this.openGlobalLock = null;
        }
        animationState && animationState.setActive("whileDrag", false);
    }
    updateAxis(axis, _point, offset) {
        const { drag: drag } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !$6938cb4e7db70676$var$shouldDrag(axis, drag, this.currentDirection)) return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, $d33855b3a8b91f10$export$b3c764d3fca3ffe3)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    }
    resolveConstraints() {
        const { dragConstraints: dragConstraints, dragElastic: dragElastic } = this.getProps();
        const { layout: layout } = this.visualElement.projection || {};
        const prevConstraints = this.constraints;
        if (dragConstraints && (0, $8bac730267ed8b61$export$dedd81df7bc1307)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, $d33855b3a8b91f10$export$4e9195bf7793bc78)(layout.layoutBox, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $d33855b3a8b91f10$export$7c5eaef8f4723d22)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) (0, $5821f44b6b7dbf7a$export$b789de563eb43b1)((axis)=>{
            if (this.getAxisMotionValue(axis)) this.constraints[axis] = (0, $d33855b3a8b91f10$export$e9672cc4c36a8b87)(layout.layoutBox[axis], this.constraints[axis]);
        });
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints, onMeasureDragConstraints: onMeasureDragConstraints } = this.getProps();
        if (!constraints || !(0, $8bac730267ed8b61$export$dedd81df7bc1307)(constraints)) return false;
        const constraintsElement = constraints.current;
        (0, $bcebfc2a15d8948d$export$f5708dca728d7177)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        const { projection: projection } = this.visualElement;
        // TODO
        if (!projection || !projection.layout) return false;
        const constraintsBox = (0, $809eff0c312625c3$export$6a597be7a7940a96)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = (0, $d33855b3a8b91f10$export$4228500f19d4cdf7)(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints((0, $58f6fb935053526e$export$b6b9cd4198191a47)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $58f6fb935053526e$export$d3955c6a8f65a36b)(userConstraints);
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag: drag, dragMomentum: dragMomentum, dragElastic: dragElastic, dragTransition: dragTransition, dragSnapToOrigin: dragSnapToOrigin, onDragTransitionEnd: onDragTransitionEnd } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = (0, $5821f44b6b7dbf7a$export$b789de563eb43b1)((axis)=>{
            if (!$6938cb4e7db70676$var$shouldDrag(axis, drag, this.currentDirection)) return;
            let transition = constraints && constraints[axis] || {};
            if (dragSnapToOrigin) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = {
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10,
                ...dragTransition,
                ...transition
            };
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        return axisValue.start((0, $567a733505d98c06$export$90b3dfc33ff3548)(axis, axisValue, 0, transition));
    }
    stopAnimation() {
        (0, $5821f44b6b7dbf7a$export$b789de563eb43b1)((axis)=>this.getAxisMotionValue(axis).stop());
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ getAxisMotionValue(axis) {
        const dragKey = "_drag" + axis.toUpperCase();
        const props = this.visualElement.getProps();
        const externalMotionValue = props[dragKey];
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : undefined) || 0);
    }
    snapToCursor(point) {
        (0, $5821f44b6b7dbf7a$export$b789de563eb43b1)((axis)=>{
            const { drag: drag } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!$6938cb4e7db70676$var$shouldDrag(axis, drag, this.currentDirection)) return;
            const { projection: projection } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min: min, max: max } = projection.layout.layoutBox[axis];
                axisValue.set(point[axis] - (0, $523387644f7b98c2$export$2c9e8a9632a706b2)(min, max, 0.5));
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ scalePositionWithinConstraints() {
        if (!this.visualElement.current) return;
        const { drag: drag, dragConstraints: dragConstraints } = this.getProps();
        const { projection: projection } = this.visualElement;
        if (!(0, $8bac730267ed8b61$export$dedd81df7bc1307)(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ const boxProgress = {
            x: 0,
            y: 0
        };
        (0, $5821f44b6b7dbf7a$export$b789de563eb43b1)((axis)=>{
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue) {
                const latest = axisValue.get();
                boxProgress[axis] = (0, $d33855b3a8b91f10$export$13abbfca044ca46d)({
                    min: latest,
                    max: latest
                }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ const { transformTemplate: transformTemplate } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        projection.root && projection.root.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, $5821f44b6b7dbf7a$export$b789de563eb43b1)((axis)=>{
            if (!$6938cb4e7db70676$var$shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ const axisValue = this.getAxisMotionValue(axis);
            const { min: min, max: max } = this.constraints[axis];
            axisValue.set((0, $523387644f7b98c2$export$2c9e8a9632a706b2)(min, max, boxProgress[axis]));
        });
    }
    addListeners() {
        if (!this.visualElement.current) return;
        $6938cb4e7db70676$export$f0a15892c27dc07c.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ const stopPointerListener = (0, $ab731bc0caef970f$export$fcff2e64e6676b81)(element, "pointerdown", (event)=>{
            const { drag: drag, dragListener: dragListener = true } = this.getProps();
            drag && dragListener && this.start(event);
        });
        const measureDragConstraints = ()=>{
            const { dragConstraints: dragConstraints } = this.getProps();
            if ((0, $8bac730267ed8b61$export$dedd81df7bc1307)(dragConstraints)) this.constraints = this.resolveRefConstraints();
        };
        const { projection: projection } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            projection.root && projection.root.updateScroll();
            projection.updateLayout();
        }
        measureDragConstraints();
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ const stopResizeListener = (0, $105610e7777eba77$export$b1d829ddf82884aa)(window, "resize", ()=>this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged })=>{
            if (this.isDragging && hasLayoutChanged) {
                (0, $5821f44b6b7dbf7a$export$b789de563eb43b1)((axis)=>{
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        });
        return ()=>{
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener && stopLayoutUpdateListener();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag: drag = false, dragDirectionLock: dragDirectionLock = false, dragPropagation: dragPropagation = false, dragConstraints: dragConstraints = false, dragElastic: dragElastic = (0, $d33855b3a8b91f10$export$a3366d3bac43a742), dragMomentum: dragMomentum = true } = props;
        return {
            ...props,
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        };
    }
}
function $6938cb4e7db70676$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $6938cb4e7db70676$var$getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}


class $5a76b16e61ca02d1$export$5d97dc2872682820 extends (0, $2bff128c5f01d94e$export$6e91cf7616333d5) {
    constructor(node){
        super(node);
        this.removeGroupControls = (0, $6c31de3ed15607ce$export$8793edee2d425525);
        this.removeListeners = (0, $6c31de3ed15607ce$export$8793edee2d425525);
        this.controls = new (0, $6938cb4e7db70676$export$86bff71f18910307)(node);
    }
    mount() {
        // If we've been provided a DragControls for manual control over the drag gesture,
        // subscribe this component to it on mount.
        const { dragControls: dragControls } = this.node.getProps();
        if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
        this.removeListeners = this.controls.addListeners() || (0, $6c31de3ed15607ce$export$8793edee2d425525);
    }
    unmount() {
        this.removeGroupControls();
        this.removeListeners();
    }
}







const $01cacad67cb03fed$var$asyncHandler = (handler)=>(event, info)=>{
        if (handler) (0, $1abd9a21e276f8f7$export$2cef06c20297c17d).update(()=>handler(event, info));
    };
class $01cacad67cb03fed$export$b4f8f1ee75ce5859 extends (0, $2bff128c5f01d94e$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.removePointerDownListener = (0, $6c31de3ed15607ce$export$8793edee2d425525);
    }
    onPointerDown(pointerDownEvent) {
        this.session = new (0, $cbf74c09179d2213$export$d9c66232c9c4689c)(pointerDownEvent, this.createPanHandlers(), {
            transformPagePoint: this.node.getTransformPagePoint()
        });
    }
    createPanHandlers() {
        const { onPanSessionStart: onPanSessionStart, onPanStart: onPanStart, onPan: onPan, onPanEnd: onPanEnd } = this.node.getProps();
        return {
            onSessionStart: $01cacad67cb03fed$var$asyncHandler(onPanSessionStart),
            onStart: $01cacad67cb03fed$var$asyncHandler(onPanStart),
            onMove: onPan,
            onEnd: (event, info)=>{
                delete this.session;
                if (onPanEnd) (0, $1abd9a21e276f8f7$export$2cef06c20297c17d).update(()=>onPanEnd(event, info));
            }
        };
    }
    mount() {
        this.removePointerDownListener = (0, $ab731bc0caef970f$export$fcff2e64e6676b81)(this.node.current, "pointerdown", (event)=>this.onPointerDown(event));
    }
    update() {
        this.session && this.session.updateHandlers(this.createPanHandlers());
    }
    unmount() {
        this.removePointerDownListener();
        this.session && this.session.end();
    }
}



var $8NFma = parcelRequire("8NFma");

var $8NFma = parcelRequire("8NFma");

/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $72a6fd105f9d64db$export$2a8c16d82a0a0e26() {
    const context = (0, $8NFma.useContext)((0, $7a24fabcbe07cfd9$export$f224e4635b6f8ce2));
    if (context === null) return [
        true,
        null
    ];
    const { isPresent: isPresent, onExitComplete: onExitComplete, register: register } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    const id = (0, $8NFma.useId)();
    (0, $8NFma.useEffect)(()=>register(id), []);
    const safeToRemove = ()=>onExitComplete && onExitComplete(id);
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $72a6fd105f9d64db$export$8249053f690ea39a() {
    return $72a6fd105f9d64db$export$ee27c052bca048fb((0, $8NFma.useContext)((0, $7a24fabcbe07cfd9$export$f224e4635b6f8ce2)));
}
function $72a6fd105f9d64db$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}




/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ const $d0b38a53f0c16f11$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};



function $219d0b4f61267bfe$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ const $219d0b4f61267bfe$export$5eafb6257a5844c = {
    correct: (latest, node)=>{
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $ecde22e9cf283015$export$91c0eda1d06bf008).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ const x = $219d0b4f61267bfe$export$fafff692be55225d(latest, node.target.x);
        const y = $219d0b4f61267bfe$export$fafff692be55225d(latest, node.target.y);
        return `${x}% ${y}%`;
    }
};




const $45e8e283fc0f518c$export$eb0bc629e74dcf8 = {
    correct: (latest, { treeScale: treeScale, projectionDelta: projectionDelta })=>{
        const original = latest;
        const shadow = (0, $0f730cf17d9cdef4$export$83a0e34f1302825b).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        const template = (0, $0f730cf17d9cdef4$export$83a0e34f1302825b).createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ const averageScale = (0, $523387644f7b98c2$export$2c9e8a9632a706b2)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        return template(shadow);
    }
};




class $bd8b833bea6eb6cd$var$MeasureLayoutWithContext extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ componentDidMount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: switchLayoutGroup, layoutId: layoutId } = this.props;
        const { projection: projection } = visualElement;
        (0, $4fdff83f42bd104a$export$de9e7791c71225fd)($bd8b833bea6eb6cd$var$defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup.group) layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) switchLayoutGroup.register(projection);
            projection.root.didUpdate();
            projection.addEventListener("animationComplete", ()=>{
                this.safeToRemove();
            });
            projection.setOptions({
                ...projection.options,
                onExitComplete: ()=>this.safeToRemove()
            });
        }
        (0, $d0b38a53f0c16f11$export$97db156a3ed1593b).hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency: layoutDependency, visualElement: visualElement, drag: drag, isPresent: isPresent } = this.props;
        const projection = visualElement.projection;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, $1abd9a21e276f8f7$export$2cef06c20297c17d).postRender(()=>{
                const stack = projection.getStack();
                if (!stack || !stack.members.length) this.safeToRemove();
            });
        }
        return null;
    }
    componentDidUpdate() {
        const { projection: projection } = this.props.visualElement;
        if (projection) {
            projection.root.didUpdate();
            queueMicrotask(()=>{
                if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
            });
        }
    }
    componentWillUnmount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: promoteContext } = this.props;
        const { projection: projection } = visualElement;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup && layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext && promoteContext.deregister) promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove: safeToRemove } = this.props;
        safeToRemove && safeToRemove();
    }
    render() {
        return null;
    }
}
function $bd8b833bea6eb6cd$export$779f5fb01ad751cd(props) {
    const [isPresent, safeToRemove] = (0, $72a6fd105f9d64db$export$2a8c16d82a0a0e26)();
    const layoutGroup = (0, $8NFma.useContext)((0, $1af765e09ca06198$export$a3579ca508007a95));
    return (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement($bd8b833bea6eb6cd$var$MeasureLayoutWithContext, {
        ...props,
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $8NFma.useContext)((0, $db7280e5d3034edc$export$da5f7b802957459a)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    });
}
const $bd8b833bea6eb6cd$var$defaultScaleCorrectors = {
    borderRadius: {
        ...(0, $219d0b4f61267bfe$export$5eafb6257a5844c),
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    },
    borderTopLeftRadius: (0, $219d0b4f61267bfe$export$5eafb6257a5844c),
    borderTopRightRadius: (0, $219d0b4f61267bfe$export$5eafb6257a5844c),
    borderBottomLeftRadius: (0, $219d0b4f61267bfe$export$5eafb6257a5844c),
    borderBottomRightRadius: (0, $219d0b4f61267bfe$export$5eafb6257a5844c),
    boxShadow: (0, $45e8e283fc0f518c$export$eb0bc629e74dcf8)
};








const $e613c751604bfffd$var$borders = [
    "TopLeft",
    "TopRight",
    "BottomLeft",
    "BottomRight"
];
const $e613c751604bfffd$var$numBorders = $e613c751604bfffd$var$borders.length;
const $e613c751604bfffd$var$asNumber = (value)=>typeof value === "string" ? parseFloat(value) : value;
const $e613c751604bfffd$var$isPx = (value)=>typeof value === "number" || (0, $ecde22e9cf283015$export$91c0eda1d06bf008).test(value);
function $e613c751604bfffd$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    if (shouldCrossfadeOpacity) {
        target.opacity = (0, $523387644f7b98c2$export$2c9e8a9632a706b2)(0, // TODO Reinstate this if only child
        lead.opacity !== undefined ? lead.opacity : 1, $e613c751604bfffd$var$easeCrossfadeIn(progress));
        target.opacityExit = (0, $523387644f7b98c2$export$2c9e8a9632a706b2)(follow.opacity !== undefined ? follow.opacity : 1, 0, $e613c751604bfffd$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $523387644f7b98c2$export$2c9e8a9632a706b2)(follow.opacity !== undefined ? follow.opacity : 1, lead.opacity !== undefined ? lead.opacity : 1, progress);
    /**
     * Mix border radius
     */ for(let i = 0; i < $e613c751604bfffd$var$numBorders; i++){
        const borderLabel = `border${$e613c751604bfffd$var$borders[i]}Radius`;
        let followRadius = $e613c751604bfffd$var$getRadius(follow, borderLabel);
        let leadRadius = $e613c751604bfffd$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 || leadRadius === 0 || $e613c751604bfffd$var$isPx(followRadius) === $e613c751604bfffd$var$isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, $523387644f7b98c2$export$2c9e8a9632a706b2)($e613c751604bfffd$var$asNumber(followRadius), $e613c751604bfffd$var$asNumber(leadRadius), progress), 0);
            if ((0, $ecde22e9cf283015$export$626336c2cd4b14de).test(leadRadius) || (0, $ecde22e9cf283015$export$626336c2cd4b14de).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $523387644f7b98c2$export$2c9e8a9632a706b2)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $e613c751604bfffd$var$getRadius(values, radiusName) {
    return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
const $e613c751604bfffd$var$easeCrossfadeIn = $e613c751604bfffd$var$compress(0, 0.5, (0, $fc6c39d65ec3a73f$export$c8d67a19199d1a50));
const $e613c751604bfffd$var$easeCrossfadeOut = $e613c751604bfffd$var$compress(0.5, 0.95, (0, $6c31de3ed15607ce$export$8793edee2d425525));
function $e613c751604bfffd$var$compress(min, max, easing) {
    return (p)=>{
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $22a0644f7d6d6502$export$504d7abb21fa8c9)(min, max, p));
    };
}


/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $038af85914793979$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $038af85914793979$export$c53fd88f45d77e4b(box, originBox) {
    $038af85914793979$export$a0230ae482601ae8(box.x, originBox.x);
    $038af85914793979$export$a0230ae482601ae8(box.y, originBox.y);
}







/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $4180e5c54cbe587b$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $f3e92f72e92b4bea$export$2290ec7febe36dd6)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $f3e92f72e92b4bea$export$2290ec7febe36dd6)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $4180e5c54cbe587b$export$cc12a0672fae5b4a(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if ((0, $ecde22e9cf283015$export$626336c2cd4b14de).test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = (0, $523387644f7b98c2$export$2c9e8a9632a706b2)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    let originPoint = (0, $523387644f7b98c2$export$2c9e8a9632a706b2)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $4180e5c54cbe587b$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $4180e5c54cbe587b$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $4180e5c54cbe587b$export$42b76f1d0d16d5b(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    $4180e5c54cbe587b$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $4180e5c54cbe587b$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $4180e5c54cbe587b$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $4180e5c54cbe587b$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $4180e5c54cbe587b$export$42b76f1d0d16d5b(box.x, transforms, $4180e5c54cbe587b$var$xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
    $4180e5c54cbe587b$export$42b76f1d0d16d5b(box.y, transforms, $4180e5c54cbe587b$var$yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}





function $da079738137e5883$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $da079738137e5883$export$a7ec7642fe550fb6(delta) {
    return $da079738137e5883$var$isAxisDeltaZero(delta.x) && $da079738137e5883$var$isAxisDeltaZero(delta.y);
}
function $da079738137e5883$export$8d5cf76bb7daff09(a, b) {
    return a.x.min === b.x.min && a.x.max === b.x.max && a.y.min === b.y.min && a.y.max === b.y.max;
}
function $da079738137e5883$export$ef641b782d85522(a, b) {
    return Math.round(a.x.min) === Math.round(b.x.min) && Math.round(a.x.max) === Math.round(b.x.max) && Math.round(a.y.min) === Math.round(b.y.min) && Math.round(a.y.max) === Math.round(b.y.max);
}
function $da079738137e5883$export$c5706146bc63213(box) {
    return (0, $fb864feed65dd055$export$c1c127004b72a37)(box.x) / (0, $fb864feed65dd055$export$c1c127004b72a37)(box.y);
}



class $24f866b0150d9faa$export$39be5b2d82fc9dc7 {
    constructor(){
        this.members = [];
    }
    add(node) {
        (0, $560e5a2c215d9315$export$20e507e47fae79fd)(this.members, node);
        node.scheduleRender();
    }
    remove(node) {
        (0, $560e5a2c215d9315$export$fe2d9b4e03920b4c)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    }
    relegate(node) {
        const indexOfNode = this.members.findIndex((member)=>node === member);
        if (indexOfNode === 0) return false;
        /**
         * Find the next projection node that is present
         */ let prevLead;
        for(let i = indexOfNode; i >= 0; i--){
            const member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        } else return false;
    }
    promote(node, preserveFollowOpacity) {
        const prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) node.resumeFrom.preserveOpacity = true;
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
            }
            if (node.root && node.root.isUpdating) node.isLayoutDirty = true;
            const { crossfade: crossfade } = node.options;
            if (crossfade === false) prevLead.hide();
        /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */ }
    }
    exitAnimationComplete() {
        this.members.forEach((node)=>{
            const { options: options, resumingFrom: resumingFrom } = node;
            options.onExitComplete && options.onExitComplete();
            if (resumingFrom) resumingFrom.options.onExitComplete && resumingFrom.options.onExitComplete();
        });
    }
    scheduleRender() {
        this.members.forEach((node)=>{
            node.instance && node.scheduleRender(false);
        });
    }
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */ removeLeadSnapshot() {
        if (this.lead && this.lead.snapshot) this.lead.snapshot = undefined;
    }
}



function $fcfd35f3fe9c231e$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    if (xTranslate || yTranslate) transform = `translate3d(${xTranslate}px, ${yTranslate}px, 0) `;
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ if (treeScale.x !== 1 || treeScale.y !== 1) transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    if (latestTransform) {
        const { rotate: rotate, rotateX: rotateX, rotateY: rotateY } = latestTransform;
        if (rotate) transform += `rotate(${rotate}deg) `;
        if (rotateX) transform += `rotateX(${rotateX}deg) `;
        if (rotateY) transform += `rotateY(${rotateY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) transform += `scale(${elementScaleX}, ${elementScaleY})`;
    return transform || "none";
}





const $ed8079a6941d6d1c$export$d689d9dec5ad338 = (a, b)=>a.depth - b.depth;


class $6703cd7d45a47598$export$1465d17e3de78a96 {
    constructor(){
        this.children = [];
        this.isDirty = false;
    }
    add(child) {
        (0, $560e5a2c215d9315$export$20e507e47fae79fd)(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        (0, $560e5a2c215d9315$export$fe2d9b4e03920b4c)(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort((0, $ed8079a6941d6d1c$export$d689d9dec5ad338));
        this.isDirty = false;
        this.children.forEach(callback);
    }
}





/**
 * Timeout defined in ms
 */ function $0c206a7020ff0297$export$1391212d75b2ee65(callback, timeout) {
    const start = performance.now();
    const checkElapsed = ({ timestamp: timestamp })=>{
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            (0, $1abd9a21e276f8f7$export$ec99c0ef4978dccb)(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    (0, $1abd9a21e276f8f7$export$2cef06c20297c17d).read(checkElapsed, true);
    return ()=>(0, $1abd9a21e276f8f7$export$ec99c0ef4978dccb)(checkElapsed);
}



function $3ff6d30fca957b1b$export$e5185e241753e543(data) {
    if (window.MotionDebug) window.MotionDebug.record(data);
}


function $260fc16a320c712e$export$17eda790a720ec57(element) {
    return element instanceof SVGElement && element.tagName !== "svg";
}





function $10847b8422ba7fe6$export$335a17c977067b99(value, keyframes, options) {
    const motionValue$1 = (0, $56c5f751f01a3bad$export$605d60a2578142d3)(value) ? value : (0, $33b71ad0065b86cf$export$ce8bdc721e76545f)(value);
    motionValue$1.start((0, $567a733505d98c06$export$90b3dfc33ff3548)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}





const $164a4e28765da53e$var$transformAxes = [
    "",
    "X",
    "Y",
    "Z"
];
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ const $164a4e28765da53e$var$animationTarget = 1000;
let $164a4e28765da53e$var$id = 0;
/**
 * Use a mutable data object for debug data so as to not create a new
 * object every frame.
 */ const $164a4e28765da53e$var$projectionFrameData = {
    type: "projectionFrame",
    totalNodes: 0,
    resolvedTargetDeltas: 0,
    recalculatedProjection: 0
};
function $164a4e28765da53e$export$a84b61f69daa9da0({ attachResizeListener: attachResizeListener, defaultParent: defaultParent, measureScroll: measureScroll, checkIsScrollRoot: checkIsScrollRoot, resetTransform: resetTransform }) {
    return class ProjectionNode {
        constructor(latestValues = {}, parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent()){
            /**
             * A unique ID generated for every projection node.
             */ this.id = $164a4e28765da53e$var$id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */ this.animationId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Flag to true if we think the projection calculations for this node needs
             * recalculating as a result of an updated transform or layout animation.
             */ this.isProjectionDirty = false;
            /**
             * Flag to true if the layout *or* transform has changed. This then gets propagated
             * throughout the projection tree, forcing any element below to recalculate on the next frame.
             */ this.isSharedProjectionDirty = false;
            /**
             * Flag transform dirty. This gets propagated throughout the whole tree but is only
             * respected by shared nodes.
             */ this.isTransformDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            this.hasTreeAnimated = false;
            // Note: Currently only running on root node
            this.updateScheduled = false;
            this.checkUpdateFailed = ()=>{
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */ this.updateProjection = ()=>{
                /**
                 * Reset debug counts. Manually resetting rather than creating a new
                 * object each frame.
                 */ $164a4e28765da53e$var$projectionFrameData.totalNodes = $164a4e28765da53e$var$projectionFrameData.resolvedTargetDeltas = $164a4e28765da53e$var$projectionFrameData.recalculatedProjection = 0;
                this.nodes.forEach($164a4e28765da53e$export$131f2f0cc5fe9609);
                this.nodes.forEach($164a4e28765da53e$var$resolveTargetDelta);
                this.nodes.forEach($164a4e28765da53e$var$calcProjection);
                this.nodes.forEach($164a4e28765da53e$export$c2664f37bc951031);
                (0, $3ff6d30fca957b1b$export$e5185e241753e543)($164a4e28765da53e$var$projectionFrameData);
            };
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [
                ...parent.path,
                parent
            ] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            for(let i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $6703cd7d45a47598$export$1465d17e3de78a96)();
        }
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $a6375dce0ad778ec$export$e7dff9482a5fd23c)());
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager && subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        /**
         * Lifecycles
         */ mount(instance, isLayoutDirty = this.root.hasTreeAnimated) {
            if (this.instance) return;
            this.isSVG = (0, $260fc16a320c712e$export$17eda790a720ec57)(instance);
            this.instance = instance;
            const { layoutId: layoutId, layout: layout, visualElement: visualElement } = this.options;
            if (visualElement && !visualElement.current) visualElement.mount(instance);
            this.root.nodes.add(this);
            this.parent && this.parent.children.add(this);
            if (isLayoutDirty && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                let cancelDelay;
                const resizeUnblockUpdate = ()=>this.root.updateBlockedByResize = false;
                attachResizeListener(instance, ()=>{
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = (0, $0c206a7020ff0297$export$1391212d75b2ee65)(resizeUnblockUpdate, 250);
                    if ((0, $d0b38a53f0c16f11$export$97db156a3ed1593b).hasAnimatedSinceResize) {
                        (0, $d0b38a53f0c16f11$export$97db156a3ed1593b).hasAnimatedSinceResize = false;
                        this.nodes.forEach($164a4e28765da53e$var$finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged, hasRelativeTargetChanged: hasRelativeTargetChanged, layout: newLayout })=>{
                if (this.isTreeAnimationBlocked()) {
                    this.target = undefined;
                    this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                const layoutTransition = this.options.transition || visualElement.getDefaultTransition() || $164a4e28765da53e$var$defaultLayoutTransition;
                const { onLayoutAnimationStart: onLayoutAnimationStart, onLayoutAnimationComplete: onLayoutAnimationComplete } = visualElement.getProps();
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ const targetChanged = !this.targetLayout || !(0, $da079738137e5883$export$ef641b782d85522)(this.targetLayout, newLayout) || hasRelativeTargetChanged;
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
                if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || hasOnlyRelativeTargetChanged || hasLayoutChanged && (targetChanged || !this.currentAnimation)) {
                    if (this.resumeFrom) {
                        this.resumingFrom = this.resumeFrom;
                        this.resumingFrom.resumingFrom = undefined;
                    }
                    this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                    const animationOptions = {
                        ...(0, $805c9cc606559c5c$export$7c1391340308742e)(layoutTransition, "layout"),
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    };
                    if (visualElement.shouldReduceMotion || this.options.layoutRoot) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    this.startAnimation(animationOptions);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged) $164a4e28765da53e$var$finishAnimation(this);
                    if (this.isLead() && this.options.onExitComplete) this.options.onExitComplete();
                }
                this.targetLayout = newLayout;
            });
        }
        unmount() {
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            const stack = this.getStack();
            stack && stack.remove(this);
            this.parent && this.parent.children.delete(this);
            this.instance = undefined;
            (0, $1abd9a21e276f8f7$export$ec99c0ef4978dccb)(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
        }
        // Note: currently only running on root node
        startUpdate() {
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            this.nodes && this.nodes.forEach($164a4e28765da53e$var$resetRotation);
            this.animationId++;
        }
        getTransformTemplate() {
            const { visualElement: visualElement } = this.options;
            return visualElement && visualElement.getProps().transformTemplate;
        }
        willUpdate(shouldNotifyListeners = true) {
            this.root.hasTreeAnimated = true;
            if (this.root.isUpdateBlocked()) {
                this.options.onExitComplete && this.options.onExitComplete();
                return;
            }
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.shouldResetTransform = true;
                node.updateScroll("snapshot");
                if (node.options.layoutRoot) node.willUpdate(false);
            }
            const { layoutId: layoutId, layout: layout } = this.options;
            if (layoutId === undefined && !layout) return;
            const transformTemplate = this.getTransformTemplate();
            this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        update() {
            this.updateScheduled = false;
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach($164a4e28765da53e$var$clearMeasurements);
                return;
            }
            if (!this.isUpdating) this.nodes.forEach($164a4e28765da53e$var$clearIsLayoutDirty);
            this.isUpdating = false;
            /**
             * Write
             */ this.nodes.forEach($164a4e28765da53e$var$resetTransformStyle);
            /**
             * Read ==================
             */ // Update layout measurements of updated children
            this.nodes.forEach($164a4e28765da53e$var$updateLayout);
            /**
             * Write
             */ // Notify listeners that the layout is updated
            this.nodes.forEach($164a4e28765da53e$var$notifyLayoutUpdate);
            this.clearAllSnapshots();
            /**
             * Manually flush any pending updates. Ideally
             * we could leave this to the following requestAnimationFrame but this seems
             * to leave a flash of incorrectly styled content.
             */ const now = performance.now();
            (0, $1abd9a21e276f8f7$export$fff89137e9e818ce).delta = (0, $e6730597558a14cb$export$7d15b64cf5a3a4c4)(0, 1000 / 60, now - (0, $1abd9a21e276f8f7$export$fff89137e9e818ce).timestamp);
            (0, $1abd9a21e276f8f7$export$fff89137e9e818ce).timestamp = now;
            (0, $1abd9a21e276f8f7$export$fff89137e9e818ce).isProcessing = true;
            (0, $1abd9a21e276f8f7$export$be3f796aed065412).update.process((0, $1abd9a21e276f8f7$export$fff89137e9e818ce));
            (0, $1abd9a21e276f8f7$export$be3f796aed065412).preRender.process((0, $1abd9a21e276f8f7$export$fff89137e9e818ce));
            (0, $1abd9a21e276f8f7$export$be3f796aed065412).render.process((0, $1abd9a21e276f8f7$export$fff89137e9e818ce));
            (0, $1abd9a21e276f8f7$export$fff89137e9e818ce).isProcessing = false;
        }
        didUpdate() {
            if (!this.updateScheduled) {
                this.updateScheduled = true;
                queueMicrotask(()=>this.update());
            }
        }
        clearAllSnapshots() {
            this.nodes.forEach($164a4e28765da53e$var$clearSnapshot);
            this.sharedNodes.forEach($164a4e28765da53e$var$removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            (0, $1abd9a21e276f8f7$export$2cef06c20297c17d).preRender(this.updateProjection, false, true);
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $1abd9a21e276f8f7$export$2cef06c20297c17d).postRender(()=>{
                if (this.isLayoutDirty) this.root.didUpdate();
                else this.root.checkUpdateFailed();
            });
        }
        /**
         * Update measurements
         */ updateSnapshot() {
            if (this.snapshot || !this.instance) return;
            this.snapshot = this.measure();
        }
        updateLayout() {
            if (!this.instance) return;
            // TODO: Incorporate into a forwarded scroll offset
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.updateScroll();
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutCorrected = (0, $200bf4b8ec180084$export$6459fc9e86be362e)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            const { visualElement: visualElement } = this.options;
            visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) needsMeasurement = false;
            if (needsMeasurement) this.scroll = {
                animationId: this.root.animationId,
                phase: phase,
                isRoot: checkIsScrollRoot(this.instance),
                offset: measureScroll(this.instance)
            };
        }
        resetTransform() {
            if (!resetTransform) return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform;
            const hasProjection = this.projectionDelta && !(0, $da079738137e5883$export$a7ec7642fe550fb6)(this.projectionDelta);
            const transformTemplate = this.getTransformTemplate();
            const transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && (hasProjection || (0, $9a0da4f30a85b12c$export$a545127cf1fbb600)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */ if (removeTransform) layoutBox = this.removeTransform(layoutBox);
            $164a4e28765da53e$var$roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox: layoutBox,
                latestValues: {},
                source: this.id
            };
        }
        measurePageBox() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return (0, $200bf4b8ec180084$export$6459fc9e86be362e)();
            const box = visualElement.measureViewportBox();
            // Remove viewport scroll to give page-relative coordinates
            const { scroll: scroll } = this.root;
            if (scroll) {
                (0, $f3e92f72e92b4bea$export$a807a5ce5ebb3895)(box.x, scroll.offset.x);
                (0, $f3e92f72e92b4bea$export$a807a5ce5ebb3895)(box.y, scroll.offset.y);
            }
            return box;
        }
        removeElementScroll(box) {
            const boxWithoutScroll = (0, $200bf4b8ec180084$export$6459fc9e86be362e)();
            (0, $038af85914793979$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                const { scroll: scroll, options: options } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (scroll.isRoot) {
                        (0, $038af85914793979$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
                        const { scroll: rootScroll } = this.root;
                        /**
                         * Undo the application of page scroll that was originally added
                         * to the measured bounding box.
                         */ if (rootScroll) {
                            (0, $f3e92f72e92b4bea$export$a807a5ce5ebb3895)(boxWithoutScroll.x, -rootScroll.offset.x);
                            (0, $f3e92f72e92b4bea$export$a807a5ce5ebb3895)(boxWithoutScroll.y, -rootScroll.offset.y);
                        }
                    }
                    (0, $f3e92f72e92b4bea$export$a807a5ce5ebb3895)(boxWithoutScroll.x, scroll.offset.x);
                    (0, $f3e92f72e92b4bea$export$a807a5ce5ebb3895)(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false) {
            const withTransforms = (0, $200bf4b8ec180084$export$6459fc9e86be362e)();
            (0, $038af85914793979$export$c53fd88f45d77e4b)(withTransforms, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) (0, $f3e92f72e92b4bea$export$58b16271041fbfb)(withTransforms, {
                    x: -node.scroll.offset.x,
                    y: -node.scroll.offset.y
                });
                if (!(0, $9a0da4f30a85b12c$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $f3e92f72e92b4bea$export$58b16271041fbfb)(withTransforms, node.latestValues);
            }
            if ((0, $9a0da4f30a85b12c$export$a545127cf1fbb600)(this.latestValues)) (0, $f3e92f72e92b4bea$export$58b16271041fbfb)(withTransforms, this.latestValues);
            return withTransforms;
        }
        removeTransform(box) {
            const boxWithoutTransform = (0, $200bf4b8ec180084$export$6459fc9e86be362e)();
            (0, $038af85914793979$export$c53fd88f45d77e4b)(boxWithoutTransform, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!node.instance) continue;
                if (!(0, $9a0da4f30a85b12c$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $9a0da4f30a85b12c$export$bdf30dca883ea463)(node.latestValues) && node.updateSnapshot();
                const sourceBox = (0, $200bf4b8ec180084$export$6459fc9e86be362e)();
                const nodeBox = node.measurePageBox();
                (0, $038af85914793979$export$c53fd88f45d77e4b)(sourceBox, nodeBox);
                (0, $4180e5c54cbe587b$export$73e1ad0a9694e25c)(boxWithoutTransform, node.latestValues, node.snapshot ? node.snapshot.layoutBox : undefined, sourceBox);
            }
            if ((0, $9a0da4f30a85b12c$export$a545127cf1fbb600)(this.latestValues)) (0, $4180e5c54cbe587b$export$73e1ad0a9694e25c)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        }
        setTargetDelta(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
            this.isProjectionDirty = true;
        }
        setOptions(options) {
            this.options = {
                ...this.options,
                ...options,
                crossfade: options.crossfade !== undefined ? options.crossfade : true
            };
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        forceRelativeParentToResolveTarget() {
            if (!this.relativeParent) return;
            /**
             * If the parent target isn't up-to-date, force it to update.
             * This is an unfortunate de-optimisation as it means any updating relative
             * projection will cause all the relative parents to recalculate back
             * up the tree.
             */ if (this.relativeParent.resolvedRelativeTargetAt !== (0, $1abd9a21e276f8f7$export$fff89137e9e818ce).timestamp) this.relativeParent.resolveTargetDelta(true);
        }
        resolveTargetDelta(forceRecalculation = false) {
            var _a;
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */ const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */ const canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty) || this.attemptToResolveRelativeTarget);
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            this.resolvedRelativeTargetAt = (0, $1abd9a21e276f8f7$export$fff89137e9e818ce).timestamp;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ // TODO If this is unsuccessful this currently happens every frame
            if (!this.targetDelta && !this.relativeTarget) {
                // TODO: This is a semi-repetition of further down this function, make DRY
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && relativeParent.layout && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $200bf4b8ec180084$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $200bf4b8ec180084$export$6459fc9e86be362e)();
                    (0, $fb864feed65dd055$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
                    (0, $038af85914793979$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, $200bf4b8ec180084$export$6459fc9e86be362e)();
                this.targetWithTransforms = (0, $200bf4b8ec180084$export$6459fc9e86be362e)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
                this.forceRelativeParentToResolveTarget();
                (0, $fb864feed65dd055$export$426154f9d100f99)(this.target, this.relativeTarget, this.relativeParent.target);
            /**
                 * If we've only got a targetDelta, resolve it into a target
                 */ } else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) // TODO: This is creating a new object every frame
                this.target = this.applyTransform(this.layout.layoutBox);
                else (0, $038af85914793979$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
                (0, $f3e92f72e92b4bea$export$d80074982803af5c)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, $038af85914793979$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $200bf4b8ec180084$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $200bf4b8ec180084$export$6459fc9e86be362e)();
                    (0, $fb864feed65dd055$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.target, relativeParent.target);
                    (0, $038af85914793979$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * Increase debug counter for resolved target deltas
             */ $164a4e28765da53e$var$projectionFrameData.resolvedTargetDeltas++;
        }
        getClosestProjectingParent() {
            if (!this.parent || (0, $9a0da4f30a85b12c$export$bdf30dca883ea463)(this.parent.latestValues) || (0, $9a0da4f30a85b12c$export$bf80f5f8f4dc327f)(this.parent.latestValues)) return undefined;
            if (this.parent.isProjecting()) return this.parent;
            else return this.parent.getClosestProjectingParent();
        }
        isProjecting() {
            return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
        }
        calcProjection() {
            var _a;
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            /**
             * If this is a normal layout animation and neither this node nor its nearest projecting
             * is dirty then we can't skip.
             */ if (this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty)) canSkip = false;
            /**
             * If this is a shared layout animation and this node's shared projection is dirty then
             * we can't skip.
             */ if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) canSkip = false;
            /**
             * If we have resolved the target this frame we must recalculate the
             * projection to ensure it visually represents the internal calculations.
             */ if (this.resolvedRelativeTargetAt === (0, $1abd9a21e276f8f7$export$fff89137e9e818ce).timestamp) canSkip = false;
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $038af85914793979$export$c53fd88f45d77e4b)(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Record previous tree scales before updating.
             */ const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $f3e92f72e92b4bea$export$e2a980535c55eabb)(this.layoutCorrected, this.treeScale, this.path, isShared);
            /**
             * If this layer needs to perform scale correction but doesn't have a target,
             * use the layout as the target.
             */ if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) lead.target = lead.layout.layoutBox;
            const { target: target } = lead;
            if (!target) {
                /**
                 * If we don't have a target to project into, but we were previously
                 * projecting, we want to remove the stored transform and schedule
                 * a render to ensure the elements reflect the removed transform.
                 */ if (this.projectionTransform) {
                    this.projectionDelta = (0, $200bf4b8ec180084$export$3d227df54007d73a)();
                    this.projectionTransform = "none";
                    this.scheduleRender();
                }
                return;
            }
            if (!this.projectionDelta) {
                this.projectionDelta = (0, $200bf4b8ec180084$export$3d227df54007d73a)();
                this.projectionDeltaWithTransform = (0, $200bf4b8ec180084$export$3d227df54007d73a)();
            }
            const prevProjectionTransform = this.projectionTransform;
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $fb864feed65dd055$export$c0d25e96fc67d310)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            this.projectionTransform = (0, $fcfd35f3fe9c231e$export$d33653b270fe725c)(this.projectionDelta, this.treeScale);
            if (this.projectionTransform !== prevProjectionTransform || this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
            /**
             * Increase debug counter for recalculated projections
             */ $164a4e28765da53e$var$projectionFrameData.recalculatedProjection++;
        }
        hide() {
            this.isVisible = false;
        // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
        // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            this.options.scheduleRender && this.options.scheduleRender();
            if (notifyAll) {
                const stack = this.getStack();
                stack && stack.scheduleRender();
            }
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
            const snapshot = this.snapshot;
            const snapshotLatestValues = snapshot ? snapshot.latestValues : {};
            const mixedValues = {
                ...this.latestValues
            };
            const targetDelta = (0, $200bf4b8ec180084$export$3d227df54007d73a)();
            if (!this.relativeParent || !this.relativeParent.options.layoutRoot) this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = (0, $200bf4b8ec180084$export$6459fc9e86be362e)();
            const snapshotSource = snapshot ? snapshot.source : undefined;
            const layoutSource = this.layout ? this.layout.source : undefined;
            const isSharedLayoutAnimation = snapshotSource !== layoutSource;
            const stack = this.getStack();
            const isOnlyMember = !stack || stack.members.length <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($164a4e28765da53e$var$hasOpacityCrossfade));
            this.animationProgress = 0;
            let prevRelativeTarget;
            this.mixTargetDelta = (latest)=>{
                const progress = latest / 1000;
                $164a4e28765da53e$export$91dbf443e1bf1de1(targetDelta.x, delta.x, progress);
                $164a4e28765da53e$export$91dbf443e1bf1de1(targetDelta.y, delta.y, progress);
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout) {
                    (0, $fb864feed65dd055$export$2785bfcc929c5650)(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
                    $164a4e28765da53e$export$6ffd3e6ae339a132(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                    /**
                     * If this is an unchanged relative target we can consider the
                     * projection not dirty.
                     */ if (prevRelativeTarget && (0, $da079738137e5883$export$8d5cf76bb7daff09)(this.relativeTarget, prevRelativeTarget)) this.isProjectionDirty = false;
                    if (!prevRelativeTarget) prevRelativeTarget = (0, $200bf4b8ec180084$export$6459fc9e86be362e)();
                    (0, $038af85914793979$export$c53fd88f45d77e4b)(prevRelativeTarget, this.relativeTarget);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    (0, $e613c751604bfffd$export$739e279c17d51c3d)(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
        }
        startAnimation(options) {
            this.notifyListeners("animationStart");
            this.currentAnimation && this.currentAnimation.stop();
            if (this.resumingFrom && this.resumingFrom.currentAnimation) this.resumingFrom.currentAnimation.stop();
            if (this.pendingAnimation) {
                (0, $1abd9a21e276f8f7$export$ec99c0ef4978dccb)(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $1abd9a21e276f8f7$export$2cef06c20297c17d).update(()=>{
                (0, $d0b38a53f0c16f11$export$97db156a3ed1593b).hasAnimatedSinceResize = true;
                this.currentAnimation = (0, $10847b8422ba7fe6$export$335a17c977067b99)(0, $164a4e28765da53e$var$animationTarget, {
                    ...options,
                    onUpdate: (latest)=>{
                        this.mixTargetDelta(latest);
                        options.onUpdate && options.onUpdate(latest);
                    },
                    onComplete: ()=>{
                        options.onComplete && options.onComplete();
                        this.completeAnimation();
                    }
                });
                if (this.resumingFrom) this.resumingFrom.currentAnimation = this.currentAnimation;
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            const stack = this.getStack();
            stack && stack.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            if (this.currentAnimation) {
                this.mixTargetDelta && this.mixTargetDelta($164a4e28765da53e$var$animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms: targetWithTransforms, target: target, layout: layout, latestValues: latestValues } = lead;
            if (!targetWithTransforms || !target || !layout) return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */ if (this !== lead && this.layout && layout && $164a4e28765da53e$var$shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || (0, $200bf4b8ec180084$export$6459fc9e86be362e)();
                const xLength = (0, $fb864feed65dd055$export$c1c127004b72a37)(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = (0, $fb864feed65dd055$export$c1c127004b72a37)(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            (0, $038af85914793979$export$c53fd88f45d77e4b)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $f3e92f72e92b4bea$export$58b16271041fbfb)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */ (0, $fb864feed65dd055$export$c0d25e96fc67d310)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $24f866b0150d9faa$export$39be5b2d82fc9dc7)());
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            const config = node.options.initialPromotionConfig;
            node.promote({
                transition: config ? config.transition : undefined,
                preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node) : undefined
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
        }
        getPrevLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
        }
        getStack() {
            const { layoutId: layoutId } = this.options;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset: needsReset, transition: transition, preserveFollowOpacity: preserveFollowOpacity } = {}) {
            const stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition: transition
            });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        }
        resetRotation() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return;
            // If there's no detected rotation values, we can early return without a forced render.
            let hasRotate = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */ const { latestValues: latestValues } = visualElement;
            if (latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ) hasRotate = true;
            // If there's no rotation values, we don't need to do any more.
            if (!hasRotate) return;
            const resetValues = {};
            // Check the rotate value of all axes and reset to 0
            for(let i = 0; i < $164a4e28765da53e$var$transformAxes.length; i++){
                const key = "rotate" + $164a4e28765da53e$var$transformAxes[i];
                // Record the rotation and then temporarily set it to 0
                if (latestValues[key]) {
                    resetValues[key] = latestValues[key];
                    visualElement.setStaticValue(key, 0);
                }
            }
            // Force a render of this element to apply the transform with all rotations
            // set to 0.
            visualElement.render();
            // Put back all the values we reset
            for(const key in resetValues)visualElement.setStaticValue(key, resetValues[key]);
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        getProjectionStyles(styleProp = {}) {
            var _a, _b;
            // TODO: Return lifecycle-persistent object
            const styles = {};
            if (!this.instance || this.isSVG) return styles;
            if (!this.isVisible) return {
                visibility: "hidden"
            };
            else styles.visibility = "";
            const transformTemplate = this.getTransformTemplate();
            if (this.needsReset) {
                this.needsReset = false;
                styles.opacity = "";
                styles.pointerEvents = (0, $69a92c324366a6b4$export$fcc2206ecb6d74b)(styleProp.pointerEvents) || "";
                styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return styles;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                const emptyStyles = {};
                if (this.options.layoutId) {
                    emptyStyles.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
                    emptyStyles.pointerEvents = (0, $69a92c324366a6b4$export$fcc2206ecb6d74b)(styleProp.pointerEvents) || "";
                }
                if (this.hasProjected && !(0, $9a0da4f30a85b12c$export$a545127cf1fbb600)(this.latestValues)) {
                    emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return emptyStyles;
            }
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            styles.transform = (0, $fcfd35f3fe9c231e$export$d33653b270fe725c)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) styles.transform = transformTemplate(valuesToRender, styles.transform);
            const { x: x, y: y } = this.projectionDelta;
            styles.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ styles.opacity = lead === this ? (_b = (_a = valuesToRender.opacity) !== null && _a !== void 0 ? _a : this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */ styles.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
            /**
             * Apply scale correction
             */ for(const key in 0, $4fdff83f42bd104a$export$91ddd985b97788d1){
                if (valuesToRender[key] === undefined) continue;
                const { correct: correct, applyTo: applyTo } = (0, $4fdff83f42bd104a$export$91ddd985b97788d1)[key];
                /**
                 * Only apply scale correction to the value if we have an
                 * active projection transform. Otherwise these values become
                 * vulnerable to distortion if the element changes size without
                 * a corresponding layout animation.
                 */ const corrected = styles.transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for(let i = 0; i < num; i++)styles[applyTo[i]] = corrected;
                } else styles[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) styles.pointerEvents = lead === this ? (0, $69a92c324366a6b4$export$fcc2206ecb6d74b)(styleProp.pointerEvents) || "" : "none";
            return styles;
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node)=>{
                var _a;
                return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
            });
            this.root.nodes.forEach($164a4e28765da53e$var$clearMeasurements);
            this.root.sharedNodes.clear();
        }
    };
}
function $164a4e28765da53e$var$updateLayout(node) {
    node.updateLayout();
}
function $164a4e28765da53e$var$notifyLayoutUpdate(node) {
    var _a;
    const snapshot = ((_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) || node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        const { layoutBox: layout, measuredBox: measuredLayout } = node.layout;
        const { animationType: animationType } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") (0, $5821f44b6b7dbf7a$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $fb864feed65dd055$export$c1c127004b72a37)(axisSnapshot);
            axisSnapshot.min = layout[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if ($164a4e28765da53e$var$shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) (0, $5821f44b6b7dbf7a$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $fb864feed65dd055$export$c1c127004b72a37)(layout[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
            /**
                 * Ensure relative target gets resized and rerendererd
                 */ if (node.relativeTarget && !node.currentAnimation) {
                node.isProjectionDirty = true;
                node.relativeTarget[axis].max = node.relativeTarget[axis].min + length;
            }
        });
        const layoutDelta = (0, $200bf4b8ec180084$export$3d227df54007d73a)();
        (0, $fb864feed65dd055$export$c0d25e96fc67d310)(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = (0, $200bf4b8ec180084$export$3d227df54007d73a)();
        if (isShared) (0, $fb864feed65dd055$export$c0d25e96fc67d310)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        else (0, $fb864feed65dd055$export$c0d25e96fc67d310)(visualDelta, layout, snapshot.layoutBox);
        const hasLayoutChanged = !(0, $da079738137e5883$export$a7ec7642fe550fb6)(layoutDelta);
        let hasRelativeTargetChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const relativeSnapshot = (0, $200bf4b8ec180084$export$6459fc9e86be362e)();
                    (0, $fb864feed65dd055$export$2785bfcc929c5650)(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
                    const relativeLayout = (0, $200bf4b8ec180084$export$6459fc9e86be362e)();
                    (0, $fb864feed65dd055$export$2785bfcc929c5650)(relativeLayout, layout, parentLayout.layoutBox);
                    if (!(0, $da079738137e5883$export$ef641b782d85522)(relativeSnapshot, relativeLayout)) hasRelativeTargetChanged = true;
                    if (relativeParent.options.layoutRoot) {
                        node.relativeTarget = relativeLayout;
                        node.relativeTargetOrigin = relativeSnapshot;
                        node.relativeParent = relativeParent;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeTargetChanged: hasRelativeTargetChanged
        });
    } else if (node.isLead()) {
        const { onExitComplete: onExitComplete } = node.options;
        onExitComplete && onExitComplete();
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $164a4e28765da53e$export$131f2f0cc5fe9609(node) {
    /**
     * Increase debug counter for nodes encountered this frame
     */ $164a4e28765da53e$var$projectionFrameData.totalNodes++;
    if (!node.parent) return;
    /**
     * If this node isn't projecting, propagate isProjectionDirty. It will have
     * no performance impact but it will allow the next child that *is* projecting
     * but *isn't* dirty to just check its parent to see if *any* ancestor needs
     * correcting.
     */ if (!node.isProjecting()) node.isProjectionDirty = node.parent.isProjectionDirty;
    /**
     * Propagate isSharedProjectionDirty and isTransformDirty
     * throughout the whole tree. A future revision can take another look at
     * this but for safety we still recalcualte shared nodes.
     */ node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty || node.parent.isProjectionDirty || node.parent.isSharedProjectionDirty));
    node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function $164a4e28765da53e$export$c2664f37bc951031(node) {
    node.isProjectionDirty = node.isSharedProjectionDirty = node.isTransformDirty = false;
}
function $164a4e28765da53e$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $164a4e28765da53e$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $164a4e28765da53e$var$clearIsLayoutDirty(node) {
    node.isLayoutDirty = false;
}
function $164a4e28765da53e$var$resetTransformStyle(node) {
    const { visualElement: visualElement } = node.options;
    if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) visualElement.notify("BeforeLayoutMeasure");
    node.resetTransform();
}
function $164a4e28765da53e$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
    node.isProjectionDirty = true;
}
function $164a4e28765da53e$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $164a4e28765da53e$var$calcProjection(node) {
    node.calcProjection();
}
function $164a4e28765da53e$var$resetRotation(node) {
    node.resetRotation();
}
function $164a4e28765da53e$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $164a4e28765da53e$export$91dbf443e1bf1de1(output, delta, p) {
    output.translate = (0, $523387644f7b98c2$export$2c9e8a9632a706b2)(delta.translate, 0, p);
    output.scale = (0, $523387644f7b98c2$export$2c9e8a9632a706b2)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $164a4e28765da53e$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $523387644f7b98c2$export$2c9e8a9632a706b2)(from.min, to.min, p);
    output.max = (0, $523387644f7b98c2$export$2c9e8a9632a706b2)(from.max, to.max, p);
}
function $164a4e28765da53e$export$6ffd3e6ae339a132(output, from, to, p) {
    $164a4e28765da53e$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $164a4e28765da53e$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $164a4e28765da53e$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
const $164a4e28765da53e$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
const $164a4e28765da53e$var$userAgentContains = (string)=>typeof navigator !== "undefined" && navigator.userAgent.toLowerCase().includes(string);
/**
 * Measured bounding boxes must be rounded in Safari and
 * left untouched in Chrome, otherwise non-integer layouts within scaled-up elements
 * can appear to jump.
 */ const $164a4e28765da53e$var$roundPoint = $164a4e28765da53e$var$userAgentContains("applewebkit/") && !$164a4e28765da53e$var$userAgentContains("chrome/") ? Math.round : (0, $6c31de3ed15607ce$export$8793edee2d425525);
function $164a4e28765da53e$var$roundAxis(axis) {
    // Round to the nearest .5 pixels to support subpixel layouts
    axis.min = $164a4e28765da53e$var$roundPoint(axis.min);
    axis.max = $164a4e28765da53e$var$roundPoint(axis.max);
}
function $164a4e28765da53e$var$roundBox(box) {
    $164a4e28765da53e$var$roundAxis(box.x);
    $164a4e28765da53e$var$roundAxis(box.y);
}
function $164a4e28765da53e$var$shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return animationType === "position" || animationType === "preserve-aspect" && !(0, $fb864feed65dd055$export$28d0384c4b79bde2)((0, $da079738137e5883$export$c5706146bc63213)(snapshot), (0, $da079738137e5883$export$c5706146bc63213)(layout), 0.2);
}




const $9f18e43ac04b1a2f$export$2d029a49a09b6177 = (0, $164a4e28765da53e$export$a84b61f69daa9da0)({
    attachResizeListener: (ref, notify)=>(0, $105610e7777eba77$export$b1d829ddf82884aa)(ref, "resize", notify),
    measureScroll: ()=>({
            x: document.documentElement.scrollLeft || document.body.scrollLeft,
            y: document.documentElement.scrollTop || document.body.scrollTop
        }),
    checkIsScrollRoot: ()=>true
});


const $59500a1af4e1a156$export$b91509fcf893b648 = {
    current: undefined
};
const $59500a1af4e1a156$export$b61a9eb3dbde8858 = (0, $164a4e28765da53e$export$a84b61f69daa9da0)({
    measureScroll: (instance)=>({
            x: instance.scrollLeft,
            y: instance.scrollTop
        }),
    defaultParent: ()=>{
        if (!$59500a1af4e1a156$export$b91509fcf893b648.current) {
            const documentNode = new (0, $9f18e43ac04b1a2f$export$2d029a49a09b6177)({});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            $59500a1af4e1a156$export$b91509fcf893b648.current = documentNode;
        }
        return $59500a1af4e1a156$export$b91509fcf893b648.current;
    },
    resetTransform: (instance, value)=>{
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance)=>Boolean(window.getComputedStyle(instance).position === "fixed")
});


const $548a9e48e4e01a07$export$d7d5d435647ed5a0 = {
    pan: {
        Feature: (0, $01cacad67cb03fed$export$b4f8f1ee75ce5859)
    },
    drag: {
        Feature: (0, $5a76b16e61ca02d1$export$5d97dc2872682820),
        ProjectionNode: (0, $59500a1af4e1a156$export$b61a9eb3dbde8858),
        MeasureLayout: $bd8b833bea6eb6cd$export$779f5fb01ad751cd
    }
};












/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $ecc5e5bf6da60a47$var$splitCSSVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function $ecc5e5bf6da60a47$export$b9f0c1f373aee2b0(current) {
    const match = $ecc5e5bf6da60a47$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token, fallback] = match;
    return [
        token,
        fallback
    ];
}
const $ecc5e5bf6da60a47$var$maxDepth = 4;
function $ecc5e5bf6da60a47$var$getVariableValue(current, element, depth = 1) {
    (0, $bcebfc2a15d8948d$export$f5708dca728d7177)(depth <= $ecc5e5bf6da60a47$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
    const [token, fallback] = $ecc5e5bf6da60a47$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) return resolved.trim();
    else if ((0, $96385673d2db5539$export$31f9caa2600b5723)(fallback)) // The fallback might itself be a CSS variable, in which case we attempt to resolve it too.
    return $ecc5e5bf6da60a47$var$getVariableValue(fallback, element, depth + 1);
    else return fallback;
}
/**
 * Resolve CSS variables from
 *
 * @internal
 */ function $ecc5e5bf6da60a47$export$669319b042b57350(visualElement, { ...target }, transitionEnd) {
    const element = visualElement.current;
    if (!(element instanceof Element)) return {
        target: target,
        transitionEnd: transitionEnd
    };
    // If `transitionEnd` isn't `undefined`, clone it. We could clone `target` and `transitionEnd`
    // only if they change but I think this reads clearer and this isn't a performance-critical path.
    if (transitionEnd) transitionEnd = {
        ...transitionEnd
    };
    // Go through existing `MotionValue`s and ensure any existing CSS variables are resolved
    visualElement.values.forEach((value)=>{
        const current = value.get();
        if (!(0, $96385673d2db5539$export$31f9caa2600b5723)(current)) return;
        const resolved = $ecc5e5bf6da60a47$var$getVariableValue(current, element);
        if (resolved) value.set(resolved);
    });
    // Cycle through every target property and resolve CSS variables. Currently
    // we only read single-var properties like `var(--foo)`, not `calc(var(--foo) + 20px)`
    for(const key in target){
        const current = target[key];
        if (!(0, $96385673d2db5539$export$31f9caa2600b5723)(current)) continue;
        const resolved = $ecc5e5bf6da60a47$var$getVariableValue(current, element);
        if (!resolved) continue;
        // Clone target if it hasn't already been
        target[key] = resolved;
        if (!transitionEnd) transitionEnd = {};
        // If the user hasn't already set this key on `transitionEnd`, set it to the unresolved
        // CSS variable. This will ensure that after the animation the component will reflect
        // changes in the value of the CSS variable.
        if (transitionEnd[key] === undefined) transitionEnd[key] = current;
    }
    return {
        target: target,
        transitionEnd: transitionEnd
    };
}









const $e972b2215eee4e3c$var$positionalKeys = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y",
    "translateX",
    "translateY"
]);
const $e972b2215eee4e3c$var$isPositionalKey = (key)=>$e972b2215eee4e3c$var$positionalKeys.has(key);
const $e972b2215eee4e3c$var$hasPositionalKey = (target)=>{
    return Object.keys(target).some($e972b2215eee4e3c$var$isPositionalKey);
};
const $e972b2215eee4e3c$var$isNumOrPxType = (v)=>v === (0, $561ee22ed5cc3453$export$98e628dec113755e) || v === (0, $ecde22e9cf283015$export$91c0eda1d06bf008);
const $e972b2215eee4e3c$var$getPosFromMatrix = (matrix, pos)=>parseFloat(matrix.split(", ")[pos]);
const $e972b2215eee4e3c$var$getTranslateFromMatrix = (pos2, pos3)=>(_bbox, { transform: transform })=>{
        if (transform === "none" || !transform) return 0;
        const matrix3d = transform.match(/^matrix3d\((.+)\)$/);
        if (matrix3d) return $e972b2215eee4e3c$var$getPosFromMatrix(matrix3d[1], pos3);
        else {
            const matrix = transform.match(/^matrix\((.+)\)$/);
            if (matrix) return $e972b2215eee4e3c$var$getPosFromMatrix(matrix[1], pos2);
            else return 0;
        }
    };
const $e972b2215eee4e3c$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $e972b2215eee4e3c$var$nonTranslationalTransformKeys = (0, $ca5c3ae346f46e59$export$280dc01950909d86).filter((key)=>!$e972b2215eee4e3c$var$transformKeys.has(key));
function $e972b2215eee4e3c$var$removeNonTranslationalTransform(visualElement) {
    const removedTransforms = [];
    $e972b2215eee4e3c$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    // Apply changes to element before measurement
    if (removedTransforms.length) visualElement.render();
    return removedTransforms;
}
const $e972b2215eee4e3c$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x }, { paddingLeft: paddingLeft = "0", paddingRight: paddingRight = "0" })=>x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y: y }, { paddingTop: paddingTop = "0", paddingBottom: paddingBottom = "0" })=>y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top: top })=>parseFloat(top),
    left: (_bbox, { left: left })=>parseFloat(left),
    bottom: ({ y: y }, { top: top })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x }, { left: left })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: $e972b2215eee4e3c$var$getTranslateFromMatrix(4, 13),
    y: $e972b2215eee4e3c$var$getTranslateFromMatrix(5, 14)
};
// Alias translate longform names
$e972b2215eee4e3c$export$781d46a8aa670d52.translateX = $e972b2215eee4e3c$export$781d46a8aa670d52.x;
$e972b2215eee4e3c$export$781d46a8aa670d52.translateY = $e972b2215eee4e3c$export$781d46a8aa670d52.y;
const $e972b2215eee4e3c$var$convertChangedValueTypes = (target, visualElement, changedKeys)=>{
    const originBbox = visualElement.measureViewportBox();
    const element = visualElement.current;
    const elementComputedStyle = getComputedStyle(element);
    const { display: display } = elementComputedStyle;
    const origin = {};
    // If the element is currently set to display: "none", make it visible before
    // measuring the target bounding box
    if (display === "none") visualElement.setStaticValue("display", target.display || "block");
    /**
     * Record origins before we render and update styles
     */ changedKeys.forEach((key)=>{
        origin[key] = $e972b2215eee4e3c$export$781d46a8aa670d52[key](originBbox, elementComputedStyle);
    });
    // Apply the latest values (as set in checkAndConvertChangedValueTypes)
    visualElement.render();
    const targetBbox = visualElement.measureViewportBox();
    changedKeys.forEach((key)=>{
        // Restore styles to their **calculated computed style**, not their actual
        // originally set style. This allows us to animate between equivalent pixel units.
        const value = visualElement.getValue(key);
        value && value.jump(origin[key]);
        target[key] = $e972b2215eee4e3c$export$781d46a8aa670d52[key](targetBbox, elementComputedStyle);
    });
    return target;
};
const $e972b2215eee4e3c$var$checkAndConvertChangedValueTypes = (visualElement, target, origin = {}, transitionEnd = {})=>{
    target = {
        ...target
    };
    transitionEnd = {
        ...transitionEnd
    };
    const targetPositionalKeys = Object.keys(target).filter($e972b2215eee4e3c$var$isPositionalKey);
    // We want to remove any transform values that could affect the element's bounding box before
    // it's measured. We'll reapply these later.
    let removedTransformValues = [];
    let hasAttemptedToRemoveTransformValues = false;
    const changedValueTypeKeys = [];
    targetPositionalKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (!visualElement.hasValue(key)) return;
        let from = origin[key];
        let fromType = (0, $a8226391f55e88e8$export$eefdd52e3ccae428)(from);
        const to = target[key];
        let toType;
        // TODO: The current implementation of this basically throws an error
        // if you try and do value conversion via keyframes. There's probably
        // a way of doing this but the performance implications would need greater scrutiny,
        // as it'd be doing multiple resize-remeasure operations.
        if ((0, $0d0309bb748c55b8$export$9153ad4c4999f4a0)(to)) {
            const numKeyframes = to.length;
            const fromIndex = to[0] === null ? 1 : 0;
            from = to[fromIndex];
            fromType = (0, $a8226391f55e88e8$export$eefdd52e3ccae428)(from);
            for(let i = fromIndex; i < numKeyframes; i++){
                /**
                 * Don't allow wildcard keyframes to be used to detect
                 * a difference in value types.
                 */ if (to[i] === null) break;
                if (!toType) {
                    toType = (0, $a8226391f55e88e8$export$eefdd52e3ccae428)(to[i]);
                    (0, $bcebfc2a15d8948d$export$f5708dca728d7177)(toType === fromType || $e972b2215eee4e3c$var$isNumOrPxType(fromType) && $e972b2215eee4e3c$var$isNumOrPxType(toType), "Keyframes must be of the same dimension as the current value");
                } else (0, $bcebfc2a15d8948d$export$f5708dca728d7177)((0, $a8226391f55e88e8$export$eefdd52e3ccae428)(to[i]) === toType, "All keyframes must be of the same type");
            }
        } else toType = (0, $a8226391f55e88e8$export$eefdd52e3ccae428)(to);
        if (fromType !== toType) {
            // If they're both just number or px, convert them both to numbers rather than
            // relying on resize/remeasure to convert (which is wasteful in this situation)
            if ($e972b2215eee4e3c$var$isNumOrPxType(fromType) && $e972b2215eee4e3c$var$isNumOrPxType(toType)) {
                const current = value.get();
                if (typeof current === "string") value.set(parseFloat(current));
                if (typeof to === "string") target[key] = parseFloat(to);
                else if (Array.isArray(to) && toType === (0, $ecde22e9cf283015$export$91c0eda1d06bf008)) target[key] = to.map(parseFloat);
            } else if ((fromType === null || fromType === void 0 ? void 0 : fromType.transform) && (toType === null || toType === void 0 ? void 0 : toType.transform) && (from === 0 || to === 0)) {
                // If one or the other value is 0, it's safe to coerce it to the
                // type of the other without measurement
                if (from === 0) value.set(toType.transform(from));
                else target[key] = fromType.transform(to);
            } else {
                // If we're going to do value conversion via DOM measurements, we first
                // need to remove non-positional transform values that could affect the bbox measurements.
                if (!hasAttemptedToRemoveTransformValues) {
                    removedTransformValues = $e972b2215eee4e3c$var$removeNonTranslationalTransform(visualElement);
                    hasAttemptedToRemoveTransformValues = true;
                }
                changedValueTypeKeys.push(key);
                transitionEnd[key] = transitionEnd[key] !== undefined ? transitionEnd[key] : target[key];
                value.jump(to);
            }
        }
    });
    if (changedValueTypeKeys.length) {
        const scrollY = changedValueTypeKeys.indexOf("height") >= 0 ? window.pageYOffset : null;
        const convertedTarget = $e972b2215eee4e3c$var$convertChangedValueTypes(target, visualElement, changedValueTypeKeys);
        // If we removed transform values, reapply them before the next render
        if (removedTransformValues.length) removedTransformValues.forEach(([key, value])=>{
            visualElement.getValue(key).set(value);
        });
        // Reapply original values
        visualElement.render();
        // Restore scroll position
        if ((0, $4e6fb092a41bfb82$export$4e09c449d6c407f7) && scrollY !== null) window.scrollTo({
            top: scrollY
        });
        return {
            target: convertedTarget,
            transitionEnd: transitionEnd
        };
    } else return {
        target: target,
        transitionEnd: transitionEnd
    };
};
/**
 * Convert value types for x/y/width/height/top/left/bottom/right
 *
 * Allows animation between `'auto'` -> `'100%'` or `0` -> `'calc(50% - 10vw)'`
 *
 * @internal
 */ function $e972b2215eee4e3c$export$9e04b0cab841a28(visualElement, target, origin, transitionEnd) {
    return $e972b2215eee4e3c$var$hasPositionalKey(target) ? $e972b2215eee4e3c$var$checkAndConvertChangedValueTypes(visualElement, target, origin, transitionEnd) : {
        target: target,
        transitionEnd: transitionEnd
    };
}


/**
 * Parse a DOM variant to make it animatable. This involves resolving CSS variables
 * and ensuring animations like "20%" => "calc(50vw)" are performed in pixels.
 */ const $dce481c9c7d99539$export$5849e743e29831d6 = (visualElement, target, origin, transitionEnd)=>{
    const resolved = (0, $ecc5e5bf6da60a47$export$669319b042b57350)(visualElement, target, transitionEnd);
    target = resolved.target;
    transitionEnd = resolved.transitionEnd;
    return (0, $e972b2215eee4e3c$export$9e04b0cab841a28)(visualElement, target, origin, transitionEnd);
};






// Does this device prefer reduced motion? Returns `null` server-side.
const $104f8e5b741c829f$export$ff7706047246b98b = {
    current: null
};
const $104f8e5b741c829f$export$6476d16e2fd2d0db = {
    current: false
};


function $9024eedbc479bf66$export$ca9f41fb23dded3d() {
    (0, $104f8e5b741c829f$export$6476d16e2fd2d0db).current = true;
    if (!(0, $4e6fb092a41bfb82$export$4e09c449d6c407f7)) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, $104f8e5b741c829f$export$ff7706047246b98b).current = motionMediaQuery.matches;
        motionMediaQuery.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $104f8e5b741c829f$export$ff7706047246b98b).current = false;
}














function $4723f7fe466525d9$export$9a552858d5197f6e(element, next, prev) {
    const { willChange: willChange } = next;
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $56c5f751f01a3bad$export$605d60a2578142d3)(nextValue)) {
            /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
            if ((0, $2d5ab3a3cea3faff$export$98397f3adbf6259f)(willChange)) willChange.add(key);
        } else if ((0, $56c5f751f01a3bad$export$605d60a2578142d3)(prevValue)) {
            /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $33b71ad0065b86cf$export$ce8bdc721e76545f)(nextValue, {
                owner: element
            }));
            if ((0, $2d5ab3a3cea3faff$export$98397f3adbf6259f)(willChange)) willChange.remove(key);
        } else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                // TODO: Only update values that aren't being animated or even looked at
                !existingValue.hasAnimated && existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $33b71ad0065b86cf$export$ce8bdc721e76545f)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}






const $c688d272006ace14$export$bc2a978a17abfdde = new WeakMap();



const $3384b7423e0343f2$var$featureNames = Object.keys((0, $1de64697b9c13d22$export$65570e08d843624d));
const $3384b7423e0343f2$var$numFeatures = $3384b7423e0343f2$var$featureNames.length;
const $3384b7423e0343f2$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
const $3384b7423e0343f2$var$numVariantProps = (0, $db4213190228bc95$export$1405a65085f40b9).length;
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class $3384b7423e0343f2$export$fa8b653c0f3714e5 {
    constructor({ parent: parent, props: props, presenceContext: presenceContext, reducedMotionConfig: reducedMotionConfig, visualState: visualState }, options = {}){
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.scheduleRender = ()=>(0, $1abd9a21e276f8f7$export$2cef06c20297c17d).render(this.render, false, true);
        const { latestValues: latestValues, renderState: renderState } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = {
            ...latestValues
        };
        this.initialValues = props.initial ? {
            ...latestValues
        } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.isControllingVariants = (0, $c4d8b2907c7e2211$export$4b3c3bd8d910d78d)(props);
        this.isVariantNode = (0, $c4d8b2907c7e2211$export$ce46fa4165cdec40)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't neccessarily a breaking change,
         * more a reflection of the test.
         */ const { willChange: willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {});
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $56c5f751f01a3bad$export$605d60a2578142d3)(value)) {
                value.set(latestValues[key], false);
                if ((0, $2d5ab3a3cea3faff$export$98397f3adbf6259f)(willChange)) willChange.add(key);
            }
        }
    }
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps) {
        return {};
    }
    mount(instance) {
        this.current = instance;
        (0, $c688d272006ace14$export$bc2a978a17abfdde).set(instance, this);
        if (this.projection && !this.projection.instance) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        if (!(0, $104f8e5b741c829f$export$6476d16e2fd2d0db).current) (0, $9024eedbc479bf66$export$ca9f41fb23dded3d)();
        this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : (0, $104f8e5b741c829f$export$ff7706047246b98b).current;
        if (this.parent) this.parent.children.add(this);
        this.update(this.props, this.presenceContext);
    }
    unmount() {
        (0, $c688d272006ace14$export$bc2a978a17abfdde).delete(this.current);
        this.projection && this.projection.unmount();
        (0, $1abd9a21e276f8f7$export$ec99c0ef4978dccb)(this.notifyUpdate);
        (0, $1abd9a21e276f8f7$export$ec99c0ef4978dccb)(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent && this.parent.children.delete(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features)this.features[key].unmount();
        this.current = null;
    }
    bindToMotionValue(key, value) {
        const valueIsTransform = (0, $ca5c3ae346f46e59$export$7b42a0094fb00b6e).has(key);
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, $1abd9a21e276f8f7$export$2cef06c20297c17d).update(this.notifyUpdate, false, true);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
        });
        const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            removeOnRenderRequest();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    loadFeatures({ children: children, ...renderedProps }, isStrict, preloadedFeatures, initialLayoutGroupConfig) {
        let ProjectionNodeConstructor;
        let MeasureLayout;
        for(let i = 0; i < $3384b7423e0343f2$var$numFeatures; i++){
            const name = $3384b7423e0343f2$var$featureNames[i];
            const { isEnabled: isEnabled, Feature: FeatureConstructor, ProjectionNode: ProjectionNode, MeasureLayout: MeasureLayoutComponent } = (0, $1de64697b9c13d22$export$65570e08d843624d)[name];
            if (ProjectionNode) ProjectionNodeConstructor = ProjectionNode;
            if (isEnabled(renderedProps)) {
                if (!this.features[name] && FeatureConstructor) this.features[name] = new FeatureConstructor(this);
                if (MeasureLayoutComponent) MeasureLayout = MeasureLayoutComponent;
            }
        }
        if (!this.projection && ProjectionNodeConstructor) {
            this.projection = new ProjectionNodeConstructor(this.latestValues, this.parent && this.parent.projection);
            const { layoutId: layoutId, layout: layout, drag: drag, dragConstraints: dragConstraints, layoutScroll: layoutScroll, layoutRoot: layoutRoot } = renderedProps;
            this.projection.setOptions({
                layoutId: layoutId,
                layout: layout,
                alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $8bac730267ed8b61$export$dedd81df7bc1307)(dragConstraints),
                visualElement: this,
                scheduleRender: ()=>this.scheduleRender(),
                /**
                 * TODO: Update options in an effect. This could be tricky as it'll be too late
                 * to update by the time layout animations run.
                 * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
                 * ensuring it gets called if there's no potential layout animations.
                 *
                 */ animationType: typeof layout === "string" ? layout : "both",
                initialPromotionConfig: initialLayoutGroupConfig,
                layoutScroll: layoutScroll,
                layoutRoot: layoutRoot
            });
        }
        return MeasureLayout;
    }
    updateFeatures() {
        for(const key in this.features){
            const feature = this.features[key];
            if (feature.isMounted) feature.update();
            else {
                feature.mount();
                feature.isMounted = true;
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.options, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $200bf4b8ec180084$export$6459fc9e86be362e)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Make a target animatable by Popmotion. For instance, if we're
     * trying to animate width from 100px to 100vw we need to measure 100vw
     * in pixels to determine what we really need to animate to. This is also
     * pluggable to support Framer's custom value types like Color,
     * and CSS variables.
     */ makeTargetAnimatable(target, canMutate = true) {
        return this.makeTargetAnimatableFromInstance(target, this.props, canMutate);
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < $3384b7423e0343f2$var$propEventHandlers.length; i++){
            const key = $3384b7423e0343f2$var$propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listener = props["on" + key];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, $4723f7fe466525d9$export$9a552858d5197f6e)(this, this.scrapeMotionValuesFromProps(props, this.prevProps), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    getVariantContext(startAtParent = false) {
        if (startAtParent) return this.parent ? this.parent.getVariantContext() : undefined;
        if (!this.isControllingVariants) {
            const context = this.parent ? this.parent.getVariantContext() || {} : {};
            if (this.props.initial !== undefined) context.initial = this.props.initial;
            return context;
        }
        const context = {};
        for(let i = 0; i < $3384b7423e0343f2$var$numVariantProps; i++){
            const name = (0, $db4213190228bc95$export$1405a65085f40b9)[i];
            const prop = this.props[name];
            if ((0, $33e95f2e5351c1c0$export$720b90e312cea233)(prop) || prop === false) context[name] = prop;
        }
        return context;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        if (value !== this.values.get(key)) {
            this.removeValue(key);
            this.bindToMotionValue(key, value);
        }
        this.values.set(key, value);
        this.latestValues[key] = value.get();
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, $33b71ad0065b86cf$export$ce8bdc721e76545f)(defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key) {
        var _a;
        return this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : (_a = this.getBaseTargetFromProps(this.props, key)) !== null && _a !== void 0 ? _a : this.readValueFromInstance(this.current, key, this.options);
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        var _a;
        const { initial: initial } = this.props;
        const valueFromInitial = typeof initial === "string" || typeof initial === "object" ? (_a = (0, $318b02a1e1f48ccb$export$d68f140c4d9b48bc)(this.props, initial)) === null || _a === void 0 ? void 0 : _a[key] : undefined;
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, $56c5f751f01a3bad$export$605d60a2578142d3)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $a6375dce0ad778ec$export$e7dff9482a5fd23c)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
}


class $8d813535283727b2$export$e49735c2a366bdc7 extends (0, $3384b7423e0343f2$export$fa8b653c0f3714e5) {
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        return props.style ? props.style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars: vars, style: style }) {
        delete vars[key];
        delete style[key];
    }
    makeTargetAnimatableFromInstance({ transition: transition, transitionEnd: transitionEnd, ...target }, { transformValues: transformValues }, isMounted) {
        let origin = (0, $ce7c85a117778f2d$export$5a759dc7a1cfb72a)(target, transition || {}, this);
        /**
         * If Framer has provided a function to convert `Color` etc value types, convert them
         */ if (transformValues) {
            if (transitionEnd) transitionEnd = transformValues(transitionEnd);
            if (target) target = transformValues(target);
            if (origin) origin = transformValues(origin);
        }
        if (isMounted) {
            (0, $ce7c85a117778f2d$export$6afbed164019a54c)(this, target, origin);
            const parsed = (0, $dce481c9c7d99539$export$5849e743e29831d6)(this, target, origin, transitionEnd);
            transitionEnd = parsed.transitionEnd;
            target = parsed.target;
        }
        return {
            transition: transition,
            transitionEnd: transitionEnd,
            ...target
        };
    }
}



function $af8cdffc0038eea1$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
class $af8cdffc0038eea1$export$23fea75b03ac16b3 extends (0, $8d813535283727b2$export$e49735c2a366bdc7) {
    readValueFromInstance(instance, key) {
        if ((0, $ca5c3ae346f46e59$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $67678bc8be638c06$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        } else {
            const computedStyle = $af8cdffc0038eea1$export$3735103072e4a80(instance);
            const value = ((0, $96385673d2db5539$export$9de1236619d9e756)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint: transformPagePoint }) {
        return (0, $809eff0c312625c3$export$d8718b6a7e5c624e)(instance, transformPagePoint);
    }
    build(renderState, latestValues, options, props) {
        (0, $6bc0775b95155db5$export$bb517f8b40f8e99d)(renderState, latestValues, options, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps) {
        return (0, $37e7cb925f50d74f$export$16da615486abaa45)(props, prevProps);
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children: children } = this.props;
        if ((0, $56c5f751f01a3bad$export$605d60a2578142d3)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $4897080e77be3535$export$1a32bf6229c258c0)(instance, renderState, styleProp, projection);
    }
}












class $ae5e3340965ae4ee$export$86bcdffbaf733d84 extends (0, $8d813535283727b2$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.isSVGTag = false;
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, $ca5c3ae346f46e59$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $67678bc8be638c06$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, $03996e6affc7ae07$export$28931db5d57958e5).has(key) ? (0, $64d13cd8bd24d1b3$export$9fd24a634729c672)(key) : key;
        return instance.getAttribute(key);
    }
    measureInstanceViewportBox() {
        return (0, $200bf4b8ec180084$export$6459fc9e86be362e)();
    }
    scrapeMotionValuesFromProps(props, prevProps) {
        return (0, $f15ca6b0d702ad3b$export$16da615486abaa45)(props, prevProps);
    }
    build(renderState, latestValues, options, props) {
        (0, $77100f389af05a7f$export$5475d24f125d7053)(renderState, latestValues, options, this.isSVGTag, props.transformTemplate);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $f4c34eeabc0a0368$export$c5f8399d19a7394b)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, $8009848b0f810604$export$6328ce7565ea1049)(instance.tagName);
        super.mount(instance);
    }
}



const $8768dd14613ace7f$export$56ba0183203348f5 = (Component, options)=>{
    return (0, $b4d5c6204542c379$export$88f3fc2fd3766989)(Component) ? new (0, $ae5e3340965ae4ee$export$86bcdffbaf733d84)(options, {
        enableHardwareAcceleration: false
    }) : new (0, $af8cdffc0038eea1$export$23fea75b03ac16b3)(options, {
        enableHardwareAcceleration: true
    });
};




const $c7aa46a04edf1ac2$export$b3219800bda33a1f = {
    layout: {
        ProjectionNode: (0, $59500a1af4e1a156$export$b61a9eb3dbde8858),
        MeasureLayout: $bd8b833bea6eb6cd$export$779f5fb01ad751cd
    }
};


const $bb8231acd22e51c2$var$preloadedFeatures = {
    ...(0, $e2d1ec617b1ce2aa$export$7f9953c70dacfd7f),
    ...(0, $78bbaacfde380b3d$export$e5b72898e5a201f1),
    ...(0, $548a9e48e4e01a07$export$d7d5d435647ed5a0),
    ...(0, $c7aa46a04edf1ac2$export$b3219800bda33a1f)
};
/**
 * HTML & SVG components, optimised for use with gestures and animation. These can be used as
 * drop-in replacements for any HTML & SVG component, all CSS & SVG properties are supported.
 *
 * @public
 */ const $bb8231acd22e51c2$export$e25e478948902b8b = /*@__PURE__*/ (0, $9a825e4d76c73dad$export$a28d6df673050e18)((Component, config)=>(0, $c21ef8d8f121db35$export$732916c0e88175fb)(Component, config, $bb8231acd22e51c2$var$preloadedFeatures, (0, $8768dd14613ace7f$export$56ba0183203348f5)));
/**
 * Create a DOM `motion` component with the provided string. This is primarily intended
 * as a full alternative to `motion` for consumers who have to support environments that don't
 * support `Proxy`.
 *
 * ```javascript
 * import { createDomMotionComponent } from "framer-motion"
 *
 * const motion = {
 *   div: createDomMotionComponent('div')
 * }
 * ```
 *
 * @public
 */ function $bb8231acd22e51c2$export$546614c4a05701f9(key) {
    return (0, $b030745d33f27814$export$46b7e4b9dc6110c3)((0, $c21ef8d8f121db35$export$732916c0e88175fb)(key, {
        forwardMotionProps: false
    }, $bb8231acd22e51c2$var$preloadedFeatures, (0, $8768dd14613ace7f$export$56ba0183203348f5)));
}





var $8NFma = parcelRequire("8NFma");

var $8NFma = parcelRequire("8NFma");
var $0e35f4eab9d23d34$exports = {};
var $f252d8db80447bb3$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $f252d8db80447bb3$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
$f252d8db80447bb3$exports = $f252d8db80447bb3$var$isObject;


var $14808ccd12f91c2c$exports = {};
var $a5d9a14830ba4e3d$exports = {};
var $bdd23c336734cabc$exports = {};
/** Detect free variable `global` from Node.js. */ var $bdd23c336734cabc$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
$bdd23c336734cabc$exports = $bdd23c336734cabc$var$freeGlobal;


/** Detect free variable `self`. */ var $a5d9a14830ba4e3d$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $a5d9a14830ba4e3d$var$root = $bdd23c336734cabc$exports || $a5d9a14830ba4e3d$var$freeSelf || Function('return this')();
$a5d9a14830ba4e3d$exports = $a5d9a14830ba4e3d$var$root;


/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $14808ccd12f91c2c$var$now = function() {
    return $a5d9a14830ba4e3d$exports.Date.now();
};
$14808ccd12f91c2c$exports = $14808ccd12f91c2c$var$now;


var $406347b540c1b6af$exports = {};
var $1214060930b72fb3$exports = {};
var $239747baff5e4ab8$exports = {};
/** Used to match a single whitespace character. */ var $239747baff5e4ab8$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $239747baff5e4ab8$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $239747baff5e4ab8$var$reWhitespace.test(string.charAt(index)));
    return index;
}
$239747baff5e4ab8$exports = $239747baff5e4ab8$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $1214060930b72fb3$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $1214060930b72fb3$var$baseTrim(string) {
    return string ? string.slice(0, $239747baff5e4ab8$exports(string) + 1).replace($1214060930b72fb3$var$reTrimStart, '') : string;
}
$1214060930b72fb3$exports = $1214060930b72fb3$var$baseTrim;



var $57d933e0496b031f$exports = {};
var $c642e992d66c2487$exports = {};
var $35c34fed223e8d4f$exports = {};

/** Built-in value references. */ var $35c34fed223e8d4f$var$Symbol = $a5d9a14830ba4e3d$exports.Symbol;
$35c34fed223e8d4f$exports = $35c34fed223e8d4f$var$Symbol;


var $9c731e4150a7ad2a$exports = {};

/** Used for built-in method references. */ var $9c731e4150a7ad2a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9c731e4150a7ad2a$var$hasOwnProperty = $9c731e4150a7ad2a$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $9c731e4150a7ad2a$var$nativeObjectToString = $9c731e4150a7ad2a$var$objectProto.toString;
/** Built-in value references. */ var $9c731e4150a7ad2a$var$symToStringTag = $35c34fed223e8d4f$exports ? $35c34fed223e8d4f$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $9c731e4150a7ad2a$var$getRawTag(value) {
    var isOwn = $9c731e4150a7ad2a$var$hasOwnProperty.call(value, $9c731e4150a7ad2a$var$symToStringTag), tag = value[$9c731e4150a7ad2a$var$symToStringTag];
    try {
        value[$9c731e4150a7ad2a$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $9c731e4150a7ad2a$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$9c731e4150a7ad2a$var$symToStringTag] = tag;
        else delete value[$9c731e4150a7ad2a$var$symToStringTag];
    }
    return result;
}
$9c731e4150a7ad2a$exports = $9c731e4150a7ad2a$var$getRawTag;


var $2ded20f023f64d8f$exports = {};
/** Used for built-in method references. */ var $2ded20f023f64d8f$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $2ded20f023f64d8f$var$nativeObjectToString = $2ded20f023f64d8f$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $2ded20f023f64d8f$var$objectToString(value) {
    return $2ded20f023f64d8f$var$nativeObjectToString.call(value);
}
$2ded20f023f64d8f$exports = $2ded20f023f64d8f$var$objectToString;


/** `Object#toString` result references. */ var $c642e992d66c2487$var$nullTag = '[object Null]', $c642e992d66c2487$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $c642e992d66c2487$var$symToStringTag = $35c34fed223e8d4f$exports ? $35c34fed223e8d4f$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $c642e992d66c2487$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $c642e992d66c2487$var$undefinedTag : $c642e992d66c2487$var$nullTag;
    return $c642e992d66c2487$var$symToStringTag && $c642e992d66c2487$var$symToStringTag in Object(value) ? $9c731e4150a7ad2a$exports(value) : $2ded20f023f64d8f$exports(value);
}
$c642e992d66c2487$exports = $c642e992d66c2487$var$baseGetTag;


var $c8674e57225e697f$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $c8674e57225e697f$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
$c8674e57225e697f$exports = $c8674e57225e697f$var$isObjectLike;


/** `Object#toString` result references. */ var $57d933e0496b031f$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $57d933e0496b031f$var$isSymbol(value) {
    return typeof value == 'symbol' || $c8674e57225e697f$exports(value) && $c642e992d66c2487$exports(value) == $57d933e0496b031f$var$symbolTag;
}
$57d933e0496b031f$exports = $57d933e0496b031f$var$isSymbol;


/** Used as references for various `Number` constants. */ var $406347b540c1b6af$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $406347b540c1b6af$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $406347b540c1b6af$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $406347b540c1b6af$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $406347b540c1b6af$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $406347b540c1b6af$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($57d933e0496b031f$exports(value)) return $406347b540c1b6af$var$NAN;
    if ($f252d8db80447bb3$exports(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $f252d8db80447bb3$exports(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = $1214060930b72fb3$exports(value);
    var isBinary = $406347b540c1b6af$var$reIsBinary.test(value);
    return isBinary || $406347b540c1b6af$var$reIsOctal.test(value) ? $406347b540c1b6af$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $406347b540c1b6af$var$reIsBadHex.test(value) ? $406347b540c1b6af$var$NAN : +value;
}
$406347b540c1b6af$exports = $406347b540c1b6af$var$toNumber;


/** Error message constants. */ var $0e35f4eab9d23d34$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $0e35f4eab9d23d34$var$nativeMax = Math.max, $0e35f4eab9d23d34$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $0e35f4eab9d23d34$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($0e35f4eab9d23d34$var$FUNC_ERROR_TEXT);
    wait = $406347b540c1b6af$exports(wait) || 0;
    if ($f252d8db80447bb3$exports(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $0e35f4eab9d23d34$var$nativeMax($406347b540c1b6af$exports(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $0e35f4eab9d23d34$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $14808ccd12f91c2c$exports();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($14808ccd12f91c2c$exports());
    }
    function debounced() {
        var time = $14808ccd12f91c2c$exports(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
$0e35f4eab9d23d34$exports = $0e35f4eab9d23d34$var$debounce;


var $10c34a22c834dedf$exports = {};


/** Error message constants. */ var $10c34a22c834dedf$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $10c34a22c834dedf$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($10c34a22c834dedf$var$FUNC_ERROR_TEXT);
    if ($f252d8db80447bb3$exports(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $0e35f4eab9d23d34$exports(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
$10c34a22c834dedf$exports = $10c34a22c834dedf$var$throttle;


const $186d05b333a95faf$var$patchResizeCallback = (resizeCallback, refreshMode, refreshRate, refreshOptions)=>{
    switch(refreshMode){
        case 'debounce':
            return (0, (/*@__PURE__*/$parcel$interopDefault($0e35f4eab9d23d34$exports)))(resizeCallback, refreshRate, refreshOptions);
        case 'throttle':
            return (0, (/*@__PURE__*/$parcel$interopDefault($10c34a22c834dedf$exports)))(resizeCallback, refreshRate, refreshOptions);
        default:
            return resizeCallback;
    }
};
/**
 * A custom hook that converts a callback to a ref to avoid triggering re-renders when passed as a
 * prop or avoid re-executing effects when passed as a dependency
 */ const $186d05b333a95faf$var$useCallbackRef = // eslint-disable-next-line @typescript-eslint/no-explicit-any
(callback)=>{
    const callbackRef = $8NFma.useRef(callback);
    $8NFma.useEffect(()=>{
        callbackRef.current = callback;
    });
    return $8NFma.useMemo(()=>(...args)=>{
            var _a;
            return (_a = callbackRef.current) === null || _a === void 0 ? void 0 : _a.call(callbackRef, ...args);
        }, []);
};
/** `useRef` hook doesn't handle conditional rendering or dynamic ref changes.
 * This hook creates a proxy that ensures that `refElement` is updated whenever the ref is changed. */ const $186d05b333a95faf$var$useRefProxy = // eslint-disable-next-line @typescript-eslint/no-explicit-any
(targetRef)=>{
    // we are going to use this ref to store the last element that was passed to the hook
    const [refElement, setRefElement] = $8NFma.useState((targetRef === null || targetRef === void 0 ? void 0 : targetRef.current) || null);
    // if targetRef is passed, we need to update the refElement
    // we have to use setTimeout because ref get assigned after the hook is called
    // in the future releases we are going to remove targetRef and force users to use ref returned by the hook
    if (targetRef) setTimeout(()=>{
        if (targetRef.current !== refElement) setRefElement(targetRef.current);
    }, 0);
    // this is a memo that will be called every time the ref is changed
    // This proxy will properly call setState either when the ref is called as a function or when `.current` is set
    // we call setState inside to trigger rerender
    const refProxy = $8NFma.useMemo(()=>new Proxy((node)=>{
            if (node !== refElement) setRefElement(node);
        }, {
            get (target, prop) {
                if (prop === 'current') return refElement;
                return target[prop];
            },
            set (target, prop, value) {
                if (prop === 'current') setRefElement(value);
                else target[prop] = value;
                return true;
            }
        }), [
        refElement
    ]);
    return {
        refProxy: refProxy,
        refElement: refElement,
        setRefElement: setRefElement
    };
};
/** Calculates the dimensions of the element based on the current box model.
 * @see https://developer.mozilla.org/en-US/docs/Learn/CSS/Building_blocks/The_box_model
 */ const $186d05b333a95faf$var$getDimensions = (entry, box)=>{
    // Value	          Border	  Padding	  Inner Content
    // ---------------------------------------------------
    // 'border-box'	    Yes	      Yes	      Yes
    // 'content-box'	  No	      No	      Yes
    //  undefined       No	      No?	      Yes
    if (box === 'border-box') return {
        width: entry.borderBoxSize[0].inlineSize,
        height: entry.borderBoxSize[0].blockSize
    };
    if (box === 'content-box') return {
        width: entry.contentBoxSize[0].inlineSize,
        height: entry.contentBoxSize[0].blockSize
    };
    return {
        width: entry.contentRect.width,
        height: entry.contentRect.height
    };
}; // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $186d05b333a95faf$export$453c3d1cba18d800({ skipOnMount: skipOnMount = false, refreshMode: refreshMode, refreshRate: refreshRate = 1000, refreshOptions: refreshOptions, handleWidth: handleWidth = true, handleHeight: handleHeight = true, targetRef: targetRef, observerOptions: observerOptions, onResize: onResize } = {}) {
    // If `skipOnMount` is enabled, skip the first resize event
    const skipResize = (0, $8NFma.useRef)(skipOnMount);
    // Wrap the `onResize` callback with a ref to avoid re-renders
    const onResizeRef = $186d05b333a95faf$var$useCallbackRef(onResize);
    const [size, setSize] = (0, $8NFma.useState)({
        width: undefined,
        height: undefined
    });
    // Create a proxy ref to handle conditional rendering and dynamic ref changes of the target element
    const { refProxy: refProxy, refElement: refElement } = $186d05b333a95faf$var$useRefProxy(targetRef);
    const { box: box } = observerOptions || {};
    const resizeCallback = (0, $8NFma.useCallback)((entries)=>{
        if (!handleWidth && !handleHeight) return;
        if (skipResize.current) {
            skipResize.current = false;
            return;
        }
        // Only update the size if one of the observed dimensions has changed
        const shouldSetSize = (prevSize, nextSize)=>handleWidth && prevSize.width !== nextSize.width || handleHeight && prevSize.height !== nextSize.height;
        entries.forEach((entry)=>{
            const dimensions = $186d05b333a95faf$var$getDimensions(entry, box);
            setSize((prevSize)=>{
                if (!shouldSetSize(prevSize, dimensions)) return prevSize;
                onResizeRef === null || onResizeRef === void 0 || onResizeRef({
                    width: dimensions.width,
                    height: dimensions.height,
                    entry: entry
                });
                return dimensions;
            });
        });
    }, [
        handleWidth,
        handleHeight,
        skipResize,
        box
    ]);
    // Throttle/Debounce the resize event if refreshMode is configured
    const resizeHandler = (0, $8NFma.useCallback)($186d05b333a95faf$var$patchResizeCallback(resizeCallback, refreshMode, refreshRate, refreshOptions), [
        resizeCallback,
        refreshMode,
        refreshRate,
        refreshOptions
    ]);
    // Attach ResizeObserver to the element
    (0, $8NFma.useEffect)(()=>{
        let resizeObserver;
        if (refElement) {
            resizeObserver = new window.ResizeObserver(resizeHandler);
            resizeObserver.observe(refElement, observerOptions);
        } else if (size.width || size.height) {
            onResizeRef === null || onResizeRef === void 0 || onResizeRef({
                width: null,
                height: null,
                entry: null
            });
            setSize({
                width: undefined,
                height: undefined
            });
        }
        // Disconnect the ResizeObserver when the component is unmounted
        return ()=>{
            var _a, _b, _c;
            (_a = resizeObserver === null || resizeObserver === void 0 ? void 0 : resizeObserver.disconnect) === null || _a === void 0 || _a.call(resizeObserver);
            (_c = (_b = resizeHandler).cancel) === null || _c === void 0 || _c.call(_b);
        };
    }, [
        resizeHandler,
        refElement
    ]);
    return Object.assign({
        ref: refProxy
    }, size);
}





const $0a574bc6d89559c7$var$LfStyleDefs = {
    breaks: {
        xxsmall: 375,
        xsmall: 414,
        small: 767,
        medium: 1024,
        large: 1200
    },
    fonts: {
        heading: 'VAG Rounded, sans-serif',
        main: 'Muli, sans-serif',
        icons: 'lararforsakringar'
    },
    colors: {
        almostBlack: '#182329',
        blueBackground: '#0068bd',
        blueButtonLighter: '#4388C3',
        blueButtonDarker: '#2B69A9',
        grayText: '#8b9194',
        grayBorder: '#dbdee0',
        grayBackground: '#fcfcfc',
        grayBackgroundDarker: '#f5f5f5',
        grayBackgroundDarkest: '#ececec',
        green: '#00873F',
        greenFifty: '#80C39F',
        orange: '#b03b00',
        error: '#cf3d79',
        lightError: '#f79ac0'
    },
    iconCodes: {
        facebook: '\\e900',
        twitter: '\\e901',
        search: '\\e926',
        arrowDown: '\\e902',
        arrowLeft: '\\e903',
        arrowRight: '\\e904',
        arrowUp: '\\e905',
        arrowUpDown: '\\e911',
        checkCircle: '\\e906',
        check: '\\e907',
        chevDown: '\\e908',
        chevLeft: '\\e909',
        chevRight: '\\e90a',
        chevUp: '\\e90b',
        downloadCircleFilled: '\\e90c',
        downloadCircle: '\\e90d',
        download: '\\e90e',
        gridIcon: '\\e90f',
        healthCross: '\\e910',
        heart: '\\e911',
        home: '\\e912',
        informationIcon: '\\e914',
        iconSearch: '\\e926',
        iconSignOut: '\\e927',
        iconX: '\\e93d',
        lararforbundet: '\\e929',
        lararnasriksforbund: '\\e93b',
        iconExternalLink: '\\e92a',
        upDownArrow: '\\e913',
        plus: '\\e92e',
        plus2: '\\e930'
    }
};
var $0a574bc6d89559c7$export$2e2bcd8739ae039 = $0a574bc6d89559c7$var$LfStyleDefs;



/**
 * Media query helper - for use in conjunction with react+styled-components, example usage: 
 * 
 * definitions.breaks = {
 *      ...
 *      medium: 1024,
 *      ...
 * }
 * 
 * const Wrapper = styled.div`
 *   width: 100%;
 *   background-color: blue;
 *   ${mediaQuery.medium(`
 *       background-color: red;
 *   `)};
 * `;
 */ const $45d1242a07988139$export$8f880b6e390052fa = Object.keys({
    ...(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).breaks,
    custom: ''
}).reduce((result, sizeName)=>{
    result[sizeName] = (styles, customWidth = null)=>`@media only screen and (max-width: ${customWidth ? customWidth : `${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).breaks[sizeName]}px`}) { ${styles} }`;
    return result;
}, {});
/**
 * Simple clearfix
 */ const $45d1242a07988139$export$8c467e8859fdef13 = ()=>`
    &:after {
        content: "";
        display: table;
        clear: both;
    }
`;
/**
 * Icon helper, se css constant definitions for available icon names 
 */ const $45d1242a07988139$export$74300498d1a9477c = Object.keys((0, $0a574bc6d89559c7$export$2e2bcd8739ae039).iconCodes).reduce((result, iconName)=>{
    result[iconName] = ()=>{
        return `
                content: '${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).iconCodes[iconName]}';
                font-family: '${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.icons}';
                font-weight: normal;
            `;
    };
    return result;
}, {});




var $8NFma = parcelRequire("8NFma");
var $22374b4858edafee$exports = {};
var $af5239f7b6768612$exports = {};
var $6d4bd7a05b42e19a$exports = {};
var $a4afebf11262d5c0$exports = {};

$parcel$export($a4afebf11262d5c0$exports, "linear", () => $a4afebf11262d5c0$export$45db2fc2f15997e7, (v) => $a4afebf11262d5c0$export$45db2fc2f15997e7 = v);
$parcel$export($a4afebf11262d5c0$exports, "inQuad", () => $a4afebf11262d5c0$export$418f331a90850394, (v) => $a4afebf11262d5c0$export$418f331a90850394 = v);
$parcel$export($a4afebf11262d5c0$exports, "outQuad", () => $a4afebf11262d5c0$export$f58614528ce1ca0f, (v) => $a4afebf11262d5c0$export$f58614528ce1ca0f = v);
$parcel$export($a4afebf11262d5c0$exports, "inOutQuad", () => $a4afebf11262d5c0$export$c100883bbabee3f7, (v) => $a4afebf11262d5c0$export$c100883bbabee3f7 = v);
$parcel$export($a4afebf11262d5c0$exports, "inCube", () => $a4afebf11262d5c0$export$61ec7bdc2b29cb9e, (v) => $a4afebf11262d5c0$export$61ec7bdc2b29cb9e = v);
$parcel$export($a4afebf11262d5c0$exports, "outCube", () => $a4afebf11262d5c0$export$4c2ded59ecbc5bba, (v) => $a4afebf11262d5c0$export$4c2ded59ecbc5bba = v);
$parcel$export($a4afebf11262d5c0$exports, "inOutCube", () => $a4afebf11262d5c0$export$def39dc8f7ebad6b, (v) => $a4afebf11262d5c0$export$def39dc8f7ebad6b = v);
$parcel$export($a4afebf11262d5c0$exports, "inQuart", () => $a4afebf11262d5c0$export$3d21461a505d9669, (v) => $a4afebf11262d5c0$export$3d21461a505d9669 = v);
$parcel$export($a4afebf11262d5c0$exports, "outQuart", () => $a4afebf11262d5c0$export$bb6472ca17d5d81c, (v) => $a4afebf11262d5c0$export$bb6472ca17d5d81c = v);
$parcel$export($a4afebf11262d5c0$exports, "inOutQuart", () => $a4afebf11262d5c0$export$92f5a0c2420b7723, (v) => $a4afebf11262d5c0$export$92f5a0c2420b7723 = v);
$parcel$export($a4afebf11262d5c0$exports, "inQuint", () => $a4afebf11262d5c0$export$e44277c3cd3c056, (v) => $a4afebf11262d5c0$export$e44277c3cd3c056 = v);
$parcel$export($a4afebf11262d5c0$exports, "outQuint", () => $a4afebf11262d5c0$export$c2b5994b53a2601, (v) => $a4afebf11262d5c0$export$c2b5994b53a2601 = v);
$parcel$export($a4afebf11262d5c0$exports, "inOutQuint", () => $a4afebf11262d5c0$export$b3f23f922f8fb0fb, (v) => $a4afebf11262d5c0$export$b3f23f922f8fb0fb = v);
$parcel$export($a4afebf11262d5c0$exports, "inSine", () => $a4afebf11262d5c0$export$b8b85ea21fe80b64, (v) => $a4afebf11262d5c0$export$b8b85ea21fe80b64 = v);
$parcel$export($a4afebf11262d5c0$exports, "outSine", () => $a4afebf11262d5c0$export$cef097a6f35c9b6a, (v) => $a4afebf11262d5c0$export$cef097a6f35c9b6a = v);
$parcel$export($a4afebf11262d5c0$exports, "inOutSine", () => $a4afebf11262d5c0$export$3b66c8bd42e4127c, (v) => $a4afebf11262d5c0$export$3b66c8bd42e4127c = v);
$parcel$export($a4afebf11262d5c0$exports, "inExpo", () => $a4afebf11262d5c0$export$c36e93d776b4c647, (v) => $a4afebf11262d5c0$export$c36e93d776b4c647 = v);
$parcel$export($a4afebf11262d5c0$exports, "outExpo", () => $a4afebf11262d5c0$export$658688ca915d76e1, (v) => $a4afebf11262d5c0$export$658688ca915d76e1 = v);
$parcel$export($a4afebf11262d5c0$exports, "inOutExpo", () => $a4afebf11262d5c0$export$b7a9c61e516d1823, (v) => $a4afebf11262d5c0$export$b7a9c61e516d1823 = v);
$parcel$export($a4afebf11262d5c0$exports, "inCirc", () => $a4afebf11262d5c0$export$c53de65d697180bc, (v) => $a4afebf11262d5c0$export$c53de65d697180bc = v);
$parcel$export($a4afebf11262d5c0$exports, "outCirc", () => $a4afebf11262d5c0$export$2f3c12cb6b6f5b16, (v) => $a4afebf11262d5c0$export$2f3c12cb6b6f5b16 = v);
$parcel$export($a4afebf11262d5c0$exports, "inOutCirc", () => $a4afebf11262d5c0$export$4c85969b52260a91, (v) => $a4afebf11262d5c0$export$4c85969b52260a91 = v);
$parcel$export($a4afebf11262d5c0$exports, "inBack", () => $a4afebf11262d5c0$export$e38aa6d936f277b2, (v) => $a4afebf11262d5c0$export$e38aa6d936f277b2 = v);
$parcel$export($a4afebf11262d5c0$exports, "outBack", () => $a4afebf11262d5c0$export$bcede31c95c9ee9, (v) => $a4afebf11262d5c0$export$bcede31c95c9ee9 = v);
$parcel$export($a4afebf11262d5c0$exports, "inOutBack", () => $a4afebf11262d5c0$export$cb7af22dffdedde, (v) => $a4afebf11262d5c0$export$cb7af22dffdedde = v);
$parcel$export($a4afebf11262d5c0$exports, "inBounce", () => $a4afebf11262d5c0$export$bf09a266620a0c03, (v) => $a4afebf11262d5c0$export$bf09a266620a0c03 = v);
$parcel$export($a4afebf11262d5c0$exports, "outBounce", () => $a4afebf11262d5c0$export$9138992b597e3e5c, (v) => $a4afebf11262d5c0$export$9138992b597e3e5c = v);
$parcel$export($a4afebf11262d5c0$exports, "inOutBounce", () => $a4afebf11262d5c0$export$a28277282d497a29, (v) => $a4afebf11262d5c0$export$a28277282d497a29 = v);
$parcel$export($a4afebf11262d5c0$exports, "inElastic", () => $a4afebf11262d5c0$export$e412010d8652bc3e, (v) => $a4afebf11262d5c0$export$e412010d8652bc3e = v);
$parcel$export($a4afebf11262d5c0$exports, "outElastic", () => $a4afebf11262d5c0$export$44c6bbd772ed246f, (v) => $a4afebf11262d5c0$export$44c6bbd772ed246f = v);
$parcel$export($a4afebf11262d5c0$exports, "inOutElastic", () => $a4afebf11262d5c0$export$5589b45d2ec771ca, (v) => $a4afebf11262d5c0$export$5589b45d2ec771ca = v);
$parcel$export($a4afebf11262d5c0$exports, "in-quad", () => $a4afebf11262d5c0$export$a1cddc65d22701f0, (v) => $a4afebf11262d5c0$export$a1cddc65d22701f0 = v);
$parcel$export($a4afebf11262d5c0$exports, "out-quad", () => $a4afebf11262d5c0$export$5b3551f15ae55827, (v) => $a4afebf11262d5c0$export$5b3551f15ae55827 = v);
$parcel$export($a4afebf11262d5c0$exports, "in-out-quad", () => $a4afebf11262d5c0$export$318b9145208b55a9, (v) => $a4afebf11262d5c0$export$318b9145208b55a9 = v);
$parcel$export($a4afebf11262d5c0$exports, "in-cube", () => $a4afebf11262d5c0$export$c72fbaca3b3e8af8, (v) => $a4afebf11262d5c0$export$c72fbaca3b3e8af8 = v);
$parcel$export($a4afebf11262d5c0$exports, "out-cube", () => $a4afebf11262d5c0$export$ebf75a969f1a2188, (v) => $a4afebf11262d5c0$export$ebf75a969f1a2188 = v);
$parcel$export($a4afebf11262d5c0$exports, "in-out-cube", () => $a4afebf11262d5c0$export$ccfb00a026b6f7cf, (v) => $a4afebf11262d5c0$export$ccfb00a026b6f7cf = v);
$parcel$export($a4afebf11262d5c0$exports, "in-quart", () => $a4afebf11262d5c0$export$fbbe20c3eb762997, (v) => $a4afebf11262d5c0$export$fbbe20c3eb762997 = v);
$parcel$export($a4afebf11262d5c0$exports, "out-quart", () => $a4afebf11262d5c0$export$5a2d91a05069d006, (v) => $a4afebf11262d5c0$export$5a2d91a05069d006 = v);
$parcel$export($a4afebf11262d5c0$exports, "in-out-quart", () => $a4afebf11262d5c0$export$b7fb5d0517fa47e0, (v) => $a4afebf11262d5c0$export$b7fb5d0517fa47e0 = v);
$parcel$export($a4afebf11262d5c0$exports, "in-quint", () => $a4afebf11262d5c0$export$b6075dfe7d89188c, (v) => $a4afebf11262d5c0$export$b6075dfe7d89188c = v);
$parcel$export($a4afebf11262d5c0$exports, "out-quint", () => $a4afebf11262d5c0$export$5e281c7a013bb025, (v) => $a4afebf11262d5c0$export$5e281c7a013bb025 = v);
$parcel$export($a4afebf11262d5c0$exports, "in-out-quint", () => $a4afebf11262d5c0$export$195fabf35383b3d4, (v) => $a4afebf11262d5c0$export$195fabf35383b3d4 = v);
$parcel$export($a4afebf11262d5c0$exports, "in-sine", () => $a4afebf11262d5c0$export$50c99a696ec8acf7, (v) => $a4afebf11262d5c0$export$50c99a696ec8acf7 = v);
$parcel$export($a4afebf11262d5c0$exports, "out-sine", () => $a4afebf11262d5c0$export$d741d49e5c025f8c, (v) => $a4afebf11262d5c0$export$d741d49e5c025f8c = v);
$parcel$export($a4afebf11262d5c0$exports, "in-out-sine", () => $a4afebf11262d5c0$export$7f5393135ad69509, (v) => $a4afebf11262d5c0$export$7f5393135ad69509 = v);
$parcel$export($a4afebf11262d5c0$exports, "in-expo", () => $a4afebf11262d5c0$export$a08adfe40f2aebf0, (v) => $a4afebf11262d5c0$export$a08adfe40f2aebf0 = v);
$parcel$export($a4afebf11262d5c0$exports, "out-expo", () => $a4afebf11262d5c0$export$60a8087447276f8d, (v) => $a4afebf11262d5c0$export$60a8087447276f8d = v);
$parcel$export($a4afebf11262d5c0$exports, "in-out-expo", () => $a4afebf11262d5c0$export$8f5fdd7ace16d5c0, (v) => $a4afebf11262d5c0$export$8f5fdd7ace16d5c0 = v);
$parcel$export($a4afebf11262d5c0$exports, "in-circ", () => $a4afebf11262d5c0$export$6f0fe67bc97c1e67, (v) => $a4afebf11262d5c0$export$6f0fe67bc97c1e67 = v);
$parcel$export($a4afebf11262d5c0$exports, "out-circ", () => $a4afebf11262d5c0$export$4faaec9352662124, (v) => $a4afebf11262d5c0$export$4faaec9352662124 = v);
$parcel$export($a4afebf11262d5c0$exports, "in-out-circ", () => $a4afebf11262d5c0$export$d6f8a8e1903140b2, (v) => $a4afebf11262d5c0$export$d6f8a8e1903140b2 = v);
$parcel$export($a4afebf11262d5c0$exports, "in-back", () => $a4afebf11262d5c0$export$244752ea1996a3d8, (v) => $a4afebf11262d5c0$export$244752ea1996a3d8 = v);
$parcel$export($a4afebf11262d5c0$exports, "out-back", () => $a4afebf11262d5c0$export$8ae8024afddee641, (v) => $a4afebf11262d5c0$export$8ae8024afddee641 = v);
$parcel$export($a4afebf11262d5c0$exports, "in-out-back", () => $a4afebf11262d5c0$export$912f13c58e8ecfe3, (v) => $a4afebf11262d5c0$export$912f13c58e8ecfe3 = v);
$parcel$export($a4afebf11262d5c0$exports, "in-bounce", () => $a4afebf11262d5c0$export$d9c88faa90d08718, (v) => $a4afebf11262d5c0$export$d9c88faa90d08718 = v);
$parcel$export($a4afebf11262d5c0$exports, "out-bounce", () => $a4afebf11262d5c0$export$c98b7275ae28b699, (v) => $a4afebf11262d5c0$export$c98b7275ae28b699 = v);
$parcel$export($a4afebf11262d5c0$exports, "in-out-bounce", () => $a4afebf11262d5c0$export$c10ec19ba8a1d71b, (v) => $a4afebf11262d5c0$export$c10ec19ba8a1d71b = v);
$parcel$export($a4afebf11262d5c0$exports, "in-elastic", () => $a4afebf11262d5c0$export$851b37f8b4636772, (v) => $a4afebf11262d5c0$export$851b37f8b4636772 = v);
$parcel$export($a4afebf11262d5c0$exports, "out-elastic", () => $a4afebf11262d5c0$export$9a9e1c182cbb2f62, (v) => $a4afebf11262d5c0$export$9a9e1c182cbb2f62 = v);
$parcel$export($a4afebf11262d5c0$exports, "in-out-elastic", () => $a4afebf11262d5c0$export$a199a95bda036e40, (v) => $a4afebf11262d5c0$export$a199a95bda036e40 = v);
// easing functions from "Tween.js"
var $a4afebf11262d5c0$export$45db2fc2f15997e7;
var $a4afebf11262d5c0$export$418f331a90850394;
var $a4afebf11262d5c0$export$f58614528ce1ca0f;
var $a4afebf11262d5c0$export$c100883bbabee3f7;
var $a4afebf11262d5c0$export$61ec7bdc2b29cb9e;
var $a4afebf11262d5c0$export$4c2ded59ecbc5bba;
var $a4afebf11262d5c0$export$def39dc8f7ebad6b;
var $a4afebf11262d5c0$export$3d21461a505d9669;
var $a4afebf11262d5c0$export$bb6472ca17d5d81c;
var $a4afebf11262d5c0$export$92f5a0c2420b7723;
var $a4afebf11262d5c0$export$e44277c3cd3c056;
var $a4afebf11262d5c0$export$c2b5994b53a2601;
var $a4afebf11262d5c0$export$b3f23f922f8fb0fb;
var $a4afebf11262d5c0$export$b8b85ea21fe80b64;
var $a4afebf11262d5c0$export$cef097a6f35c9b6a;
var $a4afebf11262d5c0$export$3b66c8bd42e4127c;
var $a4afebf11262d5c0$export$c36e93d776b4c647;
var $a4afebf11262d5c0$export$658688ca915d76e1;
var $a4afebf11262d5c0$export$b7a9c61e516d1823;
var $a4afebf11262d5c0$export$c53de65d697180bc;
var $a4afebf11262d5c0$export$2f3c12cb6b6f5b16;
var $a4afebf11262d5c0$export$4c85969b52260a91;
var $a4afebf11262d5c0$export$e38aa6d936f277b2;
var $a4afebf11262d5c0$export$bcede31c95c9ee9;
var $a4afebf11262d5c0$export$cb7af22dffdedde;
var $a4afebf11262d5c0$export$bf09a266620a0c03;
var $a4afebf11262d5c0$export$9138992b597e3e5c;
var $a4afebf11262d5c0$export$a28277282d497a29;
var $a4afebf11262d5c0$export$e412010d8652bc3e;
var $a4afebf11262d5c0$export$44c6bbd772ed246f;
var $a4afebf11262d5c0$export$5589b45d2ec771ca;
// aliases
var $a4afebf11262d5c0$export$a1cddc65d22701f0;
var $a4afebf11262d5c0$export$5b3551f15ae55827;
var $a4afebf11262d5c0$export$318b9145208b55a9;
var $a4afebf11262d5c0$export$c72fbaca3b3e8af8;
var $a4afebf11262d5c0$export$ebf75a969f1a2188;
var $a4afebf11262d5c0$export$ccfb00a026b6f7cf;
var $a4afebf11262d5c0$export$fbbe20c3eb762997;
var $a4afebf11262d5c0$export$5a2d91a05069d006;
var $a4afebf11262d5c0$export$b7fb5d0517fa47e0;
var $a4afebf11262d5c0$export$b6075dfe7d89188c;
var $a4afebf11262d5c0$export$5e281c7a013bb025;
var $a4afebf11262d5c0$export$195fabf35383b3d4;
var $a4afebf11262d5c0$export$50c99a696ec8acf7;
var $a4afebf11262d5c0$export$d741d49e5c025f8c;
var $a4afebf11262d5c0$export$7f5393135ad69509;
var $a4afebf11262d5c0$export$a08adfe40f2aebf0;
var $a4afebf11262d5c0$export$60a8087447276f8d;
var $a4afebf11262d5c0$export$8f5fdd7ace16d5c0;
var $a4afebf11262d5c0$export$6f0fe67bc97c1e67;
var $a4afebf11262d5c0$export$4faaec9352662124;
var $a4afebf11262d5c0$export$d6f8a8e1903140b2;
var $a4afebf11262d5c0$export$244752ea1996a3d8;
var $a4afebf11262d5c0$export$8ae8024afddee641;
var $a4afebf11262d5c0$export$912f13c58e8ecfe3;
var $a4afebf11262d5c0$export$d9c88faa90d08718;
var $a4afebf11262d5c0$export$c98b7275ae28b699;
var $a4afebf11262d5c0$export$c10ec19ba8a1d71b;
var $a4afebf11262d5c0$export$851b37f8b4636772;
var $a4afebf11262d5c0$export$9a9e1c182cbb2f62;
var $a4afebf11262d5c0$export$a199a95bda036e40;
$a4afebf11262d5c0$export$45db2fc2f15997e7 = function(n) {
    return n;
};
$a4afebf11262d5c0$export$418f331a90850394 = function(n) {
    return n * n;
};
$a4afebf11262d5c0$export$f58614528ce1ca0f = function(n) {
    return n * (2 - n);
};
$a4afebf11262d5c0$export$c100883bbabee3f7 = function(n) {
    n *= 2;
    if (n < 1) return 0.5 * n * n;
    return -0.5 * (--n * (n - 2) - 1);
};
$a4afebf11262d5c0$export$61ec7bdc2b29cb9e = function(n) {
    return n * n * n;
};
$a4afebf11262d5c0$export$4c2ded59ecbc5bba = function(n) {
    return --n * n * n + 1;
};
$a4afebf11262d5c0$export$def39dc8f7ebad6b = function(n) {
    n *= 2;
    if (n < 1) return 0.5 * n * n * n;
    return 0.5 * ((n -= 2) * n * n + 2);
};
$a4afebf11262d5c0$export$3d21461a505d9669 = function(n) {
    return n * n * n * n;
};
$a4afebf11262d5c0$export$bb6472ca17d5d81c = function(n) {
    return 1 - --n * n * n * n;
};
$a4afebf11262d5c0$export$92f5a0c2420b7723 = function(n) {
    n *= 2;
    if (n < 1) return 0.5 * n * n * n * n;
    return -0.5 * ((n -= 2) * n * n * n - 2);
};
$a4afebf11262d5c0$export$e44277c3cd3c056 = function(n) {
    return n * n * n * n * n;
};
$a4afebf11262d5c0$export$c2b5994b53a2601 = function(n) {
    return --n * n * n * n * n + 1;
};
$a4afebf11262d5c0$export$b3f23f922f8fb0fb = function(n) {
    n *= 2;
    if (n < 1) return 0.5 * n * n * n * n * n;
    return 0.5 * ((n -= 2) * n * n * n * n + 2);
};
$a4afebf11262d5c0$export$b8b85ea21fe80b64 = function(n) {
    return 1 - Math.cos(n * Math.PI / 2);
};
$a4afebf11262d5c0$export$cef097a6f35c9b6a = function(n) {
    return Math.sin(n * Math.PI / 2);
};
$a4afebf11262d5c0$export$3b66c8bd42e4127c = function(n) {
    return .5 * (1 - Math.cos(Math.PI * n));
};
$a4afebf11262d5c0$export$c36e93d776b4c647 = function(n) {
    return 0 == n ? 0 : Math.pow(1024, n - 1);
};
$a4afebf11262d5c0$export$658688ca915d76e1 = function(n) {
    return 1 == n ? n : 1 - Math.pow(2, -10 * n);
};
$a4afebf11262d5c0$export$b7a9c61e516d1823 = function(n) {
    if (0 == n) return 0;
    if (1 == n) return 1;
    if ((n *= 2) < 1) return .5 * Math.pow(1024, n - 1);
    return .5 * (-Math.pow(2, -10 * (n - 1)) + 2);
};
$a4afebf11262d5c0$export$c53de65d697180bc = function(n) {
    return 1 - Math.sqrt(1 - n * n);
};
$a4afebf11262d5c0$export$2f3c12cb6b6f5b16 = function(n) {
    return Math.sqrt(1 - --n * n);
};
$a4afebf11262d5c0$export$4c85969b52260a91 = function(n) {
    n *= 2;
    if (n < 1) return -0.5 * (Math.sqrt(1 - n * n) - 1);
    return 0.5 * (Math.sqrt(1 - (n -= 2) * n) + 1);
};
$a4afebf11262d5c0$export$e38aa6d936f277b2 = function(n) {
    var s = 1.70158;
    return n * n * ((s + 1) * n - s);
};
$a4afebf11262d5c0$export$bcede31c95c9ee9 = function(n) {
    var s = 1.70158;
    return --n * n * ((s + 1) * n + s) + 1;
};
$a4afebf11262d5c0$export$cb7af22dffdedde = function(n) {
    var s = 2.5949095;
    if ((n *= 2) < 1) return 0.5 * (n * n * ((s + 1) * n - s));
    return 0.5 * ((n -= 2) * n * ((s + 1) * n + s) + 2);
};
$a4afebf11262d5c0$export$bf09a266620a0c03 = function(n) {
    return 1 - $a4afebf11262d5c0$export$9138992b597e3e5c(1 - n);
};
$a4afebf11262d5c0$export$9138992b597e3e5c = function(n) {
    if (n < 1 / 2.75) return 7.5625 * n * n;
    else if (n < 2 / 2.75) return 7.5625 * (n -= 1.5 / 2.75) * n + 0.75;
    else if (n < 2.5 / 2.75) return 7.5625 * (n -= 2.25 / 2.75) * n + 0.9375;
    else return 7.5625 * (n -= 2.625 / 2.75) * n + 0.984375;
};
$a4afebf11262d5c0$export$a28277282d497a29 = function(n) {
    if (n < .5) return $a4afebf11262d5c0$export$bf09a266620a0c03(n * 2) * .5;
    return $a4afebf11262d5c0$export$9138992b597e3e5c(n * 2 - 1) * .5 + .5;
};
$a4afebf11262d5c0$export$e412010d8652bc3e = function(n) {
    var s, a = 0.1, p = 0.4;
    if (n === 0) return 0;
    if (n === 1) return 1;
    if (!a || a < 1) {
        a = 1;
        s = p / 4;
    } else s = p * Math.asin(1 / a) / (2 * Math.PI);
    return -(a * Math.pow(2, 10 * (n -= 1)) * Math.sin((n - s) * (2 * Math.PI) / p));
};
$a4afebf11262d5c0$export$44c6bbd772ed246f = function(n) {
    var s, a = 0.1, p = 0.4;
    if (n === 0) return 0;
    if (n === 1) return 1;
    if (!a || a < 1) {
        a = 1;
        s = p / 4;
    } else s = p * Math.asin(1 / a) / (2 * Math.PI);
    return a * Math.pow(2, -10 * n) * Math.sin((n - s) * (2 * Math.PI) / p) + 1;
};
$a4afebf11262d5c0$export$5589b45d2ec771ca = function(n) {
    var s, a = 0.1, p = 0.4;
    if (n === 0) return 0;
    if (n === 1) return 1;
    if (!a || a < 1) {
        a = 1;
        s = p / 4;
    } else s = p * Math.asin(1 / a) / (2 * Math.PI);
    if ((n *= 2) < 1) return -0.5 * (a * Math.pow(2, 10 * (n -= 1)) * Math.sin((n - s) * (2 * Math.PI) / p));
    return a * Math.pow(2, -10 * (n -= 1)) * Math.sin((n - s) * (2 * Math.PI) / p) * 0.5 + 1;
};
$a4afebf11262d5c0$export$a1cddc65d22701f0 = $a4afebf11262d5c0$export$418f331a90850394;
$a4afebf11262d5c0$export$5b3551f15ae55827 = $a4afebf11262d5c0$export$f58614528ce1ca0f;
$a4afebf11262d5c0$export$318b9145208b55a9 = $a4afebf11262d5c0$export$c100883bbabee3f7;
$a4afebf11262d5c0$export$c72fbaca3b3e8af8 = $a4afebf11262d5c0$export$61ec7bdc2b29cb9e;
$a4afebf11262d5c0$export$ebf75a969f1a2188 = $a4afebf11262d5c0$export$4c2ded59ecbc5bba;
$a4afebf11262d5c0$export$ccfb00a026b6f7cf = $a4afebf11262d5c0$export$def39dc8f7ebad6b;
$a4afebf11262d5c0$export$fbbe20c3eb762997 = $a4afebf11262d5c0$export$3d21461a505d9669;
$a4afebf11262d5c0$export$5a2d91a05069d006 = $a4afebf11262d5c0$export$bb6472ca17d5d81c;
$a4afebf11262d5c0$export$b7fb5d0517fa47e0 = $a4afebf11262d5c0$export$92f5a0c2420b7723;
$a4afebf11262d5c0$export$b6075dfe7d89188c = $a4afebf11262d5c0$export$e44277c3cd3c056;
$a4afebf11262d5c0$export$5e281c7a013bb025 = $a4afebf11262d5c0$export$c2b5994b53a2601;
$a4afebf11262d5c0$export$195fabf35383b3d4 = $a4afebf11262d5c0$export$b3f23f922f8fb0fb;
$a4afebf11262d5c0$export$50c99a696ec8acf7 = $a4afebf11262d5c0$export$b8b85ea21fe80b64;
$a4afebf11262d5c0$export$d741d49e5c025f8c = $a4afebf11262d5c0$export$cef097a6f35c9b6a;
$a4afebf11262d5c0$export$7f5393135ad69509 = $a4afebf11262d5c0$export$3b66c8bd42e4127c;
$a4afebf11262d5c0$export$a08adfe40f2aebf0 = $a4afebf11262d5c0$export$c36e93d776b4c647;
$a4afebf11262d5c0$export$60a8087447276f8d = $a4afebf11262d5c0$export$658688ca915d76e1;
$a4afebf11262d5c0$export$8f5fdd7ace16d5c0 = $a4afebf11262d5c0$export$b7a9c61e516d1823;
$a4afebf11262d5c0$export$6f0fe67bc97c1e67 = $a4afebf11262d5c0$export$c53de65d697180bc;
$a4afebf11262d5c0$export$4faaec9352662124 = $a4afebf11262d5c0$export$2f3c12cb6b6f5b16;
$a4afebf11262d5c0$export$d6f8a8e1903140b2 = $a4afebf11262d5c0$export$4c85969b52260a91;
$a4afebf11262d5c0$export$244752ea1996a3d8 = $a4afebf11262d5c0$export$e38aa6d936f277b2;
$a4afebf11262d5c0$export$8ae8024afddee641 = $a4afebf11262d5c0$export$bcede31c95c9ee9;
$a4afebf11262d5c0$export$912f13c58e8ecfe3 = $a4afebf11262d5c0$export$cb7af22dffdedde;
$a4afebf11262d5c0$export$d9c88faa90d08718 = $a4afebf11262d5c0$export$bf09a266620a0c03;
$a4afebf11262d5c0$export$c98b7275ae28b699 = $a4afebf11262d5c0$export$9138992b597e3e5c;
$a4afebf11262d5c0$export$c10ec19ba8a1d71b = $a4afebf11262d5c0$export$a28277282d497a29;
$a4afebf11262d5c0$export$851b37f8b4636772 = $a4afebf11262d5c0$export$e412010d8652bc3e;
$a4afebf11262d5c0$export$9a9e1c182cbb2f62 = $a4afebf11262d5c0$export$44c6bbd772ed246f;
$a4afebf11262d5c0$export$a199a95bda036e40 = $a4afebf11262d5c0$export$5589b45d2ec771ca;


var $ffb7e7103ca02b01$exports = {};
function $ffb7e7103ca02b01$var$Emitter(obj) {
    if (obj) return $ffb7e7103ca02b01$var$mixin(obj);
}
function $ffb7e7103ca02b01$var$mixin(obj) {
    for(var key in $ffb7e7103ca02b01$var$Emitter.prototype)obj[key] = $ffb7e7103ca02b01$var$Emitter.prototype[key];
    return obj;
}
$ffb7e7103ca02b01$var$Emitter.prototype.on = $ffb7e7103ca02b01$var$Emitter.prototype.addEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    (this._callbacks['$' + event] = this._callbacks['$' + event] || []).push(fn);
    return this;
};
$ffb7e7103ca02b01$var$Emitter.prototype.once = function(event, fn) {
    function on() {
        this.off(event, on);
        fn.apply(this, arguments);
    }
    on.fn = fn;
    this.on(event, on);
    return this;
};
$ffb7e7103ca02b01$var$Emitter.prototype.off = $ffb7e7103ca02b01$var$Emitter.prototype.removeListener = $ffb7e7103ca02b01$var$Emitter.prototype.removeAllListeners = $ffb7e7103ca02b01$var$Emitter.prototype.removeEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    // all
    if (0 == arguments.length) {
        this._callbacks = {};
        return this;
    }
    // specific event
    var callbacks = this._callbacks['$' + event];
    if (!callbacks) return this;
    // remove all handlers
    if (1 == arguments.length) {
        delete this._callbacks['$' + event];
        return this;
    }
    // remove specific handler
    var cb;
    for(var i = 0; i < callbacks.length; i++){
        cb = callbacks[i];
        if (cb === fn || cb.fn === fn) {
            callbacks.splice(i, 1);
            break;
        }
    }
    // Remove event specific arrays for event types that no
    // one is subscribed for to avoid memory leak.
    if (callbacks.length === 0) delete this._callbacks['$' + event];
    return this;
};
$ffb7e7103ca02b01$var$Emitter.prototype.emit = function(event) {
    this._callbacks = this._callbacks || {};
    var args = [].slice.call(arguments, 1), callbacks = this._callbacks['$' + event];
    if (callbacks) {
        callbacks = callbacks.slice(0);
        for(var i = 0, len = callbacks.length; i < len; ++i)callbacks[i].apply(this, args);
    }
    return this;
};
$ffb7e7103ca02b01$var$Emitter.prototype.listeners = function(event) {
    this._callbacks = this._callbacks || {};
    return this._callbacks['$' + event] || [];
};
$ffb7e7103ca02b01$var$Emitter.prototype.hasListeners = function(event) {
    return !!this.listeners(event).length;
};
$ffb7e7103ca02b01$exports = $ffb7e7103ca02b01$var$Emitter;


function $6d4bd7a05b42e19a$var$extend(obj, src) {
    for(var key in src)if (src.hasOwnProperty(key)) obj[key] = src[key];
    return obj;
}
function $6d4bd7a05b42e19a$var$Tween(obj) {
    if (!(this instanceof $6d4bd7a05b42e19a$var$Tween)) return new $6d4bd7a05b42e19a$var$Tween(obj);
    this._from = obj;
    this.ease('linear');
    this.duration(500);
}
$ffb7e7103ca02b01$exports($6d4bd7a05b42e19a$var$Tween.prototype);
$6d4bd7a05b42e19a$var$Tween.prototype.reset = function() {
    this.isArray = Object.prototype.toString.call(this._from) === '[object Array]';
    this._curr = $6d4bd7a05b42e19a$var$extend({}, this._from);
    this._done = false;
    this._start = Date.now();
    return this;
};
$6d4bd7a05b42e19a$var$Tween.prototype.to = function(obj) {
    this.reset();
    this._to = obj;
    return this;
};
$6d4bd7a05b42e19a$var$Tween.prototype.duration = function(ms) {
    this._duration = ms;
    return this;
};
$6d4bd7a05b42e19a$var$Tween.prototype.ease = function(fn) {
    fn = 'function' == typeof fn ? fn : $a4afebf11262d5c0$exports[fn];
    if (!fn) throw new TypeError('invalid easing function');
    this._ease = fn;
    return this;
};
$6d4bd7a05b42e19a$var$Tween.prototype.stop = function() {
    this.stopped = true;
    this._done = true;
    this.emit('stop');
    this.emit('end');
    return this;
};
$6d4bd7a05b42e19a$var$Tween.prototype.step = function() {
    if (this._done) return;
    var duration = this._duration;
    var now = Date.now();
    var delta = now - this._start;
    var done = delta >= duration;
    if (done) {
        this._from = this._to;
        this._update(this._to);
        this._done = true;
        this.emit('end');
        return this;
    }
    var from = this._from;
    var to = this._to;
    var curr = this._curr;
    var fn = this._ease;
    var p = (now - this._start) / duration;
    var n = fn(p);
    if (this.isArray) {
        for(var i = 0; i < from.length; ++i)curr[i] = from[i] + (to[i] - from[i]) * n;
        this._update(curr);
        return this;
    }
    for(var k in from)curr[k] = from[k] + (to[k] - from[k]) * n;
    this._update(curr);
    return this;
};
$6d4bd7a05b42e19a$var$Tween.prototype.update = function(fn) {
    if (0 == arguments.length) return this.step();
    this._update = fn;
    return this;
};
$6d4bd7a05b42e19a$exports = $6d4bd7a05b42e19a$var$Tween;


var $a9334679fceb5904$exports = {};
var $d78d660f0965e541$exports = {};

// Generated by CoffeeScript 1.12.2
(function() {
    var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
    if (typeof performance !== "undefined" && performance !== null && performance.now) $d78d660f0965e541$exports = function() {
        return performance.now();
    };
    else if (typeof $d3c1734dacb01657$exports !== "undefined" && $d3c1734dacb01657$exports !== null && $d3c1734dacb01657$exports.hrtime) {
        $d78d660f0965e541$exports = function() {
            return (getNanoSeconds() - nodeLoadTime) / 1e6;
        };
        hrtime = $d3c1734dacb01657$exports.hrtime;
        getNanoSeconds = function() {
            var hr;
            hr = hrtime();
            return hr[0] * 1e9 + hr[1];
        };
        moduleLoadTime = getNanoSeconds();
        upTime = $d3c1734dacb01657$exports.uptime() * 1e9;
        nodeLoadTime = moduleLoadTime - upTime;
    } else if (Date.now) {
        $d78d660f0965e541$exports = function() {
            return Date.now() - loadTime;
        };
        loadTime = Date.now();
    } else {
        $d78d660f0965e541$exports = function() {
            return new Date().getTime() - loadTime;
        };
        loadTime = new Date().getTime();
    }
}).call($d78d660f0965e541$exports);


var $a9334679fceb5904$var$root = typeof window === 'undefined' ? $parcel$global : window, $a9334679fceb5904$var$vendors = [
    'moz',
    'webkit'
], $a9334679fceb5904$var$suffix = 'AnimationFrame', $a9334679fceb5904$var$raf = $a9334679fceb5904$var$root['request' + $a9334679fceb5904$var$suffix], $a9334679fceb5904$var$caf = $a9334679fceb5904$var$root['cancel' + $a9334679fceb5904$var$suffix] || $a9334679fceb5904$var$root['cancelRequest' + $a9334679fceb5904$var$suffix];
for(var $a9334679fceb5904$var$i = 0; !$a9334679fceb5904$var$raf && $a9334679fceb5904$var$i < $a9334679fceb5904$var$vendors.length; $a9334679fceb5904$var$i++){
    $a9334679fceb5904$var$raf = $a9334679fceb5904$var$root[$a9334679fceb5904$var$vendors[$a9334679fceb5904$var$i] + 'Request' + $a9334679fceb5904$var$suffix];
    $a9334679fceb5904$var$caf = $a9334679fceb5904$var$root[$a9334679fceb5904$var$vendors[$a9334679fceb5904$var$i] + 'Cancel' + $a9334679fceb5904$var$suffix] || $a9334679fceb5904$var$root[$a9334679fceb5904$var$vendors[$a9334679fceb5904$var$i] + 'CancelRequest' + $a9334679fceb5904$var$suffix];
}
// Some versions of FF have rAF but not cAF
if (!$a9334679fceb5904$var$raf || !$a9334679fceb5904$var$caf) {
    var $a9334679fceb5904$var$last = 0, $a9334679fceb5904$var$id = 0, $a9334679fceb5904$var$queue = [], $a9334679fceb5904$var$frameDuration = 1000 / 60;
    $a9334679fceb5904$var$raf = function(callback) {
        if ($a9334679fceb5904$var$queue.length === 0) {
            var _now = $d78d660f0965e541$exports(), next = Math.max(0, $a9334679fceb5904$var$frameDuration - (_now - $a9334679fceb5904$var$last));
            $a9334679fceb5904$var$last = next + _now;
            setTimeout(function() {
                var cp = $a9334679fceb5904$var$queue.slice(0);
                // Clear queue here to prevent
                // callbacks from appending listeners
                // to the current frame's queue
                $a9334679fceb5904$var$queue.length = 0;
                for(var i = 0; i < cp.length; i++){
                    if (!cp[i].cancelled) try {
                        cp[i].callback($a9334679fceb5904$var$last);
                    } catch (e) {
                        setTimeout(function() {
                            throw e;
                        }, 0);
                    }
                }
            }, Math.round(next));
        }
        $a9334679fceb5904$var$queue.push({
            handle: ++$a9334679fceb5904$var$id,
            callback: callback,
            cancelled: false
        });
        return $a9334679fceb5904$var$id;
    };
    $a9334679fceb5904$var$caf = function(handle) {
        for(var i = 0; i < $a9334679fceb5904$var$queue.length; i++)if ($a9334679fceb5904$var$queue[i].handle === handle) $a9334679fceb5904$var$queue[i].cancelled = true;
    };
}
$a9334679fceb5904$exports = function(fn) {
    // Wrap in a new function to prevent
    // `cancel` potentially being assigned
    // to the native rAF function
    return $a9334679fceb5904$var$raf.call($a9334679fceb5904$var$root, fn);
};
$a9334679fceb5904$exports.cancel = function() {
    $a9334679fceb5904$var$caf.apply($a9334679fceb5904$var$root, arguments);
};
$a9334679fceb5904$exports.polyfill = function(object) {
    if (!object) object = $a9334679fceb5904$var$root;
    object.requestAnimationFrame = $a9334679fceb5904$var$raf;
    object.cancelAnimationFrame = $a9334679fceb5904$var$caf;
};


function $af5239f7b6768612$var$scroll() {
    var y = window.pageYOffset || document.documentElement.scrollTop;
    var x = window.pageXOffset || document.documentElement.scrollLeft;
    return {
        top: y,
        left: x
    };
}
function $af5239f7b6768612$var$scrollTo(x, y, options) {
    options = options || {};
    // start position
    var start = $af5239f7b6768612$var$scroll();
    // setup tween
    var tween = $6d4bd7a05b42e19a$exports(start).ease(options.ease || 'out-circ').to({
        top: y,
        left: x
    }).duration(options.duration || 1000);
    // scroll
    tween.update(function(o) {
        window.scrollTo(o.left | 0, o.top | 0);
    });
    // handle end
    tween.on('end', function() {
        animate = function() {};
    });
    // animate
    function animate() {
        $a9334679fceb5904$exports(animate);
        tween.update();
    }
    animate();
    return tween;
}
$af5239f7b6768612$exports = $af5239f7b6768612$var$scrollTo;


function $22374b4858edafee$var$calculateScrollOffset(elem, additionalOffset, alignment) {
    var body = document.body, html = document.documentElement;
    var elemRect = elem.getBoundingClientRect();
    var clientHeight = html.clientHeight;
    var documentHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
    additionalOffset = additionalOffset || 0;
    var scrollPosition;
    if (alignment === 'bottom') scrollPosition = elemRect.bottom - clientHeight;
    else if (alignment === 'middle') scrollPosition = elemRect.bottom - clientHeight / 2 - elemRect.height / 2;
    else scrollPosition = elemRect.top;
    var maxScrollPosition = documentHeight - clientHeight;
    return Math.min(scrollPosition + additionalOffset + window.pageYOffset, maxScrollPosition);
}
$22374b4858edafee$exports = function(elem, options) {
    options = options || {};
    if (typeof elem === 'string') elem = document.querySelector(elem);
    if (elem) return $af5239f7b6768612$exports(0, $22374b4858edafee$var$calculateScrollOffset(elem, options.offset, options.align), options);
};


function $c657a2af5c9e1b33$export$f5d3771428a1f489(duration = 100) {
    return new Promise((resolve)=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($22374b4858edafee$exports)))('header', {
            offset: 0,
            duration: duration
        });
        setTimeout(resolve, duration);
    });
}
function $c657a2af5c9e1b33$export$2353115f31f4d15(el, duration = 100) {
    return new Promise((resolve)=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($22374b4858edafee$exports)))(el, {
            offset: 0,
            duration: duration
        });
        setTimeout(resolve, duration);
    });
}
function $c657a2af5c9e1b33$export$e1500fe70a4f6f8f(WrappedComponent) {
    return class extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
        scrollToEl = (e)=>{
            e.preventDefault();
            (0, (/*@__PURE__*/$parcel$interopDefault($22374b4858edafee$exports)))(this.props.to, {
                align: 'middle',
                duration: this.props.duration
            });
        };
        render() {
            return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)(WrappedComponent, {
                onClick: this.scrollToEl,
                ...this.props
            });
        }
    };
}


const $87d87c79350c4a5e$var$Accordion = ({ unexpandable: unexpandable, customHeader: customHeader, id: id, title: title, labelRightComponent: labelRightComponent, labelRight: labelRight, headerComponent: headerComponent, footerComponent: footerComponent, labelReadMore: labelReadMore, hideOverflow: hideOverflow, noHeaderPadding: noHeaderPadding, children: children, noBackground: noBackground, extraBottomMargin: extraBottomMargin, customMargin: customMargin, isOpen: isOpen, expandHeight: expandHeight })=>{
    const [open, setOpen] = (0, $8NFma.useState)(false);
    const [expandAreaHeight, setExpandAreaHeight] = (0, $8NFma.useState)(0);
    const mainContainerEl = (0, $8NFma.useRef)(null);
    const expEl = (0, $8NFma.useRef)(null);
    const { ref: ref, height: height } = (0, $186d05b333a95faf$export$453c3d1cba18d800)();
    (0, $8NFma.useEffect)(()=>{
        if (!unexpandable) setExpandAreaHeight(expEl.current.clientHeight);
    }, []);
    (0, $8NFma.useEffect)(()=>{
        if (expEl.current && expandAreaHeight !== expEl.current.clientHeight) setExpandAreaHeight(expEl.current.clientHeight);
    }, [
        children
    ]);
    const toggleAccordion = (event)=>{
        event.preventDefault();
        if (open && expandAreaHeight > window.innerHeight / 2) (0, $c657a2af5c9e1b33$export$2353115f31f4d15)(mainContainerEl.current, 300);
        setOpen(!open);
    };
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($87d87c79350c4a5e$var$BoxWrapper, {
        id: id,
        extraBottomMargin: unexpandable,
        children: [
            customHeader || /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($87d87c79350c4a5e$var$HeaderWrapper, {
                children: [
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($87d87c79350c4a5e$var$HeaderTitle, {
                        align: "left",
                        children: title
                    }),
                    labelRightComponent && labelRightComponent,
                    labelRight && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($87d87c79350c4a5e$var$HeaderTitle, {
                        align: "right",
                        children: [
                            labelRight.text,
                            ": ",
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("span", {
                                children: [
                                    labelRight.value,
                                    "kr"
                                ]
                            })
                        ]
                    })
                ]
            }),
            headerComponent && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($87d87c79350c4a5e$var$Container, {
                hideOverflow: hideOverflow,
                noPadding: noHeaderPadding,
                children: [
                    hideOverflow || noBackground || /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($87d87c79350c4a5e$var$ContainerBackground, {}),
                    headerComponent
                ]
            }),
            footerComponent && footerComponent,
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $bb8231acd22e51c2$export$e25e478948902b8b).div, {
                initial: {
                    maxHeight: 0
                },
                animate: {
                    maxHeight: isOpen ? expandHeight * 1.2 : 0
                },
                transition: {
                    type: "spring",
                    stiffness: 188,
                    damping: 26
                },
                ref: (el)=>{
                    mainContainerEl.current = el;
                },
                "data-lf-accordion-body": true,
                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                    style: {
                        display: 'block',
                        width: '100%'
                    },
                    ref: (el)=>{
                        expEl.current = el;
                    },
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                        ref: ref,
                        children: children
                    })
                })
            }),
            !unexpandable && !customHeader && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($87d87c79350c4a5e$var$ReadMore, {
                isOpen: isOpen,
                customMargin: customMargin,
                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("a", {
                    href: "#",
                    onClick: toggleAccordion,
                    children: !isOpen ? labelReadMore ? labelReadMore : "L\xe4s mer" : "St\xe4ng"
                })
            })
        ]
    });
};
$87d87c79350c4a5e$var$Accordion.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).element
    ]),
    labelRight: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).object,
    labelRightComponent: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).element,
    headerComponent: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).element,
    footerComponent: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).element,
    labelReadMore: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
    unexpandable: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).bool,
    noHeaderPadding: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).bool,
    customMargin: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
    hideOverflow: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).bool,
    noBackground: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).bool
};
$87d87c79350c4a5e$var$Accordion.defaultProps = {
    hideOverflow: true,
    noBackground: false
};
var $87d87c79350c4a5e$export$2e2bcd8739ae039 = $87d87c79350c4a5e$var$Accordion;
const $87d87c79350c4a5e$var$boxPropsToExclude = [
    'extraBottomMargin'
];
// styles
const $87d87c79350c4a5e$var$BoxWrapper = (0, $65e706775ff71837$export$2e2bcd8739ae039).div.withConfig({
    shouldForwardProp: (prop)=>!$87d87c79350c4a5e$var$boxPropsToExclude.includes(prop)
})`
    width: 100%;
    margin-top: 30px;
    border-radius: 5px;
    &:first-of-type {
        margin-top: 0px;
    }
    margin-bottom: 30px;

    padding: 25px 20px ${(props)=>props.extraBottomMargin ? '30px' : '10px'} 20px;
    ${(props)=>(0, $45d1242a07988139$export$8f880b6e390052fa).large(`
        padding: 10px 20px ${props.extraBottomMargin ? '15px' : '10px'} 20px;
        margin-top: 15px;
        margin-bottom: 30px;
    `)}

    background-color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.blueBackground};
    font-family: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.main};
    
    ${(0, $45d1242a07988139$export$8f880b6e390052fa).custom(`
        padding: 20px;
    `, '1234px')}

     ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        padding: 15px 20px;
        margin-top: 0px;
        margin-bottom: 15px;
    `)}
`;
const $87d87c79350c4a5e$var$HeaderWrapper = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    width: 100%; 
    display: inline-flex; 
    align-items: flex-end;

    margin-bottom: 20px;
    font-family: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.main};
    
    ${(0, $45d1242a07988139$export$8f880b6e390052fa).medium(`
        margin-bottom: 15px;
    `)}

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        display: initial;
        margin-bottom: 0px;
    `)}
`;
const $87d87c79350c4a5e$var$headerPropsToExclude = [
    'align'
];
const $87d87c79350c4a5e$var$HeaderTitle = (0, $65e706775ff71837$export$2e2bcd8739ae039).div.withConfig({
    shouldForwardProp: (prop)=>!$87d87c79350c4a5e$var$headerPropsToExclude.includes(prop)
})`
    width: 50%; 
    padding-bottom: ${(props)=>props.align === 'right' ? '3px' : '0'};

    font-size: ${(props)=>props.align === 'right' ? '18px' : '28px'};
    ${(props)=>(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        font-size: ${props.align === 'right' ? '14px' : '22px'};
        width: 100%; 
    `)}

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).medium(`
        font-size: 20px;
        line-height: 1.4;
        margin-bottom: 10px;
        width: 100%;

        &:nth-of-type(2) {
            font-size: 16px;
            font-weight: normal;
            line-height: 1;
        }
    `)}

    font-weight: bold;
    font-family: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.heading};
    text-align: ${(props)=>props.align === 'right' ? 'right' : 'left'};
    color: white;

    span {
        font-family: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.main};
        font-weight: normal; 
	    color: white; 
	}

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        font-size: 18px;
        line-height: 1.2;
        text-align: left;
        span {
            float: right;
	    }
    `)}
`;
const $87d87c79350c4a5e$var$containerPropsToExclude = [
    'hideOverflow',
    'noPadding'
];
const $87d87c79350c4a5e$var$Container = (0, $65e706775ff71837$export$2e2bcd8739ae039).div.withConfig({
    shouldForwardProp: (prop)=>!$87d87c79350c4a5e$var$containerPropsToExclude.includes(prop)
})`
    padding: ${(props)=>props.noPadding ? '0' : '36px'};

    position: relative;
    overflow: ${(props)=>props.hideOverflow ? 'hidden' : 'visible'};
    border-radius: ${(props)=>props.hideOverflow ? '5px' : 'none'};
    background-color: ${(props)=>props.hideOverflow ? 'white' : 'none'};;

	font-size: 16px;
    font-family: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.main};
    text-align: left; 

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).medium(`
        padding: 0px;
    `)}
`;
const $87d87c79350c4a5e$var$ContainerBackground = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    border-radius: 5px;
    background-color: white;
`;
const $87d87c79350c4a5e$var$MainContainer = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    width:100%; 
    height: auto; 
    overflow: hidden;

    ${(0, $45d1242a07988139$export$8c467e8859fdef13)()}

    & > div {
        ${(0, $45d1242a07988139$export$8c467e8859fdef13)()}
    }
`;
const $87d87c79350c4a5e$var$readMorePropsToExclude = [
    'isOpen',
    'customMargin'
];
const $87d87c79350c4a5e$var$ReadMore = (0, $65e706775ff71837$export$2e2bcd8739ae039).div.withConfig({
    shouldForwardProp: (prop)=>!$87d87c79350c4a5e$var$readMorePropsToExclude.includes(prop)
})`
    width: 100%; 
    margin: 15px 0 15px 0;
    text-align: right;

    ${(props)=>props.customMargin ? `
        ${(0, $45d1242a07988139$export$8f880b6e390052fa).medium(`
            margin: ${props.customMargin};
        `)}
    ` : `
        ${(0, $45d1242a07988139$export$8f880b6e390052fa).medium(`
            margin: 0px;
        `)}
    `}

    a, a:hover, a:visited, a:focus {
        color: white; 
        text-decoration: none; 
        font-family: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.heading};
        font-size: 20px; 
        font-weight: bold;

        ${(0, $45d1242a07988139$export$8f880b6e390052fa).medium(`
            font-size: 18px;
        `)}
        ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
            font-size: 16px;
        `)}
    }

    a:hover {
        text-decoration: underline; 
    }

    a {
        &:after {
            display: inline-block;
            ${(0, $45d1242a07988139$export$74300498d1a9477c).chevDown()} 
            
            font-size: 0.55em;
            margin-left: 0.8em;
            
            transform: ${(props)=>props.isOpen ? 'rotateZ(-180deg) translateY(0.3em)' : 'none'};
            transition: transform 400ms ease-out; 
        }

        &:hover {
            &:after {
                text-decoration: none;
            }
        }
    }
`;




var $8NFma = parcelRequire("8NFma");


class $492d68823d70b95b$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    static get propTypes() {
        return {
            color: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
            margin: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string
        };
    }
    constructor(props){
        super(props);
    }
    render() {
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($492d68823d70b95b$var$Wrapper, {
            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($492d68823d70b95b$var$Spinner, {
                margin: this.props.margin,
                children: [
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($492d68823d70b95b$var$Bouncer, {
                        color: this.props.color
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($492d68823d70b95b$var$Bouncer2, {
                        color: this.props.color
                    })
                ]
            })
        });
    }
}
const $492d68823d70b95b$var$Wrapper = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    position: relative;
    display: block;
    margin: 0 auto;


    &::before {
        content: " ";
        display: table;
    }
      
    &::after {
        content: " ";
        display: table;
        clear: both;
    }
`;
const $492d68823d70b95b$var$Spinner = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    width: 40px;
    height: 40px;

    position: relative;
    margin: ${(props)=>props.margin ? props.margin : '100px auto'};
`;
const $492d68823d70b95b$var$BounceAnimation = (0, $65e706775ff71837$export$d25ddfdf17c3ad3e)`
    0%, 100% { 
        transform: scale(0.0);
    } 50% { 
        transform: scale(1.0);
    }
`;
const $492d68823d70b95b$var$Bouncer = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    border-radius: 50%;
    background-color: ${(props)=>props.color ? props.color : '#333'}; 
    opacity: 0.6;
    animation: ${$492d68823d70b95b$var$BounceAnimation} 2.0s infinite ease-in-out;
`;
const $492d68823d70b95b$var$Bouncer2 = (0, $65e706775ff71837$export$2e2bcd8739ae039)($492d68823d70b95b$var$Bouncer)`
    animation-delay: -1.0s;
`;




var $8NFma = parcelRequire("8NFma");



class $19ac445fff8f1f3a$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    constructor(props){
        super(props);
    }
    static get propTypes() {
        return {
            message: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string
        };
    }
    render() {
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($19ac445fff8f1f3a$var$ErrorWrapper, {
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("strong", {
                    children: this.props.message
                }),
                this.props.children
            ]
        });
    }
}
const $19ac445fff8f1f3a$var$ErrorWrapper = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    position: relative;
    width: 100%; 
    min-height: 100px;

    margin-top: 15px; 

    text-align: center;

    strong {
        color: red;
        font-family: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.heading};
    }
`;



parcelRequire("8NFma");

// b64 encode & decode taken from:
// https://stackoverflow.com/questions/30106476/using-javascripts-atob-to-decode-base64-doesnt-properly-decode-utf-8-strings
const $96c25128201e5f07$var$b64EncodeUnicode = (str)=>btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (match, p1)=>String.fromCharCode(`0x${p1}`)));
const $96c25128201e5f07$var$b64DecodeUnicode = (str)=>decodeURIComponent(atob(str).split('').map((c)=>'%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join(''));
const $96c25128201e5f07$var$isBase64Encoded = (str)=>{
    try {
        return $96c25128201e5f07$var$b64EncodeUnicode($96c25128201e5f07$var$b64DecodeUnicode(str)) == str;
    } catch (err) {
        return false;
    }
};
// make dom node to the raw container div accessible by inputRef prop in parent
// see https://5abc31d8be40f1556f06c4be--reactjs.netlify.com/docs/refs-and-the-dom.html
// NOTE: the react ref api changed in 16.3.0! THIS IS 16.2.0!!
const $96c25128201e5f07$var$RawHtml = ({ children: children, className: className = "", inputRef: inputRef })=>{
    const htmlString = $96c25128201e5f07$var$isBase64Encoded(children) ? $96c25128201e5f07$var$b64DecodeUnicode(children) : children;
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
        ref: inputRef,
        className: className,
        dangerouslySetInnerHTML: {
            __html: htmlString.replace(/\\"/g, '"').replace('\n', '').replace('\r', '')
        }
    });
};
$96c25128201e5f07$var$RawHtml.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string.isRequired,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string
};
var $96c25128201e5f07$export$2e2bcd8739ae039 = $96c25128201e5f07$var$RawHtml;




var $8NFma = parcelRequire("8NFma");



var $YChVI = parcelRequire("YChVI");




var $4Y7rX = parcelRequire("4Y7rX");
parcelRequire("8NFma");
// a list of insurance groups that shouldn't generate a form entry (not yet implemented or other reasons)
const $2c01078d80653909$export$cd8c59008b71c628 = [];
// a list of insurance names that shouldn't generate a form entry (they're handled differently - as part of another insurance or otherwise)
const $2c01078d80653909$export$bbfe0f4c36f4c8b1 = [
    'home-basic-cooperative-security',
    'home-medium-cooperative-security',
    'home-large-cooperative-security',
    'student-home-cooperative-security'
];
const $2c01078d80653909$export$e6dc421dc375b72e = [
    'cat',
    'cat-life',
    'dog',
    'dog-life',
    'small-animal'
];
const $2c01078d80653909$export$12cbb794d0561059 = {
    'accident': {
        displayName: "Olycksfallsf\uDE8B\uDCE4kring",
        infoComponents: [],
        availableForGroup: null,
        availableForInsurances: []
    },
    'accident-senior': {
        displayName: "Olycksfallsf\uDE8B\uDCE4kring Senior",
        infoComponents: [],
        availableForGroup: null,
        availableForInsurances: []
    },
    'child': {
        displayName: "Barnf\uDE8B\uDCE4kring",
        infoComponents: [],
        availableForGroup: null,
        availableForInsurances: []
    },
    'home': {
        displayName: "Hemf\uDE8B\uDCE4kring",
        infoComponents: [],
        availableForGroup: null,
        availableForInsurances: []
    },
    'house': {
        displayName: "Villaf\uDE8B\uDCE4kring",
        infoComponents: [],
        availableForGroup: null,
        availableForInsurances: []
    },
    'holiday-cottage': {
        displayName: "Fritidshusf\uDE8B\uDCE4kring",
        infoComponents: [],
        availableForGroup: null,
        availableForInsurances: []
    },
    'healthcare': {
        displayName: "Sjukv\u5CA4sf\uDE8B\uDCE4kring",
        availableForGroup: null,
        availableForInsurances: []
    },
    'healthcare-accident-senior': {
        displayName: "Sjukv\u5CA4 vid olycksfall Senior",
        availableForGroup: null,
        availableForInsurances: []
    },
    'health': {
        displayName: "Sjukf\uDE8B\uDCE4kring",
        availableForGroup: null,
        availableForInsurances: []
    },
    'life': {
        displayName: "Livf\uDE8B\uDCE4kring",
        availableForGroup: null,
        availableForInsurances: []
    },
    'musical-instrument': {
        displayName: "Musikinstrumentf\uDE8B\uDCE4kring",
        infoComponents: [],
        availableForGroup: null,
        availableForInsurances: []
    },
    'pregnant': {
        displayName: "Gravidf\uDE8B\uDCE4kring",
        availableForGroup: null,
        availableForInsurances: []
    },
    'student': {
        displayName: "Studerandef\uDE8B\uDCE4kring",
        infoComponents: [],
        availableForGroup: null,
        availableForInsurances: []
    },
    'student-home': {
        displayName: "Studentf\uDE8B\uDCE4kring Bo",
        infoComponents: [],
        availableForGroup: null,
        availableForInsurances: []
    },
    'student-leva': {
        displayName: "Studentf\uDE8B\uDCE4kring Leva",
        infoComponents: [],
        availableForGroup: null,
        availableForInsurances: []
    },
    'travel': {
        displayName: "Resklar (ing\u5CA0i Hemf\uDE8B\uDCE4kring Stor)",
        infoComponents: [],
        availableForGroup: null,
        availableForInsurances: []
    },
    'dog': {
        displayName: "Hundf\uDE8B\uDCE4kring",
        infoComponents: [],
        availableForGroup: null,
        availableForInsurances: []
    },
    'dog-life': {
        displayName: "Livf\uDE8B\uDCE4kring Hund",
        infoComponents: [],
        availableForGroup: 'dog',
        availableForInsurances: [
            'dog-medium',
            'dog-large'
        ] // dog-life can be purchased only if these are already purchased
    },
    'cat': {
        displayName: "Kattf\uDE8B\uDCE4kring",
        infoComponents: [],
        availableForGroup: null,
        availableForInsurances: []
    },
    'cat-life': {
        displayName: "Livf\uDE8B\uDCE4kring Katt",
        infoComponents: [],
        availableForGroup: 'cat',
        availableForInsurances: [
            'cat-medium',
            'cat-large'
        ] // cat-life can be purchased only if these are already purchased
    },
    'small-animal': {
        displayName: "Sm\u592Aursf\uDE8B\uDCE4kring",
        infoComponents: [],
        availableForGroup: null,
        availableForInsurances: []
    }
};


function $36509d2879dd53eb$export$86b9bf27d05da341(insuranceName) {
    const store = window.__bazStore.getState();
    let data = store.insurancePageData.insurancesByName || store.preregistrationPageData.insurancesByName || store.startPageData.insurancesByName;
    return data[insuranceName];
}
function $36509d2879dd53eb$export$69caa002db9082af(insuranceName) {
    let data = window.__bazStore.getState().insurancePageData;
    if (!data) return null;
    let insuranceMeta = data.insurancesByName[insuranceName];
    let quoteIndex = data.quotesByGroupName.findIndex((q)=>q.groupName == insuranceMeta.groupName);
    let quote = data.quotesByGroupName[quoteIndex].insurances.find((i)=>i.insuranceName == insuranceName);
    return quote;
}
function $36509d2879dd53eb$export$6771486234ee8fa5(possessionId) {
    let data = window.__bazStore.getState().insurancePageData;
    if (!data || !data.possessions) return null;
    return data.possessions.find((i)=>i.possessionId == possessionId);
}
function $36509d2879dd53eb$export$485947edd4674a74(insuranceObjectId) {
    let data = window.__bazStore.getState().insurancePageData;
    if (!data || !data.possessions) return null;
    return data.possessions.find((i)=>i.insuranceObjectId == insuranceObjectId);
}
function $36509d2879dd53eb$export$2a0be428efc19c5c(key) {
    const premiumLabels = {
        monthly: "M\xe5nadspris",
        yearly: "\xc5rspris",
        onetime: "Eng\xe5ngspris"
    };
    return key in premiumLabels ? premiumLabels[key] : "Ok\xe4nd premieperiod";
}
function $36509d2879dd53eb$export$d8633857024224d8(key) {
    let k = typeof key !== 'undefined' && key ? key.toLowerCase() : '';
    const genderLabels = {
        male: 'Pojke',
        female: 'Flicka',
        other: 'Annat'
    };
    return k in genderLabels ? genderLabels[k] : "Ok\xe4nt";
}
function $36509d2879dd53eb$export$66b0d8b6f90d739f(key) {
    let k = typeof key !== 'undefined' && key ? key.toLowerCase() : '';
    const genderLabels = {
        male: 'Hane',
        female: 'Hona',
        castrated: 'Kastrerad'
    };
    return k in genderLabels ? genderLabels[k] : "Ok\xe4nt";
}
function $36509d2879dd53eb$export$497e880301a9a0ec(key) {
    let k = typeof key !== 'undefined' && key ? key.toLowerCase() : '';
    const typeLabels = {
        cat: 'Katt',
        dog: 'Hund',
        smallanimal: "Sm\xe5djur"
    };
    return k in typeLabels ? typeLabels[k] : "Ok\xe4nt";
}
const $36509d2879dd53eb$export$bad51be39f661eab = (metaData)=>Object.keys(metaData).reduce((acc, k)=>{
        acc[metaData[k].groupName] = metaData[k];
        return acc;
    }, {});
function $36509d2879dd53eb$export$aa98a26e797b60e6(insurances) {
    return insurances.reduce((sorted, insurance)=>{
        let name = typeof insurance.name !== 'undefined' ? insurance.name : insurance.insuranceName;
        sorted[name] = insurance;
        return sorted;
    }, {});
}
function $36509d2879dd53eb$export$9c294c7c1d8f86a5(insurances, metaData = null) {
    const getGroupName = (ins)=>{
        if (typeof ins.groupName === 'undefined' || !ins.groupName) return ins.insuranceName in metaData && typeof metaData[ins.insuranceName].groupName != 'undefined' && metaData[ins.insuranceName].groupName ? metaData[ins.insuranceName].groupName : ins.insuranceName.split('-')[0];
        return ins.groupName;
    };
    return insurances.reduce((acc, insurance)=>{
        let existingGroup = acc.filter((addedGroup)=>addedGroup.groupName === getGroupName(insurance));
        if (existingGroup.length) existingGroup[0].insurances.push(metaData ? {
            ...metaData[insurance.insuranceName],
            ...insurance
        } : insurance);
        else {
            let groupName = getGroupName(insurance);
            acc.push({
                groupName: groupName,
                displayName: groupName in (0, $2c01078d80653909$export$12cbb794d0561059) ? (0, $2c01078d80653909$export$12cbb794d0561059)[groupName].displayName : null,
                insurances: metaData ? [
                    {
                        ...metaData[insurance.insuranceName],
                        ...insurance
                    }
                ] : [
                    insurance
                ]
            });
        }
        return acc;
    }, []);
}
function $36509d2879dd53eb$export$648377fe0061b088(orders, validationResults, orderSystemDown) {
    let sorted = $36509d2879dd53eb$export$9c294c7c1d8f86a5(orders).reduce((sorted, group)=>{
        let ordersWithMeta = group.insurances.map((insurance)=>{
            return {
                ...$36509d2879dd53eb$export$86b9bf27d05da341(insurance.insuranceName),
                ...$36509d2879dd53eb$export$69caa002db9082af(insurance.insuranceName),
                ...insurance
            };
        });
        const orderHasFailed = (insuranceName)=>{
            let errors = validationResults.filter((validation)=>validation.insuranceName == insuranceName && (validation.validationErrors && validation.validationErrors.length > 0 || validation.result && !validation.result.success));
            return errors ? errors.length > 0 : false;
        };
        const getValidationErrors = (insuranceName)=>{
            let errors = validationResults.filter((validation)=>validation.insuranceName == insuranceName);
            return errors.length > 0 ? errors[0].validationErrors : {};
        };
        let completedOrders = ordersWithMeta.filter((insurance)=>!insurance.requiresHealthDeclaration && !insurance.isQuoteRequest && !orderHasFailed(insurance.insuranceName));
        let pendingOrders = ordersWithMeta.filter((insurance)=>(insurance.requiresHealthDeclaration || insurance.isQuoteRequest) && !orderHasFailed(insurance.insuranceName));
        let failedOrders = ordersWithMeta.filter((insurance)=>orderHasFailed(insurance.insuranceName)).map((insurance)=>({
                ...insurance,
                validationErrors: getValidationErrors(insurance.insuranceName)
            }));
        sorted.completed = [
            ...sorted.completed,
            ...completedOrders
        ];
        sorted.pending = [
            ...sorted.pending,
            ...pendingOrders
        ];
        sorted.failed = [
            ...sorted.failed,
            ...failedOrders
        ];
        return sorted;
    }, {
        completed: [],
        pending: [],
        failed: []
    });
    const sortByNameToArray = (insurances)=>{
        return insurances.reduce((acc, insurance)=>{
            let existingName = acc.filter((addedName)=>addedName.insuranceName === insurance.insuranceName);
            if (existingName.length) {
                let tmp = existingName[0].insurances;
                existingName[0].insurances = [
                    tmp
                ];
                existingName[0].insurances.push(insurance);
            } else acc.push({
                insuranceName: insurance.insuranceName,
                insurances: insurance
            });
            return acc;
        }, []);
    };
    if (orderSystemDown) return {
        completed: [],
        pending: sortByNameToArray([
            ...sorted.completed,
            ...sorted.pending,
            ...sorted.failed
        ]),
        failed: []
    };
    const completed = sortByNameToArray(sorted.completed);
    const pending = sortByNameToArray(sorted.pending);
    const failed = sortByNameToArray(sorted.failed);
    return {
        completed: completed,
        pending: pending,
        failed: failed,
        all: [
            ...sorted.completed,
            ...sorted.pending,
            ...sorted.failed
        ]
    };
}
function $36509d2879dd53eb$export$167680d23a59c108(regGroup) {
    let draft = regGroup.insurances.find((registration)=>registration.hasDraft);
    if (draft) return {
        ...regGroup,
        insurances: [
            draft
        ]
    };
    return regGroup;
}
function $36509d2879dd53eb$export$93d7fc36cde4ba6(regGroup) {
    let sortedGroups = regGroup.map((group)=>{
        let grouped = (0, (/*@__PURE__*/$parcel$interopDefault($4Y7rX)))(group.insurances, 'insuranceObjectId');
        group.insurances = Object.keys(grouped).map((k)=>{
            let groupedRegs = grouped[k];
            let draft = groupedRegs.find((reg)=>reg.hasDraft);
            if (draft) return [
                draft
            ];
            return groupedRegs;
        });
        return group;
    });
    return sortedGroups;
}
function $36509d2879dd53eb$export$23a64b23f50bab27(breedData) {
    return Object.keys(breedData).reduce((byType, typeKey)=>{
        let breedsForType = breedData[typeKey];
        byType[typeKey] = breedsForType.reduce((byBreedId, breed)=>{
            byBreedId[breed.id] = breed.name;
            return byBreedId;
        }, {});
        return byType;
    }, {});
}
function $36509d2879dd53eb$export$26f7a1d6ff54a39c(insuranceName) {
    return Object.keys((0, $2c01078d80653909$export$12cbb794d0561059)).filter((groupKey)=>(0, $2c01078d80653909$export$12cbb794d0561059)[groupKey].availableForInsurances.indexOf(insuranceName) > -1);
}
function $36509d2879dd53eb$export$54d7743101979cb1(group) {
    if (!group.questions || !group.questions.length) return group;
    group.questions.forEach((question)=>{
        if (!group.answers || !group.answers.length) return;
        const answer = group.answers[0].filter((answer)=>{
            return answer.questionId === question.id;
        });
        if (answer.length) question.value = answer[0].value;
        if (question.subQuestionGroup) question.subQuestionGroup = $36509d2879dd53eb$export$54d7743101979cb1(question.subQuestionGroup);
    });
    return group;
}


class $c8abba432cc26d54$var$PossessionHeading extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    render() {
        const possession = this.props.possession;
        const insuranceMeta = (0, $36509d2879dd53eb$export$86b9bf27d05da341)(possession.insuranceName);
        const hasInsuranceMeta = typeof insuranceMeta !== 'undefined' && insuranceMeta;
        if (hasInsuranceMeta && insuranceMeta.groupName === 'child') {
            const childGender = (0, $36509d2879dd53eb$export$d8633857024224d8)(possession.childGender).toLowerCase();
            const childBirthData = possession.childPersonalIdentityNumber ? possession.childPersonalIdentityNumber : (0, (/*@__PURE__*/$parcel$interopDefault($YChVI)))(possession.childBirthDate).format('YYYY-MM-DD');
            return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($c8abba432cc26d54$var$InsuranceName, {
                        children: possession.displayName
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($c8abba432cc26d54$var$SubLabel, {
                        children: [
                            possession.childFirstName ? possession.childFirstName : "(F\xf6rnamn ej angivet)",
                            " ",
                            possession.childLastName,
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("br", {}),
                            "(K\xf6n: ",
                            childGender,
                            ", ",
                            childBirthData,
                            ")"
                        ]
                    })
                ]
            });
        }
        if (hasInsuranceMeta && insuranceMeta.groupName === 'dog' || hasInsuranceMeta && insuranceMeta.groupName === 'dog-life') {
            const dogBreeds = this.props.data.breedsById.dog;
            const dogName = possession.animalDisplayName;
            const dogBreedId = possession.animalBreedId;
            const dogBreed = dogBreedId in dogBreeds ? dogBreeds[dogBreedId] : "Ok\xe4nd ras";
            return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($c8abba432cc26d54$var$InsuranceName, {
                        children: possession.displayName
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($c8abba432cc26d54$var$SubLabel, {
                        children: [
                            dogName ? dogName : '(Namn ej angivet)',
                            " (",
                            dogBreed,
                            ")",
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("br", {})
                        ]
                    })
                ]
            });
        }
        if (hasInsuranceMeta && insuranceMeta.groupName === 'cat' || hasInsuranceMeta && insuranceMeta.groupName === 'cat-life') {
            const catBreeds = this.props.data.breedsById.cat;
            const catName = possession.animalDisplayName;
            const catBreedId = possession.animalBreedId;
            const catBreed = catBreedId in catBreeds ? catBreeds[catBreedId] : "Ok\xe4nd ras";
            return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($c8abba432cc26d54$var$InsuranceName, {
                        children: possession.displayName
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($c8abba432cc26d54$var$SubLabel, {
                        children: [
                            catName ? catName : '(Namn ej angivet)',
                            " (",
                            catBreed,
                            ")",
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("br", {})
                        ]
                    })
                ]
            });
        }
        if (hasInsuranceMeta && insuranceMeta.groupName === 'small-animal') {
            const smallAnimalBreeds = this.props.data.breedsById.smallanimal;
            const animalName = possession.animalDisplayName;
            const animalBreedId = possession.animalBreedId;
            const animalType = animalBreedId in smallAnimalBreeds ? smallAnimalBreeds[animalBreedId] : "Ok\xe4nt djur";
            return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($c8abba432cc26d54$var$InsuranceName, {
                        children: possession.displayName
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($c8abba432cc26d54$var$SubLabel, {
                        children: [
                            animalName ? animalName : '(Namn ej angivet)',
                            " (",
                            animalType,
                            ")",
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("br", {})
                        ]
                    })
                ]
            });
        }
        return possession.displayName;
    }
}
// state
const $c8abba432cc26d54$var$mapStateToProps = (state)=>{
    return {
        data: state.startPageData
    };
};
const $c8abba432cc26d54$var$mapDispatchToProps = (dispatch)=>({});
var $c8abba432cc26d54$export$2e2bcd8739ae039 = (0, $5a4066412ccab0c1$export$64605811ab45167f)($c8abba432cc26d54$var$mapStateToProps, $c8abba432cc26d54$var$mapDispatchToProps)($c8abba432cc26d54$var$PossessionHeading);
// styles
const $c8abba432cc26d54$var$InsuranceName = (0, $65e706775ff71837$export$2e2bcd8739ae039).h3`
    font-size: inherit;
    margin-bottom: 10px;
    &:nth-of-type(2) {
        margin-bottom: 0px;
    }
`;
const $c8abba432cc26d54$var$SubLabel = (0, $65e706775ff71837$export$2e2bcd8739ae039).p`
    display: block;
    margin: 0px;
    color: white;
    font-size: inherit;
    font-weight: normal;

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).medium(`
        font-size: 14px;
    `)}
`;




var $8NFma = parcelRequire("8NFma");




var $YChVI = parcelRequire("YChVI");


parcelRequire("8NFma");


var $YChVI = parcelRequire("YChVI");


const $54d997f7b284a565$var$ClauseInfo = ({ heading: heading, possession: possession })=>{
    const hasSingleClause = typeof possession.clauseText !== 'undefined' && possession.clauseText != null;
    const hasMultiClause = typeof possession.clauses !== 'undefined' && possession.clauses.length > 0;
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($54d997f7b284a565$var$ClauseWrapper, {
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($54d997f7b284a565$var$Clause, {
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($54d997f7b284a565$var$ClauseHeading, {
                    children: heading
                }),
                hasSingleClause && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("p", {
                    children: possession.clauseText
                }),
                hasMultiClause && possession.clauses.map((clause, i)=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("p", {
                        children: [
                            clause.fromDate && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($54d997f7b284a565$var$ClauseDate, {
                                children: [
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("em", {
                                        children: "Fr\xe5n:"
                                    }),
                                    " ",
                                    (0, (/*@__PURE__*/$parcel$interopDefault($YChVI)))(clause.fromDate).format('YYYY-MM-DD')
                                ]
                            }),
                            clause.toDate && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($54d997f7b284a565$var$ClauseDate, {
                                children: [
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("em", {
                                        children: "Till:"
                                    }),
                                    " ",
                                    (0, (/*@__PURE__*/$parcel$interopDefault($YChVI)))(clause.toDate).format('YYYY-MM-DD')
                                ]
                            }),
                            clause.text
                        ]
                    }, i))
            ]
        })
    });
};
const $54d997f7b284a565$var$ClauseWrapper = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    display: block; 
    width: 100%;

    color: white;
    font-size: 16px; 
    font-family: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.main};
`;
const $54d997f7b284a565$var$Clause = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    position: relative;
    margin-top: 40px; 
    
    margin-left: 50px; 
    width: calc(50% - 50px);

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).medium(`
        margin-left: 23px;
        width: calc(100% - 25px); 
    `)}    

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        margin-left: 0; 
        width: 100%; 
    `)}


    &:before {
        position: absolute;
        left: -30px;
        top: -5px;

        ${(0, $45d1242a07988139$export$8f880b6e390052fa).medium(`
            left: 75px; 
            top: -4px; 
        `)}

        ${(0, $45d1242a07988139$export$74300498d1a9477c).informationIcon()} 
    }

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).medium(`
        margin-top: 20px;
    `)}

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        margin-left: 0;
    `)}

    p {
        border-bottom: 1px solid rgba(255, 255, 255, 0.25); 
        padding-bottom: 15px; 

        &:only-child,&:last-of-type {
            border-bottom: none; 
            padding-bottom: 0;
        }
    }
`;
const $54d997f7b284a565$var$ClauseHeading = (0, $65e706775ff71837$export$2e2bcd8739ae039).h4`
    font-weight: bold;
    font-size: 16px;
`;
const $54d997f7b284a565$var$ClauseDate = (0, $65e706775ff71837$export$2e2bcd8739ae039).span`
    display: block; 

    &:first-of-type {
        margin-top: 10px; 
    }

    &:last-of-type {
        margin-bottom: 10px; 
    }

    em {
        font-weight: bold; 
        font-style: normal; 
    }
`;
var $54d997f7b284a565$export$2e2bcd8739ae039 = $54d997f7b284a565$var$ClauseInfo;




var $8NFma = parcelRequire("8NFma");




parcelRequire("8NFma");

var $5e6a62740b68988a$exports = {};
"use strict";
var $5e6a62740b68988a$var$removeHash = function removeHash(hex) {
    return hex.charAt(0) === '#' ? hex.slice(1) : hex;
};
var $5e6a62740b68988a$var$parseHex = function parseHex(nakedHex) {
    var isShort = nakedHex.length === 3 || nakedHex.length === 4;
    var twoDigitHexR = isShort ? "".concat(nakedHex.slice(0, 1)).concat(nakedHex.slice(0, 1)) : nakedHex.slice(0, 2);
    var twoDigitHexG = isShort ? "".concat(nakedHex.slice(1, 2)).concat(nakedHex.slice(1, 2)) : nakedHex.slice(2, 4);
    var twoDigitHexB = isShort ? "".concat(nakedHex.slice(2, 3)).concat(nakedHex.slice(2, 3)) : nakedHex.slice(4, 6);
    var twoDigitHexA = (isShort ? "".concat(nakedHex.slice(3, 4)).concat(nakedHex.slice(3, 4)) : nakedHex.slice(6, 8)) || 'ff'; // const numericA = +((parseInt(a, 16) / 255).toFixed(2));
    return {
        r: twoDigitHexR,
        g: twoDigitHexG,
        b: twoDigitHexB,
        a: twoDigitHexA
    };
};
var $5e6a62740b68988a$var$hexToDecimal = function hexToDecimal(hex) {
    return parseInt(hex, 16);
};
var $5e6a62740b68988a$var$hexesToDecimals = function hexesToDecimals(_ref) {
    var r = _ref.r, g = _ref.g, b = _ref.b, a = _ref.a;
    return {
        r: $5e6a62740b68988a$var$hexToDecimal(r),
        g: $5e6a62740b68988a$var$hexToDecimal(g),
        b: $5e6a62740b68988a$var$hexToDecimal(b),
        a: +($5e6a62740b68988a$var$hexToDecimal(a) / 255).toFixed(2)
    };
};
var $5e6a62740b68988a$var$isNumeric = function isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}; // eslint-disable-line no-restricted-globals, max-len
var $5e6a62740b68988a$var$formatRgb = function formatRgb(decimalObject, parameterA) {
    var r = decimalObject.r, g = decimalObject.g, b = decimalObject.b, parsedA = decimalObject.a;
    var a = $5e6a62740b68988a$var$isNumeric(parameterA) ? parameterA : parsedA;
    return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(a, ")");
};
/**
 * Turns an old-fashioned css hex color value into a rgb color value.
 *
 * If you specify an alpha value, you'll get a rgba() value instead.
 *
 * @param The hex value to convert. ('123456'. '#123456', ''123', '#123')
 * @param An alpha value to apply. (optional) ('0.5', '0.25')
 * @return An rgb or rgba value. ('rgb(11, 22, 33)'. 'rgba(11, 22, 33, 0.5)')
 */ var $5e6a62740b68988a$var$hexToRgba = function hexToRgba(hex, a) {
    var hashlessHex = $5e6a62740b68988a$var$removeHash(hex);
    var hexObject = $5e6a62740b68988a$var$parseHex(hashlessHex);
    var decimalObject = $5e6a62740b68988a$var$hexesToDecimals(hexObject);
    return $5e6a62740b68988a$var$formatRgb(decimalObject, a);
};
$5e6a62740b68988a$exports = $5e6a62740b68988a$var$hexToRgba;



parcelRequire("8NFma");



var $8NFma = parcelRequire("8NFma");

function $b16bd7343b5fbb2d$export$2e2bcd8739ae039(WrappedComponent) {
    return class extends (0, $8NFma.Component) {
        static contextTypes = {
            _errors: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).object,
                (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string
            ]))
        };
        static displayName = `Button(${WrappedComponent.name})`;
        shouldComponentUpdate(nextProps, nextState, nextContext) {
            return nextContext._errors !== this.context._errors;
        }
        render() {
            const hasErrors = !!Object.keys(this.context._errors).length;
            return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)(WrappedComponent, {
                ...this.props,
                hasErrors: hasErrors
            });
        }
    };
}


const $80cca30c19bbba0b$var$Button = ({ hasErrors: hasErrors, ...props })=>{
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
        ...props,
        disabled: hasErrors
    });
};
$80cca30c19bbba0b$var$Button.contextTypes = {
    hasErrors: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).bool
};
var $80cca30c19bbba0b$export$2e2bcd8739ae039 = (0, $b16bd7343b5fbb2d$export$2e2bcd8739ae039)($80cca30c19bbba0b$var$Button);




const $b50965a6d450d3cc$var$ValidationButton = (props)=>{
    const { onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, topMargin: topMargin, noIcon: noIcon, ...allProps } = {
        ...props
    };
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($b50965a6d450d3cc$var$ButtonWrapper, {
        onMouseLeave: onMouseLeave,
        noIcon: noIcon,
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $80cca30c19bbba0b$export$2e2bcd8739ae039), {
            onMouseEnter: onMouseEnter,
            ...allProps,
            children: props.children
        })
    });
};
const $b50965a6d450d3cc$var$ButtonWrapper = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    display: inline-block; 
    width: auto;

    button {
        padding: 10px 20px 10px 20px;
        ${(0, $45d1242a07988139$export$8f880b6e390052fa).large(`
            padding: 12px 15px 12px 15px;
        `)}

        font-family: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.heading};
        font-weight: bold;
        color: white;

        background-color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.green};
        border-radius: 5px;

        transition: background-color 300ms ease-out;

        &:after {
            color: white;
            padding-left: 20px;
            font-size: 14px;

            ${(props)=>!props.noIcon ? (0, $45d1242a07988139$export$74300498d1a9477c).arrowRight() : ''};
        }

        &:disabled {
            background-color: ${(0, (/*@__PURE__*/$parcel$interopDefault($5e6a62740b68988a$exports)))((0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.green, 0.5)};
            cursor: not-allowed;
        }
    }
`;
var $b50965a6d450d3cc$export$2e2bcd8739ae039 = $b50965a6d450d3cc$var$ValidationButton;



parcelRequire("8NFma");


parcelRequire("8NFma");

var $8NFma = parcelRequire("8NFma");

var $b488569ebaeb416e$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $b488569ebaeb416e$export$2e2bcd8739ae039 = {
    randomUUID: $b488569ebaeb416e$var$randomUUID
};


// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $d0da4566d2fd20fe$var$getRandomValues;
var $d0da4566d2fd20fe$var$rnds8 = new Uint8Array(16);
function $d0da4566d2fd20fe$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$d0da4566d2fd20fe$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $d0da4566d2fd20fe$var$getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$d0da4566d2fd20fe$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return $d0da4566d2fd20fe$var$getRandomValues($d0da4566d2fd20fe$var$rnds8);
}


var $e8c673fd2604883f$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;


function $7d240e1718cbe118$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $e8c673fd2604883f$export$2e2bcd8739ae039).test(uuid);
}
var $7d240e1718cbe118$export$2e2bcd8739ae039 = $7d240e1718cbe118$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $8fb7ad22aed8f433$var$byteToHex = [];
for(var $8fb7ad22aed8f433$var$i = 0; $8fb7ad22aed8f433$var$i < 256; ++$8fb7ad22aed8f433$var$i)$8fb7ad22aed8f433$var$byteToHex.push(($8fb7ad22aed8f433$var$i + 0x100).toString(16).slice(1));
function $8fb7ad22aed8f433$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    //
    // Note to future-self: No, you can't remove the `toLowerCase()` call.
    // REF: https://github.com/uuidjs/uuid/pull/677#issuecomment-1757351351
    return ($8fb7ad22aed8f433$var$byteToHex[arr[offset + 0]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 1]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 2]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 3]] + '-' + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 4]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 5]] + '-' + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 6]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 7]] + '-' + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 8]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 9]] + '-' + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 10]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 11]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 12]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 13]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 14]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 15]]).toLowerCase();
}
function $8fb7ad22aed8f433$var$stringify(arr, offset = 0) {
    var uuid = $8fb7ad22aed8f433$export$8fb373d660548968(arr, offset);
    // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $7d240e1718cbe118$export$2e2bcd8739ae039)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $8fb7ad22aed8f433$export$2e2bcd8739ae039 = $8fb7ad22aed8f433$var$stringify;


function $27d7069422be255c$var$v4(options, buf, offset) {
    if ((0, $b488569ebaeb416e$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $b488569ebaeb416e$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    var rnds = options.random || (options.rng || (0, $d0da4566d2fd20fe$export$2e2bcd8739ae039))();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $8fb7ad22aed8f433$export$8fb373d660548968)(rnds);
}
var $27d7069422be255c$export$2e2bcd8739ae039 = $27d7069422be255c$var$v4;


class $cc48b9a4f8310803$export$2e2bcd8739ae039 extends (0, $8NFma.Component) {
    static contextTypes = {
        _register: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func.isRequired,
        _unregister: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func.isRequired,
        _setProps: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func.isRequired,
        _handleChange: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func.isRequired,
        _handleBlur: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func.isRequired,
        _getProps: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func.isRequired
    };
    static propTypes = {
        validations: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func)
    };
    static defaultProps = {
        validations: []
    };
    id = (0, $27d7069422be255c$export$2e2bcd8739ae039)();
    componentDidMount() {
        this.context._register(this, this.id);
    }
    componentWillUnmount() {
        this.context._unregister(this, this.id);
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps !== this.props) this.context._setProps(nextProps, this.id);
    }
    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return nextContext !== this.context;
    }
    handleChange = (event)=>{
        event.persist();
        this.context._handleChange(event, this.id);
    };
    handleBlur = (event)=>{
        event.persist();
        this.context._handleBlur(event, this.id);
    };
    render() {
        return null;
    }
}


function $ecd163b239ffc845$export$2e2bcd8739ae039(WrappedComponent) {
    return class extends (0, $cc48b9a4f8310803$export$2e2bcd8739ae039) {
        static displayName = `Control(${WrappedComponent.name})`;
        render() {
            const props = this.context._getProps(this.id);
            if (!props) return null;
            return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)(WrappedComponent, {
                ...props,
                onChange: this.handleChange,
                onBlur: this.handleBlur
            });
        }
    };
}




// i'm so sorry about this shitty code :(
const $8a85d66883139d14$var$RadioButton = ({ error: error, isChanged: isChanged, isUsed: isUsed, ...allProps })=>{
    const { displayname: displayname, layout: layout, theme: theme, errorColor: errorColor, textColor: textColor, uncheckable: uncheckable, customwidth: customwidth, customdisplay: customdisplay, marginbottom: marginbottom, errorMessageDisplayNone: errorMessageDisplayNone, ...props } = {
        ...allProps
    };
    const untoggleRadio = ()=>{
        // If user clicks checked radio-button, uncheck it
        let inp = document.getElementById(radioRef.id);
        if (inp.checked) setTimeout(()=>inp.checked = false, 66);
    };
    let labelRef = null;
    let radioRef = null;
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($8a85d66883139d14$var$RadioWrapper, {
        layout: layout,
        theme: theme,
        displayname: displayname,
        customwidth: customwidth,
        customdisplay: customdisplay,
        marginbottom: marginbottom,
        errorColor: errorColor,
        errorMessageDisplayNone: errorMessageDisplayNone,
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("input", {
                "aria-labelledby": `${props.id}-radiolabel ${props.id}-hiddenlabel`,
                type: "radio",
                ref: (el)=>radioRef = el,
                ...props,
                ...isChanged && isUsed && error ? {
                    className: `is-invalid-input ${props.className}`
                } : {
                    className: props.className
                }
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("label", {
                id: `${props.id}-hiddenlabel`,
                ref: (el)=>labelRef = el,
                onClick: uncheckable ? untoggleRadio : ()=>0,
                htmlFor: props.id,
                children: [
                    theme !== 'big' && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($8a85d66883139d14$var$RadioLabel, {
                        textColor: textColor,
                        "aria-label": displayname,
                        className: "radiolabel",
                        id: `${props.id}-radiolabel`,
                        customdisplay: customdisplay,
                        children: displayname
                    }),
                    theme === 'big' && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                        id: `${props.id}-radiolabel`,
                        className: "visually-hidden",
                        children: displayname
                    }),
                    "\xa0"
                ]
            }),
            isChanged && isUsed && error
        ]
    });
};
var $8a85d66883139d14$export$2e2bcd8739ae039 = (0, $ecd163b239ffc845$export$2e2bcd8739ae039)($8a85d66883139d14$var$RadioButton);
const $8a85d66883139d14$var$wrapperPropsToExclude = [
    'layout',
    'customdisplay',
    'errorMessageDisplayNone',
    'marginbottom',
    'errorColor',
    'theme',
    'customwidth'
];
// styled components
const $8a85d66883139d14$var$RadioWrapper = (0, $65e706775ff71837$export$2e2bcd8739ae039).div.withConfig({
    shouldForwardProp: (prop, defaultValidatorFn)=>!$8a85d66883139d14$var$wrapperPropsToExclude.includes(prop)
})`
    position: relative;
    display: ${(props)=>props.layout == 'inline' ? 'inline-block' : 'block'};

    line-height: 1;

    // ie/edge fix
    ${'' /* line-height: 0; */ }

    ${(props)=>props.customdisplay ? `
        ${(0, $45d1242a07988139$export$8f880b6e390052fa).medium(`
            display: ${props.customdisplay};
        `)}
    ` : ``}


    ${(props)=>props.errorMessageDisplayNone ? `
        ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
            span.form-error {
                display: none;
            }
        `)}
    ` : ``}

    ${(props)=>props.marginbottom ? `
        ${(0, $45d1242a07988139$export$8f880b6e390052fa).medium(`
            margin-bottom: ${props.marginbottom};
        `)}
    ` : `
        ${(0, $45d1242a07988139$export$8f880b6e390052fa).medium(`
            margin-bottom: 0px;
        `)}
    `}

    &:not(:first-of-type) {
        margin-left: ${(props)=>props.layout == 'inline' ? '35px' : '0'};
        ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
            margin-left: 0px;
        `)}
    }

    // only show error for first of type in case this a radio button series
    &:not(:first-of-type) {
        span.form-error {
            opacity: 0;
        }
    }

    span.form-error {
        color: ${(props)=>props.errorColor ? props.errorColor : (0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.error};
    }

    input[type=radio] {
        position: absolute;
        opacity: 0;
    }

    input[type=radio] + label {
        cursor: pointer;
        padding: 0;
        display: block;
        padding-left: 30px;
    }

    // hide regular label, but only half-way for accessibility reasons
    input[type=radio].is-invalid-input + label,
    input[type=radio].is-invalid-input ~ .radiolabel { // see <RadioLabel> below
        margin-bottom: 0;
        color: ${(props)=>props.errorColor ? props.errorColor : (0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.error};
    }

    input[type=radio].is-invalid-input + label:before {
        border-color: ${(props)=>props.errorColor ? props.errorColor : (0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.error};
        background-color: white;
        margin-bottom: 0;
    }

    input[type=radio]:focus:not(:checked) + label:before {
        outline: rgb(59, 153, 252) auto 5px;
    }

    input[type=radio]:checked + label:after {
        position: absolute;
        content: '';

        height: 10px;
        width: 10px;

        border-radius: 5px;
        background-color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.green};

        left: 5px;
        top: 10px;
        transform: translateY(-50%);
    }

    label:before {
        display: block;
        content: '';
        position: absolute;
        top: 0;
        left: 0;

        vertical-align: sub; //text-top;
        margin-right: 10px;
        ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
            margin-right: 10px;
        `)}

        width: 20px;
        height: 20px;

        background: #f5f4f4;
        border: 1px solid #c5c9cc;
        border-radius: 10px;
    }

    // theme: big
    ${(props)=>props.theme === 'big' ? `
        // min-height: 150px;

        &:not(:first-of-type) {
            padding-left: 10px !important;
        }

        // ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        //     min-height: 103px;
        // `)}

        input[type=radio] + label {
            padding-left: 0;
        }


        input[type=radio]:focus + label:before {
            outline: none;
        }

        input[type=radio]:focus:not(:checked) + label:before {
            outline: none;
            box-shadow: inset 0px 0px 1px 1px rgb(59, 153, 252);
        }

        label:before {
            display: inline-block;
            content: '${props.displayname}';
            position: relative;

            width: auto;
            height: auto;
            // max-height: 70px;
            padding: 34px 53px;
            margin-bottom: 26px;
            margin-right: 10px;
            line-height: 1;

            font-family: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.heading};
            font-size: 22px;
            font-weight: bold;
            color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.almostBlack};

            background: transparent;
            border: none;
            border-radius: 0;
            outline: 1px solid ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.grayBorder};

            transition: outline 150ms ease-out, color 150ms ease-out;

            ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
                padding: 10px 15px 10px 15px;
                font-size: 20px;
                margin-bottom: 15px;
            `)}
        }

        input[type=radio]:checked + label:before {
            outline: 3px solid ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.green};
            color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.green};
        }

        input[type=radio]:checked + label:after {
            display: none;
        }

        .form-error {
            text-align: left;
            margin-top: 10px;

        }` : ''}

    ${(props)=>props.customwidth ? `
        ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
            width: ${props.customwidth};
        `)}
    ` : `
        ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
            width: 176px;
        `)}
    `}
`;
const $8a85d66883139d14$var$radioPropsToExclude = [
    'textColor',
    'customdisplay'
];
const $8a85d66883139d14$var$RadioLabel = (0, $65e706775ff71837$export$2e2bcd8739ae039).div.withConfig({
    shouldForwardProp: (prop, defaultValidatorFn)=>!$8a85d66883139d14$var$radioPropsToExclude.includes(prop)
})`
    display: inline-block;
    font-size: 16px;
    hyphens: auto;
    color: ${(props)=>props.textColor ? props.textColor : 'black'};
    cursor: pointer;
    pointer-events: none;
    padding-top: 2px;

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        padding-top: 4px;
        font-size: 13px;
    `)}
    cursor: pointer;

    ${(props)=>props.customdisplay ? `
        display: ${props.customdisplay};
    ` : ``}
`;


parcelRequire("8NFma");



const $3dd5c3afc4410032$export$ea9bc56cad11e33b = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    display: block;
    width: 100%;

    margin-top: 15px;
    margin-bottom: 20px;
    padding: 30px;
    border-radius: 5px;

    background-color: white;
    ${(0, $45d1242a07988139$export$8c467e8859fdef13)()}

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).medium(`
        padding: 20px;
        margin-bottom: 15px;
    `)}

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        padding: 15px;
        margin-bottom: 15px;
    `)}
`;
const $3dd5c3afc4410032$export$29d11c0fe2fc51d8 = (0, $65e706775ff71837$export$2e2bcd8739ae039).a`
    position: relative;
    display: inline-block;
    width: auto;

    margin-top: 30px;
    padding: 7px 20px 7px 20px;

    font-family: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.heading};
    font-size: 18px;
    font-weight: bold;
    color: white;

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).large(`
        font-size: 16px;
    `)}

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).medium(`
        margin-top: 0px;
        margin-bottom: 0px;
    `)}

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        margin-top: 0px;
        margin-bottom: 0px;
    `)}

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).xxsmall(`
        padding: 7px 15px 7px 15px;
    `)}

    background-color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.green};

    transition: background-color 300ms ease-out;

    &:hover {
        text-decoration: none;
        color: white;
    }
`;
const $3dd5c3afc4410032$export$cfc7921d29ef7b80 = (0, $65e706775ff71837$export$2e2bcd8739ae039).button`
    position: relative;
    display: inline-block;
    width: auto;

    padding: 10px 20px 10px 20px;
    margin-right: 20px;

    font-family: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.heading};
    font-size: 18px;
    ${(0, $45d1242a07988139$export$8f880b6e390052fa).large(`
        font-size: 16px;
    `)}

    font-weight: bold;
    color: white;

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        margin: 0px 10px 10px 0px;
    `)}

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).xxsmall(`
        padding: 10px 15px 10px 15px;
    `)}

    background-color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.green};
    border-radius: 5px;

    transition: background-color 300ms ease-out;

    &:hover {
        text-decoration: none;
        color: white;
    }
`;




var $8NFma = parcelRequire("8NFma");



var $8NFma = parcelRequire("8NFma");

var $e97c31e13ca7cbde$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var $e97c31e13ca7cbde$var$LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var $e97c31e13ca7cbde$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used as references for various `Number` constants. */ var $e97c31e13ca7cbde$var$INFINITY = 1 / 0, $e97c31e13ca7cbde$var$MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var $e97c31e13ca7cbde$var$argsTag = '[object Arguments]', $e97c31e13ca7cbde$var$funcTag = '[object Function]', $e97c31e13ca7cbde$var$genTag = '[object GeneratorFunction]', $e97c31e13ca7cbde$var$symbolTag = '[object Symbol]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $e97c31e13ca7cbde$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $e97c31e13ca7cbde$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var $e97c31e13ca7cbde$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/** Detect free variable `global` from Node.js. */ var $e97c31e13ca7cbde$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $e97c31e13ca7cbde$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $e97c31e13ca7cbde$var$root = $e97c31e13ca7cbde$var$freeGlobal || $e97c31e13ca7cbde$var$freeSelf || Function('return this')();
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $e97c31e13ca7cbde$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $e97c31e13ca7cbde$var$arrayIncludes(array, value) {
    var length = array ? array.length : 0;
    return !!length && $e97c31e13ca7cbde$var$baseIndexOf(array, value, 0) > -1;
}
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $e97c31e13ca7cbde$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $e97c31e13ca7cbde$var$arrayMap(array, iteratee) {
    var index = -1, length = array ? array.length : 0, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $e97c31e13ca7cbde$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $e97c31e13ca7cbde$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $e97c31e13ca7cbde$var$baseIndexOf(array, value, fromIndex) {
    if (value !== value) return $e97c31e13ca7cbde$var$baseFindIndex(array, $e97c31e13ca7cbde$var$baseIsNaN, fromIndex);
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $e97c31e13ca7cbde$var$baseIsNaN(value) {
    return value !== value;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $e97c31e13ca7cbde$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $e97c31e13ca7cbde$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Checks if a cache value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e97c31e13ca7cbde$var$cacheHas(cache, key) {
    return cache.has(key);
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $e97c31e13ca7cbde$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function $e97c31e13ca7cbde$var$isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') try {
        result = !!(value + '');
    } catch (e) {}
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $e97c31e13ca7cbde$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var $e97c31e13ca7cbde$var$arrayProto = Array.prototype, $e97c31e13ca7cbde$var$funcProto = Function.prototype, $e97c31e13ca7cbde$var$objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var $e97c31e13ca7cbde$var$coreJsData = $e97c31e13ca7cbde$var$root['__core-js_shared__'];
/** Used to detect methods masquerading as native. */ var $e97c31e13ca7cbde$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($e97c31e13ca7cbde$var$coreJsData && $e97c31e13ca7cbde$var$coreJsData.keys && $e97c31e13ca7cbde$var$coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/** Used to resolve the decompiled source of functions. */ var $e97c31e13ca7cbde$var$funcToString = $e97c31e13ca7cbde$var$funcProto.toString;
/** Used to check objects for own properties. */ var $e97c31e13ca7cbde$var$hasOwnProperty = $e97c31e13ca7cbde$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $e97c31e13ca7cbde$var$objectToString = $e97c31e13ca7cbde$var$objectProto.toString;
/** Used to detect if a method is native. */ var $e97c31e13ca7cbde$var$reIsNative = RegExp('^' + $e97c31e13ca7cbde$var$funcToString.call($e97c31e13ca7cbde$var$hasOwnProperty).replace($e97c31e13ca7cbde$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var $e97c31e13ca7cbde$var$Symbol = $e97c31e13ca7cbde$var$root.Symbol, $e97c31e13ca7cbde$var$getPrototype = $e97c31e13ca7cbde$var$overArg(Object.getPrototypeOf, Object), $e97c31e13ca7cbde$var$propertyIsEnumerable = $e97c31e13ca7cbde$var$objectProto.propertyIsEnumerable, $e97c31e13ca7cbde$var$splice = $e97c31e13ca7cbde$var$arrayProto.splice, $e97c31e13ca7cbde$var$spreadableSymbol = $e97c31e13ca7cbde$var$Symbol ? $e97c31e13ca7cbde$var$Symbol.isConcatSpreadable : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $e97c31e13ca7cbde$var$nativeGetSymbols = Object.getOwnPropertySymbols, $e97c31e13ca7cbde$var$nativeMax = Math.max;
/* Built-in method references that are verified to be native. */ var $e97c31e13ca7cbde$var$Map = $e97c31e13ca7cbde$var$getNative($e97c31e13ca7cbde$var$root, 'Map'), $e97c31e13ca7cbde$var$nativeCreate = $e97c31e13ca7cbde$var$getNative(Object, 'create');
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $e97c31e13ca7cbde$var$Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $e97c31e13ca7cbde$var$hashClear() {
    this.__data__ = $e97c31e13ca7cbde$var$nativeCreate ? $e97c31e13ca7cbde$var$nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $e97c31e13ca7cbde$var$hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $e97c31e13ca7cbde$var$hashGet(key) {
    var data = this.__data__;
    if ($e97c31e13ca7cbde$var$nativeCreate) {
        var result = data[key];
        return result === $e97c31e13ca7cbde$var$HASH_UNDEFINED ? undefined : result;
    }
    return $e97c31e13ca7cbde$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e97c31e13ca7cbde$var$hashHas(key) {
    var data = this.__data__;
    return $e97c31e13ca7cbde$var$nativeCreate ? data[key] !== undefined : $e97c31e13ca7cbde$var$hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $e97c31e13ca7cbde$var$hashSet(key, value) {
    var data = this.__data__;
    data[key] = $e97c31e13ca7cbde$var$nativeCreate && value === undefined ? $e97c31e13ca7cbde$var$HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
$e97c31e13ca7cbde$var$Hash.prototype.clear = $e97c31e13ca7cbde$var$hashClear;
$e97c31e13ca7cbde$var$Hash.prototype['delete'] = $e97c31e13ca7cbde$var$hashDelete;
$e97c31e13ca7cbde$var$Hash.prototype.get = $e97c31e13ca7cbde$var$hashGet;
$e97c31e13ca7cbde$var$Hash.prototype.has = $e97c31e13ca7cbde$var$hashHas;
$e97c31e13ca7cbde$var$Hash.prototype.set = $e97c31e13ca7cbde$var$hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $e97c31e13ca7cbde$var$ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $e97c31e13ca7cbde$var$listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $e97c31e13ca7cbde$var$listCacheDelete(key) {
    var data = this.__data__, index = $e97c31e13ca7cbde$var$assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $e97c31e13ca7cbde$var$splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $e97c31e13ca7cbde$var$listCacheGet(key) {
    var data = this.__data__, index = $e97c31e13ca7cbde$var$assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e97c31e13ca7cbde$var$listCacheHas(key) {
    return $e97c31e13ca7cbde$var$assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $e97c31e13ca7cbde$var$listCacheSet(key, value) {
    var data = this.__data__, index = $e97c31e13ca7cbde$var$assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
$e97c31e13ca7cbde$var$ListCache.prototype.clear = $e97c31e13ca7cbde$var$listCacheClear;
$e97c31e13ca7cbde$var$ListCache.prototype['delete'] = $e97c31e13ca7cbde$var$listCacheDelete;
$e97c31e13ca7cbde$var$ListCache.prototype.get = $e97c31e13ca7cbde$var$listCacheGet;
$e97c31e13ca7cbde$var$ListCache.prototype.has = $e97c31e13ca7cbde$var$listCacheHas;
$e97c31e13ca7cbde$var$ListCache.prototype.set = $e97c31e13ca7cbde$var$listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $e97c31e13ca7cbde$var$MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $e97c31e13ca7cbde$var$mapCacheClear() {
    this.__data__ = {
        'hash': new $e97c31e13ca7cbde$var$Hash,
        'map': new ($e97c31e13ca7cbde$var$Map || $e97c31e13ca7cbde$var$ListCache),
        'string': new $e97c31e13ca7cbde$var$Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $e97c31e13ca7cbde$var$mapCacheDelete(key) {
    return $e97c31e13ca7cbde$var$getMapData(this, key)['delete'](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $e97c31e13ca7cbde$var$mapCacheGet(key) {
    return $e97c31e13ca7cbde$var$getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e97c31e13ca7cbde$var$mapCacheHas(key) {
    return $e97c31e13ca7cbde$var$getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $e97c31e13ca7cbde$var$mapCacheSet(key, value) {
    $e97c31e13ca7cbde$var$getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
$e97c31e13ca7cbde$var$MapCache.prototype.clear = $e97c31e13ca7cbde$var$mapCacheClear;
$e97c31e13ca7cbde$var$MapCache.prototype['delete'] = $e97c31e13ca7cbde$var$mapCacheDelete;
$e97c31e13ca7cbde$var$MapCache.prototype.get = $e97c31e13ca7cbde$var$mapCacheGet;
$e97c31e13ca7cbde$var$MapCache.prototype.has = $e97c31e13ca7cbde$var$mapCacheHas;
$e97c31e13ca7cbde$var$MapCache.prototype.set = $e97c31e13ca7cbde$var$mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $e97c31e13ca7cbde$var$SetCache(values) {
    var index = -1, length = values ? values.length : 0;
    this.__data__ = new $e97c31e13ca7cbde$var$MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $e97c31e13ca7cbde$var$setCacheAdd(value) {
    this.__data__.set(value, $e97c31e13ca7cbde$var$HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $e97c31e13ca7cbde$var$setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
$e97c31e13ca7cbde$var$SetCache.prototype.add = $e97c31e13ca7cbde$var$SetCache.prototype.push = $e97c31e13ca7cbde$var$setCacheAdd;
$e97c31e13ca7cbde$var$SetCache.prototype.has = $e97c31e13ca7cbde$var$setCacheHas;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $e97c31e13ca7cbde$var$arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = $e97c31e13ca7cbde$var$isArray(value) || $e97c31e13ca7cbde$var$isArguments(value) ? $e97c31e13ca7cbde$var$baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || $e97c31e13ca7cbde$var$hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || $e97c31e13ca7cbde$var$isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $e97c31e13ca7cbde$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($e97c31e13ca7cbde$var$eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */ function $e97c31e13ca7cbde$var$baseDifference(array, values, iteratee, comparator) {
    var index = -1, includes = $e97c31e13ca7cbde$var$arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
    if (!length) return result;
    if (iteratee) values = $e97c31e13ca7cbde$var$arrayMap(values, $e97c31e13ca7cbde$var$baseUnary(iteratee));
    if (comparator) {
        includes = $e97c31e13ca7cbde$var$arrayIncludesWith;
        isCommon = false;
    } else if (values.length >= $e97c31e13ca7cbde$var$LARGE_ARRAY_SIZE) {
        includes = $e97c31e13ca7cbde$var$cacheHas;
        isCommon = false;
        values = new $e97c31e13ca7cbde$var$SetCache(values);
    }
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var valuesIndex = valuesLength;
            while(valuesIndex--){
                if (values[valuesIndex] === computed) continue outer;
            }
            result.push(value);
        } else if (!includes(values, computed, comparator)) result.push(value);
    }
    return result;
}
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $e97c31e13ca7cbde$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $e97c31e13ca7cbde$var$isFlattenable);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $e97c31e13ca7cbde$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $e97c31e13ca7cbde$var$arrayPush(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $e97c31e13ca7cbde$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $e97c31e13ca7cbde$var$isArray(object) ? result : $e97c31e13ca7cbde$var$arrayPush(result, symbolsFunc(object));
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $e97c31e13ca7cbde$var$baseIsNative(value) {
    if (!$e97c31e13ca7cbde$var$isObject(value) || $e97c31e13ca7cbde$var$isMasked(value)) return false;
    var pattern = $e97c31e13ca7cbde$var$isFunction(value) || $e97c31e13ca7cbde$var$isHostObject(value) ? $e97c31e13ca7cbde$var$reIsNative : $e97c31e13ca7cbde$var$reIsHostCtor;
    return pattern.test($e97c31e13ca7cbde$var$toSource(value));
}
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $e97c31e13ca7cbde$var$baseKeysIn(object) {
    if (!$e97c31e13ca7cbde$var$isObject(object)) return $e97c31e13ca7cbde$var$nativeKeysIn(object);
    var isProto = $e97c31e13ca7cbde$var$isPrototype(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$e97c31e13ca7cbde$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} props The property identifiers to pick.
 * @returns {Object} Returns the new object.
 */ function $e97c31e13ca7cbde$var$basePick(object, props) {
    object = Object(object);
    return $e97c31e13ca7cbde$var$basePickBy(object, props, function(value, key) {
        return key in object;
    });
}
/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} props The property identifiers to pick from.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function $e97c31e13ca7cbde$var$basePickBy(object, props, predicate) {
    var index = -1, length = props.length, result = {};
    while(++index < length){
        var key = props[index], value = object[key];
        if (predicate(value, key)) result[key] = value;
    }
    return result;
}
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $e97c31e13ca7cbde$var$baseRest(func, start) {
    start = $e97c31e13ca7cbde$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $e97c31e13ca7cbde$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = array;
        return $e97c31e13ca7cbde$var$apply(func, this, otherArgs);
    };
}
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $e97c31e13ca7cbde$var$getAllKeysIn(object) {
    return $e97c31e13ca7cbde$var$baseGetAllKeys(object, $e97c31e13ca7cbde$var$keysIn, $e97c31e13ca7cbde$var$getSymbolsIn);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $e97c31e13ca7cbde$var$getMapData(map, key) {
    var data = map.__data__;
    return $e97c31e13ca7cbde$var$isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $e97c31e13ca7cbde$var$getNative(object, key) {
    var value = $e97c31e13ca7cbde$var$getValue(object, key);
    return $e97c31e13ca7cbde$var$baseIsNative(value) ? value : undefined;
}
/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $e97c31e13ca7cbde$var$getSymbols = $e97c31e13ca7cbde$var$nativeGetSymbols ? $e97c31e13ca7cbde$var$overArg($e97c31e13ca7cbde$var$nativeGetSymbols, Object) : $e97c31e13ca7cbde$var$stubArray;
/**
 * Creates an array of the own and inherited enumerable symbol properties
 * of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $e97c31e13ca7cbde$var$getSymbolsIn = !$e97c31e13ca7cbde$var$nativeGetSymbols ? $e97c31e13ca7cbde$var$stubArray : function(object) {
    var result = [];
    while(object){
        $e97c31e13ca7cbde$var$arrayPush(result, $e97c31e13ca7cbde$var$getSymbols(object));
        object = $e97c31e13ca7cbde$var$getPrototype(object);
    }
    return result;
};
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $e97c31e13ca7cbde$var$isFlattenable(value) {
    return $e97c31e13ca7cbde$var$isArray(value) || $e97c31e13ca7cbde$var$isArguments(value) || !!($e97c31e13ca7cbde$var$spreadableSymbol && value && value[$e97c31e13ca7cbde$var$spreadableSymbol]);
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $e97c31e13ca7cbde$var$isIndex(value, length) {
    length = length == null ? $e97c31e13ca7cbde$var$MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || $e97c31e13ca7cbde$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $e97c31e13ca7cbde$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $e97c31e13ca7cbde$var$isMasked(func) {
    return !!$e97c31e13ca7cbde$var$maskSrcKey && $e97c31e13ca7cbde$var$maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $e97c31e13ca7cbde$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $e97c31e13ca7cbde$var$objectProto;
    return value === proto;
}
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $e97c31e13ca7cbde$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $e97c31e13ca7cbde$var$toKey(value) {
    if (typeof value == 'string' || $e97c31e13ca7cbde$var$isSymbol(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$e97c31e13ca7cbde$var$INFINITY ? '-0' : result;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function $e97c31e13ca7cbde$var$toSource(func) {
    if (func != null) {
        try {
            return $e97c31e13ca7cbde$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $e97c31e13ca7cbde$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function $e97c31e13ca7cbde$var$isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return $e97c31e13ca7cbde$var$isArrayLikeObject(value) && $e97c31e13ca7cbde$var$hasOwnProperty.call(value, 'callee') && (!$e97c31e13ca7cbde$var$propertyIsEnumerable.call(value, 'callee') || $e97c31e13ca7cbde$var$objectToString.call(value) == $e97c31e13ca7cbde$var$argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $e97c31e13ca7cbde$var$isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $e97c31e13ca7cbde$var$isArrayLike(value) {
    return value != null && $e97c31e13ca7cbde$var$isLength(value.length) && !$e97c31e13ca7cbde$var$isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $e97c31e13ca7cbde$var$isArrayLikeObject(value) {
    return $e97c31e13ca7cbde$var$isObjectLike(value) && $e97c31e13ca7cbde$var$isArrayLike(value);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $e97c31e13ca7cbde$var$isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = $e97c31e13ca7cbde$var$isObject(value) ? $e97c31e13ca7cbde$var$objectToString.call(value) : '';
    return tag == $e97c31e13ca7cbde$var$funcTag || tag == $e97c31e13ca7cbde$var$genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $e97c31e13ca7cbde$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $e97c31e13ca7cbde$var$MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $e97c31e13ca7cbde$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $e97c31e13ca7cbde$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $e97c31e13ca7cbde$var$isSymbol(value) {
    return typeof value == 'symbol' || $e97c31e13ca7cbde$var$isObjectLike(value) && $e97c31e13ca7cbde$var$objectToString.call(value) == $e97c31e13ca7cbde$var$symbolTag;
}
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $e97c31e13ca7cbde$var$keysIn(object) {
    return $e97c31e13ca7cbde$var$isArrayLike(object) ? $e97c31e13ca7cbde$var$arrayLikeKeys(object, true) : $e97c31e13ca7cbde$var$baseKeysIn(object);
}
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable string keyed properties of `object` that are
 * not omitted.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [props] The property identifiers to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $e97c31e13ca7cbde$var$omit = $e97c31e13ca7cbde$var$baseRest(function(object, props) {
    if (object == null) return {};
    props = $e97c31e13ca7cbde$var$arrayMap($e97c31e13ca7cbde$var$baseFlatten(props, 1), $e97c31e13ca7cbde$var$toKey);
    return $e97c31e13ca7cbde$var$basePick(object, $e97c31e13ca7cbde$var$baseDifference($e97c31e13ca7cbde$var$getAllKeysIn(object), props));
});
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $e97c31e13ca7cbde$var$stubArray() {
    return [];
}
$e97c31e13ca7cbde$exports = $e97c31e13ca7cbde$var$omit;


const $55d82dae47c14986$var$_isCheckable = (component)=>component.props.type === 'radio' || component.props.type === 'checkbox';
function $55d82dae47c14986$export$2e2bcd8739ae039(WrappedComponent) {
    return class extends (0, $8NFma.PureComponent) {
        static displayName = `Form(${WrappedComponent.name})`;
        static propTypes = {};
        static childContextTypes = {
            _register: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func.isRequired,
            _unregister: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func.isRequired,
            _setProps: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func.isRequired,
            _handleChange: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func.isRequired,
            _handleBlur: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func.isRequired,
            _getProps: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func.isRequired,
            _errors: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).array
        };
        constructor(props, context){
            super(props, context);
            this.state = {
                byName: {},
                byId: {}
            };
        }
        getChildContext() {
            return {
                _register: this._register,
                _unregister: this._unregister,
                _setProps: this._setProps,
                _handleChange: this._handleChange,
                _handleBlur: this._handleBlur,
                _getProps: this._getProps,
                _errors: Object.keys(this.state.byId).filter((id)=>this.state.byId[id].error)
            };
        }
        _register = (component, id)=>{
            this.setState((state)=>({
                    byName: {
                        ...state.byName,
                        [component.props.name]: [
                            ...state.byName[component.props.name] || [],
                            id
                        ]
                    },
                    byId: {
                        ...state.byId,
                        [id]: {
                            ...component.props,
                            isCheckable: $55d82dae47c14986$var$_isCheckable(component),
                            value: component.props.value || '',
                            ...$55d82dae47c14986$var$_isCheckable(component) ? {
                                checked: !!component.props.checked
                            } : {}
                        }
                    }
                }), this._setErrors);
        };
        _unregister = (component, id)=>{
            const byComponentName = [
                ...this.state.byName[component.props.name]
            ];
            byComponentName.splice(byComponentName.indexOf(id), 1);
            const byName = byComponentName.length ? {
                ...this.state.byName,
                [component.props.name]: byComponentName
            } : (0, (/*@__PURE__*/$parcel$interopDefault($e97c31e13ca7cbde$exports)))(this.state.byName, component.props.name);
            this.setState({
                byName: byName,
                byId: (0, (/*@__PURE__*/$parcel$interopDefault($e97c31e13ca7cbde$exports)))(this.state.byId, id)
            });
        };
        _getProps = (id)=>{
            if (this.state.byId[id]) {
                const { validations: validations, isCheckable: isCheckable, ...props } = this.state.byId[id];
                return props;
            }
        };
        _setProps = (props, id)=>{
            this.setState((state)=>({
                    byId: {
                        ...state.byId,
                        [id]: {
                            ...state.byId[id],
                            ...props
                        }
                    }
                }), this._setErrors);
        };
        _handleChange = (event, id)=>{
            const isCheckable = this.state.byId[id].isCheckable;
            this.setState({
                byId: {
                    ...this.state.byId,
                    ...isCheckable ? {
                        ...this.state.byName[this.state.byId[id].name].reduce((components, id)=>{
                            components[id] = {
                                ...this.state.byId[id],
                                checked: false
                            };
                            return components;
                        }, {})
                    } : {},
                    [id]: {
                        ...this.state.byId[id],
                        isChanged: true,
                        value: event.target.value,
                        ...isCheckable && {
                            checked: event.target.checked
                        }
                    }
                }
            }, this._setErrors);
        };
        _handleBlur = (event, id)=>{
            this.setState({
                byId: {
                    ...this.state.byId,
                    [id]: {
                        ...this.state.byId[id],
                        isUsed: true,
                        value: event.target.value
                    }
                }
            }, this._setErrors);
        };
        _setErrors = ()=>{
            this.setState((state)=>{
                return {
                    byId: Object.keys(state.byId).reduce((byId, id)=>{
                        const validations = state.byId[id].validations;
                        const props = state.byId[id];
                        const components = Object.keys(state.byName).reduce((byName, name)=>{
                            byName[name] = state.byName[name].map((id)=>state.byId[id]);
                            return byName;
                        }, {});
                        const value = props.value;
                        byId[id] = {
                            ...state.byId[id]
                        };
                        for (const validation of validations){
                            const error = validation(value, props, components);
                            if (error) {
                                byId[id].error = error;
                                break;
                            } else delete byId[id].error;
                        }
                        return byId;
                    }, {})
                };
            });
        };
        getValues = ()=>Object.keys(this.state.byName).reduce((values, name)=>{
                if (this.state.byName[name].length > 1) values[name] = this.state.byName[name].map((id)=>this.state.byId[id].value);
                else values[name] = this.state.byId[this.state.byName[name][0]].value;
                return values;
            }, {});
        validate = (name)=>{
            this.setState((state)=>({
                    byId: {
                        ...state.byId,
                        ...state.byName[name].reduce((byId, id)=>{
                            byId[id] = {
                                ...state.byId[id],
                                isChanged: true,
                                isUsed: true
                            };
                            return byId;
                        }, {})
                    }
                }), this._setErrors);
        };
        validateAll = ()=>{
            this.setState((state)=>({
                    byId: {
                        ...state.byId,
                        ...Object.keys(state.byName).reduce((byId, name)=>{
                            state.byName[name].reduce((components, id)=>{
                                byId[id] = {
                                    ...state.byId[id],
                                    isChanged: true,
                                    isUsed: true
                                };
                                return components;
                            }, {});
                            return byId;
                        }, {})
                    }
                }), this._setErrors);
        };
        showError = (component, error)=>{
            if (component) setTimeout(()=>{
                this.setState({
                    byId: {
                        ...this.state.byId,
                        [component.id]: {
                            ...this.state.byId[component.id],
                            isChanged: true,
                            isUsed: true,
                            error: error
                        }
                    }
                });
            }, 0);
        };
        hideError = (component)=>{
            this.setState((state)=>({
                    byId: {
                        ...state.byId,
                        [component.id]: {
                            ...(0, (/*@__PURE__*/$parcel$interopDefault($e97c31e13ca7cbde$exports)))(state.byId[component.id], 'error'),
                            isChanged: false,
                            isUsed: false
                        }
                    }
                }));
        };
        render() {
            return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)(WrappedComponent, {
                ...this.props,
                validate: this.validate,
                validateAll: this.validateAll,
                getValues: this.getValues,
                showError: this.showError,
                hideError: this.hideError
            });
        }
    };
}


class $8c02aa23a40a9b45$var$Form extends (0, $8NFma.Component) {
    static propTypes = {
        getValues: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func.isRequired,
        validate: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func.isRequired,
        validateAll: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func.isRequired,
        showError: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func.isRequired,
        hideError: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func.isRequired
    };
    render() {
        const { getValues: getValues, validate: validate, validateAll: validateAll, showError: showError, hideError: hideError, ...props } = this.props;
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("form", {
            ...props
        });
    }
}
var $8c02aa23a40a9b45$export$2e2bcd8739ae039 = (0, $55d82dae47c14986$export$2e2bcd8739ae039)($8c02aa23a40a9b45$var$Form);



parcelRequire("8NFma");

var $YChVI = parcelRequire("YChVI");
var $41cc8a07a576c3f4$exports = {};
"use strict";
Object.defineProperty($41cc8a07a576c3f4$exports, "__esModule", {
    value: true
});
$41cc8a07a576c3f4$exports.default = $41cc8a07a576c3f4$var$isISO8601;

var $41cc8a07a576c3f4$var$_assertString = $41cc8a07a576c3f4$var$_interopRequireDefault((parcelRequire("3OyjO")));
function $41cc8a07a576c3f4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/* eslint-disable max-len */ // from http://goo.gl/0ejHHW
var $41cc8a07a576c3f4$var$iso8601 = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-3])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/;
// same as above, except with a strict 'T' separator between date and time
var $41cc8a07a576c3f4$var$iso8601StrictSeparator = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-3])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/;
/* eslint-enable max-len */ var $41cc8a07a576c3f4$var$isValidDate = function isValidDate(str) {
    // str must have passed the ISO8601 check
    // this check is meant to catch invalid dates
    // like 2009-02-31
    // first check for ordinal dates
    var ordinalMatch = str.match(/^(\d{4})-?(\d{3})([ T]{1}\.*|$)/);
    if (ordinalMatch) {
        var oYear = Number(ordinalMatch[1]);
        var oDay = Number(ordinalMatch[2]);
        // if is leap year
        if (oYear % 4 === 0 && oYear % 100 !== 0 || oYear % 400 === 0) return oDay <= 366;
        return oDay <= 365;
    }
    var match = str.match(/(\d{4})-?(\d{0,2})-?(\d*)/).map(Number);
    var year = match[1];
    var month = match[2];
    var day = match[3];
    var monthString = month ? "0".concat(month).slice(-2) : month;
    var dayString = day ? "0".concat(day).slice(-2) : day;
    // create a date object and compare
    var d = new Date("".concat(year, "-").concat(monthString || '01', "-").concat(dayString || '01'));
    if (month && day) return d.getUTCFullYear() === year && d.getUTCMonth() + 1 === month && d.getUTCDate() === day;
    return true;
};
function $41cc8a07a576c3f4$var$isISO8601(str) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, $41cc8a07a576c3f4$var$_assertString.default)(str);
    var check = options.strictSeparator ? $41cc8a07a576c3f4$var$iso8601StrictSeparator.test(str) : $41cc8a07a576c3f4$var$iso8601.test(str);
    if (check && options.strict) return $41cc8a07a576c3f4$var$isValidDate(str);
    return check;
}
$41cc8a07a576c3f4$exports = $41cc8a07a576c3f4$exports.default;
$41cc8a07a576c3f4$exports.default = $41cc8a07a576c3f4$exports.default;


// src/errors.ts
var $cc655631f417fb2d$var$PersonnummerError = class extends Error {
    constructor(){
        super("Invalid swedish personal identity number");
    }
};
// src/utils.ts
var $cc655631f417fb2d$var$compareAsc = (dateLeft, dateRight)=>{
    const diff = dateLeft.getTime() - dateRight.getTime();
    return diff < 0 ? -1 : diff > 0 ? 1 : diff;
};
var $cc655631f417fb2d$var$diffInYears = (dateLeft, dateRight)=>{
    const sign = $cc655631f417fb2d$var$compareAsc(dateLeft, dateRight);
    const yearDiff = Math.abs(dateLeft.getFullYear() - dateRight.getFullYear());
    dateLeft.setFullYear(dateLeft.getFullYear() - sign * yearDiff);
    const isLastYearNotFull = $cc655631f417fb2d$var$compareAsc(dateLeft, dateRight) === -sign;
    const result = sign * (yearDiff - +isLastYearNotFull);
    return result === 0 ? 0 : result;
};
var $cc655631f417fb2d$var$luhn = (str)=>{
    let sum = 0;
    str += "";
    for(let i = 0, l = str.length; i < l; i++){
        let v = parseInt(str[i]);
        v *= 2 - i % 2;
        if (v > 9) v -= 9;
        sum += v;
    }
    return Math.ceil(sum / 10) * 10 - sum;
};
var $cc655631f417fb2d$var$testDate = (year, month, day)=>{
    month -= 1;
    const date = new Date(year, month, day);
    return !(date.getFullYear() !== year || date.getMonth() !== month || date.getDate() !== day);
};
// src/index.ts
var $cc655631f417fb2d$var$Personnummer = class {
    /**
   * Personnummer constructor.
   *
   * @param {string} pin
   * @param {object} options
   */ constructor(pin, options){
        /**
     * Personnummer century.
     *
     * @var {string}
     */ this._century = "";
        /**
     * Personnummer full year.
     *
     * @var {string}
     */ this._fullYear = "";
        /**
     * Personnummer year.
     *
     * @var {string}
     */ this._year = "";
        /**
     * Personnummer month.
     *
     * @var {string}
     */ this._month = "";
        /**
     * Personnummer day.
     *
     * @var {string}
     */ this._day = "";
        /**
     * Personnummer seperator.
     *
     * @var {string}
     */ this._sep = "";
        /**
     * Personnumer first three of the last four numbers.
     *
     * @var {string}
     */ this._num = "";
        /**
     * The last number of the personnummer.
     *
     * @var {string}
     */ this._check = "";
        this.parse(pin, {
            allowCoordinationNumber: true,
            allowInterimNumber: false,
            ...options
        });
    }
    /**
   * Get century.
   *
   * @return {string}
   */ get century() {
        return this._century;
    }
    /**
   * Get age.
   *
   * @return {string}
   */ get fullYear() {
        return this._fullYear;
    }
    /**
   * Get age.
   *
   * @return {string}
   */ get year() {
        return this._year;
    }
    /**
   * Get month.
   *
   * @return {string}
   */ get month() {
        return this._month;
    }
    /**
   * Get day.
   *
   * @return {string}
   */ get day() {
        return this._day;
    }
    /**
   * Get sep.
   *
   * @return {string}
   */ get sep() {
        return this._sep;
    }
    /**
   * Get num.
   *
   * @return {string}
   */ get num() {
        return this._num;
    }
    /**
   * Get check.
   *
   * @return {string}
   */ get check() {
        return this._check;
    }
    /**
   * Parse personnummer.
   *
   * @param {string} pin
   * @param {object} options
   *
   * @return {Personnummer}
   */ static parse(pin, options) {
        return new $cc655631f417fb2d$var$Personnummer(pin, options);
    }
    /**
   * Validate a Swedish personal identity number.
   *
   * @param {string} str
   * @param {object} options
   *
   * @return {boolean}
   */ static valid(pin, options) {
        try {
            $cc655631f417fb2d$var$Personnummer.parse(pin, options);
            return true;
        } catch (e) {
            return false;
        }
    }
    /**
   * Parse personnummer and set class properties.
   *
   * @param {string} pin
   * @param {object} options
   */ parse(pin, options) {
        if (pin.length < 10 || pin.length > 13) throw new $cc655631f417fb2d$var$PersonnummerError();
        const reg = /^(\d{2}){0,1}(\d{2})(\d{2})(\d{2})([+-]?)((?!000)\d{3}|[TRSUWXJKLMN]\d{2})(\d)$/;
        const match = reg.exec(pin);
        if (!match) throw new $cc655631f417fb2d$var$PersonnummerError();
        const century = match[1];
        const year = match[2];
        const month = match[3];
        const day = match[4];
        const sep = match[5];
        const num = match[6];
        const check = match[7];
        if (typeof century === "undefined" || !century.length) {
            const d = /* @__PURE__ */ new Date();
            let baseYear = 0;
            if (sep === "+") {
                this._sep = "+";
                baseYear = d.getFullYear() - 100;
            } else {
                this._sep = "-";
                baseYear = d.getFullYear();
            }
            this._century = ("" + (baseYear - (baseYear - parseInt(year)) % 100)).substr(0, 2);
        } else {
            this._century = century;
            if (/* @__PURE__ */ new Date().getFullYear() - parseInt(century + year, 10) < 100) this._sep = "-";
            else this._sep = "+";
        }
        this._year = year;
        this._fullYear = this._century + year;
        this._month = month;
        this._day = day;
        this._num = num;
        this._check = check;
        if (!this.valid()) throw new $cc655631f417fb2d$var$PersonnummerError();
        if (!(options == null ? void 0 : options.allowCoordinationNumber) && this.isCoordinationNumber()) throw new $cc655631f417fb2d$var$PersonnummerError();
        if (!(options == null ? void 0 : options.allowInterimNumber) && this.isInterimNumber()) throw new $cc655631f417fb2d$var$PersonnummerError();
    }
    /**
   * Validate a Swedish personal identity number.
   *
   * @return {boolean}
   */ valid() {
        const valid = $cc655631f417fb2d$var$luhn(this.year + this.month + this.day + this.num.replace(/[TRSUWXJKLMN]/, "1")) === +this.check && !!this.check;
        if (valid && $cc655631f417fb2d$var$testDate(parseInt(this.century + this.year), +this.month, +this.day)) return valid;
        return valid && $cc655631f417fb2d$var$testDate(parseInt(this.century + this.year), +this.month, +this.day - 60);
    }
    /**
   * Format a Swedish personal identity number as one of the official formats,
   * A long format or a short format.
   *
   * If the input number could not be parsed a empty string will be returned.
   *
   * @param {boolean} longFormat
   *
   * @return {string}
   */ format(longFormat = false) {
        if (longFormat) return `${this.century}${this.year}${this.month}${this.day}${this.num}${this.check}`;
        return `${this.year}${this.month}${this.day}${this.sep}${this.num}${this.check}`;
    }
    /**
   * Get age from a Swedish personal identity number.
   *
   * @return {number}
   */ getAge() {
        const date = this.getDate();
        return $cc655631f417fb2d$var$diffInYears(new Date(Date.now()), date);
    }
    /**
   * Get date from a Swedish personal identity number.
   *
   * @return {Date}
   */ getDate() {
        let ageDay = +this.day;
        if (this.isCoordinationNumber()) ageDay -= 60;
        const ageDate = this.century + this.year + "-" + this.month + "-" + (ageDay < 10 ? "0" + ageDay : ageDay);
        return new Date(ageDate);
    }
    /**
   * Check if a Swedish personal identity number is a interim number or not.
   *
   * @return {boolean}
   */ isInterimNumber() {
        return /[TRSUWXJKLMN]/.test(this.num[0]);
    }
    /**
   * Check if a Swedish personal identity number is a coordination number or not.
   *
   * @return {boolean}
   */ isCoordinationNumber() {
        return $cc655631f417fb2d$var$testDate(parseInt(this.century + this.year), +this.month, +this.day - 60);
    }
    /**
   * Check if a Swedish personal identity number is for a female.
   *
   * @return {boolean}
   */ isFemale() {
        return !this.isMale();
    }
    /**
   * Check if a Swedish personal identity number is for a male.
   *
   * @return {boolean}
   */ isMale() {
        const sexDigit = parseInt(this.num.substr(-1));
        return sexDigit % 2 === 1;
    }
};
var $cc655631f417fb2d$export$2e2bcd8739ae039 = $cc655631f417fb2d$var$Personnummer;



var $3i3Ry = parcelRequire("3i3Ry");


var $8NFma = parcelRequire("8NFma");



/**
 * Smooth switch between content and empty.
 * Wraps content in a div with display: grid.
 *
 * Display children if on is true.
 */ 

var $8NFma = parcelRequire("8NFma");
const $38017ade0fe843ad$export$7d106a70e0bc643b = ({ id: id, labelledBy: labelledBy, children: children, direction: direction = 'vertical', on: on, className: className })=>{
    const appearTimeout = (0, $8NFma.useRef)(null);
    const [transitioning, setTransitioning] = (0, $8NFma.useState)(false);
    (0, $8NFma.useEffect)(()=>{
        if (appearTimeout.current) {
            clearTimeout(appearTimeout.current);
            setTransitioning(false);
        }
        setTransitioning(true);
        appearTimeout.current = setTimeout(()=>{
            clearTimeout(appearTimeout.current);
            appearTimeout.current = null;
            setTransitioning(false);
        }, 600);
        return ()=>{
            if (appearTimeout.current) clearTimeout(appearTimeout.current);
        };
    }, [
        on,
        setTransitioning
    ]);
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
        id: id,
        "aria-labelledby": labelledBy,
        "aria-hidden": !on,
        className: [
            'appearutil',
            on ? 'appearutil--on' : '',
            transitioning ? 'appearutil--transitioning' : '',
            `appearutil--direction-${direction}`,
            className || ''
        ].join(' '),
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
            className: 'appearutil__content',
            children: children
        })
    });
};


const $26c341b73c843285$var$DEFAULT_ERROR_MESSAGE = "F\xe4ltet m\xe5ste fyllas i";
const $26c341b73c843285$var$ErrorMessage = (props)=>{
    let errorMessage;
    const [visible, setVisible] = (0, $8NFma.useState)(false);
    (0, $8NFma.useEffect)(()=>{
        const timeout = setTimeout(()=>setVisible(true), 100);
        return ()=>clearTimeout(timeout);
    }, [
        setVisible
    ]);
    if (props.forId) {
        let validatedEl = document.getElementById(props.forId);
        errorMessage = typeof validatedEl.dataset.validationErrorMessage !== 'undefined' ? validatedEl.dataset.validationErrorMessage : $26c341b73c843285$var$DEFAULT_ERROR_MESSAGE;
    } else if (props.message) errorMessage = props.message;
    else errorMessage = $26c341b73c843285$var$DEFAULT_ERROR_MESSAGE;
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $38017ade0fe843ad$export$7d106a70e0bc643b), {
        on: visible,
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($26c341b73c843285$var$ErrorSpan, {
            className: "form-error is-visible",
            children: errorMessage
        })
    });
};
var $26c341b73c843285$export$2e2bcd8739ae039 = $26c341b73c843285$var$ErrorMessage;
const $26c341b73c843285$var$ErrorSpan = (0, $65e706775ff71837$export$2e2bcd8739ae039).span`
    display: block;

    color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.error};
    line-height: 2.3; 
    
    font-size: 16px;
    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        font-size: 13px;
        padding: 5px 0px 10px 0px;
    `)}
`;


const $083d6309f04b9f7c$var$INPUT_MUST_BE_USED_PREMISE_FOR_FORM = 'data-validation-form-premise-checked';
const $083d6309f04b9f7c$var$INPUT_REQUIRED_IF_OTHER_EMPTY = 'data-validation-other-required-id';
const $083d6309f04b9f7c$var$INPUT_RADIO_ONE_OF_SELECTED = 'data-validation-form-premise-atleast-one-radio';
function $083d6309f04b9f7c$export$6907a1ab9df2f7fd(forms, allFormsMustBeUsed = false) {
    let errorForms = $083d6309f04b9f7c$export$e31ed0dd27646bfa(forms);
    return errorForms.length === 0 && (allFormsMustBeUsed ? forms.length == $083d6309f04b9f7c$export$522a9696356a5639(forms).length : $083d6309f04b9f7c$export$5ad647538b3264d1(forms).length > 0);
}
function $083d6309f04b9f7c$export$5ad647538b3264d1(forms) {
    let noErrorForms = $083d6309f04b9f7c$export$705bd80a5c0be73c(forms);
    let finalValidForms = noErrorForms.filter((form)=>{
        const formIsValid = Object.keys(form.state.byId).filter((key)=>{
            let isValid = false;
            if (form.state.byId[key][$083d6309f04b9f7c$var$INPUT_MUST_BE_USED_PREMISE_FOR_FORM]) isValid = form.state.byId[key].checked;
            else if (form.state.byId[key][$083d6309f04b9f7c$var$INPUT_RADIO_ONE_OF_SELECTED]) {
                let checkedRadios = Object.keys(form.state.byId).filter((key)=>form.state.byId[key][$083d6309f04b9f7c$var$INPUT_RADIO_ONE_OF_SELECTED] && document.getElementById(form.state.byId[key].id).checked);
                isValid = checkedRadios.length > 0;
            } else isValid = true;
            return isValid;
        }).length === Object.keys(form.state.byId).length;
        return formIsValid;
    });
    return finalValidForms;
}
function $083d6309f04b9f7c$export$522a9696356a5639(forms) {
    let noErrorForms = $083d6309f04b9f7c$export$705bd80a5c0be73c(forms);
    return noErrorForms.filter((form)=>{
        const formIsValid = Object.keys(form.state.byId).filter((key)=>{
            let isValid = true;
            if (form.state.byId[key][$083d6309f04b9f7c$var$INPUT_MUST_BE_USED_PREMISE_FOR_FORM]) isValid = form.state.byId[key].checked;
            if (form.state.byId[key].validations.length && !form.state.byId[key][$083d6309f04b9f7c$var$INPUT_REQUIRED_IF_OTHER_EMPTY]) isValid = !!form.state.byId[key].isChanged;
            if (form.state.byId[key][$083d6309f04b9f7c$var$INPUT_RADIO_ONE_OF_SELECTED]) {
                // todo: check for matching name (otherwise this will cause a bug if several radio groups exist in the same form)
                let checkedRadios = Object.keys(form.state.byId).filter((key)=>form.state.byId[key][$083d6309f04b9f7c$var$INPUT_RADIO_ONE_OF_SELECTED] && document.getElementById(form.state.byId[key].id).checked);
                isValid = checkedRadios.length > 0;
            }
            return isValid;
        }).length === Object.keys(form.state.byId).length;
        return formIsValid;
    });
}
function $083d6309f04b9f7c$export$e31ed0dd27646bfa(forms) {
    return forms.filter((form)=>{
        return Object.keys(form.state.byId).filter((key)=>{
            return typeof form.state.byId[key].error !== 'undefined' && form.state.byId[key].isUsed;
        }).length;
    });
}
function $083d6309f04b9f7c$export$705bd80a5c0be73c(forms) {
    return forms.filter((form)=>{
        return !Object.keys(form.state.byId).filter((key)=>{
            return typeof form.state.byId[key].error !== 'undefined' && form.state.byId[key].isUsed;
        }).length;
    });
}
function $083d6309f04b9f7c$export$146d0c2cf7ef61b3(form, id) {
    let results = Object.keys(form.state.byId).filter((key)=>{
        return typeof form.state.byId[key].id == id;
    });
    return results.length ? results[0] : null;
}
function $083d6309f04b9f7c$export$fd126ff104591c5(value) {
    return value.replace(/^(\+|00)46/, "0");
}
function $083d6309f04b9f7c$export$1318658b188bf22b(value) {
    return value.replace(/[\s\-]/g, '');
}
function $083d6309f04b9f7c$export$de2485f55d098040(value) {
    return value.substr(0, 1) == "0";
}
function $083d6309f04b9f7c$export$7e4aa119212bc614(value) {
    return /^[0-9]+$/.test(value);
}


function $d5552fc3ceef5489$export$a7a0278c004aac3f(value, props, components) {
    let valid = false;
    // series of checkboxes/radios where at least one has to be checked
    if (typeof components !== 'undefined' && components[props.name].length > 1) valid = components[props.name].reduce((oneValid, radio)=>{
        let radioEl = document.getElementById(radio.id);
        return oneValid || radioEl.checked;
    }, false);
    else valid = props.isCheckable ? props.checked : value || value != 0;
    if (!valid) return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $26c341b73c843285$export$2e2bcd8739ae039), {
        forId: props.id
    });
}
function $d5552fc3ceef5489$export$8fe860a115a1e636(minLen) {
    return (value, props, components)=>{
        if ((value + '').length < minLen && value != null && value != '') return typeof props !== 'undefined' && props ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $26c341b73c843285$export$2e2bcd8739ae039), {
            forId: props.id
        }) : false;
    };
}
function $d5552fc3ceef5489$export$fada92a4f641601a(value, props, components) {
    const birthdate = (0, (/*@__PURE__*/$parcel$interopDefault($YChVI)))(value);
    let today = (0, (/*@__PURE__*/$parcel$interopDefault($YChVI)))();
    const age = (0, (/*@__PURE__*/$parcel$interopDefault($YChVI)))(today, 'YYYY-MM-DD').diff((0, (/*@__PURE__*/$parcel$interopDefault($YChVI)))(birthdate), 'years');
    if (age >= 7) return typeof props !== 'undefined' ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $26c341b73c843285$export$2e2bcd8739ae039), {
        forId: props.id
    }) : false;
}
function $d5552fc3ceef5489$export$ed5aee3c174444cb(value, props) {
    let date = value.substring(0, 8);
    const birthdate = (0, (/*@__PURE__*/$parcel$interopDefault($YChVI)))(date);
    let today = (0, (/*@__PURE__*/$parcel$interopDefault($YChVI)))();
    const age = (0, (/*@__PURE__*/$parcel$interopDefault($YChVI)))(today, 'YYYY-MM-DD').diff((0, (/*@__PURE__*/$parcel$interopDefault($YChVI)))(birthdate), 'years');
    if (age < 18) return typeof props !== 'undefined' ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $26c341b73c843285$export$2e2bcd8739ae039), {
        message: "Medf\xf6rs\xe4krad m\xe5ste vara \xf6ver 18 \xe5r"
    }) : false;
}
function $d5552fc3ceef5489$export$b2201b610a3f2b56(len) {
    return (value, props, components)=>{
        if ((value + '').length != len && value != null && value != '') return typeof props !== 'undefined' && props ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $26c341b73c843285$export$2e2bcd8739ae039), {
            forId: props.id
        }) : false;
    };
}
function $d5552fc3ceef5489$export$4a7d835afd9fd1e4(validatorFunc = null) {
    const valid = validatorFunc ? validatorFunc : $d5552fc3ceef5489$export$a7a0278c004aac3f;
    return (value, props, components)=>{
        let validatedEl = document.getElementById(props.id);
        const otherCheckedId = validatedEl.dataset.validationOtherCheckedId;
        let otherCheckedEl = document.getElementById(otherCheckedId);
        if (otherCheckedEl.checked) return valid(value, props);
    };
}
function $d5552fc3ceef5489$export$4e4e239469d8507c(validationFunc) {
    return (value, props, components)=>{
        let validatedEl = document.getElementById(props.id);
        const otherInputId = validatedEl.dataset.validationOtherRequiredId;
        let otherInputEl = document.getElementById(otherInputId);
        if (otherInputEl.classList.contains('is-invalid-input') || !otherInputEl.value) return validationFunc(value, props);
    };
}
function $d5552fc3ceef5489$export$dbcae51bc7691d6c(validatorFunc = null) {
    const valid = validatorFunc ? validatorFunc : $d5552fc3ceef5489$export$a7a0278c004aac3f;
    return (value, props, components)=>{
        let validatedEl = document.getElementById(props.id);
        const otherCheckedId = validatedEl.dataset.validationOtherCheckedId;
        let otherCheckedEl = document.getElementById(otherCheckedId);
        if (!otherCheckedEl.checked) return valid(value, props);
    };
}
function $d5552fc3ceef5489$export$81945865c63a43f7(validationFunc) {
    return (value, props)=>{
        if (typeof value !== 'undefined' && value.length > 0) return validationFunc(value, props);
    };
}
function $d5552fc3ceef5489$export$8e8fc82834721462(input0, input1, errorMessage) {
    errorMessage = typeof errorMessage != 'undefined' ? errorMessage : ' ';
    return (value, props, components)=>{
        const bothUsed = components[input0][0].isUsed && components[input1][0].isUsed;
        const bothChanged = components[input0][0].isChanged && components[input1][0].isChanged;
        if (bothChanged && bothUsed && components[input0][0].value !== components[input1][0].value) return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $26c341b73c843285$export$2e2bcd8739ae039), {
            message: errorMessage
        });
    };
}
function $d5552fc3ceef5489$export$80e3168fea119969(input1, input2, errorMessageEmail, errorMessageMatch) {
    return (value, props, components)=>{
        const emailValue = components[input1][0].value;
        const confirmEmailValue = components[input2][0].value;
        // Check if correct email format
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($3i3Ry)))(value)) return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $26c341b73c843285$export$2e2bcd8739ae039), {
            message: errorMessageEmail
        });
        // Check if the two email addresses match
        if (emailValue !== confirmEmailValue) return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $26c341b73c843285$export$2e2bcd8739ae039), {
            message: errorMessageMatch
        });
    };
}
function $d5552fc3ceef5489$export$1fd13a8724cd7091(value, props, components) {
    if (!/^\+?[1-9]\d*$/.test(value)) return typeof props !== 'undefined' ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $26c341b73c843285$export$2e2bcd8739ae039), {
        forId: props.id
    }) : false;
}
function $d5552fc3ceef5489$export$9ecd99379ed9109(min, max) {
    return (value, props, components)=>{
        if (!/^\+?[1-9]\d*$/.test(value) || parseInt(value) > max || parseInt(value) < min) return typeof props !== 'undefined' ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $26c341b73c843285$export$2e2bcd8739ae039), {
            forId: props.id
        }) : false;
    };
}
function $d5552fc3ceef5489$export$c8c2927bd53a1468(min, max) {
    return (value, props, components)=>{
        if (parseInt(value) != value) return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $26c341b73c843285$export$2e2bcd8739ae039), {
            forId: props.id
        });
        if ((value + '').length > max || (value + '').length < min) return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $26c341b73c843285$export$2e2bcd8739ae039), {
            forId: props.id
        });
        return false;
    };
}
function $d5552fc3ceef5489$export$ae53e5468f97a6c(value, props, components) {
    if (!/^[0-9]+$/.test(value) && value != null && value != '') return typeof props !== 'undefined' ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $26c341b73c843285$export$2e2bcd8739ae039), {
        forId: props.id
    }) : false;
}
function $d5552fc3ceef5489$export$9ab921aaffe56820(value, props, components) {
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($3i3Ry)))(value)) return typeof props !== 'undefined' ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $26c341b73c843285$export$2e2bcd8739ae039), {
        forId: props.id
    }) : false;
}
function $d5552fc3ceef5489$export$6b5405a3207f4c0f(value, props, components) {
    const val = value.replace(/-/g, '');
    try {
        const number = (0, $cc655631f417fb2d$export$2e2bcd8739ae039).parse(val);
        if (val.length !== 12 || number.isCoordinationNumber()) return typeof props !== 'undefined' ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $26c341b73c843285$export$2e2bcd8739ae039), {
            forId: props.id
        }) : false;
    } catch (e) {
        return typeof props !== 'undefined' ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $26c341b73c843285$export$2e2bcd8739ae039), {
            forId: props.id
        }) : false;
    }
}
function $d5552fc3ceef5489$export$10f2e5580e5de03b(value, props, components) {
    // Coordination Number = Samordningsnummer
    const val = value.replace(/-/g, '');
    if (val.length !== 12 || !(0, $cc655631f417fb2d$export$2e2bcd8739ae039).valid(val)) return typeof props !== 'undefined' ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $26c341b73c843285$export$2e2bcd8739ae039), {
        forId: props.id
    }) : false;
}
function $d5552fc3ceef5489$export$d1e4c282e09ffddb(insureePersonalId) {
    return (value, props, components)=>{
        const val = value.replace(/-/g, '');
        try {
            const numbersMatch = (0, $cc655631f417fb2d$export$2e2bcd8739ae039).parse(insureePersonalId).format() == (0, $cc655631f417fb2d$export$2e2bcd8739ae039).parse(val).format();
            if (val.length !== 12 || numbersMatch) {
                const message = "Du verkar ha fyllt i ditt eget personnummer p\xe5 en f\xf6rs\xe4kring f\xf6r medf\xf6rs\xe4krad. Ange ist\xe4llet medf\xf6rs\xe4krads personnummer f\xf6r att g\xe5 vidare.";
                return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $26c341b73c843285$export$2e2bcd8739ae039), {
                    message: message
                });
            }
        } catch (e) {
            return typeof props !== 'undefined' ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $26c341b73c843285$export$2e2bcd8739ae039), {
                forId: props.id
            }) : false;
        }
    };
}
function $d5552fc3ceef5489$var$validAbstractPhoneNumber(value, props, numberFunction) {
    const number = (0, $083d6309f04b9f7c$export$1318658b188bf22b)((0, $083d6309f04b9f7c$export$fd126ff104591c5)(value));
    // Allow for blank values = clear value in database
    if (value.length == 0) return;
    if (!(0, $083d6309f04b9f7c$export$de2485f55d098040)(number) || !(0, $083d6309f04b9f7c$export$7e4aa119212bc614)(number) || !numberFunction(number)) return typeof props !== 'undefined' ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $26c341b73c843285$export$2e2bcd8739ae039), {
        forId: props.id
    }) : false;
}
function $d5552fc3ceef5489$export$8cf0558aca0fb9bc(value, props) {
    return $d5552fc3ceef5489$var$validAbstractPhoneNumber(value, props, (number)=>{
        console.log("nf:", number);
        return number.length == 10;
    });
}
function $d5552fc3ceef5489$export$213f62348afd7d3b(value, props) {
    return $d5552fc3ceef5489$var$validAbstractPhoneNumber(value, props, (number)=>{
        return number.length <= 10 && number.length >= 8;
    });
}
function $d5552fc3ceef5489$export$36b5ac7df4d972b0(value, props) {
    if (value.length !== 5 || isNaN(parseInt(value))) return typeof props !== 'undefined' ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $26c341b73c843285$export$2e2bcd8739ae039), {
        forId: props.id
    }) : false;
}
function $d5552fc3ceef5489$export$32149351cfacd020(value, props) {
    const [year, month] = value.split('-').map((v)=>parseInt(v.replace(/^[0]+/g, '')));
    if (value.length > 7 || typeof $d5552fc3ceef5489$export$1fd13a8724cd7091(month) !== 'undefined' || typeof $d5552fc3ceef5489$export$1fd13a8724cd7091(year) !== 'undefined' || month > 12) return typeof props !== 'undefined' ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $26c341b73c843285$export$2e2bcd8739ae039), {
        forId: props.id
    }) : false;
}
function $d5552fc3ceef5489$export$c03bb0116ee09d4b(value, props) {
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($41cc8a07a576c3f4$exports)))(value) || value.length !== 10) return typeof props !== 'undefined' ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $26c341b73c843285$export$2e2bcd8739ae039), {
        forId: props.id
    }) : false;
}
function $d5552fc3ceef5489$export$de9e95bbc8d43786(value, props) {
    let now = (0, (/*@__PURE__*/$parcel$interopDefault($YChVI)))();
    if (typeof $d5552fc3ceef5489$export$c03bb0116ee09d4b(value, props) !== 'undefined' || now.isAfter((0, (/*@__PURE__*/$parcel$interopDefault($YChVI)))(value), 'day')) return typeof props !== 'undefined' ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $26c341b73c843285$export$2e2bcd8739ae039), {
        forId: props.id
    }) : false;
}
function $d5552fc3ceef5489$export$e1212d4c6932d1e7(inputKey, inputName, premise) {
    return (value, props)=>{
        if (typeof premise !== 'undefined') {
            let localValidation = premise(value, props);
            if (typeof localValidation !== 'undefined') return localValidation;
        }
        let input = this.apiValidationInputs[inputKey][inputName];
        if (input.invalidated) return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $26c341b73c843285$export$2e2bcd8739ae039), {
            message: input.errorMessage
        });
    };
}
function $d5552fc3ceef5489$export$99f47c6026b30a0b(validationFunction) {
    return (value, props)=>{
        if (value == '') return;
        return validationFunction(value, props);
    };
}


// home-made parsing of react-validation HOC form 
function $f2bfeab6e0c24c97$export$2e2bcd8739ae039(form) {
    let rawValues = Object.keys(form.state.byName).reduce((values, name)=>{
        if (form.state.byName[name].length > 1) values[name] = form.state.byName[name].map((id)=>{
            let inputEl = document.getElementById(form.state.byId[id].id);
            if ('data-ignore-on-signup' in form.state.byId[id]) return null;
            if ((inputEl.type == 'radio' || inputEl.type == 'checkbox') && !inputEl.checked) return null;
            if (form.state.byId[id].value == 'true' || form.state.byId[id].value == 'false') return Boolean(form.state.byId[id].value);
            else return form.state.byId[id].value;
        });
        else {
            if ('data-ignore-on-signup' in form.state.byId[form.state.byName[name][0]]) return values;
            let inputEl = document.getElementById(form.state.byId[form.state.byName[name][0]].id);
            if (inputEl && (inputEl.type == 'radio' || inputEl.type == 'checkbox')) values[name] = inputEl.checked ? form.state.byId[form.state.byName[name][0]].value : false;
            else values[name] = form.state.byId[form.state.byName[name][0]].value;
            if (values[name] == 'true' || values[name] == 'false') values[name] = Boolean(values[name]);
        }
        return values;
    }, {});
    let values = null;
    // check for multiple input name duplicates scenario => arrays of name-indexed values (i.e. groupName in HomeStep1Form)
    if (Array.isArray(rawValues.groupName)) {
        let filledIndex = rawValues.insuranceName.findIndex((v)=>v != null);
        values = Object.keys(rawValues).reduce((res, key)=>{
            res[key] = rawValues[key][filledIndex];
            return res;
        }, {});
    } else values = Object.keys(rawValues).reduce((res, key)=>{
        let val = rawValues[key];
        if (key.indexOf('[') > -1) {
            key = key.split('[')[0];
            res[key] = res[key] || [];
            if (val) res[key].push(val);
        } else if (Array.isArray(val)) {
            let valIndex = val.findIndex((v)=>v != null);
            res[key] = val[valIndex];
        } else res[key] = val;
        return res;
    }, {});
    return values;
}


var $929f93a20bca9658$exports = {};
var $b4bc57601b5c8d82$exports = {};
'use strict';
function $b4bc57601b5c8d82$var$preserveCamelCase(str) {
    var isLastCharLower = false;
    for(var i = 0; i < str.length; i++){
        var c = str.charAt(i);
        if (isLastCharLower && /[a-zA-Z]/.test(c) && c.toUpperCase() === c) {
            str = str.substr(0, i) + '-' + str.substr(i);
            isLastCharLower = false;
            i++;
        } else isLastCharLower = c.toLowerCase() === c;
    }
    return str;
}
$b4bc57601b5c8d82$exports = function() {
    var str = [].map.call(arguments, function(str) {
        return str.trim();
    }).filter(function(str) {
        return str.length;
    }).join('-');
    if (!str.length) return '';
    if (str.length === 1) return str;
    if (!/[_.\- ]+/.test(str)) {
        if (str === str.toUpperCase()) return str.toLowerCase();
        if (str[0] !== str[0].toLowerCase()) return str[0].toLowerCase() + str.slice(1);
        return str;
    }
    str = $b4bc57601b5c8d82$var$preserveCamelCase(str);
    return str.replace(/^[_.\- ]+/, '').toLowerCase().replace(/[_.\- ]+(\w|$)/g, function(m, p1) {
        return p1.toUpperCase();
    });
};


var $49adbb4536b0641b$exports = {};
'use strict';
$49adbb4536b0641b$exports = function(obj, cb) {
    var ret = {};
    var keys = Object.keys(obj);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var res = cb(key, obj[key], obj);
        ret[res[0]] = res[1];
    }
    return ret;
};


$929f93a20bca9658$exports = function camelcaseKeysDeep(obj) {
    // Any falsy, which includes `null` whose typeof is `object`.
    if (!obj) return obj;
    // Date, whose typeof is `object` too.
    if (obj instanceof Date) return obj;
    // Array, whose typeof is `object` too.
    if (Array.isArray(obj)) return obj.map(function(element) {
        return camelcaseKeysDeep(element);
    });
    // So, if this is still an `object`, we might be interested in it.
    if (typeof obj === "object") return $49adbb4536b0641b$exports(obj, function(key, value) {
        var newKey = $b4bc57601b5c8d82$exports(key);
        if (key !== newKey && newKey in obj) throw new Error("Camelcased key `" + newKey + "` would overwrite existing key of the given JSON object");
        return [
            newKey,
            camelcaseKeysDeep(value)
        ];
    });
    // Something else like a String or Number.
    return obj;
};


class $ec5d6bcbbe0f9d64$export$2e2bcd8739ae039 {
    constructor(options){
        if (typeof options !== 'undefined') this.baseUrl = options.baseUrl || '';
        return {
            get: this.get,
            put: this.put,
            post: this.post,
            del: this.del
        };
    }
    // public
    get = (endpoint)=>{
        return this.makeRequest('GET', endpoint);
    };
    put = (endpoint, data)=>{
        return this.makeRequest('PUT', endpoint, data);
    };
    post = (endpoint, data)=>{
        return this.makeRequest('POST', endpoint, data);
    };
    del = (endpoint, data)=>{
        return this.makeRequest('DELETE', endpoint, data);
    };
    // private
    makeRequest(verb, endpoint, data) {
        // remove undefined props
        if (this.isVerbWithPayload(verb)) Object.keys(data).forEach((key)=>typeof data[key] === 'undefined' && delete data[key]);
        if (window._bazDebug) {
            console.log(`[DEBUG] Making ${verb} request to ${endpoint}`);
            if (this.isVerbWithPayload(verb)) {
                console.warn('[DEBUG] Payload: ');
                console.dir(data);
            }
        }
        return new Promise((resolve, reject)=>{
            const settings = {
                method: verb,
                mode: 'cors',
                cache: 'no-cache',
                headers: new Headers({
                    'Content-Type': 'text/plain'
                }),
                credentials: 'same-origin',
                body: this.isVerbWithPayload(verb) ? JSON.stringify(data) : undefined
            };
            fetch(new Request(this.baseUrl + endpoint, settings)).then((response)=>{
                if (!response.ok) reject(response.statusText);
                return response.json();
            }).then((data)=>{
                data = $929f93a20bca9658$exports(data, {
                    deep: true
                });
                if (data.errorMessage != null) {
                    let error = data.errorMessage;
                    if (data.validationErrors) error += `: ${data.validationErrors.map((e)=>e.errorMessage.toLowerCase()).join(', ')}`;
                    reject(error);
                }
                if (window._bazDebug) {
                    console.warn('[DEBUG] Response data: ');
                    console.dir(data);
                }
                resolve(data.result);
            }).catch((e)=>reject(e));
        });
    }
    isVerbWithPayload(verb) {
        return verb === 'POST' || verb === 'PUT';
    }
}


const $0f2b98672976a17a$var$basePath = '/api/', $0f2b98672976a17a$var$endpoints = {
    myPagesStart: `/${window.__lfSettings.myPagesStartPageUrl}`,
    profile: `/${window.__lfSettings.profilePageUrl}`,
    metaData: `${$0f2b98672976a17a$var$basePath}insurance-data/`,
    insurancePreregistrations: `/${window.__lfSettings.preregistrationPageUrl}`,
    contentPage: (page)=>`ContentPage/?page=${page}`,
    contentSearchPage: (page, query)=>`${window.location.pathname}/ContentPage/?page=${page}&q=${query}`,
    insuranceGuide: (data)=>`${window.location.pathname}/result?data=${data}`,
    healthDeclaration: (insuranceName, objId)=>`/${window.__lfSettings.healthDeclarationPageUrl}?insuranceName=${insuranceName}${objId ? `&insuranceObjectId=${objId}` : ''}`,
    insurancePurchase: (insuranceGroupNames = null, preSelection = null, possessionId = null, preFilledValues = null)=>`/${window.__lfSettings.purchasePageUrl}` + `${insuranceGroupNames ? `?groups=${Array.isArray(insuranceGroupNames) ? insuranceGroupNames.join(',') : insuranceGroupNames}` : ''}` + `${preSelection ? `&selected=${Array.isArray(preSelection) ? preSelection.join(',') : preSelection}` : ''}` + `${possessionId ? `&possessionId=${possessionId}` : ''}` + `${preFilledValues ? `&preFilledValues=${encodeURIComponent(JSON.stringify(preFilledValues))}` : ''}`,
    coInsuredForm: (data)=>`${window.location.origin}` + `${data.url}`,
    managedPensionInsuranceSigning: (url, appId)=>`${url}?appId=${appId}`,
    //Call to endpoint api v2
    insuranceMetaData: `${$0f2b98672976a17a$var$basePath}v2/insurance-metadata/`
};
let $0f2b98672976a17a$var$instance = null;
class $0f2b98672976a17a$export$2e2bcd8739ae039 {
    constructor(){
        if (!$0f2b98672976a17a$var$instance) {
            this.client = new (0, $ec5d6bcbbe0f9d64$export$2e2bcd8739ae039)({
                basePath: ''
            });
            $0f2b98672976a17a$var$instance = this;
        }
        return $0f2b98672976a17a$var$instance;
    }
    // url getters
    get myPagesStartUrl() {
        return $0f2b98672976a17a$var$endpoints.myPagesStart;
    }
    // url methods
    healthDeclarationUrl = (insuranceName, objId = null)=>{
        return $0f2b98672976a17a$var$endpoints.healthDeclaration(insuranceName, objId);
    };
    insurancePurchaseUrl = (insuranceGroupNames, selection, possessionId, preFilledValues = null)=>{
        return $0f2b98672976a17a$var$endpoints.insurancePurchase(insuranceGroupNames, selection, possessionId, preFilledValues);
    };
    insurancePreregistrationsUrl = ()=>{
        return $0f2b98672976a17a$var$endpoints.insurancePreregistrations;
    };
    profilePageUrl = ()=>{
        return $0f2b98672976a17a$var$endpoints.profile;
    };
    // web api calls 
    insuranceMetaData = ()=>{
        return this.client.get($0f2b98672976a17a$var$endpoints.metaData);
    };
    contentPage = (page)=>{
        return this.client.get($0f2b98672976a17a$var$endpoints.contentPage(page));
    };
    contentSearchPage = (page, query)=>{
        return this.client.get($0f2b98672976a17a$var$endpoints.contentSearchPage(page, query));
    };
    //Web api calls to v2
    possessionsMetaData = ()=>{
        return this.client.get($0f2b98672976a17a$var$endpoints.insuranceMetaData);
    };
    // redirects 
    myPages = ()=>{
        window.location.href = $0f2b98672976a17a$var$endpoints.myPagesStart;
    };
    insurancePreregistrations = ()=>{
        window.location.href = $0f2b98672976a17a$var$endpoints.insurancePreregistrations;
    };
    insuranceGuide = (data)=>{
        window.location.href = $0f2b98672976a17a$var$endpoints.insuranceGuide(encodeURIComponent(btoa(JSON.stringify(data))));
    };
    insurancePurchase = (insuranceGroupName, selection, possessionId)=>{
        window.location.href = $0f2b98672976a17a$var$endpoints.insurancePurchase(insuranceGroupName, selection, possessionId);
    };
    coinsuredFormConfirmation = (data)=>{
        window.location.href = $0f2b98672976a17a$var$endpoints.coInsuredForm(data);
    };
    startApplicationSigning = (data)=>{
        window.location.href = $0f2b98672976a17a$var$endpoints.managedPensionInsuranceSigning(data);
    };
}


function $67f4b1d2fb7c2244$export$ea4b4733f4ca2df0(bool) {
    return {
        type: 'PAGE_HAS_ERRORED',
        hasErrored: bool
    };
}
function $67f4b1d2fb7c2244$export$7a8bb273722d5103(error) {
    return {
        type: 'PAGE_ERROR',
        error: error
    };
}
function $67f4b1d2fb7c2244$export$5630fcc02dc02d1b(bool) {
    return {
        type: 'PAGE_IS_LOADING',
        isLoading: bool
    };
}
function $67f4b1d2fb7c2244$export$453e7c361a52c908(step) {
    return {
        type: 'PAGE_CURRENT_STEP',
        step: step
    };
}
function $67f4b1d2fb7c2244$export$d497f3040bd37192() {
    const lfWebService = new (0, $0f2b98672976a17a$export$2e2bcd8739ae039)();
    return (dispatch, getState)=>{
        return lfWebService.insurancePreregistrationsUrl();
    };
}
function $67f4b1d2fb7c2244$export$1b4ebad6b9033866(insuranceName, objId = null) {
    const lfWebService = new (0, $0f2b98672976a17a$export$2e2bcd8739ae039)();
    return (dispatch, getState)=>{
        return lfWebService.healthDeclarationUrl(insuranceName, objId);
    };
}
function $67f4b1d2fb7c2244$export$891cb1f3e85fe317(insuranceName, objId = null) {
    const lfWebService = new (0, $0f2b98672976a17a$export$2e2bcd8739ae039)();
    return (dispatch, getState)=>{
        window.location.href = lfWebService.healthDeclarationUrl(insuranceName, objId);
    };
}
function $67f4b1d2fb7c2244$export$a39968088ed1a779(insuranceGroupNames, preSelection, possessionId) {
    const lfWebService = new (0, $0f2b98672976a17a$export$2e2bcd8739ae039)();
    return (dispatch, getState)=>{
        return lfWebService.insurancePurchaseUrl(insuranceGroupNames, preSelection, possessionId);
    };
}





const $9036c591bc37f875$var$chunk = (arr, n)=>Array(Math.ceil(arr.length / n)).fill().map((_, i)=>arr.slice(i * n, i * n + n));
const $9036c591bc37f875$var$minNoOfUpgradesForLargeView = 2;
class $9036c591bc37f875$var$UpgradeCta extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    static get propTypes() {
        return {
            alignment: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
            possession: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).object.isRequired
        };
    }
    constructor(props){
        super(props);
        this.form = null;
        this.validationTimer = null;
    }
    handleFormSelection = (e)=>{
        e.preventDefault();
        const { upgradeUrl: upgradeUrl } = (0, $f2bfeab6e0c24c97$export$2e2bcd8739ae039)(this.form);
        window.location = upgradeUrl;
    };
    render() {
        const possession = this.props.possession;
        const possessionDisplayName = this.props.data.insurancesByName[possession.insuranceName].displayNameHeading;
        const upgrades = this.props.data.insurancesByName[possession.insuranceName].possibleUpgrades.filter((upgradeName)=>this.props.data.quotesByName[upgradeName]).map((upgradeName)=>({
                ...this.props.data.insurancesByName[upgradeName],
                ...this.props.data.quotesByName[upgradeName]
            }));
        const isMinQuote = upgrades.length == 1 ? upgrades[0].isMinQuote : true;
        const isPregnantOrChildInsurance = upgrades.find((u)=>u.insuranceName.match(/^(pregnant|child)\-/) != null);
        const smallUpgradeCTA = isPregnantOrChildInsurance && upgrades.length < $9036c591bc37f875$var$minNoOfUpgradesForLargeView;
        if (smallUpgradeCTA) return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($9036c591bc37f875$var$Wrapper, {
            alignment: this.props.alignment,
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($9036c591bc37f875$var$UpgradeHeading, {
                    children: [
                        "Uppgradera din ",
                        possessionDisplayName,
                        isMinQuote && " fr\xe5n",
                        ": "
                    ]
                }),
                upgrades.map((upgrade, i)=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("a", {
                        href: this.props.getInsurancePurchaseUrlFor([
                            upgrade.groupName,
                            ...(0, $36509d2879dd53eb$export$26f7a1d6ff54a39c)(upgrade.insuranceName)
                        ], upgrade.insuranceName, possession.possessionId),
                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $3dd5c3afc4410032$export$cfc7921d29ef7b80), {
                            children: [
                                "+",
                                upgrade.quote - possession.premium,
                                " kr",
                                upgrade.premiumPeriod == "monthly" ? "/m\xe5n" : " i eng\xe5ngspris"
                            ]
                        })
                    }, `upgrade-${upgrade.groupName}-${i}`))
            ]
        });
        else return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($9036c591bc37f875$var$LargeUpgradeWrapper, {
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($9036c591bc37f875$var$UpgradeHeading, {
                    children: [
                        "Uppgradera din ",
                        possessionDisplayName,
                        " till: "
                    ]
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $8c02aa23a40a9b45$export$2e2bcd8739ae039), {
                    ref: (el)=>{
                        this.form = el;
                    },
                    onSubmit: this.handleFormSelection,
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($9036c591bc37f875$var$GridContainer, {
                            children: $9036c591bc37f875$var$chunk(upgrades, 3).map((chunkedUpgrades, i)=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($9036c591bc37f875$var$Column, {
                                    children: chunkedUpgrades.map((upgrade, j)=>{
                                        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($9036c591bc37f875$var$PossessionRow, {
                                            children: [
                                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($9036c591bc37f875$var$PossessionColumn, {
                                                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $8a85d66883139d14$export$2e2bcd8739ae039), {
                                                        layout: "block",
                                                        textColor: "white",
                                                        errorColor: (0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.lightError,
                                                        id: upgrade.insuranceName,
                                                        name: "upgradeUrl",
                                                        value: this.props.getInsurancePurchaseUrlFor(upgrade.groupName, upgrade.insuranceName, upgrade.possessionId),
                                                        validations: [
                                                            (0, $d5552fc3ceef5489$export$a7a0278c004aac3f)
                                                        ],
                                                        displayname: upgrade.displayName,
                                                        // show error msg only on last radio item
                                                        "data-validation-error-message": (i + 1) * (j + 1) === upgrades.length - 1 ? "V\xe4lj en uppgradering" : '',
                                                        customwidth: "100%"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($9036c591bc37f875$var$PriceColumn, {
                                                    children: [
                                                        "+",
                                                        upgrade.quote - possession.premium,
                                                        " kr",
                                                        upgrade.premiumPeriod == "monthly" ? "/m\xe5n" : " i eng\xe5ngspris"
                                                    ]
                                                })
                                            ]
                                        }, `large-inner-${upgrade.insuranceName}`);
                                    })
                                }, `large-outer-${chunkedUpgrades[0].insuranceName}`))
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($9036c591bc37f875$var$ValidationButtonWrapper, {
                            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $b50965a6d450d3cc$export$2e2bcd8739ae039), {
                                onMouseEnter: ()=>this.validationTimer = setTimeout(this.form.validateAll, 1000),
                                onMouseLeave: ()=>clearTimeout(this.validationTimer),
                                topMargin: "20px",
                                noIcon: true,
                                children: "Uppgradera"
                            })
                        })
                    ]
                })
            ]
        });
    }
}
// state
const $9036c591bc37f875$var$mapStateToProps = (state)=>{
    return {
        data: state.startPageData,
        metaData: state.startPageInsuranceMetaData
    };
};
const $9036c591bc37f875$var$mapDispatchToProps = (dispatch)=>{
    return {
        getInsurancePurchaseUrlFor: (groupName, selection, possessionId)=>dispatch((0, $67f4b1d2fb7c2244$export$a39968088ed1a779)(groupName, selection, possessionId))
    };
};
var $9036c591bc37f875$export$2e2bcd8739ae039 = (0, $5a4066412ccab0c1$export$64605811ab45167f)($9036c591bc37f875$var$mapStateToProps, $9036c591bc37f875$var$mapDispatchToProps)($9036c591bc37f875$var$UpgradeCta);
// styles
const $9036c591bc37f875$var$Wrapper = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    display: block; 
    text-align: ${(props)=>props.alignment ? props.alignment : 'center'}; 
    margin-bottom: 55px;

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).medium(`
        margin-bottom: 0px;
    `)}
    ${(0, $45d1242a07988139$export$8f880b6e390052fa).xsmall(`
        max-width: none;
    `)}
    ${(0, $45d1242a07988139$export$8f880b6e390052fa).xxsmall(`
        max-width: 88vw;
    `)}
`;
const $9036c591bc37f875$var$UpgradeHeading = (0, $65e706775ff71837$export$2e2bcd8739ae039).h4`
    display: inline-block;
    margin-right: 40px;
    margin-bottom: 20px;
    font-size: 20px;
    color: white;
    ${(0, $45d1242a07988139$export$8f880b6e390052fa).medium(`
        margin-top: 25px;
        width: 100%;
    `)}
    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        font-size: 16px;
        float: left;
        margin-bottom: 15px;
        margin-right: 0px;
        text-align: left;
    `)}
`;
const $9036c591bc37f875$var$LargeUpgradeWrapper = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    padding: 30px;

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).medium(`
        padding: 15px; 
    `)}

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        padding: 0px; 
    `)}
`;
const $9036c591bc37f875$var$GridContainer = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    position: relative; 
    width: 100%; 

    ${(0, $45d1242a07988139$export$8c467e8859fdef13)()}
`;
const $9036c591bc37f875$var$Column = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    width: 50%; 
    float: left; 
    ${(0, $45d1242a07988139$export$8f880b6e390052fa).medium(`
        width: 100%; 
        float: none; 
    `)}

    ${(0, $45d1242a07988139$export$8c467e8859fdef13)()}
`;
const $9036c591bc37f875$var$PossessionRow = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    position: relative; 
    
    width: 100%; 
    margin-top: 15px; 
    line-height: 1.5;

    ${(0, $45d1242a07988139$export$8c467e8859fdef13)()}
`;
const $9036c591bc37f875$var$PossessionColumn = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    position: relative; 
    width: 70%; 
    float: left;
`;
const $9036c591bc37f875$var$PriceColumn = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    position: relative; 
    width: 30%; 
    float: left;

    padding-right: 30px;

    font-size: 16px;
    color: white; 
    text-align: right;

    line-height: 1.2;

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).medium(`
        padding-right: 0;
        line-height: 1.8; 
    `)}

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        font-size: 13px;
        line-height: 2.2;
    `)}
`;
const $9036c591bc37f875$var$ValidationButtonWrapper = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    text-align: center;
`;




var $8NFma = parcelRequire("8NFma");








class $f46f19c5115a7469$var$AnimalUpgradeCta extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    static get propTypes() {
        return {
            alignment: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
            possession: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).object.isRequired
        };
    }
    insuranceTypeLabel(insurance) {
        switch(insurance.animalType){
            case 'dog':
                return "Hundf\xf6rs\xe4kring";
            case 'cat':
                return "Kattf\xf6rs\xe4kring";
            case 'small-animal':
                return "Sm\xe5djursf\xf6rs\xe4kring";
            default:
                return "f\xf6rs\xe4kring";
        }
    }
    render() {
        const possession = this.props.possession;
        const upgrades = this.props.data.insurancesByName[possession.insuranceName].possibleUpgrades.map((upgradeName)=>({
                ...this.props.data.insurancesByName[upgradeName],
                ...this.props.data.quotesByName[upgradeName]
            }));
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($f46f19c5115a7469$var$Wrapper, {
            alignment: this.props.alignment,
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($f46f19c5115a7469$var$UpgradeHeading, {
                    children: [
                        "Uppgradera din ",
                        this.insuranceTypeLabel(possession),
                        " f\xf6r:"
                    ]
                }),
                upgrades.map((upgrade, i)=>{
                    if (!(possession.insuranceObjectId in this.props.animalPossessionQuotes)) return null;
                    const upgradeQuote = this.props.animalPossessionQuotes[possession.insuranceObjectId][upgrade.insuranceName];
                    const upgradeUrl = this.props.getInsurancePurchaseUrlFor([
                        upgrade.groupName,
                        ...(0, $36509d2879dd53eb$export$26f7a1d6ff54a39c)(upgrade.insuranceName)
                    ], upgrade.insuranceName, possession.possessionId);
                    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("a", {
                        href: upgradeUrl,
                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $3dd5c3afc4410032$export$cfc7921d29ef7b80), {
                            children: [
                                "+",
                                upgradeQuote - possession.premium,
                                " kr/m\xe5n"
                            ]
                        })
                    }, `upgrade-${upgrade.groupName}-${i}`);
                })
            ]
        });
    }
}
// state
const $f46f19c5115a7469$var$mapStateToProps = (state)=>{
    return {
        data: state.startPageData,
        animalPossessionQuotes: state.startPageAnimalPossessionQuoteData
    };
};
const $f46f19c5115a7469$var$mapDispatchToProps = (dispatch)=>{
    return {
        getInsurancePurchaseUrlFor: (groupName, selection, possessionId)=>dispatch((0, $67f4b1d2fb7c2244$export$a39968088ed1a779)(groupName, selection, possessionId))
    };
};
var $f46f19c5115a7469$export$2e2bcd8739ae039 = (0, $5a4066412ccab0c1$export$64605811ab45167f)($f46f19c5115a7469$var$mapStateToProps, $f46f19c5115a7469$var$mapDispatchToProps)($f46f19c5115a7469$var$AnimalUpgradeCta);
// styles
const $f46f19c5115a7469$var$Wrapper = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    display: block; 
    text-align: ${(props)=>props.alignment ? props.alignment : 'center'}; 
    margin-bottom: 55px;

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).medium(`
        margin-bottom: 0px;
    `)}
    ${(0, $45d1242a07988139$export$8f880b6e390052fa).xsmall(`
        max-width: none;
    `)}
    ${(0, $45d1242a07988139$export$8f880b6e390052fa).xxsmall(`
        max-width: 88vw;
    `)}
`;
const $f46f19c5115a7469$var$UpgradeHeading = (0, $65e706775ff71837$export$2e2bcd8739ae039).h4`
    display: inline-block;
    margin-right: 40px;
    margin-bottom: 20px;
    font-size: 20px;
    color: white;
    ${(0, $45d1242a07988139$export$8f880b6e390052fa).medium(`
        margin-top: 25px;
        width: 100%;
    `)}
    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        font-size: 16px;
        float: left;
        margin-bottom: 15px;
        margin-right: 0px;
        text-align: left;
    `)}
`;






class $2a0f9e8495de2782$var$PossessionInfo extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    static get propTypes() {
        return {
            possession: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).object.isRequired
        };
    }
    constructor(props){
        super(props);
        this.insuranceRawHtmlInfoEl = null;
    }
    componentDidMount() {
        if (this.insuranceRawHtmlInfoEl) this.fadeOutInsuranceComparisonLevels(this.insuranceRawHtmlInfoEl);
    }
    getInsuranceWebMeta(name) {
        if (!(name in this.props.data.insurancesByName)) return null;
        const groupName = this.props.data.insurancesByName[name].groupName;
        if (groupName in this.props.data.metaData) return this.props.data.metaData[groupName];
        return null;
    }
    // fade out available insurance upgrades in possession insurance comparison
    // while keeping the possession insurance opaque
    fadeOutInsuranceComparisonLevels(parentEl) {
        const fadeOutOpacity = '0.5';
        let comparisonEls = parentEl.querySelectorAll('*[data-lf-comparison-level]');
        let comparisonElsToFade = [
            ...comparisonEls
        ] // nodelist to array
        .filter((el)=>el.getAttribute('data-lf-comparison-level').split(',').map((s)=>s.trim()) // may contain comma-separated ids: "home-basic, home-basic-cooperative, home-basic-cooperative-security"
            .indexOf(this.props.possession.insuranceName) == -1);
        comparisonElsToFade.forEach((el)=>{
            el.style.opacity = fadeOutOpacity;
            if (typeof el.firstElementChild !== 'undefined' && el.firstElementChild) el.firstElementChild.style.opacity = fadeOutOpacity;
        });
    }
    render() {
        const animalInsuranceGroups = [
            'cat',
            'cat-life',
            'dog',
            'dog-life',
            'small-animal'
        ];
        const possession = this.props.possession;
        const posGroupName = possession.insuranceName in this.props.data.insurancesByName ? this.props.data.insurancesByName[possession.insuranceName].groupName : '';
        const metaData = this.getInsuranceWebMeta(possession.insuranceName);
        const insuranceData = possession.insuranceName in this.props.data.insurancesByName ? this.props.data.insurancesByName[possession.insuranceName] : null;
        const isCoinsured = insuranceData && insuranceData.isCoinsured;
        const member = this.props.data.memberInfo;
        const name = `${member.firstName} ${member.lastName}`;
        const coinsuredName = possession.coInsuredName ? possession.coInsuredName : '-';
        const estimatedInsuranceEndDate = !possession.estimatedInsuranceEndDate ? 'Tills vidare' : (0, (/*@__PURE__*/$parcel$interopDefault($YChVI)))(possession.estimatedInsuranceEndDate).format('YYYY-MM-DD');
        const fromDate = (0, (/*@__PURE__*/$parcel$interopDefault($YChVI)))(possession.fromDate).format('YYYY-MM-DD');
        const toDate = !possession.toDate ? estimatedInsuranceEndDate : (0, (/*@__PURE__*/$parcel$interopDefault($YChVI)))(possession.toDate).format('YYYY-MM-DD');
        const ordinaryPremiumFromDate = possession.ordinaryPremiumFromDate ? (0, (/*@__PURE__*/$parcel$interopDefault($YChVI)))(possession.ordinaryPremiumFromDate).format('YYYY-MM-DD') : null;
        const isOffer = possession.isOffer;
        const isAnimalInsurance = animalInsuranceGroups.indexOf(posGroupName) > -1;
        const hasRawHtmlInfo = metaData && metaData.insuranceInfoHtml != null;
        const hasUpgrades = possession.insuranceName in this.props.data.insurancesByName && this.props.data.insurancesByName[possession.insuranceName].possibleUpgrades.length > 0 && !possession.isNonUpgradeable;
        const areUpgradesAvailable = hasUpgrades && (()=>{
            const possibleUpgrades = this.props.data.insurancesByName[possession.insuranceName].possibleUpgrades;
            const quotesByName = this.props.data.quotesByName;
            const availableUpgrades = possibleUpgrades.filter((upgrade)=>{
                return !!this.props.data.quotesByName[upgrade];
            });
            return !!availableUpgrades.length;
        })();
        const hasSingleClause = typeof possession.clauseText !== 'undefined' && possession.clauseText != null;
        const hasMultiClause = typeof possession.clauses !== 'undefined' && possession.clauses.length > 0;
        const hasClauses = hasSingleClause || hasMultiClause;
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
            children: [
                hasRawHtmlInfo && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $3dd5c3afc4410032$export$ea9bc56cad11e33b), {
                    className: "rounded",
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $96c25128201e5f07$export$2e2bcd8739ae039), {
                        inputRef: (el)=>{
                            this.insuranceRawHtmlInfoEl = el;
                        },
                        children: metaData.insuranceInfoHtml
                    })
                }),
                hasUpgrades && areUpgradesAvailable && !isAnimalInsurance && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $9036c591bc37f875$export$2e2bcd8739ae039), {
                    possession: possession,
                    alignment: hasRawHtmlInfo ? 'center' : 'left'
                }),
                hasUpgrades && areUpgradesAvailable && isAnimalInsurance && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $f46f19c5115a7469$export$2e2bcd8739ae039), {
                    possession: possession,
                    alignment: hasRawHtmlInfo ? 'center' : 'left'
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($2a0f9e8495de2782$var$Wrapper, {
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($2a0f9e8495de2782$var$Content, {
                        children: [
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($2a0f9e8495de2782$var$Label, {
                                children: "F\xf6rs\xe4kringstagare:"
                            }),
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($2a0f9e8495de2782$var$Value, {
                                children: isCoinsured ? coinsuredName : name
                            }),
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($2a0f9e8495de2782$var$Label, {
                                children: "G\xe4ller fr\xe5n:"
                            }),
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($2a0f9e8495de2782$var$Value, {
                                children: fromDate
                            }),
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($2a0f9e8495de2782$var$Label, {
                                children: "G\xe4ller till:"
                            }),
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($2a0f9e8495de2782$var$Value, {
                                children: toDate
                            }),
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($2a0f9e8495de2782$var$Label, {
                                children: [
                                    (0, $36509d2879dd53eb$export$2a0be428efc19c5c)(possession.premiumPeriod),
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($2a0f9e8495de2782$var$Value, {
                                children: [
                                    possession.premium,
                                    "kr"
                                ]
                            }),
                            possession.ordinaryPremium != null && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($2a0f9e8495de2782$var$Label, {
                                        children: "Ordinarie pris:"
                                    }),
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($2a0f9e8495de2782$var$Value, {
                                        children: [
                                            possession.ordinaryPremium ? possession.ordinaryPremium : '- ',
                                            "kr"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($2a0f9e8495de2782$var$Label, {
                                        children: "Ordinarie pris fr\xe5n:"
                                    }),
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($2a0f9e8495de2782$var$Value, {
                                        children: ordinaryPremiumFromDate
                                    })
                                ]
                            }),
                            isOffer && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($2a0f9e8495de2782$var$Label, {
                                        children: "Erbjudande:"
                                    }),
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($2a0f9e8495de2782$var$Value, {
                                        children: "Ja"
                                    })
                                ]
                            })
                        ]
                    })
                }),
                hasClauses && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($2a0f9e8495de2782$var$Wrapper, {
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $54d997f7b284a565$export$2e2bcd8739ae039), {
                        heading: "Klausuler",
                        possession: possession
                    })
                }),
                metaData && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($2a0f9e8495de2782$var$Wrapper, {
                    textAlign: "center",
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $3dd5c3afc4410032$export$29d11c0fe2fc51d8), {
                        className: "rounded",
                        href: metaData.url,
                        children: "L\xe4s mer om f\xf6rs\xe4kringens inneh\xe5ll"
                    })
                })
            ]
        });
    }
}
// state
const $2a0f9e8495de2782$var$mapStateToProps = (state)=>{
    return {
        data: state.startPageData
    };
};
const $2a0f9e8495de2782$var$mapDispatchToProps = (dispatch)=>({});
var $2a0f9e8495de2782$export$2e2bcd8739ae039 = (0, $5a4066412ccab0c1$export$64605811ab45167f)($2a0f9e8495de2782$var$mapStateToProps, $2a0f9e8495de2782$var$mapDispatchToProps)($2a0f9e8495de2782$var$PossessionInfo);
// styles
const $2a0f9e8495de2782$var$Wrapper = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    display: table;
    width: 100%; 
    margin-bottom: 17px;
    margin-top: 35px;
        
    text-align: ${(props)=>props.textAlign ? props.textAlign : 'left'};

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).medium(`
        &:nth-of-type(2) {
            margin-bottom: 10px;
        }
    `)}

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        margin-top: 20px;
    `)}

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).xsmall(`
        max-width: none;
    `)}

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).xxsmall(`
        max-width: 88vw;
    `)}
`;
const $2a0f9e8495de2782$var$Content = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    width: 100%;
    
    padding: 0 50px 0 50px;
    margin: 0px;

    font-family: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.main};
    font-size: 18px;

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).medium(`
        padding: 0px 20px;
    `)}

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        width: 100%; 
        padding: 0;
        line-height: 1.4;
        font-size: 16px;
        margin: 17px 0px 0px 0px;
        &:nth-of-type(2) {
            margin: 0px;
        }
    `)}

    color: white;

    ${(0, $45d1242a07988139$export$8c467e8859fdef13)()}
`;
const $2a0f9e8495de2782$var$Column = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    float: left;
    width: 50%;
    
    padding: 0 50px 0 50px;
    margin: 0px;

    font-family: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.main};
    font-size: 18px;

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).medium(`
        padding: 0px 20px;
    `)}

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        width: 100%; 
        padding: 0;
        line-height: 1.4;
        font-size: 16px;
        margin: 17px 0px 0px 0px;
        &:nth-of-type(2) {
            margin: 0px;
        }
    `)}

    color: white;
    
    &:nth-of-type(odd) {
        border-right: 1px solid rgba(255, 255, 255, 0.25); 

        ${(0, $45d1242a07988139$export$8f880b6e390052fa).xsmall(`
            border-right: none;
        `)}

        ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
            border-right: none;
        `)}

        ${(0, $45d1242a07988139$export$8f880b6e390052fa).medium(`
            border-right: none;
        `)}
    }

    ${(0, $45d1242a07988139$export$8c467e8859fdef13)()}
`;
const $2a0f9e8495de2782$var$Label = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    width: 50%; 
    float: left; 
    ${(0, $45d1242a07988139$export$8f880b6e390052fa).xsmall(`
        width: 100%; 
        float: none;
    `)}

    text-align: left; 
    font-weight: bold;
`;
const $2a0f9e8495de2782$var$Value = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    width: 50%; 
    float: left; 

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        margin-bottom: 10px;
    `)}

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).xsmall(`
        width: 100%; 
        float: none;
    `)}

    text-align: right; 
    ${(0, $45d1242a07988139$export$8f880b6e390052fa).xsmall(`
        text-align: left; 
    `)}

    font-weight: normal;
`;




var $8NFma = parcelRequire("8NFma");
var $ac8bf4b7d201ab28$exports = {};
Object.defineProperty($ac8bf4b7d201ab28$exports, '__esModule', {
    value: true
});
const $ac8bf4b7d201ab28$var$svgns = "http://www.w3.org/2000/svg";
const $ac8bf4b7d201ab28$var$xlinkns = "http://www.w3.org/1999/xlink";
function $ac8bf4b7d201ab28$var$iconHelper(icon) {
    const svg = document.createElementNS($ac8bf4b7d201ab28$var$svgns, 'svg');
    const use = document.createElementNS($ac8bf4b7d201ab28$var$svgns, 'use');
    svg.setAttribute('viewBox', '0 0 32 32');
    svg.setAttribute('class', 'icon inline-icon-' + icon);
    use.setAttributeNS($ac8bf4b7d201ab28$var$xlinkns, 'href', '/images/icons.svg#' + icon);
    svg.appendChild(use);
    return svg;
}
$ac8bf4b7d201ab28$exports['default'] = $ac8bf4b7d201ab28$var$iconHelper;


// custom header for displaying on My Pages / My Possessions
const $9ee55d3c8be7e04d$var$PossessionCustomHeading = ({ value: value, text: text, isCurrent: isCurrent, date: date, heading: heading })=>{
    const dateToRender = date.slice(0, 10);
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("h2", {
                className: `possessions-custom-header__heading`,
                children: heading
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                className: "possessions-custom-header__content",
                children: [
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("p", {
                        className: "possessions-custom-header__content__value",
                        children: [
                            text,
                            ": ",
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("span", {
                                children: [
                                    value,
                                    " kr"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("p", {
                        className: `possessions-custom-header__content__status`,
                        children: [
                            "Status:",
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                className: `possessions-custom-header__content__icon`,
                                dangerouslySetInnerHTML: {
                                    __html: (0, (/*@__PURE__*/$parcel$interopDefault($ac8bf4b7d201ab28$exports)))(isCurrent ? 'check-circle' : 'clock').outerHTML
                                }
                            }),
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                className: "possessions-custom-header__content__toggle",
                                role: "button",
                                dangerouslySetInnerHTML: {
                                    __html: (0, (/*@__PURE__*/$parcel$interopDefault($ac8bf4b7d201ab28$exports)))('chev-down').outerHTML
                                }
                            })
                        ]
                    })
                ]
            }),
            !isCurrent ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("p", {
                    className: "possessions-custom-header__date",
                    children: [
                        "B\xf6rjar g\xe4lla: ",
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                            children: dateToRender
                        })
                    ]
                })
            }) : null
        ]
    });
};
var $9ee55d3c8be7e04d$export$2e2bcd8739ae039 = $9ee55d3c8be7e04d$var$PossessionCustomHeading;


var $8f17f8f0636254af$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as references for various `Number` constants. */ var $8f17f8f0636254af$var$MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var $8f17f8f0636254af$var$argsTag = '[object Arguments]', $8f17f8f0636254af$var$funcTag = '[object Function]', $8f17f8f0636254af$var$genTag = '[object GeneratorFunction]';
/** Detect free variable `global` from Node.js. */ var $8f17f8f0636254af$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $8f17f8f0636254af$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $8f17f8f0636254af$var$root = $8f17f8f0636254af$var$freeGlobal || $8f17f8f0636254af$var$freeSelf || Function('return this')();
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $8f17f8f0636254af$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/** Used for built-in method references. */ var $8f17f8f0636254af$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $8f17f8f0636254af$var$hasOwnProperty = $8f17f8f0636254af$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $8f17f8f0636254af$var$objectToString = $8f17f8f0636254af$var$objectProto.toString;
/** Built-in value references. */ var $8f17f8f0636254af$var$Symbol = $8f17f8f0636254af$var$root.Symbol, $8f17f8f0636254af$var$propertyIsEnumerable = $8f17f8f0636254af$var$objectProto.propertyIsEnumerable, $8f17f8f0636254af$var$spreadableSymbol = $8f17f8f0636254af$var$Symbol ? $8f17f8f0636254af$var$Symbol.isConcatSpreadable : undefined;
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $8f17f8f0636254af$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $8f17f8f0636254af$var$isFlattenable);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $8f17f8f0636254af$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $8f17f8f0636254af$var$arrayPush(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $8f17f8f0636254af$var$isFlattenable(value) {
    return $8f17f8f0636254af$var$isArray(value) || $8f17f8f0636254af$var$isArguments(value) || !!($8f17f8f0636254af$var$spreadableSymbol && value && value[$8f17f8f0636254af$var$spreadableSymbol]);
}
/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $8f17f8f0636254af$var$flatten(array) {
    var length = array ? array.length : 0;
    return length ? $8f17f8f0636254af$var$baseFlatten(array, 1) : [];
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function $8f17f8f0636254af$var$isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return $8f17f8f0636254af$var$isArrayLikeObject(value) && $8f17f8f0636254af$var$hasOwnProperty.call(value, 'callee') && (!$8f17f8f0636254af$var$propertyIsEnumerable.call(value, 'callee') || $8f17f8f0636254af$var$objectToString.call(value) == $8f17f8f0636254af$var$argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $8f17f8f0636254af$var$isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $8f17f8f0636254af$var$isArrayLike(value) {
    return value != null && $8f17f8f0636254af$var$isLength(value.length) && !$8f17f8f0636254af$var$isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $8f17f8f0636254af$var$isArrayLikeObject(value) {
    return $8f17f8f0636254af$var$isObjectLike(value) && $8f17f8f0636254af$var$isArrayLike(value);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $8f17f8f0636254af$var$isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = $8f17f8f0636254af$var$isObject(value) ? $8f17f8f0636254af$var$objectToString.call(value) : '';
    return tag == $8f17f8f0636254af$var$funcTag || tag == $8f17f8f0636254af$var$genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $8f17f8f0636254af$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $8f17f8f0636254af$var$MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $8f17f8f0636254af$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $8f17f8f0636254af$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
$8f17f8f0636254af$exports = $8f17f8f0636254af$var$flatten;



var $YChVI = parcelRequire("YChVI");

const $25937fdb26d57abd$var$basePaths = {
    public: '/lf-data/api/v1',
    protected: '/lf-data-authenticated/api/v1',
    authenticated: '/lf-data-authenticated/api/v1' //Todo: Changed this back to v1 because of new Api
};
const $25937fdb26d57abd$var$dataEndpoints = {
    // public
    quickInsuranceQuote: (insuranceGroup, birthDate)=>`/lf-data/api/v1/insurancequotes?insurancegroup=${insuranceGroup}&birthDate=${birthDate}`,
    homeInsuranceQuotes: (zipCode, birthDate)=>`/lf-data/api/v1/homeinsurancequotes?zipCode=${zipCode}&birthDate=${birthDate}`,
    animalInsuranceQuotes: function(animalType, breedId, birthdate, gender, previouslyInsured, zipCode, includeLifeInsuranceQuote, lifeInsuranceValue) {
        return `/lf-data/api/v1/animalinsurancequotes?animalType=${animalType}&animalBreedId=${breedId}` + (birthdate !== null ? `&birthDate=${birthdate}` : '') + (gender ? `&gender=${gender}` : '') + (typeof previouslyInsured !== 'undefined' ? `&hasBeenPreviouslyInsured=${previouslyInsured}` : '') + `&zipCode=${zipCode}` + (includeLifeInsuranceQuote !== null ? `&includeLifeInsuranceQuote=${includeLifeInsuranceQuote}` : '') + (lifeInsuranceValue !== null ? `&lifeInsuranceValue=${lifeInsuranceValue}` : '');
    },
    animalBreeds: (animalType)=>`/lf-data/api/v1/animalbreeds?animalType=${animalType}`,
    categorizedFAQData: (selectedCategory)=>`/api/v1/faq/questions?selectedCategories=${selectedCategory}`,
    // protected (member only)
    customerInfo: `/lf-data-authenticated/api/v1/customer`,
    customerAnimals: `/lf-data-authenticated/api/v1/memberanimals`,
    customerChildren: `/lf-data-authenticated/api/v1/memberchildren`,
    travelCertificate: `/lf-data-authenticated/api/v1/travelcertificate`,
    mailTravelCertificate: `/lf-data-authenticated/api/v1/travelcertificate/mail`,
    possessions: `/lf-data-authenticated/api/v1/possessions`,
    possessionStatus: (groups)=>`/lf-data-authenticated/api/v1/possession/status?InsuranceGroup=` + groups.join('&InsuranceGroup='),
    insurances: `/lf-data-authenticated/api/v1/insurances`,
    purchase: `/lf-data-authenticated/api/v1/purchase`,
    preregistrations: `/lf-data-authenticated/api/v1/preregistrations`,
    paymentMethod: `/lf-data-authenticated/api/v1/paymentmethod`,
    saveHealthdeclaration: `/lf-data-authenticated/api/v1/healthdeclaration`,
    pensionGuidanceForm: `/lf-data-authenticated/api/v1/pensionguidanceform`,
    student: `/lf-data-authenticated/api/v1/student`,
    extension: `/lf-data-authenticated/api/v1/extendinsurance`,
    extensionAutomatic: `/lf-data-authenticated/api/v1/extendinsurance/automaticpayment`,
    healthdeclaration: (insuranceName, objId)=>`/lf-data-authenticated/api/v1/healthdeclaration?insuranceName=${insuranceName}` + (objId ? `&insuranceObjectId=${objId}` : ''),
    quote: (insuranceName, values)=>`/lf-data-authenticated/api/v1/quote?insuranceName=${insuranceName}` + `${Object.keys(values).map((k)=>`&${k}=${values[k]}`).join('')}`,
    quotes: (zipCode, purchaseDate = null)=>`/lf-data-authenticated/api/v1/quotes?zipCode=${zipCode}` + (purchaseDate ? `&purchaseDate=${purchaseDate}` : ''),
    insuranceObjectQuote: (insuranceName, insuranceObjectId, insuranceValue)=>`/lf-data-authenticated/api/v1/insuranceobjectquote?insuranceName=${insuranceName}` + `&insuranceValue=${insuranceValue}&insuranceObjectId=${insuranceObjectId}`,
    achievements: `/lf-data-authenticated/api/v1/achievements`,
    newAchievements: `/lf-data-authenticated/api/v1/achievements/new`,
    coInsuredForm: `/lf-data-authenticated/api/v1/customerinfo/coinsured`,
    announcements: `/lf-data-authenticated/api/v1/achievements/notifications`,
    wizardQuestions: `/lf-data-authenticated/api/v1/customerknowledgeform`,
    // calls to api, v2
    possessionsData: `/lf-data-authenticated/api/v1/possessions`,
    basicCoverageData: `/lf-data-authenticated/api/v1/basic-coverage`,
    managedPensionQuestions: `/lf-data-authenticated/api/v1/managedpensioninsurances/questions`,
    managedPensionApplications: `/lf-data-authenticated/api/v1/managedpensioninsurances/applications`,
    preregistrationSummary: `/lf-data-authenticated/api/v1/preregistrationsummary`,
    managedPensionApplicationStatus: (applicationId)=>`/lf-data-authenticated/api/v1/managedpensioninsurances/applications/${applicationId}/status`,
    managedPensionApplicationSignStatus: (applicationId)=>`${$25937fdb26d57abd$var$basePaths.authenticated}/managedpensioninsurances/applications/${applicationId}/sign`,
    managedPensionSigningReference: (applicationId, signingRef)=>`${$25937fdb26d57abd$var$basePaths.authenticated}/managedpensioninsurances/applications/${applicationId}/sign/${signingRef}`
};
let $25937fdb26d57abd$var$instance = null;
class $25937fdb26d57abd$export$2e2bcd8739ae039 {
    constructor(){
        if (!$25937fdb26d57abd$var$instance) {
            this.client = new (0, $ec5d6bcbbe0f9d64$export$2e2bcd8739ae039)({
                baseUrl: ''
            });
            $25937fdb26d57abd$var$instance = this;
        }
        return $25937fdb26d57abd$var$instance;
    }
    // url getters
    get generatedTravelCertificateUrl() {
        return $25937fdb26d57abd$var$dataEndpoints.travelCertificate;
    }
    // public calls
    quickInsuranceQuote(insuranceGroup, birthDate) {
        return this.client.get($25937fdb26d57abd$var$dataEndpoints.quickInsuranceQuote(insuranceGroup, birthDate));
    }
    homeInsuranceQuotes(zipCode, birthDate) {
        return this.client.get($25937fdb26d57abd$var$dataEndpoints.homeInsuranceQuotes(zipCode, birthDate));
    }
    animalBreeds(type) {
        return this.client.get($25937fdb26d57abd$var$dataEndpoints.animalBreeds(type));
    }
    getAnimalInsuranceQuotes(animalType, breedId, birthdate = null, gender = null, previouslyInsured = null, zipCode, includeLifeInsuranceQuote = null, lifeInsuranceValue = null) {
        return this.client.get($25937fdb26d57abd$var$dataEndpoints.animalInsuranceQuotes(animalType, breedId, birthdate, gender, previouslyInsured, zipCode, includeLifeInsuranceQuote, lifeInsuranceValue));
    }
    getCategorizedFAQData(selectedCategory) {
        return this.client.get($25937fdb26d57abd$var$dataEndpoints.categorizedFAQData(selectedCategory));
    }
    // protected calls
    insurances() {
        return this.client.get($25937fdb26d57abd$var$dataEndpoints.insurances);
    }
    customerInfo() {
        return this.client.get($25937fdb26d57abd$var$dataEndpoints.customerInfo);
    }
    customerAnimals() {
        return this.client.get($25937fdb26d57abd$var$dataEndpoints.customerAnimals);
    }
    customerChildren() {
        return this.client.get($25937fdb26d57abd$var$dataEndpoints.customerChildren);
    }
    paymentMethod() {
        return this.client.get($25937fdb26d57abd$var$dataEndpoints.paymentMethod);
    }
    updatePaymentMethod(bankcode, accountnumber) {
        const postData = {
            accountnumber: parseInt(accountnumber, 10),
            bankcode: parseInt(bankcode, 10)
        };
        return this.client.post($25937fdb26d57abd$var$dataEndpoints.paymentMethod, postData);
    }
    updateEmail(data) {
        return this.client.post($25937fdb26d57abd$var$dataEndpoints.customerInfo, data);
    }
    updateProfile(data) {
        return this.client.post($25937fdb26d57abd$var$dataEndpoints.customerInfo, data);
    }
    updateCustomerChildren(data) {
        return this.client.put($25937fdb26d57abd$var$dataEndpoints.customerChildren, data);
    }
    extendStudentInsuranceAutomatic(insuranceName, accountnumber, bankcode, IsFullyAbleToWork, PurchaseTermsApproved) {
        const postData = {
            insurancename: insuranceName,
            accountnumber: parseInt(accountnumber, 10),
            bankcode: parseInt(bankcode, 10),
            IsFullyAbleToWork: !!IsFullyAbleToWork,
            PurchaseTermsApproved: !!PurchaseTermsApproved
        };
        return this.client.post($25937fdb26d57abd$var$dataEndpoints.extensionAutomatic, postData);
    }
    extendStudentInsurance(insuranceName, IsFullyAbleToWork, PurchaseTermsApproved) {
        const postData = {
            insurancename: insuranceName,
            IsFullyAbleToWork: !!IsFullyAbleToWork,
            PurchaseTermsApproved: !!PurchaseTermsApproved
        };
        return this.client.post($25937fdb26d57abd$var$dataEndpoints.extension, postData);
    }
    mailTravelCertificate() {
        return this.client.get($25937fdb26d57abd$var$dataEndpoints.mailTravelCertificate);
    }
    possessions() {
        return this.client.get($25937fdb26d57abd$var$dataEndpoints.possessions);
    }
    possessionStatus(groups) {
        return this.client.get($25937fdb26d57abd$var$dataEndpoints.possessionStatus(groups));
    }
    quote(insuranceName, values) {
        return this.client.get($25937fdb26d57abd$var$dataEndpoints.quote(insuranceName, values));
    }
    quotes(zipCode) {
        return this.client.get($25937fdb26d57abd$var$dataEndpoints.quotes(zipCode));
    }
    insuranceObjectQuote(insuranceName, insuranceObjectId, insuranceValue) {
        return this.client.get($25937fdb26d57abd$var$dataEndpoints.insuranceObjectQuote(insuranceName, insuranceObjectId, insuranceValue));
    }
    preregistrations() {
        return this.client.get($25937fdb26d57abd$var$dataEndpoints.preregistrations);
    }
    healthDeclaration(insuranceName, objId) {
        return this.client.get($25937fdb26d57abd$var$dataEndpoints.healthdeclaration(insuranceName, objId));
    }
    saveHealthDeclaration(data) {
        return this.client.post($25937fdb26d57abd$var$dataEndpoints.saveHealthdeclaration, data);
    }
    validateInsurancePurchaseData(insuranceData) {
        let data = window.__bazStore.getState().insurancePageData;
        return this.client.post($25937fdb26d57abd$var$dataEndpoints.purchase, {
            onlyValidate: true,
            insurances: [
                {
                    personId: data.customerInfo.personId,
                    streetAddress: data.customerInfo.streetAddress,
                    address2: data.customerInfo.address2,
                    zipCode: data.customerInfo.zipCode,
                    ...insuranceData
                }
            ]
        });
    }
    purchase(orders, onlyValidate = false) {
        let data = window.__bazStore.getState().insurancePageData;
        const insurances = orders.map((insuranceOrder)=>({
                personId: data.customerInfo.personId,
                streetAddress: data.customerInfo.streetAddress,
                address2: data.customerInfo.address2,
                zipCode: data.customerInfo.zipCode,
                ...insuranceOrder
            }));
        return this.client.post($25937fdb26d57abd$var$dataEndpoints.purchase, {
            onlyValidate: onlyValidate,
            insurances: insurances
        });
    }
    pensionGuidanceForm() {
        return this.client.get($25937fdb26d57abd$var$dataEndpoints.pensionGuidanceForm);
    }
    submitPensionGuidance(data) {
        return this.client.post($25937fdb26d57abd$var$dataEndpoints.pensionGuidanceForm, data);
    }
    submitCoInsured(data) {
        return this.client.post($25937fdb26d57abd$var$dataEndpoints.coInsuredForm, data);
    }
    getAchievements() {
        return this.client.get($25937fdb26d57abd$var$dataEndpoints.achievements);
    }
    getNewAchievements() {
        return this.client.get($25937fdb26d57abd$var$dataEndpoints.newAchievements);
    }
    submitViewedAchievements() {
        return this.client.post($25937fdb26d57abd$var$dataEndpoints.newAchievements, {});
    }
    getAnnouncements() {
        return this.client.get($25937fdb26d57abd$var$dataEndpoints.announcements);
    }
    viewedAnnouncements() {
        return this.client.post($25937fdb26d57abd$var$dataEndpoints.announcements, {});
    }
    getWizardQuestions() {
        return this.client.get($25937fdb26d57abd$var$dataEndpoints.wizardQuestions);
    }
    submitWizardForm(data) {
        return this.client.post($25937fdb26d57abd$var$dataEndpoints.wizardQuestions, data);
    }
    // protected / authenticated calls to api, v2
    getPossessionsData() {
        return this.client.get($25937fdb26d57abd$var$dataEndpoints.possessionsData);
    }
    getBasicCoverageData() {
        return this.client.get($25937fdb26d57abd$var$dataEndpoints.basicCoverageData);
    }
    getManagedPensionQuestions() {
        return this.client.get($25937fdb26d57abd$var$dataEndpoints.managedPensionQuestions);
    }
    getPreregistrationSummary() {
        return this.client.get($25937fdb26d57abd$var$dataEndpoints.preregistrationSummary);
    }
    submitPensionWizardForm(data) {
        return this.client.post($25937fdb26d57abd$var$dataEndpoints.managedPensionApplications, data);
    }
    // Check application status at Futur - can application be signed with bankId? GET /status
    getManagedPensionApplicationSignatureStatus(data) {
        return this.client.get($25937fdb26d57abd$var$dataEndpoints.managedPensionApplicationStatus(data.appId), {});
    }
    // POST to /sign to get autoStartToken and signingReference
    startManagedPensionApplicationSigning(data) {
        return this.client.post($25937fdb26d57abd$var$dataEndpoints.managedPensionApplicationSignStatus(data.appId), {});
    }
    // GET to /sign: Check application status at BankId
    getManagedPensionApplicationBankIDStatus(data) {
        return this.client.get($25937fdb26d57abd$var$dataEndpoints.managedPensionApplicationSignStatus(data.appId));
    }
    // Get ongoing status of BankID signing
    getManagedPensionBankIDCurrentStatus(data) {
        return this.client.get($25937fdb26d57abd$var$dataEndpoints.managedPensionSigningReference(data.appId, data.signingRef));
    }
}





const $2fbee14f339500ec$var$defaultOrder = 99999;
const $2fbee14f339500ec$var$sortByInsuranceMetaOrder = (insurancesByName, metaData, previouslyActiveGroups)=>(a, b)=>{
        previouslyActiveGroups = typeof previouslyActiveGroups !== 'undefined' && previouslyActiveGroups != null ? previouslyActiveGroups : [];
        let aOrder, bOrder;
        let insuranceGroupA, insuranceGroupB;
        if (typeof a.groupName !== 'undefined') insuranceGroupA = a.groupName;
        else insuranceGroupA = a.insuranceName in insurancesByName ? insurancesByName[a.insuranceName].groupName : null;
        if (typeof b.groupName !== 'undefined') insuranceGroupB = b.groupName;
        else insuranceGroupB = b.insuranceName in insurancesByName ? insurancesByName[b.insuranceName].groupName : null;
        aOrder = (insuranceGroupA in metaData ? metaData[insuranceGroupA].sortOrder : $2fbee14f339500ec$var$defaultOrder) + (previouslyActiveGroups.indexOf(insuranceGroupA) === -1 ? 999999 : 0);
        bOrder = (insuranceGroupB in metaData ? metaData[insuranceGroupB].sortOrder : $2fbee14f339500ec$var$defaultOrder) + (previouslyActiveGroups.indexOf(insuranceGroupB) === -1 ? 999999 : 0);
        return aOrder < bOrder ? -1 : 1;
    };
var $2fbee14f339500ec$export$2e2bcd8739ae039 = $2fbee14f339500ec$var$sortByInsuranceMetaOrder;


function $0715c3ea4b61f617$export$978808698667f5fa() {
    return (dispatch)=>{
        const lfDataService = new (0, $25937fdb26d57abd$export$2e2bcd8739ae039)();
        const lfWebService = new (0, $0f2b98672976a17a$export$2e2bcd8739ae039)();
        let memberInfo, currentCoInsured;
        dispatch((0, $67f4b1d2fb7c2244$export$5630fcc02dc02d1b)(true));
        lfDataService.memberInfo().then((data)=>{
            memberInfo = data.memberInfo;
            currentCoInsured = data.currentCoInsured;
            return Promise.all([
                lfDataService.possessions(),
                lfDataService.insurances(),
                lfDataService.quotes(memberInfo.zipCode),
                lfDataService.animalBreeds('all'),
                lfWebService.insuranceMetaData().then((data)=>({
                        metaData: (0, $36509d2879dd53eb$export$bad51be39f661eab)(data.insurances)
                    }))
            ]);
        }).then((values)=>{
            let data = values.reduce((acc, obj)=>{
                Object.keys(obj).forEach((prop)=>acc[prop] = obj[prop]);
                return acc;
            }, {});
            const possessions = data.possessions.filter((p)=>p.insuranceName != null);
            const insurancesByName = (0, $36509d2879dd53eb$export$aa98a26e797b60e6)(data.insurances);
            const currentPossessions = possessions.filter((i)=>(0, (/*@__PURE__*/$parcel$interopDefault($YChVI)))(i.fromDate).isSameOrBefore((0, (/*@__PURE__*/$parcel$interopDefault($YChVI)))(), 'day')).sort((0, $2fbee14f339500ec$export$2e2bcd8739ae039)(insurancesByName, data.metaData, []));
            const futurePossessions = possessions.filter((i)=>(0, (/*@__PURE__*/$parcel$interopDefault($YChVI)))(i.fromDate).isAfter((0, (/*@__PURE__*/$parcel$interopDefault($YChVI)))(), 'day')).sort((0, $2fbee14f339500ec$export$2e2bcd8739ae039)(insurancesByName, data.metaData, []));
            const currentPremiumTotal = currentPossessions.map((pos)=>{
                return pos.premiumPeriod === 'monthly' ? pos.premium : 0;
            }).reduce((sum, val)=>sum + val, 0);
            dispatch($0715c3ea4b61f617$export$3deeb30fda2ffb1e({
                ...data,
                memberInfo: memberInfo,
                currentCoInsured: currentCoInsured,
                insurancesByName: insurancesByName,
                possessions: possessions,
                quotesByName: (0, $36509d2879dd53eb$export$aa98a26e797b60e6)(data.quotes),
                possessionsByName: (0, $36509d2879dd53eb$export$aa98a26e797b60e6)(possessions),
                currentPossessions: currentPossessions,
                futurePossessions: futurePossessions,
                currentPremiumTotal: currentPremiumTotal,
                breedsById: (0, $36509d2879dd53eb$export$23a64b23f50bab27)(data.breeds),
                insurancePurchaseUrl: lfWebService.insurancePurchaseUrl(),
                insurancePreregistrationsUrl: lfWebService.insurancePreregistrationsUrl()
            }));
            dispatch((0, $67f4b1d2fb7c2244$export$5630fcc02dc02d1b)(false));
            dispatch($0715c3ea4b61f617$export$c9cdebd24ea41201(possessions, insurancesByName));
        }).catch((e)=>{
            dispatch((0, $67f4b1d2fb7c2244$export$5630fcc02dc02d1b)(false));
            dispatch((0, $67f4b1d2fb7c2244$export$7a8bb273722d5103)(e));
            dispatch((0, $67f4b1d2fb7c2244$export$ea4b4733f4ca2df0)(true));
        });
    };
}
function $0715c3ea4b61f617$export$3deeb30fda2ffb1e(data) {
    return {
        type: 'STARTPAGE_LOADED',
        data: data
    };
}
function $0715c3ea4b61f617$export$c9cdebd24ea41201() {
    const lfDataService = new (0, $25937fdb26d57abd$export$2e2bcd8739ae039)();
    return (dispatch, getState)=>{
        const { startPageData: startPageData } = getState();
        const possessions = startPageData.possessions;
        const insurancesByName = startPageData.insurancesByName;
        let upgradeablePossessions = possessions.filter((p)=>{
            const groupName = insurancesByName[p.insuranceName].groupName;
            const possibleUpgrades = insurancesByName[p.insuranceName].possibleUpgrades;
            return animalInsuranceGroups.indexOf(groupName) > -1 && possibleUpgrades.length > 0;
        });
        let animalQuotePromises = (0, (/*@__PURE__*/$parcel$interopDefault($8f17f8f0636254af$exports)))(upgradeablePossessions.map((p)=>insurancesByName[p.insuranceName].possibleUpgrades.map((upgradeInsuranceName)=>lfDataService.insuranceObjectQuote(upgradeInsuranceName, p.insuranceObjectId).then((data)=>({
                        [p.insuranceObjectId]: {
                            insuranceName: upgradeInsuranceName,
                            quote: data.quote
                        }
                    })).catch((e)=>{
                    console.error(`Could not fetch animal quote for insurance object id : ${p.insuranceObjectId}`, e);
                }))));
        Promise.all(animalQuotePromises).then((data)=>{
            const quotes = data.reduce((quoteObj, quote)=>{
                Object.keys(quote).forEach((insuranceObjectId)=>{
                    const quoteInsuranceName = quote[insuranceObjectId].insuranceName;
                    const currentQuote = quote[insuranceObjectId].quote;
                    quoteObj[insuranceObjectId] = {
                        ...quoteObj[insuranceObjectId],
                        [quoteInsuranceName]: currentQuote
                    };
                });
                return quoteObj;
            }, {});
            dispatch($0715c3ea4b61f617$export$45d673bbc7b56766(quotes));
        });
    };
}
function $0715c3ea4b61f617$export$45d673bbc7b56766(quotes) {
    return {
        type: 'ANIMAL_POSSESSION_QUOTES_LOADED',
        quotes: quotes
    };
}


function $e6aeb63e6149c504$export$161fa9a9af21e7de(name, rootId) {
    let root = document.getElementById(rootId);
    return root.getAttribute(`data-lf-epi-${name}`);
}
function $e6aeb63e6149c504$export$1de30afe8bf7ed5f(name, element) {
    return element.getAttribute(`data-lf-epi-${name}`);
}





class $2b17f3b505a2d431$var$SignedInStartPage extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    static get propTypes() {
        return {
            mountRootId: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string.isRequired
        };
    }
    constructor(props){
        super(props);
        this.heading = (0, $e6aeb63e6149c504$export$161fa9a9af21e7de)('heading', this.props.mountRootId);
        this.preamble = (0, $e6aeb63e6149c504$export$161fa9a9af21e7de)('preamble', this.props.mountRootId);
        this.futureInsurancesHeading = (0, $e6aeb63e6149c504$export$161fa9a9af21e7de)('future-insurances-heading', this.props.mountRootId);
        this.futureInsurancesPreamble = (0, $e6aeb63e6149c504$export$161fa9a9af21e7de)('future-insurances-preamble', this.props.mountRootId);
    }
    componentDidMount() {
        this.props.loadData();
    }
    render() {
        const hasNoPossessions = !this.props.data.possessions || !this.props.data.possessions.length;
        if (this.props.error.hasErrored) return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $19ac445fff8f1f3a$export$2e2bcd8739ae039), {
            message: `Ooops! Ett fel uppstod vid h\xe4mtningen: ${typeof this.props.error === 'string' ? this.props.error : this.props.error.message}`
        });
        if (this.props.isLoading) return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Fragment, {
            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $492d68823d70b95b$export$2e2bcd8739ae039), {
                color: (0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.blueBackground
            })
        });
        if (hasNoPossessions) return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Fragment, {
            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $bb8231acd22e51c2$export$e25e478948902b8b).div, {
                initial: {
                    opacity: 0
                },
                animate: {
                    opacity: 1
                },
                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($2b17f3b505a2d431$var$HeadingWrapper, {
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("h3", {
                            children: this.heading
                        }),
                        "Du har just nu inga tecknade f\xf6rs\xe4kringar."
                    ]
                })
            })
        });
        // custom header for displaying on My Pages / My Possessions
        const CustomHeader = ({ text: text, value: value, isCurrent: isCurrent, date: date, heading: heading })=>{
            return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                className: "possessions-custom-header",
                "data-lf-accordion": true,
                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $9ee55d3c8be7e04d$export$2e2bcd8739ae039), {
                    text: text,
                    value: value,
                    isCurrent: isCurrent,
                    date: date,
                    heading: heading
                })
            });
        };
        const PossessionListing = ({ possessions: possessions, current: current })=>possessions.map((insurance, i)=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $87d87c79350c4a5e$export$2e2bcd8739ae039), {
                    title: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $c8abba432cc26d54$export$2e2bcd8739ae039), {
                        possession: insurance
                    }),
                    labelRight: {
                        text: (0, $36509d2879dd53eb$export$2a0be428efc19c5c)(insurance.premiumPeriod),
                        value: insurance.premium
                    },
                    align: 'right',
                    customHeader: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)(CustomHeader, {
                        heading: insurance.displayName,
                        text: (0, $36509d2879dd53eb$export$2a0be428efc19c5c)(insurance.premiumPeriod),
                        value: insurance.premium,
                        isCurrent: current,
                        date: insurance.fromDate
                    }),
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $2a0f9e8495de2782$export$2e2bcd8739ae039), {
                        possession: insurance
                    })
                }, `possession-${i}`));
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Fragment, {
            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $bb8231acd22e51c2$export$e25e478948902b8b).div, {
                initial: {
                    opacity: 0
                },
                animate: {
                    opacity: 1
                },
                children: [
                    this.props.data.currentPossessions.length > 0 && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($2b17f3b505a2d431$var$ColumnContainer, {
                                children: [
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($2b17f3b505a2d431$var$Column, {
                                        children: (this.heading || this.preamble) && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($2b17f3b505a2d431$var$HeadingWrapper, {
                                            children: [
                                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("h3", {
                                                    children: this.heading
                                                }),
                                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $96c25128201e5f07$export$2e2bcd8739ae039), {
                                                    children: this.preamble
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($2b17f3b505a2d431$var$Column, {
                                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($2b17f3b505a2d431$var$PremiumSummary, {
                                            children: [
                                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("strong", {
                                                    style: {
                                                        marginRight: 10
                                                    },
                                                    children: "Summa m\xe5nadspris:"
                                                }),
                                                " ",
                                                this.props.data.currentPremiumTotal,
                                                " kr"
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)(PossessionListing, {
                                possessions: this.props.data.currentPossessions,
                                current: true
                            })
                        ]
                    }),
                    this.props.data.futurePossessions.length > 0 && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($2b17f3b505a2d431$var$Spacer, {}),
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($2b17f3b505a2d431$var$HeadingWrapper, {
                                children: [
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("h3", {
                                        children: this.futureInsurancesHeading
                                    }),
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $96c25128201e5f07$export$2e2bcd8739ae039), {
                                        children: this.futureInsurancesPreamble
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)(PossessionListing, {
                                possessions: this.props.data.futurePossessions,
                                current: false
                            })
                        ]
                    })
                ]
            })
        });
    }
}
const $2b17f3b505a2d431$var$mapStateToProps = (state)=>{
    return {
        data: state.startPageData,
        hasErrored: state.pageHasErrored,
        error: state.pageError,
        isLoading: state.pageIsLoading
    };
};
const $2b17f3b505a2d431$var$mapDispatchToProps = (dispatch)=>{
    return {
        loadData: ()=>dispatch((0, $0715c3ea4b61f617$export$978808698667f5fa)())
    };
};
var $2b17f3b505a2d431$export$2e2bcd8739ae039 = (0, $5a4066412ccab0c1$export$64605811ab45167f)($2b17f3b505a2d431$var$mapStateToProps, $2b17f3b505a2d431$var$mapDispatchToProps)($2b17f3b505a2d431$var$SignedInStartPage);
// styles
const $2b17f3b505a2d431$var$Spacer = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    height: 20px;
    ${(0, $45d1242a07988139$export$8f880b6e390052fa).xsmall(`
        height: 10px;
    `)}
`;
const $2b17f3b505a2d431$var$HeadingWrapper = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    padding: 17px 17px 0px 17px;

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        padding-bottom: 17px;
    `)}

    h3 {
        font-size: 28px;
        margin-bottom: 10px;

        ${(0, $45d1242a07988139$export$8f880b6e390052fa).xsmall(`
            font-size: 20px;
            margin-bottom: 5px;
        `)}
    }

    p {
        margin-top: 0;
    }
    p:last-child {
        margin-bottom: 0;
    }
`;
const $2b17f3b505a2d431$var$ColumnContainer = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    width: 100%;
`;
const $2b17f3b505a2d431$var$Column = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`

`;
const $2b17f3b505a2d431$var$PremiumSummary = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 10px;
`;




var $8NFma = parcelRequire("8NFma");






function $e998e29c519b6c18$export$fa3015a6507c7d7b() {
    const lfDataService = new (0, $25937fdb26d57abd$export$2e2bcd8739ae039)();
    return (dispatch)=>{
        lfDataService.memberInfo().then((data)=>{
            dispatch($e998e29c519b6c18$export$675d69eeae13b896({
                memberInfo: data.memberInfo,
                coinsuredInfo: data.currentCoInsured
            }));
            dispatch((0, $67f4b1d2fb7c2244$export$5630fcc02dc02d1b)(false));
        }).catch((e)=>{
            dispatch((0, $67f4b1d2fb7c2244$export$7a8bb273722d5103)(e));
            dispatch((0, $67f4b1d2fb7c2244$export$ea4b4733f4ca2df0)(true));
        });
    };
}
function $e998e29c519b6c18$export$675d69eeae13b896(data) {
    return {
        type: 'PROFILE_PAGE_LOADED',
        data: data
    };
}
function $e998e29c519b6c18$export$69cd666a2ca44457(data) {
    const lfDataService = new (0, $25937fdb26d57abd$export$2e2bcd8739ae039)();
    const lfWebService = new (0, $0f2b98672976a17a$export$2e2bcd8739ae039)();
    return (dispatch)=>{
        dispatch((0, $67f4b1d2fb7c2244$export$5630fcc02dc02d1b)(true));
        lfDataService.updateProfile(data).then((result)=>{
            if (result.success) {
                lfWebService.myPages();
                return;
            }
            dispatch((0, $67f4b1d2fb7c2244$export$5630fcc02dc02d1b)(false));
            dispatch((0, $67f4b1d2fb7c2244$export$7a8bb273722d5103)('kunde inte uppdatera dina uppgifter'));
            dispatch((0, $67f4b1d2fb7c2244$export$ea4b4733f4ca2df0)(true));
        }).catch((e)=>{
            dispatch((0, $67f4b1d2fb7c2244$export$5630fcc02dc02d1b)(true));
            dispatch((0, $67f4b1d2fb7c2244$export$7a8bb273722d5103)(e));
            dispatch((0, $67f4b1d2fb7c2244$export$ea4b4733f4ca2df0)(true));
        });
    };
}








var $8NFma = parcelRequire("8NFma");





parcelRequire("8NFma");




const $fdc1d0f3f8a87be4$var$TextInput = ({ error: error, isChanged: isChanged, isUsed: isUsed, ...allProps })=>{
    const { displayname: displayname, fieldWidth: fieldWidth, textInputWrapperWidth: textInputWrapperWidth, marginBottom: marginBottom, ...props } = allProps;
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($fdc1d0f3f8a87be4$var$TextInputWrapper, {
        fieldWidth: fieldWidth,
        marginBottom: marginBottom,
        textInputWrapperWidth: textInputWrapperWidth,
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("input", {
                type: "text",
                ...props,
                ...isChanged && isUsed && error ? {
                    className: `is-invalid-input ${props.className}`
                } : {
                    className: props.className
                }
            }),
            displayname && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("label", {
                htmlFor: props.id,
                children: displayname
            }),
            isChanged && isUsed && error
        ]
    });
};
const $fdc1d0f3f8a87be4$var$TextInputWrapper = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    width: ${(props)=>props.textInputWrapperWidth ? props.textInputWrapperWidth : '100%'}; 
    ${(0, $45d1242a07988139$export$8f880b6e390052fa).medium(`
        width: 100%;
    `)}

    input[type=text] {
        width: ${(props)=>props.fieldWidth ? props.fieldWidth : '100%'}; 

        padding: 12px;
        //margin-bottom: 27px; 
        margin-bottom: ${(props)=>props.marginBottom ? props.marginBottom : '10px'}; 
        
        background-color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.grayBackground};
        border: 1px solid ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.grayBorder};

        font-family: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.main};
        font-size: 18px;

        &:disabled {
            cursor: not-allowed;
            opacity: 0.5;
        }
        ${(0, $45d1242a07988139$export$8f880b6e390052fa).medium(`
            width: 95%;
        `)}
        ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
            font-size: 13px;
            padding: 5px;
            width: 100%;
        `)}
    }

    input[type=text]::placeholder {
        opacity: 0.3; 
    }

    input[type=text].is-invalid-input {
        border: 1px solid ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.error};
        margin-bottom: 0px; 
    }
`;
var $fdc1d0f3f8a87be4$export$2e2bcd8739ae039 = (0, $ecd163b239ffc845$export$2e2bcd8739ae039)($fdc1d0f3f8a87be4$var$TextInput);







const $505e6dfcdb88d92d$export$ac7496df4f1f837a = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    background-color: 'white';
    color: 'black';
    border-radius: 5px;

    padding: 30px;

    &:not(:first-of-type) {
        margin-top: 30px;
    }

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).medium(`
        padding: 15px;
    `)}

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        margin-top: 10px;
        &:not(:first-of-type) {
            margin-top: 15px;
            padding: 0px 15px;
        }
    `)}

    form {
        display: table;
        width: 100%; 
    }
`;
const $505e6dfcdb88d92d$export$2a4fbecf595add23 = (0, $65e706775ff71837$export$2e2bcd8739ae039).h4`
    display: block; 

    padding: 15px 15px 0 15px;

    font-family: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.main};
    font-size: 18px;
    font-weight: bold;

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        padding: 0px;
    `)}
`;
const $505e6dfcdb88d92d$var$formHeadingPropsToExclude = [
    'layout',
    'normalWeight',
    'noMarginBottom',
    'customPadding'
];
const $505e6dfcdb88d92d$export$6e0923060fc4578e = (0, $65e706775ff71837$export$2e2bcd8739ae039).h4.withConfig({
    shouldForwardProp: (prop)=>!$505e6dfcdb88d92d$var$formHeadingPropsToExclude.includes(prop)
})`
    display: ${(props)=>props.layout ? props.layout : 'block'}; 
    font-family: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.main};
    font-size: 22px;

    font-weight: ${(props)=>props.normalWeight ? 'normal' : 'bold'};

    margin-bottom: ${(props)=>props.noMarginBottom ? '0px' : '15px'};
    padding-left: 15px;

    &:nth-of-type(2) {
        padding-left: 0px;
    }

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).medium(`
        font-size: 20px;
    `)}

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        font-size: 16px;
    `)}

    ${(props)=>props.customPadding ? `
        ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
            padding: ${props.customPadding};
        `)}
    ` : `
        ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
            padding: 0px;
        `)}
    `}
`;
const $505e6dfcdb88d92d$var$inputHeadingPropsToExclude = [
    'normalWeight'
];
const $505e6dfcdb88d92d$export$ff2cc7cd7ab415a4 = (0, $65e706775ff71837$export$2e2bcd8739ae039).h4.withConfig({
    shouldForwardProp: (prop)=>!$505e6dfcdb88d92d$var$inputHeadingPropsToExclude.includes(prop)
})`
    display: block; 
    margin-bottom: 10px;
    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        margin-bottom: 5px;
    `)}

    font-family: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.heading};
    font-size: 20px;

    font-weight: ${(props)=>props.normalWeight ? 'normal' : 'bold'};
`;
const $505e6dfcdb88d92d$var$formPropsToExclude = [
    'noPadding',
    'topMargin',
    'noBorder',
    'borderColor',
    'customPadding'
];
const $505e6dfcdb88d92d$export$b534bc812df080fd = (0, $65e706775ff71837$export$2e2bcd8739ae039).div.withConfig({
    shouldForwardProp: (prop)=>!$505e6dfcdb88d92d$var$formPropsToExclude.includes(prop)
})`
    position: relative;
    width: 100%;
    display: table;
    padding: ${(props)=>props.noPadding ? '0' : '15px'};

    margin-top: ${(props)=>props.topMargin ? '10px' : '0'};
    border-bottom: ${(props)=>!props.noBorder ? `1px solid ${props.borderColor ? props.borderColor : (0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.grayBorder}` : 'none'};
    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        font-size: 13px;
        line-height: 1.4;
        margin-top: 0px;
    `)}

    ${(props)=>props.customPadding && !props.noPadding ? `
        ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
            padding: ${props.customPadding} !important;
        `)}
    ` : ''}

    ${(props)=>!props.noPadding ? (0, $45d1242a07988139$export$8f880b6e390052fa).small(`
            padding: 15px 0px;
        `) : ''};
`;
const $505e6dfcdb88d92d$var$columnPropsToExclude = [
    'valignTop',
    'width',
    'bottomPadding',
    'customDisplay',
    'customPadding',
    'textAlign',
    'customwidth'
];
const $505e6dfcdb88d92d$export$721f69dc1a24ae03 = (0, $65e706775ff71837$export$2e2bcd8739ae039).div.withConfig({
    shouldForwardProp: (prop)=>!$505e6dfcdb88d92d$var$columnPropsToExclude.includes(prop)
})`
    position: relative;
    display: table-cell;

    height: 100%;
    width: ${(props)=>props.width ? props.width : '100%'};

    ${(props)=>props.valignTop ? `
        vertical-align: top;
    ` : ''};

     ${(props)=>props.bottomPadding ? `
        ${(0, $45d1242a07988139$export$8f880b6e390052fa).large(`
            padding-bottom: ${props.bottomPadding};
        `)};
    ` : ''};

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        box-sizing: border-box;
        width: 50%;
    `)}

    ${(props)=>props.customdisplay ? `
        ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
            display: ${props.customdisplay};
        `)}
    ` : `
        ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
            display: table-cell;
        `)}
    `}

    ${(props)=>props.customPadding ? `
        ${(0, $45d1242a07988139$export$8f880b6e390052fa).medium(`
            padding: ${props.customPadding};
        `)}
    ` : `
        ${(0, $45d1242a07988139$export$8f880b6e390052fa).medium(`
            padding: 0px;
        `)}
    `}
    
    text-align: ${(props)=>props.textAlign ? props.textAlign : 'left'};

    h4 {
        font-family: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.heading};
        font-size: 18px;
        ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
            width: 100%;
            font-size: 13px;
        `)}
    }

    ${(props)=>props.customwidth ? `
        ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
            width: ${props.customwidth};
        `)}
    ` : `
        ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
            width: 50%;
        `)}
    `}
`;
const $505e6dfcdb88d92d$export$584b03256262262 = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    width: 100%;
    min-height: 30px;
    background-color ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.blueBackground};
    position: relative;

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).medium(`
        min-height: 25px;
    `)}


    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        min-height: 15px;
    `)}


    &:before {
        content: "";
        background: white;
        width: 100%;
        position: absolute;
        top: -5px;
        height: 10px;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;

    }

    &:after {
        content: "";
        background: white;
        width: 100%;
        position: absolute;
        bottom: -5px;
        height: 10px;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
    }
`;
const $505e6dfcdb88d92d$export$23e8c31bf5f4aca3 = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    width: 100%;
    min-height: 30px;
    background-color ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.blueBackground};
    position: relative;

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).medium(`
        min-height: 25px;
    `)}


    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        min-height: 15px;
    `)}

    &:after {
        content: "";
        background: white;
        width: 100%;
        position: absolute;
        bottom: -5px;
        height: 10px;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
    }
`;
const $505e6dfcdb88d92d$export$d148ff25b432a05 = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    width: 100%;
    position: relative;
    background-color ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.blueBackground};
    color: white;
`;



class $e1e8215ce3ae7666$var$ProfileForm extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    submitForm = (e)=>{
        e.preventDefault();
        this.props.submitProfileForm((0, $f2bfeab6e0c24c97$export$2e2bcd8739ae039)(this.form));
    };
    render() {
        const currentEmail = this.props.data.memberInfo.emailAddress ? this.props.data.memberInfo.emailAddress : 'mail@mail.se';
        const currentMobileNumber = this.props.data.memberInfo.mobilePhone;
        const currentPhoneNumber = this.props.data.memberInfo.homePhone;
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $8c02aa23a40a9b45$export$2e2bcd8739ae039), {
            ref: (el)=>{
                this.form = el;
            },
            onSubmit: (e)=>this.submitForm(e),
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($e1e8215ce3ae7666$export$b534bc812df080fd, {
                    noBorder: true,
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $505e6dfcdb88d92d$export$ff2cc7cd7ab415a4), {
                            children: "Telefonnummer"
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $fdc1d0f3f8a87be4$export$2e2bcd8739ae039), {
                            id: "mobilePhone",
                            name: "mobilePhone",
                            placeholder: currentMobileNumber,
                            "data-validation-error-message": "Ange ett svenskt mobilnummer",
                            validations: [
                                (0, $d5552fc3ceef5489$export$8cf0558aca0fb9bc)
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($e1e8215ce3ae7666$export$b534bc812df080fd, {
                    noBorder: true,
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $505e6dfcdb88d92d$export$ff2cc7cd7ab415a4), {
                            children: "Ny e-post"
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $fdc1d0f3f8a87be4$export$2e2bcd8739ae039), {
                            id: "emailAddress",
                            name: "emailAddress",
                            placeholder: currentEmail,
                            "data-validation-error-message": "Ange en korrekt e-post",
                            validations: [
                                (0, $d5552fc3ceef5489$export$9ab921aaffe56820),
                                (0, $d5552fc3ceef5489$export$8e8fc82834721462)('emailAddress', 'emailAddressConfirmation')
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($e1e8215ce3ae7666$export$b534bc812df080fd, {
                    noBorder: true,
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $505e6dfcdb88d92d$export$ff2cc7cd7ab415a4), {
                            children: "Bekr\xe4fta ny e-post"
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $fdc1d0f3f8a87be4$export$2e2bcd8739ae039), {
                            id: "emailAddressConfirmation",
                            name: "emailAddressConfirmation",
                            placeholder: currentEmail,
                            "data-validation-error-message": "Ange en korrekt e-post",
                            validations: [
                                (0, $d5552fc3ceef5489$export$9ab921aaffe56820),
                                (0, $d5552fc3ceef5489$export$8e8fc82834721462)('emailAddress', 'emailAddressConfirmation', "E-postadresserna st\xe4mmer inte \xf6verens")
                            ]
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $b50965a6d450d3cc$export$2e2bcd8739ae039), {
                            children: "Spara"
                        })
                    ]
                })
            ]
        });
    }
}
// state
const $e1e8215ce3ae7666$var$mapStateToProps = (state)=>{
    return {
        data: state.profilePageData,
        hasErrored: state.pageHasErrored,
        error: state.pageError,
        isLoading: state.pageIsLoading
    };
};
const $e1e8215ce3ae7666$var$mapDispatchToProps = (dispatch)=>{
    return {
        submitProfileForm: (data)=>dispatch((0, $e998e29c519b6c18$export$69cd666a2ca44457)(data))
    };
};
var $e1e8215ce3ae7666$export$2e2bcd8739ae039 = (0, $5a4066412ccab0c1$export$64605811ab45167f)($e1e8215ce3ae7666$var$mapStateToProps, $e1e8215ce3ae7666$var$mapDispatchToProps)($e1e8215ce3ae7666$var$ProfileForm);
const $e1e8215ce3ae7666$export$b534bc812df080fd = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    position: relative;
    margin-top: 30px;
`;




class $d46d5bb68afd6fcd$var$ProfilePage extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    constructor(props){
        super(props);
        this.heading = (0, $e6aeb63e6149c504$export$161fa9a9af21e7de)('heading', this.props.mountRootId);
        this.preamble = (0, $e6aeb63e6149c504$export$161fa9a9af21e7de)('preamble', this.props.mountRootId);
    }
    static get propTypes() {
        return {
            mountRootId: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string.isRequired
        };
    }
    componentDidMount() {
        this.props.loadData();
    }
    render() {
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($d46d5bb68afd6fcd$export$e6dfd72ab29f8598, {
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($d46d5bb68afd6fcd$export$a8a3e93435678ff9, {
                    children: this.heading
                }),
                !this.props.hasErrored && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($d46d5bb68afd6fcd$export$c6d1ad8c1472a6e0, {
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $96c25128201e5f07$export$2e2bcd8739ae039), {
                        children: this.preamble
                    })
                }),
                this.props.hasErrored && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $19ac445fff8f1f3a$export$2e2bcd8739ae039), {
                    message: `Ooops! Ett fel har uppst\xe5tt: ${typeof this.props.error === 'string' ? this.props.error : this.props.error.message}`
                }),
                this.props.isLoading && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $492d68823d70b95b$export$2e2bcd8739ae039), {
                    color: (0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.blueBackground
                }),
                !this.props.isLoading && !this.props.hasErrored && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($d46d5bb68afd6fcd$export$ac7496df4f1f837a, {
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $e1e8215ce3ae7666$export$2e2bcd8739ae039), {})
                })
            ]
        });
    }
}
// state
const $d46d5bb68afd6fcd$var$mapStateToProps = (state)=>{
    return {
        data: state.preregistrationPageData,
        hasErrored: state.pageHasErrored,
        error: state.pageError,
        isLoading: state.pageIsLoading
    };
};
const $d46d5bb68afd6fcd$var$mapDispatchToProps = (dispatch)=>{
    return {
        loadData: ()=>dispatch((0, $e998e29c519b6c18$export$fa3015a6507c7d7b)())
    };
};
var $d46d5bb68afd6fcd$export$2e2bcd8739ae039 = (0, $5a4066412ccab0c1$export$64605811ab45167f)($d46d5bb68afd6fcd$var$mapStateToProps, $d46d5bb68afd6fcd$var$mapDispatchToProps)($d46d5bb68afd6fcd$var$ProfilePage);
const $d46d5bb68afd6fcd$export$e6dfd72ab29f8598 = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    position: relative;
    margin: 0 0 100px 0;
    padding: 0;

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).custom(`
        padding: 13px;
    `, '1234px')}

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).large(`
        padding: 21px;
    `)}
`;
const $d46d5bb68afd6fcd$export$a8a3e93435678ff9 = (0, $65e706775ff71837$export$2e2bcd8739ae039).h1`
    padding-bottom: 30px;
    margin-top: 50px;
    margin-bottom: 35px;

    font-family: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.heading};
    font-size: 60px;
    color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.almostBlack};

    border-bottom: 1px solid ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.grayBorder};

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        font-size: 28px;
    `)}

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).large(`
        margin-bottom: 10px;
        margin-top: 10px;
        padding: 0;

        border: none;
    `)}
`;
const $d46d5bb68afd6fcd$export$c6d1ad8c1472a6e0 = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    max-width: 60%;
    margin-bottom: 40px;

    font-family: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.main};
    font-size: 20px;
    color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.almostBlack};

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).large(`
        margin: 0;
        max-width: none;
        font-size: 16px;
        line-height: 1.5;
    `)}
`;
const $d46d5bb68afd6fcd$export$ac7496df4f1f837a = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    position: relative;
    max-width: 500px;
    width: 100%;
`;




var $8NFma = parcelRequire("8NFma");





function $49616a0841218e49$export$63c023c236fcc971() {
    const lfDataService = new (0, $25937fdb26d57abd$export$2e2bcd8739ae039)();
    return (dispatch)=>{
        lfDataService.customerInfo().then((data)=>{
            dispatch($49616a0841218e49$export$ed74cb8dbad54ebf({
                customerInfo: data.customer,
                coinsuredInfo: data.currentCoInsured,
                travelCertificateUrl: lfDataService.generatedTravelCertificateUrl,
                mailSentStatus: false
            }));
            dispatch((0, $67f4b1d2fb7c2244$export$5630fcc02dc02d1b)(false));
        }).catch((e)=>{
            dispatch((0, $67f4b1d2fb7c2244$export$7a8bb273722d5103)(e));
            dispatch((0, $67f4b1d2fb7c2244$export$ea4b4733f4ca2df0)(true));
        });
    };
}
function $49616a0841218e49$export$ed74cb8dbad54ebf(data) {
    return {
        type: 'TRAVEL_CERT_PAGE_LOADED',
        data: data
    };
}
function $49616a0841218e49$export$f2534dc59d65b4d4() {
    const lfDataService = new (0, $25937fdb26d57abd$export$2e2bcd8739ae039)();
    return (dispatch)=>{
        dispatch($49616a0841218e49$export$dc5af9605220832b(false));
        dispatch((0, $67f4b1d2fb7c2244$export$5630fcc02dc02d1b)(true));
        lfDataService.mailTravelCertificate().then((result)=>{
            if (result.success) {
                dispatch($49616a0841218e49$export$dc5af9605220832b(true));
                dispatch((0, $67f4b1d2fb7c2244$export$5630fcc02dc02d1b)(false));
                return;
            }
            dispatch((0, $67f4b1d2fb7c2244$export$5630fcc02dc02d1b)(false));
            dispatch((0, $67f4b1d2fb7c2244$export$7a8bb273722d5103)('kunde inte skicka resebevis'));
            dispatch((0, $67f4b1d2fb7c2244$export$ea4b4733f4ca2df0)(true));
        }).catch((e)=>{
            dispatch((0, $67f4b1d2fb7c2244$export$5630fcc02dc02d1b)(true));
            dispatch((0, $67f4b1d2fb7c2244$export$7a8bb273722d5103)(e));
            dispatch((0, $67f4b1d2fb7c2244$export$ea4b4733f4ca2df0)(true));
        });
    };
}
function $49616a0841218e49$export$dc5af9605220832b(travelCertMailSent) {
    return {
        type: 'TRAVEL_CERT_PAGE_MAIL_SENT_STATUS',
        travelCertMailSent: travelCertMailSent
    };
}









class $1df16087f6936667$var$TravelCertificatePage extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    static get propTypes() {
        return {
            mountRootId: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string.isRequired
        };
    }
    constructor(props){
        super(props);
        this.heading = (0, $e6aeb63e6149c504$export$161fa9a9af21e7de)('heading', this.props.mountRootId);
        this.preamble = (0, $e6aeb63e6149c504$export$161fa9a9af21e7de)('preamble', this.props.mountRootId);
    }
    componentDidMount() {
        this.props.loadData();
    }
    render() {
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($1df16087f6936667$export$e6dfd72ab29f8598, {
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($1df16087f6936667$export$a8a3e93435678ff9, {
                    children: this.heading
                }),
                !this.props.hasErrored && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($1df16087f6936667$export$c6d1ad8c1472a6e0, {
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $96c25128201e5f07$export$2e2bcd8739ae039), {
                        children: this.preamble
                    })
                }),
                this.props.hasErrored && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $19ac445fff8f1f3a$export$2e2bcd8739ae039), {
                    message: `Ooops! Ett fel har uppst\xe5tt: ${typeof this.props.error === 'string' ? this.props.error : this.props.error.message}`
                }),
                this.props.isLoading && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $492d68823d70b95b$export$2e2bcd8739ae039), {
                    color: (0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.blueBackground
                }),
                !this.props.isLoading && !this.props.hasErrored && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($1df16087f6936667$export$6dc9c7a2fd68ee6d, {
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($1df16087f6936667$export$d53c836cccbb0d90, {
                            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $3dd5c3afc4410032$export$29d11c0fe2fc51d8), {
                                href: this.props.data.travelCertificateUrl,
                                target: "_blank",
                                download: true,
                                children: "Ladda ner reseskydd"
                            })
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($1df16087f6936667$export$d53c836cccbb0d90, {
                            children: [
                                !this.props.data.travelCertMailSent && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $3dd5c3afc4410032$export$cfc7921d29ef7b80), {
                                    onClick: this.props.mailTravelCert,
                                    children: [
                                        "Maila reseskydd till ",
                                        this.props.data.customerInfo.emailAddress
                                    ]
                                }),
                                this.props.data.travelCertMailSent && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("strong", {
                                    children: [
                                        "Ditt reseskydd har skickats till ",
                                        this.props.data.customerInfo.emailAddress,
                                        ". Trevlig resa!"
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
}
// state
const $1df16087f6936667$var$mapStateToProps = (state)=>{
    return {
        data: state.travelCertPageData,
        hasErrored: state.pageHasErrored,
        error: state.pageError,
        isLoading: state.pageIsLoading
    };
};
const $1df16087f6936667$var$mapDispatchToProps = (dispatch)=>{
    return {
        loadData: ()=>dispatch((0, $49616a0841218e49$export$63c023c236fcc971)()),
        mailTravelCert: ()=>dispatch((0, $49616a0841218e49$export$f2534dc59d65b4d4)())
    };
};
var $1df16087f6936667$export$2e2bcd8739ae039 = (0, $5a4066412ccab0c1$export$64605811ab45167f)($1df16087f6936667$var$mapStateToProps, $1df16087f6936667$var$mapDispatchToProps)($1df16087f6936667$var$TravelCertificatePage);
const $1df16087f6936667$export$e6dfd72ab29f8598 = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    position: relative;
    margin: 0 0 100px 0;
    padding: 0;

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).custom(`
        padding: 13px;
    `, '1234px')}

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).large(`
        padding: 21px;
    `)}
`;
const $1df16087f6936667$export$a8a3e93435678ff9 = (0, $65e706775ff71837$export$2e2bcd8739ae039).h1`
    padding-bottom: 30px;
    margin-top: 50px;
    margin-bottom: 35px;

    font-family: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.heading};
    font-size: 60px;
    color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.almostBlack};

    border-bottom: 1px solid ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.grayBorder};

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        font-size: 28px;
    `)}

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).large(`
        margin-bottom: 10px;
        margin-top: 10px;
        padding: 0;

        border: none;
    `)}
`;
const $1df16087f6936667$export$c6d1ad8c1472a6e0 = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    max-width: 60%;
    margin-bottom: 20px;

    font-family: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.main};
    font-size: 20px;
    color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.almostBlack};

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).large(`
        max-width: none;
        font-size: 16px;
        line-height: 1.5;
    `)}
`;
const $1df16087f6936667$export$6dc9c7a2fd68ee6d = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    position: relative;
    max-width: 800px;
    width: 100%;
`;
const $1df16087f6936667$export$d53c836cccbb0d90 = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    margin-top: 15px;

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        display: block;
        width: 100%;
        text-align: center;

        margin-top: 20px;
    `)}
`;




var $8NFma = parcelRequire("8NFma");






const $0b70dc5e2f76d9ec$var$defaultResolveTimeout = 1500;
const $0b70dc5e2f76d9ec$var$defaultPurchaseAffiliation = "LF - tecknade f\xf6rs\xe4kringar";
const $0b70dc5e2f76d9ec$var$defaultPurchaseFailedAffiliation = 'LF - misslyckade tecknanden';
let $0b70dc5e2f76d9ec$var$instance = null;
class $0b70dc5e2f76d9ec$export$2e2bcd8739ae039 {
    constructor(){
        if ($0b70dc5e2f76d9ec$var$instance) return $0b70dc5e2f76d9ec$var$instance;
        this.ready = typeof window.dataLayer !== 'undefined' && typeof window.dataLayer.push === 'function';
        $0b70dc5e2f76d9ec$var$instance = {
            trackInsurancePurchase: this.trackInsurancePurchase,
            trackVirtualPageView: this.trackVirtualPageView
        };
        return $0b70dc5e2f76d9ec$var$instance;
    }
    // public 
    trackInsurancePurchase = (orders, memberInfo)=>{
        const completedOrders = [
            ...orders.completed,
            ...orders.pending
        ];
        const failedOrders = orders.failed;
        // split completed and failed orders into new and upgrade categories
        const completedNewOrders = this.filterOrders(completedOrders, (order)=>typeof order.isUpgrade === 'undefined' || !order.isUpgrade);
        const completedUpgradeOrders = this.filterOrders(completedOrders, (order)=>typeof order.isUpgrade !== 'undefined' && order.isUpgrade);
        const failedNewOrders = this.filterOrders(failedOrders, (order)=>typeof order.isUpgrade === 'undefined' || !order.isUpgrade);
        const failedUpgradeOrders = this.filterOrders(failedOrders, (order)=>typeof order.isUpgrade !== 'undefined' && order.isUpgrade);
        const orderId = `${Date.now()}-success`;
        const upgradeOrderId = `${Date.now()}-upgrade-success`;
        const failedOrderId = `${Date.now()}-fail`;
        const upgradeFailedOrderId = `${Date.now()}-upgrade-fail`;
        return Promise.all([
            this.trackInsurancePurchaseCategory(orderId, $0b70dc5e2f76d9ec$var$defaultPurchaseAffiliation, completedNewOrders),
            this.trackInsurancePurchaseCategory(upgradeOrderId, $0b70dc5e2f76d9ec$var$defaultPurchaseAffiliation, completedUpgradeOrders),
            this.trackInsurancePurchaseCategory(failedOrderId, $0b70dc5e2f76d9ec$var$defaultPurchaseFailedAffiliation, failedNewOrders),
            this.trackInsurancePurchaseCategory(upgradeFailedOrderId, $0b70dc5e2f76d9ec$var$defaultPurchaseFailedAffiliation, failedUpgradeOrders)
        ]);
    };
    // NOTE: the "virtualPageView" gtm/mtm event has to be a trigger for a ga page view, also,
    // virtualPageTitle must map to the field "title" and virtualPagePath to the "page" field.
    trackVirtualPageView = this.promisifyWithTimeout((resolve, pageTitle, pagePath)=>{
        if (!this.ready) {
            resolve();
            return;
        }
        dataLayer.push({
            event: 'virtualPageView',
            virtualPageTitle: pageTitle,
            virtualPagePath: pagePath,
            eventCallback: ()=>{
                resolve();
            }
        });
    });
    // private 
    filterOrders(orders, filterFn) {
        return orders.map((groupOrder)=>(Array.isArray(groupOrder.insurances) ? groupOrder.insurances : [
                groupOrder.insurances
            ]).filter((order)=>filterFn(order))).reduce((acc, val)=>val ? acc.concat(val) : acc, []); // flatten final array
    }
    trackInsurancePurchaseCategory = this.promisifyWithTimeout((resolve, orderId, category, orders)=>{
        if (!this.ready || orders.length === 0) {
            resolve();
            return;
        }
        const products = orders.map((order)=>({
                name: order.displayName,
                id: orderId,
                sku: order.insuranceName,
                category: order.groupName,
                quantity: 1,
                price: order.premiumPeriod === 'monthly' ? order.quote : 0
            }));
        const totalRevenue = products.reduce((sum, prod)=>sum + parseFloat(prod.price), 0);
        // push to ga via gtm/mtm
        // NOTE: the "insurancePurchase" event has to be a trigger for a transaction type universal ga tag in gtm/mtm admin!
        dataLayer.push({
            event: 'insurancePurchase',
            transactionId: orderId,
            transactionAffiliation: category,
            transactionTotal: totalRevenue,
            transactionTax: 0,
            transactionShipping: 0,
            transactionProducts: products,
            eventCallback: ()=>{
                resolve();
            }
        });
    });
    // promisify a function with an automatic resolve timeout
    // NOTE: func must provide arg "resolve" as first param (the resolve function) when declared
    // the returned final function accepts all original params except "resolve"!
    promisifyWithTimeout(func) {
        return (...args)=>new Promise((resolve)=>{
                let gaTimeout = setTimeout(()=>{
                    console.warn('[LF] Google analytics transaction timed out or was cancelled');
                    resolve();
                }, $0b70dc5e2f76d9ec$var$defaultResolveTimeout);
                func(()=>{
                    clearTimeout(gaTimeout);
                    resolve();
                }, ...args);
            }).catch((e)=>{
                console.warn('[LF] Error sending Google analytics transaction!');
                console.dir(e);
            });
    }
}




const $7c3038616dbee0e6$export$5af54ce744e65c54 = '__';


function $5f7d48bf7fc39678$export$764ce8bf84d80b6(step) {
    return (dispatch, getState)=>{
        dispatch((0, $67f4b1d2fb7c2244$export$453e7c361a52c908)(step));
    };
}
function $5f7d48bf7fc39678$export$593192119cdc7493() {
    return (dispatch)=>{
        const lfDataService = new (0, $25937fdb26d57abd$export$2e2bcd8739ae039)();
        const lfWebService = new (0, $0f2b98672976a17a$export$2e2bcd8739ae039)();
        dispatch((0, $67f4b1d2fb7c2244$export$5630fcc02dc02d1b)(true));
        Promise.all([
            lfDataService.pensionGuidanceForm(),
            lfDataService.customerInfo()
        ]).then((values)=>{
            let rawData = values.reduce((acc, obj)=>{
                Object.keys(obj).forEach((prop)=>acc[prop] = obj[prop]);
                return acc;
            }, {});
            let { questionGroups: questionGroups, ...data } = rawData;
            if (questionGroups && questionGroups.length) questionGroups.forEach((group, index)=>{
                questionGroups[index] = (0, $36509d2879dd53eb$export$54d7743101979cb1)(group);
            });
            // add base level form inputs from groups
            dispatch($5f7d48bf7fc39678$export$29033efa511d7ede(questionGroups));
            // data
            data.pensionGuidanceFormData = {
                questionGroups: questionGroups
            };
            data.myPagesStartUrl = lfWebService.myPagesStartUrl;
            data.insurancePurchaseUrl = lfWebService.insurancePurchaseUrl();
            dispatch($5f7d48bf7fc39678$export$633dbd460cb0b029(data));
            dispatch((0, $67f4b1d2fb7c2244$export$5630fcc02dc02d1b)(false));
            dispatch($5f7d48bf7fc39678$export$764ce8bf84d80b6(0));
        }).catch((e)=>{
            dispatch((0, $67f4b1d2fb7c2244$export$7a8bb273722d5103)(e));
            dispatch((0, $67f4b1d2fb7c2244$export$ea4b4733f4ca2df0)(true));
            if (window._bazDebug) throw e;
        });
    };
}
function $5f7d48bf7fc39678$export$633dbd460cb0b029(data) {
    return {
        type: 'PENSION_GUIDANCE_DECLARATION_DATA_LOADED',
        pensionGuidancePageData: data
    };
}
function $5f7d48bf7fc39678$export$289f035e1c193ca3() {
    const lfDataService = new (0, $25937fdb26d57abd$export$2e2bcd8739ae039)();
    const lfWebService = new (0, $0f2b98672976a17a$export$2e2bcd8739ae039)();
    return (dispatch, getState)=>{
        const { pageCurrentStep: pageCurrentStep, pensionGuidancePageData: pensionGuidancePageData, pensionGuidanceFormInputs: pensionGuidanceFormInputs } = getState();
        const personId = pensionGuidancePageData.customer.personId;
        const answers = Object.keys(pensionGuidanceFormInputs).filter((k)=>pensionGuidanceFormInputs[k].valid && pensionGuidanceFormInputs[k].postable).map((k)=>({
                questionId: k,
                answer: pensionGuidanceFormInputs[k].value,
                // parse repetition count from id:
                // normal question id: '14dc0a49e0f44453b2d24feb9b4106e0'
                // first repetition id: '14dc0a49e0f44453b2d24feb9b4106e0__1'
                // the first repetition of the question (the second occurence)
                // will have an index-suffixed id
                repetition: k.indexOf((0, $7c3038616dbee0e6$export$5af54ce744e65c54)) > -1 ? parseInt(k.slice(k.indexOf((0, $7c3038616dbee0e6$export$5af54ce744e65c54)) + (0, $7c3038616dbee0e6$export$5af54ce744e65c54).length, k.length)) : undefined
            }));
        const postData = {
            personId: personId,
            answers: answers
        };
        lfDataService.submitPensionGuidance(postData).then((data)=>{
            if (!data.success) throw "det gick inte att skicka in dina svar - var v\xe4nlig f\xf6rs\xf6k igen senare";
            dispatch($5f7d48bf7fc39678$export$764ce8bf84d80b6(pageCurrentStep + 1));
            dispatch((0, $67f4b1d2fb7c2244$export$5630fcc02dc02d1b)(false));
        }).catch((error)=>{
            dispatch((0, $67f4b1d2fb7c2244$export$7a8bb273722d5103)(error));
            dispatch((0, $67f4b1d2fb7c2244$export$ea4b4733f4ca2df0)(true));
        });
    };
}
function $5f7d48bf7fc39678$export$29033efa511d7ede(questionGroup, nestLev = 0, maxLev = 2) {
    return (dispatch, getState)=>{
        const { pensionGuidanceFormInputs: pensionGuidanceFormInputs } = getState();
        const addInputs = (questionGroup, nestLevel, maxLevel, ignoreNestLevel = false)=>{
            if (!ignoreNestLevel && nestLevel === maxLevel) return;
            questionGroup.forEach((group)=>{
                group.questions.forEach((question)=>{
                    if (!(question.id in pensionGuidanceFormInputs)) {
                        dispatch($5f7d48bf7fc39678$export$16d7062e15973a98(question));
                        dispatch($5f7d48bf7fc39678$export$5d17e1bcfe4a6223(question.id, !question.isUneditable));
                        if (question.subQuestionGroup) {
                            const toggleGroupOnValue = question.questionType === 'Radio' ? question.options.filter((option)=>option.togglesSubQuestionGroup).reduce((_, option)=>option.text, null) : null;
                            if (question.value === toggleGroupOnValue || question.questionType !== 'Radio') addInputs([
                                question.subQuestionGroup
                            ], nestLevel + 1, maxLevel);
                        }
                    }
                });
                if (group.subQuestionGroups && group.subQuestionGroups.length) addInputs(group.subQuestionGroups, nestLevel + 1, maxLevel);
            });
        };
        addInputs(questionGroup, nestLev, maxLev);
    };
}
function $5f7d48bf7fc39678$export$9db56972f3fa02fa(questionGroup, nestLev = 0, maxLev = 2) {
    return (dispatch)=>{
        const removeInputs = (questionGroup, nestLevel, maxLevel)=>{
            if (nestLevel === maxLevel) return;
            questionGroup.forEach((group)=>{
                group.questions.forEach((question)=>{
                    dispatch($5f7d48bf7fc39678$export$58ee132a5c20b005(question.id));
                    if (question.subQuestionGroup) removeInputs([
                        question.subQuestionGroup
                    ], nestLevel + 1, maxLevel);
                });
                if (group.subQuestionGroups.length) removeInputs(group.subQuestionGroups, nestLevel + 1, maxLevel);
            });
        };
        removeInputs(questionGroup, nestLev, maxLev);
    };
}
function $5f7d48bf7fc39678$export$671bb340aac9ce17(questionGroup) {
    const questionGroupId = questionGroup.id;
    return (dispatch, getState)=>{
        const { pensionGuidanceRepeatedInputs: pensionGuidanceRepeatedInputs } = getState();
        const currentRepeatCount = questionGroupId in pensionGuidanceRepeatedInputs ? pensionGuidanceRepeatedInputs[questionGroupId] + 1 : 1;
        questionGroup.questions.forEach((question)=>{
            let repeatedQuestion = {
                ...question,
                id: `${question.id}${(0, $7c3038616dbee0e6$export$5af54ce744e65c54)}${currentRepeatCount}`
            };
            dispatch($5f7d48bf7fc39678$export$16d7062e15973a98(repeatedQuestion, true));
        });
        dispatch($5f7d48bf7fc39678$export$175a59ec0259572(questionGroupId));
    };
}
function $5f7d48bf7fc39678$export$852745b4351040cd(questionGroup, repeatableCountIndex) {
    const questionGroupId = questionGroup.id;
    const questionIds = questionGroup.questions.map((q)=>q.id);
    return (dispatch, getState)=>{
        questionIds.forEach((questionId)=>{
            dispatch($5f7d48bf7fc39678$export$58ee132a5c20b005(`${questionId}${(0, $7c3038616dbee0e6$export$5af54ce744e65c54)}${repeatableCountIndex}`));
        });
        dispatch($5f7d48bf7fc39678$export$16fd17ec4777f728(questionGroupId));
        dispatch($5f7d48bf7fc39678$export$e1486b03ba56df60(questionGroup));
    };
}
function $5f7d48bf7fc39678$export$e1486b03ba56df60(questionGroup) {
    return (dispatch, getState)=>{
        const { pensionGuidanceFormInputs: pensionGuidanceFormInputs, pensionGuidanceRepeatedInputs: pensionGuidanceRepeatedInputs } = getState();
        const questionGroupId = questionGroup.id;
        const repeatableCounter = pensionGuidanceRepeatedInputs[questionGroupId];
        const questionIds = questionGroup.questions.map((q)=>q.id);
        const groupInputFormsKeys = {};
        const groupInputFormsValues = {};
        questionIds.forEach((questionId)=>{
            groupInputFormsKeys[questionId] = [];
            groupInputFormsValues[questionId] = [];
            Object.keys(pensionGuidanceFormInputs).forEach(function(key, index) {
                const questionIdKeyPrefix = `${questionId}${(0, $7c3038616dbee0e6$export$5af54ce744e65c54)}`;
                if (key.startsWith(questionIdKeyPrefix)) {
                    groupInputFormsKeys[questionId].push(key);
                    groupInputFormsValues[questionId].push(pensionGuidanceFormInputs[key]);
                }
            });
            groupInputFormsKeys[questionId].forEach((key)=>{
                dispatch($5f7d48bf7fc39678$export$58ee132a5c20b005(key));
                delete pensionGuidanceFormInputs[key];
            });
            groupInputFormsKeys[questionId].sort();
            groupInputFormsKeys[questionId].forEach((repeatedQuestionId, index)=>{
                const value = groupInputFormsValues[questionId].find((q)=>q.id === repeatedQuestionId);
                const repeatableIndex = index + 1;
                const newKey = `${questionId}${(0, $7c3038616dbee0e6$export$5af54ce744e65c54)}${repeatableIndex}`;
                value.id = newKey;
                dispatch($5f7d48bf7fc39678$export$16d7062e15973a98(value));
            });
        });
    };
}
function $5f7d48bf7fc39678$export$16fd17ec4777f728(groupId) {
    return {
        type: 'PENSION_GUIDANCE_REMOVE_REPEAT_FORM_INPUT',
        groupId: groupId
    };
}
function $5f7d48bf7fc39678$export$175a59ec0259572(groupId) {
    return {
        type: 'PENSION_GUIDANCE_REPEAT_FORM_INPUT',
        groupId: groupId
    };
}
function $5f7d48bf7fc39678$export$a5a3746997a283b1(data) {
    return {
        type: 'PENSION_GUIDANCE_FORM_DATA_UPDATED',
        pensionGuidanceFormData: data
    };
}
function $5f7d48bf7fc39678$export$16d7062e15973a98(question, isActive = false) {
    return (dispatch)=>{
        const hasValue = typeof question.value !== 'undefined' && question.value;
        const isUneditable = question.isUneditable;
        const isRequired = question.required || question.questionType == 'Radio';
        dispatch($5f7d48bf7fc39678$export$bab0156a8ba9b212({
            id: question.id,
            questionText: question.questionText,
            value: hasValue ? question.value : '',
            required: isRequired,
            active: isActive,
            valid: hasValue || !isRequired || isUneditable ? true : false,
            touched: hasValue ? true : false,
            postable: !isUneditable
        }));
    };
}
function $5f7d48bf7fc39678$export$58ee132a5c20b005(questionId) {
    return {
        type: 'PENSION_GUIDANCE_FORM_INPUT_REMOVED',
        questionId: questionId
    };
}
function $5f7d48bf7fc39678$export$5d17e1bcfe4a6223(questionId, status) {
    return (dispatch, getState)=>{
        const { pensionGuidanceFormInputs: pensionGuidanceFormInputs } = getState();
        dispatch($5f7d48bf7fc39678$export$bab0156a8ba9b212({
            ...pensionGuidanceFormInputs[questionId],
            active: status
        }));
    };
}
function $5f7d48bf7fc39678$export$4723e7a828d2768d(questionId, value, validator) {
    return (dispatch, getState)=>{
        const { pensionGuidanceFormInputs: pensionGuidanceFormInputs } = getState();
        const currentInput = pensionGuidanceFormInputs[questionId];
        dispatch($5f7d48bf7fc39678$export$bab0156a8ba9b212({
            ...currentInput,
            value: value,
            active: true
        }));
        dispatch($5f7d48bf7fc39678$export$fe99ccfc3914bd08(questionId, validator, currentInput.touched));
    };
}
function $5f7d48bf7fc39678$export$bab0156a8ba9b212(inputData) {
    return {
        type: 'PENSION_GUIDANCE_FORM_INPUT_UPDATED',
        inputData: inputData
    };
}
function $5f7d48bf7fc39678$export$fe99ccfc3914bd08(questionId, validator, touched = true) {
    return (dispatch, getState)=>{
        const { pensionGuidanceFormInputs: pensionGuidanceFormInputs } = getState();
        const currentInput = pensionGuidanceFormInputs[questionId];
        const questionValue = currentInput.value;
        let valid = true;
        if (typeof validator === 'function' && currentInput.value != null && currentInput.value != '') valid = typeof validator(questionValue) === 'undefined'; // see rules.jsx
        else if (currentInput.required) valid = questionValue != null && questionValue !== '';
        dispatch($5f7d48bf7fc39678$export$bab0156a8ba9b212({
            ...currentInput,
            touched: touched,
            valid: valid
        }));
        dispatch($5f7d48bf7fc39678$export$b5e4d51f623d4fff()); // update global valid/invalid form status
    };
}
function $5f7d48bf7fc39678$export$6fb56587caafb4c4() {
    return (dispatch, getState)=>{
        const { pensionGuidanceFormInputs: pensionGuidanceFormInputs } = getState();
        Object.keys(pensionGuidanceFormInputs).forEach((questionId)=>{
            const currentInput = pensionGuidanceFormInputs[questionId];
            if (currentInput.active && !currentInput.touched) dispatch($5f7d48bf7fc39678$export$bab0156a8ba9b212({
                ...currentInput,
                touched: true
            }));
        });
    };
}
function $5f7d48bf7fc39678$export$b5e4d51f623d4fff() {
    return (dispatch, getState)=>{
        const { pensionGuidanceFormInputs: pensionGuidanceFormInputs } = getState();
        let invalidInputs = Object.keys(pensionGuidanceFormInputs).map((key)=>pensionGuidanceFormInputs[key]).filter((input)=>input.active && !input.valid);
        dispatch($5f7d48bf7fc39678$export$46391c8f85452741(invalidInputs.length == 0));
    };
}
function $5f7d48bf7fc39678$export$46391c8f85452741(bool) {
    return {
        type: 'PENSION_GUIDANCE_FORM_STATUS',
        valid: bool
    };
}










var $8NFma = parcelRequire("8NFma");





class $9ebfac828c61691f$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    constructor(props){
        super(props);
    }
    static get propTypes() {
        return {
            stepLabels: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).array.isRequired,
            activeStep: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).number.isRequired,
            textColor: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
            noHeading: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).bool,
            responsiveHideStepOne: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).bool,
            fadeOutOnLastStep: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).bool,
            hideDescOnResp: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).bool,
            edgeMargin: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).bool,
            noMobilePadding: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).bool,
            clickableSteps: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).bool,
            onStepClick: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func
        };
    }
    render() {
        const steps = this.props.stepLabels;
        const noOfSteps = this.props.stepCount;
        const activeStep = this.props.activeStep || 0;
        const hideOnResponsive = typeof this.props.hideDescOnResp !== 'undefined' ? this.props.hideDescOnResp : false;
        const edgeMargin = typeof this.props.edgeMargin !== 'undefined' ? this.props.edgeMargin : false;
        const clickableSteps = typeof this.props.clickableSteps !== 'undefined' ? this.props.clickableSteps : false;
        const onStepClick = this.props.onStepClick;
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($9ebfac828c61691f$var$BarWrapper, {
            noMobilePadding: this.props.noMobilePadding,
            responsiveHideStepOne: this.props.responsiveHideStepOne,
            fadeOutOnLastStep: this.props.fadeOutOnLastStep,
            noOfSteps: noOfSteps,
            activeStep: activeStep,
            children: [
                ...Array(noOfSteps)
            ].map((_, step)=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($9ebfac828c61691f$var$SectionStatus, {
                    noOfSteps: noOfSteps,
                    textColor: this.props.textColor,
                    completed: activeStep > step ? true : false,
                    active: activeStep == step ? true : false,
                    edgeMargin: edgeMargin,
                    clickableSteps: clickableSteps && step < activeStep,
                    onClick: clickableSteps && step < activeStep ? ()=>onStepClick(step) : undefined,
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($9ebfac828c61691f$var$Step, {
                            children: [
                                "Steg ",
                                parseInt(step) + 1
                            ]
                        }),
                        steps.length > 0 && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($9ebfac828c61691f$var$StepDescription, {
                            hideOnResponsive: hideOnResponsive,
                            children: steps[step]
                        })
                    ]
                }, step))
        });
    }
}
// exclude props from being passed to the DOM
const $9ebfac828c61691f$var$barPropsToExclude = [
    'responsiveHideStepOne',
    'fadeOutOnLastStep',
    'activeStep',
    'noOfSteps',
    'noMobilePadding'
];
const $9ebfac828c61691f$var$BarWrapper = (0, $65e706775ff71837$export$2e2bcd8739ae039).div.withConfig({
    shouldForwardProp: (prop)=>!$9ebfac828c61691f$var$barPropsToExclude.includes(prop)
})`
    position: relative;
    width: 100%;

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).custom(`
        padding: 0px 17px;
    `, '1234px')}

    ${(props)=>props.noMobilePadding ? `
        ${(0, $45d1242a07988139$export$8f880b6e390052fa).xsmall(`
            padding: 0px;
        `)}
    ` : ``}
    

    transition: ${(props)=>props.fadeOutOnLastStep ? 'max-height 350ms ease-out, opacity 350ms ease-out' : 'none'};

    ${(props)=>props.fadeOutOnLastStep && props.activeStep == props.noOfSteps ? `
        opacity: 0;
        overflow: hidden;
        max-height: 0;
    ` : `
        opacity: 1;
        overflow: auto;
        max-height: 300px;
    `}

    ${(props)=>(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        transition: ${props.responsiveHideStepOne ? 'max-height 350ms ease-out, opacity 350ms ease-out' : 'none'};

        ${props.responsiveHideStepOne && props.activeStep == 0 ? `
            opacity: 0;
            overflow: hidden;
            max-height: 0;
        ` : `
            opacity: 1;
            overflow: auto;
            max-height: 300px;
        `}
    `)}
`;
const $9ebfac828c61691f$var$sectionMargin = 26;
const $9ebfac828c61691f$var$responsiveRowCount = 2;
// exclude props from being passed to the DOM
const $9ebfac828c61691f$var$sectionPropsToExclude = [
    'noOfSteps',
    'completed',
    'edgeMargin',
    'active',
    'textColor',
    'clickableSteps'
];
const $9ebfac828c61691f$var$SectionStatus = (0, $65e706775ff71837$export$2e2bcd8739ae039).div.withConfig({
    shouldForwardProp: (prop)=>!$9ebfac828c61691f$var$sectionPropsToExclude.includes(prop)
})`
    position: relative;
    display: inline-block;

    padding: 20px 20px 20px ${(props)=>props.completed ? '20px' : '0'};

    ${(props)=>props.clickableSteps && 'cursor: pointer;'}

    ${(props)=>props.edgeMargin ? `
        width: calc(${100 / (props.noOfSteps + 0.01)}% - ${$9ebfac828c61691f$var$sectionMargin}px);
        margin-left: ${$9ebfac828c61691f$var$sectionMargin / 2}px;
        margin-right: ${$9ebfac828c61691f$var$sectionMargin / 2}px;
    ` : `
        width: calc(${100 / (props.noOfSteps + 0.01)}% - ${$9ebfac828c61691f$var$sectionMargin}px + ${$9ebfac828c61691f$var$sectionMargin / props.noOfSteps}px);
        &:not(:first-of-type) {
            margin-left: ${$9ebfac828c61691f$var$sectionMargin / 2}px;
        }

        &:not(:last-of-type) {
            margin-right: ${$9ebfac828c61691f$var$sectionMargin / 2}px;
        }
    `};

    // two rows

    ${(props)=>props.noOfSteps > 3 ? (0, $45d1242a07988139$export$8f880b6e390052fa).custom(`
        width: calc(${100 / parseInt(props.noOfSteps + 0.01) * $9ebfac828c61691f$var$responsiveRowCount}% - ${$9ebfac828c61691f$var$sectionMargin / 2}px);
        padding: 8px 10px 8px 8px;
        margin: ${$9ebfac828c61691f$var$sectionMargin / 4}px ${$9ebfac828c61691f$var$sectionMargin / 4}px 0 ${$9ebfac828c61691f$var$sectionMargin / 4}px;

        &:first-of-type {
            margin-top: 25px;
        }
    `, '550px') : ''};

    ${(props)=>props.noOfSteps > 4 ? (0, $45d1242a07988139$export$8f880b6e390052fa).custom(`
        width: calc(${100 / parseInt(props.noOfSteps + 0.01) * $9ebfac828c61691f$var$responsiveRowCount}% - ${$9ebfac828c61691f$var$sectionMargin / 2}px);
        padding: 8px 10px 8px 8px;
        margin: ${$9ebfac828c61691f$var$sectionMargin / 4}px ${$9ebfac828c61691f$var$sectionMargin / 4}px 0 ${$9ebfac828c61691f$var$sectionMargin / 4}px;

        &:first-of-type {
            margin-top: 25px;
        }
    `, '1200px') : ''};

    border-bottom: 4px solid ${(props)=>props.active ? (0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.greenFifty : !props.active && !props.completed ? (0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.grayBorder : 'transparent'};
    background-color: ${(props)=>props.completed ? (0, (/*@__PURE__*/$parcel$interopDefault($5e6a62740b68988a$exports)))((0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.green, 0.5) : 'transparent'};

    transition: all 300ms ease-out;

    font-family: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.heading};
    font-size: 18px;
    font-weight: bold;
    color: ${(props)=>props.textColor ? props.textColor : 'black'};
    text-align: left;

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).medium(`
        font-size: 18px;
    `)};

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        font-size: 16px;
        padding: 8px 10px 8px 0px;
    `)};

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).custom(`
        font-size: 12px;
    `, '362px')};

    ${(props)=>props.completed ? `
        color: white;
        ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
            font-size: 16px;
            padding: 8px 10px 8px 8px;
        `)};
    ` : ''};

    ${(props)=>props.completed ? `
        &:after {
            position: absolute;

            ${(0, $45d1242a07988139$export$74300498d1a9477c).checkCircle()};
            right: 10%;
            top: 50%;
            transform: translateY(-50%);

            color: white;

            ${(0, $45d1242a07988139$export$8f880b6e390052fa).xxsmall(`
                right: 5px;
                font-size: 12px;
            `)}

            ${(0, $45d1242a07988139$export$8f880b6e390052fa).custom(`
                display: none;
            `, '420px')}

            ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
                right: 15px;
                font-size: 14px;
            `)}

            ${(0, $45d1242a07988139$export$8f880b6e390052fa).medium(`
                right: 10px;
            `)}
        }
    ` : ''};

`;
const $9ebfac828c61691f$var$Step = (0, $65e706775ff71837$export$2e2bcd8739ae039).span`
    display: block;
    width: 100%;

    font-family: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.heading};
    font-size: 18px;
    font-weight: 600;
    line-height: 1.2;
    white-space: nowrap;

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        font-size: 14px;
    `)}
`;
// exclude props from being passed to the DOM
const $9ebfac828c61691f$var$stepPropsToExclude = [
    'hideOnResponsive'
];
const $9ebfac828c61691f$var$StepDescription = (0, $65e706775ff71837$export$2e2bcd8739ae039).span.withConfig({
    shouldForwardProp: (prop)=>!$9ebfac828c61691f$var$stepPropsToExclude.includes(prop)
})`
    font-family: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.main};

    display:inline-block;
    ${(props)=>props.hideOnResponsive ? `
        ${(0, $45d1242a07988139$export$8f880b6e390052fa).custom(`
            display: none;
        `, '810px')}
    ` : ''}
`;




var $8NFma = parcelRequire("8NFma");



var $8NFma = parcelRequire("8NFma");

var $8NFma = parcelRequire("8NFma");

var $8NFma = parcelRequire("8NFma");

function $14f305aae9b1bfc7$export$80c2a3957bcb42ea() {
    const isMounted = (0, $8NFma.useRef)(false);
    (0, $ba41941b3a1a751e$export$700979bc83e7db82)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return isMounted;
}



function $3eff18a1a8a44896$export$91db9bc4f8ac944a() {
    const isMounted = (0, $14f305aae9b1bfc7$export$80c2a3957bcb42ea)();
    const [forcedRenderCount, setForcedRenderCount] = (0, $8NFma.useState)(0);
    const forceRender = (0, $8NFma.useCallback)(()=>{
        isMounted.current && setForcedRenderCount(forcedRenderCount + 1);
    }, [
        forcedRenderCount
    ]);
    /**
     * Defer this to the end of the next animation frame in case there are multiple
     * synchronous calls.
     */ const deferredForceRender = (0, $8NFma.useCallback)(()=>(0, $1abd9a21e276f8f7$export$2cef06c20297c17d).postRender(forceRender), [
        forceRender
    ]);
    return [
        deferredForceRender,
        forcedRenderCount
    ];
}




var $8NFma = parcelRequire("8NFma");



var $8NFma = parcelRequire("8NFma");
/**
 * Measurement functionality has to be within a separate component
 * to leverage snapshot lifecycle.
 */ class $eec08e6c3a0b9bac$var$PopChildMeasure extends $8NFma.Component {
    getSnapshotBeforeUpdate(prevProps) {
        const element = this.props.childRef.current;
        if (element && prevProps.isPresent && !this.props.isPresent) {
            const size = this.props.sizeRef.current;
            size.height = element.offsetHeight || 0;
            size.width = element.offsetWidth || 0;
            size.top = element.offsetTop;
            size.left = element.offsetLeft;
        }
        return null;
    }
    /**
     * Required with getSnapshotBeforeUpdate to stop React complaining.
     */ componentDidUpdate() {}
    render() {
        return this.props.children;
    }
}
function $eec08e6c3a0b9bac$export$1d6cdde0c6816c6d({ children: children, isPresent: isPresent }) {
    const id = (0, $8NFma.useId)();
    const ref = (0, $8NFma.useRef)(null);
    const size = (0, $8NFma.useRef)({
        width: 0,
        height: 0,
        top: 0,
        left: 0
    });
    /**
     * We create and inject a style block so we can apply this explicit
     * sizing in a non-destructive manner by just deleting the style block.
     *
     * We can't apply size via render as the measurement happens
     * in getSnapshotBeforeUpdate (post-render), likewise if we apply the
     * styles directly on the DOM node, we might be overwriting
     * styles set via the style prop.
     */ (0, $8NFma.useInsertionEffect)(()=>{
        const { width: width, height: height, top: top, left: left } = size.current;
        if (isPresent || !ref.current || !width || !height) return;
        ref.current.dataset.motionPopId = id;
        const style = document.createElement("style");
        document.head.appendChild(style);
        if (style.sheet) style.sheet.insertRule(`
          [data-motion-pop-id="${id}"] {
            position: absolute !important;
            width: ${width}px !important;
            height: ${height}px !important;
            top: ${top}px !important;
            left: ${left}px !important;
          }
        `);
        return ()=>{
            document.head.removeChild(style);
        };
    }, [
        isPresent
    ]);
    return $8NFma.createElement($eec08e6c3a0b9bac$var$PopChildMeasure, {
        isPresent: isPresent,
        childRef: ref,
        sizeRef: size
    }, $8NFma.cloneElement(children, {
        ref: ref
    }));
}


const $289f4baefd8e1643$export$979daf65881a382a = ({ children: children, initial: initial, isPresent: isPresent, onExitComplete: onExitComplete, custom: custom, presenceAffectsLayout: presenceAffectsLayout, mode: mode })=>{
    const presenceChildren = (0, $d40915b962da1eaf$export$fe4300aa8eebea86)($289f4baefd8e1643$var$newChildrenMap);
    const id = (0, $8NFma.useId)();
    const context = (0, $8NFma.useMemo)(()=>({
            id: id,
            initial: initial,
            isPresent: isPresent,
            custom: custom,
            onExitComplete: (childId)=>{
                presenceChildren.set(childId, true);
                for (const isComplete of presenceChildren.values()){
                    if (!isComplete) return; // can stop searching when any is incomplete
                }
                onExitComplete && onExitComplete();
            },
            register: (childId)=>{
                presenceChildren.set(childId, false);
                return ()=>presenceChildren.delete(childId);
            }
        }), /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */ presenceAffectsLayout ? undefined : [
        isPresent
    ]);
    (0, $8NFma.useMemo)(()=>{
        presenceChildren.forEach((_, key)=>presenceChildren.set(key, false));
    }, [
        isPresent
    ]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */ $8NFma.useEffect(()=>{
        !isPresent && !presenceChildren.size && onExitComplete && onExitComplete();
    }, [
        isPresent
    ]);
    if (mode === "popLayout") children = $8NFma.createElement((0, $eec08e6c3a0b9bac$export$1d6cdde0c6816c6d), {
        isPresent: isPresent
    }, children);
    return $8NFma.createElement((0, $7a24fabcbe07cfd9$export$f224e4635b6f8ce2).Provider, {
        value: context
    }, children);
};
function $289f4baefd8e1643$var$newChildrenMap() {
    return new Map();
}





var $8NFma = parcelRequire("8NFma");
function $fb5108ff768a1bd0$export$f3a192d0cbd30b96(callback) {
    return (0, $8NFma.useEffect)(()=>()=>callback(), []);
}



const $9b0ae67beb2269f5$var$getChildKey = (child)=>child.key || "";
function $9b0ae67beb2269f5$var$updateChildLookup(children, allChildren) {
    children.forEach((child)=>{
        const key = $9b0ae67beb2269f5$var$getChildKey(child);
        allChildren.set(key, child);
    });
}
function $9b0ae67beb2269f5$var$onlyElements(children) {
    const filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    (0, $8NFma.Children).forEach(children, (child)=>{
        if ((0, $8NFma.isValidElement)(child)) filtered.push(child);
    });
    return filtered;
}
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */ const $9b0ae67beb2269f5$export$3ae376d12526dd6f = ({ children: children, custom: custom, initial: initial = true, onExitComplete: onExitComplete, exitBeforeEnter: exitBeforeEnter, presenceAffectsLayout: presenceAffectsLayout = true, mode: mode = "sync" })=>{
    (0, $bcebfc2a15d8948d$export$f5708dca728d7177)(!exitBeforeEnter, "Replace exitBeforeEnter with mode='wait'");
    // We want to force a re-render once all exiting animations have finished. We
    // either use a local forceRender function, or one from a parent context if it exists.
    const forceRender = (0, $8NFma.useContext)((0, $1af765e09ca06198$export$a3579ca508007a95)).forceRender || (0, $3eff18a1a8a44896$export$91db9bc4f8ac944a)()[0];
    const isMounted = (0, $14f305aae9b1bfc7$export$80c2a3957bcb42ea)();
    // Filter out any children that aren't ReactElements. We can only track ReactElements with a props.key
    const filteredChildren = $9b0ae67beb2269f5$var$onlyElements(children);
    let childrenToRender = filteredChildren;
    const exitingChildren = (0, $8NFma.useRef)(new Map()).current;
    // Keep a living record of the children we're actually rendering so we
    // can diff to figure out which are entering and exiting
    const presentChildren = (0, $8NFma.useRef)(childrenToRender);
    // A lookup table to quickly reference components by key
    const allChildren = (0, $8NFma.useRef)(new Map()).current;
    // If this is the initial component render, just deal with logic surrounding whether
    // we play onMount animations or not.
    const isInitialRender = (0, $8NFma.useRef)(true);
    (0, $ba41941b3a1a751e$export$700979bc83e7db82)(()=>{
        isInitialRender.current = false;
        $9b0ae67beb2269f5$var$updateChildLookup(filteredChildren, allChildren);
        presentChildren.current = childrenToRender;
    });
    (0, $fb5108ff768a1bd0$export$f3a192d0cbd30b96)(()=>{
        isInitialRender.current = true;
        allChildren.clear();
        exitingChildren.clear();
    });
    if (isInitialRender.current) return $8NFma.createElement($8NFma.Fragment, null, childrenToRender.map((child)=>$8NFma.createElement((0, $289f4baefd8e1643$export$979daf65881a382a), {
            key: $9b0ae67beb2269f5$var$getChildKey(child),
            isPresent: true,
            initial: initial ? undefined : false,
            presenceAffectsLayout: presenceAffectsLayout,
            mode: mode
        }, child)));
    // If this is a subsequent render, deal with entering and exiting children
    childrenToRender = [
        ...childrenToRender
    ];
    // Diff the keys of the currently-present and target children to update our
    // exiting list.
    const presentKeys = presentChildren.current.map($9b0ae67beb2269f5$var$getChildKey);
    const targetKeys = filteredChildren.map($9b0ae67beb2269f5$var$getChildKey);
    // Diff the present children with our target children and mark those that are exiting
    const numPresent = presentKeys.length;
    for(let i = 0; i < numPresent; i++){
        const key = presentKeys[i];
        if (targetKeys.indexOf(key) === -1 && !exitingChildren.has(key)) exitingChildren.set(key, undefined);
    }
    // If we currently have exiting children, and we're deferring rendering incoming children
    // until after all current children have exiting, empty the childrenToRender array
    if (mode === "wait" && exitingChildren.size) childrenToRender = [];
    // Loop through all currently exiting components and clone them to overwrite `animate`
    // with any `exit` prop they might have defined.
    exitingChildren.forEach((component, key)=>{
        // If this component is actually entering again, early return
        if (targetKeys.indexOf(key) !== -1) return;
        const child = allChildren.get(key);
        if (!child) return;
        const insertionIndex = presentKeys.indexOf(key);
        let exitingComponent = component;
        if (!exitingComponent) {
            const onExit = ()=>{
                allChildren.delete(key);
                exitingChildren.delete(key);
                // Remove this child from the present children
                const removeIndex = presentChildren.current.findIndex((presentChild)=>presentChild.key === key);
                presentChildren.current.splice(removeIndex, 1);
                // Defer re-rendering until all exiting children have indeed left
                if (!exitingChildren.size) {
                    presentChildren.current = filteredChildren;
                    if (isMounted.current === false) return;
                    forceRender();
                    onExitComplete && onExitComplete();
                }
            };
            exitingComponent = $8NFma.createElement((0, $289f4baefd8e1643$export$979daf65881a382a), {
                key: $9b0ae67beb2269f5$var$getChildKey(child),
                isPresent: false,
                onExitComplete: onExit,
                custom: custom,
                presenceAffectsLayout: presenceAffectsLayout,
                mode: mode
            }, child);
            exitingChildren.set(key, exitingComponent);
        }
        childrenToRender.splice(insertionIndex, 0, exitingComponent);
    });
    // Add `MotionContext` even to children that don't need it to ensure we're rendering
    // the same tree between renders
    childrenToRender = childrenToRender.map((child)=>{
        const key = child.key;
        return exitingChildren.has(key) ? child : $8NFma.createElement((0, $289f4baefd8e1643$export$979daf65881a382a), {
            key: $9b0ae67beb2269f5$var$getChildKey(child),
            isPresent: true,
            presenceAffectsLayout: presenceAffectsLayout,
            mode: mode
        }, child);
    });
    return $8NFma.createElement($8NFma.Fragment, null, exitingChildren.size ? childrenToRender : childrenToRender.map((child)=>(0, $8NFma.cloneElement)(child)));
};



class $cd1ec0cc88bc8751$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    constructor(props){
        super(props);
    }
    static get propTypes() {
        return {
            sectionId: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).number.isRequired
        };
    }
    willLeave = ()=>({
            opacity: spring(0, {
                stiffness: 390,
                damping: 31
            }),
            translateLeft: spring(-1000, {
                stiffness: 390,
                damping: 31
            }),
            maxHeight: spring(0, {
                stiffness: 390,
                damping: 31
            }),
            position: 0
        });
    willEnter = ()=>({
            opacity: 0,
            translateLeft: 1000,
            maxHeight: 3000,
            position: 1
        });
    getStyles = ()=>({
            opacity: spring(1),
            translateLeft: spring(0),
            maxHeight: spring(3000),
            position: spring(1)
        });
    getInterpolatedStyles = (style)=>({
            opacity: style.opacity,
            // disable transform when done, otherwise interferes with children positioned as fixed, see: 
            // https://stackoverflow.com/questions/25824749/why-webkit-transform-translate3d0-0-0-messes-up-with-fixed-childs
            transform: style.translateLeft === 0 ? 'none' : `translateX(${style.translateLeft}vw)`,
            zIndex: '99',
            maxHeight: `${style.maxHeight}vh`,
            position: `${style.position > 0 ? 'relative' : 'absolute'}` // HACK: fixes parent wrapper height resize issues
        });
    render() {
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $9b0ae67beb2269f5$export$3ae376d12526dd6f), {
            children: this.props.children.length ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $bb8231acd22e51c2$export$e25e478948902b8b).div, {
                initial: {
                    opacity: 0,
                    x: 1000,
                    maxHeight: 3000,
                    position: 'absolute'
                },
                animate: {
                    opacity: 1,
                    x: 0,
                    maxHeight: 3000,
                    position: 'relative'
                },
                exit: {
                    opacity: 0,
                    x: -1000,
                    maxHeight: 0,
                    position: 'absolute'
                },
                transition: {
                    type: "spring",
                    stiffness: 390,
                    damping: 31
                },
                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($cd1ec0cc88bc8751$var$SectionWrapper, {
                    children: this.props.children
                })
            }, `${this.props.sectionId}--key`) : null
        });
    }
}
const $cd1ec0cc88bc8751$var$SectionWrapper = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    position: relative;
    float: left; 
    width: 100%; 

    ${(0, $45d1242a07988139$export$8c467e8859fdef13)()}; 
`;




var $8NFma = parcelRequire("8NFma");



// TODO: refactor this file into smaller styled-components wrappers




const $7db30f9b8380a2de$var$propsToExclude = [
    'paddingTop',
    'displayValue',
    'noBorder',
    'alternateBackground',
    'noTopPadding',
    'noSidePadding',
    'transparentBackground',
    'rightAlign'
];
const $7db30f9b8380a2de$export$1ad2c548eee6cf38 = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    display: inline-block;
    width: 100%;
    text-align: right;

    span {
        display: block;

        color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.error};
        font-weight: 400;
        font-size: 16px;
        margin-top: 10px;

        ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
            font-size: 13px;
        `)}
    }
`;
const $7db30f9b8380a2de$export$bf39d720edf35aea = (0, $65e706775ff71837$export$2e2bcd8739ae039).form`
    background-color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.blueBackground};
`;
const $7db30f9b8380a2de$export$23e1bd76cdf094ea = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    background-color: #fff;
    border-radius: 5px;

    padding: 37px;
    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        padding: 0px;
    `)}

    &:not(:first-of-type){
        margin-top: 40px;
        ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
            margin-top: 20px;
        `)}
    }
`;
const $7db30f9b8380a2de$export$dfa5220aeb9c0ce1 = (0, $65e706775ff71837$export$2e2bcd8739ae039)($7db30f9b8380a2de$export$23e1bd76cdf094ea)`
    padding: 0px;
`;
const $7db30f9b8380a2de$export$e5514f626972a05 = (0, $65e706775ff71837$export$2e2bcd8739ae039)($7db30f9b8380a2de$export$23e1bd76cdf094ea)`
    background-color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.blueBackground};
    border-radius: 5px;
    clear: both;
    color: #fff;
    line-height: 1.4;
    margin: 10px auto 50px auto;
    padding: 30px 35px;
    position: relative;

    ${(0, $45d1242a07988139$export$8c467e8859fdef13)()};

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).medium(`
        padding: 20px 25px;
    `)}

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        padding: 17px;
        margin: 0px auto 17px auto;
    `)}

    .memberInfoContainer,
    .nextStepBtn,
    .saveForLaterBtn,
    .sendConfirmedAnswersBtn {
        display: inline-block;
    }

    .memberInfoContainer {
        display: block;
        float: left;

        ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
            display: block;
        `)}

        h3 {
            font-family: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.main};
            ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
                border-bottom: 1px solid rgba(255, 255, 255, 0.1);
                padding-bottom: 17px;
            `)}
        }

        p, h3 {
            font-size: 16px;
            margin: 0px auto;
            ${(0, $45d1242a07988139$export$8f880b6e390052fa).xxsmall(`
                font-size: 13px;
            `)}
        }

        .memberInfoName, h3 {
            font-size: 18px;
            ${(0, $45d1242a07988139$export$8f880b6e390052fa).xxsmall(`
                font-size: 16px;
            `)}
        }

        .memberInfoName {
            margin: 10px auto;
        }

        .memberInfoZipCodeArea {
            margin-bottom: 17px;
        }

        span {
            font-weight: bold;
            margin-right: 5px;
        }
    }

    .informationBoxBtnContainer {
        text-aling: right;
        position: absolute;
        bottom: 30px;
        right: 40px;

        ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
            float:  none;
            position: initial;
            text-align: center;
            margin-top: 30px;
            width: 100%;
        `)}

        ${(0, $45d1242a07988139$export$8f880b6e390052fa).medium(`
            float: left;
            bottom: 20px;
            right: 20px;
        `)}

        ${(0, $45d1242a07988139$export$8f880b6e390052fa).large(`
            bottom: 30px;
            right: 40px;
        `)}
    }

    .nextStepBtn,
    .sendConfirmedAnswersBtn {
        ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
            display: block;
            margin: 10px auto 0 auto;
        `)}

        padding: 10px 20px 10px 20px;

        font-family: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.main};
        font-size: 16px;
        font-weight: bold;
        color: white;

        background-color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.green};
        border-radius: 5px;
        margin-left: 30px;

        &:disabled {
            background-color: ${(0, (/*@__PURE__*/$parcel$interopDefault($5e6a62740b68988a$exports)))((0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.green, 0.5)};
            cursor: not-allowed;
        }

        ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
            padding: 10px 17px;
            line-height: 1;
        `)}

        ${(0, $45d1242a07988139$export$8f880b6e390052fa).xxsmall(`
            font-size: 13px;
        `)}
    }

    .autoSavedDraftNotice {
        width: 100%;
        text-align: left;
        ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
            text-align: center;
        `)}

        span {
            display: inline-block;

            font-size: 14px;
            ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
                margin-top: 10px;
            `)}
        }
    }

    .nextStepBtn:after {
        color: white;
        padding-left: 10px;
        font-size: 14px;
        font-weight: normal;

        ${(0, $45d1242a07988139$export$74300498d1a9477c).arrowRight()}
        transition: transform 300ms ease-out;

        ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
            font-size: 9px;
            position: relative;
            top: -1px;
        `)}
    }

    .editBtn {
        background: none;
        color: white;
        border: none;
        padding: 0px;
        font: inherit;
        font-size: 16px;
        cursor: pointer;

        ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
            padding: 0px 15px;
        `)}

        ${(0, $45d1242a07988139$export$8f880b6e390052fa).xxsmall(`
            font-size: 13px;
        `)}
    }
`;
const $7db30f9b8380a2de$export$886e578016c5bff5 = (0, $65e706775ff71837$export$2e2bcd8739ae039).h4`
    font-family: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.main};
    font-size: 20px;

    font-weight: bold;
    margin-bottom: 20px;

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        padding: 17px;
        margin-bottom: 0px;
    `)}

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).xxsmall(`
        font-size: 16px;
    `)}
`;
const $7db30f9b8380a2de$export$7b5f5eaf3ac2a2d3 = (0, $65e706775ff71837$export$2e2bcd8739ae039).p`
    font-family: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.main};
    font-size: 16px;
    font-weight: bold;
    line-height: 1.2;
    margin-top: 0px;

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        margin: 0px 17px 17px 17px;

        &:empty {
            margin: 0px;
        }
    `)}

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).xxsmall(`
        font-size: 13px;
    `)}
`;
const $7db30f9b8380a2de$export$131bf4e6dc574a42 = (0, $65e706775ff71837$export$2e2bcd8739ae039).div.withConfig({
    shoudlForwardProps: (prop)=>!$7db30f9b8380a2de$var$propsToExclude.includes(prop)
})`
    border: 1px solid ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.grayBorder};
    border-bottom: none;

    ${(props)=>props.noTopMargin ? `
        border-top: none;
    ` : ''}

    margin: ${(props)=>props.noTopMargin ? '0' : '20px'} auto 0px auto;

    width: 100%;
    &:first-of-type {
        margin: 0px auto;
    }
`;
const $7db30f9b8380a2de$var$levelPropstoExclude = [
    'paddingTop',
    'displayValue',
    'noBorder',
    'alternateBackground',
    'noTopPadding',
    'noSidePadding',
    'transparentBackground',
    'rightAlign'
];
const $7db30f9b8380a2de$export$96ef1c2806f15a6f = (0, $65e706775ff71837$export$2e2bcd8739ae039)($7db30f9b8380a2de$export$131bf4e6dc574a42).withConfig({
    shouldForwardProp: (prop)=>!$7db30f9b8380a2de$var$levelPropstoExclude.includes(prop)
})`
    padding: ${(props)=>props.paddingTop ? props.paddingTop : '0px'} 30px;

    border: none;
    border-bottom: 1px solid ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.grayBorder};
    display: ${(props)=>props.displayValue === 'block' ? 'block' : 'none'};
    margin: 0px auto;
    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        padding: 0px;
    `)}

    ${(props)=>props.noBorder ? `
        border-bottom: 0px solid ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.grayBorder};
    ` : ''};
`;
const $7db30f9b8380a2de$var$levelTwoRowContainerNoStripesPropsToExclude = [
    'alternateBackground'
];
const $7db30f9b8380a2de$export$b2a9478d4dfb7ba3 = (0, $65e706775ff71837$export$2e2bcd8739ae039)($7db30f9b8380a2de$export$96ef1c2806f15a6f)`
    background-color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.grayBackgroundDarker};

    ${(props)=>props.alternateBackground ? `
        &:nth-child(odd) {
            background-color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.grayBackgroundDarkest} !important;
        }
    ` : ''};
`;
const $7db30f9b8380a2de$export$4500945742ad6dc4 = (0, $65e706775ff71837$export$2e2bcd8739ae039)($7db30f9b8380a2de$export$b2a9478d4dfb7ba3).withConfig({
    shouldForwardProp: (prop)=>!$7db30f9b8380a2de$var$levelPropstoExclude.includes(prop)
})`
    display: block;
    padding-top: 10px !important;

    ${(props)=>props.rightAlign ? `
        text-align: right;
    ` : ''}
    ${(props)=>props.noSidePadding ? `
        padding-left: 0px;
        padding-right: 0px;
    ` : ''}
    ${(props)=>props.noTopPadding ? `
        padding-top: 0px !important;
    ` : ''}
    ${(props)=>props.transparentBackground ? `
        background-color: transparent !important;
    ` : ''}
`;
const $7db30f9b8380a2de$var$repeatGroupButtonPropsToExclude = [
    'inlineBlock'
];
const $7db30f9b8380a2de$export$598729083b8b96f6 = (0, $65e706775ff71837$export$2e2bcd8739ae039).button.withConfig({
    shouldForwardProp: (prop)=>!$7db30f9b8380a2de$var$repeatGroupButtonPropsToExclude.includes(prop)
})`
    width: auto;
    margin: 0 auto;
    display: block;

    margin-top: 20px;
    margin-bottom: 30px;

    padding: 10px 50px 10px 50px;

    font-size: 16px;
    font-family: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.main};


    ${(props)=>props.inlineBlock ? `
        display: inline-block;
    ` : ''}

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        font-size: 14px;
        padding: 10px 30px 10px 30px;
    `)}

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        font-size: 14px;
        padding: 10px 30px 10px 30px;
        max-width: 70vw;
    `)}

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).xxsmall(`
        font-size: 12px;
        padding: 10px;
        font-size: 12px;
        max-width: 70vw;
    `)}
`;
const $7db30f9b8380a2de$export$4151ca22ad2d0d6c = (0, $65e706775ff71837$export$2e2bcd8739ae039).button.withConfig({
    shouldForwardProp: (prop)=>!$7db30f9b8380a2de$var$levelPropstoExclude.includes(prop)
})`
    width: auto;
    display: inline-block;
    position: relative;

    margin: 17px 0px;

    padding: 0px;

    background: transparent;

    font-family: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.main};
    color: #182329;	
    font-size: 14px;	
    line-height: 17px;

    padding-right: 21px;

    font-weight: normal;


    &:after {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translate(0, -50%);
        ${(0, $45d1242a07988139$export$74300498d1a9477c).plus()}
        border-radius: 50%;
        color: #fff;
        background: red;
        transform-origin: center;
        background: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.green};
    
        margin-top: -1px;

        width: 15px;
        height: 15px;
        font-size: 11px;
        line-height: 15px;
        padding-left: 1px;
        text-align: center;

        ${(props)=>props.removeIcon ? `
            background: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.error};
            transform: translate(0, -50%) rotate(-45deg);
            font-size: 12px;
            padding-top: 1px;
            padding-left: 0px;
        ` : ''}

        display: flex;
        justify-content: center;
        align-items: center;
    }



    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        max-width: 70vw;
        margin: 17px 17px;
    `)}

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).xxsmall(`
        font-size: 12px;
        font-size: 12px;
        max-width: 70vw;
        margin: 17px 17px;

    `)}
`;
const $7db30f9b8380a2de$export$9344ca545e738767 = (0, $65e706775ff71837$export$2e2bcd8739ae039)($7db30f9b8380a2de$export$b2a9478d4dfb7ba3)`
    background-color: #fff;
    border: 1px solid ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.grayBorder};
    margin: 0px auto 17px auto;
    top: 14px;
    position: relative;
    &:first-of-type {
        margin: 0px auto 17px auto;
    }
`;
const $7db30f9b8380a2de$var$formRowPropsToExclude = [
    'styleForConfirmView',
    'paddingTop',
    'displayValue',
    'noBorder',
    'alternateBackground',
    'noTopPadding',
    'noSidePadding',
    'transparentBackground',
    'rightAlign'
];
const $7db30f9b8380a2de$export$752baedc428a866c = (0, $65e706775ff71837$export$2e2bcd8739ae039).div.withConfig({
    shouldForwardProp: (prop)=>!$7db30f9b8380a2de$var$formRowPropsToExclude.includes(prop)
})`
    padding: 15px 30px;

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        padding: 15px 17px;
        word-wrap: break-word;
    `)}

    background-color: transparent !important;
    border-bottom: 1px solid ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.grayBorder};
    font-weight: bold;
    overflow: ${(props)=>props.styleForConfirmView ? 'auto' : 'initial'};
    width: 100%;

    ${(0, $45d1242a07988139$export$8c467e8859fdef13)()}

    label, legend, .dynamicFormConfirmedQuestion, .dynamicFormConfirmedAnswer {
        box-sizing: border-box;
        margin: 0;
        width: 40%;
        font-family: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.heading};
        font-size: 16px;
        font-weight: bold;
        line-height: 1.2;

        ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
            padding-right: 10px;
            width: 60%;
        `)}

        ${(0, $45d1242a07988139$export$8f880b6e390052fa).xxsmall(`
            font-size: 13px;
        `)}
    }

    .dynamicFormSubmittedAnswerContainer {
        line-height: 1.2;
    }

    .dynamicFormConfirmedQuestion, .dynamicFormConfirmedAnswer {
        display: inline-block;
        padding: 5px 0px;
        width: auto;
    }

    .dynamicFormConfirmedQuestion {
        margin-right: 10px;
        max-width: 60%;
        ${(0, $45d1242a07988139$export$8f880b6e390052fa).xxsmall(`
            max-width: 50%;
        `)}
    }

    .dynamicFormConfirmedAnswer {
        float: right;
        font-family: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.main};
        text-align: right;
        max-width: 60%;
        ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
            max-width: 100%;
        `)}
    }

    label {
        display: inline-block;
        padding: 7px 10px 7px 0px;

        ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
            display: block;
            padding-top: 0px;
            width: 100%;
        `)}
    }

    .textareaLabel {
        float: left;
    }

    fieldset {
        display: block;
        border: 0;
        padding: 5px 0px;
        ${(0, $45d1242a07988139$export$8f880b6e390052fa).xxsmall(`
            padding: 0px;
        `)}
        margin: 0;
        width: 100%;

        ${(0, $45d1242a07988139$export$8c467e8859fdef13)()}

        legend {
            float: left;
            padding-top: 4px;
            display: inline-block;

            ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
                float: none;

                margin: 2px 0px;
                padding-top: 0px;
                width: calc(100% - 120px);
            `)}

            ${(0, $45d1242a07988139$export$8f880b6e390052fa).xxsmall(`
                margin: 4px 0px;
            `)}
        }

        .dynamicFormRadioContainer {
            position: relative;
            width: 60%;
            display: block;
            float: right;

            text-align: right;

            ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
                width: 100%;
                float: none;
                text-align: left;
            `)}

            ${(0, $45d1242a07988139$export$8f880b6e390052fa).xxsmall(`
                text-align: left;
            `)}

            ${(0, $45d1242a07988139$export$8c467e8859fdef13)()}

            label {
                width: auto;
                display: inline-block;

                font-family: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.heading};
                font-weight: normal;

                &:not(:last-of-type) {
                    padding-right: 35px;
                    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
                        padding-right: 30px;
                    `)}

                    ${(0, $45d1242a07988139$export$8f880b6e390052fa).xxsmall(`
                        padding-right: 20px;
                    `)}
                }
            }

            [type="radio"]:checked,
            [type="radio"]:not(:checked) {
                position: absolute;
                left: -9999px;
            }

            [type="radio"]:checked + label,
            [type="radio"]:not(:checked) + label {
                position: relative;
                padding-left: 28px;
                cursor: pointer;
                line-height: 20px;
                display: inline-block;
            }

            [type="radio"]:checked + label:before,
            [type="radio"]:not(:checked) + label:before {
                content: '';
                position: absolute;
                left: 0;
                top: 50%;
                transform: translateY(-50%);

                ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
                    transform: translateY(-75%);
                `)}

                width: 20px;
                height: 20px;

                border: 1px solid ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.grayBorder};
                border-radius: 100%;
                background: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.grayBackground};
            }

            [type="radio"]:checked + label:after,
            [type="radio"]:not(:checked) + label:after {
                position: absolute;

                content: '';
                width: 10px;
                height: 10px;

                background: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.green};

                top: 12px;
                left: 5px;

                ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
                    top: 4px;
                `)}

                border-radius: 100%;

                transition: all 0.2s ease;
            }

            [type="radio"]:not(:checked) + label:after {
                opacity: 0;
                transform: scale(0);
            }

            [type="radio"]:checked + label:after {
                opacity: 1;
                transform: scale(1);
            }
        }
    }

    body:not(:-moz-handler-blocked) fieldset {
        display: table-cell;
    }

    input[type=text], input[type=email], input[role="combobox"], textarea {
        width: 50%;
        padding: 7px;
        line-height: 1;
        float: right;
        -webkit-appearance: none;

        background-color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.grayBackground};
        border: 1px solid ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.grayBorder};

        font-family: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.heading};
        font-weight: normal;

        &:disabled {
            cursor: not-allowed;
            opacity: 0.5;
        }

        ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
            float: none;
            display: block;
            padding: 5px;
            width: 100%;
        `)}

        ${(0, $45d1242a07988139$export$8f880b6e390052fa).xxsmall(`
            font-size: 13px;
        `)}
    }

    textarea {
        float: right;
        -webkit-appearance: none;

        min-height: 160px;
        resize: none;
    }

    input[type=text]::placeholder, input[type=email]::placeholder {
        opacity: 0.3;
    }

    input[type=text].is-invalid-input, input[type=email].is-invalid-input {
        border: 1px solid ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.error};
    }

    textarea.is-invalid-input {
        background-color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.error};
    }

    &:last-of-type {
        border-bottom: none;
    }

    .dynamicFormCheckboxContainer {
        position: relative;
        ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
            label {
                display: inline-block;
                padding-top: 7px;
                width: calc(100% - 120px);
            }
        `)}

        .dynamicFormCheckboxFauxLabel {
            float: right;
            font-weight: normal;
            margin-top: 2px;
            margin-left: 10px;

            ${(0, $45d1242a07988139$export$8f880b6e390052fa).xxsmall(`
                font-size: 13px;
            `)}
        }

        .dynamicFormCheckboxWrapper {
            position: relative;
            z-index: 1;
            float: right;
            margin-top: 7px;


            input[type="checkbox"],
            .dynamicFormCheckbox {
                width: 20px;
                height: 20px;
            }

            input[type="checkbox"] {
                position: absolute;
                right: 0;
                top:0;

                opacity: 0;
                margin: 0px;
                z-index: 2;
                width: 30px;
                height: 30px;
                cursor: pointer;
            }

            .dynamicFormCheckbox {
                display: block;
                min-width: 20px;
                min-height: 20px;
                content: '';
                cursor: pointer;
                background: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.grayBackground};
                border: 1px solid #c5c9cc;
                border-radius: 4px;

                &:after {
                    position: relative;
                    opacity: 0;
	                ${(0, $45d1242a07988139$export$74300498d1a9477c).check()}
                    color: #00873F;
                    font-size: 11px;
                    font-weight: normal;
                    left: 3px;
                    top: -5px;
                }
            }

            input[type=checkbox]:checked ~ .dynamicFormCheckbox:after {
                opacity: 1;
            }

            .dynamicFormCheckboxFauxLabel {
                font-weight: normal;
                float: right;
            }
        }
    }

    .dynamicFormSelectContainer {
        select {
            min-width: 200px;
            width: 50%;
            float: right;

            padding: 7px;

            font-family: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.heading};
            font-weight: normal;

            border-radius:2px;
            background: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.grayBackground};
            border: solid 1px ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.grayBorder};

            -webkit-appearance: none;
            -moz-appearance: none;
            cursor: pointer;

            background-image: url('/images/arrows.svg');
            background-position: right 0 bottom 6px;
            background-size: 20px 20px;
            background-repeat: no-repeat;

            font-size:16px;
            line-height:1.2;
            color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.grayText};

            &:disabled {
                cursor: not-allowed;
                opacity: 0.5;
            }

            ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
                background-position: bottom 6px right 0px;
                background-size: 15px 15px;

                width: 100%;

                padding: 5px;
            `)}

            ${(0, $45d1242a07988139$export$8f880b6e390052fa).xxsmall(`
                background-position: bottom 6px right 0px;
                font-size: 13px;
            `)}
        }

        select.is-invalid-input {
            border: 1px solid ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.error};
            margin-bottom: 0px;
        }
    }

    .dynamicFormDateWrapper {
        ${(0, $45d1242a07988139$export$8c467e8859fdef13)()}

        .dynamicFormDateInputContainer {
            display: inline-block;
            width: 50%;
            ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
                width: 100%;
            `)}

            max-height: 34px;
            float: right;

            input {
                width: 100%;
            }
        }
    }

    .dynamicFormAutocompleteWrapper {
        position: relative;
        float: right;
        width: 50%;

        ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
            width: 100%;
        `)}


        & > div {
            display: inline-block;
            width: 100%;

            input {
                width: 100%;
                padding: 7px;
                line-height: 1;
                float: right;
                appearance: none;
                background-color: rgb(252, 252, 252);
                border: 1px solid rgb(219, 222, 224);
                font-family: "VAG Rounded", sans-serif;
                font-weight: normal;
            }

            .dynamicFormAutocompleteMenu {
                position: absolute;
                top: 37px;
                left: 0;

                width: 100%;
                max-height: 70vh;

                z-index: 99;

                ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
                    max-height: 200px;
                    overflow-y: scroll;
                `)}

                background-color: white;
                box-shadow: 0px 2px 22px -2px rgba(0,0,0,0.51);

                .dynamicFormAutocompleteMenuItem {
                    padding: 10px;
                    background: white;
                    color: black;
                    cursor: default;
                    font-weight: normal;

                    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
                        width: 100%;
                        font-size: 13px;
                    `)}

                    &--active {
                        background: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.green};
                        color: white;
                        cursor: pointer;
                    }
                }
            }
        }
    }
`;
const $7db30f9b8380a2de$export$5fb19acf7b63fc10 = (0, $65e706775ff71837$export$2e2bcd8739ae039)($7db30f9b8380a2de$export$752baedc428a866c)`
    padding: 17px 0px;
`;
const $7db30f9b8380a2de$export$daf517bb16ef8b39 = (0, $65e706775ff71837$export$2e2bcd8739ae039)($7db30f9b8380a2de$export$5fb19acf7b63fc10)`
    background-color: #fff;
`;
const $7db30f9b8380a2de$export$cd84e9082c144302 = (0, $65e706775ff71837$export$2e2bcd8739ae039).span`
    position: relative;
    font-weight: normal;
    .helpTextIcon {
        background: none;
        border: 0;
        box-sizing: content-box;
        cursor: pointer;
        color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.blueBackground};
        height: 1em;

        transition: all 3s ease-in-out;
        padding: 0px 7px;
        position: absolute;

        &:after {
            font-size: initial;
            font-weight: normal;
            ${(0, $45d1242a07988139$export$74300498d1a9477c).informationIcon()}
            position: relative;
            top: -5.5px;

            ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
                top: 1px;
            `)}

            ${(0, $45d1242a07988139$export$8f880b6e390052fa).xxsmall(`
                font-size: 12px;
                top: -1px;
            `)}
        }

        &:hover {
            color: #23527c;
        }

        span {
            display: none;
        }
    }

    .helpText {
        display: ${(props)=>props.helpTextVisibility === true ? 'block' : 'none'};
        position: absolute;
        top: 21px;
        left: -200px;
        padding-top: 5px;
        z-index: 1;

        ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
            position: relative;
            top: 15px;
            left: 0px;
            height: 0px;
            padding: 0px;
            width: 0px;
        `)}

        .helpTextArrow {
            display: block;
            width: 0;
            height: 0;
            border-left: 15px solid transparent;
            border-right: 15px solid transparent;
            border-bottom: 11px solid ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.blueBackground};
            margin: 0px auto -1px auto;
            ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
                display: none;
            `)}
        }

        .helpTextContent {
            background-color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.blueBackground};
            color: #fff;
            display: block;
            text-align: left;
            border-radius: 10px;
            padding: 25px 30px;
            margin: 0px auto;
            width: 430px;
            line-height: 1.2;
            box-shadow: -1px 4px 10px -1px rgba(0,0,0,0.4);

            ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
                padding: 15px 20px;
                width: 80vw;
                position: absolute;
            `)}
        }
    }
`;




var $8NFma = parcelRequire("8NFma");



var $8NFma = parcelRequire("8NFma");

class $b6cf6ab8ff89da81$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    constructor(props){
        super(props);
        this.state = {
            helpTextVisibility: false
        };
    }
    closeHelpText = (e)=>{
        document.body.removeEventListener('click', this.closeHelpText, false);
        this.setState({
            helpTextVisibility: false
        });
    };
    toggleHelpText = (e)=>{
        const helpTextVisibility = this.state.helpTextVisibility;
        if (!helpTextVisibility) document.body.addEventListener('click', this.closeHelpText);
        this.setState({
            helpTextVisibility: !helpTextVisibility
        });
    };
    render() {
        const questionGroupHelpText = this.props.questionGroupHelpText;
        if (questionGroupHelpText !== null) return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $7db30f9b8380a2de$export$cd84e9082c144302), {
            helpTextVisibility: this.state.helpTextVisibility,
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                    type: "button",
                    className: "helpTextIcon",
                    onClick: (e)=>this.toggleHelpText(e),
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                        children: "Se ordf\xf6rklaring."
                    })
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("span", {
                    className: "helpText",
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                            className: "helpTextArrow",
                            children: "\xa0"
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                            className: "helpTextContent",
                            children: questionGroupHelpText
                        })
                    ]
                })
            ]
        });
        return null;
    }
}




var $8NFma = parcelRequire("8NFma");



var $8NFma = parcelRequire("8NFma");

var $8NFma = parcelRequire("8NFma");

/* abstract */ class $592b0359ede6f151$export$ee2c3a0c5b571646 extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    constructor(props){
        super(props);
        // find option value that toggles sub question group (usually 'Ja' or 'Nej')
        const toggleGroupOnValue = props.questionGroup.questionType === 'Radio' ? props.questionGroup.options.filter((option)=>option.togglesSubQuestionGroup).reduce((_, option)=>option.text, null) : null;
        const groupIsVisible = props.questionGroup.questionType === 'Radio' && props.questionGroup.id in props.formInputs && props.formInputs[props.questionGroup.id].value === toggleGroupOnValue || props.questionGroup.value === toggleGroupOnValue;
        const groupInited = props.questionGroup.subQuestionGroup && props.questionGroup.subQuestionGroup.id in props.formInputs;
        this.toggleGroupOnValue = toggleGroupOnValue;
        this.state = {
            subQuestionVisibility: groupIsVisible ? true : false
        };
        if (groupIsVisible && !groupInited && props.currentStep === 0 && props.questionGroup.subQuestionGroup) props.addQuestionGroupInputs([
            props.questionGroup.subQuestionGroup
        ], 0, 1);
    }
    toggleSubQuestions = (e)=>{
        const subQuestionGroup = this.props.questionGroup.subQuestionGroup;
        if (subQuestionGroup && subQuestionGroup.questions.length) {
            if (!this.state.subQuestionVisibility && e.target.value === this.toggleGroupOnValue) {
                this.props.addQuestionGroupInputs([
                    subQuestionGroup
                ], 0, 1);
                this.setState({
                    subQuestionVisibility: true
                });
            } else if (this.state.subQuestionVisibility && e.target.value !== this.toggleGroupOnValue) {
                this.props.removeQuestionGroupInputs([
                    subQuestionGroup
                ], 0, 3);
                this.setState({
                    subQuestionVisibility: false
                });
            }
        }
    };
}
const $592b0359ede6f151$export$de2ca8c2e4a4fc69 = (classObject)=>{
    const mapStateToProps = (state)=>{
        return {
            currentStep: state.pageCurrentStep
        };
    };
    const mapDispatchToProps = (dispatch)=>{
        return {};
    };
    return (0, $5a4066412ccab0c1$export$64605811ab45167f)(mapStateToProps, mapDispatchToProps)(classObject);
};




parcelRequire("8NFma");




var $8NFma = parcelRequire("8NFma");


class $73e1661e3a3d7a06$var$DynamicFormLevel3QuestionRow extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).PureComponent {
    render() {
        const QuestionTypeHandler = this.props.questionTypeHandler;
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $7db30f9b8380a2de$export$daf517bb16ef8b39), {
            styleForConfirmView: this.props.currentStep === 1,
            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)(QuestionTypeHandler, {
                question: this.props.questionGroup,
                formInput: this.props.formInput
            })
        });
    }
}
const $73e1661e3a3d7a06$var$mapDispatchToProps = (dispatch)=>({});
const $73e1661e3a3d7a06$var$mapStateToProps = (state)=>({
        currentStep: state.pageCurrentStep
    });
var $73e1661e3a3d7a06$export$2e2bcd8739ae039 = (0, $5a4066412ccab0c1$export$64605811ab45167f)($73e1661e3a3d7a06$var$mapStateToProps, $73e1661e3a3d7a06$var$mapDispatchToProps)($73e1661e3a3d7a06$var$DynamicFormLevel3QuestionRow);



class $7246263e15d1db7f$var$DynamicFormLevel2QuestionRow extends (0, $592b0359ede6f151$export$ee2c3a0c5b571646) {
    render() {
        const QuestionTypeHandler = this.props.questionTypeHandler;
        let questionGroup = this.props.questionGroup;
        const isRepeated = this.props.isRepeated;
        const repeatCount = this.props.repeatCount;
        const questionGroupId = isRepeated ? `${questionGroup.id}${0, $7c3038616dbee0e6$export$5af54ce744e65c54}${repeatCount}` : questionGroup.id;
        if (isRepeated) questionGroup = {
            ...questionGroup,
            id: questionGroupId
        };
        const subQuestionGroup = this.props.questionGroup.subQuestionGroup;
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $7db30f9b8380a2de$export$5fb19acf7b63fc10), {
            displayValue: this.props.displayValue,
            styleForConfirmView: this.props.currentStep === 1,
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)(QuestionTypeHandler, {
                    question: questionGroup,
                    formInput: this.props.formInputs[questionGroupId],
                    toggleSubQuestions: this.toggleSubQuestions
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $7db30f9b8380a2de$export$9344ca545e738767), {
                    displayValue: this.state.subQuestionVisibility && subQuestionGroup ? 'block' : 'none',
                    children: subQuestionGroup && this.state.subQuestionVisibility && subQuestionGroup.questions.map((group)=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $73e1661e3a3d7a06$export$2e2bcd8739ae039), {
                            formInput: this.props.formInputs[group.id],
                            questionGroup: group,
                            questionTypeHandler: QuestionTypeHandler
                        }, group.id))
                })
            ]
        });
    }
}
var $7246263e15d1db7f$export$2e2bcd8739ae039 = (0, $592b0359ede6f151$export$de2ca8c2e4a4fc69)($7246263e15d1db7f$var$DynamicFormLevel2QuestionRow);



class $4951633387b25b05$var$DynamicFormLevel1QuestionRow extends (0, $592b0359ede6f151$export$ee2c3a0c5b571646) {
    render() {
        const QuestionTypeHandler = this.props.questionTypeHandler;
        const questionGroupId = this.props.isRepeated ? `${this.props.questionGroup.id}${0, $7c3038616dbee0e6$export$5af54ce744e65c54}${this.props.repeatCount}` : this.props.questionGroup.id;
        const questionGroup = {
            ...this.props.questionGroup,
            id: questionGroupId
        };
        const subQuestionGroup = typeof this.props.questionGroup.subQuestionGroup !== 'undefined' && this.props.questionGroup.subQuestionGroup ? this.props.questionGroup.subQuestionGroup : null;
        const subGroupIsRepeatable = subQuestionGroup && subQuestionGroup.repeatable;
        const subGroupIsRepeated = subQuestionGroup && subQuestionGroup.id in this.props.repeatedInputs;
        const repeatCount = subGroupIsRepeated ? this.props.repeatedInputs[subQuestionGroup.id] : 0;
        const useStripedLayout = !(subQuestionGroup && subQuestionGroup.title);
        const RowContainer = useStripedLayout ? (0, $7db30f9b8380a2de$export$b2a9478d4dfb7ba3) : (0, $7db30f9b8380a2de$export$96ef1c2806f15a6f);
        let RepeatButton = null;
        if (subGroupIsRepeatable) RepeatButton = ()=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $7db30f9b8380a2de$export$4151ca22ad2d0d6c), {
                onClick: (e)=>{
                    e.preventDefault();
                    this.props.repeatQuestionGroup(subQuestionGroup);
                },
                children: subQuestionGroup.addRepetitionButtonLabel !== null ? subQuestionGroup.addRepetitionButtonLabel : "L\xe4gg till f\xe4lt"
            });
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $7db30f9b8380a2de$export$752baedc428a866c), {
                    styleForConfirmView: this.props.currentStep === 1,
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)(QuestionTypeHandler, {
                        question: questionGroup,
                        formInput: this.props.formInputs[questionGroupId],
                        toggleSubQuestions: this.toggleSubQuestions
                    })
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)(RowContainer, {
                    displayValue: this.state.subQuestionVisibility && subQuestionGroup !== null ? 'block' : null,
                    children: [
                        subQuestionGroup && this.state.subQuestionVisibility && subQuestionGroup.questions.map((group)=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $7246263e15d1db7f$export$2e2bcd8739ae039), {
                                questionGroup: group,
                                styleForConfirmView: this.props.currentStep === 1,
                                questionTypeHandler: QuestionTypeHandler,
                                isRepeated: false,
                                formInputs: this.props.formInputs,
                                addQuestionGroupInputs: this.props.addQuestionGroupInputs,
                                removeQuestionGroupInputs: this.props.removeQuestionGroupInputs
                            }, group.id)),
                        subGroupIsRepeatable && repeatCount === 0 && this.props.currentStep == 0 && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $7db30f9b8380a2de$export$4500945742ad6dc4), {
                            transparentBackground: true,
                            noBorder: !useStripedLayout,
                            rightAlign: true,
                            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)(RepeatButton, {})
                        })
                    ]
                }),
                subGroupIsRepeated && subQuestionGroup !== null && subQuestionGroup.questions.length && this.state.subQuestionVisibility && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Fragment, {
                    children: [
                        ...Array(repeatCount)
                    ].map((_, i)=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Fragment, {
                            children: [
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)(RowContainer, {
                                    alternateBackground: useStripedLayout,
                                    displayValue: this.state.subQuestionVisibility && subQuestionGroup !== null ? 'block' : null,
                                    children: [
                                        subQuestionGroup.questions.map((group, j)=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $7246263e15d1db7f$export$2e2bcd8739ae039), {
                                                questionGroup: group,
                                                questionTypeHandler: QuestionTypeHandler,
                                                isRepeated: true,
                                                repeatCount: i + 1,
                                                repeatedInputs: this.props.repeatedInputs,
                                                formInputs: this.props.formInputs,
                                                addQuestionGroupInputs: this.props.addQuestionGroupInputs,
                                                removeQuestionGroupInputs: this.props.removeQuestionGroupInputs
                                            }, (this.props.formInputs[`${group.id}${0, $7c3038616dbee0e6$export$5af54ce744e65c54}${i + 1}`].uniqueKeyId || `${group.id}-${i}`) + '-' + j)),
                                        subGroupIsRepeatable && this.props.currentStep == 0 && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $7db30f9b8380a2de$export$4500945742ad6dc4), {
                                            noSidePadding: true,
                                            noTopPadding: true,
                                            transparentBackground: true,
                                            noBorder: true,
                                            rightAlign: true,
                                            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $7db30f9b8380a2de$export$4151ca22ad2d0d6c), {
                                                removeIcon: true,
                                                onClick: (e)=>{
                                                    e.preventDefault();
                                                    const repeatableIndex = i + 1;
                                                    this.props.removeRepeatedQuestionGroup(subQuestionGroup, repeatableIndex);
                                                },
                                                children: subQuestionGroup.deleteRepetitionButtonLabel !== null ? subQuestionGroup.deleteRepetitionButtonLabel : "Ta bort f\xe4lt"
                                            })
                                        })
                                    ]
                                }),
                                repeatCount == i + 1 && this.props.currentStep == 0 && // show if last item
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $7db30f9b8380a2de$export$4500945742ad6dc4), {
                                    noTopPadding: true,
                                    alternateBackground: useStripedLayout,
                                    transparentBackground: !useStripedLayout,
                                    rightAlign: true,
                                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)(RepeatButton, {})
                                })
                            ]
                        }, i))
                })
            ]
        });
    }
}
var $4951633387b25b05$export$2e2bcd8739ae039 = (0, $592b0359ede6f151$export$de2ca8c2e4a4fc69)($4951633387b25b05$var$DynamicFormLevel1QuestionRow);






class $7a5e27495db5f9d6$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).PureComponent {
    constructor(props){
        super(props);
        this.state = {
            uniqueKey: 'loaded'
        };
    }
    render() {
        const QuestionTypeHandler = this.props.questionTypeHandler;
        const questionGroup = this.props.questionGroup;
        const groupTitle = questionGroup.title;
        const groupPreamble = questionGroup.preamble;
        const groupQuestions = questionGroup.questions;
        const groupSubQuestions = questionGroup.subQuestionGroups;
        const groupIsRepeatable = questionGroup.repeatable;
        const isRepeated = questionGroup.id in this.props.repeatedInputs;
        const repeatCount = isRepeated ? this.props.repeatedInputs[questionGroup.id] : 0;
        const repeatButtonTitle = questionGroup.repeatableButtonText ? questionGroup.repeatableButtonText : questionGroup.title ? `L\xe4gg till fler f\xe4lt f\xf6r "${questionGroup.title}"` : "L\xe4gg till fler f\xe4lt";
        const hasChanged = ()=>{
            setTimeout(()=>{
                const newKey = Math.round(Math.random() * 10000);
                this.setState({
                    uniqueKey: Math.round(newKey)
                });
            }, 33);
        };
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $7db30f9b8380a2de$export$dfa5220aeb9c0ce1), {
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $7db30f9b8380a2de$export$7b5f5eaf3ac2a2d3), {
                    children: [
                        groupTitle,
                        groupPreamble,
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $b6cf6ab8ff89da81$export$2e2bcd8739ae039), {
                            questionGroupHelpText: this.props.questionGroup.helpText
                        })
                    ]
                }),
                groupSubQuestions !== null && groupSubQuestions.length > 0 && groupSubQuestions.map((group)=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($7a5e27495db5f9d6$export$2e2bcd8739ae039, {
                        questionGroup: group,
                        questionTypeHandler: QuestionTypeHandler,
                        formInputs: this.props.formInputs,
                        addQuestionGroupInputs: this.props.addQuestionGroupInputs,
                        removeQuestionGroupInputs: this.props.removeQuestionGroupInputs,
                        removeRepeatedQuestionGroup: this.props.removeRepeatedQuestionGroup
                    }, group.id)),
                groupQuestions !== null && groupQuestions.length > 0 && groupQuestions.map((group, i)=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $7db30f9b8380a2de$export$131bf4e6dc574a42), {
                        noTopMargin: i != 0 && group.subQuestionGroup == null,
                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $4951633387b25b05$export$2e2bcd8739ae039), {
                            questionGroup: group,
                            questionTypeHandler: QuestionTypeHandler,
                            isRepeated: false,
                            formInputs: this.props.formInputs,
                            repeatedInputs: this.props.repeatedInputs,
                            addQuestionGroupInputs: this.props.addQuestionGroupInputs,
                            removeQuestionGroupInputs: this.props.removeQuestionGroupInputs,
                            repeatQuestionGroup: this.props.repeatQuestionGroup,
                            removeRepeatedQuestionGroup: this.props.removeRepeatedQuestionGroup
                        })
                    }, group.id)),
                groupIsRepeatable && !this.props.currentStep && !repeatCount && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($7a5e27495db5f9d6$var$RepeatableRowActions, {
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($7a5e27495db5f9d6$var$RepeatableRowActionAdd, {
                        href: "#",
                        title: repeatButtonTitle,
                        onClick: (e)=>{
                            e.preventDefault();
                            this.props.repeatQuestionGroup(questionGroup);
                            hasChanged();
                        },
                        children: "L\xe4gg till f\xe4lt"
                    })
                }),
                isRepeated && groupQuestions !== null && groupQuestions.length > 0 && [
                    ...Array(repeatCount)
                ].map((_, i)=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Fragment, {
                        children: [
                            groupQuestions.map((group, j)=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $7db30f9b8380a2de$export$131bf4e6dc574a42), {
                                    noTopMargin: j != 0 && group.subQuestionGroup == null,
                                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $4951633387b25b05$export$2e2bcd8739ae039), {
                                        questionGroup: group,
                                        questionTypeHandler: QuestionTypeHandler,
                                        isRepeated: true,
                                        repeatCount: i + 1,
                                        formInputs: this.props.formInputs,
                                        repeatedInputs: this.props.repeatedInputs,
                                        repeatQuestionGroup: this.props.repeatQuestionGroup,
                                        removeRepeatedQuestionGroup: this.props.removeRepeatedQuestionGroup,
                                        addQuestionGroupInputs: this.props.addQuestionGroupInputs,
                                        removeQuestionGroupInputs: this.props.removeQuestionGroupInputs
                                    })
                                }, this.state.uniqueKey + '_' + group.id)),
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($7a5e27495db5f9d6$var$RepeatableRowActions, {
                                children: [
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($7a5e27495db5f9d6$var$RepeatableRowActionDelete, {
                                        href: "#",
                                        onClick: (e)=>{
                                            e.preventDefault();
                                            const repeatableIndex = i + 1;
                                            this.props.removeRepeatedQuestionGroup(questionGroup, repeatableIndex);
                                            hasChanged();
                                        },
                                        children: "Ta bort f\xe4lt"
                                    }),
                                    i === repeatCount - 1 && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($7a5e27495db5f9d6$var$RepeatableRowActionAdd, {
                                        href: "#",
                                        onClick: (e)=>{
                                            e.preventDefault();
                                            this.props.repeatQuestionGroup(questionGroup);
                                            hasChanged();
                                        },
                                        children: "L\xe4gg till f\xe4lt"
                                    })
                                ]
                            })
                        ]
                    }, i))
            ]
        });
    }
}
const $7a5e27495db5f9d6$var$RepeatableRowActions = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    text-align: right
`;
const $7a5e27495db5f9d6$var$RepeatableRowAction = (0, $65e706775ff71837$export$2e2bcd8739ae039).a`
    display: inline-block;
    margin-left: 10px;
    text-decoration: underline;
    position: relative;
    padding-right: 22px;
    font-size: 14px;
    line-height: 17px;

    &:after {
        display: block;
        position: absolute;
        right: 0;
        top: 50%;
        color: #fff;
        width: 15px;
        height: 15px;

        border-radius: 50%;
        text-align: center;
        line-height: 19px;
        font-size: 15px;
        display: flex;
        align-items: center;
        justify-content: center;

        transform: translate(0, -50%);

        ${(0, $45d1242a07988139$export$74300498d1a9477c).plus()}
    }
    &:focus,
    &:hover {
        color: initial;
        text-decoration: none;
    }
`;
const $7a5e27495db5f9d6$var$RepeatableRowActionAdd = (0, $65e706775ff71837$export$2e2bcd8739ae039)($7a5e27495db5f9d6$var$RepeatableRowAction)`
    color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.green};
    font-weight: bold;
    font-size: 14px;
    &:after {
        background-color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.green};
    }
    &:focus,
    &:hover {
        color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.green};
    }
`;
const $7a5e27495db5f9d6$var$RepeatableRowActionDelete = (0, $65e706775ff71837$export$2e2bcd8739ae039)($7a5e27495db5f9d6$var$RepeatableRowAction)`
    color: #c10054;
    &:after {
        background-color: #c10054;
        transform: translate(0, -50%) rotate(-45deg);
    }
    &:focus,
    &:hover {
        color: #c10054;
    }
`;




class $16a5e7598873f904$var$DynamicFormQuestionGroup extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).PureComponent {
    render() {
        const QuestionTypeHandler = this.props.questionTypeHandler;
        const questionGroup = this.props.questionGroup;
        const groupTitle = questionGroup.title;
        const groupPreamble = questionGroup.preamble;
        const groupQuestions = questionGroup.questions;
        const groupSubQuestions = questionGroup.subQuestionGroups;
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $7db30f9b8380a2de$export$23e1bd76cdf094ea), {
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $7db30f9b8380a2de$export$886e578016c5bff5), {
                    children: groupTitle
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $7db30f9b8380a2de$export$7b5f5eaf3ac2a2d3), {
                    children: [
                        groupPreamble,
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $b6cf6ab8ff89da81$export$2e2bcd8739ae039), {
                            questionGroupHelpText: this.props.questionGroup.helpText
                        })
                    ]
                }),
                groupQuestions && groupQuestions.length > 0 && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $7db30f9b8380a2de$export$131bf4e6dc574a42), {
                    children: groupQuestions.map((group)=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $4951633387b25b05$export$2e2bcd8739ae039), {
                            questionGroup: group,
                            styleForConfirmView: this.props.currentStep === 1,
                            questionTypeHandler: QuestionTypeHandler,
                            formInputs: this.props.formInputs,
                            repeatedInputs: this.props.repeatedInputs,
                            addQuestionGroupInputs: this.props.addQuestionGroupInputs,
                            removeQuestionGroupInputs: this.props.removeQuestionGroupInputs,
                            removeRepeatedQuestionGroup: this.props.removeRepeatedQuestionGroup,
                            repeatQuestionGroup: this.props.repeatQuestionGroup,
                            removeRepeatedQuestionGroup: this.props.removeRepeatedQuestionGroup
                        }, group.id))
                }),
                groupSubQuestions && groupSubQuestions.length > 0 && groupSubQuestions.map((group)=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $7a5e27495db5f9d6$export$2e2bcd8739ae039), {
                        questionGroup: group,
                        questionTypeHandler: QuestionTypeHandler,
                        formInputs: this.props.formInputs,
                        repeatedInputs: this.props.repeatedInputs,
                        addQuestionGroupInputs: this.props.addQuestionGroupInputs,
                        removeQuestionGroupInputs: this.props.removeQuestionGroupInputs,
                        removeRepeatedQuestionGroup: this.props.removeRepeatedQuestionGroup,
                        repeatQuestionGroup: this.props.repeatQuestionGroup,
                        removeRepeatedQuestionGroup: this.props.removeRepeatedQuestionGroup
                    }, group.id))
            ]
        });
    }
}
const $16a5e7598873f904$var$mapStateToProps = (state)=>{
    return {
        currentStep: state.pageCurrentStep
    };
};
const $16a5e7598873f904$var$mapDispatchToProps = (dispatch)=>{
    return {};
};
var $16a5e7598873f904$export$2e2bcd8739ae039 = (0, $5a4066412ccab0c1$export$64605811ab45167f)($16a5e7598873f904$var$mapStateToProps, $16a5e7598873f904$var$mapDispatchToProps)($16a5e7598873f904$var$DynamicFormQuestionGroup);




var $8NFma = parcelRequire("8NFma");


parcelRequire("8NFma");


parcelRequire("8NFma");


const $f51edab487ea15ea$var$DynamicFormError = (props)=>{
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $7db30f9b8380a2de$export$1ad2c548eee6cf38), {
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $bb8231acd22e51c2$export$e25e478948902b8b).div, {
            initial: {
                opacity: 0
            },
            animate: {
                opacity: 1
            },
            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                children: props.children
            })
        })
    });
};
var $f51edab487ea15ea$export$2e2bcd8739ae039 = $f51edab487ea15ea$var$DynamicFormError;


const $26b938ae087d8201$var$ShortString = ({ question: question, isValid: isValid, isTouched: isTouched, invalidError: invalidError, ...props })=>{
    const questionId = question.id;
    const questionText = question.questionText;
    const questionHelpText = question.helpText ? question.helpText : null;
    const isUneditable = question.isUneditable;
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("label", {
                htmlFor: questionId,
                children: [
                    questionText,
                    questionHelpText && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $b6cf6ab8ff89da81$export$2e2bcd8739ae039), {
                        questionGroupHelpText: questionHelpText
                    })
                ]
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("input", {
                type: "text",
                id: `question-${questionId}`,
                name: questionId,
                disabled: isUneditable,
                ...props
            }, questionId),
            !isValid && typeof isValid !== 'undefined' && isTouched && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $f51edab487ea15ea$export$2e2bcd8739ae039), {
                children: invalidError
            })
        ]
    });
};
var $26b938ae087d8201$export$2e2bcd8739ae039 = $26b938ae087d8201$var$ShortString;



parcelRequire("8NFma");


const $0e27fd283c2470a0$var$LongString = ({ question: question, isValid: isValid, isTouched: isTouched, invalidError: invalidError, ...props })=>{
    const questionId = question.id;
    const questionText = question.questionText;
    const questionHelpText = question.helpText ? question.helpText : null;
    const isUneditable = question.isUneditable;
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("label", {
                htmlFor: questionId,
                className: "textareaLabel",
                children: [
                    questionText,
                    questionHelpText && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $b6cf6ab8ff89da81$export$2e2bcd8739ae039), {
                        questionGroupHelpText: questionHelpText
                    })
                ]
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("textarea", {
                id: `question-${questionId}`,
                name: questionId,
                disabled: isUneditable,
                ...props
            }, questionId),
            !isValid && typeof isValid !== 'undefined' && isTouched && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $f51edab487ea15ea$export$2e2bcd8739ae039), {
                children: invalidError
            })
        ]
    });
};
var $0e27fd283c2470a0$export$2e2bcd8739ae039 = $0e27fd283c2470a0$var$LongString;



parcelRequire("8NFma");


const $317ea1b249e06865$var$Number = ({ question: question, isValid: isValid, isTouched: isTouched, invalidError: invalidError, ...props })=>{
    const questionId = question.id;
    const questionText = question.questionText;
    const questionHelpText = question.helpText ? question.helpText : null;
    const isUneditable = question.isUneditable;
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("label", {
                htmlFor: questionId,
                children: [
                    questionText,
                    questionHelpText && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $b6cf6ab8ff89da81$export$2e2bcd8739ae039), {
                        questionGroupHelpText: questionHelpText
                    })
                ]
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("input", {
                type: "text",
                id: `question-${questionId}`,
                name: questionId,
                disabled: isUneditable,
                ...props
            }, questionId),
            !isValid && typeof isValid !== 'undefined' && isTouched && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $f51edab487ea15ea$export$2e2bcd8739ae039), {
                children: invalidError
            })
        ]
    });
};
var $317ea1b249e06865$export$2e2bcd8739ae039 = $317ea1b249e06865$var$Number;




var $8NFma = parcelRequire("8NFma");


const $a3f2d27852734a11$var$RadioButtons = ({ question: question, value: value, isValid: isValid, isTouched: isTouched, invalidError: invalidError, ...props })=>{
    const questionId = question.id;
    const questionText = question.questionText;
    const questionHelpText = question.helpText ? question.helpText : null;
    const isUneditable = question.isUneditable;
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("fieldset", {
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("legend", {
                children: [
                    questionText,
                    questionHelpText && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $b6cf6ab8ff89da81$export$2e2bcd8739ae039), {
                        questionGroupHelpText: questionHelpText
                    })
                ]
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                className: "dynamicFormRadioContainer",
                id: `question-${questionId}`,
                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                    className: "dynamicFormRadioWrapper",
                    children: question.options.map((option, i)=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Fragment, {
                            children: [
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("input", {
                                    type: "radio",
                                    id: `question-${questionId}-radio${i}`,
                                    name: questionId,
                                    value: option.text,
                                    defaultChecked: value === option.text ? true : false,
                                    disabled: isUneditable,
                                    ...props
                                }, questionId + `radio${i}`),
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("label", {
                                    className: "dynamicFormRadioLabel",
                                    htmlFor: `question-${questionId}-radio${i}`,
                                    children: option.text
                                })
                            ]
                        }, `${questionId}-${option.text}`))
                })
            }),
            !isValid && typeof isValid !== 'undefined' && isTouched && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $f51edab487ea15ea$export$2e2bcd8739ae039), {
                children: invalidError
            })
        ]
    });
};
var $a3f2d27852734a11$export$2e2bcd8739ae039 = $a3f2d27852734a11$var$RadioButtons;



parcelRequire("8NFma");


const $5207a6288062d4a3$var$Checkbox = ({ question: question, value: value, isValid: isValid, isTouched: isTouched, invalidError: invalidError, ...props })=>{
    const questionId = question.id;
    const questionText = question.questionText;
    const questionHelpText = question.helpText ? question.helpText : null;
    const isUneditable = question.isUneditable;
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
        className: "dynamicFormCheckboxContainer",
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("label", {
                htmlFor: questionId,
                children: [
                    questionText,
                    questionHelpText && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $b6cf6ab8ff89da81$export$2e2bcd8739ae039), {
                        questionGroupHelpText: questionHelpText
                    })
                ]
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                className: "dynamicFormCheckboxFauxLabel",
                children: question.options[0].text
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                className: "dynamicFormCheckboxWrapper",
                children: [
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("input", {
                        type: "checkbox",
                        id: `question-${questionId}`,
                        name: questionId,
                        value: question.options[0].text,
                        defaultChecked: value === question.options[0].text ? true : false,
                        disabled: isUneditable,
                        ...props
                    }, questionId),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                        className: "dynamicFormCheckbox"
                    })
                ]
            }),
            !isValid && typeof isValid !== 'undefined' && isTouched && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $f51edab487ea15ea$export$2e2bcd8739ae039), {
                children: invalidError
            })
        ]
    });
};
var $5207a6288062d4a3$export$2e2bcd8739ae039 = $5207a6288062d4a3$var$Checkbox;



parcelRequire("8NFma");


const $1aede351419caa54$var$Dropdown = ({ question: question, isValid: isValid, isTouched: isTouched, invalidError: invalidError, ...props })=>{
    const questionId = question.id;
    const questionText = question.questionText;
    const questionHelpText = question.helpText ? question.helpText : null;
    const isUneditable = question.isUneditable;
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
        className: "dynamicFormSelectContainer",
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("label", {
                htmlFor: questionId,
                children: [
                    questionText,
                    questionHelpText && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $b6cf6ab8ff89da81$export$2e2bcd8739ae039), {
                        questionGroupHelpText: questionHelpText
                    })
                ]
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("select", {
                id: `question-${questionId}`,
                name: questionId,
                disabled: isUneditable,
                ...props,
                children: [
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("option", {
                        value: "",
                        children: "V\xe4lj"
                    }),
                    question.options.map((option, i)=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("option", {
                            value: option.text,
                            children: option.text
                        }, option.text))
                ]
            }, questionId),
            !isValid && typeof isValid !== 'undefined' && isTouched && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $f51edab487ea15ea$export$2e2bcd8739ae039), {
                children: invalidError
            })
        ]
    });
};
var $1aede351419caa54$export$2e2bcd8739ae039 = $1aede351419caa54$var$Dropdown;



parcelRequire("8NFma");
function $cfde373be945f92b$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $e3e49ed681292e30$export$2e2bcd8739ae039() {
    return $e3e49ed681292e30$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e3e49ed681292e30$export$2e2bcd8739ae039.apply(null, arguments);
}


function $40f4c2feb843f2da$export$2e2bcd8739ae039(t, e) {
    return $40f4c2feb843f2da$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $40f4c2feb843f2da$export$2e2bcd8739ae039(t, e);
}


function $c04286edcac4109a$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $40f4c2feb843f2da$export$2e2bcd8739ae039)(t, o);
}




var $8NFma = parcelRequire("8NFma");
var $161775e6c718b902$exports = {};
'use strict';

$161775e6c718b902$exports = (parcelRequire("cdwfJ"));


const $c6dfb11ca46a690a$var$t = (t)=>"object" == typeof t && null != t && 1 === t.nodeType, $c6dfb11ca46a690a$var$e = (t, e)=>(!e || "hidden" !== t) && "visible" !== t && "clip" !== t, $c6dfb11ca46a690a$var$n = (t, n)=>{
    if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
        const o = getComputedStyle(t, null);
        return $c6dfb11ca46a690a$var$e(o.overflowY, n) || $c6dfb11ca46a690a$var$e(o.overflowX, n) || ((t)=>{
            const e = ((t)=>{
                if (!t.ownerDocument || !t.ownerDocument.defaultView) return null;
                try {
                    return t.ownerDocument.defaultView.frameElement;
                } catch (t) {
                    return null;
                }
            })(t);
            return !!e && (e.clientHeight < t.scrollHeight || e.clientWidth < t.scrollWidth);
        })(t);
    }
    return !1;
}, $c6dfb11ca46a690a$var$o = (t, e, n, o, l, r, i, s)=>r < t && i > e || r > t && i < e ? 0 : r <= t && s <= n || i >= e && s >= n ? r - t - o : i > e && s < n || r < t && s > n ? i - e + l : 0, $c6dfb11ca46a690a$var$l = (t)=>{
    const e = t.parentElement;
    return null == e ? t.getRootNode().host || null : e;
}, $c6dfb11ca46a690a$export$3b12cb22b12b954b = (e, r)=>{
    var i, s, d, h;
    if ("undefined" == typeof document) return [];
    const { scrollMode: c, block: f, inline: u, boundary: a, skipOverflowHiddenElements: g } = r, p = "function" == typeof a ? a : (t)=>t !== a;
    if (!$c6dfb11ca46a690a$var$t(e)) throw new TypeError("Invalid target");
    const m = document.scrollingElement || document.documentElement, w = [];
    let W = e;
    for(; $c6dfb11ca46a690a$var$t(W) && p(W);){
        if (W = $c6dfb11ca46a690a$var$l(W), W === m) {
            w.push(W);
            break;
        }
        null != W && W === document.body && $c6dfb11ca46a690a$var$n(W) && !$c6dfb11ca46a690a$var$n(document.documentElement) || null != W && $c6dfb11ca46a690a$var$n(W, g) && w.push(W);
    }
    const b = null != (s = null == (i = window.visualViewport) ? void 0 : i.width) ? s : innerWidth, H = null != (h = null == (d = window.visualViewport) ? void 0 : d.height) ? h : innerHeight, { scrollX: y, scrollY: M } = window, { height: v, width: E, top: x, right: C, bottom: I, left: R } = e.getBoundingClientRect(), { top: T, right: B, bottom: F, left: V } = ((t)=>{
        const e = window.getComputedStyle(t);
        return {
            top: parseFloat(e.scrollMarginTop) || 0,
            right: parseFloat(e.scrollMarginRight) || 0,
            bottom: parseFloat(e.scrollMarginBottom) || 0,
            left: parseFloat(e.scrollMarginLeft) || 0
        };
    })(e);
    let k = "start" === f || "nearest" === f ? x - T : "end" === f ? I + F : x + v / 2 - T + F, D = "center" === u ? R + E / 2 - V + B : "end" === u ? C + B : R - V;
    const L = [];
    for(let t = 0; t < w.length; t++){
        const e = w[t], { height: n, width: l, top: r, right: i, bottom: s, left: d } = e.getBoundingClientRect();
        if ("if-needed" === c && x >= 0 && R >= 0 && I <= H && C <= b && x >= r && I <= s && R >= d && C <= i) return L;
        const h = getComputedStyle(e), a = parseInt(h.borderLeftWidth, 10), g = parseInt(h.borderTopWidth, 10), p = parseInt(h.borderRightWidth, 10), W = parseInt(h.borderBottomWidth, 10);
        let T = 0, B = 0;
        const F = "offsetWidth" in e ? e.offsetWidth - e.clientWidth - a - p : 0, V = "offsetHeight" in e ? e.offsetHeight - e.clientHeight - g - W : 0, S = "offsetWidth" in e ? 0 === e.offsetWidth ? 0 : l / e.offsetWidth : 0, X = "offsetHeight" in e ? 0 === e.offsetHeight ? 0 : n / e.offsetHeight : 0;
        if (m === e) T = "start" === f ? k : "end" === f ? k - H : "nearest" === f ? $c6dfb11ca46a690a$var$o(M, M + H, H, g, W, M + k, M + k + v, v) : k - H / 2, B = "start" === u ? D : "center" === u ? D - b / 2 : "end" === u ? D - b : $c6dfb11ca46a690a$var$o(y, y + b, b, a, p, y + D, y + D + E, E), T = Math.max(0, T + M), B = Math.max(0, B + y);
        else {
            T = "start" === f ? k - r - g : "end" === f ? k - s + W + V : "nearest" === f ? $c6dfb11ca46a690a$var$o(r, s, n, g, W + V, k, k + v, v) : k - (r + n / 2) + V / 2, B = "start" === u ? D - d - a : "center" === u ? D - (d + l / 2) + F / 2 : "end" === u ? D - i + p + F : $c6dfb11ca46a690a$var$o(d, i, l, a, p + F, D, D + E, E);
            const { scrollLeft: t, scrollTop: h } = e;
            T = 0 === X ? 0 : Math.max(0, Math.min(h + T / X, e.scrollHeight - n / X + V)), B = 0 === S ? 0 : Math.max(0, Math.min(t + B / S, e.scrollWidth - l / S + F)), k += h - T, D += t - B;
        }
        L.push({
            el: e,
            top: T,
            left: B
        });
    }
    return L;
};



var $f4c8705b32f2a63d$var$idCounter = 0;
/**
 * Accepts a parameter and returns it if it's a function
 * or a noop function if it's not. This allows us to
 * accept a callback, but not worry about it if it's not
 * passed.
 * @param {Function} cb the callback
 * @return {Function} a function
 */ function $f4c8705b32f2a63d$var$cbToCb(cb) {
    return typeof cb === 'function' ? cb : $f4c8705b32f2a63d$var$noop;
}
function $f4c8705b32f2a63d$var$noop() {}
/**
 * Scroll node into view if necessary
 * @param {HTMLElement} node the element that should scroll into view
 * @param {HTMLElement} menuNode the menu element of the component
 */ function $f4c8705b32f2a63d$var$scrollIntoView(node, menuNode) {
    if (!node) return;
    var actions = (0, $c6dfb11ca46a690a$export$3b12cb22b12b954b)(node, {
        boundary: menuNode,
        block: 'nearest',
        scrollMode: 'if-needed'
    });
    actions.forEach(function(_ref) {
        var el = _ref.el, top = _ref.top, left = _ref.left;
        el.scrollTop = top;
        el.scrollLeft = left;
    });
}
/**
 * @param {HTMLElement} parent the parent node
 * @param {HTMLElement} child the child node
 * @param {Window} environment The window context where downshift renders.
 * @return {Boolean} whether the parent is the child or the child is in the parent
 */ function $f4c8705b32f2a63d$var$isOrContainsNode(parent, child, environment) {
    var result = parent === child || child instanceof environment.Node && parent.contains && parent.contains(child);
    return result;
}
/**
 * Simple debounce implementation. Will call the given
 * function once after the time given has passed since
 * it was last called.
 * @param {Function} fn the function to call after the time
 * @param {Number} time the time to wait
 * @return {Function} the debounced function
 */ function $f4c8705b32f2a63d$var$debounce(fn, time) {
    var timeoutId;
    function cancel() {
        if (timeoutId) clearTimeout(timeoutId);
    }
    function wrapper() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        cancel();
        timeoutId = setTimeout(function() {
            timeoutId = null;
            fn.apply(void 0, args);
        }, time);
    }
    wrapper.cancel = cancel;
    return wrapper;
}
/**
 * This is intended to be used to compose event handlers.
 * They are executed in order until one of them sets
 * `event.preventDownshiftDefault = true`.
 * @param {...Function} fns the event handler functions
 * @return {Function} the event handler to add to an element
 */ function $f4c8705b32f2a63d$var$callAllEventHandlers() {
    for(var _len2 = arguments.length, fns = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)fns[_key2] = arguments[_key2];
    return function(event) {
        for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
        return fns.some(function(fn) {
            if (fn) fn.apply(void 0, [
                event
            ].concat(args));
            return event.preventDownshiftDefault || event.hasOwnProperty('nativeEvent') && event.nativeEvent.preventDownshiftDefault;
        });
    };
}
function $f4c8705b32f2a63d$var$handleRefs() {
    for(var _len4 = arguments.length, refs = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)refs[_key4] = arguments[_key4];
    return function(node) {
        refs.forEach(function(ref) {
            if (typeof ref === 'function') ref(node);
            else if (ref) ref.current = node;
        });
    };
}
/**
 * This generates a unique ID for an instance of Downshift
 * @return {String} the unique ID
 */ function $f4c8705b32f2a63d$var$generateId() {
    return String($f4c8705b32f2a63d$var$idCounter++);
}
/**
 * Resets idCounter to 0. Used for SSR.
 */ function $f4c8705b32f2a63d$export$4fba683129f6ab1e() {
    // istanbul ignore next
    if ('useId' in (0, (/*@__PURE__*/$parcel$interopDefault($8NFma)))) {
        console.warn("It is not necessary to call resetIdCounter when using React 18+");
        return;
    }
    $f4c8705b32f2a63d$var$idCounter = 0;
}
/**
 * Default implementation for status message. Only added when menu is open.
 * Will specify if there are results in the list, and if so, how many,
 * and what keys are relevant.
 *
 * @param {Object} param the downshift state and other relevant properties
 * @return {String} the a11y status message
 */ function $f4c8705b32f2a63d$var$getA11yStatusMessage(_ref2) {
    var isOpen = _ref2.isOpen, resultCount = _ref2.resultCount, previousResultCount = _ref2.previousResultCount;
    if (!isOpen) return '';
    if (!resultCount) return 'No results are available.';
    if (resultCount !== previousResultCount) return resultCount + " result" + (resultCount === 1 ? ' is' : 's are') + " available, use up and down arrow keys to navigate. Press Enter key to select.";
    return '';
}
/**
 * Takes an argument and if it's an array, returns the first item in the array
 * otherwise returns the argument
 * @param {*} arg the maybe-array
 * @param {*} defaultValue the value if arg is falsey not defined
 * @return {*} the arg or it's first item
 */ function $f4c8705b32f2a63d$var$unwrapArray(arg, defaultValue) {
    arg = Array.isArray(arg) ? /* istanbul ignore next (preact) */ arg[0] : arg;
    if (!arg && defaultValue) return defaultValue;
    else return arg;
}
/**
 * @param {Object} element (P)react element
 * @return {Boolean} whether it's a DOM element
 */ function $f4c8705b32f2a63d$var$isDOMElement(element) {
    // then we assume this is react
    return typeof element.type === 'string';
}
/**
 * @param {Object} element (P)react element
 * @return {Object} the props
 */ function $f4c8705b32f2a63d$var$getElementProps(element) {
    return element.props;
}
/**
 * Throws a helpful error message for required properties. Useful
 * to be used as a default in destructuring or object params.
 * @param {String} fnName the function name
 * @param {String} propName the prop name
 */ function $f4c8705b32f2a63d$var$requiredProp(fnName, propName) {
    // eslint-disable-next-line no-console
    console.error("The property \"" + propName + "\" is required in \"" + fnName + "\"");
}
var $f4c8705b32f2a63d$var$stateKeys = [
    'highlightedIndex',
    'inputValue',
    'isOpen',
    'selectedItem',
    'type'
];
/**
 * @param {Object} state the state object
 * @return {Object} state that is relevant to downshift
 */ function $f4c8705b32f2a63d$var$pickState(state) {
    if (state === void 0) state = {};
    var result = {};
    $f4c8705b32f2a63d$var$stateKeys.forEach(function(k) {
        if (state.hasOwnProperty(k)) result[k] = state[k];
    });
    return result;
}
/**
 * This will perform a shallow merge of the given state object
 * with the state coming from props
 * (for the controlled component scenario)
 * This is used in state updater functions so they're referencing
 * the right state regardless of where it comes from.
 *
 * @param {Object} state The state of the component/hook.
 * @param {Object} props The props that may contain controlled values.
 * @returns {Object} The merged controlled state.
 */ function $f4c8705b32f2a63d$var$getState(state, props) {
    if (!state || !props) return state;
    return Object.keys(state).reduce(function(prevState, key) {
        prevState[key] = $f4c8705b32f2a63d$var$isControlledProp(props, key) ? props[key] : state[key];
        return prevState;
    }, {});
}
/**
 * This determines whether a prop is a "controlled prop" meaning it is
 * state which is controlled by the outside of this component rather
 * than within this component.
 *
 * @param {Object} props The props that may contain controlled values.
 * @param {String} key the key to check
 * @return {Boolean} whether it is a controlled controlled prop
 */ function $f4c8705b32f2a63d$var$isControlledProp(props, key) {
    return props[key] !== undefined;
}
/**
 * Normalizes the 'key' property of a KeyboardEvent in IE/Edge
 * @param {Object} event a keyboardEvent object
 * @return {String} keyboard key
 */ function $f4c8705b32f2a63d$var$normalizeArrowKey(event) {
    var key = event.key, keyCode = event.keyCode;
    /* istanbul ignore next (ie) */ if (keyCode >= 37 && keyCode <= 40 && key.indexOf('Arrow') !== 0) return "Arrow" + key;
    return key;
}
/**
 * Simple check if the value passed is object literal
 * @param {*} obj any things
 * @return {Boolean} whether it's object literal
 */ function $f4c8705b32f2a63d$var$isPlainObject(obj) {
    return Object.prototype.toString.call(obj) === '[object Object]';
}
/**
 * Returns the next non-disabled highlightedIndex value.
 *
 * @param {number} start The current highlightedIndex.
 * @param {number} offset The offset from the current highlightedIndex to start searching.
 * @param {unknown[]} items The items array.
 * @param {(item: unknown, index: number) => boolean} isItemDisabled Function that tells if an item is disabled or not.
 * @param {boolean?} circular If the search reaches the end, if it can search again starting from the other end.
 * @returns {number} The next highlightedIndex.
 */ function $f4c8705b32f2a63d$var$getHighlightedIndex(start, offset, items, isItemDisabled, circular) {
    if (circular === void 0) circular = false;
    var count = items.length;
    if (count === 0) return -1;
    var itemsLastIndex = count - 1;
    if (typeof start !== 'number' || start < 0 || start > itemsLastIndex) start = offset > 0 ? -1 : itemsLastIndex + 1;
    var current = start + offset;
    if (current < 0) current = circular ? itemsLastIndex : 0;
    else if (current > itemsLastIndex) current = circular ? 0 : itemsLastIndex;
    var highlightedIndex = $f4c8705b32f2a63d$var$getNonDisabledIndex(current, offset < 0, items, isItemDisabled, circular);
    if (highlightedIndex === -1) return start >= count ? -1 : start;
    return highlightedIndex;
}
/**
 * Returns the next non-disabled highlightedIndex value.
 *
 * @param {number} start The current highlightedIndex.
 * @param {boolean} backwards If true, it will search backwards from the start.
 * @param {unknown[]} items The items array.
 * @param {(item: unknown, index: number) => boolean} isItemDisabled Function that tells if an item is disabled or not.
 * @param {boolean} circular If the search reaches the end, if it can search again starting from the other end.
 * @returns {number} The next non-disabled index.
 */ function $f4c8705b32f2a63d$var$getNonDisabledIndex(start, backwards, items, isItemDisabled, circular) {
    if (circular === void 0) circular = false;
    var count = items.length;
    if (backwards) for(var index = start; index >= 0; index--){
        if (!isItemDisabled(items[index], index)) return index;
    }
    else for(var _index = start; _index < count; _index++){
        if (!isItemDisabled(items[_index], _index)) return _index;
    }
    if (circular) return $f4c8705b32f2a63d$var$getNonDisabledIndex(backwards ? count - 1 : 0, backwards, items, isItemDisabled);
    return -1;
}
/**
 * Checks if event target is within the downshift elements.
 *
 * @param {EventTarget} target Target to check.
 * @param {HTMLElement[]} downshiftElements The elements that form downshift (list, toggle button etc).
 * @param {Window} environment The window context where downshift renders.
 * @param {boolean} checkActiveElement Whether to also check activeElement.
 *
 * @returns {boolean} Whether or not the target is within downshift elements.
 */ function $f4c8705b32f2a63d$var$targetWithinDownshift(target, downshiftElements, environment, checkActiveElement) {
    if (checkActiveElement === void 0) checkActiveElement = true;
    return environment && downshiftElements.some(function(contextNode) {
        return contextNode && ($f4c8705b32f2a63d$var$isOrContainsNode(contextNode, target, environment) || checkActiveElement && $f4c8705b32f2a63d$var$isOrContainsNode(contextNode, environment.document.activeElement, environment));
    });
}
// eslint-disable-next-line import/no-mutable-exports
var $f4c8705b32f2a63d$var$validateControlledUnchanged = $f4c8705b32f2a63d$var$noop;
var $f4c8705b32f2a63d$var$cleanupStatus = $f4c8705b32f2a63d$var$debounce(function(documentProp) {
    $f4c8705b32f2a63d$var$getStatusDiv(documentProp).textContent = '';
}, 500);
/**
 * Get the status node or create it if it does not already exist.
 * @param {Object} documentProp document passed by the user.
 * @return {HTMLElement} the status node.
 */ function $f4c8705b32f2a63d$var$getStatusDiv(documentProp) {
    var statusDiv = documentProp.getElementById('a11y-status-message');
    if (statusDiv) return statusDiv;
    statusDiv = documentProp.createElement('div');
    statusDiv.setAttribute('id', 'a11y-status-message');
    statusDiv.setAttribute('role', 'status');
    statusDiv.setAttribute('aria-live', 'polite');
    statusDiv.setAttribute('aria-relevant', 'additions text');
    Object.assign(statusDiv.style, {
        border: '0',
        clip: 'rect(0 0 0 0)',
        height: '1px',
        margin: '-1px',
        overflow: 'hidden',
        padding: '0',
        position: 'absolute',
        width: '1px'
    });
    documentProp.body.appendChild(statusDiv);
    return statusDiv;
}
/**
 * @param {String} status the status message
 * @param {Object} documentProp document passed by the user.
 */ function $f4c8705b32f2a63d$var$setStatus(status, documentProp) {
    if (!status || !documentProp) return;
    var div = $f4c8705b32f2a63d$var$getStatusDiv(documentProp);
    div.textContent = status;
    $f4c8705b32f2a63d$var$cleanupStatus(documentProp);
}
/**
 * Removes the status element from the DOM
 * @param {Document} documentProp 
 */ function $f4c8705b32f2a63d$var$cleanupStatusDiv(documentProp) {
    var statusDiv = documentProp == null ? void 0 : documentProp.getElementById('a11y-status-message');
    if (statusDiv) statusDiv.remove();
}
var $f4c8705b32f2a63d$var$unknown = 0;
var $f4c8705b32f2a63d$var$mouseUp = 1;
var $f4c8705b32f2a63d$var$itemMouseEnter = 2;
var $f4c8705b32f2a63d$var$keyDownArrowUp = 3;
var $f4c8705b32f2a63d$var$keyDownArrowDown = 4;
var $f4c8705b32f2a63d$var$keyDownEscape = 5;
var $f4c8705b32f2a63d$var$keyDownEnter = 6;
var $f4c8705b32f2a63d$var$keyDownHome = 7;
var $f4c8705b32f2a63d$var$keyDownEnd = 8;
var $f4c8705b32f2a63d$var$clickItem = 9;
var $f4c8705b32f2a63d$var$blurInput = 10;
var $f4c8705b32f2a63d$var$changeInput = 11;
var $f4c8705b32f2a63d$var$keyDownSpaceButton = 12;
var $f4c8705b32f2a63d$var$clickButton = 13;
var $f4c8705b32f2a63d$var$blurButton = 14;
var $f4c8705b32f2a63d$var$controlledPropUpdatedSelectedItem = 15;
var $f4c8705b32f2a63d$var$touchEnd = 16;
var $f4c8705b32f2a63d$var$stateChangeTypes$3 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    blurButton: $f4c8705b32f2a63d$var$blurButton,
    blurInput: $f4c8705b32f2a63d$var$blurInput,
    changeInput: $f4c8705b32f2a63d$var$changeInput,
    clickButton: $f4c8705b32f2a63d$var$clickButton,
    clickItem: $f4c8705b32f2a63d$var$clickItem,
    controlledPropUpdatedSelectedItem: $f4c8705b32f2a63d$var$controlledPropUpdatedSelectedItem,
    itemMouseEnter: $f4c8705b32f2a63d$var$itemMouseEnter,
    keyDownArrowDown: $f4c8705b32f2a63d$var$keyDownArrowDown,
    keyDownArrowUp: $f4c8705b32f2a63d$var$keyDownArrowUp,
    keyDownEnd: $f4c8705b32f2a63d$var$keyDownEnd,
    keyDownEnter: $f4c8705b32f2a63d$var$keyDownEnter,
    keyDownEscape: $f4c8705b32f2a63d$var$keyDownEscape,
    keyDownHome: $f4c8705b32f2a63d$var$keyDownHome,
    keyDownSpaceButton: $f4c8705b32f2a63d$var$keyDownSpaceButton,
    mouseUp: $f4c8705b32f2a63d$var$mouseUp,
    touchEnd: $f4c8705b32f2a63d$var$touchEnd,
    unknown: $f4c8705b32f2a63d$var$unknown
});
var $f4c8705b32f2a63d$var$_excluded$3 = [
    "refKey",
    "ref"
], $f4c8705b32f2a63d$var$_excluded2$3 = [
    "onClick",
    "onPress",
    "onKeyDown",
    "onKeyUp",
    "onBlur"
], $f4c8705b32f2a63d$var$_excluded3$2 = [
    "onKeyDown",
    "onBlur",
    "onChange",
    "onInput",
    "onChangeText"
], $f4c8705b32f2a63d$var$_excluded4$2 = [
    "refKey",
    "ref"
], $f4c8705b32f2a63d$var$_excluded5 = [
    "onMouseMove",
    "onMouseDown",
    "onClick",
    "onPress",
    "index",
    "item"
];
var $f4c8705b32f2a63d$var$Downshift = /*#__PURE__*/ function() {
    var Downshift = /*#__PURE__*/ function(_Component) {
        function Downshift(_props) {
            var _this;
            _this = _Component.call(this, _props) || this;
            // fancy destructuring + defaults + aliases
            // this basically says each value of state should either be set to
            // the initial value or the default value if the initial value is not provided
            _this.id = _this.props.id || "downshift-" + $f4c8705b32f2a63d$var$generateId();
            _this.menuId = _this.props.menuId || _this.id + "-menu";
            _this.labelId = _this.props.labelId || _this.id + "-label";
            _this.inputId = _this.props.inputId || _this.id + "-input";
            _this.getItemId = _this.props.getItemId || function(index) {
                return _this.id + "-item-" + index;
            };
            _this.items = [];
            // itemCount can be changed asynchronously
            // from within downshift (so it can't come from a prop)
            // this is why we store it as an instance and use
            // getItemCount rather than just use items.length
            // (to support windowing + async)
            _this.itemCount = null;
            _this.previousResultCount = 0;
            _this.timeoutIds = [];
            /**
       * @param {Function} fn the function to call after the time
       * @param {Number} time the time to wait
       */ _this.internalSetTimeout = function(fn, time) {
                var id = setTimeout(function() {
                    _this.timeoutIds = _this.timeoutIds.filter(function(i) {
                        return i !== id;
                    });
                    fn();
                }, time);
                _this.timeoutIds.push(id);
            };
            _this.setItemCount = function(count) {
                _this.itemCount = count;
            };
            _this.unsetItemCount = function() {
                _this.itemCount = null;
            };
            _this.isItemDisabled = function(_item, index) {
                var currentElementNode = _this.getItemNodeFromIndex(index);
                return currentElementNode && currentElementNode.hasAttribute('disabled');
            };
            _this.setHighlightedIndex = function(highlightedIndex, otherStateToSet) {
                if (highlightedIndex === void 0) highlightedIndex = _this.props.defaultHighlightedIndex;
                if (otherStateToSet === void 0) otherStateToSet = {};
                otherStateToSet = $f4c8705b32f2a63d$var$pickState(otherStateToSet);
                _this.internalSetState((0, $e3e49ed681292e30$export$2e2bcd8739ae039)({
                    highlightedIndex: highlightedIndex
                }, otherStateToSet));
            };
            _this.clearSelection = function(cb) {
                _this.internalSetState({
                    selectedItem: null,
                    inputValue: '',
                    highlightedIndex: _this.props.defaultHighlightedIndex,
                    isOpen: _this.props.defaultIsOpen
                }, cb);
            };
            _this.selectItem = function(item, otherStateToSet, cb) {
                otherStateToSet = $f4c8705b32f2a63d$var$pickState(otherStateToSet);
                _this.internalSetState((0, $e3e49ed681292e30$export$2e2bcd8739ae039)({
                    isOpen: _this.props.defaultIsOpen,
                    highlightedIndex: _this.props.defaultHighlightedIndex,
                    selectedItem: item,
                    inputValue: _this.props.itemToString(item)
                }, otherStateToSet), cb);
            };
            _this.selectItemAtIndex = function(itemIndex, otherStateToSet, cb) {
                var item = _this.items[itemIndex];
                if (item == null) return;
                _this.selectItem(item, otherStateToSet, cb);
            };
            _this.selectHighlightedItem = function(otherStateToSet, cb) {
                return _this.selectItemAtIndex(_this.getState().highlightedIndex, otherStateToSet, cb);
            };
            // any piece of our state can live in two places:
            // 1. Uncontrolled: it's internal (this.state)
            //    We will call this.setState to update that state
            // 2. Controlled: it's external (this.props)
            //    We will call this.props.onStateChange to update that state
            //
            // In addition, we'll call this.props.onChange if the
            // selectedItem is changed.
            _this.internalSetState = function(stateToSet, cb) {
                var isItemSelected, onChangeArg;
                var onStateChangeArg = {};
                var isStateToSetFunction = typeof stateToSet === 'function';
                // we want to call `onInputValueChange` before the `setState` call
                // so someone controlling the `inputValue` state gets notified of
                // the input change as soon as possible. This avoids issues with
                // preserving the cursor position.
                // See https://github.com/downshift-js/downshift/issues/217 for more info.
                if (!isStateToSetFunction && stateToSet.hasOwnProperty('inputValue')) _this.props.onInputValueChange(stateToSet.inputValue, (0, $e3e49ed681292e30$export$2e2bcd8739ae039)({}, _this.getStateAndHelpers(), stateToSet));
                return _this.setState(function(state) {
                    var _newStateToSet;
                    state = _this.getState(state);
                    var newStateToSet = isStateToSetFunction ? stateToSet(state) : stateToSet;
                    // Your own function that could modify the state that will be set.
                    newStateToSet = _this.props.stateReducer(state, newStateToSet);
                    // checks if an item is selected, regardless of if it's different from
                    // what was selected before
                    // used to determine if onSelect and onChange callbacks should be called
                    isItemSelected = newStateToSet.hasOwnProperty('selectedItem');
                    // this keeps track of the object we want to call with setState
                    var nextState = {};
                    // we need to call on change if the outside world is controlling any of our state
                    // and we're trying to update that state. OR if the selection has changed and we're
                    // trying to update the selection
                    if (isItemSelected && newStateToSet.selectedItem !== state.selectedItem) onChangeArg = newStateToSet.selectedItem;
                    (_newStateToSet = newStateToSet).type || (_newStateToSet.type = $f4c8705b32f2a63d$var$unknown);
                    Object.keys(newStateToSet).forEach(function(key) {
                        // onStateChangeArg should only have the state that is
                        // actually changing
                        if (state[key] !== newStateToSet[key]) onStateChangeArg[key] = newStateToSet[key];
                        // the type is useful for the onStateChangeArg
                        // but we don't actually want to set it in internal state.
                        // this is an undocumented feature for now... Not all internalSetState
                        // calls support it and I'm not certain we want them to yet.
                        // But it enables users controlling the isOpen state to know when
                        // the isOpen state changes due to mouseup events which is quite handy.
                        if (key === 'type') return;
                        newStateToSet[key];
                        // if it's coming from props, then we don't care to set it internally
                        if (!$f4c8705b32f2a63d$var$isControlledProp(_this.props, key)) nextState[key] = newStateToSet[key];
                    });
                    // if stateToSet is a function, then we weren't able to call onInputValueChange
                    // earlier, so we'll call it now that we know what the inputValue state will be.
                    if (isStateToSetFunction && newStateToSet.hasOwnProperty('inputValue')) _this.props.onInputValueChange(newStateToSet.inputValue, (0, $e3e49ed681292e30$export$2e2bcd8739ae039)({}, _this.getStateAndHelpers(), newStateToSet));
                    return nextState;
                }, function() {
                    // call the provided callback if it's a function
                    $f4c8705b32f2a63d$var$cbToCb(cb)();
                    // only call the onStateChange and onChange callbacks if
                    // we have relevant information to pass them.
                    var hasMoreStateThanType = Object.keys(onStateChangeArg).length > 1;
                    if (hasMoreStateThanType) _this.props.onStateChange(onStateChangeArg, _this.getStateAndHelpers());
                    if (isItemSelected) _this.props.onSelect(stateToSet.selectedItem, _this.getStateAndHelpers());
                    if (onChangeArg !== undefined) _this.props.onChange(onChangeArg, _this.getStateAndHelpers());
                    // this is currently undocumented and therefore subject to change
                    // We'll try to not break it, but just be warned.
                    _this.props.onUserAction(onStateChangeArg, _this.getStateAndHelpers());
                });
            };
            //////////////////////////// ROOT
            _this.rootRef = function(node) {
                return _this._rootNode = node;
            };
            _this.getRootProps = function(_temp, _temp2) {
                var _extends2;
                var _ref = _temp === void 0 ? {} : _temp, _ref$refKey = _ref.refKey, refKey = _ref$refKey === void 0 ? 'ref' : _ref$refKey, ref = _ref.ref, rest = (0, $cfde373be945f92b$export$2e2bcd8739ae039)(_ref, $f4c8705b32f2a63d$var$_excluded$3);
                var _ref2 = _temp2 === void 0 ? {} : _temp2, _ref2$suppressRefErro = _ref2.suppressRefError, suppressRefError = _ref2$suppressRefErro === void 0 ? false : _ref2$suppressRefErro;
                // this is used in the render to know whether the user has called getRootProps.
                // It uses that to know whether to apply the props automatically
                _this.getRootProps.called = true;
                _this.getRootProps.refKey = refKey;
                _this.getRootProps.suppressRefError = suppressRefError;
                var _this$getState = _this.getState(), isOpen = _this$getState.isOpen;
                return (0, $e3e49ed681292e30$export$2e2bcd8739ae039)((_extends2 = {}, _extends2[refKey] = $f4c8705b32f2a63d$var$handleRefs(ref, _this.rootRef), _extends2.role = 'combobox', _extends2['aria-expanded'] = isOpen, _extends2['aria-haspopup'] = 'listbox', _extends2['aria-owns'] = isOpen ? _this.menuId : undefined, _extends2['aria-labelledby'] = _this.labelId, _extends2), rest);
            };
            //\\\\\\\\\\\\\\\\\\\\\\\\\\ ROOT
            _this.keyDownHandlers = {
                ArrowDown: function ArrowDown(event) {
                    var _this2 = this;
                    event.preventDefault();
                    if (this.getState().isOpen) {
                        var amount = event.shiftKey ? 5 : 1;
                        this.moveHighlightedIndex(amount, {
                            type: $f4c8705b32f2a63d$var$keyDownArrowDown
                        });
                    } else this.internalSetState({
                        isOpen: true,
                        type: $f4c8705b32f2a63d$var$keyDownArrowDown
                    }, function() {
                        var itemCount = _this2.getItemCount();
                        if (itemCount > 0) {
                            var _this2$getState = _this2.getState(), highlightedIndex = _this2$getState.highlightedIndex;
                            var nextHighlightedIndex = $f4c8705b32f2a63d$var$getHighlightedIndex(highlightedIndex, 1, {
                                length: itemCount
                            }, _this2.isItemDisabled, true);
                            _this2.setHighlightedIndex(nextHighlightedIndex, {
                                type: $f4c8705b32f2a63d$var$keyDownArrowDown
                            });
                        }
                    });
                },
                ArrowUp: function ArrowUp(event) {
                    var _this3 = this;
                    event.preventDefault();
                    if (this.getState().isOpen) {
                        var amount = event.shiftKey ? -5 : -1;
                        this.moveHighlightedIndex(amount, {
                            type: $f4c8705b32f2a63d$var$keyDownArrowUp
                        });
                    } else this.internalSetState({
                        isOpen: true,
                        type: $f4c8705b32f2a63d$var$keyDownArrowUp
                    }, function() {
                        var itemCount = _this3.getItemCount();
                        if (itemCount > 0) {
                            var _this3$getState = _this3.getState(), highlightedIndex = _this3$getState.highlightedIndex;
                            var nextHighlightedIndex = $f4c8705b32f2a63d$var$getHighlightedIndex(highlightedIndex, -1, {
                                length: itemCount
                            }, _this3.isItemDisabled, true);
                            _this3.setHighlightedIndex(nextHighlightedIndex, {
                                type: $f4c8705b32f2a63d$var$keyDownArrowUp
                            });
                        }
                    });
                },
                Enter: function Enter(event) {
                    if (event.which === 229) return;
                    var _this$getState2 = this.getState(), isOpen = _this$getState2.isOpen, highlightedIndex = _this$getState2.highlightedIndex;
                    if (isOpen && highlightedIndex != null) {
                        event.preventDefault();
                        var item = this.items[highlightedIndex];
                        var itemNode = this.getItemNodeFromIndex(highlightedIndex);
                        if (item == null || itemNode && itemNode.hasAttribute('disabled')) return;
                        this.selectHighlightedItem({
                            type: $f4c8705b32f2a63d$var$keyDownEnter
                        });
                    }
                },
                Escape: function Escape(event) {
                    event.preventDefault();
                    this.reset((0, $e3e49ed681292e30$export$2e2bcd8739ae039)({
                        type: $f4c8705b32f2a63d$var$keyDownEscape
                    }, !this.state.isOpen && {
                        selectedItem: null,
                        inputValue: ''
                    }));
                }
            };
            //////////////////////////// BUTTON
            _this.buttonKeyDownHandlers = (0, $e3e49ed681292e30$export$2e2bcd8739ae039)({}, _this.keyDownHandlers, {
                ' ': function _(event) {
                    event.preventDefault();
                    this.toggleMenu({
                        type: $f4c8705b32f2a63d$var$keyDownSpaceButton
                    });
                }
            });
            _this.inputKeyDownHandlers = (0, $e3e49ed681292e30$export$2e2bcd8739ae039)({}, _this.keyDownHandlers, {
                Home: function Home(event) {
                    var _this$getState3 = this.getState(), isOpen = _this$getState3.isOpen;
                    if (!isOpen) return;
                    event.preventDefault();
                    var itemCount = this.getItemCount();
                    if (itemCount <= 0 || !isOpen) return;
                    // get next non-disabled starting downwards from 0 if that's disabled.
                    var newHighlightedIndex = $f4c8705b32f2a63d$var$getNonDisabledIndex(0, false, {
                        length: itemCount
                    }, this.isItemDisabled);
                    this.setHighlightedIndex(newHighlightedIndex, {
                        type: $f4c8705b32f2a63d$var$keyDownHome
                    });
                },
                End: function End(event) {
                    var _this$getState4 = this.getState(), isOpen = _this$getState4.isOpen;
                    if (!isOpen) return;
                    event.preventDefault();
                    var itemCount = this.getItemCount();
                    if (itemCount <= 0 || !isOpen) return;
                    // get next non-disabled starting upwards from last index if that's disabled.
                    var newHighlightedIndex = $f4c8705b32f2a63d$var$getNonDisabledIndex(itemCount - 1, true, {
                        length: itemCount
                    }, this.isItemDisabled);
                    this.setHighlightedIndex(newHighlightedIndex, {
                        type: $f4c8705b32f2a63d$var$keyDownEnd
                    });
                }
            });
            _this.getToggleButtonProps = function(_temp3) {
                var _ref3 = _temp3 === void 0 ? {} : _temp3, onClick = _ref3.onClick;
                _ref3.onPress;
                var onKeyDown = _ref3.onKeyDown, onKeyUp = _ref3.onKeyUp, onBlur = _ref3.onBlur, rest = (0, $cfde373be945f92b$export$2e2bcd8739ae039)(_ref3, $f4c8705b32f2a63d$var$_excluded2$3);
                var _this$getState5 = _this.getState(), isOpen = _this$getState5.isOpen;
                var enabledEventHandlers = {
                    onClick: $f4c8705b32f2a63d$var$callAllEventHandlers(onClick, _this.buttonHandleClick),
                    onKeyDown: $f4c8705b32f2a63d$var$callAllEventHandlers(onKeyDown, _this.buttonHandleKeyDown),
                    onKeyUp: $f4c8705b32f2a63d$var$callAllEventHandlers(onKeyUp, _this.buttonHandleKeyUp),
                    onBlur: $f4c8705b32f2a63d$var$callAllEventHandlers(onBlur, _this.buttonHandleBlur)
                };
                var eventHandlers = rest.disabled ? {} : enabledEventHandlers;
                return (0, $e3e49ed681292e30$export$2e2bcd8739ae039)({
                    type: 'button',
                    role: 'button',
                    'aria-label': isOpen ? 'close menu' : 'open menu',
                    'aria-haspopup': true,
                    'data-toggle': true
                }, eventHandlers, rest);
            };
            _this.buttonHandleKeyUp = function(event) {
                // Prevent click event from emitting in Firefox
                event.preventDefault();
            };
            _this.buttonHandleKeyDown = function(event) {
                var key = $f4c8705b32f2a63d$var$normalizeArrowKey(event);
                if (_this.buttonKeyDownHandlers[key]) _this.buttonKeyDownHandlers[key].call(_this, event);
            };
            _this.buttonHandleClick = function(event) {
                event.preventDefault();
                // handle odd case for Safari and Firefox which
                // don't give the button the focus properly.
                /* istanbul ignore if (can't reasonably test this) */ if (_this.props.environment) {
                    var _this$props$environme = _this.props.environment.document, body = _this$props$environme.body, activeElement = _this$props$environme.activeElement;
                    if (body && body === activeElement) event.target.focus();
                }
                // Ensure that toggle of menu occurs after the potential blur event in iOS
                _this.internalSetTimeout(function() {
                    return _this.toggleMenu({
                        type: $f4c8705b32f2a63d$var$clickButton
                    });
                });
            };
            _this.buttonHandleBlur = function(event) {
                var blurTarget = event.target; // Save blur target for comparison with activeElement later
                // Need setTimeout, so that when the user presses Tab, the activeElement is the next focused element, not body element
                _this.internalSetTimeout(function() {
                    if (_this.isMouseDown || !_this.props.environment) return;
                    var activeElement = _this.props.environment.document.activeElement;
                    if ((activeElement == null || activeElement.id !== _this.inputId) && activeElement !== blurTarget // Do nothing if we refocus the same element again (to solve issue in Safari on iOS)
                    ) _this.reset({
                        type: $f4c8705b32f2a63d$var$blurButton
                    });
                });
            };
            //\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ BUTTON
            /////////////////////////////// LABEL
            _this.getLabelProps = function(props) {
                return (0, $e3e49ed681292e30$export$2e2bcd8739ae039)({
                    htmlFor: _this.inputId,
                    id: _this.labelId
                }, props);
            };
            //\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ LABEL
            /////////////////////////////// INPUT
            _this.getInputProps = function(_temp4) {
                var _ref4 = _temp4 === void 0 ? {} : _temp4, onKeyDown = _ref4.onKeyDown, onBlur = _ref4.onBlur, onChange = _ref4.onChange, onInput = _ref4.onInput;
                _ref4.onChangeText;
                var rest = (0, $cfde373be945f92b$export$2e2bcd8739ae039)(_ref4, $f4c8705b32f2a63d$var$_excluded3$2);
                var onChangeKey;
                var eventHandlers = {};
                onChangeKey = 'onChange';
                var _this$getState6 = _this.getState(), inputValue = _this$getState6.inputValue, isOpen = _this$getState6.isOpen, highlightedIndex = _this$getState6.highlightedIndex;
                if (!rest.disabled) {
                    var _eventHandlers;
                    eventHandlers = (_eventHandlers = {}, _eventHandlers[onChangeKey] = $f4c8705b32f2a63d$var$callAllEventHandlers(onChange, onInput, _this.inputHandleChange), _eventHandlers.onKeyDown = $f4c8705b32f2a63d$var$callAllEventHandlers(onKeyDown, _this.inputHandleKeyDown), _eventHandlers.onBlur = $f4c8705b32f2a63d$var$callAllEventHandlers(onBlur, _this.inputHandleBlur), _eventHandlers);
                }
                return (0, $e3e49ed681292e30$export$2e2bcd8739ae039)({
                    'aria-autocomplete': 'list',
                    'aria-activedescendant': isOpen && typeof highlightedIndex === 'number' && highlightedIndex >= 0 ? _this.getItemId(highlightedIndex) : undefined,
                    'aria-controls': isOpen ? _this.menuId : undefined,
                    'aria-labelledby': rest && rest['aria-label'] ? undefined : _this.labelId,
                    // https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
                    // revert back since autocomplete="nope" is ignored on latest Chrome and Opera
                    autoComplete: 'off',
                    value: inputValue,
                    id: _this.inputId
                }, eventHandlers, rest);
            };
            _this.inputHandleKeyDown = function(event) {
                var key = $f4c8705b32f2a63d$var$normalizeArrowKey(event);
                if (key && _this.inputKeyDownHandlers[key]) _this.inputKeyDownHandlers[key].call(_this, event);
            };
            _this.inputHandleChange = function(event) {
                _this.internalSetState({
                    type: $f4c8705b32f2a63d$var$changeInput,
                    isOpen: true,
                    inputValue: event.target.value,
                    highlightedIndex: _this.props.defaultHighlightedIndex
                });
            };
            _this.inputHandleBlur = function() {
                // Need setTimeout, so that when the user presses Tab, the activeElement is the next focused element, not the body element
                _this.internalSetTimeout(function() {
                    var _activeElement$datase;
                    if (_this.isMouseDown || !_this.props.environment) return;
                    var activeElement = _this.props.environment.document.activeElement;
                    var downshiftButtonIsActive = (activeElement == null || (_activeElement$datase = activeElement.dataset) == null ? void 0 : _activeElement$datase.toggle) && _this._rootNode && _this._rootNode.contains(activeElement);
                    if (!downshiftButtonIsActive) _this.reset({
                        type: $f4c8705b32f2a63d$var$blurInput
                    });
                });
            };
            //\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ INPUT
            /////////////////////////////// MENU
            _this.menuRef = function(node) {
                _this._menuNode = node;
            };
            _this.getMenuProps = function(_temp5, _temp6) {
                var _extends3;
                var _ref5 = _temp5 === void 0 ? {} : _temp5, _ref5$refKey = _ref5.refKey, refKey = _ref5$refKey === void 0 ? 'ref' : _ref5$refKey, ref = _ref5.ref, props = (0, $cfde373be945f92b$export$2e2bcd8739ae039)(_ref5, $f4c8705b32f2a63d$var$_excluded4$2);
                var _ref6 = _temp6 === void 0 ? {} : _temp6, _ref6$suppressRefErro = _ref6.suppressRefError, suppressRefError = _ref6$suppressRefErro === void 0 ? false : _ref6$suppressRefErro;
                _this.getMenuProps.called = true;
                _this.getMenuProps.refKey = refKey;
                _this.getMenuProps.suppressRefError = suppressRefError;
                return (0, $e3e49ed681292e30$export$2e2bcd8739ae039)((_extends3 = {}, _extends3[refKey] = $f4c8705b32f2a63d$var$handleRefs(ref, _this.menuRef), _extends3.role = 'listbox', _extends3['aria-labelledby'] = props && props['aria-label'] ? undefined : _this.labelId, _extends3.id = _this.menuId, _extends3), props);
            };
            //\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ MENU
            /////////////////////////////// ITEM
            _this.getItemProps = function(_temp7) {
                var _enabledEventHandlers;
                var _ref7 = _temp7 === void 0 ? {} : _temp7, onMouseMove = _ref7.onMouseMove, onMouseDown = _ref7.onMouseDown, onClick = _ref7.onClick;
                _ref7.onPress;
                var index = _ref7.index, _ref7$item = _ref7.item, item = _ref7$item === void 0 ? /* istanbul ignore next */ undefined : _ref7$item, rest = (0, $cfde373be945f92b$export$2e2bcd8739ae039)(_ref7, $f4c8705b32f2a63d$var$_excluded5);
                if (index === undefined) {
                    _this.items.push(item);
                    index = _this.items.indexOf(item);
                } else _this.items[index] = item;
                var onSelectKey = 'onClick';
                var customClickHandler = onClick;
                var enabledEventHandlers = (_enabledEventHandlers = {
                    // onMouseMove is used over onMouseEnter here. onMouseMove
                    // is only triggered on actual mouse movement while onMouseEnter
                    // can fire on DOM changes, interrupting keyboard navigation
                    onMouseMove: $f4c8705b32f2a63d$var$callAllEventHandlers(onMouseMove, function() {
                        if (index === _this.getState().highlightedIndex) return;
                        _this.setHighlightedIndex(index, {
                            type: $f4c8705b32f2a63d$var$itemMouseEnter
                        });
                        // We never want to manually scroll when changing state based
                        // on `onMouseMove` because we will be moving the element out
                        // from under the user which is currently scrolling/moving the
                        // cursor
                        _this.avoidScrolling = true;
                        _this.internalSetTimeout(function() {
                            return _this.avoidScrolling = false;
                        }, 250);
                    }),
                    onMouseDown: $f4c8705b32f2a63d$var$callAllEventHandlers(onMouseDown, function(event) {
                        // This prevents the activeElement from being changed
                        // to the item so it can remain with the current activeElement
                        // which is a more common use case.
                        event.preventDefault();
                    })
                }, _enabledEventHandlers[onSelectKey] = $f4c8705b32f2a63d$var$callAllEventHandlers(customClickHandler, function() {
                    _this.selectItemAtIndex(index, {
                        type: $f4c8705b32f2a63d$var$clickItem
                    });
                }), _enabledEventHandlers);
                // Passing down the onMouseDown handler to prevent redirect
                // of the activeElement if clicking on disabled items
                var eventHandlers = rest.disabled ? {
                    onMouseDown: enabledEventHandlers.onMouseDown
                } : enabledEventHandlers;
                return (0, $e3e49ed681292e30$export$2e2bcd8739ae039)({
                    id: _this.getItemId(index),
                    role: 'option',
                    'aria-selected': _this.getState().highlightedIndex === index
                }, eventHandlers, rest);
            };
            //\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ ITEM
            _this.clearItems = function() {
                _this.items = [];
            };
            _this.reset = function(otherStateToSet, cb) {
                if (otherStateToSet === void 0) otherStateToSet = {};
                otherStateToSet = $f4c8705b32f2a63d$var$pickState(otherStateToSet);
                _this.internalSetState(function(_ref8) {
                    var selectedItem = _ref8.selectedItem;
                    return (0, $e3e49ed681292e30$export$2e2bcd8739ae039)({
                        isOpen: _this.props.defaultIsOpen,
                        highlightedIndex: _this.props.defaultHighlightedIndex,
                        inputValue: _this.props.itemToString(selectedItem)
                    }, otherStateToSet);
                }, cb);
            };
            _this.toggleMenu = function(otherStateToSet, cb) {
                if (otherStateToSet === void 0) otherStateToSet = {};
                otherStateToSet = $f4c8705b32f2a63d$var$pickState(otherStateToSet);
                _this.internalSetState(function(_ref9) {
                    var isOpen = _ref9.isOpen;
                    return (0, $e3e49ed681292e30$export$2e2bcd8739ae039)({
                        isOpen: !isOpen
                    }, isOpen && {
                        highlightedIndex: _this.props.defaultHighlightedIndex
                    }, otherStateToSet);
                }, function() {
                    var _this$getState7 = _this.getState(), isOpen = _this$getState7.isOpen, highlightedIndex = _this$getState7.highlightedIndex;
                    if (isOpen) {
                        if (_this.getItemCount() > 0 && typeof highlightedIndex === 'number') _this.setHighlightedIndex(highlightedIndex, otherStateToSet);
                    }
                    $f4c8705b32f2a63d$var$cbToCb(cb)();
                });
            };
            _this.openMenu = function(cb) {
                _this.internalSetState({
                    isOpen: true
                }, cb);
            };
            _this.closeMenu = function(cb) {
                _this.internalSetState({
                    isOpen: false
                }, cb);
            };
            _this.updateStatus = $f4c8705b32f2a63d$var$debounce(function() {
                var _this$props;
                if (!((_this$props = _this.props) != null && (_this$props = _this$props.environment) != null && _this$props.document)) return;
                var state = _this.getState();
                var item = _this.items[state.highlightedIndex];
                var resultCount = _this.getItemCount();
                var status = _this.props.getA11yStatusMessage((0, $e3e49ed681292e30$export$2e2bcd8739ae039)({
                    itemToString: _this.props.itemToString,
                    previousResultCount: _this.previousResultCount,
                    resultCount: resultCount,
                    highlightedItem: item
                }, state));
                _this.previousResultCount = resultCount;
                $f4c8705b32f2a63d$var$setStatus(status, _this.props.environment.document);
            }, 200);
            var _this$props2 = _this.props, defaultHighlightedIndex = _this$props2.defaultHighlightedIndex, _this$props2$initialH = _this$props2.initialHighlightedIndex, _highlightedIndex = _this$props2$initialH === void 0 ? defaultHighlightedIndex : _this$props2$initialH, defaultIsOpen = _this$props2.defaultIsOpen, _this$props2$initialI = _this$props2.initialIsOpen, _isOpen = _this$props2$initialI === void 0 ? defaultIsOpen : _this$props2$initialI, _this$props2$initialI2 = _this$props2.initialInputValue, _inputValue = _this$props2$initialI2 === void 0 ? '' : _this$props2$initialI2, _this$props2$initialS = _this$props2.initialSelectedItem, _selectedItem = _this$props2$initialS === void 0 ? null : _this$props2$initialS;
            var _state = _this.getState({
                highlightedIndex: _highlightedIndex,
                isOpen: _isOpen,
                inputValue: _inputValue,
                selectedItem: _selectedItem
            });
            if (_state.selectedItem != null && _this.props.initialInputValue === undefined) _state.inputValue = _this.props.itemToString(_state.selectedItem);
            _this.state = _state;
            return _this;
        }
        (0, $c04286edcac4109a$export$2e2bcd8739ae039)(Downshift, _Component);
        var _proto = Downshift.prototype;
        /**
     * Clear all running timeouts
     */ _proto.internalClearTimeouts = function internalClearTimeouts() {
            this.timeoutIds.forEach(function(id) {
                clearTimeout(id);
            });
            this.timeoutIds = [];
        } /**
     * Gets the state based on internal state or props
     * If a state value is passed via props, then that
     * is the value given, otherwise it's retrieved from
     * stateToMerge
     *
     * @param {Object} stateToMerge defaults to this.state
     * @return {Object} the state
     */ ;
        _proto.getState = function getState$1(stateToMerge) {
            if (stateToMerge === void 0) stateToMerge = this.state;
            return $f4c8705b32f2a63d$var$getState(stateToMerge, this.props);
        };
        _proto.getItemCount = function getItemCount() {
            // things read better this way. They're in priority order:
            // 1. `this.itemCount`
            // 2. `this.props.itemCount`
            // 3. `this.items.length`
            var itemCount = this.items.length;
            if (this.itemCount != null) itemCount = this.itemCount;
            else if (this.props.itemCount !== undefined) itemCount = this.props.itemCount;
            return itemCount;
        };
        _proto.getItemNodeFromIndex = function getItemNodeFromIndex(index) {
            return this.props.environment ? this.props.environment.document.getElementById(this.getItemId(index)) : null;
        };
        _proto.scrollHighlightedItemIntoView = function scrollHighlightedItemIntoView() {
            var node = this.getItemNodeFromIndex(this.getState().highlightedIndex);
            this.props.scrollIntoView(node, this._menuNode);
        };
        _proto.moveHighlightedIndex = function moveHighlightedIndex(amount, otherStateToSet) {
            var itemCount = this.getItemCount();
            var _this$getState8 = this.getState(), highlightedIndex = _this$getState8.highlightedIndex;
            if (itemCount > 0) {
                var nextHighlightedIndex = $f4c8705b32f2a63d$var$getHighlightedIndex(highlightedIndex, amount, {
                    length: itemCount
                }, this.isItemDisabled, true);
                this.setHighlightedIndex(nextHighlightedIndex, otherStateToSet);
            }
        };
        _proto.getStateAndHelpers = function getStateAndHelpers() {
            var _this$getState9 = this.getState(), highlightedIndex = _this$getState9.highlightedIndex, inputValue = _this$getState9.inputValue, selectedItem = _this$getState9.selectedItem, isOpen = _this$getState9.isOpen;
            var itemToString = this.props.itemToString;
            var id = this.id;
            var getRootProps = this.getRootProps, getToggleButtonProps = this.getToggleButtonProps, getLabelProps = this.getLabelProps, getMenuProps = this.getMenuProps, getInputProps = this.getInputProps, getItemProps = this.getItemProps, openMenu = this.openMenu, closeMenu = this.closeMenu, toggleMenu = this.toggleMenu, selectItem = this.selectItem, selectItemAtIndex = this.selectItemAtIndex, selectHighlightedItem = this.selectHighlightedItem, setHighlightedIndex = this.setHighlightedIndex, clearSelection = this.clearSelection, clearItems = this.clearItems, reset = this.reset, setItemCount = this.setItemCount, unsetItemCount = this.unsetItemCount, setState = this.internalSetState;
            return {
                // prop getters
                getRootProps: getRootProps,
                getToggleButtonProps: getToggleButtonProps,
                getLabelProps: getLabelProps,
                getMenuProps: getMenuProps,
                getInputProps: getInputProps,
                getItemProps: getItemProps,
                // actions
                reset: reset,
                openMenu: openMenu,
                closeMenu: closeMenu,
                toggleMenu: toggleMenu,
                selectItem: selectItem,
                selectItemAtIndex: selectItemAtIndex,
                selectHighlightedItem: selectHighlightedItem,
                setHighlightedIndex: setHighlightedIndex,
                clearSelection: clearSelection,
                clearItems: clearItems,
                setItemCount: setItemCount,
                unsetItemCount: unsetItemCount,
                setState: setState,
                // props
                itemToString: itemToString,
                // derived
                id: id,
                // state
                highlightedIndex: highlightedIndex,
                inputValue: inputValue,
                isOpen: isOpen,
                selectedItem: selectedItem
            };
        };
        _proto.componentDidMount = function componentDidMount() {
            var _this4 = this;
            /* istanbul ignore if (react-native or SSR) */ if (!this.props.environment) this.cleanup = function() {
                _this4.internalClearTimeouts();
            };
            else {
                // this.isMouseDown helps us track whether the mouse is currently held down.
                // This is useful when the user clicks on an item in the list, but holds the mouse
                // down long enough for the list to disappear (because the blur event fires on the input)
                // this.isMouseDown is used in the blur handler on the input to determine whether the blur event should
                // trigger hiding the menu.
                var onMouseDown = function onMouseDown() {
                    _this4.isMouseDown = true;
                };
                var onMouseUp = function onMouseUp(event) {
                    _this4.isMouseDown = false;
                    // if the target element or the activeElement is within a downshift node
                    // then we don't want to reset downshift
                    var contextWithinDownshift = $f4c8705b32f2a63d$var$targetWithinDownshift(event.target, [
                        _this4._rootNode,
                        _this4._menuNode
                    ], _this4.props.environment);
                    if (!contextWithinDownshift && _this4.getState().isOpen) _this4.reset({
                        type: $f4c8705b32f2a63d$var$mouseUp
                    }, function() {
                        return _this4.props.onOuterClick(_this4.getStateAndHelpers());
                    });
                };
                // Touching an element in iOS gives focus and hover states, but touching out of
                // the element will remove hover, and persist the focus state, resulting in the
                // blur event not being triggered.
                // this.isTouchMove helps us track whether the user is tapping or swiping on a touch screen.
                // If the user taps outside of Downshift, the component should be reset,
                // but not if the user is swiping
                var onTouchStart = function onTouchStart() {
                    _this4.isTouchMove = false;
                };
                var onTouchMove = function onTouchMove() {
                    _this4.isTouchMove = true;
                };
                var onTouchEnd = function onTouchEnd(event) {
                    var contextWithinDownshift = $f4c8705b32f2a63d$var$targetWithinDownshift(event.target, [
                        _this4._rootNode,
                        _this4._menuNode
                    ], _this4.props.environment, false);
                    if (!_this4.isTouchMove && !contextWithinDownshift && _this4.getState().isOpen) _this4.reset({
                        type: $f4c8705b32f2a63d$var$touchEnd
                    }, function() {
                        return _this4.props.onOuterClick(_this4.getStateAndHelpers());
                    });
                };
                var environment = this.props.environment;
                environment.addEventListener('mousedown', onMouseDown);
                environment.addEventListener('mouseup', onMouseUp);
                environment.addEventListener('touchstart', onTouchStart);
                environment.addEventListener('touchmove', onTouchMove);
                environment.addEventListener('touchend', onTouchEnd);
                this.cleanup = function() {
                    _this4.internalClearTimeouts();
                    _this4.updateStatus.cancel();
                    environment.removeEventListener('mousedown', onMouseDown);
                    environment.removeEventListener('mouseup', onMouseUp);
                    environment.removeEventListener('touchstart', onTouchStart);
                    environment.removeEventListener('touchmove', onTouchMove);
                    environment.removeEventListener('touchend', onTouchEnd);
                };
            }
        };
        _proto.shouldScroll = function shouldScroll(prevState, prevProps) {
            var _ref10 = this.props.highlightedIndex === undefined ? this.getState() : this.props, currentHighlightedIndex = _ref10.highlightedIndex;
            var _ref11 = prevProps.highlightedIndex === undefined ? prevState : prevProps, prevHighlightedIndex = _ref11.highlightedIndex;
            var scrollWhenOpen = currentHighlightedIndex && this.getState().isOpen && !prevState.isOpen;
            var scrollWhenNavigating = currentHighlightedIndex !== prevHighlightedIndex;
            return scrollWhenOpen || scrollWhenNavigating;
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            if ($f4c8705b32f2a63d$var$isControlledProp(this.props, 'selectedItem') && this.props.selectedItemChanged(prevProps.selectedItem, this.props.selectedItem)) this.internalSetState({
                type: $f4c8705b32f2a63d$var$controlledPropUpdatedSelectedItem,
                inputValue: this.props.itemToString(this.props.selectedItem)
            });
            if (!this.avoidScrolling && this.shouldScroll(prevState, prevProps)) this.scrollHighlightedItemIntoView();
            this.updateStatus();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.cleanup(); // avoids memory leak
        };
        _proto.render = function render() {
            var children = $f4c8705b32f2a63d$var$unwrapArray(this.props.children, $f4c8705b32f2a63d$var$noop);
            // because the items are rerendered every time we call the children
            // we clear this out each render and it will be populated again as
            // getItemProps is called.
            this.clearItems();
            // we reset this so we know whether the user calls getRootProps during
            // this render. If they do then we don't need to do anything,
            // if they don't then we need to clone the element they return and
            // apply the props for them.
            this.getRootProps.called = false;
            this.getRootProps.refKey = undefined;
            this.getRootProps.suppressRefError = undefined;
            // we do something similar for getMenuProps
            this.getMenuProps.called = false;
            this.getMenuProps.refKey = undefined;
            this.getMenuProps.suppressRefError = undefined;
            // we do something similar for getLabelProps
            this.getLabelProps.called = false;
            // and something similar for getInputProps
            this.getInputProps.called = false;
            var element = $f4c8705b32f2a63d$var$unwrapArray(children(this.getStateAndHelpers()));
            if (!element) return null;
            if (this.getRootProps.called || this.props.suppressRefError) return element;
            else if ($f4c8705b32f2a63d$var$isDOMElement(element)) // they didn't apply the root props, but we can clone
            // this and apply the props ourselves
            return /*#__PURE__*/ (0, $8NFma.cloneElement)(element, this.getRootProps($f4c8705b32f2a63d$var$getElementProps(element)));
            /* istanbul ignore next */ return undefined;
        };
        return Downshift;
    }((0, $8NFma.Component));
    Downshift.defaultProps = {
        defaultHighlightedIndex: null,
        defaultIsOpen: false,
        getA11yStatusMessage: $f4c8705b32f2a63d$var$getA11yStatusMessage,
        itemToString: function itemToString(i) {
            if (i == null) return '';
            return String(i);
        },
        onStateChange: $f4c8705b32f2a63d$var$noop,
        onInputValueChange: $f4c8705b32f2a63d$var$noop,
        onUserAction: $f4c8705b32f2a63d$var$noop,
        onChange: $f4c8705b32f2a63d$var$noop,
        onSelect: $f4c8705b32f2a63d$var$noop,
        onOuterClick: $f4c8705b32f2a63d$var$noop,
        selectedItemChanged: function selectedItemChanged(prevItem, item) {
            return prevItem !== item;
        },
        environment: /* istanbul ignore next (ssr) */ typeof window === 'undefined' || false ? undefined : window,
        stateReducer: function stateReducer(state, stateToSet) {
            return stateToSet;
        },
        suppressRefError: false,
        scrollIntoView: $f4c8705b32f2a63d$var$scrollIntoView
    };
    Downshift.stateChangeTypes = $f4c8705b32f2a63d$var$stateChangeTypes$3;
    return Downshift;
}();
var $f4c8705b32f2a63d$export$2e2bcd8739ae039 = $f4c8705b32f2a63d$var$Downshift;
function $f4c8705b32f2a63d$var$validateGetMenuPropsCalledCorrectly(node, _ref12) {
    var refKey = _ref12.refKey;
    if (!node) // eslint-disable-next-line no-console
    console.error("downshift: The ref prop \"" + refKey + "\" from getMenuProps was not applied correctly on your menu element.");
}
function $f4c8705b32f2a63d$var$validateGetRootPropsCalledCorrectly(element, _ref13) {
    var refKey = _ref13.refKey;
    var refKeySpecified = refKey !== 'ref';
    var isComposite = !$f4c8705b32f2a63d$var$isDOMElement(element);
    if (isComposite && !refKeySpecified && !(0, $161775e6c718b902$exports.isForwardRef)(element)) // eslint-disable-next-line no-console
    console.error('downshift: You returned a non-DOM element. You must specify a refKey in getRootProps');
    else if (!isComposite && refKeySpecified) // eslint-disable-next-line no-console
    console.error("downshift: You returned a DOM element. You should not specify a refKey in getRootProps. You specified \"" + refKey + "\"");
    if (!(0, $161775e6c718b902$exports.isForwardRef)(element) && !$f4c8705b32f2a63d$var$getElementProps(element)[refKey]) // eslint-disable-next-line no-console
    console.error("downshift: You must apply the ref prop \"" + refKey + "\" from getRootProps onto your root element.");
}
var $f4c8705b32f2a63d$var$dropdownDefaultStateValues = {
    highlightedIndex: -1,
    isOpen: false,
    selectedItem: null,
    inputValue: ''
};
function $f4c8705b32f2a63d$var$callOnChangeProps(action, state, newState) {
    var props = action.props, type = action.type;
    var changes = {};
    Object.keys(state).forEach(function(key) {
        $f4c8705b32f2a63d$var$invokeOnChangeHandler(key, action, state, newState);
        if (newState[key] !== state[key]) changes[key] = newState[key];
    });
    if (props.onStateChange && Object.keys(changes).length) props.onStateChange((0, $e3e49ed681292e30$export$2e2bcd8739ae039)({
        type: type
    }, changes));
}
function $f4c8705b32f2a63d$var$invokeOnChangeHandler(key, action, state, newState) {
    var props = action.props, type = action.type;
    var handler = "on" + $f4c8705b32f2a63d$var$capitalizeString(key) + "Change";
    if (props[handler] && newState[key] !== undefined && newState[key] !== state[key]) props[handler]((0, $e3e49ed681292e30$export$2e2bcd8739ae039)({
        type: type
    }, newState));
}
/**
 * Default state reducer that returns the changes.
 *
 * @param {Object} s state.
 * @param {Object} a action with changes.
 * @returns {Object} changes.
 */ function $f4c8705b32f2a63d$var$stateReducer(s, a) {
    return a.changes;
}
/**
 * Debounced call for updating the a11y message.
 */ var $f4c8705b32f2a63d$var$updateA11yStatus = $f4c8705b32f2a63d$var$debounce(function(status, document) {
    $f4c8705b32f2a63d$var$setStatus(status, document);
}, 200);
// istanbul ignore next
var $f4c8705b32f2a63d$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $8NFma.useLayoutEffect) : (0, $8NFma.useEffect);
// istanbul ignore next
var $f4c8705b32f2a63d$var$useElementIds = 'useId' in (0, (/*@__PURE__*/$parcel$interopDefault($8NFma)) // Avoid conditional useId call
) ? function useElementIds(_ref) {
    var id = _ref.id, labelId = _ref.labelId, menuId = _ref.menuId, getItemId = _ref.getItemId, toggleButtonId = _ref.toggleButtonId, inputId = _ref.inputId;
    // Avoid conditional useId call
    var reactId = "downshift-" + (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useId();
    if (!id) id = reactId;
    var elementIdsRef = (0, $8NFma.useRef)({
        labelId: labelId || id + "-label",
        menuId: menuId || id + "-menu",
        getItemId: getItemId || function(index) {
            return id + "-item-" + index;
        },
        toggleButtonId: toggleButtonId || id + "-toggle-button",
        inputId: inputId || id + "-input"
    });
    return elementIdsRef.current;
} : function useElementIds(_ref2) {
    var _ref2$id = _ref2.id, id = _ref2$id === void 0 ? "downshift-" + $f4c8705b32f2a63d$var$generateId() : _ref2$id, labelId = _ref2.labelId, menuId = _ref2.menuId, getItemId = _ref2.getItemId, toggleButtonId = _ref2.toggleButtonId, inputId = _ref2.inputId;
    var elementIdsRef = (0, $8NFma.useRef)({
        labelId: labelId || id + "-label",
        menuId: menuId || id + "-menu",
        getItemId: getItemId || function(index) {
            return id + "-item-" + index;
        },
        toggleButtonId: toggleButtonId || id + "-toggle-button",
        inputId: inputId || id + "-input"
    });
    return elementIdsRef.current;
};
function $f4c8705b32f2a63d$var$getItemAndIndex(itemProp, indexProp, items, errorMessage) {
    var item, index;
    if (itemProp === undefined) {
        if (indexProp === undefined) throw new Error(errorMessage);
        item = items[indexProp];
        index = indexProp;
    } else {
        index = indexProp === undefined ? items.indexOf(itemProp) : indexProp;
        item = itemProp;
    }
    return [
        item,
        index
    ];
}
function $f4c8705b32f2a63d$var$isAcceptedCharacterKey(key) {
    return /^\S{1}$/.test(key);
}
function $f4c8705b32f2a63d$var$capitalizeString(string) {
    return "" + string.slice(0, 1).toUpperCase() + string.slice(1);
}
function $f4c8705b32f2a63d$var$useLatestRef(val) {
    var ref = (0, $8NFma.useRef)(val);
    // technically this is not "concurrent mode safe" because we're manipulating
    // the value during render (so it's not idempotent). However, the places this
    // hook is used is to support memoizing callbacks which will be called
    // *during* render, so we need the latest values *during* render.
    // If not for this, then we'd probably want to use useLayoutEffect instead.
    ref.current = val;
    return ref;
}
/**
 * Computes the controlled state using a the previous state, props,
 * two reducers, one from downshift and an optional one from the user.
 * Also calls the onChange handlers for state values that have changed.
 *
 * @param {Function} reducer Reducer function from downshift.
 * @param {Object} props The hook props, also passed to createInitialState.
 * @param {Function} createInitialState Function that returns the initial state.
 * @param {Function} isStateEqual Function that checks if a previous state is equal to the next.
 * @returns {Array} An array with the state and an action dispatcher.
 */ function $f4c8705b32f2a63d$var$useEnhancedReducer(reducer, props, createInitialState, isStateEqual) {
    var prevStateRef = (0, $8NFma.useRef)();
    var actionRef = (0, $8NFma.useRef)();
    var enhancedReducer = (0, $8NFma.useCallback)(function(state, action) {
        actionRef.current = action;
        state = $f4c8705b32f2a63d$var$getState(state, action.props);
        var changes = reducer(state, action);
        var newState = action.props.stateReducer(state, (0, $e3e49ed681292e30$export$2e2bcd8739ae039)({}, action, {
            changes: changes
        }));
        return newState;
    }, [
        reducer
    ]);
    var _useReducer = (0, $8NFma.useReducer)(enhancedReducer, props, createInitialState), state = _useReducer[0], dispatch = _useReducer[1];
    var propsRef = $f4c8705b32f2a63d$var$useLatestRef(props);
    var dispatchWithProps = (0, $8NFma.useCallback)(function(action) {
        return dispatch((0, $e3e49ed681292e30$export$2e2bcd8739ae039)({
            props: propsRef.current
        }, action));
    }, [
        propsRef
    ]);
    var action = actionRef.current;
    (0, $8NFma.useEffect)(function() {
        var prevState = $f4c8705b32f2a63d$var$getState(prevStateRef.current, action == null ? void 0 : action.props);
        var shouldCallOnChangeProps = action && prevStateRef.current && !isStateEqual(prevState, state);
        if (shouldCallOnChangeProps) $f4c8705b32f2a63d$var$callOnChangeProps(action, prevState, state);
        prevStateRef.current = state;
    }, [
        state,
        action,
        isStateEqual
    ]);
    return [
        state,
        dispatchWithProps
    ];
}
/**
 * Wraps the useEnhancedReducer and applies the controlled prop values before
 * returning the new state.
 *
 * @param {Function} reducer Reducer function from downshift.
 * @param {Object} props The hook props, also passed to createInitialState.
 * @param {Function} createInitialState Function that returns the initial state.
 * @param {Function} isStateEqual Function that checks if a previous state is equal to the next.
 * @returns {Array} An array with the state and an action dispatcher.
 */ function $f4c8705b32f2a63d$var$useControlledReducer$1(reducer, props, createInitialState, isStateEqual) {
    var _useEnhancedReducer = $f4c8705b32f2a63d$var$useEnhancedReducer(reducer, props, createInitialState, isStateEqual), state = _useEnhancedReducer[0], dispatch = _useEnhancedReducer[1];
    return [
        $f4c8705b32f2a63d$var$getState(state, props),
        dispatch
    ];
}
var $f4c8705b32f2a63d$var$defaultProps$3 = {
    itemToString: function itemToString(item) {
        return item ? String(item) : '';
    },
    itemToKey: function itemToKey(item) {
        return item;
    },
    stateReducer: $f4c8705b32f2a63d$var$stateReducer,
    scrollIntoView: $f4c8705b32f2a63d$var$scrollIntoView,
    environment: /* istanbul ignore next (ssr) */ typeof window === 'undefined' || false ? undefined : window
};
function $f4c8705b32f2a63d$var$getDefaultValue$1(props, propKey, defaultStateValues) {
    if (defaultStateValues === void 0) defaultStateValues = $f4c8705b32f2a63d$var$dropdownDefaultStateValues;
    var defaultValue = props["default" + $f4c8705b32f2a63d$var$capitalizeString(propKey)];
    if (defaultValue !== undefined) return defaultValue;
    return defaultStateValues[propKey];
}
function $f4c8705b32f2a63d$var$getInitialValue$1(props, propKey, defaultStateValues) {
    if (defaultStateValues === void 0) defaultStateValues = $f4c8705b32f2a63d$var$dropdownDefaultStateValues;
    var value = props[propKey];
    if (value !== undefined) return value;
    var initialValue = props["initial" + $f4c8705b32f2a63d$var$capitalizeString(propKey)];
    if (initialValue !== undefined) return initialValue;
    return $f4c8705b32f2a63d$var$getDefaultValue$1(props, propKey, defaultStateValues);
}
function $f4c8705b32f2a63d$var$getInitialState$2(props) {
    var selectedItem = $f4c8705b32f2a63d$var$getInitialValue$1(props, 'selectedItem');
    var isOpen = $f4c8705b32f2a63d$var$getInitialValue$1(props, 'isOpen');
    var highlightedIndex = $f4c8705b32f2a63d$var$getInitialHighlightedIndex(props);
    var inputValue = $f4c8705b32f2a63d$var$getInitialValue$1(props, 'inputValue');
    return {
        highlightedIndex: highlightedIndex < 0 && selectedItem && isOpen ? props.items.findIndex(function(item) {
            return props.itemToKey(item) === props.itemToKey(selectedItem);
        }) : highlightedIndex,
        isOpen: isOpen,
        selectedItem: selectedItem,
        inputValue: inputValue
    };
}
function $f4c8705b32f2a63d$var$getHighlightedIndexOnOpen(props, state, offset) {
    var items = props.items, initialHighlightedIndex = props.initialHighlightedIndex, defaultHighlightedIndex = props.defaultHighlightedIndex, isItemDisabled = props.isItemDisabled, itemToKey = props.itemToKey;
    var selectedItem = state.selectedItem, highlightedIndex = state.highlightedIndex;
    if (items.length === 0) return -1;
    // initialHighlightedIndex will give value to highlightedIndex on initial state only.
    if (initialHighlightedIndex !== undefined && highlightedIndex === initialHighlightedIndex && !isItemDisabled(items[initialHighlightedIndex], initialHighlightedIndex)) return initialHighlightedIndex;
    if (defaultHighlightedIndex !== undefined && !isItemDisabled(items[defaultHighlightedIndex], defaultHighlightedIndex)) return defaultHighlightedIndex;
    if (selectedItem) return items.findIndex(function(item) {
        return itemToKey(selectedItem) === itemToKey(item);
    });
    if (offset < 0 && !isItemDisabled(items[items.length - 1], items.length - 1)) return items.length - 1;
    if (offset > 0 && !isItemDisabled(items[0], 0)) return 0;
    return -1;
}
/**
 * Tracks mouse and touch events, such as mouseDown, touchMove and touchEnd.
 *
 * @param {Object} environment The environment to add the event listeners to, for instance window.
 * @param {Array<HTMLElement>} downshiftElementRefs The refs for the element that should not trigger a blur action from mouseDown or touchEnd.
 * @param {Function} handleBlur The function that is called if mouseDown or touchEnd occured outside the downshiftElements.
 * @returns {Object} The mouse and touch events information, if any of are happening.
 */ function $f4c8705b32f2a63d$var$useMouseAndTouchTracker(environment, downshiftElementRefs, handleBlur) {
    var mouseAndTouchTrackersRef = (0, $8NFma.useRef)({
        isMouseDown: false,
        isTouchMove: false,
        isTouchEnd: false
    });
    (0, $8NFma.useEffect)(function() {
        if (!environment) return $f4c8705b32f2a63d$var$noop;
        var downshiftElements = downshiftElementRefs.map(function(ref) {
            return ref.current;
        });
        function onMouseDown() {
            mouseAndTouchTrackersRef.current.isTouchEnd = false; // reset this one.
            mouseAndTouchTrackersRef.current.isMouseDown = true;
        }
        function onMouseUp(event) {
            mouseAndTouchTrackersRef.current.isMouseDown = false;
            if (!$f4c8705b32f2a63d$var$targetWithinDownshift(event.target, downshiftElements, environment)) handleBlur();
        }
        function onTouchStart() {
            mouseAndTouchTrackersRef.current.isTouchEnd = false;
            mouseAndTouchTrackersRef.current.isTouchMove = false;
        }
        function onTouchMove() {
            mouseAndTouchTrackersRef.current.isTouchMove = true;
        }
        function onTouchEnd(event) {
            mouseAndTouchTrackersRef.current.isTouchEnd = true;
            if (!mouseAndTouchTrackersRef.current.isTouchMove && !$f4c8705b32f2a63d$var$targetWithinDownshift(event.target, downshiftElements, environment, false)) handleBlur();
        }
        environment.addEventListener('mousedown', onMouseDown);
        environment.addEventListener('mouseup', onMouseUp);
        environment.addEventListener('touchstart', onTouchStart);
        environment.addEventListener('touchmove', onTouchMove);
        environment.addEventListener('touchend', onTouchEnd);
        return function cleanup() {
            environment.removeEventListener('mousedown', onMouseDown);
            environment.removeEventListener('mouseup', onMouseUp);
            environment.removeEventListener('touchstart', onTouchStart);
            environment.removeEventListener('touchmove', onTouchMove);
            environment.removeEventListener('touchend', onTouchEnd);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- refs don't change
    }, [
        environment,
        handleBlur
    ]);
    return mouseAndTouchTrackersRef.current;
}
/* istanbul ignore next */ // eslint-disable-next-line import/no-mutable-exports
var $f4c8705b32f2a63d$var$useGetterPropsCalledChecker = function useGetterPropsCalledChecker() {
    return $f4c8705b32f2a63d$var$noop;
};
/**
 * Adds an a11y aria live status message if getA11yStatusMessage is passed.
 * @param {(options: Object) => string} getA11yStatusMessage The function that builds the status message.
 * @param {Object} options The options to be passed to getA11yStatusMessage if called.
 * @param {Array<unknown>} dependencyArray The dependency array that triggers the status message setter via useEffect.
 * @param {{document: Document}} environment The environment object containing the document.
 */ function $f4c8705b32f2a63d$var$useA11yMessageStatus(getA11yStatusMessage, options, dependencyArray, environment) {
    if (environment === void 0) environment = {};
    var document = environment.document;
    var isInitialMount = $f4c8705b32f2a63d$var$useIsInitialMount();
    // Adds an a11y aria live status message if getA11yStatusMessage is passed.
    (0, $8NFma.useEffect)(function() {
        if (!getA11yStatusMessage || isInitialMount || false || !document) return;
        var status = getA11yStatusMessage(options);
        $f4c8705b32f2a63d$var$updateA11yStatus(status, document);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, dependencyArray);
    // Cleanup the status message container.
    (0, $8NFma.useEffect)(function() {
        return function() {
            $f4c8705b32f2a63d$var$updateA11yStatus.cancel();
            $f4c8705b32f2a63d$var$cleanupStatusDiv(document);
        };
    }, [
        document
    ]);
}
function $f4c8705b32f2a63d$var$useScrollIntoView(_ref3) {
    var highlightedIndex = _ref3.highlightedIndex, isOpen = _ref3.isOpen, itemRefs = _ref3.itemRefs, getItemNodeFromIndex = _ref3.getItemNodeFromIndex, menuElement = _ref3.menuElement, scrollIntoViewProp = _ref3.scrollIntoView;
    // used not to scroll on highlight by mouse.
    var shouldScrollRef = (0, $8NFma.useRef)(true);
    // Scroll on highlighted item if change comes from keyboard.
    $f4c8705b32f2a63d$var$useIsomorphicLayoutEffect(function() {
        if (highlightedIndex < 0 || !isOpen || !Object.keys(itemRefs.current).length) return;
        if (shouldScrollRef.current === false) shouldScrollRef.current = true;
        else scrollIntoViewProp(getItemNodeFromIndex(highlightedIndex), menuElement);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        highlightedIndex
    ]);
    return shouldScrollRef;
}
// eslint-disable-next-line import/no-mutable-exports
var $f4c8705b32f2a63d$var$useControlPropsValidator = $f4c8705b32f2a63d$var$noop;
/**
 * Handles selection on Enter / Alt + ArrowUp. Closes the menu and resets the highlighted index, unless there is a highlighted.
 * In that case, selects the item and resets to defaults for open state and highlighted idex.
 * @param {Object} props The useCombobox props.
 * @param {number} highlightedIndex The index from the state.
 * @param {boolean} inputValue Also return the input value for state.
 * @returns The changes for the state.
 */ function $f4c8705b32f2a63d$var$getChangesOnSelection(props, highlightedIndex, inputValue) {
    var _props$items;
    if (inputValue === void 0) inputValue = true;
    var shouldSelect = ((_props$items = props.items) == null ? void 0 : _props$items.length) && highlightedIndex >= 0;
    return (0, $e3e49ed681292e30$export$2e2bcd8739ae039)({
        isOpen: false,
        highlightedIndex: -1
    }, shouldSelect && (0, $e3e49ed681292e30$export$2e2bcd8739ae039)({
        selectedItem: props.items[highlightedIndex],
        isOpen: $f4c8705b32f2a63d$var$getDefaultValue$1(props, 'isOpen'),
        highlightedIndex: $f4c8705b32f2a63d$var$getDefaultValue$1(props, 'highlightedIndex')
    }, inputValue && {
        inputValue: props.itemToString(props.items[highlightedIndex])
    }));
}
/**
 * Check if a state is equal for dropdowns, by comparing isOpen, inputValue, highlightedIndex and selected item.
 * Used by useSelect and useCombobox.
 *
 * @param {Object} prevState
 * @param {Object} newState
 * @returns {boolean} Wheather the states are deeply equal.
 */ function $f4c8705b32f2a63d$var$isDropdownsStateEqual(prevState, newState) {
    return prevState.isOpen === newState.isOpen && prevState.inputValue === newState.inputValue && prevState.highlightedIndex === newState.highlightedIndex && prevState.selectedItem === newState.selectedItem;
}
/**
 * Tracks if it's the first render.
 */ function $f4c8705b32f2a63d$var$useIsInitialMount() {
    var isInitialMountRef = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useRef(true);
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useEffect(function() {
        isInitialMountRef.current = false;
        return function() {
            isInitialMountRef.current = true;
        };
    }, []);
    return isInitialMountRef.current;
}
/**
 * Returns the new highlightedIndex based on the defaultHighlightedIndex prop, if it's not disabled.
 *
 * @param {Object} props Props from useCombobox or useSelect.
 * @returns {number} The highlighted index.
 */ function $f4c8705b32f2a63d$var$getDefaultHighlightedIndex(props) {
    var highlightedIndex = $f4c8705b32f2a63d$var$getDefaultValue$1(props, 'highlightedIndex');
    if (highlightedIndex > -1 && props.isItemDisabled(props.items[highlightedIndex], highlightedIndex)) return -1;
    return highlightedIndex;
}
/**
 * Returns the new highlightedIndex based on the initialHighlightedIndex prop, if not disabled.
 *
 * @param {Object} props Props from useCombobox or useSelect.
 * @returns {number} The highlighted index.
 */ function $f4c8705b32f2a63d$var$getInitialHighlightedIndex(props) {
    var highlightedIndex = $f4c8705b32f2a63d$var$getInitialValue$1(props, 'highlightedIndex');
    if (highlightedIndex > -1 && props.isItemDisabled(props.items[highlightedIndex], highlightedIndex)) return -1;
    return highlightedIndex;
}
// Shared between all exports.
var $f4c8705b32f2a63d$var$commonPropTypes = {
    environment: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).shape({
        addEventListener: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func.isRequired,
        removeEventListener: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func.isRequired,
        document: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).shape({
            createElement: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func.isRequired,
            getElementById: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func.isRequired,
            activeElement: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).any.isRequired,
            body: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).any.isRequired
        }).isRequired,
        Node: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func.isRequired
    }),
    itemToString: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func,
    itemToKey: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func,
    stateReducer: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func
};
// Shared between useSelect, useCombobox, Downshift.
var $f4c8705b32f2a63d$var$commonDropdownPropTypes = (0, $e3e49ed681292e30$export$2e2bcd8739ae039)({}, $f4c8705b32f2a63d$var$commonPropTypes, {
    getA11yStatusMessage: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func,
    highlightedIndex: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).number,
    defaultHighlightedIndex: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).number,
    initialHighlightedIndex: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).number,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).bool,
    defaultIsOpen: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).bool,
    initialIsOpen: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).bool,
    selectedItem: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).any,
    initialSelectedItem: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).any,
    defaultSelectedItem: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).any,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
    labelId: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
    menuId: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
    getItemId: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func,
    toggleButtonId: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
    onSelectedItemChange: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func,
    onHighlightedIndexChange: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func,
    onStateChange: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func,
    onIsOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func,
    scrollIntoView: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func
});
function $f4c8705b32f2a63d$var$downshiftCommonReducer(state, action, stateChangeTypes) {
    var type = action.type, props = action.props;
    var changes;
    switch(type){
        case stateChangeTypes.ItemMouseMove:
            changes = {
                highlightedIndex: action.disabled ? -1 : action.index
            };
            break;
        case stateChangeTypes.MenuMouseLeave:
            changes = {
                highlightedIndex: -1
            };
            break;
        case stateChangeTypes.ToggleButtonClick:
        case stateChangeTypes.FunctionToggleMenu:
            changes = {
                isOpen: !state.isOpen,
                highlightedIndex: state.isOpen ? -1 : $f4c8705b32f2a63d$var$getHighlightedIndexOnOpen(props, state, 0)
            };
            break;
        case stateChangeTypes.FunctionOpenMenu:
            changes = {
                isOpen: true,
                highlightedIndex: $f4c8705b32f2a63d$var$getHighlightedIndexOnOpen(props, state, 0)
            };
            break;
        case stateChangeTypes.FunctionCloseMenu:
            changes = {
                isOpen: false
            };
            break;
        case stateChangeTypes.FunctionSetHighlightedIndex:
            changes = {
                highlightedIndex: props.isItemDisabled(props.items[action.highlightedIndex], action.highlightedIndex) ? -1 : action.highlightedIndex
            };
            break;
        case stateChangeTypes.FunctionSetInputValue:
            changes = {
                inputValue: action.inputValue
            };
            break;
        case stateChangeTypes.FunctionReset:
            changes = {
                highlightedIndex: $f4c8705b32f2a63d$var$getDefaultHighlightedIndex(props),
                isOpen: $f4c8705b32f2a63d$var$getDefaultValue$1(props, 'isOpen'),
                selectedItem: $f4c8705b32f2a63d$var$getDefaultValue$1(props, 'selectedItem'),
                inputValue: $f4c8705b32f2a63d$var$getDefaultValue$1(props, 'inputValue')
            };
            break;
        default:
            throw new Error('Reducer called without proper action type.');
    }
    return (0, $e3e49ed681292e30$export$2e2bcd8739ae039)({}, state, changes);
}
/* eslint-enable complexity */ function $f4c8705b32f2a63d$var$getItemIndexByCharacterKey(_a) {
    var keysSoFar = _a.keysSoFar, highlightedIndex = _a.highlightedIndex, items = _a.items, itemToString = _a.itemToString, isItemDisabled = _a.isItemDisabled;
    var lowerCasedKeysSoFar = keysSoFar.toLowerCase();
    for(var index = 0; index < items.length; index++){
        // if we already have a search query in progress, we also consider the current highlighted item.
        var offsetIndex = (index + highlightedIndex + (keysSoFar.length < 2 ? 1 : 0)) % items.length;
        var item = items[offsetIndex];
        if (item !== undefined && itemToString(item).toLowerCase().startsWith(lowerCasedKeysSoFar) && !isItemDisabled(item, offsetIndex)) return offsetIndex;
    }
    return highlightedIndex;
}
var $f4c8705b32f2a63d$var$propTypes$2 = (0, $c106e002a49a00cb$export$18ce0697a983be9b)((0, $c106e002a49a00cb$export$18ce0697a983be9b)({}, $f4c8705b32f2a63d$var$commonDropdownPropTypes), {
    items: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).array.isRequired,
    isItemDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func
});
var $f4c8705b32f2a63d$var$defaultProps$2 = (0, $c106e002a49a00cb$export$18ce0697a983be9b)((0, $c106e002a49a00cb$export$18ce0697a983be9b)({}, $f4c8705b32f2a63d$var$defaultProps$3), {
    isItemDisabled: function() {
        return false;
    }
});
// eslint-disable-next-line import/no-mutable-exports
var $f4c8705b32f2a63d$var$validatePropTypes$2 = $f4c8705b32f2a63d$var$noop;
var $f4c8705b32f2a63d$var$ToggleButtonClick$1 = 0;
var $f4c8705b32f2a63d$var$ToggleButtonKeyDownArrowDown = 1;
var $f4c8705b32f2a63d$var$ToggleButtonKeyDownArrowUp = 2;
var $f4c8705b32f2a63d$var$ToggleButtonKeyDownCharacter = 3;
var $f4c8705b32f2a63d$var$ToggleButtonKeyDownEscape = 4;
var $f4c8705b32f2a63d$var$ToggleButtonKeyDownHome = 5;
var $f4c8705b32f2a63d$var$ToggleButtonKeyDownEnd = 6;
var $f4c8705b32f2a63d$var$ToggleButtonKeyDownEnter = 7;
var $f4c8705b32f2a63d$var$ToggleButtonKeyDownSpaceButton = 8;
var $f4c8705b32f2a63d$var$ToggleButtonKeyDownPageUp = 9;
var $f4c8705b32f2a63d$var$ToggleButtonKeyDownPageDown = 10;
var $f4c8705b32f2a63d$var$ToggleButtonBlur = 11;
var $f4c8705b32f2a63d$var$MenuMouseLeave$1 = 12;
var $f4c8705b32f2a63d$var$ItemMouseMove$1 = 13;
var $f4c8705b32f2a63d$var$ItemClick$1 = 14;
var $f4c8705b32f2a63d$var$FunctionToggleMenu$1 = 15;
var $f4c8705b32f2a63d$var$FunctionOpenMenu$1 = 16;
var $f4c8705b32f2a63d$var$FunctionCloseMenu$1 = 17;
var $f4c8705b32f2a63d$var$FunctionSetHighlightedIndex$1 = 18;
var $f4c8705b32f2a63d$var$FunctionSelectItem$1 = 19;
var $f4c8705b32f2a63d$var$FunctionSetInputValue$1 = 20;
var $f4c8705b32f2a63d$var$FunctionReset$2 = 21;
var $f4c8705b32f2a63d$var$stateChangeTypes$2 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    FunctionCloseMenu: $f4c8705b32f2a63d$var$FunctionCloseMenu$1,
    FunctionOpenMenu: $f4c8705b32f2a63d$var$FunctionOpenMenu$1,
    FunctionReset: $f4c8705b32f2a63d$var$FunctionReset$2,
    FunctionSelectItem: $f4c8705b32f2a63d$var$FunctionSelectItem$1,
    FunctionSetHighlightedIndex: $f4c8705b32f2a63d$var$FunctionSetHighlightedIndex$1,
    FunctionSetInputValue: $f4c8705b32f2a63d$var$FunctionSetInputValue$1,
    FunctionToggleMenu: $f4c8705b32f2a63d$var$FunctionToggleMenu$1,
    ItemClick: $f4c8705b32f2a63d$var$ItemClick$1,
    ItemMouseMove: $f4c8705b32f2a63d$var$ItemMouseMove$1,
    MenuMouseLeave: $f4c8705b32f2a63d$var$MenuMouseLeave$1,
    ToggleButtonBlur: $f4c8705b32f2a63d$var$ToggleButtonBlur,
    ToggleButtonClick: $f4c8705b32f2a63d$var$ToggleButtonClick$1,
    ToggleButtonKeyDownArrowDown: $f4c8705b32f2a63d$var$ToggleButtonKeyDownArrowDown,
    ToggleButtonKeyDownArrowUp: $f4c8705b32f2a63d$var$ToggleButtonKeyDownArrowUp,
    ToggleButtonKeyDownCharacter: $f4c8705b32f2a63d$var$ToggleButtonKeyDownCharacter,
    ToggleButtonKeyDownEnd: $f4c8705b32f2a63d$var$ToggleButtonKeyDownEnd,
    ToggleButtonKeyDownEnter: $f4c8705b32f2a63d$var$ToggleButtonKeyDownEnter,
    ToggleButtonKeyDownEscape: $f4c8705b32f2a63d$var$ToggleButtonKeyDownEscape,
    ToggleButtonKeyDownHome: $f4c8705b32f2a63d$var$ToggleButtonKeyDownHome,
    ToggleButtonKeyDownPageDown: $f4c8705b32f2a63d$var$ToggleButtonKeyDownPageDown,
    ToggleButtonKeyDownPageUp: $f4c8705b32f2a63d$var$ToggleButtonKeyDownPageUp,
    ToggleButtonKeyDownSpaceButton: $f4c8705b32f2a63d$var$ToggleButtonKeyDownSpaceButton
});
/* eslint-disable complexity */ function $f4c8705b32f2a63d$var$downshiftSelectReducer(state, action) {
    var _props$items;
    var type = action.type, props = action.props, altKey = action.altKey;
    var changes;
    switch(type){
        case $f4c8705b32f2a63d$var$ItemClick$1:
            changes = {
                isOpen: $f4c8705b32f2a63d$var$getDefaultValue$1(props, 'isOpen'),
                highlightedIndex: $f4c8705b32f2a63d$var$getDefaultHighlightedIndex(props),
                selectedItem: props.items[action.index]
            };
            break;
        case $f4c8705b32f2a63d$var$ToggleButtonKeyDownCharacter:
            var lowercasedKey = action.key;
            var inputValue = "" + state.inputValue + lowercasedKey;
            var prevHighlightedIndex = !state.isOpen && state.selectedItem ? props.items.findIndex(function(item) {
                return props.itemToKey(item) === props.itemToKey(state.selectedItem);
            }) : state.highlightedIndex;
            var highlightedIndex = $f4c8705b32f2a63d$var$getItemIndexByCharacterKey({
                keysSoFar: inputValue,
                highlightedIndex: prevHighlightedIndex,
                items: props.items,
                itemToString: props.itemToString,
                isItemDisabled: props.isItemDisabled
            });
            changes = {
                inputValue: inputValue,
                highlightedIndex: highlightedIndex,
                isOpen: true
            };
            break;
        case $f4c8705b32f2a63d$var$ToggleButtonKeyDownArrowDown:
            var _highlightedIndex = state.isOpen ? $f4c8705b32f2a63d$var$getHighlightedIndex(state.highlightedIndex, 1, props.items, props.isItemDisabled) : altKey && state.selectedItem == null ? -1 : $f4c8705b32f2a63d$var$getHighlightedIndexOnOpen(props, state, 1);
            changes = {
                highlightedIndex: _highlightedIndex,
                isOpen: true
            };
            break;
        case $f4c8705b32f2a63d$var$ToggleButtonKeyDownArrowUp:
            if (state.isOpen && altKey) changes = $f4c8705b32f2a63d$var$getChangesOnSelection(props, state.highlightedIndex, false);
            else {
                var _highlightedIndex2 = state.isOpen ? $f4c8705b32f2a63d$var$getHighlightedIndex(state.highlightedIndex, -1, props.items, props.isItemDisabled) : $f4c8705b32f2a63d$var$getHighlightedIndexOnOpen(props, state, -1);
                changes = {
                    highlightedIndex: _highlightedIndex2,
                    isOpen: true
                };
            }
            break;
        // only triggered when menu is open.
        case $f4c8705b32f2a63d$var$ToggleButtonKeyDownEnter:
        case $f4c8705b32f2a63d$var$ToggleButtonKeyDownSpaceButton:
            changes = $f4c8705b32f2a63d$var$getChangesOnSelection(props, state.highlightedIndex, false);
            break;
        case $f4c8705b32f2a63d$var$ToggleButtonKeyDownHome:
            changes = {
                highlightedIndex: $f4c8705b32f2a63d$var$getNonDisabledIndex(0, false, props.items, props.isItemDisabled),
                isOpen: true
            };
            break;
        case $f4c8705b32f2a63d$var$ToggleButtonKeyDownEnd:
            changes = {
                highlightedIndex: $f4c8705b32f2a63d$var$getNonDisabledIndex(props.items.length - 1, true, props.items, props.isItemDisabled),
                isOpen: true
            };
            break;
        case $f4c8705b32f2a63d$var$ToggleButtonKeyDownPageUp:
            changes = {
                highlightedIndex: $f4c8705b32f2a63d$var$getHighlightedIndex(state.highlightedIndex, -10, props.items, props.isItemDisabled)
            };
            break;
        case $f4c8705b32f2a63d$var$ToggleButtonKeyDownPageDown:
            changes = {
                highlightedIndex: $f4c8705b32f2a63d$var$getHighlightedIndex(state.highlightedIndex, 10, props.items, props.isItemDisabled)
            };
            break;
        case $f4c8705b32f2a63d$var$ToggleButtonKeyDownEscape:
            changes = {
                isOpen: false,
                highlightedIndex: -1
            };
            break;
        case $f4c8705b32f2a63d$var$ToggleButtonBlur:
            changes = (0, $e3e49ed681292e30$export$2e2bcd8739ae039)({
                isOpen: false,
                highlightedIndex: -1
            }, state.highlightedIndex >= 0 && ((_props$items = props.items) == null ? void 0 : _props$items.length) && {
                selectedItem: props.items[state.highlightedIndex]
            });
            break;
        case $f4c8705b32f2a63d$var$FunctionSelectItem$1:
            changes = {
                selectedItem: action.selectedItem
            };
            break;
        default:
            return $f4c8705b32f2a63d$var$downshiftCommonReducer(state, action, $f4c8705b32f2a63d$var$stateChangeTypes$2);
    }
    return (0, $e3e49ed681292e30$export$2e2bcd8739ae039)({}, state, changes);
}
/* eslint-enable complexity */ var $f4c8705b32f2a63d$var$_excluded$2 = [
    "onClick"
], $f4c8705b32f2a63d$var$_excluded2$2 = [
    "onMouseLeave",
    "refKey",
    "ref"
], $f4c8705b32f2a63d$var$_excluded3$1 = [
    "onBlur",
    "onClick",
    "onPress",
    "onKeyDown",
    "refKey",
    "ref"
], $f4c8705b32f2a63d$var$_excluded4$1 = [
    "item",
    "index",
    "onMouseMove",
    "onClick",
    "onMouseDown",
    "onPress",
    "refKey",
    "disabled",
    "ref"
];
$f4c8705b32f2a63d$export$e64b2f635402ca43.stateChangeTypes = $f4c8705b32f2a63d$var$stateChangeTypes$2;
function $f4c8705b32f2a63d$export$e64b2f635402ca43(userProps) {
    if (userProps === void 0) userProps = {};
    $f4c8705b32f2a63d$var$validatePropTypes$2(userProps, $f4c8705b32f2a63d$export$e64b2f635402ca43);
    // Props defaults and destructuring.
    var props = (0, $e3e49ed681292e30$export$2e2bcd8739ae039)({}, $f4c8705b32f2a63d$var$defaultProps$2, userProps);
    var scrollIntoView = props.scrollIntoView, environment = props.environment, getA11yStatusMessage = props.getA11yStatusMessage;
    // Initial state depending on controlled props.
    var _useControlledReducer = $f4c8705b32f2a63d$var$useControlledReducer$1($f4c8705b32f2a63d$var$downshiftSelectReducer, props, $f4c8705b32f2a63d$var$getInitialState$2, $f4c8705b32f2a63d$var$isDropdownsStateEqual), state = _useControlledReducer[0], dispatch = _useControlledReducer[1];
    var isOpen = state.isOpen, highlightedIndex = state.highlightedIndex, selectedItem = state.selectedItem, inputValue = state.inputValue;
    // Element efs.
    var toggleButtonRef = (0, $8NFma.useRef)(null);
    var menuRef = (0, $8NFma.useRef)(null);
    var itemRefs = (0, $8NFma.useRef)({});
    // used to keep the inputValue clearTimeout object between renders.
    var clearTimeoutRef = (0, $8NFma.useRef)(null);
    // prevent id re-generation between renders.
    var elementIds = $f4c8705b32f2a63d$var$useElementIds(props);
    // utility callback to get item element.
    var latest = $f4c8705b32f2a63d$var$useLatestRef({
        state: state,
        props: props
    });
    // Some utils.
    var getItemNodeFromIndex = (0, $8NFma.useCallback)(function(index) {
        return itemRefs.current[elementIds.getItemId(index)];
    }, [
        elementIds
    ]);
    // Effects.
    // Adds an a11y aria live status message if getA11yStatusMessage is passed.
    $f4c8705b32f2a63d$var$useA11yMessageStatus(getA11yStatusMessage, state, [
        isOpen,
        highlightedIndex,
        selectedItem,
        inputValue
    ], environment);
    // Scroll on highlighted item if change comes from keyboard.
    var shouldScrollRef = $f4c8705b32f2a63d$var$useScrollIntoView({
        menuElement: menuRef.current,
        highlightedIndex: highlightedIndex,
        isOpen: isOpen,
        itemRefs: itemRefs,
        scrollIntoView: scrollIntoView,
        getItemNodeFromIndex: getItemNodeFromIndex
    });
    // Sets cleanup for the keysSoFar callback, debounded after 500ms.
    (0, $8NFma.useEffect)(function() {
        // init the clean function here as we need access to dispatch.
        clearTimeoutRef.current = $f4c8705b32f2a63d$var$debounce(function(outerDispatch) {
            outerDispatch({
                type: $f4c8705b32f2a63d$var$FunctionSetInputValue$1,
                inputValue: ''
            });
        }, 500);
        // Cancel any pending debounced calls on mount
        return function() {
            clearTimeoutRef.current.cancel();
        };
    }, []);
    // Invokes the keysSoFar callback set up above.
    (0, $8NFma.useEffect)(function() {
        if (!inputValue) return;
        clearTimeoutRef.current(dispatch);
    }, [
        dispatch,
        inputValue
    ]);
    $f4c8705b32f2a63d$var$useControlPropsValidator({
        props: props,
        state: state
    });
    // Focus the toggle button on first render if required.
    (0, $8NFma.useEffect)(function() {
        var focusOnOpen = $f4c8705b32f2a63d$var$getInitialValue$1(props, 'isOpen');
        if (focusOnOpen && toggleButtonRef.current) toggleButtonRef.current.focus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var mouseAndTouchTrackers = $f4c8705b32f2a63d$var$useMouseAndTouchTracker(environment, [
        toggleButtonRef,
        menuRef
    ], (0, $8NFma.useCallback)(function handleBlur() {
        if (latest.current.state.isOpen) dispatch({
            type: $f4c8705b32f2a63d$var$ToggleButtonBlur
        });
    }, [
        dispatch,
        latest
    ]));
    var setGetterPropCallInfo = $f4c8705b32f2a63d$var$useGetterPropsCalledChecker('getMenuProps', 'getToggleButtonProps');
    // Reset itemRefs on close.
    (0, $8NFma.useEffect)(function() {
        if (!isOpen) itemRefs.current = {};
    }, [
        isOpen
    ]);
    // Event handler functions.
    var toggleButtonKeyDownHandlers = (0, $8NFma.useMemo)(function() {
        return {
            ArrowDown: function ArrowDown(event) {
                event.preventDefault();
                dispatch({
                    type: $f4c8705b32f2a63d$var$ToggleButtonKeyDownArrowDown,
                    altKey: event.altKey
                });
            },
            ArrowUp: function ArrowUp(event) {
                event.preventDefault();
                dispatch({
                    type: $f4c8705b32f2a63d$var$ToggleButtonKeyDownArrowUp,
                    altKey: event.altKey
                });
            },
            Home: function Home(event) {
                event.preventDefault();
                dispatch({
                    type: $f4c8705b32f2a63d$var$ToggleButtonKeyDownHome
                });
            },
            End: function End(event) {
                event.preventDefault();
                dispatch({
                    type: $f4c8705b32f2a63d$var$ToggleButtonKeyDownEnd
                });
            },
            Escape: function Escape() {
                if (latest.current.state.isOpen) dispatch({
                    type: $f4c8705b32f2a63d$var$ToggleButtonKeyDownEscape
                });
            },
            Enter: function Enter(event) {
                event.preventDefault();
                dispatch({
                    type: latest.current.state.isOpen ? $f4c8705b32f2a63d$var$ToggleButtonKeyDownEnter : $f4c8705b32f2a63d$var$ToggleButtonClick$1
                });
            },
            PageUp: function PageUp(event) {
                if (latest.current.state.isOpen) {
                    event.preventDefault();
                    dispatch({
                        type: $f4c8705b32f2a63d$var$ToggleButtonKeyDownPageUp
                    });
                }
            },
            PageDown: function PageDown(event) {
                if (latest.current.state.isOpen) {
                    event.preventDefault();
                    dispatch({
                        type: $f4c8705b32f2a63d$var$ToggleButtonKeyDownPageDown
                    });
                }
            },
            ' ': function _(event) {
                event.preventDefault();
                var currentState = latest.current.state;
                if (!currentState.isOpen) {
                    dispatch({
                        type: $f4c8705b32f2a63d$var$ToggleButtonClick$1
                    });
                    return;
                }
                if (currentState.inputValue) dispatch({
                    type: $f4c8705b32f2a63d$var$ToggleButtonKeyDownCharacter,
                    key: ' '
                });
                else dispatch({
                    type: $f4c8705b32f2a63d$var$ToggleButtonKeyDownSpaceButton
                });
            }
        };
    }, [
        dispatch,
        latest
    ]);
    // Action functions.
    var toggleMenu = (0, $8NFma.useCallback)(function() {
        dispatch({
            type: $f4c8705b32f2a63d$var$FunctionToggleMenu$1
        });
    }, [
        dispatch
    ]);
    var closeMenu = (0, $8NFma.useCallback)(function() {
        dispatch({
            type: $f4c8705b32f2a63d$var$FunctionCloseMenu$1
        });
    }, [
        dispatch
    ]);
    var openMenu = (0, $8NFma.useCallback)(function() {
        dispatch({
            type: $f4c8705b32f2a63d$var$FunctionOpenMenu$1
        });
    }, [
        dispatch
    ]);
    var setHighlightedIndex = (0, $8NFma.useCallback)(function(newHighlightedIndex) {
        dispatch({
            type: $f4c8705b32f2a63d$var$FunctionSetHighlightedIndex$1,
            highlightedIndex: newHighlightedIndex
        });
    }, [
        dispatch
    ]);
    var selectItem = (0, $8NFma.useCallback)(function(newSelectedItem) {
        dispatch({
            type: $f4c8705b32f2a63d$var$FunctionSelectItem$1,
            selectedItem: newSelectedItem
        });
    }, [
        dispatch
    ]);
    var reset = (0, $8NFma.useCallback)(function() {
        dispatch({
            type: $f4c8705b32f2a63d$var$FunctionReset$2
        });
    }, [
        dispatch
    ]);
    var setInputValue = (0, $8NFma.useCallback)(function(newInputValue) {
        dispatch({
            type: $f4c8705b32f2a63d$var$FunctionSetInputValue$1,
            inputValue: newInputValue
        });
    }, [
        dispatch
    ]);
    // Getter functions.
    var getLabelProps = (0, $8NFma.useCallback)(function(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, onClick = _ref.onClick, labelProps = (0, $cfde373be945f92b$export$2e2bcd8739ae039)(_ref, $f4c8705b32f2a63d$var$_excluded$2);
        var labelHandleClick = function labelHandleClick() {
            var _toggleButtonRef$curr;
            (_toggleButtonRef$curr = toggleButtonRef.current) == null || _toggleButtonRef$curr.focus();
        };
        return (0, $e3e49ed681292e30$export$2e2bcd8739ae039)({
            id: elementIds.labelId,
            htmlFor: elementIds.toggleButtonId,
            onClick: $f4c8705b32f2a63d$var$callAllEventHandlers(onClick, labelHandleClick)
        }, labelProps);
    }, [
        elementIds
    ]);
    var getMenuProps = (0, $8NFma.useCallback)(function(_temp2, _temp3) {
        var _extends2;
        var _ref2 = _temp2 === void 0 ? {} : _temp2, onMouseLeave = _ref2.onMouseLeave, _ref2$refKey = _ref2.refKey, refKey = _ref2$refKey === void 0 ? 'ref' : _ref2$refKey, ref = _ref2.ref, rest = (0, $cfde373be945f92b$export$2e2bcd8739ae039)(_ref2, $f4c8705b32f2a63d$var$_excluded2$2);
        var _ref3 = _temp3 === void 0 ? {} : _temp3, _ref3$suppressRefErro = _ref3.suppressRefError, suppressRefError = _ref3$suppressRefErro === void 0 ? false : _ref3$suppressRefErro;
        var menuHandleMouseLeave = function menuHandleMouseLeave() {
            dispatch({
                type: $f4c8705b32f2a63d$var$MenuMouseLeave$1
            });
        };
        setGetterPropCallInfo('getMenuProps', suppressRefError, refKey, menuRef);
        return (0, $e3e49ed681292e30$export$2e2bcd8739ae039)((_extends2 = {}, _extends2[refKey] = $f4c8705b32f2a63d$var$handleRefs(ref, function(menuNode) {
            menuRef.current = menuNode;
        }), _extends2.id = elementIds.menuId, _extends2.role = 'listbox', _extends2['aria-labelledby'] = rest && rest['aria-label'] ? undefined : "" + elementIds.labelId, _extends2.onMouseLeave = $f4c8705b32f2a63d$var$callAllEventHandlers(onMouseLeave, menuHandleMouseLeave), _extends2), rest);
    }, [
        dispatch,
        setGetterPropCallInfo,
        elementIds
    ]);
    var getToggleButtonProps = (0, $8NFma.useCallback)(function(_temp4, _temp5) {
        var _extends3;
        var _ref4 = _temp4 === void 0 ? {} : _temp4, onBlur = _ref4.onBlur, onClick = _ref4.onClick;
        _ref4.onPress;
        var onKeyDown = _ref4.onKeyDown, _ref4$refKey = _ref4.refKey, refKey = _ref4$refKey === void 0 ? 'ref' : _ref4$refKey, ref = _ref4.ref, rest = (0, $cfde373be945f92b$export$2e2bcd8739ae039)(_ref4, $f4c8705b32f2a63d$var$_excluded3$1);
        var _ref5 = _temp5 === void 0 ? {} : _temp5, _ref5$suppressRefErro = _ref5.suppressRefError, suppressRefError = _ref5$suppressRefErro === void 0 ? false : _ref5$suppressRefErro;
        var latestState = latest.current.state;
        var toggleButtonHandleClick = function toggleButtonHandleClick() {
            dispatch({
                type: $f4c8705b32f2a63d$var$ToggleButtonClick$1
            });
        };
        var toggleButtonHandleBlur = function toggleButtonHandleBlur() {
            if (latestState.isOpen && !mouseAndTouchTrackers.isMouseDown) dispatch({
                type: $f4c8705b32f2a63d$var$ToggleButtonBlur
            });
        };
        var toggleButtonHandleKeyDown = function toggleButtonHandleKeyDown(event) {
            var key = $f4c8705b32f2a63d$var$normalizeArrowKey(event);
            if (key && toggleButtonKeyDownHandlers[key]) toggleButtonKeyDownHandlers[key](event);
            else if ($f4c8705b32f2a63d$var$isAcceptedCharacterKey(key)) dispatch({
                type: $f4c8705b32f2a63d$var$ToggleButtonKeyDownCharacter,
                key: key
            });
        };
        var toggleProps = (0, $e3e49ed681292e30$export$2e2bcd8739ae039)((_extends3 = {}, _extends3[refKey] = $f4c8705b32f2a63d$var$handleRefs(ref, function(toggleButtonNode) {
            toggleButtonRef.current = toggleButtonNode;
        }), _extends3['aria-activedescendant'] = latestState.isOpen && latestState.highlightedIndex > -1 ? elementIds.getItemId(latestState.highlightedIndex) : '', _extends3['aria-controls'] = elementIds.menuId, _extends3['aria-expanded'] = latest.current.state.isOpen, _extends3['aria-haspopup'] = 'listbox', _extends3['aria-labelledby'] = rest && rest['aria-label'] ? undefined : "" + elementIds.labelId, _extends3.id = elementIds.toggleButtonId, _extends3.role = 'combobox', _extends3.tabIndex = 0, _extends3.onBlur = $f4c8705b32f2a63d$var$callAllEventHandlers(onBlur, toggleButtonHandleBlur), _extends3), rest);
        if (!rest.disabled) {
            toggleProps.onClick = $f4c8705b32f2a63d$var$callAllEventHandlers(onClick, toggleButtonHandleClick);
            toggleProps.onKeyDown = $f4c8705b32f2a63d$var$callAllEventHandlers(onKeyDown, toggleButtonHandleKeyDown);
        }
        setGetterPropCallInfo('getToggleButtonProps', suppressRefError, refKey, toggleButtonRef);
        return toggleProps;
    }, [
        dispatch,
        elementIds,
        latest,
        mouseAndTouchTrackers,
        setGetterPropCallInfo,
        toggleButtonKeyDownHandlers
    ]);
    var getItemProps = (0, $8NFma.useCallback)(function(_temp6) {
        var _extends4;
        var _ref6 = _temp6 === void 0 ? {} : _temp6, itemProp = _ref6.item, indexProp = _ref6.index, onMouseMove = _ref6.onMouseMove, onClick = _ref6.onClick, onMouseDown = _ref6.onMouseDown;
        _ref6.onPress;
        var _ref6$refKey = _ref6.refKey, refKey = _ref6$refKey === void 0 ? 'ref' : _ref6$refKey, disabledProp = _ref6.disabled, ref = _ref6.ref, rest = (0, $cfde373be945f92b$export$2e2bcd8739ae039)(_ref6, $f4c8705b32f2a63d$var$_excluded4$1);
        if (disabledProp !== undefined) console.warn('Passing "disabled" as an argument to getItemProps is not supported anymore. Please use the isItemDisabled prop from useSelect.');
        var _latest$current = latest.current, latestState = _latest$current.state, latestProps = _latest$current.props;
        var _getItemAndIndex = $f4c8705b32f2a63d$var$getItemAndIndex(itemProp, indexProp, latestProps.items, 'Pass either item or index to getItemProps!'), item = _getItemAndIndex[0], index = _getItemAndIndex[1];
        var disabled = latestProps.isItemDisabled(item, index);
        var itemHandleMouseMove = function itemHandleMouseMove() {
            if (mouseAndTouchTrackers.isTouchEnd || index === latestState.highlightedIndex) return;
            shouldScrollRef.current = false;
            dispatch({
                type: $f4c8705b32f2a63d$var$ItemMouseMove$1,
                index: index,
                disabled: disabled
            });
        };
        var itemHandleClick = function itemHandleClick() {
            dispatch({
                type: $f4c8705b32f2a63d$var$ItemClick$1,
                index: index
            });
        };
        var itemHandleMouseDown = function itemHandleMouseDown(e) {
            return e.preventDefault();
        }; // keep focus on the toggle after item click select.
        var itemProps = (0, $e3e49ed681292e30$export$2e2bcd8739ae039)((_extends4 = {}, _extends4[refKey] = $f4c8705b32f2a63d$var$handleRefs(ref, function(itemNode) {
            if (itemNode) itemRefs.current[elementIds.getItemId(index)] = itemNode;
        }), _extends4['aria-disabled'] = disabled, _extends4['aria-selected'] = item === latestState.selectedItem, _extends4.id = elementIds.getItemId(index), _extends4.role = 'option', _extends4), rest);
        if (!disabled) itemProps.onClick = $f4c8705b32f2a63d$var$callAllEventHandlers(onClick, itemHandleClick);
        itemProps.onMouseMove = $f4c8705b32f2a63d$var$callAllEventHandlers(onMouseMove, itemHandleMouseMove);
        itemProps.onMouseDown = $f4c8705b32f2a63d$var$callAllEventHandlers(onMouseDown, itemHandleMouseDown);
        return itemProps;
    }, [
        latest,
        elementIds,
        mouseAndTouchTrackers,
        shouldScrollRef,
        dispatch
    ]);
    return {
        // prop getters.
        getToggleButtonProps: getToggleButtonProps,
        getLabelProps: getLabelProps,
        getMenuProps: getMenuProps,
        getItemProps: getItemProps,
        // actions.
        toggleMenu: toggleMenu,
        openMenu: openMenu,
        closeMenu: closeMenu,
        setHighlightedIndex: setHighlightedIndex,
        selectItem: selectItem,
        reset: reset,
        setInputValue: setInputValue,
        // state.
        highlightedIndex: highlightedIndex,
        isOpen: isOpen,
        selectedItem: selectedItem,
        inputValue: inputValue
    };
}
var $f4c8705b32f2a63d$var$InputKeyDownArrowDown = 0;
var $f4c8705b32f2a63d$var$InputKeyDownArrowUp = 1;
var $f4c8705b32f2a63d$var$InputKeyDownEscape = 2;
var $f4c8705b32f2a63d$var$InputKeyDownHome = 3;
var $f4c8705b32f2a63d$var$InputKeyDownEnd = 4;
var $f4c8705b32f2a63d$var$InputKeyDownPageUp = 5;
var $f4c8705b32f2a63d$var$InputKeyDownPageDown = 6;
var $f4c8705b32f2a63d$var$InputKeyDownEnter = 7;
var $f4c8705b32f2a63d$var$InputChange = 8;
var $f4c8705b32f2a63d$var$InputBlur = 9;
var $f4c8705b32f2a63d$var$InputClick = 10;
var $f4c8705b32f2a63d$var$MenuMouseLeave = 11;
var $f4c8705b32f2a63d$var$ItemMouseMove = 12;
var $f4c8705b32f2a63d$var$ItemClick = 13;
var $f4c8705b32f2a63d$var$ToggleButtonClick = 14;
var $f4c8705b32f2a63d$var$FunctionToggleMenu = 15;
var $f4c8705b32f2a63d$var$FunctionOpenMenu = 16;
var $f4c8705b32f2a63d$var$FunctionCloseMenu = 17;
var $f4c8705b32f2a63d$var$FunctionSetHighlightedIndex = 18;
var $f4c8705b32f2a63d$var$FunctionSelectItem = 19;
var $f4c8705b32f2a63d$var$FunctionSetInputValue = 20;
var $f4c8705b32f2a63d$var$FunctionReset$1 = 21;
var $f4c8705b32f2a63d$var$ControlledPropUpdatedSelectedItem = 22;
var $f4c8705b32f2a63d$var$stateChangeTypes$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ControlledPropUpdatedSelectedItem: $f4c8705b32f2a63d$var$ControlledPropUpdatedSelectedItem,
    FunctionCloseMenu: $f4c8705b32f2a63d$var$FunctionCloseMenu,
    FunctionOpenMenu: $f4c8705b32f2a63d$var$FunctionOpenMenu,
    FunctionReset: $f4c8705b32f2a63d$var$FunctionReset$1,
    FunctionSelectItem: $f4c8705b32f2a63d$var$FunctionSelectItem,
    FunctionSetHighlightedIndex: $f4c8705b32f2a63d$var$FunctionSetHighlightedIndex,
    FunctionSetInputValue: $f4c8705b32f2a63d$var$FunctionSetInputValue,
    FunctionToggleMenu: $f4c8705b32f2a63d$var$FunctionToggleMenu,
    InputBlur: $f4c8705b32f2a63d$var$InputBlur,
    InputChange: $f4c8705b32f2a63d$var$InputChange,
    InputClick: $f4c8705b32f2a63d$var$InputClick,
    InputKeyDownArrowDown: $f4c8705b32f2a63d$var$InputKeyDownArrowDown,
    InputKeyDownArrowUp: $f4c8705b32f2a63d$var$InputKeyDownArrowUp,
    InputKeyDownEnd: $f4c8705b32f2a63d$var$InputKeyDownEnd,
    InputKeyDownEnter: $f4c8705b32f2a63d$var$InputKeyDownEnter,
    InputKeyDownEscape: $f4c8705b32f2a63d$var$InputKeyDownEscape,
    InputKeyDownHome: $f4c8705b32f2a63d$var$InputKeyDownHome,
    InputKeyDownPageDown: $f4c8705b32f2a63d$var$InputKeyDownPageDown,
    InputKeyDownPageUp: $f4c8705b32f2a63d$var$InputKeyDownPageUp,
    ItemClick: $f4c8705b32f2a63d$var$ItemClick,
    ItemMouseMove: $f4c8705b32f2a63d$var$ItemMouseMove,
    MenuMouseLeave: $f4c8705b32f2a63d$var$MenuMouseLeave,
    ToggleButtonClick: $f4c8705b32f2a63d$var$ToggleButtonClick
});
function $f4c8705b32f2a63d$var$getInitialState$1(props) {
    var initialState = $f4c8705b32f2a63d$var$getInitialState$2(props);
    var selectedItem = initialState.selectedItem;
    var inputValue = initialState.inputValue;
    if (inputValue === '' && selectedItem && props.defaultInputValue === undefined && props.initialInputValue === undefined && props.inputValue === undefined) inputValue = props.itemToString(selectedItem);
    return (0, $e3e49ed681292e30$export$2e2bcd8739ae039)({}, initialState, {
        inputValue: inputValue
    });
}
var $f4c8705b32f2a63d$var$propTypes$1 = (0, $e3e49ed681292e30$export$2e2bcd8739ae039)({}, $f4c8705b32f2a63d$var$commonDropdownPropTypes, {
    items: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).array.isRequired,
    isItemDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func,
    inputValue: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
    defaultInputValue: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
    initialInputValue: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
    inputId: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
    onInputValueChange: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func
});
/**
 * The useCombobox version of useControlledReducer, which also
 * checks if the controlled prop selectedItem changed between
 * renders. If so, it will also update inputValue with its
 * string equivalent. It uses the common useEnhancedReducer to
 * compute the rest of the state.
 *
 * @param {Function} reducer Reducer function from downshift.
 * @param {Object} props The hook props, also passed to createInitialState.
 * @param {Function} createInitialState Function that returns the initial state.
 * @param {Function} isStateEqual Function that checks if a previous state is equal to the next.
 * @returns {Array} An array with the state and an action dispatcher.
 */ function $f4c8705b32f2a63d$var$useControlledReducer(reducer, props, createInitialState, isStateEqual) {
    var previousSelectedItemRef = (0, $8NFma.useRef)();
    var _useEnhancedReducer = $f4c8705b32f2a63d$var$useEnhancedReducer(reducer, props, createInitialState, isStateEqual), state = _useEnhancedReducer[0], dispatch = _useEnhancedReducer[1];
    var isInitialMount = $f4c8705b32f2a63d$var$useIsInitialMount();
    (0, $8NFma.useEffect)(function() {
        if (!$f4c8705b32f2a63d$var$isControlledProp(props, 'selectedItem')) return;
        if (!isInitialMount // on first mount we already have the proper inputValue for a initial selected item.
        ) {
            var shouldCallDispatch = props.itemToKey(props.selectedItem) !== props.itemToKey(previousSelectedItemRef.current);
            if (shouldCallDispatch) dispatch({
                type: $f4c8705b32f2a63d$var$ControlledPropUpdatedSelectedItem,
                inputValue: props.itemToString(props.selectedItem)
            });
        }
        previousSelectedItemRef.current = state.selectedItem === previousSelectedItemRef.current ? props.selectedItem : state.selectedItem;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        state.selectedItem,
        props.selectedItem
    ]);
    return [
        $f4c8705b32f2a63d$var$getState(state, props),
        dispatch
    ];
}
// eslint-disable-next-line import/no-mutable-exports
var $f4c8705b32f2a63d$var$validatePropTypes$1 = $f4c8705b32f2a63d$var$noop;
var $f4c8705b32f2a63d$var$defaultProps$1 = (0, $e3e49ed681292e30$export$2e2bcd8739ae039)({}, $f4c8705b32f2a63d$var$defaultProps$3, {
    isItemDisabled: function isItemDisabled() {
        return false;
    }
});
/* eslint-disable complexity */ function $f4c8705b32f2a63d$var$downshiftUseComboboxReducer(state, action) {
    var _props$items;
    var type = action.type, props = action.props, altKey = action.altKey;
    var changes;
    switch(type){
        case $f4c8705b32f2a63d$var$ItemClick:
            changes = {
                isOpen: $f4c8705b32f2a63d$var$getDefaultValue$1(props, 'isOpen'),
                highlightedIndex: $f4c8705b32f2a63d$var$getDefaultHighlightedIndex(props),
                selectedItem: props.items[action.index],
                inputValue: props.itemToString(props.items[action.index])
            };
            break;
        case $f4c8705b32f2a63d$var$InputKeyDownArrowDown:
            if (state.isOpen) changes = {
                highlightedIndex: $f4c8705b32f2a63d$var$getHighlightedIndex(state.highlightedIndex, 1, props.items, props.isItemDisabled, true)
            };
            else changes = {
                highlightedIndex: altKey && state.selectedItem == null ? -1 : $f4c8705b32f2a63d$var$getHighlightedIndexOnOpen(props, state, 1),
                isOpen: props.items.length >= 0
            };
            break;
        case $f4c8705b32f2a63d$var$InputKeyDownArrowUp:
            if (state.isOpen) {
                if (altKey) changes = $f4c8705b32f2a63d$var$getChangesOnSelection(props, state.highlightedIndex);
                else changes = {
                    highlightedIndex: $f4c8705b32f2a63d$var$getHighlightedIndex(state.highlightedIndex, -1, props.items, props.isItemDisabled, true)
                };
            } else changes = {
                highlightedIndex: $f4c8705b32f2a63d$var$getHighlightedIndexOnOpen(props, state, -1),
                isOpen: props.items.length >= 0
            };
            break;
        case $f4c8705b32f2a63d$var$InputKeyDownEnter:
            changes = $f4c8705b32f2a63d$var$getChangesOnSelection(props, state.highlightedIndex);
            break;
        case $f4c8705b32f2a63d$var$InputKeyDownEscape:
            changes = (0, $e3e49ed681292e30$export$2e2bcd8739ae039)({
                isOpen: false,
                highlightedIndex: -1
            }, !state.isOpen && {
                selectedItem: null,
                inputValue: ''
            });
            break;
        case $f4c8705b32f2a63d$var$InputKeyDownPageUp:
            changes = {
                highlightedIndex: $f4c8705b32f2a63d$var$getHighlightedIndex(state.highlightedIndex, -10, props.items, props.isItemDisabled, true)
            };
            break;
        case $f4c8705b32f2a63d$var$InputKeyDownPageDown:
            changes = {
                highlightedIndex: $f4c8705b32f2a63d$var$getHighlightedIndex(state.highlightedIndex, 10, props.items, props.isItemDisabled, true)
            };
            break;
        case $f4c8705b32f2a63d$var$InputKeyDownHome:
            changes = {
                highlightedIndex: $f4c8705b32f2a63d$var$getNonDisabledIndex(0, false, props.items, props.isItemDisabled)
            };
            break;
        case $f4c8705b32f2a63d$var$InputKeyDownEnd:
            changes = {
                highlightedIndex: $f4c8705b32f2a63d$var$getNonDisabledIndex(props.items.length - 1, true, props.items, props.isItemDisabled)
            };
            break;
        case $f4c8705b32f2a63d$var$InputBlur:
            changes = (0, $e3e49ed681292e30$export$2e2bcd8739ae039)({
                isOpen: false,
                highlightedIndex: -1
            }, state.highlightedIndex >= 0 && ((_props$items = props.items) == null ? void 0 : _props$items.length) && action.selectItem && {
                selectedItem: props.items[state.highlightedIndex],
                inputValue: props.itemToString(props.items[state.highlightedIndex])
            });
            break;
        case $f4c8705b32f2a63d$var$InputChange:
            changes = {
                isOpen: true,
                highlightedIndex: $f4c8705b32f2a63d$var$getDefaultHighlightedIndex(props),
                inputValue: action.inputValue
            };
            break;
        case $f4c8705b32f2a63d$var$InputClick:
            changes = {
                isOpen: !state.isOpen,
                highlightedIndex: state.isOpen ? -1 : $f4c8705b32f2a63d$var$getHighlightedIndexOnOpen(props, state, 0)
            };
            break;
        case $f4c8705b32f2a63d$var$FunctionSelectItem:
            changes = {
                selectedItem: action.selectedItem,
                inputValue: props.itemToString(action.selectedItem)
            };
            break;
        case $f4c8705b32f2a63d$var$ControlledPropUpdatedSelectedItem:
            changes = {
                inputValue: action.inputValue
            };
            break;
        default:
            return $f4c8705b32f2a63d$var$downshiftCommonReducer(state, action, $f4c8705b32f2a63d$var$stateChangeTypes$1);
    }
    return (0, $e3e49ed681292e30$export$2e2bcd8739ae039)({}, state, changes);
}
/* eslint-enable complexity */ var $f4c8705b32f2a63d$var$_excluded$1 = [
    "onMouseLeave",
    "refKey",
    "ref"
], $f4c8705b32f2a63d$var$_excluded2$1 = [
    "item",
    "index",
    "refKey",
    "ref",
    "onMouseMove",
    "onMouseDown",
    "onClick",
    "onPress",
    "disabled"
], $f4c8705b32f2a63d$var$_excluded3 = [
    "onClick",
    "onPress",
    "refKey",
    "ref"
], $f4c8705b32f2a63d$var$_excluded4 = [
    "onKeyDown",
    "onChange",
    "onInput",
    "onBlur",
    "onChangeText",
    "onClick",
    "refKey",
    "ref"
];
$f4c8705b32f2a63d$export$7a023a466c03eb3d.stateChangeTypes = $f4c8705b32f2a63d$var$stateChangeTypes$1;
function $f4c8705b32f2a63d$export$7a023a466c03eb3d(userProps) {
    if (userProps === void 0) userProps = {};
    $f4c8705b32f2a63d$var$validatePropTypes$1(userProps, $f4c8705b32f2a63d$export$7a023a466c03eb3d);
    // Props defaults and destructuring.
    var props = (0, $e3e49ed681292e30$export$2e2bcd8739ae039)({}, $f4c8705b32f2a63d$var$defaultProps$1, userProps);
    var items = props.items, scrollIntoView = props.scrollIntoView, environment = props.environment, getA11yStatusMessage = props.getA11yStatusMessage;
    // Initial state depending on controlled props.
    var _useControlledReducer = $f4c8705b32f2a63d$var$useControlledReducer($f4c8705b32f2a63d$var$downshiftUseComboboxReducer, props, $f4c8705b32f2a63d$var$getInitialState$1, $f4c8705b32f2a63d$var$isDropdownsStateEqual), state = _useControlledReducer[0], dispatch = _useControlledReducer[1];
    var isOpen = state.isOpen, highlightedIndex = state.highlightedIndex, selectedItem = state.selectedItem, inputValue = state.inputValue;
    // Element refs.
    var menuRef = (0, $8NFma.useRef)(null);
    var itemRefs = (0, $8NFma.useRef)({});
    var inputRef = (0, $8NFma.useRef)(null);
    var toggleButtonRef = (0, $8NFma.useRef)(null);
    var isInitialMount = $f4c8705b32f2a63d$var$useIsInitialMount();
    // prevent id re-generation between renders.
    var elementIds = $f4c8705b32f2a63d$var$useElementIds(props);
    // used to keep track of how many items we had on previous cycle.
    var previousResultCountRef = (0, $8NFma.useRef)();
    // utility callback to get item element.
    var latest = $f4c8705b32f2a63d$var$useLatestRef({
        state: state,
        props: props
    });
    var getItemNodeFromIndex = (0, $8NFma.useCallback)(function(index) {
        return itemRefs.current[elementIds.getItemId(index)];
    }, [
        elementIds
    ]);
    // Effects.
    // Adds an a11y aria live status message if getA11yStatusMessage is passed.
    $f4c8705b32f2a63d$var$useA11yMessageStatus(getA11yStatusMessage, state, [
        isOpen,
        highlightedIndex,
        selectedItem,
        inputValue
    ], environment);
    // Scroll on highlighted item if change comes from keyboard.
    var shouldScrollRef = $f4c8705b32f2a63d$var$useScrollIntoView({
        menuElement: menuRef.current,
        highlightedIndex: highlightedIndex,
        isOpen: isOpen,
        itemRefs: itemRefs,
        scrollIntoView: scrollIntoView,
        getItemNodeFromIndex: getItemNodeFromIndex
    });
    $f4c8705b32f2a63d$var$useControlPropsValidator({
        props: props,
        state: state
    });
    // Focus the input on first render if required.
    (0, $8NFma.useEffect)(function() {
        var focusOnOpen = $f4c8705b32f2a63d$var$getInitialValue$1(props, 'isOpen');
        if (focusOnOpen && inputRef.current) inputRef.current.focus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $8NFma.useEffect)(function() {
        if (!isInitialMount) previousResultCountRef.current = items.length;
    });
    var mouseAndTouchTrackers = $f4c8705b32f2a63d$var$useMouseAndTouchTracker(environment, [
        toggleButtonRef,
        menuRef,
        inputRef
    ], (0, $8NFma.useCallback)(function handleBlur() {
        if (latest.current.state.isOpen) dispatch({
            type: $f4c8705b32f2a63d$var$InputBlur,
            selectItem: false
        });
    }, [
        dispatch,
        latest
    ]));
    var setGetterPropCallInfo = $f4c8705b32f2a63d$var$useGetterPropsCalledChecker('getInputProps', 'getMenuProps');
    // Reset itemRefs on close.
    (0, $8NFma.useEffect)(function() {
        if (!isOpen) itemRefs.current = {};
    }, [
        isOpen
    ]);
    // Reset itemRefs on close.
    (0, $8NFma.useEffect)(function() {
        var _inputRef$current;
        if (!isOpen || !(environment != null && environment.document) || !(inputRef != null && (_inputRef$current = inputRef.current) != null && _inputRef$current.focus)) return;
        if (environment.document.activeElement !== inputRef.current) inputRef.current.focus();
    }, [
        isOpen,
        environment
    ]);
    /* Event handler functions */ var inputKeyDownHandlers = (0, $8NFma.useMemo)(function() {
        return {
            ArrowDown: function ArrowDown(event) {
                event.preventDefault();
                dispatch({
                    type: $f4c8705b32f2a63d$var$InputKeyDownArrowDown,
                    altKey: event.altKey
                });
            },
            ArrowUp: function ArrowUp(event) {
                event.preventDefault();
                dispatch({
                    type: $f4c8705b32f2a63d$var$InputKeyDownArrowUp,
                    altKey: event.altKey
                });
            },
            Home: function Home(event) {
                if (!latest.current.state.isOpen) return;
                event.preventDefault();
                dispatch({
                    type: $f4c8705b32f2a63d$var$InputKeyDownHome
                });
            },
            End: function End(event) {
                if (!latest.current.state.isOpen) return;
                event.preventDefault();
                dispatch({
                    type: $f4c8705b32f2a63d$var$InputKeyDownEnd
                });
            },
            Escape: function Escape(event) {
                var latestState = latest.current.state;
                if (latestState.isOpen || latestState.inputValue || latestState.selectedItem || latestState.highlightedIndex > -1) {
                    event.preventDefault();
                    dispatch({
                        type: $f4c8705b32f2a63d$var$InputKeyDownEscape
                    });
                }
            },
            Enter: function Enter(event) {
                var latestState = latest.current.state;
                // if closed or no highlighted index, do nothing.
                if (!latestState.isOpen || event.which === 229 // if IME composing, wait for next Enter keydown event.
                ) return;
                event.preventDefault();
                dispatch({
                    type: $f4c8705b32f2a63d$var$InputKeyDownEnter
                });
            },
            PageUp: function PageUp(event) {
                if (latest.current.state.isOpen) {
                    event.preventDefault();
                    dispatch({
                        type: $f4c8705b32f2a63d$var$InputKeyDownPageUp
                    });
                }
            },
            PageDown: function PageDown(event) {
                if (latest.current.state.isOpen) {
                    event.preventDefault();
                    dispatch({
                        type: $f4c8705b32f2a63d$var$InputKeyDownPageDown
                    });
                }
            }
        };
    }, [
        dispatch,
        latest
    ]);
    // Getter props.
    var getLabelProps = (0, $8NFma.useCallback)(function(labelProps) {
        return (0, $e3e49ed681292e30$export$2e2bcd8739ae039)({
            id: elementIds.labelId,
            htmlFor: elementIds.inputId
        }, labelProps);
    }, [
        elementIds
    ]);
    var getMenuProps = (0, $8NFma.useCallback)(function(_temp, _temp2) {
        var _extends2;
        var _ref = _temp === void 0 ? {} : _temp, onMouseLeave = _ref.onMouseLeave, _ref$refKey = _ref.refKey, refKey = _ref$refKey === void 0 ? 'ref' : _ref$refKey, ref = _ref.ref, rest = (0, $cfde373be945f92b$export$2e2bcd8739ae039)(_ref, $f4c8705b32f2a63d$var$_excluded$1);
        var _ref2 = _temp2 === void 0 ? {} : _temp2, _ref2$suppressRefErro = _ref2.suppressRefError, suppressRefError = _ref2$suppressRefErro === void 0 ? false : _ref2$suppressRefErro;
        setGetterPropCallInfo('getMenuProps', suppressRefError, refKey, menuRef);
        return (0, $e3e49ed681292e30$export$2e2bcd8739ae039)((_extends2 = {}, _extends2[refKey] = $f4c8705b32f2a63d$var$handleRefs(ref, function(menuNode) {
            menuRef.current = menuNode;
        }), _extends2.id = elementIds.menuId, _extends2.role = 'listbox', _extends2['aria-labelledby'] = rest && rest['aria-label'] ? undefined : "" + elementIds.labelId, _extends2.onMouseLeave = $f4c8705b32f2a63d$var$callAllEventHandlers(onMouseLeave, function() {
            dispatch({
                type: $f4c8705b32f2a63d$var$MenuMouseLeave
            });
        }), _extends2), rest);
    }, [
        dispatch,
        setGetterPropCallInfo,
        elementIds
    ]);
    var getItemProps = (0, $8NFma.useCallback)(function(_temp3) {
        var _extends3, _ref4;
        var _ref3 = _temp3 === void 0 ? {} : _temp3, itemProp = _ref3.item, indexProp = _ref3.index, _ref3$refKey = _ref3.refKey, refKey = _ref3$refKey === void 0 ? 'ref' : _ref3$refKey, ref = _ref3.ref, onMouseMove = _ref3.onMouseMove, onMouseDown = _ref3.onMouseDown, onClick = _ref3.onClick;
        _ref3.onPress;
        var disabledProp = _ref3.disabled, rest = (0, $cfde373be945f92b$export$2e2bcd8739ae039)(_ref3, $f4c8705b32f2a63d$var$_excluded2$1);
        if (disabledProp !== undefined) console.warn('Passing "disabled" as an argument to getItemProps is not supported anymore. Please use the isItemDisabled prop from useCombobox.');
        var _latest$current = latest.current, latestProps = _latest$current.props, latestState = _latest$current.state;
        var _getItemAndIndex = $f4c8705b32f2a63d$var$getItemAndIndex(itemProp, indexProp, latestProps.items, 'Pass either item or index to getItemProps!'), item = _getItemAndIndex[0], index = _getItemAndIndex[1];
        var disabled = latestProps.isItemDisabled(item, index);
        var onSelectKey = 'onClick';
        var customClickHandler = onClick;
        var itemHandleMouseMove = function itemHandleMouseMove() {
            if (mouseAndTouchTrackers.isTouchEnd || index === latestState.highlightedIndex) return;
            shouldScrollRef.current = false;
            dispatch({
                type: $f4c8705b32f2a63d$var$ItemMouseMove,
                index: index,
                disabled: disabled
            });
        };
        var itemHandleClick = function itemHandleClick() {
            dispatch({
                type: $f4c8705b32f2a63d$var$ItemClick,
                index: index
            });
        };
        var itemHandleMouseDown = function itemHandleMouseDown(e) {
            return e.preventDefault();
        }; // keep focus on the input after item click select.
        return (0, $e3e49ed681292e30$export$2e2bcd8739ae039)((_extends3 = {}, _extends3[refKey] = $f4c8705b32f2a63d$var$handleRefs(ref, function(itemNode) {
            if (itemNode) itemRefs.current[elementIds.getItemId(index)] = itemNode;
        }), _extends3['aria-disabled'] = disabled, _extends3['aria-selected'] = index === latestState.highlightedIndex, _extends3.id = elementIds.getItemId(index), _extends3.role = 'option', _extends3), !disabled && (_ref4 = {}, _ref4[onSelectKey] = $f4c8705b32f2a63d$var$callAllEventHandlers(customClickHandler, itemHandleClick), _ref4), {
            onMouseMove: $f4c8705b32f2a63d$var$callAllEventHandlers(onMouseMove, itemHandleMouseMove),
            onMouseDown: $f4c8705b32f2a63d$var$callAllEventHandlers(onMouseDown, itemHandleMouseDown)
        }, rest);
    }, [
        dispatch,
        elementIds,
        latest,
        mouseAndTouchTrackers,
        shouldScrollRef
    ]);
    var getToggleButtonProps = (0, $8NFma.useCallback)(function(_temp4) {
        var _extends4;
        var _ref5 = _temp4 === void 0 ? {} : _temp4, onClick = _ref5.onClick;
        _ref5.onPress;
        var _ref5$refKey = _ref5.refKey, refKey = _ref5$refKey === void 0 ? 'ref' : _ref5$refKey, ref = _ref5.ref, rest = (0, $cfde373be945f92b$export$2e2bcd8739ae039)(_ref5, $f4c8705b32f2a63d$var$_excluded3);
        var latestState = latest.current.state;
        var toggleButtonHandleClick = function toggleButtonHandleClick() {
            dispatch({
                type: $f4c8705b32f2a63d$var$ToggleButtonClick
            });
        };
        return (0, $e3e49ed681292e30$export$2e2bcd8739ae039)((_extends4 = {}, _extends4[refKey] = $f4c8705b32f2a63d$var$handleRefs(ref, function(toggleButtonNode) {
            toggleButtonRef.current = toggleButtonNode;
        }), _extends4['aria-controls'] = elementIds.menuId, _extends4['aria-expanded'] = latestState.isOpen, _extends4.id = elementIds.toggleButtonId, _extends4.tabIndex = -1, _extends4), !rest.disabled && (0, $e3e49ed681292e30$export$2e2bcd8739ae039)({}, {
            onClick: $f4c8705b32f2a63d$var$callAllEventHandlers(onClick, toggleButtonHandleClick)
        }), rest);
    }, [
        dispatch,
        latest,
        elementIds
    ]);
    var getInputProps = (0, $8NFma.useCallback)(function(_temp5, _temp6) {
        var _extends5;
        var _ref6 = _temp5 === void 0 ? {} : _temp5, onKeyDown = _ref6.onKeyDown, onChange = _ref6.onChange, onInput = _ref6.onInput, onBlur = _ref6.onBlur;
        _ref6.onChangeText;
        var onClick = _ref6.onClick, _ref6$refKey = _ref6.refKey, refKey = _ref6$refKey === void 0 ? 'ref' : _ref6$refKey, ref = _ref6.ref, rest = (0, $cfde373be945f92b$export$2e2bcd8739ae039)(_ref6, $f4c8705b32f2a63d$var$_excluded4);
        var _ref7 = _temp6 === void 0 ? {} : _temp6, _ref7$suppressRefErro = _ref7.suppressRefError, suppressRefError = _ref7$suppressRefErro === void 0 ? false : _ref7$suppressRefErro;
        setGetterPropCallInfo('getInputProps', suppressRefError, refKey, inputRef);
        var latestState = latest.current.state;
        var inputHandleKeyDown = function inputHandleKeyDown(event) {
            var key = $f4c8705b32f2a63d$var$normalizeArrowKey(event);
            if (key && inputKeyDownHandlers[key]) inputKeyDownHandlers[key](event);
        };
        var inputHandleChange = function inputHandleChange(event) {
            dispatch({
                type: $f4c8705b32f2a63d$var$InputChange,
                inputValue: event.target.value
            });
        };
        var inputHandleBlur = function inputHandleBlur(event) {
            /* istanbul ignore else */ if (environment != null && environment.document && latestState.isOpen && !mouseAndTouchTrackers.isMouseDown) {
                var isBlurByTabChange = event.relatedTarget === null && environment.document.activeElement !== environment.document.body;
                dispatch({
                    type: $f4c8705b32f2a63d$var$InputBlur,
                    selectItem: !isBlurByTabChange
                });
            }
        };
        var inputHandleClick = function inputHandleClick() {
            dispatch({
                type: $f4c8705b32f2a63d$var$InputClick
            });
        };
        /* istanbul ignore next (preact) */ var onChangeKey = 'onChange';
        var eventHandlers = {};
        if (!rest.disabled) {
            var _eventHandlers;
            eventHandlers = (_eventHandlers = {}, _eventHandlers[onChangeKey] = $f4c8705b32f2a63d$var$callAllEventHandlers(onChange, onInput, inputHandleChange), _eventHandlers.onKeyDown = $f4c8705b32f2a63d$var$callAllEventHandlers(onKeyDown, inputHandleKeyDown), _eventHandlers.onBlur = $f4c8705b32f2a63d$var$callAllEventHandlers(onBlur, inputHandleBlur), _eventHandlers.onClick = $f4c8705b32f2a63d$var$callAllEventHandlers(onClick, inputHandleClick), _eventHandlers);
        }
        return (0, $e3e49ed681292e30$export$2e2bcd8739ae039)((_extends5 = {}, _extends5[refKey] = $f4c8705b32f2a63d$var$handleRefs(ref, function(inputNode) {
            inputRef.current = inputNode;
        }), _extends5['aria-activedescendant'] = latestState.isOpen && latestState.highlightedIndex > -1 ? elementIds.getItemId(latestState.highlightedIndex) : '', _extends5['aria-autocomplete'] = 'list', _extends5['aria-controls'] = elementIds.menuId, _extends5['aria-expanded'] = latestState.isOpen, _extends5['aria-labelledby'] = rest && rest['aria-label'] ? undefined : elementIds.labelId, _extends5.autoComplete = 'off', _extends5.id = elementIds.inputId, _extends5.role = 'combobox', _extends5.value = latestState.inputValue, _extends5), eventHandlers, rest);
    }, [
        dispatch,
        elementIds,
        environment,
        inputKeyDownHandlers,
        latest,
        mouseAndTouchTrackers,
        setGetterPropCallInfo
    ]);
    // returns
    var toggleMenu = (0, $8NFma.useCallback)(function() {
        dispatch({
            type: $f4c8705b32f2a63d$var$FunctionToggleMenu
        });
    }, [
        dispatch
    ]);
    var closeMenu = (0, $8NFma.useCallback)(function() {
        dispatch({
            type: $f4c8705b32f2a63d$var$FunctionCloseMenu
        });
    }, [
        dispatch
    ]);
    var openMenu = (0, $8NFma.useCallback)(function() {
        dispatch({
            type: $f4c8705b32f2a63d$var$FunctionOpenMenu
        });
    }, [
        dispatch
    ]);
    var setHighlightedIndex = (0, $8NFma.useCallback)(function(newHighlightedIndex) {
        dispatch({
            type: $f4c8705b32f2a63d$var$FunctionSetHighlightedIndex,
            highlightedIndex: newHighlightedIndex
        });
    }, [
        dispatch
    ]);
    var selectItem = (0, $8NFma.useCallback)(function(newSelectedItem) {
        dispatch({
            type: $f4c8705b32f2a63d$var$FunctionSelectItem,
            selectedItem: newSelectedItem
        });
    }, [
        dispatch
    ]);
    var setInputValue = (0, $8NFma.useCallback)(function(newInputValue) {
        dispatch({
            type: $f4c8705b32f2a63d$var$FunctionSetInputValue,
            inputValue: newInputValue
        });
    }, [
        dispatch
    ]);
    var reset = (0, $8NFma.useCallback)(function() {
        dispatch({
            type: $f4c8705b32f2a63d$var$FunctionReset$1
        });
    }, [
        dispatch
    ]);
    return {
        // prop getters.
        getItemProps: getItemProps,
        getLabelProps: getLabelProps,
        getMenuProps: getMenuProps,
        getInputProps: getInputProps,
        getToggleButtonProps: getToggleButtonProps,
        // actions.
        toggleMenu: toggleMenu,
        openMenu: openMenu,
        closeMenu: closeMenu,
        setHighlightedIndex: setHighlightedIndex,
        setInputValue: setInputValue,
        selectItem: selectItem,
        reset: reset,
        // state.
        highlightedIndex: highlightedIndex,
        isOpen: isOpen,
        selectedItem: selectedItem,
        inputValue: inputValue
    };
}
var $f4c8705b32f2a63d$var$defaultStateValues = {
    activeIndex: -1,
    selectedItems: []
};
/**
 * Returns the initial value for a state key in the following order:
 * 1. controlled prop, 2. initial prop, 3. default prop, 4. default
 * value from Downshift.
 *
 * @param {Object} props Props passed to the hook.
 * @param {string} propKey Props key to generate the value for.
 * @returns {any} The initial value for that prop.
 */ function $f4c8705b32f2a63d$var$getInitialValue(props, propKey) {
    return $f4c8705b32f2a63d$var$getInitialValue$1(props, propKey, $f4c8705b32f2a63d$var$defaultStateValues);
}
/**
 * Returns the default value for a state key in the following order:
 * 1. controlled prop, 2. default prop, 3. default value from Downshift.
 *
 * @param {Object} props Props passed to the hook.
 * @param {string} propKey Props key to generate the value for.
 * @returns {any} The initial value for that prop.
 */ function $f4c8705b32f2a63d$var$getDefaultValue(props, propKey) {
    return $f4c8705b32f2a63d$var$getDefaultValue$1(props, propKey, $f4c8705b32f2a63d$var$defaultStateValues);
}
/**
 * Gets the initial state based on the provided props. It uses initial, default
 * and controlled props related to state in order to compute the initial value.
 *
 * @param {Object} props Props passed to the hook.
 * @returns {Object} The initial state.
 */ function $f4c8705b32f2a63d$var$getInitialState(props) {
    var activeIndex = $f4c8705b32f2a63d$var$getInitialValue(props, 'activeIndex');
    var selectedItems = $f4c8705b32f2a63d$var$getInitialValue(props, 'selectedItems');
    return {
        activeIndex: activeIndex,
        selectedItems: selectedItems
    };
}
/**
 * Returns true if dropdown keydown operation is permitted. Should not be
 * allowed on keydown with modifier keys (ctrl, alt, shift, meta), on
 * input element with text content that is either highlighted or selection
 * cursor is not at the starting position.
 *
 * @param {KeyboardEvent} event The event from keydown.
 * @returns {boolean} Whether the operation is allowed.
 */ function $f4c8705b32f2a63d$var$isKeyDownOperationPermitted(event) {
    if (event.shiftKey || event.metaKey || event.ctrlKey || event.altKey) return false;
    var element = event.target;
    if (element instanceof HTMLInputElement && // if element is a text input
    element.value !== '' && // and we have text in it
    // and cursor is either not at the start or is currently highlighting text.
    (element.selectionStart !== 0 || element.selectionEnd !== 0)) return false;
    return true;
}
/**
 * Check if a state is equal for taglist, by comparing active index and selected items.
 * Used by useSelect and useCombobox.
 *
 * @param {Object} prevState
 * @param {Object} newState
 * @returns {boolean} Wheather the states are deeply equal.
 */ function $f4c8705b32f2a63d$var$isStateEqual(prevState, newState) {
    return prevState.selectedItems === newState.selectedItems && prevState.activeIndex === newState.activeIndex;
}
var $f4c8705b32f2a63d$var$propTypes = {
    stateReducer: $f4c8705b32f2a63d$var$commonPropTypes.stateReducer,
    itemToKey: $f4c8705b32f2a63d$var$commonPropTypes.itemToKey,
    environment: $f4c8705b32f2a63d$var$commonPropTypes.environment,
    selectedItems: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).array,
    initialSelectedItems: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).array,
    defaultSelectedItems: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).array,
    getA11yStatusMessage: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func,
    activeIndex: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).number,
    initialActiveIndex: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).number,
    defaultActiveIndex: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).number,
    onActiveIndexChange: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func,
    onSelectedItemsChange: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func,
    keyNavigationNext: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
    keyNavigationPrevious: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string
};
var $f4c8705b32f2a63d$var$defaultProps = {
    itemToKey: $f4c8705b32f2a63d$var$defaultProps$3.itemToKey,
    stateReducer: $f4c8705b32f2a63d$var$defaultProps$3.stateReducer,
    environment: $f4c8705b32f2a63d$var$defaultProps$3.environment,
    keyNavigationNext: 'ArrowRight',
    keyNavigationPrevious: 'ArrowLeft'
};
// eslint-disable-next-line import/no-mutable-exports
var $f4c8705b32f2a63d$var$validatePropTypes = $f4c8705b32f2a63d$var$noop;
var $f4c8705b32f2a63d$var$SelectedItemClick = 0;
var $f4c8705b32f2a63d$var$SelectedItemKeyDownDelete = 1;
var $f4c8705b32f2a63d$var$SelectedItemKeyDownBackspace = 2;
var $f4c8705b32f2a63d$var$SelectedItemKeyDownNavigationNext = 3;
var $f4c8705b32f2a63d$var$SelectedItemKeyDownNavigationPrevious = 4;
var $f4c8705b32f2a63d$var$DropdownKeyDownNavigationPrevious = 5;
var $f4c8705b32f2a63d$var$DropdownKeyDownBackspace = 6;
var $f4c8705b32f2a63d$var$DropdownClick = 7;
var $f4c8705b32f2a63d$var$FunctionAddSelectedItem = 8;
var $f4c8705b32f2a63d$var$FunctionRemoveSelectedItem = 9;
var $f4c8705b32f2a63d$var$FunctionSetSelectedItems = 10;
var $f4c8705b32f2a63d$var$FunctionSetActiveIndex = 11;
var $f4c8705b32f2a63d$var$FunctionReset = 12;
var $f4c8705b32f2a63d$var$stateChangeTypes = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    DropdownClick: $f4c8705b32f2a63d$var$DropdownClick,
    DropdownKeyDownBackspace: $f4c8705b32f2a63d$var$DropdownKeyDownBackspace,
    DropdownKeyDownNavigationPrevious: $f4c8705b32f2a63d$var$DropdownKeyDownNavigationPrevious,
    FunctionAddSelectedItem: $f4c8705b32f2a63d$var$FunctionAddSelectedItem,
    FunctionRemoveSelectedItem: $f4c8705b32f2a63d$var$FunctionRemoveSelectedItem,
    FunctionReset: $f4c8705b32f2a63d$var$FunctionReset,
    FunctionSetActiveIndex: $f4c8705b32f2a63d$var$FunctionSetActiveIndex,
    FunctionSetSelectedItems: $f4c8705b32f2a63d$var$FunctionSetSelectedItems,
    SelectedItemClick: $f4c8705b32f2a63d$var$SelectedItemClick,
    SelectedItemKeyDownBackspace: $f4c8705b32f2a63d$var$SelectedItemKeyDownBackspace,
    SelectedItemKeyDownDelete: $f4c8705b32f2a63d$var$SelectedItemKeyDownDelete,
    SelectedItemKeyDownNavigationNext: $f4c8705b32f2a63d$var$SelectedItemKeyDownNavigationNext,
    SelectedItemKeyDownNavigationPrevious: $f4c8705b32f2a63d$var$SelectedItemKeyDownNavigationPrevious
});
/* eslint-disable complexity */ function $f4c8705b32f2a63d$var$downshiftMultipleSelectionReducer(state, action) {
    var type = action.type, index = action.index, props = action.props, selectedItem = action.selectedItem;
    var activeIndex = state.activeIndex, selectedItems = state.selectedItems;
    var changes;
    switch(type){
        case $f4c8705b32f2a63d$var$SelectedItemClick:
            changes = {
                activeIndex: index
            };
            break;
        case $f4c8705b32f2a63d$var$SelectedItemKeyDownNavigationPrevious:
            changes = {
                activeIndex: activeIndex - 1 < 0 ? 0 : activeIndex - 1
            };
            break;
        case $f4c8705b32f2a63d$var$SelectedItemKeyDownNavigationNext:
            changes = {
                activeIndex: activeIndex + 1 >= selectedItems.length ? -1 : activeIndex + 1
            };
            break;
        case $f4c8705b32f2a63d$var$SelectedItemKeyDownBackspace:
        case $f4c8705b32f2a63d$var$SelectedItemKeyDownDelete:
            if (activeIndex < 0) break;
            var newActiveIndex = activeIndex;
            if (selectedItems.length === 1) newActiveIndex = -1;
            else if (activeIndex === selectedItems.length - 1) newActiveIndex = selectedItems.length - 2;
            changes = (0, $e3e49ed681292e30$export$2e2bcd8739ae039)({
                selectedItems: [].concat(selectedItems.slice(0, activeIndex), selectedItems.slice(activeIndex + 1))
            }, {
                activeIndex: newActiveIndex
            });
            break;
        case $f4c8705b32f2a63d$var$DropdownKeyDownNavigationPrevious:
            changes = {
                activeIndex: selectedItems.length - 1
            };
            break;
        case $f4c8705b32f2a63d$var$DropdownKeyDownBackspace:
            changes = {
                selectedItems: selectedItems.slice(0, selectedItems.length - 1)
            };
            break;
        case $f4c8705b32f2a63d$var$FunctionAddSelectedItem:
            changes = {
                selectedItems: [].concat(selectedItems, [
                    selectedItem
                ])
            };
            break;
        case $f4c8705b32f2a63d$var$DropdownClick:
            changes = {
                activeIndex: -1
            };
            break;
        case $f4c8705b32f2a63d$var$FunctionRemoveSelectedItem:
            var _newActiveIndex = activeIndex;
            var selectedItemIndex = selectedItems.findIndex(function(item) {
                return props.itemToKey(item) === props.itemToKey(selectedItem);
            });
            if (selectedItemIndex < 0) break;
            if (selectedItems.length === 1) _newActiveIndex = -1;
            else if (selectedItemIndex === selectedItems.length - 1) _newActiveIndex = selectedItems.length - 2;
            changes = {
                selectedItems: [].concat(selectedItems.slice(0, selectedItemIndex), selectedItems.slice(selectedItemIndex + 1)),
                activeIndex: _newActiveIndex
            };
            break;
        case $f4c8705b32f2a63d$var$FunctionSetSelectedItems:
            var newSelectedItems = action.selectedItems;
            changes = {
                selectedItems: newSelectedItems
            };
            break;
        case $f4c8705b32f2a63d$var$FunctionSetActiveIndex:
            var _newActiveIndex2 = action.activeIndex;
            changes = {
                activeIndex: _newActiveIndex2
            };
            break;
        case $f4c8705b32f2a63d$var$FunctionReset:
            changes = {
                activeIndex: $f4c8705b32f2a63d$var$getDefaultValue(props, 'activeIndex'),
                selectedItems: $f4c8705b32f2a63d$var$getDefaultValue(props, 'selectedItems')
            };
            break;
        default:
            throw new Error('Reducer called without proper action type.');
    }
    return (0, $e3e49ed681292e30$export$2e2bcd8739ae039)({}, state, changes);
}
var $f4c8705b32f2a63d$var$_excluded = [
    "refKey",
    "ref",
    "onClick",
    "onKeyDown",
    "selectedItem",
    "index"
], $f4c8705b32f2a63d$var$_excluded2 = [
    "refKey",
    "ref",
    "onKeyDown",
    "onClick",
    "preventKeyAction"
];
$f4c8705b32f2a63d$export$134e7e7faed1473a.stateChangeTypes = $f4c8705b32f2a63d$var$stateChangeTypes;
function $f4c8705b32f2a63d$export$134e7e7faed1473a(userProps) {
    if (userProps === void 0) userProps = {};
    $f4c8705b32f2a63d$var$validatePropTypes(userProps, $f4c8705b32f2a63d$export$134e7e7faed1473a);
    // Props defaults and destructuring.
    var props = (0, $e3e49ed681292e30$export$2e2bcd8739ae039)({}, $f4c8705b32f2a63d$var$defaultProps, userProps);
    var getA11yStatusMessage = props.getA11yStatusMessage, environment = props.environment, keyNavigationNext = props.keyNavigationNext, keyNavigationPrevious = props.keyNavigationPrevious;
    // Reducer init.
    var _useControlledReducer = $f4c8705b32f2a63d$var$useControlledReducer$1($f4c8705b32f2a63d$var$downshiftMultipleSelectionReducer, props, $f4c8705b32f2a63d$var$getInitialState, $f4c8705b32f2a63d$var$isStateEqual), state = _useControlledReducer[0], dispatch = _useControlledReducer[1];
    var activeIndex = state.activeIndex, selectedItems = state.selectedItems;
    // Refs.
    var isInitialMount = $f4c8705b32f2a63d$var$useIsInitialMount();
    var dropdownRef = (0, $8NFma.useRef)(null);
    var selectedItemRefs = (0, $8NFma.useRef)();
    selectedItemRefs.current = [];
    var latest = $f4c8705b32f2a63d$var$useLatestRef({
        state: state,
        props: props
    });
    // Effects.
    // Adds an a11y aria live status message if getA11yStatusMessage is passed.
    $f4c8705b32f2a63d$var$useA11yMessageStatus(getA11yStatusMessage, state, [
        activeIndex,
        selectedItems
    ], environment);
    // Sets focus on active item.
    (0, $8NFma.useEffect)(function() {
        if (isInitialMount) return;
        if (activeIndex === -1 && dropdownRef.current) dropdownRef.current.focus();
        else if (selectedItemRefs.current[activeIndex]) selectedItemRefs.current[activeIndex].focus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        activeIndex
    ]);
    $f4c8705b32f2a63d$var$useControlPropsValidator({
        props: props,
        state: state
    });
    var setGetterPropCallInfo = $f4c8705b32f2a63d$var$useGetterPropsCalledChecker('getDropdownProps');
    // Event handler functions.
    var selectedItemKeyDownHandlers = (0, $8NFma.useMemo)(function() {
        var _ref;
        return _ref = {}, _ref[keyNavigationPrevious] = function() {
            dispatch({
                type: $f4c8705b32f2a63d$var$SelectedItemKeyDownNavigationPrevious
            });
        }, _ref[keyNavigationNext] = function() {
            dispatch({
                type: $f4c8705b32f2a63d$var$SelectedItemKeyDownNavigationNext
            });
        }, _ref.Delete = function Delete() {
            dispatch({
                type: $f4c8705b32f2a63d$var$SelectedItemKeyDownDelete
            });
        }, _ref.Backspace = function Backspace() {
            dispatch({
                type: $f4c8705b32f2a63d$var$SelectedItemKeyDownBackspace
            });
        }, _ref;
    }, [
        dispatch,
        keyNavigationNext,
        keyNavigationPrevious
    ]);
    var dropdownKeyDownHandlers = (0, $8NFma.useMemo)(function() {
        var _ref2;
        return _ref2 = {}, _ref2[keyNavigationPrevious] = function(event) {
            if ($f4c8705b32f2a63d$var$isKeyDownOperationPermitted(event)) dispatch({
                type: $f4c8705b32f2a63d$var$DropdownKeyDownNavigationPrevious
            });
        }, _ref2.Backspace = function Backspace(event) {
            if ($f4c8705b32f2a63d$var$isKeyDownOperationPermitted(event)) dispatch({
                type: $f4c8705b32f2a63d$var$DropdownKeyDownBackspace
            });
        }, _ref2;
    }, [
        dispatch,
        keyNavigationPrevious
    ]);
    // Getter props.
    var getSelectedItemProps = (0, $8NFma.useCallback)(function(_temp) {
        var _extends2;
        var _ref3 = _temp === void 0 ? {} : _temp, _ref3$refKey = _ref3.refKey, refKey = _ref3$refKey === void 0 ? 'ref' : _ref3$refKey, ref = _ref3.ref, onClick = _ref3.onClick, onKeyDown = _ref3.onKeyDown, selectedItemProp = _ref3.selectedItem, indexProp = _ref3.index, rest = (0, $cfde373be945f92b$export$2e2bcd8739ae039)(_ref3, $f4c8705b32f2a63d$var$_excluded);
        var latestState = latest.current.state;
        var _getItemAndIndex = $f4c8705b32f2a63d$var$getItemAndIndex(selectedItemProp, indexProp, latestState.selectedItems, 'Pass either item or index to getSelectedItemProps!'), index = _getItemAndIndex[1];
        var isFocusable = index > -1 && index === latestState.activeIndex;
        var selectedItemHandleClick = function selectedItemHandleClick() {
            dispatch({
                type: $f4c8705b32f2a63d$var$SelectedItemClick,
                index: index
            });
        };
        var selectedItemHandleKeyDown = function selectedItemHandleKeyDown(event) {
            var key = $f4c8705b32f2a63d$var$normalizeArrowKey(event);
            if (key && selectedItemKeyDownHandlers[key]) selectedItemKeyDownHandlers[key](event);
        };
        return (0, $e3e49ed681292e30$export$2e2bcd8739ae039)((_extends2 = {}, _extends2[refKey] = $f4c8705b32f2a63d$var$handleRefs(ref, function(selectedItemNode) {
            if (selectedItemNode) selectedItemRefs.current.push(selectedItemNode);
        }), _extends2.tabIndex = isFocusable ? 0 : -1, _extends2.onClick = $f4c8705b32f2a63d$var$callAllEventHandlers(onClick, selectedItemHandleClick), _extends2.onKeyDown = $f4c8705b32f2a63d$var$callAllEventHandlers(onKeyDown, selectedItemHandleKeyDown), _extends2), rest);
    }, [
        dispatch,
        latest,
        selectedItemKeyDownHandlers
    ]);
    var getDropdownProps = (0, $8NFma.useCallback)(function(_temp2, _temp3) {
        var _extends3;
        var _ref4 = _temp2 === void 0 ? {} : _temp2, _ref4$refKey = _ref4.refKey, refKey = _ref4$refKey === void 0 ? 'ref' : _ref4$refKey, ref = _ref4.ref, onKeyDown = _ref4.onKeyDown, onClick = _ref4.onClick, _ref4$preventKeyActio = _ref4.preventKeyAction, preventKeyAction = _ref4$preventKeyActio === void 0 ? false : _ref4$preventKeyActio, rest = (0, $cfde373be945f92b$export$2e2bcd8739ae039)(_ref4, $f4c8705b32f2a63d$var$_excluded2);
        var _ref5 = _temp3 === void 0 ? {} : _temp3, _ref5$suppressRefErro = _ref5.suppressRefError, suppressRefError = _ref5$suppressRefErro === void 0 ? false : _ref5$suppressRefErro;
        setGetterPropCallInfo('getDropdownProps', suppressRefError, refKey, dropdownRef);
        var dropdownHandleKeyDown = function dropdownHandleKeyDown(event) {
            var key = $f4c8705b32f2a63d$var$normalizeArrowKey(event);
            if (key && dropdownKeyDownHandlers[key]) dropdownKeyDownHandlers[key](event);
        };
        var dropdownHandleClick = function dropdownHandleClick() {
            dispatch({
                type: $f4c8705b32f2a63d$var$DropdownClick
            });
        };
        return (0, $e3e49ed681292e30$export$2e2bcd8739ae039)((_extends3 = {}, _extends3[refKey] = $f4c8705b32f2a63d$var$handleRefs(ref, function(dropdownNode) {
            if (dropdownNode) dropdownRef.current = dropdownNode;
        }), _extends3), !preventKeyAction && {
            onKeyDown: $f4c8705b32f2a63d$var$callAllEventHandlers(onKeyDown, dropdownHandleKeyDown),
            onClick: $f4c8705b32f2a63d$var$callAllEventHandlers(onClick, dropdownHandleClick)
        }, rest);
    }, [
        dispatch,
        dropdownKeyDownHandlers,
        setGetterPropCallInfo
    ]);
    // returns
    var addSelectedItem = (0, $8NFma.useCallback)(function(selectedItem) {
        dispatch({
            type: $f4c8705b32f2a63d$var$FunctionAddSelectedItem,
            selectedItem: selectedItem
        });
    }, [
        dispatch
    ]);
    var removeSelectedItem = (0, $8NFma.useCallback)(function(selectedItem) {
        dispatch({
            type: $f4c8705b32f2a63d$var$FunctionRemoveSelectedItem,
            selectedItem: selectedItem
        });
    }, [
        dispatch
    ]);
    var setSelectedItems = (0, $8NFma.useCallback)(function(newSelectedItems) {
        dispatch({
            type: $f4c8705b32f2a63d$var$FunctionSetSelectedItems,
            selectedItems: newSelectedItems
        });
    }, [
        dispatch
    ]);
    var setActiveIndex = (0, $8NFma.useCallback)(function(newActiveIndex) {
        dispatch({
            type: $f4c8705b32f2a63d$var$FunctionSetActiveIndex,
            activeIndex: newActiveIndex
        });
    }, [
        dispatch
    ]);
    var reset = (0, $8NFma.useCallback)(function() {
        dispatch({
            type: $f4c8705b32f2a63d$var$FunctionReset
        });
    }, [
        dispatch
    ]);
    return {
        getSelectedItemProps: getSelectedItemProps,
        getDropdownProps: getDropdownProps,
        addSelectedItem: addSelectedItem,
        removeSelectedItem: removeSelectedItem,
        setSelectedItems: setSelectedItems,
        setActiveIndex: setActiveIndex,
        reset: reset,
        selectedItems: selectedItems,
        activeIndex: activeIndex
    };
}




const $9620e399f052a619$var$descSort = (prop)=>(a, b)=>a[prop] < b[prop] ? -1 : 1;
var $9620e399f052a619$export$2e2bcd8739ae039 = $9620e399f052a619$var$descSort;


const $79e3f0c90d489474$var$FreetextDropdown = ({ question: question, value: value, onChange: onChange, isValid: isValid, isTouched: isTouched, invalidError: invalidError })=>{
    const inputValue = value || '';
    const findItemByValue = (value)=>question.options.find((option)=>option.text === value);
    const handleSelection = (selectedItem)=>{
        const newValue = selectedItem ? selectedItem.text : '';
        onChange({
            target: {
                value: newValue
            }
        });
    };
    const currentItem = findItemByValue(inputValue) || {
        text: ''
    };
    // Filter options based on input value
    const filteredOptions = question.options.filter((option)=>option.text.toLowerCase().includes(value.toLowerCase()));
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("label", {
                htmlFor: question.id,
                children: [
                    question.questionText,
                    question.helpText && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $b6cf6ab8ff89da81$export$2e2bcd8739ae039), {
                        questionGroupHelpText: question.helpText
                    })
                ]
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                className: "dynamicFormAutocompleteWrapper",
                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $f4c8705b32f2a63d$export$2e2bcd8739ae039), {
                    inputValue: inputValue,
                    onChange: handleSelection,
                    selectedItem: currentItem,
                    itemToString: (item)=>item ? item.text : '',
                    children: ({ getInputProps: getInputProps, getItemProps: getItemProps, getMenuProps: getMenuProps, highlightedIndex: highlightedIndex, isOpen: isOpen })=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("input", {
                                    ...getInputProps({
                                        onChange: (e)=>{
                                            onChange({
                                                target: {
                                                    value: e.target.value
                                                }
                                            });
                                        }
                                    })
                                }),
                                isOpen && filteredOptions.length > 0 && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                    ...getMenuProps(),
                                    className: "dynamicFormAutocompleteMenu",
                                    children: filteredOptions.sort((0, $9620e399f052a619$export$2e2bcd8739ae039)('text')).map((item, index)=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                            ...getItemProps({
                                                key: item.text,
                                                index: index,
                                                item: item,
                                                style: {
                                                    backgroundColor: highlightedIndex === index ? 'lightgray' : 'white',
                                                    fontWeight: item.text === currentItem.text ? 'bold' : 'normal'
                                                }
                                            }),
                                            className: `dynamicFormAutocompleteMenuItem ${highlightedIndex === index ? 'dynamicFormAutocompleteMenuItem--active' : ''}`,
                                            children: item.text
                                        }))
                                })
                            ]
                        })
                })
            }),
            !isValid && typeof isValid !== 'undefined' && isTouched && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $f51edab487ea15ea$export$2e2bcd8739ae039), {
                children: invalidError
            })
        ]
    });
};
var $79e3f0c90d489474$export$2e2bcd8739ae039 = $79e3f0c90d489474$var$FreetextDropdown;




function $a6b818f50380bcca$export$2e2bcd8739ae039(func, wait = 30) {
    let timeout;
    return (...args)=>{
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(()=>func.apply(context, args), wait);
    };
}


const $68dd6a022515bd47$var$inputThrottleTime = 300;
class $68dd6a022515bd47$var$PensionGuidanceQuestionTypeHandler extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).PureComponent {
    constructor(props){
        super(props);
        this.validator = undefined;
        const inputValue = this.props.formInput ? this.props.formInput.value : this.props.question.value ? this.props.question.value : '';
        this.state = {
            value: inputValue
        };
    }
    // throttling needed when updating redux state for this many inputs, see related discussion at:
    // https://github.com/erikras/redux-form/issues/454
    handleInputChange = (e, throttle = true)=>{
        let questionValue;
        if (this.props.question.questionType === 'Checkbox') questionValue = e.target.checked ? this.props.question.options[0].text : '';
        else questionValue = e.target.value;
        if (throttle) this.props.pensionGuidanceThrottledFormInputeChange(this.props.question.id, questionValue, this.validator);
        else this.props.pensionGuidanceFormInputChange(this.props.question.id, questionValue, this.validator);
        this.setState({
            value: questionValue
        });
    };
    // validate and take throttle timeout into account
    validate = ()=>{
        setTimeout(()=>this.props.validatePensionGuidanceFormInput(this.props.question.id, this.validator), $68dd6a022515bd47$var$inputThrottleTime);
    };
    // TODO: verify that PureComponent gives better performance than manually checking props (pretty sure they're kinda equal)
    //shouldComponentUpdate(nextProps, nextState) {
    //    return this.state.value !== nextState.value ||
    //        this.props.formInput.touched !== nextProps.formInput.touched ||
    //        this.props.formInput.valid !== nextProps.formInput.valid;
    //}
    render() {
        const question = this.props.question;
        const currentStep = this.props.currentStep;
        let questionType = question.questionType;
        let submittedValue = '';
        const questionId = question.id;
        const questionText = question.questionText;
        const questionHelpText = question.helpText ? question.helpText : null;
        const isUneditable = question.isUneditable;
        const isTouched = typeof this.props.formInput !== 'undefined' && this.props.formInput ? this.props.formInput.touched : false;
        const isValid = typeof this.props.formInput !== 'undefined' && this.props.formInput ? this.props.formInput.valid : undefined;
        // render input
        switch(questionType){
            case 'Radio':
                return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $a3f2d27852734a11$export$2e2bcd8739ae039), {
                    question: question,
                    value: this.state.value,
                    isValid: isValid,
                    isTouched: isTouched,
                    invalidError: "V\xe4lj ett av alternativen",
                    onChange: (e)=>this.handleInputChange(e, true),
                    onBlur: this.validate,
                    onClick: (e)=>{
                        e.persist();
                        this.props.toggleSubQuestions(e);
                        setTimeout(()=>this.validate(), 200);
                    }
                });
            case 'Money':
            case 'ShortString':
                return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $26b938ae087d8201$export$2e2bcd8739ae039), {
                    question: question,
                    value: this.state.value,
                    isValid: isValid,
                    isTouched: isTouched,
                    invalidError: "F\xe4ltet m\xe5ste fyllas i",
                    onChange: this.handleInputChange,
                    onBlur: this.validate
                });
            case 'LongString':
                return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $0e27fd283c2470a0$export$2e2bcd8739ae039), {
                    question: question,
                    value: this.state.value,
                    isValid: isValid,
                    isTouched: isTouched,
                    invalidError: "F\xe4ltet m\xe5ste fyllas i",
                    onChange: this.handleInputChange,
                    onBlur: this.validate
                });
            case 'Number':
                this.validator = (0, $d5552fc3ceef5489$export$1fd13a8724cd7091);
                return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $317ea1b249e06865$export$2e2bcd8739ae039), {
                        question: question,
                        value: this.state.value,
                        isValid: isValid,
                        isTouched: isTouched,
                        invalidError: "Ange en siffra utan decimaler",
                        onChange: this.handleInputChange,
                        onBlur: this.validate
                    })
                });
            case 'PersonalIdentityNumber':
                this.validator = (0, $d5552fc3ceef5489$export$6b5405a3207f4c0f);
                return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $26b938ae087d8201$export$2e2bcd8739ae039), {
                    question: question,
                    value: this.state.value,
                    isValid: isValid,
                    isTouched: isTouched,
                    invalidError: "Ange ett giltigt personnummer",
                    onChange: this.handleInputChange,
                    onBlur: this.validate
                });
            case 'EmailAddress':
                this.validator = (0, $d5552fc3ceef5489$export$9ab921aaffe56820);
                return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $26b938ae087d8201$export$2e2bcd8739ae039), {
                    question: question,
                    value: this.state.value,
                    isValid: isValid,
                    isTouched: isTouched,
                    invalidError: "Ange en giltig e-postadress",
                    onChange: this.handleInputChange,
                    onBlur: this.validate
                });
            case 'Checkbox':
                return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $5207a6288062d4a3$export$2e2bcd8739ae039), {
                    question: question,
                    value: this.state.value,
                    isValid: isValid,
                    isTouched: isTouched,
                    invalidError: "Markera kryssrutan",
                    onChange: this.handleInputChange,
                    onBlur: this.validate
                });
            case 'FreetextDropdown':
                return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $79e3f0c90d489474$export$2e2bcd8739ae039), {
                    question: question,
                    value: this.state.value,
                    isValid: isValid,
                    isTouched: isTouched,
                    invalidError: "F\xe4ltet m\xe5ste fyllas i",
                    onBlur: this.validate,
                    onChange: (e)=>this.handleInputChange(e)
                });
            case 'Dropdown':
                return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $1aede351419caa54$export$2e2bcd8739ae039), {
                    question: question,
                    isValid: isValid,
                    isTouched: isTouched,
                    invalidError: "F\xe4ltet m\xe5ste fyllas i",
                    onChange: this.handleInputChange,
                    onBlur: this.validate
                });
            case 'MonthAndYear':
                this.validator = (0, $d5552fc3ceef5489$export$32149351cfacd020);
                return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $26b938ae087d8201$export$2e2bcd8739ae039), {
                    question: question,
                    placeholder: "\xc5\xc5\xc5\xc5-MM",
                    value: this.state.value,
                    isValid: isValid,
                    isTouched: isTouched,
                    invalidError: 'Ange ett datum p\xe5 formen "\xc5\xc5\xc5\xc5-MM", t.ex. "2011-10" f\xf6r Oktober \xe5r 2011',
                    onChange: this.handleInputChange,
                    onBlur: this.validate
                });
            case 'Date':
                this.validator = (0, $d5552fc3ceef5489$export$c03bb0116ee09d4b);
                return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $26b938ae087d8201$export$2e2bcd8739ae039), {
                    question: question,
                    placeholder: "\xc5\xc5\xc5\xc5-MM-DD",
                    value: this.state.value,
                    isValid: isValid,
                    isTouched: isTouched,
                    invalidError: 'Ange ett datum p\xe5 formen "\xc5\xc5\xc5\xc5-MM-DD", t.ex. "2011-10-01" f\xf6r 1:a Oktober \xe5r 2011',
                    onChange: this.handleInputChange,
                    onBlur: this.validate
                });
            default:
                return null;
        }
    }
}
const $68dd6a022515bd47$var$mapStateToProps = (state)=>{
    return {
        data: state.pensionGuidancePageData,
        currentStep: state.pageCurrentStep
    };
};
const $68dd6a022515bd47$var$mapDispatchToProps = (dispatch)=>{
    return {
        pensionGuidanceFormInputChange: (questionId, value, validator)=>dispatch((0, $5f7d48bf7fc39678$export$4723e7a828d2768d)(questionId, value, validator)),
        pensionGuidanceThrottledFormInputeChange: (0, $a6b818f50380bcca$export$2e2bcd8739ae039)((questionId, value, validator)=>dispatch((0, $5f7d48bf7fc39678$export$4723e7a828d2768d)(questionId, value, validator)), $68dd6a022515bd47$var$inputThrottleTime),
        validatePensionGuidanceFormInput: (questionId, validator)=>dispatch((0, $5f7d48bf7fc39678$export$fe99ccfc3914bd08)(questionId, validator))
    };
};
var $68dd6a022515bd47$export$2e2bcd8739ae039 = (0, $5a4066412ccab0c1$export$64605811ab45167f)($68dd6a022515bd47$var$mapStateToProps, $68dd6a022515bd47$var$mapDispatchToProps)($68dd6a022515bd47$var$PensionGuidanceQuestionTypeHandler);



var $4785d4341f4a3225$exports = {};

$parcel$export($4785d4341f4a3225$exports, "extract", () => $4785d4341f4a3225$export$f9380c9a627682d3);
$parcel$export($4785d4341f4a3225$exports, "parse", () => $4785d4341f4a3225$export$98e6a39c04603d36);
$parcel$export($4785d4341f4a3225$exports, "stringify", () => $4785d4341f4a3225$export$fac44ee5b035f737);
$parcel$export($4785d4341f4a3225$exports, "parseUrl", () => $4785d4341f4a3225$export$7a5253c0f62e0150);
$parcel$export($4785d4341f4a3225$exports, "stringifyUrl", () => $4785d4341f4a3225$export$a8c1621ea79325d3);
$parcel$export($4785d4341f4a3225$exports, "pick", () => $4785d4341f4a3225$export$357523c63a2253b9);
$parcel$export($4785d4341f4a3225$exports, "exclude", () => $4785d4341f4a3225$export$44c361b8ec72ef7f);
const $ec67ae2b7c3a784e$var$token = '%[a-f0-9]{2}';
const $ec67ae2b7c3a784e$var$singleMatcher = new RegExp('(' + $ec67ae2b7c3a784e$var$token + ')|([^%]+?)', 'gi');
const $ec67ae2b7c3a784e$var$multiMatcher = new RegExp('(' + $ec67ae2b7c3a784e$var$token + ')+', 'gi');
function $ec67ae2b7c3a784e$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(''))
        ];
    } catch  {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    const left = components.slice(0, split);
    const right = components.slice(split);
    return Array.prototype.concat.call([], $ec67ae2b7c3a784e$var$decodeComponents(left), $ec67ae2b7c3a784e$var$decodeComponents(right));
}
function $ec67ae2b7c3a784e$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch  {
        let tokens = input.match($ec67ae2b7c3a784e$var$singleMatcher) || [];
        for(let i = 1; i < tokens.length; i++){
            input = $ec67ae2b7c3a784e$var$decodeComponents(tokens, i).join('');
            tokens = input.match($ec67ae2b7c3a784e$var$singleMatcher) || [];
        }
        return input;
    }
}
function $ec67ae2b7c3a784e$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    const replaceMap = {
        '%FE%FF': '\uFFFD\uFFFD',
        '%FF%FE': '\uFFFD\uFFFD'
    };
    let match = $ec67ae2b7c3a784e$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch  {
            const result = $ec67ae2b7c3a784e$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $ec67ae2b7c3a784e$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap['%C2'] = '\uFFFD';
    const entries = Object.keys(replaceMap);
    for (const key of entries)// Replace all decoded components
    input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
    return input;
}
function $ec67ae2b7c3a784e$export$2e2bcd8739ae039(encodedURI) {
    if (typeof encodedURI !== 'string') throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
    try {
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch  {
        // Fallback to a more advanced decoder
        return $ec67ae2b7c3a784e$var$customDecodeURIComponent(encodedURI);
    }
}


function $8233cf7ea7b12548$export$2e2bcd8739ae039(string, separator) {
    if (!(typeof string === 'string' && typeof separator === 'string')) throw new TypeError('Expected the arguments to be of type `string`');
    if (string === '' || separator === '') return [];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
}


function $6d713629ee1845c1$export$ff05df6c2df24b52(object, predicate) {
    const result = {};
    if (Array.isArray(predicate)) for (const key of predicate){
        const descriptor = Object.getOwnPropertyDescriptor(object, key);
        if (descriptor?.enumerable) Object.defineProperty(result, key, descriptor);
    }
    else // `Reflect.ownKeys()` is required to retrieve symbol properties
    for (const key of Reflect.ownKeys(object)){
        const descriptor = Object.getOwnPropertyDescriptor(object, key);
        if (descriptor.enumerable) {
            const value = object[key];
            if (predicate(key, value, object)) Object.defineProperty(result, key, descriptor);
        }
    }
    return result;
}
function $6d713629ee1845c1$export$e87405134ad524be(object, predicate) {
    if (Array.isArray(predicate)) {
        const set = new Set(predicate);
        return $6d713629ee1845c1$export$ff05df6c2df24b52(object, (key)=>!set.has(key));
    }
    return $6d713629ee1845c1$export$ff05df6c2df24b52(object, (key, value, object)=>!predicate(key, value, object));
}


const $4785d4341f4a3225$var$isNullOrUndefined = (value)=>value === null || value === undefined;
// eslint-disable-next-line unicorn/prefer-code-point
const $4785d4341f4a3225$var$strictUriEncode = (string)=>encodeURIComponent(string).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);
const $4785d4341f4a3225$var$encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');
function $4785d4341f4a3225$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case 'index':
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $4785d4341f4a3225$var$encode(key, options),
                            '[',
                            index,
                            ']'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $4785d4341f4a3225$var$encode(key, options),
                            '[',
                            $4785d4341f4a3225$var$encode(index, options),
                            ']=',
                            $4785d4341f4a3225$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'bracket':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $4785d4341f4a3225$var$encode(key, options),
                            '[]'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $4785d4341f4a3225$var$encode(key, options),
                            '[]=',
                            $4785d4341f4a3225$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'colon-list-separator':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $4785d4341f4a3225$var$encode(key, options),
                            ':list='
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $4785d4341f4a3225$var$encode(key, options),
                            ':list=',
                            $4785d4341f4a3225$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'comma':
        case 'separator':
        case 'bracket-separator':
            {
                const keyValueSep = options.arrayFormat === 'bracket-separator' ? '[]=' : '=';
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? '' : value;
                        if (result.length === 0) return [
                            [
                                $4785d4341f4a3225$var$encode(key, options),
                                keyValueSep,
                                $4785d4341f4a3225$var$encode(value, options)
                            ].join('')
                        ];
                        return [
                            [
                                result,
                                $4785d4341f4a3225$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        $4785d4341f4a3225$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $4785d4341f4a3225$var$encode(key, options),
                            '=',
                            $4785d4341f4a3225$var$encode(value, options)
                        ].join('')
                    ];
                };
    }
}
function $4785d4341f4a3225$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case 'index':
            return (key, value, accumulator)=>{
                result = /\[(\d*)]$/.exec(key);
                key = key.replace(/\[\d*]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return (key, value, accumulator)=>{
                result = /(\[])$/.exec(key);
                key = key.replace(/\[]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [
                    ...accumulator[key],
                    value
                ];
            };
        case 'colon-list-separator':
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [
                    ...accumulator[key],
                    value
                ];
            };
        case 'comma':
        case 'separator':
            return (key, value, accumulator)=>{
                const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === 'string' && !isArray && $4785d4341f4a3225$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $4785d4341f4a3225$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$4785d4341f4a3225$var$decode(item, options)) : value === null ? value : $4785d4341f4a3225$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case 'bracket-separator':
            return (key, value, accumulator)=>{
                const isArray = /(\[])$/.test(key);
                key = key.replace(/\[]$/, '');
                if (!isArray) {
                    accumulator[key] = value ? $4785d4341f4a3225$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$4785d4341f4a3225$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [
                    ...accumulator[key],
                    ...arrayValue
                ];
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [
                    ...[
                        accumulator[key]
                    ].flat(),
                    value
                ];
            };
    }
}
function $4785d4341f4a3225$var$validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) throw new TypeError('arrayFormatSeparator must be single character string');
}
function $4785d4341f4a3225$var$encode(value, options) {
    if (options.encode) return options.strict ? $4785d4341f4a3225$var$strictUriEncode(value) : encodeURIComponent(value);
    return value;
}
function $4785d4341f4a3225$var$decode(value, options) {
    if (options.decode) return (0, $ec67ae2b7c3a784e$export$2e2bcd8739ae039)(value);
    return value;
}
function $4785d4341f4a3225$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === 'object') return $4785d4341f4a3225$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $4785d4341f4a3225$var$removeHash(input) {
    const hashStart = input.indexOf('#');
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $4785d4341f4a3225$var$getHash(url) {
    let hash = '';
    const hashStart = url.indexOf('#');
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $4785d4341f4a3225$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) value = value.toLowerCase() === 'true';
    return value;
}
function $4785d4341f4a3225$export$f9380c9a627682d3(input) {
    input = $4785d4341f4a3225$var$removeHash(input);
    const queryStart = input.indexOf('?');
    if (queryStart === -1) return '';
    return input.slice(queryStart + 1);
}
function $4785d4341f4a3225$export$98e6a39c04603d36(query, options) {
    options = {
        decode: true,
        sort: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ',',
        parseNumbers: false,
        parseBooleans: false,
        ...options
    };
    $4785d4341f4a3225$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $4785d4341f4a3225$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const returnValue = Object.create(null);
    if (typeof query !== 'string') return returnValue;
    query = query.trim().replace(/^[?#&]/, '');
    if (!query) return returnValue;
    for (const parameter of query.split('&')){
        if (parameter === '') continue;
        const parameter_ = options.decode ? parameter.replace(/\+/g, ' ') : parameter;
        let [key, value] = (0, $8233cf7ea7b12548$export$2e2bcd8739ae039)(parameter_, '=');
        if (key === undefined) key = parameter_;
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            'comma',
            'separator',
            'bracket-separator'
        ].includes(options.arrayFormat) ? value : $4785d4341f4a3225$var$decode(value, options);
        formatter($4785d4341f4a3225$var$decode(key, options), value, returnValue);
    }
    for (const [key, value] of Object.entries(returnValue)){
        if (typeof value === 'object' && value !== null) for (const [key2, value2] of Object.entries(value))value[key2] = $4785d4341f4a3225$var$parseValue(value2, options);
        else returnValue[key] = $4785d4341f4a3225$var$parseValue(value, options);
    }
    if (options.sort === false) return returnValue;
    // TODO: Remove the use of `reduce`.
    // eslint-disable-next-line unicorn/no-array-reduce
    return (options.sort === true ? Object.keys(returnValue).sort() : Object.keys(returnValue).sort(options.sort)).reduce((result, key)=>{
        const value = returnValue[key];
        if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $4785d4341f4a3225$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
function $4785d4341f4a3225$export$fac44ee5b035f737(object, options) {
    if (!object) return '';
    options = {
        encode: true,
        strict: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ',',
        ...options
    };
    $4785d4341f4a3225$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $4785d4341f4a3225$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    const formatter = $4785d4341f4a3225$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const [key, value] of Object.entries(object))if (!shouldFilter(key)) objectCopy[key] = value;
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return '';
        if (value === null) return $4785d4341f4a3225$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === 'bracket-separator') return $4785d4341f4a3225$var$encode(key, options) + '[]';
            return value.reduce(formatter(key), []).join('&');
        }
        return $4785d4341f4a3225$var$encode(key, options) + '=' + $4785d4341f4a3225$var$encode(value, options);
    }).filter((x)=>x.length > 0).join('&');
}
function $4785d4341f4a3225$export$7a5253c0f62e0150(url, options) {
    options = {
        decode: true,
        ...options
    };
    let [url_, hash] = (0, $8233cf7ea7b12548$export$2e2bcd8739ae039)(url, '#');
    if (url_ === undefined) url_ = url;
    return {
        url: url_?.split('?')?.[0] ?? '',
        query: $4785d4341f4a3225$export$98e6a39c04603d36($4785d4341f4a3225$export$f9380c9a627682d3(url), options),
        ...options && options.parseFragmentIdentifier && hash ? {
            fragmentIdentifier: $4785d4341f4a3225$var$decode(hash, options)
        } : {}
    };
}
function $4785d4341f4a3225$export$a8c1621ea79325d3(object, options) {
    options = {
        encode: true,
        strict: true,
        [$4785d4341f4a3225$var$encodeFragmentIdentifier]: true,
        ...options
    };
    const url = $4785d4341f4a3225$var$removeHash(object.url).split('?')[0] || '';
    const queryFromUrl = $4785d4341f4a3225$export$f9380c9a627682d3(object.url);
    const query = {
        ...$4785d4341f4a3225$export$98e6a39c04603d36(queryFromUrl, {
            sort: false
        }),
        ...object.query
    };
    let queryString = $4785d4341f4a3225$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $4785d4341f4a3225$var$getHash(object.url);
    if (object.fragmentIdentifier) {
        const urlObjectForFragmentEncode = new URL(url);
        urlObjectForFragmentEncode.hash = object.fragmentIdentifier;
        hash = options[$4785d4341f4a3225$var$encodeFragmentIdentifier] ? urlObjectForFragmentEncode.hash : `#${object.fragmentIdentifier}`;
    }
    return `${url}${queryString}${hash}`;
}
function $4785d4341f4a3225$export$357523c63a2253b9(input, filter, options) {
    options = {
        parseFragmentIdentifier: true,
        [$4785d4341f4a3225$var$encodeFragmentIdentifier]: false,
        ...options
    };
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $4785d4341f4a3225$export$7a5253c0f62e0150(input, options);
    return $4785d4341f4a3225$export$a8c1621ea79325d3({
        url: url,
        query: (0, $6d713629ee1845c1$export$ff05df6c2df24b52)(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
}
function $4785d4341f4a3225$export$44c361b8ec72ef7f(input, filter, options) {
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $4785d4341f4a3225$export$357523c63a2253b9(input, exclusionFilter, options);
}


var $659e798a75438a59$export$2e2bcd8739ae039 = $4785d4341f4a3225$exports;








function $bde6e20398c9b639$export$edb2fd95ac60ce1c(step) {
    return (dispatch, getState)=>{
        const { healthDeclarationPageData: healthDeclarationPageData1 } = getState();
        const allowDraft = healthDeclarationPageData1.allowDraft;
        const enableAutoSave = healthDeclarationPageData1.enableAutoDraft;
        const setupAutoSave = allowDraft && enableAutoSave;
        if (step === 0 && setupAutoSave) dispatch($bde6e20398c9b639$var$insuranceHealthDeclarationSetupDraftAutoSaveAction());
        else if (typeof healthDeclarationPageData1.autoSave !== 'undefined' && healthDeclarationPageData1.autoSave.intervalId) clearInterval(healthDeclarationPageData1.autoSave.intervalId);
        if (step === 1) dispatch($bde6e20398c9b639$export$50ae14802d2eabe7(true, true, allowDraft));
        dispatch((0, $67f4b1d2fb7c2244$export$453e7c361a52c908)(step));
    };
}
function $bde6e20398c9b639$export$5c8e5fdd7721aac0() {
    let params = (0, $659e798a75438a59$export$2e2bcd8739ae039).parse(window.location.search);
    const insuranceName = params.insuranceName;
    const insuranceObjId = params.insuranceObjectId;
    return (dispatch)=>{
        const lfDataService = new (0, $25937fdb26d57abd$export$2e2bcd8739ae039)();
        const lfWebService = new (0, $0f2b98672976a17a$export$2e2bcd8739ae039)();
        if (typeof insuranceName === 'undefined') {
            dispatch((0, $67f4b1d2fb7c2244$export$5630fcc02dc02d1b)(false));
            dispatch((0, $67f4b1d2fb7c2244$export$7a8bb273722d5103)("inget f\xf6rs\xe4krings-id angivet"));
            dispatch((0, $67f4b1d2fb7c2244$export$ea4b4733f4ca2df0)(true));
            return;
        }
        dispatch((0, $67f4b1d2fb7c2244$export$5630fcc02dc02d1b)(true));
        Promise.all([
            lfDataService.healthDeclaration(insuranceName, insuranceObjId),
            lfDataService.customerInfo(),
            lfDataService.preregistrations(),
            lfDataService.quotes()
        ]).then((values)=>{
            let rawData = values.reduce((acc, obj)=>{
                Object.keys(obj).forEach((prop)=>acc[prop] = obj[prop]);
                return acc;
            }, {});
            let { questionGroups: questionGroups, preregistrations: preregistrations, ...data } = rawData;
            if (questionGroups && questionGroups.length) questionGroups.forEach((group, index)=>{
                questionGroups[index] = (0, $36509d2879dd53eb$export$54d7743101979cb1)(group);
            });
            // add base level form inputs from groups
            dispatch($bde6e20398c9b639$export$29033efa511d7ede(questionGroups));
            // data
            data.healthFormData = {
                questionGroups: questionGroups
            };
            data.quotes = (0, $36509d2879dd53eb$export$aa98a26e797b60e6)(data.quotes);
            data.healthDeclarationRegistration = typeof insuranceObjId !== 'undefined' && insuranceObjId ? preregistrations.find((registration)=>registration.insuranceName == insuranceName && registration.insuranceObjectId == insuranceObjId) : (0, $36509d2879dd53eb$export$aa98a26e797b60e6)(preregistrations)[insuranceName];
            data.myPagesStartUrl = lfWebService.myPagesStartUrl;
            data.insurancePurchaseUrl = lfWebService.insurancePurchaseUrl();
            // used when regging virutal page views to gtm/mtm/ga
            data.originalPageTitle = document.getElementsByTagName('title')[0].innerText;
            data.originalPagePath = window.location.pathname.slice(1);
            dispatch($bde6e20398c9b639$export$84af259443d2cd62(data));
            dispatch((0, $67f4b1d2fb7c2244$export$5630fcc02dc02d1b)(false));
            dispatch($bde6e20398c9b639$export$edb2fd95ac60ce1c(0));
            dispatch($bde6e20398c9b639$export$198654a2ca522131(data.healthFormData.questionGroups));
        }).catch((e)=>{
            dispatch((0, $67f4b1d2fb7c2244$export$7a8bb273722d5103)(e));
            dispatch((0, $67f4b1d2fb7c2244$export$ea4b4733f4ca2df0)(true));
            if (window._bazDebug) throw e;
        });
    };
}
function $bde6e20398c9b639$export$84af259443d2cd62(data) {
    return {
        type: 'INSURANCE_HEALTH_DECLARATION_DATA_LOADED',
        healthDeclarationPageData: data
    };
}
// draft autosave stuff
function $bde6e20398c9b639$var$insuranceHealthDeclarationSetupDraftAutoSaveAction() {
    const autoSaveInterval = 6000000; // 10min
    return (dispatch)=>{
        const intervalId = setInterval(()=>{
            const allowDraft = healthDeclarationPageData.allowDraft;
            dispatch($bde6e20398c9b639$export$31f1211e544ca94({
                timestamp: Date.now(),
                intervalId: intervalId
            }));
            dispatch($bde6e20398c9b639$export$50ae14802d2eabe7(true, true, allowDraft));
        }, autoSaveInterval);
        dispatch($bde6e20398c9b639$export$31f1211e544ca94({
            timestamp: null,
            intervalId: intervalId
        }));
    };
}
function $bde6e20398c9b639$export$31f1211e544ca94(data) {
    return {
        type: 'INSURANCE_HEALTH_DECLARATION_UPDATE_AUTOSAVE',
        autoSave: data
    };
}
function $bde6e20398c9b639$export$d8e056e7216fcf24() {
    const analyticsService = new (0, $0b70dc5e2f76d9ec$export$2e2bcd8739ae039)();
    const pathSteps = [
        'steg1',
        'steg2',
        'steg3'
    ];
    const stepTitles = [
        'Fyll i uppgifter',
        "Bekr\xe4fta",
        'Klar'
    ];
    return (dispatch, getState)=>{
        const { pageCurrentStep: pageCurrentStep, healthDeclarationPageData: healthDeclarationPageData1 } = getState();
        const hdInsuranceName = healthDeclarationPageData1.healthDeclarationRegistration.insuranceName;
        const hdInsuranceDisplayName = healthDeclarationPageData1.healthDeclarationRegistration.displayName;
        const pageTitle = healthDeclarationPageData1.originalPageTitle;
        const pagePath = healthDeclarationPageData1.originalPagePath;
        const path = `${pagePath}${hdInsuranceName}/${pathSteps[pageCurrentStep]}/`;
        const title = `${hdInsuranceDisplayName} - ${stepTitles[pageCurrentStep]} - ${pageTitle}`;
        return analyticsService.trackVirtualPageView(title, path);
    };
}
function $bde6e20398c9b639$export$50ae14802d2eabe7(isDraft = true, autoSave = false, allowDraft = true) {
    const lfDataService = new (0, $25937fdb26d57abd$export$2e2bcd8739ae039)();
    const lfWebService = new (0, $0f2b98672976a17a$export$2e2bcd8739ae039)();
    return (dispatch, getState)=>{
        const { pageCurrentStep: pageCurrentStep, healthDeclarationPageData: healthDeclarationPageData1, healthDeclarationFormInputs: healthDeclarationFormInputs } = getState();
        const insuranceName = healthDeclarationPageData1.healthDeclarationRegistration.insuranceName;
        const personId = healthDeclarationPageData1.customer.customerId;
        const insuranceObjectId = healthDeclarationPageData1.healthDeclarationRegistration.insuranceObjectId;
        const dontPostDraftData = isDraft && !allowDraft;
        const answers = Object.keys(healthDeclarationFormInputs).filter((k)=>healthDeclarationFormInputs[k].valid && healthDeclarationFormInputs[k].postable).map((k)=>({
                questionId: k,
                answer: healthDeclarationFormInputs[k].value,
                // parse repetition count from id:
                // normal question id: '14dc0a49e0f44453b2d24feb9b4106e0'
                // first repetition id: '14dc0a49e0f44453b2d24feb9b4106e0__1'
                // the first repetition of the question (the second occurence)
                // will have an index-suffixed id
                repetition: k.indexOf((0, $7c3038616dbee0e6$export$5af54ce744e65c54)) > -1 ? parseInt(k.slice(k.indexOf((0, $7c3038616dbee0e6$export$5af54ce744e65c54)) + (0, $7c3038616dbee0e6$export$5af54ce744e65c54).length, k.length)) : undefined
            }));
        const postData = {
            personId: personId,
            insuranceName: insuranceName,
            insuranceObjectId: insuranceObjectId,
            submitHealthDeclaration: !isDraft,
            answers: answers
        };
        if (!autoSave) dispatch((0, $67f4b1d2fb7c2244$export$5630fcc02dc02d1b)(true));
        if (dontPostDraftData) {
            if (!autoSave) lfWebService.insurancePreregistrations();
            return;
        }
        lfDataService.saveHealthDeclaration(postData).then((data)=>{
            if (!isDraft && !autoSave) {
                dispatch($bde6e20398c9b639$export$44f0d4ce1de89f86(data));
                dispatch($bde6e20398c9b639$export$edb2fd95ac60ce1c(pageCurrentStep + 1));
                dispatch((0, $67f4b1d2fb7c2244$export$5630fcc02dc02d1b)(false));
            } else if (!autoSave) lfWebService.insurancePreregistrations();
        }).catch((error)=>{
            if (!autoSave) {
                dispatch((0, $67f4b1d2fb7c2244$export$7a8bb273722d5103)(error));
                dispatch((0, $67f4b1d2fb7c2244$export$ea4b4733f4ca2df0)(true));
            }
        });
    };
}
function $bde6e20398c9b639$export$44f0d4ce1de89f86(data) {
    return {
        type: 'INSURANCE_HEALTH_FORM_SAVED_RESULT',
        healthDeclarationSavedResult: data
    };
}
function $bde6e20398c9b639$export$198654a2ca522131(questionGroup, nestLev = 0, maxLev = 2) {
    return (dispatch, getState)=>{
        const { healthDeclarationFormInputs: healthDeclarationFormInputs } = getState();
        const repeatGroups = (questionGroup, nestLevel, maxLevel, ignoreNestLevel = false)=>{
            if (!ignoreNestLevel && nestLevel === maxLevel) return;
            if (!questionGroup) return;
            questionGroup.forEach((group)=>{
                if (group.questions && group.questions.length) {
                    if (group.repeatable) {
                        if (!group.answers) return;
                        group.answers.forEach((answerGroup, index)=>{
                            if (index === 0) {
                                if (!answerGroup) return;
                                answerGroup.forEach((answer)=>{
                                    const question = {
                                        ...group.questions.find((q)=>q.id === answer.questionId)
                                    };
                                    question.value = answer.value;
                                    dispatch($bde6e20398c9b639$export$6340b43b72f6104d(question));
                                });
                            } else dispatch($bde6e20398c9b639$export$671bb340aac9ce17(group, answerGroup));
                        });
                    }
                    if (!group.questions) return;
                    group.questions.forEach((question)=>{
                        if (question.subQuestionGroup) repeatGroups([
                            question.subQuestionGroup
                        ], nestLevel + 1, maxLevel);
                    });
                }
                if (group.subQuestionGroups && group.subQuestionGroups.length) repeatGroups(group.subQuestionGroups, nestLevel + 1, maxLevel);
            });
        };
        repeatGroups(questionGroup, nestLev, maxLev);
    };
}
function $bde6e20398c9b639$export$29033efa511d7ede(questionGroup, nestLev = 0, maxLev = 2) {
    return (dispatch, getState)=>{
        const { healthDeclarationFormInputs: healthDeclarationFormInputs } = getState();
        const addInputs = (questionGroup, nestLevel, maxLevel, ignoreNestLevel = false)=>{
            if (!ignoreNestLevel && nestLevel === maxLevel) return;
            questionGroup.forEach((group)=>{
                if (group.questions && group.questions.length) group.questions.forEach((question)=>{
                    if (!(question.id in healthDeclarationFormInputs)) {
                        dispatch($bde6e20398c9b639$export$6340b43b72f6104d(question));
                        dispatch($bde6e20398c9b639$export$c57ea87c7bdc999b(question.id, !question.isUneditable));
                        if (question.subQuestionGroup) {
                            const toggleGroupOnValue = question.questionType === 'Radio' ? question.options.filter((option)=>option.togglesSubQuestionGroup).reduce((_, option)=>option.text, '') : null;
                            if (question.value === toggleGroupOnValue || question.questionType !== 'Radio') addInputs([
                                question.subQuestionGroup
                            ], nestLevel + 1, maxLevel);
                        }
                    }
                });
                if (group.subQuestionGroups && group.subQuestionGroups.length) addInputs(group.subQuestionGroups, nestLevel + 1, maxLevel);
            });
        };
        addInputs(questionGroup, nestLev, maxLev);
    };
}
function $bde6e20398c9b639$export$9db56972f3fa02fa(questionGroup, nestLev = 0, maxLev = 2) {
    return (dispatch)=>{
        const removeInputs = (questionGroup, nestLevel, maxLevel)=>{
            if (nestLevel === maxLevel) return;
            questionGroup.forEach((group)=>{
                group.questions.forEach((question)=>{
                    dispatch($bde6e20398c9b639$export$c5378d5ad69d9977(question.id));
                    if (question.subQuestionGroup) removeInputs([
                        question.subQuestionGroup
                    ], nestLevel + 1, maxLevel);
                });
                if (group.subQuestionGroups.length) removeInputs(group.subQuestionGroups, nestLevel + 1, maxLevel);
            });
        };
        removeInputs(questionGroup, nestLev, maxLev);
    };
}
function $bde6e20398c9b639$export$671bb340aac9ce17(questionGroup, answers = null) {
    const questionGroupId = questionGroup.id;
    return (dispatch, getState)=>{
        const { healthDeclarationRepeatedInputs: healthDeclarationRepeatedInputs } = getState();
        const currentRepeatCount = questionGroupId in healthDeclarationRepeatedInputs ? healthDeclarationRepeatedInputs[questionGroupId] + 1 : 1;
        questionGroup.questions.forEach((question)=>{
            let repeatedQuestion = {
                ...question,
                id: `${question.id}${(0, $7c3038616dbee0e6$export$5af54ce744e65c54)}${currentRepeatCount}`,
                value: undefined
            };
            if (answers) {
                const answer = answers.find((a)=>a.questionId === question.id);
                if (answer) repeatedQuestion.value = answer.value;
            }
            dispatch($bde6e20398c9b639$export$6340b43b72f6104d(repeatedQuestion));
        });
        dispatch($bde6e20398c9b639$export$896c886d9e7e0185(questionGroupId));
    };
}
function $bde6e20398c9b639$export$852745b4351040cd(questionGroup, repeatableCountIndex) {
    const questionGroupId = questionGroup.id;
    const questionIds = questionGroup.questions.map((q)=>q.id);
    return (dispatch, getState)=>{
        questionIds.forEach((questionId)=>{
            dispatch($bde6e20398c9b639$export$c5378d5ad69d9977(`${questionId}${(0, $7c3038616dbee0e6$export$5af54ce744e65c54)}${repeatableCountIndex}`));
        });
        dispatch($bde6e20398c9b639$export$49cdec09fcadc5f3(questionGroupId));
        dispatch($bde6e20398c9b639$export$e1486b03ba56df60(questionGroup));
    };
}
function $bde6e20398c9b639$export$e1486b03ba56df60(questionGroup) {
    return (dispatch, getState)=>{
        const { healthDeclarationFormInputs: healthDeclarationFormInputs, healthDeclarationRepeatedInputs: healthDeclarationRepeatedInputs } = getState();
        const questionGroupId = questionGroup.id;
        const repeatableCounter = healthDeclarationRepeatedInputs[questionGroupId];
        const questionIds = questionGroup.questions.map((q)=>q.id);
        const groupInputFormsKeys = {};
        const groupInputFormsValues = {};
        questionIds.forEach((questionId)=>{
            groupInputFormsKeys[questionId] = [];
            groupInputFormsValues[questionId] = [];
            Object.keys(healthDeclarationFormInputs).forEach(function(key, index) {
                const questionIdKeyPrefix = `${questionId}${(0, $7c3038616dbee0e6$export$5af54ce744e65c54)}`;
                if (key.startsWith(questionIdKeyPrefix)) {
                    groupInputFormsKeys[questionId].push(key);
                    groupInputFormsValues[questionId].push(healthDeclarationFormInputs[key]);
                }
            });
            groupInputFormsKeys[questionId].forEach((key)=>{
                dispatch($bde6e20398c9b639$export$c5378d5ad69d9977(key));
                delete healthDeclarationFormInputs[key];
            });
            groupInputFormsKeys[questionId].sort();
            groupInputFormsKeys[questionId].forEach((repeatedQuestionId, index)=>{
                const value = groupInputFormsValues[questionId].find((q)=>q.id === repeatedQuestionId);
                const repeatableIndex = index + 1;
                const newKey = `${questionId}${(0, $7c3038616dbee0e6$export$5af54ce744e65c54)}${repeatableIndex}`;
                value.id = newKey;
                dispatch($bde6e20398c9b639$export$6340b43b72f6104d(value));
            });
        });
    };
}
function $bde6e20398c9b639$export$49cdec09fcadc5f3(groupId) {
    return {
        type: 'INSURANCE_HEALTH_FORM_REMOVE_REPEAT_FORM_INPUT',
        groupId: groupId
    };
}
function $bde6e20398c9b639$export$896c886d9e7e0185(groupId) {
    return {
        type: 'INSURANCE_HEALTH_FORM_REPEAT_FORM_INPUT',
        groupId: groupId
    };
}
function $bde6e20398c9b639$export$6340b43b72f6104d(question) {
    return (dispatch)=>{
        const hasValue = typeof question.value !== 'undefined' && question.value;
        const isUneditable = question.isUneditable;
        const isRequired = question.required || question.questionType == 'Radio';
        const uniqueKeyId = question.uniqueKeyId || Math.round(Math.random() * 100000000);
        dispatch($bde6e20398c9b639$export$dbe15aaadc146587({
            id: question.id,
            questionText: question.questionText,
            value: hasValue ? question.value : '',
            required: isRequired,
            active: false,
            valid: hasValue || !isRequired || isUneditable ? true : false,
            touched: hasValue ? true : false,
            postable: !isUneditable,
            uniqueKeyId: uniqueKeyId
        }));
    };
}
function $bde6e20398c9b639$export$c5378d5ad69d9977(questionId) {
    return {
        type: 'INSURANCE_HEALTH_FORM_INPUT_REMOVED',
        questionId: questionId
    };
}
function $bde6e20398c9b639$export$c57ea87c7bdc999b(questionId, status) {
    return (dispatch, getState)=>{
        const { healthDeclarationFormInputs: healthDeclarationFormInputs } = getState();
        dispatch($bde6e20398c9b639$export$dbe15aaadc146587({
            ...healthDeclarationFormInputs[questionId],
            active: status
        }));
    };
}
function $bde6e20398c9b639$export$127340f0cbfa346(questionId, value, validator) {
    return (dispatch, getState)=>{
        const { healthDeclarationFormInputs: healthDeclarationFormInputs } = getState();
        const currentInput = healthDeclarationFormInputs[questionId];
        dispatch($bde6e20398c9b639$export$dbe15aaadc146587({
            ...currentInput,
            value: value,
            active: true
        }));
        dispatch($bde6e20398c9b639$export$7b56e35cbe759228(questionId, validator, currentInput.touched));
    };
}
function $bde6e20398c9b639$export$dbe15aaadc146587(inputData) {
    return {
        type: 'INSURANCE_HEALTH_FORM_INPUT_UPDATED',
        inputData: inputData
    };
}
function $bde6e20398c9b639$export$7b56e35cbe759228(questionId, validator, touched = true) {
    return (dispatch, getState)=>{
        const { healthDeclarationFormInputs: healthDeclarationFormInputs } = getState();
        const currentInput = healthDeclarationFormInputs[questionId];
        const questionValue = currentInput.value;
        let valid = true;
        if (typeof validator === 'function' && currentInput.value != null && currentInput.value != '') valid = typeof validator(questionValue) === 'undefined'; // see rules.jsx
        else if (currentInput.required) valid = questionValue != null && questionValue !== '';
        dispatch($bde6e20398c9b639$export$dbe15aaadc146587({
            ...currentInput,
            touched: touched,
            valid: valid
        }));
        dispatch($bde6e20398c9b639$export$bb7970e613939413()); // update global valid/invalid form status
    };
}
function $bde6e20398c9b639$export$fbcf6208d1beaa3c() {
    return (dispatch, getState)=>{
        const { healthDeclarationFormInputs: healthDeclarationFormInputs } = getState();
        Object.keys(healthDeclarationFormInputs).forEach((questionId)=>{
            const currentInput = healthDeclarationFormInputs[questionId];
            if (currentInput.active && !currentInput.touched) dispatch($bde6e20398c9b639$export$dbe15aaadc146587({
                ...currentInput,
                touched: true
            }));
        });
    };
}
function $bde6e20398c9b639$export$bb7970e613939413() {
    return (dispatch, getState)=>{
        const { healthDeclarationFormInputs: healthDeclarationFormInputs } = getState();
        let invalidInputs = Object.keys(healthDeclarationFormInputs).map((key)=>healthDeclarationFormInputs[key]).filter((input)=>input.active && !input.valid);
        dispatch($bde6e20398c9b639$export$ab4c217c1a1e02dd(invalidInputs.length == 0));
    };
}
function $bde6e20398c9b639$export$ab4c217c1a1e02dd(bool) {
    return {
        type: 'INSURANCE_HEALTH_FORM_STATUS',
        valid: bool
    };
}


class $819d1a9cb8baca47$var$PensionGuidanceForm extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    componentDidMount() {
        // in case we've loaded a saved hd draft with all input fields valid
        // the status has to updated in order to reflect this (=> enabling the continue button)
        this.props.updatePensionGuidanceStatus();
    }
    render() {
        const formData = this.props.data.pensionGuidanceFormData;
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $bb8231acd22e51c2$export$e25e478948902b8b).div, {
            initial: {
                opacity: 0
            },
            animate: {
                opacity: 1
            },
            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $87d87c79350c4a5e$export$2e2bcd8739ae039), {
                unexpandable: true,
                noHeaderPadding: true,
                headerComponent: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $7db30f9b8380a2de$export$bf39d720edf35aea), {
                    id: "pensionGuidanceForm",
                    onSubmit: (e)=>e.preventDefault(),
                    children: formData.questionGroups.map((group)=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $16a5e7598873f904$export$2e2bcd8739ae039), {
                            questionGroup: group,
                            questionTypeHandler: (0, $68dd6a022515bd47$export$2e2bcd8739ae039),
                            formInputs: this.props.formInputs,
                            repeatedInputs: this.props.repeatedInputs,
                            removeRepeatedQuestionGroup: this.props.removeRepeatedQuestionGroup,
                            repeatQuestionGroup: this.props.repeatQuestionGroup,
                            addQuestionGroupInputs: this.props.addQuestionGroupInputs,
                            removeQuestionGroupInputs: this.props.removeQuestionGroupInputs
                        }, group.id))
                })
            })
        });
    }
}
const $819d1a9cb8baca47$var$mapStateToProps = (state)=>{
    return {
        data: state.pensionGuidancePageData,
        formInputs: state.pensionGuidanceFormInputs,
        repeatedInputs: state.pensionGuidanceRepeatedInputs
    };
};
const $819d1a9cb8baca47$var$mapDispatchToProps = (dispatch)=>{
    return {
        updatePensionGuidanceStatus: ()=>dispatch((0, $5f7d48bf7fc39678$export$b5e4d51f623d4fff)()),
        registerVirtualPageView: ()=>dispatch((0, $bde6e20398c9b639$export$d8e056e7216fcf24)()),
        repeatQuestionGroup: (questionGroup)=>dispatch((0, $5f7d48bf7fc39678$export$671bb340aac9ce17)(questionGroup)),
        addQuestionGroupInputs: (...args)=>dispatch((0, $5f7d48bf7fc39678$export$29033efa511d7ede)(...args)),
        removeQuestionGroupInputs: (...args)=>dispatch((0, $5f7d48bf7fc39678$export$9db56972f3fa02fa)(...args)),
        removeRepeatedQuestionGroup: (questionGroup, index)=>dispatch((0, $5f7d48bf7fc39678$export$852745b4351040cd)(questionGroup, index))
    };
};
var $819d1a9cb8baca47$export$2e2bcd8739ae039 = (0, $5a4066412ccab0c1$export$64605811ab45167f)($819d1a9cb8baca47$var$mapStateToProps, $819d1a9cb8baca47$var$mapDispatchToProps)($819d1a9cb8baca47$var$PensionGuidanceForm);




var $8NFma = parcelRequire("8NFma");



var $8NFma = parcelRequire("8NFma");






class $830198e7d4a3a075$var$DynamicFormErrorBox extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    render() {
        const invalidInputs = Object.keys(this.props.formInputs).map((k)=>this.props.formInputs[k]).filter((i)=>i.active && i.touched && !i.valid);
        if (invalidInputs.length === 0) return null;
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($830198e7d4a3a075$var$DynamicFormErrorWrapper, {
            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $bb8231acd22e51c2$export$e25e478948902b8b).div, {
                initial: {
                    opacity: 0
                },
                animate: {
                    opacity: 1
                },
                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($830198e7d4a3a075$var$FormErrorBox, {
                    align: this.props.currentStep === 0 ? 'left' : 'right',
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("strong", {
                            children: "Ojoj, n\xe5got st\xe4mmer inte!"
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("strong", {
                            children: "Kontrollera dina uppgifter f\xf6r f\xf6ljande fr\xe5gor:"
                        }),
                        invalidInputs.map((input)=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($830198e7d4a3a075$var$FormErrorLink, {
                                to: `#question-${input.id}`,
                                duration: 300,
                                children: input.questionText
                            }, `scroll-${input.id}`))
                    ]
                })
            })
        });
    }
}
const $830198e7d4a3a075$var$mapDispatchToProps = (dispatch)=>({});
const $830198e7d4a3a075$var$mapStateToProps = (state)=>{
    return {
        currentStep: state.pageCurrentStep
    };
};
var $830198e7d4a3a075$export$2e2bcd8739ae039 = (0, $5a4066412ccab0c1$export$64605811ab45167f)($830198e7d4a3a075$var$mapStateToProps, $830198e7d4a3a075$var$mapDispatchToProps)($830198e7d4a3a075$var$DynamicFormErrorBox);
// styles
const $830198e7d4a3a075$var$DynamicFormErrorWrapper = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    float: right;
    margin-bottom: 80px;
    max-width: 60%;

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).medium(`
        float: left; 
        max-width: none; 

        position: relative; 
        margin-bottom: 10px; 
    `)}
`;
const $830198e7d4a3a075$var$FormErrorBox = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    padding: 20px;
    float: right;
    font-size: 16px;

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).large(`
        margin: 30px 0 0 0;
    `)}
    ${(0, $45d1242a07988139$export$8f880b6e390052fa).medium(`
        margin: 30px 0 80px 0;
        width: 100%; 
    `)}
    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        margin: 25px 0px 0px 0px;
        padding: 15px;
        float: none;
    `)}
    ${(0, $45d1242a07988139$export$8f880b6e390052fa).xxsmall(`
        font-size: 13px;
    `)}

    background-color: white;
    color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.error};
    border: 2px solid ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.error}; 

    text-align: ${(props)=>props.align ? props.align : 'left'}; 

    strong {
        display: block;
        font-weight: bold; 
    }
`;
const $830198e7d4a3a075$var$FormErrorLink = (0, $c657a2af5c9e1b33$export$e1500fe70a4f6f8f)((0, $65e706775ff71837$export$2e2bcd8739ae039).a`
    display: block;
    
    cursor: pointer; 

    color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.blueBackground}; 
    text-decoration: none;
    margin-top: 10px;

    &:hover {
        color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.blueBackground};
        text-decoration: underline;
    }
`);






class $fb253486e69bd4d7$var$PensionGuidanceInformationBox extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    submitPensionGuidanceForm = (e)=>{
        e.preventDefault();
        (0, $c657a2af5c9e1b33$export$f5d3771428a1f489)().then(()=>{
            this.props.savePensionGuidance();
        });
    };
    validatePensionGuidance = (0, $a6b818f50380bcca$export$2e2bcd8739ae039)(()=>{
        this.props.showAllPensionGuidanceFormErrors();
    }, 200);
    render() {
        const memberInfo = this.props.data.customer;
        const currentStep = this.props.currentStep;
        let continueButton = null;
        if (currentStep === 0) continueButton = /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
            className: "informationBoxBtnContainer",
            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                form: "pensionGuidanceForm",
                type: "submit",
                value: "Submit",
                className: "nextStepBtn",
                disabled: !this.props.hdStatus.valid,
                onClick: this.submitPensionGuidanceForm,
                onMouseEnter: this.validatePensionGuidance,
                onTouchStart: this.validatePensionGuidance,
                children: "Skicka in"
            })
        });
        else if (currentStep === 1) continueButton = /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
            className: "informationBoxBtnContainer",
            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("a", {
                href: this.props.data.myPagesStartUrl,
                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                    className: "sendConfirmedAnswersBtn",
                    children: "G\xe5 till Mina sidor"
                })
            })
        });
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $7db30f9b8380a2de$export$e5514f626972a05), {
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                    className: "memberInfoContainer",
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("h3", {
                            children: "Dina uppgifter"
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("p", {
                            className: "memberInfoName",
                            children: memberInfo.firstName + ' ' + memberInfo.lastName
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("p", {
                            children: memberInfo.streetAddress
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("p", {
                            className: "memberInfoZipCodeArea",
                            children: memberInfo.zipCodeArea
                        })
                    ]
                }),
                !this.props.hdStatus.valid && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $830198e7d4a3a075$export$2e2bcd8739ae039), {
                    formInputs: this.props.formInputs
                }),
                continueButton
            ]
        });
    }
}
const $fb253486e69bd4d7$var$mapStateToProps = (state)=>{
    return {
        data: state.pensionGuidancePageData,
        currentStep: state.pageCurrentStep,
        hdStatus: state.pensionGuidanceStatus,
        formInputs: state.pensionGuidanceFormInputs
    };
};
const $fb253486e69bd4d7$var$mapDispatchToProps = (dispatch)=>{
    return {
        setCurrentStep: (step)=>dispatch((0, $5f7d48bf7fc39678$export$764ce8bf84d80b6)(step)),
        showAllPensionGuidanceFormErrors: ()=>dispatch((0, $5f7d48bf7fc39678$export$6fb56587caafb4c4)()),
        savePensionGuidance: ()=>dispatch((0, $5f7d48bf7fc39678$export$289f035e1c193ca3)())
    };
};
var $fb253486e69bd4d7$export$2e2bcd8739ae039 = (0, $5a4066412ccab0c1$export$64605811ab45167f)($fb253486e69bd4d7$var$mapStateToProps, $fb253486e69bd4d7$var$mapDispatchToProps)($fb253486e69bd4d7$var$PensionGuidanceInformationBox);



const $b5c9fbd602d2b3b3$var$stepLabels = [
    "Svara p\xe5 fr\xe5gor",
    "Bekr\xe4ftelse"
];
class $b5c9fbd602d2b3b3$var$PensionGuidanceQuestionPage extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    static get propTypes() {
        return {
            mountRootId: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string.isRequired
        };
    }
    constructor(props){
        super(props);
        this.headerData = this.getHeaderData();
    }
    componentDidMount() {
        this.props.loadPensionGuidanceData();
    }
    getHeaderData() {
        return {
            headings: [
                (0, $e6aeb63e6149c504$export$161fa9a9af21e7de)('heading', this.props.mountRootId),
                (0, $e6aeb63e6149c504$export$161fa9a9af21e7de)('heading-step2', this.props.mountRootId)
            ],
            preambles: [
                (0, $e6aeb63e6149c504$export$161fa9a9af21e7de)('preamble', this.props.mountRootId),
                (0, $e6aeb63e6149c504$export$161fa9a9af21e7de)('preamble-step2', this.props.mountRootId)
            ]
        };
    }
    render() {
        const Header = (props)=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($b5c9fbd602d2b3b3$var$Heading, {
                        children: this.headerData.headings[this.props.step]
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($b5c9fbd602d2b3b3$var$Preamble, {
                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $96c25128201e5f07$export$2e2bcd8739ae039), {
                            children: this.headerData.preambles[this.props.step]
                        })
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $9ebfac828c61691f$export$2e2bcd8739ae039), {
                        stepLabels: $b5c9fbd602d2b3b3$var$stepLabels,
                        stepCount: $b5c9fbd602d2b3b3$var$stepLabels.length,
                        activeStep: this.props.step,
                        hideDescOnResp: true
                    })
                ]
            });
        if (this.props.hasErrored) {
            const errorMsg = typeof this.props.error === 'string' ? this.props.error : this.props.error.message;
            return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)(Header, {}),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $19ac445fff8f1f3a$export$2e2bcd8739ae039), {
                        message: `Ooops! Ett fel uppstod vid h\xe4mtningen: ${errorMsg}`
                    })
                ]
            });
        }
        if (this.props.isLoading) return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)(Header, {}),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $492d68823d70b95b$export$2e2bcd8739ae039), {
                    color: (0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.blueBackground
                })
            ]
        });
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)(Header, {}),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $bb8231acd22e51c2$export$e25e478948902b8b).div, {
                    initial: {
                        opacity: 0
                    },
                    animate: {
                        opacity: 1
                    },
                    transition: {
                        duration: 0.5
                    },
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $cd1ec0cc88bc8751$export$2e2bcd8739ae039), {
                                sectionId: this.props.step,
                                children: [
                                    "\xa0 ",
                                    this.props.step === 0 && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $819d1a9cb8baca47$export$2e2bcd8739ae039), {})
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $fb253486e69bd4d7$export$2e2bcd8739ae039), {})
                    ]
                })
            ]
        });
    }
}
const $b5c9fbd602d2b3b3$var$mapStateToProps = (state)=>{
    return {
        data: state.pensionGuidancePageData,
        hasErrored: state.pageHasErrored,
        error: state.pageError,
        isLoading: state.pageIsLoading,
        step: state.pageCurrentStep
    };
};
const $b5c9fbd602d2b3b3$var$mapDispatchToProps = (dispatch)=>{
    return {
        loadPensionGuidanceData: (insurance)=>dispatch((0, $5f7d48bf7fc39678$export$593192119cdc7493)(insurance)),
        setCurrentStep: (step)=>dispatch((0, $67f4b1d2fb7c2244$export$453e7c361a52c908)(step))
    };
};
var $b5c9fbd602d2b3b3$export$2e2bcd8739ae039 = (0, $5a4066412ccab0c1$export$64605811ab45167f)($b5c9fbd602d2b3b3$var$mapStateToProps, $b5c9fbd602d2b3b3$var$mapDispatchToProps)($b5c9fbd602d2b3b3$var$PensionGuidanceQuestionPage);
// styles
const $b5c9fbd602d2b3b3$var$Heading = (0, $65e706775ff71837$export$2e2bcd8739ae039).h1`
    padding-bottom: 30px;
    margin-top: 50px;
    margin-bottom: 35px;

    font-family: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.heading};
    font-size: 60px;
    color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.almostBlack};

    border-bottom: 1px solid ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.grayBorder};

     ${(0, $45d1242a07988139$export$8f880b6e390052fa).custom(`
        margin-left: 17px;
        margin-right: 17px;
    `, '1234px')}

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        border: none;
        font-size: 28px;
        padding-bottom: 0px;
        margin-bottom: 10px;
        margin-top: 31px;
    `)}
     ${(0, $45d1242a07988139$export$8f880b6e390052fa).xxsmall(`
        font-size: 20px;
    `)}
`;
const $b5c9fbd602d2b3b3$var$Preamble = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    max-width: 60%;
    margin-bottom: 40px;

    font-family: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.main};
    font-size: 20px;
    color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.almostBlack};

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).custom(`
        margin-left: 17px;
        margin-right: 17px;
    `, '1234px')}

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        margin-bottom: 15px;
        max-width: none;
        font-size: 16px;
        line-height: 1.5;
    `)}

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).xxsmall(`
        font-size: 13px;
    `)}
`;
const $b5c9fbd602d2b3b3$var$PensionGuidanceConfirmation = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    padding: 20px;
`;




var $8NFma = parcelRequire("8NFma");













var $8NFma = parcelRequire("8NFma");





var $8NFma = parcelRequire("8NFma");




class $a7ba641823ad9c62$var$HealthDeclarationHeading extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    render() {
        const registration = this.props.data.healthDeclarationRegistration;
        let name = '';
        if (registration.targetGroupName == 'djur') name = registration.animalGivenName;
        else if (!registration.appliesToCoinsured) name = `${this.props.data.customer.firstName} ${this.props.data.customer.lastName}`;
        else if (typeof this.props.data.coinsuredInfo !== 'undefined' && this.props.data.coinsuredInfo && this.props.data.coinsuredInfo.firstName && this.props.data.coinsuredInfo.lastName) name = `${this.props.data.coinsuredInfo.firstName} ${this.props.data.coinsuredInfo.lastName}`;
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($a7ba641823ad9c62$var$HealthDeclarationHeadingWrapper, {
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("h4", {
                    children: registration.displayName
                }),
                name
            ]
        });
    }
}
// state
const $a7ba641823ad9c62$var$mapStateToProps = (state)=>{
    return {
        data: state.healthDeclarationPageData
    };
};
const $a7ba641823ad9c62$var$mapDispatchToProps = ()=>({});
var $a7ba641823ad9c62$export$2e2bcd8739ae039 = (0, $5a4066412ccab0c1$export$64605811ab45167f)($a7ba641823ad9c62$var$mapStateToProps, $a7ba641823ad9c62$var$mapDispatchToProps)($a7ba641823ad9c62$var$HealthDeclarationHeading);
// styles
const $a7ba641823ad9c62$var$HealthDeclarationHeadingWrapper = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    margin-bottom: 10px;
    font-size: 18px;
    font-weight: 400;
    font-family: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.main};

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).medium(`
        padding-top: 10px;
    `)}

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        padding-top: 0;
        font-size: 16px;
        h4 {
            font-size: 20px;
            margin: 5px 0px 10px 0px;
        }
    `)}

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).xxsmall(`
        padding-top: 0;
        font-size: 13px;
        h4 {
            font-size: 16px;
        }
    `)}
`;




var $8NFma = parcelRequire("8NFma");


var $YChVI = parcelRequire("YChVI");





var $8NFma = parcelRequire("8NFma");
var $24686044b033fe8a$exports = {};
/*!
  react-datepicker v7.0.0
  https://github.com/Hacker0x01/react-datepicker
  Released under the MIT License.
*/ 































































!function(e, t) {
    t($24686044b033fe8a$exports, (parcelRequire("ase04")), (parcelRequire("8NFma")), (parcelRequire("iy6bE")), (parcelRequire("l4b73")), (parcelRequire("afGQf")), (parcelRequire("iIzcA")), (parcelRequire("1YUHS")), (parcelRequire("ieLCh")), (parcelRequire("dn1OK")), (parcelRequire("2jgJV")), (parcelRequire("1mchh")), (parcelRequire("fD3hg")), (parcelRequire("ewRVG")), (parcelRequire("8Farc")), (parcelRequire("gD5RP")), (parcelRequire("8jKFG")), (parcelRequire("lhOVV")), (parcelRequire("7hfjh")), (parcelRequire("kUlnb")), (parcelRequire("i1DkS")), (parcelRequire("3YS3k")), (parcelRequire("11Qi3")), (parcelRequire("1U5fu")), (parcelRequire("h6qsS")), (parcelRequire("d6CyT")), (parcelRequire("dEe92")), (parcelRequire("lyYEL")), (parcelRequire("gxKq4")), (parcelRequire("52BGz")), (parcelRequire("85ki6")), (parcelRequire("7ScgT")), (parcelRequire("kfiXO")), (parcelRequire("51jqk")), (parcelRequire("iQyIl")), (parcelRequire("4IEfZ")), (parcelRequire("1lTi8")), (parcelRequire("jiRfE")), (parcelRequire("50Nv4")), (parcelRequire("5ujzY")), (parcelRequire("2bLfr")), (parcelRequire("hI4mr")), (parcelRequire("1yGut")), (parcelRequire("hEUsU")), (parcelRequire("aNBww")), (parcelRequire("1cAmv")), (parcelRequire("c13vl")), (parcelRequire("drvhi")), (parcelRequire("14fnZ")), (parcelRequire("k8wSb")), (parcelRequire("g5D6y")), (parcelRequire("hkGXQ")), (parcelRequire("kdTO4")), (parcelRequire("d15Zh")), (parcelRequire("jMRxa")), (parcelRequire("2cZ4R")), (parcelRequire("9FGIH")), (parcelRequire("6PGPz")), (parcelRequire("9i2HO")), (parcelRequire("iRpsV")), (parcelRequire("7KMpi")), (parcelRequire("jT5xJ")), (parcelRequire("7yyQt")), (parcelRequire("dXIky")), (parcelRequire("2pmb0")));
}($24686044b033fe8a$exports, function(e, t, r, n, a, o, s, i, l, c, p, d, u, f, h, m, v, g, y, D, k, w, S, b, M, _, C, E, Y, P, x, N, O, I, T, R, L, A, F, H, W, Q, q, K, B, V, j, U, $, z, X, G, J, Z, ee, te, re, ne, ae, oe, se, ie, le, ce, pe) {
    "use strict";
    function de(e) {
        return e && "object" == typeof e && "default" in e ? e : {
            default: e
        };
    }
    var ue = de(r), fe = de(n), he = de(pe), me = function(e, t) {
        return me = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(e, t) {
            e.__proto__ = t;
        } || function(e, t) {
            for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
        }, me(e, t);
    };
    function ve(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function r() {
            this.constructor = e;
        }
        me(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
    }
    var ge = function() {
        return ge = Object.assign || function(e) {
            for(var t, r = 1, n = arguments.length; r < n; r++)for(var a in t = arguments[r])Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
            return e;
        }, ge.apply(this, arguments);
    };
    function ye(e, t, r) {
        if (r || 2 === arguments.length) for(var n, a = 0, o = t.length; a < o; a++)!n && a in t || (n || (n = Array.prototype.slice.call(t, 0, a)), n[a] = t[a]);
        return e.concat(n || Array.prototype.slice.call(t));
    }
    "function" == typeof SuppressedError && SuppressedError;
    var De, ke = function(e) {
        var t = e.showTimeSelectOnly, r = void 0 !== t && t, n = e.showTime, a = void 0 !== n && n, o = e.className, s = e.children, i = r ? "Choose Time" : "Choose Date".concat(a ? " and Time" : "");
        return ue.default.createElement("div", {
            className: o,
            role: "dialog",
            "aria-label": i,
            "aria-modal": "true"
        }, s);
    };
    function we() {
        return "undefined" != typeof window ? window : globalThis;
    }
    !function(e) {
        e.ArrowUp = "ArrowUp", e.ArrowDown = "ArrowDown", e.ArrowLeft = "ArrowLeft", e.ArrowRight = "ArrowRight", e.PageUp = "PageUp", e.PageDown = "PageDown", e.Home = "Home", e.End = "End", e.Enter = "Enter", e.Space = " ", e.Tab = "Tab", e.Escape = "Escape", e.Backspace = "Backspace", e.X = "x";
    }(De || (De = {}));
    var Se = 12, be = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
    function Me(e) {
        if (null == e) return new Date;
        var t = "string" == typeof e ? B.parseISO(e) : le.toDate(e);
        return _e(t) ? t : new Date;
    }
    function _e(e, t) {
        return H.isValid(e) && !O.isBefore(e, null != t ? t : new Date("1/1/1800"));
    }
    function Ce(e, t, r) {
        if ("en" === r) return k.format(e, t, {
            useAdditionalWeekYearTokens: !0,
            useAdditionalDayOfYearTokens: !0
        });
        var n = r ? Ke(r) : void 0;
        return r && !n && console.warn('A locale object was not found for the provided string ["'.concat(r, '"].')), !n && qe() && Ke(qe()) && (n = Ke(qe())), k.format(e, t, {
            locale: n,
            useAdditionalWeekYearTokens: !0,
            useAdditionalDayOfYearTokens: !0
        });
    }
    function Ee(e, t) {
        var r = t.dateFormat, n = t.locale, a = Array.isArray(r) && r.length > 0 ? r[0] : r;
        return e && Ce(e, a, n) || "";
    }
    function Ye(e, t) {
        var r = t.hour, n = void 0 === r ? 0 : r, a = t.minute, o = void 0 === a ? 0 : a, s = t.second, i = void 0 === s ? 0 : s;
        return j.setHours(U.setMinutes(X.setSeconds(e, i), o), n);
    }
    function Pe(e) {
        return J.startOfDay(e);
    }
    function xe(e, t, r) {
        var n = Ke(t || qe());
        return te.startOfWeek(e, {
            locale: n,
            weekStartsOn: r
        });
    }
    function Ne(e) {
        return Z.startOfMonth(e);
    }
    function Oe(e) {
        return re.startOfYear(e);
    }
    function Ie(e) {
        return ee.startOfQuarter(e);
    }
    function Te() {
        return J.startOfDay(Me());
    }
    function Re(e) {
        return v.endOfDay(e);
    }
    function Le(e, t) {
        return e && t ? F.isSameYear(e, t) : !e && !t;
    }
    function Ae(e, t) {
        return e && t ? L.isSameMonth(e, t) : !e && !t;
    }
    function Fe(e, t) {
        return e && t ? A.isSameQuarter(e, t) : !e && !t;
    }
    function He(e, t) {
        return e && t ? R.isSameDay(e, t) : !e && !t;
    }
    function We(e, t) {
        return e && t ? T.isEqual(e, t) : !e && !t;
    }
    function Qe(e, t, r) {
        var n, a = J.startOfDay(t), o = v.endOfDay(r);
        try {
            n = W.isWithinInterval(e, {
                start: a,
                end: o
            });
        } catch (e) {
            n = !1;
        }
        return n;
    }
    function qe() {
        return we().__localeId__;
    }
    function Ke(e) {
        if ("string" == typeof e) {
            var t = we();
            return t.__localeData__ ? t.__localeData__[e] : void 0;
        }
        return e;
    }
    function Be(e, t) {
        return Ce($.setMonth(Me(), e), "LLLL", t);
    }
    function Ve(e, t) {
        return Ce($.setMonth(Me(), e), "LLL", t);
    }
    function je(e, t) {
        var r = void 0 === t ? {} : t, n = r.minDate, a = r.maxDate, o = r.excludeDates, s = r.excludeDateIntervals, i = r.includeDates, l = r.includeDateIntervals, c = r.filterDate;
        return tt(e, {
            minDate: n,
            maxDate: a
        }) || o && o.some(function(t) {
            var r;
            return t instanceof Date ? He(e, t) : He(e, null !== (r = t.date) && void 0 !== r ? r : new Date);
        }) || s && s.some(function(t) {
            var r = t.start, n = t.end;
            return W.isWithinInterval(e, {
                start: r,
                end: n
            });
        }) || i && !i.some(function(t) {
            return He(e, t);
        }) || l && !l.some(function(t) {
            var r = t.start, n = t.end;
            return W.isWithinInterval(e, {
                start: r,
                end: n
            });
        }) || c && !c(Me(e)) || !1;
    }
    function Ue(e, t) {
        var r = void 0 === t ? {} : t, n = r.excludeDates, a = r.excludeDateIntervals;
        return a && a.length > 0 ? a.some(function(t) {
            var r = t.start, n = t.end;
            return W.isWithinInterval(e, {
                start: r,
                end: n
            });
        }) : n && n.some(function(t) {
            var r;
            return t instanceof Date ? He(e, t) : He(e, null !== (r = t.date) && void 0 !== r ? r : new Date);
        }) || !1;
    }
    function $e(e, t) {
        var r = void 0 === t ? {} : t, n = r.minDate, a = r.maxDate, o = r.excludeDates, s = r.includeDates, i = r.filterDate;
        return tt(e, {
            minDate: n ? Z.startOfMonth(n) : void 0,
            maxDate: a ? g.endOfMonth(a) : void 0
        }) || (null == o ? void 0 : o.some(function(t) {
            return Ae(e, t instanceof Date ? t : t.date);
        })) || s && !s.some(function(t) {
            return Ae(e, t);
        }) || i && !i(Me(e)) || !1;
    }
    function ze(e, t, r, n) {
        var a = x.getYear(e), o = C.getMonth(e), s = x.getYear(t), i = C.getMonth(t), l = x.getYear(n);
        return a === s && a === l ? o <= r && r <= i : a < s && (l === a && o <= r || l === s && i >= r || l < s && l > a);
    }
    function Xe(e, t) {
        var r = void 0 === t ? {} : t, n = r.minDate, a = r.maxDate, o = r.excludeDates, s = r.includeDates;
        return tt(e, {
            minDate: n,
            maxDate: a
        }) || o && o.some(function(t) {
            return Ae(t instanceof Date ? t : t.date, e);
        }) || s && !s.some(function(t) {
            return Ae(t, e);
        }) || !1;
    }
    function Ge(e, t) {
        var r = void 0 === t ? {} : t, n = r.minDate, a = r.maxDate, o = r.excludeDates, s = r.includeDates, i = r.filterDate;
        return tt(e, {
            minDate: n,
            maxDate: a
        }) || (null == o ? void 0 : o.some(function(t) {
            return Fe(e, t instanceof Date ? t : t.date);
        })) || s && !s.some(function(t) {
            return Fe(e, t);
        }) || i && !i(Me(e)) || !1;
    }
    function Je(e, t, r) {
        if (!t || !r) return !1;
        if (!H.isValid(t) || !H.isValid(r)) return !1;
        var n = x.getYear(t), a = x.getYear(r);
        return n <= e && a >= e;
    }
    function Ze(e, t) {
        var r = void 0 === t ? {} : t, n = r.minDate, a = r.maxDate, o = r.excludeDates, s = r.includeDates, i = r.filterDate, l = new Date(e, 0, 1);
        return tt(l, {
            minDate: n ? re.startOfYear(n) : void 0,
            maxDate: a ? D.endOfYear(a) : void 0
        }) || (null == o ? void 0 : o.some(function(e) {
            return Le(l, e instanceof Date ? e : e.date);
        })) || s && !s.some(function(e) {
            return Le(l, e);
        }) || i && !i(Me(l)) || !1;
    }
    function et(e, t, r, n) {
        var a = x.getYear(e), o = E.getQuarter(e), s = x.getYear(t), i = E.getQuarter(t), l = x.getYear(n);
        return a === s && a === l ? o <= r && r <= i : a < s && (l === a && o <= r || l === s && i >= r || l < s && l > a);
    }
    function tt(e, t) {
        var r, n = void 0 === t ? {} : t, a = n.minDate, o = n.maxDate;
        return null !== (r = a && u.differenceInCalendarDays(e, a) < 0 || o && u.differenceInCalendarDays(e, o) > 0) && void 0 !== r && r;
    }
    function rt(e, t) {
        return t.some(function(t) {
            return b.getHours(t) === b.getHours(e) && _.getMinutes(t) === _.getMinutes(e) && Y.getSeconds(t) === Y.getSeconds(e);
        });
    }
    function nt(e, t) {
        var r = void 0 === t ? {} : t, n = r.excludeTimes, a = r.includeTimes, o = r.filterTime;
        return n && rt(e, n) || a && !rt(e, a) || o && !o(e) || !1;
    }
    function at(e, t) {
        var r = t.minTime, n = t.maxTime;
        if (!r || !n) throw new Error("Both minTime and maxTime props required");
        var a = Me();
        a = j.setHours(a, b.getHours(e)), a = U.setMinutes(a, _.getMinutes(e)), a = X.setSeconds(a, Y.getSeconds(e));
        var o = Me();
        o = j.setHours(o, b.getHours(r)), o = U.setMinutes(o, _.getMinutes(r)), o = X.setSeconds(o, Y.getSeconds(r));
        var s, i = Me();
        i = j.setHours(i, b.getHours(n)), i = U.setMinutes(i, _.getMinutes(n)), i = X.setSeconds(i, Y.getSeconds(n));
        try {
            s = !W.isWithinInterval(a, {
                start: o,
                end: i
            });
        } catch (e) {
            s = !1;
        }
        return s;
    }
    function ot(e, t) {
        var r = void 0 === t ? {} : t, n = r.minDate, a = r.includeDates, o = ae.subMonths(e, 1);
        return n && f.differenceInCalendarMonths(n, o) > 0 || a && a.every(function(e) {
            return f.differenceInCalendarMonths(e, o) > 0;
        }) || !1;
    }
    function st(e, t) {
        var r = void 0 === t ? {} : t, n = r.maxDate, a = r.includeDates, o = i.addMonths(e, 1);
        return n && f.differenceInCalendarMonths(o, n) > 0 || a && a.every(function(e) {
            return f.differenceInCalendarMonths(o, e) > 0;
        }) || !1;
    }
    function it(e, t) {
        var r = void 0 === t ? {} : t, n = r.minDate, a = r.includeDates, o = ie.subYears(e, 1);
        return n && m.differenceInCalendarYears(n, o) > 0 || a && a.every(function(e) {
            return m.differenceInCalendarYears(e, o) > 0;
        }) || !1;
    }
    function lt(e, t) {
        var r = void 0 === t ? {} : t, n = r.maxDate, a = r.includeDates, o = d.addYears(e, 1);
        return n && m.differenceInCalendarYears(o, n) > 0 || a && a.every(function(e) {
            return m.differenceInCalendarYears(o, e) > 0;
        }) || !1;
    }
    function ct(e) {
        var t = e.minDate, r = e.includeDates;
        if (r && t) {
            var n = r.filter(function(e) {
                return u.differenceInCalendarDays(e, t) >= 0;
            });
            return q.min(n);
        }
        return r ? q.min(r) : t;
    }
    function pt(e) {
        var t = e.maxDate, r = e.includeDates;
        if (r && t) {
            var n = r.filter(function(e) {
                return u.differenceInCalendarDays(e, t) <= 0;
            });
            return Q.max(n);
        }
        return r ? Q.max(r) : t;
    }
    function dt(e, t) {
        var r;
        void 0 === e && (e = []), void 0 === t && (t = "react-datepicker__day--highlighted");
        for(var n = new Map, a = 0, o = e.length; a < o; a++){
            var s = e[a];
            if (I.isDate(s)) {
                var i = Ce(s, "MM.dd.yyyy");
                (f = n.get(i) || []).includes(t) || (f.push(t), n.set(i, f));
            } else if ("object" == typeof s) {
                var l = null !== (r = Object.keys(s)[0]) && void 0 !== r ? r : "", c = s[l];
                if ("string" == typeof l && Array.isArray(c)) for(var p = 0, d = c.length; p < d; p++){
                    var u = c[p];
                    if (u) {
                        var f;
                        i = Ce(u, "MM.dd.yyyy");
                        (f = n.get(i) || []).includes(l) || (f.push(l), n.set(i, f));
                    }
                }
            }
        }
        return n;
    }
    function ut(e, t) {
        void 0 === e && (e = []), void 0 === t && (t = "react-datepicker__day--holidays");
        var r = new Map;
        return e.forEach(function(e) {
            var n = e.date, a = e.holidayName;
            if (I.isDate(n)) {
                var o = Ce(n, "MM.dd.yyyy"), s = r.get(o) || {
                    className: "",
                    holidayNames: []
                };
                if (!("className" in s) || s.className !== t || (i = s.holidayNames, l = [
                    a
                ], i.length !== l.length || !i.every(function(e, t) {
                    return e === l[t];
                }))) {
                    var i, l;
                    s.className = t;
                    var c = s.holidayNames;
                    s.holidayNames = c ? ye(ye([], c, !0), [
                        a
                    ], !1) : [
                        a
                    ], r.set(o, s);
                }
            }
        }), r;
    }
    function ft(e, t, r, n, a) {
        for(var i = a.length, l = [], p = 0; p < i; p++){
            var d = e, u = a[p];
            u && (d = o.addHours(d, b.getHours(u)), d = s.addMinutes(d, _.getMinutes(u)), d = c.addSeconds(d, Y.getSeconds(u)));
            var f = s.addMinutes(e, (r + 1) * n);
            N.isAfter(d, t) && O.isBefore(d, f) && null != u && l.push(u);
        }
        return l;
    }
    function ht(e) {
        return e < 10 ? "0".concat(e) : "".concat(e);
    }
    function mt(e, t) {
        void 0 === t && (t = Se);
        var r = Math.ceil(x.getYear(e) / t) * t;
        return {
            startPeriod: r - (t - 1),
            endPeriod: r
        };
    }
    function vt(e) {
        var t = e.getSeconds(), r = e.getMilliseconds();
        return le.toDate(e.getTime() - 1e3 * t - r);
    }
    function gt(e) {
        if (!I.isDate(e)) throw new Error("Invalid date");
        var t = new Date(e);
        return t.setHours(0, 0, 0, 0), t;
    }
    function yt(e, t) {
        if (!I.isDate(e) || !I.isDate(t)) throw new Error("Invalid date received");
        var r = gt(e), n = gt(t);
        return O.isBefore(r, n);
    }
    function Dt(e) {
        return e.key === De.Space;
    }
    var kt, wt = function(e) {
        function t(t) {
            var n = e.call(this, t) || this;
            return n.onTimeChange = function(e) {
                var t, r;
                n.setState({
                    time: e
                });
                var a = n.props.date, o = a instanceof Date && !isNaN(+a) ? a : new Date;
                if (null == e ? void 0 : e.includes(":")) {
                    var s = e.split(":"), i = s[0], l = s[1];
                    o.setHours(Number(i)), o.setMinutes(Number(l));
                }
                null === (r = (t = n.props).onChange) || void 0 === r || r.call(t, o);
            }, n.renderTimeInput = function() {
                var e = n.state.time, t = n.props, a = t.date, o = t.timeString, s = t.customTimeInput;
                return s ? r.cloneElement(s, {
                    date: a,
                    value: e,
                    onChange: n.onTimeChange
                }) : ue.default.createElement("input", {
                    type: "time",
                    className: "react-datepicker-time__input",
                    placeholder: "Time",
                    name: "time-input",
                    required: !0,
                    value: e,
                    onChange: function(e) {
                        n.onTimeChange(e.target.value || o);
                    }
                });
            }, n.state = {
                time: n.props.timeString
            }, n;
        }
        return ve(t, e), t.getDerivedStateFromProps = function(e, t) {
            return e.timeString !== t.time ? {
                time: e.timeString
            } : null;
        }, t.prototype.render = function() {
            return ue.default.createElement("div", {
                className: "react-datepicker__input-time-container"
            }, ue.default.createElement("div", {
                className: "react-datepicker-time__caption"
            }, this.props.timeInputLabel), ue.default.createElement("div", {
                className: "react-datepicker-time__input-container"
            }, ue.default.createElement("div", {
                className: "react-datepicker-time__input"
            }, this.renderTimeInput())));
        }, t;
    }(r.Component), St = function(e) {
        function n() {
            var n = null !== e && e.apply(this, arguments) || this;
            return n.dayEl = r.createRef(), n.handleClick = function(e) {
                !n.isDisabled() && n.props.onClick && n.props.onClick(e);
            }, n.handleMouseEnter = function(e) {
                !n.isDisabled() && n.props.onMouseEnter && n.props.onMouseEnter(e);
            }, n.handleOnKeyDown = function(e) {
                var t, r;
                e.key === De.Space && (e.preventDefault(), e.key = De.Enter), null === (r = (t = n.props).handleOnKeyDown) || void 0 === r || r.call(t, e);
            }, n.isSameDay = function(e) {
                return He(n.props.day, e);
            }, n.isKeyboardSelected = function() {
                var e;
                return !n.props.disabledKeyboardNavigation && !(n.props.selectsMultiple ? null === (e = n.props.selectedDates) || void 0 === e ? void 0 : e.some(function(e) {
                    return n.isSameDayOrWeek(e);
                }) : n.isSameDayOrWeek(n.props.selected)) && n.isSameDayOrWeek(n.props.preSelection);
            }, n.isDisabled = function() {
                return je(n.props.day, {
                    minDate: n.props.minDate,
                    maxDate: n.props.maxDate,
                    excludeDates: n.props.excludeDates,
                    excludeDateIntervals: n.props.excludeDateIntervals,
                    includeDateIntervals: n.props.includeDateIntervals,
                    includeDates: n.props.includeDates,
                    filterDate: n.props.filterDate
                });
            }, n.isExcluded = function() {
                return Ue(n.props.day, {
                    excludeDates: n.props.excludeDates,
                    excludeDateIntervals: n.props.excludeDateIntervals
                });
            }, n.isStartOfWeek = function() {
                return He(n.props.day, xe(n.props.day, n.props.locale, n.props.calendarStartDay));
            }, n.isSameWeek = function(e) {
                return n.props.showWeekPicker && He(e, xe(n.props.day, n.props.locale, n.props.calendarStartDay));
            }, n.isSameDayOrWeek = function(e) {
                return n.isSameDay(e) || n.isSameWeek(e);
            }, n.getHighLightedClass = function() {
                var e = n.props, t = e.day, r = e.highlightDates;
                if (!r) return !1;
                var a = Ce(t, "MM.dd.yyyy");
                return r.get(a);
            }, n.getHolidaysClass = function() {
                var e, t = n.props, r = t.day, a = t.holidays;
                if (!a) return [
                    void 0
                ];
                var o = Ce(r, "MM.dd.yyyy");
                return a.has(o) ? [
                    null === (e = a.get(o)) || void 0 === e ? void 0 : e.className
                ] : [
                    void 0
                ];
            }, n.isInRange = function() {
                var e = n.props, t = e.day, r = e.startDate, a = e.endDate;
                return !(!r || !a) && Qe(t, r, a);
            }, n.isInSelectingRange = function() {
                var e, t = n.props, r = t.day, a = t.selectsStart, o = t.selectsEnd, s = t.selectsRange, i = t.selectsDisabledDaysInRange, l = t.startDate, c = t.endDate, p = null !== (e = n.props.selectingDate) && void 0 !== e ? e : n.props.preSelection;
                return !(!(a || o || s) || !p || !i && n.isDisabled()) && (a && c && (O.isBefore(p, c) || We(p, c)) ? Qe(r, p, c) : (o && l && (N.isAfter(p, l) || We(p, l)) || !(!s || !l || c || !N.isAfter(p, l) && !We(p, l))) && Qe(r, l, p));
            }, n.isSelectingRangeStart = function() {
                var e;
                if (!n.isInSelectingRange()) return !1;
                var t = n.props, r = t.day, a = t.startDate, o = t.selectsStart, s = null !== (e = n.props.selectingDate) && void 0 !== e ? e : n.props.preSelection;
                return He(r, o ? s : a);
            }, n.isSelectingRangeEnd = function() {
                var e;
                if (!n.isInSelectingRange()) return !1;
                var t = n.props, r = t.day, a = t.endDate, o = t.selectsEnd, s = t.selectsRange, i = null !== (e = n.props.selectingDate) && void 0 !== e ? e : n.props.preSelection;
                return He(r, o || s ? i : a);
            }, n.isRangeStart = function() {
                var e = n.props, t = e.day, r = e.startDate, a = e.endDate;
                return !(!r || !a) && He(r, t);
            }, n.isRangeEnd = function() {
                var e = n.props, t = e.day, r = e.startDate, a = e.endDate;
                return !(!r || !a) && He(a, t);
            }, n.isWeekend = function() {
                var e = S.getDay(n.props.day);
                return 0 === e || 6 === e;
            }, n.isAfterMonth = function() {
                return void 0 !== n.props.month && (n.props.month + 1) % 12 === C.getMonth(n.props.day);
            }, n.isBeforeMonth = function() {
                return void 0 !== n.props.month && (C.getMonth(n.props.day) + 1) % 12 === n.props.month;
            }, n.isCurrentDay = function() {
                return n.isSameDay(Me());
            }, n.isSelected = function() {
                var e;
                return n.props.selectsMultiple ? null === (e = n.props.selectedDates) || void 0 === e ? void 0 : e.some(function(e) {
                    return n.isSameDayOrWeek(e);
                }) : n.isSameDayOrWeek(n.props.selected);
            }, n.getClassNames = function(e) {
                var r, a = n.props.dayClassName ? n.props.dayClassName(e) : void 0;
                return t.clsx("react-datepicker__day", a, "react-datepicker__day--" + Ce(n.props.day, "ddd", r), {
                    "react-datepicker__day--disabled": n.isDisabled(),
                    "react-datepicker__day--excluded": n.isExcluded(),
                    "react-datepicker__day--selected": n.isSelected(),
                    "react-datepicker__day--keyboard-selected": n.isKeyboardSelected(),
                    "react-datepicker__day--range-start": n.isRangeStart(),
                    "react-datepicker__day--range-end": n.isRangeEnd(),
                    "react-datepicker__day--in-range": n.isInRange(),
                    "react-datepicker__day--in-selecting-range": n.isInSelectingRange(),
                    "react-datepicker__day--selecting-range-start": n.isSelectingRangeStart(),
                    "react-datepicker__day--selecting-range-end": n.isSelectingRangeEnd(),
                    "react-datepicker__day--today": n.isCurrentDay(),
                    "react-datepicker__day--weekend": n.isWeekend(),
                    "react-datepicker__day--outside-month": n.isAfterMonth() || n.isBeforeMonth()
                }, n.getHighLightedClass(), n.getHolidaysClass());
            }, n.getAriaLabel = function() {
                var e = n.props, t = e.day, r = e.ariaLabelPrefixWhenEnabled, a = void 0 === r ? "Choose" : r, o = e.ariaLabelPrefixWhenDisabled, s = void 0 === o ? "Not available" : o, i = n.isDisabled() || n.isExcluded() ? s : a;
                return "".concat(i, " ").concat(Ce(t, "PPPP", n.props.locale));
            }, n.getTitle = function() {
                var e = n.props, t = e.day, r = e.holidays, a = void 0 === r ? new Map : r, o = e.excludeDates, s = Ce(t, "MM.dd.yyyy"), i = [];
                return a.has(s) && i.push.apply(i, a.get(s).holidayNames), n.isExcluded() && i.push(null == o ? void 0 : o.filter(function(e) {
                    return e instanceof Date ? He(e, t) : He(null == e ? void 0 : e.date, t);
                }).map(function(e) {
                    if (!(e instanceof Date)) return null == e ? void 0 : e.message;
                })), i.join(", ");
            }, n.getTabIndex = function() {
                var e = n.props.selected, t = n.props.preSelection;
                return (!n.props.showWeekPicker || !n.props.showWeekNumber && n.isStartOfWeek()) && (n.isKeyboardSelected() || n.isSameDay(e) && He(t, e)) ? 0 : -1;
            }, n.handleFocusDay = function() {
                var e;
                n.shouldFocusDay() && (null === (e = n.dayEl.current) || void 0 === e || e.focus({
                    preventScroll: !0
                }));
            }, n.renderDayContents = function() {
                return n.props.monthShowsDuplicateDaysEnd && n.isAfterMonth() || n.props.monthShowsDuplicateDaysStart && n.isBeforeMonth() ? null : n.props.renderDayContents ? n.props.renderDayContents(w.getDate(n.props.day), n.props.day) : w.getDate(n.props.day);
            }, n.render = function() {
                return ue.default.createElement("div", {
                    ref: n.dayEl,
                    className: n.getClassNames(n.props.day),
                    onKeyDown: n.handleOnKeyDown,
                    onClick: n.handleClick,
                    onMouseEnter: n.props.usePointerEvent ? void 0 : n.handleMouseEnter,
                    onPointerEnter: n.props.usePointerEvent ? n.handleMouseEnter : void 0,
                    tabIndex: n.getTabIndex(),
                    "aria-label": n.getAriaLabel(),
                    role: "option",
                    title: n.getTitle(),
                    "aria-disabled": n.isDisabled(),
                    "aria-current": n.isCurrentDay() ? "date" : void 0,
                    "aria-selected": n.isSelected() || n.isInRange()
                }, n.renderDayContents(), "" !== n.getTitle() && ue.default.createElement("span", {
                    className: "overlay"
                }, n.getTitle()));
            }, n;
        }
        return ve(n, e), n.prototype.componentDidMount = function() {
            this.handleFocusDay();
        }, n.prototype.componentDidUpdate = function() {
            this.handleFocusDay();
        }, n.prototype.shouldFocusDay = function() {
            var e = !1;
            return 0 === this.getTabIndex() && this.isSameDay(this.props.preSelection) && (document.activeElement && document.activeElement !== document.body || (e = !0), this.props.inline && !this.props.shouldFocusDayInline && (e = !1), this.isDayActiveElement() && (e = !0), this.isDuplicateDay() && (e = !1)), e;
        }, n.prototype.isDayActiveElement = function() {
            var e, t, r;
            return (null === (t = null === (e = this.props.containerRef) || void 0 === e ? void 0 : e.current) || void 0 === t ? void 0 : t.contains(document.activeElement)) && (null === (r = document.activeElement) || void 0 === r ? void 0 : r.classList.contains("react-datepicker__day"));
        }, n.prototype.isDuplicateDay = function() {
            return this.props.monthShowsDuplicateDaysEnd && this.isAfterMonth() || this.props.monthShowsDuplicateDaysStart && this.isBeforeMonth();
        }, n;
    }(r.Component), bt = function(e) {
        function n() {
            var t = null !== e && e.apply(this, arguments) || this;
            return t.weekNumberEl = r.createRef(), t.handleClick = function(e) {
                t.props.onClick && t.props.onClick(e);
            }, t.handleOnKeyDown = function(e) {
                var r, n;
                e.key === De.Space && (e.preventDefault(), e.key = De.Enter), null === (n = (r = t.props).handleOnKeyDown) || void 0 === n || n.call(r, e);
            }, t.isKeyboardSelected = function() {
                return !t.props.disabledKeyboardNavigation && !He(t.props.date, t.props.selected) && He(t.props.date, t.props.preSelection);
            }, t.getTabIndex = function() {
                return t.props.showWeekPicker && t.props.showWeekNumber && (t.isKeyboardSelected() || He(t.props.date, t.props.selected) && He(t.props.preSelection, t.props.selected)) ? 0 : -1;
            }, t.handleFocusWeekNumber = function(e) {
                var r = !1;
                0 === t.getTabIndex() && !(null == e ? void 0 : e.isInputFocused) && He(t.props.date, t.props.preSelection) && (document.activeElement && document.activeElement !== document.body || (r = !0), t.props.inline && !t.props.shouldFocusDayInline && (r = !1), t.props.containerRef && t.props.containerRef.current && t.props.containerRef.current.contains(document.activeElement) && document.activeElement && document.activeElement.classList.contains("react-datepicker__week-number") && (r = !0)), r && t.weekNumberEl.current && t.weekNumberEl.current.focus({
                    preventScroll: !0
                });
            }, t;
        }
        return ve(n, e), Object.defineProperty(n, "defaultProps", {
            get: function() {
                return {
                    ariaLabelPrefix: "week "
                };
            },
            enumerable: !1,
            configurable: !0
        }), n.prototype.componentDidMount = function() {
            this.handleFocusWeekNumber();
        }, n.prototype.componentDidUpdate = function(e) {
            this.handleFocusWeekNumber(e);
        }, n.prototype.render = function() {
            var e = this.props, r = e.weekNumber, a = e.ariaLabelPrefix, o = void 0 === a ? n.defaultProps.ariaLabelPrefix : a, s = e.onClick, i = {
                "react-datepicker__week-number": !0,
                "react-datepicker__week-number--clickable": !!s,
                "react-datepicker__week-number--selected": !!s && He(this.props.date, this.props.selected),
                "react-datepicker__week-number--keyboard-selected": this.isKeyboardSelected()
            };
            return ue.default.createElement("div", {
                ref: this.weekNumberEl,
                className: t.clsx(i),
                "aria-label": "".concat(o, " ").concat(this.props.weekNumber),
                onClick: this.handleClick,
                onKeyDown: this.handleOnKeyDown,
                tabIndex: this.getTabIndex()
            }, r);
        }, n;
    }(r.Component), Mt = function(e) {
        function r() {
            var t = null !== e && e.apply(this, arguments) || this;
            return t.handleDayClick = function(e, r) {
                t.props.onDayClick && t.props.onDayClick(e, r);
            }, t.handleDayMouseEnter = function(e) {
                t.props.onDayMouseEnter && t.props.onDayMouseEnter(e);
            }, t.handleWeekClick = function(e, n, a) {
                var o, s, i;
                "function" == typeof t.props.onWeekSelect && t.props.onWeekSelect(e, n, a), t.props.showWeekPicker && t.handleDayClick(e, a), (null !== (o = t.props.shouldCloseOnSelect) && void 0 !== o ? o : r.defaultProps.shouldCloseOnSelect) && (null === (i = (s = t.props).setOpen) || void 0 === i || i.call(s, !1));
            }, t.formatWeekNumber = function(e) {
                return t.props.formatWeekNumber ? t.props.formatWeekNumber(e) : function(e) {
                    return M.getISOWeek(e);
                }(e);
            }, t.renderDays = function() {
                var e = t.startOfWeek(), n = [], o = t.formatWeekNumber(e);
                if (t.props.showWeekNumber) {
                    var s = t.props.onWeekSelect || t.props.showWeekPicker ? t.handleWeekClick.bind(t, e, o) : void 0;
                    n.push(ue.default.createElement(bt, ge({
                        key: "W"
                    }, r.defaultProps, t.props, {
                        weekNumber: o,
                        date: e,
                        onClick: s
                    })));
                }
                return n.concat([
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6
                ].map(function(n) {
                    var o = a.addDays(e, n);
                    return ue.default.createElement(St, ge({}, r.defaultProps, t.props, {
                        ariaLabelPrefixWhenEnabled: t.props.chooseDayAriaLabelPrefix,
                        ariaLabelPrefixWhenDisabled: t.props.disabledDayAriaLabelPrefix,
                        key: o.valueOf(),
                        day: o,
                        onClick: t.handleDayClick.bind(t, o),
                        onMouseEnter: t.handleDayMouseEnter.bind(t, o)
                    }));
                }));
            }, t.startOfWeek = function() {
                return xe(t.props.day, t.props.locale, t.props.calendarStartDay);
            }, t.isKeyboardSelected = function() {
                return !t.props.disabledKeyboardNavigation && !He(t.startOfWeek(), t.props.selected) && He(t.startOfWeek(), t.props.preSelection);
            }, t;
        }
        return ve(r, e), Object.defineProperty(r, "defaultProps", {
            get: function() {
                return {
                    shouldCloseOnSelect: !0
                };
            },
            enumerable: !1,
            configurable: !0
        }), r.prototype.render = function() {
            var e = {
                "react-datepicker__week": !0,
                "react-datepicker__week--selected": He(this.startOfWeek(), this.props.selected),
                "react-datepicker__week--keyboard-selected": this.isKeyboardSelected()
            };
            return ue.default.createElement("div", {
                className: t.clsx(e)
            }, this.renderDays());
        }, r;
    }(r.Component), _t = "two_columns", Ct = "three_columns", Et = "four_columns", Yt = ((kt = {})[_t] = {
        grid: [
            [
                0,
                1
            ],
            [
                2,
                3
            ],
            [
                4,
                5
            ],
            [
                6,
                7
            ],
            [
                8,
                9
            ],
            [
                10,
                11
            ]
        ],
        verticalNavigationOffset: 2
    }, kt[Ct] = {
        grid: [
            [
                0,
                1,
                2
            ],
            [
                3,
                4,
                5
            ],
            [
                6,
                7,
                8
            ],
            [
                9,
                10,
                11
            ]
        ],
        verticalNavigationOffset: 3
    }, kt[Et] = {
        grid: [
            [
                0,
                1,
                2,
                3
            ],
            [
                4,
                5,
                6,
                7
            ],
            [
                8,
                9,
                10,
                11
            ]
        ],
        verticalNavigationOffset: 4
    }, kt);
    function Pt(e, t) {
        return e ? Et : t ? _t : Ct;
    }
    var xt = function(e) {
        function n() {
            var n = null !== e && e.apply(this, arguments) || this;
            return n.MONTH_REFS = ye([], Array(12), !0).map(function() {
                return r.createRef();
            }), n.QUARTER_REFS = ye([], Array(4), !0).map(function() {
                return r.createRef();
            }), n.isDisabled = function(e) {
                return je(e, {
                    minDate: n.props.minDate,
                    maxDate: n.props.maxDate,
                    excludeDates: n.props.excludeDates,
                    excludeDateIntervals: n.props.excludeDateIntervals,
                    includeDateIntervals: n.props.includeDateIntervals,
                    includeDates: n.props.includeDates,
                    filterDate: n.props.filterDate
                });
            }, n.isExcluded = function(e) {
                return Ue(e, {
                    excludeDates: n.props.excludeDates,
                    excludeDateIntervals: n.props.excludeDateIntervals
                });
            }, n.handleDayClick = function(e, t) {
                var r, a;
                null === (a = (r = n.props).onDayClick) || void 0 === a || a.call(r, e, t, n.props.orderInDisplay);
            }, n.handleDayMouseEnter = function(e) {
                var t, r;
                null === (r = (t = n.props).onDayMouseEnter) || void 0 === r || r.call(t, e);
            }, n.handleMouseLeave = function() {
                var e, t;
                null === (t = (e = n.props).onMouseLeave) || void 0 === t || t.call(e);
            }, n.isRangeStartMonth = function(e) {
                var t = n.props, r = t.day, a = t.startDate, o = t.endDate;
                return !(!a || !o) && Ae($.setMonth(r, e), a);
            }, n.isRangeStartQuarter = function(e) {
                var t = n.props, r = t.day, a = t.startDate, o = t.endDate;
                return !(!a || !o) && Fe(z.setQuarter(r, e), a);
            }, n.isRangeEndMonth = function(e) {
                var t = n.props, r = t.day, a = t.startDate, o = t.endDate;
                return !(!a || !o) && Ae($.setMonth(r, e), o);
            }, n.isRangeEndQuarter = function(e) {
                var t = n.props, r = t.day, a = t.startDate, o = t.endDate;
                return !(!a || !o) && Fe(z.setQuarter(r, e), o);
            }, n.isInSelectingRangeMonth = function(e) {
                var t, r = n.props, a = r.day, o = r.selectsStart, s = r.selectsEnd, i = r.selectsRange, l = r.startDate, c = r.endDate, p = null !== (t = n.props.selectingDate) && void 0 !== t ? t : n.props.preSelection;
                return !(!(o || s || i) || !p) && (o && c ? ze(p, c, e, a) : (s && l || !(!i || !l || c)) && ze(l, p, e, a));
            }, n.isSelectingMonthRangeStart = function(e) {
                var t;
                if (!n.isInSelectingRangeMonth(e)) return !1;
                var r = n.props, a = r.day, o = r.startDate, s = r.selectsStart, i = $.setMonth(a, e), l = null !== (t = n.props.selectingDate) && void 0 !== t ? t : n.props.preSelection;
                return Ae(i, s ? l : o);
            }, n.isSelectingMonthRangeEnd = function(e) {
                var t;
                if (!n.isInSelectingRangeMonth(e)) return !1;
                var r = n.props, a = r.day, o = r.endDate, s = r.selectsEnd, i = r.selectsRange, l = $.setMonth(a, e), c = null !== (t = n.props.selectingDate) && void 0 !== t ? t : n.props.preSelection;
                return Ae(l, s || i ? c : o);
            }, n.isInSelectingRangeQuarter = function(e) {
                var t, r = n.props, a = r.day, o = r.selectsStart, s = r.selectsEnd, i = r.selectsRange, l = r.startDate, c = r.endDate, p = null !== (t = n.props.selectingDate) && void 0 !== t ? t : n.props.preSelection;
                return !(!(o || s || i) || !p) && (o && c ? et(p, c, e, a) : (s && l || !(!i || !l || c)) && et(l, p, e, a));
            }, n.isWeekInMonth = function(e) {
                var t = n.props.day, r = a.addDays(e, 6);
                return Ae(e, t) || Ae(r, t);
            }, n.isCurrentMonth = function(e, t) {
                return x.getYear(e) === x.getYear(Me()) && t === C.getMonth(Me());
            }, n.isCurrentQuarter = function(e, t) {
                return x.getYear(e) === x.getYear(Me()) && t === E.getQuarter(Me());
            }, n.isSelectedMonth = function(e, t, r) {
                return C.getMonth(r) === t && x.getYear(e) === x.getYear(r);
            }, n.isSelectedQuarter = function(e, t, r) {
                return E.getQuarter(e) === t && x.getYear(e) === x.getYear(r);
            }, n.renderWeeks = function() {
                for(var e = [], t = n.props.fixedHeight, r = 0, a = !1, o = xe(Ne(n.props.day), n.props.locale, n.props.calendarStartDay), s = n.props.selected ? function(e) {
                    return n.props.showWeekPicker ? xe(e, n.props.locale, n.props.calendarStartDay) : n.props.selected;
                }(n.props.selected) : void 0, i = n.props.preSelection ? function(e) {
                    return n.props.showWeekPicker ? xe(e, n.props.locale, n.props.calendarStartDay) : n.props.preSelection;
                }(n.props.preSelection) : void 0; e.push(ue.default.createElement(Mt, ge({}, n.props, {
                    ariaLabelPrefix: n.props.weekAriaLabelPrefix,
                    key: r,
                    day: o,
                    month: C.getMonth(n.props.day),
                    onDayClick: n.handleDayClick,
                    onDayMouseEnter: n.handleDayMouseEnter,
                    selected: s,
                    preSelection: i,
                    showWeekNumber: n.props.showWeekNumbers
                }))), !a;){
                    r++, o = p.addWeeks(o, 1);
                    var l = t && r >= 6, c = !t && !n.isWeekInMonth(o);
                    if (l || c) {
                        if (!n.props.peekNextMonth) break;
                        a = !0;
                    }
                }
                return e;
            }, n.onMonthClick = function(e, t) {
                var r = n.isMonthDisabledForLabelDate(t), a = r.isDisabled, o = r.labelDate;
                a || n.handleDayClick(Ne(o), e);
            }, n.onMonthMouseEnter = function(e) {
                var t = n.isMonthDisabledForLabelDate(e), r = t.isDisabled, a = t.labelDate;
                r || n.handleDayMouseEnter(Ne(a));
            }, n.handleMonthNavigation = function(e, t) {
                var r, a, o, s;
                null === (a = (r = n.props).setPreSelection) || void 0 === a || a.call(r, t), null === (s = null === (o = n.MONTH_REFS[e]) || void 0 === o ? void 0 : o.current) || void 0 === s || s.focus();
            }, n.handleKeyboardNavigation = function(e, t, r) {
                var a, o = n.props, s = o.selected, l = o.preSelection, c = o.setPreSelection, p = o.minDate, d = o.maxDate, u = o.showFourColumnMonthYearPicker, f = o.showTwoColumnMonthYearPicker;
                if (l) {
                    var h = Pt(u, f), m = n.getVerticalOffset(h), v = null === (a = Yt[h]) || void 0 === a ? void 0 : a.grid, g = function(e, t, r) {
                        var n, a, o = t, s = r;
                        switch(e){
                            case De.ArrowRight:
                                o = i.addMonths(t, 1), s = 11 === r ? 0 : r + 1;
                                break;
                            case De.ArrowLeft:
                                o = ae.subMonths(t, 1), s = 0 === r ? 11 : r - 1;
                                break;
                            case De.ArrowUp:
                                o = ae.subMonths(t, m), s = (null === (n = null == v ? void 0 : v[0]) || void 0 === n ? void 0 : n.includes(r)) ? r + 12 - m : r - m;
                                break;
                            case De.ArrowDown:
                                o = i.addMonths(t, m), s = (null === (a = null == v ? void 0 : v[v.length - 1]) || void 0 === a ? void 0 : a.includes(r)) ? r - 12 + m : r + m;
                        }
                        return {
                            newCalculatedDate: o,
                            newCalculatedMonth: s
                        };
                    };
                    if (t !== De.Enter) {
                        var y = function(e, t, r) {
                            for(var a = e, o = !1, s = 0, i = g(a, t, r), l = i.newCalculatedDate, c = i.newCalculatedMonth; !o;){
                                if (s >= 40) {
                                    l = t, c = r;
                                    break;
                                }
                                var u;
                                if (p && l < p) a = De.ArrowRight, l = (u = g(a, l, c)).newCalculatedDate, c = u.newCalculatedMonth;
                                if (d && l > d) a = De.ArrowLeft, l = (u = g(a, l, c)).newCalculatedDate, c = u.newCalculatedMonth;
                                if (Xe(l, n.props)) l = (u = g(a, l, c)).newCalculatedDate, c = u.newCalculatedMonth;
                                else o = !0;
                                s++;
                            }
                            return {
                                newCalculatedDate: l,
                                newCalculatedMonth: c
                            };
                        }(t, l, r), D = y.newCalculatedDate, k = y.newCalculatedMonth;
                        switch(t){
                            case De.ArrowRight:
                            case De.ArrowLeft:
                            case De.ArrowUp:
                            case De.ArrowDown:
                                n.handleMonthNavigation(k, D);
                        }
                    } else n.isMonthDisabled(r) || (n.onMonthClick(e, r), null == c || c(s));
                }
            }, n.getVerticalOffset = function(e) {
                var t, r;
                return null !== (r = null === (t = Yt[e]) || void 0 === t ? void 0 : t.verticalNavigationOffset) && void 0 !== r ? r : 0;
            }, n.onMonthKeyDown = function(e, t) {
                var r = n.props, a = r.disabledKeyboardNavigation, o = r.handleOnMonthKeyDown, s = e.key;
                s !== De.Tab && e.preventDefault(), a || n.handleKeyboardNavigation(e, s, t), o && o(e);
            }, n.onQuarterClick = function(e, t) {
                var r = z.setQuarter(n.props.day, t);
                Ge(r, n.props) || n.handleDayClick(Ie(r), e);
            }, n.onQuarterMouseEnter = function(e) {
                var t = z.setQuarter(n.props.day, e);
                Ge(t, n.props) || n.handleDayMouseEnter(Ie(t));
            }, n.handleQuarterNavigation = function(e, t) {
                var r, a, o, s;
                n.isDisabled(t) || n.isExcluded(t) || (null === (a = (r = n.props).setPreSelection) || void 0 === a || a.call(r, t), null === (s = null === (o = n.QUARTER_REFS[e - 1]) || void 0 === o ? void 0 : o.current) || void 0 === s || s.focus());
            }, n.onQuarterKeyDown = function(e, t) {
                var r, a, o = e.key;
                if (!n.props.disabledKeyboardNavigation) switch(o){
                    case De.Enter:
                        n.onQuarterClick(e, t), null === (a = (r = n.props).setPreSelection) || void 0 === a || a.call(r, n.props.selected);
                        break;
                    case De.ArrowRight:
                        if (!n.props.preSelection) break;
                        n.handleQuarterNavigation(4 === t ? 1 : t + 1, l.addQuarters(n.props.preSelection, 1));
                        break;
                    case De.ArrowLeft:
                        if (!n.props.preSelection) break;
                        n.handleQuarterNavigation(1 === t ? 4 : t - 1, oe.subQuarters(n.props.preSelection, 1));
                }
            }, n.isMonthDisabledForLabelDate = function(e) {
                var t, r = n.props, a = r.day, o = r.minDate, s = r.maxDate, i = r.excludeDates, l = r.includeDates, c = $.setMonth(a, e);
                return {
                    isDisabled: null !== (t = (o || s || i || l) && $e(c, n.props)) && void 0 !== t && t,
                    labelDate: c
                };
            }, n.isMonthDisabled = function(e) {
                return n.isMonthDisabledForLabelDate(e).isDisabled;
            }, n.getMonthClassNames = function(e) {
                var r = n.props, a = r.day, o = r.startDate, s = r.endDate, i = r.selected, l = r.preSelection, c = r.monthClassName, p = c ? c($.setMonth(a, e)) : void 0;
                return t.clsx("react-datepicker__month-text", "react-datepicker__month-".concat(e), p, {
                    "react-datepicker__month-text--disabled": n.isMonthDisabled(e),
                    "react-datepicker__month-text--selected": i ? n.isSelectedMonth(a, e, i) : void 0,
                    "react-datepicker__month-text--keyboard-selected": !n.props.disabledKeyboardNavigation && l && n.isSelectedMonth(a, e, l),
                    "react-datepicker__month-text--in-selecting-range": n.isInSelectingRangeMonth(e),
                    "react-datepicker__month-text--in-range": o && s ? ze(o, s, e, a) : void 0,
                    "react-datepicker__month-text--range-start": n.isRangeStartMonth(e),
                    "react-datepicker__month-text--range-end": n.isRangeEndMonth(e),
                    "react-datepicker__month-text--selecting-range-start": n.isSelectingMonthRangeStart(e),
                    "react-datepicker__month-text--selecting-range-end": n.isSelectingMonthRangeEnd(e),
                    "react-datepicker__month-text--today": n.isCurrentMonth(a, e)
                });
            }, n.getTabIndex = function(e) {
                if (null == n.props.preSelection) return "-1";
                var t = C.getMonth(n.props.preSelection);
                return n.props.disabledKeyboardNavigation || e !== t ? "-1" : "0";
            }, n.getQuarterTabIndex = function(e) {
                if (null == n.props.preSelection) return "-1";
                var t = E.getQuarter(n.props.preSelection);
                return n.props.disabledKeyboardNavigation || e !== t ? "-1" : "0";
            }, n.getAriaLabel = function(e) {
                var t = n.props, r = t.chooseDayAriaLabelPrefix, a = void 0 === r ? "Choose" : r, o = t.disabledDayAriaLabelPrefix, s = void 0 === o ? "Not available" : o, i = t.day, l = t.locale, c = $.setMonth(i, e), p = n.isDisabled(c) || n.isExcluded(c) ? s : a;
                return "".concat(p, " ").concat(Ce(c, "MMMM yyyy", l));
            }, n.getQuarterClassNames = function(e) {
                var r = n.props, a = r.day, o = r.startDate, s = r.endDate, i = r.selected, l = r.minDate, c = r.maxDate, p = r.preSelection, d = r.disabledKeyboardNavigation;
                return t.clsx("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(e), {
                    "react-datepicker__quarter-text--disabled": (l || c) && Ge(z.setQuarter(a, e), n.props),
                    "react-datepicker__quarter-text--selected": i ? n.isSelectedQuarter(a, e, i) : void 0,
                    "react-datepicker__quarter-text--keyboard-selected": !d && p && n.isSelectedQuarter(a, e, p),
                    "react-datepicker__quarter-text--in-selecting-range": n.isInSelectingRangeQuarter(e),
                    "react-datepicker__quarter-text--in-range": o && s ? et(o, s, e, a) : void 0,
                    "react-datepicker__quarter-text--range-start": n.isRangeStartQuarter(e),
                    "react-datepicker__quarter-text--range-end": n.isRangeEndQuarter(e)
                });
            }, n.getMonthContent = function(e) {
                var t = n.props, r = t.showFullMonthYearPicker, a = t.renderMonthContent, o = t.locale, s = t.day, i = Ve(e, o), l = Be(e, o);
                return a ? a(e, i, l, s) : r ? l : i;
            }, n.getQuarterContent = function(e) {
                var t, r = n.props, a = r.renderQuarterContent, o = function(e, t) {
                    return Ce(z.setQuarter(Me(), e), "QQQ", t);
                }(e, r.locale);
                return null !== (t = null == a ? void 0 : a(e, o)) && void 0 !== t ? t : o;
            }, n.renderMonths = function() {
                var e, t = n.props, r = t.showTwoColumnMonthYearPicker, a = t.showFourColumnMonthYearPicker, o = t.day, s = t.selected, i = null === (e = Yt[Pt(a, r)]) || void 0 === e ? void 0 : e.grid;
                return null == i ? void 0 : i.map(function(e, t) {
                    return ue.default.createElement("div", {
                        className: "react-datepicker__month-wrapper",
                        key: t
                    }, e.map(function(e, t) {
                        return ue.default.createElement("div", {
                            ref: n.MONTH_REFS[e],
                            key: t,
                            onClick: function(t) {
                                n.onMonthClick(t, e);
                            },
                            onKeyDown: function(t) {
                                Dt(t) && (t.preventDefault(), t.key = De.Enter), n.onMonthKeyDown(t, e);
                            },
                            onMouseEnter: n.props.usePointerEvent ? void 0 : function() {
                                return n.onMonthMouseEnter(e);
                            },
                            onPointerEnter: n.props.usePointerEvent ? function() {
                                return n.onMonthMouseEnter(e);
                            } : void 0,
                            tabIndex: Number(n.getTabIndex(e)),
                            className: n.getMonthClassNames(e),
                            "aria-disabled": n.isMonthDisabled(e),
                            role: "option",
                            "aria-label": n.getAriaLabel(e),
                            "aria-current": n.isCurrentMonth(o, e) ? "date" : void 0,
                            "aria-selected": s ? n.isSelectedMonth(o, e, s) : void 0
                        }, n.getMonthContent(e));
                    }));
                });
            }, n.renderQuarters = function() {
                var e = n.props, t = e.day, r = e.selected;
                return ue.default.createElement("div", {
                    className: "react-datepicker__quarter-wrapper"
                }, [
                    1,
                    2,
                    3,
                    4
                ].map(function(e, a) {
                    return ue.default.createElement("div", {
                        key: a,
                        ref: n.QUARTER_REFS[a],
                        role: "option",
                        onClick: function(t) {
                            n.onQuarterClick(t, e);
                        },
                        onKeyDown: function(t) {
                            n.onQuarterKeyDown(t, e);
                        },
                        onMouseEnter: n.props.usePointerEvent ? void 0 : function() {
                            return n.onQuarterMouseEnter(e);
                        },
                        onPointerEnter: n.props.usePointerEvent ? function() {
                            return n.onQuarterMouseEnter(e);
                        } : void 0,
                        className: n.getQuarterClassNames(e),
                        "aria-selected": r ? n.isSelectedQuarter(t, e, r) : void 0,
                        tabIndex: Number(n.getQuarterTabIndex(e)),
                        "aria-current": n.isCurrentQuarter(t, e) ? "date" : void 0
                    }, n.getQuarterContent(e));
                }));
            }, n.getClassNames = function() {
                var e = n.props, r = e.selectingDate, a = e.selectsStart, o = e.selectsEnd, s = e.showMonthYearPicker, i = e.showQuarterYearPicker, l = e.showWeekPicker;
                return t.clsx("react-datepicker__month", {
                    "react-datepicker__month--selecting-range": r && (a || o)
                }, {
                    "react-datepicker__monthPicker": s
                }, {
                    "react-datepicker__quarterPicker": i
                }, {
                    "react-datepicker__weekPicker": l
                });
            }, n;
        }
        return ve(n, e), n.prototype.render = function() {
            var e = this.props, t = e.showMonthYearPicker, r = e.showQuarterYearPicker, n = e.day, a = e.ariaLabelPrefix, o = void 0 === a ? "Month " : a, s = o ? o.trim() + " " : "";
            return ue.default.createElement("div", {
                className: this.getClassNames(),
                onMouseLeave: this.props.usePointerEvent ? void 0 : this.handleMouseLeave,
                onPointerLeave: this.props.usePointerEvent ? this.handleMouseLeave : void 0,
                "aria-label": "".concat(s).concat(Ce(n, "MMMM, yyyy", this.props.locale)),
                role: "listbox"
            }, t ? this.renderMonths() : r ? this.renderQuarters() : this.renderWeeks());
        }, n;
    }(r.Component), Nt = function(e) {
        function t() {
            var t = null !== e && e.apply(this, arguments) || this;
            return t.isSelectedMonth = function(e) {
                return t.props.month === e;
            }, t.renderOptions = function() {
                return t.props.monthNames.map(function(e, r) {
                    return ue.default.createElement("div", {
                        className: t.isSelectedMonth(r) ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option",
                        key: e,
                        onClick: t.onChange.bind(t, r),
                        "aria-selected": t.isSelectedMonth(r) ? "true" : void 0
                    }, t.isSelectedMonth(r) ? ue.default.createElement("span", {
                        className: "react-datepicker__month-option--selected"
                    }, "\u2713") : "", e);
                });
            }, t.onChange = function(e) {
                return t.props.onChange(e);
            }, t.handleClickOutside = function() {
                return t.props.onCancel();
            }, t;
        }
        return ve(t, e), t.prototype.render = function() {
            return ue.default.createElement("div", {
                className: "react-datepicker__month-dropdown"
            }, this.renderOptions());
        }, t;
    }(r.Component), Ot = fe.default(Nt), It = function(e) {
        function t() {
            var t = null !== e && e.apply(this, arguments) || this;
            return t.state = {
                dropdownVisible: !1
            }, t.renderSelectOptions = function(e) {
                return e.map(function(e, t) {
                    return ue.default.createElement("option", {
                        key: e,
                        value: t
                    }, e);
                });
            }, t.renderSelectMode = function(e) {
                return ue.default.createElement("select", {
                    value: t.props.month,
                    className: "react-datepicker__month-select",
                    onChange: function(e) {
                        return t.onChange(parseInt(e.target.value));
                    }
                }, t.renderSelectOptions(e));
            }, t.renderReadView = function(e, r) {
                return ue.default.createElement("div", {
                    key: "read",
                    style: {
                        visibility: e ? "visible" : "hidden"
                    },
                    className: "react-datepicker__month-read-view",
                    onClick: t.toggleDropdown
                }, ue.default.createElement("span", {
                    className: "react-datepicker__month-read-view--down-arrow"
                }), ue.default.createElement("span", {
                    className: "react-datepicker__month-read-view--selected-month"
                }, r[t.props.month]));
            }, t.renderDropdown = function(e) {
                return ue.default.createElement(Ot, ge({
                    key: "dropdown"
                }, t.props, {
                    monthNames: e,
                    onChange: t.onChange,
                    onCancel: t.toggleDropdown
                }));
            }, t.renderScrollMode = function(e) {
                var r = t.state.dropdownVisible, n = [
                    t.renderReadView(!r, e)
                ];
                return r && n.unshift(t.renderDropdown(e)), n;
            }, t.onChange = function(e) {
                t.toggleDropdown(), e !== t.props.month && t.props.onChange(e);
            }, t.toggleDropdown = function() {
                return t.setState({
                    dropdownVisible: !t.state.dropdownVisible
                });
            }, t;
        }
        return ve(t, e), t.prototype.render = function() {
            var e, t = this, r = [
                0,
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ].map(this.props.useShortMonthInDropdown ? function(e) {
                return Ve(e, t.props.locale);
            } : function(e) {
                return Be(e, t.props.locale);
            });
            switch(this.props.dropdownMode){
                case "scroll":
                    e = this.renderScrollMode(r);
                    break;
                case "select":
                    e = this.renderSelectMode(r);
            }
            return ue.default.createElement("div", {
                className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)
            }, e);
        }, t;
    }(r.Component);
    function Tt(e, t) {
        for(var r = [], n = Ne(e), a = Ne(t); !N.isAfter(n, a);)r.push(Me(n)), n = i.addMonths(n, 1);
        return r;
    }
    var Rt = function(e) {
        function r(t) {
            var r = e.call(this, t) || this;
            return r.renderOptions = function() {
                return r.state.monthYearsList.map(function(e) {
                    var t = P.getTime(e), n = Le(r.props.date, e) && Ae(r.props.date, e);
                    return ue.default.createElement("div", {
                        className: n ? "react-datepicker__month-year-option--selected_month-year" : "react-datepicker__month-year-option",
                        key: t,
                        onClick: r.onChange.bind(r, t),
                        "aria-selected": n ? "true" : void 0
                    }, n ? ue.default.createElement("span", {
                        className: "react-datepicker__month-year-option--selected"
                    }, "\u2713") : "", Ce(e, r.props.dateFormat, r.props.locale));
                });
            }, r.onChange = function(e) {
                return r.props.onChange(e);
            }, r.handleClickOutside = function() {
                r.props.onCancel();
            }, r.state = {
                monthYearsList: Tt(r.props.minDate, r.props.maxDate)
            }, r;
        }
        return ve(r, e), r.prototype.render = function() {
            var e = t.clsx({
                "react-datepicker__month-year-dropdown": !0,
                "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
            });
            return ue.default.createElement("div", {
                className: e
            }, this.renderOptions());
        }, r;
    }(r.Component), Lt = fe.default(Rt), At = function(e) {
        function t() {
            var t = null !== e && e.apply(this, arguments) || this;
            return t.state = {
                dropdownVisible: !1
            }, t.renderSelectOptions = function() {
                for(var e = Ne(t.props.minDate), r = Ne(t.props.maxDate), n = []; !N.isAfter(e, r);){
                    var a = P.getTime(e);
                    n.push(ue.default.createElement("option", {
                        key: a,
                        value: a
                    }, Ce(e, t.props.dateFormat, t.props.locale))), e = i.addMonths(e, 1);
                }
                return n;
            }, t.onSelectChange = function(e) {
                t.onChange(parseInt(e.target.value));
            }, t.renderSelectMode = function() {
                return ue.default.createElement("select", {
                    value: P.getTime(Ne(t.props.date)),
                    className: "react-datepicker__month-year-select",
                    onChange: t.onSelectChange
                }, t.renderSelectOptions());
            }, t.renderReadView = function(e) {
                var r = Ce(t.props.date, t.props.dateFormat, t.props.locale);
                return ue.default.createElement("div", {
                    key: "read",
                    style: {
                        visibility: e ? "visible" : "hidden"
                    },
                    className: "react-datepicker__month-year-read-view",
                    onClick: t.toggleDropdown
                }, ue.default.createElement("span", {
                    className: "react-datepicker__month-year-read-view--down-arrow"
                }), ue.default.createElement("span", {
                    className: "react-datepicker__month-year-read-view--selected-month-year"
                }, r));
            }, t.renderDropdown = function() {
                return ue.default.createElement(Lt, ge({
                    key: "dropdown"
                }, t.props, {
                    onChange: t.onChange,
                    onCancel: t.toggleDropdown
                }));
            }, t.renderScrollMode = function() {
                var e = t.state.dropdownVisible, r = [
                    t.renderReadView(!e)
                ];
                return e && r.unshift(t.renderDropdown()), r;
            }, t.onChange = function(e) {
                t.toggleDropdown();
                var r = Me(e);
                Le(t.props.date, r) && Ae(t.props.date, r) || t.props.onChange(r);
            }, t.toggleDropdown = function() {
                return t.setState({
                    dropdownVisible: !t.state.dropdownVisible
                });
            }, t;
        }
        return ve(t, e), t.prototype.render = function() {
            var e;
            switch(this.props.dropdownMode){
                case "scroll":
                    e = this.renderScrollMode();
                    break;
                case "select":
                    e = this.renderSelectMode();
            }
            return ue.default.createElement("div", {
                className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)
            }, e);
        }, t;
    }(r.Component), Ft = function(e) {
        function t() {
            var r = null !== e && e.apply(this, arguments) || this;
            return r.state = {
                height: null
            }, r.scrollToTheSelectedTime = function() {
                requestAnimationFrame(function() {
                    var e, n, a;
                    r.list && (r.list.scrollTop = null !== (a = r.centerLi && t.calcCenterPosition(r.props.monthRef ? r.props.monthRef.clientHeight - (null !== (n = null === (e = r.header) || void 0 === e ? void 0 : e.clientHeight) && void 0 !== n ? n : 0) : r.list.clientHeight, r.centerLi)) && void 0 !== a ? a : 0);
                });
            }, r.handleClick = function(e) {
                var t, n;
                (r.props.minTime || r.props.maxTime) && at(e, r.props) || (r.props.excludeTimes || r.props.includeTimes || r.props.filterTime) && nt(e, r.props) || null === (n = (t = r.props).onChange) || void 0 === n || n.call(t, e);
            }, r.isSelectedTime = function(e) {
                var t, n;
                return r.props.selected && (t = r.props.selected, n = e, vt(t).getTime() === vt(n).getTime());
            }, r.isDisabledTime = function(e) {
                return (r.props.minTime || r.props.maxTime) && at(e, r.props) || (r.props.excludeTimes || r.props.includeTimes || r.props.filterTime) && nt(e, r.props);
            }, r.liClasses = function(e) {
                var n, a = [
                    "react-datepicker__time-list-item",
                    r.props.timeClassName ? r.props.timeClassName(e) : void 0
                ];
                return r.isSelectedTime(e) && a.push("react-datepicker__time-list-item--selected"), r.isDisabledTime(e) && a.push("react-datepicker__time-list-item--disabled"), r.props.injectTimes && (3600 * b.getHours(e) + 60 * _.getMinutes(e) + Y.getSeconds(e)) % (60 * (null !== (n = r.props.intervals) && void 0 !== n ? n : t.defaultProps.intervals)) != 0 && a.push("react-datepicker__time-list-item--injected"), a.join(" ");
            }, r.handleOnKeyDown = function(e, t) {
                var n, a;
                e.key === De.Space && (e.preventDefault(), e.key = De.Enter), (e.key === De.ArrowUp || e.key === De.ArrowLeft) && e.target instanceof HTMLElement && e.target.previousSibling && (e.preventDefault(), e.target.previousSibling instanceof HTMLElement && e.target.previousSibling.focus()), (e.key === De.ArrowDown || e.key === De.ArrowRight) && e.target instanceof HTMLElement && e.target.nextSibling && (e.preventDefault(), e.target.nextSibling instanceof HTMLElement && e.target.nextSibling.focus()), e.key === De.Enter && r.handleClick(t), null === (a = (n = r.props).handleOnKeyDown) || void 0 === a || a.call(n, e);
            }, r.renderTimes = function() {
                for(var e, n = [], a = r.props.format ? r.props.format : "p", o = null !== (e = r.props.intervals) && void 0 !== e ? e : t.defaultProps.intervals, i = r.props.selected || r.props.openToDate || Me(), l = Pe(i), c = r.props.injectTimes && r.props.injectTimes.sort(function(e, t) {
                    return e.getTime() - t.getTime();
                }), p = 60 * function(e) {
                    var t = new Date(e.getFullYear(), e.getMonth(), e.getDate()), r = new Date(e.getFullYear(), e.getMonth(), e.getDate(), 24);
                    return Math.round((+r - +t) / 36e5);
                }(i), d = p / o, u = 0; u < d; u++){
                    var f = s.addMinutes(l, u * o);
                    if (n.push(f), c) {
                        var h = ft(l, f, u, o, c);
                        n = n.concat(h);
                    }
                }
                var m = n.reduce(function(e, t) {
                    return t.getTime() <= i.getTime() ? t : e;
                }, n[0]);
                return n.map(function(e) {
                    return ue.default.createElement("li", {
                        key: e.valueOf(),
                        onClick: r.handleClick.bind(r, e),
                        className: r.liClasses(e),
                        ref: function(t) {
                            e === m && (r.centerLi = t);
                        },
                        onKeyDown: function(t) {
                            r.handleOnKeyDown(t, e);
                        },
                        tabIndex: e === m ? 0 : -1,
                        role: "option",
                        "aria-selected": r.isSelectedTime(e) ? "true" : void 0,
                        "aria-disabled": r.isDisabledTime(e) ? "true" : void 0
                    }, Ce(e, a, r.props.locale));
                });
            }, r;
        }
        return ve(t, e), Object.defineProperty(t, "defaultProps", {
            get: function() {
                return {
                    intervals: 30,
                    todayButton: null,
                    timeCaption: "Time"
                };
            },
            enumerable: !1,
            configurable: !0
        }), t.prototype.componentDidMount = function() {
            this.scrollToTheSelectedTime(), this.props.monthRef && this.header && this.setState({
                height: this.props.monthRef.clientHeight - this.header.clientHeight
            });
        }, t.prototype.render = function() {
            var e, r = this, n = this.state.height;
            return ue.default.createElement("div", {
                className: "react-datepicker__time-container ".concat((null !== (e = this.props.todayButton) && void 0 !== e ? e : t.defaultProps.todayButton) ? "react-datepicker__time-container--with-today-button" : "")
            }, ue.default.createElement("div", {
                className: "react-datepicker__header react-datepicker__header--time ".concat(this.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""),
                ref: function(e) {
                    r.header = e;
                }
            }, ue.default.createElement("div", {
                className: "react-datepicker-time__header"
            }, this.props.timeCaption)), ue.default.createElement("div", {
                className: "react-datepicker__time"
            }, ue.default.createElement("div", {
                className: "react-datepicker__time-box"
            }, ue.default.createElement("ul", {
                className: "react-datepicker__time-list",
                ref: function(e) {
                    r.list = e;
                },
                style: n ? {
                    height: n
                } : {},
                role: "listbox",
                "aria-label": this.props.timeCaption
            }, this.renderTimes()))));
        }, t.calcCenterPosition = function(e, t) {
            return t.offsetTop - (e / 2 - t.clientHeight / 2);
        }, t;
    }(r.Component), Ht = function(e) {
        function n(n) {
            var a = e.call(this, n) || this;
            return a.YEAR_REFS = ye([], Array(a.props.yearItemNumber), !0).map(function() {
                return r.createRef();
            }), a.isDisabled = function(e) {
                return je(e, {
                    minDate: a.props.minDate,
                    maxDate: a.props.maxDate,
                    excludeDates: a.props.excludeDates,
                    includeDates: a.props.includeDates,
                    filterDate: a.props.filterDate
                });
            }, a.isExcluded = function(e) {
                return Ue(e, {
                    excludeDates: a.props.excludeDates
                });
            }, a.selectingDate = function() {
                var e;
                return null !== (e = a.props.selectingDate) && void 0 !== e ? e : a.props.preSelection;
            }, a.updateFocusOnPaginate = function(e) {
                window.requestAnimationFrame(function() {
                    var t, r;
                    null === (r = null === (t = a.YEAR_REFS[e]) || void 0 === t ? void 0 : t.current) || void 0 === r || r.focus();
                });
            }, a.handleYearClick = function(e, t) {
                a.props.onDayClick && a.props.onDayClick(e, t);
            }, a.handleYearNavigation = function(e, t) {
                var r, n, o, s, i = a.props, l = i.date, c = i.yearItemNumber;
                if (void 0 !== l && void 0 !== c) {
                    var p = mt(l, c).startPeriod;
                    a.isDisabled(t) || a.isExcluded(t) || (null === (n = (r = a.props).setPreSelection) || void 0 === n || n.call(r, t), e - p < 0 ? a.updateFocusOnPaginate(c - (p - e)) : e - p >= c ? a.updateFocusOnPaginate(Math.abs(c - (e - p))) : null === (s = null === (o = a.YEAR_REFS[e - p]) || void 0 === o ? void 0 : o.current) || void 0 === s || s.focus());
                }
            }, a.isSameDay = function(e, t) {
                return He(e, t);
            }, a.isCurrentYear = function(e) {
                return e === x.getYear(Me());
            }, a.isRangeStart = function(e) {
                return a.props.startDate && a.props.endDate && Le(G.setYear(Me(), e), a.props.startDate);
            }, a.isRangeEnd = function(e) {
                return a.props.startDate && a.props.endDate && Le(G.setYear(Me(), e), a.props.endDate);
            }, a.isInRange = function(e) {
                return Je(e, a.props.startDate, a.props.endDate);
            }, a.isInSelectingRange = function(e) {
                var t = a.props, r = t.selectsStart, n = t.selectsEnd, o = t.selectsRange, s = t.startDate, i = t.endDate;
                return !(!(r || n || o) || !a.selectingDate()) && (r && i ? Je(e, a.selectingDate(), i) : (n && s || !(!o || !s || i)) && Je(e, s, a.selectingDate()));
            }, a.isSelectingRangeStart = function(e) {
                var t;
                if (!a.isInSelectingRange(e)) return !1;
                var r = a.props, n = r.startDate, o = r.selectsStart, s = G.setYear(Me(), e);
                return Le(s, o ? null !== (t = a.selectingDate()) && void 0 !== t ? t : null : null != n ? n : null);
            }, a.isSelectingRangeEnd = function(e) {
                var t;
                if (!a.isInSelectingRange(e)) return !1;
                var r = a.props, n = r.endDate, o = r.selectsEnd, s = r.selectsRange, i = G.setYear(Me(), e);
                return Le(i, o || s ? null !== (t = a.selectingDate()) && void 0 !== t ? t : null : null != n ? n : null);
            }, a.isKeyboardSelected = function(e) {
                if (void 0 !== a.props.date && null != a.props.selected && null != a.props.preSelection) {
                    var t = Oe(G.setYear(a.props.date, e));
                    return !a.props.disabledKeyboardNavigation && !a.props.inline && !He(t, Oe(a.props.selected)) && He(t, Oe(a.props.preSelection));
                }
            }, a.onYearClick = function(e, t) {
                var r = a.props.date;
                void 0 !== r && a.handleYearClick(Oe(G.setYear(r, t)), e);
            }, a.onYearKeyDown = function(e, t) {
                var r, n, o = e.key, s = a.props, i = s.date, l = s.yearItemNumber, c = s.handleOnKeyDown;
                if (o !== De.Tab && e.preventDefault(), !a.props.disabledKeyboardNavigation) switch(o){
                    case De.Enter:
                        if (null == a.props.selected) break;
                        a.onYearClick(e, t), null === (n = (r = a.props).setPreSelection) || void 0 === n || n.call(r, a.props.selected);
                        break;
                    case De.ArrowRight:
                        if (null == a.props.preSelection) break;
                        a.handleYearNavigation(t + 1, d.addYears(a.props.preSelection, 1));
                        break;
                    case De.ArrowLeft:
                        if (null == a.props.preSelection) break;
                        a.handleYearNavigation(t - 1, ie.subYears(a.props.preSelection, 1));
                        break;
                    case De.ArrowUp:
                        if (void 0 === i || void 0 === l || null == a.props.preSelection) break;
                        var p = mt(i, l).startPeriod;
                        if ((h = t - (f = 3)) < p) {
                            var u = l % f;
                            t >= p && t < p + u ? f = u : f += u, h = t - f;
                        }
                        a.handleYearNavigation(h, ie.subYears(a.props.preSelection, f));
                        break;
                    case De.ArrowDown:
                        if (void 0 === i || void 0 === l || null == a.props.preSelection) break;
                        var f, h, m = mt(i, l).endPeriod;
                        if ((h = t + (f = 3)) > m) {
                            u = l % f;
                            t <= m && t > m - u ? f = u : f += u, h = t + f;
                        }
                        a.handleYearNavigation(h, d.addYears(a.props.preSelection, f));
                }
                c && c(e);
            }, a.getYearClassNames = function(e) {
                var r = a.props, n = r.date, o = r.minDate, s = r.maxDate, i = r.selected, l = r.excludeDates, c = r.includeDates, p = r.filterDate, d = r.yearClassName;
                return t.clsx("react-datepicker__year-text", "react-datepicker__year-".concat(e), n ? null == d ? void 0 : d(G.setYear(n, e)) : void 0, {
                    "react-datepicker__year-text--selected": i ? e === x.getYear(i) : void 0,
                    "react-datepicker__year-text--disabled": (o || s || l || c || p) && Ze(e, a.props),
                    "react-datepicker__year-text--keyboard-selected": a.isKeyboardSelected(e),
                    "react-datepicker__year-text--range-start": a.isRangeStart(e),
                    "react-datepicker__year-text--range-end": a.isRangeEnd(e),
                    "react-datepicker__year-text--in-range": a.isInRange(e),
                    "react-datepicker__year-text--in-selecting-range": a.isInSelectingRange(e),
                    "react-datepicker__year-text--selecting-range-start": a.isSelectingRangeStart(e),
                    "react-datepicker__year-text--selecting-range-end": a.isSelectingRangeEnd(e),
                    "react-datepicker__year-text--today": a.isCurrentYear(e)
                });
            }, a.getYearTabIndex = function(e) {
                return a.props.disabledKeyboardNavigation || null == a.props.preSelection ? "-1" : e === x.getYear(a.props.preSelection) ? "0" : "-1";
            }, a.getYearContainerClassNames = function() {
                var e = a.props, r = e.selectingDate, n = e.selectsStart, o = e.selectsEnd, s = e.selectsRange;
                return t.clsx("react-datepicker__year", {
                    "react-datepicker__year--selecting-range": r && (n || o || s)
                });
            }, a.getYearContent = function(e) {
                return a.props.renderYearContent ? a.props.renderYearContent(e) : e;
            }, a;
        }
        return ve(n, e), n.prototype.render = function() {
            var e = this, t = [], r = this.props, n = r.date, a = r.yearItemNumber, o = r.onYearMouseEnter, s = r.onYearMouseLeave;
            if (void 0 === n) return null;
            for(var i = mt(n, a), l = i.startPeriod, c = i.endPeriod, p = function(r) {
                t.push(ue.default.createElement("div", {
                    ref: d.YEAR_REFS[r - l],
                    onClick: function(t) {
                        e.onYearClick(t, r);
                    },
                    onKeyDown: function(t) {
                        Dt(t) && (t.preventDefault(), t.key = De.Enter), e.onYearKeyDown(t, r);
                    },
                    tabIndex: Number(d.getYearTabIndex(r)),
                    className: d.getYearClassNames(r),
                    onMouseEnter: d.props.usePointerEvent ? void 0 : function(e) {
                        return o(e, r);
                    },
                    onPointerEnter: d.props.usePointerEvent ? function(e) {
                        return o(e, r);
                    } : void 0,
                    onMouseLeave: d.props.usePointerEvent ? void 0 : function(e) {
                        return s(e, r);
                    },
                    onPointerLeave: d.props.usePointerEvent ? function(e) {
                        return s(e, r);
                    } : void 0,
                    key: r,
                    "aria-current": d.isCurrentYear(r) ? "date" : void 0
                }, d.getYearContent(r)));
            }, d = this, u = l; u <= c; u++)p(u);
            return ue.default.createElement("div", {
                className: this.getYearContainerClassNames()
            }, ue.default.createElement("div", {
                className: "react-datepicker__year-wrapper",
                onMouseLeave: this.props.usePointerEvent ? void 0 : this.props.clearSelectingDate,
                onPointerLeave: this.props.usePointerEvent ? this.props.clearSelectingDate : void 0
            }, t));
        }, n;
    }(r.Component);
    function Wt(e, t, r, n) {
        for(var a = [], o = 0; o < 2 * t + 1; o++){
            var s = e + t - o, i = !0;
            r && (i = x.getYear(r) <= s), n && i && (i = x.getYear(n) >= s), i && a.push(s);
        }
        return a;
    }
    var Qt = function(e) {
        function n(t) {
            var n = e.call(this, t) || this;
            n.renderOptions = function() {
                var e = n.props.year, t = n.state.yearsList.map(function(t) {
                    return ue.default.createElement("div", {
                        className: e === t ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option",
                        key: t,
                        onClick: n.onChange.bind(n, t),
                        "aria-selected": e === t ? "true" : void 0
                    }, e === t ? ue.default.createElement("span", {
                        className: "react-datepicker__year-option--selected"
                    }, "\u2713") : "", t);
                }), r = n.props.minDate ? x.getYear(n.props.minDate) : null, a = n.props.maxDate ? x.getYear(n.props.maxDate) : null;
                return a && n.state.yearsList.find(function(e) {
                    return e === a;
                }) || t.unshift(ue.default.createElement("div", {
                    className: "react-datepicker__year-option",
                    key: "upcoming",
                    onClick: n.incrementYears
                }, ue.default.createElement("a", {
                    className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"
                }))), r && n.state.yearsList.find(function(e) {
                    return e === r;
                }) || t.push(ue.default.createElement("div", {
                    className: "react-datepicker__year-option",
                    key: "previous",
                    onClick: n.decrementYears
                }, ue.default.createElement("a", {
                    className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"
                }))), t;
            }, n.onChange = function(e) {
                n.props.onChange(e);
            }, n.handleClickOutside = function() {
                n.props.onCancel();
            }, n.shiftYears = function(e) {
                var t = n.state.yearsList.map(function(t) {
                    return t + e;
                });
                n.setState({
                    yearsList: t
                });
            }, n.incrementYears = function() {
                return n.shiftYears(1);
            }, n.decrementYears = function() {
                return n.shiftYears(-1);
            };
            var a = t.yearDropdownItemNumber, o = t.scrollableYearDropdown, s = a || (o ? 10 : 5);
            return n.state = {
                yearsList: Wt(n.props.year, s, n.props.minDate, n.props.maxDate)
            }, n.dropdownRef = r.createRef(), n;
        }
        return ve(n, e), n.prototype.componentDidMount = function() {
            var e = this.dropdownRef.current;
            if (e) {
                var t = e.children ? Array.from(e.children) : null, r = t ? t.find(function(e) {
                    return e.ariaSelected;
                }) : null;
                e.scrollTop = r && r instanceof HTMLElement ? r.offsetTop + (r.clientHeight - e.clientHeight) / 2 : (e.scrollHeight - e.clientHeight) / 2;
            }
        }, n.prototype.render = function() {
            var e = t.clsx({
                "react-datepicker__year-dropdown": !0,
                "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
            });
            return ue.default.createElement("div", {
                className: e,
                ref: this.dropdownRef
            }, this.renderOptions());
        }, n;
    }(r.Component), qt = fe.default(Qt), Kt = function(e) {
        function t() {
            var t = null !== e && e.apply(this, arguments) || this;
            return t.state = {
                dropdownVisible: !1
            }, t.renderSelectOptions = function() {
                for(var e = t.props.minDate ? x.getYear(t.props.minDate) : 1900, r = t.props.maxDate ? x.getYear(t.props.maxDate) : 2100, n = [], a = e; a <= r; a++)n.push(ue.default.createElement("option", {
                    key: a,
                    value: a
                }, a));
                return n;
            }, t.onSelectChange = function(e) {
                t.onChange(parseInt(e.target.value));
            }, t.renderSelectMode = function() {
                return ue.default.createElement("select", {
                    value: t.props.year,
                    className: "react-datepicker__year-select",
                    onChange: t.onSelectChange
                }, t.renderSelectOptions());
            }, t.renderReadView = function(e) {
                return ue.default.createElement("div", {
                    key: "read",
                    style: {
                        visibility: e ? "visible" : "hidden"
                    },
                    className: "react-datepicker__year-read-view",
                    onClick: function(e) {
                        return t.toggleDropdown(e);
                    }
                }, ue.default.createElement("span", {
                    className: "react-datepicker__year-read-view--down-arrow"
                }), ue.default.createElement("span", {
                    className: "react-datepicker__year-read-view--selected-year"
                }, t.props.year));
            }, t.renderDropdown = function() {
                return ue.default.createElement(qt, ge({
                    key: "dropdown"
                }, t.props, {
                    onChange: t.onChange,
                    onCancel: t.toggleDropdown
                }));
            }, t.renderScrollMode = function() {
                var e = t.state.dropdownVisible, r = [
                    t.renderReadView(!e)
                ];
                return e && r.unshift(t.renderDropdown()), r;
            }, t.onChange = function(e) {
                t.toggleDropdown(), e !== t.props.year && t.props.onChange(e);
            }, t.toggleDropdown = function(e) {
                t.setState({
                    dropdownVisible: !t.state.dropdownVisible
                }, function() {
                    t.props.adjustDateOnChange && t.handleYearChange(t.props.date, e);
                });
            }, t.handleYearChange = function(e, r) {
                t.onSelect(e, r), t.setOpen();
            }, t.onSelect = function(e, r) {
                t.props.onSelect && t.props.onSelect(e, r);
            }, t.setOpen = function() {
                t.props.setOpen && t.props.setOpen(!0);
            }, t;
        }
        return ve(t, e), t.prototype.render = function() {
            var e;
            switch(this.props.dropdownMode){
                case "scroll":
                    e = this.renderScrollMode();
                    break;
                case "select":
                    e = this.renderSelectMode();
            }
            return ue.default.createElement("div", {
                className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)
            }, e);
        }, t;
    }(r.Component), Bt = [
        "react-datepicker__year-select",
        "react-datepicker__month-select",
        "react-datepicker__month-year-select"
    ], Vt = function(e) {
        function n(o) {
            var s = e.call(this, o) || this;
            return s.monthContainer = void 0, s.handleClickOutside = function(e) {
                s.props.onClickOutside(e);
            }, s.setClickOutsideRef = function() {
                return s.containerRef.current;
            }, s.handleDropdownFocus = function(e) {
                var t, r, n, a;
                n = e.target, a = (n.className || "").split(/\s+/), Bt.some(function(e) {
                    return a.indexOf(e) >= 0;
                }) && (null === (r = (t = s.props).onDropdownFocus) || void 0 === r || r.call(t, e));
            }, s.getDateInView = function() {
                var e = s.props, t = e.preSelection, r = e.selected, n = e.openToDate, a = ct(s.props), o = pt(s.props), i = Me(), l = n || r || t;
                return l || (a && O.isBefore(i, a) ? a : o && N.isAfter(i, o) ? o : i);
            }, s.increaseMonth = function() {
                s.setState(function(e) {
                    var t = e.date;
                    return {
                        date: i.addMonths(t, 1)
                    };
                }, function() {
                    return s.handleMonthChange(s.state.date);
                });
            }, s.decreaseMonth = function() {
                s.setState(function(e) {
                    var t = e.date;
                    return {
                        date: ae.subMonths(t, 1)
                    };
                }, function() {
                    return s.handleMonthChange(s.state.date);
                });
            }, s.handleDayClick = function(e, t, r) {
                s.props.onSelect(e, t, r), s.props.setPreSelection && s.props.setPreSelection(e);
            }, s.handleDayMouseEnter = function(e) {
                s.setState({
                    selectingDate: e
                }), s.props.onDayMouseEnter && s.props.onDayMouseEnter(e);
            }, s.handleMonthMouseLeave = function() {
                s.setState({
                    selectingDate: void 0
                }), s.props.onMonthMouseLeave && s.props.onMonthMouseLeave();
            }, s.handleYearMouseEnter = function(e, t) {
                s.setState({
                    selectingDate: G.setYear(Me(), t)
                }), s.props.onYearMouseEnter && s.props.onYearMouseEnter(e, t);
            }, s.handleYearMouseLeave = function(e, t) {
                s.props.onYearMouseLeave && s.props.onYearMouseLeave(e, t);
            }, s.handleYearChange = function(e) {
                s.props.onYearChange && (s.props.onYearChange(e), s.setState({
                    isRenderAriaLiveMessage: !0
                })), s.props.adjustDateOnChange && (s.props.onSelect && s.props.onSelect(e), s.props.setOpen && s.props.setOpen(!0)), s.props.setPreSelection && s.props.setPreSelection(e);
            }, s.handleMonthChange = function(e) {
                s.handleCustomMonthChange(e), s.props.adjustDateOnChange && (s.props.onSelect && s.props.onSelect(e), s.props.setOpen && s.props.setOpen(!0)), s.props.setPreSelection && s.props.setPreSelection(e);
            }, s.handleCustomMonthChange = function(e) {
                s.props.onMonthChange && (s.props.onMonthChange(e), s.setState({
                    isRenderAriaLiveMessage: !0
                }));
            }, s.handleMonthYearChange = function(e) {
                s.handleYearChange(e), s.handleMonthChange(e);
            }, s.changeYear = function(e) {
                s.setState(function(t) {
                    var r = t.date;
                    return {
                        date: G.setYear(r, Number(e))
                    };
                }, function() {
                    return s.handleYearChange(s.state.date);
                });
            }, s.changeMonth = function(e) {
                s.setState(function(t) {
                    var r = t.date;
                    return {
                        date: $.setMonth(r, Number(e))
                    };
                }, function() {
                    return s.handleMonthChange(s.state.date);
                });
            }, s.changeMonthYear = function(e) {
                s.setState(function(t) {
                    var r = t.date;
                    return {
                        date: G.setYear($.setMonth(r, C.getMonth(e)), x.getYear(e))
                    };
                }, function() {
                    return s.handleMonthYearChange(s.state.date);
                });
            }, s.header = function(e) {
                void 0 === e && (e = s.state.date);
                var r = xe(e, s.props.locale, s.props.calendarStartDay), n = [];
                return s.props.showWeekNumbers && n.push(ue.default.createElement("div", {
                    key: "W",
                    className: "react-datepicker__day-name"
                }, s.props.weekLabel || "#")), n.concat([
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6
                ].map(function(e) {
                    var n = a.addDays(r, e), o = s.formatWeekday(n, s.props.locale), i = s.props.weekDayClassName ? s.props.weekDayClassName(n) : void 0;
                    return ue.default.createElement("div", {
                        key: e,
                        "aria-label": Ce(n, "EEEE", s.props.locale),
                        className: t.clsx("react-datepicker__day-name", i)
                    }, o);
                }));
            }, s.formatWeekday = function(e, t) {
                return s.props.formatWeekDay ? function(e, t, r) {
                    return t(Ce(e, "EEEE", r));
                }(e, s.props.formatWeekDay, t) : s.props.useWeekdaysShort ? function(e, t) {
                    return Ce(e, "EEE", t);
                }(e, t) : function(e, t) {
                    return Ce(e, "EEEEEE", t);
                }(e, t);
            }, s.decreaseYear = function() {
                s.setState(function(e) {
                    var t, r = e.date;
                    return {
                        date: ie.subYears(r, s.props.showYearPicker ? null !== (t = s.props.yearItemNumber) && void 0 !== t ? t : n.defaultProps.yearItemNumber : 1)
                    };
                }, function() {
                    return s.handleYearChange(s.state.date);
                });
            }, s.clearSelectingDate = function() {
                s.setState({
                    selectingDate: void 0
                });
            }, s.renderPreviousButton = function() {
                var e;
                if (!s.props.renderCustomHeader) {
                    var t;
                    switch(!0){
                        case s.props.showMonthYearPicker:
                            t = it(s.state.date, s.props);
                            break;
                        case s.props.showYearPicker:
                            t = function(e, t) {
                                var r = void 0 === t ? {} : t, n = r.minDate, a = r.yearItemNumber, o = void 0 === a ? Se : a, s = mt(Oe(ie.subYears(e, o)), o).endPeriod, i = n && x.getYear(n);
                                return i && i > s || !1;
                            }(s.state.date, s.props);
                            break;
                        case s.props.showQuarterYearPicker:
                            t = function(e, t) {
                                var r = void 0 === t ? {} : t, n = r.minDate, a = r.includeDates, o = re.startOfYear(e), s = oe.subQuarters(o, 1);
                                return n && h.differenceInCalendarQuarters(n, s) > 0 || a && a.every(function(e) {
                                    return h.differenceInCalendarQuarters(e, s) > 0;
                                }) || !1;
                            }(s.state.date, s.props);
                            break;
                        default:
                            t = ot(s.state.date, s.props);
                    }
                    if (((null !== (e = s.props.forceShowMonthNavigation) && void 0 !== e ? e : n.defaultProps.forceShowMonthNavigation) || s.props.showDisabledMonthNavigation || !t) && !s.props.showTimeSelectOnly) {
                        var r = [
                            "react-datepicker__navigation",
                            "react-datepicker__navigation--previous"
                        ], a = s.decreaseMonth;
                        (s.props.showMonthYearPicker || s.props.showQuarterYearPicker || s.props.showYearPicker) && (a = s.decreaseYear), t && s.props.showDisabledMonthNavigation && (r.push("react-datepicker__navigation--previous--disabled"), a = void 0);
                        var o = s.props.showMonthYearPicker || s.props.showQuarterYearPicker || s.props.showYearPicker, i = s.props, l = i.previousMonthButtonLabel, c = void 0 === l ? n.defaultProps.previousMonthButtonLabel : l, p = i.previousYearButtonLabel, d = void 0 === p ? n.defaultProps.previousYearButtonLabel : p, u = s.props, f = u.previousMonthAriaLabel, m = void 0 === f ? "string" == typeof c ? c : "Previous Month" : f, v = u.previousYearAriaLabel, g = void 0 === v ? "string" == typeof d ? d : "Previous Year" : v;
                        return ue.default.createElement("button", {
                            type: "button",
                            className: r.join(" "),
                            onClick: a,
                            onKeyDown: s.props.handleOnKeyDown,
                            "aria-label": o ? g : m
                        }, ue.default.createElement("span", {
                            className: [
                                "react-datepicker__navigation-icon",
                                "react-datepicker__navigation-icon--previous"
                            ].join(" ")
                        }, o ? d : c));
                    }
                }
            }, s.increaseYear = function() {
                s.setState(function(e) {
                    var t, r = e.date;
                    return {
                        date: d.addYears(r, s.props.showYearPicker ? null !== (t = s.props.yearItemNumber) && void 0 !== t ? t : n.defaultProps.yearItemNumber : 1)
                    };
                }, function() {
                    return s.handleYearChange(s.state.date);
                });
            }, s.renderNextButton = function() {
                var e;
                if (!s.props.renderCustomHeader) {
                    var t;
                    switch(!0){
                        case s.props.showMonthYearPicker:
                            t = lt(s.state.date, s.props);
                            break;
                        case s.props.showYearPicker:
                            t = function(e, t) {
                                var r = void 0 === t ? {} : t, n = r.maxDate, a = r.yearItemNumber, o = void 0 === a ? Se : a, s = mt(d.addYears(e, o), o).startPeriod, i = n && x.getYear(n);
                                return i && i < s || !1;
                            }(s.state.date, s.props);
                            break;
                        case s.props.showQuarterYearPicker:
                            t = function(e, t) {
                                var r = void 0 === t ? {} : t, n = r.maxDate, a = r.includeDates, o = D.endOfYear(e), s = l.addQuarters(o, 1);
                                return n && h.differenceInCalendarQuarters(s, n) > 0 || a && a.every(function(e) {
                                    return h.differenceInCalendarQuarters(s, e) > 0;
                                }) || !1;
                            }(s.state.date, s.props);
                            break;
                        default:
                            t = st(s.state.date, s.props);
                    }
                    if (((null !== (e = s.props.forceShowMonthNavigation) && void 0 !== e ? e : n.defaultProps.forceShowMonthNavigation) || s.props.showDisabledMonthNavigation || !t) && !s.props.showTimeSelectOnly) {
                        var r = [
                            "react-datepicker__navigation",
                            "react-datepicker__navigation--next"
                        ];
                        s.props.showTimeSelect && r.push("react-datepicker__navigation--next--with-time"), s.props.todayButton && r.push("react-datepicker__navigation--next--with-today-button");
                        var a = s.increaseMonth;
                        (s.props.showMonthYearPicker || s.props.showQuarterYearPicker || s.props.showYearPicker) && (a = s.increaseYear), t && s.props.showDisabledMonthNavigation && (r.push("react-datepicker__navigation--next--disabled"), a = void 0);
                        var o = s.props.showMonthYearPicker || s.props.showQuarterYearPicker || s.props.showYearPicker, i = s.props, c = i.nextMonthButtonLabel, p = void 0 === c ? n.defaultProps.nextMonthButtonLabel : c, u = i.nextYearButtonLabel, f = void 0 === u ? n.defaultProps.nextYearButtonLabel : u, m = s.props, v = m.nextMonthAriaLabel, g = void 0 === v ? "string" == typeof p ? p : "Next Month" : v, y = m.nextYearAriaLabel, k = void 0 === y ? "string" == typeof f ? f : "Next Year" : y;
                        return ue.default.createElement("button", {
                            type: "button",
                            className: r.join(" "),
                            onClick: a,
                            onKeyDown: s.props.handleOnKeyDown,
                            "aria-label": o ? k : g
                        }, ue.default.createElement("span", {
                            className: [
                                "react-datepicker__navigation-icon",
                                "react-datepicker__navigation-icon--next"
                            ].join(" ")
                        }, o ? f : p));
                    }
                }
            }, s.renderCurrentMonth = function(e) {
                void 0 === e && (e = s.state.date);
                var t = [
                    "react-datepicker__current-month"
                ];
                return s.props.showYearDropdown && t.push("react-datepicker__current-month--hasYearDropdown"), s.props.showMonthDropdown && t.push("react-datepicker__current-month--hasMonthDropdown"), s.props.showMonthYearDropdown && t.push("react-datepicker__current-month--hasMonthYearDropdown"), ue.default.createElement("h2", {
                    className: t.join(" ")
                }, Ce(e, s.props.dateFormat, s.props.locale));
            }, s.renderYearDropdown = function(e) {
                if (void 0 === e && (e = !1), s.props.showYearDropdown && !e) return ue.default.createElement(Kt, ge({}, n.defaultProps, s.props, {
                    date: s.state.date,
                    onChange: s.changeYear,
                    year: x.getYear(s.state.date)
                }));
            }, s.renderMonthDropdown = function(e) {
                if (void 0 === e && (e = !1), s.props.showMonthDropdown && !e) return ue.default.createElement(It, ge({}, n.defaultProps, s.props, {
                    month: C.getMonth(s.state.date),
                    onChange: s.changeMonth
                }));
            }, s.renderMonthYearDropdown = function(e) {
                if (void 0 === e && (e = !1), s.props.showMonthYearDropdown && !e) return ue.default.createElement(At, ge({}, n.defaultProps, s.props, {
                    date: s.state.date,
                    onChange: s.changeMonthYear
                }));
            }, s.handleTodayButtonClick = function(e) {
                s.props.onSelect(Te(), e), s.props.setPreSelection && s.props.setPreSelection(Te());
            }, s.renderTodayButton = function() {
                if (s.props.todayButton && !s.props.showTimeSelectOnly) return ue.default.createElement("div", {
                    className: "react-datepicker__today-button",
                    onClick: s.handleTodayButtonClick
                }, s.props.todayButton);
            }, s.renderDefaultHeader = function(e) {
                var t = e.monthDate, r = e.i;
                return ue.default.createElement("div", {
                    className: "react-datepicker__header ".concat(s.props.showTimeSelect ? "react-datepicker__header--has-time-select" : "")
                }, s.renderCurrentMonth(t), ue.default.createElement("div", {
                    className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(s.props.dropdownMode),
                    onFocus: s.handleDropdownFocus
                }, s.renderMonthDropdown(0 !== r), s.renderMonthYearDropdown(0 !== r), s.renderYearDropdown(0 !== r)), ue.default.createElement("div", {
                    className: "react-datepicker__day-names"
                }, s.header(t)));
            }, s.renderCustomHeader = function(e) {
                var t, r, n = e.monthDate, a = e.i;
                if (s.props.showTimeSelect && !s.state.monthContainer || s.props.showTimeSelectOnly) return null;
                var o = ot(s.state.date, s.props), i = st(s.state.date, s.props), l = it(s.state.date, s.props), c = lt(s.state.date, s.props), p = !s.props.showMonthYearPicker && !s.props.showQuarterYearPicker && !s.props.showYearPicker;
                return ue.default.createElement("div", {
                    className: "react-datepicker__header react-datepicker__header--custom",
                    onFocus: s.props.onDropdownFocus
                }, null === (r = (t = s.props).renderCustomHeader) || void 0 === r ? void 0 : r.call(t, ge(ge({}, s.state), {
                    customHeaderCount: a,
                    monthDate: n,
                    changeMonth: s.changeMonth,
                    changeYear: s.changeYear,
                    decreaseMonth: s.decreaseMonth,
                    increaseMonth: s.increaseMonth,
                    decreaseYear: s.decreaseYear,
                    increaseYear: s.increaseYear,
                    prevMonthButtonDisabled: o,
                    nextMonthButtonDisabled: i,
                    prevYearButtonDisabled: l,
                    nextYearButtonDisabled: c
                })), p && ue.default.createElement("div", {
                    className: "react-datepicker__day-names"
                }, s.header(n)));
            }, s.renderYearHeader = function(e) {
                var t = e.monthDate, r = s.props, a = r.showYearPicker, o = r.yearItemNumber, i = mt(t, void 0 === o ? n.defaultProps.yearItemNumber : o), l = i.startPeriod, c = i.endPeriod;
                return ue.default.createElement("div", {
                    className: "react-datepicker__header react-datepicker-year-header"
                }, a ? "".concat(l, " - ").concat(c) : x.getYear(t));
            }, s.renderHeader = function(e) {
                var t = e.monthDate, r = e.i, n = {
                    monthDate: t,
                    i: void 0 === r ? 0 : r
                };
                switch(!0){
                    case void 0 !== s.props.renderCustomHeader:
                        return s.renderCustomHeader(n);
                    case s.props.showMonthYearPicker || s.props.showQuarterYearPicker || s.props.showYearPicker:
                        return s.renderYearHeader(n);
                    default:
                        return s.renderDefaultHeader(n);
                }
            }, s.renderMonths = function() {
                var e, t;
                if (!s.props.showTimeSelectOnly && !s.props.showYearPicker) {
                    for(var r = [], a = null !== (e = s.props.monthsShown) && void 0 !== e ? e : n.defaultProps.monthsShown, o = s.props.showPreviousMonths ? a - 1 : 0, l = s.props.showMonthYearPicker || s.props.showQuarterYearPicker ? d.addYears(s.state.date, o) : ae.subMonths(s.state.date, o), c = null !== (t = s.props.monthSelectedIn) && void 0 !== t ? t : o, p = 0; p < a; ++p){
                        var u = p - c + o, f = s.props.showMonthYearPicker || s.props.showQuarterYearPicker ? d.addYears(l, u) : i.addMonths(l, u), h = "month-".concat(p), m = p < a - 1, v = p > 0;
                        r.push(ue.default.createElement("div", {
                            key: h,
                            ref: function(e) {
                                s.monthContainer = null != e ? e : void 0;
                            },
                            className: "react-datepicker__month-container"
                        }, s.renderHeader({
                            monthDate: f,
                            i: p
                        }), ue.default.createElement(xt, ge({}, n.defaultProps, s.props, {
                            ariaLabelPrefix: s.props.monthAriaLabelPrefix,
                            day: f,
                            onDayClick: s.handleDayClick,
                            handleOnKeyDown: s.props.handleOnDayKeyDown,
                            handleOnMonthKeyDown: s.props.handleOnKeyDown,
                            onDayMouseEnter: s.handleDayMouseEnter,
                            onMouseLeave: s.handleMonthMouseLeave,
                            orderInDisplay: p,
                            selectingDate: s.state.selectingDate,
                            monthShowsDuplicateDaysEnd: m,
                            monthShowsDuplicateDaysStart: v
                        }))));
                    }
                    return r;
                }
            }, s.renderYears = function() {
                if (!s.props.showTimeSelectOnly) return s.props.showYearPicker ? ue.default.createElement("div", {
                    className: "react-datepicker__year--container"
                }, s.renderHeader({
                    monthDate: s.state.date
                }), ue.default.createElement(Ht, ge({}, n.defaultProps, s.props, {
                    selectingDate: s.state.selectingDate,
                    date: s.state.date,
                    onDayClick: s.handleDayClick,
                    clearSelectingDate: s.clearSelectingDate,
                    onYearMouseEnter: s.handleYearMouseEnter,
                    onYearMouseLeave: s.handleYearMouseLeave
                }))) : void 0;
            }, s.renderTimeSection = function() {
                if (s.props.showTimeSelect && (s.state.monthContainer || s.props.showTimeSelectOnly)) return ue.default.createElement(Ft, ge({}, n.defaultProps, s.props, {
                    onChange: s.props.onTimeChange,
                    format: s.props.timeFormat,
                    intervals: s.props.timeIntervals,
                    monthRef: s.state.monthContainer
                }));
            }, s.renderInputTimeSection = function() {
                var e = s.props.selected ? new Date(s.props.selected) : void 0, t = e && _e(e) && Boolean(s.props.selected) ? "".concat(ht(e.getHours()), ":").concat(ht(e.getMinutes())) : "";
                if (s.props.showTimeInput) return ue.default.createElement(wt, ge({}, n.defaultProps, s.props, {
                    date: e,
                    timeString: t,
                    onChange: s.props.onTimeChange
                }));
            }, s.renderAriaLiveRegion = function() {
                var e, t, r = mt(s.state.date, null !== (e = s.props.yearItemNumber) && void 0 !== e ? e : n.defaultProps.yearItemNumber), a = r.startPeriod, o = r.endPeriod;
                return t = s.props.showYearPicker ? "".concat(a, " - ").concat(o) : s.props.showMonthYearPicker || s.props.showQuarterYearPicker ? x.getYear(s.state.date) : "".concat(Be(C.getMonth(s.state.date), s.props.locale), " ").concat(x.getYear(s.state.date)), ue.default.createElement("span", {
                    role: "alert",
                    "aria-live": "polite",
                    className: "react-datepicker__aria-live"
                }, s.state.isRenderAriaLiveMessage && t);
            }, s.renderChildren = function() {
                if (s.props.children) return ue.default.createElement("div", {
                    className: "react-datepicker__children-container"
                }, s.props.children);
            }, s.containerRef = r.createRef(), s.state = {
                date: s.getDateInView(),
                selectingDate: void 0,
                monthContainer: void 0,
                isRenderAriaLiveMessage: !1
            }, s;
        }
        return ve(n, e), Object.defineProperty(n, "defaultProps", {
            get: function() {
                return {
                    monthsShown: 1,
                    forceShowMonthNavigation: !1,
                    timeCaption: "Time",
                    previousYearButtonLabel: "Previous Year",
                    nextYearButtonLabel: "Next Year",
                    previousMonthButtonLabel: "Previous Month",
                    nextMonthButtonLabel: "Next Month",
                    yearItemNumber: Se
                };
            },
            enumerable: !1,
            configurable: !0
        }), n.prototype.componentDidMount = function() {
            var e = this;
            this.props.showTimeSelect && (this.assignMonthContainer = void e.setState({
                monthContainer: e.monthContainer
            }));
        }, n.prototype.componentDidUpdate = function(e) {
            var t = this;
            if (!this.props.preSelection || He(this.props.preSelection, e.preSelection) && this.props.monthSelectedIn === e.monthSelectedIn) this.props.openToDate && !He(this.props.openToDate, e.openToDate) && this.setState({
                date: this.props.openToDate
            });
            else {
                var r = !Ae(this.state.date, this.props.preSelection);
                this.setState({
                    date: this.props.preSelection
                }, function() {
                    return r && t.handleCustomMonthChange(t.state.date);
                });
            }
        }, n.prototype.render = function() {
            var e = this.props.container || ke;
            return ue.default.createElement("div", {
                style: {
                    display: "contents"
                },
                ref: this.containerRef
            }, ue.default.createElement(e, {
                className: t.clsx("react-datepicker", this.props.className, {
                    "react-datepicker--time-only": this.props.showTimeSelectOnly
                }),
                showTime: this.props.showTimeSelect || this.props.showTimeInput,
                showTimeSelectOnly: this.props.showTimeSelectOnly
            }, this.renderAriaLiveRegion(), this.renderPreviousButton(), this.renderNextButton(), this.renderMonths(), this.renderYears(), this.renderTodayButton(), this.renderTimeSection(), this.renderInputTimeSection(), this.renderChildren()));
        }, n;
    }(r.Component), jt = function(e) {
        var t = e.icon, r = e.className, n = void 0 === r ? "" : r, a = e.onClick, o = "react-datepicker__calendar-icon";
        return "string" == typeof t ? ue.default.createElement("i", {
            className: "".concat(o, " ").concat(t, " ").concat(n),
            "aria-hidden": "true",
            onClick: a
        }) : ue.default.isValidElement(t) ? ue.default.cloneElement(t, {
            className: "".concat(t.props.className || "", " ").concat(o, " ").concat(n),
            onClick: function(e) {
                "function" == typeof t.props.onClick && t.props.onClick(e), "function" == typeof a && a(e);
            }
        }) : ue.default.createElement("svg", {
            className: "".concat(o, " ").concat(n),
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 448 512",
            onClick: a
        }, ue.default.createElement("path", {
            d: "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z"
        }));
    }, Ut = function(e) {
        function t(t) {
            var r = e.call(this, t) || this;
            return r.portalRoot = null, r.el = document.createElement("div"), r;
        }
        return ve(t, e), t.prototype.componentDidMount = function() {
            this.portalRoot = (this.props.portalHost || document).getElementById(this.props.portalId), this.portalRoot || (this.portalRoot = document.createElement("div"), this.portalRoot.setAttribute("id", this.props.portalId), (this.props.portalHost || document.body).appendChild(this.portalRoot)), this.portalRoot.appendChild(this.el);
        }, t.prototype.componentWillUnmount = function() {
            this.portalRoot && this.portalRoot.removeChild(this.el);
        }, t.prototype.render = function() {
            return he.default.createPortal(this.props.children, this.el);
        }, t;
    }(r.Component), $t = function(e) {
        return (e instanceof HTMLAnchorElement || !e.disabled) && -1 !== e.tabIndex;
    }, zt = function(e) {
        function t(t) {
            var n = e.call(this, t) || this;
            return n.getTabChildren = function() {
                var e;
                return Array.prototype.slice.call(null === (e = n.tabLoopRef.current) || void 0 === e ? void 0 : e.querySelectorAll("[tabindex], a, button, input, select, textarea"), 1, -1).filter($t);
            }, n.handleFocusStart = function() {
                var e = n.getTabChildren();
                e && e.length > 1 && e[e.length - 1].focus();
            }, n.handleFocusEnd = function() {
                var e = n.getTabChildren();
                e && e.length > 1 && e[0].focus();
            }, n.tabLoopRef = r.createRef(), n;
        }
        return ve(t, e), t.prototype.render = function() {
            var e;
            return (null !== (e = this.props.enableTabLoop) && void 0 !== e ? e : t.defaultProps.enableTabLoop) ? ue.default.createElement("div", {
                className: "react-datepicker__tab-loop",
                ref: this.tabLoopRef
            }, ue.default.createElement("div", {
                className: "react-datepicker__tab-loop__start",
                tabIndex: 0,
                onFocus: this.handleFocusStart
            }), this.props.children, ue.default.createElement("div", {
                className: "react-datepicker__tab-loop__end",
                tabIndex: 0,
                onFocus: this.handleFocusEnd
            })) : this.props.children;
        }, t.defaultProps = {
            enableTabLoop: !0
        }, t;
    }(r.Component);
    var Xt, Gt = function(e) {
        function n() {
            return null !== e && e.apply(this, arguments) || this;
        }
        return ve(n, e), Object.defineProperty(n, "defaultProps", {
            get: function() {
                return {
                    hidePopper: !0
                };
            },
            enumerable: !1,
            configurable: !0
        }), n.prototype.render = function() {
            var e = this.props, a = e.className, o = e.wrapperClassName, s = e.hidePopper, i = void 0 === s ? n.defaultProps.hidePopper : s, l = e.popperComponent, c = e.targetComponent, p = e.enableTabLoop, d = e.popperOnKeyDown, u = e.portalId, f = e.portalHost, h = e.popperProps, m = e.showArrow, v = void 0;
            if (!i) {
                var g = t.clsx("react-datepicker-popper", a);
                v = ue.default.createElement(zt, {
                    enableTabLoop: p
                }, ue.default.createElement("div", {
                    ref: h.refs.setFloating,
                    style: h.floatingStyles,
                    className: g,
                    "data-placement": h.placement,
                    onKeyDown: d
                }, l, m && ue.default.createElement(ce.FloatingArrow, {
                    ref: h.arrowRef,
                    context: h.context,
                    fill: "currentColor",
                    strokeWidth: 1,
                    height: 8,
                    width: 16,
                    style: {
                        transform: "translateY(-1px)"
                    },
                    className: "react-datepicker__triangle"
                })));
            }
            this.props.popperContainer && (v = r.createElement(this.props.popperContainer, {}, v)), u && !i && (v = ue.default.createElement(Ut, {
                portalId: u,
                portalHost: f
            }, v));
            var y = t.clsx("react-datepicker-wrapper", o);
            return ue.default.createElement(ue.default.Fragment, null, ue.default.createElement("div", {
                ref: h.refs.setReference,
                className: y
            }, c), v);
        }, n;
    }(r.Component), Jt = (Xt = Gt, function(e) {
        var t, n = "boolean" != typeof e.hidePopper || e.hidePopper, a = r.useRef(null), o = ce.useFloating(ge({
            open: !n,
            whileElementsMounted: ce.autoUpdate,
            placement: e.popperPlacement,
            middleware: ye([
                ce.flip({
                    padding: 15
                }),
                ce.offset(10),
                ce.arrow({
                    element: a
                })
            ], null !== (t = e.popperModifiers) && void 0 !== t ? t : [], !0)
        }, e.popperProps)), s = ge(ge({}, e), {
            hidePopper: n,
            popperProps: ge(ge({}, o), {
                arrowRef: a
            })
        });
        return ue.default.createElement(Xt, ge({}, s));
    }), Zt = "react-datepicker-ignore-onclickoutside", er = fe.default(Vt);
    var tr = "Date input not valid.", rr = function(e) {
        function n(o) {
            var s = e.call(this, o) || this;
            return s.calendar = null, s.input = null, s.getPreSelection = function() {
                return s.props.openToDate ? s.props.openToDate : s.props.selectsEnd && s.props.startDate ? s.props.startDate : s.props.selectsStart && s.props.endDate ? s.props.endDate : Me();
            }, s.modifyHolidays = function() {
                var e;
                return null === (e = s.props.holidays) || void 0 === e ? void 0 : e.reduce(function(e, t) {
                    var r = new Date(t.date);
                    return _e(r) ? ye(ye([], e, !0), [
                        ge(ge({}, t), {
                            date: r
                        })
                    ], !1) : e;
                }, []);
            }, s.calcInitialState = function() {
                var e, t = s.getPreSelection(), r = ct(s.props), n = pt(s.props), a = r && O.isBefore(t, Pe(r)) ? r : n && N.isAfter(t, Re(n)) ? n : t;
                return {
                    open: s.props.startOpen || !1,
                    preventFocus: !1,
                    inputValue: null,
                    preSelection: null !== (e = s.props.selectsRange ? s.props.startDate : s.props.selected) && void 0 !== e ? e : a,
                    highlightDates: dt(s.props.highlightDates),
                    focused: !1,
                    shouldFocusDayInline: !1,
                    isRenderAriaLiveMessage: !1,
                    wasHidden: !1
                };
            }, s.resetHiddenStatus = function() {
                s.setState(ge(ge({}, s.state), {
                    wasHidden: !1
                }));
            }, s.setHiddenStatus = function() {
                s.setState(ge(ge({}, s.state), {
                    wasHidden: !0
                }));
            }, s.setHiddenStateOnVisibilityHidden = function() {
                "hidden" === document.visibilityState && s.setHiddenStatus();
            }, s.clearPreventFocusTimeout = function() {
                s.preventFocusTimeout && clearTimeout(s.preventFocusTimeout);
            }, s.setFocus = function() {
                s.input && s.input.focus && s.input.focus({
                    preventScroll: !0
                });
            }, s.setBlur = function() {
                s.input && s.input.blur && s.input.blur(), s.cancelFocusInput();
            }, s.setOpen = function(e, t) {
                void 0 === t && (t = !1), s.setState({
                    open: e,
                    preSelection: e && s.state.open ? s.state.preSelection : s.calcInitialState().preSelection,
                    lastPreSelectChange: ar
                }, function() {
                    e || s.setState(function(e) {
                        return {
                            focused: !!t && e.focused
                        };
                    }, function() {
                        !t && s.setBlur(), s.setState({
                            inputValue: null
                        });
                    });
                });
            }, s.inputOk = function() {
                return I.isDate(s.state.preSelection);
            }, s.isCalendarOpen = function() {
                return void 0 === s.props.open ? s.state.open && !s.props.disabled && !s.props.readOnly : s.props.open;
            }, s.handleFocus = function(e) {
                var t, r, n = s.state.wasHidden, a = !n || s.state.open;
                n && s.resetHiddenStatus(), !s.state.preventFocus && a && (null === (r = (t = s.props).onFocus) || void 0 === r || r.call(t, e), s.props.preventOpenOnFocus || s.props.readOnly || s.setOpen(!0)), s.setState({
                    focused: !0
                });
            }, s.sendFocusBackToInput = function() {
                s.preventFocusTimeout && s.clearPreventFocusTimeout(), s.setState({
                    preventFocus: !0
                }, function() {
                    s.preventFocusTimeout = setTimeout(function() {
                        s.setFocus(), s.setState({
                            preventFocus: !1
                        });
                    });
                });
            }, s.cancelFocusInput = function() {
                clearTimeout(s.inputFocusTimeout), s.inputFocusTimeout = void 0;
            }, s.deferFocusInput = function() {
                s.cancelFocusInput(), s.inputFocusTimeout = setTimeout(function() {
                    return s.setFocus();
                }, 1);
            }, s.handleDropdownFocus = function() {
                s.cancelFocusInput();
            }, s.handleBlur = function(e) {
                var t, r;
                (!s.state.open || s.props.withPortal || s.props.showTimeInput) && (null === (r = (t = s.props).onBlur) || void 0 === r || r.call(t, e)), s.setState({
                    focused: !1
                });
            }, s.handleCalendarClickOutside = function(e) {
                var t, r;
                s.props.inline || s.setOpen(!1), null === (r = (t = s.props).onClickOutside) || void 0 === r || r.call(t, e), s.props.withPortal && e.preventDefault();
            }, s.handleChange = function() {
                for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
                var r = e[0];
                if (!s.props.onChangeRaw || (s.props.onChangeRaw.apply(s, e), r && "function" == typeof r.isDefaultPrevented && !r.isDefaultPrevented())) {
                    s.setState({
                        inputValue: (null == r ? void 0 : r.target) instanceof HTMLInputElement ? r.target.value : null,
                        lastPreSelectChange: nr
                    });
                    var a = s.props, o = a.dateFormat, i = void 0 === o ? n.defaultProps.dateFormat : o, l = a.strictParsing, c = void 0 === l ? n.defaultProps.strictParsing : l, p = function(e, t, r, n, a) {
                        var o, s = null, i = Ke(r) || Ke(qe()), l = !0;
                        if (Array.isArray(t)) return t.forEach(function(t) {
                            var o = K.parse(e, t, new Date, {
                                locale: i,
                                useAdditionalWeekYearTokens: !0,
                                useAdditionalDayOfYearTokens: !0
                            });
                            n && (l = _e(o, a) && e === Ce(o, t, r)), _e(o, a) && l && (s = o);
                        }), s;
                        if (s = K.parse(e, t, new Date, {
                            locale: i,
                            useAdditionalWeekYearTokens: !0,
                            useAdditionalDayOfYearTokens: !0
                        }), n) l = _e(s) && e === Ce(s, t, r);
                        else if (!_e(s)) {
                            var c = (null !== (o = t.match(be)) && void 0 !== o ? o : []).map(function(e) {
                                var t = e[0];
                                if ("p" === t || "P" === t) {
                                    var r = k.longFormatters[t];
                                    return i ? r(e, i.formatLong) : t;
                                }
                                return e;
                            }).join("");
                            e.length > 0 && (s = K.parse(e, c.slice(0, e.length), new Date, {
                                useAdditionalWeekYearTokens: !0,
                                useAdditionalDayOfYearTokens: !0
                            })), _e(s) || (s = new Date(e));
                        }
                        return _e(s) && l ? s : null;
                    }((null == r ? void 0 : r.target) instanceof HTMLInputElement ? r.target.value : "", i, s.props.locale, c, s.props.minDate);
                    s.props.showTimeSelectOnly && s.props.selected && p && !He(p, s.props.selected) && (p = V.set(s.props.selected, {
                        hours: b.getHours(p),
                        minutes: _.getMinutes(p),
                        seconds: Y.getSeconds(p)
                    })), !p && (null == r ? void 0 : r.target) instanceof HTMLInputElement && (null == r ? void 0 : r.target.value) || s.setSelected(p, r, !0);
                }
            }, s.handleSelect = function(e, t, r) {
                if (s.props.shouldCloseOnSelect && !s.props.showTimeSelect && s.sendFocusBackToInput(), s.props.onChangeRaw && s.props.onChangeRaw(t), s.setSelected(e, t, !1, r), s.props.showDateSelect && s.setState({
                    isRenderAriaLiveMessage: !0
                }), !s.props.shouldCloseOnSelect || s.props.showTimeSelect) s.setPreSelection(e);
                else if (!s.props.inline) {
                    s.props.selectsRange || s.setOpen(!1);
                    var n = s.props, a = n.startDate, o = n.endDate;
                    !a || o || !s.props.swapRange && yt(e, a) || s.setOpen(!1);
                }
            }, s.setSelected = function(e, t, r, n) {
                var a = e;
                if (s.props.showYearPicker) {
                    if (null !== a && Ze(x.getYear(a), s.props)) return;
                } else if (s.props.showMonthYearPicker) {
                    if (null !== a && $e(a, s.props)) return;
                } else if (null !== a && je(a, s.props)) return;
                var o = s.props, i = o.onChange, l = o.selectsRange, c = o.startDate, p = o.endDate, d = o.selectsMultiple, u = o.selectedDates, f = o.minTime, h = o.swapRange;
                if (!We(s.props.selected, a) || s.props.allowSameDay || l || d) {
                    if (null !== a && (!s.props.selected || r && (s.props.showTimeSelect || s.props.showTimeSelectOnly || s.props.showTimeInput) || (a = Ye(a, {
                        hour: b.getHours(s.props.selected),
                        minute: _.getMinutes(s.props.selected),
                        second: Y.getSeconds(s.props.selected)
                    })), r || !s.props.showTimeSelect && !s.props.showTimeSelectOnly || f && (a = Ye(a, {
                        hour: f.getHours(),
                        minute: f.getMinutes(),
                        second: f.getSeconds()
                    })), s.props.inline || s.setState({
                        preSelection: a
                    }), s.props.focusSelectedMonth || s.setState({
                        monthSelectedIn: n
                    })), l) {
                        var m = c && !p, v = c && p;
                        !c && !p ? i([
                            a,
                            null
                        ], t) : m && (null === a ? i([
                            null,
                            null
                        ], t) : yt(a, c) ? i(h ? [
                            a,
                            c
                        ] : [
                            a,
                            null
                        ], t) : i([
                            c,
                            a
                        ], t)), v && i([
                            a,
                            null
                        ], t);
                    } else if (d) {
                        if (null !== a) {
                            if (null == u ? void 0 : u.length) {
                                if (u.some(function(e) {
                                    return He(e, a);
                                })) i(u.filter(function(e) {
                                    return !He(e, a);
                                }), t);
                                else i(ye(ye([], u, !0), [
                                    a
                                ], !1), t);
                            } else i([
                                a
                            ], t);
                        }
                    } else i(a, t);
                }
                r || (s.props.onSelect(a, t), s.setState({
                    inputValue: null
                }));
            }, s.setPreSelection = function(e) {
                var t = I.isDate(s.props.minDate), r = I.isDate(s.props.maxDate), n = !0;
                if (e) {
                    var a = Pe(e);
                    if (t && r) n = Qe(e, s.props.minDate, s.props.maxDate);
                    else if (t) {
                        var o = Pe(s.props.minDate);
                        n = N.isAfter(e, o) || We(a, o);
                    } else if (r) {
                        var i = Re(s.props.maxDate);
                        n = O.isBefore(e, i) || We(a, i);
                    }
                }
                n && s.setState({
                    preSelection: e
                });
            }, s.toggleCalendar = function() {
                s.setOpen(!s.state.open);
            }, s.handleTimeChange = function(e) {
                if (!s.props.selectsRange && !s.props.selectsMultiple) {
                    var t = s.props.selected ? s.props.selected : s.getPreSelection(), r = s.props.selected ? e : Ye(t, {
                        hour: b.getHours(e),
                        minute: _.getMinutes(e)
                    });
                    s.setState({
                        preSelection: r
                    }), s.props.onChange(r), s.props.shouldCloseOnSelect && !s.props.showTimeInput && (s.sendFocusBackToInput(), s.setOpen(!1)), s.props.showTimeInput && s.setOpen(!0), (s.props.showTimeSelectOnly || s.props.showTimeSelect) && s.setState({
                        isRenderAriaLiveMessage: !0
                    }), s.setState({
                        inputValue: null
                    });
                }
            }, s.onInputClick = function() {
                var e, t;
                s.props.disabled || s.props.readOnly || s.setOpen(!0), null === (t = (e = s.props).onInputClick) || void 0 === t || t.call(e);
            }, s.onInputKeyDown = function(e) {
                var t, r, n, a, o;
                null === (r = (t = s.props).onKeyDown) || void 0 === r || r.call(t, e);
                var i = e.key;
                if (s.state.open || s.props.inline || s.props.preventOpenOnFocus) {
                    if (s.state.open) {
                        if (i === De.ArrowDown || i === De.ArrowUp) {
                            e.preventDefault();
                            var l = s.props.showTimeSelectOnly ? ".react-datepicker__time-list-item[tabindex='0']" : s.props.showWeekPicker && s.props.showWeekNumbers ? '.react-datepicker__week-number[tabindex="0"]' : s.props.showFullMonthYearPicker || s.props.showMonthYearPicker ? '.react-datepicker__month-text[tabindex="0"]' : '.react-datepicker__day[tabindex="0"]', c = (null === (n = s.calendar) || void 0 === n ? void 0 : n.componentNode) instanceof Element && s.calendar.componentNode.querySelector(l);
                            return void (c instanceof HTMLElement && c.focus({
                                preventScroll: !0
                            }));
                        }
                        var p = Me(s.state.preSelection);
                        i === De.Enter ? (e.preventDefault(), s.inputOk() && s.state.lastPreSelectChange === ar ? (s.handleSelect(p, e), !s.props.shouldCloseOnSelect && s.setPreSelection(p)) : s.setOpen(!1)) : i === De.Escape ? (e.preventDefault(), s.sendFocusBackToInput(), s.setOpen(!1)) : i === De.Tab && s.setOpen(!1), s.inputOk() || null === (o = (a = s.props).onInputError) || void 0 === o || o.call(a, {
                            code: 1,
                            msg: tr
                        });
                    }
                } else i !== De.ArrowDown && i !== De.ArrowUp && i !== De.Enter || s.onInputClick();
            }, s.onPortalKeyDown = function(e) {
                e.key === De.Escape && (e.preventDefault(), s.setState({
                    preventFocus: !0
                }, function() {
                    s.setOpen(!1), setTimeout(function() {
                        s.setFocus(), s.setState({
                            preventFocus: !1
                        });
                    });
                }));
            }, s.onDayKeyDown = function(e) {
                var t, r, n, o, l = s.props, c = l.minDate, u = l.maxDate, f = l.disabledKeyboardNavigation, h = l.showWeekPicker, m = l.shouldCloseOnSelect, v = l.locale, g = l.calendarStartDay, D = l.adjustDateOnChange, k = l.inline;
                if (null === (r = (t = s.props).onKeyDown) || void 0 === r || r.call(t, e), !f) {
                    var w = e.key, S = e.shiftKey, b = Me(s.state.preSelection), M = function(e, t) {
                        var r = t;
                        switch(e){
                            case De.ArrowRight:
                                r = h ? p.addWeeks(t, 1) : a.addDays(t, 1);
                                break;
                            case De.ArrowLeft:
                                r = h ? se.subWeeks(t, 1) : ne.subDays(t, 1);
                                break;
                            case De.ArrowUp:
                                r = se.subWeeks(t, 1);
                                break;
                            case De.ArrowDown:
                                r = p.addWeeks(t, 1);
                                break;
                            case De.PageUp:
                                r = S ? ie.subYears(t, 1) : ae.subMonths(t, 1);
                                break;
                            case De.PageDown:
                                r = S ? d.addYears(t, 1) : i.addMonths(t, 1);
                                break;
                            case De.Home:
                                r = xe(t, v, g);
                                break;
                            case De.End:
                                r = function(e) {
                                    return y.endOfWeek(e);
                                }(t);
                        }
                        return r;
                    };
                    if (w === De.Enter) return e.preventDefault(), s.handleSelect(b, e), void (!m && s.setPreSelection(b));
                    if (w === De.Escape) return e.preventDefault(), s.setOpen(!1), void (s.inputOk() || null === (o = (n = s.props).onInputError) || void 0 === o || o.call(n, {
                        code: 1,
                        msg: tr
                    }));
                    var _ = null;
                    switch(w){
                        case De.ArrowLeft:
                        case De.ArrowRight:
                        case De.ArrowUp:
                        case De.ArrowDown:
                        case De.PageUp:
                        case De.PageDown:
                        case De.Home:
                        case De.End:
                            _ = function(e, t) {
                                for(var r = e, n = !1, a = 0, o = M(e, t); !n;){
                                    if (a >= 40) {
                                        o = t;
                                        break;
                                    }
                                    c && o < c && (r = De.ArrowRight, o = je(c, s.props) ? M(r, o) : c), u && o > u && (r = De.ArrowLeft, o = je(u, s.props) ? M(r, o) : u), je(o, s.props) ? (r !== De.PageUp && r !== De.Home || (r = De.ArrowRight), r !== De.PageDown && r !== De.End || (r = De.ArrowLeft), o = M(r, o)) : n = !0, a++;
                                }
                                return o;
                            }(w, b);
                    }
                    if (_) {
                        if (e.preventDefault(), s.setState({
                            lastPreSelectChange: ar
                        }), D && s.setSelected(_), s.setPreSelection(_), k) {
                            var E = C.getMonth(b), Y = C.getMonth(_), P = x.getYear(b), N = x.getYear(_);
                            E !== Y || P !== N ? s.setState({
                                shouldFocusDayInline: !0
                            }) : s.setState({
                                shouldFocusDayInline: !1
                            });
                        }
                    } else s.props.onInputError && s.props.onInputError({
                        code: 1,
                        msg: tr
                    });
                }
            }, s.onPopperKeyDown = function(e) {
                e.key === De.Escape && (e.preventDefault(), s.sendFocusBackToInput());
            }, s.onClearClick = function(e) {
                e && e.preventDefault && e.preventDefault(), s.sendFocusBackToInput();
                var t = s.props, r = t.selectsRange, n = t.onChange;
                n(r ? [
                    null,
                    null
                ] : null, e), s.props.selectsRange ? s.props.onChange([
                    null,
                    null
                ], e) : s.props.onChange(null, e), s.setState({
                    inputValue: null
                });
            }, s.clear = function() {
                s.onClearClick();
            }, s.onScroll = function(e) {
                "boolean" == typeof s.props.closeOnScroll && s.props.closeOnScroll ? e.target !== document && e.target !== document.documentElement && e.target !== document.body || s.setOpen(!1) : "function" == typeof s.props.closeOnScroll && s.props.closeOnScroll(e) && s.setOpen(!1);
            }, s.renderCalendar = function() {
                var e, t;
                return s.props.inline || s.isCalendarOpen() ? ue.default.createElement(er, ge({
                    ref: function(e) {
                        s.calendar = e;
                    }
                }, s.props, s.state, {
                    setOpen: s.setOpen,
                    dateFormat: null !== (e = s.props.dateFormatCalendar) && void 0 !== e ? e : n.defaultProps.dateFormatCalendar,
                    onSelect: s.handleSelect,
                    onClickOutside: s.handleCalendarClickOutside,
                    holidays: ut(s.modifyHolidays()),
                    outsideClickIgnoreClass: Zt,
                    onDropdownFocus: s.handleDropdownFocus,
                    onTimeChange: s.handleTimeChange,
                    className: s.props.calendarClassName,
                    container: s.props.calendarContainer,
                    handleOnKeyDown: s.props.onKeyDown,
                    handleOnDayKeyDown: s.onDayKeyDown,
                    setPreSelection: s.setPreSelection,
                    dropdownMode: null !== (t = s.props.dropdownMode) && void 0 !== t ? t : n.defaultProps.dropdownMode
                }), s.props.children) : null;
            }, s.renderAriaLiveRegion = function() {
                var e, t = s.props, r = t.dateFormat, a = void 0 === r ? n.defaultProps.dateFormat : r, o = t.locale, i = s.props.showTimeInput || s.props.showTimeSelect ? "PPPPp" : "PPPP";
                return e = s.props.selectsRange ? "Selected start date: ".concat(Ee(s.props.startDate, {
                    dateFormat: i,
                    locale: o
                }), ". ").concat(s.props.endDate ? "End date: " + Ee(s.props.endDate, {
                    dateFormat: i,
                    locale: o
                }) : "") : s.props.showTimeSelectOnly ? "Selected time: ".concat(Ee(s.props.selected, {
                    dateFormat: a,
                    locale: o
                })) : s.props.showYearPicker ? "Selected year: ".concat(Ee(s.props.selected, {
                    dateFormat: "yyyy",
                    locale: o
                })) : s.props.showMonthYearPicker ? "Selected month: ".concat(Ee(s.props.selected, {
                    dateFormat: "MMMM yyyy",
                    locale: o
                })) : s.props.showQuarterYearPicker ? "Selected quarter: ".concat(Ee(s.props.selected, {
                    dateFormat: "yyyy, QQQ",
                    locale: o
                })) : "Selected date: ".concat(Ee(s.props.selected, {
                    dateFormat: i,
                    locale: o
                })), ue.default.createElement("span", {
                    role: "alert",
                    "aria-live": "polite",
                    className: "react-datepicker__aria-live"
                }, e);
            }, s.renderDateInput = function() {
                var e, a, o, i = t.clsx(s.props.className, ((e = {})[Zt] = s.state.open, e)), l = s.props.customInput || ue.default.createElement("input", {
                    type: "text"
                }), c = s.props.customInputRef || "ref", p = s.props, d = p.dateFormat, u = void 0 === d ? n.defaultProps.dateFormat : d, f = p.locale, h = "string" == typeof s.props.value ? s.props.value : "string" == typeof s.state.inputValue ? s.state.inputValue : s.props.selectsRange ? function(e, t, r) {
                    if (!e) return "";
                    var n = Ee(e, r), a = t ? Ee(t, r) : "";
                    return "".concat(n, " - ").concat(a);
                }(s.props.startDate, s.props.endDate, {
                    dateFormat: u,
                    locale: f
                }) : s.props.selectsMultiple ? function(e, t) {
                    if (!(null == e ? void 0 : e.length)) return "";
                    var r = e[0] ? Ee(e[0], t) : "";
                    if (1 === e.length) return r;
                    if (2 === e.length && e[1]) {
                        var n = Ee(e[1], t);
                        return "".concat(r, ", ").concat(n);
                    }
                    var a = e.length - 1;
                    return "".concat(r, " (+").concat(a, ")");
                }(null !== (o = s.props.selectedDates) && void 0 !== o ? o : [], {
                    dateFormat: u,
                    locale: f
                }) : Ee(s.props.selected, {
                    dateFormat: u,
                    locale: f
                });
                return r.cloneElement(l, ((a = {})[c] = function(e) {
                    s.input = e;
                }, a.value = h, a.onBlur = s.handleBlur, a.onChange = s.handleChange, a.onClick = s.onInputClick, a.onFocus = s.handleFocus, a.onKeyDown = s.onInputKeyDown, a.id = s.props.id, a.name = s.props.name, a.form = s.props.form, a.autoFocus = s.props.autoFocus, a.placeholder = s.props.placeholderText, a.disabled = s.props.disabled, a.autoComplete = s.props.autoComplete, a.className = t.clsx(l.props.className, i), a.title = s.props.title, a.readOnly = s.props.readOnly, a.required = s.props.required, a.tabIndex = s.props.tabIndex, a["aria-describedby"] = s.props.ariaDescribedBy, a["aria-invalid"] = s.props.ariaInvalid, a["aria-labelledby"] = s.props.ariaLabelledBy, a["aria-required"] = s.props.ariaRequired, a));
            }, s.renderClearButton = function() {
                var e = s.props, r = e.isClearable, n = e.disabled, a = e.selected, o = e.startDate, i = e.endDate, l = e.clearButtonTitle, c = e.clearButtonClassName, p = void 0 === c ? "" : c, d = e.ariaLabelClose, u = void 0 === d ? "Close" : d, f = e.selectedDates;
                return r && (null != a || null != o || null != i || (null == f ? void 0 : f.length)) ? ue.default.createElement("button", {
                    type: "button",
                    className: t.clsx("react-datepicker__close-icon", p, {
                        "react-datepicker__close-icon--disabled": n
                    }),
                    disabled: n,
                    "aria-label": u,
                    onClick: s.onClearClick,
                    title: l,
                    tabIndex: -1
                }) : null;
            }, s.state = s.calcInitialState(), s.preventFocusTimeout = void 0, s;
        }
        return ve(n, e), Object.defineProperty(n, "defaultProps", {
            get: function() {
                return {
                    allowSameDay: !1,
                    dateFormat: "MM/dd/yyyy",
                    dateFormatCalendar: "LLLL yyyy",
                    onChange: function() {},
                    disabled: !1,
                    disabledKeyboardNavigation: !1,
                    dropdownMode: "scroll",
                    onFocus: function() {},
                    onBlur: function() {},
                    onKeyDown: function() {},
                    onInputClick: function() {},
                    onSelect: function() {},
                    onClickOutside: function() {},
                    onMonthChange: function() {},
                    onCalendarOpen: function() {},
                    onCalendarClose: function() {},
                    preventOpenOnFocus: !1,
                    onYearChange: function() {},
                    onInputError: function() {},
                    monthsShown: 1,
                    readOnly: !1,
                    withPortal: !1,
                    selectsDisabledDaysInRange: !1,
                    shouldCloseOnSelect: !0,
                    showTimeSelect: !1,
                    showTimeInput: !1,
                    showPreviousMonths: !1,
                    showMonthYearPicker: !1,
                    showFullMonthYearPicker: !1,
                    showTwoColumnMonthYearPicker: !1,
                    showFourColumnMonthYearPicker: !1,
                    showYearPicker: !1,
                    showQuarterYearPicker: !1,
                    showWeekPicker: !1,
                    strictParsing: !1,
                    swapRange: !1,
                    timeIntervals: 30,
                    timeCaption: "Time",
                    previousMonthAriaLabel: "Previous Month",
                    previousMonthButtonLabel: "Previous Month",
                    nextMonthAriaLabel: "Next Month",
                    nextMonthButtonLabel: "Next Month",
                    previousYearAriaLabel: "Previous Year",
                    previousYearButtonLabel: "Previous Year",
                    nextYearAriaLabel: "Next Year",
                    nextYearButtonLabel: "Next Year",
                    timeInputLabel: "Time",
                    enableTabLoop: !0,
                    yearItemNumber: Se,
                    focusSelectedMonth: !1,
                    showPopperArrow: !0,
                    excludeScrollbar: !0,
                    customTimeInput: null,
                    calendarStartDay: void 0,
                    toggleCalendarOnIconClick: !1,
                    usePointerEvent: !1
                };
            },
            enumerable: !1,
            configurable: !0
        }), n.prototype.componentDidMount = function() {
            window.addEventListener("scroll", this.onScroll, !0), document.addEventListener("visibilitychange", this.setHiddenStateOnVisibilityHidden);
        }, n.prototype.componentDidUpdate = function(e, t) {
            var r, n, a, o, s, i;
            e.inline && (s = e.selected, i = this.props.selected, s && i ? C.getMonth(s) !== C.getMonth(i) || x.getYear(s) !== x.getYear(i) : s !== i) && this.setPreSelection(this.props.selected), void 0 !== this.state.monthSelectedIn && e.monthsShown !== this.props.monthsShown && this.setState({
                monthSelectedIn: 0
            }), e.highlightDates !== this.props.highlightDates && this.setState({
                highlightDates: dt(this.props.highlightDates)
            }), t.focused || We(e.selected, this.props.selected) || this.setState({
                inputValue: null
            }), t.open !== this.state.open && (!1 === t.open && !0 === this.state.open && (null === (n = (r = this.props).onCalendarOpen) || void 0 === n || n.call(r)), !0 === t.open && !1 === this.state.open && (null === (o = (a = this.props).onCalendarClose) || void 0 === o || o.call(a)));
        }, n.prototype.componentWillUnmount = function() {
            this.clearPreventFocusTimeout(), window.removeEventListener("scroll", this.onScroll, !0), document.removeEventListener("visibilitychange", this.setHiddenStateOnVisibilityHidden);
        }, n.prototype.renderInputContainer = function() {
            var e = this.props, r = e.showIcon, n = e.icon, a = e.calendarIconClassname, o = e.calendarIconClassName, s = e.toggleCalendarOnIconClick, i = this.state.open;
            return a && console.warn("calendarIconClassname props is deprecated. should use calendarIconClassName props."), ue.default.createElement("div", {
                className: "react-datepicker__input-container".concat(r ? " react-datepicker__view-calendar-icon" : "")
            }, r && ue.default.createElement(jt, ge({
                icon: n,
                className: t.clsx(o, !o && a, i && "react-datepicker-ignore-onclickoutside")
            }, s ? {
                onClick: this.toggleCalendar
            } : null)), this.state.isRenderAriaLiveMessage && this.renderAriaLiveRegion(), this.renderDateInput(), this.renderClearButton());
        }, n.prototype.render = function() {
            var e = this.renderCalendar();
            if (this.props.inline) return e;
            if (this.props.withPortal) {
                var t = this.state.open ? ue.default.createElement(zt, {
                    enableTabLoop: this.props.enableTabLoop
                }, ue.default.createElement("div", {
                    className: "react-datepicker__portal",
                    tabIndex: -1,
                    onKeyDown: this.onPortalKeyDown
                }, e)) : null;
                return this.state.open && this.props.portalId && (t = ue.default.createElement(Ut, ge({
                    portalId: this.props.portalId
                }, this.props), t)), ue.default.createElement("div", null, this.renderInputContainer(), t);
            }
            return ue.default.createElement(Jt, ge({}, this.props, {
                className: this.props.popperClassName,
                hidePopper: !this.isCalendarOpen(),
                targetComponent: this.renderInputContainer(),
                popperComponent: e,
                popperOnKeyDown: this.onPopperKeyDown,
                showArrow: this.props.showPopperArrow
            }));
        }, n;
    }(r.Component), nr = "input", ar = "navigate";
    e.CalendarContainer = ke, e.default = rr, e.getDefaultLocale = qe, e.registerLocale = function(e, t) {
        var r = we();
        r.__localeData__ || (r.__localeData__ = {}), r.__localeData__[e] = t;
    }, e.setDefaultLocale = function(e) {
        we().__localeId__ = e;
    }, Object.defineProperty(e, "__esModule", {
        value: !0
    });
});





const $b93cf27f2a3b8c2f$var$CustomDatePicker = ({ question: question, value: value = '', isValid: isValid, isTouched: isTouched, invalidError: invalidError, ...props })=>{
    const questionId = question.id;
    const questionText = question.questionText;
    const questionHelpText = question.helpText ? question.helpText : null;
    class CustomDateInput extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
        render() {
            const inputValue = this.props.value ? this.props.value : '';
            return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("input", {
                type: "text",
                readOnly: true,
                onClick: this.props.onClick,
                value: inputValue,
                placeholder: "\xc5\xc5\xc5\xc5-MM-DD"
            });
        }
    }
    const selectedDate = typeof value !== 'undefined' && value && !isNaN(Date.parse(value)) ? new Date(value) : null;
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
        className: "dynamicFormDateWrapper",
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("label", {
                htmlFor: questionId,
                children: [
                    questionText,
                    questionHelpText && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $b6cf6ab8ff89da81$export$2e2bcd8739ae039), {
                        questionGroupHelpText: questionHelpText
                    })
                ]
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                className: "dynamicFormDateInputContainer",
                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($24686044b033fe8a$exports))), {
                    customInput: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)(CustomDateInput, {}),
                    placeholderText: "\xc5\xc5\xc5\xc5-MM-DD",
                    dateFormat: "yyyy-MM-dd",
                    withPortal: window.innerWidth <= (0, $0a574bc6d89559c7$export$2e2bcd8739ae039).breaks.small,
                    fixedHeight: true,
                    selected: selectedDate,
                    nextMonthButtonLabel: "",
                    previousMonthButtonLabel: "",
                    ...props
                })
            }),
            !isValid && typeof isValid !== 'undefined' && isTouched && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $f51edab487ea15ea$export$2e2bcd8739ae039), {
                children: invalidError
            })
        ]
    });
};
var $b93cf27f2a3b8c2f$export$2e2bcd8739ae039 = $b93cf27f2a3b8c2f$var$CustomDatePicker;







parcelRequire("8NFma");
const $542891d798e2f880$var$SubmittedAnswer = ({ question: question, value: value, ...props })=>{
    const questionText = question.questionText;
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
        className: "dynamicFormSubmittedAnswerContainer",
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("p", {
                className: "dynamicFormConfirmedQuestion",
                children: questionText
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("p", {
                className: "dynamicFormConfirmedAnswer",
                children: value
            })
        ]
    });
};
var $542891d798e2f880$export$2e2bcd8739ae039 = $542891d798e2f880$var$SubmittedAnswer;





const $b572cf21a7b9cee9$var$inputThrottleTime = 300;
class $b572cf21a7b9cee9$var$HealthDeclarationQuestionTypeHandler extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).PureComponent {
    constructor(props){
        super(props);
        this.validator = undefined;
        this.validatorTimeOut = null;
        const inputValue = this.props.formInput ? this.props.formInput.value : this.props.question.value ? this.props.question.value : '';
        this.state = {
            value: inputValue
        };
    }
    componentWillUnmount() {
        clearInterval(this.validatorTimeOut);
    }
    // throttling needed when updating redux state for this many inputs, see related discussion at:
    // https://github.com/erikras/redux-form/issues/454
    handleInputChange = (e, throttle = true)=>{
        let questionValue;
        if (this.props.question.questionType === 'Date') questionValue = (0, (/*@__PURE__*/$parcel$interopDefault($YChVI)))(e).format('YYYY-MM-DD'); // save string representation in state instead of moment-object
        else if (this.props.question.questionType === 'Checkbox') questionValue = e.target.checked ? this.props.question.options[0].text : '';
        else questionValue = e.target.value;
        if (throttle) this.props.healthDeclarationThrottledFormInputeChange(this.props.question.id, questionValue, this.validator);
        else this.props.healthDeclarationFormInputChange(this.props.question.id, questionValue, this.validator);
        this.setState({
            value: questionValue
        });
    };
    // validate and take throttle timeout into account
    validate = ()=>{
        this.validatorTimeOut = setTimeout(()=>this.props.validateHealthDeclarationFormInput(this.props.question.id, this.validator), $b572cf21a7b9cee9$var$inputThrottleTime);
    };
    // TODO: verify that PureComponent gives better performance than manually checking props (pretty sure they're kinda equal)
    //shouldComponentUpdate(nextProps, nextState) {
    //    return this.state.value !== nextState.value ||
    //        this.props.formInput.touched !== nextProps.formInput.touched ||
    //        this.props.formInput.valid !== nextProps.formInput.valid;
    //}
    render() {
        const question = this.props.question;
        const currentStep = this.props.currentStep;
        let questionType = question.questionType;
        let submittedValue = '';
        const questionId = question.id;
        const questionText = question.questionText;
        const questionHelpText = question.helpText ? question.helpText : null;
        const isUneditable = question.isUneditable;
        const isTouched = typeof this.props.formInput !== 'undefined' && this.props.formInput ? this.props.formInput.touched : false;
        const isValid = typeof this.props.formInput !== 'undefined' && this.props.formInput ? this.props.formInput.valid : undefined;
        // rendering confirm page?
        if (currentStep === 1) {
            questionType = 'SubmittedAnswer';
            if (this.props.formInput) submittedValue = this.props.formInput.value;
        }
        // render input
        switch(questionType){
            case 'SubmittedAnswer':
                return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $542891d798e2f880$export$2e2bcd8739ae039), {
                    question: question,
                    value: submittedValue
                });
            case 'Radio':
                return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $a3f2d27852734a11$export$2e2bcd8739ae039), {
                    question: question,
                    value: this.state.value,
                    isValid: isValid,
                    isTouched: isTouched,
                    invalidError: "V\xe4lj ett av alternativen",
                    onChange: (e)=>this.handleInputChange(e, true),
                    onBlur: this.validate,
                    onClick: (e)=>{
                        e.persist();
                        this.props.toggleSubQuestions(e);
                        setTimeout(()=>this.validate(), 200);
                    }
                });
            case 'Money':
            case 'ShortString':
                return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $26b938ae087d8201$export$2e2bcd8739ae039), {
                    question: question,
                    value: this.state.value,
                    isValid: isValid,
                    isTouched: isTouched,
                    invalidError: "F\xe4ltet m\xe5ste fyllas i",
                    onChange: this.handleInputChange,
                    onBlur: this.validate
                });
            case 'LongString':
                return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $0e27fd283c2470a0$export$2e2bcd8739ae039), {
                    question: question,
                    value: this.state.value,
                    isValid: isValid,
                    isTouched: isTouched,
                    invalidError: "F\xe4ltet m\xe5ste fyllas i",
                    onChange: this.handleInputChange,
                    onBlur: this.validate
                });
            case 'Number':
                this.validator = (0, $d5552fc3ceef5489$export$1fd13a8724cd7091);
                return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $317ea1b249e06865$export$2e2bcd8739ae039), {
                        question: question,
                        value: this.state.value,
                        isValid: isValid,
                        isTouched: isTouched,
                        invalidError: "Ange en siffra utan decimaler",
                        onChange: this.handleInputChange,
                        onBlur: this.validate
                    })
                });
            case 'PersonalIdentityNumber':
                this.validator = (0, $d5552fc3ceef5489$export$6b5405a3207f4c0f);
                return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $26b938ae087d8201$export$2e2bcd8739ae039), {
                    question: question,
                    value: this.state.value,
                    isValid: isValid,
                    isTouched: isTouched,
                    invalidError: "Ange ett giltigt personnummer",
                    onChange: this.handleInputChange,
                    onBlur: this.validate
                });
            case 'EmailAddress':
                this.validator = (0, $d5552fc3ceef5489$export$9ab921aaffe56820);
                return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $26b938ae087d8201$export$2e2bcd8739ae039), {
                    question: question,
                    value: this.state.value,
                    isValid: isValid,
                    isTouched: isTouched,
                    invalidError: "Ange en giltig e-postadress",
                    onChange: this.handleInputChange,
                    onBlur: this.validate
                });
            case 'Checkbox':
                return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $5207a6288062d4a3$export$2e2bcd8739ae039), {
                    question: question,
                    value: this.state.value,
                    isValid: isValid,
                    isTouched: isTouched,
                    invalidError: "Markera kryssrutan",
                    onChange: this.handleInputChange,
                    onBlur: this.validate
                });
            case 'FreetextDropdown':
                return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $79e3f0c90d489474$export$2e2bcd8739ae039), {
                    question: question,
                    value: this.state.value,
                    isValid: isValid,
                    isTouched: isTouched,
                    invalidError: "F\xe4ltet m\xe5ste fyllas i",
                    onBlur: this.validate,
                    onChange: (e)=>this.handleInputChange(e)
                });
            case 'Dropdown':
                return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $1aede351419caa54$export$2e2bcd8739ae039), {
                    question: question,
                    isValid: isValid,
                    isTouched: isTouched,
                    invalidError: "F\xe4ltet m\xe5ste fyllas i",
                    onChange: this.handleInputChange,
                    onBlur: this.validate
                });
            case 'MonthAndYear':
                this.validator = (0, $d5552fc3ceef5489$export$32149351cfacd020);
                return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $26b938ae087d8201$export$2e2bcd8739ae039), {
                    question: question,
                    placeholder: "\xc5\xc5\xc5\xc5-MM",
                    value: this.state.value,
                    isValid: isValid,
                    isTouched: isTouched,
                    invalidError: 'Ange ett datum p\xe5 formen "\xc5\xc5\xc5\xc5-MM", t.ex. "2011-10" f\xf6r Oktober \xe5r 2011',
                    onChange: this.handleInputChange,
                    onBlur: this.validate
                });
            case 'Date':
                return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $b93cf27f2a3b8c2f$export$2e2bcd8739ae039), {
                    question: question,
                    showYearDropdown: true,
                    value: this.state.value,
                    isValid: isValid,
                    isTouched: isTouched,
                    invalidError: "V\xe4lj ett datum",
                    onChange: this.handleInputChange,
                    onBlur: this.validate
                });
            default:
                return null;
        }
    }
}
const $b572cf21a7b9cee9$var$mapStateToProps = (state)=>{
    return {
        data: state.healthDeclarationPageData,
        currentStep: state.pageCurrentStep
    };
};
const $b572cf21a7b9cee9$var$mapDispatchToProps = (dispatch)=>{
    return {
        healthDeclarationFormInputChange: (questionId, value, validator)=>dispatch((0, $bde6e20398c9b639$export$127340f0cbfa346)(questionId, value, validator)),
        healthDeclarationThrottledFormInputeChange: (0, $a6b818f50380bcca$export$2e2bcd8739ae039)((questionId, value, validator)=>dispatch((0, $bde6e20398c9b639$export$127340f0cbfa346)(questionId, value, validator)), $b572cf21a7b9cee9$var$inputThrottleTime),
        validateHealthDeclarationFormInput: (questionId, validator)=>dispatch((0, $bde6e20398c9b639$export$7b56e35cbe759228)(questionId, validator))
    };
};
var $b572cf21a7b9cee9$export$2e2bcd8739ae039 = (0, $5a4066412ccab0c1$export$64605811ab45167f)($b572cf21a7b9cee9$var$mapStateToProps, $b572cf21a7b9cee9$var$mapDispatchToProps)($b572cf21a7b9cee9$var$HealthDeclarationQuestionTypeHandler);




class $7a88e7524014cdf4$var$HealthDeclarationStepOne extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    componentDidMount() {
        // in case we've loaded a saved hd draft with all input fields valid
        // the status has to updated in order to reflect this (=> enabling the continue button)
        this.props.updateHealthDeclarationStatus();
        // send virtual page view to gtm/mtm / ga
        this.props.registerVirtualPageView();
    }
    render() {
        const healthFormData = this.props.data.healthFormData;
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $87d87c79350c4a5e$export$2e2bcd8739ae039), {
                title: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $a7ba641823ad9c62$export$2e2bcd8739ae039), {}),
                unexpandable: true,
                hideOverflow: false,
                noBackground: true,
                noHeaderPadding: true,
                headerComponent: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $7db30f9b8380a2de$export$bf39d720edf35aea), {
                    id: "healthDeclarationForm",
                    onSubmit: (e)=>e.preventDefault(),
                    children: healthFormData.questionGroups.map((group)=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $16a5e7598873f904$export$2e2bcd8739ae039), {
                            questionGroup: group,
                            questionTypeHandler: (0, $b572cf21a7b9cee9$export$2e2bcd8739ae039),
                            formInputs: this.props.formInputs,
                            repeatedInputs: this.props.repeatedInputs,
                            repeatQuestionGroup: this.props.repeatQuestionGroup,
                            removeRepeatedQuestionGroup: this.props.removeRepeatedQuestionGroup,
                            addQuestionGroupInputs: this.props.addQuestionGroupInputs,
                            removeQuestionGroupInputs: this.props.removeQuestionGroupInputs
                        }, group.id))
                })
            })
        });
    }
}
const $7a88e7524014cdf4$var$mapStateToProps = (state)=>{
    return {
        data: state.healthDeclarationPageData,
        formInputs: state.healthDeclarationFormInputs,
        repeatedInputs: state.healthDeclarationRepeatedInputs
    };
};
const $7a88e7524014cdf4$var$mapDispatchToProps = (dispatch)=>{
    return {
        updateHealthDeclarationStatus: ()=>dispatch((0, $bde6e20398c9b639$export$bb7970e613939413)()),
        registerVirtualPageView: ()=>dispatch((0, $bde6e20398c9b639$export$d8e056e7216fcf24)()),
        repeatQuestionGroup: (questionGroup)=>dispatch((0, $bde6e20398c9b639$export$671bb340aac9ce17)(questionGroup)),
        removeRepeatedQuestionGroup: (questionGroup, index)=>dispatch((0, $bde6e20398c9b639$export$852745b4351040cd)(questionGroup, index)),
        addQuestionGroupInputs: (...args)=>dispatch((0, $bde6e20398c9b639$export$29033efa511d7ede)(...args)),
        removeQuestionGroupInputs: (...args)=>dispatch((0, $bde6e20398c9b639$export$9db56972f3fa02fa)(...args))
    };
};
var $7a88e7524014cdf4$export$2e2bcd8739ae039 = (0, $5a4066412ccab0c1$export$64605811ab45167f)($7a88e7524014cdf4$var$mapStateToProps, $7a88e7524014cdf4$var$mapDispatchToProps)($7a88e7524014cdf4$var$HealthDeclarationStepOne);




var $8NFma = parcelRequire("8NFma");








class $1482e0141f21ac2b$var$HealthDeclarationStepTwo extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    componentDidMount() {
        this.props.registerVirtualPageView();
    }
    render() {
        const healthFormData = this.props.data.healthFormData;
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $87d87c79350c4a5e$export$2e2bcd8739ae039), {
                title: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $a7ba641823ad9c62$export$2e2bcd8739ae039), {}),
                unexpandable: true,
                noHeaderPadding: true,
                headerComponent: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($1482e0141f21ac2b$var$HealthDeclarationConfirmation, {
                    children: healthFormData.questionGroups.map((group)=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $16a5e7598873f904$export$2e2bcd8739ae039), {
                            questionGroup: group,
                            questionTypeHandler: (0, $b572cf21a7b9cee9$export$2e2bcd8739ae039),
                            formInputs: this.props.formInputs,
                            repeatedInputs: this.props.repeatedInputs,
                            removeRepeatedQuestionGroup: this.props.removeRepeatedQuestionGroup,
                            repeatQuestionGroup: this.props.repeatQuestionGroup,
                            addQuestionGroupInputs: this.props.addQuestionGroupInputs,
                            removeQuestionGroupInputs: this.props.removeQuestionGroupInputs
                        }, group.id))
                })
            })
        });
    }
}
// state
const $1482e0141f21ac2b$var$mapStateToProps = (state)=>{
    return {
        data: state.healthDeclarationPageData,
        currentStep: state.pageCurrentStep,
        formInputs: state.healthDeclarationFormInputs,
        repeatedInputs: state.healthDeclarationRepeatedInputs
    };
};
const $1482e0141f21ac2b$var$mapDispatchToProps = (dispatch)=>{
    return {
        registerVirtualPageView: ()=>dispatch((0, $bde6e20398c9b639$export$d8e056e7216fcf24)()),
        addQuestionGroupInputs: (...args)=>dispatch((0, $bde6e20398c9b639$export$29033efa511d7ede)(...args)),
        removeRepeatedQuestionGroup: (questionGroup, index)=>dispatch((0, $bde6e20398c9b639$export$852745b4351040cd)(questionGroup, index)),
        repeatQuestionGroup: (questionGroup)=>dispatch((0, $bde6e20398c9b639$export$671bb340aac9ce17)(questionGroup)),
        removeQuestionGroupInputs: (...args)=>dispatch((0, $bde6e20398c9b639$export$9db56972f3fa02fa)(...args))
    };
};
var $1482e0141f21ac2b$export$2e2bcd8739ae039 = (0, $5a4066412ccab0c1$export$64605811ab45167f)($1482e0141f21ac2b$var$mapStateToProps, $1482e0141f21ac2b$var$mapDispatchToProps)($1482e0141f21ac2b$var$HealthDeclarationStepTwo);
// styles
const $1482e0141f21ac2b$var$HealthDeclarationConfirmation = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    background-color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.blueBackground};
`;




var $8NFma = parcelRequire("8NFma");







class $71671243f8b8a923$var$HealthDeclarationStepThree extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    componentDidMount() {
        this.props.registerVirtualPageView();
    }
    render() {
        const HealthDeclarationSavedStatus = ()=>{
            const healthDeclarationStatus = this.props.saveStatus.status;
            return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($71671243f8b8a923$export$f87505743bbbfe23, {
                children: $71671243f8b8a923$var$status[healthDeclarationStatus]
            });
        };
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $87d87c79350c4a5e$export$2e2bcd8739ae039), {
                title: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $a7ba641823ad9c62$export$2e2bcd8739ae039), {}),
                unexpandable: true,
                noHeaderPadding: true,
                headerComponent: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)(HealthDeclarationSavedStatus, {})
            })
        });
    }
}
const $71671243f8b8a923$var$status = {
    success: "Din h\xe4lsopr\xf6vning \xe4r godk\xe4nd och f\xf6rs\xe4kringen har tecknats.",
    processing: 'Tack f\xf6r din ans\xf6kan. K\xf6pet \xe4r under behandling och kommer att slutf\xf6ras inom kort. N\xe4r f\xf6rs\xe4kringen \xe4r godk\xe4nd ser du den under "Mina f\xf6rs\xe4kringar". Om du inte ser f\xf6rs\xe4kringen kontakta kundservice p\xe5 0771-21 09 09.',
    risk: "Tack f\xf6r din ans\xf6kan. Din h\xe4lsopr\xf6vning \xe4r skickad f\xf6r granskning och vi \xe5terkommer med besked inom kort.",
    failed: "Ett fel uppstod n\xe4r h\xe4lsodeklarationen skulle skickas in. V\xe4nligen f\xf6rs\xf6k p\xe5 nytt och kontakta kundservice om problemet kvarst\xe5r."
};
// state
const $71671243f8b8a923$var$mapStateToProps = (state)=>{
    return {
        data: state.healthDeclarationPageAnswers,
        saveStatus: state.healthDeclarationSavedResult
    };
};
const $71671243f8b8a923$var$mapDispatchToProps = (dispatch)=>{
    return {
        registerVirtualPageView: ()=>dispatch((0, $bde6e20398c9b639$export$d8e056e7216fcf24)())
    };
};
var $71671243f8b8a923$export$2e2bcd8739ae039 = (0, $5a4066412ccab0c1$export$64605811ab45167f)($71671243f8b8a923$var$mapStateToProps, $71671243f8b8a923$var$mapDispatchToProps)($71671243f8b8a923$var$HealthDeclarationStepThree);
const $71671243f8b8a923$export$f87505743bbbfe23 = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    background-color: white;
    color: black;
    padding: 30px;
    font-family: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.main};
    font-size: 18px;

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).medium(`
        padding: 25px;
        font-size: 16px;
    `)}

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        padding: 20px;
    `)}
`;



parcelRequire("8NFma");






const $dc931a1b3212d598$var$stepLabels = [
    "Svara p\xe5 fr\xe5gor",
    "Bekr\xe4fta svar",
    "Bekr\xe4ftelse"
];
const $dc931a1b3212d598$var$HealthDeclarationHeader = ({ appliesToCoinsured: appliesToCoinsured, headerData: headerData, step: step })=>{
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($dc931a1b3212d598$var$Heading, {
                children: headerData.headings[step]
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($dc931a1b3212d598$var$Preamble, {
                children: [
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $96c25128201e5f07$export$2e2bcd8739ae039), {
                        children: headerData.preambles[step]
                    }),
                    appliesToCoinsured && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($dc931a1b3212d598$var$Notice, {
                        children: "Observera att det \xe4r den medf\xf6rs\xe4krades personuppgifter och h\xe4lsotillst\xe5nd som skall anges."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $9ebfac828c61691f$export$2e2bcd8739ae039), {
                stepLabels: $dc931a1b3212d598$var$stepLabels,
                stepCount: $dc931a1b3212d598$var$stepLabels.length,
                activeStep: step,
                hideDescOnResp: true
            })
        ]
    });
};
var $dc931a1b3212d598$export$2e2bcd8739ae039 = $dc931a1b3212d598$var$HealthDeclarationHeader;
// styles
const $dc931a1b3212d598$var$Heading = (0, $65e706775ff71837$export$2e2bcd8739ae039).h1`
    padding-bottom: 30px;
    margin-top: 50px;
    margin-bottom: 35px;

    font-family: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.heading};
    font-size: 60px;
    color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.almostBlack};

    border-bottom: 1px solid ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.grayBorder};

     ${(0, $45d1242a07988139$export$8f880b6e390052fa).custom(`
        margin-left: 17px;
        margin-right: 17px;
    `, '1234px')}

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        border: none;
        font-size: 28px;
        padding-bottom: 0px;
        margin-bottom: 10px;
        margin-top: 31px;
    `)}

     ${(0, $45d1242a07988139$export$8f880b6e390052fa).xxsmall(`
        font-size: 20px;
    `)}
`;
const $dc931a1b3212d598$var$Preamble = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    max-width: 60%;
    width: auto;

    margin-bottom: 20px;

    font-family: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.main};
    font-size: 20px;
    color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.almostBlack};

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).custom(`
        margin-left: 17px;
        margin-right: 17px;
    `, '1234px')}

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        margin-bottom: 15px;
        max-width: none;
        font-size: 16px;
        line-height: 1.5;
    `)}

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).xxsmall(`
        font-size: 13px;
    `)}
`;
const $dc931a1b3212d598$var$Notice = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    padding: 20px 0 0 0;
    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        padding: 15px 0 0 0;
    `)}

    font-family: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.heading};
    font-weight: bold;
    font-size: inherit;

    color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.error};
`;




var $8NFma = parcelRequire("8NFma");


var $YChVI = parcelRequire("YChVI");





//import {iconCode} from '../../../Style/cssHelpers';
class $b100d04932b49ce1$var$HealthDeclarationInformationBox extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    saveDraft = ()=>{
        (0, $c657a2af5c9e1b33$export$f5d3771428a1f489)().then(()=>this.props.saveInsuranceHealthDeclaration(true));
    };
    lastStep = (e)=>{
        e.preventDefault();
        if (this.props.currentStep > 0) (0, $c657a2af5c9e1b33$export$f5d3771428a1f489)().then(()=>{
            this.props.setCurrentStep(this.props.currentStep - 1);
        });
    };
    nextStep = (e)=>{
        const allowDraft = !!this.props.data.allowDraft;
        e.preventDefault();
        (0, $c657a2af5c9e1b33$export$f5d3771428a1f489)().then(()=>{
            if (this.props.currentStep === 1) this.props.saveInsuranceHealthDeclaration(false, undefined, allowDraft);
            else this.props.setCurrentStep(this.props.currentStep + 1);
        });
    };
    validateHealthDeclaration = (0, $a6b818f50380bcca$export$2e2bcd8739ae039)(()=>{
        this.props.showAllHealthDeclarationFormErrors();
    }, 200);
    render() {
        const customerInfo = this.props.data.customer;
        const currentStep = this.props.currentStep;
        const allowDraft = !!this.props.data.allowDraft;
        let healthDeclarationButton = null;
        if (currentStep === 0) healthDeclarationButton = /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
            className: "informationBoxBtnContainer",
            children: [
                allowDraft ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                    className: "editBtn",
                    onClick: this.saveDraft,
                    children: "Spara och forts\xe4tt redigera senare"
                }) : null,
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                    form: "healthDeclarationForm",
                    type: "submit",
                    value: "Submit",
                    className: "nextStepBtn",
                    disabled: !this.props.hdStatus.valid,
                    onClick: this.nextStep,
                    onMouseEnter: this.validateHealthDeclaration,
                    onTouchStart: this.validateHealthDeclaration,
                    children: "G\xe5 vidare"
                }),
                this.props.data.autoSave && this.props.data.autoSave.timestamp && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                    className: "autoSavedDraftNotice",
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("span", {
                        children: [
                            "(Utkast autosparat kl. ",
                            (0, (/*@__PURE__*/$parcel$interopDefault($YChVI)))(this.props.data.autoSave.timestamp).format('HH:mm'),
                            ")"
                        ]
                    })
                })
            ]
        });
        else if (currentStep === 1) healthDeclarationButton = /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
            className: "informationBoxBtnContainer",
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                    className: "editBtn",
                    onClick: this.lastStep,
                    children: "\xc4ndra svar"
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                    className: "sendConfirmedAnswersBtn",
                    onClick: this.nextStep,
                    children: "Skicka"
                })
            ]
        });
        else if (currentStep === 2) healthDeclarationButton = /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
            className: "informationBoxBtnContainer",
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("a", {
                    href: this.props.data.myPagesStartUrl,
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                        className: "editBtn",
                        children: "G\xe5 till Mina sidor"
                    })
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("a", {
                    href: this.props.data.insurancePurchaseUrl,
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                        className: "sendConfirmedAnswersBtn",
                        children: "K\xf6p fler f\xf6rs\xe4kringar"
                    })
                })
            ]
        });
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $7db30f9b8380a2de$export$e5514f626972a05), {
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                    className: "memberInfoContainer",
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("h3", {
                            children: "Dina uppgifter"
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("p", {
                            className: "memberInfoName",
                            children: customerInfo.firstName + ' ' + customerInfo.lastName
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("p", {
                            children: customerInfo.streetAddress
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("p", {
                            className: "memberInfoZipCodeArea",
                            children: customerInfo.zipCodeArea
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                    children: "Personnummer:"
                                }),
                                customerInfo.idNumber
                            ]
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                    children: "E-postadress:"
                                }),
                                "\xad",
                                customerInfo.emailAddress
                            ]
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                    children: "Telefon:"
                                }),
                                customerInfo.mobilePhone
                            ]
                        })
                    ]
                }),
                !this.props.hdStatus.valid && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $830198e7d4a3a075$export$2e2bcd8739ae039), {
                    formInputs: this.props.formInputs
                }),
                healthDeclarationButton
            ]
        });
    }
}
const $b100d04932b49ce1$var$mapStateToProps = (state)=>{
    return {
        data: state.healthDeclarationPageData,
        currentStep: state.pageCurrentStep,
        hdStatus: state.healthDeclarationStatus,
        formInputs: state.healthDeclarationFormInputs
    };
};
const $b100d04932b49ce1$var$mapDispatchToProps = (dispatch)=>{
    return {
        setCurrentStep: (step)=>dispatch((0, $bde6e20398c9b639$export$edb2fd95ac60ce1c)(step)),
        showAllHealthDeclarationFormErrors: ()=>dispatch((0, $bde6e20398c9b639$export$fbcf6208d1beaa3c)()),
        saveInsuranceHealthDeclaration: (isDraft, isAutoSave, allowDraft)=>dispatch((0, $bde6e20398c9b639$export$50ae14802d2eabe7)(isDraft, isAutoSave, allowDraft))
    };
};
var $b100d04932b49ce1$export$2e2bcd8739ae039 = (0, $5a4066412ccab0c1$export$64605811ab45167f)($b100d04932b49ce1$var$mapStateToProps, $b100d04932b49ce1$var$mapDispatchToProps)($b100d04932b49ce1$var$HealthDeclarationInformationBox);



class $0f02de9eff7b0a0d$var$InsuranceHealthDeclarationPage extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    static get propTypes() {
        return {
            mountRootId: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string.isRequired
        };
    }
    constructor(props){
        super(props);
        this.headerData = this.getHeaderData();
    }
    componentDidMount() {
        this.props.loadHealthDeclarationData();
        // setup back button handling, pressing it when on step 2 should gracefully step back to step1
        history.pushState({}, '', window.location.href);
        window.onpopstate = this.handleBackButton;
    }
    getHeaderData() {
        return {
            headings: [
                (0, $e6aeb63e6149c504$export$161fa9a9af21e7de)('heading', this.props.mountRootId),
                (0, $e6aeb63e6149c504$export$161fa9a9af21e7de)('heading-step2', this.props.mountRootId),
                (0, $e6aeb63e6149c504$export$161fa9a9af21e7de)('heading-step3', this.props.mountRootId)
            ],
            preambles: [
                (0, $e6aeb63e6149c504$export$161fa9a9af21e7de)('preamble', this.props.mountRootId),
                (0, $e6aeb63e6149c504$export$161fa9a9af21e7de)('preamble-step2', this.props.mountRootId),
                (0, $e6aeb63e6149c504$export$161fa9a9af21e7de)('preamble-step3', this.props.mountRootId)
            ]
        };
    }
    handleBackButton = (e)=>{
        e.preventDefault();
        if (this.props.step == 1) {
            this.props.setCurrentStep(this.props.step - 1);
            history.pushState(null, null, window.location.href);
        } else history.back();
    };
    render() {
        const appliesToCoinsured = this.props.data.healthDeclarationRegistration && this.props.data.healthDeclarationRegistration.appliesToCoinsured == true;
        if (this.props.hasErrored) {
            const errorMsg = typeof this.props.error === 'string' ? this.props.error : this.props.error.message;
            return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $dc931a1b3212d598$export$2e2bcd8739ae039), {
                        appliesToCoinsured: appliesToCoinsured,
                        headerData: this.headerData,
                        step: this.props.step
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $19ac445fff8f1f3a$export$2e2bcd8739ae039), {
                        message: `Ooops! Ett fel uppstod vid h\xe4mtningen: ${errorMsg}`
                    })
                ]
            });
        }
        if (this.props.isLoading) return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $dc931a1b3212d598$export$2e2bcd8739ae039), {
                    appliesToCoinsured: appliesToCoinsured,
                    headerData: this.headerData,
                    step: this.props.step
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $492d68823d70b95b$export$2e2bcd8739ae039), {
                    color: (0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.blueBackground
                })
            ]
        });
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $dc931a1b3212d598$export$2e2bcd8739ae039), {
                    appliesToCoinsured: appliesToCoinsured,
                    headerData: this.headerData,
                    step: this.props.step
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $bb8231acd22e51c2$export$e25e478948902b8b).div, {
                    initial: {
                        opacity: 0
                    },
                    animate: {
                        opacity: 1
                    },
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $cd1ec0cc88bc8751$export$2e2bcd8739ae039), {
                                sectionId: this.props.step,
                                children: [
                                    this.props.step === 0 && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $7a88e7524014cdf4$export$2e2bcd8739ae039), {}),
                                    this.props.step === 1 && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $1482e0141f21ac2b$export$2e2bcd8739ae039), {}),
                                    this.props.step === 2 && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $71671243f8b8a923$export$2e2bcd8739ae039), {})
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $b100d04932b49ce1$export$2e2bcd8739ae039), {})
                    ]
                })
            ]
        });
    }
}
const $0f02de9eff7b0a0d$var$mapStateToProps = (state)=>{
    return {
        data: state.healthDeclarationPageData,
        hasErrored: state.pageHasErrored,
        error: state.pageError,
        isLoading: state.pageIsLoading,
        step: state.pageCurrentStep
    };
};
const $0f02de9eff7b0a0d$var$mapDispatchToProps = (dispatch)=>{
    return {
        loadHealthDeclarationData: (insurance)=>dispatch((0, $bde6e20398c9b639$export$5c8e5fdd7721aac0)(insurance)),
        setCurrentStep: (step)=>dispatch((0, $67f4b1d2fb7c2244$export$453e7c361a52c908)(step))
    };
};
var $0f02de9eff7b0a0d$export$2e2bcd8739ae039 = (0, $5a4066412ccab0c1$export$64605811ab45167f)($0f02de9eff7b0a0d$var$mapStateToProps, $0f02de9eff7b0a0d$var$mapDispatchToProps)($0f02de9eff7b0a0d$var$InsuranceHealthDeclarationPage);
const $0f02de9eff7b0a0d$var$Heading = (0, $65e706775ff71837$export$2e2bcd8739ae039).h1`
    padding-bottom: 30px;
    margin-top: 50px;
    margin-bottom: 35px;

    font-family: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.heading};
    font-size: 60px;
    color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.almostBlack};

    border-bottom: 1px solid ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.grayBorder};

     ${(0, $45d1242a07988139$export$8f880b6e390052fa).custom(`
        margin-left: 17px;
        margin-right: 17px;
    `, '1234px')}

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        border: none;
        font-size: 28px;
        padding-bottom: 0px;
        margin-bottom: 10px;
        margin-top: 31px;
    `)}
     ${(0, $45d1242a07988139$export$8f880b6e390052fa).xxsmall(`
        font-size: 20px;
    `)}
`;
const $0f02de9eff7b0a0d$var$Preamble = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    max-width: 60%;
    margin-bottom: 40px;

    font-family: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.main};
    font-size: 20px;
    color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.almostBlack};

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).custom(`
        margin-left: 17px;
        margin-right: 17px;
    `, '1234px')}

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        margin-bottom: 15px;
        max-width: none;
        font-size: 16px;
        line-height: 1.5;
    `)}

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).xxsmall(`
        font-size: 13px;
    `)}
`;




var $8NFma = parcelRequire("8NFma");







function $b3626e4088541fc3$export$5281bdcf793676e4() {
    const lfDataService = new (0, $25937fdb26d57abd$export$2e2bcd8739ae039)();
    return (dispatch)=>{
        let customerInfo, coinsuredInfo;
        lfDataService.customerInfo().then((data)=>{
            customerInfo = data.customerInfo;
            coinsuredInfo = data.currentCoInsured;
            return Promise.all([
                lfDataService.insurances(),
                lfDataService.preregistrations()
            ]);
        }).then((values)=>{
            let data = values.reduce((acc, obj)=>{
                Object.keys(obj).forEach((prop)=>acc[prop] = obj[prop]);
                return acc;
            }, {});
            data.customerInfo = customerInfo;
            data.coinsuredInfo = coinsuredInfo;
            data.insurancesByName = (0, $36509d2879dd53eb$export$aa98a26e797b60e6)(data.insurances);
            let memberRegistrations = (0, $36509d2879dd53eb$export$9c294c7c1d8f86a5)(data.preregistrations.filter((r)=>!r.appliesToCoinsured && r.targetGroupName !== 'djur'));
            let coRegistrations = (0, $36509d2879dd53eb$export$9c294c7c1d8f86a5)(data.preregistrations.filter((r)=>r.appliesToCoinsured && r.targetGroupName !== 'djur'));
            let animalRegistrations = (0, $36509d2879dd53eb$export$9c294c7c1d8f86a5)(data.preregistrations.filter((r)=>r.targetGroupName === 'djur'));
            data.animalRegistrations = (0, $36509d2879dd53eb$export$93d7fc36cde4ba6)(animalRegistrations);
            data.memberRegistrations = memberRegistrations.map((group)=>(0, $36509d2879dd53eb$export$167680d23a59c108)(group));
            data.coRegistrations = coRegistrations.map((group)=>(0, $36509d2879dd53eb$export$167680d23a59c108)(group));
            dispatch($b3626e4088541fc3$export$d7fef8a037e0705c(data));
            dispatch((0, $67f4b1d2fb7c2244$export$5630fcc02dc02d1b)(false));
            dispatch((0, $67f4b1d2fb7c2244$export$453e7c361a52c908)(0));
        }).catch((e)=>{
            dispatch((0, $67f4b1d2fb7c2244$export$7a8bb273722d5103)(e));
            dispatch((0, $67f4b1d2fb7c2244$export$ea4b4733f4ca2df0)(true));
        });
    };
}
function $b3626e4088541fc3$export$d7fef8a037e0705c(data) {
    return {
        type: 'INSURANCE_PREREGISTRATIONS_PAGE_LOADED',
        data: data
    };
}









var $8NFma = parcelRequire("8NFma");







var $8NFma = parcelRequire("8NFma");







var $8NFma = parcelRequire("8NFma");






class $9c467c5a87322c76$var$InsuranceHeading extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    static get propTypes() {
        return {
            registration: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).object.isRequired
        };
    }
    render() {
        let registrationSuffix, displayName;
        const registration = this.props.registration;
        if (registration.targetGroupName === 'djur') {
            registrationSuffix = registration.animalGivenName;
            displayName = registration.displayName;
        } else {
            const regMeta = (0, $36509d2879dd53eb$export$86b9bf27d05da341)(this.props.registration.insuranceName);
            const targetInfo = this.props.registration.isCoinsured ? this.props.data.coinsuredInfo : this.props.data.memberInfo;
            registrationSuffix = targetInfo && targetInfo.firstName && targetInfo.lastName ? `${targetInfo.firstName} ${targetInfo.lastName}` : this.props.registration.isCoinsured ? "medf\xf6rs\xe4krad" : 'medlem';
            displayName = regMeta ? regMeta.displayNameHeading : registration.displayName;
        }
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($9c467c5a87322c76$var$Heading, {
                    children: displayName
                }),
                registrationSuffix && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($9c467c5a87322c76$var$Separator, {
                            children: "\xa0-\xa0"
                        }),
                        registrationSuffix
                    ]
                })
            ]
        });
    }
}
// state
const $9c467c5a87322c76$var$mapStateToProps = (state)=>{
    return {
        data: state.preregistrationPageData
    };
};
var $9c467c5a87322c76$export$2e2bcd8739ae039 = (0, $5a4066412ccab0c1$export$64605811ab45167f)($9c467c5a87322c76$var$mapStateToProps, ()=>({}))($9c467c5a87322c76$var$InsuranceHeading);
// styles 
const $9c467c5a87322c76$var$Heading = (0, $65e706775ff71837$export$2e2bcd8739ae039).h4`
    display: inline-block; 
    ${(0, $45d1242a07988139$export$8f880b6e390052fa).xsmall(`
        display: block;
    `)}

    font-family: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.main};
    font-size: 18px; 
    ${(0, $45d1242a07988139$export$8f880b6e390052fa).large(`
        font-size: 16px;
    `)}
    font-weight: bold; 
`;
const $9c467c5a87322c76$var$Separator = (0, $65e706775ff71837$export$2e2bcd8739ae039).span`
    display: inline-block; 
    ${(0, $45d1242a07988139$export$8f880b6e390052fa).xsmall(`
        display: none;
    `)}
`;



parcelRequire("8NFma");




const $6576a2d815cae8a6$export$8465014fda0aad24 = {
    notStarted: {
        color: '#ef3f6b',
        statusCopy: "Ej p\xe5b\xf6rjad",
        buttonCopy: "Fyll i h\xe4lsopr\xf6vning"
    },
    started: {
        color: '#f57f2f',
        statusCopy: "P\xe5b\xf6rjad",
        buttonCopy: "Slutf\xf6r"
    },
    pending: {
        color: '#00873F;',
        statusCopy: 'Under granskning'
    }
};
const $6576a2d815cae8a6$export$edb630af4eea6856 = (registration)=>{
    let status = 'notStarted';
    if (registration.hasDraft) status = 'started';
    if (registration.markedForRisk) status = 'pending';
    return status;
};


function $4a9f2702f29137cb$export$2e2bcd8739ae039({ status: status }) {
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($4a9f2702f29137cb$var$StatusBlockWrapper, {
        statusColor: (0, $6576a2d815cae8a6$export$8465014fda0aad24)[status].color,
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("h5", {
                children: "Status"
            }),
            (0, $6576a2d815cae8a6$export$8465014fda0aad24)[status].statusCopy
        ]
    });
}
// styles 
const $4a9f2702f29137cb$var$StatusBlockWrapper = (0, $65e706775ff71837$export$2e2bcd8739ae039).div` 
    position: relative; 

    font-size: 18px; 
    ${(0, $45d1242a07988139$export$8f880b6e390052fa).large(`
        font-size: 16px;
    `)}

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        margin-left: 12px;
    `)}

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).xxsmall(`
        margin-left: 22px;
    `)}

    h5 {
        font-size: 18px; 
        ${(0, $45d1242a07988139$export$8f880b6e390052fa).large(`
            font-size: 16px;
        `)}

        font-weight: bold; 
        font-family: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.heading};
    }

    &:before {
        display: inline-block;
        position: absolute;
        content: '';

        left: -25px;
        bottom: 7px;

        width: 15px;
        height: 15px;

        border-radius: 7.5px;
        
        background-color: ${(props)=>props.statusColor};
    }
`;





const $a3d734c472685c36$export$574561728a5b3f23 = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    position: relative; 
    margin-bottom: 40px;
    border-radius: 5px;
    overflow: hidden;

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        margin-top: 20px;
        margin-bottom: 0px;
    `)};
`;
const $a3d734c472685c36$export$8b251419efc915eb = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    background-color: white; 
    color: black; 
    padding: 30px;
    ${(0, $45d1242a07988139$export$8f880b6e390052fa).large(`
        padding: 20px;
    `)};

    font-family: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.main};
    font-size: 18px; 
    ${(0, $45d1242a07988139$export$8f880b6e390052fa).large(`
        font-size: 16px;
    `)}
`;
const $a3d734c472685c36$export$3322244dfe9948f3 = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    position: relative;
    height: auto; 
    padding: 35px;
    ${(0, $45d1242a07988139$export$8f880b6e390052fa).xxsmall(`
        padding: 20px;
    `)};

    color: white; 
    border: 1px solid rgba(255, 255, 255, 0.3);

    ${(0, $45d1242a07988139$export$8c467e8859fdef13)()}
`;
const $a3d734c472685c36$export$599b43d50eaacbcd = (0, $65e706775ff71837$export$2e2bcd8739ae039).div` 
    float: left; 
    width: 50%;
    text-align: ${(props)=>props.align ? props.align : 'left'};

    ${(props)=>(0, $45d1242a07988139$export$8f880b6e390052fa).xsmall(`
        float: none; 
        width: 100%;
        display: block;

        &:not(:first-of-type) {
            margin-top: 20px;
        }

        text-align: ${props.align == 'right' ? 'center' : 'left'};
    `)}

`;




class $ed3d5ff57a91bbaf$var$SingleRegistration extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    static get propTypes() {
        return {
            registration: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).object.isRequired
        };
    }
    render() {
        const registration = this.props.registration;
        const status = (0, $6576a2d815cae8a6$export$edb630af4eea6856)(this.props.registration);
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $a3d734c472685c36$export$574561728a5b3f23), {
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $a3d734c472685c36$export$8b251419efc915eb), {
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $9c467c5a87322c76$export$2e2bcd8739ae039), {
                        registration: registration
                    })
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $a3d734c472685c36$export$3322244dfe9948f3), {
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $a3d734c472685c36$export$599b43d50eaacbcd), {
                            align: "left",
                            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $4a9f2702f29137cb$export$2e2bcd8739ae039), {
                                status: status
                            })
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $a3d734c472685c36$export$599b43d50eaacbcd), {
                            align: "right",
                            children: status !== 'pending' && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($ed3d5ff57a91bbaf$var$DeclarationButton, {
                                href: this.props.getHealthDeclarationUrlFor(registration.insuranceName, registration.insuranceObjectId),
                                children: (0, $6576a2d815cae8a6$export$8465014fda0aad24)[status].buttonCopy
                            })
                        })
                    ]
                })
            ]
        });
    }
}
// state
const $ed3d5ff57a91bbaf$var$mapDispatchToProps = (dispatch)=>{
    return {
        getHealthDeclarationUrlFor: (insuranceName, objId)=>dispatch((0, $67f4b1d2fb7c2244$export$1b4ebad6b9033866)(insuranceName, objId))
    };
};
var $ed3d5ff57a91bbaf$export$2e2bcd8739ae039 = (0, $5a4066412ccab0c1$export$64605811ab45167f)(()=>({}), $ed3d5ff57a91bbaf$var$mapDispatchToProps)($ed3d5ff57a91bbaf$var$SingleRegistration);
// styles 
const $ed3d5ff57a91bbaf$var$DeclarationButton = (0, $65e706775ff71837$export$2e2bcd8739ae039).a`
    position: absolute; 

    width: auto; 
    right: 30px; 
    bottom: 40px;
    padding: 7px 20px 7px 20px;
    ${(0, $45d1242a07988139$export$8f880b6e390052fa).xsmall(`
        position: relative; 
        display: inline-block;
        right: 0; 
        bottom: 0;
        padding: 7px 15px 7px 15px;
    `)}

    font-family: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.heading};
    font-size: 18px;
    ${(0, $45d1242a07988139$export$8f880b6e390052fa).large(`
        font-size: 16px;
    `)}

    font-weight: bold;
    color: white; 
    
    background-color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.green};
    border-radius: 5px;

    transition: background-color 300ms ease-out; 

    &:hover, &:focus {
        text-decoration: none; 
        color: white;
    }
`;




var $8NFma = parcelRequire("8NFma");














parcelRequire("8NFma");


const $2155d489c882aebf$var$HiddenInput = ({ error: error, isChanged: isChanged, isUsed: isUsed, ...props })=>{
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($2155d489c882aebf$var$HiddenInputWrapper, {
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("input", {
                type: "hidden",
                ...props,
                ...isChanged && isUsed && error ? {
                    className: `is-invalid-input ${props.className}`
                } : {
                    className: props.className
                }
            }),
            isChanged && isUsed && error
        ]
    });
};
const $2155d489c882aebf$var$HiddenInputWrapper = (0, $65e706775ff71837$export$2e2bcd8739ae039).span`
    display: none; 
`;
var $2155d489c882aebf$export$2e2bcd8739ae039 = (0, $ecd163b239ffc845$export$2e2bcd8739ae039)($2155d489c882aebf$var$HiddenInput);



class $0559b222d7b8e757$var$MultipleRegistration extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    constructor(props){
        super(props);
        this.form = null;
    }
    static get propTypes() {
        return {
            registrations: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).array.isRequired
        };
    }
    handleFormSelection = (e)=>{
        e.preventDefault();
        const { insuranceName: insuranceName, insuranceObjectId: insuranceObjectId } = (0, $f2bfeab6e0c24c97$export$2e2bcd8739ae039)(this.form);
        this.props.redirectToHealthDeclarationFor(insuranceName, insuranceObjectId);
    };
    render() {
        const registrations = this.props.registrations;
        const registrationsMarkedForRisk = registrations.filter((registration, index)=>{
            return registration.markedForRisk;
        });
        const showOnlyMarkedForRisk = registrationsMarkedForRisk.length;
        const status = showOnlyMarkedForRisk ? 'pending' : 'notStarted';
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $a3d734c472685c36$export$574561728a5b3f23), {
            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $8c02aa23a40a9b45$export$2e2bcd8739ae039), {
                ref: (el)=>{
                    this.form = el;
                },
                onSubmit: this.handleFormSelection,
                children: [
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $a3d734c472685c36$export$8b251419efc915eb), {
                        children: [
                            !showOnlyMarkedForRisk && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($0559b222d7b8e757$var$Heading, {
                                children: "V\xe4lj en ans\xf6kning att slutf\xf6ra"
                            }),
                            registrations.map((registration, i)=>{
                                const markedForRisk = registration.markedForRisk;
                                if (markedForRisk) return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $9c467c5a87322c76$export$2e2bcd8739ae039), {
                                        registration: registration
                                    })
                                }, i);
                                if (showOnlyMarkedForRisk) return;
                                return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $8a85d66883139d14$export$2e2bcd8739ae039), {
                                            id: registration.insuranceName,
                                            name: "insuranceName",
                                            value: registration.insuranceName,
                                            validations: [
                                                (0, $d5552fc3ceef5489$export$a7a0278c004aac3f)
                                            ],
                                            displayname: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $9c467c5a87322c76$export$2e2bcd8739ae039), {
                                                registration: registration
                                            }),
                                            "data-validation-error-message": i == this.props.registrations.length - 1 ? "V\xe4lj en ans\xf6kning att slutf\xf6ra" : '',
                                            customdisplay: "inline-block",
                                            marginbottom: "10px",
                                            customwidth: "100%"
                                        }),
                                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $2155d489c882aebf$export$2e2bcd8739ae039), {
                                            id: `${registration.insuranceName}-objectId`,
                                            name: "insuranceObjectId",
                                            value: registration.insuranceObjectId
                                        })
                                    ]
                                }, i);
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $a3d734c472685c36$export$3322244dfe9948f3), {
                        children: [
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $a3d734c472685c36$export$599b43d50eaacbcd), {
                                align: "left",
                                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $4a9f2702f29137cb$export$2e2bcd8739ae039), {
                                    status: status
                                })
                            }),
                            !showOnlyMarkedForRisk && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $a3d734c472685c36$export$599b43d50eaacbcd), {
                                align: "right",
                                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $b50965a6d450d3cc$export$2e2bcd8739ae039), {
                                    onMouseEnter: ()=>this.validationTimer = setTimeout(this.form.validateAll, 1000),
                                    onMouseLeave: ()=>clearTimeout(this.validationTimer),
                                    topMargin: "0",
                                    noIcon: true,
                                    children: "Fyll i h\xe4lsopr\xf6vning"
                                })
                            })
                        ]
                    })
                ]
            })
        });
    }
}
// state
const $0559b222d7b8e757$var$mapDispatchToProps = (dispatch)=>{
    return {
        redirectToHealthDeclarationFor: (insuranceName, insuranceObjectId)=>dispatch((0, $67f4b1d2fb7c2244$export$891cb1f3e85fe317)(insuranceName, insuranceObjectId))
    };
};
var $0559b222d7b8e757$export$2e2bcd8739ae039 = (0, $5a4066412ccab0c1$export$64605811ab45167f)(()=>({}), $0559b222d7b8e757$var$mapDispatchToProps)($0559b222d7b8e757$var$MultipleRegistration);
// styles
const $0559b222d7b8e757$var$Heading = (0, $65e706775ff71837$export$2e2bcd8739ae039).h3`
    margin-bottom: 18px;

    font-size: 18px;
    ${(0, $45d1242a07988139$export$8f880b6e390052fa).large(`
        font-size: 16px;
    `)}
`;


class $b2159f3ffca2adcb$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    static get propTypes() {
        return {
            registrations: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).array.isRequired
        };
    }
    render() {
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($b2159f3ffca2adcb$var$Wrapper, {
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($b2159f3ffca2adcb$var$RegistrationInfo, {
                    children: "En p\xe5b\xf6rjad ans\xf6kan beh\xf6ver slutf\xf6ras inom 30 dagar. D\xe4refter m\xe5ste du b\xf6rja om fr\xe5n b\xf6rjan."
                }),
                this.props.registrations.map((regGroup, i)=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                        children: [
                            regGroup.insurances.length && Array.isArray(regGroup.insurances[0]) && regGroup.insurances.map((objInsurances, j)=>objInsurances.length > 1 ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $0559b222d7b8e757$export$2e2bcd8739ae039), {
                                    registrations: objInsurances
                                }, j) : /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $ed3d5ff57a91bbaf$export$2e2bcd8739ae039), {
                                    registration: objInsurances[0]
                                }, j)),
                            regGroup.insurances.length && !Array.isArray(regGroup.insurances[0]) && regGroup.insurances.length > 1 && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $0559b222d7b8e757$export$2e2bcd8739ae039), {
                                registrations: regGroup.insurances
                            }),
                            regGroup.insurances.length && !Array.isArray(regGroup.insurances[0]) && regGroup.insurances.length == 1 && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $ed3d5ff57a91bbaf$export$2e2bcd8739ae039), {
                                registration: regGroup.insurances[0]
                            })
                        ]
                    }, i))
            ]
        });
    }
}
// styles 
const $b2159f3ffca2adcb$var$Wrapper = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    background-color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.blueBackground};
    color: white; 
`;
const $b2159f3ffca2adcb$var$RegistrationInfo = (0, $65e706775ff71837$export$2e2bcd8739ae039).p`
    padding-top: 5px;
    margin-top: -10px;
    
    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        margin-top: 5px;
        line-height: 1.4;
    `)}

    font-size: 18px;
    ${(0, $45d1242a07988139$export$8f880b6e390052fa).large(`
        font-size: 16px;
    `)}

    color: white; 
`;




class $a1bbebf1cc25d62e$var$InsurancePreregistrationPage extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    constructor(props){
        super(props);
        this.heading = (0, $e6aeb63e6149c504$export$161fa9a9af21e7de)('heading', this.props.mountRootId);
        this.preamble = (0, $e6aeb63e6149c504$export$161fa9a9af21e7de)('preamble', this.props.mountRootId);
    }
    static get propTypes() {
        return {
            mountRootId: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string.isRequired
        };
    }
    componentDidMount() {
        this.props.loadData();
    }
    render() {
        const Header = ({ preamble: preamble })=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($a1bbebf1cc25d62e$export$960a49cc3d27a090, {
                children: [
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($a1bbebf1cc25d62e$export$a8a3e93435678ff9, {
                        children: this.heading
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($a1bbebf1cc25d62e$export$c6d1ad8c1472a6e0, {
                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $96c25128201e5f07$export$2e2bcd8739ae039), {
                            children: preamble
                        })
                    })
                ]
            });
        if (this.props.hasErrored) return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Fragment, {
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)(Header, {
                    preamble: this.preamble
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $19ac445fff8f1f3a$export$2e2bcd8739ae039), {
                    message: `Ooops! Ett fel har uppst\xe5tt: ${typeof this.props.error === 'string' ? this.props.error : this.props.error.message}`
                })
            ]
        });
        if (this.props.isLoading) return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Fragment, {
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)(Header, {
                    preamble: ""
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $492d68823d70b95b$export$2e2bcd8739ae039), {
                    color: (0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.blueBackground
                })
            ]
        });
        const hasMemberRegs = this.props.data.memberRegistrations.length > 0;
        const hasCoInsRegs = this.props.data.coRegistrations.length > 0;
        const hasAnimalRegs = this.props.data.animalRegistrations.length > 0;
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Fragment, {
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)(Header, {
                    preamble: !hasMemberRegs && !hasCoInsRegs && !hasAnimalRegs ? "Du har just nu inga p\xe5b\xf6rjade h\xe4lsodeklarationer" : this.preamble
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $bb8231acd22e51c2$export$e25e478948902b8b).div, {
                    initial: {
                        opacity: 0
                    },
                    animate: {
                        opacity: 1
                    },
                    transition: {
                        duration: 0.5
                    },
                    children: [
                        hasMemberRegs && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $87d87c79350c4a5e$export$2e2bcd8739ae039), {
                            title: "F\xf6r medlem",
                            noBackground: true,
                            hideOverflow: false,
                            headerComponent: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $b2159f3ffca2adcb$export$2e2bcd8739ae039), {
                                registrations: this.props.data.memberRegistrations
                            }),
                            noHeaderPadding: true,
                            unexpandable: true
                        }),
                        hasCoInsRegs && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $87d87c79350c4a5e$export$2e2bcd8739ae039), {
                            title: "F\xf6r medf\xf6rs\xe4krad",
                            noBackground: true,
                            hideOverflow: false,
                            headerComponent: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $b2159f3ffca2adcb$export$2e2bcd8739ae039), {
                                registrations: this.props.data.coRegistrations
                            }),
                            noHeaderPadding: true,
                            unexpandable: true
                        }),
                        hasAnimalRegs && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $87d87c79350c4a5e$export$2e2bcd8739ae039), {
                            title: "F\xf6r djur",
                            noBackground: true,
                            hideOverflow: false,
                            headerComponent: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $b2159f3ffca2adcb$export$2e2bcd8739ae039), {
                                registrations: this.props.data.animalRegistrations
                            }),
                            noHeaderPadding: true,
                            unexpandable: true
                        })
                    ]
                })
            ]
        });
    }
}
// state
const $a1bbebf1cc25d62e$var$mapStateToProps = (state)=>{
    return {
        data: state.preregistrationPageData,
        hasErrored: state.pageHasErrored,
        error: state.pageError,
        isLoading: state.pageIsLoading
    };
};
const $a1bbebf1cc25d62e$var$mapDispatchToProps = (dispatch)=>{
    return {
        loadData: ()=>dispatch((0, $b3626e4088541fc3$export$5281bdcf793676e4)())
    };
};
var $a1bbebf1cc25d62e$export$2e2bcd8739ae039 = (0, $5a4066412ccab0c1$export$64605811ab45167f)($a1bbebf1cc25d62e$var$mapStateToProps, $a1bbebf1cc25d62e$var$mapDispatchToProps)($a1bbebf1cc25d62e$var$InsurancePreregistrationPage);
const $a1bbebf1cc25d62e$export$960a49cc3d27a090 = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    position: relative;
    margin: 0;
    padding: 0;
`;
const $a1bbebf1cc25d62e$export$a8a3e93435678ff9 = (0, $65e706775ff71837$export$2e2bcd8739ae039).h1`
    font-family: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.heading};
    font-size: 48px;
    color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.almostBlack};

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        font-size: 28px;
    `)}
`;
const $a1bbebf1cc25d62e$export$c6d1ad8c1472a6e0 = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`    
    margin-bottom: 40px;

    font-family: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.main};
    font-size: 20px;
    color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.almostBlack};

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).large(`
        margin: 0;       
        font-size: 16px;
    `)}
`;




var $8NFma = parcelRequire("8NFma");



const $defc9e244fcd6007$var$fetchAchievements = (data)=>{
    return {
        type: 'ACHIEVEMENTS_FETCH',
        data: data
    };
};
const $defc9e244fcd6007$var$fetchNewAchievements = (data)=>{
    return {
        type: 'NEW_ACHIEVEMENTS_FETCH',
        data: data
    };
};
const $defc9e244fcd6007$var$fetchAchievementsFailed = (failed)=>{
    return {
        type: 'ACHIEVEMENTS_FETCH_FAILED',
        data: failed
    };
};
const $defc9e244fcd6007$export$250783bb0ed552ae = ()=>{
    const lfDataService = new (0, $25937fdb26d57abd$export$2e2bcd8739ae039)();
    return (dispatch)=>{
        let result;
        lfDataService.getAchievements().then((data)=>{
            result = data;
            dispatch($defc9e244fcd6007$var$fetchAchievements(result));
        }).catch((e1)=>{
            dispatch((0, $67f4b1d2fb7c2244$export$7a8bb273722d5103)(e1));
            dispatch((0, $67f4b1d2fb7c2244$export$ea4b4733f4ca2df0)(true));
            dispatch($defc9e244fcd6007$var$fetchAchievementsFailed(true));
        });
    };
};
const $defc9e244fcd6007$export$97f59f2b60c32ef8 = ()=>{
    const lfDataService = new (0, $25937fdb26d57abd$export$2e2bcd8739ae039)();
    return (dispatch)=>{
        let result;
        lfDataService.getNewAchievements().then((data)=>{
            result = data;
            dispatch($defc9e244fcd6007$var$fetchNewAchievements(result));
        }).catch((e1)=>{
            dispatch((0, $67f4b1d2fb7c2244$export$7a8bb273722d5103)(e1));
            dispatch((0, $67f4b1d2fb7c2244$export$ea4b4733f4ca2df0)(true));
            dispatch($defc9e244fcd6007$var$fetchAchievementsFailed(true));
        });
    };
};
const $defc9e244fcd6007$export$5cf7beec07b6fa2a = ()=>{
    const lfDataService = new (0, $25937fdb26d57abd$export$2e2bcd8739ae039)();
    return (dispatch)=>{
        lfDataService.submitViewedAchievements().then((result)=>{
            if (result.success) return;
            else {
                dispatch((0, $67f4b1d2fb7c2244$export$7a8bb273722d5103)(e));
                dispatch((0, $67f4b1d2fb7c2244$export$ea4b4733f4ca2df0)(true));
            }
        }).catch((e1)=>{
            dispatch((0, $67f4b1d2fb7c2244$export$7a8bb273722d5103)(e1));
            dispatch((0, $67f4b1d2fb7c2244$export$ea4b4733f4ca2df0)(true));
        });
    };
};



parcelRequire("8NFma");
var $2c1cc6e8319f49c7$exports = {};


(function(global, factory) {
    factory($2c1cc6e8319f49c7$exports, (parcelRequire("hnBya")), (parcelRequire("8NFma")));
})($2c1cc6e8319f49c7$exports, function(exports1, lottie, React) {
    'use strict';
    function _interopDefaultLegacy(e) {
        return e && typeof e === 'object' && 'default' in e ? e : {
            'default': e
        };
    }
    var lottie__default = /*#__PURE__*/ _interopDefaultLegacy(lottie);
    var React__default = /*#__PURE__*/ _interopDefaultLegacy(React);
    function _iterableToArrayLimit(arr, i) {
        var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
        if (null != _i) {
            var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
            try {
                if (_x = (_i = _i.call(arr)).next, 0 === i) {
                    if (Object(_i) !== _i) return;
                    _n = !1;
                } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
            } catch (err) {
                _d = !0, _e = err;
            } finally{
                try {
                    if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
                } finally{
                    if (_d) throw _e;
                }
            }
            return _arr;
        }
    }
    function ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            enumerableOnly && (symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            })), keys.push.apply(keys, symbols);
        }
        return keys;
    }
    function _objectSpread2(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = null != arguments[i] ? arguments[i] : {};
            i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
                _defineProperty(target, key, source[key]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target;
    }
    function _defineProperty(obj, key, value) {
        key = _toPropertyKey(key);
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function _objectWithoutPropertiesLoose(source, excluded) {
        if (source == null) return {};
        var target = {};
        var sourceKeys = Object.keys(source);
        var key, i;
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            target[key] = source[key];
        }
        return target;
    }
    function _objectWithoutProperties(source, excluded) {
        if (source == null) return {};
        var target = _objectWithoutPropertiesLoose(source, excluded);
        var key, i;
        if (Object.getOwnPropertySymbols) {
            var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
            for(i = 0; i < sourceSymbolKeys.length; i++){
                key = sourceSymbolKeys[i];
                if (excluded.indexOf(key) >= 0) continue;
                if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
                target[key] = source[key];
            }
        }
        return target;
    }
    function _slicedToArray(arr, i) {
        return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
    }
    function _arrayWithHoles(arr) {
        if (Array.isArray(arr)) return arr;
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _toPrimitive(input, hint) {
        if (typeof input !== "object" || input === null) return input;
        var prim = input[Symbol.toPrimitive];
        if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if (typeof res !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (hint === "string" ? String : Number)(input);
    }
    function _toPropertyKey(arg) {
        var key = _toPrimitive(arg, "string");
        return typeof key === "symbol" ? key : String(key);
    }
    var _excluded$1 = [
        "animationData",
        "loop",
        "autoplay",
        "initialSegment",
        "onComplete",
        "onLoopComplete",
        "onEnterFrame",
        "onSegmentStart",
        "onConfigReady",
        "onDataReady",
        "onDataFailed",
        "onLoadedImages",
        "onDOMLoaded",
        "onDestroy",
        "lottieRef",
        "renderer",
        "name",
        "assetsPath",
        "rendererSettings"
    ];
    var useLottie = function useLottie(props, style) {
        var animationData = props.animationData, loop = props.loop, autoplay = props.autoplay, initialSegment = props.initialSegment, onComplete = props.onComplete, onLoopComplete = props.onLoopComplete, onEnterFrame = props.onEnterFrame, onSegmentStart = props.onSegmentStart, onConfigReady = props.onConfigReady, onDataReady = props.onDataReady, onDataFailed = props.onDataFailed, onLoadedImages = props.onLoadedImages, onDOMLoaded = props.onDOMLoaded, onDestroy = props.onDestroy;
        props.lottieRef;
        props.renderer;
        props.name;
        props.assetsPath;
        props.rendererSettings;
        var rest = _objectWithoutProperties(props, _excluded$1);
        var _useState = React.useState(false), _useState2 = _slicedToArray(_useState, 2), animationLoaded = _useState2[0], setAnimationLoaded = _useState2[1];
        var animationInstanceRef = React.useRef();
        var animationContainer = React.useRef(null);
        /*
          ======================================
              INTERACTION METHODS
          ======================================
       */ /**
     * Play
     */ var play = function play() {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.play();
        };
        /**
     * Stop
     */ var stop = function stop() {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.stop();
        };
        /**
     * Pause
     */ var pause = function pause() {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.pause();
        };
        /**
     * Set animation speed
     * @param speed
     */ var setSpeed = function setSpeed(speed) {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.setSpeed(speed);
        };
        /**
     * Got to frame and play
     * @param value
     * @param isFrame
     */ var goToAndPlay = function goToAndPlay(value, isFrame) {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.goToAndPlay(value, isFrame);
        };
        /**
     * Got to frame and stop
     * @param value
     * @param isFrame
     */ var goToAndStop = function goToAndStop(value, isFrame) {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.goToAndStop(value, isFrame);
        };
        /**
     * Set animation direction
     * @param direction
     */ var setDirection = function setDirection(direction) {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.setDirection(direction);
        };
        /**
     * Play animation segments
     * @param segments
     * @param forceFlag
     */ var playSegments = function playSegments(segments, forceFlag) {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.playSegments(segments, forceFlag);
        };
        /**
     * Set sub frames
     * @param useSubFrames
     */ var setSubframe = function setSubframe(useSubFrames) {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.setSubframe(useSubFrames);
        };
        /**
     * Get animation duration
     * @param inFrames
     */ var getDuration = function getDuration(inFrames) {
            var _a;
            return (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.getDuration(inFrames);
        };
        /**
     * Destroy animation
     */ var destroy = function destroy() {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.destroy();
            // Removing the reference to the animation so separate cleanups are skipped.
            // Without it the internal `lottie-react` instance throws exceptions as it already cleared itself on destroy.
            animationInstanceRef.current = undefined;
        };
        /*
          ======================================
              LOTTIE
          ======================================
       */ /**
     * Load a new animation, and if it's the case, destroy the previous one
     * @param {Object} forcedConfigs
     */ var loadAnimation = function loadAnimation() {
            var forcedConfigs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var _a;
            // Return if the container ref is null
            if (!animationContainer.current) return;
            // Destroy any previous instance
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.destroy();
            // Build the animation configuration
            var config = _objectSpread2(_objectSpread2(_objectSpread2({}, props), forcedConfigs), {}, {
                container: animationContainer.current
            });
            // Save the animation instance
            animationInstanceRef.current = lottie__default["default"].loadAnimation(config);
            setAnimationLoaded(!!animationInstanceRef.current);
            // Return a function that will clean up
            return function() {
                var _a;
                (_a = animationInstanceRef.current) === null || _a === void 0 || _a.destroy();
                animationInstanceRef.current = undefined;
            };
        };
        /**
     * (Re)Initialize when animation data changed
     */ React.useEffect(function() {
            var onUnmount = loadAnimation();
            // Clean up on unmount
            return function() {
                return onUnmount === null || onUnmount === void 0 ? void 0 : onUnmount();
            };
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            animationData,
            loop
        ]);
        // Update the autoplay state
        React.useEffect(function() {
            if (!animationInstanceRef.current) return;
            animationInstanceRef.current.autoplay = !!autoplay;
        }, [
            autoplay
        ]);
        // Update the initial segment state
        React.useEffect(function() {
            if (!animationInstanceRef.current) return;
            // When null should reset to default animation length
            if (!initialSegment) {
                animationInstanceRef.current.resetSegments(true);
                return;
            }
            // If it's not a valid segment, do nothing
            if (!Array.isArray(initialSegment) || !initialSegment.length) return;
            // If the current position it's not in the new segment
            // set the current position to start
            if (animationInstanceRef.current.currentRawFrame < initialSegment[0] || animationInstanceRef.current.currentRawFrame > initialSegment[1]) animationInstanceRef.current.currentRawFrame = initialSegment[0];
            // Update the segment
            animationInstanceRef.current.setSegment(initialSegment[0], initialSegment[1]);
        }, [
            initialSegment
        ]);
        /*
          ======================================
              EVENTS
          ======================================
       */ /**
     * Reinitialize listener on change
     */ React.useEffect(function() {
            var partialListeners = [
                {
                    name: "complete",
                    handler: onComplete
                },
                {
                    name: "loopComplete",
                    handler: onLoopComplete
                },
                {
                    name: "enterFrame",
                    handler: onEnterFrame
                },
                {
                    name: "segmentStart",
                    handler: onSegmentStart
                },
                {
                    name: "config_ready",
                    handler: onConfigReady
                },
                {
                    name: "data_ready",
                    handler: onDataReady
                },
                {
                    name: "data_failed",
                    handler: onDataFailed
                },
                {
                    name: "loaded_images",
                    handler: onLoadedImages
                },
                {
                    name: "DOMLoaded",
                    handler: onDOMLoaded
                },
                {
                    name: "destroy",
                    handler: onDestroy
                }
            ];
            var listeners = partialListeners.filter(function(listener) {
                return listener.handler != null;
            });
            if (!listeners.length) return;
            var deregisterList = listeners.map(/**
       * Handle the process of adding an event listener
       * @param {Listener} listener
       * @return {Function} Function that deregister the listener
       */ function(listener) {
                var _a;
                (_a = animationInstanceRef.current) === null || _a === void 0 || _a.addEventListener(listener.name, listener.handler);
                // Return a function to deregister this listener
                return function() {
                    var _a;
                    (_a = animationInstanceRef.current) === null || _a === void 0 || _a.removeEventListener(listener.name, listener.handler);
                };
            });
            // Deregister listeners on unmount
            return function() {
                deregisterList.forEach(function(deregister) {
                    return deregister();
                });
            };
        }, [
            onComplete,
            onLoopComplete,
            onEnterFrame,
            onSegmentStart,
            onConfigReady,
            onDataReady,
            onDataFailed,
            onLoadedImages,
            onDOMLoaded,
            onDestroy
        ]);
        /**
     * Build the animation view
     */ var View = /*#__PURE__*/ React__default["default"].createElement("div", _objectSpread2({
            style: style,
            ref: animationContainer
        }, rest));
        return {
            View: View,
            play: play,
            stop: stop,
            pause: pause,
            setSpeed: setSpeed,
            goToAndStop: goToAndStop,
            goToAndPlay: goToAndPlay,
            setDirection: setDirection,
            playSegments: playSegments,
            setSubframe: setSubframe,
            getDuration: getDuration,
            destroy: destroy,
            animationContainerRef: animationContainer,
            animationLoaded: animationLoaded,
            animationItem: animationInstanceRef.current
        };
    };
    // helpers
    function getContainerVisibility(container) {
        var _container$getBoundin = container.getBoundingClientRect(), top = _container$getBoundin.top, height = _container$getBoundin.height;
        var current = window.innerHeight - top;
        var max = window.innerHeight + height;
        return current / max;
    }
    function getContainerCursorPosition(container, cursorX, cursorY) {
        var _container$getBoundin2 = container.getBoundingClientRect(), top = _container$getBoundin2.top, left = _container$getBoundin2.left, width = _container$getBoundin2.width, height = _container$getBoundin2.height;
        var x = (cursorX - left) / width;
        var y = (cursorY - top) / height;
        return {
            x: x,
            y: y
        };
    }
    var useInitInteractivity = function useInitInteractivity(_ref) {
        var wrapperRef = _ref.wrapperRef, animationItem = _ref.animationItem, mode = _ref.mode, actions = _ref.actions;
        React.useEffect(function() {
            var wrapper = wrapperRef.current;
            if (!wrapper || !animationItem || !actions.length) return;
            animationItem.stop();
            var scrollModeHandler = function scrollModeHandler() {
                var assignedSegment = null;
                var scrollHandler = function scrollHandler() {
                    var currentPercent = getContainerVisibility(wrapper);
                    // Find the first action that satisfies the current position conditions
                    var action = actions.find(function(_ref2) {
                        var visibility = _ref2.visibility;
                        return visibility && currentPercent >= visibility[0] && currentPercent <= visibility[1];
                    });
                    // Skip if no matching action was found!
                    if (!action) return;
                    if (action.type === "seek" && action.visibility && action.frames.length === 2) {
                        // Seek: Go to a frame based on player scroll position action
                        var frameToGo = action.frames[0] + Math.ceil((currentPercent - action.visibility[0]) / (action.visibility[1] - action.visibility[0]) * action.frames[1]);
                        //! goToAndStop must be relative to the start of the current segment
                        animationItem.goToAndStop(frameToGo - animationItem.firstFrame - 1, true);
                    }
                    if (action.type === "loop") {
                        // Loop: Loop a given frames
                        if (assignedSegment === null) {
                            // if not playing any segments currently. play those segments and save to state
                            animationItem.playSegments(action.frames, true);
                            assignedSegment = action.frames;
                        } else {
                            // if playing any segments currently.
                            //check if segments in state are equal to the frames selected by action
                            if (assignedSegment !== action.frames) {
                                // if they are not equal. new segments are to be loaded
                                animationItem.playSegments(action.frames, true);
                                assignedSegment = action.frames;
                            } else if (animationItem.isPaused) {
                                // if they are equal the play method must be called only if lottie is paused
                                animationItem.playSegments(action.frames, true);
                                assignedSegment = action.frames;
                            }
                        }
                    }
                    if (action.type === "play" && animationItem.isPaused) {
                        // Play: Reset segments and continue playing full animation from current position
                        animationItem.resetSegments(true);
                        animationItem.play();
                    }
                    if (action.type === "stop") // Stop: Stop playback
                    animationItem.goToAndStop(action.frames[0] - animationItem.firstFrame - 1, true);
                };
                document.addEventListener("scroll", scrollHandler);
                return function() {
                    document.removeEventListener("scroll", scrollHandler);
                };
            };
            var cursorModeHandler = function cursorModeHandler() {
                var handleCursor = function handleCursor(_x, _y) {
                    var x = _x;
                    var y = _y;
                    // Resolve cursor position if cursor is inside container
                    if (x !== -1 && y !== -1) {
                        // Get container cursor position
                        var pos = getContainerCursorPosition(wrapper, x, y);
                        // Use the resolved position
                        x = pos.x;
                        y = pos.y;
                    }
                    // Find the first action that satisfies the current position conditions
                    var action = actions.find(function(_ref3) {
                        var position = _ref3.position;
                        if (position && Array.isArray(position.x) && Array.isArray(position.y)) return x >= position.x[0] && x <= position.x[1] && y >= position.y[0] && y <= position.y[1];
                        if (position && !Number.isNaN(position.x) && !Number.isNaN(position.y)) return x === position.x && y === position.y;
                        return false;
                    });
                    // Skip if no matching action was found!
                    if (!action) return;
                    // Process action types:
                    if (action.type === "seek" && action.position && Array.isArray(action.position.x) && Array.isArray(action.position.y) && action.frames.length === 2) {
                        // Seek: Go to a frame based on player scroll position action
                        var xPercent = (x - action.position.x[0]) / (action.position.x[1] - action.position.x[0]);
                        var yPercent = (y - action.position.y[0]) / (action.position.y[1] - action.position.y[0]);
                        animationItem.playSegments(action.frames, true);
                        animationItem.goToAndStop(Math.ceil((xPercent + yPercent) / 2 * (action.frames[1] - action.frames[0])), true);
                    }
                    if (action.type === "loop") animationItem.playSegments(action.frames, true);
                    if (action.type === "play") {
                        // Play: Reset segments and continue playing full animation from current position
                        if (animationItem.isPaused) animationItem.resetSegments(false);
                        animationItem.playSegments(action.frames);
                    }
                    if (action.type === "stop") animationItem.goToAndStop(action.frames[0], true);
                };
                var mouseMoveHandler = function mouseMoveHandler(ev) {
                    handleCursor(ev.clientX, ev.clientY);
                };
                var mouseOutHandler = function mouseOutHandler() {
                    handleCursor(-1, -1);
                };
                wrapper.addEventListener("mousemove", mouseMoveHandler);
                wrapper.addEventListener("mouseout", mouseOutHandler);
                return function() {
                    wrapper.removeEventListener("mousemove", mouseMoveHandler);
                    wrapper.removeEventListener("mouseout", mouseOutHandler);
                };
            };
            switch(mode){
                case "scroll":
                    return scrollModeHandler();
                case "cursor":
                    return cursorModeHandler();
            }
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            mode,
            animationItem
        ]);
    };
    var useLottieInteractivity = function useLottieInteractivity(_ref4) {
        var actions = _ref4.actions, mode = _ref4.mode, lottieObj = _ref4.lottieObj;
        var animationItem = lottieObj.animationItem, View = lottieObj.View, animationContainerRef = lottieObj.animationContainerRef;
        useInitInteractivity({
            actions: actions,
            animationItem: animationItem,
            mode: mode,
            wrapperRef: animationContainerRef
        });
        return View;
    };
    var _excluded = [
        "style",
        "interactivity"
    ];
    var Lottie = function Lottie(props) {
        var _a, _b, _c;
        var style = props.style, interactivity = props.interactivity, lottieProps = _objectWithoutProperties(props, _excluded);
        /**
     * Initialize the 'useLottie' hook
     */ var _useLottie = useLottie(lottieProps, style), View = _useLottie.View, play = _useLottie.play, stop = _useLottie.stop, pause = _useLottie.pause, setSpeed = _useLottie.setSpeed, goToAndStop = _useLottie.goToAndStop, goToAndPlay = _useLottie.goToAndPlay, setDirection = _useLottie.setDirection, playSegments = _useLottie.playSegments, setSubframe = _useLottie.setSubframe, getDuration = _useLottie.getDuration, destroy = _useLottie.destroy, animationContainerRef = _useLottie.animationContainerRef, animationLoaded = _useLottie.animationLoaded, animationItem = _useLottie.animationItem;
        /**
     * Make the hook variables/methods available through the provided 'lottieRef'
     */ React.useEffect(function() {
            if (props.lottieRef) props.lottieRef.current = {
                play: play,
                stop: stop,
                pause: pause,
                setSpeed: setSpeed,
                goToAndPlay: goToAndPlay,
                goToAndStop: goToAndStop,
                setDirection: setDirection,
                playSegments: playSegments,
                setSubframe: setSubframe,
                getDuration: getDuration,
                destroy: destroy,
                animationContainerRef: animationContainerRef,
                animationLoaded: animationLoaded,
                animationItem: animationItem
            };
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            (_a = props.lottieRef) === null || _a === void 0 ? void 0 : _a.current
        ]);
        return useLottieInteractivity({
            lottieObj: {
                View: View,
                play: play,
                stop: stop,
                pause: pause,
                setSpeed: setSpeed,
                goToAndStop: goToAndStop,
                goToAndPlay: goToAndPlay,
                setDirection: setDirection,
                playSegments: playSegments,
                setSubframe: setSubframe,
                getDuration: getDuration,
                destroy: destroy,
                animationContainerRef: animationContainerRef,
                animationLoaded: animationLoaded,
                animationItem: animationItem
            },
            actions: (_b = interactivity === null || interactivity === void 0 ? void 0 : interactivity.actions) !== null && _b !== void 0 ? _b : [],
            mode: (_c = interactivity === null || interactivity === void 0 ? void 0 : interactivity.mode) !== null && _c !== void 0 ? _c : "scroll"
        });
    };
    Object.defineProperty(exports1, 'LottiePlayer', {
        enumerable: true,
        get: function() {
            return lottie__default["default"];
        }
    });
    exports1["default"] = Lottie;
    exports1.useLottie = useLottie;
    exports1.useLottieInteractivity = useLottieInteractivity;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});


var $d26f4d72fc067362$exports = {};
$d26f4d72fc067362$exports = JSON.parse("{\"v\":\"5.7.13\",\"fr\":30,\"ip\":0,\"op\":120,\"w\":32,\"h\":32,\"nm\":\"info_i_blue 2\",\"ddd\":0,\"assets\":[],\"layers\":[{\"ddd\":0,\"ind\":1,\"ty\":4,\"nm\":\"ring 2\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[16,16,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[-1.868,0.632,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"d\":1,\"ty\":\"el\",\"s\":{\"a\":0,\"k\":[28,28],\"ix\":2},\"p\":{\"a\":0,\"k\":[0,0],\"ix\":3},\"nm\":\"Ellipse Path 1\",\"mn\":\"ADBE Vector Shape - Ellipse\",\"hd\":false},{\"ty\":\"st\",\"c\":{\"a\":0,\"k\":[0.294117647059,0.623529411765,0.823529471603,1],\"ix\":3},\"o\":{\"a\":0,\"k\":100,\"ix\":4},\"w\":{\"a\":0,\"k\":3,\"ix\":5},\"lc\":2,\"lj\":1,\"ml\":4,\"bm\":0,\"nm\":\"Stroke 1\",\"mn\":\"ADBE Vector Graphic - Stroke\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[-1.868,0.632],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Ellipse 1\",\"np\":3,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"tm\",\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":63,\"s\":[0]},{\"t\":120,\"s\":[0]}],\"ix\":1},\"e\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":63,\"s\":[0]},{\"t\":120,\"s\":[100]}],\"ix\":2},\"o\":{\"a\":0,\"k\":0,\"ix\":3},\"m\":1,\"ix\":2,\"nm\":\"Trim Paths 1\",\"mn\":\"ADBE Vector Filter - Trim\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"d\":1,\"ty\":\"el\",\"s\":{\"a\":0,\"k\":[51.926,54.526],\"ix\":2},\"p\":{\"a\":0,\"k\":[0,0],\"ix\":3},\"nm\":\"Ellipse Path 1\",\"mn\":\"ADBE Vector Shape - Ellipse\",\"hd\":false},{\"ty\":\"st\",\"c\":{\"a\":0,\"k\":[0.294117647059,0.623529411765,0.823529471603,1],\"ix\":3},\"o\":{\"a\":0,\"k\":100,\"ix\":4},\"w\":{\"a\":0,\"k\":4,\"ix\":5},\"lc\":1,\"lj\":1,\"ml\":4,\"bm\":0,\"nm\":\"Stroke 1\",\"mn\":\"ADBE Vector Graphic - Stroke\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[-620.287,-22.987],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Ellipse 2\",\"np\":3,\"cix\":2,\"bm\":0,\"ix\":3,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":63,\"op\":120,\"st\":61,\"bm\":0},{\"ddd\":0,\"ind\":2,\"ty\":4,\"nm\":\"ring\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[16,16,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[-1.868,0.632,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"d\":1,\"ty\":\"el\",\"s\":{\"a\":0,\"k\":[28,28],\"ix\":2},\"p\":{\"a\":0,\"k\":[0,0],\"ix\":3},\"nm\":\"Ellipse Path 1\",\"mn\":\"ADBE Vector Shape - Ellipse\",\"hd\":false},{\"ty\":\"st\",\"c\":{\"a\":0,\"k\":[0.294117647059,0.623529411765,0.823529471603,1],\"ix\":3},\"o\":{\"a\":0,\"k\":100,\"ix\":4},\"w\":{\"a\":0,\"k\":3,\"ix\":5},\"lc\":2,\"lj\":1,\"ml\":4,\"bm\":0,\"nm\":\"Stroke 1\",\"mn\":\"ADBE Vector Graphic - Stroke\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[-1.868,0.632],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Ellipse 1\",\"np\":3,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"tm\",\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":0,\"s\":[0]},{\"t\":60,\"s\":[100]}],\"ix\":1},\"e\":{\"a\":0,\"k\":100,\"ix\":2},\"o\":{\"a\":0,\"k\":0,\"ix\":3},\"m\":1,\"ix\":2,\"nm\":\"Trim Paths 1\",\"mn\":\"ADBE Vector Filter - Trim\",\"hd\":false}],\"ip\":0,\"op\":60,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":3,\"ty\":4,\"nm\":\"i\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[16,16,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[16.5,16.02,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0.8,0],[0,0.8],[0,0],[-0.8,0],[0,-0.8]],\"o\":[[0,0.8],[-0.8,0],[0,0],[0,-0.8],[0.8,0],[0,0]],\"v\":[[1.6,3.2],[0,4.8],[-1.6,3.2],[-1.6,-3.2],[0,-4.8],[1.6,-3.2]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.294117647059,0.623529411765,0.823529471603,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[16.5,19.2],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0.16,-0.16],[0.8,0.48],[0.16,0.16],[0,0.48],[-0.16,0.16],[-0.16,0.16],[-0.16,0],[-0.48,-0.16],[-0.16,-0.16],[0,-0.48]],\"o\":[[-0.32,0.8],[-0.16,0],[-0.32,-0.32],[0,-0.16],[0,-0.16],[0.16,-0.16],[0.32,-0.16],[0.16,0],[0.32,0.32],[0,0.16]],\"v\":[[1.44,0.48],[-0.64,1.28],[-1.12,0.96],[-1.6,-0.16],[-1.44,-0.8],[-1.12,-1.28],[-0.64,-1.6],[0.64,-1.6],[1.12,-1.28],[1.6,-0.16]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.294117647059,0.623529411765,0.823529471603,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[16.5,9.76],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 2\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":120,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":4,\"ty\":4,\"nm\":\"ring 3\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":40,\"ix\":11},\"r\":{\"a\":0,\"k\":180,\"ix\":10},\"p\":{\"a\":0,\"k\":[16,16,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[-1.868,0.632,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"d\":1,\"ty\":\"el\",\"s\":{\"a\":0,\"k\":[28,28],\"ix\":2},\"p\":{\"a\":0,\"k\":[0,0],\"ix\":3},\"nm\":\"Ellipse Path 1\",\"mn\":\"ADBE Vector Shape - Ellipse\",\"hd\":false},{\"ty\":\"st\",\"c\":{\"a\":0,\"k\":[0.294117647059,0.623529411765,0.823529471603,1],\"ix\":3},\"o\":{\"a\":0,\"k\":100,\"ix\":4},\"w\":{\"a\":0,\"k\":3,\"ix\":5},\"lc\":2,\"lj\":1,\"ml\":4,\"bm\":0,\"nm\":\"Stroke 1\",\"mn\":\"ADBE Vector Graphic - Stroke\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[-1.868,0.632],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Ellipse 1\",\"np\":3,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":120,\"st\":0,\"bm\":0}],\"markers\":[]}");


const $1c6fe1315a0b413a$var$InfoLoader = (props)=>{
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
        className: "info-loader",
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2c1cc6e8319f49c7$exports))), {
                className: "info-loader__animation",
                autoplay: true,
                loop: true,
                animationData: (0, (/*@__PURE__*/$parcel$interopDefault($d26f4d72fc067362$exports)))
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("p", {
                className: "info-loader__text",
                children: props.loaderText
            })
        ]
    });
};
var $1c6fe1315a0b413a$export$2e2bcd8739ae039 = $1c6fe1315a0b413a$var$InfoLoader;




var $8NFma = parcelRequire("8NFma");




var $8NFma = parcelRequire("8NFma");

// src/index.ts
// src/hooks/useChain.ts
// src/index.ts
var $14f355fb1db5a5c1$var$updateQueue = $14f355fb1db5a5c1$var$makeQueue();
var $14f355fb1db5a5c1$export$27f233d61a9e2fa4 = (fn)=>$14f355fb1db5a5c1$var$schedule(fn, $14f355fb1db5a5c1$var$updateQueue);
var $14f355fb1db5a5c1$var$writeQueue = $14f355fb1db5a5c1$var$makeQueue();
$14f355fb1db5a5c1$export$27f233d61a9e2fa4.write = (fn)=>$14f355fb1db5a5c1$var$schedule(fn, $14f355fb1db5a5c1$var$writeQueue);
var $14f355fb1db5a5c1$var$onStartQueue = $14f355fb1db5a5c1$var$makeQueue();
$14f355fb1db5a5c1$export$27f233d61a9e2fa4.onStart = (fn)=>$14f355fb1db5a5c1$var$schedule(fn, $14f355fb1db5a5c1$var$onStartQueue);
var $14f355fb1db5a5c1$var$onFrameQueue = $14f355fb1db5a5c1$var$makeQueue();
$14f355fb1db5a5c1$export$27f233d61a9e2fa4.onFrame = (fn)=>$14f355fb1db5a5c1$var$schedule(fn, $14f355fb1db5a5c1$var$onFrameQueue);
var $14f355fb1db5a5c1$var$onFinishQueue = $14f355fb1db5a5c1$var$makeQueue();
$14f355fb1db5a5c1$export$27f233d61a9e2fa4.onFinish = (fn)=>$14f355fb1db5a5c1$var$schedule(fn, $14f355fb1db5a5c1$var$onFinishQueue);
var $14f355fb1db5a5c1$var$timeouts = [];
$14f355fb1db5a5c1$export$27f233d61a9e2fa4.setTimeout = (handler, ms)=>{
    const time = $14f355fb1db5a5c1$export$27f233d61a9e2fa4.now() + ms;
    const cancel = ()=>{
        const i = $14f355fb1db5a5c1$var$timeouts.findIndex((t)=>t.cancel == cancel);
        if (~i) $14f355fb1db5a5c1$var$timeouts.splice(i, 1);
        $14f355fb1db5a5c1$var$pendingCount -= ~i ? 1 : 0;
    };
    const timeout = {
        time: time,
        handler: handler,
        cancel: cancel
    };
    $14f355fb1db5a5c1$var$timeouts.splice($14f355fb1db5a5c1$var$findTimeout(time), 0, timeout);
    $14f355fb1db5a5c1$var$pendingCount += 1;
    $14f355fb1db5a5c1$var$start();
    return timeout;
};
var $14f355fb1db5a5c1$var$findTimeout = (time)=>~(~$14f355fb1db5a5c1$var$timeouts.findIndex((t)=>t.time > time) || ~$14f355fb1db5a5c1$var$timeouts.length);
$14f355fb1db5a5c1$export$27f233d61a9e2fa4.cancel = (fn)=>{
    $14f355fb1db5a5c1$var$onStartQueue.delete(fn);
    $14f355fb1db5a5c1$var$onFrameQueue.delete(fn);
    $14f355fb1db5a5c1$var$onFinishQueue.delete(fn);
    $14f355fb1db5a5c1$var$updateQueue.delete(fn);
    $14f355fb1db5a5c1$var$writeQueue.delete(fn);
};
$14f355fb1db5a5c1$export$27f233d61a9e2fa4.sync = (fn)=>{
    $14f355fb1db5a5c1$var$sync = true;
    $14f355fb1db5a5c1$export$27f233d61a9e2fa4.batchedUpdates(fn);
    $14f355fb1db5a5c1$var$sync = false;
};
$14f355fb1db5a5c1$export$27f233d61a9e2fa4.throttle = (fn)=>{
    let lastArgs;
    function queuedFn() {
        try {
            fn(...lastArgs);
        } finally{
            lastArgs = null;
        }
    }
    function throttled(...args) {
        lastArgs = args;
        $14f355fb1db5a5c1$export$27f233d61a9e2fa4.onStart(queuedFn);
    }
    throttled.handler = fn;
    throttled.cancel = ()=>{
        $14f355fb1db5a5c1$var$onStartQueue.delete(queuedFn);
        lastArgs = null;
    };
    return throttled;
};
var $14f355fb1db5a5c1$var$nativeRaf = typeof window != "undefined" ? window.requestAnimationFrame : // eslint-disable-next-line @typescript-eslint/no-empty-function
()=>{};
$14f355fb1db5a5c1$export$27f233d61a9e2fa4.use = (impl)=>$14f355fb1db5a5c1$var$nativeRaf = impl;
$14f355fb1db5a5c1$export$27f233d61a9e2fa4.now = typeof performance != "undefined" ? ()=>performance.now() : Date.now;
$14f355fb1db5a5c1$export$27f233d61a9e2fa4.batchedUpdates = (fn)=>fn();
$14f355fb1db5a5c1$export$27f233d61a9e2fa4.catch = console.error;
$14f355fb1db5a5c1$export$27f233d61a9e2fa4.frameLoop = "always";
$14f355fb1db5a5c1$export$27f233d61a9e2fa4.advance = ()=>{
    if ($14f355fb1db5a5c1$export$27f233d61a9e2fa4.frameLoop !== "demand") console.warn("Cannot call the manual advancement of rafz whilst frameLoop is not set as demand");
    else $14f355fb1db5a5c1$var$update();
};
var $14f355fb1db5a5c1$var$ts = -1;
var $14f355fb1db5a5c1$var$pendingCount = 0;
var $14f355fb1db5a5c1$var$sync = false;
function $14f355fb1db5a5c1$var$schedule(fn, queue) {
    if ($14f355fb1db5a5c1$var$sync) {
        queue.delete(fn);
        fn(0);
    } else {
        queue.add(fn);
        $14f355fb1db5a5c1$var$start();
    }
}
function $14f355fb1db5a5c1$var$start() {
    if ($14f355fb1db5a5c1$var$ts < 0) {
        $14f355fb1db5a5c1$var$ts = 0;
        if ($14f355fb1db5a5c1$export$27f233d61a9e2fa4.frameLoop !== "demand") $14f355fb1db5a5c1$var$nativeRaf($14f355fb1db5a5c1$var$loop);
    }
}
function $14f355fb1db5a5c1$var$stop() {
    $14f355fb1db5a5c1$var$ts = -1;
}
function $14f355fb1db5a5c1$var$loop() {
    if (~$14f355fb1db5a5c1$var$ts) {
        $14f355fb1db5a5c1$var$nativeRaf($14f355fb1db5a5c1$var$loop);
        $14f355fb1db5a5c1$export$27f233d61a9e2fa4.batchedUpdates($14f355fb1db5a5c1$var$update);
    }
}
function $14f355fb1db5a5c1$var$update() {
    const prevTs = $14f355fb1db5a5c1$var$ts;
    $14f355fb1db5a5c1$var$ts = $14f355fb1db5a5c1$export$27f233d61a9e2fa4.now();
    const count = $14f355fb1db5a5c1$var$findTimeout($14f355fb1db5a5c1$var$ts);
    if (count) {
        $14f355fb1db5a5c1$var$eachSafely($14f355fb1db5a5c1$var$timeouts.splice(0, count), (t)=>t.handler());
        $14f355fb1db5a5c1$var$pendingCount -= count;
    }
    if (!$14f355fb1db5a5c1$var$pendingCount) {
        $14f355fb1db5a5c1$var$stop();
        return;
    }
    $14f355fb1db5a5c1$var$onStartQueue.flush();
    $14f355fb1db5a5c1$var$updateQueue.flush(prevTs ? Math.min(64, $14f355fb1db5a5c1$var$ts - prevTs) : 16.667);
    $14f355fb1db5a5c1$var$onFrameQueue.flush();
    $14f355fb1db5a5c1$var$writeQueue.flush();
    $14f355fb1db5a5c1$var$onFinishQueue.flush();
}
function $14f355fb1db5a5c1$var$makeQueue() {
    let next = /* @__PURE__ */ new Set();
    let current = next;
    return {
        add (fn) {
            $14f355fb1db5a5c1$var$pendingCount += current == next && !next.has(fn) ? 1 : 0;
            next.add(fn);
        },
        delete (fn) {
            $14f355fb1db5a5c1$var$pendingCount -= current == next && next.has(fn) ? 1 : 0;
            return next.delete(fn);
        },
        flush (arg) {
            if (current.size) {
                next = /* @__PURE__ */ new Set();
                $14f355fb1db5a5c1$var$pendingCount -= current.size;
                $14f355fb1db5a5c1$var$eachSafely(current, (fn)=>fn(arg) && next.add(fn));
                $14f355fb1db5a5c1$var$pendingCount += next.size;
                current = next;
            }
        }
    };
}
function $14f355fb1db5a5c1$var$eachSafely(values, each) {
    values.forEach((value)=>{
        try {
            each(value);
        } catch (e) {
            $14f355fb1db5a5c1$export$27f233d61a9e2fa4.catch(e);
        }
    });
}
var $14f355fb1db5a5c1$export$ef91a23fc803e177 = {
    /** The number of pending tasks */ count () {
        return $14f355fb1db5a5c1$var$pendingCount;
    },
    /** Whether there's a raf update loop running */ isRunning () {
        return $14f355fb1db5a5c1$var$ts >= 0;
    },
    /** Clear internal state. Never call from update loop! */ clear () {
        $14f355fb1db5a5c1$var$ts = -1;
        $14f355fb1db5a5c1$var$timeouts = [];
        $14f355fb1db5a5c1$var$onStartQueue = $14f355fb1db5a5c1$var$makeQueue();
        $14f355fb1db5a5c1$var$updateQueue = $14f355fb1db5a5c1$var$makeQueue();
        $14f355fb1db5a5c1$var$onFrameQueue = $14f355fb1db5a5c1$var$makeQueue();
        $14f355fb1db5a5c1$var$writeQueue = $14f355fb1db5a5c1$var$makeQueue();
        $14f355fb1db5a5c1$var$onFinishQueue = $14f355fb1db5a5c1$var$makeQueue();
        $14f355fb1db5a5c1$var$pendingCount = 0;
    }
};



var $8NFma = parcelRequire("8NFma");
var $0188c8620d3f23ab$var$__defProp = Object.defineProperty;
var $0188c8620d3f23ab$var$__export = (target, all)=>{
    for(var name in all)$0188c8620d3f23ab$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
// src/globals.ts
var $0188c8620d3f23ab$export$cceeabf822b64fc0 = {};
$0188c8620d3f23ab$var$__export($0188c8620d3f23ab$export$cceeabf822b64fc0, {
    assign: ()=>$0188c8620d3f23ab$var$assign,
    colors: ()=>$0188c8620d3f23ab$var$colors,
    createStringInterpolator: ()=>$0188c8620d3f23ab$var$createStringInterpolator,
    skipAnimation: ()=>$0188c8620d3f23ab$var$skipAnimation,
    to: ()=>$0188c8620d3f23ab$var$to,
    willAdvance: ()=>$0188c8620d3f23ab$var$willAdvance
});
// src/helpers.ts
function $0188c8620d3f23ab$export$8793edee2d425525() {}
var $0188c8620d3f23ab$export$5c74248ea0e35446 = (obj, key, value)=>Object.defineProperty(obj, key, {
        value: value,
        writable: true,
        configurable: true
    });
var $0188c8620d3f23ab$export$226b3eccf92c9ed9 = {
    arr: Array.isArray,
    obj: (a)=>!!a && a.constructor.name === "Object",
    fun: (a)=>typeof a === "function",
    str: (a)=>typeof a === "string",
    num: (a)=>typeof a === "number",
    und: (a)=>a === void 0
};
function $0188c8620d3f23ab$export$248d38f6296296c5(a, b) {
    if ($0188c8620d3f23ab$export$226b3eccf92c9ed9.arr(a)) {
        if (!$0188c8620d3f23ab$export$226b3eccf92c9ed9.arr(b) || a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    return a === b;
}
var $0188c8620d3f23ab$export$79b2f7037acddd43 = (obj, fn)=>obj.forEach(fn);
function $0188c8620d3f23ab$export$f4c6fe153f5a944e(obj, fn, ctx) {
    if ($0188c8620d3f23ab$export$226b3eccf92c9ed9.arr(obj)) {
        for(let i = 0; i < obj.length; i++)fn.call(ctx, obj[i], `${i}`);
        return;
    }
    for(const key in obj)if (obj.hasOwnProperty(key)) fn.call(ctx, obj[key], key);
}
var $0188c8620d3f23ab$export$45b10814cc054894 = (a)=>$0188c8620d3f23ab$export$226b3eccf92c9ed9.und(a) ? [] : $0188c8620d3f23ab$export$226b3eccf92c9ed9.arr(a) ? a : [
        a
    ];
function $0188c8620d3f23ab$export$4909b86c8034bf73(queue, iterator) {
    if (queue.size) {
        const items = Array.from(queue);
        queue.clear();
        $0188c8620d3f23ab$export$79b2f7037acddd43(items, iterator);
    }
}
var $0188c8620d3f23ab$export$7ba486852759e806 = (queue, ...args)=>$0188c8620d3f23ab$export$4909b86c8034bf73(queue, (fn)=>fn(...args));
var $0188c8620d3f23ab$export$48d7c418edadb60c = ()=>typeof window === "undefined" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent);
// src/globals.ts
var $0188c8620d3f23ab$var$createStringInterpolator;
var $0188c8620d3f23ab$var$to;
var $0188c8620d3f23ab$var$colors = null;
var $0188c8620d3f23ab$var$skipAnimation = false;
var $0188c8620d3f23ab$var$willAdvance = $0188c8620d3f23ab$export$8793edee2d425525;
var $0188c8620d3f23ab$var$assign = (globals)=>{
    if (globals.to) $0188c8620d3f23ab$var$to = globals.to;
    if (globals.now) (0, $14f355fb1db5a5c1$export$27f233d61a9e2fa4).now = globals.now;
    if (globals.colors !== void 0) $0188c8620d3f23ab$var$colors = globals.colors;
    if (globals.skipAnimation != null) $0188c8620d3f23ab$var$skipAnimation = globals.skipAnimation;
    if (globals.createStringInterpolator) $0188c8620d3f23ab$var$createStringInterpolator = globals.createStringInterpolator;
    if (globals.requestAnimationFrame) (0, $14f355fb1db5a5c1$export$27f233d61a9e2fa4).use(globals.requestAnimationFrame);
    if (globals.batchedUpdates) (0, $14f355fb1db5a5c1$export$27f233d61a9e2fa4).batchedUpdates = globals.batchedUpdates;
    if (globals.willAdvance) $0188c8620d3f23ab$var$willAdvance = globals.willAdvance;
    if (globals.frameLoop) (0, $14f355fb1db5a5c1$export$27f233d61a9e2fa4).frameLoop = globals.frameLoop;
};
var $0188c8620d3f23ab$var$startQueue = /* @__PURE__ */ new Set();
var $0188c8620d3f23ab$var$currentFrame = [];
var $0188c8620d3f23ab$var$prevFrame = [];
var $0188c8620d3f23ab$var$priority = 0;
var $0188c8620d3f23ab$export$a57f5080a3bcc90a = {
    get idle () {
        return !$0188c8620d3f23ab$var$startQueue.size && !$0188c8620d3f23ab$var$currentFrame.length;
    },
    /** Advance the given animation on every frame until idle. */ start (animation) {
        if ($0188c8620d3f23ab$var$priority > animation.priority) {
            $0188c8620d3f23ab$var$startQueue.add(animation);
            (0, $14f355fb1db5a5c1$export$27f233d61a9e2fa4).onStart($0188c8620d3f23ab$var$flushStartQueue);
        } else {
            $0188c8620d3f23ab$var$startSafely(animation);
            (0, $14f355fb1db5a5c1$export$27f233d61a9e2fa4)($0188c8620d3f23ab$var$advance);
        }
    },
    advance: /** Advance all animations by the given time. */ $0188c8620d3f23ab$var$advance,
    /** Call this when an animation's priority changes. */ sort (animation) {
        if ($0188c8620d3f23ab$var$priority) (0, $14f355fb1db5a5c1$export$27f233d61a9e2fa4).onFrame(()=>$0188c8620d3f23ab$export$a57f5080a3bcc90a.sort(animation));
        else {
            const prevIndex = $0188c8620d3f23ab$var$currentFrame.indexOf(animation);
            if (~prevIndex) {
                $0188c8620d3f23ab$var$currentFrame.splice(prevIndex, 1);
                $0188c8620d3f23ab$var$startUnsafely(animation);
            }
        }
    },
    /**
   * Clear all animations. For testing purposes.
   *
   * ☠️ Never call this from within the frameloop.
   */ clear () {
        $0188c8620d3f23ab$var$currentFrame = [];
        $0188c8620d3f23ab$var$startQueue.clear();
    }
};
function $0188c8620d3f23ab$var$flushStartQueue() {
    $0188c8620d3f23ab$var$startQueue.forEach($0188c8620d3f23ab$var$startSafely);
    $0188c8620d3f23ab$var$startQueue.clear();
    (0, $14f355fb1db5a5c1$export$27f233d61a9e2fa4)($0188c8620d3f23ab$var$advance);
}
function $0188c8620d3f23ab$var$startSafely(animation) {
    if (!$0188c8620d3f23ab$var$currentFrame.includes(animation)) $0188c8620d3f23ab$var$startUnsafely(animation);
}
function $0188c8620d3f23ab$var$startUnsafely(animation) {
    $0188c8620d3f23ab$var$currentFrame.splice($0188c8620d3f23ab$var$findIndex($0188c8620d3f23ab$var$currentFrame, (other)=>other.priority > animation.priority), 0, animation);
}
function $0188c8620d3f23ab$var$advance(dt) {
    const nextFrame = $0188c8620d3f23ab$var$prevFrame;
    for(let i = 0; i < $0188c8620d3f23ab$var$currentFrame.length; i++){
        const animation = $0188c8620d3f23ab$var$currentFrame[i];
        $0188c8620d3f23ab$var$priority = animation.priority;
        if (!animation.idle) {
            $0188c8620d3f23ab$var$willAdvance(animation);
            animation.advance(dt);
            if (!animation.idle) nextFrame.push(animation);
        }
    }
    $0188c8620d3f23ab$var$priority = 0;
    $0188c8620d3f23ab$var$prevFrame = $0188c8620d3f23ab$var$currentFrame;
    $0188c8620d3f23ab$var$prevFrame.length = 0;
    $0188c8620d3f23ab$var$currentFrame = nextFrame;
    return $0188c8620d3f23ab$var$currentFrame.length > 0;
}
function $0188c8620d3f23ab$var$findIndex(arr, test) {
    const index = arr.findIndex(test);
    return index < 0 ? arr.length : index;
}
// src/clamp.ts
var $0188c8620d3f23ab$export$7d15b64cf5a3a4c4 = (min, max, v)=>Math.min(Math.max(v, min), max);
// src/colors.ts
var $0188c8620d3f23ab$export$8f45430ccf837300 = {
    transparent: 0,
    aliceblue: 4042850303,
    antiquewhite: 4209760255,
    aqua: 16777215,
    aquamarine: 2147472639,
    azure: 4043309055,
    beige: 4126530815,
    bisque: 4293182719,
    black: 255,
    blanchedalmond: 4293643775,
    blue: 65535,
    blueviolet: 2318131967,
    brown: 2771004159,
    burlywood: 3736635391,
    burntsienna: 3934150143,
    cadetblue: 1604231423,
    chartreuse: 2147418367,
    chocolate: 3530104575,
    coral: 4286533887,
    cornflowerblue: 1687547391,
    cornsilk: 4294499583,
    crimson: 3692313855,
    cyan: 16777215,
    darkblue: 35839,
    darkcyan: 9145343,
    darkgoldenrod: 3095792639,
    darkgray: 2846468607,
    darkgreen: 6553855,
    darkgrey: 2846468607,
    darkkhaki: 3182914559,
    darkmagenta: 2332068863,
    darkolivegreen: 1433087999,
    darkorange: 4287365375,
    darkorchid: 2570243327,
    darkred: 2332033279,
    darksalmon: 3918953215,
    darkseagreen: 2411499519,
    darkslateblue: 1211993087,
    darkslategray: 793726975,
    darkslategrey: 793726975,
    darkturquoise: 13554175,
    darkviolet: 2483082239,
    deeppink: 4279538687,
    deepskyblue: 12582911,
    dimgray: 1768516095,
    dimgrey: 1768516095,
    dodgerblue: 512819199,
    firebrick: 2988581631,
    floralwhite: 4294635775,
    forestgreen: 579543807,
    fuchsia: 4278255615,
    gainsboro: 3705462015,
    ghostwhite: 4177068031,
    gold: 4292280575,
    goldenrod: 3668254975,
    gray: 2155905279,
    green: 8388863,
    greenyellow: 2919182335,
    grey: 2155905279,
    honeydew: 4043305215,
    hotpink: 4285117695,
    indianred: 3445382399,
    indigo: 1258324735,
    ivory: 4294963455,
    khaki: 4041641215,
    lavender: 3873897215,
    lavenderblush: 4293981695,
    lawngreen: 2096890111,
    lemonchiffon: 4294626815,
    lightblue: 2916673279,
    lightcoral: 4034953471,
    lightcyan: 3774873599,
    lightgoldenrodyellow: 4210742015,
    lightgray: 3553874943,
    lightgreen: 2431553791,
    lightgrey: 3553874943,
    lightpink: 4290167295,
    lightsalmon: 4288707327,
    lightseagreen: 548580095,
    lightskyblue: 2278488831,
    lightslategray: 2005441023,
    lightslategrey: 2005441023,
    lightsteelblue: 2965692159,
    lightyellow: 4294959359,
    lime: 16711935,
    limegreen: 852308735,
    linen: 4210091775,
    magenta: 4278255615,
    maroon: 2147483903,
    mediumaquamarine: 1724754687,
    mediumblue: 52735,
    mediumorchid: 3126187007,
    mediumpurple: 2473647103,
    mediumseagreen: 1018393087,
    mediumslateblue: 2070474495,
    mediumspringgreen: 16423679,
    mediumturquoise: 1221709055,
    mediumvioletred: 3340076543,
    midnightblue: 421097727,
    mintcream: 4127193855,
    mistyrose: 4293190143,
    moccasin: 4293178879,
    navajowhite: 4292783615,
    navy: 33023,
    oldlace: 4260751103,
    olive: 2155872511,
    olivedrab: 1804477439,
    orange: 4289003775,
    orangered: 4282712319,
    orchid: 3664828159,
    palegoldenrod: 4008225535,
    palegreen: 2566625535,
    paleturquoise: 2951671551,
    palevioletred: 3681588223,
    papayawhip: 4293907967,
    peachpuff: 4292524543,
    peru: 3448061951,
    pink: 4290825215,
    plum: 3718307327,
    powderblue: 2967529215,
    purple: 2147516671,
    rebeccapurple: 1714657791,
    red: 4278190335,
    rosybrown: 3163525119,
    royalblue: 1097458175,
    saddlebrown: 2336560127,
    salmon: 4202722047,
    sandybrown: 4104413439,
    seagreen: 780883967,
    seashell: 4294307583,
    sienna: 2689740287,
    silver: 3233857791,
    skyblue: 2278484991,
    slateblue: 1784335871,
    slategray: 1887473919,
    slategrey: 1887473919,
    snow: 4294638335,
    springgreen: 16744447,
    steelblue: 1182971135,
    tan: 3535047935,
    teal: 8421631,
    thistle: 3636451583,
    tomato: 4284696575,
    turquoise: 1088475391,
    violet: 4001558271,
    wheat: 4125012991,
    white: 4294967295,
    whitesmoke: 4126537215,
    yellow: 4294902015,
    yellowgreen: 2597139199
};
// src/colorMatchers.ts
var $0188c8620d3f23ab$var$NUMBER = "[-+]?\\d*\\.?\\d+";
var $0188c8620d3f23ab$var$PERCENTAGE = $0188c8620d3f23ab$var$NUMBER + "%";
function $0188c8620d3f23ab$var$call(...parts) {
    return "\\(\\s*(" + parts.join(")\\s*,\\s*(") + ")\\s*\\)";
}
var $0188c8620d3f23ab$export$8972dc0e6ad9238f = new RegExp("rgb" + $0188c8620d3f23ab$var$call($0188c8620d3f23ab$var$NUMBER, $0188c8620d3f23ab$var$NUMBER, $0188c8620d3f23ab$var$NUMBER));
var $0188c8620d3f23ab$export$4e46ac54fc82cf3b = new RegExp("rgba" + $0188c8620d3f23ab$var$call($0188c8620d3f23ab$var$NUMBER, $0188c8620d3f23ab$var$NUMBER, $0188c8620d3f23ab$var$NUMBER, $0188c8620d3f23ab$var$NUMBER));
var $0188c8620d3f23ab$export$8f4a7c0bb78e6ea8 = new RegExp("hsl" + $0188c8620d3f23ab$var$call($0188c8620d3f23ab$var$NUMBER, $0188c8620d3f23ab$var$PERCENTAGE, $0188c8620d3f23ab$var$PERCENTAGE));
var $0188c8620d3f23ab$export$810b04175080204c = new RegExp("hsla" + $0188c8620d3f23ab$var$call($0188c8620d3f23ab$var$NUMBER, $0188c8620d3f23ab$var$PERCENTAGE, $0188c8620d3f23ab$var$PERCENTAGE, $0188c8620d3f23ab$var$NUMBER));
var $0188c8620d3f23ab$export$a99b93d698493da5 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var $0188c8620d3f23ab$export$4573e032242724d8 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var $0188c8620d3f23ab$export$86e51e8f361b966e = /^#([0-9a-fA-F]{6})$/;
var $0188c8620d3f23ab$export$a09ec12fb14c61c4 = /^#([0-9a-fA-F]{8})$/;
// src/normalizeColor.ts
function $0188c8620d3f23ab$var$normalizeColor(color) {
    let match;
    if (typeof color === "number") return color >>> 0 === color && color >= 0 && color <= 4294967295 ? color : null;
    if (match = $0188c8620d3f23ab$export$86e51e8f361b966e.exec(color)) return parseInt(match[1] + "ff", 16) >>> 0;
    if ($0188c8620d3f23ab$var$colors && $0188c8620d3f23ab$var$colors[color] !== void 0) return $0188c8620d3f23ab$var$colors[color];
    if (match = $0188c8620d3f23ab$export$8972dc0e6ad9238f.exec(color)) return ($0188c8620d3f23ab$var$parse255(match[1]) << 24 | // r
    $0188c8620d3f23ab$var$parse255(match[2]) << 16 | // g
    $0188c8620d3f23ab$var$parse255(match[3]) << 8 | // b
    255) >>> // a
    0;
    if (match = $0188c8620d3f23ab$export$4e46ac54fc82cf3b.exec(color)) return ($0188c8620d3f23ab$var$parse255(match[1]) << 24 | // r
    $0188c8620d3f23ab$var$parse255(match[2]) << 16 | // g
    $0188c8620d3f23ab$var$parse255(match[3]) << 8 | // b
    $0188c8620d3f23ab$var$parse1(match[4])) >>> // a
    0;
    if (match = $0188c8620d3f23ab$export$a99b93d698493da5.exec(color)) return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    "ff", // a
    16) >>> 0;
    if (match = $0188c8620d3f23ab$export$a09ec12fb14c61c4.exec(color)) return parseInt(match[1], 16) >>> 0;
    if (match = $0188c8620d3f23ab$export$4573e032242724d8.exec(color)) return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    match[4] + match[4], // a
    16) >>> 0;
    if (match = $0188c8620d3f23ab$export$8f4a7c0bb78e6ea8.exec(color)) return ($0188c8620d3f23ab$var$hslToRgb($0188c8620d3f23ab$var$parse360(match[1]), // h
    $0188c8620d3f23ab$var$parsePercentage(match[2]), // s
    $0188c8620d3f23ab$var$parsePercentage(match[3])) | 255) >>> // a
    0;
    if (match = $0188c8620d3f23ab$export$810b04175080204c.exec(color)) return ($0188c8620d3f23ab$var$hslToRgb($0188c8620d3f23ab$var$parse360(match[1]), // h
    $0188c8620d3f23ab$var$parsePercentage(match[2]), // s
    $0188c8620d3f23ab$var$parsePercentage(match[3])) | $0188c8620d3f23ab$var$parse1(match[4])) >>> // a
    0;
    return null;
}
function $0188c8620d3f23ab$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $0188c8620d3f23ab$var$hslToRgb(h, s, l) {
    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;
    const r = $0188c8620d3f23ab$var$hue2rgb(p, q, h + 1 / 3);
    const g = $0188c8620d3f23ab$var$hue2rgb(p, q, h);
    const b = $0188c8620d3f23ab$var$hue2rgb(p, q, h - 1 / 3);
    return Math.round(r * 255) << 24 | Math.round(g * 255) << 16 | Math.round(b * 255) << 8;
}
function $0188c8620d3f23ab$var$parse255(str) {
    const int = parseInt(str, 10);
    if (int < 0) return 0;
    if (int > 255) return 255;
    return int;
}
function $0188c8620d3f23ab$var$parse360(str) {
    const int = parseFloat(str);
    return (int % 360 + 360) % 360 / 360;
}
function $0188c8620d3f23ab$var$parse1(str) {
    const num = parseFloat(str);
    if (num < 0) return 0;
    if (num > 1) return 255;
    return Math.round(num * 255);
}
function $0188c8620d3f23ab$var$parsePercentage(str) {
    const int = parseFloat(str);
    if (int < 0) return 0;
    if (int > 100) return 1;
    return int / 100;
}
// src/colorToRgba.ts
function $0188c8620d3f23ab$export$61db176b839af1f(input) {
    let int32Color = $0188c8620d3f23ab$var$normalizeColor(input);
    if (int32Color === null) return input;
    int32Color = int32Color || 0;
    const r = (int32Color & 4278190080) >>> 24;
    const g = (int32Color & 16711680) >>> 16;
    const b = (int32Color & 65280) >>> 8;
    const a = (int32Color & 255) / 255;
    return `rgba(${r}, ${g}, ${b}, ${a})`;
}
// src/createInterpolator.ts
var $0188c8620d3f23ab$export$b12af43b97697ef5 = (range, output, extrapolate)=>{
    if ($0188c8620d3f23ab$export$226b3eccf92c9ed9.fun(range)) return range;
    if ($0188c8620d3f23ab$export$226b3eccf92c9ed9.arr(range)) return $0188c8620d3f23ab$export$b12af43b97697ef5({
        range: range,
        output: output,
        extrapolate: extrapolate
    });
    if ($0188c8620d3f23ab$export$226b3eccf92c9ed9.str(range.output[0])) return $0188c8620d3f23ab$var$createStringInterpolator(range);
    const config = range;
    const outputRange = config.output;
    const inputRange = config.range || [
        0,
        1
    ];
    const extrapolateLeft = config.extrapolateLeft || config.extrapolate || "extend";
    const extrapolateRight = config.extrapolateRight || config.extrapolate || "extend";
    const easing = config.easing || ((t)=>t);
    return (input)=>{
        const range2 = $0188c8620d3f23ab$var$findRange(input, inputRange);
        return $0188c8620d3f23ab$var$interpolate(input, inputRange[range2], inputRange[range2 + 1], outputRange[range2], outputRange[range2 + 1], easing, extrapolateLeft, extrapolateRight, config.map);
    };
};
function $0188c8620d3f23ab$var$interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight, map) {
    let result = map ? map(input) : input;
    if (result < inputMin) {
        if (extrapolateLeft === "identity") return result;
        else if (extrapolateLeft === "clamp") result = inputMin;
    }
    if (result > inputMax) {
        if (extrapolateRight === "identity") return result;
        else if (extrapolateRight === "clamp") result = inputMax;
    }
    if (outputMin === outputMax) return outputMin;
    if (inputMin === inputMax) return input <= inputMin ? outputMin : outputMax;
    if (inputMin === -Infinity) result = -result;
    else if (inputMax === Infinity) result = result - inputMin;
    else result = (result - inputMin) / (inputMax - inputMin);
    result = easing(result);
    if (outputMin === -Infinity) result = -result;
    else if (outputMax === Infinity) result = result + outputMin;
    else result = result * (outputMax - outputMin) + outputMin;
    return result;
}
function $0188c8620d3f23ab$var$findRange(input, inputRange) {
    for(var i = 1; i < inputRange.length - 1; ++i)if (inputRange[i] >= input) break;
    return i - 1;
}
// src/easings.ts
var $0188c8620d3f23ab$var$steps = (steps2, direction = "end")=>(progress2)=>{
        progress2 = direction === "end" ? Math.min(progress2, 0.999) : Math.max(progress2, 1e-3);
        const expanded = progress2 * steps2;
        const rounded = direction === "end" ? Math.floor(expanded) : Math.ceil(expanded);
        return $0188c8620d3f23ab$export$7d15b64cf5a3a4c4(0, 1, rounded / steps2);
    };
var $0188c8620d3f23ab$var$c1 = 1.70158;
var $0188c8620d3f23ab$var$c2 = $0188c8620d3f23ab$var$c1 * 1.525;
var $0188c8620d3f23ab$var$c3 = $0188c8620d3f23ab$var$c1 + 1;
var $0188c8620d3f23ab$var$c4 = 2 * Math.PI / 3;
var $0188c8620d3f23ab$var$c5 = 2 * Math.PI / 4.5;
var $0188c8620d3f23ab$var$bounceOut = (x)=>{
    const n1 = 7.5625;
    const d1 = 2.75;
    if (x < 1 / d1) return n1 * x * x;
    else if (x < 2 / d1) return n1 * (x -= 1.5 / d1) * x + 0.75;
    else if (x < 2.5 / d1) return n1 * (x -= 2.25 / d1) * x + 0.9375;
    else return n1 * (x -= 2.625 / d1) * x + 0.984375;
};
var $0188c8620d3f23ab$export$15a0bf1b4bbacad8 = {
    linear: (x)=>x,
    easeInQuad: (x)=>x * x,
    easeOutQuad: (x)=>1 - (1 - x) * (1 - x),
    easeInOutQuad: (x)=>x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2,
    easeInCubic: (x)=>x * x * x,
    easeOutCubic: (x)=>1 - Math.pow(1 - x, 3),
    easeInOutCubic: (x)=>x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2,
    easeInQuart: (x)=>x * x * x * x,
    easeOutQuart: (x)=>1 - Math.pow(1 - x, 4),
    easeInOutQuart: (x)=>x < 0.5 ? 8 * x * x * x * x : 1 - Math.pow(-2 * x + 2, 4) / 2,
    easeInQuint: (x)=>x * x * x * x * x,
    easeOutQuint: (x)=>1 - Math.pow(1 - x, 5),
    easeInOutQuint: (x)=>x < 0.5 ? 16 * x * x * x * x * x : 1 - Math.pow(-2 * x + 2, 5) / 2,
    easeInSine: (x)=>1 - Math.cos(x * Math.PI / 2),
    easeOutSine: (x)=>Math.sin(x * Math.PI / 2),
    easeInOutSine: (x)=>-(Math.cos(Math.PI * x) - 1) / 2,
    easeInExpo: (x)=>x === 0 ? 0 : Math.pow(2, 10 * x - 10),
    easeOutExpo: (x)=>x === 1 ? 1 : 1 - Math.pow(2, -10 * x),
    easeInOutExpo: (x)=>x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? Math.pow(2, 20 * x - 10) / 2 : (2 - Math.pow(2, -20 * x + 10)) / 2,
    easeInCirc: (x)=>1 - Math.sqrt(1 - Math.pow(x, 2)),
    easeOutCirc: (x)=>Math.sqrt(1 - Math.pow(x - 1, 2)),
    easeInOutCirc: (x)=>x < 0.5 ? (1 - Math.sqrt(1 - Math.pow(2 * x, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * x + 2, 2)) + 1) / 2,
    easeInBack: (x)=>$0188c8620d3f23ab$var$c3 * x * x * x - $0188c8620d3f23ab$var$c1 * x * x,
    easeOutBack: (x)=>1 + $0188c8620d3f23ab$var$c3 * Math.pow(x - 1, 3) + $0188c8620d3f23ab$var$c1 * Math.pow(x - 1, 2),
    easeInOutBack: (x)=>x < 0.5 ? Math.pow(2 * x, 2) * (($0188c8620d3f23ab$var$c2 + 1) * 2 * x - $0188c8620d3f23ab$var$c2) / 2 : (Math.pow(2 * x - 2, 2) * (($0188c8620d3f23ab$var$c2 + 1) * (x * 2 - 2) + $0188c8620d3f23ab$var$c2) + 2) / 2,
    easeInElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : -Math.pow(2, 10 * x - 10) * Math.sin((x * 10 - 10.75) * $0188c8620d3f23ab$var$c4),
    easeOutElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : Math.pow(2, -10 * x) * Math.sin((x * 10 - 0.75) * $0188c8620d3f23ab$var$c4) + 1,
    easeInOutElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? -(Math.pow(2, 20 * x - 10) * Math.sin((20 * x - 11.125) * $0188c8620d3f23ab$var$c5)) / 2 : Math.pow(2, -20 * x + 10) * Math.sin((20 * x - 11.125) * $0188c8620d3f23ab$var$c5) / 2 + 1,
    easeInBounce: (x)=>1 - $0188c8620d3f23ab$var$bounceOut(1 - x),
    easeOutBounce: $0188c8620d3f23ab$var$bounceOut,
    easeInOutBounce: (x)=>x < 0.5 ? (1 - $0188c8620d3f23ab$var$bounceOut(1 - 2 * x)) / 2 : (1 + $0188c8620d3f23ab$var$bounceOut(2 * x - 1)) / 2,
    steps: $0188c8620d3f23ab$var$steps
};
// src/fluids.ts
var $0188c8620d3f23ab$var$$get = Symbol.for("FluidValue.get");
var $0188c8620d3f23ab$var$$observers = Symbol.for("FluidValue.observers");
var $0188c8620d3f23ab$export$57ea7e3a7f6280c7 = (arg)=>Boolean(arg && arg[$0188c8620d3f23ab$var$$get]);
var $0188c8620d3f23ab$export$e37b7520edd66839 = (arg)=>arg && arg[$0188c8620d3f23ab$var$$get] ? arg[$0188c8620d3f23ab$var$$get]() : arg;
var $0188c8620d3f23ab$export$133f54e9f7cf1796 = (target)=>target[$0188c8620d3f23ab$var$$observers] || null;
function $0188c8620d3f23ab$export$8cbca1207adce0c0(observer2, event) {
    if (observer2.eventObserved) observer2.eventObserved(event);
    else observer2(event);
}
function $0188c8620d3f23ab$export$31752c40a5fab62a(target, event) {
    const observers = target[$0188c8620d3f23ab$var$$observers];
    if (observers) observers.forEach((observer2)=>{
        $0188c8620d3f23ab$export$8cbca1207adce0c0(observer2, event);
    });
}
var $0188c8620d3f23ab$export$aff8e1ac1a016a2 = class {
    constructor(get){
        if (!get && !(get = this.get)) throw Error("Unknown getter");
        $0188c8620d3f23ab$export$a3b4618659637aa3(this, get);
    }
};
$0188c8620d3f23ab$var$$get, $0188c8620d3f23ab$var$$observers;
var $0188c8620d3f23ab$export$a3b4618659637aa3 = (target, get)=>$0188c8620d3f23ab$var$setHidden(target, $0188c8620d3f23ab$var$$get, get);
function $0188c8620d3f23ab$export$72d604e3f8d000a5(target, observer2) {
    if (target[$0188c8620d3f23ab$var$$get]) {
        let observers = target[$0188c8620d3f23ab$var$$observers];
        if (!observers) $0188c8620d3f23ab$var$setHidden(target, $0188c8620d3f23ab$var$$observers, observers = /* @__PURE__ */ new Set());
        if (!observers.has(observer2)) {
            observers.add(observer2);
            if (target.observerAdded) target.observerAdded(observers.size, observer2);
        }
    }
    return observer2;
}
function $0188c8620d3f23ab$export$7a0eb830d336339b(target, observer2) {
    const observers = target[$0188c8620d3f23ab$var$$observers];
    if (observers && observers.has(observer2)) {
        const count = observers.size - 1;
        if (count) observers.delete(observer2);
        else target[$0188c8620d3f23ab$var$$observers] = null;
        if (target.observerRemoved) target.observerRemoved(count, observer2);
    }
}
var $0188c8620d3f23ab$var$setHidden = (target, key, value)=>Object.defineProperty(target, key, {
        value: value,
        writable: true,
        configurable: true
    });
// src/regexs.ts
var $0188c8620d3f23ab$var$numberRegex = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
var $0188c8620d3f23ab$var$colorRegex = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi;
var $0188c8620d3f23ab$var$unitRegex = new RegExp(`(${$0188c8620d3f23ab$var$numberRegex.source})(%|[a-z]+)`, "i");
var $0188c8620d3f23ab$var$rgbaRegex = /rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi;
var $0188c8620d3f23ab$var$cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
// src/variableToRgba.ts
var $0188c8620d3f23ab$var$variableToRgba = (input)=>{
    const [token, fallback] = $0188c8620d3f23ab$var$parseCSSVariable(input);
    if (!token || $0188c8620d3f23ab$export$48d7c418edadb60c()) return input;
    const value = window.getComputedStyle(document.documentElement).getPropertyValue(token);
    if (value) return value.trim();
    else if (fallback && fallback.startsWith("--")) {
        const value2 = window.getComputedStyle(document.documentElement).getPropertyValue(fallback);
        if (value2) return value2;
        else return input;
    } else if (fallback && $0188c8620d3f23ab$var$cssVariableRegex.test(fallback)) return $0188c8620d3f23ab$var$variableToRgba(fallback);
    else if (fallback) return fallback;
    return input;
};
var $0188c8620d3f23ab$var$parseCSSVariable = (current)=>{
    const match = $0188c8620d3f23ab$var$cssVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token, fallback] = match;
    return [
        token,
        fallback
    ];
};
// src/stringInterpolation.ts
var $0188c8620d3f23ab$var$namedColorRegex;
var $0188c8620d3f23ab$var$rgbaRound = (_, p1, p2, p3, p4)=>`rgba(${Math.round(p1)}, ${Math.round(p2)}, ${Math.round(p3)}, ${p4})`;
var $0188c8620d3f23ab$export$4759a013d387347a = (config)=>{
    if (!$0188c8620d3f23ab$var$namedColorRegex) $0188c8620d3f23ab$var$namedColorRegex = $0188c8620d3f23ab$var$colors ? // match color names, ignore partial matches
    new RegExp(`(${Object.keys($0188c8620d3f23ab$var$colors).join("|")})(?!\\w)`, "g") : // never match
    /^\b$/;
    const output = config.output.map((value)=>{
        return $0188c8620d3f23ab$export$e37b7520edd66839(value).replace($0188c8620d3f23ab$var$cssVariableRegex, $0188c8620d3f23ab$var$variableToRgba).replace($0188c8620d3f23ab$var$colorRegex, $0188c8620d3f23ab$export$61db176b839af1f).replace($0188c8620d3f23ab$var$namedColorRegex, $0188c8620d3f23ab$export$61db176b839af1f);
    });
    const keyframes = output.map((value)=>value.match($0188c8620d3f23ab$var$numberRegex).map(Number));
    const outputRanges = keyframes[0].map((_, i)=>keyframes.map((values)=>{
            if (!(i in values)) throw Error('The arity of each "output" value must be equal');
            return values[i];
        }));
    const interpolators = outputRanges.map((output2)=>$0188c8620d3f23ab$export$b12af43b97697ef5({
            ...config,
            output: output2
        }));
    return (input)=>{
        const missingUnit = !$0188c8620d3f23ab$var$unitRegex.test(output[0]) && output.find((value)=>$0188c8620d3f23ab$var$unitRegex.test(value))?.replace($0188c8620d3f23ab$var$numberRegex, "");
        let i = 0;
        return output[0].replace($0188c8620d3f23ab$var$numberRegex, ()=>`${interpolators[i++](input)}${missingUnit || ""}`).replace($0188c8620d3f23ab$var$rgbaRegex, $0188c8620d3f23ab$var$rgbaRound);
    };
};
// src/deprecations.ts
var $0188c8620d3f23ab$export$82e9f45cca5ba907 = "react-spring: ";
var $0188c8620d3f23ab$export$d2de3aaeafa91619 = (fn)=>{
    const func = fn;
    let called = false;
    if (typeof func != "function") throw new TypeError(`${$0188c8620d3f23ab$export$82e9f45cca5ba907}once requires a function parameter`);
    return (...args)=>{
        if (!called) {
            func(...args);
            called = true;
        }
    };
};
var $0188c8620d3f23ab$var$warnInterpolate = $0188c8620d3f23ab$export$d2de3aaeafa91619(console.warn);
function $0188c8620d3f23ab$export$2abfcde8ae218ba8() {
    $0188c8620d3f23ab$var$warnInterpolate(`${$0188c8620d3f23ab$export$82e9f45cca5ba907}The "interpolate" function is deprecated in v9 (use "to" instead)`);
}
var $0188c8620d3f23ab$var$warnDirectCall = $0188c8620d3f23ab$export$d2de3aaeafa91619(console.warn);
function $0188c8620d3f23ab$export$d99d974913ad3b12() {
    $0188c8620d3f23ab$var$warnDirectCall(`${$0188c8620d3f23ab$export$82e9f45cca5ba907}Directly calling start instead of using the api object is deprecated in v9 (use ".start" instead), this will be removed in later 0.X.0 versions`);
}
// src/isAnimatedString.ts
function $0188c8620d3f23ab$export$75bed621f62abfa9(value) {
    return $0188c8620d3f23ab$export$226b3eccf92c9ed9.str(value) && (value[0] == "#" || /\d/.test(value) || // Do not identify a CSS variable as an AnimatedString if its SSR
    !$0188c8620d3f23ab$export$48d7c418edadb60c() && $0188c8620d3f23ab$var$cssVariableRegex.test(value) || value in ($0188c8620d3f23ab$var$colors || {}));
}
// src/dom-events/resize/resizeElement.ts
var $0188c8620d3f23ab$var$observer;
var $0188c8620d3f23ab$var$resizeHandlers = /* @__PURE__ */ new WeakMap();
var $0188c8620d3f23ab$var$handleObservation = (entries)=>entries.forEach(({ target: target, contentRect: contentRect })=>{
        return $0188c8620d3f23ab$var$resizeHandlers.get(target)?.forEach((handler)=>handler(contentRect));
    });
function $0188c8620d3f23ab$var$resizeElement(handler, target) {
    if (!$0188c8620d3f23ab$var$observer) {
        if (typeof ResizeObserver !== "undefined") $0188c8620d3f23ab$var$observer = new ResizeObserver($0188c8620d3f23ab$var$handleObservation);
    }
    let elementHandlers = $0188c8620d3f23ab$var$resizeHandlers.get(target);
    if (!elementHandlers) {
        elementHandlers = /* @__PURE__ */ new Set();
        $0188c8620d3f23ab$var$resizeHandlers.set(target, elementHandlers);
    }
    elementHandlers.add(handler);
    if ($0188c8620d3f23ab$var$observer) $0188c8620d3f23ab$var$observer.observe(target);
    return ()=>{
        const elementHandlers2 = $0188c8620d3f23ab$var$resizeHandlers.get(target);
        if (!elementHandlers2) return;
        elementHandlers2.delete(handler);
        if (!elementHandlers2.size && $0188c8620d3f23ab$var$observer) $0188c8620d3f23ab$var$observer.unobserve(target);
    };
}
// src/dom-events/resize/resizeWindow.ts
var $0188c8620d3f23ab$var$listeners = /* @__PURE__ */ new Set();
var $0188c8620d3f23ab$var$cleanupWindowResizeHandler;
var $0188c8620d3f23ab$var$createResizeHandler = ()=>{
    const handleResize = ()=>{
        $0188c8620d3f23ab$var$listeners.forEach((callback)=>callback({
                width: window.innerWidth,
                height: window.innerHeight
            }));
    };
    window.addEventListener("resize", handleResize);
    return ()=>{
        window.removeEventListener("resize", handleResize);
    };
};
var $0188c8620d3f23ab$var$resizeWindow = (callback)=>{
    $0188c8620d3f23ab$var$listeners.add(callback);
    if (!$0188c8620d3f23ab$var$cleanupWindowResizeHandler) $0188c8620d3f23ab$var$cleanupWindowResizeHandler = $0188c8620d3f23ab$var$createResizeHandler();
    return ()=>{
        $0188c8620d3f23ab$var$listeners.delete(callback);
        if (!$0188c8620d3f23ab$var$listeners.size && $0188c8620d3f23ab$var$cleanupWindowResizeHandler) {
            $0188c8620d3f23ab$var$cleanupWindowResizeHandler();
            $0188c8620d3f23ab$var$cleanupWindowResizeHandler = void 0;
        }
    };
};
// src/dom-events/resize/index.ts
var $0188c8620d3f23ab$export$45b39e67d4ce4921 = (callback, { container: container = document.documentElement } = {})=>{
    if (container === document.documentElement) return $0188c8620d3f23ab$var$resizeWindow(callback);
    else return $0188c8620d3f23ab$var$resizeElement(callback, container);
};
// src/progress.ts
var $0188c8620d3f23ab$var$progress = (min, max, value)=>max - min === 0 ? 1 : (value - min) / (max - min);
// src/dom-events/scroll/ScrollHandler.ts
var $0188c8620d3f23ab$var$SCROLL_KEYS = {
    x: {
        length: "Width",
        position: "Left"
    },
    y: {
        length: "Height",
        position: "Top"
    }
};
var $0188c8620d3f23ab$var$ScrollHandler = class {
    constructor(callback, container){
        this.createAxis = ()=>({
                current: 0,
                progress: 0,
                scrollLength: 0
            });
        this.updateAxis = (axisName)=>{
            const axis = this.info[axisName];
            const { length: length, position: position } = $0188c8620d3f23ab$var$SCROLL_KEYS[axisName];
            axis.current = this.container[`scroll${position}`];
            axis.scrollLength = this.container[`scroll${length}`] - this.container[`client${length}`];
            axis.progress = $0188c8620d3f23ab$var$progress(0, axis.scrollLength, axis.current);
        };
        this.update = ()=>{
            this.updateAxis("x");
            this.updateAxis("y");
        };
        this.sendEvent = ()=>{
            this.callback(this.info);
        };
        this.advance = ()=>{
            this.update();
            this.sendEvent();
        };
        this.callback = callback;
        this.container = container;
        this.info = {
            time: 0,
            x: this.createAxis(),
            y: this.createAxis()
        };
    }
};
// src/dom-events/scroll/index.ts
var $0188c8620d3f23ab$var$scrollListeners = /* @__PURE__ */ new WeakMap();
var $0188c8620d3f23ab$var$resizeListeners = /* @__PURE__ */ new WeakMap();
var $0188c8620d3f23ab$var$onScrollHandlers = /* @__PURE__ */ new WeakMap();
var $0188c8620d3f23ab$var$getTarget = (container)=>container === document.documentElement ? window : container;
var $0188c8620d3f23ab$export$d4d89fd61e5416ee = (callback, { container: container = document.documentElement } = {})=>{
    let containerHandlers = $0188c8620d3f23ab$var$onScrollHandlers.get(container);
    if (!containerHandlers) {
        containerHandlers = /* @__PURE__ */ new Set();
        $0188c8620d3f23ab$var$onScrollHandlers.set(container, containerHandlers);
    }
    const containerHandler = new $0188c8620d3f23ab$var$ScrollHandler(callback, container);
    containerHandlers.add(containerHandler);
    if (!$0188c8620d3f23ab$var$scrollListeners.has(container)) {
        const listener = ()=>{
            containerHandlers?.forEach((handler)=>handler.advance());
            return true;
        };
        $0188c8620d3f23ab$var$scrollListeners.set(container, listener);
        const target = $0188c8620d3f23ab$var$getTarget(container);
        window.addEventListener("resize", listener, {
            passive: true
        });
        if (container !== document.documentElement) $0188c8620d3f23ab$var$resizeListeners.set(container, $0188c8620d3f23ab$export$45b39e67d4ce4921(listener, {
            container: container
        }));
        target.addEventListener("scroll", listener, {
            passive: true
        });
    }
    const animateScroll = $0188c8620d3f23ab$var$scrollListeners.get(container);
    (0, $14f355fb1db5a5c1$export$27f233d61a9e2fa4)(animateScroll);
    return ()=>{
        (0, $14f355fb1db5a5c1$export$27f233d61a9e2fa4).cancel(animateScroll);
        const containerHandlers2 = $0188c8620d3f23ab$var$onScrollHandlers.get(container);
        if (!containerHandlers2) return;
        containerHandlers2.delete(containerHandler);
        if (containerHandlers2.size) return;
        const listener = $0188c8620d3f23ab$var$scrollListeners.get(container);
        $0188c8620d3f23ab$var$scrollListeners.delete(container);
        if (listener) {
            $0188c8620d3f23ab$var$getTarget(container).removeEventListener("scroll", listener);
            window.removeEventListener("resize", listener);
            $0188c8620d3f23ab$var$resizeListeners.get(container)?.();
        }
    };
};
function $0188c8620d3f23ab$export$fe4300aa8eebea86(init) {
    const ref = (0, $8NFma.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}
var $0188c8620d3f23ab$export$700979bc83e7db82 = $0188c8620d3f23ab$export$48d7c418edadb60c() ? (0, $8NFma.useEffect) : (0, $8NFma.useLayoutEffect);
// src/hooks/useIsMounted.ts
var $0188c8620d3f23ab$var$useIsMounted = ()=>{
    const isMounted = (0, $8NFma.useRef)(false);
    $0188c8620d3f23ab$export$700979bc83e7db82(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return isMounted;
};
// src/hooks/useForceUpdate.ts
function $0188c8620d3f23ab$export$91db9bc4f8ac944a() {
    const update = (0, $8NFma.useState)()[1];
    const isMounted = $0188c8620d3f23ab$var$useIsMounted();
    return ()=>{
        if (isMounted.current) update(Math.random());
    };
}
function $0188c8620d3f23ab$export$b6feb8998cd9b342(getResult, inputs) {
    const [initial] = (0, $8NFma.useState)(()=>({
            inputs: inputs,
            result: getResult()
        }));
    const committed = (0, $8NFma.useRef)();
    const prevCache = committed.current;
    let cache = prevCache;
    if (cache) {
        const useCache = Boolean(inputs && cache.inputs && $0188c8620d3f23ab$var$areInputsEqual(inputs, cache.inputs));
        if (!useCache) cache = {
            inputs: inputs,
            result: getResult()
        };
    } else cache = initial;
    (0, $8NFma.useEffect)(()=>{
        committed.current = cache;
        if (prevCache == initial) initial.inputs = initial.result = void 0;
    }, [
        cache
    ]);
    return cache.result;
}
function $0188c8620d3f23ab$var$areInputsEqual(next, prev) {
    if (next.length !== prev.length) return false;
    for(let i = 0; i < next.length; i++){
        if (next[i] !== prev[i]) return false;
    }
    return true;
}
var $0188c8620d3f23ab$export$392544347a18b6ea = (effect)=>(0, $8NFma.useEffect)(effect, $0188c8620d3f23ab$var$emptyDeps);
var $0188c8620d3f23ab$var$emptyDeps = [];
function $0188c8620d3f23ab$export$ef7ad0c4e19d7fbf(value) {
    const prevRef = (0, $8NFma.useRef)();
    (0, $8NFma.useEffect)(()=>{
        prevRef.current = value;
    });
    return prevRef.current;
}
var $0188c8620d3f23ab$export$6a42007cf1e7b6f8 = ()=>{
    const [reducedMotion, setReducedMotion] = (0, $8NFma.useState)(null);
    $0188c8620d3f23ab$export$700979bc83e7db82(()=>{
        const mql = window.matchMedia("(prefers-reduced-motion)");
        const handleMediaChange = (e)=>{
            setReducedMotion(e.matches);
            $0188c8620d3f23ab$var$assign({
                skipAnimation: e.matches
            });
        };
        handleMediaChange(mql);
        if (mql.addEventListener) mql.addEventListener("change", handleMediaChange);
        else mql.addListener(handleMediaChange);
        return ()=>{
            if (mql.removeEventListener) mql.removeEventListener("change", handleMediaChange);
            else mql.removeListener(handleMediaChange);
        };
    }, []);
    return reducedMotion;
};



var $8NFma = parcelRequire("8NFma");
// src/Animated.ts


var $8NFma = parcelRequire("8NFma");
var $21c5332537d86d23$var$$node = Symbol.for("Animated:node");
var $21c5332537d86d23$export$3df5e165e801a70f = (value)=>!!value && value[$21c5332537d86d23$var$$node] === value;
var $21c5332537d86d23$export$6b63995194a3a9e4 = (owner)=>owner && owner[$21c5332537d86d23$var$$node];
var $21c5332537d86d23$export$b553cb5b22b81b04 = (owner, node)=>(0, $0188c8620d3f23ab$export$5c74248ea0e35446)(owner, $21c5332537d86d23$var$$node, node);
var $21c5332537d86d23$export$ccab2b64c5d440 = (owner)=>owner && owner[$21c5332537d86d23$var$$node] && owner[$21c5332537d86d23$var$$node].getPayload();
var $21c5332537d86d23$export$31627395a3b18e54 = class {
    constructor(){
        $21c5332537d86d23$export$b553cb5b22b81b04(this, this);
    }
    /** Get every `AnimatedValue` used by this node. */ getPayload() {
        return this.payload || [];
    }
};
var $21c5332537d86d23$export$cb1e8f3c05d37ad5 = class extends $21c5332537d86d23$export$31627395a3b18e54 {
    constructor(_value){
        super();
        this._value = _value;
        this.done = true;
        this.durationProgress = 0;
        if ((0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).num(this._value)) this.lastPosition = this._value;
    }
    /** @internal */ static create(value) {
        return new $21c5332537d86d23$export$cb1e8f3c05d37ad5(value);
    }
    getPayload() {
        return [
            this
        ];
    }
    getValue() {
        return this._value;
    }
    setValue(value, step) {
        if ((0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).num(value)) {
            this.lastPosition = value;
            if (step) {
                value = Math.round(value / step) * step;
                if (this.done) this.lastPosition = value;
            }
        }
        if (this._value === value) return false;
        this._value = value;
        return true;
    }
    reset() {
        const { done: done } = this;
        this.done = false;
        if ((0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).num(this._value)) {
            this.elapsedTime = 0;
            this.durationProgress = 0;
            this.lastPosition = this._value;
            if (done) this.lastVelocity = null;
            this.v0 = null;
        }
    }
};
var $21c5332537d86d23$export$f6c6c4cbd7fa5b93 = class extends $21c5332537d86d23$export$cb1e8f3c05d37ad5 {
    constructor(value){
        super(0);
        this._string = null;
        this._toString = (0, $0188c8620d3f23ab$export$b12af43b97697ef5)({
            output: [
                value,
                value
            ]
        });
    }
    /** @internal */ static create(value) {
        return new $21c5332537d86d23$export$f6c6c4cbd7fa5b93(value);
    }
    getValue() {
        const value = this._string;
        return value == null ? this._string = this._toString(this._value) : value;
    }
    setValue(value) {
        if ((0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).str(value)) {
            if (value == this._string) return false;
            this._string = value;
            this._value = 1;
        } else if (super.setValue(value)) this._string = null;
        else return false;
        return true;
    }
    reset(goal) {
        if (goal) this._toString = (0, $0188c8620d3f23ab$export$b12af43b97697ef5)({
            output: [
                this.getValue(),
                goal
            ]
        });
        this._value = 0;
        super.reset();
    }
};
// src/context.ts
var $21c5332537d86d23$var$TreeContext = {
    dependencies: null
};
// src/AnimatedObject.ts
var $21c5332537d86d23$export$f1b0b9e366a6e2d4 = class extends $21c5332537d86d23$export$31627395a3b18e54 {
    constructor(source){
        super();
        this.source = source;
        this.setValue(source);
    }
    getValue(animated) {
        const values = {};
        (0, $0188c8620d3f23ab$export$f4c6fe153f5a944e)(this.source, (source, key)=>{
            if ($21c5332537d86d23$export$3df5e165e801a70f(source)) values[key] = source.getValue(animated);
            else if ((0, $0188c8620d3f23ab$export$57ea7e3a7f6280c7)(source)) values[key] = (0, $0188c8620d3f23ab$export$e37b7520edd66839)(source);
            else if (!animated) values[key] = source;
        });
        return values;
    }
    /** Replace the raw object data */ setValue(source) {
        this.source = source;
        this.payload = this._makePayload(source);
    }
    reset() {
        if (this.payload) (0, $0188c8620d3f23ab$export$79b2f7037acddd43)(this.payload, (node)=>node.reset());
    }
    /** Create a payload set. */ _makePayload(source) {
        if (source) {
            const payload = /* @__PURE__ */ new Set();
            (0, $0188c8620d3f23ab$export$f4c6fe153f5a944e)(source, this._addToPayload, payload);
            return Array.from(payload);
        }
    }
    /** Add to a payload set. */ _addToPayload(source) {
        if ($21c5332537d86d23$var$TreeContext.dependencies && (0, $0188c8620d3f23ab$export$57ea7e3a7f6280c7)(source)) $21c5332537d86d23$var$TreeContext.dependencies.add(source);
        const payload = $21c5332537d86d23$export$ccab2b64c5d440(source);
        if (payload) (0, $0188c8620d3f23ab$export$79b2f7037acddd43)(payload, (node)=>this.add(node));
    }
};
// src/AnimatedArray.ts
var $21c5332537d86d23$export$ede394683406942d = class extends $21c5332537d86d23$export$f1b0b9e366a6e2d4 {
    constructor(source){
        super(source);
    }
    /** @internal */ static create(source) {
        return new $21c5332537d86d23$export$ede394683406942d(source);
    }
    getValue() {
        return this.source.map((node)=>node.getValue());
    }
    setValue(source) {
        const payload = this.getPayload();
        if (source.length == payload.length) return payload.map((node, i)=>node.setValue(source[i])).some(Boolean);
        super.setValue(source.map($21c5332537d86d23$var$makeAnimated));
        return true;
    }
};
function $21c5332537d86d23$var$makeAnimated(value) {
    const nodeType = (0, $0188c8620d3f23ab$export$75bed621f62abfa9)(value) ? $21c5332537d86d23$export$f6c6c4cbd7fa5b93 : $21c5332537d86d23$export$cb1e8f3c05d37ad5;
    return nodeType.create(value);
}
function $21c5332537d86d23$export$e6b77ddbe47b132e(value) {
    const parentNode = $21c5332537d86d23$export$6b63995194a3a9e4(value);
    return parentNode ? parentNode.constructor : (0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).arr(value) ? $21c5332537d86d23$export$ede394683406942d : (0, $0188c8620d3f23ab$export$75bed621f62abfa9)(value) ? $21c5332537d86d23$export$f6c6c4cbd7fa5b93 : $21c5332537d86d23$export$cb1e8f3c05d37ad5;
}
var $21c5332537d86d23$var$withAnimated = (Component, host)=>{
    const hasInstance = // Function components must use "forwardRef" to avoid being
    // re-rendered on every animation frame.
    !(0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).fun(Component) || Component.prototype && Component.prototype.isReactComponent;
    return (0, $8NFma.forwardRef)((givenProps, givenRef)=>{
        const instanceRef = (0, $8NFma.useRef)(null);
        const ref = hasInstance && // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $8NFma.useCallback)((value)=>{
            instanceRef.current = $21c5332537d86d23$var$updateRef(givenRef, value);
        }, [
            givenRef
        ]);
        const [props, deps] = $21c5332537d86d23$var$getAnimatedState(givenProps, host);
        const forceUpdate = (0, $0188c8620d3f23ab$export$91db9bc4f8ac944a)();
        const callback = ()=>{
            const instance = instanceRef.current;
            if (hasInstance && !instance) return;
            const didUpdate = instance ? host.applyAnimatedValues(instance, props.getValue(true)) : false;
            if (didUpdate === false) forceUpdate();
        };
        const observer = new $21c5332537d86d23$var$PropsObserver(callback, deps);
        const observerRef = (0, $8NFma.useRef)();
        (0, $0188c8620d3f23ab$export$700979bc83e7db82)(()=>{
            observerRef.current = observer;
            (0, $0188c8620d3f23ab$export$79b2f7037acddd43)(deps, (dep)=>(0, $0188c8620d3f23ab$export$72d604e3f8d000a5)(dep, observer));
            return ()=>{
                if (observerRef.current) {
                    (0, $0188c8620d3f23ab$export$79b2f7037acddd43)(observerRef.current.deps, (dep)=>(0, $0188c8620d3f23ab$export$7a0eb830d336339b)(dep, observerRef.current));
                    (0, $14f355fb1db5a5c1$export$27f233d61a9e2fa4).cancel(observerRef.current.update);
                }
            };
        });
        (0, $8NFma.useEffect)(callback, []);
        (0, $0188c8620d3f23ab$export$392544347a18b6ea)(()=>()=>{
                const observer2 = observerRef.current;
                (0, $0188c8620d3f23ab$export$79b2f7037acddd43)(observer2.deps, (dep)=>(0, $0188c8620d3f23ab$export$7a0eb830d336339b)(dep, observer2));
            });
        const usedProps = host.getComponentProps(props.getValue());
        return /* @__PURE__ */ $8NFma.createElement(Component, {
            ...usedProps,
            ref: ref
        });
    });
};
var $21c5332537d86d23$var$PropsObserver = class {
    constructor(update, deps){
        this.update = update;
        this.deps = deps;
    }
    eventObserved(event) {
        if (event.type == "change") (0, $14f355fb1db5a5c1$export$27f233d61a9e2fa4).write(this.update);
    }
};
function $21c5332537d86d23$var$getAnimatedState(props, host) {
    const dependencies = /* @__PURE__ */ new Set();
    $21c5332537d86d23$var$TreeContext.dependencies = dependencies;
    if (props.style) props = {
        ...props,
        style: host.createAnimatedStyle(props.style)
    };
    props = new $21c5332537d86d23$export$f1b0b9e366a6e2d4(props);
    $21c5332537d86d23$var$TreeContext.dependencies = null;
    return [
        props,
        dependencies
    ];
}
function $21c5332537d86d23$var$updateRef(ref, value) {
    if (ref) {
        if ((0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).fun(ref)) ref(value);
        else ref.current = value;
    }
    return value;
}
// src/createHost.ts
var $21c5332537d86d23$var$cacheKey = Symbol.for("AnimatedComponent");
var $21c5332537d86d23$export$4ee5c78f6dcbcef = (components, { applyAnimatedValues: applyAnimatedValues = ()=>false, createAnimatedStyle: createAnimatedStyle = (style)=>new $21c5332537d86d23$export$f1b0b9e366a6e2d4(style), getComponentProps: getComponentProps = (props)=>props } = {})=>{
    const hostConfig = {
        applyAnimatedValues: applyAnimatedValues,
        createAnimatedStyle: createAnimatedStyle,
        getComponentProps: getComponentProps
    };
    const animated = (Component)=>{
        const displayName = $21c5332537d86d23$var$getDisplayName(Component) || "Anonymous";
        if ((0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).str(Component)) Component = animated[Component] || (animated[Component] = $21c5332537d86d23$var$withAnimated(Component, hostConfig));
        else Component = Component[$21c5332537d86d23$var$cacheKey] || (Component[$21c5332537d86d23$var$cacheKey] = $21c5332537d86d23$var$withAnimated(Component, hostConfig));
        Component.displayName = `Animated(${displayName})`;
        return Component;
    };
    (0, $0188c8620d3f23ab$export$f4c6fe153f5a944e)(components, (Component, key)=>{
        if ((0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).arr(components)) key = $21c5332537d86d23$var$getDisplayName(Component);
        animated[key] = animated(Component);
    });
    return {
        animated: animated
    };
};
var $21c5332537d86d23$var$getDisplayName = (arg)=>(0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).str(arg) ? arg : arg && (0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).str(arg.displayName) ? arg.displayName : (0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).fun(arg) && arg.name || null;


// src/utils.ts
var $4c48ba990071af29$export$b24b633b1364b94b = class {
};


function $9abb3f64d0b26b19$var$callProp(value, ...args) {
    return (0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).fun(value) ? value(...args) : value;
}
var $9abb3f64d0b26b19$var$matchProp = (value, key)=>value === true || !!(key && value && ((0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).fun(value) ? value(key) : (0, $0188c8620d3f23ab$export$45b10814cc054894)(value).includes(key)));
var $9abb3f64d0b26b19$var$resolveProp = (prop, key)=>(0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).obj(prop) ? key && prop[key] : prop;
var $9abb3f64d0b26b19$var$getDefaultProp = (props, key)=>props.default === true ? props[key] : props.default ? props.default[key] : void 0;
var $9abb3f64d0b26b19$var$noopTransform = (value)=>value;
var $9abb3f64d0b26b19$var$getDefaultProps = (props, transform = $9abb3f64d0b26b19$var$noopTransform)=>{
    let keys = $9abb3f64d0b26b19$var$DEFAULT_PROPS;
    if (props.default && props.default !== true) {
        props = props.default;
        keys = Object.keys(props);
    }
    const defaults2 = {};
    for (const key of keys){
        const value = transform(props[key], key);
        if (!(0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).und(value)) defaults2[key] = value;
    }
    return defaults2;
};
var $9abb3f64d0b26b19$var$DEFAULT_PROPS = [
    "config",
    "onProps",
    "onStart",
    "onChange",
    "onPause",
    "onResume",
    "onRest"
];
var $9abb3f64d0b26b19$var$RESERVED_PROPS = {
    config: 1,
    from: 1,
    to: 1,
    ref: 1,
    loop: 1,
    reset: 1,
    pause: 1,
    cancel: 1,
    reverse: 1,
    immediate: 1,
    default: 1,
    delay: 1,
    onProps: 1,
    onStart: 1,
    onChange: 1,
    onPause: 1,
    onResume: 1,
    onRest: 1,
    onResolve: 1,
    // Transition props
    items: 1,
    trail: 1,
    sort: 1,
    expires: 1,
    initial: 1,
    enter: 1,
    update: 1,
    leave: 1,
    children: 1,
    onDestroyed: 1,
    // Internal props
    keys: 1,
    callId: 1,
    parentId: 1
};
function $9abb3f64d0b26b19$var$getForwardProps(props) {
    const forward = {};
    let count = 0;
    (0, $0188c8620d3f23ab$export$f4c6fe153f5a944e)(props, (value, prop)=>{
        if (!$9abb3f64d0b26b19$var$RESERVED_PROPS[prop]) {
            forward[prop] = value;
            count++;
        }
    });
    if (count) return forward;
}
function $9abb3f64d0b26b19$export$b971039a739bf227(props) {
    const to2 = $9abb3f64d0b26b19$var$getForwardProps(props);
    if (to2) {
        const out = {
            to: to2
        };
        (0, $0188c8620d3f23ab$export$f4c6fe153f5a944e)(props, (val, key)=>key in to2 || (out[key] = val));
        return out;
    }
    return {
        ...props
    };
}
function $9abb3f64d0b26b19$var$computeGoal(value) {
    value = (0, $0188c8620d3f23ab$export$e37b7520edd66839)(value);
    return (0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).arr(value) ? value.map($9abb3f64d0b26b19$var$computeGoal) : (0, $0188c8620d3f23ab$export$75bed621f62abfa9)(value) ? (0, $0188c8620d3f23ab$export$cceeabf822b64fc0).createStringInterpolator({
        range: [
            0,
            1
        ],
        output: [
            value,
            value
        ]
    })(1) : value;
}
function $9abb3f64d0b26b19$var$hasProps(props) {
    for(const _ in props)return true;
    return false;
}
function $9abb3f64d0b26b19$var$isAsyncTo(to2) {
    return (0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).fun(to2) || (0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).arr(to2) && (0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).obj(to2[0]);
}
function $9abb3f64d0b26b19$var$detachRefs(ctrl, ref) {
    ctrl.ref?.delete(ctrl);
    ref?.delete(ctrl);
}
function $9abb3f64d0b26b19$var$replaceRef(ctrl, ref) {
    if (ref && ctrl.ref !== ref) {
        ctrl.ref?.delete(ctrl);
        ref.add(ctrl);
        ctrl.ref = ref;
    }
}
// src/hooks/useChain.ts
function $9abb3f64d0b26b19$export$a4a17273dffcc09c(refs, timeSteps, timeFrame = 1e3) {
    (0, $0188c8620d3f23ab$export$700979bc83e7db82)(()=>{
        if (timeSteps) {
            let prevDelay = 0;
            (0, $0188c8620d3f23ab$export$79b2f7037acddd43)(refs, (ref, i)=>{
                const controllers = ref.current;
                if (controllers.length) {
                    let delay = timeFrame * timeSteps[i];
                    if (isNaN(delay)) delay = prevDelay;
                    else prevDelay = delay;
                    (0, $0188c8620d3f23ab$export$79b2f7037acddd43)(controllers, (ctrl)=>{
                        (0, $0188c8620d3f23ab$export$79b2f7037acddd43)(ctrl.queue, (props)=>{
                            const memoizedDelayProp = props.delay;
                            props.delay = (key)=>delay + $9abb3f64d0b26b19$var$callProp(memoizedDelayProp || 0, key);
                        });
                    });
                    ref.start();
                }
            });
        } else {
            let p = Promise.resolve();
            (0, $0188c8620d3f23ab$export$79b2f7037acddd43)(refs, (ref)=>{
                const controllers = ref.current;
                if (controllers.length) {
                    const queues = controllers.map((ctrl)=>{
                        const q = ctrl.queue;
                        ctrl.queue = [];
                        return q;
                    });
                    p = p.then(()=>{
                        (0, $0188c8620d3f23ab$export$79b2f7037acddd43)(controllers, (ctrl, i)=>(0, $0188c8620d3f23ab$export$79b2f7037acddd43)(queues[i] || [], (update2)=>ctrl.queue.push(update2)));
                        return Promise.all(ref.start());
                    });
                }
            });
        }
    });
}
// src/constants.ts
var $9abb3f64d0b26b19$export$e506a1d27d1eaa20 = {
    default: {
        tension: 170,
        friction: 26
    },
    gentle: {
        tension: 120,
        friction: 14
    },
    wobbly: {
        tension: 180,
        friction: 12
    },
    stiff: {
        tension: 210,
        friction: 20
    },
    slow: {
        tension: 280,
        friction: 60
    },
    molasses: {
        tension: 280,
        friction: 120
    }
};
// src/AnimationConfig.ts
var $9abb3f64d0b26b19$var$defaults = {
    ...$9abb3f64d0b26b19$export$e506a1d27d1eaa20.default,
    mass: 1,
    damping: 1,
    easing: (0, $0188c8620d3f23ab$export$15a0bf1b4bbacad8).linear,
    clamp: false
};
var $9abb3f64d0b26b19$var$AnimationConfig = class {
    constructor(){
        /**
     * The initial velocity of one or more values.
     *
     * @default 0
     */ this.velocity = 0;
        Object.assign(this, $9abb3f64d0b26b19$var$defaults);
    }
};
function $9abb3f64d0b26b19$var$mergeConfig(config2, newConfig, defaultConfig) {
    if (defaultConfig) {
        defaultConfig = {
            ...defaultConfig
        };
        $9abb3f64d0b26b19$var$sanitizeConfig(defaultConfig, newConfig);
        newConfig = {
            ...defaultConfig,
            ...newConfig
        };
    }
    $9abb3f64d0b26b19$var$sanitizeConfig(config2, newConfig);
    Object.assign(config2, newConfig);
    for(const key in $9abb3f64d0b26b19$var$defaults)if (config2[key] == null) config2[key] = $9abb3f64d0b26b19$var$defaults[key];
    let { frequency: frequency, damping: damping } = config2;
    const { mass: mass } = config2;
    if (!(0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).und(frequency)) {
        if (frequency < 0.01) frequency = 0.01;
        if (damping < 0) damping = 0;
        config2.tension = Math.pow(2 * Math.PI / frequency, 2) * mass;
        config2.friction = 4 * Math.PI * damping * mass / frequency;
    }
    return config2;
}
function $9abb3f64d0b26b19$var$sanitizeConfig(config2, props) {
    if (!(0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).und(props.decay)) config2.duration = void 0;
    else {
        const isTensionConfig = !(0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).und(props.tension) || !(0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).und(props.friction);
        if (isTensionConfig || !(0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).und(props.frequency) || !(0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).und(props.damping) || !(0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).und(props.mass)) {
            config2.duration = void 0;
            config2.decay = void 0;
        }
        if (isTensionConfig) config2.frequency = void 0;
    }
}
// src/Animation.ts
var $9abb3f64d0b26b19$var$emptyArray = [];
var $9abb3f64d0b26b19$var$Animation = class {
    constructor(){
        this.changed = false;
        this.values = $9abb3f64d0b26b19$var$emptyArray;
        this.toValues = null;
        this.fromValues = $9abb3f64d0b26b19$var$emptyArray;
        this.config = new $9abb3f64d0b26b19$var$AnimationConfig();
        this.immediate = false;
    }
};
function $9abb3f64d0b26b19$var$scheduleProps(callId, { key: key, props: props, defaultProps: defaultProps, state: state, actions: actions }) {
    return new Promise((resolve, reject)=>{
        let delay;
        let timeout;
        let cancel = $9abb3f64d0b26b19$var$matchProp(props.cancel ?? defaultProps?.cancel, key);
        if (cancel) onStart();
        else {
            if (!(0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).und(props.pause)) state.paused = $9abb3f64d0b26b19$var$matchProp(props.pause, key);
            let pause = defaultProps?.pause;
            if (pause !== true) pause = state.paused || $9abb3f64d0b26b19$var$matchProp(pause, key);
            delay = $9abb3f64d0b26b19$var$callProp(props.delay || 0, key);
            if (pause) {
                state.resumeQueue.add(onResume);
                actions.pause();
            } else {
                actions.resume();
                onResume();
            }
        }
        function onPause() {
            state.resumeQueue.add(onResume);
            state.timeouts.delete(timeout);
            timeout.cancel();
            delay = timeout.time - (0, $14f355fb1db5a5c1$export$27f233d61a9e2fa4).now();
        }
        function onResume() {
            if (delay > 0 && !(0, $0188c8620d3f23ab$export$cceeabf822b64fc0).skipAnimation) {
                state.delayed = true;
                timeout = (0, $14f355fb1db5a5c1$export$27f233d61a9e2fa4).setTimeout(onStart, delay);
                state.pauseQueue.add(onPause);
                state.timeouts.add(timeout);
            } else onStart();
        }
        function onStart() {
            if (state.delayed) state.delayed = false;
            state.pauseQueue.delete(onPause);
            state.timeouts.delete(timeout);
            if (callId <= (state.cancelId || 0)) cancel = true;
            try {
                actions.start({
                    ...props,
                    callId: callId,
                    cancel: cancel
                }, resolve);
            } catch (err) {
                reject(err);
            }
        }
    });
}
// src/AnimationResult.ts
var $9abb3f64d0b26b19$var$getCombinedResult = (target, results)=>results.length == 1 ? results[0] : results.some((result)=>result.cancelled) ? $9abb3f64d0b26b19$var$getCancelledResult(target.get()) : results.every((result)=>result.noop) ? $9abb3f64d0b26b19$var$getNoopResult(target.get()) : $9abb3f64d0b26b19$var$getFinishedResult(target.get(), results.every((result)=>result.finished));
var $9abb3f64d0b26b19$var$getNoopResult = (value)=>({
        value: value,
        noop: true,
        finished: true,
        cancelled: false
    });
var $9abb3f64d0b26b19$var$getFinishedResult = (value, finished, cancelled = false)=>({
        value: value,
        finished: finished,
        cancelled: cancelled
    });
var $9abb3f64d0b26b19$var$getCancelledResult = (value)=>({
        value: value,
        cancelled: true,
        finished: false
    });
// src/runAsync.ts
function $9abb3f64d0b26b19$var$runAsync(to2, props, state, target) {
    const { callId: callId, parentId: parentId, onRest: onRest } = props;
    const { asyncTo: prevTo, promise: prevPromise } = state;
    if (!parentId && to2 === prevTo && !props.reset) return prevPromise;
    return state.promise = (async ()=>{
        state.asyncId = callId;
        state.asyncTo = to2;
        const defaultProps = $9abb3f64d0b26b19$var$getDefaultProps(props, (value, key)=>// The `onRest` prop is only called when the `runAsync` promise is resolved.
            key === "onRest" ? void 0 : value);
        let preventBail;
        let bail;
        const bailPromise = new Promise((resolve, reject)=>(preventBail = resolve, bail = reject));
        const bailIfEnded = (bailSignal)=>{
            const bailResult = // The `cancel` prop or `stop` method was used.
            callId <= (state.cancelId || 0) && $9abb3f64d0b26b19$var$getCancelledResult(target) || // The async `to` prop was replaced.
            callId !== state.asyncId && $9abb3f64d0b26b19$var$getFinishedResult(target, false);
            if (bailResult) {
                bailSignal.result = bailResult;
                bail(bailSignal);
                throw bailSignal;
            }
        };
        const animate = (arg1, arg2)=>{
            const bailSignal = new $9abb3f64d0b26b19$export$d362d093fa99dc7();
            const skipAnimationSignal = new $9abb3f64d0b26b19$var$SkipAnimationSignal();
            return (async ()=>{
                if ((0, $0188c8620d3f23ab$export$cceeabf822b64fc0).skipAnimation) {
                    $9abb3f64d0b26b19$var$stopAsync(state);
                    skipAnimationSignal.result = $9abb3f64d0b26b19$var$getFinishedResult(target, false);
                    bail(skipAnimationSignal);
                    throw skipAnimationSignal;
                }
                bailIfEnded(bailSignal);
                const props2 = (0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).obj(arg1) ? {
                    ...arg1
                } : {
                    ...arg2,
                    to: arg1
                };
                props2.parentId = callId;
                (0, $0188c8620d3f23ab$export$f4c6fe153f5a944e)(defaultProps, (value, key)=>{
                    if ((0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).und(props2[key])) props2[key] = value;
                });
                const result2 = await target.start(props2);
                bailIfEnded(bailSignal);
                if (state.paused) await new Promise((resume)=>{
                    state.resumeQueue.add(resume);
                });
                return result2;
            })();
        };
        let result;
        if ((0, $0188c8620d3f23ab$export$cceeabf822b64fc0).skipAnimation) {
            $9abb3f64d0b26b19$var$stopAsync(state);
            return $9abb3f64d0b26b19$var$getFinishedResult(target, false);
        }
        try {
            let animating;
            if ((0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).arr(to2)) animating = (async (queue)=>{
                for (const props2 of queue)await animate(props2);
            })(to2);
            else animating = Promise.resolve(to2(animate, target.stop.bind(target)));
            await Promise.all([
                animating.then(preventBail),
                bailPromise
            ]);
            result = $9abb3f64d0b26b19$var$getFinishedResult(target.get(), true, false);
        } catch (err) {
            if (err instanceof $9abb3f64d0b26b19$export$d362d093fa99dc7) result = err.result;
            else if (err instanceof $9abb3f64d0b26b19$var$SkipAnimationSignal) result = err.result;
            else throw err;
        } finally{
            if (callId == state.asyncId) {
                state.asyncId = parentId;
                state.asyncTo = parentId ? prevTo : void 0;
                state.promise = parentId ? prevPromise : void 0;
            }
        }
        if ((0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).fun(onRest)) (0, $14f355fb1db5a5c1$export$27f233d61a9e2fa4).batchedUpdates(()=>{
            onRest(result, target, target.item);
        });
        return result;
    })();
}
function $9abb3f64d0b26b19$var$stopAsync(state, cancelId) {
    (0, $0188c8620d3f23ab$export$4909b86c8034bf73)(state.timeouts, (t)=>t.cancel());
    state.pauseQueue.clear();
    state.resumeQueue.clear();
    state.asyncId = state.asyncTo = state.promise = void 0;
    if (cancelId) state.cancelId = cancelId;
}
var $9abb3f64d0b26b19$export$d362d093fa99dc7 = class extends Error {
    constructor(){
        super("An async animation has been interrupted. You see this error because you forgot to use `await` or `.catch(...)` on its returned promise.");
    }
};
var $9abb3f64d0b26b19$var$SkipAnimationSignal = class extends Error {
    constructor(){
        super("SkipAnimationSignal");
    }
};
var $9abb3f64d0b26b19$var$isFrameValue = (value)=>value instanceof $9abb3f64d0b26b19$export$8229896f80e2495e;
var $9abb3f64d0b26b19$var$nextId = 1;
var $9abb3f64d0b26b19$export$8229896f80e2495e = class extends (0, $0188c8620d3f23ab$export$aff8e1ac1a016a2) {
    constructor(){
        super(...arguments);
        this.id = $9abb3f64d0b26b19$var$nextId++;
        this._priority = 0;
    }
    get priority() {
        return this._priority;
    }
    set priority(priority) {
        if (this._priority != priority) {
            this._priority = priority;
            this._onPriorityChange(priority);
        }
    }
    /** Get the current value */ get() {
        const node = (0, $21c5332537d86d23$export$6b63995194a3a9e4)(this);
        return node && node.getValue();
    }
    /** Create a spring that maps our value to another value */ to(...args) {
        return (0, $0188c8620d3f23ab$export$cceeabf822b64fc0).to(this, args);
    }
    /** @deprecated Use the `to` method instead. */ interpolate(...args) {
        (0, $0188c8620d3f23ab$export$2abfcde8ae218ba8)();
        return (0, $0188c8620d3f23ab$export$cceeabf822b64fc0).to(this, args);
    }
    toJSON() {
        return this.get();
    }
    observerAdded(count) {
        if (count == 1) this._attach();
    }
    observerRemoved(count) {
        if (count == 0) this._detach();
    }
    /** Called when the first child is added. */ _attach() {}
    /** Called when the last child is removed. */ _detach() {}
    /** Tell our children about our new value */ _onChange(value, idle = false) {
        (0, $0188c8620d3f23ab$export$31752c40a5fab62a)(this, {
            type: "change",
            parent: this,
            value: value,
            idle: idle
        });
    }
    /** Tell our children about our new priority */ _onPriorityChange(priority) {
        if (!this.idle) (0, $0188c8620d3f23ab$export$a57f5080a3bcc90a).sort(this);
        (0, $0188c8620d3f23ab$export$31752c40a5fab62a)(this, {
            type: "priority",
            parent: this,
            priority: priority
        });
    }
};
// src/SpringPhase.ts
var $9abb3f64d0b26b19$var$$P = Symbol.for("SpringPhase");
var $9abb3f64d0b26b19$var$HAS_ANIMATED = 1;
var $9abb3f64d0b26b19$var$IS_ANIMATING = 2;
var $9abb3f64d0b26b19$var$IS_PAUSED = 4;
var $9abb3f64d0b26b19$var$hasAnimated = (target)=>(target[$9abb3f64d0b26b19$var$$P] & $9abb3f64d0b26b19$var$HAS_ANIMATED) > 0;
var $9abb3f64d0b26b19$var$isAnimating = (target)=>(target[$9abb3f64d0b26b19$var$$P] & $9abb3f64d0b26b19$var$IS_ANIMATING) > 0;
var $9abb3f64d0b26b19$var$isPaused = (target)=>(target[$9abb3f64d0b26b19$var$$P] & $9abb3f64d0b26b19$var$IS_PAUSED) > 0;
var $9abb3f64d0b26b19$var$setActiveBit = (target, active)=>active ? target[$9abb3f64d0b26b19$var$$P] |= $9abb3f64d0b26b19$var$IS_ANIMATING | $9abb3f64d0b26b19$var$HAS_ANIMATED : target[$9abb3f64d0b26b19$var$$P] &= ~$9abb3f64d0b26b19$var$IS_ANIMATING;
var $9abb3f64d0b26b19$var$setPausedBit = (target, paused)=>paused ? target[$9abb3f64d0b26b19$var$$P] |= $9abb3f64d0b26b19$var$IS_PAUSED : target[$9abb3f64d0b26b19$var$$P] &= ~$9abb3f64d0b26b19$var$IS_PAUSED;
// src/SpringValue.ts
var $9abb3f64d0b26b19$export$5854d13427d5a954 = class extends $9abb3f64d0b26b19$export$8229896f80e2495e {
    constructor(arg1, arg2){
        super();
        /** The animation state */ this.animation = new $9abb3f64d0b26b19$var$Animation();
        /** Some props have customizable default values */ this.defaultProps = {};
        /** The state for `runAsync` calls */ this._state = {
            paused: false,
            delayed: false,
            pauseQueue: /* @__PURE__ */ new Set(),
            resumeQueue: /* @__PURE__ */ new Set(),
            timeouts: /* @__PURE__ */ new Set()
        };
        /** The promise resolvers of pending `start` calls */ this._pendingCalls = /* @__PURE__ */ new Set();
        /** The counter for tracking `scheduleProps` calls */ this._lastCallId = 0;
        /** The last `scheduleProps` call that changed the `to` prop */ this._lastToId = 0;
        this._memoizedDuration = 0;
        if (!(0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).und(arg1) || !(0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).und(arg2)) {
            const props = (0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).obj(arg1) ? {
                ...arg1
            } : {
                ...arg2,
                from: arg1
            };
            if ((0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).und(props.default)) props.default = true;
            this.start(props);
        }
    }
    /** Equals true when not advancing on each frame. */ get idle() {
        return !($9abb3f64d0b26b19$var$isAnimating(this) || this._state.asyncTo) || $9abb3f64d0b26b19$var$isPaused(this);
    }
    get goal() {
        return (0, $0188c8620d3f23ab$export$e37b7520edd66839)(this.animation.to);
    }
    get velocity() {
        const node = (0, $21c5332537d86d23$export$6b63995194a3a9e4)(this);
        return node instanceof (0, $21c5332537d86d23$export$cb1e8f3c05d37ad5) ? node.lastVelocity || 0 : node.getPayload().map((node2)=>node2.lastVelocity || 0);
    }
    /**
   * When true, this value has been animated at least once.
   */ get hasAnimated() {
        return $9abb3f64d0b26b19$var$hasAnimated(this);
    }
    /**
   * When true, this value has an unfinished animation,
   * which is either active or paused.
   */ get isAnimating() {
        return $9abb3f64d0b26b19$var$isAnimating(this);
    }
    /**
   * When true, all current and future animations are paused.
   */ get isPaused() {
        return $9abb3f64d0b26b19$var$isPaused(this);
    }
    /**
   *
   *
   */ get isDelayed() {
        return this._state.delayed;
    }
    /** Advance the current animation by a number of milliseconds */ advance(dt) {
        let idle = true;
        let changed = false;
        const anim = this.animation;
        let { toValues: toValues } = anim;
        const { config: config2 } = anim;
        const payload = (0, $21c5332537d86d23$export$ccab2b64c5d440)(anim.to);
        if (!payload && (0, $0188c8620d3f23ab$export$57ea7e3a7f6280c7)(anim.to)) toValues = (0, $0188c8620d3f23ab$export$45b10814cc054894)((0, $0188c8620d3f23ab$export$e37b7520edd66839)(anim.to));
        anim.values.forEach((node2, i)=>{
            if (node2.done) return;
            const to2 = // Animated strings always go from 0 to 1.
            node2.constructor == (0, $21c5332537d86d23$export$f6c6c4cbd7fa5b93) ? 1 : payload ? payload[i].lastPosition : toValues[i];
            let finished = anim.immediate;
            let position = to2;
            if (!finished) {
                position = node2.lastPosition;
                if (config2.tension <= 0) {
                    node2.done = true;
                    return;
                }
                let elapsed = node2.elapsedTime += dt;
                const from = anim.fromValues[i];
                const v0 = node2.v0 != null ? node2.v0 : node2.v0 = (0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).arr(config2.velocity) ? config2.velocity[i] : config2.velocity;
                let velocity;
                const precision = config2.precision || (from == to2 ? 5e-3 : Math.min(1, Math.abs(to2 - from) * 1e-3));
                if (!(0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).und(config2.duration)) {
                    let p = 1;
                    if (config2.duration > 0) {
                        if (this._memoizedDuration !== config2.duration) {
                            this._memoizedDuration = config2.duration;
                            if (node2.durationProgress > 0) {
                                node2.elapsedTime = config2.duration * node2.durationProgress;
                                elapsed = node2.elapsedTime += dt;
                            }
                        }
                        p = (config2.progress || 0) + elapsed / this._memoizedDuration;
                        p = p > 1 ? 1 : p < 0 ? 0 : p;
                        node2.durationProgress = p;
                    }
                    position = from + config2.easing(p) * (to2 - from);
                    velocity = (position - node2.lastPosition) / dt;
                    finished = p == 1;
                } else if (config2.decay) {
                    const decay = config2.decay === true ? 0.998 : config2.decay;
                    const e = Math.exp(-(1 - decay) * elapsed);
                    position = from + v0 / (1 - decay) * (1 - e);
                    finished = Math.abs(node2.lastPosition - position) <= precision;
                    velocity = v0 * e;
                } else {
                    velocity = node2.lastVelocity == null ? v0 : node2.lastVelocity;
                    const restVelocity = config2.restVelocity || precision / 10;
                    const bounceFactor = config2.clamp ? 0 : config2.bounce;
                    const canBounce = !(0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).und(bounceFactor);
                    const isGrowing = from == to2 ? node2.v0 > 0 : from < to2;
                    let isMoving;
                    let isBouncing = false;
                    const step = 1;
                    const numSteps = Math.ceil(dt / step);
                    for(let n = 0; n < numSteps; ++n){
                        isMoving = Math.abs(velocity) > restVelocity;
                        if (!isMoving) {
                            finished = Math.abs(to2 - position) <= precision;
                            if (finished) break;
                        }
                        if (canBounce) {
                            isBouncing = position == to2 || position > to2 == isGrowing;
                            if (isBouncing) {
                                velocity = -velocity * bounceFactor;
                                position = to2;
                            }
                        }
                        const springForce = -config2.tension * 1e-6 * (position - to2);
                        const dampingForce = -config2.friction * 1e-3 * velocity;
                        const acceleration = (springForce + dampingForce) / config2.mass;
                        velocity = velocity + acceleration * step;
                        position = position + velocity * step;
                    }
                }
                node2.lastVelocity = velocity;
                if (Number.isNaN(position)) {
                    console.warn(`Got NaN while animating:`, this);
                    finished = true;
                }
            }
            if (payload && !payload[i].done) finished = false;
            if (finished) node2.done = true;
            else idle = false;
            if (node2.setValue(position, config2.round)) changed = true;
        });
        const node = (0, $21c5332537d86d23$export$6b63995194a3a9e4)(this);
        const currVal = node.getValue();
        if (idle) {
            const finalVal = (0, $0188c8620d3f23ab$export$e37b7520edd66839)(anim.to);
            if ((currVal !== finalVal || changed) && !config2.decay) {
                node.setValue(finalVal);
                this._onChange(finalVal);
            } else if (changed && config2.decay) this._onChange(currVal);
            this._stop();
        } else if (changed) this._onChange(currVal);
    }
    /** Set the current value, while stopping the current animation */ set(value) {
        (0, $14f355fb1db5a5c1$export$27f233d61a9e2fa4).batchedUpdates(()=>{
            this._stop();
            this._focus(value);
            this._set(value);
        });
        return this;
    }
    /**
   * Freeze the active animation in time, as well as any updates merged
   * before `resume` is called.
   */ pause() {
        this._update({
            pause: true
        });
    }
    /** Resume the animation if paused. */ resume() {
        this._update({
            pause: false
        });
    }
    /** Skip to the end of the current animation. */ finish() {
        if ($9abb3f64d0b26b19$var$isAnimating(this)) {
            const { to: to2, config: config2 } = this.animation;
            (0, $14f355fb1db5a5c1$export$27f233d61a9e2fa4).batchedUpdates(()=>{
                this._onStart();
                if (!config2.decay) this._set(to2, false);
                this._stop();
            });
        }
        return this;
    }
    /** Push props into the pending queue. */ update(props) {
        const queue = this.queue || (this.queue = []);
        queue.push(props);
        return this;
    }
    start(to2, arg2) {
        let queue;
        if (!(0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).und(to2)) queue = [
            (0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).obj(to2) ? to2 : {
                ...arg2,
                to: to2
            }
        ];
        else {
            queue = this.queue || [];
            this.queue = [];
        }
        return Promise.all(queue.map((props)=>{
            const up = this._update(props);
            return up;
        })).then((results)=>$9abb3f64d0b26b19$var$getCombinedResult(this, results));
    }
    /**
   * Stop the current animation, and cancel any delayed updates.
   *
   * Pass `true` to call `onRest` with `cancelled: true`.
   */ stop(cancel) {
        const { to: to2 } = this.animation;
        this._focus(this.get());
        $9abb3f64d0b26b19$var$stopAsync(this._state, cancel && this._lastCallId);
        (0, $14f355fb1db5a5c1$export$27f233d61a9e2fa4).batchedUpdates(()=>this._stop(to2, cancel));
        return this;
    }
    /** Restart the animation. */ reset() {
        this._update({
            reset: true
        });
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") this._start();
        else if (event.type == "priority") this.priority = event.priority + 1;
    }
    /**
   * Parse the `to` and `from` range from the given `props` object.
   *
   * This also ensures the initial value is available to animated components
   * during the render phase.
   */ _prepareNode(props) {
        const key = this.key || "";
        let { to: to2, from: from } = props;
        to2 = (0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).obj(to2) ? to2[key] : to2;
        if (to2 == null || $9abb3f64d0b26b19$var$isAsyncTo(to2)) to2 = void 0;
        from = (0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).obj(from) ? from[key] : from;
        if (from == null) from = void 0;
        const range = {
            to: to2,
            from: from
        };
        if (!$9abb3f64d0b26b19$var$hasAnimated(this)) {
            if (props.reverse) [to2, from] = [
                from,
                to2
            ];
            from = (0, $0188c8620d3f23ab$export$e37b7520edd66839)(from);
            if (!(0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).und(from)) this._set(from);
            else if (!(0, $21c5332537d86d23$export$6b63995194a3a9e4)(this)) this._set(to2);
        }
        return range;
    }
    /** Every update is processed by this method before merging. */ _update({ ...props }, isLoop) {
        const { key: key, defaultProps: defaultProps } = this;
        if (props.default) Object.assign(defaultProps, $9abb3f64d0b26b19$var$getDefaultProps(props, (value, prop)=>/^on/.test(prop) ? $9abb3f64d0b26b19$var$resolveProp(value, key) : value));
        $9abb3f64d0b26b19$var$mergeActiveFn(this, props, "onProps");
        $9abb3f64d0b26b19$var$sendEvent(this, "onProps", props, this);
        const range = this._prepareNode(props);
        if (Object.isFrozen(this)) throw Error("Cannot animate a `SpringValue` object that is frozen. Did you forget to pass your component to `animated(...)` before animating its props?");
        const state = this._state;
        return $9abb3f64d0b26b19$var$scheduleProps(++this._lastCallId, {
            key: key,
            props: props,
            defaultProps: defaultProps,
            state: state,
            actions: {
                pause: ()=>{
                    if (!$9abb3f64d0b26b19$var$isPaused(this)) {
                        $9abb3f64d0b26b19$var$setPausedBit(this, true);
                        (0, $0188c8620d3f23ab$export$7ba486852759e806)(state.pauseQueue);
                        $9abb3f64d0b26b19$var$sendEvent(this, "onPause", $9abb3f64d0b26b19$var$getFinishedResult(this, $9abb3f64d0b26b19$var$checkFinished(this, this.animation.to)), this);
                    }
                },
                resume: ()=>{
                    if ($9abb3f64d0b26b19$var$isPaused(this)) {
                        $9abb3f64d0b26b19$var$setPausedBit(this, false);
                        if ($9abb3f64d0b26b19$var$isAnimating(this)) this._resume();
                        (0, $0188c8620d3f23ab$export$7ba486852759e806)(state.resumeQueue);
                        $9abb3f64d0b26b19$var$sendEvent(this, "onResume", $9abb3f64d0b26b19$var$getFinishedResult(this, $9abb3f64d0b26b19$var$checkFinished(this, this.animation.to)), this);
                    }
                },
                start: this._merge.bind(this, range)
            }
        }).then((result)=>{
            if (props.loop && result.finished && !(isLoop && result.noop)) {
                const nextProps = $9abb3f64d0b26b19$var$createLoopUpdate(props);
                if (nextProps) return this._update(nextProps, true);
            }
            return result;
        });
    }
    /** Merge props into the current animation */ _merge(range, props, resolve) {
        if (props.cancel) {
            this.stop(true);
            return resolve($9abb3f64d0b26b19$var$getCancelledResult(this));
        }
        const hasToProp = !(0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).und(range.to);
        const hasFromProp = !(0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).und(range.from);
        if (hasToProp || hasFromProp) {
            if (props.callId > this._lastToId) this._lastToId = props.callId;
            else return resolve($9abb3f64d0b26b19$var$getCancelledResult(this));
        }
        const { key: key, defaultProps: defaultProps, animation: anim } = this;
        const { to: prevTo, from: prevFrom } = anim;
        let { to: to2 = prevTo, from: from = prevFrom } = range;
        if (hasFromProp && !hasToProp && (!props.default || (0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).und(to2))) to2 = from;
        if (props.reverse) [to2, from] = [
            from,
            to2
        ];
        const hasFromChanged = !(0, $0188c8620d3f23ab$export$248d38f6296296c5)(from, prevFrom);
        if (hasFromChanged) anim.from = from;
        from = (0, $0188c8620d3f23ab$export$e37b7520edd66839)(from);
        const hasToChanged = !(0, $0188c8620d3f23ab$export$248d38f6296296c5)(to2, prevTo);
        if (hasToChanged) this._focus(to2);
        const hasAsyncTo = $9abb3f64d0b26b19$var$isAsyncTo(props.to);
        const { config: config2 } = anim;
        const { decay: decay, velocity: velocity } = config2;
        if (hasToProp || hasFromProp) config2.velocity = 0;
        if (props.config && !hasAsyncTo) $9abb3f64d0b26b19$var$mergeConfig(config2, $9abb3f64d0b26b19$var$callProp(props.config, key), // Avoid calling the same "config" prop twice.
        props.config !== defaultProps.config ? $9abb3f64d0b26b19$var$callProp(defaultProps.config, key) : void 0);
        let node = (0, $21c5332537d86d23$export$6b63995194a3a9e4)(this);
        if (!node || (0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).und(to2)) return resolve($9abb3f64d0b26b19$var$getFinishedResult(this, true));
        const reset = // When `reset` is undefined, the `from` prop implies `reset: true`,
        // except for declarative updates. When `reset` is defined, there
        // must exist a value to animate from.
        (0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).und(props.reset) ? hasFromProp && !props.default : !(0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).und(from) && $9abb3f64d0b26b19$var$matchProp(props.reset, key);
        const value = reset ? from : this.get();
        const goal = $9abb3f64d0b26b19$var$computeGoal(to2);
        const isAnimatable = (0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).num(goal) || (0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).arr(goal) || (0, $0188c8620d3f23ab$export$75bed621f62abfa9)(goal);
        const immediate = !hasAsyncTo && (!isAnimatable || $9abb3f64d0b26b19$var$matchProp(defaultProps.immediate || props.immediate, key));
        if (hasToChanged) {
            const nodeType = (0, $21c5332537d86d23$export$e6b77ddbe47b132e)(to2);
            if (nodeType !== node.constructor) {
                if (immediate) node = this._set(goal);
                else throw Error(`Cannot animate between ${node.constructor.name} and ${nodeType.name}, as the "to" prop suggests`);
            }
        }
        const goalType = node.constructor;
        let started = (0, $0188c8620d3f23ab$export$57ea7e3a7f6280c7)(to2);
        let finished = false;
        if (!started) {
            const hasValueChanged = reset || !$9abb3f64d0b26b19$var$hasAnimated(this) && hasFromChanged;
            if (hasToChanged || hasValueChanged) {
                finished = (0, $0188c8620d3f23ab$export$248d38f6296296c5)($9abb3f64d0b26b19$var$computeGoal(value), goal);
                started = !finished;
            }
            if (!(0, $0188c8620d3f23ab$export$248d38f6296296c5)(anim.immediate, immediate) && !immediate || !(0, $0188c8620d3f23ab$export$248d38f6296296c5)(config2.decay, decay) || !(0, $0188c8620d3f23ab$export$248d38f6296296c5)(config2.velocity, velocity)) started = true;
        }
        if (finished && $9abb3f64d0b26b19$var$isAnimating(this)) {
            if (anim.changed && !reset) started = true;
            else if (!started) this._stop(prevTo);
        }
        if (!hasAsyncTo) {
            if (started || (0, $0188c8620d3f23ab$export$57ea7e3a7f6280c7)(prevTo)) {
                anim.values = node.getPayload();
                anim.toValues = (0, $0188c8620d3f23ab$export$57ea7e3a7f6280c7)(to2) ? null : goalType == (0, $21c5332537d86d23$export$f6c6c4cbd7fa5b93) ? [
                    1
                ] : (0, $0188c8620d3f23ab$export$45b10814cc054894)(goal);
            }
            if (anim.immediate != immediate) {
                anim.immediate = immediate;
                if (!immediate && !reset) this._set(prevTo);
            }
            if (started) {
                const { onRest: onRest } = anim;
                (0, $0188c8620d3f23ab$export$79b2f7037acddd43)($9abb3f64d0b26b19$var$ACTIVE_EVENTS, (type)=>$9abb3f64d0b26b19$var$mergeActiveFn(this, props, type));
                const result = $9abb3f64d0b26b19$var$getFinishedResult(this, $9abb3f64d0b26b19$var$checkFinished(this, prevTo));
                (0, $0188c8620d3f23ab$export$7ba486852759e806)(this._pendingCalls, result);
                this._pendingCalls.add(resolve);
                if (anim.changed) (0, $14f355fb1db5a5c1$export$27f233d61a9e2fa4).batchedUpdates(()=>{
                    anim.changed = !reset;
                    onRest?.(result, this);
                    if (reset) $9abb3f64d0b26b19$var$callProp(defaultProps.onRest, result);
                    else anim.onStart?.(result, this);
                });
            }
        }
        if (reset) this._set(value);
        if (hasAsyncTo) resolve($9abb3f64d0b26b19$var$runAsync(props.to, props, this._state, this));
        else if (started) this._start();
        else if ($9abb3f64d0b26b19$var$isAnimating(this) && !hasToChanged) this._pendingCalls.add(resolve);
        else resolve($9abb3f64d0b26b19$var$getNoopResult(value));
    }
    /** Update the `animation.to` value, which might be a `FluidValue` */ _focus(value) {
        const anim = this.animation;
        if (value !== anim.to) {
            if ((0, $0188c8620d3f23ab$export$133f54e9f7cf1796)(this)) this._detach();
            anim.to = value;
            if ((0, $0188c8620d3f23ab$export$133f54e9f7cf1796)(this)) this._attach();
        }
    }
    _attach() {
        let priority = 0;
        const { to: to2 } = this.animation;
        if ((0, $0188c8620d3f23ab$export$57ea7e3a7f6280c7)(to2)) {
            (0, $0188c8620d3f23ab$export$72d604e3f8d000a5)(to2, this);
            if ($9abb3f64d0b26b19$var$isFrameValue(to2)) priority = to2.priority + 1;
        }
        this.priority = priority;
    }
    _detach() {
        const { to: to2 } = this.animation;
        if ((0, $0188c8620d3f23ab$export$57ea7e3a7f6280c7)(to2)) (0, $0188c8620d3f23ab$export$7a0eb830d336339b)(to2, this);
    }
    /**
   * Update the current value from outside the frameloop,
   * and return the `Animated` node.
   */ _set(arg, idle = true) {
        const value = (0, $0188c8620d3f23ab$export$e37b7520edd66839)(arg);
        if (!(0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).und(value)) {
            const oldNode = (0, $21c5332537d86d23$export$6b63995194a3a9e4)(this);
            if (!oldNode || !(0, $0188c8620d3f23ab$export$248d38f6296296c5)(value, oldNode.getValue())) {
                const nodeType = (0, $21c5332537d86d23$export$e6b77ddbe47b132e)(value);
                if (!oldNode || oldNode.constructor != nodeType) (0, $21c5332537d86d23$export$b553cb5b22b81b04)(this, nodeType.create(value));
                else oldNode.setValue(value);
                if (oldNode) (0, $14f355fb1db5a5c1$export$27f233d61a9e2fa4).batchedUpdates(()=>{
                    this._onChange(value, idle);
                });
            }
        }
        return (0, $21c5332537d86d23$export$6b63995194a3a9e4)(this);
    }
    _onStart() {
        const anim = this.animation;
        if (!anim.changed) {
            anim.changed = true;
            $9abb3f64d0b26b19$var$sendEvent(this, "onStart", $9abb3f64d0b26b19$var$getFinishedResult(this, $9abb3f64d0b26b19$var$checkFinished(this, anim.to)), this);
        }
    }
    _onChange(value, idle) {
        if (!idle) {
            this._onStart();
            $9abb3f64d0b26b19$var$callProp(this.animation.onChange, value, this);
        }
        $9abb3f64d0b26b19$var$callProp(this.defaultProps.onChange, value, this);
        super._onChange(value, idle);
    }
    // This method resets the animation state (even if already animating) to
    // ensure the latest from/to range is used, and it also ensures this spring
    // is added to the frameloop.
    _start() {
        const anim = this.animation;
        (0, $21c5332537d86d23$export$6b63995194a3a9e4)(this).reset((0, $0188c8620d3f23ab$export$e37b7520edd66839)(anim.to));
        if (!anim.immediate) anim.fromValues = anim.values.map((node)=>node.lastPosition);
        if (!$9abb3f64d0b26b19$var$isAnimating(this)) {
            $9abb3f64d0b26b19$var$setActiveBit(this, true);
            if (!$9abb3f64d0b26b19$var$isPaused(this)) this._resume();
        }
    }
    _resume() {
        if ((0, $0188c8620d3f23ab$export$cceeabf822b64fc0).skipAnimation) this.finish();
        else (0, $0188c8620d3f23ab$export$a57f5080a3bcc90a).start(this);
    }
    /**
   * Exit the frameloop and notify `onRest` listeners.
   *
   * Always wrap `_stop` calls with `batchedUpdates`.
   */ _stop(goal, cancel) {
        if ($9abb3f64d0b26b19$var$isAnimating(this)) {
            $9abb3f64d0b26b19$var$setActiveBit(this, false);
            const anim = this.animation;
            (0, $0188c8620d3f23ab$export$79b2f7037acddd43)(anim.values, (node)=>{
                node.done = true;
            });
            if (anim.toValues) anim.onChange = anim.onPause = anim.onResume = void 0;
            (0, $0188c8620d3f23ab$export$31752c40a5fab62a)(this, {
                type: "idle",
                parent: this
            });
            const result = cancel ? $9abb3f64d0b26b19$var$getCancelledResult(this.get()) : $9abb3f64d0b26b19$var$getFinishedResult(this.get(), $9abb3f64d0b26b19$var$checkFinished(this, goal ?? anim.to));
            (0, $0188c8620d3f23ab$export$7ba486852759e806)(this._pendingCalls, result);
            if (anim.changed) {
                anim.changed = false;
                $9abb3f64d0b26b19$var$sendEvent(this, "onRest", result, this);
            }
        }
    }
};
function $9abb3f64d0b26b19$var$checkFinished(target, to2) {
    const goal = $9abb3f64d0b26b19$var$computeGoal(to2);
    const value = $9abb3f64d0b26b19$var$computeGoal(target.get());
    return (0, $0188c8620d3f23ab$export$248d38f6296296c5)(value, goal);
}
function $9abb3f64d0b26b19$var$createLoopUpdate(props, loop = props.loop, to2 = props.to) {
    const loopRet = $9abb3f64d0b26b19$var$callProp(loop);
    if (loopRet) {
        const overrides = loopRet !== true && $9abb3f64d0b26b19$export$b971039a739bf227(loopRet);
        const reverse = (overrides || props).reverse;
        const reset = !overrides || overrides.reset;
        return $9abb3f64d0b26b19$var$createUpdate({
            ...props,
            loop: loop,
            // Avoid updating default props when looping.
            default: false,
            // Never loop the `pause` prop.
            pause: void 0,
            // For the "reverse" prop to loop as expected, the "to" prop
            // must be undefined. The "reverse" prop is ignored when the
            // "to" prop is an array or function.
            to: !reverse || $9abb3f64d0b26b19$var$isAsyncTo(to2) ? to2 : void 0,
            // Ignore the "from" prop except on reset.
            from: reset ? props.from : void 0,
            reset: reset,
            // The "loop" prop can return a "useSpring" props object to
            // override any of the original props.
            ...overrides
        });
    }
}
function $9abb3f64d0b26b19$var$createUpdate(props) {
    const { to: to2, from: from } = props = $9abb3f64d0b26b19$export$b971039a739bf227(props);
    const keys = /* @__PURE__ */ new Set();
    if ((0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).obj(to2)) $9abb3f64d0b26b19$var$findDefined(to2, keys);
    if ((0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).obj(from)) $9abb3f64d0b26b19$var$findDefined(from, keys);
    props.keys = keys.size ? Array.from(keys) : null;
    return props;
}
function $9abb3f64d0b26b19$var$declareUpdate(props) {
    const update2 = $9abb3f64d0b26b19$var$createUpdate(props);
    if ((0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).und(update2.default)) update2.default = $9abb3f64d0b26b19$var$getDefaultProps(update2);
    return update2;
}
function $9abb3f64d0b26b19$var$findDefined(values, keys) {
    (0, $0188c8620d3f23ab$export$f4c6fe153f5a944e)(values, (value, key)=>value != null && keys.add(key));
}
var $9abb3f64d0b26b19$var$ACTIVE_EVENTS = [
    "onStart",
    "onRest",
    "onChange",
    "onPause",
    "onResume"
];
function $9abb3f64d0b26b19$var$mergeActiveFn(target, props, type) {
    target.animation[type] = props[type] !== $9abb3f64d0b26b19$var$getDefaultProp(props, type) ? $9abb3f64d0b26b19$var$resolveProp(props[type], target.key) : void 0;
}
function $9abb3f64d0b26b19$var$sendEvent(target, type, ...args) {
    target.animation[type]?.(...args);
    target.defaultProps[type]?.(...args);
}
var $9abb3f64d0b26b19$var$BATCHED_EVENTS = [
    "onStart",
    "onChange",
    "onRest"
];
var $9abb3f64d0b26b19$var$nextId2 = 1;
var $9abb3f64d0b26b19$export$bd0bf19f25da8474 = class {
    constructor(props, flush3){
        this.id = $9abb3f64d0b26b19$var$nextId2++;
        /** The animated values */ this.springs = {};
        /** The queue of props passed to the `update` method. */ this.queue = [];
        /** The counter for tracking `scheduleProps` calls */ this._lastAsyncId = 0;
        /** The values currently being animated */ this._active = /* @__PURE__ */ new Set();
        /** The values that changed recently */ this._changed = /* @__PURE__ */ new Set();
        /** Equals false when `onStart` listeners can be called */ this._started = false;
        /** State used by the `runAsync` function */ this._state = {
            paused: false,
            pauseQueue: /* @__PURE__ */ new Set(),
            resumeQueue: /* @__PURE__ */ new Set(),
            timeouts: /* @__PURE__ */ new Set()
        };
        /** The event queues that are flushed once per frame maximum */ this._events = {
            onStart: /* @__PURE__ */ new Map(),
            onChange: /* @__PURE__ */ new Map(),
            onRest: /* @__PURE__ */ new Map()
        };
        this._onFrame = this._onFrame.bind(this);
        if (flush3) this._flush = flush3;
        if (props) this.start({
            default: true,
            ...props
        });
    }
    /**
   * Equals `true` when no spring values are in the frameloop, and
   * no async animation is currently active.
   */ get idle() {
        return !this._state.asyncTo && Object.values(this.springs).every((spring)=>{
            return spring.idle && !spring.isDelayed && !spring.isPaused;
        });
    }
    get item() {
        return this._item;
    }
    set item(item) {
        this._item = item;
    }
    /** Get the current values of our springs */ get() {
        const values = {};
        this.each((spring, key)=>values[key] = spring.get());
        return values;
    }
    /** Set the current values without animating. */ set(values) {
        for(const key in values){
            const value = values[key];
            if (!(0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).und(value)) this.springs[key].set(value);
        }
    }
    /** Push an update onto the queue of each value. */ update(props) {
        if (props) this.queue.push($9abb3f64d0b26b19$var$createUpdate(props));
        return this;
    }
    /**
   * Start the queued animations for every spring, and resolve the returned
   * promise once all queued animations have finished or been cancelled.
   *
   * When you pass a queue (instead of nothing), that queue is used instead of
   * the queued animations added with the `update` method, which are left alone.
   */ start(props) {
        let { queue: queue } = this;
        if (props) queue = (0, $0188c8620d3f23ab$export$45b10814cc054894)(props).map($9abb3f64d0b26b19$var$createUpdate);
        else this.queue = [];
        if (this._flush) return this._flush(this, queue);
        $9abb3f64d0b26b19$var$prepareKeys(this, queue);
        return $9abb3f64d0b26b19$var$flushUpdateQueue(this, queue);
    }
    /** @internal */ stop(arg, keys) {
        if (arg !== !!arg) keys = arg;
        if (keys) {
            const springs = this.springs;
            (0, $0188c8620d3f23ab$export$79b2f7037acddd43)((0, $0188c8620d3f23ab$export$45b10814cc054894)(keys), (key)=>springs[key].stop(!!arg));
        } else {
            $9abb3f64d0b26b19$var$stopAsync(this._state, this._lastAsyncId);
            this.each((spring)=>spring.stop(!!arg));
        }
        return this;
    }
    /** Freeze the active animation in time */ pause(keys) {
        if ((0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).und(keys)) this.start({
            pause: true
        });
        else {
            const springs = this.springs;
            (0, $0188c8620d3f23ab$export$79b2f7037acddd43)((0, $0188c8620d3f23ab$export$45b10814cc054894)(keys), (key)=>springs[key].pause());
        }
        return this;
    }
    /** Resume the animation if paused. */ resume(keys) {
        if ((0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).und(keys)) this.start({
            pause: false
        });
        else {
            const springs = this.springs;
            (0, $0188c8620d3f23ab$export$79b2f7037acddd43)((0, $0188c8620d3f23ab$export$45b10814cc054894)(keys), (key)=>springs[key].resume());
        }
        return this;
    }
    /** Call a function once per spring value */ each(iterator) {
        (0, $0188c8620d3f23ab$export$f4c6fe153f5a944e)(this.springs, iterator);
    }
    /** @internal Called at the end of every animation frame */ _onFrame() {
        const { onStart: onStart, onChange: onChange, onRest: onRest } = this._events;
        const active = this._active.size > 0;
        const changed = this._changed.size > 0;
        if (active && !this._started || changed && !this._started) {
            this._started = true;
            (0, $0188c8620d3f23ab$export$4909b86c8034bf73)(onStart, ([onStart2, result])=>{
                result.value = this.get();
                onStart2(result, this, this._item);
            });
        }
        const idle = !active && this._started;
        const values = changed || idle && onRest.size ? this.get() : null;
        if (changed && onChange.size) (0, $0188c8620d3f23ab$export$4909b86c8034bf73)(onChange, ([onChange2, result])=>{
            result.value = values;
            onChange2(result, this, this._item);
        });
        if (idle) {
            this._started = false;
            (0, $0188c8620d3f23ab$export$4909b86c8034bf73)(onRest, ([onRest2, result])=>{
                result.value = values;
                onRest2(result, this, this._item);
            });
        }
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") {
            this._changed.add(event.parent);
            if (!event.idle) this._active.add(event.parent);
        } else if (event.type == "idle") this._active.delete(event.parent);
        else return;
        (0, $14f355fb1db5a5c1$export$27f233d61a9e2fa4).onFrame(this._onFrame);
    }
};
function $9abb3f64d0b26b19$var$flushUpdateQueue(ctrl, queue) {
    return Promise.all(queue.map((props)=>$9abb3f64d0b26b19$var$flushUpdate(ctrl, props))).then((results)=>$9abb3f64d0b26b19$var$getCombinedResult(ctrl, results));
}
async function $9abb3f64d0b26b19$var$flushUpdate(ctrl, props, isLoop) {
    const { keys: keys, to: to2, from: from, loop: loop, onRest: onRest, onResolve: onResolve } = props;
    const defaults2 = (0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).obj(props.default) && props.default;
    if (loop) props.loop = false;
    if (to2 === false) props.to = null;
    if (from === false) props.from = null;
    const asyncTo = (0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).arr(to2) || (0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).fun(to2) ? to2 : void 0;
    if (asyncTo) {
        props.to = void 0;
        props.onRest = void 0;
        if (defaults2) defaults2.onRest = void 0;
    } else (0, $0188c8620d3f23ab$export$79b2f7037acddd43)($9abb3f64d0b26b19$var$BATCHED_EVENTS, (key)=>{
        const handler = props[key];
        if ((0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).fun(handler)) {
            const queue = ctrl["_events"][key];
            props[key] = ({ finished: finished, cancelled: cancelled })=>{
                const result2 = queue.get(handler);
                if (result2) {
                    if (!finished) result2.finished = false;
                    if (cancelled) result2.cancelled = true;
                } else queue.set(handler, {
                    value: null,
                    finished: finished || false,
                    cancelled: cancelled || false
                });
            };
            if (defaults2) defaults2[key] = props[key];
        }
    });
    const state = ctrl["_state"];
    if (props.pause === !state.paused) {
        state.paused = props.pause;
        (0, $0188c8620d3f23ab$export$7ba486852759e806)(props.pause ? state.pauseQueue : state.resumeQueue);
    } else if (state.paused) props.pause = true;
    const promises = (keys || Object.keys(ctrl.springs)).map((key)=>ctrl.springs[key].start(props));
    const cancel = props.cancel === true || $9abb3f64d0b26b19$var$getDefaultProp(props, "cancel") === true;
    if (asyncTo || cancel && state.asyncId) promises.push($9abb3f64d0b26b19$var$scheduleProps(++ctrl["_lastAsyncId"], {
        props: props,
        state: state,
        actions: {
            pause: (0, $0188c8620d3f23ab$export$8793edee2d425525),
            resume: (0, $0188c8620d3f23ab$export$8793edee2d425525),
            start (props2, resolve) {
                if (cancel) {
                    $9abb3f64d0b26b19$var$stopAsync(state, ctrl["_lastAsyncId"]);
                    resolve($9abb3f64d0b26b19$var$getCancelledResult(ctrl));
                } else {
                    props2.onRest = onRest;
                    resolve($9abb3f64d0b26b19$var$runAsync(asyncTo, props2, state, ctrl));
                }
            }
        }
    }));
    if (state.paused) await new Promise((resume)=>{
        state.resumeQueue.add(resume);
    });
    const result = $9abb3f64d0b26b19$var$getCombinedResult(ctrl, await Promise.all(promises));
    if (loop && result.finished && !(isLoop && result.noop)) {
        const nextProps = $9abb3f64d0b26b19$var$createLoopUpdate(props, loop, to2);
        if (nextProps) {
            $9abb3f64d0b26b19$var$prepareKeys(ctrl, [
                nextProps
            ]);
            return $9abb3f64d0b26b19$var$flushUpdate(ctrl, nextProps, true);
        }
    }
    if (onResolve) (0, $14f355fb1db5a5c1$export$27f233d61a9e2fa4).batchedUpdates(()=>onResolve(result, ctrl, ctrl.item));
    return result;
}
function $9abb3f64d0b26b19$var$getSprings(ctrl, props) {
    const springs = {
        ...ctrl.springs
    };
    if (props) (0, $0188c8620d3f23ab$export$79b2f7037acddd43)((0, $0188c8620d3f23ab$export$45b10814cc054894)(props), (props2)=>{
        if ((0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).und(props2.keys)) props2 = $9abb3f64d0b26b19$var$createUpdate(props2);
        if (!(0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).obj(props2.to)) props2 = {
            ...props2,
            to: void 0
        };
        $9abb3f64d0b26b19$var$prepareSprings(springs, props2, (key)=>{
            return $9abb3f64d0b26b19$var$createSpring(key);
        });
    });
    $9abb3f64d0b26b19$var$setSprings(ctrl, springs);
    return springs;
}
function $9abb3f64d0b26b19$var$setSprings(ctrl, springs) {
    (0, $0188c8620d3f23ab$export$f4c6fe153f5a944e)(springs, (spring, key)=>{
        if (!ctrl.springs[key]) {
            ctrl.springs[key] = spring;
            (0, $0188c8620d3f23ab$export$72d604e3f8d000a5)(spring, ctrl);
        }
    });
}
function $9abb3f64d0b26b19$var$createSpring(key, observer) {
    const spring = new $9abb3f64d0b26b19$export$5854d13427d5a954();
    spring.key = key;
    if (observer) (0, $0188c8620d3f23ab$export$72d604e3f8d000a5)(spring, observer);
    return spring;
}
function $9abb3f64d0b26b19$var$prepareSprings(springs, props, create) {
    if (props.keys) (0, $0188c8620d3f23ab$export$79b2f7037acddd43)(props.keys, (key)=>{
        const spring = springs[key] || (springs[key] = create(key));
        spring["_prepareNode"](props);
    });
}
function $9abb3f64d0b26b19$var$prepareKeys(ctrl, queue) {
    (0, $0188c8620d3f23ab$export$79b2f7037acddd43)(queue, (props)=>{
        $9abb3f64d0b26b19$var$prepareSprings(ctrl.springs, props, (key)=>{
            return $9abb3f64d0b26b19$var$createSpring(key, ctrl);
        });
    });
}
var $9abb3f64d0b26b19$export$f12a216ec50d2cf1 = ({ children: children, ...props })=>{
    const inherited = (0, $8NFma.useContext)($9abb3f64d0b26b19$var$ctx);
    const pause = props.pause || !!inherited.pause, immediate = props.immediate || !!inherited.immediate;
    props = (0, $0188c8620d3f23ab$export$b6feb8998cd9b342)(()=>({
            pause: pause,
            immediate: immediate
        }), [
        pause,
        immediate
    ]);
    const { Provider: Provider } = $9abb3f64d0b26b19$var$ctx;
    return /* @__PURE__ */ $8NFma.createElement(Provider, {
        value: props
    }, children);
};
var $9abb3f64d0b26b19$var$ctx = $9abb3f64d0b26b19$var$makeContext($9abb3f64d0b26b19$export$f12a216ec50d2cf1, {});
$9abb3f64d0b26b19$export$f12a216ec50d2cf1.Provider = $9abb3f64d0b26b19$var$ctx.Provider;
$9abb3f64d0b26b19$export$f12a216ec50d2cf1.Consumer = $9abb3f64d0b26b19$var$ctx.Consumer;
function $9abb3f64d0b26b19$var$makeContext(target, init) {
    Object.assign(target, $8NFma.createContext(init));
    target.Provider._context = target;
    target.Consumer._context = target;
    return target;
}
var $9abb3f64d0b26b19$export$2471ae76e2946684 = ()=>{
    const current = [];
    const SpringRef2 = function(props) {
        (0, $0188c8620d3f23ab$export$d99d974913ad3b12)();
        const results = [];
        (0, $0188c8620d3f23ab$export$79b2f7037acddd43)(current, (ctrl, i)=>{
            if ((0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).und(props)) results.push(ctrl.start());
            else {
                const update2 = _getProps(props, ctrl, i);
                if (update2) results.push(ctrl.start(update2));
            }
        });
        return results;
    };
    SpringRef2.current = current;
    SpringRef2.add = function(ctrl) {
        if (!current.includes(ctrl)) current.push(ctrl);
    };
    SpringRef2.delete = function(ctrl) {
        const i = current.indexOf(ctrl);
        if (~i) current.splice(i, 1);
    };
    SpringRef2.pause = function() {
        (0, $0188c8620d3f23ab$export$79b2f7037acddd43)(current, (ctrl)=>ctrl.pause(...arguments));
        return this;
    };
    SpringRef2.resume = function() {
        (0, $0188c8620d3f23ab$export$79b2f7037acddd43)(current, (ctrl)=>ctrl.resume(...arguments));
        return this;
    };
    SpringRef2.set = function(values) {
        (0, $0188c8620d3f23ab$export$79b2f7037acddd43)(current, (ctrl, i)=>{
            const update2 = (0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).fun(values) ? values(i, ctrl) : values;
            if (update2) ctrl.set(update2);
        });
    };
    SpringRef2.start = function(props) {
        const results = [];
        (0, $0188c8620d3f23ab$export$79b2f7037acddd43)(current, (ctrl, i)=>{
            if ((0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).und(props)) results.push(ctrl.start());
            else {
                const update2 = this._getProps(props, ctrl, i);
                if (update2) results.push(ctrl.start(update2));
            }
        });
        return results;
    };
    SpringRef2.stop = function() {
        (0, $0188c8620d3f23ab$export$79b2f7037acddd43)(current, (ctrl)=>ctrl.stop(...arguments));
        return this;
    };
    SpringRef2.update = function(props) {
        (0, $0188c8620d3f23ab$export$79b2f7037acddd43)(current, (ctrl, i)=>ctrl.update(this._getProps(props, ctrl, i)));
        return this;
    };
    const _getProps = function(arg, ctrl, index) {
        return (0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).fun(arg) ? arg(index, ctrl) : arg;
    };
    SpringRef2._getProps = _getProps;
    return SpringRef2;
};
// src/hooks/useSprings.ts
function $9abb3f64d0b26b19$export$15786d483ab9f469(length, props, deps) {
    const propsFn = (0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).fun(props) && props;
    if (propsFn && !deps) deps = [];
    const ref = (0, $8NFma.useMemo)(()=>propsFn || arguments.length == 3 ? $9abb3f64d0b26b19$export$2471ae76e2946684() : void 0, []);
    const layoutId = (0, $8NFma.useRef)(0);
    const forceUpdate = (0, $0188c8620d3f23ab$export$91db9bc4f8ac944a)();
    const state = (0, $8NFma.useMemo)(()=>({
            ctrls: [],
            queue: [],
            flush (ctrl, updates2) {
                const springs2 = $9abb3f64d0b26b19$var$getSprings(ctrl, updates2);
                const canFlushSync = layoutId.current > 0 && !state.queue.length && !Object.keys(springs2).some((key)=>!ctrl.springs[key]);
                return canFlushSync ? $9abb3f64d0b26b19$var$flushUpdateQueue(ctrl, updates2) : new Promise((resolve)=>{
                    $9abb3f64d0b26b19$var$setSprings(ctrl, springs2);
                    state.queue.push(()=>{
                        resolve($9abb3f64d0b26b19$var$flushUpdateQueue(ctrl, updates2));
                    });
                    forceUpdate();
                });
            }
        }), []);
    const ctrls = (0, $8NFma.useRef)([
        ...state.ctrls
    ]);
    const updates = [];
    const prevLength = (0, $0188c8620d3f23ab$export$ef7ad0c4e19d7fbf)(length) || 0;
    (0, $8NFma.useMemo)(()=>{
        (0, $0188c8620d3f23ab$export$79b2f7037acddd43)(ctrls.current.slice(length, prevLength), (ctrl)=>{
            $9abb3f64d0b26b19$var$detachRefs(ctrl, ref);
            ctrl.stop(true);
        });
        ctrls.current.length = length;
        declareUpdates(prevLength, length);
    }, [
        length
    ]);
    (0, $8NFma.useMemo)(()=>{
        declareUpdates(0, Math.min(prevLength, length));
    }, deps);
    function declareUpdates(startIndex, endIndex) {
        for(let i = startIndex; i < endIndex; i++){
            const ctrl = ctrls.current[i] || (ctrls.current[i] = new $9abb3f64d0b26b19$export$bd0bf19f25da8474(null, state.flush));
            const update2 = propsFn ? propsFn(i, ctrl) : props[i];
            if (update2) updates[i] = $9abb3f64d0b26b19$var$declareUpdate(update2);
        }
    }
    const springs = ctrls.current.map((ctrl, i)=>$9abb3f64d0b26b19$var$getSprings(ctrl, updates[i]));
    const context = (0, $8NFma.useContext)($9abb3f64d0b26b19$export$f12a216ec50d2cf1);
    const prevContext = (0, $0188c8620d3f23ab$export$ef7ad0c4e19d7fbf)(context);
    const hasContext = context !== prevContext && $9abb3f64d0b26b19$var$hasProps(context);
    (0, $0188c8620d3f23ab$export$700979bc83e7db82)(()=>{
        layoutId.current++;
        state.ctrls = ctrls.current;
        const { queue: queue } = state;
        if (queue.length) {
            state.queue = [];
            (0, $0188c8620d3f23ab$export$79b2f7037acddd43)(queue, (cb)=>cb());
        }
        (0, $0188c8620d3f23ab$export$79b2f7037acddd43)(ctrls.current, (ctrl, i)=>{
            ref?.add(ctrl);
            if (hasContext) ctrl.start({
                default: context
            });
            const update2 = updates[i];
            if (update2) {
                $9abb3f64d0b26b19$var$replaceRef(ctrl, update2.ref);
                if (ctrl.ref) ctrl.queue.push(update2);
                else ctrl.start(update2);
            }
        });
    });
    (0, $0188c8620d3f23ab$export$392544347a18b6ea)(()=>()=>{
            (0, $0188c8620d3f23ab$export$79b2f7037acddd43)(state.ctrls, (ctrl)=>ctrl.stop(true));
        });
    const values = springs.map((x)=>({
            ...x
        }));
    return ref ? [
        values,
        ref
    ] : values;
}
// src/hooks/useSpring.ts
function $9abb3f64d0b26b19$export$c4af9125706c4d30(props, deps) {
    const isFn = (0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).fun(props);
    const [[values], ref] = $9abb3f64d0b26b19$export$15786d483ab9f469(1, isFn ? props : [
        props
    ], isFn ? deps || [] : deps);
    return isFn || arguments.length == 2 ? [
        values,
        ref
    ] : values;
}
var $9abb3f64d0b26b19$var$initSpringRef = ()=>$9abb3f64d0b26b19$export$2471ae76e2946684();
var $9abb3f64d0b26b19$export$564bff9c23cad2ca = ()=>(0, $8NFma.useState)($9abb3f64d0b26b19$var$initSpringRef)[0];
var $9abb3f64d0b26b19$export$ab73804b080feffc = (initial, props)=>{
    const springValue = (0, $0188c8620d3f23ab$export$fe4300aa8eebea86)(()=>new $9abb3f64d0b26b19$export$5854d13427d5a954(initial, props));
    (0, $0188c8620d3f23ab$export$392544347a18b6ea)(()=>()=>{
            springValue.stop();
        });
    return springValue;
};
function $9abb3f64d0b26b19$export$250279104b4672ed(length, propsArg, deps) {
    const propsFn = (0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).fun(propsArg) && propsArg;
    if (propsFn && !deps) deps = [];
    let reverse = true;
    let passedRef = void 0;
    const result = $9abb3f64d0b26b19$export$15786d483ab9f469(length, (i, ctrl)=>{
        const props = propsFn ? propsFn(i, ctrl) : propsArg;
        passedRef = props.ref;
        reverse = reverse && props.reverse;
        return props;
    }, // Ensure the props function is called when no deps exist.
    // This works around the 3 argument rule.
    deps || [
        {}
    ]);
    (0, $0188c8620d3f23ab$export$700979bc83e7db82)(()=>{
        (0, $0188c8620d3f23ab$export$79b2f7037acddd43)(result[1].current, (ctrl, i)=>{
            const parent = result[1].current[i + (reverse ? 1 : -1)];
            $9abb3f64d0b26b19$var$replaceRef(ctrl, passedRef);
            if (ctrl.ref) {
                if (parent) ctrl.update({
                    to: parent.springs
                });
                return;
            }
            if (parent) ctrl.start({
                to: parent.springs
            });
            else ctrl.start();
        });
    }, deps);
    if (propsFn || arguments.length == 3) {
        const ref = passedRef ?? result[1];
        ref["_getProps"] = (propsArg2, ctrl, i)=>{
            const props = (0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).fun(propsArg2) ? propsArg2(i, ctrl) : propsArg2;
            if (props) {
                const parent = ref.current[i + (props.reverse ? 1 : -1)];
                if (parent) props.to = parent.springs;
                return props;
            }
        };
        return result;
    }
    return result[0];
}
function $9abb3f64d0b26b19$export$7b286972b8d8ccbf(data, props, deps) {
    const propsFn = (0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).fun(props) && props;
    const { reset: reset, sort: sort, trail: trail = 0, expires: expires = true, exitBeforeEnter: exitBeforeEnter = false, onDestroyed: onDestroyed, ref: propsRef, config: propsConfig } = propsFn ? propsFn() : props;
    const ref = (0, $8NFma.useMemo)(()=>propsFn || arguments.length == 3 ? $9abb3f64d0b26b19$export$2471ae76e2946684() : void 0, []);
    const items = (0, $0188c8620d3f23ab$export$45b10814cc054894)(data);
    const transitions = [];
    const usedTransitions = (0, $8NFma.useRef)(null);
    const prevTransitions = reset ? null : usedTransitions.current;
    (0, $0188c8620d3f23ab$export$700979bc83e7db82)(()=>{
        usedTransitions.current = transitions;
    });
    (0, $0188c8620d3f23ab$export$392544347a18b6ea)(()=>{
        (0, $0188c8620d3f23ab$export$79b2f7037acddd43)(transitions, (t)=>{
            ref?.add(t.ctrl);
            t.ctrl.ref = ref;
        });
        return ()=>{
            (0, $0188c8620d3f23ab$export$79b2f7037acddd43)(usedTransitions.current, (t)=>{
                if (t.expired) clearTimeout(t.expirationId);
                $9abb3f64d0b26b19$var$detachRefs(t.ctrl, ref);
                t.ctrl.stop(true);
            });
        };
    });
    const keys = $9abb3f64d0b26b19$var$getKeys(items, propsFn ? propsFn() : props, prevTransitions);
    const expired = reset && usedTransitions.current || [];
    (0, $0188c8620d3f23ab$export$700979bc83e7db82)(()=>(0, $0188c8620d3f23ab$export$79b2f7037acddd43)(expired, ({ ctrl: ctrl, item: item, key: key })=>{
            $9abb3f64d0b26b19$var$detachRefs(ctrl, ref);
            $9abb3f64d0b26b19$var$callProp(onDestroyed, item, key);
        }));
    const reused = [];
    if (prevTransitions) (0, $0188c8620d3f23ab$export$79b2f7037acddd43)(prevTransitions, (t, i)=>{
        if (t.expired) {
            clearTimeout(t.expirationId);
            expired.push(t);
        } else {
            i = reused[i] = keys.indexOf(t.key);
            if (~i) transitions[i] = t;
        }
    });
    (0, $0188c8620d3f23ab$export$79b2f7037acddd43)(items, (item, i)=>{
        if (!transitions[i]) {
            transitions[i] = {
                key: keys[i],
                item: item,
                phase: "mount" /* MOUNT */ ,
                ctrl: new $9abb3f64d0b26b19$export$bd0bf19f25da8474()
            };
            transitions[i].ctrl.item = item;
        }
    });
    if (reused.length) {
        let i = -1;
        const { leave: leave } = propsFn ? propsFn() : props;
        (0, $0188c8620d3f23ab$export$79b2f7037acddd43)(reused, (keyIndex, prevIndex)=>{
            const t = prevTransitions[prevIndex];
            if (~keyIndex) {
                i = transitions.indexOf(t);
                transitions[i] = {
                    ...t,
                    item: items[keyIndex]
                };
            } else if (leave) transitions.splice(++i, 0, t);
        });
    }
    if ((0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).fun(sort)) transitions.sort((a, b)=>sort(a.item, b.item));
    let delay = -trail;
    const forceUpdate = (0, $0188c8620d3f23ab$export$91db9bc4f8ac944a)();
    const defaultProps = $9abb3f64d0b26b19$var$getDefaultProps(props);
    const changes = /* @__PURE__ */ new Map();
    const exitingTransitions = (0, $8NFma.useRef)(/* @__PURE__ */ new Map());
    const forceChange = (0, $8NFma.useRef)(false);
    (0, $0188c8620d3f23ab$export$79b2f7037acddd43)(transitions, (t, i)=>{
        const key = t.key;
        const prevPhase = t.phase;
        const p = propsFn ? propsFn() : props;
        let to2;
        let phase;
        const propsDelay = $9abb3f64d0b26b19$var$callProp(p.delay || 0, key);
        if (prevPhase == "mount" /* MOUNT */ ) {
            to2 = p.enter;
            phase = "enter" /* ENTER */ ;
        } else {
            const isLeave = keys.indexOf(key) < 0;
            if (prevPhase != "leave" /* LEAVE */ ) {
                if (isLeave) {
                    to2 = p.leave;
                    phase = "leave" /* LEAVE */ ;
                } else if (to2 = p.update) phase = "update" /* UPDATE */ ;
                else return;
            } else if (!isLeave) {
                to2 = p.enter;
                phase = "enter" /* ENTER */ ;
            } else return;
        }
        to2 = $9abb3f64d0b26b19$var$callProp(to2, t.item, i);
        to2 = (0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).obj(to2) ? $9abb3f64d0b26b19$export$b971039a739bf227(to2) : {
            to: to2
        };
        if (!to2.config) {
            const config2 = propsConfig || defaultProps.config;
            to2.config = $9abb3f64d0b26b19$var$callProp(config2, t.item, i, phase);
        }
        delay += trail;
        const payload = {
            ...defaultProps,
            // we need to add our props.delay value you here.
            delay: propsDelay + delay,
            ref: propsRef,
            immediate: p.immediate,
            // This prevents implied resets.
            reset: false,
            // Merge any phase-specific props.
            ...to2
        };
        if (phase == "enter" /* ENTER */  && (0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).und(payload.from)) {
            const p2 = propsFn ? propsFn() : props;
            const from = (0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).und(p2.initial) || prevTransitions ? p2.from : p2.initial;
            payload.from = $9abb3f64d0b26b19$var$callProp(from, t.item, i);
        }
        const { onResolve: onResolve } = payload;
        payload.onResolve = (result)=>{
            $9abb3f64d0b26b19$var$callProp(onResolve, result);
            const transitions2 = usedTransitions.current;
            const t2 = transitions2.find((t3)=>t3.key === key);
            if (!t2) return;
            if (result.cancelled && t2.phase != "update" /* UPDATE */ ) return;
            if (t2.ctrl.idle) {
                const idle = transitions2.every((t3)=>t3.ctrl.idle);
                if (t2.phase == "leave" /* LEAVE */ ) {
                    const expiry = $9abb3f64d0b26b19$var$callProp(expires, t2.item);
                    if (expiry !== false) {
                        const expiryMs = expiry === true ? 0 : expiry;
                        t2.expired = true;
                        if (!idle && expiryMs > 0) {
                            if (expiryMs <= 2147483647) t2.expirationId = setTimeout(forceUpdate, expiryMs);
                            return;
                        }
                    }
                }
                if (idle && transitions2.some((t3)=>t3.expired)) {
                    exitingTransitions.current.delete(t2);
                    if (exitBeforeEnter) forceChange.current = true;
                    forceUpdate();
                }
            }
        };
        const springs = $9abb3f64d0b26b19$var$getSprings(t.ctrl, payload);
        if (phase === "leave" /* LEAVE */  && exitBeforeEnter) exitingTransitions.current.set(t, {
            phase: phase,
            springs: springs,
            payload: payload
        });
        else changes.set(t, {
            phase: phase,
            springs: springs,
            payload: payload
        });
    });
    const context = (0, $8NFma.useContext)($9abb3f64d0b26b19$export$f12a216ec50d2cf1);
    const prevContext = (0, $0188c8620d3f23ab$export$ef7ad0c4e19d7fbf)(context);
    const hasContext = context !== prevContext && $9abb3f64d0b26b19$var$hasProps(context);
    (0, $0188c8620d3f23ab$export$700979bc83e7db82)(()=>{
        if (hasContext) (0, $0188c8620d3f23ab$export$79b2f7037acddd43)(transitions, (t)=>{
            t.ctrl.start({
                default: context
            });
        });
    }, [
        context
    ]);
    (0, $0188c8620d3f23ab$export$79b2f7037acddd43)(changes, (_, t)=>{
        if (exitingTransitions.current.size) {
            const ind = transitions.findIndex((state)=>state.key === t.key);
            transitions.splice(ind, 1);
        }
    });
    (0, $0188c8620d3f23ab$export$700979bc83e7db82)(()=>{
        (0, $0188c8620d3f23ab$export$79b2f7037acddd43)(exitingTransitions.current.size ? exitingTransitions.current : changes, ({ phase: phase, payload: payload }, t)=>{
            const { ctrl: ctrl } = t;
            t.phase = phase;
            ref?.add(ctrl);
            if (hasContext && phase == "enter" /* ENTER */ ) ctrl.start({
                default: context
            });
            if (payload) {
                $9abb3f64d0b26b19$var$replaceRef(ctrl, payload.ref);
                if ((ctrl.ref || ref) && !forceChange.current) ctrl.update(payload);
                else {
                    ctrl.start(payload);
                    if (forceChange.current) forceChange.current = false;
                }
            }
        });
    }, reset ? void 0 : deps);
    const renderTransitions = (render)=>/* @__PURE__ */ $8NFma.createElement($8NFma.Fragment, null, transitions.map((t, i)=>{
            const { springs: springs } = changes.get(t) || t.ctrl;
            const elem = render({
                ...springs
            }, t.item, t, i);
            return elem && elem.type ? /* @__PURE__ */ $8NFma.createElement(elem.type, {
                ...elem.props,
                key: (0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).str(t.key) || (0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).num(t.key) ? t.key : t.ctrl.id,
                ref: elem.ref
            }) : elem;
        }));
    return ref ? [
        renderTransitions,
        ref
    ] : renderTransitions;
}
var $9abb3f64d0b26b19$var$nextKey = 1;
function $9abb3f64d0b26b19$var$getKeys(items, { key: key, keys: keys = key }, prevTransitions) {
    if (keys === null) {
        const reused = /* @__PURE__ */ new Set();
        return items.map((item)=>{
            const t = prevTransitions && prevTransitions.find((t2)=>t2.item === item && t2.phase !== "leave" /* LEAVE */  && !reused.has(t2));
            if (t) {
                reused.add(t);
                return t.key;
            }
            return $9abb3f64d0b26b19$var$nextKey++;
        });
    }
    return (0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).und(keys) ? items : (0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).fun(keys) ? items.map(keys) : (0, $0188c8620d3f23ab$export$45b10814cc054894)(keys);
}
var $9abb3f64d0b26b19$export$d928051c8cd740b = ({ container: container, ...springOptions } = {})=>{
    const [scrollValues, api] = $9abb3f64d0b26b19$export$c4af9125706c4d30(()=>({
            scrollX: 0,
            scrollY: 0,
            scrollXProgress: 0,
            scrollYProgress: 0,
            ...springOptions
        }), []);
    (0, $0188c8620d3f23ab$export$700979bc83e7db82)(()=>{
        const cleanupScroll = (0, $0188c8620d3f23ab$export$d4d89fd61e5416ee)(({ x: x, y: y })=>{
            api.start({
                scrollX: x.current,
                scrollXProgress: x.progress,
                scrollY: y.current,
                scrollYProgress: y.progress
            });
        }, {
            container: container?.current || void 0
        });
        return ()=>{
            (0, $0188c8620d3f23ab$export$79b2f7037acddd43)(Object.values(scrollValues), (value)=>value.stop());
            cleanupScroll();
        };
    }, []);
    return scrollValues;
};
var $9abb3f64d0b26b19$export$e8b771555dc4a003 = ({ container: container, ...springOptions })=>{
    const [sizeValues, api] = $9abb3f64d0b26b19$export$c4af9125706c4d30(()=>({
            width: 0,
            height: 0,
            ...springOptions
        }), []);
    (0, $0188c8620d3f23ab$export$700979bc83e7db82)(()=>{
        const cleanupScroll = (0, $0188c8620d3f23ab$export$45b39e67d4ce4921)(({ width: width, height: height })=>{
            api.start({
                width: width,
                height: height,
                immediate: sizeValues.width.get() === 0 || sizeValues.height.get() === 0
            });
        }, {
            container: container?.current || void 0
        });
        return ()=>{
            (0, $0188c8620d3f23ab$export$79b2f7037acddd43)(Object.values(sizeValues), (value)=>value.stop());
            cleanupScroll();
        };
    }, []);
    return sizeValues;
};
var $9abb3f64d0b26b19$var$defaultThresholdOptions = {
    any: 0,
    all: 1
};
function $9abb3f64d0b26b19$export$2f62ee6831462844(props, args) {
    const [isInView, setIsInView] = (0, $8NFma.useState)(false);
    const ref = (0, $8NFma.useRef)();
    const propsFn = (0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).fun(props) && props;
    const springsProps = propsFn ? propsFn() : {};
    const { to: to2 = {}, from: from = {}, ...restSpringProps } = springsProps;
    const intersectionArguments = propsFn ? args : props;
    const [springs, api] = $9abb3f64d0b26b19$export$c4af9125706c4d30(()=>({
            from: from,
            ...restSpringProps
        }), []);
    (0, $0188c8620d3f23ab$export$700979bc83e7db82)(()=>{
        const element = ref.current;
        const { root: root, once: once, amount: amount = "any", ...restArgs } = intersectionArguments ?? {};
        if (!element || once && isInView || typeof IntersectionObserver === "undefined") return;
        const activeIntersections = /* @__PURE__ */ new WeakMap();
        const onEnter = ()=>{
            if (to2) api.start(to2);
            setIsInView(true);
            const cleanup = ()=>{
                if (from) api.start(from);
                setIsInView(false);
            };
            return once ? void 0 : cleanup;
        };
        const handleIntersection = (entries)=>{
            entries.forEach((entry)=>{
                const onLeave = activeIntersections.get(entry.target);
                if (entry.isIntersecting === Boolean(onLeave)) return;
                if (entry.isIntersecting) {
                    const newOnLeave = onEnter();
                    if ((0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).fun(newOnLeave)) activeIntersections.set(entry.target, newOnLeave);
                    else observer.unobserve(entry.target);
                } else if (onLeave) {
                    onLeave();
                    activeIntersections.delete(entry.target);
                }
            });
        };
        const observer = new IntersectionObserver(handleIntersection, {
            root: root && root.current || void 0,
            threshold: typeof amount === "number" || Array.isArray(amount) ? amount : $9abb3f64d0b26b19$var$defaultThresholdOptions[amount],
            ...restArgs
        });
        observer.observe(element);
        return ()=>observer.unobserve(element);
    }, [
        intersectionArguments
    ]);
    if (propsFn) return [
        ref,
        springs
    ];
    return [
        ref,
        isInView
    ];
}
// src/components/Spring.tsx
function $9abb3f64d0b26b19$export$a500e5b516cedfc({ children: children, ...props }) {
    return children($9abb3f64d0b26b19$export$c4af9125706c4d30(props));
}
function $9abb3f64d0b26b19$export$3b8b9d47fbf8fd2b({ items: items, children: children, ...props }) {
    const trails = $9abb3f64d0b26b19$export$250279104b4672ed(items.length, props);
    return items.map((item, index)=>{
        const result = children(item, index);
        return (0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).fun(result) ? result(trails[index]) : result;
    });
}
// src/components/Transition.tsx
function $9abb3f64d0b26b19$export$be58926105124dd4({ items: items, children: children, ...props }) {
    return $9abb3f64d0b26b19$export$7b286972b8d8ccbf(items, props)(children);
}
var $9abb3f64d0b26b19$export$b0cc4f9860136880 = class extends $9abb3f64d0b26b19$export$8229896f80e2495e {
    constructor(source, args){
        super();
        this.source = source;
        /** Equals false when in the frameloop */ this.idle = true;
        /** The inputs which are currently animating */ this._active = /* @__PURE__ */ new Set();
        this.calc = (0, $0188c8620d3f23ab$export$b12af43b97697ef5)(...args);
        const value = this._get();
        const nodeType = (0, $21c5332537d86d23$export$e6b77ddbe47b132e)(value);
        (0, $21c5332537d86d23$export$b553cb5b22b81b04)(this, nodeType.create(value));
    }
    advance(_dt) {
        const value = this._get();
        const oldValue = this.get();
        if (!(0, $0188c8620d3f23ab$export$248d38f6296296c5)(value, oldValue)) {
            (0, $21c5332537d86d23$export$6b63995194a3a9e4)(this).setValue(value);
            this._onChange(value, this.idle);
        }
        if (!this.idle && $9abb3f64d0b26b19$var$checkIdle(this._active)) $9abb3f64d0b26b19$var$becomeIdle(this);
    }
    _get() {
        const inputs = (0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).arr(this.source) ? this.source.map((0, $0188c8620d3f23ab$export$e37b7520edd66839)) : (0, $0188c8620d3f23ab$export$45b10814cc054894)((0, $0188c8620d3f23ab$export$e37b7520edd66839)(this.source));
        return this.calc(...inputs);
    }
    _start() {
        if (this.idle && !$9abb3f64d0b26b19$var$checkIdle(this._active)) {
            this.idle = false;
            (0, $0188c8620d3f23ab$export$79b2f7037acddd43)((0, $21c5332537d86d23$export$ccab2b64c5d440)(this), (node)=>{
                node.done = false;
            });
            if ((0, $0188c8620d3f23ab$export$cceeabf822b64fc0).skipAnimation) {
                (0, $14f355fb1db5a5c1$export$27f233d61a9e2fa4).batchedUpdates(()=>this.advance());
                $9abb3f64d0b26b19$var$becomeIdle(this);
            } else (0, $0188c8620d3f23ab$export$a57f5080a3bcc90a).start(this);
        }
    }
    // Observe our sources only when we're observed.
    _attach() {
        let priority = 1;
        (0, $0188c8620d3f23ab$export$79b2f7037acddd43)((0, $0188c8620d3f23ab$export$45b10814cc054894)(this.source), (source)=>{
            if ((0, $0188c8620d3f23ab$export$57ea7e3a7f6280c7)(source)) (0, $0188c8620d3f23ab$export$72d604e3f8d000a5)(source, this);
            if ($9abb3f64d0b26b19$var$isFrameValue(source)) {
                if (!source.idle) this._active.add(source);
                priority = Math.max(priority, source.priority + 1);
            }
        });
        this.priority = priority;
        this._start();
    }
    // Stop observing our sources once we have no observers.
    _detach() {
        (0, $0188c8620d3f23ab$export$79b2f7037acddd43)((0, $0188c8620d3f23ab$export$45b10814cc054894)(this.source), (source)=>{
            if ((0, $0188c8620d3f23ab$export$57ea7e3a7f6280c7)(source)) (0, $0188c8620d3f23ab$export$7a0eb830d336339b)(source, this);
        });
        this._active.clear();
        $9abb3f64d0b26b19$var$becomeIdle(this);
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") {
            if (event.idle) this.advance();
            else {
                this._active.add(event.parent);
                this._start();
            }
        } else if (event.type == "idle") this._active.delete(event.parent);
        else if (event.type == "priority") this.priority = (0, $0188c8620d3f23ab$export$45b10814cc054894)(this.source).reduce((highest, parent)=>Math.max(highest, ($9abb3f64d0b26b19$var$isFrameValue(parent) ? parent.priority : 0) + 1), 0);
    }
};
function $9abb3f64d0b26b19$var$isIdle(source) {
    return source.idle !== false;
}
function $9abb3f64d0b26b19$var$checkIdle(active) {
    return !active.size || Array.from(active).every($9abb3f64d0b26b19$var$isIdle);
}
function $9abb3f64d0b26b19$var$becomeIdle(self) {
    if (!self.idle) {
        self.idle = true;
        (0, $0188c8620d3f23ab$export$79b2f7037acddd43)((0, $21c5332537d86d23$export$ccab2b64c5d440)(self), (node)=>{
            node.done = true;
        });
        (0, $0188c8620d3f23ab$export$31752c40a5fab62a)(self, {
            type: "idle",
            parent: self
        });
    }
}
// src/interpolate.ts
var $9abb3f64d0b26b19$export$2c618a4308a30424 = (source, ...args)=>new $9abb3f64d0b26b19$export$b0cc4f9860136880(source, args);
var $9abb3f64d0b26b19$export$89e29e4ab65e70a9 = (source, ...args)=>((0, $0188c8620d3f23ab$export$2abfcde8ae218ba8)(), new $9abb3f64d0b26b19$export$b0cc4f9860136880(source, args));
(0, $0188c8620d3f23ab$export$cceeabf822b64fc0).assign({
    createStringInterpolator: $0188c8620d3f23ab$export$4759a013d387347a,
    to: (source, args)=>new $9abb3f64d0b26b19$export$b0cc4f9860136880(source, args)
});
var $9abb3f64d0b26b19$export$722fbec263ad908a = (0, $0188c8620d3f23ab$export$a57f5080a3bcc90a).advance;



var $2pmb0 = parcelRequire("2pmb0");


// src/applyAnimatedValues.ts
var $e2b5b10d47aeba87$var$isCustomPropRE = /^--/;
function $e2b5b10d47aeba87$var$dangerousStyleValue(name, value) {
    if (value == null || typeof value === "boolean" || value === "") return "";
    if (typeof value === "number" && value !== 0 && !$e2b5b10d47aeba87$var$isCustomPropRE.test(name) && !($e2b5b10d47aeba87$var$isUnitlessNumber.hasOwnProperty(name) && $e2b5b10d47aeba87$var$isUnitlessNumber[name])) return value + "px";
    return ("" + value).trim();
}
var $e2b5b10d47aeba87$var$attributeCache = {};
function $e2b5b10d47aeba87$var$applyAnimatedValues(instance, props) {
    if (!instance.nodeType || !instance.setAttribute) return false;
    const isFilterElement = instance.nodeName === "filter" || instance.parentNode && instance.parentNode.nodeName === "filter";
    const { style: style, children: children, scrollTop: scrollTop, scrollLeft: scrollLeft, viewBox: viewBox, ...attributes } = props;
    const values = Object.values(attributes);
    const names = Object.keys(attributes).map((name)=>isFilterElement || instance.hasAttribute(name) ? name : $e2b5b10d47aeba87$var$attributeCache[name] || ($e2b5b10d47aeba87$var$attributeCache[name] = name.replace(/([A-Z])/g, // Attributes are written in dash case
        (n)=>"-" + n.toLowerCase())));
    if (children !== void 0) instance.textContent = children;
    for(const name in style)if (style.hasOwnProperty(name)) {
        const value = $e2b5b10d47aeba87$var$dangerousStyleValue(name, style[name]);
        if ($e2b5b10d47aeba87$var$isCustomPropRE.test(name)) instance.style.setProperty(name, value);
        else instance.style[name] = value;
    }
    names.forEach((name, i)=>{
        instance.setAttribute(name, values[i]);
    });
    if (scrollTop !== void 0) instance.scrollTop = scrollTop;
    if (scrollLeft !== void 0) instance.scrollLeft = scrollLeft;
    if (viewBox !== void 0) instance.setAttribute("viewBox", viewBox);
}
var $e2b5b10d47aeba87$var$isUnitlessNumber = {
    animationIterationCount: true,
    borderImageOutset: true,
    borderImageSlice: true,
    borderImageWidth: true,
    boxFlex: true,
    boxFlexGroup: true,
    boxOrdinalGroup: true,
    columnCount: true,
    columns: true,
    flex: true,
    flexGrow: true,
    flexPositive: true,
    flexShrink: true,
    flexNegative: true,
    flexOrder: true,
    gridRow: true,
    gridRowEnd: true,
    gridRowSpan: true,
    gridRowStart: true,
    gridColumn: true,
    gridColumnEnd: true,
    gridColumnSpan: true,
    gridColumnStart: true,
    fontWeight: true,
    lineClamp: true,
    lineHeight: true,
    opacity: true,
    order: true,
    orphans: true,
    tabSize: true,
    widows: true,
    zIndex: true,
    zoom: true,
    // SVG-related properties
    fillOpacity: true,
    floodOpacity: true,
    stopOpacity: true,
    strokeDasharray: true,
    strokeDashoffset: true,
    strokeMiterlimit: true,
    strokeOpacity: true,
    strokeWidth: true
};
var $e2b5b10d47aeba87$var$prefixKey = (prefix, key)=>prefix + key.charAt(0).toUpperCase() + key.substring(1);
var $e2b5b10d47aeba87$var$prefixes = [
    "Webkit",
    "Ms",
    "Moz",
    "O"
];
$e2b5b10d47aeba87$var$isUnitlessNumber = Object.keys($e2b5b10d47aeba87$var$isUnitlessNumber).reduce((acc, prop)=>{
    $e2b5b10d47aeba87$var$prefixes.forEach((prefix)=>acc[$e2b5b10d47aeba87$var$prefixKey(prefix, prop)] = acc[prop]);
    return acc;
}, $e2b5b10d47aeba87$var$isUnitlessNumber);
var $e2b5b10d47aeba87$var$domTransforms = /^(matrix|translate|scale|rotate|skew)/;
var $e2b5b10d47aeba87$var$pxTransforms = /^(translate)/;
var $e2b5b10d47aeba87$var$degTransforms = /^(rotate|skew)/;
var $e2b5b10d47aeba87$var$addUnit = (value, unit)=>(0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).num(value) && value !== 0 ? value + unit : value;
var $e2b5b10d47aeba87$var$isValueIdentity = (value, id)=>(0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).arr(value) ? value.every((v)=>$e2b5b10d47aeba87$var$isValueIdentity(v, id)) : (0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).num(value) ? value === id : parseFloat(value) === id;
var $e2b5b10d47aeba87$var$AnimatedStyle = class extends (0, $21c5332537d86d23$export$f1b0b9e366a6e2d4) {
    constructor({ x: x, y: y, z: z, ...style }){
        const inputs = [];
        const transforms = [];
        if (x || y || z) {
            inputs.push([
                x || 0,
                y || 0,
                z || 0
            ]);
            transforms.push((xyz)=>[
                    `translate3d(${xyz.map((v)=>$e2b5b10d47aeba87$var$addUnit(v, "px")).join(",")})`,
                    // prettier-ignore
                    $e2b5b10d47aeba87$var$isValueIdentity(xyz, 0)
                ]);
        }
        (0, $0188c8620d3f23ab$export$f4c6fe153f5a944e)(style, (value, key)=>{
            if (key === "transform") {
                inputs.push([
                    value || ""
                ]);
                transforms.push((transform)=>[
                        transform,
                        transform === ""
                    ]);
            } else if ($e2b5b10d47aeba87$var$domTransforms.test(key)) {
                delete style[key];
                if ((0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).und(value)) return;
                const unit = $e2b5b10d47aeba87$var$pxTransforms.test(key) ? "px" : $e2b5b10d47aeba87$var$degTransforms.test(key) ? "deg" : "";
                inputs.push((0, $0188c8620d3f23ab$export$45b10814cc054894)(value));
                transforms.push(key === "rotate3d" ? ([x2, y2, z2, deg])=>[
                        `rotate3d(${x2},${y2},${z2},${$e2b5b10d47aeba87$var$addUnit(deg, unit)})`,
                        $e2b5b10d47aeba87$var$isValueIdentity(deg, 0)
                    ] : (input)=>[
                        `${key}(${input.map((v)=>$e2b5b10d47aeba87$var$addUnit(v, unit)).join(",")})`,
                        $e2b5b10d47aeba87$var$isValueIdentity(input, key.startsWith("scale") ? 1 : 0)
                    ]);
            }
        });
        if (inputs.length) style.transform = new $e2b5b10d47aeba87$var$FluidTransform(inputs, transforms);
        super(style);
    }
};
var $e2b5b10d47aeba87$var$FluidTransform = class extends (0, $0188c8620d3f23ab$export$aff8e1ac1a016a2) {
    constructor(inputs, transforms){
        super();
        this.inputs = inputs;
        this.transforms = transforms;
        this._value = null;
    }
    get() {
        return this._value || (this._value = this._get());
    }
    _get() {
        let transform = "";
        let identity = true;
        (0, $0188c8620d3f23ab$export$79b2f7037acddd43)(this.inputs, (input, i)=>{
            const arg1 = (0, $0188c8620d3f23ab$export$e37b7520edd66839)(input[0]);
            const [t, id] = this.transforms[i]((0, $0188c8620d3f23ab$export$226b3eccf92c9ed9).arr(arg1) ? arg1 : input.map((0, $0188c8620d3f23ab$export$e37b7520edd66839)));
            transform += " " + t;
            identity = identity && id;
        });
        return identity ? "none" : transform;
    }
    // Start observing our inputs once we have an observer.
    observerAdded(count) {
        if (count == 1) (0, $0188c8620d3f23ab$export$79b2f7037acddd43)(this.inputs, (input)=>(0, $0188c8620d3f23ab$export$79b2f7037acddd43)(input, (value)=>(0, $0188c8620d3f23ab$export$57ea7e3a7f6280c7)(value) && (0, $0188c8620d3f23ab$export$72d604e3f8d000a5)(value, this)));
    }
    // Stop observing our inputs once we have no observers.
    observerRemoved(count) {
        if (count == 0) (0, $0188c8620d3f23ab$export$79b2f7037acddd43)(this.inputs, (input)=>(0, $0188c8620d3f23ab$export$79b2f7037acddd43)(input, (value)=>(0, $0188c8620d3f23ab$export$57ea7e3a7f6280c7)(value) && (0, $0188c8620d3f23ab$export$7a0eb830d336339b)(value, this)));
    }
    eventObserved(event) {
        if (event.type == "change") this._value = null;
        (0, $0188c8620d3f23ab$export$31752c40a5fab62a)(this, event);
    }
};
// src/primitives.ts
var $e2b5b10d47aeba87$var$primitives = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    // SVG
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
(0, $0188c8620d3f23ab$export$cceeabf822b64fc0).assign({
    batchedUpdates: (0, $2pmb0.unstable_batchedUpdates),
    createStringInterpolator: $0188c8620d3f23ab$export$4759a013d387347a,
    colors: $0188c8620d3f23ab$export$8f45430ccf837300
});
var $e2b5b10d47aeba87$var$host = (0, $21c5332537d86d23$export$4ee5c78f6dcbcef)($e2b5b10d47aeba87$var$primitives, {
    applyAnimatedValues: $e2b5b10d47aeba87$var$applyAnimatedValues,
    createAnimatedStyle: (style)=>new $e2b5b10d47aeba87$var$AnimatedStyle(style),
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getComponentProps: ({ scrollTop: scrollTop, scrollLeft: scrollLeft, ...props })=>props
});
var $e2b5b10d47aeba87$export$407448d2b89b1813 = $e2b5b10d47aeba87$var$host.animated;


const $d3f0b15427f824f6$var$NewAchievementItem = ({ description: description, animationData: animationData, index: index })=>{
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useRef();
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useEffect(()=>{
        setTimeout(()=>{
            if (ref && ref.current) ref.current.play();
        }, index * 1000 + 500);
    }, [
        ref,
        index
    ]);
    const { c: c } = (0, $9abb3f64d0b26b19$export$c4af9125706c4d30)({
        config: {
            mass: 3,
            tension: 400,
            friction: 10,
            frequency: 3.5,
            damping: 1.5
        },
        from: {
            c: 0
        },
        c: 1,
        delay: index * 500
    });
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("li", {
        className: "my-pages-achievements__list__item",
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $e2b5b10d47aeba87$export$407448d2b89b1813).div, {
            className: "my-pages-achievements__list__item__text__container my-pages-achievements__list__item__text__container--new",
            style: {
                background: c.to({
                    range: [
                        0,
                        .75,
                        1
                    ],
                    output: [
                        'white',
                        '#D1E9F9',
                        'white'
                    ]
                }).to((c)=>c)
            },
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2c1cc6e8319f49c7$exports))), {
                    className: "my-pages-achievements__list__item__star my-pages-achievements__list__item__star--lottie",
                    lottieRef: ref,
                    autoplay: false,
                    loop: false,
                    animationData: animationData
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("p", {
                    className: "my-pages-achievements__list__item__text__container__description",
                    children: description
                })
            ]
        })
    });
};
var $d3f0b15427f824f6$export$2e2bcd8739ae039 = $d3f0b15427f824f6$var$NewAchievementItem;


var $237ee716930ba5e7$exports = {};
$237ee716930ba5e7$exports = JSON.parse("{\"v\":\"5.7.13\",\"fr\":30,\"ip\":0,\"op\":45,\"w\":78,\"h\":62,\"nm\":\"star_animation\",\"ddd\":0,\"assets\":[],\"layers\":[{\"ddd\":0,\"ind\":1,\"ty\":4,\"nm\":\"Fill\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[38.915,31.101,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[22.234,22.58,0],\"ix\":1,\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,-14.833]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":15,\"s\":[82.353,82.353,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,-15.833]},\"t\":19,\"s\":[95,95,100]},{\"t\":30,\"s\":[82.353,82.353,100]}],\"ix\":6,\"l\":2}},\"ao\":0,\"hasMask\":true,\"masksProperties\":[{\"inv\":false,\"mode\":\"a\",\"pt\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":4,\"s\":[{\"i\":[[9.125,12],[0,0],[0,0],[1.266,16.682],[9.5,-2.625]],\"o\":[[-8.375,13.828],[0,0],[0,0],[-1.375,-18.125],[-9.258,2.558]],\"v\":[[-6.306,22.479],[-8.181,47.104],[58.694,47.104],[58.819,42.354],[25.069,42.104]],\"c\":true}]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":9,\"s\":[{\"i\":[[14.854,-11.812],[0,0],[0,0],[8.32,5.047],[8.958,1.062]],\"o\":[[-8.375,13.828],[0,0],[0,0],[-6.583,-17.25],[-8.735,-1.038]],\"v\":[[-7.16,32.416],[-8.181,47.104],[58.694,47.104],[51.527,24.479],[24.673,33.979]],\"c\":true}]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":14,\"s\":[{\"i\":[[19.708,-4.625],[0,0],[0,0],[15.375,-6.589],[8.417,4.75]],\"o\":[[-8.375,13.828],[0,0],[0,0],[-16.917,7.25],[-8.213,-4.635]],\"v\":[[-10.015,17.604],[-8.181,47.104],[58.694,47.104],[47.485,18.604],[23.777,27.604]],\"c\":true}]},{\"t\":30,\"s\":[{\"i\":[[9.125,12],[0,0],[0,0],[1.875,16.625],[7.5,-6]],\"o\":[[-8.375,13.828],[0,0],[0,0],[-1.875,-16.625],[-7.5,6]],\"v\":[[-3.931,-3.771],[-8.181,47.104],[58.694,47.104],[51.069,5.979],[21.194,-1.396]],\"c\":true}]}],\"ix\":1},\"o\":{\"a\":0,\"k\":100,\"ix\":3},\"x\":{\"a\":0,\"k\":0,\"ix\":4},\"nm\":\"Mask 1\"}],\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[19.992,5],[16.371,16.672],[5,20.751],[14.842,27.91],[15.208,40.159],[24.913,32.91],[36.512,36.401],[32.665,24.765],[39.468,14.673],[27.385,14.731]],\"c\":true},\"ix\":2},\"nm\":\"Path 2\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[22.234,22.58],\"ix\":2},\"a\":{\"a\":0,\"k\":[22.234,22.58],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Yellow lone\",\"np\":1,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.35],\"y\":[0.253]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":16,\"s\":[0.996078431606,0.803921580315,0.196078434587,1]},{\"i\":{\"x\":[0.619],\"y\":[1]},\"o\":{\"x\":[0.864],\"y\":[-1.986]},\"t\":19,\"s\":[1,0.915556788445,0.648440599442,1]},{\"t\":25,\"s\":[0.996078431606,0.803921580315,0.196078434587,1]}],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false}],\"ip\":0,\"op\":45,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":2,\"ty\":4,\"nm\":\"Outline\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":0,\"s\":[100]},{\"t\":30,\"s\":[0]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[38.915,31.101,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[22.234,22.58,0],\"ix\":1,\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,-0.212]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":15,\"s\":[82.353,82.353,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,1.6]},\"t\":19,\"s\":[95,95,100]},{\"t\":30,\"s\":[82.353,82.353,100]}],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[10.431,2.186],[17.234,-7.906],[5.151,-7.848],[-2.242,-17.579],[-5.863,-5.908],[-17.234,-1.828],[-7.392,5.331],[-7.026,17.579],[2.679,10.331],[14.278,13.822]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"st\",\"c\":{\"a\":0,\"k\":[0.545098039216,0.56862745098,0.580392156863,1],\"ix\":3},\"o\":{\"a\":0,\"k\":100,\"ix\":4},\"w\":{\"a\":0,\"k\":2,\"ix\":5},\"lc\":1,\"lj\":1,\"ml\":10,\"bm\":0,\"nm\":\"Stroke 1\",\"mn\":\"ADBE Vector Graphic - Stroke\",\"hd\":false},{\"ty\":\"op\",\"nm\":\"Offset Paths 1\",\"a\":{\"a\":0,\"k\":-1,\"ix\":1},\"lj\":1,\"ml\":{\"a\":0,\"k\":4,\"ix\":3},\"ix\":3,\"mn\":\"ADBE Vector Filter - Offset\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[22.234,22.58],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Gray Line\",\"np\":3,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":45,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":3,\"ty\":4,\"nm\":\"LittleStar 5\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":22,\"s\":[100]},{\"t\":32,\"s\":[0]}],\"ix\":11},\"r\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":14,\"s\":[80]},{\"t\":54,\"s\":[235]}],\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.333,\"y\":0},\"t\":14,\"s\":[39.415,31.351,0],\"to\":[7.437,-0.709,0],\"ti\":[-3.593,-7.603,0]},{\"i\":{\"x\":0.298,\"y\":1},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":25,\"s\":[64.539,45.723,0],\"to\":[3.594,7.605,0],\"ti\":[0.312,-5.792,0]},{\"t\":54,\"s\":[66.54,66.476,0]}],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[22.234,22.58,0],\"ix\":1,\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":14,\"s\":[11,11,100]},{\"t\":22,\"s\":[19,19,100]}],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[19.992,5],[16.371,16.672],[5,20.751],[14.842,27.91],[15.208,40.159],[24.913,32.91],[36.512,36.401],[32.665,24.765],[39.468,14.673],[27.385,14.731]],\"c\":true},\"ix\":2},\"nm\":\"Path 2\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[22.234,22.58],\"ix\":2},\"a\":{\"a\":0,\"k\":[22.234,22.58],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Yellow lone\",\"np\":1,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.996078431606,0.803921580315,0.196078434587,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false}],\"ip\":14,\"op\":45,\"st\":-6,\"bm\":0},{\"ddd\":0,\"ind\":4,\"ty\":4,\"nm\":\"LittleStar 4\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":21,\"s\":[100]},{\"t\":34,\"s\":[0]}],\"ix\":11},\"r\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":13,\"s\":[-85]},{\"t\":53,\"s\":[-210]}],\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.333,\"y\":0},\"t\":13,\"s\":[39.415,31.351,0],\"to\":[-0.416,-13.021,0],\"ti\":[6.728,-0.356,0]},{\"i\":{\"x\":0.298,\"y\":1},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":27,\"s\":[24.668,6.973,0],\"to\":[-15.548,0.823,0],\"ti\":[0.167,-22.98,0]},{\"t\":53,\"s\":[5.415,48.226,0]}],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[22.234,22.58,0],\"ix\":1,\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":13,\"s\":[11,11,100]},{\"t\":25,\"s\":[26,26,100]}],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[19.992,5],[16.371,16.672],[5,20.751],[14.842,27.91],[15.208,40.159],[24.913,32.91],[36.512,36.401],[32.665,24.765],[39.468,14.673],[27.385,14.731]],\"c\":true},\"ix\":2},\"nm\":\"Path 2\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[22.234,22.58],\"ix\":2},\"a\":{\"a\":0,\"k\":[22.234,22.58],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Yellow lone\",\"np\":1,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.996078431606,0.803921580315,0.196078434587,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false}],\"ip\":13,\"op\":45,\"st\":-7,\"bm\":0},{\"ddd\":0,\"ind\":5,\"ty\":4,\"nm\":\"LittleStar 3\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":21,\"s\":[100]},{\"t\":31,\"s\":[0]}],\"ix\":11},\"r\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":38,\"s\":[106]},{\"t\":53,\"s\":[108]}],\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.333,\"y\":0},\"t\":13,\"s\":[39.415,31.351,0],\"to\":[-5.271,-0.5,0],\"ti\":[4.115,-7.501,0]},{\"i\":{\"x\":0.298,\"y\":1},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":24,\"s\":[12.664,38.228,0],\"to\":[-4.114,7.499,0],\"ti\":[-0.229,-5.75,0]},{\"t\":53,\"s\":[9.79,66.601,0]}],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[22.234,22.58,0],\"ix\":1,\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":13,\"s\":[11,11,100]},{\"t\":21,\"s\":[18,18,100]}],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[19.992,5],[16.371,16.672],[5,20.751],[14.842,27.91],[15.208,40.159],[24.913,32.91],[36.512,36.401],[32.665,24.765],[39.468,14.673],[27.385,14.731]],\"c\":true},\"ix\":2},\"nm\":\"Path 2\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[22.234,22.58],\"ix\":2},\"a\":{\"a\":0,\"k\":[22.234,22.58],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Yellow lone\",\"np\":1,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.996078431606,0.803921580315,0.196078434587,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false}],\"ip\":13,\"op\":45,\"st\":-7,\"bm\":0},{\"ddd\":0,\"ind\":6,\"ty\":4,\"nm\":\"LittleStar 2\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":20,\"s\":[100]},{\"t\":30,\"s\":[0]}],\"ix\":11},\"r\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":12,\"s\":[-20]},{\"t\":52,\"s\":[-116]}],\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.333,\"y\":0},\"t\":12,\"s\":[39.415,31.351,0],\"to\":[4.312,-5.563,0],\"ti\":[-6.405,-7.655,0]},{\"i\":{\"x\":0.298,\"y\":1},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":23,\"s\":[67.538,24.473,0],\"to\":[6.407,7.657,0],\"ti\":[0.062,-6.313,0]},{\"t\":52,\"s\":[73.54,68.476,0]}],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[22.234,22.58,0],\"ix\":1,\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":12,\"s\":[11,11,100]},{\"t\":20,\"s\":[22,22,100]}],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[19.992,5],[16.371,16.672],[5,20.751],[14.842,27.91],[15.208,40.159],[24.913,32.91],[36.512,36.401],[32.665,24.765],[39.468,14.673],[27.385,14.731]],\"c\":true},\"ix\":2},\"nm\":\"Path 2\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[22.234,22.58],\"ix\":2},\"a\":{\"a\":0,\"k\":[22.234,22.58],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Yellow lone\",\"np\":1,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.996078431606,0.803921580315,0.196078434587,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false}],\"ip\":12,\"op\":45,\"st\":-8,\"bm\":0},{\"ddd\":0,\"ind\":7,\"ty\":4,\"nm\":\"LittleStar\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":23,\"s\":[100]},{\"t\":33,\"s\":[0]}],\"ix\":11},\"r\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":15,\"s\":[0]},{\"t\":55,\"s\":[-224]}],\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.333,\"y\":0},\"t\":15,\"s\":[39.415,31.351,0],\"to\":[-4.479,2.083,0],\"ti\":[3.135,-9.895,0]},{\"i\":{\"x\":0.298,\"y\":1},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":26,\"s\":[18.666,50.973,0],\"to\":[-2.325,7.339,0],\"ti\":[-0.146,-5.459,0]},{\"t\":55,\"s\":[17.29,66.976,0]}],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[22.234,22.58,0],\"ix\":1,\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":15,\"s\":[11,11,100]},{\"t\":23,\"s\":[28,28,100]}],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[19.992,5],[16.371,16.672],[5,20.751],[14.842,27.91],[15.208,40.159],[24.913,32.91],[36.512,36.401],[32.665,24.765],[39.468,14.673],[27.385,14.731]],\"c\":true},\"ix\":2},\"nm\":\"Path 2\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[22.234,22.58],\"ix\":2},\"a\":{\"a\":0,\"k\":[22.234,22.58],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Yellow lone\",\"np\":1,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.996078431606,0.803921580315,0.196078434587,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false}],\"ip\":15,\"op\":45,\"st\":-5,\"bm\":0}],\"markers\":[]}");


const $aba6adf522f463d4$var$NewAchievements = (props)=>{
    const [stars, setStars] = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useState([]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useEffect(()=>{
        if (props.data) setStars(props.data.map((star, index)=>{
            return star.description.description;
        }));
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useEffect(()=>{
        setTimeout(()=>{
            props.isAchievementsViewed();
        }, 1000);
    }, []);
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Fragment, {
        children: stars.map((star, index)=>{
            return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $d3f0b15427f824f6$export$2e2bcd8739ae039), {
                index: index,
                description: star,
                animationData: (0, (/*@__PURE__*/$parcel$interopDefault($237ee716930ba5e7$exports)))
            }, index);
        })
    });
};
const $aba6adf522f463d4$var$mapStateToProps = (state)=>{
    return {};
};
const $aba6adf522f463d4$var$mapDispatchToProps = (dispatch)=>{
    return {
        isAchievementsViewed: ()=>dispatch((0, $defc9e244fcd6007$export$5cf7beec07b6fa2a)())
    };
};
var $aba6adf522f463d4$export$2e2bcd8739ae039 = (0, $5a4066412ccab0c1$export$64605811ab45167f)($aba6adf522f463d4$var$mapStateToProps, $aba6adf522f463d4$var$mapDispatchToProps)($aba6adf522f463d4$var$NewAchievements);




var $8NFma = parcelRequire("8NFma");

const $01a43fab045dbe56$var$Achievements = (props)=>{
    const [stars, setStars] = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useState([]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useEffect(()=>{
        if (props.data) setStars(props.data.map((star, index)=>{
            return star;
        }));
    }, [
        props.data
    ]);
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
        children: stars.length > 0 && stars.sort((a, b)=>b.isAchieved - a.isAchieved).map((star, index)=>{
            return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("li", {
                className: "my-pages-achievements__list__item",
                children: [
                    star.isAchieved === true ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("img", {
                        className: "my-pages-achievements__list__item__star",
                        src: "/images/star-checked.svg"
                    }) : /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("img", {
                        className: "my-pages-achievements__list__item__star",
                        src: "/images/star-unchecked.svg"
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                        className: "my-pages-achievements__list__item__text__container",
                        children: [
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("p", {
                                className: "my-pages-achievements__list__item__text__container__description",
                                children: star.description.description
                            }),
                            star.isAchieved === false && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("a", {
                                className: "my-pages-achievements__list__item__text__link arrow-link",
                                href: star.description.actionLinkUrl,
                                children: [
                                    star.description.actionLinkText,
                                    " ",
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                        className: "icon",
                                        dangerouslySetInnerHTML: {
                                            __html: (0, (/*@__PURE__*/$parcel$interopDefault($ac8bf4b7d201ab28$exports)))('long-arrow-right').outerHTML
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }, index);
        })
    });
};
var $01a43fab045dbe56$export$2e2bcd8739ae039 = $01a43fab045dbe56$var$Achievements;


const $f1b5b7a22df3a832$var$AchievementsPage = (props)=>{
    const [showList, setShowList] = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useState(false);
    const [collectedStars, setCollectedStars] = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useState([]);
    const [sync, setSyncCompleted] = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useEffect(()=>{
        props.loadAchievements();
    }, []);
    let data = [];
    if (props.achievements) data = props.achievements;
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useEffect(()=>{
        if (data.initialSyncCompleted === true) setSyncCompleted(!sync);
    }, [
        data.syncCompleted
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useEffect(()=>{
        props.loadNewAchievements();
    }, []);
    let newData = [];
    if (props.newAchievements) newData = props.newAchievements;
    let prevStars = [];
    let newStars = [];
    let allStars = [];
    if (data.achievements && data.achievements.length > 0) {
        allStars = data.achievements;
        if (newData.newAchievements.length > 0) {
            newStars = allStars.filter((i)=>newData.newAchievements.includes(i.achievementType));
            prevStars = allStars.filter((i)=>!newData.newAchievements.includes(i.achievementType));
        }
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useEffect(()=>{
        setTimeout(()=>{
            setShowList(!showList);
        }, 800);
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useEffect(()=>{
        if (allStars.length > 0) allStars.map((collectedStar, index)=>{
            if (collectedStar.isAchieved === true) setCollectedStars((collectedStars)=>[
                    ...collectedStars,
                    collectedStar.isAchieved
                ]);
        });
    }, [
        allStars
    ]);
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
        className: `my-pages-achievements ${showList ? "js-animate" : ""}`,
        children: [
            !sync && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $1c6fe1315a0b413a$export$2e2bcd8739ae039), {
                loaderText: "Just nu h\xe4mtar vi dina stj\xe4rnor. Kom tillbaka inom kort f\xf6r att se vilka stj\xe4rnor du har."
            }),
            sync && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("p", {
                        className: "my-pages-achievements__status",
                        children: [
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                className: "my-pages-achievements__status--bold",
                                children: "Status"
                            }),
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("span", {
                                className: "my-pages-achievements__status__text",
                                children: [
                                    "Du har samlat ",
                                    collectedStars.length,
                                    " av ",
                                    allStars.length,
                                    " stj\xe4rnor"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("ul", {
                        className: "my-pages-achievements__list",
                        children: [
                            newStars.length > 0 && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $aba6adf522f463d4$export$2e2bcd8739ae039), {
                                data: newStars
                            }),
                            newStars.length > 0 && prevStars.length > 0 && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $01a43fab045dbe56$export$2e2bcd8739ae039), {
                                data: prevStars
                            }),
                            newStars.length < 1 && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $01a43fab045dbe56$export$2e2bcd8739ae039), {
                                data: allStars
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $f1b5b7a22df3a832$var$mapStateToProps = (state)=>{
    return {
        achievements: state.achievementsData,
        newAchievements: state.newAchievementsData
    };
};
const $f1b5b7a22df3a832$var$mapDispatchToProps = (dispatch)=>{
    return {
        loadAchievements: (achievements)=>dispatch((0, $defc9e244fcd6007$export$250783bb0ed552ae)(achievements)),
        loadNewAchievements: (newAchievements)=>dispatch((0, $defc9e244fcd6007$export$97f59f2b60c32ef8)(newAchievements))
    };
};
var $f1b5b7a22df3a832$export$2e2bcd8739ae039 = (0, $5a4066412ccab0c1$export$64605811ab45167f)($f1b5b7a22df3a832$var$mapStateToProps, $f1b5b7a22df3a832$var$mapDispatchToProps)($f1b5b7a22df3a832$var$AchievementsPage);




var $8NFma = parcelRequire("8NFma");




const $8ce77540804c1437$var$actionTypes = {
    CUSTOMER_INFO_SET: 'CUSTOMER_INFO_SET',
    CUSTOMER_INFO_FETCHING_SET: 'CUSTOMER_INFO_FETCHING_SET',
    COINSURED_INFO_SET: 'COINSURED_INFO_SET',
    COINSURED_INFO_FETCHING_SET: 'COINSURED_INFO_FETCHING_SET',
    CUSTOMER_CHILDREN_FETCHING_SET: 'CUSTOMER_CHILDREN_FETCHING_SET',
    CUSTOMER_CHILDREN_SET: 'CUSTOMER_CHILDREN_SET',
    CUSTOMER_ANIMALS_FETCHING_SET: 'CUSTOMER_ANIMALS_FETCHING_SET',
    CUSTOMER_ANIMALS_SET: 'CUSTOMER_ANIMALS_SET'
};
var $8ce77540804c1437$export$2e2bcd8739ae039 = $8ce77540804c1437$var$actionTypes;





const $e7d11b27b0d4ec0b$var$initialState = {
    fetching: false,
    fetched: false,
    error: null,
    statusCode: null,
    birthDate: '',
    city: '',
    coAddress: null,
    coInsuredId: null,
    country: null,
    firstName: '',
    foAddress: null,
    lastName: '',
    personalIdentityNumber: '',
    streetAddress: '',
    zipCode: null
};
function $e7d11b27b0d4ec0b$export$2e2bcd8739ae039(state = $e7d11b27b0d4ec0b$var$initialState, action = {}) {
    let returnState = {
        ...state
    };
    switch(action.type){
        case (0, $8ce77540804c1437$export$2e2bcd8739ae039).COINSURED_INFO_FETCHING_SET:
            returnState = {
                ...state,
                fetching: !!action.payload
            };
            break;
        case (0, $8ce77540804c1437$export$2e2bcd8739ae039).COINSURED_INFO_SET:
            returnState = {
                ...state,
                ...action.payload
            };
            break;
    }
    return returnState;
}


function $1b014d605fa09c6d$export$3e49cf51e9d71a() {
    const lfDataService = new (0, $25937fdb26d57abd$export$2e2bcd8739ae039)();
    return (dispatch)=>{
        let customerInfo;
        let coinsuredInfo;
        dispatch($1b014d605fa09c6d$export$56d36a7e0dea0b8(true));
        dispatch($1b014d605fa09c6d$export$75a9efaf27b035a3(true));
        lfDataService.customerInfo().then((data)=>{
            customerInfo = data.customer;
            coinsuredInfo = data.currentCoinsured;
            dispatch($1b014d605fa09c6d$export$fe2cacc15ccb5d59(customerInfo));
            dispatch($1b014d605fa09c6d$export$ed6d3c220b4355e8(coinsuredInfo));
            dispatch($1b014d605fa09c6d$export$56d36a7e0dea0b8(false));
            dispatch($1b014d605fa09c6d$export$75a9efaf27b035a3(false));
        }).catch((e)=>{
            dispatch((0, $67f4b1d2fb7c2244$export$7a8bb273722d5103)(e));
            dispatch((0, $67f4b1d2fb7c2244$export$ea4b4733f4ca2df0)(true));
        });
    };
}
function $1b014d605fa09c6d$export$3333903bd8e1423e(data) {
    const lfDataService = new (0, $25937fdb26d57abd$export$2e2bcd8739ae039)();
    return (dispatch)=>{
        dispatch((0, $67f4b1d2fb7c2244$export$5630fcc02dc02d1b)(true));
        dispatch($1b014d605fa09c6d$export$56d36a7e0dea0b8(true));
        lfDataService.updateProfile(data).then((result)=>{
            dispatch((0, $67f4b1d2fb7c2244$export$5630fcc02dc02d1b)(false));
            dispatch((0, $67f4b1d2fb7c2244$export$7a8bb273722d5103)('kunde inte uppdatera dina kontaktuppgifter'));
            dispatch((0, $67f4b1d2fb7c2244$export$ea4b4733f4ca2df0)(true));
            dispatch($1b014d605fa09c6d$export$3e49cf51e9d71a());
        }).catch((e)=>{
            dispatch((0, $67f4b1d2fb7c2244$export$5630fcc02dc02d1b)(true));
            dispatch((0, $67f4b1d2fb7c2244$export$7a8bb273722d5103)(e));
            dispatch((0, $67f4b1d2fb7c2244$export$ea4b4733f4ca2df0)(true));
        });
    };
}
function $1b014d605fa09c6d$export$fe2cacc15ccb5d59(data) {
    return {
        type: (0, $8ce77540804c1437$export$2e2bcd8739ae039).CUSTOMER_INFO_SET,
        payload: data
    };
}
function $1b014d605fa09c6d$export$ed6d3c220b4355e8(data) {
    return {
        type: (0, $8ce77540804c1437$export$2e2bcd8739ae039).COINSURED_INFO_SET,
        payload: data
    };
}
function $1b014d605fa09c6d$export$56d36a7e0dea0b8(data) {
    return {
        type: (0, $8ce77540804c1437$export$2e2bcd8739ae039).CUSTOMER_INFO_FETCHING_SET,
        payload: !!data
    };
}
function $1b014d605fa09c6d$export$75a9efaf27b035a3(data) {
    return {
        type: (0, $8ce77540804c1437$export$2e2bcd8739ae039).COINSURED_INFO_FETCHING_SET,
        payload: !!data
    };
}





function $8bb4df1e5092f6ea$export$37eb3fe7e2d7d07b() {
    const lfDataService = new (0, $25937fdb26d57abd$export$2e2bcd8739ae039)();
    return (dispatch)=>{
        let children;
        dispatch($8bb4df1e5092f6ea$export$20cab1d5ba084553(true));
        lfDataService.customerChildren().then((data)=>{
            children = data.children;
            dispatch($8bb4df1e5092f6ea$export$69a0f252e37c3ae9(children));
            dispatch($8bb4df1e5092f6ea$export$20cab1d5ba084553(false));
        }).catch((e)=>{
            dispatch((0, $67f4b1d2fb7c2244$export$7a8bb273722d5103)(e));
            dispatch((0, $67f4b1d2fb7c2244$export$ea4b4733f4ca2df0)(true));
        });
    };
}
function $8bb4df1e5092f6ea$export$f9b5988fdf706b91(data) {
    const lfDataService = new (0, $25937fdb26d57abd$export$2e2bcd8739ae039)();
    return (dispatch)=>{
        dispatch((0, $67f4b1d2fb7c2244$export$5630fcc02dc02d1b)(true));
        dispatch($8bb4df1e5092f6ea$export$20cab1d5ba084553(true));
        lfDataService.updateCustomerChildren(data).then((result)=>{
            dispatch((0, $67f4b1d2fb7c2244$export$5630fcc02dc02d1b)(false));
            dispatch((0, $67f4b1d2fb7c2244$export$7a8bb273722d5103)('kunde inte uppdatera barn'));
            dispatch((0, $67f4b1d2fb7c2244$export$ea4b4733f4ca2df0)(true));
            dispatch($8bb4df1e5092f6ea$export$37eb3fe7e2d7d07b());
        }).catch((e)=>{
            dispatch((0, $67f4b1d2fb7c2244$export$5630fcc02dc02d1b)(true));
            dispatch((0, $67f4b1d2fb7c2244$export$7a8bb273722d5103)(e));
            dispatch((0, $67f4b1d2fb7c2244$export$ea4b4733f4ca2df0)(true));
        });
    };
}
function $8bb4df1e5092f6ea$export$20cab1d5ba084553(data) {
    return {
        type: (0, $8ce77540804c1437$export$2e2bcd8739ae039).CUSTOMER_CHILDREN_FETCHING_SET,
        payload: data
    };
}
function $8bb4df1e5092f6ea$export$69a0f252e37c3ae9(data) {
    return {
        type: (0, $8ce77540804c1437$export$2e2bcd8739ae039).CUSTOMER_CHILDREN_SET,
        payload: data
    };
}





function $af2f3ac2298380a3$export$b604c6d5738fafd4() {
    const lfDataService = new (0, $25937fdb26d57abd$export$2e2bcd8739ae039)();
    return (dispatch)=>{
        let animals;
        dispatch($af2f3ac2298380a3$export$688c452fadb3e7bb(true));
        lfDataService.customerAnimals().then((data)=>{
            animals = data.animals;
            dispatch($af2f3ac2298380a3$export$adb31dcdbdf5d34a(animals));
            dispatch($af2f3ac2298380a3$export$688c452fadb3e7bb(false));
        }).catch((e)=>{
            dispatch((0, $67f4b1d2fb7c2244$export$7a8bb273722d5103)(e));
            dispatch((0, $67f4b1d2fb7c2244$export$ea4b4733f4ca2df0)(true));
        });
    };
}
function $af2f3ac2298380a3$export$688c452fadb3e7bb(data) {
    return {
        type: (0, $8ce77540804c1437$export$2e2bcd8739ae039).CUSTOMER_ANIMALS_FETCHING_SET,
        payload: data
    };
}
function $af2f3ac2298380a3$export$adb31dcdbdf5d34a(data) {
    return {
        type: (0, $8ce77540804c1437$export$2e2bcd8739ae039).CUSTOMER_ANIMALS_SET,
        payload: data
    };
}




var $8NFma = parcelRequire("8NFma");

class $77e75f8e9d2fab4b$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    static propTypes = {
        title: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
        description: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
        htmlDescription: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).node),
            (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).node,
            (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).array
        ]),
        modifierClass: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).array
    };
    static defaultProps = {
        title: '',
        children: [],
        description: '',
        htmlDescription: '',
        modifierClass: []
    };
    render() {
        const description = this.props.htmlDescription !== '' ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
            dangerouslySetInnerHTML: {
                __html: this.props.htmlDescription
            }
        }) : /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("p", {
            children: this.props.description
        });
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
            className: "insurance insurance--member-info insurance--visible-overflow",
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                    className: "insurance__content",
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("h1", {
                            children: this.props.title
                        }),
                        description
                    ]
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                    className: "insurance__accordion",
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("ul", {
                        className: "insurance__accordion__list",
                        children: this.props.children
                    })
                })
            ]
        });
    }
}




var $8NFma = parcelRequire("8NFma");


class $7869c274f4138d81$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    static propTypes = {
        title: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).node),
            (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).node,
            (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).array
        ]),
        modifierClass: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).array
    };
    static defaultProps = {
        title: '',
        children: [],
        excerpt: '',
        modifierClass: []
    };
    render() {
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("li", {
            className: "insurance__accordion__item insurance__accordion__item--green",
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("button", {
                    className: "insurance__accordion__link",
                    "data-lf-accordion": true,
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("h3", {
                            children: this.props.title
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                            dangerouslySetInnerHTML: {
                                __html: (0, (/*@__PURE__*/$parcel$interopDefault($ac8bf4b7d201ab28$exports)))('chev-down').outerHTML
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                    className: "insurance__accordion__item__content__wrapper",
                    "data-lf-accordion-body": true,
                    style: {
                        maxHeight: '0px'
                    },
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                        className: "insurance__accordion__item__content",
                        children: this.props.children
                    })
                })
            ]
        });
    }
}




var $8NFma = parcelRequire("8NFma");




var $8NFma = parcelRequire("8NFma");


class $b46c391aa29114dc$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    static propTypes = {
        children: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).node),
            (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).node,
            (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).array
        ]),
        actionShow: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).bool,
        actionLabel: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
        actionOnClick: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func,
        actionIsFormButton: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).bool,
        secondaryActionShow: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).bool,
        secondaryActionLabel: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
        secondaryActionOnClick: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func,
        push: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).bool,
        border: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).bool,
        modifierClass: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).array
    };
    static defaultProps = {
        children: [],
        excerpt: '',
        modifierClass: [],
        actionShow: false,
        actionLabel: '',
        actionOnClick: ()=>{},
        push: false,
        border: true,
        actionIsFormButton: false,
        secondaryActionShow: false,
        secondaryActionLabel: '',
        secondaryActionOnClick: ()=>{}
    };
    onActionClick() {
        this.props.actionOnClick();
    }
    secondaryActionClick() {
        this.props.secondaryActionOnClick();
    }
    render() {
        const classNames = [
            'meta-list'
        ].concat(this.props.modifierClass);
        let actionButton;
        let secondaryActionButton;
        if (this.props.push) classNames.push('meta-list--push');
        if (!this.props.border) classNames.push('meta-list--no-border');
        if (this.props.actionShow) {
            actionButton = /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                className: "meta-list__actions__action my-pages-btn button button--green",
                onClick: (ev)=>{
                    ev.preventDefault();
                    this.onActionClick();
                },
                children: this.props.actionLabel
            });
            if (this.props.actionIsFormButton) actionButton = /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $80cca30c19bbba0b$export$2e2bcd8739ae039), {
                className: "meta-list__actions__action meta-list__actions__action--form my-pages-btn button button--green",
                children: this.props.actionLabel
            });
        }
        if (this.props.secondaryActionShow) secondaryActionButton = /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
            className: "meta-list__actions__action meta-list__actions__action--secondary my-pages-btn button button--green",
            onClick: (ev)=>{
                ev.preventDefault();
                this.secondaryActionClick();
            },
            children: this.props.secondaryActionLabel
        });
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
            className: classNames.join(' '),
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("dl", {
                    className: "meta-list__list",
                    children: this.props.children
                }),
                (this.props.actionShow || this.props.secondaryActionShow) && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                    className: "meta-list__actions",
                    children: [
                        actionButton,
                        secondaryActionButton
                    ]
                })
            ]
        });
    }
}




var $8NFma = parcelRequire("8NFma");



var $8NFma = parcelRequire("8NFma");



class $aa192976c67b1def$var$InfoBox extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    constructor(props){
        super(props);
        this.state = {
            helpTextVisibility: false
        };
    }
    closeHelpText = (e)=>{
        e.stopPropagation();
        e.preventDefault();
        document.body.removeEventListener('click', this.closeHelpText, false);
        this.setState({
            helpTextVisibility: false
        });
    };
    toggleHelpText = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        const helpTextVisibility = this.state.helpTextVisibility;
        if (!helpTextVisibility) document.body.addEventListener('click', this.closeHelpText);
        this.setState({
            helpTextVisibility: !helpTextVisibility
        });
    };
    render() {
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($aa192976c67b1def$var$InfoBoxWrapper, {
            helpTextVisibility: this.state.helpTextVisibility,
            marginTop: this.props.marginTop,
            contentFontSize: this.props.fontSize,
            top: this.props.top,
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                    type: "button",
                    className: "helpTextIcon",
                    onClick: (e)=>this.toggleHelpText(e),
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                        children: "Se ordf\xf6rklaring."
                    })
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("span", {
                    className: "helpText",
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                            className: "helpTextArrow",
                            children: "\xa0"
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                            className: "helpTextContent",
                            children: this.props.children
                        })
                    ]
                })
            ]
        });
    }
}
var $aa192976c67b1def$export$2e2bcd8739ae039 = $aa192976c67b1def$var$InfoBox;
// styled components
const $aa192976c67b1def$var$infoBoxPropsToExclude = [
    'marginTop',
    'top',
    'helpTextVisibility',
    'contentFontSize'
];
const $aa192976c67b1def$var$InfoBoxWrapper = (0, $65e706775ff71837$export$2e2bcd8739ae039).div.withConfig({
    shouldForwardProp: (prop)=>!$aa192976c67b1def$var$infoBoxPropsToExclude.includes(prop)
})`
    position: relative;
    display: inline-block;
    font-weight: normal;

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        display: inline;
    `)}

    .helpTextIcon {
        background: none;
        border: 0;
        box-sizing: content-box;
        cursor: pointer;
        color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.blueBackground};
        height: 1em;

        margin-top: ${(props)=>props.marginTop ? props.marginTop : '0'}px;
        ${(props)=>props.top ? 'top:' + props.top + 'px' : ''};


        transition: all 3s ease-in-out;

        &:after {
            font-size: initial;
            font-weight: normal;
            ${(0, $45d1242a07988139$export$74300498d1a9477c).informationIcon()}
            position: relative;
            top: 1.5px;
            left: 5px;
            ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
                top: 1px;
                left: -1px;
            `)}
            ${(0, $45d1242a07988139$export$8f880b6e390052fa).xxsmall(`
                font-size: 12px;
                top: -1px;
            `)}
        }

        &:hover {
            color: #23527c;
        }

        span {
            display: none;
        }
    }

    .helpText {
        display: ${(props)=>props.helpTextVisibility === true ? 'block' : 'none'};
        position: absolute;
        top: 15px;
        left: -207px;
        padding-top: 5px;
        z-index: 1;

        ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
            position: relative;
            top: 5px;
            left: 0px;
            height: 0px;
            padding: 0px;
            width: 0px;
        `)}

        .helpTextArrow {
            display: block;
            width: 0;
            height: 0;
            border-left: 15px solid transparent;
            border-right: 15px solid transparent;
            border-bottom: 11px solid ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.blueBackground};
            margin: 0px auto -1px auto;

            ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
                display: none;
            `)}
        }

        .helpTextContent {
            background-color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.blueBackground};
            color: #fff;
            display: block;
            text-align: left;
            border-radius: 10px;
            padding: 15px 15px;
            margin: 0px auto;
            width: 430px;
            line-height: 1.3;
            box-shadow: -1px 4px 10px -1px rgba(0,0,0,0.4);

            ${(props)=>props.contentFontSize ? 'font-size:' + props.contentFontSize + 'px' : ''};


            ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
                padding: 15px 20px;
                width: 80vw;
                position: absolute;
            `)}
        }
    }
`;


class $416bb2eafae90d64$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    static propTypes = {
        title: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
        helpText: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).array,
            (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).node
        ]),
        helpTextActionLabel: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
        helpTextActionUrl: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
        contents: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).array
        ]),
        modifierClass: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).array,
        compactMode: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).bool
    };
    static defaultProps = {
        title: '',
        helpText: '',
        contents: [],
        modifierClass: [],
        compactMode: false
    };
    render() {
        const helpText = this.props.helpText;
        const contentRows = this.props.contents.length ? this.props.contents : [
            this.props.contents
        ];
        const titleClasses = [
            'meta-list__list__title'
        ];
        const content = contentRows.map((content, index)=>{
            const contentClasses = [
                'meta-list__list__content'
            ];
            if (this.props.compactMode) contentClasses.push('meta-list__list__content--compact');
            return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("dd", {
                className: contentClasses.join(' '),
                children: content
            }, index + '_');
        });
        let helpTextElement;
        if (helpText) helpTextElement = /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $aa192976c67b1def$export$2e2bcd8739ae039), {
            fontSize: 16,
            children: helpText
        });
        if (this.props.compactMode) titleClasses.push('meta-list__list__title--compact');
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Fragment, {
            children: [
                this.props.title && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("dt", {
                    className: titleClasses.join(' '),
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("h5", {
                        className: "meta-list__list__title__heading",
                        children: [
                            this.props.title,
                            " ",
                            helpTextElement
                        ]
                    })
                }),
                content
            ]
        });
    }
}



parcelRequire("8NFma");




const $c27467240a58e77f$export$c86715117507e8e5 = ({ error: error, isChanged: isChanged, isUsed: isUsed, ...allProps })=>{
    const { displayname: displayname, fieldWidth: fieldWidth, textInputWrapperWidth: textInputWrapperWidth, marginBottom: marginBottom, inlineBlock: inlineBlock, ...props } = allProps;
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($c27467240a58e77f$var$TextInputWrapper, {
        fieldWidth: fieldWidth,
        marginBottom: marginBottom,
        inlineBlock: inlineBlock,
        textInputWrapperWidth: textInputWrapperWidth,
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("input", {
                type: "text",
                ...props,
                ...isChanged && isUsed && error ? {
                    className: `is-invalid-input ${props.className}`
                } : {
                    className: props.className
                }
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {}),
            displayname && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("label", {
                htmlFor: props.id,
                children: displayname
            }),
            isChanged && isUsed && error
        ]
    });
};
const $c27467240a58e77f$var$testPropsToExclude = [
    'displayname',
    'fieldWidth',
    'textInputWrapperWidth',
    'marginBottom',
    'inlineBlock'
];
const $c27467240a58e77f$var$TextInputWrapper = (0, $65e706775ff71837$export$2e2bcd8739ae039).div.withConfig({
    shouldForwardProp: (prop)=>!$c27467240a58e77f$var$testPropsToExclude.includes(prop)
})`
    max-width: 300px;
    width: ${(props)=>props.textInputWrapperWidth ? props.textInputWrapperWidth : '100%'}; 
    display: ${(props)=>props.inlineBlock ? 'inline-block' : 'block'}; 
    position: relative;
    margin-bottom: 20px;

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).medium(`
        max-width: 95%;
        width: 95%;
    `)}
    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        max-width: 100%;
        width: 100%;
    `)}

    input[type=text] {
        width: ${(props)=>props.fieldWidth ? props.fieldWidth : '100%'}; 

        padding: 15px 15px 16px 14px;
        margin-bottom: ${(props)=>props.marginBottom ? props.marginBottom : '0px'}; 
        background-color: #FCFCFC;
        border: 1px solid ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.almostBlack};
        font-family: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.main};
        font-size: 16px;

        outline: none !important;

        &[value=""] { 
            border-color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.almostBlack};
        }

        &:not([value=""]) { 
            border-color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.almostBlack};
        }

        &:not([value=""]):not(:focus):not(.is-invalid-input) {
            padding-right: 32px;
            border-color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.green};

            & + span {
                font-size: 13px;
                position: absolute;
                top: 50%;
                left: 100%;
                transform: translate(-26px, -50%);
                color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.green};

                &:after {
                    ${(0, $45d1242a07988139$export$74300498d1a9477c).check()}
                }
            }
        }

        &.is-invalid-input {
            border-color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.error};
        }

        &:disabled {
            cursor: not-allowed;
            opacity: 0.5;
        }


        ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
            border-width: 2px;
        `)}
    }

     input[type=text]::placeholder {
        opacity: 1;
        color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.almostBlack};
    }
`;
var $c27467240a58e77f$export$2e2bcd8739ae039 = (0, $ecd163b239ffc845$export$2e2bcd8739ae039)($c27467240a58e77f$export$c86715117507e8e5);





class $d9b644d9ab5202b6$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    static propTypes = {
        modifierClass: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).array,
        firstName: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
        lastName: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
        personalIdentityNumber: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
        gender: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
        dateOfBirth: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
        customerSupportUrl: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
        personalIdentityNumberIsEditable: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).bool,
        firstNameIsEditable: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).bool,
        isEditing: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).bool,
        onEditSave: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func,
        onEditCancel: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func,
        onEditButtonClick: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func
    };
    static defaultProps = {
        firstName: '',
        lastName: '',
        personalIdentityNumber: '',
        gender: '',
        dateOfBirth: '',
        modifierClass: [],
        customerSupportUrl: '#',
        personalIdentityNumberIsEditable: false,
        firstNameIsEditable: false,
        isEditing: false,
        onEditSave: ()=>{},
        onEditCancel: ()=>{},
        onEditButtonClick: ()=>{}
    };
    getName() {
        if (this.props.isEditing && this.props.firstNameIsEditable) return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
            style: {
                whiteSpace: 'nowrap'
            },
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $c27467240a58e77f$export$2e2bcd8739ae039), {
                    id: "child_firstname",
                    name: "firstName",
                    required: true,
                    inlineBlock: true,
                    value: this.props.firstName,
                    placeholder: "F\xf6rnamn",
                    "data-validation-error-message": "Ange ett f\xf6rnamn",
                    validations: []
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("strong", {
                    children: [
                        "\xa0",
                        this.props.lastName
                    ]
                })
            ]
        });
        return null;
    }
    getPersonalIdentityNumber() {
        const personalIdentityNumber = this.props.personalIdentityNumber;
        if (this.props.isEditing && this.props.personalIdentityNumberIsEditable) return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $c27467240a58e77f$export$2e2bcd8739ae039), {
                id: "child_personalidentitynumber",
                name: "personalIdentityNumber",
                required: true,
                inlineBlock: true,
                value: this.props.personalIdentityNumber,
                placeholder: 'xxxxxxxxxxxxx',
                "data-validation-error-message": "Ange ett korrekt personnummer",
                validations: [
                    (0, $d5552fc3ceef5489$export$6b5405a3207f4c0f)
                ]
            })
        });
        return personalIdentityNumber;
    }
    onEditButton() {
        this.props.onEditButtonClick();
    }
    onSaveButton() {
        const formValues = (0, $f2bfeab6e0c24c97$export$2e2bcd8739ae039)(this.form);
        const firstName = formValues.firstName;
        const personalIdentityNumber = formValues.personalIdentityNumber;
        this.props.onEditSave(firstName, personalIdentityNumber);
    }
    onCancelButton() {
        this.props.onEditCancel();
    }
    submitForm(ev) {
        ev.preventDefault();
        if (this.props.isEditing) this.onSaveButton();
    }
    render() {
        const isEditable = this.props.personalIdentityNumberIsEditable || this.props.firstNameIsEditable;
        let fullName = (this.props.firstName == null ? "(F\xf6rnamn saknas)" : this.props.firstName) + ' ' + this.props.lastName;
        let actionLabel = "\xc4ndra";
        let actionFunction = ()=>{
            this.onEditButton();
        };
        let showCancel = false;
        let actionIsFormButton = false;
        if (this.props.isEditing) {
            showCancel = true;
            if (this.props.firstNameIsEditable) fullName = '';
            actionIsFormButton = true;
            actionLabel = 'Spara';
            actionFunction = ()=>{
                this.onSaveButton();
            };
        }
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $8c02aa23a40a9b45$export$2e2bcd8739ae039), {
            ref: (el)=>{
                this.form = el;
            },
            onSubmit: (e)=>this.submitForm(e),
            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $b46c391aa29114dc$export$2e2bcd8739ae039), {
                actionShow: isEditable,
                actionLabel: actionLabel,
                actionOnClick: actionFunction,
                actionIsFormButton: actionIsFormButton,
                secondaryActionShow: showCancel,
                secondaryActionLabel: 'Avbryt',
                secondaryActionOnClick: ()=>{
                    this.onCancelButton();
                },
                children: [
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $416bb2eafae90d64$export$2e2bcd8739ae039), {
                        title: fullName,
                        contents: [
                            this.getName(),
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                className: "meta-list__list__content--personal-id-no",
                                children: this.getPersonalIdentityNumber()
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $416bb2eafae90d64$export$2e2bcd8739ae039), {
                        title: "K\xf6n: ",
                        compactMode: true,
                        contents: [
                            this.props.gender
                        ]
                    })
                ]
            })
        });
    }
}
const $d9b644d9ab5202b6$export$778543a9d14c4d01 = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    margin-bottom: 30px;
`;




var $8NFma = parcelRequire("8NFma");






var $8NFma = parcelRequire("8NFma");


const $02195558c03def3c$var$MONTH_NAMES_SWEDISH = [
    "Januari",
    "Februari",
    "Mars",
    "April",
    "Maj",
    "Juni",
    "Juli",
    "Augusti",
    "September",
    "Oktober",
    "November",
    "December"
];
class $02195558c03def3c$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    static propTypes = {
        date: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string
    };
    static defaultProps = {
        date: ''
    };
    render() {
        const theDate = new Date(this.props.date);
        let day = theDate.getDate();
        let month = $02195558c03def3c$var$MONTH_NAMES_SWEDISH[theDate.getMonth()];
        let year = theDate.getFullYear();
        if (isNaN(day)) {
            day = 'Felaktigt datum';
            month = '';
            year = '';
        }
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Fragment, {
            children: [
                day,
                " ",
                month,
                " ",
                year
            ]
        });
    }
}


class $bbb4298cccabddb4$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    static propTypes = {
        modifierClass: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).array,
        name: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
        species: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
        breed: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
        sex: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
        dateOfBirth: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
        insuranceNumber: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).number,
        customerSupportUrl: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string
    };
    static defaultProps = {
        firstName: '',
        species: '',
        breed: '',
        sex: '',
        dateOfBirth: '',
        insuranceNumber: 0,
        modifierClass: [],
        customerSupportUrl: '#'
    };
    render() {
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $b46c391aa29114dc$export$2e2bcd8739ae039), {
            actionShow: false,
            actionLabel: "\xc4ndra",
            actionOnClick: ()=>{},
            push: true,
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $416bb2eafae90d64$export$2e2bcd8739ae039), {
                    title: this.props.firstName,
                    contents: [
                        this.props.species + (this.props.breed ? ' - ' : '') + this.props.breed
                    ]
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $416bb2eafae90d64$export$2e2bcd8739ae039), {
                    title: "K\xf6n: ",
                    compactMode: true,
                    contents: [
                        this.props.sex
                    ]
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("dd", {}),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $416bb2eafae90d64$export$2e2bcd8739ae039), {
                    title: "F\xf6delsedatum: ",
                    compactMode: true,
                    contents: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $02195558c03def3c$export$2e2bcd8739ae039), {
                            date: this.props.dateOfBirth
                        })
                    ]
                })
            ]
        });
    }
}




var $8NFma = parcelRequire("8NFma");


class $e257fc0c98f3cdd4$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    static propTypes = {
        isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).bool,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).node),
            (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).node,
            (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).array
        ])
    };
    static defaultProps = {
        isLoading: false,
        children: []
    };
    render() {
        if (this.props.isLoading) return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $492d68823d70b95b$export$2e2bcd8739ae039), {});
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Fragment, {
            children: this.props.children
        });
    }
}




const $4fd266fc19f7b686$var$NoInsurances = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    font-family: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.main};
    font-size: inherit;
    color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.almostBlack};

`;
var $4fd266fc19f7b686$export$2e2bcd8739ae039 = $4fd266fc19f7b686$var$NoInsurances;




var $8NFma = parcelRequire("8NFma");





var $8NFma = parcelRequire("8NFma");










class $1f74f6fd69c785c1$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    static propTypes = {
        modifierClass: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).array,
        email: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
        phone: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
        mobile: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
        onFormCancel: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func,
        onFormSubmit: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func
    };
    static defaultProps = {
        modifierClass: [],
        email: '',
        phone: '',
        mobile: '',
        onFormCancel: ()=>{},
        onFormSubmit: ()=>{}
    };
    submitForm = (e)=>{
        e.preventDefault();
        const formValues = (0, $f2bfeab6e0c24c97$export$2e2bcd8739ae039)(this.form);
        formValues.mobilePhone = (0, $083d6309f04b9f7c$export$1318658b188bf22b)((0, $083d6309f04b9f7c$export$fd126ff104591c5)(formValues.mobilePhone));
        // Normalize email fields to lowercase
        if (formValues.emailAddress) formValues.emailAddress = formValues.emailAddress.toLowerCase();
        if (formValues.emailAddressConfirmation) formValues.emailAddressConfirmation = formValues.emailAddressConfirmation.toLowerCase();
        // Remove email fields if both are empty
        if (formValues.emailAddress === '' && formValues.emailAddressConfirmation === '') {
            delete formValues.emailAddress;
            delete formValues.emailAddressConfirmation;
        }
        this.props.onFormSubmit(formValues);
    };
    render() {
        const currentEmail = this.props.email ? this.props.email : 'mail@mail.se';
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $8c02aa23a40a9b45$export$2e2bcd8739ae039), {
            ref: (el)=>{
                this.form = el;
            },
            onSubmit: (e)=>this.submitForm(e),
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($1f74f6fd69c785c1$export$b534bc812df080fd, {
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($1f74f6fd69c785c1$export$a8a3e93435678ff9, {
                            children: "Mobiltelefon"
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $c27467240a58e77f$export$2e2bcd8739ae039), {
                            id: "mobilePhone",
                            name: "mobilePhone",
                            value: this.props.mobile,
                            "data-validation-error-message": "Ange ett svenskt telefonnummer",
                            validations: [
                                (0, $d5552fc3ceef5489$export$213f62348afd7d3b)
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($1f74f6fd69c785c1$export$b534bc812df080fd, {
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($1f74f6fd69c785c1$export$a8a3e93435678ff9, {
                            children: "E-postadress"
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $c27467240a58e77f$export$2e2bcd8739ae039), {
                            id: "emailAddress",
                            name: "emailAddress",
                            placeholder: currentEmail,
                            "data-validation-error-message": "Ange en korrekt e-post",
                            validations: [
                                (0, $d5552fc3ceef5489$export$80e3168fea119969)('emailAddress', 'emailAddressConfirmation', 'Ange en korrekt e-post', "E-postadresserna st\xe4mmer inte \xf6verens")
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($1f74f6fd69c785c1$export$b534bc812df080fd, {
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($1f74f6fd69c785c1$export$a8a3e93435678ff9, {
                            children: "Bekr\xe4fta e-postadress"
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $c27467240a58e77f$export$2e2bcd8739ae039), {
                            id: "emailAddressConfirmation",
                            name: "emailAddressConfirmation",
                            placeholder: currentEmail,
                            "data-validation-error-message": "Ange en korrekt e-post",
                            validations: [
                                (0, $d5552fc3ceef5489$export$80e3168fea119969)('emailAddress', 'emailAddressConfirmation', 'Ange en korrekt e-post', "E-postadresserna st\xe4mmer inte \xf6verens")
                            ]
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $80cca30c19bbba0b$export$2e2bcd8739ae039), {
                            className: "my-pages-btn button button--green",
                            children: "Spara"
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($1f74f6fd69c785c1$export$488fee190faedb43, {
                            className: "my-pages-btn--cancel",
                            onClick: (ev)=>{
                                ev.preventDefault();
                                this.props.onFormCancel();
                            },
                            children: "Avbryt"
                        })
                    ]
                })
            ]
        });
    }
}
const $1f74f6fd69c785c1$export$b534bc812df080fd = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    position: relative;

    button {
        margin-top: 10px;
    }
    button[disabled] {
        opacity: 0.5;
    }
`;
const $1f74f6fd69c785c1$export$a8a3e93435678ff9 = (0, $65e706775ff71837$export$2e2bcd8739ae039).h5`
    font-size: 24px;
    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        font-size: 18px !important;
        line-height: 37.4px;
    `)}
    margin-bottom: 5px !important;
`;
const $1f74f6fd69c785c1$export$488fee190faedb43 = (0, $65e706775ff71837$export$2e2bcd8739ae039).button`
    font-weight: normal !important;
`;





var $8NFma = parcelRequire("8NFma");
class $c5c8b7bd823ac383$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    static propTypes = {
        modifierClass: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).array,
        title: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
        description: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
        showAddButton: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).bool,
        addButtonLabel: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
        onAddButtonClick: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func,
        addButtonUrl: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).node),
            (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).node,
            (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).array
        ])
    };
    static defaultProps = {
        modifierClass: [],
        title: '',
        description: '',
        addButtonUrl: '',
        children: [],
        showAddButton: false,
        addButtonLabel: "L\xe4gg till",
        onAddButtonClick: ()=>{}
    };
    render() {
        const containerClasses = [
            'member-info-section'
        ].concat(this.props.modifierClass);
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
            className: containerClasses.join(' '),
            "data-matomo-mask": true,
            children: [
                this.props.title && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("h2", {
                    className: "member-info-section__title",
                    children: this.props.title
                }),
                this.props.description && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                    className: "member-info-section__description",
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("p", {
                        children: this.props.description
                    })
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                    className: "member-info-section__content",
                    children: this.props.children
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                    className: "member-info-section__footer",
                    children: this.props.showAddButton && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("a", {
                        className: "member-info-section__footer__add-button",
                        onClick: this.props.onAddButtonClick,
                        href: this.props.addButtonUrl,
                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("span", {
                            className: "button button--green",
                            children: [
                                " ",
                                this.props.addButtonLabel
                            ]
                        })
                    })
                })
            ]
        });
    }
}



class $3866f5890567e2ee$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    static propTypes = {
        modifierClass: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).array,
        name: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
        personalIdentityNumber: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
        phonenumber: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
        adressLine1: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
        adressLine2: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
        email: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
        customerSupportUrl: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
        editing: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).bool,
        onChangeInfoClick: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func,
        onInfoSave: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func,
        onInfoCancel: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func
    };
    static defaultProps = {
        modifierClass: [],
        title: '',
        children: [],
        excerpt: '',
        customerSupportUrl: '#',
        modifierClass: [],
        editing: false,
        onInfoSave: ()=>{},
        onInfoCancel: ()=>{},
        onChangeInfoClick: ()=>{}
    };
    getContactInfo() {
        if (this.props.editing === false) return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
            children: [
                this.props.mobileNumber && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $1f74f6fd69c785c1$export$a8a3e93435678ff9), {
                            children: "Mobiltelefon"
                        }),
                        this.props.mobileNumber
                    ]
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $1f74f6fd69c785c1$export$a8a3e93435678ff9), {
                    children: "E-postadress"
                }),
                this.props.email,
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("br", {}),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("br", {}),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                    className: "my-pages-btn button button--green",
                    onClick: this.props.onChangeInfoClick,
                    children: "\xc4ndra mina kontaktuppgifter"
                })
            ]
        });
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $1f74f6fd69c785c1$export$2e2bcd8739ae039), {
            email: this.props.email,
            phone: this.props.phoneNumber,
            mobile: this.props.mobileNumber,
            onFormSubmit: (formData)=>{
                this.props.onInfoSave(formData);
            },
            onFormCancel: ()=>{
                this.props.onInfoCancel();
            }
        });
    }
    render() {
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $c5c8b7bd823ac383$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $b46c391aa29114dc$export$2e2bcd8739ae039), {
                border: false,
                children: [
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $416bb2eafae90d64$export$2e2bcd8739ae039), {
                        title: "Namn",
                        contents: [
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Fragment, {
                                children: [
                                    this.props.name,
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $aa192976c67b1def$export$2e2bcd8739ae039), {
                                        isMemberInfoPage: true,
                                        fontSize: 16,
                                        children: "Namn, adress och personnummer h\xe4mtas fr\xe5n folkbokf\xf6ringen och kan inte \xe4ndras p\xe5 webbplatsen. Om uppgifterna \xe4r felaktiga s\xe5 kontakta kundservice p\xe5 0771-21 09 09."
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $416bb2eafae90d64$export$2e2bcd8739ae039), {
                        title: "Adress",
                        contents: [
                            this.props.adressLine1,
                            this.props.adressLine2
                        ]
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $416bb2eafae90d64$export$2e2bcd8739ae039), {
                        contents: [
                            this.getContactInfo()
                        ]
                    })
                ]
            })
        });
    }
}




var $8NFma = parcelRequire("8NFma");





class $a527b435506aeaab$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    static propTypes = {
        title: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
        description: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
        name: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
        personalIdentityNumber: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
        customerSupportUrl: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
        modifierClass: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).array,
        hasRegisteredInsurances: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).bool
    };
    static defaultProps = {
        title: '',
        description: '',
        name: '',
        personalIdentityNumber: '',
        customerSupportUrl: '#',
        modifierClass: [],
        hasRegisteredInsurances: true
    };
    render() {
        const helpText = /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("span", {
            children: [
                "Om du har n\xe5gra fr\xe5gor, eller om du sedan tidigare har en registrerad medf\xf6rs\xe4krad och vill byta till en ny ",
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("br", {}),
                "medf\xf6rs\xe4krad, kontakta kundservice p\xe5 0771-21 09 09."
            ]
        });
        const unknownCoinsured = this.props.name.indexOf("Ok\xe4nd ") === 0;
        const unknownCoinsuredText = /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("span", {
            children: [
                "Vi saknar uppgifter om din medf\xf6rs\xe4krade. Kontakta kundservice p\xe5 ",
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("a", {
                    className: "inline-phone-link",
                    href: "tel:0771210909",
                    children: "0771-21 09 09"
                }),
                " f\xf6r att l\xe4mna dessa."
            ]
        });
        const noCoinsuredText = "Du har ingen registrerad medf\xf6rs\xe4krad";
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $c5c8b7bd823ac383$export$2e2bcd8739ae039), {
            title: this.props.title,
            description: this.props.description,
            children: [
                this.props.personalIdentityNumber && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $b46c391aa29114dc$export$2e2bcd8739ae039), {
                    children: [
                        !this.props.hasRegisteredInsurances && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("span", {
                            className: "member-info-section__content__coinsured-no-insurances",
                            children: [
                                "Nedan person \xe4r registrerad som din medf\xf6rs\xe4krade men saknar just nu f\xf6rs\xe4kringar. Om du vill uppdatera dina uppgifter s\xe5 kontakta kundservice p\xe5 ",
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("a", {
                                    href: "tel:+46771210909",
                                    children: "0771-21 09 09"
                                }),
                                ".",
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("br", {}),
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("a", {
                                    href: "/mina-sidor/teckna-forsakring/",
                                    children: "Teckna f\xf6rs\xe4kringar f\xf6r medf\xf6rs\xe4krad"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $416bb2eafae90d64$export$2e2bcd8739ae039), {
                            helpText: helpText,
                            helpTextActionLabel: "Kontakta kundtj\xe4nst",
                            helpTextActionUrl: this.props.customerSupportUrl,
                            title: this.props.name
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $416bb2eafae90d64$export$2e2bcd8739ae039), {
                            contents: [
                                this.props.personalIdentityNumber
                            ]
                        })
                    ]
                }),
                !this.props.personalIdentityNumber && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $4fd266fc19f7b686$export$2e2bcd8739ae039), {
                    children: unknownCoinsured ? unknownCoinsuredText : noCoinsuredText
                })
            ]
        });
    }
}




var $8NFma = parcelRequire("8NFma");




var $8NFma = parcelRequire("8NFma");
class $6131b7dc9e5eb8c4$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    static propTypes = {
        modifierClass: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).array,
        title: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
        description: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
        showAddButton: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).bool,
        addButtonLabel: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
        onAddButtonClick: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func,
        addButtonUrl: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).node),
            (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).node,
            (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).array
        ])
    };
    static defaultProps = {
        modifierClass: [],
        title: '',
        description: '',
        addButtonUrl: '',
        children: [],
        showAddButton: false,
        addButtonLabel: "L\xe4gg till",
        onAddButtonClick: ()=>{}
    };
    render() {
        const containerClasses = [
            'member-info-section'
        ].concat(this.props.modifierClass);
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
            className: containerClasses.join(' '),
            "data-matomo-mask": true,
            children: [
                this.props.title && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("h2", {
                    className: "member-info-section__title",
                    children: this.props.title
                }),
                this.props.description && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                    className: "member-info-section__description",
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("p", {
                        children: this.props.description
                    })
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                    className: "member-info-section__content",
                    children: this.props.children
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                    className: "member-info-section__footer",
                    children: this.props.showAddButton && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("a", {
                        className: "member-info-section__footer__add-button",
                        onClick: this.props.onAddButtonClick,
                        href: this.props.addButtonUrl,
                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("span", {
                            className: "button button--green",
                            children: [
                                " ",
                                this.props.addButtonLabel
                            ]
                        })
                    })
                })
            ]
        });
    }
}


class $3741c9454d143e02$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    static propTypes = {
        modifierClass: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).array,
        title: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
        description: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
        onAddButtonClick: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func,
        addButtonUrl: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).node),
            (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).node,
            (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).array
        ])
    };
    static defaultProps = {
        modifierClass: [],
        title: '',
        description: '',
        signupUrl: '',
        children: [],
        onAddButtonClick: ()=>{}
    };
    render() {
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $6131b7dc9e5eb8c4$export$2e2bcd8739ae039), {
            title: this.props.title,
            description: this.props.description,
            showAddButton: true,
            addButtonLabel: "Teckna ytterligare f\xf6rs\xe4kring",
            onAddButtonClick: this.props.onAddButtonClick,
            addButtonUrl: this.props.addButtonUrl,
            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                children: this.props.children
            })
        });
    }
}




var $8NFma = parcelRequire("8NFma");


class $5f98d75a2a8f45af$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    static propTypes = {
        modifierClass: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).array,
        title: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
        description: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
        onAddButtonClick: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).func,
        addButtonUrl: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).node),
            (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).node,
            (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).array
        ])
    };
    static defaultProps = {
        modifierClass: [],
        title: '',
        description: '',
        signupUrl: '',
        children: [],
        onAddButtonClick: ()=>{}
    };
    render() {
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $6131b7dc9e5eb8c4$export$2e2bcd8739ae039), {
            title: this.props.title,
            description: this.props.description,
            showAddButton: true,
            addButtonLabel: "Teckna ytterligare f\xf6rs\xe4kring",
            onAddButtonClick: this.props.onAddButtonClick,
            addButtonUrl: this.props.addButtonUrl,
            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                children: this.props.children
            })
        });
    }
}


class $17dbe4af74964259$var$CustomerInfoPage extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    static get propTypes() {
        return {
            mountRootId: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string.isRequired
        };
    }
    constructor(props){
        super(props);
        this.attributeData = this.getAttributeData();
        this.state = {
            editContactInfo: false,
            editChildIds: []
        };
    }
    componentDidMount() {
        this.props.loadData();
    }
    getAttributeData() {
        return {
            heading: (0, $e6aeb63e6149c504$export$161fa9a9af21e7de)('heading', this.props.mountRootId),
            preamble: (0, $e6aeb63e6149c504$export$161fa9a9af21e7de)('preamble', this.props.mountRootId),
            customerSupportUrl: (0, $e6aeb63e6149c504$export$161fa9a9af21e7de)('customer-support-url', this.props.mountRootId),
            animalInsuranceSignupUrl: (0, $e6aeb63e6149c504$export$161fa9a9af21e7de)('animal-insurance-signup-url', this.props.mountRootId),
            childInsuranceSignupUrl: (0, $e6aeb63e6149c504$export$161fa9a9af21e7de)('child-insurance-signup-url', this.props.mountRootId)
        };
    }
    getAnimalElements() {
        const customerSupportUrl = this.attributeData.customerSupportUrl;
        const customerAnimals = this.props.customerAnimals.animals;
        if (!customerAnimals || !customerAnimals.length) return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $4fd266fc19f7b686$export$2e2bcd8739ae039), {
            children: "Du har inga f\xf6rs\xe4kringar f\xf6r djur"
        });
        return customerAnimals.map((animal, index)=>{
            return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $bbb4298cccabddb4$export$2e2bcd8739ae039), {
                firstName: animal.animalDisplayName,
                species: (0, $36509d2879dd53eb$export$497e880301a9a0ec)(animal.animalType),
                breed: animal.animalBreedName,
                sex: (0, $36509d2879dd53eb$export$66b0d8b6f90d739f)(animal.animalGender),
                dateOfBirth: animal.animalBirthDate,
                insuranceNumber: animal.insuranceObjectId,
                customerSupportUrl: customerSupportUrl
            }, index);
        });
    }
    getInsuredChildrenElements() {
        const customerSupportUrl = this.attributeData.customerSupportUrl;
        const customerChildren = this.props.customerChildren.children;
        if (!customerChildren || !customerChildren.length) return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $4fd266fc19f7b686$export$2e2bcd8739ae039), {
            children: "Du har inga f\xf6rs\xe4kringar f\xf6r barn"
        });
        return customerChildren.map((child)=>{
            const insuranceId = child.insuranceObjectId;
            const isBeingEdited = this.state.editChildIds.indexOf(insuranceId) !== -1;
            const personalIdentityNumberIsEditable = child.personalIdentityNumberIsEditable;
            const firstNameIsEditable = child.firstNameIsEditable;
            return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $d9b644d9ab5202b6$export$2e2bcd8739ae039), {
                firstName: child.childFirstName,
                lastName: child.childLastName,
                gender: (0, $36509d2879dd53eb$export$d8633857024224d8)(child.childGender),
                personalIdentityNumber: child.childPersonalIdentityNumber,
                dateOfBirth: child.childBirthDate,
                customerSupportUrl: customerSupportUrl,
                personalIdentityNumberIsEditable: personalIdentityNumberIsEditable,
                firstNameIsEditable: firstNameIsEditable,
                isEditing: isBeingEdited,
                onEditSave: (firstName, personalIdentityNumber)=>{
                    this.updateChild(child, firstName, personalIdentityNumber);
                    this.stopEditChild(insuranceId);
                },
                onEditCancel: ()=>{
                    this.stopEditChild(insuranceId);
                },
                onEditButtonClick: ()=>{
                    this.startEditChild(insuranceId);
                }
            }, insuranceId);
        });
    }
    updateChild(child, firstName, personalIdentityNumber) {
        const formData = {
            PersonId: this.props.customer.personId,
            ChildInsuranceObjectId: child.insuranceObjectId
        };
        if (firstName) formData.FirstName = firstName;
        if (personalIdentityNumber) formData.PersonalIdentityNumber = personalIdentityNumber;
        this.props.updateChild(formData);
    }
    startEditChild(insuranceObjectId) {
        const editChildIds = this.state.editChildIds;
        editChildIds.push(insuranceObjectId);
        this.setState({
            editChildIds: editChildIds
        });
    }
    stopEditChild(insuranceObjectId) {
        const editChildIds = this.state.editChildIds;
        var childIndex = editChildIds.indexOf(insuranceObjectId);
        if (childIndex > -1) editChildIds.splice(childIndex, 1);
        this.setState({
            editChildIds: editChildIds
        });
    }
    formatZipCode(zip) {
        if (!zip || zip.toString().length != 5) // Unknown zip format, do nothing
        return zip;
        zip = zip.toString();
        return zip.substring(0, 3) + ' ' + zip.substring(3);
    }
    render() {
        const title = this.attributeData.heading;
        const preamble = this.attributeData.preamble;
        const customerSupportUrl = this.attributeData.customerSupportUrl;
        const animalInsuranceSignupUrl = this.attributeData.animalInsuranceSignupUrl;
        const childInsuranceSignupUrl = this.attributeData.childInsuranceSignupUrl;
        let coinsuredDescription = "Medf\xf6rs\xe4krad \xe4r alltid den person som du \xe4r gift eller sambo med.";
        if (this.props.coInsuredInfo.personalIdentityNumber) coinsuredDescription += " Kontrollera att uppgifterna st\xe4mmer.";
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $77e75f8e9d2fab4b$export$2e2bcd8739ae039), {
            title: title,
            htmlDescription: preamble,
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $7869c274f4138d81$export$2e2bcd8739ae039), {
                    title: "Kontaktuppgifter",
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $e257fc0c98f3cdd4$export$2e2bcd8739ae039), {
                        isLoading: this.props.customerInfo.fetching,
                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $3866f5890567e2ee$export$2e2bcd8739ae039), {
                            name: this.props.customerInfo.firstName + ' ' + this.props.customerInfo.lastName,
                            phoneNumber: this.props.customerInfo.homePhone,
                            mobileNumber: this.props.customerInfo.mobilePhone,
                            adressLine1: this.props.customerInfo.streetAddress,
                            adressLine2: this.formatZipCode(this.props.customerInfo.zipCode) + ' ' + this.props.customerInfo.city,
                            email: this.props.customerInfo.emailAddress,
                            customerSupportUrl: customerSupportUrl,
                            editing: this.state.editContactInfo,
                            onInfoSave: (formData)=>{
                                this.props.updateContactInfo(formData);
                                this.setState({
                                    editContactInfo: false
                                });
                            },
                            onInfoCancel: ()=>{
                                this.setState({
                                    editContactInfo: false
                                });
                            },
                            onChangeInfoClick: ()=>{
                                this.setState({
                                    editContactInfo: true
                                });
                            }
                        })
                    })
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $7869c274f4138d81$export$2e2bcd8739ae039), {
                    title: "Medf\xf6rs\xe4krad",
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $e257fc0c98f3cdd4$export$2e2bcd8739ae039), {
                        isLoading: this.props.coInsuredInfo.fetching,
                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $a527b435506aeaab$export$2e2bcd8739ae039), {
                            title: "Medf\xf6rs\xe4krad",
                            hasRegisteredInsurances: this.props.coInsuredInfo.isInsured,
                            description: coinsuredDescription,
                            name: this.props.coInsuredInfo.firstName + ' ' + this.props.coInsuredInfo.lastName,
                            personalIdentityNumber: this.props.coInsuredInfo.personalIdentityNumber,
                            customerSupportUrl: customerSupportUrl
                        })
                    })
                })
            ]
        });
    }
}
const $17dbe4af74964259$var$mapStateToProps = (state)=>{
    return {
        customerInfo: state.customerInfoPageCustomerInfo,
        coInsuredInfo: state.customerInfoPageCoInsuredInfo,
        //customerAnimals: state.customerInfoPageCustomerAnimals,
        //customerChildren: state.customerInfoPageCustomerChildren,
        hasErrored: state.pageHasErrored,
        error: state.pageError,
        isLoading: state.pageIsLoading,
        step: state.pageCurrentStep
    };
};
const $17dbe4af74964259$var$mapDispatchToProps = (dispatch)=>{
    return {
        loadData: ()=>{
            dispatch((0, $1b014d605fa09c6d$export$3e49cf51e9d71a)());
        // dispatch(fetchCustomerChildren())
        // dispatch(fetchCustomerAnimals())
        },
        updateContactInfo: (formData)=>{
            dispatch((0, $1b014d605fa09c6d$export$3333903bd8e1423e)(formData));
        },
        updateChild: (formData)=>{
            dispatch((0, $8bb4df1e5092f6ea$export$f9b5988fdf706b91)(formData));
        }
    };
};
var $17dbe4af74964259$export$2e2bcd8739ae039 = (0, $5a4066412ccab0c1$export$64605811ab45167f)($17dbe4af74964259$var$mapStateToProps, $17dbe4af74964259$var$mapDispatchToProps)($17dbe4af74964259$var$CustomerInfoPage);




var $8NFma = parcelRequire("8NFma");










var $8NFma = parcelRequire("8NFma");




parcelRequire("8NFma");




const $86b86a30bc1812cf$var$Checkbox = ({ error: error, isChanged: isChanged, isUsed: isUsed, ...allProps })=>{
    const { displayname: displayname, layout: layout, theme: theme, customwidth: customwidth, mobilePaddingRight: mobilePaddingRight, marginbottom: marginbottom, smallLabel: smallLabel, labelAsInline: labelAsInline, children: children, ...props } = {
        ...allProps
    };
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($86b86a30bc1812cf$var$CheckboxWrapper, {
        layout: layout,
        theme: theme,
        displayname: displayname,
        customwidth: customwidth,
        labelAsInline: labelAsInline,
        smallLabel: smallLabel,
        mobilePaddingRight: mobilePaddingRight,
        marginbottom: marginbottom,
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("input", {
                ...props,
                ...isChanged && isUsed && error ? {
                    className: `is-invalid-input ${props.className}`
                } : {
                    className: props.className
                }
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("label", {
                htmlFor: props.id,
                children: [
                    theme !== 'big' && displayname,
                    theme === 'big' && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                        class: "visually-hidden",
                        children: displayname
                    })
                ]
            }),
            children,
            isChanged && isUsed && error
        ]
    });
};
const $86b86a30bc1812cf$var$propsToExclude = [
    'layout',
    'theme',
    'displayname',
    'customwidth',
    'labelAsInline',
    'smallLabel',
    'mobilePaddingRight',
    'marginbottom'
];
const $86b86a30bc1812cf$var$CheckboxWrapper = (0, $65e706775ff71837$export$2e2bcd8739ae039).div.withConfig({
    shouldForwardProp: (prop, defaultValidatorFn)=>!$86b86a30bc1812cf$var$propsToExclude.includes(prop)
})`
    position: ${(props)=>props.layout ? props.layout : 'relative'};
    ${'' /* line-height: 1; */ }

    ${(props)=>props.customwidth ? `
        ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
            width: ${props.customwidth};
        `)}
        ` : ''}
    ${(props)=>props.mobilePaddingRight ? `
        ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
            padding-right: ${props.mobilePaddingRight};
        `)}
        ` : ''}

    ${(props)=>props.layout === 'absolute' ? `top: 50%;
         transform: translateY(-50%)` : ''};

    ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        position: relative;
        top: 0%;
        transform: none;
    `)}

    padding-left: 30px;

    input {
        position: absolute;
        opacity: 0;
    }

    input + label {
        position: relative;
        cursor: pointer;
        padding: 0;
        hyphens: auto;
        display: block;
        width: 100%;
        color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.almostBlack};
        
        ${(props)=>props.labelAsInline ? `
            display: inline;
            width: auto;
        ` : ''}

        ${(props)=>props.smallLabel ? `
            font-size: 14px;
            line-height: 17px;
            padding-top: 4px;
            color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.grayText};
            ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
                padding-top: 0px;
            `)}

            ` : ''}
    }

    input:focus:not(:checked) + label:before {
        outline: rgb(59, 153, 252) auto 5px;
    }

    input:checked + label:after {
        position: absolute;
        ${(0, $45d1242a07988139$export$74300498d1a9477c).check()}
        color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.green};

        left: -26px;
        top: 14px;
        transform: translateY(-50%);
        font-size: 11px;

        ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
            top: 8px;
        `)}
    }

    label:before {
        display: block;
        content: '';
        position: absolute;

        top: 3px;
        left: -30px;

        vertical-align: text-top;
        

        width: 20px;
        height: 20px;

        background: #f5f4f4;
        border: 1px solid #c5c9cc;
        border-radius: 4px;

        ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
            top: -2px;
        `)}

        ${(props)=>props.marginbottom ? `
            ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
                margin-bottom: ${props.marginbottom};
            `)}
        ` : `
            ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
                margin-bottom: 5px;
            `)}
        `}
    }

    // theme: big
    ${(props)=>props.theme === 'big' ? `
        position: relative;
        // min-height: 150px;
        display: inline-block;
        
        padding-left: 0;

        &:not(:first-of-type) {
            padding-left: 10px !important;
        }

        // ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
        //     min-height: 103px;
        // `)}

        label:before {
            display: inline-block;
            content: '${props.displayname}';
            position: relative;

            top: 0;
            left: 0;

            width: auto;
            height: auto;
            // max-height: 70px;
            padding: 34px 53px;
            margin-bottom: 26px;
            margin-right: 10px;

            line-height: 1;
            font-family: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.heading};
            font-size: 22px;
            font-weight: bold;
            color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.almostBlack};

            background: transparent;
            border: none;
            border-radius: 0;
            outline: 1px solid ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.grayBorder};

            transition: outline 150ms ease-out, color 150ms ease-out;

            ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
                padding: 10px 15px 10px 15px;
                font-size: 20px;
                margin-bottom: 15px;
            `)}

            // display: inline-block;
            // content: '${props.displayname}';
            //
            // width: auto;
            // height: auto;
            // padding: 34px 53px;
            // margin-bottom: 26px;
            // margin-right: 10px;
            //
            // font-family: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).fonts.heading};
            // font-size: 22px;
            // font-weight: bold;
            // color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.almostBlack};
            //
            // border-radius: 0;
            // background: transparent;
            // border: none;
            //
            // outline: 1px solid ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.grayBorder};
            // transition: outline 150ms ease-out, color 150ms ease-out, box-shadow none;
            //
            // ${(0, $45d1242a07988139$export$8f880b6e390052fa).small(`
            //     min-width: 200px;
            //     // padding: 17px 24px;
            //     padding: 10px 20px;
            //     font-size: 20px;
            //     margin-bottom: 15px;
            // `)}
        }

        input[type=radio]:focus:not(:checked) + label:before {
            box-shadow: inset 0px 0px 1px 1px rgb(59, 153, 252);
        }

        input:checked + label:before {
            outline: 3px solid ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.green};
            color: ${(0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.green};
        }

        input:checked + label:after {
            display: none;
        }

        .form-error {
            text-align: left;
            margin-top: 10px;
        }` : ''}
`;
var $86b86a30bc1812cf$export$2e2bcd8739ae039 = (0, $ecd163b239ffc845$export$2e2bcd8739ae039)($86b86a30bc1812cf$var$Checkbox);





const $9ce43aec95b4f532$export$8cb9fe3f31391d38 = 'success';
const $9ce43aec95b4f532$export$f232ef6075ada121 = 'failure';
class $9ce43aec95b4f532$var$Notice extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    onRetryClick() {
        if (this.props.onRetryClick) this.props.onRetryClick();
    }
    render() {
        const iconClasses = [
            'extend-student-insurance-notice__header__icon'
        ];
        const actions = [];
        if (this.props.type) iconClasses.push('extend-student-insurance-notice__header__icon--' + this.props.type);
        if (this.props.type === $9ce43aec95b4f532$export$f232ef6075ada121) actions.push(/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
            className: "my-pages-btn",
            onClick: ()=>{
                this.onRetryClick();
            },
            children: "F\xf6rs\xf6k igen"
        }, "retry-btn"));
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
            className: "extend-student-insurance-notice",
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                    className: "extend-student-insurance-notice__header",
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                        className: iconClasses.join(' ')
                    })
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                    className: "extend-student-insurance-notice__content",
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                        className: "extend-student-insurance-notice__content__description",
                        children: this.props.description
                    })
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                    className: "extend-student-insurance-notice__actions",
                    children: actions
                })
            ]
        });
    }
}
var $9ce43aec95b4f532$export$2e2bcd8739ae039 = $9ce43aec95b4f532$var$Notice;





function $14139987caa9620c$export$b1e157761d7a0e55() {
    const lfDataService = new (0, $25937fdb26d57abd$export$2e2bcd8739ae039)();
    return (dispatch)=>{
        dispatch((0, $67f4b1d2fb7c2244$export$5630fcc02dc02d1b)(true));
        let serviceCall;
        lfDataService.paymentMethod().then((result)=>{
            dispatch($14139987caa9620c$export$c32611e3ba9deedf(result.paymentMethod));
            dispatch((0, $67f4b1d2fb7c2244$export$5630fcc02dc02d1b)(false));
        }).catch((error)=>{
            dispatch((0, $67f4b1d2fb7c2244$export$5630fcc02dc02d1b)(false));
        });
    };
}
function $14139987caa9620c$export$492199e0ce8b7143() {
    return (dispatch)=>{
        dispatch((0, $67f4b1d2fb7c2244$export$5630fcc02dc02d1b)(false));
    };
}
function $14139987caa9620c$export$9a10e96f62ca4785(hasFailed) {
    return {
        type: 'STUDENT_SPECIAL_TEASER_FORM_SUBMIT_FAILURE',
        data: !!hasFailed
    };
}
function $14139987caa9620c$export$1f1c05d366730ea7(submitted, automatic) {
    return {
        type: 'STUDENT_SPECIAL_TEASER_FORM_SUBMITTED',
        data: {
            submitted: !!submitted,
            automatic: !!automatic
        }
    };
}
function $14139987caa9620c$export$c32611e3ba9deedf(data) {
    return {
        type: 'STUDENT_SPECIAL_PAYMENT_METHOD_LOADED',
        data: data
    };
}
function $14139987caa9620c$export$217fa9d59d3bf39b(data, automatic) {
    const lfDataService = new (0, $25937fdb26d57abd$export$2e2bcd8739ae039)();
    return (dispatch)=>{
        dispatch((0, $67f4b1d2fb7c2244$export$5630fcc02dc02d1b)(true));
        let serviceCall;
        if (automatic) {
            const { insurancename: insurancename, accountnumber: accountnumber, bankcode: bankcode, IsFullyAbleToWork: IsFullyAbleToWork, PurchaseTermsApproved: PurchaseTermsApproved } = data;
            serviceCall = lfDataService.extendStudentInsuranceAutomatic(insurancename, accountnumber, bankcode, IsFullyAbleToWork, PurchaseTermsApproved);
        } else {
            const { insurancename: insurancename, IsFullyAbleToWork: IsFullyAbleToWork, PurchaseTermsApproved: PurchaseTermsApproved } = data;
            serviceCall = lfDataService.extendStudentInsurance(insurancename, IsFullyAbleToWork, PurchaseTermsApproved);
        }
        serviceCall.then((result)=>{
            dispatch((0, $67f4b1d2fb7c2244$export$5630fcc02dc02d1b)(false));
            if (result.success) {
                dispatch($14139987caa9620c$export$9a10e96f62ca4785(false));
                dispatch($14139987caa9620c$export$1f1c05d366730ea7(true, automatic));
                return;
            }
            dispatch($14139987caa9620c$export$1f1c05d366730ea7(false, automatic));
            dispatch($14139987caa9620c$export$9a10e96f62ca4785(true));
        }).catch((e)=>{
            dispatch((0, $67f4b1d2fb7c2244$export$5630fcc02dc02d1b)(false));
            dispatch($14139987caa9620c$export$9a10e96f62ca4785(true));
        });
    };
}




var $8NFma = parcelRequire("8NFma");





var $8NFma = parcelRequire("8NFma");






class $8126d026e641c38b$var$BaseForm extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    constructor(){
        super();
        this.accordionContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createRef();
    }
    formSubmit() {
        const formValues = (0, $f2bfeab6e0c24c97$export$2e2bcd8739ae039)(this.form);
        this.props.onSubmit(formValues);
    }
    componentDidMount() {
        const accordionContent = this.accordionContent.current;
        if (this.props.isOpen && accordionContent) setTimeout(()=>{
            accordionContent.style.maxHeight = accordionContent.scrollHeight + "px";
        }, 100);
    }
    render() {
        const termsSection = /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                    className: "extend-student-insurance-teaser__content__section",
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $86b86a30bc1812cf$export$2e2bcd8739ae039), {
                        type: "checkbox",
                        id: "IsFullyAbleToWork" + this.props.formId,
                        name: "IsFullyAbleToWork" + this.props.formId,
                        smallLabel: true,
                        labelAsInline: true,
                        value: true,
                        validations: [
                            (0, $d5552fc3ceef5489$export$a7a0278c004aac3f)
                        ],
                        "data-validation-error-message": "Du m\xe5ste vara studief\xf6r",
                        displayname: "Jag intygar att jag \xe4r fullt studief\xf6r. Se definition i f\xf6rk\xf6psinformationen.",
                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $aa192976c67b1def$export$2e2bcd8739ae039), {
                            isFixed: true,
                            top: 5,
                            marginTop: 5,
                            fontSize: 14,
                            children: "F\xf6r att f\xf6rs\xe4kringen ska g\xe4lla s\xe5 m\xe5ste du vara fullt studief\xf6r vid anslutningen och 3 m\xe5nader innan. Det inneb\xe4r att du kan studera utan begr\xe4nsningar. Du \xe4r inte fullt studief\xf6r om du tar emot eller har r\xe4tt till ers\xe4ttning som har samband med egen sjukdom, olycksfall och/eller funktionsneds\xe4ttning eller om du har vilande s\xe5dan ers\xe4ttning."
                        })
                    })
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                    className: "extend-student-insurance-teaser__content__section",
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $86b86a30bc1812cf$export$2e2bcd8739ae039), {
                        type: "checkbox",
                        id: "PurchaseTermsApproved" + this.props.formId,
                        name: "PurchaseTermsApproved" + this.props.formId,
                        smallLabel: true,
                        value: true,
                        validations: [
                            (0, $d5552fc3ceef5489$export$a7a0278c004aac3f)
                        ],
                        "data-validation-error-message": "Du m\xe5ste godk\xe4nna villkoren",
                        displayname: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("span", {
                            children: [
                                "Jag bekr\xe4ftar att jag har tagit del av f\xf6rk\xf6psinformation och att f\xf6rs\xe4kringen som den beskrivs i ",
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("a", {
                                    href: this.props.termsAndConditionsUrl,
                                    children: "f\xf6rk\xf6psinformationen"
                                }),
                                " motsvarar mina krav och behov"
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                    className: "extend-student-insurance-teaser__content__section extend-student-insurance-teaser__content__section--actions",
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $b50965a6d450d3cc$export$2e2bcd8739ae039), {
                        noIcon: true,
                        children: "F\xf6rl\xe4ng nu"
                    })
                })
            ]
        });
        if (this.props.showHeader) return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $8c02aa23a40a9b45$export$2e2bcd8739ae039), {
            ref: (el)=>{
                this.form = el;
            },
            onSubmit: (ev)=>{
                ev.preventDefault();
                this.formSubmit();
            },
            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                ref: this.props.domRef,
                className: "extend-student-insurance-teaser__content__accordion",
                "data-lf-accordion-open": this.props.isOpen,
                children: [
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("a", {
                        "data-lf-accordion": true,
                        href: "#",
                        onClick: (e)=>{
                            e.preventDefault();
                            this.props.onFormHeaderClick();
                        },
                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("h4", {
                            children: this.props.header
                        })
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                        "data-lf-accordion-body": true,
                        ref: this.accordionContent,
                        children: [
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                className: "extend-student-insurance-teaser__content__section",
                                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("p", {
                                    children: this.props.body
                                })
                            }),
                            this.props.children,
                            termsSection
                        ]
                    })
                ]
            })
        });
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $8c02aa23a40a9b45$export$2e2bcd8739ae039), {
            ref: (el)=>{
                this.form = el;
            },
            onSubmit: (ev)=>{
                ev.preventDefault();
                this.formSubmit();
            },
            children: [
                this.props.children,
                termsSection
            ]
        });
    }
}
var // state
$8126d026e641c38b$export$2e2bcd8739ae039 = $8126d026e641c38b$var$BaseForm;


class $e9160a40e95ec3cd$var$BankingForm extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    render() {
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $8126d026e641c38b$export$2e2bcd8739ae039), {
            domRef: this.props.domRef,
            formId: "banking",
            showHeader: this.props.showHeader,
            header: "Byt betals\xe4tt till autogiro",
            body: "Det konto som anges m\xe5ste vara ditt eget.",
            onSubmit: this.props.onSubmit,
            onFormHeaderClick: (e)=>this.props.onFormHeaderClick(),
            termsAndConditionsUrl: this.props.termsAndConditionsUrl,
            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                className: "extend-student-insurance-teaser__content__section extend-student-insurance-teaser__content__section--columns",
                children: [
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                        className: "extend-student-insurance-teaser__content__section__column",
                        children: [
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $505e6dfcdb88d92d$export$ff2cc7cd7ab415a4), {
                                children: "Clearingnummer"
                            }),
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $fdc1d0f3f8a87be4$export$2e2bcd8739ae039), {
                                id: "bankcode",
                                name: "bankcode",
                                placeholder: "Ange clearingnummer",
                                "data-validation-error-message": "Ange clearingnummer",
                                validations: [
                                    (0, $d5552fc3ceef5489$export$c8c2927bd53a1468)(4, 5)
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                        className: "extend-student-insurance-teaser__content__section__column",
                        children: [
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $505e6dfcdb88d92d$export$ff2cc7cd7ab415a4), {
                                children: "Kontonummer"
                            }),
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $fdc1d0f3f8a87be4$export$2e2bcd8739ae039), {
                                id: "accountnumber",
                                name: "accountnumber",
                                placeholder: "Ange kontonummer",
                                "data-validation-error-message": "Ange kontonummer",
                                validations: [
                                    (0, $d5552fc3ceef5489$export$c8c2927bd53a1468)(6, 12)
                                ]
                            })
                        ]
                    })
                ]
            })
        });
    }
}
var // state
$e9160a40e95ec3cd$export$2e2bcd8739ae039 = $e9160a40e95ec3cd$var$BankingForm;




var $8NFma = parcelRequire("8NFma");

class $6586d9ddba878ee5$var$InvoiceForm extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    render() {
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $8126d026e641c38b$export$2e2bcd8739ae039), {
            domRef: this.props.domRef,
            formId: "invoice",
            isOpen: true,
            showHeader: this.props.showHeader,
            header: "F\xf6rl\xe4ng Studentf\xf6rs\xe4kring Leva",
            body: 'Det enda du beh\xf6ver g\xf6ra f\xf6r att beh\xe5lla Studentf\xf6rs\xe4kring Leva \xe4r att klicka p\xe5 "F\xf6rl\xe4ng nu" s\xe5 kommer ett inbetalningskort med posten. Tryggt och enkelt.',
            onSubmit: this.props.onSubmit,
            onFormHeaderClick: (e)=>this.props.onFormHeaderClick(),
            termsAndConditionsUrl: this.props.termsAndConditionsUrl
        });
    }
}
var // state
$6586d9ddba878ee5$export$2e2bcd8739ae039 = $6586d9ddba878ee5$var$InvoiceForm;



const $199d50ff90edc78d$var$INVOICE_FORM = 0;
const $199d50ff90edc78d$var$BANKING_FORM = 1;
class $199d50ff90edc78d$var$ExtendStudentInsuranceTeaser extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    static get propTypes() {
        return {
            mountRootId: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string.isRequired
        };
    }
    constructor(props){
        super(props);
        this.heading = (0, $e6aeb63e6149c504$export$161fa9a9af21e7de)('heading', this.props.mountRootId) || '';
        this.preamble = (0, $e6aeb63e6149c504$export$161fa9a9af21e7de)('preamble', this.props.mountRootId) || '';
        this.image = (0, $e6aeb63e6149c504$export$161fa9a9af21e7de)('image', this.props.mountRootId) || false;
        this.customerServiceUrl = (0, $e6aeb63e6149c504$export$161fa9a9af21e7de)('customer-service-url', this.props.mountRootId) || false;
        this.myInsurancesUrl = (0, $e6aeb63e6149c504$export$161fa9a9af21e7de)('my-insurances-url', this.props.mountRootId) || false;
        this.termsAndConditionsUrl = (0, $e6aeb63e6149c504$export$161fa9a9af21e7de)('product-page-url', this.props.mountRootId) || false;
        this.insuranceName = (0, $e6aeb63e6149c504$export$161fa9a9af21e7de)('insurance-name', this.props.mountRootId) || false;
        this.invoiceForm = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createRef();
        this.bankingForm = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createRef();
    }
    componentDidMount() {
        this.props.loadData();
    }
    stripFormNamesFromSharedVars(formValues) {
        const sharedVars = [
            "IsFullyAbleToWork",
            "PurchaseTermsApproved"
        ];
        let newObject = {};
        let keysToRemove = [];
        Object.keys(formValues).forEach((key)=>{
            sharedVars.forEach((sharedVar)=>{
                if (key.indexOf(sharedVar) == 0) {
                    newObject[sharedVar] = formValues[key];
                    keysToRemove.push(key);
                }
            });
        });
        Object.keys(newObject).forEach((key)=>{
            formValues[key] = newObject[key];
        });
        keysToRemove.forEach((key)=>{
            delete formValues[key];
        });
        return formValues;
    }
    formSubmit(formId, formValues) {
        formValues = this.stripFormNamesFromSharedVars(formValues);
        formValues.insurancename = this.insuranceName;
        switch(formId){
            case $199d50ff90edc78d$var$BANKING_FORM:
                this.props.submitStudentInsuranceForm(formValues, true);
                break;
            case $199d50ff90edc78d$var$INVOICE_FORM:
                this.props.submitStudentInsuranceForm(formValues, false);
                break;
        }
    }
    isFormOpen(element) {
        return element.getAttribute('data-lf-accordion-open');
    }
    formHeaderClick(clickedForm) {
        const paymentMethodIsAutomatic = this.props.data.paymentMethod == 'Autogiro';
        if (paymentMethodIsAutomatic) return;
        setTimeout(()=>{
            if (clickedForm.getAttribute('data-lf-accordion-open')) {
                const fakeClick = new MouseEvent('click', {
                    view: window,
                    bubbles: true,
                    cancelable: true
                });
                if (clickedForm == this.invoiceForm.current && this.isFormOpen(this.bankingForm.current)) this.bankingForm.current.querySelector('a[data-lf-accordion]').dispatchEvent(fakeClick);
                else if (clickedForm == this.bankingForm.current && this.isFormOpen(this.invoiceForm.current)) {
                    // haxx time: when automatically closing this form, the window scrolls away too much which we do not want
                    const heightOffset = this.bankingForm.current.offsetTop;
                    try {
                        window.scrollTo({
                            left: 0,
                            top: heightOffset,
                            behavior: "smooth"
                        });
                    } catch (e) {
                        window.scrollTo(0, heightOffset);
                    }
                    this.invoiceForm.current.querySelector('a[data-lf-accordion]').dispatchEvent(fakeClick);
                }
            }
        }, 100);
    }
    render() {
        const formSubmitFailed = this.props.data.formSubmitFailed;
        const formSubmitSuccess = this.props.data.formSubmitted;
        const automaticForm = this.props.data.automaticForm;
        const paymentMethodIsAutomatic = this.props.data.paymentMethod == 'Autogiro';
        let content = /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
            children: [
                !paymentMethodIsAutomatic && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                    className: "extend-student-insurance-teaser__content__spacer"
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $6586d9ddba878ee5$export$2e2bcd8739ae039), {
                    domRef: this.invoiceForm,
                    showHeader: !paymentMethodIsAutomatic,
                    onFormHeaderClick: (e)=>{
                        this.formHeaderClick(this.invoiceForm.current);
                    },
                    termsAndConditionsUrl: this.termsAndConditionsUrl,
                    onSubmit: (formValues)=>{
                        this.formSubmit($199d50ff90edc78d$var$INVOICE_FORM, formValues);
                    }
                })
            ]
        });
        if (this.props.isLoading) content = /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $492d68823d70b95b$export$2e2bcd8739ae039), {
            color: (0, $0a574bc6d89559c7$export$2e2bcd8739ae039).colors.blueBackground
        });
        if (this.props.hasErrored) content = /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $19ac445fff8f1f3a$export$2e2bcd8739ae039), {
            message: `Ooops! Ett fel har uppst\xe5tt: ${typeof this.props.error === 'string' ? this.props.error : this.props.error.message}`
        });
        if (formSubmitFailed) content = /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $9ce43aec95b4f532$export$2e2bcd8739ae039), {
            type: (0, $9ce43aec95b4f532$export$f232ef6075ada121),
            description: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("p", {
                children: [
                    "N\xe5got gick fel och din f\xf6rl\xe4ngning har inte genomf\xf6rts. Om problemet kvartst\xe5r kan du ",
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("a", {
                        href: this.customerServiceUrl,
                        children: "kontakta kundtj\xe4nst"
                    }),
                    "."
                ]
            }),
            onRetryClick: ()=>{
                this.props.resetFormSubmitFailure();
            }
        });
        if (formSubmitSuccess) content = /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $9ce43aec95b4f532$export$2e2bcd8739ae039), {
            type: (0, $9ce43aec95b4f532$export$8cb9fe3f31391d38),
            description: automaticForm == true || paymentMethodIsAutomatic ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("p", {
                children: [
                    "Tack! Din f\xf6rl\xe4ngning har mottagits. Du ser dina f\xf6rs\xe4kringar p\xe5 ",
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("a", {
                        href: this.myInsurancesUrl,
                        children: "Mina f\xf6rs\xe4kringar"
                    }),
                    "."
                ]
            }) : /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $13f4c0370d7de649$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("p", {
                        className: "extend-student-insurance-notice__first-paragraph",
                        children: "Tack! Din f\xf6rl\xe4ngning har mottagits. Du kommer f\xe5 ett inbetalningskort med posten. Om du vill slippa pappersfakturor kan du ist\xe4llet v\xe4lja autogiro."
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("a", {
                        href: "https://www.mypayex.com/application/direct-debit-sign-up-se/24416/register",
                        target: "_blank",
                        className: "button button--green button--external-link",
                        children: [
                            "Betala med autogiro",
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                className: "extend-student-insurance-notice__link-icon",
                                dangerouslySetInnerHTML: {
                                    __html: (0, (/*@__PURE__*/$parcel$interopDefault($ac8bf4b7d201ab28$exports)))('external-link').outerHTML
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("p", {
                        className: "extend-student-insurance-notice__last-paragraph",
                        children: [
                            "Du ser dina f\xf6rs\xe4kringar p\xe5 ",
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("a", {
                                href: this.myInsurancesUrl,
                                children: "Mina f\xf6rs\xe4kringar"
                            }),
                            "."
                        ]
                    })
                ]
            })
        });
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
            className: "extend-student-insurance-teaser",
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                    className: "extend-student-insurance-teaser__header",
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                            className: "extend-student-insurance-teaser__header__content",
                            children: [
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("h3", {
                                    className: "extend-student-insurance-teaser__header__content__title",
                                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $96c25128201e5f07$export$2e2bcd8739ae039), {
                                        children: this.heading
                                    })
                                }),
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                    className: "extend-student-insurance-teaser__header__content__description",
                                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $96c25128201e5f07$export$2e2bcd8739ae039), {
                                        children: this.preamble
                                    })
                                })
                            ]
                        }),
                        this.image && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                            className: "extend-student-insurance-teaser__header__image",
                            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("img", {
                                className: "extend-student-insurance-teaser__header__image__img",
                                src: this.image
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                    className: "extend-student-insurance-teaser__content",
                    children: content
                })
            ]
        });
    }
}
// state
const $199d50ff90edc78d$var$mapStateToProps = (state)=>{
    return {
        data: state.extendStudentInsuranceTeaserData,
        hasErrored: state.pageHasErrored,
        error: state.pageError,
        isLoading: state.pageIsLoading
    };
};
const $199d50ff90edc78d$var$mapDispatchToProps = (dispatch)=>{
    return {
        loadData: ()=>dispatch((0, $14139987caa9620c$export$b1e157761d7a0e55)()),
        resetFormSubmitFailure: ()=>dispatch((0, $14139987caa9620c$export$9a10e96f62ca4785)(false)),
        submitStudentInsuranceForm: (data)=>dispatch((0, $14139987caa9620c$export$217fa9d59d3bf39b)(data))
    };
};
var $199d50ff90edc78d$export$2e2bcd8739ae039 = (0, $5a4066412ccab0c1$export$64605811ab45167f)($199d50ff90edc78d$var$mapStateToProps, $199d50ff90edc78d$var$mapDispatchToProps)($199d50ff90edc78d$var$ExtendStudentInsuranceTeaser);



parcelRequire("8NFma");


var $8NFma = parcelRequire("8NFma");




const $469b149fba9d1a07$export$97a140343a8e4907 = (data)=>{
    return {
        type: 'FETCH_POSSESSIONS_STARTED',
        data: data
    };
};
const $469b149fba9d1a07$export$a1edd7175901928e = (data)=>{
    return {
        type: 'FETCH_POSSESSIONS_COMPLETE',
        data: data
    };
};
const $469b149fba9d1a07$export$d68f5ae971a565c4 = (data)=>{
    return {
        type: 'FETCH_METADATA',
        data: data
    };
};
const $469b149fba9d1a07$export$93d5f8b3ca44987c = ()=>{
    const lfDataService = new (0, $25937fdb26d57abd$export$2e2bcd8739ae039)();
    return (dispatch)=>{
        let possessions;
        dispatch($469b149fba9d1a07$export$97a140343a8e4907());
        lfDataService.getPossessionsData().then((data)=>{
            possessions = data;
            dispatch($469b149fba9d1a07$export$a1edd7175901928e(possessions));
        }).catch((e)=>{
            dispatch((0, $67f4b1d2fb7c2244$export$7a8bb273722d5103)(e));
            dispatch((0, $67f4b1d2fb7c2244$export$ea4b4733f4ca2df0)(true));
        });
    };
};
const $469b149fba9d1a07$export$ea1c1228362632d = ()=>{
    const lfWebService = new (0, $0f2b98672976a17a$export$2e2bcd8739ae039)();
    return (dispatch)=>{
        let meta;
        lfWebService.possessionsMetaData().then((data)=>{
            meta = data;
            dispatch($469b149fba9d1a07$export$d68f5ae971a565c4(meta));
        }).catch((e)=>{
            dispatch((0, $67f4b1d2fb7c2244$export$7a8bb273722d5103)(e));
            dispatch((0, $67f4b1d2fb7c2244$export$ea4b4733f4ca2df0)(true));
        });
    };
};


const $5e562208d71718d1$var$PossessionsData = ({ children: children, ...props })=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useEffect(()=>{
        props.loadPossessions();
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useEffect(()=>{
        props.loadMetaData();
    }, []);
    let possessions = props.possessionsData.possessions;
    let metaData = props.metaData;
    let monthlyPremium = props.possessionsData.monthlyPremium;
    let combined = [];
    let future = [];
    let current = [];
    const today = new Date();
    let currentDate = '';
    if (today !== null) currentDate = today.getFullYear() + '-' + ("0" + (today.getMonth() + 1)).slice(-2) + '-' + ("0" + today.getDate()).slice(-2);
    if (possessions && possessions.length > 0) {
        combined = possessions.map((item)=>({
                ...item,
                metaData: metaData.meta.filter((f)=>f.groupName === item.productGroupName)
            }));
        //maps through the combined array to separate current from future possessions
        combined.length > 0 && combined.map((item)=>{
            if (item.fromDate <= currentDate) current.push(item);
            if (item.fromDate > currentDate) future.push(item);
        });
    }
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Fragment, {
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).cloneElement(children, {
            combined: combined,
            monthlyPremium: monthlyPremium,
            future: future,
            current: current
        })
    });
};
const $5e562208d71718d1$var$mapStateToProps = (state)=>{
    return {
        possessionsData: state.possessionsData,
        metaData: state.metaData
    };
};
const $5e562208d71718d1$var$mapDispatchToProps = (dispatch)=>{
    return {
        loadPossessions: (possessionsData)=>dispatch((0, $469b149fba9d1a07$export$93d5f8b3ca44987c)(possessionsData)),
        loadMetaData: (metaData)=>dispatch((0, $469b149fba9d1a07$export$ea1c1228362632d)(metaData))
    };
};
var $5e562208d71718d1$export$2e2bcd8739ae039 = (0, $5a4066412ccab0c1$export$64605811ab45167f)($5e562208d71718d1$var$mapStateToProps, $5e562208d71718d1$var$mapDispatchToProps)($5e562208d71718d1$var$PossessionsData);




var $8NFma = parcelRequire("8NFma");



var $8NFma = parcelRequire("8NFma");


var $8NFma = parcelRequire("8NFma");





var $8NFma = parcelRequire("8NFma");





var $8NFma = parcelRequire("8NFma");


var $8NFma = parcelRequire("8NFma");


parcelRequire("8NFma");



const $44fb2dff744e4c44$var$PossessionsTableContent = ({ description: description, title: title, index: index, expanded: expanded, setExpanded: setExpanded })=>{
    const isOpen = index === expanded;
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
        className: "possessions__table__body",
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $bb8231acd22e51c2$export$e25e478948902b8b).div, {
            className: "possessions__table__body__row",
            onClick: ()=>setExpanded(isOpen ? false : index),
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("p", {
                    className: "possessions__table__body__heading",
                    children: [
                        title,
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                            dangerouslySetInnerHTML: {
                                __html: (0, (/*@__PURE__*/$parcel$interopDefault($ac8bf4b7d201ab28$exports)))('chev-down').outerHTML
                            },
                            className: "possessions__table__body__heading__icon"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $9b0ae67beb2269f5$export$3ae376d12526dd6f), {
                    initial: false,
                    children: isOpen && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $bb8231acd22e51c2$export$e25e478948902b8b).div, {
                        className: "possessions__table__body__foldout",
                        initial: "collapsed",
                        animate: "open",
                        exit: "collapsed",
                        variants: {
                            open: {
                                opacity: 1,
                                height: "auto"
                            },
                            collapsed: {
                                opacity: 0,
                                height: 0
                            }
                        },
                        transition: {
                            duration: 0.4
                        },
                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $96c25128201e5f07$export$2e2bcd8739ae039), {
                            children: description
                        })
                    }, "content")
                })
            ]
        })
    }, index);
};
var $44fb2dff744e4c44$export$2e2bcd8739ae039 = $44fb2dff744e4c44$var$PossessionsTableContent;



parcelRequire("8NFma");




const $e436036827aff547$var$PossessionsTableContentChart = ({ selectedRowIndex: selectedRowIndex, levels: levels, description: description, title: title, expanded: expanded, setExpanded: setExpanded, index: index })=>{
    const isOpen = index === expanded;
    const specs = (level, i)=>{
        const selected = i === selectedRowIndex;
        const included = level.included === true;
        const text = level.text;
        if (included && text) return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("td", {
            className: `possessions__table__body__icon possessions__table__body__icon--text ${selected ? "selected" : ""}`,
            children: text
        }, (0, $27d7069422be255c$export$2e2bcd8739ae039)());
        else if (included) return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("td", {
            className: `possessions__table__body__icon possessions__table__body__icon--included ${selected ? "selected" : ""}`,
            dangerouslySetInnerHTML: {
                __html: (0, (/*@__PURE__*/$parcel$interopDefault($ac8bf4b7d201ab28$exports)))('check').outerHTML
            }
        }, (0, $27d7069422be255c$export$2e2bcd8739ae039)());
        else return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("td", {
            className: `possessions__table__body__icon possessions__table__body__icon--omitted ${selected ? "selected" : ""}`,
            dangerouslySetInnerHTML: {
                __html: (0, (/*@__PURE__*/$parcel$interopDefault($ac8bf4b7d201ab28$exports)))('close').outerHTML
            }
        }, (0, $27d7069422be255c$export$2e2bcd8739ae039)());
    };
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("tbody", {
        className: "possessions__table__body",
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $bb8231acd22e51c2$export$e25e478948902b8b).tr, {
            className: "",
            onClick: ()=>setExpanded(isOpen ? false : index),
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("th", {
                    className: "possessions__table__body__heading",
                    children: [
                        title,
                        description !== null && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                            dangerouslySetInnerHTML: {
                                __html: (0, (/*@__PURE__*/$parcel$interopDefault($ac8bf4b7d201ab28$exports)))('chev-down').outerHTML
                            },
                            className: "possessions__table__body__heading__icon"
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $9b0ae67beb2269f5$export$3ae376d12526dd6f), {
                            initial: false,
                            children: isOpen && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $bb8231acd22e51c2$export$e25e478948902b8b).div, {
                                className: "possessions__table__body__foldout",
                                initial: "collapsed",
                                animate: "open",
                                exit: "collapsed",
                                variants: {
                                    open: {
                                        opacity: 1,
                                        height: "auto"
                                    },
                                    collapsed: {
                                        opacity: 0,
                                        height: 0
                                    }
                                },
                                transition: {
                                    duration: 0.4
                                },
                                children: description !== null && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $96c25128201e5f07$export$2e2bcd8739ae039), {
                                    children: description
                                })
                            }, "content")
                        })
                    ]
                }),
                levels.map((level, i)=>specs(level, i))
            ]
        })
    }, selectedRowIndex);
};
var $e436036827aff547$export$2e2bcd8739ae039 = $e436036827aff547$var$PossessionsTableContentChart;



parcelRequire("8NFma");
const $c0da39b532f48c00$var$PossessionsTableHeader = ({ content: content, selected: selected, heading: heading })=>{
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("thead", {
        className: "possessions__table__header",
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("tr", {
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("th", {
                    className: "possessions__table__header__heading",
                    children: heading
                }),
                content.levels.map((level)=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("th", {
                        className: `possessions__table__header__level ${selected === level.label ? "selected" : ""}`,
                        children: [
                            selected === level.label && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                children: "Vald"
                            }),
                            level.label
                        ]
                    }, level.label))
            ]
        })
    });
};
var $c0da39b532f48c00$export$2e2bcd8739ae039 = $c0da39b532f48c00$var$PossessionsTableHeader;


const $90414eda8f318aa3$var$PossessionsTable = ({ content: content, selected: selected, heading: heading, selectedRowIndex: selectedRowIndex, expanded: expanded, setExpanded: setExpanded })=>{
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("table", {
        className: "possessions__table",
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $c0da39b532f48c00$export$2e2bcd8739ae039), {
                content: content,
                selected: selected,
                heading: heading
            }),
            content.insuranceCoverage.map(({ title: title, description: description, levels: levels }, index)=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Fragment, {
                    children: [
                        levels.length > 0 && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $e436036827aff547$export$2e2bcd8739ae039), {
                            selectedRowIndex: selectedRowIndex,
                            content: content,
                            levels: levels,
                            description: description,
                            title: title,
                            index: index,
                            expanded: expanded,
                            setExpanded: setExpanded
                        }),
                        levels.length <= 0 && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $44fb2dff744e4c44$export$2e2bcd8739ae039), {
                            content: content,
                            description: description,
                            title: title,
                            index: index,
                            expanded: expanded,
                            setExpanded: setExpanded
                        })
                    ]
                }, (0, $27d7069422be255c$export$2e2bcd8739ae039)()))
        ]
    });
};
var $90414eda8f318aa3$export$2e2bcd8739ae039 = $90414eda8f318aa3$var$PossessionsTable;




var $8NFma = parcelRequire("8NFma");


var $8NFma = parcelRequire("8NFma");

const $279ef0f8496a98da$var$PossessionsTableHeaderMobile = ({ parent: parent, content: content, selected: selected, heading: heading })=>{
    const [sticky, setSticky] = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useState("");
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useRef();
    let stickyClass = "";
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useEffect(()=>{
        window.addEventListener("scroll", (0, $a6b818f50380bcca$export$2e2bcd8739ae039)(handleScroll), 400);
        return ()=>{
            window.removeEventListener("scroll", (0, $a6b818f50380bcca$export$2e2bcd8739ae039)(handleScroll));
        };
    }, []);
    const handleScroll = ()=>{
        if (parent && parent.current) {
            const windowTop = window.scrollY;
            const elemTop = parent.current.getBoundingClientRect().top;
            const elemBottom = parent.current.getBoundingClientRect().bottom;
            const stickyHeight = ref.current.scrollHeight;
            let stickPosition = elemTop + windowTop;
            let unstickPosition = elemBottom + windowTop - stickyHeight;
            if (windowTop > stickPosition && windowTop < unstickPosition) {
                stickyClass = "sticky";
                setSticky(stickyClass);
            }
            if (windowTop >= unstickPosition || windowTop <= stickPosition) {
                stickyClass = "";
                setSticky(stickyClass);
            }
        }
    };
    const classes = `possessions__table__mobile__header__levels ${sticky}`;
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
        className: "possessions__table__mobile__header",
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("h4", {
                className: "possessions__table__mobile__header__heading",
                children: heading
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                className: classes,
                ref: ref,
                children: content.levels.map((level)=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                        className: `possessions__table__mobile__header__level ${selected === level.label ? "selected" : ""}`,
                        children: [
                            selected === level.label && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                children: "Vald"
                            }),
                            level.label
                        ]
                    }, level.label))
            })
        ]
    });
};
var $279ef0f8496a98da$export$2e2bcd8739ae039 = $279ef0f8496a98da$var$PossessionsTableHeaderMobile;



parcelRequire("8NFma");



const $bf896e727a128822$var$PossessionsTableContentMobile = ({ description: description, title: title, index: index, isExpanded: isExpanded, setIsExpanded: setIsExpanded })=>{
    const isOpen = index === isExpanded;
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
        className: "possessions__table__body",
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $bb8231acd22e51c2$export$e25e478948902b8b).div, {
            className: "possessions__table__body__row",
            onClick: ()=>setIsExpanded(isOpen ? false : index),
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("p", {
                    className: "possessions__table__body__heading",
                    children: [
                        title,
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                            dangerouslySetInnerHTML: {
                                __html: (0, (/*@__PURE__*/$parcel$interopDefault($ac8bf4b7d201ab28$exports)))('chev-down').outerHTML
                            },
                            className: "possessions__table__body__heading__icon"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $9b0ae67beb2269f5$export$3ae376d12526dd6f), {
                    initial: false,
                    children: isOpen && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $bb8231acd22e51c2$export$e25e478948902b8b).div, {
                        className: "possessions__table__body__foldout",
                        initial: "collapsed",
                        animate: "open",
                        exit: "collapsed",
                        variants: {
                            open: {
                                opacity: 1,
                                height: "auto"
                            },
                            collapsed: {
                                opacity: 0,
                                height: 0
                            }
                        },
                        transition: {
                            duration: 0.4
                        },
                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $96c25128201e5f07$export$2e2bcd8739ae039), {
                            children: description
                        })
                    }, "content")
                })
            ]
        })
    });
};
var $bf896e727a128822$export$2e2bcd8739ae039 = $bf896e727a128822$var$PossessionsTableContentMobile;



parcelRequire("8NFma");




const $ea78fa17cd18c146$var$PossessionsTableContentChartMobile = ({ levels: levels, description: description, title: title, isExpanded: isExpanded, setIsExpanded: setIsExpanded, index: index })=>{
    const isOpen = index === isExpanded;
    const specs = (level)=>{
        const included = level.included === true;
        const text = level.text;
        if (included && text) return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
            className: "possessions__table__mobile__body__icon possessions__table__mobile__body__icon--text",
            children: text
        }, (0, $27d7069422be255c$export$2e2bcd8739ae039)());
        else if (included) return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
            className: "possessions__table__mobile__body__icon possessions__table__mobile__body__icon--included",
            dangerouslySetInnerHTML: {
                __html: (0, (/*@__PURE__*/$parcel$interopDefault($ac8bf4b7d201ab28$exports)))('check').outerHTML
            }
        }, (0, $27d7069422be255c$export$2e2bcd8739ae039)());
        else return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
            className: "possessions__table__mobile__body__icon possessions__table__mobile__body__icon--omitted",
            dangerouslySetInnerHTML: {
                __html: (0, (/*@__PURE__*/$parcel$interopDefault($ac8bf4b7d201ab28$exports)))('close').outerHTML
            }
        }, (0, $27d7069422be255c$export$2e2bcd8739ae039)());
    };
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
        className: `possessions__table__mobile__body ${isOpen ? "possessions__table__mobile__body--open" : ""}`,
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $bb8231acd22e51c2$export$e25e478948902b8b).div, {
                className: "possessions__table__mobile__body__heading",
                onClick: ()=>setIsExpanded(isOpen ? false : index),
                children: [
                    title,
                    description !== null && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                        dangerouslySetInnerHTML: {
                            __html: (0, (/*@__PURE__*/$parcel$interopDefault($ac8bf4b7d201ab28$exports)))('chev-down').outerHTML
                        },
                        className: "possessions__table__mobile__body__heading__icon"
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $9b0ae67beb2269f5$export$3ae376d12526dd6f), {
                        initial: false,
                        children: description && description.length > 0 && isOpen && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $bb8231acd22e51c2$export$e25e478948902b8b).div, {
                            className: "possessions__table__mobile__body__foldout",
                            initial: "collapsed",
                            animate: "open",
                            exit: "collapsed",
                            variants: {
                                open: {
                                    opacity: 1,
                                    height: "auto"
                                },
                                collapsed: {
                                    opacity: 0,
                                    height: 0
                                }
                            },
                            transition: {
                                duration: 0.4,
                                ease: [
                                    0.04,
                                    0.62,
                                    0.23,
                                    0.98
                                ]
                            },
                            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $96c25128201e5f07$export$2e2bcd8739ae039), {
                                children: description
                            })
                        }, "content")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                className: "possessions__table__mobile__body__levels",
                children: levels.map((level, i)=>specs(level, i))
            })
        ]
    });
};
var $ea78fa17cd18c146$export$2e2bcd8739ae039 = $ea78fa17cd18c146$var$PossessionsTableContentChartMobile;


const $a8d666651fe5acaf$var$PossessionsTableMobile = ({ content: content, selected: selected, heading: heading, isExpanded: isExpanded, setIsExpanded: setIsExpanded })=>{
    const parent = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useRef();
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
        className: "possessions__table__mobile",
        ref: parent,
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $279ef0f8496a98da$export$2e2bcd8739ae039), {
                parent: parent,
                content: content,
                selected: selected,
                heading: heading
            }),
            content.insuranceCoverage.map(({ title: title, description: description, levels: levels }, index)=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Fragment, {
                    children: [
                        levels.length > 0 && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $ea78fa17cd18c146$export$2e2bcd8739ae039), {
                            levels: levels,
                            description: description,
                            title: title,
                            index: index,
                            isExpanded: isExpanded,
                            setIsExpanded: setIsExpanded
                        }),
                        levels.length <= 0 && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $bf896e727a128822$export$2e2bcd8739ae039), {
                            content: content,
                            levels: levels,
                            description: description,
                            title: title,
                            index: index,
                            isExpanded: isExpanded,
                            setIsExpanded: setIsExpanded
                        })
                    ]
                }))
        ]
    });
};
var $a8d666651fe5acaf$export$2e2bcd8739ae039 = $a8d666651fe5acaf$var$PossessionsTableMobile;


const $f875a91845764e6e$var$PossessionsTableBase = (props)=>{
    const [expanded, setExpanded] = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useState(false);
    const [isExpanded, setIsExpanded] = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useState(false);
    const [selected, setSelected] = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useState("");
    const [selectedRowIndex, setSelectedRowIndex] = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useState(null);
    const insuranceName = props.insuranceName;
    const content = props.content;
    const heading = content.heading;
    const mobile = props.mobile;
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useEffect(()=>{
        content.levels.map((level, index)=>{
            if (level.insuranceNames.find((name)=>name === insuranceName)) {
                setSelected(level.label);
                setSelectedRowIndex(index);
            }
        });
    }, []);
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Fragment, {
        children: [
            mobile === false && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $90414eda8f318aa3$export$2e2bcd8739ae039), {
                content: content,
                selected: selected,
                heading: heading,
                selectedRowIndex: selectedRowIndex,
                expanded: expanded,
                setExpanded: setExpanded
            }),
            mobile === true && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $a8d666651fe5acaf$export$2e2bcd8739ae039), {
                content: content,
                selected: selected,
                heading: heading,
                isExpanded: isExpanded,
                setIsExpanded: setIsExpanded
            })
        ]
    });
};
var $f875a91845764e6e$export$2e2bcd8739ae039 = $f875a91845764e6e$var$PossessionsTableBase;


const $72169ee7b15c742f$var$PossessionsTabs = (props)=>{
    const [mobile, setMobile] = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useEffect(()=>{
        if (window.innerWidth < 550) setMobile(!mobile);
    }, []);
    const handleDataEvent = (tab)=>{
        dataLayer.push({
            'insurance_name': `${props.insuranceName}`,
            'event': `${tab} selected`
        });
    };
    // determine what tabs to show and which one should be checked as default
    const tabs = ()=>{
        if (tabData.insuranceCoverageInfo !== null && tabData.damageClaimInfo !== null && tabData.terminateInsuranceInfo !== null) return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Fragment, {
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("input", {
                    type: "radio",
                    id: "tab-1",
                    name: "tab-effect-1",
                    defaultChecked: "checked",
                    onChange: ()=>handleDataEvent("Om f\xf6rs\xe4kringen")
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("label", {
                    htmlFor: "tab-1",
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                            className: "possessions-icon",
                            dangerouslySetInnerHTML: {
                                __html: (0, (/*@__PURE__*/$parcel$interopDefault($ac8bf4b7d201ab28$exports)))('info-circle-line').outerHTML
                            }
                        }),
                        "Om f\xf6rs\xe4kringen"
                    ]
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("input", {
                    type: "radio",
                    id: "tab-2",
                    name: "tab-effect-1",
                    onChange: ()=>handleDataEvent("Anm\xe4l skada")
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("label", {
                    htmlFor: "tab-2",
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                            className: "possessions-icon",
                            dangerouslySetInnerHTML: {
                                __html: (0, (/*@__PURE__*/$parcel$interopDefault($ac8bf4b7d201ab28$exports)))('medical').outerHTML
                            }
                        }),
                        "Anm\xe4l skada"
                    ]
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("input", {
                    type: "radio",
                    id: "tab-3",
                    name: "tab-effect-1",
                    onChange: ()=>handleDataEvent("Avsluta f\xf6rs\xe4kring")
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("label", {
                    htmlFor: "tab-3",
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                            className: "possessions-icon",
                            dangerouslySetInnerHTML: {
                                __html: (0, (/*@__PURE__*/$parcel$interopDefault($ac8bf4b7d201ab28$exports)))('minus').outerHTML
                            }
                        }),
                        "Avsluta f\xf6rs\xe4kring"
                    ]
                })
            ]
        });
        else if (tabData.insuranceCoverageInfo === null && tabData.damageClaimInfo !== null && tabData.terminateInsuranceInfo !== null) return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Fragment, {
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("input", {
                    type: "radio",
                    id: "tab-2",
                    name: "tab-effect-1",
                    defaultChecked: "checked",
                    onChange: ()=>handleDataEvent("Anm\xe4l skada")
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("label", {
                    htmlFor: "tab-2",
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                            className: "possessions-icon",
                            dangerouslySetInnerHTML: {
                                __html: (0, (/*@__PURE__*/$parcel$interopDefault($ac8bf4b7d201ab28$exports)))('medical').outerHTML
                            }
                        }),
                        "Anm\xe4l skada"
                    ]
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("input", {
                    type: "radio",
                    id: "tab-3",
                    name: "tab-effect-1",
                    onChange: ()=>handleDataEvent('Avsluta skada')
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("label", {
                    htmlFor: "tab-3",
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                            className: "possessions-icon",
                            dangerouslySetInnerHTML: {
                                __html: (0, (/*@__PURE__*/$parcel$interopDefault($ac8bf4b7d201ab28$exports)))('minus').outerHTML
                            }
                        }),
                        "Avsluta f\xf6rs\xe4kring"
                    ]
                })
            ]
        });
        else if (tabData.insuranceCoverageInfo === null && tabData.damageClaimInfo === null && tabData.insuranceCoverageInfo !== null) return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Fragment, {
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("input", {
                    type: "radio",
                    id: "tab-3",
                    name: "tab-effect-1",
                    defaultChecked: "checked",
                    onChange: ()=>handleDataEvent('Avsluta skada')
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("label", {
                    htmlFor: "tab-3",
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                            className: "possessions-icon",
                            dangerouslySetInnerHTML: {
                                __html: (0, (/*@__PURE__*/$parcel$interopDefault($ac8bf4b7d201ab28$exports)))('minus').outerHTML
                            }
                        }),
                        "Avsluta f\xf6rs\xe4kring"
                    ]
                })
            ]
        });
        else if (tabData.insuranceCoverageInfo === null && tabData.damageClaimInfo !== null && tabData.terminateInsuranceInfo === null) return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Fragment, {
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("input", {
                    type: "radio",
                    id: "tab-2",
                    name: "tab-effect-1",
                    defaultChecked: "checked",
                    onChange: ()=>handleDataEvent("Anm\xe4l skada")
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("label", {
                    htmlFor: "tab-2",
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                            className: "possessions-icon",
                            dangerouslySetInnerHTML: {
                                __html: (0, (/*@__PURE__*/$parcel$interopDefault($ac8bf4b7d201ab28$exports)))('medical').outerHTML
                            }
                        }),
                        "Anm\xe4l skada"
                    ]
                })
            ]
        });
        else if (tabData.insuranceCoverageInfo !== null && tabData.damageClaimInfo !== null && tabData.terminateInsuranceInfo === null) return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Fragment, {
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("input", {
                    type: "radio",
                    id: "tab-1",
                    name: "tab-effect-1",
                    defaultChecked: "checked",
                    onChange: ()=>handleDataEvent("Om f\xf6rs\xe4kringen")
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("label", {
                    htmlFor: "tab-1",
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                            className: "possessions-icon",
                            dangerouslySetInnerHTML: {
                                __html: (0, (/*@__PURE__*/$parcel$interopDefault($ac8bf4b7d201ab28$exports)))('info-circle-line').outerHTML
                            }
                        }),
                        "Om f\xf6rs\xe4kringen"
                    ]
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("input", {
                    type: "radio",
                    id: "tab-2",
                    name: "tab-effect-1",
                    onChange: ()=>handleDataEvent("Anm\xe4l skada")
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("label", {
                    htmlFor: "tab-2",
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                            className: "possessions-icon",
                            dangerouslySetInnerHTML: {
                                __html: (0, (/*@__PURE__*/$parcel$interopDefault($ac8bf4b7d201ab28$exports)))('medical').outerHTML
                            }
                        }),
                        "Anm\xe4l skada"
                    ]
                })
            ]
        });
        else if (tabData.insuranceCoverageInfo !== null && tabData.damageClaimInfo === null && tabData.terminateInsuranceInfo !== null) return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Fragment, {
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("input", {
                    type: "radio",
                    id: "tab-1",
                    name: "tab-effect-1",
                    defaultChecked: "checked",
                    onChange: ()=>handleDataEvent("Om f\xf6rs\xe4kringen")
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("label", {
                    htmlFor: "tab-1",
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                            className: "possessions-icon",
                            dangerouslySetInnerHTML: {
                                __html: (0, (/*@__PURE__*/$parcel$interopDefault($ac8bf4b7d201ab28$exports)))('info-circle-line').outerHTML
                            }
                        }),
                        "Om f\xf6rs\xe4kringen"
                    ]
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("input", {
                    type: "radio",
                    id: "tab-3",
                    name: "tab-effect-1",
                    onChange: ()=>handleDataEvent("Avsluta f\xf6rs\xe4kringen")
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("label", {
                    htmlFor: "tab-3",
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                            className: "possessions-icon",
                            dangerouslySetInnerHTML: {
                                __html: (0, (/*@__PURE__*/$parcel$interopDefault($ac8bf4b7d201ab28$exports)))('minus').outerHTML
                            }
                        }),
                        "Avsluta f\xf6rs\xe4kring"
                    ]
                })
            ]
        });
        else if (tabData.insuranceCoverageInfo !== null && tabData.damageClaimInfo === null && tabData.terminateInsuranceInfo === null) return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Fragment, {
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("input", {
                    type: "radio",
                    id: "tab-1",
                    name: "tab-effect-1",
                    defaultChecked: "checked",
                    onChange: ()=>handleDataEvent("Om f\xf6rs\xe4kringen")
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("label", {
                    htmlFor: "tab-1",
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                            className: "possessions-icon",
                            dangerouslySetInnerHTML: {
                                __html: (0, (/*@__PURE__*/$parcel$interopDefault($ac8bf4b7d201ab28$exports)))('info-circle-line').outerHTML
                            }
                        }),
                        "Om f\xf6rs\xe4kringen"
                    ]
                })
            ]
        });
        else return;
    };
    const tabData = props.tabData;
    const insuranceName = props.insuranceName;
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
        className: "tabs-container",
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
            className: "tabs-container__tabs effect-1",
            children: [
                tabs(tabData),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                    className: "tabs-container__tab-content",
                    children: [
                        tabData.insuranceCoverageInfo !== null && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("section", {
                            id: "tab-item-1",
                            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $f875a91845764e6e$export$2e2bcd8739ae039), {
                                mobile: mobile,
                                insuranceName: insuranceName,
                                content: tabData.insuranceCoverageInfo
                            }, (0, $27d7069422be255c$export$2e2bcd8739ae039)())
                        }),
                        tabData.damageClaimInfo !== null && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("section", {
                            id: "tab-item-2",
                            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                className: "tab-item-2__content",
                                children: [
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("h3", {
                                        children: tabData.damageClaimInfo.heading
                                    }),
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $96c25128201e5f07$export$2e2bcd8739ae039), {
                                        className: "text",
                                        children: tabData.damageClaimInfo.description
                                    }),
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("a", {
                                        className: "phone",
                                        callto: tabData.damageClaimInfo.phone,
                                        children: [
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                className: "phone-icon",
                                                dangerouslySetInnerHTML: {
                                                    __html: (0, (/*@__PURE__*/$parcel$interopDefault($ac8bf4b7d201ab28$exports)))('phone').outerHTML
                                                }
                                            }),
                                            tabData.damageClaimInfo.phone
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("a", {
                                        className: "link arrow-link",
                                        href: tabData.damageClaimInfo.link.url,
                                        children: [
                                            tabData.damageClaimInfo.link.text,
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                dangerouslySetInnerHTML: {
                                                    __html: (0, (/*@__PURE__*/$parcel$interopDefault($ac8bf4b7d201ab28$exports)))('long-arrow-right').outerHTML
                                                }
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        tabData.terminateInsuranceInfo !== null && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("section", {
                            id: "tab-item-3",
                            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                className: "tab-item-3__content",
                                children: [
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("h3", {
                                        children: tabData.terminateInsuranceInfo.heading
                                    }),
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $96c25128201e5f07$export$2e2bcd8739ae039), {
                                        className: "text",
                                        children: tabData.terminateInsuranceInfo.description
                                    }),
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("a", {
                                        className: "phone",
                                        callto: tabData.terminateInsuranceInfo.phone,
                                        children: tabData.terminateInsuranceInfo.phone
                                    }),
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("a", {
                                        className: "link arrow-link",
                                        href: tabData.terminateInsuranceInfo.link.url,
                                        children: [
                                            tabData.terminateInsuranceInfo.link.text,
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                dangerouslySetInnerHTML: {
                                                    __html: (0, (/*@__PURE__*/$parcel$interopDefault($ac8bf4b7d201ab28$exports)))('long-arrow-right').outerHTML
                                                }
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $72169ee7b15c742f$export$2e2bcd8739ae039 = $72169ee7b15c742f$var$PossessionsTabs;


const $33a99b8054d67630$var$PossessionsAccordionItem = ({ id: id, combined: combined, expanded: expanded, setExpanded: setExpanded, ind: ind })=>{
    const [meta, setMeta] = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useState([]);
    const [clauses, setClauses] = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useState([]);
    const [noMeta, setNoMeta] = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useState(false);
    // check if meta is an empty or undefined array or in fact has some data, in order to render correct DOM. A bit of a hack to account for some dicey data.
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useEffect(()=>{
        if (combined.metaData) {
            if (combined.metaData.length > 0) {
                setMeta(combined.metaData[0]);
                setNoMeta(false);
            } else if (!combined.metaData.length || combined.metaData.contains(undefined)) setNoMeta(true);
        }
    }, [
        combined.metaData
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useEffect(()=>{
        if (combined.clauses !== null) setClauses(combined.clauses);
    }, [
        combined.clauses
    ]);
    const handleDataEvent = ()=>{
        dataLayer.push({
            'insurance_name': `${combined.productDisplayName}`,
            'event': 'possessions accordion opened'
        });
    };
    const isOpen = ind === expanded;
    const hasMetaData = meta.damageClaimInfo !== null || meta.insuranceCoverageInfo !== null || meta.terminateInsuranceInfo !== null;
    console.log("combined", combined);
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("li", {
        className: `possessions-accordion block-spacing ${isOpen ? "possessions-accordion--expanded" : ""}`,
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $bb8231acd22e51c2$export$e25e478948902b8b).header, {
                className: "possessions-accordion__header",
                onClick: ()=>setExpanded(isOpen ? false : ind),
                children: [
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                        className: "possessions-accordion__top-section",
                        children: [
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("h3", {
                                className: "possessions-accordion__top-section__title",
                                children: combined.productDisplayName
                            }),
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("p", {
                                className: "possessions-accordion__top-section__periodlabel",
                                children: [
                                    combined.premiumPeriodLabel,
                                    ":",
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("span", {
                                        className: `possessions-accordion__top-section__amount ${noMeta === false && hasMetaData ? "possessions-accordion__top-section__amount--divider" : ""}`,
                                        children: [
                                            combined.premium,
                                            " kr",
                                            (combined.ordinaryPremium !== null || combined.isOffer === true) && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                children: "*"
                                            })
                                        ]
                                    }),
                                    noMeta === false && hasMetaData ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                                        onClick: handleDataEvent,
                                        className: "possessions-accordion__top-section__icon",
                                        dangerouslySetInnerHTML: {
                                            __html: (0, (/*@__PURE__*/$parcel$interopDefault($ac8bf4b7d201ab28$exports)))('chev-down').outerHTML
                                        }
                                    }) : null
                                ]
                            })
                        ]
                    }),
                    combined.insuranceObjectDisplayName !== null && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("p", {
                        className: "possessions-accordion__policyholder",
                        "data-matomo-mask": true,
                        children: [
                            "F\xf6rs\xe4kringen g\xe4ller: ",
                            combined.insuranceObjectDisplayName
                        ]
                    }),
                    (combined.fromDate !== null || combined.toDate !== null || combined.ordinaryPremium !== null || combined.ordinaryPremiumFromDate !== null || combined.clauses !== null) && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                        className: "possessions-accordion__duration",
                        children: [
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                className: `possessions-accordion__duration__dates ${combined.clauses ? "possessions-accordion__duration__dates--divider" : ""}`,
                                children: [
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                        className: "possessions-accordion__duration__dates__container",
                                        children: [
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("p", {
                                                className: "possessions-accordion__duration__dates__container__from",
                                                children: [
                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                        className: "bold",
                                                        children: "G\xe4ller fr\xe5n:"
                                                    }),
                                                    " ",
                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                        children: combined.fromDate
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("p", {
                                                className: "possessions-accordion__duration__dates__container__to",
                                                children: [
                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                        className: "bold",
                                                        children: "G\xe4ller till:"
                                                    }),
                                                    " ",
                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                        children: combined.toDate
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    (combined.ordinaryPremium !== null || combined.ordinaryPremiumFromDate !== null) && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                        className: "possessions-accordion__duration__ordinary",
                                        children: [
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("p", {
                                                className: "possessions-accordion__duration__ordinary__text",
                                                children: [
                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                        className: "bold",
                                                        children: "Ordinarie pris:"
                                                    }),
                                                    " ",
                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("span", {
                                                        children: [
                                                            combined.ordinaryPremium,
                                                            " kr"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("p", {
                                                className: "possessions-accordion__duration__ordinary__from",
                                                children: [
                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                        className: "bold",
                                                        children: "Ordinarie pris g\xe4ller fr\xe5n:"
                                                    }),
                                                    " ",
                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                        children: combined.ordinaryPremiumFromDate
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            clauses && clauses.length > 0 && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("h3", {
                                className: "possessions-accordion__duration__clauses__title",
                                children: "Klausuler"
                            }),
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                className: "possessions-accordion__duration__clauses",
                                children: clauses && clauses.length > 0 && Object.keys(clauses).map((key, index)=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                        className: "possessions-accordion__duration__clauses",
                                        children: [
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("p", {
                                                className: "possessions-accordion__duration__clauses__date",
                                                children: [
                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                        children: "Fr\xe5n:"
                                                    }),
                                                    " ",
                                                    clauses[key].fromDate
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("p", {
                                                className: "possessions-accordion__duration__clauses__text",
                                                children: clauses[key].text
                                            })
                                        ]
                                    }, index))
                            })
                        ]
                    }),
                    (combined.ordinaryPremium !== null || combined.isOffer === true) && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("p", {
                        className: "possessions-accordion__campaign",
                        children: " *F\xf6rs\xe4kringen omfattas av ett erbjudande och du betalar inte ordinarie pris."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $9b0ae67beb2269f5$export$3ae376d12526dd6f), {
                initial: false,
                children: isOpen && hasMetaData && noMeta === false && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $bb8231acd22e51c2$export$e25e478948902b8b).section, {
                    initial: "collapsed",
                    animate: "open",
                    exit: "collapsed",
                    variants: {
                        open: {
                            opacity: 1,
                            height: "auto"
                        },
                        collapsed: {
                            opacity: 0,
                            height: 0
                        }
                    },
                    transition: {
                        duration: 0.8
                    },
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $72169ee7b15c742f$export$2e2bcd8739ae039), {
                            tabData: meta,
                            insuranceName: combined.productName
                        }, (0, $27d7069422be255c$export$2e2bcd8739ae039)()),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("a", {
                            className: "arrow-link",
                            href: meta.insurancePageLinkUrl,
                            children: [
                                "L\xe4s mer om f\xf6rs\xe4kringen och dess fullst\xe4ndiga villkor",
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                    dangerouslySetInnerHTML: {
                                        __html: (0, (/*@__PURE__*/$parcel$interopDefault($ac8bf4b7d201ab28$exports)))('long-arrow-right').outerHTML
                                    }
                                })
                            ]
                        })
                    ]
                }, "content")
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                children: [
                    combined.canAddCoInsured === true && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                        className: "possessions-accordion__info-container",
                        children: [
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                className: "possessions-accordion__info-container__icon-and-text",
                                children: [
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                        className: "possessions-accordion__info-container__icon-and-text__icon",
                                        dangerouslySetInnerHTML: {
                                            __html: (0, (/*@__PURE__*/$parcel$interopDefault($ac8bf4b7d201ab28$exports)))('info-circle').outerHTML
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("p", {
                                        className: "possessions-accordion__info-container__icon-and-text__text",
                                        children: "Du kan l\xe4gga till en medf\xf6rs\xe4krad"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("a", {
                                className: "possessions-accordion__info-container__button",
                                href: meta.purchaseCoInsuredLinkUrl,
                                id: "add-coinsured",
                                children: "L\xe4gg till medf\xf6rs\xe4krad"
                            })
                        ]
                    }),
                    combined.canUpgrade === true && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                        className: "possessions-accordion__info-container",
                        children: [
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                className: "possessions-accordion__info-container__icon-and-text",
                                children: [
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                        className: "possessions-accordion__info-container__icon-and-text__icon",
                                        dangerouslySetInnerHTML: {
                                            __html: (0, (/*@__PURE__*/$parcel$interopDefault($ac8bf4b7d201ab28$exports)))('info-circle').outerHTML
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("p", {
                                        className: "possessions-accordion__info-container__icon-and-text__text",
                                        children: "Du kan uppgradera din f\xf6rs\xe4kring"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("a", {
                                className: "possessions-accordion__info-container__button",
                                href: meta.upgradeLinkUrl,
                                children: combined.upgradeOfferText
                            })
                        ]
                    })
                ]
            })
        ]
    }, id);
};
var $33a99b8054d67630$export$2e2bcd8739ae039 = $33a99b8054d67630$var$PossessionsAccordionItem;


const $eb245c2e72dfea8c$var$PossessionsAccordion = (props)=>{
    const [expanded, setExpanded] = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useState(false);
    const combinedData = props.data;
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("ul", {
        children: combinedData && combinedData.length > 0 && combinedData.map((combined, ind)=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $33a99b8054d67630$export$2e2bcd8739ae039), {
                id: ind,
                combined: combined,
                ind: ind,
                expanded: expanded,
                setExpanded: setExpanded
            }, ind))
    });
};
var $eb245c2e72dfea8c$export$2e2bcd8739ae039 = $eb245c2e72dfea8c$var$PossessionsAccordion;



const $9656db057a1db5ff$var$PossessionsAccordionContainer = (props)=>{
    const current = props.current;
    const future = props.future;
    const combined = props.combined;
    const monthlyPremium = props.monthlyPremium;
    // Check to see when data has been fully loaded and when to render loader. If no insurances MonthlyPremium will be 0 and not undefined
    if (monthlyPremium === undefined) return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $492d68823d70b95b$export$2e2bcd8739ae039), {});
    return(//returns current possessions and/or future possessions in separate PossessionsAccordions
    //returns message if no current or future possessions
    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Fragment, {
        children: [
            current && current.length > 0 && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                className: "block-spacing",
                children: [
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("h2", {
                        className: "my-insurance__main-title",
                        children: "Mitt innehav"
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                        className: "my-insurance__hero",
                        children: [
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                className: "bold",
                                children: "Totalt m\xe5nadspris:"
                            }),
                            " ",
                            monthlyPremium,
                            " kr"
                        ]
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $eb245c2e72dfea8c$export$2e2bcd8739ae039), {
                        data: current
                    })
                ]
            }),
            future && future.length > 0 && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("h2", {
                        className: "possessions-accordion__future__title",
                        children: "H\xe4r visas framtida f\xf6rs\xe4kringar"
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("p", {
                        className: "possessions-accordion__future__paragraph",
                        children: "H\xe4r ser du dina framtida f\xf6rs\xe4kringar"
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $eb245c2e72dfea8c$export$2e2bcd8739ae039), {
                        data: future
                    })
                ]
            }),
            combined && combined.length === 0 && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                className: "my-insurance__hero__no-insurances",
                children: [
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                        dangerouslySetInnerHTML: {
                            __html: (0, (/*@__PURE__*/$parcel$interopDefault($ac8bf4b7d201ab28$exports)))('info-circle-line').outerHTML
                        }
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("p", {
                        className: "my-insurance__hero__no-insurances__text",
                        children: "Du har inga tecknade f\xf6rs\xe4kringar"
                    })
                ]
            })
        ]
    }));
};
var $9656db057a1db5ff$export$2e2bcd8739ae039 = $9656db057a1db5ff$var$PossessionsAccordionContainer;


const $4bda935fd8380b0f$var$SignedInPossessionsListing = ()=>{
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $5e562208d71718d1$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $9656db057a1db5ff$export$2e2bcd8739ae039), {})
    });
};
var $4bda935fd8380b0f$export$2e2bcd8739ae039 = $4bda935fd8380b0f$var$SignedInPossessionsListing;




var $8NFma = parcelRequire("8NFma");




const $8d67e10a1d98bf39$export$e9ff46170e09d731 = (data)=>{
    return {
        type: 'FETCH_PREREGISTRATIONSUMMARY_STARTED',
        data: data
    };
};
const $8d67e10a1d98bf39$export$b69b71abbe5f24d4 = (data)=>{
    return {
        type: 'FETCH_PREREGISTRATIONSUMMARY_COMPLETE',
        data: data
    };
};
const $8d67e10a1d98bf39$export$5ea69ce904b567f9 = ()=>{
    const lfDataService = new (0, $25937fdb26d57abd$export$2e2bcd8739ae039)();
    return (dispatch)=>{
        let summary;
        dispatch($8d67e10a1d98bf39$export$e9ff46170e09d731());
        lfDataService.getPreregistrationSummary().then((data)=>{
            summary = data;
            dispatch($8d67e10a1d98bf39$export$b69b71abbe5f24d4(summary));
        }).catch((e)=>{
            dispatch((0, $67f4b1d2fb7c2244$export$7a8bb273722d5103)(e));
            dispatch((0, $67f4b1d2fb7c2244$export$ea4b4733f4ca2df0)(true));
        });
    };
};


const $724759e89af938cb$export$d42eae1040c5f39c = {
    text: "F\xf6r att f\xf6rs\xe4kringen ska tecknas beh\xf6ver du f\xf6rst fylla i en h\xe4lsodeklaration f\xf6r ditt djur.",
    infoText: "H\xe4lsodeklaration kr\xe4vs",
    linkText: "Fyll i h\xe4lsodeklarationen"
};
const $724759e89af938cb$export$88888d9799e3d521 = {
    text: "Just nu p\xe5g\xe5r riskbed\xf6mning. Du kommer att f\xe5 besked n\xe4r den \xe4r genomf\xf6rd.",
    infoText: "Inv\xe4nta riskbed\xf6mning"
};
const $724759e89af938cb$export$51dde44f3eeee08b = {
    text: 'Vi behandlar just nu ditt k\xf6p. N\xe4r k\xf6pet \xe4r klart ser du f\xf6rs\xe4kringen p\xe5 "Mina f\xf6rs\xe4kringar".',
    infoText: "Inv\xe4nta att tecknandet slutf\xf6rs"
};
const $724759e89af938cb$export$aae9c2acc491c850 = {
    text: "F\xf6r att f\xf6rs\xe4kringen ska tecknas beh\xf6ver du fylla i en h\xe4lsodeklaration",
    infoText: "H\xe4lsodeklaration kr\xe4vs",
    linkText: "Fyll i h\xe4lsodeklarationen"
};



const $c3f8668c50d28375$var$PurchasesStatusTeaser = (props)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useEffect(()=>{
        props.loadSummary();
    }, []);
    const summaryData = props.preregistrationSummaries;
    if (!summaryData || !summaryData.length) return;
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $13f4c0370d7de649$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("h2", {
                className: "purchases-status-teaser__main-title",
                children: "P\xe5b\xf6rjade k\xf6p"
            }),
            summaryData.map((data, index)=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($c3f8668c50d28375$var$StatusTeaser, {
                    status: data.status,
                    title: data.productDisplayName,
                    date: data.fromDate,
                    props: props
                }, index))
        ]
    });
};
function $c3f8668c50d28375$var$formatDate(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}
const $c3f8668c50d28375$var$StatusTeaser = ({ status: status, title: title, date: date, props: props })=>{
    const { text: text, infoText: infoText, linkText: linkText } = $c3f8668c50d28375$var$getTexts(status);
    const formattedDate = $c3f8668c50d28375$var$formatDate(date);
    let link = (0, $e6aeb63e6149c504$export$161fa9a9af21e7de)('teaser-target', props.mountRootId) || '';
    link = `/${link}` || "";
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
        className: `purchases-status-teaser purchases-status-teaser__${status} block-spacing`,
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("h3", {
                className: "purchases-status-teaser__title",
                children: title
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("p", {
                className: "purchases-status-teaser__text",
                children: text
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("p", {
                className: "purchases-status-teaser__date",
                children: [
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("strong", {
                        children: "\xd6nskat startdatum:"
                    }),
                    " ",
                    formattedDate
                ]
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                className: `purchases-status-teaser__flex-container ${status === 'pending-terms' ? 'purchases-status-teaser__flex-container__button' : ''}`,
                children: [
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("p", {
                        className: "purchases-status-teaser__info-text",
                        children: infoText
                    }),
                    status === 'pending-terms' ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("a", {
                        className: "purchases-status-teaser__link button",
                        href: link,
                        children: [
                            linkText,
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                className: "purchases-status-teaser__link__icon",
                                dangerouslySetInnerHTML: {
                                    __html: (0, (/*@__PURE__*/$parcel$interopDefault($ac8bf4b7d201ab28$exports)))('external-link').outerHTML
                                }
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $13f4c0370d7de649$exports.Fragment), {
                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                            className: "purchases-status-teaser__icon",
                            dangerouslySetInnerHTML: {
                                __html: (0, (/*@__PURE__*/$parcel$interopDefault($ac8bf4b7d201ab28$exports)))('clock').outerHTML
                            }
                        })
                    })
                ]
            })
        ]
    });
};
function $c3f8668c50d28375$var$getTexts(status) {
    switch(status){
        case 'pending-terms':
            return {
                text: `${$724759e89af938cb$export$d42eae1040c5f39c.text}`,
                infoText: `${$724759e89af938cb$export$d42eae1040c5f39c.infoText}`,
                linkText: `${$724759e89af938cb$export$d42eae1040c5f39c.linkText}`
            };
        case 'risk':
            return {
                text: `${$724759e89af938cb$export$88888d9799e3d521.text}`,
                infoText: `${$724759e89af938cb$export$88888d9799e3d521.infoText}`
            };
        case 'processing':
            return {
                text: `${$724759e89af938cb$export$51dde44f3eeee08b.text}`,
                infoText: `${$724759e89af938cb$export$51dde44f3eeee08b.infoText}`
            };
        default:
            return {
                text: `${$724759e89af938cb$export$aae9c2acc491c850.text}`,
                infoText: `${$724759e89af938cb$export$aae9c2acc491c850.infoText}`,
                linkText: `${$724759e89af938cb$export$aae9c2acc491c850.linkText}`
            };
    }
}
const $c3f8668c50d28375$var$mapStateToProps = (state)=>{
    return {
        preregistrationSummaries: state.preregistrationSummary.preregistrationSummaries
    };
};
const $c3f8668c50d28375$var$mapDispatchToProps = (dispatch)=>{
    return {
        loadSummary: (preregistrationSummaries)=>dispatch((0, $8d67e10a1d98bf39$export$5ea69ce904b567f9)(preregistrationSummaries))
    };
};
var $c3f8668c50d28375$export$2e2bcd8739ae039 = (0, $5a4066412ccab0c1$export$64605811ab45167f)($c3f8668c50d28375$var$mapStateToProps, $c3f8668c50d28375$var$mapDispatchToProps)($c3f8668c50d28375$var$PurchasesStatusTeaser);




var $8NFma = parcelRequire("8NFma");











function $72b8ca19c8495ca5$export$f2b57a838eb36a41(data) {
    return {
        type: 'COINSURED_FORM_SUBMITTED',
        data: data
    };
}
function $72b8ca19c8495ca5$export$6135b1fb61eec095(hasFailed) {
    return {
        type: 'COINSURED_FORM_SUBMIT_FAILED',
        data: !!hasFailed
    };
}
function $72b8ca19c8495ca5$export$34e327c98e0c303(data) {
    return {
        type: 'GET_CUSTOMER_INFO',
        payload: data
    };
}
function $72b8ca19c8495ca5$export$3e49cf51e9d71a() {
    const lfDataService = new (0, $25937fdb26d57abd$export$2e2bcd8739ae039)();
    return (dispatch)=>{
        let customerInfo;
        lfDataService.customerInfo().then((data)=>{
            customerInfo = data.customerInfo;
            dispatch($72b8ca19c8495ca5$export$34e327c98e0c303(customerInfo));
        }).catch((e)=>{
            dispatch((0, $67f4b1d2fb7c2244$export$7a8bb273722d5103)(e));
            dispatch((0, $67f4b1d2fb7c2244$export$ea4b4733f4ca2df0)(true));
        });
    };
}
function $72b8ca19c8495ca5$export$b1a51576cb600ad9(data) {
    const lfDataService = new (0, $25937fdb26d57abd$export$2e2bcd8739ae039)();
    const lfWebService = new (0, $0f2b98672976a17a$export$2e2bcd8739ae039)();
    return (dispatch)=>{
        lfDataService.submitCoInsured(data).then((result)=>{
            if (result.success) {
                dispatch($72b8ca19c8495ca5$export$6135b1fb61eec095(false));
                dispatch($72b8ca19c8495ca5$export$f2b57a838eb36a41(data));
                lfWebService.coinsuredFormConfirmation(data);
                return;
            }
            dispatch($72b8ca19c8495ca5$export$6135b1fb61eec095(true));
            dispatch((0, $67f4b1d2fb7c2244$export$7a8bb273722d5103)('kunde inte uppdatera dina uppgifter'));
            dispatch((0, $67f4b1d2fb7c2244$export$ea4b4733f4ca2df0)(true));
        }).catch((e)=>{
            dispatch($72b8ca19c8495ca5$export$6135b1fb61eec095(true));
            dispatch((0, $67f4b1d2fb7c2244$export$7a8bb273722d5103)(e));
            dispatch((0, $67f4b1d2fb7c2244$export$ea4b4733f4ca2df0)(true));
        });
    };
}


class $91be79c675db81a4$var$CoInsuredForm extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    static get propTypes() {
        return {
            mountRootId: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).string.isRequired
        };
    }
    constructor(props){
        super(props);
        this.pageRedirect = (0, $e6aeb63e6149c504$export$161fa9a9af21e7de)('url', this.props.mountRootId) || '';
    }
    componentDidMount() {
        this.props.loadData();
    }
    submitForm = (e)=>{
        e.preventDefault();
        const url = this.pageRedirect;
        const formValues = (0, $f2bfeab6e0c24c97$export$2e2bcd8739ae039)(this.form);
        this.props.submitCoInsuredForm({
            url: url,
            ...formValues
        });
    };
    render() {
        let error = this.props.data.formSubmitFailed;
        const memberPersonalId = this.props.data.personalIdentityNumber;
        // variables for hiding content on surrounding view, if error
        const headline = document.querySelector('[js-campaign-title]');
        const preamble = document.querySelector('[js-campaign-preamble]');
        const subtext = document.querySelector('[js-campaign-subtext]');
        let content = /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
            className: "coinsured-form-block",
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("h2", {
                    className: "coinsured-form-block__headline",
                    children: "Uppgifter om medf\xf6rs\xe4krad"
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $8c02aa23a40a9b45$export$2e2bcd8739ae039), {
                    ref: (el)=>{
                        this.form = el;
                    },
                    onSubmit: (e)=>this.submitForm(e),
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                            className: "coinsured-form-block__header",
                            children: [
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                    className: "coinsured-form-block__header__text",
                                    children: [
                                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("h3", {
                                            className: "coinsured-form-block__header__label",
                                            children: "F\xf6rnamn"
                                        }),
                                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $fdc1d0f3f8a87be4$export$2e2bcd8739ae039), {
                                            placeholder: "F\xf6rnamn",
                                            id: "CoinsuredFirstName",
                                            name: "CoinsuredFirstName",
                                            "data-validation-error-message": "Du m\xe5ste ange medf\xf6rs\xe4krads f\xf6rnamn",
                                            validations: [
                                                (0, $d5552fc3ceef5489$export$a7a0278c004aac3f)
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                    className: "coinsured-form-block__header__text",
                                    children: [
                                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("h3", {
                                            className: "coinsured-form-block__header__label",
                                            children: "Efternamn"
                                        }),
                                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $fdc1d0f3f8a87be4$export$2e2bcd8739ae039), {
                                            required: true,
                                            placeholder: "Efternamn",
                                            id: "CoinsuredLastName",
                                            name: "CoinsuredLastName",
                                            "data-validation-error-message": "Du m\xe5ste ange medf\xf6rs\xe4krads efternamn",
                                            validations: [
                                                (0, $d5552fc3ceef5489$export$a7a0278c004aac3f)
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                            className: "coinsured-form-block__number",
                            children: [
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("h3", {
                                    className: "coinsured-form-block__label",
                                    children: "Person- eller samordningsnummer"
                                }),
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $fdc1d0f3f8a87be4$export$2e2bcd8739ae039), {
                                    required: true,
                                    placeholder: "YYYYMMMDDXXXX",
                                    id: "CoinsuredPersonalIdentityNumber",
                                    name: "CoinsuredPersonalIdentityNumber",
                                    "data-validation-error-message": "Du m\xe5ste ange ett giltigt person- eller samordningsnummer",
                                    validations: [
                                        (0, $d5552fc3ceef5489$export$10f2e5580e5de03b),
                                        (0, $d5552fc3ceef5489$export$d1e4c282e09ffddb)(memberPersonalId)
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                            className: "coinsured-form-block__button__container",
                            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $b50965a6d450d3cc$export$2e2bcd8739ae039), {
                                noIcon: true,
                                children: "Skicka in uppgifterna"
                            })
                        })
                    ]
                })
            ]
        });
        if (error) {
            headline.style.display = "none";
            preamble.style.display = "none";
            subtext.style.display = "none";
            content = /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                className: "coinsured-form-block__error",
                children: [
                    "\xc5h nej! N\xe5got blev tyv\xe4rr fel. ",
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("br", {}),
                    "Kontakta kundservice p\xe5 ",
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("a", {
                            href: "callto:0771-21 09 09",
                            children: "0771-21 09 09 "
                        })
                    }),
                    " (\xf6ppet vardagar 9-17) s\xe5 hj\xe4lper vi dig vidare."
                ]
            });
        }
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Fragment, {
            children: content
        });
    }
}
// state
const $91be79c675db81a4$var$mapStateToProps = (state)=>{
    return {
        payload: state.customerInfo,
        data: state.coInsuredFormData,
        hasErrored: state.pageHasErrored,
        error: state.pageError
    };
};
const $91be79c675db81a4$var$mapDispatchToProps = (dispatch)=>{
    return {
        loadData: (payload)=>dispatch((0, $72b8ca19c8495ca5$export$3e49cf51e9d71a)(payload)),
        submitCoInsuredForm: (data)=>dispatch((0, $72b8ca19c8495ca5$export$b1a51576cb600ad9)(data)),
        formSubmitFailed: (data)=>dispatch(submitFormSubmitFailedAction(data))
    };
};
var $91be79c675db81a4$export$2e2bcd8739ae039 = (0, $5a4066412ccab0c1$export$64605811ab45167f)($91be79c675db81a4$var$mapStateToProps, $91be79c675db81a4$var$mapDispatchToProps)($91be79c675db81a4$var$CoInsuredForm);




var $8NFma = parcelRequire("8NFma");

var $410b94b5f24598b3$exports = {};
$410b94b5f24598b3$exports = JSON.parse("{\"v\":\"5.7.8\",\"fr\":30,\"ip\":0,\"op\":180,\"w\":350,\"h\":250,\"nm\":\"Stars\",\"ddd\":0,\"assets\":[],\"layers\":[{\"ddd\":0,\"ind\":1,\"ty\":4,\"nm\":\"moln\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":0,\"s\":[100]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":90,\"s\":[80]},{\"t\":179,\"s\":[100]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[284.544,95.036,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[270.836,92.417,0],\"ix\":1,\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":0,\"s\":[100,100,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":90,\"s\":[103,103,100]},{\"t\":179,\"s\":[100,100,100]}],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[2.725,-3.622],[0,0.573],[14.127,0],[1.167,-13.046],[5.375,0],[0,-9.455],[-9.433,-0.024],[0,0],[0,8.245],[8.246,0]],\"o\":[[0.037,-0.563],[0,-14.128],[-13.351,0],[-3.139,-3.874],[-9.454,0],[0,9.44],[0,0],[8.246,0],[0,-8.245],[-4.881,0]],\"v\":[[27.263,1.696],[27.349,0.001],[1.768,-25.581],[-23.695,-2.306],[-36.999,-8.66],[-54.118,8.461],[-37.044,25.578],[39.189,25.581],[54.118,10.651],[39.189,-4.28]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,1,1,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[270.586,66.917],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":180,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":2,\"ty\":4,\"nm\":\"moln\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":0,\"s\":[100]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":49,\"s\":[80]},{\"t\":179,\"s\":[100]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[211.571,215.302,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[198.863,212.683,0],\"ix\":1,\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":0,\"s\":[104,104,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":43,\"s\":[108,108,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":136,\"s\":[100,100,100]},{\"t\":179,\"s\":[104,104,100]}],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,5.368],[-5.378,0],[-0.617,-0.122],[-8.327,0],[-1.956,-7.041],[-1.789,0],[0,-6.167],[6.167,0],[0,0],[0,0]],\"o\":[[0,-5.378],[0.653,0],[1.252,-7.974],[7.664,0],[1.499,-0.748],[6.167,0],[0,6.166],[0,0],[0,0],[-5.365,-0.013]],\"v\":[[-30.152,6.946],[-20.415,-2.79],[-18.508,-2.602],[-2.048,-16.683],[14.012,-4.467],[18.986,-5.648],[30.152,5.518],[18.986,16.683],[-20.442,16.683],[-20.442,16.681]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,1,1,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[198.863,196.058],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 2\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":180,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":3,\"ty\":4,\"nm\":\"moln\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":22,\"s\":[90]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":95,\"s\":[100]},{\"t\":179,\"s\":[90]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[42.779,124.867,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[30.071,122.248,0],\"ix\":1,\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":0,\"s\":[106,106,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":90,\"s\":[100,100,100]},{\"t\":179,\"s\":[106,106,100]}],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,5.309],[5.319,0],[0.61,-0.122],[8.236,0],[1.935,-6.964],[1.77,0],[0,-6.098],[-6.098,0],[0,0],[0,0]],\"o\":[[0,-5.319],[-0.645,0],[-1.239,-7.888],[-7.58,0],[-1.482,-0.74],[-6.098,0],[0,6.099],[0,0],[0,0],[5.307,-0.015]],\"v\":[[29.821,6.87],[20.19,-2.76],[18.305,-2.573],[2.025,-16.5],[-13.859,-4.419],[-18.779,-5.586],[-29.821,5.456],[-18.779,16.5],[20.217,16.5],[20.217,16.498]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,1,1,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[30.071,105.748],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 3\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":180,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":4,\"ty\":3,\"nm\":\"Starplacement\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":0,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":54,\"s\":[315.75,43,0],\"to\":[-60.333,33.667,0],\"ti\":[60.333,-33.667,0]},{\"t\":102,\"s\":[-46.25,245,0]}],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[0,0,0],\"ix\":1,\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":0,\"s\":[124,124,100]},{\"t\":102,\"s\":[49,49,100]}],\"ix\":6,\"l\":2}},\"ao\":0,\"ip\":0,\"op\":180,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":5,\"ty\":4,\"nm\":\"Layer 1 Outlines - Group 4\",\"parent\":4,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":65,\"s\":[11.316,10.981,0],\"to\":[8.979,-5.125,0],\"ti\":[-8.979,5.125,0]},{\"t\":86,\"s\":[65.191,-19.769,0]}],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[158.858,108.862,0],\"ix\":1,\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":65,\"s\":[140,140,100]},{\"t\":86,\"s\":[0,0,100]}],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[-0.47,-0.6],[-1.516,-0.52],[-0.847,0.292],[-1.087,1.31],[-0.111,0.931],[0.787,1.48],[0.721,0.434],[1.516,-0.244],[0.499,-0.512],[0.092,-1.48]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.996078491211,0.803921628466,0.196078446332,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[158.858,108.862],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 4\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":65,\"op\":86,\"st\":65,\"bm\":0},{\"ddd\":0,\"ind\":6,\"ty\":4,\"nm\":\"Layer 1 Outlines - Group 5\",\"parent\":4,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":72,\"s\":[-1.685,-13.254,0],\"to\":[8.979,-5.125,0],\"ti\":[-8.979,5.125,0]},{\"t\":92,\"s\":[52.19,-44.004,0]}],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[116.607,130.627,0],\"ix\":1,\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":72,\"s\":[151,151,100]},{\"t\":92,\"s\":[0,0,100]}],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[-0.737,-1.629],[-2.799,-2.017],[-1.926,-0.102],[-2.916,1.74],[-0.835,1.514],[0.616,3.039],[1.029,0.984],[2.916,0.085],[1.089,-0.958],[0.805,-3.039]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.996078491211,0.803921628466,0.196078446332,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[116.607,130.627],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 5\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":72,\"op\":92,\"st\":72,\"bm\":0},{\"ddd\":0,\"ind\":7,\"ty\":4,\"nm\":\"Layer 1 Outlines - Group 6\",\"parent\":4,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":67,\"s\":[4.353,-4.74,0],\"to\":[8.979,-5.125,0],\"ti\":[-8.979,5.125,0]},{\"t\":87,\"s\":[58.228,-35.49,0]}],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[140.895,126.016,0],\"ix\":1,\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":67,\"s\":[142,142,100]},{\"t\":87,\"s\":[0,0,100]}],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[-0.838,-0.317],[-1.521,0.48],[-0.474,0.58],[0.076,1.469],[0.498,0.511],[1.521,0.265],[0.735,-0.427],[0.818,-1.469],[-0.09,-0.939],[-1.063,-1.337]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.996078491211,0.803921628466,0.196078446332,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[140.895,126.016],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 6\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":67,\"op\":87,\"st\":67,\"bm\":0},{\"ddd\":0,\"ind\":8,\"ty\":4,\"nm\":\"Layer 1 Outlines - Group 7\",\"parent\":4,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":78,\"s\":[-2.051,-3.774,0],\"to\":[8.979,-5.125,0],\"ti\":[-8.979,5.125,0]},{\"t\":94,\"s\":[51.824,-34.524,0]}],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[139.991,114.107,0],\"ix\":1,\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":78,\"s\":[167,167,100]},{\"t\":94,\"s\":[0,0,100]}],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[-1.397,-0.528],[-2.535,0.799],[-0.79,0.967],[0.126,2.449],[0.831,0.852],[2.536,0.441],[1.225,-0.713],[1.363,-2.449],[-0.152,-1.566],[-1.772,-2.228]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.996078491211,0.803921628466,0.196078446332,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[139.991,114.107],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 7\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":78,\"op\":94,\"st\":78,\"bm\":0},{\"ddd\":0,\"ind\":9,\"ty\":4,\"nm\":\"Layer 1 Outlines - Group 8\",\"parent\":4,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":65,\"s\":[4.513,1.332,0],\"to\":[8.979,-5.125,0],\"ti\":[-8.979,5.125,0]},{\"t\":88,\"s\":[58.388,-29.418,0]}],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[137.68,138.088,0],\"ix\":1,\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":65,\"s\":[100,100,100]},{\"t\":88,\"s\":[0,0,100]}],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0.786,-1.243],[-0.385,-2.706],[-0.909,-0.901],[-2.652,-0.23],[-1.11,0.828],[-1.017,2.706],[0.459,1.555],[2.261,2.045],[1.631,0.276],[2.651,-1.3]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.996078491211,0.803921628466,0.196078446332,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[137.68,138.088],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 8\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":65,\"op\":88,\"st\":65,\"bm\":0},{\"ddd\":0,\"ind\":10,\"ty\":4,\"nm\":\"Layer 1 Outlines - Group 9\",\"parent\":4,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":70,\"s\":[6.678,4.901,0],\"to\":[8.979,-5.125,0],\"ti\":[-8.979,5.125,0]},{\"t\":90,\"s\":[60.553,-25.849,0]}],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[129.094,147.157,0],\"ix\":1,\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":70,\"s\":[176,176,100]},{\"t\":90,\"s\":[0,0,100]}],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0.881,-1.391],[-0.431,-3.031],[-1.017,-1.008],[-2.969,-0.257],[-1.243,0.926],[-1.138,3.031],[0.515,1.742],[2.532,2.291],[1.827,0.308],[2.969,-1.455]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.996078491211,0.803921628466,0.196078446332,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[129.094,147.157],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 9\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":70,\"op\":90,\"st\":70,\"bm\":0},{\"ddd\":0,\"ind\":11,\"ty\":4,\"nm\":\"Layer 1 Outlines - Group 10\",\"parent\":4,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":73,\"s\":[0.708,-5.5,0],\"to\":[8.979,-5.125,0],\"ti\":[-8.979,5.125,0]},{\"t\":93,\"s\":[54.583,-36.25,0]}],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[128.25,126.381,0],\"ix\":1,\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":73,\"s\":[139,139,100]},{\"t\":93,\"s\":[0,0,100]}],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[-1.021,-1.008],[-3,-0.312],[-1.287,0.91],[-1.224,3],[0.466,1.763],[2.485,2.358],[1.815,0.373],[3,-1.35],[0.896,-1.339],[-0.391,-3]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.996078491211,0.803921628466,0.196078446332,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[128.25,126.381],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 10\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":73,\"op\":93,\"st\":73,\"bm\":0},{\"ddd\":0,\"ind\":12,\"ty\":4,\"nm\":\"BigStar\",\"parent\":4,\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":60,\"s\":[0]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":62,\"s\":[100]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":89,\"s\":[100]},{\"t\":94,\"s\":[0]}],\"ix\":11},\"r\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":57,\"s\":[0]},{\"t\":94,\"s\":[-155]}],\"ix\":10},\"p\":{\"a\":0,\"k\":[-0.915,-0.739,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[109.127,148.642,0],\"ix\":1,\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":57,\"s\":[100,100,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":70,\"s\":[100,100,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":77,\"s\":[117,117,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":84,\"s\":[100,100,100]},{\"t\":94,\"s\":[100,100,100]}],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[-5.863,-5.908],[-17.235,-1.827],[-7.392,5.331],[-7.027,17.579],[2.678,10.329],[14.278,13.822],[10.43,2.186],[17.234,-7.905],[5.152,-7.846],[-2.243,-17.579]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.996078491211,0.803921628466,0.196078446332,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[109.127,148.642],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 11\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":180,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":13,\"ty\":4,\"nm\":\"Trail\",\"parent\":4,\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":63,\"s\":[0]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":77,\"s\":[100]},{\"t\":94,\"s\":[0]}],\"ix\":11},\"r\":{\"a\":0,\"k\":1.602,\"ix\":10},\"p\":{\"a\":0,\"k\":[53.75,-24.5,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[0,0,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ty\":\"rc\",\"d\":1,\"s\":{\"a\":0,\"k\":[238.661,29.725],\"ix\":2},\"p\":{\"a\":0,\"k\":[0,0],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":4},\"nm\":\"Rectangle Path 1\",\"mn\":\"ADBE Vector Shape - Rect\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[9.579,-10.407],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[56.195,117.677],\"ix\":3},\"r\":{\"a\":0,\"k\":-30.754,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Rectangle 1\",\"np\":1,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gf\",\"o\":{\"a\":0,\"k\":100,\"ix\":10},\"r\":1,\"bm\":0,\"g\":{\"p\":3,\"k\":{\"a\":0,\"k\":[0,1,1,1,0.5,1,1,1,1,1,1,1,0,0.2,0.5,0.1,1,0],\"ix\":9}},\"s\":{\"a\":0,\"k\":[0,0],\"ix\":5},\"e\":{\"a\":0,\"k\":[100,0],\"ix\":6},\"t\":1,\"nm\":\"Gradient Fill 1\",\"mn\":\"ADBE Vector Graphic - G-Fill\",\"hd\":false}],\"ip\":0,\"op\":180,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":14,\"ty\":4,\"nm\":\"Layer 1 Outlines - Group 21\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[106.712,73.452,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[94.004,70.833,0],\"ix\":1,\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":3,\"s\":[100,100,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":33.303,\"s\":[183,183,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":67,\"s\":[100,100,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":113,\"s\":[100,100,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":135,\"s\":[183,183,100]},{\"t\":156,\"s\":[100,100,100]}],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0.241,3.443],[0,0],[0,0],[3.442,-0.239],[0,0],[0,0],[-0.24,-3.442],[-0.007,0],[-0.005,0],[-3.442,0.24]],\"o\":[[0,0],[-3.442,-0.239],[0,0],[0,0],[-0.24,3.443],[0,0],[0,0],[3.442,0.24],[0.007,0],[0.006,0],[0.241,-3.442],[0,0]],\"v\":[[6.451,0],[6.451,-0.02],[0.018,-6.451],[0.001,-6.451],[-0.02,-6.451],[-6.451,-0.02],[-6.451,0],[-6.451,0.019],[-0.02,6.45],[0.001,6.451],[0.018,6.45],[6.451,0.019]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.996078491211,0.803921628466,0.196078446332,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[94.004,70.833],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 21\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":180,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":15,\"ty\":4,\"nm\":\"Layer 1 Outlines - Group 12\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[22.671,197.863,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[9.963,195.244,0],\"ix\":1,\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":19,\"s\":[100,100,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":41,\"s\":[20,20,100]},{\"t\":62,\"s\":[100,100,100]}],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0.156,2.235],[0,0],[0,0],[2.233,-0.155],[0,0],[0,0],[-0.156,-2.233],[-0.003,0],[-0.004,0],[-2.233,0.156]],\"o\":[[0,0],[-2.233,-0.155],[0,0],[0,0],[-0.156,2.235],[0,0],[0,0],[2.233,0.156],[0.004,0],[0.004,0],[0.156,-2.233],[0,0]],\"v\":[[4.186,0],[4.186,-0.013],[0.012,-4.187],[-0.001,-4.187],[-0.012,-4.187],[-4.186,-0.013],[-4.186,0],[-4.186,0.012],[-0.012,4.185],[-0.001,4.186],[0.012,4.185],[4.186,0.012]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,1,1,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[9.963,195.244],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 12\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":180,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":16,\"ty\":4,\"nm\":\"Layer 1 Outlines - Group 13\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[237.537,235.222,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[224.829,232.603,0],\"ix\":1,\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":59,\"s\":[100,100,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":81,\"s\":[120,120,100]},{\"t\":102,\"s\":[100,100,100]}],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0.005],[0,0.004],[0.156,2.235],[0,0],[0,0],[2.233,-0.156],[0,-0.004],[0,-0.004],[-0.156,-2.235],[0,0],[0,0],[-2.233,0.155]],\"o\":[[0,-0.004],[-2.233,-0.156],[0,0],[0,0],[-0.156,2.235],[0,0.004],[0,0.005],[2.233,0.155],[0,0],[0,0],[0.156,-2.235],[0,-0.004]],\"v\":[[4.186,-0.001],[4.185,-0.013],[0.012,-4.187],[-0.001,-4.187],[-0.012,-4.187],[-4.185,-0.013],[-4.186,-0.001],[-4.185,0.012],[-0.012,4.186],[-0.001,4.186],[0.012,4.186],[4.185,0.012]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.996078491211,0.803921628466,0.196078446332,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[224.829,232.603],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 13\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":180,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":17,\"ty\":4,\"nm\":\"Layer 1 Outlines - Group 14\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[261.531,120.639,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[248.823,118.02,0],\"ix\":1,\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":5,\"s\":[100,100,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":33,\"s\":[142,142,100]},{\"t\":69,\"s\":[100,100,100]}],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0.156,2.234],[0,0],[0,0],[2.233,-0.155],[0,0],[0,0],[-0.156,-2.233],[-0.004,0],[-0.004,0],[-2.234,0.156]],\"o\":[[0,0],[-2.234,-0.155],[0,0],[0,0],[-0.156,2.234],[0,0],[0,0],[2.233,0.156],[0.004,0],[0.004,0],[0.156,-2.233],[0,0]],\"v\":[[4.186,0],[4.186,-0.013],[0.011,-4.186],[-0.001,-4.186],[-0.013,-4.186],[-4.186,-0.013],[-4.186,0],[-4.186,0.012],[-0.013,4.185],[-0.001,4.186],[0.011,4.185],[4.186,0.012]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.996078491211,0.803921628466,0.196078446332,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[248.823,118.02],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 14\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":180,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":18,\"ty\":4,\"nm\":\"Layer 1 Outlines - Group 15\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[172.625,163.024,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[159.917,160.405,0],\"ix\":1,\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":10,\"s\":[100,100,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":35,\"s\":[61,61,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":60,\"s\":[100,100,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":101,\"s\":[100,100,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":115,\"s\":[10,10,100]},{\"t\":129,\"s\":[100,100,100]}],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0.004],[0,0.004],[0.156,2.235],[0,0],[0,0],[2.233,-0.156],[0,-0.004],[0,-0.004],[-0.156,-2.234],[0,0],[0,0],[-2.233,0.156]],\"o\":[[0,-0.004],[-2.233,-0.156],[0,0],[0,0],[-0.156,2.235],[0,0.004],[0,0.004],[2.233,0.156],[0,0],[0,0],[0.156,-2.234],[0,-0.004]],\"v\":[[4.186,0],[4.185,-0.012],[0.012,-4.187],[0,-4.187],[-0.012,-4.187],[-4.185,-0.012],[-4.186,0],[-4.185,0.012],[-0.012,4.186],[0,4.186],[0.012,4.186],[4.185,0.012]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.996078491211,0.803921628466,0.196078446332,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[159.917,160.405],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 15\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":180,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":19,\"ty\":4,\"nm\":\"Layer 1 Outlines - Group 16\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[307.706,214.876,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[294.998,212.257,0],\"ix\":1,\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":117,\"s\":[100,100,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":147,\"s\":[10,10,100]},{\"t\":168,\"s\":[100,100,100]}],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0.155,2.235],[0,0],[0,0],[2.233,-0.156],[0,0],[0,0],[-0.156,-2.235],[0,0],[0,0],[-2.233,0.155]],\"o\":[[0,0],[-2.233,-0.156],[0,0],[0,0],[-0.156,2.235],[0,0],[0,0],[2.233,0.155],[0,0],[0,0],[0.155,-2.235],[0,0]],\"v\":[[4.186,-0.001],[4.186,-0.013],[0.013,-4.187],[0,-4.187],[-0.013,-4.187],[-4.185,-0.013],[-4.185,-0.001],[-4.185,0.012],[-0.013,4.186],[0,4.186],[0.013,4.186],[4.186,0.012]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,1,1,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[294.998,212.257],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 16\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":180,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":20,\"ty\":4,\"nm\":\"Layer 1 Outlines - Group 17\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[170.449,226.868,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[157.741,224.249,0],\"ix\":1,\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":2,\"s\":[100,100,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":23,\"s\":[120,120,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":46,\"s\":[100,100,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":79,\"s\":[100,100,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":101,\"s\":[120,120,100]},{\"t\":122,\"s\":[100,100,100]}],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0.075,1.067],[0,0],[0,0],[1.067,-0.074],[0,0],[0,0],[-0.074,-1.067],[0,0],[0,0],[-1.067,0.075]],\"o\":[[0,0],[-1.067,-0.074],[0,0],[0,0],[-0.074,1.067],[0,0],[0,0],[1.067,0.075],[0,0],[0,0],[0.075,-1.067],[0,0]],\"v\":[[2,0],[2,-0.006],[0.006,-2],[0,-2],[-0.006,-2],[-2,-0.006],[-2,0],[-2,0.006],[-0.006,2],[0,2],[0.006,2],[2,0.006]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,1,1,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[157.741,224.249],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 17\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":180,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":21,\"ty\":4,\"nm\":\"Layer 1 Outlines - Group 18\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[30.635,44.683,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[17.927,42.064,0],\"ix\":1,\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":0,\"s\":[100,100,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":22,\"s\":[19,19,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":43,\"s\":[100,100,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":92,\"s\":[100,100,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":111.953,\"s\":[19,19,100]},{\"t\":131,\"s\":[100,100,100]}],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0.156,2.234],[0,0],[0,0],[2.233,-0.155],[0,0],[0,0],[-0.156,-2.233],[-0.003,0],[-0.004,0],[-2.234,0.156]],\"o\":[[0,0],[-2.234,-0.155],[0,0],[0,0],[-0.156,2.234],[0,0],[0,0],[2.233,0.156],[0.004,0],[0.004,0],[0.156,-2.233],[0,0]],\"v\":[[4.186,0],[4.186,-0.013],[0.012,-4.186],[-0.001,-4.186],[-0.012,-4.186],[-4.186,-0.013],[-4.186,0],[-4.186,0.012],[-0.012,4.185],[-0.001,4.186],[0.012,4.185],[4.186,0.012]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,1,1,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[17.927,42.064],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 18\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":180,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":22,\"ty\":4,\"nm\":\"Layer 1 Outlines - Group 19\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[318.325,33.77,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[305.617,31.151,0],\"ix\":1,\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":44,\"s\":[100,100,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":66,\"s\":[120,120,100]},{\"t\":87,\"s\":[100,100,100]}],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0.236,3.374],[0,0],[0,0],[3.375,-0.235],[0,0],[0,0],[-0.235,-3.374],[0,0],[0,0],[-3.374,0.235]],\"o\":[[0,0],[-3.374,-0.235],[0,0],[0,0],[-0.235,3.374],[0,0],[0,0],[3.375,0.235],[0,0],[0,0],[0.236,-3.374],[0,0]],\"v\":[[6.323,0],[6.323,-0.019],[0.018,-6.323],[0,-6.323],[-0.019,-6.323],[-6.323,-0.019],[-6.323,0],[-6.323,0.019],[-0.019,6.323],[0,6.323],[0.018,6.323],[6.323,0.019]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,1,1,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[305.617,31.151],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 19\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":180,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":23,\"ty\":4,\"nm\":\"Layer 1 Outlines - Group 20\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[119.593,224.713,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[106.885,222.094,0],\"ix\":1,\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":4,\"s\":[100,100,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":30,\"s\":[13,13,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":63,\"s\":[100,100,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":107,\"s\":[100,100,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":129,\"s\":[20,20,100]},{\"t\":150,\"s\":[100,100,100]}],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0.236,3.374],[0,0],[0,0],[3.375,-0.235],[0,0],[0,0],[-0.235,-3.374],[0,0],[0,0],[-3.374,0.235]],\"o\":[[0,0],[-3.374,-0.235],[0,0],[0,0],[-0.235,3.374],[0,0],[0,0],[3.375,0.235],[0,0],[0,0],[0.236,-3.374],[0,0]],\"v\":[[6.323,0],[6.323,-0.02],[0.018,-6.322],[0,-6.322],[-0.019,-6.322],[-6.323,-0.02],[-6.323,0],[-6.323,0.02],[-0.019,6.323],[0,6.323],[0.018,6.323],[6.323,0.02]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,1,1,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[106.885,222.094],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 20\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":180,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":24,\"ty\":4,\"nm\":\"Layer 1 Outlines - Group 22\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[330.895,147.84,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[318.187,145.221,0],\"ix\":1,\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":22,\"s\":[100,100,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":44,\"s\":[2,2,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":65,\"s\":[100,100,100]},{\"i\":{\"x\":[0.587,0.587,0.587],\"y\":[1,1,1]},\"o\":{\"x\":[0.165,0.165,0.165],\"y\":[0,0,0]},\"t\":137,\"s\":[100,100,100]},{\"i\":{\"x\":[0.832,0.832,0.832],\"y\":[1,1,1]},\"o\":{\"x\":[0.42,0.42,0.42],\"y\":[0,0,0]},\"t\":151,\"s\":[10,10,100]},{\"t\":164,\"s\":[100,100,100]}],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0.007],[0,0.006],[0.241,3.442],[0,0],[0,0],[3.442,-0.24],[0,0],[0,0],[-0.24,-3.442],[0,0],[0,0],[-3.442,0.24]],\"o\":[[0,-0.006],[-3.442,-0.24],[0,0],[0,0],[-0.24,3.442],[0,0],[0,0],[3.442,0.24],[0,0],[0,0],[0.241,-3.442],[0,-0.006]],\"v\":[[6.451,-0.001],[6.45,-0.02],[0.018,-6.451],[0,-6.451],[-0.02,-6.451],[-6.451,-0.02],[-6.451,-0.001],[-6.451,0.02],[-0.02,6.451],[0,6.451],[0.018,6.451],[6.45,0.02]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.996078491211,0.803921628466,0.196078446332,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[318.187,145.221],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 22\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":180,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":25,\"ty\":4,\"nm\":\"Layer 1 Outlines - Group 23\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[164.916,14.956,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[152.208,12.337,0],\"ix\":1,\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":1,\"s\":[100,100,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":86,\"s\":[10,10,100]},{\"t\":162,\"s\":[100,100,100]}],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0.012],[0,0.012],[0.449,6.449],[0.012,0],[0.013,0],[6.45,-0.449],[0,0],[0,0],[-0.449,-6.449],[-0.012,0],[-0.012,0],[-6.45,0.45]],\"o\":[[0,-0.012],[-6.45,-0.449],[-0.012,0],[-0.012,0],[-0.449,6.449],[0,0],[0,0],[6.45,0.45],[0.013,0],[0.012,0],[0.449,-6.449],[0,-0.012]],\"v\":[[12.087,0],[12.086,-0.036],[0.035,-12.086],[-0.001,-12.087],[-0.037,-12.086],[-12.088,-0.036],[-12.088,0],[-12.088,0.036],[-0.037,12.086],[-0.001,12.087],[0.035,12.086],[12.086,0.036]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.996078491211,0.803921628466,0.196078446332,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[152.208,12.337],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 23\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":180,\"st\":0,\"bm\":0}],\"markers\":[]}");


const $85fd810c0a087852$var$AchievementsHeroAnimation = ()=>{
    const lottieRef = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useRef();
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useEffect(()=>{
        lottieRef.current.setSpeed(0.5);
        setTimeout(()=>{
            lottieRef.current.play();
        }, 100);
    }, []);
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2c1cc6e8319f49c7$exports))), {
        className: "animated-hero__inner__animation__holder__element",
        lottieRef: lottieRef,
        autoplay: false,
        loop: true,
        animationData: (0, (/*@__PURE__*/$parcel$interopDefault($410b94b5f24598b3$exports)))
    });
};
var $85fd810c0a087852$export$2e2bcd8739ae039 = $85fd810c0a087852$var$AchievementsHeroAnimation;




var $8NFma = parcelRequire("8NFma");




var $2d63a60fcde866fc$exports = {};
$2d63a60fcde866fc$exports = JSON.parse("{\"v\":\"5.9.6\",\"fr\":30,\"ip\":0,\"op\":70,\"w\":488,\"h\":358,\"nm\":\"headphones\",\"ddd\":0,\"assets\":[{\"id\":\"comp_0\",\"nm\":\"Star\",\"fr\":30,\"layers\":[{\"ddd\":0,\"ind\":1,\"ty\":4,\"nm\":\"star\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.37],\"y\":[1]},\"o\":{\"x\":[0.89],\"y\":[0]},\"t\":0,\"s\":[0]},{\"i\":{\"x\":[0.29],\"y\":[1]},\"o\":{\"x\":[0.89],\"y\":[0]},\"t\":14.98,\"s\":[100]},{\"t\":51.484375,\"s\":[0]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[30.199,29.917,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[379.199,67.917,0],\"ix\":1,\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.37,0.37,0.37],\"y\":[1,1,1]},\"o\":{\"x\":[0.89,0.89,0.89],\"y\":[0,0,0]},\"t\":0,\"s\":[0,0,100]},{\"i\":{\"x\":[0.29,0.29,0.29],\"y\":[1,1,1]},\"o\":{\"x\":[0.89,0.89,0.89],\"y\":[0,0,0]},\"t\":14.98,\"s\":[100,100,100]},{\"t\":51.484375,\"s\":[0,0,100]}],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[3.002,17.558],[17.558,-3.002],[-3.002,-17.558],[-17.558,3.002]],\"o\":[[-1.996,16.457],[16.457,1.996],[1.996,-16.457],[-16.457,-1.996]],\"v\":[[0,-29.267],[-29.267,0],[0,29.267],[29.267,0]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,0.549019607843,0.066666666667,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[379.199,67.917],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 4\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":46,\"st\":0,\"ct\":1,\"bm\":0}]}],\"layers\":[{\"ddd\":0,\"ind\":1,\"ty\":3,\"nm\":\"Star04_null\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":0,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[152,295.5,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[50,50,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[82,82,100],\"ix\":6,\"l\":2}},\"ao\":0,\"ip\":17,\"op\":69,\"st\":17,\"bm\":0},{\"ddd\":0,\"ind\":2,\"ty\":0,\"nm\":\"Star_04\",\"parent\":1,\"refId\":\"comp_0\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[50,50,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[30,30,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"w\":60,\"h\":60,\"ip\":17,\"op\":69,\"st\":17,\"bm\":0},{\"ddd\":0,\"ind\":3,\"ty\":3,\"nm\":\"Star03_null\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":0,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[379.125,293.75,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[50,50,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[36,36,100],\"ix\":6,\"l\":2}},\"ao\":0,\"ip\":11,\"op\":63,\"st\":11,\"bm\":0},{\"ddd\":0,\"ind\":4,\"ty\":0,\"nm\":\"Star_03\",\"parent\":3,\"refId\":\"comp_0\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[50,50,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[30,30,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"w\":60,\"h\":60,\"ip\":11,\"op\":63,\"st\":11,\"bm\":0},{\"ddd\":0,\"ind\":5,\"ty\":3,\"nm\":\"Star02_null\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":0,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[101,198.25,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[50,50,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[36.5,36.5,100],\"ix\":6,\"l\":2}},\"ao\":0,\"ip\":5,\"op\":57,\"st\":5,\"bm\":0},{\"ddd\":0,\"ind\":6,\"ty\":0,\"nm\":\"Star_02\",\"parent\":5,\"refId\":\"comp_0\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[50,50,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[30,30,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"w\":60,\"h\":60,\"ip\":5,\"op\":57,\"st\":5,\"bm\":0},{\"ddd\":0,\"ind\":7,\"ty\":3,\"nm\":\"Star01_null\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":0,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[378.75,67.5,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[50,50,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"ip\":0,\"op\":52,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":8,\"ty\":0,\"nm\":\"Star_01\",\"parent\":7,\"refId\":\"comp_0\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[50,50,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[30,30,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"w\":60,\"h\":60,\"ip\":0,\"op\":52,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":9,\"ty\":4,\"nm\":\"Layer 1 Outlines - Group 6\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[330.616,186.843,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[330.616,186.843,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0.254],[0,0],[0.254,0],[0,0]],\"o\":[[0,0],[0.254,0],[0,0],[0,-0.254],[0,0],[0,0]],\"v\":[[-2.53,2.36],[2.07,2.36],[2.53,1.9],[2.53,-1.9],[2.07,-2.36],[-2.53,-2.36]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ind\":1,\"ty\":\"sh\",\"ix\":2,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,-1.199],[0,0],[-0.41,0],[0,0]],\"o\":[[0,0],[-1.049,0.58],[0,0],[0,0.41],[0,0],[0,0]],\"v\":[[-173.499,-10.556],[-176.859,-8.699],[-178.559,-5.816],[-178.559,-5.75],[-177.817,-5.007],[-173.499,-5.007]],\"c\":true},\"ix\":2},\"nm\":\"Path 2\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ind\":2,\"ty\":\"sh\",\"ix\":3,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,1.199],[0,0],[-0.41,0],[0,0]],\"o\":[[0,0],[-1.049,-0.58],[0,0],[0,-0.41],[0,0],[0,0]],\"v\":[[-173.499,10.549],[-176.859,8.693],[-178.559,5.81],[-178.559,5.81],[-177.817,5.068],[-173.499,5.068]],\"c\":true},\"ix\":2},\"nm\":\"Path 3\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ind\":3,\"ty\":\"sh\",\"ix\":4,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0.254],[0,0],[-0.254,0],[0,0]],\"o\":[[0,0],[-0.254,0],[0,0],[0,-0.254],[0,0],[0,0]],\"v\":[[-173.499,2.36],[-178.099,2.36],[-178.559,1.9],[-178.559,-1.9],[-178.099,-2.36],[-173.499,-2.36]],\"c\":true},\"ix\":2},\"nm\":\"Path 4\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ind\":4,\"ty\":\"sh\",\"ix\":5,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,-1.199],[0,0],[0.41,0],[0,0]],\"o\":[[0,0],[1.049,0.58],[0,0],[0,0.41],[0,0],[0,0]],\"v\":[[-2.53,-10.556],[0.829,-8.699],[2.53,-5.816],[2.53,-5.75],[1.788,-5.007],[-2.53,-5.007]],\"c\":true},\"ix\":2},\"nm\":\"Path 5\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ind\":5,\"ty\":\"sh\",\"ix\":6,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,1.199],[0,0],[0.41,0],[0,0]],\"o\":[[0,0],[1.049,-0.58],[0,0],[0,-0.41],[0,0],[0,0]],\"v\":[[-2.53,10.549],[0.829,8.693],[2.53,5.81],[2.53,5.81],[1.788,5.068],[-2.53,5.068]],\"c\":true},\"ix\":2},\"nm\":\"Path 6\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.478431402468,0.376470618154,0.301960784314,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[330.616,186.843],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 6\",\"np\":7,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":450,\"st\":0,\"ct\":1,\"bm\":0},{\"ddd\":0,\"ind\":10,\"ty\":4,\"nm\":\"Layer 1 Outlines - Group 5\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[250.538,268.113,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[250.538,268.113,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,1.763],[0,0],[1.763,0],[0,0],[0,-1.763],[0,0],[-1.763,0],[0,0]],\"o\":[[0,0],[0,-1.763],[0,0],[-1.763,0],[0,0],[0,1.763],[0,0],[1.763,0]],\"v\":[[16.132,3.15],[16.132,-3.15],[12.928,-6.355],[-12.928,-6.355],[-16.132,-3.15],[-16.132,3.15],[-12.928,6.355],[12.928,6.355]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ind\":1,\"ty\":\"sh\",\"ix\":2,\"ks\":{\"a\":0,\"k\":{\"i\":[[-3.815,0],[0,0],[0,3.815],[0,0],[3.815,0],[0,0],[0,-3.815],[0,0]],\"o\":[[0,0],[3.815,0],[0,0],[0,-3.815],[0,0],[-3.815,0],[0,0],[0,3.815]],\"v\":[[62.114,-50.06],[70.612,-50.06],[77.548,-56.995],[77.548,-106.06],[70.612,-112.995],[62.114,-112.995],[55.178,-106.06],[55.178,-56.995]],\"c\":true},\"ix\":2},\"nm\":\"Path 2\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ind\":2,\"ty\":\"sh\",\"ix\":3,\"ks\":{\"a\":0,\"k\":{\"i\":[[3.815,0],[0,0],[0,3.815],[0,0],[-3.815,0],[0,0],[0,-3.815],[0,0]],\"o\":[[0,0],[-3.815,0],[0,0],[0,-3.815],[0,0],[3.815,0],[0,0],[0,3.815]],\"v\":[[-77.987,-50.06],[-86.486,-50.06],[-93.421,-56.995],[-93.421,-106.06],[-86.486,-112.995],[-77.987,-112.995],[-71.052,-106.06],[-71.052,-56.995]],\"c\":true},\"ix\":2},\"nm\":\"Path 3\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.219607858097,0.18431372549,0.156862745098,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[250.538,268.113],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 5\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":450,\"st\":0,\"ct\":1,\"bm\":0},{\"ddd\":0,\"ind\":11,\"ty\":4,\"nm\":\"Layer 1 Outlines - Group 9\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[333.146,186.585,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[333.146,186.585,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,2.33],[0,0],[1.974,1.239],[0,0]],\"o\":[[0,0],[1.974,-1.238],[0,0],[0,-2.33],[0,0],[0,0]],\"v\":[[-5.06,16.999],[1.888,12.64],[5.06,6.905],[5.06,-6.905],[1.888,-12.64],[-5.06,-16.999]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ind\":1,\"ty\":\"sh\",\"ix\":2,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,2.33],[0,0],[-1.974,1.239],[0,0]],\"o\":[[0,0],[-1.974,-1.238],[0,0],[0,-2.33],[0,0],[0,0]],\"v\":[[-176.029,16.999],[-182.977,12.64],[-186.149,6.905],[-186.149,-6.905],[-182.977,-12.64],[-176.029,-16.999]],\"c\":true},\"ix\":2},\"nm\":\"Path 2\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.662745098039,0.513725490196,0.400000029919,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[333.146,186.585],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 9\",\"np\":3,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":450,\"st\":0,\"ct\":1,\"bm\":0},{\"ddd\":0,\"ind\":12,\"ty\":4,\"nm\":\"Layer 1 Outlines - Group 16\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[242.513,116.373,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[242.513,116.373,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[38.697,0],[0,-38.697],[0,0],[0,0],[0,0],[-43.144,0],[0,-43.143]],\"o\":[[0,0],[0,0],[0,-38.697],[-38.697,0],[0,0],[0,0],[0,0],[0,-43.143],[43.143,0],[0,0]],\"v\":[[78.243,59.915],[70.18,59.915],[70.18,18.327],[0,-51.852],[-70.179,18.327],[-70.179,59.915],[-78.243,59.915],[-78.243,18.327],[0,-59.915],[78.243,18.327]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ind\":1,\"ty\":\"sh\",\"ix\":2,\"ks\":{\"a\":0,\"k\":{\"i\":[[31.779,0],[0,0],[0,29.111],[0,0]],\"o\":[[0,0],[29.111,0],[0,0],[0,31.779]],\"v\":[[19.174,154.159],[19.174,149.321],[71.969,96.526],[76.807,96.526]],\"c\":true},\"ix\":2},\"nm\":\"Path 2\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.764705942191,0.713725490196,0.670588235294,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[242.513,116.373],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 16\",\"np\":3,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":450,\"st\":0,\"ct\":1,\"bm\":0}],\"markers\":[]}");


const $ea62222f2a4838ad$var$AnimatedUspTeaserSchoolDirectorsHeadset = (props)=>{
    const text = (0, $e6aeb63e6149c504$export$161fa9a9af21e7de)('text', props.mountRootId) || '';
    const linkText = (0, $e6aeb63e6149c504$export$161fa9a9af21e7de)('link-text', props.mountRootId) || '';
    const link = (0, $e6aeb63e6149c504$export$161fa9a9af21e7de)('link', props.mountRootId) || '';
    const heading = (0, $e6aeb63e6149c504$export$161fa9a9af21e7de)('heading', props.mountRootId) || '';
    let color = (0, $e6aeb63e6149c504$export$161fa9a9af21e7de)('color', props.mountRootId) || '';
    color = color.toLowerCase();
    const lottieRef = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useRef();
    const teaserRef = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useRef();
    const [hovered, setHovered] = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useState(false);
    const enter = ()=>setHovered(true);
    const leave = ()=>setHovered(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useEffect(()=>{
        const container = teaserRef.current;
        if (container) {
            container.addEventListener('mouseenter', enter);
            return ()=>{
                container.removeEventListener('mouseenter', enter);
            };
        }
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useEffect(()=>{
        if (lottieRef) {
            if (hovered === true) {
                lottieRef.current.play();
                // timeout to ensure animation is completed despite mouseleave
                const timer = setTimeout(leave, 1200);
                return ()=>clearTimeout(timer);
            }
            if (hovered === false) lottieRef.current.stop();
        }
    }, [
        hovered
    ]);
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
        className: `animated-usp-teaser animated-usp-teaser--headset teaser--${color} block-spacing`,
        ref: teaserRef,
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2c1cc6e8319f49c7$exports))), {
                className: "animated-usp-teaser__animation",
                animationData: (0, (/*@__PURE__*/$parcel$interopDefault($2d63a60fcde866fc$exports))),
                lottieRef: lottieRef
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                className: "animated-usp-teaser__content",
                children: [
                    heading && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("h2", {
                        className: "animated-usp-teaser__content__title",
                        children: heading
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $96c25128201e5f07$export$2e2bcd8739ae039), {
                        className: "animated-usp-teaser__content__content",
                        children: text
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("a", {
                        className: "button button--usp",
                        href: link,
                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                            children: linkText
                        })
                    })
                ]
            })
        ]
    });
};
// state
const $ea62222f2a4838ad$var$mapStateToProps = (state)=>{
    return {};
};
const $ea62222f2a4838ad$var$mapDispatchToProps = (dispatch)=>{
    return {};
};
var $ea62222f2a4838ad$export$2e2bcd8739ae039 = $ea62222f2a4838ad$var$AnimatedUspTeaserSchoolDirectorsHeadset;




var $8NFma = parcelRequire("8NFma");




var $c37229b1cb62cc06$exports = {};
$c37229b1cb62cc06$exports = JSON.parse("{\"v\":\"5.7.8\",\"fr\":30,\"ip\":0,\"op\":60,\"w\":516,\"h\":208,\"nm\":\"feedback\",\"ddd\":0,\"assets\":[],\"layers\":[{\"ddd\":0,\"ind\":1,\"ty\":4,\"nm\":\"dot06\",\"parent\":21,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":30,\"s\":[11.768,29.63,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":34,\"s\":[11.768,21.63,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":38,\"s\":[11.768,29.63,0]}],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[411.852,40.471,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[1.785,0],[0,-1.785],[-1.785,0],[0,1.785]],\"o\":[[-1.785,0],[0,1.785],[1.785,0],[0,-1.785]],\"v\":[[0,-3.233],[-3.233,0],[0,3.233],[3.233,0]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,1,1,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[411.852,40.471],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":60,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":2,\"ty\":4,\"nm\":\"dot05\",\"parent\":21,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":28,\"s\":[-0.036,29.63,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":32,\"s\":[-0.036,21.63,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":36,\"s\":[-0.036,29.63,0]}],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[400.048,40.471,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[1.785,0],[0,-1.785],[-1.785,0],[0,1.785]],\"o\":[[-1.785,0],[0,1.785],[1.785,0],[0,-1.785]],\"v\":[[0,-3.233],[-3.233,0],[0,3.233],[3.233,0]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,1,1,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[400.048,40.471],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":60,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":3,\"ty\":4,\"nm\":\"dot04\",\"parent\":21,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":26,\"s\":[-11.841,29.63,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":30,\"s\":[-11.841,21.63,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":34,\"s\":[-11.841,29.63,0]}],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[388.243,40.471,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[1.785,0],[0,-1.785],[-1.785,0],[0,1.785]],\"o\":[[-1.785,0],[0,1.785],[1.785,0],[0,-1.785]],\"v\":[[0,-3.233],[-3.233,0],[0,3.233],[3.233,0]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,1,1,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[388.243,40.471],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":60,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":4,\"ty\":4,\"nm\":\"dot03\",\"parent\":21,\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":31,\"s\":[0]},{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":35,\"s\":[50]},{\"t\":39,\"s\":[0]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":31,\"s\":[11.768,29.63,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":35,\"s\":[11.768,21.63,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":39,\"s\":[11.768,29.63,0]}],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[411.852,40.471,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[1.785,0],[0,-1.785],[-1.785,0],[0,1.785]],\"o\":[[-1.785,0],[0,1.785],[1.785,0],[0,-1.785]],\"v\":[[0,-3.233],[-3.233,0],[0,3.233],[3.233,0]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,1,1,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[411.852,40.471],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":60,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":5,\"ty\":4,\"nm\":\"dot02\",\"parent\":21,\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":29,\"s\":[0]},{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":33,\"s\":[50]},{\"t\":37,\"s\":[0]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":29,\"s\":[-0.036,29.63,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":33,\"s\":[-0.036,21.63,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":37,\"s\":[-0.036,29.63,0]}],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[400.048,40.471,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[1.785,0],[0,-1.785],[-1.785,0],[0,1.785]],\"o\":[[-1.785,0],[0,1.785],[1.785,0],[0,-1.785]],\"v\":[[0,-3.233],[-3.233,0],[0,3.233],[3.233,0]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,1,1,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[400.048,40.471],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":60,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":6,\"ty\":4,\"nm\":\"dot01\",\"parent\":21,\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":27,\"s\":[0]},{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":31,\"s\":[50]},{\"t\":35,\"s\":[0]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":27,\"s\":[-11.841,29.63,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":31,\"s\":[-11.841,21.63,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":35,\"s\":[-11.841,29.63,0]}],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[388.243,40.471,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[1.785,0],[0,-1.785],[-1.785,0],[0,1.785]],\"o\":[[-1.785,0],[0,1.785],[1.785,0],[0,-1.785]],\"v\":[[0,-3.233],[-3.233,0],[0,3.233],[3.233,0]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,1,1,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[388.243,40.471],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":60,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":7,\"ty\":4,\"nm\":\"dot09\",\"parent\":21,\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":32,\"s\":[0]},{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":36,\"s\":[50]},{\"t\":40,\"s\":[0]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":32,\"s\":[11.768,29.63,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":36,\"s\":[11.768,21.63,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":40,\"s\":[11.768,29.63,0]}],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[411.852,40.471,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[1.785,0],[0,-1.785],[-1.785,0],[0,1.785]],\"o\":[[-1.785,0],[0,1.785],[1.785,0],[0,-1.785]],\"v\":[[0,-3.233],[-3.233,0],[0,3.233],[3.233,0]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,1,1,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[411.852,40.471],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":60,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":8,\"ty\":4,\"nm\":\"dot08\",\"parent\":21,\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":30,\"s\":[0]},{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":34,\"s\":[50]},{\"t\":38,\"s\":[0]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":30,\"s\":[-0.036,29.63,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":34,\"s\":[-0.036,21.63,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":38,\"s\":[-0.036,29.63,0]}],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[400.048,40.471,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[1.785,0],[0,-1.785],[-1.785,0],[0,1.785]],\"o\":[[-1.785,0],[0,1.785],[1.785,0],[0,-1.785]],\"v\":[[0,-3.233],[-3.233,0],[0,3.233],[3.233,0]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,1,1,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[400.048,40.471],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":60,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":9,\"ty\":4,\"nm\":\"dot07\",\"parent\":21,\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":28,\"s\":[0]},{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":32,\"s\":[50]},{\"t\":36,\"s\":[0]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":28,\"s\":[-11.841,29.63,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":32,\"s\":[-11.841,21.63,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":36,\"s\":[-11.841,29.63,0]}],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[388.243,40.471,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[1.785,0],[0,-1.785],[-1.785,0],[0,1.785]],\"o\":[[-1.785,0],[0,1.785],[1.785,0],[0,-1.785]],\"v\":[[0,-3.233],[-3.233,0],[0,3.233],[3.233,0]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,1,1,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[388.243,40.471],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":60,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":10,\"ty\":4,\"nm\":\"lightbulb_socket\",\"parent\":18,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[-0.319,64.883,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[430.056,154.883,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0]],\"o\":[[0,0],[0,0]],\"v\":[[423.707,149.127],[436.405,149.127]],\"c\":false},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ind\":1,\"ty\":\"sh\",\"ix\":2,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0]],\"o\":[[0,0],[0,0]],\"v\":[[423.707,153.379],[436.405,153.379]],\"c\":false},\"ix\":2},\"nm\":\"Path 2\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ind\":2,\"ty\":\"sh\",\"ix\":3,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0]],\"o\":[[0,0],[0,0]],\"v\":[[423.707,157.632],[436.405,157.632]],\"c\":false},\"ix\":2},\"nm\":\"Path 3\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"mm\",\"mm\":1,\"nm\":\"Merge Paths 1\",\"mn\":\"ADBE Vector Filter - Merge\",\"hd\":false},{\"ty\":\"st\",\"c\":{\"a\":0,\"k\":[0.819607902976,0.819607902976,0.819607902976,1],\"ix\":3},\"o\":{\"a\":0,\"k\":100,\"ix\":4},\"w\":{\"a\":0,\"k\":2,\"ix\":5},\"lc\":1,\"lj\":1,\"ml\":10,\"bm\":0,\"nm\":\"Stroke 1\",\"mn\":\"ADBE Vector Graphic - Stroke\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[0,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":5,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0.794,0],[0,0],[0,0.794],[0,0],[0,0],[0,0]],\"o\":[[0,0],[-0.794,0],[0,0],[0,0],[0,0],[0,0.794]],\"v\":[[1.547,1.575],[-1.547,1.575],[-2.984,0.137],[-2.984,-1.575],[2.984,-1.575],[2.984,0.137]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.819607902976,0.819607902976,0.819607902976,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[430.103,162.536],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 2\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0.201,0],[0,0],[0,0.201],[0,0],[-0.201,0],[0,0],[0,-0.201],[0,0]],\"o\":[[0,0],[-0.201,0],[0,0],[0,-0.201],[0,0],[0.201,0],[0,0],[0,0.201]],\"v\":[[5.549,7.654],[-5.549,7.654],[-5.913,7.29],[-5.913,-7.29],[-5.549,-7.654],[5.549,-7.654],[5.913,-7.29],[5.913,7.29]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.686274509804,0.686274509804,0.686274509804,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[430.098,153.308],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 3\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":3,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":60,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":11,\"ty\":4,\"nm\":\"lightbulb_wire\",\"parent\":18,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[-0.273,36.568,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[430.102,126.568,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[-8.768,-1.288],[-6.269,1.288],[-3.767,-1.288],[-1.262,1.288],[1.243,-1.288],[3.748,1.288],[6.258,-1.288],[8.768,1.288]],\"c\":false},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"st\",\"c\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":19,\"s\":[0.466666696586,0.341176470588,0.141176470588,1]},{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":26,\"s\":[1,0.645879387856,0.480366289616,1]},{\"t\":39,\"s\":[0.466666696586,0.341176470588,0.141176470588,1]}],\"ix\":3},\"o\":{\"a\":0,\"k\":100,\"ix\":4},\"w\":{\"a\":0,\"k\":0.8,\"ix\":5},\"lc\":1,\"lj\":1,\"ml\":10,\"bm\":0,\"nm\":\"Stroke 1\",\"mn\":\"ADBE Vector Graphic - Stroke\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[430.102,126.568],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":60,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":12,\"ty\":4,\"nm\":\"lightbulb_glass\",\"parent\":18,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[-0.272,40.624,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[430.103,130.624,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,4.565],[8.118,-0.229],[-0.331,-7.868],[-3.168,-2.507],[0,-2.992],[0,0],[0,0],[0,0],[-2.398,1.894]],\"o\":[[0,-8.067],[-7.872,0.222],[0.182,4.31],[2.346,1.857],[0,0],[0,0],[0,0],[0,-3.056],[3.324,-2.625]],\"v\":[[14.515,-4.605],[-0.256,-18.956],[-14.184,-3.992],[-8.748,6.636],[-4.905,14.207],[-4.905,19.185],[5.224,19.185],[5.224,14.45],[9.057,6.644]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":19,\"s\":[1,0.807843197093,0.20000001496,1]},{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":26,\"s\":[1,0.86962223053,0.457202613354,1]},{\"t\":39,\"s\":[1,0.807843197093,0.20000001496,1]}],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[429.943,130.512],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":60,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":13,\"ty\":4,\"nm\":\"LightGlow\",\"parent\":18,\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":16,\"s\":[0]},{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":26,\"s\":[15]},{\"t\":39,\"s\":[0]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[-0.083,36.792,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[151.292,44.292,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"d\":1,\"ty\":\"el\",\"s\":{\"a\":0,\"k\":[58.585,58.585],\"ix\":2},\"p\":{\"a\":0,\"k\":[0,0],\"ix\":3},\"nm\":\"Ellipse Path 1\",\"mn\":\"ADBE Vector Shape - Ellipse\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,1,1,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[151.292,44.292],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Ellipse 1\",\"np\":3,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":16,\"op\":39,\"st\":3,\"bm\":0},{\"ddd\":0,\"ind\":14,\"ty\":4,\"nm\":\"heart\",\"parent\":19,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[-0.647,84.255,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[256.978,114.839,0],\"ix\":1,\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":12,\"s\":[107,107,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":18,\"s\":[120,120,100]},{\"t\":25,\"s\":[107,107,100]}],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[10.667,0],[2.841,-6.877],[8.142,0],[0,-10.291],[0,0],[-6.85,-4.614],[0,16.96],[0,0]],\"o\":[[-8.142,0],[-2.841,-6.877],[-10.667,0],[0,0],[0,16.96],[6.85,-4.614],[0,0],[0,-10.291]],\"v\":[[17.936,-31.486],[0,-19.741],[-17.935,-31.486],[-37.248,-12.852],[-37.248,-11.521],[0,31.486],[37.248,-11.521],[37.248,-12.852]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.870588295133,0.050980395897,0.262745098039,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[256.978,114.839],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":60,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":15,\"ty\":4,\"nm\":\"pot\",\"parent\":20,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":4,\"s\":[0.862,87.123,0],\"to\":[0,-0.833,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":10,\"s\":[0.862,82.123,0],\"to\":[0,0,0],\"ti\":[0,-0.833,0]},{\"t\":17,\"s\":[0.862,87.123,0]}],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[87.175,150.35,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[-17.065,1.822],[17.065,1.822],[17.065,-1.822],[-17.065,-1.822]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.815686334348,0.313725490196,0.070588235294,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[86.986,165.142],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-1.421],[1.421,0],[0,1.421],[-1.421,0]],\"o\":[[0,1.421],[-1.421,0],[0,-1.421],[1.421,0]],\"v\":[[2.571,-0.002],[0,2.571],[-2.571,-0.002],[0,-2.571]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.996078491211,0.63137254902,0.172549019608,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[75.518,147.018],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 2\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[21.168,3.488],[-21.168,3.488],[-21.168,-3.488],[21.168,-3.488]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.780392216701,0.239215701234,0.043137254902,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[87.175,137.224],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 3\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":3,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[-9.369,-14.161],[-9.369,14.161],[6.834,14.161],[9.369,-14.161]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.815686334348,0.313725490196,0.070588235294,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[96.297,151.349],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 4\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":4,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[-18.667,-14.161],[-16.131,14.161],[16.131,14.161],[18.667,-14.161]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.949019667682,0.392156892664,0.082352941176,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[86.999,151.349],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 5\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":5,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":60,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":16,\"ty\":4,\"nm\":\"catus\",\"parent\":20,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":6,\"s\":[-0.001,51.876,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":12,\"s\":[-0.001,46.876,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":19,\"s\":[-0.001,51.876,0]}],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[86.312,115.102,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[2.456,-23.018],[-2.456,-23.018],[-2.456,23.018],[2.456,23.018]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.20000001496,0.627450980392,0.172549019608,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[86.608,116.659],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[2.889,1.257],[0,0],[0,0]],\"o\":[[0,-3.352],[0,0],[0,0],[0,0]],\"v\":[[2.456,-15.192],[-2.456,-22.679],[-2.456,22.679],[2.456,22.679]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.20000001496,0.627450980392,0.172549019608,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[96.789,116.998],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 2\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0.041,-3.311]],\"o\":[[0,0],[0,0],[-2.863,1.243],[0,0]],\"v\":[[-2.456,22.68],[2.456,22.68],[2.456,-22.68],[-2.456,-15.291]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.20000001496,0.627450980392,0.172549019608,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[75.957,116.996],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 3\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":3,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[4.51,0],[0,0],[0,-4.51],[0,0],[0,0],[0,0]],\"o\":[[0,0],[-4.51,0],[0,0],[0,0],[0,0],[0,-4.51]],\"v\":[[4.71,-23.018],[-4.71,-23.018],[-12.875,-14.852],[-12.875,23.018],[12.875,23.018],[12.875,-14.852]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.074509803922,0.466666696586,0.043137254902,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[86.37,116.659],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 4\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":4,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[1.096,-1.331],[0.237,1.668],[-1.096,1.184],[0.169,-1.668]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.027450982262,0.286274509804,0,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[92.785,92.989],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 5\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":5,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[1.605,-0.628],[-0.752,1.416],[-1.605,0.283],[1.012,-1.416]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.027450982262,0.286274509804,0,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[98.272,97.25],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 6\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":6,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[1.556,0.493],[-1.556,0.709],[-1.556,-0.709],[1.556,-0.493]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.027450982262,0.286274509804,0,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[100.334,103.38],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 7\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":7,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[0.493,-1.556],[0.709,1.556],[-0.709,1.556],[-0.493,-1.556]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.027450982262,0.286274509804,0,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[86.37,92.085],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 8\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":8,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[1.556,0.493],[-1.556,0.709],[-1.556,-0.709],[1.556,-0.493]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.027450982262,0.286274509804,0,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[100.334,109.593],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 9\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":9,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[1.556,0.493],[-1.556,0.709],[-1.556,-0.709],[1.556,-0.493]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.027450982262,0.286274509804,0,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[100.334,115.806],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 10\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":10,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[1.556,0.493],[-1.556,0.709],[-1.556,-0.709],[1.556,-0.493]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.027450982262,0.286274509804,0,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[100.334,122.019],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 11\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":11,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[1.556,0.493],[-1.556,0.709],[-1.556,-0.709],[1.556,-0.493]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.027450982262,0.286274509804,0,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[100.334,134.354],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 12\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":12,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[-1.556,0.493],[1.556,0.709],[1.556,-0.709],[-1.556,-0.493]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.027450982262,0.286274509804,0,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[72.29,134.354],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 13\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":13,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[1.556,0.493],[-1.556,0.709],[-1.556,-0.709],[1.556,-0.493]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.027450982262,0.286274509804,0,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[100.334,128.232],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 14\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":14,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[-1.096,-1.331],[-0.236,1.668],[1.096,1.184],[-0.169,-1.668]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.027450982262,0.286274509804,0,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[79.839,92.989],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 15\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":15,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[-1.605,-0.628],[0.752,1.416],[1.605,0.283],[-1.012,-1.416]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.027450982262,0.286274509804,0,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[74.352,97.25],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 16\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":16,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[-1.556,0.493],[1.556,0.709],[1.556,-0.709],[-1.556,-0.493]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.027450982262,0.286274509804,0,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[72.29,103.38],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 17\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":17,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[-1.556,0.493],[1.556,0.709],[1.556,-0.709],[-1.556,-0.493]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.027450982262,0.286274509804,0,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[72.29,109.593],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 18\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":18,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[-1.556,0.493],[1.556,0.709],[1.556,-0.709],[-1.556,-0.493]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.027450982262,0.286274509804,0,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[72.29,115.806],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 19\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":19,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[-1.556,0.493],[1.556,0.709],[1.556,-0.709],[-1.556,-0.493]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.027450982262,0.286274509804,0,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[72.29,122.019],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 20\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":20,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[-1.556,0.493],[1.556,0.709],[1.556,-0.709],[-1.556,-0.493]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.027450982262,0.286274509804,0,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[72.29,128.232],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 21\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":21,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":60,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":17,\"ty\":4,\"nm\":\"potshadow\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":0,\"s\":[80]},{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":10,\"s\":[43]},{\"t\":17,\"s\":[80]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[87.14,174.68,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[-171.985,65.18,0],\"ix\":1,\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":0,\"s\":[100,100,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":10,\"s\":[102,177,100]},{\"t\":17,\"s\":[100,100,100]}],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"d\":1,\"ty\":\"el\",\"s\":{\"a\":0,\"k\":[37.529,3.361],\"ix\":2},\"p\":{\"a\":0,\"k\":[0,0],\"ix\":3},\"nm\":\"Ellipse Path 1\",\"mn\":\"ADBE Vector Shape - Ellipse\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.033311656877,0.410703591739,0.540558938419,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[-171.985,65.18],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Ellipse 1\",\"np\":3,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":60,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":18,\"ty\":3,\"nm\":\"lightbulbposition\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":0,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":16,\"s\":[430.375,90,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":24,\"s\":[430.375,81,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":38,\"s\":[430.375,90,0]}],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[0,0,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"ip\":0,\"op\":60,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":19,\"ty\":3,\"nm\":\"heartposition\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":0,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":8,\"s\":[257.625,40.062,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.169,\"y\":0.976},\"o\":{\"x\":0.333,\"y\":0},\"t\":16,\"s\":[257.625,26.188,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":30,\"s\":[257.625,40.062,0]}],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[0,0,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"ip\":0,\"op\":60,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":20,\"ty\":3,\"nm\":\"potposition\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":0,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":0,\"s\":[86.312,70.75,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":8,\"s\":[86.312,60.125,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":22,\"s\":[86.312,70.75,0]}],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[0,0,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"ip\":0,\"op\":60,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":21,\"ty\":3,\"nm\":\"dotposition\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":0,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":20,\"s\":[400.084,10.841,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":28,\"s\":[400.084,4.841,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":42,\"s\":[400.084,10.841,0]}],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[0,0,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"ip\":0,\"op\":60,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":22,\"ty\":4,\"nm\":\"bubble04_orange\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[399.607,83.583,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[399.607,83.583,0],\"ix\":1,\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":20,\"s\":[100,100,100]},{\"i\":{\"x\":[0.218,0.218,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":28,\"s\":[108,108,100]},{\"t\":42,\"s\":[100,100,100]}],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,-6.399],[0,0],[-6.4,0],[0,0],[0,0],[0,0]],\"o\":[[-6.4,0],[0,0],[0,6.4],[0,0],[0,0],[0,0],[0,0]],\"v\":[[-5.027,-36.602],[-16.614,-25.015],[-16.614,11.282],[-5.027,22.869],[11.861,22.869],[16.614,36.602],[16.614,-36.602]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,0.372549019608,0.152941176471,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[382.993,46.981],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[6.4,0],[0,0],[0,-6.399],[0,0],[-6.4,0],[0,0],[0,0],[0,0],[0,0],[0,6.4],[0,0]],\"o\":[[0,0],[-6.4,0],[0,0],[0,6.4],[0,0],[0,0],[0,0],[0,0],[6.4,0],[0,0],[0,-6.399]],\"v\":[[21.64,-36.602],[-21.641,-36.602],[-33.228,-25.015],[-33.228,11.282],[-21.641,22.869],[-4.753,22.869],[0,36.602],[4.753,22.869],[21.64,22.869],[33.228,11.282],[33.228,-25.015]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,0.301960784314,0.003921568627,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[399.607,46.981],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 2\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":60,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":23,\"ty\":4,\"nm\":\"bubble03_green\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[430.103,200.443,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[430.103,200.443,0],\"ix\":1,\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":16,\"s\":[100,100,100]},{\"i\":{\"x\":[0.218,0.218,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":24,\"s\":[108,108,100]},{\"t\":38,\"s\":[100,100,100]}],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-6.4],[0,0],[-6.4,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,6.4],[0,0],[0,0],[0,0],[0,0],[-6.4,0]],\"v\":[[-31.637,-43.829],[-31.637,28.796],[-20.05,40.383],[26.434,40.383],[31.637,55.416],[31.637,-55.416],[-20.05,-55.416]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.345098039216,0.729411764706,0.56862745098,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[398.465,145.026],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[6.399,0],[0,0],[0,-6.4],[0,0],[-6.4,0],[0,0],[0,0],[0,0],[0,0],[0,6.4],[0,0]],\"o\":[[0,0],[-6.4,0],[0,0],[0,6.4],[0,0],[0,0],[0,0],[0,0],[6.399,0],[0,0],[0,-6.4]],\"v\":[[49.112,-55.417],[-49.112,-55.417],[-60.7,-43.829],[-60.7,28.795],[-49.112,40.383],[-2.629,40.383],[2.575,55.417],[7.779,40.383],[49.112,40.383],[60.7,28.795],[60.7,-43.829]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.231372563979,0.619607843137,0.443137284821,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[427.527,145.026],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 2\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":60,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":24,\"ty\":4,\"nm\":\"bubble02_beige\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[256.634,204.578,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[256.634,204.578,0],\"ix\":1,\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":8,\"s\":[100,100,100]},{\"i\":{\"x\":[0.218,0.218,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":16,\"s\":[108,108,100]},{\"t\":30,\"s\":[100,100,100]}],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[-6.4,0],[0,0],[0,0],[0,0],[0,0],[0,-6.4],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[-6.4,0],[0,0],[0,6.4]],\"v\":[[-34.706,63.488],[39.665,63.488],[46.293,82.636],[46.293,-82.636],[-34.706,-82.636],[-46.293,-71.049],[-46.293,51.901]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.886274569642,0.811764765721,0.686274509804,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[210.341,121.941],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[6.4,0],[0,0],[0,-6.4],[0,0],[-6.4,0],[0,0],[0,0],[0,0],[0,0],[0,6.4],[0,0]],\"o\":[[0,0],[-6.4,0],[0,0],[0,6.4],[0,0],[0,0],[0,0],[0,0],[6.4,0],[0,0],[0,-6.4]],\"v\":[[80.999,-82.637],[-80.999,-82.637],[-92.586,-71.049],[-92.586,51.901],[-80.999,63.488],[-6.628,63.488],[0,82.637],[6.628,63.488],[80.999,63.488],[92.586,51.901],[92.586,-71.049]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.839215746113,0.749019607843,0.576470588235,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[256.634,121.941],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 2\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":60,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":25,\"ty\":4,\"nm\":\"bubble01_blue\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[86.371,199.095,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[86.371,199.095,0],\"ix\":1,\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":0,\"s\":[100,100,100]},{\"i\":{\"x\":[0.218,0.218,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":8,\"s\":[108,108,100]},{\"t\":22,\"s\":[100,100,100]}],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,-7.611],[0,0],[-7.611,0],[0,0],[0,0]],\"o\":[[0,0],[-7.611,0],[0,0],[0,7.611],[0,0],[0,0],[0,0]],\"v\":[[29.299,-64.742],[-15.518,-64.742],[-29.299,-50.961],[-29.299,36.422],[-15.518,50.202],[24.266,50.202],[29.299,64.742]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.458823559331,0.737254901961,0.85882358925,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[57.072,134.353],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[7.611,0],[0,0],[0,-7.611],[0,0],[-7.611,0],[0,0],[0,0],[0,0],[0,0],[0,7.611],[0,0]],\"o\":[[0,0],[-7.611,0],[0,0],[0,7.611],[0,0],[0,0],[0,0],[0,0],[7.611,0],[0,0],[0,-7.611]],\"v\":[[44.817,-64.742],[-44.817,-64.742],[-58.597,-50.961],[-58.597,36.422],[-44.817,50.202],[-5.032,50.202],[0,64.742],[5.033,50.202],[44.817,50.202],[58.597,36.422],[58.597,-50.961]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.317647058824,0.682352941176,0.807843197093,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[86.37,134.354],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 2\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":60,\"st\":0,\"bm\":0}],\"markers\":[{\"tm\":8,\"cm\":\"1\",\"dr\":0},{\"tm\":16,\"cm\":\"2\",\"dr\":0},{\"tm\":24,\"cm\":\"3\",\"dr\":0},{\"tm\":32,\"cm\":\"4\",\"dr\":0},{\"tm\":46,\"cm\":\"5\",\"dr\":0}]}");


const $d761a2753cd2a255$var$AnimatedUspTeaserCustomerSurvey = (props)=>{
    const text = (0, $e6aeb63e6149c504$export$161fa9a9af21e7de)('text', props.mountRootId) || '';
    const linkText = (0, $e6aeb63e6149c504$export$161fa9a9af21e7de)('link-text', props.mountRootId) || '';
    const link = (0, $e6aeb63e6149c504$export$161fa9a9af21e7de)('link', props.mountRootId) || '';
    const heading = (0, $e6aeb63e6149c504$export$161fa9a9af21e7de)('heading', props.mountRootId) || '';
    let color = (0, $e6aeb63e6149c504$export$161fa9a9af21e7de)('color', props.mountRootId) || '';
    color = color.toLowerCase();
    const lottieRef = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useRef();
    const teaserRef = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useRef();
    const [hovered, setHovered] = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useState(false);
    const enter = ()=>setHovered(true);
    const leave = ()=>setHovered(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useEffect(()=>{
        const container = teaserRef.current;
        if (container) {
            container.addEventListener('mouseenter', enter);
            return ()=>{
                container.removeEventListener('mouseenter', enter);
            };
        }
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useEffect(()=>{
        if (lottieRef) {
            if (hovered === true) {
                lottieRef.current.play();
                // timeout to ensure animation is completed despite mouseleave
                const timer = setTimeout(leave, 1200);
                return ()=>clearTimeout(timer);
            }
            if (hovered === false) lottieRef.current.stop();
        }
    }, [
        hovered
    ]);
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
        className: `animated-usp-teaser animated-usp-teaser--survey teaser--${color} block-spacing`,
        ref: teaserRef,
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2c1cc6e8319f49c7$exports))), {
                className: "animated-usp-teaser__animation",
                animationData: (0, (/*@__PURE__*/$parcel$interopDefault($c37229b1cb62cc06$exports))),
                lottieRef: lottieRef
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                className: "animated-usp-teaser__content",
                children: [
                    heading && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("h2", {
                        className: "animated-usp-teaser__content__title",
                        children: heading
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $96c25128201e5f07$export$2e2bcd8739ae039), {
                        className: "animated-usp-teaser__content__content",
                        children: text
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("a", {
                        className: "button button--usp",
                        href: link,
                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                            children: linkText
                        })
                    })
                ]
            })
        ]
    });
};
var $d761a2753cd2a255$export$2e2bcd8739ae039 = $d761a2753cd2a255$var$AnimatedUspTeaserCustomerSurvey;




var $8NFma = parcelRequire("8NFma");



var $1c43ced9d1543c74$exports = {};
$1c43ced9d1543c74$exports = JSON.parse("{\"v\":\"5.9.6\",\"fr\":30,\"ip\":0,\"op\":60,\"w\":360,\"h\":190,\"nm\":\"00_teaser\",\"ddd\":0,\"assets\":[{\"id\":\"comp_0\",\"nm\":\"star_blink\",\"fr\":30,\"layers\":[{\"ddd\":0,\"ind\":1,\"ty\":4,\"nm\":\"star01\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.18],\"y\":[1]},\"o\":{\"x\":[0.84],\"y\":[0]},\"t\":0,\"s\":[0]},{\"i\":{\"x\":[0.18],\"y\":[1]},\"o\":{\"x\":[0.84],\"y\":[0]},\"t\":18.062,\"s\":[100]},{\"t\":36.12109375,\"s\":[0]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[18.874,19.183,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[245.928,18.399,0],\"ix\":1,\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.18,0.18,0.18],\"y\":[1,1,1]},\"o\":{\"x\":[0.84,0.84,0.84],\"y\":[0,0,0]},\"t\":0,\"s\":[0,0,100]},{\"i\":{\"x\":[0.18,0.18,0.18],\"y\":[1,1,1]},\"o\":{\"x\":[0.84,0.84,0.84],\"y\":[0,0,0]},\"t\":18.062,\"s\":[100,100,100]},{\"t\":36.12109375,\"s\":[0,0,100]}],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[1.862,10.888],[10.888,-1.862],[-1.862,-10.888],[-10.888,1.861]],\"o\":[[-1.238,10.205],[10.205,1.237],[1.237,-10.205],[-10.205,-1.238]],\"v\":[[0,-18.149],[-18.149,0.001],[0,18.149],[18.149,0.001]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.949019667682,0.949019667682,0.949019667682,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[245.928,18.399],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 4\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":37,\"st\":0,\"ct\":1,\"bm\":0}]},{\"id\":\"comp_1\",\"nm\":\"star_blink_teaser\",\"fr\":30,\"layers\":[{\"ddd\":0,\"ind\":1,\"ty\":4,\"nm\":\"star01\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.18],\"y\":[1]},\"o\":{\"x\":[0.84],\"y\":[0]},\"t\":0,\"s\":[0]},{\"i\":{\"x\":[0.18],\"y\":[1]},\"o\":{\"x\":[0.84],\"y\":[0]},\"t\":18.062,\"s\":[100]},{\"t\":36.12109375,\"s\":[0]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[18.874,19.183,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[245.928,18.399,0],\"ix\":1,\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.18,0.18,0.18],\"y\":[1,1,1]},\"o\":{\"x\":[0.84,0.84,0.84],\"y\":[0,0,0]},\"t\":0,\"s\":[0,0,100]},{\"i\":{\"x\":[0.18,0.18,0.18],\"y\":[1,1,1]},\"o\":{\"x\":[0.84,0.84,0.84],\"y\":[0,0,0]},\"t\":18.062,\"s\":[100,100,100]},{\"t\":36.12109375,\"s\":[0,0,100]}],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[1.862,10.888],[10.888,-1.862],[-1.862,-10.888],[-10.888,1.861]],\"o\":[[-1.238,10.205],[10.205,1.237],[1.237,-10.205],[-10.205,-1.238]],\"v\":[[0,-18.149],[-18.149,0.001],[0,18.149],[18.149,0.001]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,0.737274169922,0.333333313465,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[245.928,18.399],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 4\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":37,\"st\":0,\"ct\":1,\"bm\":0}]}],\"layers\":[{\"ddd\":0,\"ind\":1,\"ty\":0,\"nm\":\"star_blink\",\"refId\":\"comp_0\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[310,131.5,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[19,19,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"w\":38,\"h\":38,\"ip\":30,\"op\":67,\"st\":30,\"bm\":0},{\"ddd\":0,\"ind\":2,\"ty\":0,\"nm\":\"star_blink_teaser\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[41.5,52.5,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[19,19,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"w\":38,\"h\":38,\"ip\":5,\"op\":42,\"st\":5,\"bm\":0},{\"ddd\":0,\"ind\":3,\"ty\":0,\"nm\":\"star_blink_teaser\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[79,123,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[19,19,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[50,50,100],\"ix\":6,\"l\":2}},\"ao\":0,\"w\":38,\"h\":38,\"ip\":17,\"op\":54,\"st\":17,\"bm\":0},{\"ddd\":0,\"ind\":4,\"ty\":0,\"nm\":\"star_blink_teaser\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[282,51.5,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[19,19,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[40,40,100],\"ix\":6,\"l\":2}},\"ao\":0,\"w\":38,\"h\":38,\"ip\":-3,\"op\":34,\"st\":-3,\"bm\":0},{\"ddd\":0,\"ind\":5,\"ty\":4,\"nm\":\"eyes\",\"parent\":9,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[182.929,75.612,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[182.929,75.612,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[-4.798,-0.846],[0.846,-4.798]],\"o\":[[0.846,-4.798],[4.798,0.846],[0,0]],\"v\":[[-9.111,2.469],[1.109,-4.687],[8.265,5.533]],\"c\":false},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"st\",\"c\":{\"a\":0,\"k\":[0.239215701818,0.57647061348,0.305882364511,1],\"ix\":3},\"o\":{\"a\":0,\"k\":100,\"ix\":4},\"w\":{\"a\":0,\"k\":5,\"ix\":5},\"lc\":2,\"lj\":1,\"ml\":10,\"bm\":0,\"nm\":\"Stroke 1\",\"mn\":\"ADBE Vector Graphic - Stroke\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[186.479,54.472],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 5\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[220.071,75.612],\"ix\":2},\"a\":{\"a\":0,\"k\":[186.124,54.827],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"pig Outlines - Group 5\",\"np\":1,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[-4.798,0.846],[-0.846,-4.798]],\"o\":[[-0.846,-4.798],[4.798,-0.846],[0,0]],\"v\":[[-8.265,5.533],[-1.109,-4.687],[9.111,2.469]],\"c\":false},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"st\",\"c\":{\"a\":0,\"k\":[0.239215701818,0.57647061348,0.305882364511,1],\"ix\":3},\"o\":{\"a\":0,\"k\":100,\"ix\":4},\"w\":{\"a\":0,\"k\":5,\"ix\":5},\"lc\":2,\"lj\":1,\"ml\":10,\"bm\":0,\"nm\":\"Stroke 1\",\"mn\":\"ADBE Vector Graphic - Stroke\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[111.486,54.472],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 6\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[145.788,75.612],\"ix\":2},\"a\":{\"a\":0,\"k\":[111.841,54.827],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"pig Outlines - Group 6\",\"np\":1,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":120,\"st\":0,\"ct\":1,\"bm\":0},{\"ddd\":0,\"ind\":6,\"ty\":3,\"nm\":\"mouth-rotator\",\"parent\":9,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":0,\"ix\":11},\"r\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.51],\"y\":[1]},\"o\":{\"x\":[0.54],\"y\":[0]},\"t\":0,\"s\":[0]},{\"i\":{\"x\":[0.51],\"y\":[1]},\"o\":{\"x\":[0.54],\"y\":[0]},\"t\":30,\"s\":[-11]},{\"t\":60,\"s\":[0]}],\"ix\":10},\"p\":{\"a\":0,\"k\":[180,95,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[0,0,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"ip\":0,\"op\":120,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":7,\"ty\":4,\"nm\":\"mouth\",\"parent\":6,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[46.296,30.624,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[192.349,104.839,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[5.403,-3.974]],\"o\":[[-3.39,5.445],[0,0]],\"v\":[[6.665,-7.126],[-6.665,7.126]],\"c\":false},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"st\",\"c\":{\"a\":0,\"k\":[0.239215701234,0.576470588235,0.305882352941,1],\"ix\":3},\"o\":{\"a\":0,\"k\":100,\"ix\":4},\"w\":{\"a\":0,\"k\":5,\"ix\":5},\"lc\":2,\"lj\":1,\"ml\":10,\"bm\":0,\"nm\":\"Stroke 1\",\"mn\":\"ADBE Vector Graphic - Stroke\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[192.349,104.839],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 7\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":120,\"st\":0,\"ct\":1,\"bm\":0},{\"ddd\":0,\"ind\":8,\"ty\":4,\"nm\":\"snot\",\"parent\":9,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[182.915,109.987,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[182.915,109.987,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[2.17,0],[0,0],[0,2.169],[0,0],[-2.17,0],[0,0],[0,-2.169],[0,0]],\"o\":[[0,0],[-2.17,0],[0,0],[0,-2.169],[0,0],[2.17,0],[0,0],[0,2.169]],\"v\":[[0.219,10.816],[-0.219,10.816],[-4.148,6.888],[-4.148,-6.888],[-0.219,-10.816],[0.219,-10.816],[4.147,-6.888],[4.147,6.888]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.239215701818,0.57647061348,0.305882364511,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[158.174,89.203],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 8\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[192.12,109.987],\"ix\":2},\"a\":{\"a\":0,\"k\":[158.174,89.203],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"pig Outlines - Group 8\",\"np\":1,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[2.17,0],[0,0],[0,2.169],[0,0],[-2.17,0],[0,0],[0,-2.169],[0,0]],\"o\":[[0,0],[-2.17,0],[0,0],[0,-2.169],[0,0],[2.17,0],[0,0],[0,2.169]],\"v\":[[0.22,10.816],[-0.218,10.816],[-4.147,6.888],[-4.147,-6.888],[-0.218,-10.816],[0.22,-10.816],[4.148,-6.888],[4.148,6.888]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.239215701818,0.57647061348,0.305882364511,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[139.762,89.203],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 9\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[173.709,109.987],\"ix\":2},\"a\":{\"a\":0,\"k\":[139.762,89.203],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"pig Outlines - Group 9\",\"np\":1,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,14.83],[19.673,0],[0,-14.83],[-19.673,0]],\"o\":[[0,-14.83],[-19.673,0],[0,14.83],[19.673,0]],\"v\":[[35.621,0],[0,-26.852],[-35.621,0],[0,26.852]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.788235366344,0.886274576187,0.800000071526,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[148.969,89.203],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 10\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[182.915,109.987],\"ix\":2},\"a\":{\"a\":0,\"k\":[148.969,89.203],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"pig Outlines - Group 10\",\"np\":1,\"cix\":2,\"bm\":0,\"ix\":3,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":120,\"st\":0,\"ct\":1,\"bm\":0},{\"ddd\":0,\"ind\":9,\"ty\":4,\"nm\":\"head - pig Outlines - Group 11\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.44],\"y\":[1]},\"o\":{\"x\":[0.61],\"y\":[0]},\"t\":0,\"s\":[-10]},{\"i\":{\"x\":[0.44],\"y\":[1]},\"o\":{\"x\":[0.61],\"y\":[0]},\"t\":30,\"s\":[10]},{\"t\":60,\"s\":[-10]}],\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":0,\"s\":[182.915,89.081,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":30,\"s\":[182.915,93.081,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":60,\"s\":[182.915,89.081,0]}],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[182.915,89.081,0],\"ix\":1,\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":0,\"s\":[100,100,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":30,\"s\":[103,98,100]},{\"t\":60,\"s\":[100,100,100]}],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,32.736],[36.909,0],[0,-32.736],[-36.908,0]],\"o\":[[0,-32.736],[-36.908,0],[0,32.736],[36.909,0]],\"v\":[[66.829,6.087],[-0.001,-65.361],[-66.828,6.087],[-0.001,65.361]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.623529434204,0.807843208313,0.654901981354,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[148.969,68.297],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 11\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[182.915,89.081],\"ix\":2},\"a\":{\"a\":0,\"k\":[148.969,68.297],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"pig Outlines - Group 11\",\"np\":1,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":120,\"st\":0,\"ct\":1,\"bm\":0},{\"ddd\":0,\"ind\":10,\"ty\":4,\"nm\":\"ear_R\",\"parent\":9,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.3],\"y\":[1]},\"o\":{\"x\":[0.7],\"y\":[0]},\"t\":0,\"s\":[-13]},{\"i\":{\"x\":[0.3],\"y\":[1]},\"o\":{\"x\":[0.7],\"y\":[0]},\"t\":30,\"s\":[13]},{\"t\":60,\"s\":[-13]}],\"ix\":10},\"p\":{\"a\":0,\"k\":[221.65,44.725,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[221.65,44.725,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ty\":\"gr\",\"it\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[1.009,-4.033],[3.686,1.986],[0,0],[0.079,2.016],[-3.685,-1.986],[0,0]],\"o\":[[-1.727,1.043],[0,0],[-3.685,-1.986],[2.814,-3.061],[0,0],[3.685,1.986]],\"v\":[[8.59,6.303],[-0.598,4.72],[-3.225,3.304],[-9.598,-3.499],[1.445,-5.36],[4.072,-3.944]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.623529434204,0.807843208313,0.654901981354,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[196.012,8.35],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 12\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[229.591,29.308],\"ix\":2},\"a\":{\"a\":0,\"k\":[195.644,8.523],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"pig Outlines - Group 12\",\"np\":1,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[229.591,29.308],\"ix\":2},\"a\":{\"a\":0,\"k\":[229.591,29.308],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"head - pig Outlines - Group 12\",\"np\":1,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ty\":\"gr\",\"it\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[3.786,2.04],[0,0],[2.792,-3.27],[0,0],[-11.337,-6.126]],\"o\":[[0,0],[1.196,-4.13],[0,0],[-3.785,-2.04],[0,0],[0,0],[15.743,9.568]],\"v\":[[9.372,15.268],[14.15,-1.237],[9.712,-11.812],[7.085,-13.228],[-4.188,-11.12],[-15.346,1.946],[-10.488,15.941]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.517647087574,0.749019622803,0.560784339905,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[190.371,16.217],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 13\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[223.9,37.475],\"ix\":2},\"a\":{\"a\":0,\"k\":[189.954,16.69],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"pig Outlines - Group 13\",\"np\":1,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[223.9,37.475],\"ix\":2},\"a\":{\"a\":0,\"k\":[223.9,37.475],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"head - pig Outlines - Group 13\",\"np\":1,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":120,\"st\":0,\"ct\":1,\"bm\":0},{\"ddd\":0,\"ind\":11,\"ty\":4,\"nm\":\"ear_L\",\"parent\":9,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.3],\"y\":[1]},\"o\":{\"x\":[0.7],\"y\":[0]},\"t\":0,\"s\":[-13]},{\"i\":{\"x\":[0.3],\"y\":[1]},\"o\":{\"x\":[0.7],\"y\":[0]},\"t\":30,\"s\":[13]},{\"t\":60,\"s\":[-13]}],\"ix\":10},\"p\":{\"a\":0,\"k\":[144.585,45.225,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[144.585,45.225,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ty\":\"gr\",\"it\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[-1.009,-4.033],[-3.685,1.986],[0,0],[-0.079,2.016],[3.685,-1.986],[0,0]],\"o\":[[1.727,1.043],[0,0],[3.685,-1.986],[-2.814,-3.061],[0,0],[-3.685,1.986]],\"v\":[[-8.589,6.303],[0.598,4.72],[3.225,3.304],[9.598,-3.499],[-1.445,-5.36],[-4.072,-3.944]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.623529434204,0.807843208313,0.654901981354,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[102.33,8.35],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 14\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[136.645,29.308],\"ix\":2},\"a\":{\"a\":0,\"k\":[102.698,8.523],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"pig Outlines - Group 14\",\"np\":1,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[136.645,29.308],\"ix\":2},\"a\":{\"a\":0,\"k\":[136.645,29.308],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"head - pig Outlines - Group 14\",\"np\":1,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ty\":\"gr\",\"it\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[-3.786,2.04],[0,0],[-2.792,-3.27],[0,0],[12.593,-7.834]],\"o\":[[0,0],[-1.196,-4.13],[0,0],[3.785,-2.04],[0,0],[0,0],[-13.959,8.683]],\"v\":[[-9.371,15.268],[-14.15,-1.237],[-9.712,-11.812],[-7.085,-13.228],[4.188,-11.12],[15.346,1.946],[8.123,15.257]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.517647087574,0.749019622803,0.560784339905,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[107.97,16.217],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 15\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[142.335,37.475],\"ix\":2},\"a\":{\"a\":0,\"k\":[108.388,16.69],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"pig Outlines - Group 15\",\"np\":1,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[142.335,37.475],\"ix\":2},\"a\":{\"a\":0,\"k\":[142.335,37.475],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"head - pig Outlines - Group 15\",\"np\":1,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":120,\"st\":0,\"ct\":1,\"bm\":0},{\"ddd\":0,\"ind\":12,\"ty\":4,\"nm\":\"legs\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[182.915,147.359,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[182.915,147.359,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[-1.33,0],[0,0],[-0.309,0.866],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0.919,0],[0,0],[0,0],[0,0],[-0.2,1.316]],\"v\":[[-14.953,23.051],[-0.67,23.051],[1.378,21.607],[17.302,-23.051],[-10.492,-23.051],[-17.102,20.551]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.517647087574,0.749019622803,0.560784339905,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[121.05,126.575],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 16\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[155.084,147.359],\"ix\":2},\"a\":{\"a\":0,\"k\":[121.137,126.575],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"pig Outlines - Group 16\",\"np\":1,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[1.33,0],[0,0],[0.309,0.866],[0,0],[0,0],[0,0]],\"o\":[[0,0],[-0.92,0],[0,0],[0,0],[0,0],[0.2,1.316]],\"v\":[[14.953,23.051],[0.67,23.051],[-1.378,21.607],[-17.302,-23.051],[10.492,-23.051],[17.102,20.551]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.517647087574,0.749019622803,0.560784339905,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[176.887,126.575],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 17\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[210.746,147.359],\"ix\":2},\"a\":{\"a\":0,\"k\":[176.8,126.575],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"pig Outlines - Group 17\",\"np\":1,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":120,\"st\":0,\"ct\":1,\"bm\":0},{\"ddd\":0,\"ind\":13,\"ty\":4,\"nm\":\"shadow\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[182.915,166.133,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[148.968,145.349,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[-5.458,0],[0,0],[0,3.567],[5.459,0],[0,0],[0,-3.567]],\"o\":[[0,0],[5.459,0],[0,-3.567],[0,0],[-5.458,0],[0,3.567]],\"v\":[[-56.945,6.458],[56.945,6.458],[66.829,0],[56.945,-6.458],[-56.945,-6.458],[-66.829,0]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.84152251482,0.89411765337,0.864898145199,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[148.968,145.349],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 18\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":120,\"st\":0,\"ct\":1,\"bm\":0}],\"markers\":[]}");


const $b470d4eebdd16aae$var$AnimatedUspTeaserManagedPension = (props)=>{
    const text = (0, $e6aeb63e6149c504$export$1de30afe8bf7ed5f)('text', props.element) || '';
    const linkText = (0, $e6aeb63e6149c504$export$1de30afe8bf7ed5f)('link-text', props.element) || '';
    const link = (0, $e6aeb63e6149c504$export$1de30afe8bf7ed5f)('link', props.element) || '';
    const heading = (0, $e6aeb63e6149c504$export$1de30afe8bf7ed5f)('heading', props.element) || '';
    const lottieRef = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useRef();
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
        className: `animated-usp-teaser animated-usp-teaser--managed-pension block-spacing`,
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2c1cc6e8319f49c7$exports))), {
                autoplay: true,
                className: "animated-usp-teaser__animation",
                animationData: (0, (/*@__PURE__*/$parcel$interopDefault($1c43ced9d1543c74$exports))),
                lottieRef: lottieRef
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                className: "animated-usp-teaser__content",
                children: [
                    heading && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("h2", {
                        className: "animated-usp-teaser__content__title",
                        children: heading
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $96c25128201e5f07$export$2e2bcd8739ae039), {
                        className: "animated-usp-teaser__content__content",
                        children: text
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("a", {
                        className: "button button--green button--usp",
                        href: link,
                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                            children: linkText
                        })
                    })
                ]
            })
        ]
    });
};
var $b470d4eebdd16aae$export$2e2bcd8739ae039 = $b470d4eebdd16aae$var$AnimatedUspTeaserManagedPension;




var $8NFma = parcelRequire("8NFma");





const $a0521c7589f563bb$var$fetchAnnouncements = (data)=>{
    return {
        type: 'ANNOUNCEMENTS_FETCH',
        data: data
    };
};
const $a0521c7589f563bb$var$fetchAnnouncementsFailed = (failed)=>{
    return {
        type: 'ANNOUNCEMENTS_FETCH_FAILED',
        data: failed
    };
};
const $a0521c7589f563bb$export$79bd6c65cd354a8 = ()=>{
    const lfDataService = new (0, $25937fdb26d57abd$export$2e2bcd8739ae039)();
    return (dispatch)=>{
        let result;
        lfDataService.getAnnouncements().then((data)=>{
            result = data;
            dispatch($a0521c7589f563bb$var$fetchAnnouncements(result));
        }).catch((e1)=>{
            dispatch((0, $67f4b1d2fb7c2244$export$7a8bb273722d5103)(e1));
            dispatch((0, $67f4b1d2fb7c2244$export$ea4b4733f4ca2df0)(true));
            dispatch($a0521c7589f563bb$var$fetchAnnouncementsFailed(true));
        });
    };
};
const $a0521c7589f563bb$export$827c5b644a2bee58 = (data)=>{
    const lfDataService = new (0, $25937fdb26d57abd$export$2e2bcd8739ae039)();
    return (dispatch)=>{
        lfDataService.viewedAnnouncements().then((result)=>{
            if (result.success) return;
            else {
                dispatch((0, $67f4b1d2fb7c2244$export$7a8bb273722d5103)(e));
                dispatch((0, $67f4b1d2fb7c2244$export$ea4b4733f4ca2df0)(true));
            }
        }).catch((e1)=>{
            dispatch((0, $67f4b1d2fb7c2244$export$7a8bb273722d5103)(e1));
            dispatch((0, $67f4b1d2fb7c2244$export$ea4b4733f4ca2df0)(true));
        });
    };
};


var $59ef4baaa83f7283$exports = {};
$59ef4baaa83f7283$exports = JSON.parse('{"v":"5.7.8","fr":30,"ip":0,"op":91,"w":106,"h":100,"nm":"star_still","ddd":0,"assets":[],"layers":[{"ao":0,"bm":0,"ddd":0,"ind":1,"ip":0,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":114,"s":[100]},{"t":120,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[42.905,72.019,0],"ix":2,"l":2},"a":{"a":0,"k":[42.905,72.019,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"nm":"Stj\xe4rna skugga","op":91,"parent":2,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0.371,-0.478],[0,0],[0,0],[0.569,0.203],[0,0],[0,0],[-0.019,0.604],[0,0],[-1.654,4.876]],"o":[[0.602,-0.061],[0,0],[0,0],[0.242,0.552],[0,0],[0,0],[-0.453,0.402],[0,0],[8.163,-4.786],[0,0]],"v":[[8.405,-9.994],[9.081,-8.774],[3.815,-2.021],[7.174,5.824],[6.308,6.749],[-1.82,3.943],[-8.262,9.653],[-9.433,9.077],[-9.372,7.154],[4.107,-9.415]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.957090549843,0.699869851505,0.223505117379,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[43.014,72.108],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"sr":1,"st":0,"ty":4},{"ddd":0,"ind":2,"ty":4,"nm":"Stj\xe4rna fyll","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":114,"s":[100]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.062],"y":[0.984]},"o":{"x":[0.333],"y":[0]},"t":1,"s":[-37]},{"t":23,"s":[0]}],"ix":10},"p":{"a":0,"k":[53.208,49.921,0],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":4,"s":[87,87,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":12,"s":[112,112,100]},{"t":31,"s":[100,100,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":91,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"Stj\xe4rna outlines","parent":2,"sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":114,"s":[100]},{"t":120,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[39.208,68.881,0],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[-0.055,-0.059],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0.001,-0.102],[0,0],[0,0],[0,0],[0,0],[0.046,-0.047],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0.899,0.313],[1.802,0.629],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0.092,0.046],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0.501,-0.007],[0.303,-0.225],[0.09,-0.406],[0,0],[0,0],[0,0],[0.206,-0.294],[0.001,-0.346],[-0.55,-0.309],[0,0],[0,0],[0,0],[0,0],[-0.316,-0.288],[-0.433,-0.001],[-0.318,0.285],[0,0],[0,0],[0,0],[-0.901,-0.315],[-1.797,-0.628],[0,0],[-0.186,0],[-0.299,0.299],[-0.001,0.473],[0.095,0.215],[0,0],[0,0],[0.002,0.356],[0.294,0.309],[0.476,-0.002],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0.001,0.091],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[-0.047,0.046],[0,0],[0,0],[0,0],[0,0],[-0.095,0.001],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[-1.797,-0.628],[-0.9,-0.314],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0.009,-0.092],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[-0.326,-0.485],[-0.366,0.001],[-0.302,0.223],[0,0],[0,0],[0,0],[-0.375,0.109],[-0.208,0.294],[-0.009,0.54],[0,0],[0,0],[0,0],[0,0],[-0.004,0.48],[0.315,0.292],[0.388,0.003],[0,0],[0,0],[0,0],[1.801,0.629],[0.898,0.313],[0,0],[0.182,0.064],[0.474,-0.001],[0.299,-0.299],[0,-0.225],[0,0],[0,0],[0.238,-0.301],[-0.001,-0.443],[-0.291,-0.31],[0,0],[0,0],[0,0],[0,0]],"v":[[-1.108,-12.76],[-1.933,-12.195],[3.214,-4.674],[12.39,-5.643],[12.363,-5.901],[12.363,-5.641],[12.39,-5.643],[12.363,-5.901],[12.363,-5.641],[12.363,-5.971],[12.126,-5.744],[12.363,-5.641],[12.363,-5.971],[12.126,-5.744],[12.356,-5.964],[12.039,-5.964],[12.126,-5.744],[12.356,-5.964],[12.039,-5.964],[12.355,-5.964],[12.103,-6.161],[12.039,-5.964],[12.355,-5.964],[12.103,-6.161],[6.419,1.107],[10.07,9.458],[10.363,9.33],[10.044,9.33],[10.07,9.459],[10.363,9.33],[10.044,9.33],[10.355,9.33],[10.132,9.107],[10.044,9.33],[10.355,9.33],[10.132,9.107],[10.349,9.324],[10.349,9.02],[10.132,9.107],[10.349,9.324],[10.349,9.02],[10.349,9.317],[10.447,9.036],[10.349,9.02],[10.349,9.317],[10.447,9.036],[10.448,9.036],[6.405,7.624],[2.352,6.208],[1.798,6.015],[-5.115,12.133],[-4.912,12.363],[-4.912,12.06],[-5.115,12.133],[-4.912,12.363],[-4.912,12.06],[-4.912,12.365],[-4.703,12.142],[-4.912,12.06],[-4.912,12.365],[-4.703,12.142],[-4.932,12.387],[-4.594,12.387],[-4.703,12.142],[-4.932,12.387],[-4.594,12.387],[-4.871,12.387],[-4.594,12.398],[-4.594,12.387],[-4.871,12.387],[-4.594,12.398],[-4.259,3.247],[-12.196,-1.317],[-12.196,-1.317],[-12.361,-1.029],[-12.031,-1.029],[-12.196,-1.317],[-12.361,-1.029],[-12.031,-1.029],[-12.335,-1.029],[-12.088,-0.854],[-12.031,-1.029],[-12.335,-1.029],[-12.088,-0.854],[-12.335,-1.029],[-12.248,-0.735],[-12.088,-0.854],[-12.335,-1.029],[-12.248,-0.735],[-3.396,-3.356],[-1.375,-12.292],[-1.375,-12.292],[-1.679,-12.361],[-1.494,-12.113],[-1.375,-12.292],[-1.679,-12.361],[-1.494,-12.113],[-1.666,-12.343],[-1.666,-12.055],[-1.494,-12.113],[-1.666,-12.343],[-1.666,-12.055],[-1.666,-12.379],[-1.933,-12.196],[-1.666,-12.055],[-1.666,-12.379],[-1.933,-12.196],[-1.933,-12.195],[-1.108,-12.76],[-0.282,-13.325],[-1.666,-14.055],[-2.691,-13.715],[-3.325,-12.734],[-3.325,-12.734],[-5.088,-4.941],[-12.816,-2.653],[-13.719,-2.011],[-14.031,-1.029],[-13.193,0.417],[-6.302,4.38],[-6.593,12.324],[-6.593,12.323],[-6.594,12.387],[-6.066,13.606],[-4.912,14.059],[-3.789,13.631],[2.685,7.901],[2.022,7.152],[1.692,8.097],[5.746,9.513],[9.788,10.925],[9.79,10.925],[10.349,11.02],[11.545,10.522],[12.044,9.33],[11.902,8.657],[8.729,1.4],[13.678,-4.929],[14.039,-5.964],[13.573,-7.125],[12.363,-7.641],[12.18,-7.632],[4.191,-6.788],[-0.282,-13.325]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.999998922909,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.204,68.879],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 3","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":91,"st":0,"bm":0},{"ddd":0,"ind":5,"ty":4,"nm":"s32","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":30.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":47,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":22,"s":[0]},{"t":47,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":22,"s":[53.208,49.381,0],"to":[7,3.042,0],"ti":[0,0,0]},{"t":44,"s":[95.208,67.631,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":22,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":29,"s":[16,16,100]},{"t":44,"s":[8,8,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":17,"op":91,"st":17,"bm":0},{"ddd":0,"ind":6,"ty":4,"nm":"s31","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":30.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":47,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":22,"s":[0]},{"t":47,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":22,"s":[53.208,49.381,0],"to":[4.75,4.333,0],"ti":[0,0,0]},{"t":46,"s":[81.708,75.381,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":22,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":31,"s":[15,15,100]},{"t":44,"s":[8,8,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":17,"op":91,"st":17,"bm":0},{"ddd":0,"ind":7,"ty":4,"nm":"s30","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":30.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":47,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":22,"s":[0]},{"t":47,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":22,"s":[53.208,49.381,0],"to":[3.125,6.042,0],"ti":[0,0,0]},{"t":47,"s":[71.958,85.631,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":22,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":26,"s":[12,12,100]},{"t":44,"s":[8,8,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":17,"op":91,"st":17,"bm":0},{"ddd":0,"ind":8,"ty":4,"nm":"s29","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":30.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":47,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":22,"s":[0]},{"t":47,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":22,"s":[53.208,49.381,0],"to":[0.458,6.708,0],"ti":[0,0,0]},{"t":45,"s":[55.958,89.631,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":22,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":28,"s":[10,10,100]},{"t":44,"s":[8,8,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":17,"op":91,"st":17,"bm":0},{"ddd":0,"ind":9,"ty":4,"nm":"s28","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":30.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":47,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":22,"s":[0]},{"t":47,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":22,"s":[53.208,49.381,0],"to":[-2.5,7.125,0],"ti":[0,0,0]},{"t":47,"s":[38.208,92.131,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":22,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":32,"s":[14,14,100]},{"t":44,"s":[8,8,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":17,"op":91,"st":17,"bm":0},{"ddd":0,"ind":10,"ty":4,"nm":"s27","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":30.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":47,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":22,"s":[0]},{"t":47,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":22,"s":[53.208,49.381,0],"to":[-4.792,5.25,0],"ti":[0,0,0]},{"t":45,"s":[24.458,80.881,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":22,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":27,"s":[17,17,100]},{"t":44,"s":[8,8,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":17,"op":91,"st":17,"bm":0},{"ddd":0,"ind":11,"ty":4,"nm":"s26","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":30.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":47,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":22,"s":[0]},{"t":47,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":22,"s":[53.208,49.381,0],"to":[-5.833,2.417,0],"ti":[0,0,0]},{"t":47,"s":[18.208,63.881,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":22,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":28,"s":[11,11,100]},{"t":44,"s":[8,8,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":17,"op":91,"st":17,"bm":0},{"ddd":0,"ind":12,"ty":4,"nm":"s25","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":30.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":47,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":22,"s":[0]},{"t":47,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":22,"s":[53.208,49.381,0],"to":[-7.667,-0.125,0],"ti":[0,0,0]},{"t":47,"s":[7.208,48.631,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":22,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":33,"s":[13,13,100]},{"t":44,"s":[8,8,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":17,"op":91,"st":17,"bm":0},{"ddd":0,"ind":13,"ty":4,"nm":"s24","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":30.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":47,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":22,"s":[0]},{"t":47,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":22,"s":[53.208,49.381,0],"to":[-6.208,-2.75,0],"ti":[0,0,0]},{"t":44,"s":[15.958,32.881,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":22,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":35,"s":[15,15,100]},{"t":44,"s":[8,8,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":17,"op":91,"st":17,"bm":0},{"ddd":0,"ind":14,"ty":4,"nm":"s23","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":30.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":47,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":22,"s":[0]},{"t":47,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":22,"s":[53.208,49.381,0],"to":[-5.333,-4.75,0],"ti":[0,0,0]},{"t":46,"s":[21.208,20.881,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":22,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":31,"s":[10,10,100]},{"t":44,"s":[8,8,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":17,"op":91,"st":17,"bm":0},{"ddd":0,"ind":15,"ty":4,"nm":"s22","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":30.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":47,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":22,"s":[0]},{"t":47,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":22,"s":[53.208,49.381,0],"to":[-2.833,-6.167,0],"ti":[0,0,0]},{"t":48,"s":[36.208,12.381,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":22,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":32,"s":[13,13,100]},{"t":44,"s":[8,8,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":17,"op":91,"st":17,"bm":0},{"ddd":0,"ind":16,"ty":4,"nm":"s21","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":30.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":47,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":22,"s":[0]},{"t":47,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":22,"s":[53.208,49.381,0],"to":[-0.167,-7.542,0],"ti":[0,0,0]},{"t":44,"s":[52.208,4.131,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":22,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":26,"s":[22,22,100]},{"t":44,"s":[8,8,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":17,"op":91,"st":17,"bm":0},{"ddd":0,"ind":17,"ty":4,"nm":"s20","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":30.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":47,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":22,"s":[0]},{"t":47,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":22,"s":[53.208,49.381,0],"to":[2.625,-6.667,0],"ti":[0,0,0]},{"t":47,"s":[68.958,9.381,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":22,"s":[-13,-13,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":32,"s":[9,9,100]},{"t":44,"s":[-5,-5,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":17,"op":91,"st":17,"bm":0},{"ddd":0,"ind":18,"ty":4,"nm":"s19","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":30.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":47,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":22,"s":[0]},{"t":47,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":22,"s":[53.208,49.381,0],"to":[4.875,-4.75,0],"ti":[0,0,0]},{"t":45,"s":[82.458,20.881,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":22,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":34,"s":[15,15,100]},{"t":44,"s":[8,8,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":17,"op":91,"st":17,"bm":0},{"ddd":0,"ind":19,"ty":4,"nm":"s18","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":30.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":47,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":22,"s":[0]},{"t":47,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":22,"s":[53.208,49.381,0],"to":[6.583,-3.125,0],"ti":[0,0,0]},{"t":47,"s":[92.708,30.631,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":22,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":32,"s":[15,15,100]},{"t":44,"s":[8,8,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":17,"op":91,"st":17,"bm":0},{"ddd":0,"ind":20,"ty":4,"nm":"s17","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":30.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":47,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":22,"s":[0]},{"t":47,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":22,"s":[53.208,49.381,0],"to":[6.333,-0.042,0],"ti":[-6.333,0.042,0]},{"t":45,"s":[91.208,49.131,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":22,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":26,"s":[16,16,100]},{"t":44,"s":[8,8,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":17,"op":91,"st":17,"bm":0},{"ddd":0,"ind":21,"ty":4,"nm":"s16","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":20.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":37,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":7,"s":[0]},{"t":37,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":7,"s":[53.208,49.381,0],"to":[5.292,2.5,0],"ti":[0,0,0]},{"t":37,"s":[84.958,64.381,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":7,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":20.999,"s":[24,24,100]},{"t":34,"s":[27,27,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":7,"op":91,"st":7,"bm":0},{"ddd":0,"ind":22,"ty":4,"nm":"s15","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":20.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":37,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":7,"s":[0]},{"t":37,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":7,"s":[53.208,49.381,0],"to":[5.125,5.125,0],"ti":[0,0,0]},{"t":34,"s":[83.958,80.131,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":7,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":20.999,"s":[24,24,100]},{"t":34,"s":[27,27,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":7,"op":91,"st":7,"bm":0},{"ddd":0,"ind":23,"ty":4,"nm":"s14","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":20.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":37,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":7,"s":[0]},{"t":37,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":17,"s":[53.208,49.381,0],"to":[3.25,6.208,0],"ti":[0,0,0]},{"t":36,"s":[72.708,86.631,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":7,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":20.999,"s":[24,24,100]},{"t":34,"s":[27,27,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":7,"op":91,"st":7,"bm":0},{"ddd":0,"ind":24,"ty":4,"nm":"s13","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":20.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":37,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":7,"s":[0]},{"t":37,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":15,"s":[53.208,49.381,0],"to":[0.625,7.083,0],"ti":[0,0,0]},{"t":37,"s":[56.958,91.881,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":7,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":20.999,"s":[24,24,100]},{"t":34,"s":[27,27,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":7,"op":91,"st":7,"bm":0},{"ddd":0,"ind":25,"ty":4,"nm":"s12","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":20.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":37,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":7,"s":[0]},{"t":37,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":7,"s":[53.208,49.381,0],"to":[-1.625,5.042,0],"ti":[0,0,0]},{"t":36,"s":[43.458,79.631,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":7,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":20.999,"s":[24,24,100]},{"t":34,"s":[27,27,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":7,"op":91,"st":7,"bm":0},{"ddd":0,"ind":26,"ty":4,"nm":"s11","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":20.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":37,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":7,"s":[0]},{"t":37,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":16,"s":[53.208,49.381,0],"to":[-4.083,4.75,0],"ti":[0,0,0]},{"t":37,"s":[28.708,77.881,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":7,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":20.999,"s":[24,24,100]},{"t":34,"s":[27,27,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":7,"op":91,"st":7,"bm":0},{"ddd":0,"ind":27,"ty":4,"nm":"s10","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":20.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":37,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":7,"s":[0]},{"t":37,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":13,"s":[53.208,49.381,0],"to":[-5.958,2.625,0],"ti":[0,0,0]},{"t":34,"s":[17.458,65.131,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":7,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":20.999,"s":[24,24,100]},{"t":34,"s":[27,27,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":7,"op":91,"st":7,"bm":0},{"ddd":0,"ind":28,"ty":4,"nm":"s09","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":20.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":37,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":7,"s":[0]},{"t":37,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":14,"s":[53.208,49.381,0],"to":[-6.083,0.042,0],"ti":[0,0,0]},{"t":36,"s":[16.708,49.631,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":7,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":20.999,"s":[24,24,100]},{"t":34,"s":[27,27,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":7,"op":91,"st":7,"bm":0},{"ddd":0,"ind":29,"ty":4,"nm":"s08","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":20.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":37,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":7,"s":[0]},{"t":37,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":17,"s":[53.208,49.381,0],"to":[-6.125,-2.667,0],"ti":[0,0,0]},{"t":35,"s":[16.458,33.381,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":7,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":20.999,"s":[24,24,100]},{"t":34,"s":[27,27,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":7,"op":91,"st":7,"bm":0},{"ddd":0,"ind":30,"ty":4,"nm":"s07","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":20.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":37,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":7,"s":[0]},{"t":37,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":13,"s":[53.208,49.381,0],"to":[-4.125,-3.833,0],"ti":[0,0,0]},{"t":33,"s":[28.458,26.381,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":7,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":20.999,"s":[24,24,100]},{"t":34,"s":[27,27,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":7,"op":91,"st":7,"bm":0},{"ddd":0,"ind":31,"ty":4,"nm":"s06","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":20.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":37,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":7,"s":[0]},{"t":37,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":15,"s":[53.208,49.381,0],"to":[-2.5,-5.292,0],"ti":[0,0,0]},{"t":37,"s":[38.208,17.631,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":7,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":20.999,"s":[24,24,100]},{"t":34,"s":[27,27,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":7,"op":91,"st":7,"bm":0},{"ddd":0,"ind":32,"ty":4,"nm":"s05","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":20.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":37,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":7,"s":[0]},{"t":37,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":14,"s":[53.208,49.381,0],"to":[-0.167,-6.25,0],"ti":[0,0,0]},{"t":35,"s":[52.208,11.881,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":7,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":20.999,"s":[24,24,100]},{"t":34,"s":[27,27,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":7,"op":91,"st":7,"bm":0},{"ddd":0,"ind":33,"ty":4,"nm":"s04","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":20.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":37,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":7,"s":[0]},{"t":37,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":13,"s":[53.208,49.381,0],"to":[2.542,-6.083,0],"ti":[0,0,0]},{"t":36,"s":[68.458,12.881,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":7,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":20.999,"s":[24,24,100]},{"t":34,"s":[27,27,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":7,"op":91,"st":7,"bm":0},{"ddd":0,"ind":34,"ty":4,"nm":"s03","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":20.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":37,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":7,"s":[0]},{"t":37,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":15,"s":[53.208,49.381,0],"to":[5.208,-5,0],"ti":[0,0,0]},{"t":34,"s":[84.458,19.381,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":7,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":20.999,"s":[24,24,100]},{"t":34,"s":[27,27,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":7,"op":91,"st":7,"bm":0},{"ddd":0,"ind":35,"ty":4,"nm":"s02","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":20.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":37,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":7,"s":[0]},{"t":37,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":7,"s":[53.208,49.381,0],"to":[5.333,-2.542,0],"ti":[0,0,0]},{"t":36,"s":[85.208,34.131,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":7,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":20.999,"s":[24,24,100]},{"t":34,"s":[27,27,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":7,"op":91,"st":7,"bm":0},{"ddd":0,"ind":36,"ty":4,"nm":"s01","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":20.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":37,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":7,"s":[0]},{"t":37,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":7,"s":[53.208,49.381,0],"to":[5.667,-0.083,0],"ti":[-5.667,0.083,0]},{"t":37,"s":[87.208,48.881,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":7,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":20.999,"s":[24,24,100]},{"t":34,"s":[27,27,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":7,"op":91,"st":7,"bm":0}],"markers":[]}');


var $0849046f18ee7608$exports = {};
$0849046f18ee7608$exports = JSON.parse('{"v":"5.7.8","fr":30,"ip":0,"op":91,"w":106,"h":100,"nm":"stars_still","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Stj\xe4rna skugga","parent":2,"sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":114,"s":[100]},{"t":120,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[42.905,72.019,0],"ix":2,"l":2},"a":{"a":0,"k":[42.905,72.019,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0.371,-0.478],[0,0],[0,0],[0.569,0.203],[0,0],[0,0],[-0.019,0.604],[0,0],[-1.654,4.876]],"o":[[0.602,-0.061],[0,0],[0,0],[0.242,0.552],[0,0],[0,0],[-0.453,0.402],[0,0],[8.163,-4.786],[0,0]],"v":[[8.405,-9.994],[9.081,-8.774],[3.815,-2.021],[7.174,5.824],[6.308,6.749],[-1.82,3.943],[-8.262,9.653],[-9.433,9.077],[-9.372,7.154],[4.107,-9.415]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.957090549843,0.699869851505,0.223505117379,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[43.014,72.108],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":91,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"Stj\xe4rna fyll","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":114,"s":[100]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.062],"y":[0.984]},"o":{"x":[0.333],"y":[0]},"t":1,"s":[-37]},{"t":23,"s":[0]}],"ix":10},"p":{"a":0,"k":[53.208,49.921,0],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":4,"s":[69,69,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":12,"s":[95,95,100]},{"t":31,"s":[83,83,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":91,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"Stj\xe4rna outlines","parent":2,"sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":114,"s":[100]},{"t":120,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[39.208,68.881,0],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[-0.055,-0.059],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0.001,-0.102],[0,0],[0,0],[0,0],[0,0],[0.046,-0.047],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0.899,0.313],[1.802,0.629],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0.092,0.046],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0.501,-0.007],[0.303,-0.225],[0.09,-0.406],[0,0],[0,0],[0,0],[0.206,-0.294],[0.001,-0.346],[-0.55,-0.309],[0,0],[0,0],[0,0],[0,0],[-0.316,-0.288],[-0.433,-0.001],[-0.318,0.285],[0,0],[0,0],[0,0],[-0.901,-0.315],[-1.797,-0.628],[0,0],[-0.186,0],[-0.299,0.299],[-0.001,0.473],[0.095,0.215],[0,0],[0,0],[0.002,0.356],[0.294,0.309],[0.476,-0.002],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0.001,0.091],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[-0.047,0.046],[0,0],[0,0],[0,0],[0,0],[-0.095,0.001],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[-1.797,-0.628],[-0.9,-0.314],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0.009,-0.092],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[-0.326,-0.485],[-0.366,0.001],[-0.302,0.223],[0,0],[0,0],[0,0],[-0.375,0.109],[-0.208,0.294],[-0.009,0.54],[0,0],[0,0],[0,0],[0,0],[-0.004,0.48],[0.315,0.292],[0.388,0.003],[0,0],[0,0],[0,0],[1.801,0.629],[0.898,0.313],[0,0],[0.182,0.064],[0.474,-0.001],[0.299,-0.299],[0,-0.225],[0,0],[0,0],[0.238,-0.301],[-0.001,-0.443],[-0.291,-0.31],[0,0],[0,0],[0,0],[0,0]],"v":[[-1.108,-12.76],[-1.933,-12.195],[3.214,-4.674],[12.39,-5.643],[12.363,-5.901],[12.363,-5.641],[12.39,-5.643],[12.363,-5.901],[12.363,-5.641],[12.363,-5.971],[12.126,-5.744],[12.363,-5.641],[12.363,-5.971],[12.126,-5.744],[12.356,-5.964],[12.039,-5.964],[12.126,-5.744],[12.356,-5.964],[12.039,-5.964],[12.355,-5.964],[12.103,-6.161],[12.039,-5.964],[12.355,-5.964],[12.103,-6.161],[6.419,1.107],[10.07,9.458],[10.363,9.33],[10.044,9.33],[10.07,9.459],[10.363,9.33],[10.044,9.33],[10.355,9.33],[10.132,9.107],[10.044,9.33],[10.355,9.33],[10.132,9.107],[10.349,9.324],[10.349,9.02],[10.132,9.107],[10.349,9.324],[10.349,9.02],[10.349,9.317],[10.447,9.036],[10.349,9.02],[10.349,9.317],[10.447,9.036],[10.448,9.036],[6.405,7.624],[2.352,6.208],[1.798,6.015],[-5.115,12.133],[-4.912,12.363],[-4.912,12.06],[-5.115,12.133],[-4.912,12.363],[-4.912,12.06],[-4.912,12.365],[-4.703,12.142],[-4.912,12.06],[-4.912,12.365],[-4.703,12.142],[-4.932,12.387],[-4.594,12.387],[-4.703,12.142],[-4.932,12.387],[-4.594,12.387],[-4.871,12.387],[-4.594,12.398],[-4.594,12.387],[-4.871,12.387],[-4.594,12.398],[-4.259,3.247],[-12.196,-1.317],[-12.196,-1.317],[-12.361,-1.029],[-12.031,-1.029],[-12.196,-1.317],[-12.361,-1.029],[-12.031,-1.029],[-12.335,-1.029],[-12.088,-0.854],[-12.031,-1.029],[-12.335,-1.029],[-12.088,-0.854],[-12.335,-1.029],[-12.248,-0.735],[-12.088,-0.854],[-12.335,-1.029],[-12.248,-0.735],[-3.396,-3.356],[-1.375,-12.292],[-1.375,-12.292],[-1.679,-12.361],[-1.494,-12.113],[-1.375,-12.292],[-1.679,-12.361],[-1.494,-12.113],[-1.666,-12.343],[-1.666,-12.055],[-1.494,-12.113],[-1.666,-12.343],[-1.666,-12.055],[-1.666,-12.379],[-1.933,-12.196],[-1.666,-12.055],[-1.666,-12.379],[-1.933,-12.196],[-1.933,-12.195],[-1.108,-12.76],[-0.282,-13.325],[-1.666,-14.055],[-2.691,-13.715],[-3.325,-12.734],[-3.325,-12.734],[-5.088,-4.941],[-12.816,-2.653],[-13.719,-2.011],[-14.031,-1.029],[-13.193,0.417],[-6.302,4.38],[-6.593,12.324],[-6.593,12.323],[-6.594,12.387],[-6.066,13.606],[-4.912,14.059],[-3.789,13.631],[2.685,7.901],[2.022,7.152],[1.692,8.097],[5.746,9.513],[9.788,10.925],[9.79,10.925],[10.349,11.02],[11.545,10.522],[12.044,9.33],[11.902,8.657],[8.729,1.4],[13.678,-4.929],[14.039,-5.964],[13.573,-7.125],[12.363,-7.641],[12.18,-7.632],[4.191,-6.788],[-0.282,-13.325]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.999998922909,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.204,68.879],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 3","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":91,"st":0,"bm":0},{"ddd":0,"ind":5,"ty":4,"nm":"s32","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":30.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":47,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":22,"s":[0]},{"t":47,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":22,"s":[53.208,49.381,0],"to":[7,3.042,0],"ti":[0,0,0]},{"t":44,"s":[95.208,67.631,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":22,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":29,"s":[16,16,100]},{"t":44,"s":[8,8,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":17,"op":91,"st":17,"bm":0},{"ddd":0,"ind":6,"ty":4,"nm":"s31","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":30.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":47,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":22,"s":[0]},{"t":47,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":22,"s":[53.208,49.381,0],"to":[4.75,4.333,0],"ti":[0,0,0]},{"t":46,"s":[81.708,75.381,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":22,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":31,"s":[15,15,100]},{"t":44,"s":[8,8,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":17,"op":91,"st":17,"bm":0},{"ddd":0,"ind":7,"ty":4,"nm":"s30","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":30.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":47,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":22,"s":[0]},{"t":47,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":22,"s":[53.208,49.381,0],"to":[3.125,6.042,0],"ti":[0,0,0]},{"t":47,"s":[71.958,85.631,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":22,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":26,"s":[12,12,100]},{"t":44,"s":[8,8,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":17,"op":91,"st":17,"bm":0},{"ddd":0,"ind":8,"ty":4,"nm":"s29","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":30.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":47,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":22,"s":[0]},{"t":47,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":22,"s":[53.208,49.381,0],"to":[0.458,6.708,0],"ti":[0,0,0]},{"t":45,"s":[55.958,89.631,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":22,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":28,"s":[10,10,100]},{"t":44,"s":[8,8,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":17,"op":91,"st":17,"bm":0},{"ddd":0,"ind":9,"ty":4,"nm":"s28","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":30.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":47,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":22,"s":[0]},{"t":47,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":22,"s":[53.208,49.381,0],"to":[-2.5,7.125,0],"ti":[0,0,0]},{"t":47,"s":[38.208,92.131,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":22,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":32,"s":[14,14,100]},{"t":44,"s":[8,8,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":17,"op":91,"st":17,"bm":0},{"ddd":0,"ind":10,"ty":4,"nm":"s27","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":30.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":47,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":22,"s":[0]},{"t":47,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":22,"s":[53.208,49.381,0],"to":[-4.792,5.25,0],"ti":[0,0,0]},{"t":45,"s":[24.458,80.881,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":22,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":27,"s":[17,17,100]},{"t":44,"s":[8,8,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":17,"op":91,"st":17,"bm":0},{"ddd":0,"ind":11,"ty":4,"nm":"s26","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":30.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":47,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":22,"s":[0]},{"t":47,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":22,"s":[53.208,49.381,0],"to":[-5.833,2.417,0],"ti":[0,0,0]},{"t":47,"s":[18.208,63.881,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":22,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":28,"s":[11,11,100]},{"t":44,"s":[8,8,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":17,"op":91,"st":17,"bm":0},{"ddd":0,"ind":12,"ty":4,"nm":"s25","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":30.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":47,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":22,"s":[0]},{"t":47,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":22,"s":[53.208,49.381,0],"to":[-7.667,-0.125,0],"ti":[0,0,0]},{"t":47,"s":[7.208,48.631,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":22,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":33,"s":[13,13,100]},{"t":44,"s":[8,8,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":17,"op":91,"st":17,"bm":0},{"ddd":0,"ind":13,"ty":4,"nm":"s24","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":30.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":47,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":22,"s":[0]},{"t":47,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":22,"s":[53.208,49.381,0],"to":[-6.208,-2.75,0],"ti":[0,0,0]},{"t":44,"s":[15.958,32.881,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":22,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":35,"s":[15,15,100]},{"t":44,"s":[8,8,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":17,"op":91,"st":17,"bm":0},{"ddd":0,"ind":14,"ty":4,"nm":"s23","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":30.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":47,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":22,"s":[0]},{"t":47,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":22,"s":[53.208,49.381,0],"to":[-5.333,-4.75,0],"ti":[0,0,0]},{"t":46,"s":[21.208,20.881,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":22,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":31,"s":[10,10,100]},{"t":44,"s":[8,8,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":17,"op":91,"st":17,"bm":0},{"ddd":0,"ind":15,"ty":4,"nm":"s22","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":30.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":47,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":22,"s":[0]},{"t":47,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":22,"s":[53.208,49.381,0],"to":[-2.833,-6.167,0],"ti":[0,0,0]},{"t":48,"s":[36.208,12.381,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":22,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":32,"s":[13,13,100]},{"t":44,"s":[8,8,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":17,"op":91,"st":17,"bm":0},{"ddd":0,"ind":16,"ty":4,"nm":"s21","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":30.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":47,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":22,"s":[0]},{"t":47,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":22,"s":[53.208,49.381,0],"to":[-0.167,-7.542,0],"ti":[0,0,0]},{"t":44,"s":[52.208,4.131,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":22,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":26,"s":[22,22,100]},{"t":44,"s":[8,8,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":17,"op":91,"st":17,"bm":0},{"ddd":0,"ind":17,"ty":4,"nm":"s20","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":30.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":47,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":22,"s":[0]},{"t":47,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":22,"s":[53.208,49.381,0],"to":[2.625,-6.667,0],"ti":[0,0,0]},{"t":47,"s":[68.958,9.381,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":22,"s":[-13,-13,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":32,"s":[9,9,100]},{"t":44,"s":[-5,-5,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":17,"op":91,"st":17,"bm":0},{"ddd":0,"ind":18,"ty":4,"nm":"s19","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":30.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":47,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":22,"s":[0]},{"t":47,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":22,"s":[53.208,49.381,0],"to":[4.875,-4.75,0],"ti":[0,0,0]},{"t":45,"s":[82.458,20.881,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":22,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":34,"s":[15,15,100]},{"t":44,"s":[8,8,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":17,"op":91,"st":17,"bm":0},{"ddd":0,"ind":19,"ty":4,"nm":"s18","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":30.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":47,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":22,"s":[0]},{"t":47,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":22,"s":[53.208,49.381,0],"to":[6.583,-3.125,0],"ti":[0,0,0]},{"t":47,"s":[92.708,30.631,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":22,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":32,"s":[15,15,100]},{"t":44,"s":[8,8,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":17,"op":91,"st":17,"bm":0},{"ddd":0,"ind":20,"ty":4,"nm":"s17","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":30.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":47,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":22,"s":[0]},{"t":47,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":22,"s":[53.208,49.381,0],"to":[6.333,-0.042,0],"ti":[-6.333,0.042,0]},{"t":45,"s":[91.208,49.131,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":22,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":26,"s":[16,16,100]},{"t":44,"s":[8,8,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":17,"op":91,"st":17,"bm":0},{"ddd":0,"ind":21,"ty":4,"nm":"s16","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":20.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":37,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":7,"s":[0]},{"t":37,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":7,"s":[53.208,49.381,0],"to":[5.292,2.5,0],"ti":[0,0,0]},{"t":37,"s":[84.958,64.381,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":7,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":20.999,"s":[24,24,100]},{"t":34,"s":[27,27,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":7,"op":91,"st":7,"bm":0},{"ddd":0,"ind":22,"ty":4,"nm":"s15","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":20.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":37,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":7,"s":[0]},{"t":37,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":7,"s":[53.208,49.381,0],"to":[5.125,5.125,0],"ti":[0,0,0]},{"t":34,"s":[83.958,80.131,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":7,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":20.999,"s":[24,24,100]},{"t":34,"s":[27,27,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":7,"op":91,"st":7,"bm":0},{"ddd":0,"ind":23,"ty":4,"nm":"s14","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":20.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":37,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":7,"s":[0]},{"t":37,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":17,"s":[53.208,49.381,0],"to":[3.25,6.208,0],"ti":[0,0,0]},{"t":36,"s":[72.708,86.631,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":7,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":20.999,"s":[24,24,100]},{"t":34,"s":[27,27,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":7,"op":91,"st":7,"bm":0},{"ddd":0,"ind":24,"ty":4,"nm":"s13","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":20.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":37,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":7,"s":[0]},{"t":37,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":15,"s":[53.208,49.381,0],"to":[0.625,7.083,0],"ti":[0,0,0]},{"t":37,"s":[56.958,91.881,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":7,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":20.999,"s":[24,24,100]},{"t":34,"s":[27,27,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":7,"op":91,"st":7,"bm":0},{"ddd":0,"ind":25,"ty":4,"nm":"s12","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":20.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":37,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":7,"s":[0]},{"t":37,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":7,"s":[53.208,49.381,0],"to":[-1.625,5.042,0],"ti":[0,0,0]},{"t":36,"s":[43.458,79.631,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":7,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":20.999,"s":[24,24,100]},{"t":34,"s":[27,27,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":7,"op":91,"st":7,"bm":0},{"ddd":0,"ind":26,"ty":4,"nm":"s11","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":20.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":37,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":7,"s":[0]},{"t":37,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":16,"s":[53.208,49.381,0],"to":[-4.083,4.75,0],"ti":[0,0,0]},{"t":37,"s":[28.708,77.881,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":7,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":20.999,"s":[24,24,100]},{"t":34,"s":[27,27,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":7,"op":91,"st":7,"bm":0},{"ddd":0,"ind":27,"ty":4,"nm":"s10","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":20.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":37,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":7,"s":[0]},{"t":37,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":13,"s":[53.208,49.381,0],"to":[-5.958,2.625,0],"ti":[0,0,0]},{"t":34,"s":[17.458,65.131,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":7,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":20.999,"s":[24,24,100]},{"t":34,"s":[27,27,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":7,"op":91,"st":7,"bm":0},{"ddd":0,"ind":28,"ty":4,"nm":"s09","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":20.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":37,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":7,"s":[0]},{"t":37,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":14,"s":[53.208,49.381,0],"to":[-6.083,0.042,0],"ti":[0,0,0]},{"t":36,"s":[16.708,49.631,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":7,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":20.999,"s":[24,24,100]},{"t":34,"s":[27,27,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":7,"op":91,"st":7,"bm":0},{"ddd":0,"ind":29,"ty":4,"nm":"s08","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":20.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":37,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":7,"s":[0]},{"t":37,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":17,"s":[53.208,49.381,0],"to":[-6.125,-2.667,0],"ti":[0,0,0]},{"t":35,"s":[16.458,33.381,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":7,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":20.999,"s":[24,24,100]},{"t":34,"s":[27,27,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":7,"op":91,"st":7,"bm":0},{"ddd":0,"ind":30,"ty":4,"nm":"s07","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":20.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":37,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":7,"s":[0]},{"t":37,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":13,"s":[53.208,49.381,0],"to":[-4.125,-3.833,0],"ti":[0,0,0]},{"t":33,"s":[28.458,26.381,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":7,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":20.999,"s":[24,24,100]},{"t":34,"s":[27,27,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":7,"op":91,"st":7,"bm":0},{"ddd":0,"ind":31,"ty":4,"nm":"s06","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":20.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":37,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":7,"s":[0]},{"t":37,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":15,"s":[53.208,49.381,0],"to":[-2.5,-5.292,0],"ti":[0,0,0]},{"t":37,"s":[38.208,17.631,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":7,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":20.999,"s":[24,24,100]},{"t":34,"s":[27,27,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":7,"op":91,"st":7,"bm":0},{"ddd":0,"ind":32,"ty":4,"nm":"s05","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":20.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":37,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":7,"s":[0]},{"t":37,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":14,"s":[53.208,49.381,0],"to":[-0.167,-6.25,0],"ti":[0,0,0]},{"t":35,"s":[52.208,11.881,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":7,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":20.999,"s":[24,24,100]},{"t":34,"s":[27,27,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":7,"op":91,"st":7,"bm":0},{"ddd":0,"ind":33,"ty":4,"nm":"s04","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":20.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":37,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":7,"s":[0]},{"t":37,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":13,"s":[53.208,49.381,0],"to":[2.542,-6.083,0],"ti":[0,0,0]},{"t":36,"s":[68.458,12.881,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":7,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":20.999,"s":[24,24,100]},{"t":34,"s":[27,27,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":7,"op":91,"st":7,"bm":0},{"ddd":0,"ind":34,"ty":4,"nm":"s03","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":20.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":37,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":7,"s":[0]},{"t":37,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":15,"s":[53.208,49.381,0],"to":[5.208,-5,0],"ti":[0,0,0]},{"t":34,"s":[84.458,19.381,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":7,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":20.999,"s":[24,24,100]},{"t":34,"s":[27,27,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":7,"op":91,"st":7,"bm":0},{"ddd":0,"ind":35,"ty":4,"nm":"s02","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":20.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":37,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":7,"s":[0]},{"t":37,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":7,"s":[53.208,49.381,0],"to":[5.333,-2.542,0],"ti":[0,0,0]},{"t":36,"s":[85.208,34.131,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":7,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":20.999,"s":[24,24,100]},{"t":34,"s":[27,27,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":7,"op":91,"st":7,"bm":0},{"ddd":0,"ind":36,"ty":4,"nm":"s01","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":20.999,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":37,"s":[0]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":7,"s":[0]},{"t":37,"s":[50]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.337,"y":1},"o":{"x":0.191,"y":0},"t":7,"s":[53.208,49.381,0],"to":[5.667,-0.083,0],"ti":[-5.667,0.083,0]},{"t":37,"s":[87.208,48.881,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":7,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":20.999,"s":[24,24,100]},{"t":34,"s":[27,27,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":7,"op":91,"st":7,"bm":0},{"ddd":0,"ind":37,"ty":4,"nm":"Stj\xe4rna outlines 4","parent":39,"sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":114,"s":[100]},{"t":120,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[40.208,68.881,0],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[-0.055,-0.059],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0.001,-0.102],[0,0],[0,0],[0,0],[0,0],[0.046,-0.047],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0.899,0.313],[1.802,0.629],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0.092,0.046],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0.501,-0.007],[0.303,-0.225],[0.09,-0.406],[0,0],[0,0],[0,0],[0.206,-0.294],[0.001,-0.346],[-0.55,-0.309],[0,0],[0,0],[0,0],[0,0],[-0.316,-0.288],[-0.433,-0.001],[-0.318,0.285],[0,0],[0,0],[0,0],[-0.901,-0.315],[-1.797,-0.628],[0,0],[-0.186,0],[-0.299,0.299],[-0.001,0.473],[0.095,0.215],[0,0],[0,0],[0.002,0.356],[0.294,0.309],[0.476,-0.002],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0.001,0.091],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[-0.047,0.046],[0,0],[0,0],[0,0],[0,0],[-0.095,0.001],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[-1.797,-0.628],[-0.9,-0.314],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0.009,-0.092],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[-0.326,-0.485],[-0.366,0.001],[-0.302,0.223],[0,0],[0,0],[0,0],[-0.375,0.109],[-0.208,0.294],[-0.009,0.54],[0,0],[0,0],[0,0],[0,0],[-0.004,0.48],[0.315,0.292],[0.388,0.003],[0,0],[0,0],[0,0],[1.801,0.629],[0.898,0.313],[0,0],[0.182,0.064],[0.474,-0.001],[0.299,-0.299],[0,-0.225],[0,0],[0,0],[0.238,-0.301],[-0.001,-0.443],[-0.291,-0.31],[0,0],[0,0],[0,0],[0,0]],"v":[[-1.108,-12.76],[-1.933,-12.195],[3.214,-4.674],[12.39,-5.643],[12.363,-5.901],[12.363,-5.641],[12.39,-5.643],[12.363,-5.901],[12.363,-5.641],[12.363,-5.971],[12.126,-5.744],[12.363,-5.641],[12.363,-5.971],[12.126,-5.744],[12.356,-5.964],[12.039,-5.964],[12.126,-5.744],[12.356,-5.964],[12.039,-5.964],[12.355,-5.964],[12.103,-6.161],[12.039,-5.964],[12.355,-5.964],[12.103,-6.161],[6.419,1.107],[10.07,9.458],[10.363,9.33],[10.044,9.33],[10.07,9.459],[10.363,9.33],[10.044,9.33],[10.355,9.33],[10.132,9.107],[10.044,9.33],[10.355,9.33],[10.132,9.107],[10.349,9.324],[10.349,9.02],[10.132,9.107],[10.349,9.324],[10.349,9.02],[10.349,9.317],[10.447,9.036],[10.349,9.02],[10.349,9.317],[10.447,9.036],[10.448,9.036],[6.405,7.624],[2.352,6.208],[1.798,6.015],[-5.115,12.133],[-4.912,12.363],[-4.912,12.06],[-5.115,12.133],[-4.912,12.363],[-4.912,12.06],[-4.912,12.365],[-4.703,12.142],[-4.912,12.06],[-4.912,12.365],[-4.703,12.142],[-4.932,12.387],[-4.594,12.387],[-4.703,12.142],[-4.932,12.387],[-4.594,12.387],[-4.871,12.387],[-4.594,12.398],[-4.594,12.387],[-4.871,12.387],[-4.594,12.398],[-4.259,3.247],[-12.196,-1.317],[-12.196,-1.317],[-12.361,-1.029],[-12.031,-1.029],[-12.196,-1.317],[-12.361,-1.029],[-12.031,-1.029],[-12.335,-1.029],[-12.088,-0.854],[-12.031,-1.029],[-12.335,-1.029],[-12.088,-0.854],[-12.335,-1.029],[-12.248,-0.735],[-12.088,-0.854],[-12.335,-1.029],[-12.248,-0.735],[-3.396,-3.356],[-1.375,-12.292],[-1.375,-12.292],[-1.679,-12.361],[-1.494,-12.113],[-1.375,-12.292],[-1.679,-12.361],[-1.494,-12.113],[-1.666,-12.343],[-1.666,-12.055],[-1.494,-12.113],[-1.666,-12.343],[-1.666,-12.055],[-1.666,-12.379],[-1.933,-12.196],[-1.666,-12.055],[-1.666,-12.379],[-1.933,-12.196],[-1.933,-12.195],[-1.108,-12.76],[-0.282,-13.325],[-1.666,-14.055],[-2.691,-13.715],[-3.325,-12.734],[-3.325,-12.734],[-5.088,-4.941],[-12.816,-2.653],[-13.719,-2.011],[-14.031,-1.029],[-13.193,0.417],[-6.302,4.38],[-6.593,12.324],[-6.593,12.323],[-6.594,12.387],[-6.066,13.606],[-4.912,14.059],[-3.789,13.631],[2.685,7.901],[2.022,7.152],[1.692,8.097],[5.746,9.513],[9.788,10.925],[9.79,10.925],[10.349,11.02],[11.545,10.522],[12.044,9.33],[11.902,8.657],[8.729,1.4],[13.678,-4.929],[14.039,-5.964],[13.573,-7.125],[12.363,-7.641],[12.18,-7.632],[4.191,-6.788],[-0.282,-13.325]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.999998922909,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.204,68.879],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 3","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":91,"st":0,"bm":0},{"ddd":0,"ind":38,"ty":4,"nm":"Stj\xe4rna skugga 4","parent":39,"sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":114,"s":[100]},{"t":120,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[43.905,72.019,0],"ix":2,"l":2},"a":{"a":0,"k":[42.905,72.019,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0.371,-0.478],[0,0],[0,0],[0.569,0.203],[0,0],[0,0],[-0.019,0.604],[0,0],[-1.654,4.876]],"o":[[0.602,-0.061],[0,0],[0,0],[0.242,0.552],[0,0],[0,0],[-0.453,0.402],[0,0],[8.163,-4.786],[0,0]],"v":[[8.405,-9.994],[9.081,-8.774],[3.815,-2.021],[7.174,5.824],[6.308,6.749],[-1.82,3.943],[-8.262,9.653],[-9.433,9.077],[-9.372,7.154],[4.107,-9.415]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.957090549843,0.699869851505,0.223505117379,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[43.014,72.108],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":91,"st":0,"bm":0},{"ddd":0,"ind":39,"ty":4,"nm":"Stj\xe4rna fyll 4","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":114,"s":[100]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.062],"y":[0.996]},"o":{"x":[0.333],"y":[0]},"t":8,"s":[-107]},{"t":24,"s":[0]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":8,"s":[53,50,0],"to":[-2.382,1.279,0],"ti":[2.382,-1.279,0]},{"t":24,"s":[38.708,57.671,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":8,"s":[13.91,13.91,100]},{"t":24,"s":[40.91,40.91,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":91,"st":0,"bm":0},{"ddd":0,"ind":40,"ty":4,"nm":"Stj\xe4rna outlines 3","parent":42,"sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":114,"s":[100]},{"t":120,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[39.208,68.881,0],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[-0.055,-0.059],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0.001,-0.102],[0,0],[0,0],[0,0],[0,0],[0.046,-0.047],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0.899,0.313],[1.802,0.629],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0.092,0.046],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0.501,-0.007],[0.303,-0.225],[0.09,-0.406],[0,0],[0,0],[0,0],[0.206,-0.294],[0.001,-0.346],[-0.55,-0.309],[0,0],[0,0],[0,0],[0,0],[-0.316,-0.288],[-0.433,-0.001],[-0.318,0.285],[0,0],[0,0],[0,0],[-0.901,-0.315],[-1.797,-0.628],[0,0],[-0.186,0],[-0.299,0.299],[-0.001,0.473],[0.095,0.215],[0,0],[0,0],[0.002,0.356],[0.294,0.309],[0.476,-0.002],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0.001,0.091],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[-0.047,0.046],[0,0],[0,0],[0,0],[0,0],[-0.095,0.001],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[-1.797,-0.628],[-0.9,-0.314],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0.009,-0.092],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[-0.326,-0.485],[-0.366,0.001],[-0.302,0.223],[0,0],[0,0],[0,0],[-0.375,0.109],[-0.208,0.294],[-0.009,0.54],[0,0],[0,0],[0,0],[0,0],[-0.004,0.48],[0.315,0.292],[0.388,0.003],[0,0],[0,0],[0,0],[1.801,0.629],[0.898,0.313],[0,0],[0.182,0.064],[0.474,-0.001],[0.299,-0.299],[0,-0.225],[0,0],[0,0],[0.238,-0.301],[-0.001,-0.443],[-0.291,-0.31],[0,0],[0,0],[0,0],[0,0]],"v":[[-1.108,-12.76],[-1.933,-12.195],[3.214,-4.674],[12.39,-5.643],[12.363,-5.901],[12.363,-5.641],[12.39,-5.643],[12.363,-5.901],[12.363,-5.641],[12.363,-5.971],[12.126,-5.744],[12.363,-5.641],[12.363,-5.971],[12.126,-5.744],[12.356,-5.964],[12.039,-5.964],[12.126,-5.744],[12.356,-5.964],[12.039,-5.964],[12.355,-5.964],[12.103,-6.161],[12.039,-5.964],[12.355,-5.964],[12.103,-6.161],[6.419,1.107],[10.07,9.458],[10.363,9.33],[10.044,9.33],[10.07,9.459],[10.363,9.33],[10.044,9.33],[10.355,9.33],[10.132,9.107],[10.044,9.33],[10.355,9.33],[10.132,9.107],[10.349,9.324],[10.349,9.02],[10.132,9.107],[10.349,9.324],[10.349,9.02],[10.349,9.317],[10.447,9.036],[10.349,9.02],[10.349,9.317],[10.447,9.036],[10.448,9.036],[6.405,7.624],[2.352,6.208],[1.798,6.015],[-5.115,12.133],[-4.912,12.363],[-4.912,12.06],[-5.115,12.133],[-4.912,12.363],[-4.912,12.06],[-4.912,12.365],[-4.703,12.142],[-4.912,12.06],[-4.912,12.365],[-4.703,12.142],[-4.932,12.387],[-4.594,12.387],[-4.703,12.142],[-4.932,12.387],[-4.594,12.387],[-4.871,12.387],[-4.594,12.398],[-4.594,12.387],[-4.871,12.387],[-4.594,12.398],[-4.259,3.247],[-12.196,-1.317],[-12.196,-1.317],[-12.361,-1.029],[-12.031,-1.029],[-12.196,-1.317],[-12.361,-1.029],[-12.031,-1.029],[-12.335,-1.029],[-12.088,-0.854],[-12.031,-1.029],[-12.335,-1.029],[-12.088,-0.854],[-12.335,-1.029],[-12.248,-0.735],[-12.088,-0.854],[-12.335,-1.029],[-12.248,-0.735],[-3.396,-3.356],[-1.375,-12.292],[-1.375,-12.292],[-1.679,-12.361],[-1.494,-12.113],[-1.375,-12.292],[-1.679,-12.361],[-1.494,-12.113],[-1.666,-12.343],[-1.666,-12.055],[-1.494,-12.113],[-1.666,-12.343],[-1.666,-12.055],[-1.666,-12.379],[-1.933,-12.196],[-1.666,-12.055],[-1.666,-12.379],[-1.933,-12.196],[-1.933,-12.195],[-1.108,-12.76],[-0.282,-13.325],[-1.666,-14.055],[-2.691,-13.715],[-3.325,-12.734],[-3.325,-12.734],[-5.088,-4.941],[-12.816,-2.653],[-13.719,-2.011],[-14.031,-1.029],[-13.193,0.417],[-6.302,4.38],[-6.593,12.324],[-6.593,12.323],[-6.594,12.387],[-6.066,13.606],[-4.912,14.059],[-3.789,13.631],[2.685,7.901],[2.022,7.152],[1.692,8.097],[5.746,9.513],[9.788,10.925],[9.79,10.925],[10.349,11.02],[11.545,10.522],[12.044,9.33],[11.902,8.657],[8.729,1.4],[13.678,-4.929],[14.039,-5.964],[13.573,-7.125],[12.363,-7.641],[12.18,-7.632],[4.191,-6.788],[-0.282,-13.325]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.999998922909,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.204,68.879],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 3","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":91,"st":0,"bm":0},{"ddd":0,"ind":41,"ty":4,"nm":"Stj\xe4rna skugga 3","parent":42,"sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":114,"s":[100]},{"t":120,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[42.905,72.019,0],"ix":2,"l":2},"a":{"a":0,"k":[42.905,72.019,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0.371,-0.478],[0,0],[0,0],[0.569,0.203],[0,0],[0,0],[-0.019,0.604],[0,0],[-1.654,4.876]],"o":[[0.602,-0.061],[0,0],[0,0],[0.242,0.552],[0,0],[0,0],[-0.453,0.402],[0,0],[8.163,-4.786],[0,0]],"v":[[8.405,-9.994],[9.081,-8.774],[3.815,-2.021],[7.174,5.824],[6.308,6.749],[-1.82,3.943],[-8.262,9.653],[-9.433,9.077],[-9.372,7.154],[4.107,-9.415]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.957090549843,0.699869851505,0.223505117379,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[43.014,72.108],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":91,"st":0,"bm":0},{"ddd":0,"ind":42,"ty":4,"nm":"Stj\xe4rna fyll 3","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":114,"s":[100]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.062],"y":[0.996]},"o":{"x":[0.333],"y":[0]},"t":7,"s":[-107]},{"t":23,"s":[0]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":7,"s":[53,50,0],"to":[1.076,-2.096,0],"ti":[-1.076,2.096,0]},{"t":23,"s":[59.458,37.421,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":7,"s":[13.91,13.91,100]},{"t":23,"s":[27.91,27.91,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":91,"st":0,"bm":0},{"ddd":0,"ind":43,"ty":4,"nm":"Stj\xe4rna outlines 2","parent":45,"sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":114,"s":[100]},{"t":120,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[39.208,68.881,0],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[-0.055,-0.059],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0.001,-0.102],[0,0],[0,0],[0,0],[0,0],[0.046,-0.047],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0.899,0.313],[1.802,0.629],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0.092,0.046],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0.501,-0.007],[0.303,-0.225],[0.09,-0.406],[0,0],[0,0],[0,0],[0.206,-0.294],[0.001,-0.346],[-0.55,-0.309],[0,0],[0,0],[0,0],[0,0],[-0.316,-0.288],[-0.433,-0.001],[-0.318,0.285],[0,0],[0,0],[0,0],[-0.901,-0.315],[-1.797,-0.628],[0,0],[-0.186,0],[-0.299,0.299],[-0.001,0.473],[0.095,0.215],[0,0],[0,0],[0.002,0.356],[0.294,0.309],[0.476,-0.002],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0.001,0.091],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[-0.047,0.046],[0,0],[0,0],[0,0],[0,0],[-0.095,0.001],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[-1.797,-0.628],[-0.9,-0.314],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0.009,-0.092],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[-0.326,-0.485],[-0.366,0.001],[-0.302,0.223],[0,0],[0,0],[0,0],[-0.375,0.109],[-0.208,0.294],[-0.009,0.54],[0,0],[0,0],[0,0],[0,0],[-0.004,0.48],[0.315,0.292],[0.388,0.003],[0,0],[0,0],[0,0],[1.801,0.629],[0.898,0.313],[0,0],[0.182,0.064],[0.474,-0.001],[0.299,-0.299],[0,-0.225],[0,0],[0,0],[0.238,-0.301],[-0.001,-0.443],[-0.291,-0.31],[0,0],[0,0],[0,0],[0,0]],"v":[[-1.108,-12.76],[-1.933,-12.195],[3.214,-4.674],[12.39,-5.643],[12.363,-5.901],[12.363,-5.641],[12.39,-5.643],[12.363,-5.901],[12.363,-5.641],[12.363,-5.971],[12.126,-5.744],[12.363,-5.641],[12.363,-5.971],[12.126,-5.744],[12.356,-5.964],[12.039,-5.964],[12.126,-5.744],[12.356,-5.964],[12.039,-5.964],[12.355,-5.964],[12.103,-6.161],[12.039,-5.964],[12.355,-5.964],[12.103,-6.161],[6.419,1.107],[10.07,9.458],[10.363,9.33],[10.044,9.33],[10.07,9.459],[10.363,9.33],[10.044,9.33],[10.355,9.33],[10.132,9.107],[10.044,9.33],[10.355,9.33],[10.132,9.107],[10.349,9.324],[10.349,9.02],[10.132,9.107],[10.349,9.324],[10.349,9.02],[10.349,9.317],[10.447,9.036],[10.349,9.02],[10.349,9.317],[10.447,9.036],[10.448,9.036],[6.405,7.624],[2.352,6.208],[1.798,6.015],[-5.115,12.133],[-4.912,12.363],[-4.912,12.06],[-5.115,12.133],[-4.912,12.363],[-4.912,12.06],[-4.912,12.365],[-4.703,12.142],[-4.912,12.06],[-4.912,12.365],[-4.703,12.142],[-4.932,12.387],[-4.594,12.387],[-4.703,12.142],[-4.932,12.387],[-4.594,12.387],[-4.871,12.387],[-4.594,12.398],[-4.594,12.387],[-4.871,12.387],[-4.594,12.398],[-4.259,3.247],[-12.196,-1.317],[-12.196,-1.317],[-12.361,-1.029],[-12.031,-1.029],[-12.196,-1.317],[-12.361,-1.029],[-12.031,-1.029],[-12.335,-1.029],[-12.088,-0.854],[-12.031,-1.029],[-12.335,-1.029],[-12.088,-0.854],[-12.335,-1.029],[-12.248,-0.735],[-12.088,-0.854],[-12.335,-1.029],[-12.248,-0.735],[-3.396,-3.356],[-1.375,-12.292],[-1.375,-12.292],[-1.679,-12.361],[-1.494,-12.113],[-1.375,-12.292],[-1.679,-12.361],[-1.494,-12.113],[-1.666,-12.343],[-1.666,-12.055],[-1.494,-12.113],[-1.666,-12.343],[-1.666,-12.055],[-1.666,-12.379],[-1.933,-12.196],[-1.666,-12.055],[-1.666,-12.379],[-1.933,-12.196],[-1.933,-12.195],[-1.108,-12.76],[-0.282,-13.325],[-1.666,-14.055],[-2.691,-13.715],[-3.325,-12.734],[-3.325,-12.734],[-5.088,-4.941],[-12.816,-2.653],[-13.719,-2.011],[-14.031,-1.029],[-13.193,0.417],[-6.302,4.38],[-6.593,12.324],[-6.593,12.323],[-6.594,12.387],[-6.066,13.606],[-4.912,14.059],[-3.789,13.631],[2.685,7.901],[2.022,7.152],[1.692,8.097],[5.746,9.513],[9.788,10.925],[9.79,10.925],[10.349,11.02],[11.545,10.522],[12.044,9.33],[11.902,8.657],[8.729,1.4],[13.678,-4.929],[14.039,-5.964],[13.573,-7.125],[12.363,-7.641],[12.18,-7.632],[4.191,-6.788],[-0.282,-13.325]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.999998922909,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.204,68.879],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 3","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":91,"st":0,"bm":0},{"ddd":0,"ind":44,"ty":4,"nm":"Stj\xe4rna skugga 2","parent":45,"sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":114,"s":[100]},{"t":120,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[42.905,72.019,0],"ix":2,"l":2},"a":{"a":0,"k":[42.905,72.019,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0.371,-0.478],[0,0],[0,0],[0.569,0.203],[0,0],[0,0],[-0.019,0.604],[0,0],[-1.654,4.876]],"o":[[0.602,-0.061],[0,0],[0,0],[0.242,0.552],[0,0],[0,0],[-0.453,0.402],[0,0],[8.163,-4.786],[0,0]],"v":[[8.405,-9.994],[9.081,-8.774],[3.815,-2.021],[7.174,5.824],[6.308,6.749],[-1.82,3.943],[-8.262,9.653],[-9.433,9.077],[-9.372,7.154],[4.107,-9.415]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.957090549843,0.699869851505,0.223505117379,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[43.014,72.108],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":91,"st":0,"bm":0},{"ddd":0,"ind":45,"ty":4,"nm":"Stj\xe4rna fyll 2","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":114,"s":[100]},{"t":120,"s":[0]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.062],"y":[0.996]},"o":{"x":[0.333],"y":[0]},"t":6,"s":[-107]},{"t":22,"s":[0]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":6,"s":[53,50,0],"to":[0.535,2.529,0],"ti":[-0.535,-2.529,0]},{"t":22,"s":[56.208,65.171,0]}],"ix":2,"l":2},"a":{"a":0,"k":[39.208,68.881,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":6,"s":[18.91,18.91,100]},{"t":22,"s":[34.91,34.91,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.337,-0.493],[0,0],[0,0],[0.372,-0.476],[0,0],[0,0],[0.567,0.197],[0.898,0.313],[1.801,0.629],[0,0],[-0.022,0.599],[0,0],[0,0],[-0.581,0.172],[0,0],[0,0]],"o":[[0,0],[0,0],[0.601,-0.064],[0,0],[0,0],[0.239,0.547],[-1.797,-0.628],[-0.901,-0.314],[0,0],[-0.454,0.401],[0,0],[0,0],[-0.519,-0.298],[0,0],[0,0],[0.133,-0.585]],"v":[[-1.133,-12.775],[3.677,-5.746],[12.26,-6.652],[12.866,-5.561],[7.549,1.238],[10.961,9.042],[10.094,9.965],[6.051,8.553],[1.997,7.137],[-4.477,12.867],[-5.618,12.345],[-5.305,3.798],[-12.719,-0.465],[-12.557,-1.709],[-4.267,-4.164],[-2.375,-12.528]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.905205640606,0.78973161286,0.30304218367,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[39.229,68.894],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":91,"st":0,"bm":0}],"markers":[]}');



const $8b1fb2af530da74a$var$Announcers = (props)=>{
    /*
    * TODO as complexity might increase, the animation initialization is not yet looped,
    * could be a bit of a challenge to handle the maintaining of the ref/starting of each lottie component
    * https://react-spring.io/hooks/use-springs
    */ const stars = props.announcerData.announcements;
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useEffect(()=>{
        props.loadAnnouncements();
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useEffect(()=>{
        if (stars.length > 0) setTimeout(()=>{
            props.isAnnouncementsViewed();
            dataLayer.push({
                'event': 'notification_shown',
                'value': stars
            });
        }, 1000);
    }, [
        stars
    ]);
    const starAnimRef = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useRef();
    const starSpring = (0, $9abb3f64d0b26b19$export$c4af9125706c4d30)({
        config: {
            tension: 120,
            friction: 16
        },
        /* TODO: refactor into something in the realm of from: "calc(100%+Xpx)" with X being the bottom margin of the card */ /* probably achievable through view interpolation: https://react-spring.io/basics#view-interpolation */ from: {
            translateY: 150
        },
        to: [
            {
                translateY: 0
            },
            {
                translateY: 120,
                delay: 15000
            }
        ],
        delay: 1000,
        onStart: (result, spring)=>{
            if ("key" in spring) {
                if (spring.animation.to === 0) // actual start
                {
                    if (starAnimRef && starAnimRef.current) starAnimRef.current.play();
                }
            }
        }
    });
    const url = (0, $e6aeb63e6149c504$export$161fa9a9af21e7de)('achievements-list-page-url', props.mountRootId) || '';
    let announcements;
    if (stars.length > 0) {
        const multiple = stars.length > 1;
        announcements = /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $e2b5b10d47aeba87$export$407448d2b89b1813).div, {
            style: starSpring,
            className: "announcement announcement--star",
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2c1cc6e8319f49c7$exports))), {
                    lottieRef: starAnimRef,
                    className: "announcement--animation",
                    animationData: multiple ? (0, (/*@__PURE__*/$parcel$interopDefault($0849046f18ee7608$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($59ef4baaa83f7283$exports))),
                    autoplay: false,
                    loop: false
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("span", {
                    children: [
                        "Du har f\xe5tt ",
                        multiple ? "nya stj\xe4rnor" : "en ny stj\xe4rna",
                        "!"
                    ]
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("a", {
                    href: url,
                    children: "Visa dina stj\xe4rnor"
                })
            ]
        }, "star-announcement");
    }
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Fragment, {
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
            className: "announcement-holder",
            children: announcements
        })
    });
};
const $8b1fb2af530da74a$var$mapStateToProps = (state)=>{
    return {
        announcerData: state.announcerData
    };
};
const $8b1fb2af530da74a$var$mapDispatchToProps = (dispatch)=>{
    return {
        loadAnnouncements: (announcerData)=>dispatch((0, $a0521c7589f563bb$export$79bd6c65cd354a8)(announcerData)),
        isAnnouncementsViewed: ()=>dispatch((0, $a0521c7589f563bb$export$827c5b644a2bee58)())
    };
};
var $8b1fb2af530da74a$export$2e2bcd8739ae039 = (0, $5a4066412ccab0c1$export$64605811ab45167f)($8b1fb2af530da74a$var$mapStateToProps, $8b1fb2af530da74a$var$mapDispatchToProps)($8b1fb2af530da74a$var$Announcers);




var $8NFma = parcelRequire("8NFma");





const $12fcc49385b12997$export$97a140343a8e4907 = (data)=>{
    return {
        type: 'FETCH_POSSESSIONS_STARTED',
        data: data
    };
};
const $12fcc49385b12997$export$a1edd7175901928e = (data)=>{
    return {
        type: 'FETCH_POSSESSIONS_COMPLETE',
        data: data
    };
};
const $12fcc49385b12997$export$d68f5ae971a565c4 = (data)=>{
    return {
        type: 'FETCH_METADATA',
        data: data
    };
};
const $12fcc49385b12997$export$93d5f8b3ca44987c = ()=>{
    const lfDataService = new (0, $25937fdb26d57abd$export$2e2bcd8739ae039)();
    return (dispatch)=>{
        let possessions;
        dispatch($12fcc49385b12997$export$97a140343a8e4907());
        lfDataService.getBasicCoverageData().then((data)=>{
            possessions = data;
            dispatch($12fcc49385b12997$export$a1edd7175901928e(possessions));
        }).catch((e)=>{
            dispatch((0, $67f4b1d2fb7c2244$export$7a8bb273722d5103)(e));
            dispatch((0, $67f4b1d2fb7c2244$export$ea4b4733f4ca2df0)(true));
        });
    };
};
const $12fcc49385b12997$export$ea1c1228362632d = ()=>{
    const lfWebService = new (0, $0f2b98672976a17a$export$2e2bcd8739ae039)();
    return (dispatch)=>{
        let meta;
        lfWebService.possessionsMetaData().then((data)=>{
            meta = data;
            dispatch($12fcc49385b12997$export$d68f5ae971a565c4(meta));
        }).catch((e)=>{
            dispatch((0, $67f4b1d2fb7c2244$export$7a8bb273722d5103)(e));
            dispatch((0, $67f4b1d2fb7c2244$export$ea4b4733f4ca2df0)(true));
        });
    };
};




var $8NFma = parcelRequire("8NFma");


const $9ecaca5bd34c60e9$var$BasicInsuranceCoverListItem = ({ id: id, combined: combined, expanded: expanded, setExpanded: setExpanded, ind: ind })=>{
    const [meta, setMeta] = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useState([]);
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useRef();
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useEffect(()=>{
        if (combined.metaData.length > 0) setMeta(combined.metaData[0]);
    }, [
        combined.metaData
    ]);
    const isOpen = ind === expanded;
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("li", {
        className: "teaser-basic-insurance",
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $bb8231acd22e51c2$export$e25e478948902b8b).header, {
                className: `teaser-basic-insurance__content ${isOpen ? "teaser-basic-insurance__content--expanded" : ""}`,
                onClick: ()=>setExpanded(isOpen ? false : ind),
                children: [
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("h3", {
                        className: "teaser-basic-insurance__content__heading",
                        children: meta.groupDisplayName
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                        className: "teaser-basic-insurance__content__pricing",
                        children: [
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("p", {
                                children: [
                                    "fr.",
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("span", {
                                        className: "bold",
                                        children: [
                                            combined.quote,
                                            "kr / m\xe5nad"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                        className: "separator"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                className: "icon",
                                dangerouslySetInnerHTML: {
                                    __html: (0, (/*@__PURE__*/$parcel$interopDefault($ac8bf4b7d201ab28$exports)))('angle-down').outerHTML
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $9b0ae67beb2269f5$export$3ae376d12526dd6f), {
                initial: false,
                children: isOpen && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $bb8231acd22e51c2$export$e25e478948902b8b).div, {
                    className: "teaser-basic-insurance__additional-info",
                    initial: "closed",
                    animate: "open",
                    exit: "closed",
                    variants: {
                        open: {
                            opacity: 1,
                            height: "auto"
                        },
                        closed: {
                            opacity: 0,
                            height: 0
                        }
                    },
                    transition: {
                        duration: 0.8
                    },
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                        className: "teaser-basic-insurance__additional-info__content",
                        ref: ref,
                        children: [
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("h4", {
                                className: "teaser-basic-insurance__additional-info__content__title",
                                children: "F\xf6rdelar med f\xf6rs\xe4kringen"
                            }),
                            meta.insuranceShortInfo !== null && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: meta.insuranceShortInfo
                                }
                            }),
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                className: "teaser-basic-insurance__additional-info__content__links",
                                children: [
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("a", {
                                        className: "link arrow-link",
                                        href: meta.insurancePageLinkUrl,
                                        children: [
                                            "L\xe4s mer om f\xf6rs\xe4kringen",
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                className: "icon",
                                                dangerouslySetInnerHTML: {
                                                    __html: (0, (/*@__PURE__*/$parcel$interopDefault($ac8bf4b7d201ab28$exports)))('long-arrow-right').outerHTML
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("a", {
                                        className: "button button--green button--small",
                                        href: meta.insurancePurchaseLinkUrl,
                                        children: "K\xf6p f\xf6rs\xe4kring"
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                className: "teaser-basic-insurance__footer",
                children: [
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("p", {
                        className: "teaser-basic-insurance__footer__notice",
                        children: [
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                className: "icon",
                                dangerouslySetInnerHTML: {
                                    __html: (0, (/*@__PURE__*/$parcel$interopDefault($ac8bf4b7d201ab28$exports)))('info-circle').outerHTML
                                }
                            }),
                            "Du saknar denna f\xf6rs\xe4kring"
                        ]
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("a", {
                        className: "button button--green button--small",
                        href: meta.insurancePurchaseLinkUrl,
                        children: "K\xf6p f\xf6rs\xe4kring"
                    })
                ]
            })
        ]
    });
};
var $9ecaca5bd34c60e9$export$2e2bcd8739ae039 = $9ecaca5bd34c60e9$var$BasicInsuranceCoverListItem;


const $4078074f44a2fef6$var$BasicInsuranceCoverList = (props)=>{
    const heading = (0, $e6aeb63e6149c504$export$161fa9a9af21e7de)('heading', props.mountRootId) || '';
    const preamble = (0, $e6aeb63e6149c504$export$161fa9a9af21e7de)('preamble', props.mountRootId) || '';
    const [expanded, setExpanded] = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useEffect(()=>{
        props.loadPossessions();
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useEffect(()=>{
        props.loadMetaData();
    }, []);
    let basicCoverage = props.possessionsData.missingBasicCoverInsurances;
    let metaData = props.metaData;
    let combined;
    if (basicCoverage && basicCoverage.length > 0) combined = basicCoverage.map((item)=>({
            ...item,
            metaData: metaData.meta.filter((f)=>f.groupName === item.groupName)
        }));
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $13f4c0370d7de649$exports.Fragment), {
        children: [
            combined && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                className: "block-spacing",
                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                    className: "section-spacing",
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("h3", {
                            children: heading
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("p", {
                            children: preamble
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("ul", {
                children: combined && combined.length > 0 && combined.map((data, ind)=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $9ecaca5bd34c60e9$export$2e2bcd8739ae039), {
                        id: ind,
                        combined: data,
                        ind: ind,
                        expanded: expanded,
                        setExpanded: setExpanded
                    }, ind))
            })
        ]
    });
};
const $4078074f44a2fef6$var$mapStateToProps = (state)=>{
    return {
        possessionsData: state.possessionsData,
        metaData: state.metaData
    };
};
const $4078074f44a2fef6$var$mapDispatchToProps = (dispatch)=>{
    return {
        loadPossessions: (possessionsData)=>dispatch((0, $12fcc49385b12997$export$93d5f8b3ca44987c)(possessionsData)),
        loadMetaData: (metaData)=>dispatch((0, $12fcc49385b12997$export$ea1c1228362632d)(metaData))
    };
};
var $4078074f44a2fef6$export$2e2bcd8739ae039 = (0, $5a4066412ccab0c1$export$64605811ab45167f)($4078074f44a2fef6$var$mapStateToProps, $4078074f44a2fef6$var$mapDispatchToProps)($4078074f44a2fef6$var$BasicInsuranceCoverList);




var $8NFma = parcelRequire("8NFma");



const $1111a13fecf05f72$export$89f44ab0884b97fc = (data)=>{
    return {
        type: 'FETCH_WIZARD',
        data: data
    };
};
const $1111a13fecf05f72$export$515e4242f6bb2050 = (data)=>{
    return {
        type: 'WIZARD_FORM_SUBMITTED',
        data: data
    };
};
const $1111a13fecf05f72$export$d4e2ec0d616699f8 = (hasFailed)=>{
    return {
        type: 'WIZARD_FORM_SUBMIT_FAILED',
        data: !!hasFailed
    };
};
const $1111a13fecf05f72$export$d699c2cd4648dfb4 = ()=>{
    const lfDataService = new (0, $25937fdb26d57abd$export$2e2bcd8739ae039)();
    return (dispatch)=>{
        let questions;
        lfDataService.getWizardQuestions().then((data)=>{
            questions = data;
            dispatch($1111a13fecf05f72$export$89f44ab0884b97fc(questions.questionGroups));
        }).catch((e)=>{
            dispatch((0, $67f4b1d2fb7c2244$export$7a8bb273722d5103)(e));
            dispatch((0, $67f4b1d2fb7c2244$export$ea4b4733f4ca2df0)(true));
        });
    };
};
const $1111a13fecf05f72$export$2a0a00b73a1d8967 = (data)=>{
    const lfDataService = new (0, $25937fdb26d57abd$export$2e2bcd8739ae039)();
    return (dispatch)=>{
        lfDataService.submitWizardForm(data).then((result)=>{
            if (result.success) {
                dispatch($1111a13fecf05f72$export$d4e2ec0d616699f8(false));
                dispatch($1111a13fecf05f72$export$515e4242f6bb2050(data));
                return;
            } else {
                dispatch($1111a13fecf05f72$export$d4e2ec0d616699f8(true));
                dispatch((0, $67f4b1d2fb7c2244$export$7a8bb273722d5103)('kunde inte uppdatera dina uppgifter'));
                dispatch((0, $67f4b1d2fb7c2244$export$ea4b4733f4ca2df0)(true));
            }
        }).catch((e)=>{
            dispatch($1111a13fecf05f72$export$d4e2ec0d616699f8(true));
            dispatch((0, $67f4b1d2fb7c2244$export$7a8bb273722d5103)(e));
            dispatch((0, $67f4b1d2fb7c2244$export$ea4b4733f4ca2df0)(true));
        });
    };
};



var $8NFma = parcelRequire("8NFma");
const $0dd9597ef3a05327$var$WizardContext = /*#__PURE__*/ (0, $8NFma.createContext)(null);
const $0dd9597ef3a05327$export$a4374de96a19cef5 = ()=>{
    const context = (0, $8NFma.useContext)($0dd9597ef3a05327$var$WizardContext);
    return context;
};
/**
 * Log messages in the console with a corresponding urgency
 *
 * @param level The urgency of the message
 * @param message The message to log in the console
 */ const $0dd9597ef3a05327$var$log = (level, message)=>{};
const $0dd9597ef3a05327$export$c6a37f46d6629cf2 = /*#__PURE__*/ (0, $8NFma.memo)(({ header: header, footer: footer, children: children, onStepChange: onStepChange, wrapper: Wrapper, startIndex: startIndex = 0 })=>{
    const [activeStep, setActiveStep] = (0, $8NFma.useState)(startIndex);
    const [isLoading, setIsLoading] = (0, $8NFma.useState)(false);
    const hasNextStep = (0, $8NFma.useRef)(true);
    const hasPreviousStep = (0, $8NFma.useRef)(false);
    const nextStepHandler = (0, $8NFma.useRef)(()=>{});
    const stepCount = (0, $8NFma.Children).toArray(children).length;
    hasNextStep.current = activeStep < stepCount - 1;
    hasPreviousStep.current = activeStep > 0;
    const goToNextStep = (0, $8NFma.useCallback)(()=>{
        if (hasNextStep.current) {
            const newActiveStepIndex = activeStep + 1;
            setActiveStep(newActiveStepIndex);
            onStepChange == null || onStepChange(newActiveStepIndex);
        }
    }, [
        activeStep,
        onStepChange
    ]);
    const goToPreviousStep = (0, $8NFma.useCallback)(()=>{
        if (hasPreviousStep.current) {
            nextStepHandler.current = null;
            const newActiveStepIndex = activeStep - 1;
            setActiveStep(newActiveStepIndex);
            onStepChange == null || onStepChange(newActiveStepIndex);
        }
    }, [
        activeStep,
        onStepChange
    ]);
    const goToStep = (0, $8NFma.useCallback)((stepIndex)=>{
        if (stepIndex >= 0 && stepIndex < stepCount) {
            nextStepHandler.current = null;
            setActiveStep(stepIndex);
            onStepChange == null || onStepChange(stepIndex);
        }
    }, [
        stepCount,
        onStepChange
    ]); // Callback to attach the step handler
    const handleStep = (0, $8NFma.useRef)((handler)=>{
        nextStepHandler.current = handler;
    });
    const doNextStep = (0, $8NFma.useCallback)(async ()=>{
        if (hasNextStep.current && nextStepHandler.current) try {
            setIsLoading(true);
            await nextStepHandler.current();
            setIsLoading(false);
            nextStepHandler.current = null;
            goToNextStep();
        } catch (error) {
            setIsLoading(false);
            throw error;
        }
        else goToNextStep();
    }, [
        goToNextStep
    ]);
    const wizardValue = (0, $8NFma.useMemo)(()=>({
            nextStep: doNextStep,
            previousStep: goToPreviousStep,
            handleStep: handleStep.current,
            isLoading: isLoading,
            activeStep: activeStep,
            stepCount: stepCount,
            isFirstStep: !hasPreviousStep.current,
            isLastStep: !hasNextStep.current,
            goToStep: goToStep
        }), [
        doNextStep,
        goToPreviousStep,
        isLoading,
        activeStep,
        stepCount,
        goToStep
    ]);
    const activeStepContent = (0, $8NFma.useMemo)(()=>{
        const reactChildren = (0, $8NFma.Children).toArray(children);
        return reactChildren[activeStep];
    }, [
        activeStep,
        children,
        header,
        footer
    ]);
    const enhancedActiveStepContent = (0, $8NFma.useMemo)(()=>Wrapper ? (0, $8NFma.cloneElement)(Wrapper, {
            children: activeStepContent
        }) : activeStepContent, [
        Wrapper,
        activeStepContent
    ]);
    return (0, $8NFma.createElement)($0dd9597ef3a05327$var$WizardContext.Provider, {
        value: wizardValue
    }, header, enhancedActiveStepContent, footer);
});





var $8NFma = parcelRequire("8NFma");


parcelRequire("8NFma");


const $f1ddc81c6a4657be$var$WizardNavigation = (props)=>{
    const { nextStep: nextStep, activeStep: activeStep, stepCount: stepCount } = (0, $0dd9597ef3a05327$export$a4374de96a19cef5)();
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("span", {
        className: "wizard__question__navigation",
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                className: "wizard__question__navigation__text",
                children: "Skr\xe4ddarsy dina uppgifter"
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("span", {
                className: "wizard__question__navigation__count",
                children: [
                    activeStep + 1,
                    " / ",
                    stepCount - 1
                ]
            }),
            activeStep >= stepCount - 1 ? null : /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                onClick: ()=>nextStep(),
                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                    dangerouslySetInnerHTML: {
                        __html: (0, (/*@__PURE__*/$parcel$interopDefault($ac8bf4b7d201ab28$exports)))('angle-right').outerHTML
                    }
                })
            })
        ]
    });
};
var $f1ddc81c6a4657be$export$2e2bcd8739ae039 = $f1ddc81c6a4657be$var$WizardNavigation;


const $1dc629998017ace5$var$WizardQuestion = (props)=>{
    const { form: [formState, setFormState] } = {
        form: (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useState([]),
        ...props.state || {}
    };
    const { nextStep: nextStep } = (0, $0dd9597ef3a05327$export$a4374de96a19cef5)();
    const onChangeHandler = (e)=>{
        const id = props.question.id;
        setFormState((formState)=>({
                ...formState,
                answers: [
                    ...formState.answers,
                    {
                        questionid: id,
                        answer: event.target.value
                    }
                ]
            }));
        setTimeout(()=>{
            nextStep();
        }, 200);
    };
    const options = props.question.options;
    let key = Math.random();
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Fragment, {
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
            className: "wizard__question",
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $f1ddc81c6a4657be$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("h2", {
                    className: "wizard__question__heading",
                    children: props.question.questionText
                }),
                options && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("section", {
                    className: "wizard__question__options",
                    children: [
                        options.length > 0 && options.map((option, i)=>{
                            return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Fragment, {
                                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("label", {
                                    htmlFor: `question-${i}`,
                                    className: "button button--green button--medium",
                                    children: [
                                        option.text,
                                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("input", {
                                            onChange: onChangeHandler,
                                            id: `question-${i}`,
                                            name: `question-${i}`,
                                            type: "radio",
                                            value: option.text
                                        })
                                    ]
                                })
                            }, i);
                        }),
                        options.length <= 0 && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Fragment, {
                            children: [
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("label", {
                                    htmlFor: "confirm",
                                    className: "button button--green button--medium",
                                    children: [
                                        "Ja",
                                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("input", {
                                            onChange: onChangeHandler,
                                            id: "confirm",
                                            name: "confirm",
                                            type: "radio",
                                            value: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("label", {
                                    htmlFor: "decline",
                                    className: "button button--green button--medium",
                                    children: [
                                        "Nej",
                                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("input", {
                                            onChange: onChangeHandler,
                                            id: "decline",
                                            name: "decline",
                                            type: "radio",
                                            value: false
                                        })
                                    ]
                                })
                            ]
                        }, key)
                    ]
                })
            ]
        }, key)
    });
};
var $1dc629998017ace5$export$2e2bcd8739ae039 = $1dc629998017ace5$var$WizardQuestion;




var $8NFma = parcelRequire("8NFma");



var $2ca59c14d83f9837$exports = {};
$2ca59c14d83f9837$exports = JSON.parse("{\"v\":\"5.7.13\",\"fr\":30,\"ip\":0,\"op\":79,\"w\":120,\"h\":120,\"nm\":\"circle\",\"ddd\":0,\"assets\":[],\"layers\":[{\"ddd\":0,\"ind\":1,\"ty\":3,\"nm\":\"heartBeat\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":0,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[60,64.5,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[50,50,0],\"ix\":1,\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":37,\"s\":[100,100,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":40.883,\"s\":[110,110,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":44.765,\"s\":[100,100,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":49.941,\"s\":[110,110,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":55.117,\"s\":[100,100,100]},{\"t\":59,\"s\":[100,100,100]}],\"ix\":6,\"l\":2}},\"ao\":0,\"ip\":28,\"op\":897,\"st\":-3,\"bm\":0},{\"ddd\":0,\"ind\":2,\"ty\":4,\"nm\":\"heat\",\"parent\":1,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[50,50,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[33.771,28.586,0],\"ix\":1,\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0,0,0.09],\"y\":[1,1,1]},\"o\":{\"x\":[0.487,0.487,0.333],\"y\":[0,0,0]},\"t\":31,\"s\":[0,0,100]},{\"i\":{\"x\":[0,0,0.565],\"y\":[1,1,1]},\"o\":{\"x\":[0.613,0.613,0.254],\"y\":[0,0,0]},\"t\":37,\"s\":[80,80,100]},{\"t\":41,\"s\":[80,80,100]}],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[-7.327,0],[0,-9.261],[0,0],[6.165,-4.153]],\"o\":[[2.557,-6.189],[9.6,0],[0,0],[0,15.263],[0,0]],\"v\":[[-16.761,-17.767],[-0.62,-28.336],[16.761,-11.566],[16.761,-10.37],[-16.761,28.336]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.160784313725,0.450980422076,0.737254901961,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[50.532,28.586],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[7.328,0],[0,-9.261],[0,0],[-6.165,-4.153],[0,0],[0,0]],\"o\":[[-2.557,-6.189],[-9.6,0],[0,0],[0,15.263],[0,0],[0,0],[0,0]],\"v\":[[16.002,-17.767],[-0.139,-28.336],[-17.519,-11.566],[-17.519,-10.37],[16.002,28.336],[17.519,27.298],[16.955,-18.582]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.215686289469,0.686274509804,0.294117647059,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[17.769,28.586],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 2\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":28,\"op\":897,\"st\":-3,\"bm\":0},{\"ddd\":0,\"ind\":3,\"ty\":3,\"nm\":\"Rotation\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":0,\"ix\":11},\"r\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.12],\"y\":[1]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":0,\"s\":[47]},{\"i\":{\"x\":[0.07],\"y\":[1]},\"o\":{\"x\":[0.167],\"y\":[0.2]},\"t\":15,\"s\":[60.928]},{\"t\":27,\"s\":[-109.435]}],\"ix\":10},\"p\":{\"a\":0,\"k\":[60,60,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[0,0,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"ip\":6,\"op\":905,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":4,\"ty\":4,\"nm\":\"SmallDot\",\"parent\":3,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[-42.117,-26.95,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[-23.717,-20.017,0],\"ix\":1,\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":0,\"s\":[0,0,100]},{\"t\":14,\"s\":[103,103,100]}],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"d\":1,\"ty\":\"el\",\"s\":{\"a\":0,\"k\":[11.967,11.967],\"ix\":2},\"p\":{\"a\":0,\"k\":[0,0],\"ix\":3},\"nm\":\"Ellipse Path 1\",\"mn\":\"ADBE Vector Shape - Ellipse\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,1,1,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[-23.717,-20.017],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Ellipse 1\",\"np\":3,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":6,\"op\":14,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":5,\"ty\":4,\"nm\":\"circle\",\"parent\":3,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":-61,\"ix\":10},\"p\":{\"a\":0,\"k\":[0,0,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[0,0,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"d\":3,\"ty\":\"el\",\"s\":{\"a\":0,\"k\":[100,100],\"ix\":2},\"p\":{\"a\":0,\"k\":[0,0],\"ix\":3},\"nm\":\"Ellipse Path 1\",\"mn\":\"ADBE Vector Shape - Ellipse\",\"hd\":false},{\"ty\":\"tm\",\"s\":{\"a\":0,\"k\":1,\"ix\":1},\"e\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.05],\"y\":[1]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":14,\"s\":[0]},{\"t\":27,\"s\":[100]}],\"ix\":2},\"o\":{\"a\":0,\"k\":0,\"ix\":3},\"m\":1,\"ix\":2,\"nm\":\"Trim Paths 1\",\"mn\":\"ADBE Vector Filter - Trim\",\"hd\":false},{\"ty\":\"st\",\"c\":{\"a\":0,\"k\":[1,1,1,1],\"ix\":3},\"o\":{\"a\":0,\"k\":100,\"ix\":4},\"w\":{\"a\":0,\"k\":12,\"ix\":5},\"lc\":2,\"lj\":1,\"ml\":4,\"bm\":0,\"nm\":\"Stroke 1\",\"mn\":\"ADBE Vector Graphic - Stroke\",\"hd\":false}],\"ip\":14,\"op\":881,\"st\":-24,\"bm\":0},{\"ddd\":0,\"ind\":6,\"ty\":4,\"nm\":\"blue_circle\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[60,60,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[0,0,0],\"ix\":1,\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.508,0.508,0.09],\"y\":[1,1,1]},\"o\":{\"x\":[0.145,0.145,0.333],\"y\":[0,0,0]},\"t\":23,\"s\":[101,101,100]},{\"t\":30,\"s\":[0,0,100]}],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"d\":1,\"ty\":\"el\",\"s\":{\"a\":0,\"k\":[1.181,0.707],\"ix\":2},\"p\":{\"a\":0,\"k\":[0,0],\"ix\":3},\"nm\":\"Ellipse Path 1\",\"mn\":\"ADBE Vector Shape - Ellipse\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.243137254902,0.447058823529,0.733333333333,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[-432.41,-96.646],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Ellipse 1\",\"np\":3,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"d\":1,\"ty\":\"el\",\"s\":{\"a\":0,\"k\":[100,100],\"ix\":2},\"p\":{\"a\":0,\"k\":[0,0],\"ix\":3},\"nm\":\"Ellipse Path 1\",\"mn\":\"ADBE Vector Shape - Ellipse\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0,0.450980395079,0.741176486015,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false}],\"ip\":0,\"op\":900,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":7,\"ty\":4,\"nm\":\"white_circle\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[60,60,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[0,0,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"d\":1,\"ty\":\"el\",\"s\":{\"a\":0,\"k\":[1.181,0.707],\"ix\":2},\"p\":{\"a\":0,\"k\":[0,0],\"ix\":3},\"nm\":\"Ellipse Path 1\",\"mn\":\"ADBE Vector Shape - Ellipse\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.243137254902,0.447058823529,0.733333333333,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[-432.41,-96.646],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Ellipse 1\",\"np\":3,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"d\":1,\"ty\":\"el\",\"s\":{\"a\":0,\"k\":[100,100],\"ix\":2},\"p\":{\"a\":0,\"k\":[0,0],\"ix\":3},\"nm\":\"Ellipse Path 1\",\"mn\":\"ADBE Vector Shape - Ellipse\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,1,1,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false}],\"ip\":0,\"op\":900,\"st\":0,\"bm\":0}],\"markers\":[]}");


const $c22727623cd89e5e$var$WizardFinal = (props)=>{
    const { form: [formState, setFormState] } = {
        form: (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useState([]),
        ...props.state || {}
    };
    const lottieRef = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useRef();
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useEffect(()=>{
        props.handleSubmit();
    }, [
        formState
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useEffect(()=>{
        if (lottieRef && lottieRef.current) lottieRef.current.play();
    }, []);
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
        className: "wizard__question",
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("h2", {
                className: "wizard__question__heading",
                children: "Tack f\xf6r dina svar! Nu blir vi lite b\xe4ttre p\xe5 att hj\xe4lpa dig vara r\xe4tt f\xf6rs\xe4krad."
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2c1cc6e8319f49c7$exports))), {
                className: "wizard__question__animation",
                lottieRef: lottieRef,
                autoplay: false,
                loop: false,
                animationData: (0, (/*@__PURE__*/$parcel$interopDefault($2ca59c14d83f9837$exports)))
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("a", {
                className: "arrow-link",
                href: "https://www.lararforsakringar.se/gdpr/",
                children: [
                    "S\xe5 h\xe4r anv\xe4nder vi uppgifterna",
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                        dangerouslySetInnerHTML: {
                            __html: (0, (/*@__PURE__*/$parcel$interopDefault($ac8bf4b7d201ab28$exports)))('long-arrow-right').outerHTML
                        }
                    })
                ]
            })
        ]
    });
};
var $c22727623cd89e5e$export$2e2bcd8739ae039 = (0, $5a4066412ccab0c1$export$64605811ab45167f)(null)($c22727623cd89e5e$var$WizardFinal);




var $8NFma = parcelRequire("8NFma");


const $10b78b9271ceb806$var$variants = {
    enter: (direction)=>{
        return {
            x: "-15%",
            opacity: 0
        };
    },
    center: {
        zIndex: 1,
        x: 0,
        opacity: 1
    }
};
const $10b78b9271ceb806$var$WizardAnimation = ({ children: children, previousStep: previousStepIndex })=>{
    const { activeStep: activeStep } = (0, $0dd9597ef3a05327$export$a4374de96a19cef5)();
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useEffect(()=>{
        previousStepIndex.current = activeStep;
    }, [
        activeStep,
        previousStepIndex
    ]);
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $bb8231acd22e51c2$export$e25e478948902b8b).div, {
        custom: activeStep - previousStepIndex.current,
        initial: "enter",
        animate: "center",
        variants: $10b78b9271ceb806$var$variants,
        transition: {
            x: {
                type: "spring",
                stiffness: 300,
                damping: 60
            },
            opacity: {
                duration: 0.5
            }
        },
        children: children
    });
};
var $10b78b9271ceb806$export$2e2bcd8739ae039 = $10b78b9271ceb806$var$WizardAnimation;


const $ade84258485b4519$var$WizardBase = (props)=>{
    const [questions, setQuestions] = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useState([]);
    const [formState, setFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useState({
        answers: []
    });
    const previousStep = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useRef(0);
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useEffect(()=>{
        props.loadQuestions();
    }, []);
    const questionGroups = props.wizardData.questions;
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useEffect(()=>{
        if (questionGroups) questionGroups.map((sections, i)=>{
            sections.questions.map((question, index)=>{
                setQuestions((questions)=>[
                        ...questions,
                        question
                    ]);
            });
        });
    }, [
        questionGroups
    ]);
    const handleSubmit = ()=>{
        //clean undefined and null values
        let formData = Object.entries(formState).reduce((a, [k, v])=>v == null ? a : (a[k] = v, a), {});
        props.submitForm(formData);
        dataLayer.push({
            'event': 'customer_knowledge_survey_complete'
        });
    };
    const totalQuestions = questions.length;
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Fragment, {
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $9b0ae67beb2269f5$export$3ae376d12526dd6f), {
            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $0dd9597ef3a05327$export$c6a37f46d6629cf2), {
                children: [
                    questions.length > 0 && questions.map((question, index)=>{
                        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("form", {
                            className: "wizard",
                            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $10b78b9271ceb806$export$2e2bcd8739ae039), {
                                previousStep: previousStep,
                                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $1dc629998017ace5$export$2e2bcd8739ae039), {
                                    totalQuestions: totalQuestions,
                                    question: question,
                                    state: {
                                        form: [
                                            formState,
                                            setFormState
                                        ]
                                    }
                                }, index)
                            })
                        }, index);
                    }),
                    questions.length > 0 && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $c22727623cd89e5e$export$2e2bcd8739ae039), {
                        handleSubmit: handleSubmit
                    })
                ]
            })
        })
    });
};
// state
const $ade84258485b4519$var$mapStateToProps = (state)=>{
    return {
        wizardData: state.wizardData,
        formData: state.formData
    };
};
const $ade84258485b4519$var$mapDispatchToProps = (dispatch)=>{
    return {
        loadQuestions: (wizardData)=>dispatch((0, $1111a13fecf05f72$export$d699c2cd4648dfb4)(wizardData)),
        submitForm: (formData)=>dispatch((0, $1111a13fecf05f72$export$2a0a00b73a1d8967)(formData))
    };
};
var $ade84258485b4519$export$2e2bcd8739ae039 = (0, $5a4066412ccab0c1$export$64605811ab45167f)($ade84258485b4519$var$mapStateToProps, $ade84258485b4519$var$mapDispatchToProps)($ade84258485b4519$var$WizardBase);




var $8NFma = parcelRequire("8NFma");





const $e0bb054daf10d535$export$154816554838c59c = (data)=>{
    return {
        type: 'FETCH_MANAGED_PENSION_QUESTIONS',
        data: data
    };
};
const $e0bb054daf10d535$export$dde045e05c544499 = (data)=>{
    return {
        type: 'CHAPTERS',
        data: data
    };
};
const $e0bb054daf10d535$export$cc86372b12ed4575 = (data)=>{
    return {
        type: 'CHAPTER_TITLES',
        data: data
    };
};
const $e0bb054daf10d535$export$37aedc7557241034 = (data)=>{
    return {
        type: 'QUESTIONS',
        data: data
    };
};
const $e0bb054daf10d535$export$fc6b8f76982e5708 = (data)=>{
    return {
        type: 'PENSION_WIZARD_FORM_SUBMITTED',
        data: data
    };
};
const $e0bb054daf10d535$export$59d4d73438d6d88e = (payload)=>{
    return {
        type: 'PENSION_WIZARD_FORM_SUBMIT_FAILED',
        data: !!payload
    };
};
const $e0bb054daf10d535$export$570f7f93f7e4318b = (payload)=>{
    return {
        type: 'STATUS',
        data: payload
    };
};
const $e0bb054daf10d535$export$9f92f7cfad488750 = (payload)=>{
    return {
        type: 'STATUS_PENDING',
        data: payload
    };
};
const $e0bb054daf10d535$export$a0d28d34487b97f0 = (payload)=>{
    return {
        type: 'APPID',
        data: payload
    };
};
const $e0bb054daf10d535$export$a5d3f4e395d333a8 = (payload)=>{
    return {
        type: 'FORMID',
        data: payload
    };
};
const $e0bb054daf10d535$export$980f7a87096fc373 = (payload)=>{
    return {
        type: 'STOP',
        data: payload
    };
};
const $e0bb054daf10d535$export$6ee946a9c0034f4a = (payload)=>{
    return {
        type: 'LOADING',
        data: payload
    };
};
const $e0bb054daf10d535$export$73f8cffc8347bbf1 = (payload)=>{
    return {
        type: 'TOGGLE_MODAL_CONTENT',
        data: payload
    };
};
const $e0bb054daf10d535$export$c83948663a313d7d = (payload)=>{
    return {
        type: 'UPDATE_PROGRESS',
        data: payload
    };
};
const $e0bb054daf10d535$export$23b5c3f8d48c5473 = (payload)=>{
    return {
        type: 'CURRENT_CHAPTER_TITLE',
        data: payload
    };
};
const $e0bb054daf10d535$export$fe2cf2aef257418b = ()=>{
    const lfDataService = new (0, $25937fdb26d57abd$export$2e2bcd8739ae039)();
    return (dispatch)=>{
        let result;
        let chapters = [];
        let titles = [];
        let questions = [];
        lfDataService.getManagedPensionQuestions().then((data)=>{
            result = data;
            dispatch($e0bb054daf10d535$export$154816554838c59c(result.questionGroups));
            dispatch($e0bb054daf10d535$export$a5d3f4e395d333a8(result.formId));
            result.questionGroups.forEach((chapter)=>chapters.push(chapter));
            dispatch($e0bb054daf10d535$export$dde045e05c544499(chapters));
            chapters.forEach((title)=>titles.push(title.title));
            dispatch($e0bb054daf10d535$export$cc86372b12ed4575(titles));
            chapters.forEach((chapter)=>questions.push(chapter.questions));
            dispatch($e0bb054daf10d535$export$37aedc7557241034(questions));
        }).catch((e)=>{
            dispatch((0, $67f4b1d2fb7c2244$export$7a8bb273722d5103)(e));
            dispatch((0, $67f4b1d2fb7c2244$export$ea4b4733f4ca2df0)(true));
        });
    };
};
const $e0bb054daf10d535$export$f059a5f39ec89d4 = (payload)=>{
    return (dispatch)=>{
        dispatch($e0bb054daf10d535$export$c83948663a313d7d(payload));
    };
};
const $e0bb054daf10d535$export$23d64402cbf037a2 = (payload)=>{
    return (dispatch)=>{
        dispatch($e0bb054daf10d535$export$23b5c3f8d48c5473(payload));
    };
};
const $e0bb054daf10d535$export$4993b9caf321516a = (data)=>{
    let response;
    let appId;
    return (dispatch)=>{
        const lfDataService = new (0, $25937fdb26d57abd$export$2e2bcd8739ae039)();
        lfDataService.submitPensionWizardForm(data).then((result)=>{
            response = result;
            if (response.success === true) {
                appId = response.applicationId;
                dispatch($e0bb054daf10d535$export$a0d28d34487b97f0(appId));
                dispatch($e0bb054daf10d535$export$fc6b8f76982e5708(true));
                dispatch($e0bb054daf10d535$export$59d4d73438d6d88e(false));
            } else dispatch($e0bb054daf10d535$export$59d4d73438d6d88e(true));
        }).catch((e)=>{
            dispatch((0, $67f4b1d2fb7c2244$export$7a8bb273722d5103)(e));
            dispatch((0, $67f4b1d2fb7c2244$export$ea4b4733f4ca2df0)(true));
        });
    };
};
const $e0bb054daf10d535$export$3f1ecdc4d97d1ccf = (data)=>{
    const lfDataService = new (0, $25937fdb26d57abd$export$2e2bcd8739ae039)();
    return (dispatch)=>{
        lfDataService.getManagedPensionApplicationSignatureStatus(data).then((res)=>{
            dispatch($e0bb054daf10d535$export$570f7f93f7e4318b(res.applicationStatus));
        });
    };
};




var $8NFma = parcelRequire("8NFma");


const $b8ceef3013a3a6fa$export$b3571188c770cc5a = {
    text: "Du beh\xf6ver bara svara p\xe5 n\xe5gra fr\xe5gor s\xe5 sk\xf6ter vi resten.",
    headline: "B\xf6rja spara idag",
    buttonText: "B\xf6rja spara"
};
const $b8ceef3013a3a6fa$export$299f8d7938fe0260 = {
    text: "N\xe4r du har skickat in din ans\xf6kan kommer den att kontrolleras automatiskt. Om allt ser r\xe4tt ut kan du i n\xe4sta steg signera din ans\xf6kan med BankID och starta ditt sparande.",
    headline: "Nu kan du skicka in din ans\xf6kan!",
    paragraph2: "Du kommer \xe4ven f\xe5 ett e-postmeddelande fr\xe5n Futur Pension med en l\xe4nk f\xf6r att signera din ans\xf6kan. Om du signerar i n\xe4sta steg kan du bortse fr\xe5n det meddelandet. ",
    paragraph3: "Din ans\xf6kan med de svar du l\xe4mnat finns tillg\xe4nglig under Mina dokument p\xe5 L\xe4rarf\xf6rs\xe4kringars Mina sidor.",
    buttonText: 'Skicka in'
};
const $b8ceef3013a3a6fa$export$6b501c78a3684162 = {
    text: "Du betalar ditt sparande med autogiro. Ange kontonumret till det konto som du vill att pengarna ska dras ifr\xe5n varje m\xe5nad.",
    headline: 'Betala med autogiro',
    labelClearing: 'Clearingnummer',
    labelAccount: 'Kontonummer'
};
const $b8ceef3013a3a6fa$export$abbdf820e7b8bc0a = {
    text: "Din ans\xf6kan \xe4r mottagen men beh\xf6ver behandlas manuellt. Du kommer att bli kontaktad med mer information inom kort. Tack f\xf6r din ans\xf6kan!",
    headline: "Din ans\xf6kan m\xe5ste behandlas manuellt",
    buttonText: 'Okej, avsluta'
};
const $b8ceef3013a3a6fa$export$a3bc9b8ed74fc = {
    text: "Din ans\xf6kan kunde tyv\xe4rr inte skickas in. Kontakta kundservice f\xf6r att f\xe5 hj\xe4lp.",
    headline: "N\xe5got har g\xe5tt fel",
    buttonText: 'Okej, avsluta'
};
const $b8ceef3013a3a6fa$export$bb83dd1197ba90eb = {
    text: "Du beh\xf6ver prata med en av v\xe5ra r\xe5dgivare. Tryck p\xe5 knappen f\xf6r att avsluta guiden och komma till bokningssidan.",
    headline: "Prata med r\xe5dgivare",
    buttonText: "Ok, avsluta och boka r\xe5dgivning",
    linkText: 'Avbryt'
};
const $b8ceef3013a3a6fa$export$34bf1befb2fab61a = {
    text: 'Vill du avsluta? Dina svar sparas inte.',
    headline: 'Avsluta',
    buttonText: 'Okej, jag vill avsluta',
    linkText: 'Avbryt'
};
const $b8ceef3013a3a6fa$export$124049a9e3d0d4c3 = {
    headline: 'Starta ditt sparande',
    text: "B\xf6rja spara i en kapitalf\xf6rs\xe4kring med fonder. Ett enkelt och f\xf6rm\xe5nligt sparande f\xf6r medlemmar i Sveriges L\xe4rare och Sveriges Skolledare med Futur Pension som f\xf6rs\xe4kringsgivare."
};
const $b8ceef3013a3a6fa$export$c058c12a17cc5c02 = {
    next: "N\xe4sta",
    leave: 'Okej, jag vill avsluta',
    advisor: "Ok, avsluta och boka r\xe5dgivning",
    quit: 'Okej, avsluta',
    start: "B\xf6rja spara"
};
const $b8ceef3013a3a6fa$export$c1c8c4a48179a206 = {
    start: 'https://www.lararforsakringar.se/',
    advise: 'https://www.lararforsakringar.se/pension--sparande/boka-radgivning/'
};




var $8NFma = parcelRequire("8NFma");




var $8NFma = parcelRequire("8NFma");




var $8NFma = parcelRequire("8NFma");


const $c94e927d30586550$var$Label = ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("label", {
        className: props.className,
        htmlFor: props.for,
        children: children
    }, props.key);
};
var $c94e927d30586550$export$2e2bcd8739ae039 = $c94e927d30586550$var$Label;


// components


const $fd2e525325cc1a5d$var$OptionButton = ({ children: children, ...props })=>{
    const handleChange = (answer)=>{
        props.handleAnswer(answer, props.id);
    };
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $c94e927d30586550$export$2e2bcd8739ae039), {
        className: props.className,
        for: props.text,
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("input", {
                className: "pension-wizard-block__question__card__options__option__button__input",
                type: "radio",
                name: "radio",
                id: props.text,
                value: props.text,
                onChange: (e)=>handleChange(e.target.value, props.id)
            }),
            props.text
        ]
    }, props.text);
};
var $fd2e525325cc1a5d$export$2e2bcd8739ae039 = $fd2e525325cc1a5d$var$OptionButton;


// components


const $f00647354fc7d932$var$OptionRadio = ({ children: children, ...props })=>{
    const handleChange = (answer)=>{
        props.handleAnswer(answer, props.id);
    };
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $c94e927d30586550$export$2e2bcd8739ae039), {
        className: props.className,
        for: props.text,
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("input", {
                className: "pension-wizard-block__question__card__options__option__radio__input",
                type: "radio",
                name: "radio",
                id: props.text,
                value: props.text,
                onChange: (event)=>handleChange(event.target.value)
            }),
            props.text
        ]
    }, props.text);
};
var $f00647354fc7d932$export$2e2bcd8739ae039 = $f00647354fc7d932$var$OptionRadio;




var $8NFma = parcelRequire("8NFma");


const $8ccf1a51d90d049f$var$Error = ({ error: error })=>{
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
        className: "pension-wizard-block__error",
        children: error
    });
};
var $8ccf1a51d90d049f$export$2e2bcd8739ae039 = $8ccf1a51d90d049f$var$Error;


const $ae5277a435794ac9$var$RadioSubQuestion = ({ children: children, handleAnswer: handleAnswer, showSubQuestion: showSubQuestion, ...props })=>{
    const [input, setInput] = (0, $8NFma.useState)('');
    const [valid, setValid] = (0, $8NFma.useState)(true);
    const [errors, setErrors] = (0, $8NFma.useState)({});
    let empty = input === '';
    const inputRef = (0, $8NFma.useRef)();
    (0, $8NFma.useEffect)(()=>{
        if (showSubQuestion === true) setTimeout(()=>{
            inputRef.current?.focus();
        }, 200);
    }, [
        showSubQuestion
    ]);
    const handleChange = (event)=>{
        event.persist();
        const element = event.target;
        let valid = element.validity.valid;
        if (element.validity.tooShort) element.setCustomValidity('Fyll i minst tre tecken');
        else element.setCustomValidity('');
        let message = element.validationMessage;
        setErrors({
            ...errors,
            [event.target.name]: message
        });
        setValid(valid);
        setInput({
            [event.target.name]: event.target.value,
            [event.target.id]: props.id
        });
        props.updateAnswer(event, props.id, false);
    };
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $9b0ae67beb2269f5$export$3ae376d12526dd6f), {
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $bb8231acd22e51c2$export$e25e478948902b8b).label, {
            className: "pension-wizard-block__question__card__dropdown",
            initial: {
                opacity: 0,
                height: 0
            },
            animate: {
                opacity: 1,
                height: "auto"
            },
            exit: {
                opacity: 0,
                height: 0
            },
            htmlFor: "QuestionId",
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("span", {
                    className: "pension-wizard-block__question__card__dropdown__helptext",
                    children: [
                        props.text,
                        ":"
                    ]
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("input", {
                    className: `${valid ? "valid" : "invalid"} `,
                    minLength: "2",
                    required: true,
                    name: "Answer",
                    ref: inputRef,
                    type: "text",
                    id: "QuestionId",
                    onChange: handleChange,
                    onKeyDown: (event)=>event.key === 'Enter' && event.preventDefault()
                }),
                errors && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $8ccf1a51d90d049f$export$2e2bcd8739ae039), {
                    error: errors.Answer
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                    type: "button",
                    className: `button button--green ${empty || !valid ? "disabled" : ""}`,
                    onClick: ()=>props.postAnswer(input, null, props.id),
                    disabled: empty || !valid ? true : false,
                    children: props.buttonText
                })
            ]
        })
    }, props.key);
};
var $ae5277a435794ac9$export$2e2bcd8739ae039 = $ae5277a435794ac9$var$RadioSubQuestion;


const $adc044d0c0d1c4ce$var$Option = ({ option: option, id: id, subQuestionGroup: subQuestionGroup, handleAnswer: handleAnswer, setCurrentAnswer: setCurrentAnswer, togglesSubQuestion: togglesSubQuestion, handleNext: handleNext, ...props })=>{
    const [showSubQuestion, setShowSubQuestion] = (0, $8NFma.useState)(false);
    const [answer, setAnswer] = (0, $8NFma.useState)('');
    const [subQId, setSubQId] = (0, $8NFma.useState)(0);
    const updateAnswer = (event, subQuestionId, togglesSubQuestion)=>{
        if (!showSubQuestion) {
            setShowSubQuestion(true);
            handleAnswer(event.target.value, id, togglesSubQuestion);
        }
        if (showSubQuestion) {
            setAnswer(event.target.value);
            setSubQId(subQuestionId);
        }
    };
    const postAnswer = ()=>{
        handleAnswer(answer, subQId, false);
        setCurrentAnswer(answer);
        handleNext();
    };
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $13f4c0370d7de649$exports.Fragment), {
        children: [
            togglesSubQuestion === false && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $13f4c0370d7de649$exports.Fragment), {
                children: option.text === "Ja" || option.text === "Nej" ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $fd2e525325cc1a5d$export$2e2bcd8739ae039), {
                    togglesSubQuestion: false,
                    className: "pension-wizard-block__question__card__options__option__button",
                    text: option.text,
                    id: id,
                    handleAnswer: handleAnswer
                }) : /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $f00647354fc7d932$export$2e2bcd8739ae039), {
                    togglesSubQuestion: false,
                    className: "pension-wizard-block__question__card__options__option__radio",
                    text: option.text,
                    id: id,
                    handleAnswer: handleAnswer
                })
            }),
            togglesSubQuestion === true && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("input", {
                            className: "pension-wizard-block__question__card__options__option__radio__input",
                            type: "radio",
                            name: "Answer",
                            id: "QuestionId",
                            value: option.text,
                            onChange: (event)=>updateAnswer(event, null, togglesSubQuestion)
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $c94e927d30586550$export$2e2bcd8739ae039), {
                            className: "pension-wizard-block__question__card__options__option__radio",
                            for: "QuestionId",
                            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                className: "pension-wizard-block__question__card__options__option__text",
                                children: option.text
                            })
                        }, option.text)
                    ]
                })
            }, option.text),
            showSubQuestion && subQuestionGroup.questions && subQuestionGroup.questions.map((q, index)=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $ae5277a435794ac9$export$2e2bcd8739ae039), {
                    q: q,
                    postAnswer: postAnswer,
                    updateAnswer: updateAnswer,
                    text: q.questionText,
                    id: q.id,
                    className: "pension-wizard-block__question__card__options__option__subquestion",
                    buttonText: "N\xe4sta"
                }, index))
        ]
    });
};
var $adc044d0c0d1c4ce$export$2e2bcd8739ae039 = $adc044d0c0d1c4ce$var$Option;




var $8NFma = parcelRequire("8NFma");
const $bc2568db80495705$var$Checkbox = ({ id: id, text: text, handleAnswer: handleAnswer, ...props })=>{
    const [buttonText, setButtonText] = (0, $8NFma.useState)('');
    const [checked, setChecked] = (0, $8NFma.useState)(false);
    const downloadQuestion = '5919a64a-884d-4a5c-80f3-f3d63e68b2f5';
    (0, $8NFma.useEffect)(()=>{
        if (id && id === downloadQuestion) setButtonText("Jag har tagit del och f\xf6rst\xe5tt");
        else setButtonText("Jag f\xf6rst\xe5r");
    }, [
        id
    ]);
    const handleChange = (answer, id)=>{
        handleAnswer(answer, id);
        setChecked(event.target.checked);
    };
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $13f4c0370d7de649$exports.Fragment), {
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("label", {
            className: "button button--green checkbox",
            htmlFor: id,
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("input", {
                    checked: checked,
                    id: id,
                    type: "checkbox",
                    value: "True",
                    onChange: (e)=>handleChange(e.target.value, id),
                    onKeyDown: (event1)=>event1.key === 'Enter' && event1.preventDefault()
                }),
                buttonText
            ]
        })
    });
};
var $bc2568db80495705$export$2e2bcd8739ae039 = $bc2568db80495705$var$Checkbox;




var $8NFma = parcelRequire("8NFma");



var $8NFma = parcelRequire("8NFma");


const $38f96ecb83a497b3$var$CheckboxSubQuestion = ({ children: children, handleAnswer: handleAnswer, showSubQuestion: showSubQuestion, setFreeText: setFreeText, setValid: setValid, valid: valid, ...props })=>{
    const [input, setInput] = (0, $8NFma.useState)('');
    const [errors, setErrors] = (0, $8NFma.useState)({});
    let empty = input === '';
    const inputRef = (0, $8NFma.useRef)();
    (0, $8NFma.useEffect)(()=>{
        if (showSubQuestion === true) setTimeout(()=>{
            inputRef.current?.focus();
        }, 200);
    }, [
        showSubQuestion
    ]);
    const handleChange = (event)=>{
        event.persist();
        const element = event.target;
        let valid = element.validity.valid;
        if (element.validity.valueMissing) element.setCustomValidity("F\xe4ltet f\xe5r inte l\xe4mnas tomt");
        else element.setCustomValidity('');
        let message = element.validationMessage;
        setErrors({
            ...errors,
            [event.target.name]: message
        });
        setValid(valid);
        setFreeText({
            [event.target.name]: event.target.value,
            [event.target.id]: props.id
        });
    };
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $9b0ae67beb2269f5$export$3ae376d12526dd6f), {
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $bb8231acd22e51c2$export$e25e478948902b8b).label, {
            className: "pension-wizard-block__question__card__dropdown",
            initial: {
                opacity: 0,
                height: 0
            },
            animate: {
                opacity: 1,
                height: "auto"
            },
            exit: {
                opacity: 0,
                height: 0
            },
            htmlFor: "QuestionId",
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("span", {
                    className: "pension-wizard-block__question__card__dropdown__helptext",
                    children: [
                        props.text,
                        ":"
                    ]
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("input", {
                    className: `${valid ? "valid" : "invalid"} `,
                    required: true,
                    name: "Answer",
                    ref: inputRef,
                    type: "text",
                    id: "QuestionId",
                    onKeyDown: (event)=>event.key === "Enter" && event.preventDefault(),
                    onChange: handleChange
                }),
                errors && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $8ccf1a51d90d049f$export$2e2bcd8739ae039), {
                    error: errors.Answer
                })
            ]
        })
    }, props.key);
};
var $38f96ecb83a497b3$export$2e2bcd8739ae039 = $38f96ecb83a497b3$var$CheckboxSubQuestion;



const $65eb5cdacc1b2c72$var$CheckboxMultiple = ({ options: options, id: id, subQuestionGroup: subQuestionGroup, handleAnswer: handleAnswer, setCurrentAnswer: setCurrentAnswer, handleNext: handleNext, text: text, ...props })=>{
    const [showSubQuestion, setShowSubQuestion] = (0, $8NFma.useState)(false);
    const [answer, setAnswer] = (0, $8NFma.useState)('');
    const [values, setValues] = (0, $8NFma.useState)([]);
    const [freeText, setFreeText] = (0, $8NFma.useState)('');
    const [valid, setValid] = (0, $8NFma.useState)(true);
    let empty = values.length === 0;
    const updateAnswer = (event, toggle)=>{
        const { value: value, checked: checked } = event.target;
        if (checked) {
            setValues([
                ...values,
                value
            ]);
            if (toggle) {
                setValues([
                    ...values,
                    value
                ]);
                setShowSubQuestion((showSubQuestion)=>!showSubQuestion);
            }
        } else {
            let valuesArr = values;
            setValues(valuesArr.filter((val)=>val !== value));
            if (toggle) setShowSubQuestion((showSubQuestion)=>!showSubQuestion);
        }
    };
    (0, $8NFma.useEffect)(()=>{
        setAnswer(values.join("|"));
    }, [
        values
    ]);
    const postAnswer = ()=>{
        if (freeText && freeText.Answer !== '') {
            handleAnswer(answer, id, true);
            handleAnswer(freeText.Answer, freeText.QuestionId, false);
        } else handleAnswer(answer, id, false);
    };
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
        className: "pension-wizard-block__question__card__options",
        children: [
            options && options.length > 0 && options.map((option, index)=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                    className: "pension-wizard-block__question__card__options__container",
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("span", {
                            className: "pension-wizard-block__question__card__options__option__container",
                            children: [
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("input", {
                                    className: "pension-wizard-block__question__card__options__option__checkbox__input",
                                    type: "checkbox",
                                    value: option.text,
                                    name: "Answer",
                                    id: option.text,
                                    onChange: (event)=>updateAnswer(event, option.togglesSubQuestionGroup)
                                }),
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $c94e927d30586550$export$2e2bcd8739ae039), {
                                    className: "pension-wizard-block__question__card__options__option__checkbox",
                                    for: option.text,
                                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                        className: "pension-wizard-block__question__card__options__option__text",
                                        children: option.text
                                    })
                                }, option.text)
                            ]
                        }),
                        showSubQuestion && option.togglesSubQuestionGroup === true && subQuestionGroup.questions && subQuestionGroup.questions.map((q, index)=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $38f96ecb83a497b3$export$2e2bcd8739ae039), {
                                q: q,
                                setValid: setValid,
                                valid: valid,
                                setFreeText: setFreeText,
                                postAnswer: postAnswer,
                                text: q.questionText,
                                id: q.id,
                                className: "pension-wizard-block__question__card__options__option__subquestion",
                                buttonText: $b8ceef3013a3a6fa$export$c058c12a17cc5c02.next
                            }, index))
                    ]
                }, index)),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                type: "button",
                className: `button button--green ${empty ? "disabled" : ""}`,
                onClick: ()=>postAnswer(),
                disabled: empty ? true : false,
                children: "N\xe4sta"
            })
        ]
    });
};
var $65eb5cdacc1b2c72$export$2e2bcd8739ae039 = $65eb5cdacc1b2c72$var$CheckboxMultiple;




var $8NFma = parcelRequire("8NFma");

const $08508c5acabea8f9$var$Money = ({ ...props })=>{
    const [currentAnswer, setCurrentAnswer] = (0, $8NFma.useState)('');
    const [valid, setValid] = (0, $8NFma.useState)(true);
    const [errors, setErrors] = (0, $8NFma.useState)({});
    const empty = currentAnswer === '';
    const updateAnswer = (event)=>{
        const element = event.target;
        let valid = element.validity.valid;
        let message = element.validationMessage;
        if (element.validity.patternMismatch) {
            element.setCustomValidity("Endast siffror \xe4r till\xe5tna");
            setErrors({
                ...errors,
                [event.target.name]: message
            });
        } else {
            element.setCustomValidity('');
            setCurrentAnswer(event.target.value);
            setErrors({});
        }
        setValid(valid);
    };
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
        className: "pension-wizard-block__question__card__money",
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("input", {
                className: "pension-wizard-block__question__card__money__input",
                name: "money",
                type: "text",
                pattern: "^\\d+$",
                id: props.id,
                value: currentAnswer,
                onChange: (event)=>{
                    event.persist();
                    updateAnswer(event);
                },
                onKeyDown: (event)=>event.key === 'Enter' && event.preventDefault()
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("label", {
                className: "pension-wizard-block__question__card__money__label",
                htmlFor: props.id,
                children: "kr/m\xe5n"
            }),
            errors && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $8ccf1a51d90d049f$export$2e2bcd8739ae039), {
                error: errors.radio
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                type: "button",
                className: `button button--green ${empty || !valid ? "disabled" : ""}`,
                onClick: ()=>props.handleAnswer(currentAnswer, props.id),
                disabled: empty || !valid ? true : false,
                children: props.buttonText
            })
        ]
    });
};
var $08508c5acabea8f9$export$2e2bcd8739ae039 = $08508c5acabea8f9$var$Money;


//components



var $8NFma = parcelRequire("8NFma");


const $2936875ef6cd3059$var$Answer = ({ ...props })=>{
    const [answer, setAnswer] = (0, $8NFma.useState)('');
    (0, $8NFma.useEffect)(()=>{
        if (props.answer === "True") setAnswer("Jag f\xf6rst\xe5r");
        else {
            const a = props.answer;
            setAnswer(a);
        }
    }, [
        props.answer
    ]);
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $9b0ae67beb2269f5$export$3ae376d12526dd6f), {
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $bb8231acd22e51c2$export$e25e478948902b8b).div, {
            className: "pension-wizard-block__answer",
            initial: {
                opacity: 0
            },
            animate: {
                opacity: 1
            },
            exit: {
                opacity: 0
            },
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                    className: "pension-wizard-block__answer__checkmark",
                    dangerouslySetInnerHTML: {
                        __html: (0, (/*@__PURE__*/$parcel$interopDefault($ac8bf4b7d201ab28$exports)))('check-circle').outerHTML
                    }
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("p", {
                    className: "pension-wizard-block__answer__text",
                    children: answer
                })
            ]
        })
    });
};
var $2936875ef6cd3059$export$2e2bcd8739ae039 = $2936875ef6cd3059$var$Answer;




const $fab99cf0ee14beb8$var$Link = ({ href: href, linkText: linkText })=>{
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("a", {
        className: "pension-wizard-block__question__card__question__download-link",
        href: href,
        target: "_blank",
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                className: "pension-wizard-block__question__card__question__download-link__icon",
                dangerouslySetInnerHTML: {
                    __html: (0, (/*@__PURE__*/$parcel$interopDefault($ac8bf4b7d201ab28$exports)))('download').outerHTML
                }
            }),
            linkText
        ]
    });
};
var $fab99cf0ee14beb8$export$2e2bcd8739ae039 = $fab99cf0ee14beb8$var$Link;


const $1a6d44ba24626eed$var$QuestionHeader = ({ id: id, paragraph2: paragraph2, paragraph3: paragraph3, index: index, total: total, headline: headline, text: text, answer: answer, showCount: showCount, count: count, showApplication: showApplication })=>{
    const downloadQuestion = '5919a64a-884d-4a5c-80f3-f3d63e68b2f5';
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
        className: "pension-wizard-block__question__card__question",
        children: [
            showCount && total && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("legend", {
                className: "pension-wizard-block__question__card__count",
                children: [
                    `${count ? count : index + 1}`,
                    " av ",
                    total
                ]
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("h3", {
                className: "pension-wizard-block__question__card__headline",
                children: headline
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("p", {
                className: "pension-wizard-block__question__card__info",
                children: text
            }),
            paragraph2 && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("p", {
                className: "pension-wizard-block__question__card__info",
                children: paragraph2
            }),
            paragraph3 && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("p", {
                className: "pension-wizard-block__question__card__info",
                children: paragraph3
            }),
            id === downloadQuestion && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $fab99cf0ee14beb8$export$2e2bcd8739ae039), {
                href: "/pensionsforsakringsdokument/futur-produktinformation",
                linkText: "F\xf6rk\xf6psinformation, faktablad och villkor"
            }),
            showApplication && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $fab99cf0ee14beb8$export$2e2bcd8739ae039), {
                href: `/pensionsforsakringsdokument/ansokan/${id}`,
                linkText: "Ans\xf6kan om sparande"
            }),
            answer && answer !== '' && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $2936875ef6cd3059$export$2e2bcd8739ae039), {
                answer: answer,
                index: index + 1,
                total: total,
                showCount: showCount
            })
        ]
    });
};
var $1a6d44ba24626eed$export$2e2bcd8739ae039 = $1a6d44ba24626eed$var$QuestionHeader;




var $8NFma = parcelRequire("8NFma");
const $381b8b96c62e63a4$var$QuestionWrapper = ({ children: children, question: question, index: index, tabIndex: tabIndex, onAnswered: onAnswered, ...props })=>{
    // animation
    const animationConfig = {
        behavior: "smooth",
        block: 'nearest',
        inline: 'start'
    };
    const questionRefs = (0, $8NFma.useRef)([]);
    (0, $8NFma.useEffect)(()=>{
        if (questionRefs.current[index]) questionRefs.current[index].scrollIntoView(animationConfig);
    }, [
        index,
        question
    ]);
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("section", {
        onClick: onAnswered,
        tabIndex: tabIndex,
        className: props.classes,
        ref: (element)=>questionRefs.current[index] = element,
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
            className: "pension-wizard-block__question__card",
            children: children
        })
    });
};
var $381b8b96c62e63a4$export$2e2bcd8739ae039 = $381b8b96c62e63a4$var$QuestionWrapper;


const $a186ac013ce1bab2$var$Question = ({ index: index, headline: headline, text: text, id: id, state: state, total: total, totalIndex: totalIndex, handleNext: handleNext, currentChapterIndex: currentChapterIndex, question: question, isLastQuestion: isLastQuestion, toggleShowAccount: toggleShowAccount, togglePreSign: togglePreSign, handleReset: handleReset, ...props })=>{
    const [currentAnswer, setCurrentAnswer] = (0, $8NFma.useState)('');
    const checkbox = question.questionType === 'Checkbox';
    const money = question.questionType === 'Money';
    const checkboxMultiple = question.questionType === 'CheckboxMultiple';
    const radio = question.questionType === 'Radio';
    let answered = currentAnswer !== '';
    let expectedAnswer = question.expectedAnswers;
    let subQuestionGroup = question.subQuestionGroup;
    // capture data to post back to api
    const { form: [formState, setFormState] } = {
        form: (0, $8NFma.useState)([]),
        ...state || {}
    };
    // handle answer
    const onAnswer = (answer, id, togglesSubQuestion)=>{
        if (expectedAnswer) checkExpectedAnswer(expectedAnswer, answer);
        else updateFormState(answer, id, togglesSubQuestion);
    };
    const checkExpectedAnswer = (expectation, answer)=>{
        if (expectation !== answer) {
            props.stop(true);
            props.setModalContent('STOP');
        } else updateFormState(answer, id);
    };
    // get the answer and id for post to api
    // if the answer toggles a subquestion (togglesSubQuestion === true), 
    // the wizard should stop and wait for further data
    const updateFormState = (answer, id, togglesSubQuestion)=>{
        setFormState((formState)=>({
                ...formState,
                Answers: [
                    ...formState.Answers,
                    {
                        Answer: answer,
                        QuestionId: id
                    }
                ]
            }));
        if (togglesSubQuestion) return;
        else updateAnswer(answer);
    };
    const updateAnswer = (answer)=>{
        if (answer.includes('|')) setCurrentAnswer(answer.replace(/\|(?=.|$)/g, ", "));
        else setCurrentAnswer(answer);
        handleNext();
        if (isLastQuestion) toggleShowAccount(true);
    };
    // handle edit
    const onEdit = ()=>{
        handleReset(index, id, currentChapterIndex, isLastQuestion);
        setCurrentAnswer('');
    };
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $381b8b96c62e63a4$export$2e2bcd8739ae039), {
        onAnswered: answered ? onEdit : undefined,
        question: question,
        index: index,
        tabIndex: `${answered ? -1 : 0}`,
        classes: `pension-wizard-block__question ${answered ? "answered" : ""}`,
        children: [
            !answered && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $1a6d44ba24626eed$export$2e2bcd8739ae039), {
                id: id,
                showCount: true,
                headline: headline,
                text: text,
                index: index,
                total: `${isLastQuestion ? total + 1 : total}`
            }),
            answered && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $1a6d44ba24626eed$export$2e2bcd8739ae039), {
                showCount: true,
                headline: headline,
                text: text,
                index: index,
                total: `${isLastQuestion ? total + 1 : total}`,
                answer: currentAnswer
            }),
            !answered && radio && question.options && question.options.length > 0 && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                className: "pension-wizard-block__question__card__options",
                children: question.options.map((option, i)=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $adc044d0c0d1c4ce$export$2e2bcd8739ae039), {
                        option: option,
                        subQuestionGroup: subQuestionGroup,
                        togglesSubQuestion: option.togglesSubQuestionGroup,
                        id: id,
                        text: text,
                        handleAnswer: onAnswer,
                        handleNext: handleNext,
                        setCurrentAnswer: setCurrentAnswer
                    }, i))
            }),
            !answered && checkbox && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $bc2568db80495705$export$2e2bcd8739ae039), {
                handleAnswer: onAnswer,
                id: id
            }),
            !answered && money && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $08508c5acabea8f9$export$2e2bcd8739ae039), {
                buttonText: "N\xe4sta",
                handleAnswer: onAnswer,
                id: id
            }),
            !answered && checkboxMultiple && question.options && question.options.length > 0 && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $65eb5cdacc1b2c72$export$2e2bcd8739ae039), {
                options: question.options,
                id: id,
                handleAnswer: onAnswer,
                setCurrentAnswer: setCurrentAnswer,
                subQuestionGroup: subQuestionGroup
            })
        ]
    });
};
// state
const $a186ac013ce1bab2$var$mapStateToProps = (state)=>{
    return {
        stop: state.pensionWizardFlow.stop
    };
};
const $a186ac013ce1bab2$var$mapDispatchToProps = (dispatch)=>{
    return {
        stop: (payload)=>dispatch((0, $e0bb054daf10d535$export$980f7a87096fc373)(payload)),
        setModalContent: (payload)=>dispatch((0, $e0bb054daf10d535$export$73f8cffc8347bbf1)(payload))
    };
};
var $a186ac013ce1bab2$export$2e2bcd8739ae039 = (0, $5a4066412ccab0c1$export$64605811ab45167f)($a186ac013ce1bab2$var$mapStateToProps, $a186ac013ce1bab2$var$mapDispatchToProps)($a186ac013ce1bab2$var$Question);




var $8NFma = parcelRequire("8NFma");





var $28afb2a41d1593e9$export$6b501c78a3684162;

$28afb2a41d1593e9$export$6b501c78a3684162 = (parcelRequire("aPsqN"));


var $b05f15c1b2dd1b92$require$bankAccount = $28afb2a41d1593e9$export$6b501c78a3684162;
const $b05f15c1b2dd1b92$var$Account = ({ children: children, state: state, answersState: answersState, total: total, totalIndex: totalIndex, currentChapterIndex: currentChapterIndex, togglePreSign: togglePreSign, progress: progress, handleReset: handleReset, ...props })=>{
    const [tempValue, setTempValue] = (0, $8NFma.useState)({
        PaymentBankAccountNumber: '',
        PaymentClearingNumber: ''
    });
    const [accountDetails, setAccountDetails] = (0, $8NFma.useState)({
        PaymentBankAccountNumber: '',
        PaymentClearingNumber: ''
    });
    const [answered, setAnswered] = (0, $8NFma.useState)(false);
    const [valid, setValid] = (0, $8NFma.useState)(true);
    const [errors, setErrors] = (0, $8NFma.useState)({});
    const empty = Object.keys(tempValue).length === 0;
    const both = tempValue.PaymentBankAccountNumber !== '' && tempValue.PaymentClearingNumber !== '';
    let clearing;
    let account;
    let answer;
    let id = 'account';
    // masking account number on post
    if (Object.keys(accountDetails).length > 0 && accountDetails && accountDetails.PaymentBankAccountNumber !== '' && accountDetails.PaymentClearingNumber !== '') {
        clearing = accountDetails.PaymentClearingNumber;
        clearing = clearing.replace(/\d{4}(\d*)/, '****$1');
        account = accountDetails.PaymentBankAccountNumber;
        account = account.replace(/\d{4}(\d*)/, '****$1');
        answer = `${clearing}-${account}`;
    }
    const totalQuestions = 22;
    let increment = 100 / totalQuestions;
    // capture data to post back to api
    const { form: [formState, setFormState] } = {
        form: (0, $8NFma.useState)([]),
        ...state || {}
    };
    (0, $8NFma.useEffect)(()=>{
        if (accountDetails.PaymentBankAccountNumber !== '') setFormState((formState)=>({
                ...formState,
                accountDetails: accountDetails
            }));
    }, [
        accountDetails
    ]);
    const handleChange = (event)=>{
        event.persist();
        setTempValue({
            ...tempValue,
            [event.target.name]: event.target.value
        });
        const element = event.target;
        let valid = element.validity.valid;
        if (element.validity.patternMismatch) element.setCustomValidity("Endast siffror \xe4r till\xe5tna");
        else if (element.validity.tooShort) element.setCustomValidity("F\xf6r kort");
        else if (element.validity.tooLong) element.setCustomValidity("F\xf6r l\xe5ngt");
        else element.setCustomValidity('');
        let message = element.validationMessage;
        setErrors({
            ...errors,
            [event.target.name]: message,
            invalidAccountNumber: ''
        });
    };
    const handleAnswered = ()=>{
        const isValidAccount = !!$b05f15c1b2dd1b92$require$bankAccount(tempValue.PaymentClearingNumber + '-' + tempValue.PaymentBankAccountNumber);
        if (!isValidAccount) {
            setErrors({
                ...errors,
                invalidAccountNumber: 'Ogiltigt kontonummer'
            });
            return;
        }
        setAnswered(true);
        setAccountDetails(tempValue);
        let newProgress = progress + 1;
        props.updateProgress(newProgress * increment);
        togglePreSign(true);
    };
    const onEdit = ()=>{
        setAnswered(false);
        setAccountDetails({});
        setTempValue({
            PaymentBankAccountNumber: '',
            PaymentClearingNumber: ''
        });
        handleReset(1, id, currentChapterIndex);
    //props.updateProgress(progress * increment)
    };
    // animation
    const accountRef = (0, $8NFma.useRef)();
    const animationConfig = {
        behavior: "smooth",
        block: 'nearest',
        inline: 'start'
    };
    (0, $8NFma.useEffect)(()=>{
        if (accountRef) accountRef.current.scrollIntoView(animationConfig);
    }, []);
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
        ref: accountRef,
        tabIndex: `${answered ? -1 : 0}`,
        className: `pension-wizard-block__question ${answered ? "answered" : ""}`,
        onClick: answered ? onEdit : undefined,
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
            className: "pension-wizard-block__question__card",
            children: [
                accountDetails.PaymentBankAccountNumber !== null && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $1a6d44ba24626eed$export$2e2bcd8739ae039), {
                    showCount: true,
                    count: 2,
                    total: 2,
                    headline: $b8ceef3013a3a6fa$export$6b501c78a3684162.headline,
                    text: $b8ceef3013a3a6fa$export$6b501c78a3684162.text,
                    index: progress,
                    answer: answer
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                    className: "pension-wizard-block__question__card__account",
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("label", {
                            className: "pension-wizard-block__question__card__account__label",
                            htmlFor: "clearing",
                            children: $b8ceef3013a3a6fa$export$6b501c78a3684162.labelClearing
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("input", {
                            className: `pension-wizard-block__question__card__account__input ${!valid ? "pension-wizard-block__question__card__account__input--invalid" : ""}`,
                            minLength: "4",
                            maxLength: "5",
                            pattern: "^\\d+$",
                            name: "PaymentClearingNumber",
                            id: "PaymentClearingNumber",
                            type: "text",
                            value: tempValue.PaymentClearingNumber,
                            onChange: handleChange
                        }),
                        errors && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $8ccf1a51d90d049f$export$2e2bcd8739ae039), {
                            error: errors.PaymentClearingNumber
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("label", {
                            className: "pension-wizard-block__question__card__account__label",
                            htmlFor: "account",
                            children: $b8ceef3013a3a6fa$export$6b501c78a3684162.labelAccount
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("input", {
                            className: `pension-wizard-block__question__card__account__input ${!valid ? "pension-wizard-block__question__card__account__input--invalid" : ""}`,
                            minLength: "7",
                            maxLength: "10",
                            pattern: "^\\d+$",
                            name: "PaymentBankAccountNumber",
                            id: "PaymentBankAccountNumber",
                            type: "text",
                            value: tempValue.PaymentBankAccountNumber,
                            onChange: handleChange
                        }),
                        errors && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $8ccf1a51d90d049f$export$2e2bcd8739ae039), {
                            error: errors.PaymentBankAccountNumber
                        }),
                        errors && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $8ccf1a51d90d049f$export$2e2bcd8739ae039), {
                            error: errors.invalidAccountNumber
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                            type: "button",
                            className: `button button--green ${empty || !valid || !both ? "disabled" : ""}`,
                            disabled: empty || !valid || !both ? true : false,
                            onClick: handleAnswered,
                            children: $b8ceef3013a3a6fa$export$c058c12a17cc5c02.next
                        })
                    ]
                })
            ]
        })
    });
};
const $b05f15c1b2dd1b92$var$mapDispatchToProps = (dispatch)=>{
    return {
        updateProgress: (payload)=>dispatch((0, $e0bb054daf10d535$export$f059a5f39ec89d4)(payload))
    };
};
var $b05f15c1b2dd1b92$export$2e2bcd8739ae039 = (0, $5a4066412ccab0c1$export$64605811ab45167f)(null, $b05f15c1b2dd1b92$var$mapDispatchToProps)($b05f15c1b2dd1b92$var$Account);


// components



const $924071b42abeed35$var$PreSign = ()=>{
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("section", {
        className: "pension-wizard-block__question",
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
            className: "pension-wizard-block__question__card",
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $1a6d44ba24626eed$export$2e2bcd8739ae039), {
                    heading: $b8ceef3013a3a6fa$export$299f8d7938fe0260.headline,
                    text: $b8ceef3013a3a6fa$export$299f8d7938fe0260.text,
                    paragraph2: $b8ceef3013a3a6fa$export$299f8d7938fe0260.paragraph2,
                    paragraph3: $b8ceef3013a3a6fa$export$299f8d7938fe0260.paragraph3
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                    type: "submit",
                    className: "button button--green",
                    children: $b8ceef3013a3a6fa$export$299f8d7938fe0260.buttonText
                })
            ]
        })
    });
};
var $924071b42abeed35$export$2e2bcd8739ae039 = $924071b42abeed35$var$PreSign;


const $8df271a6da8a3e79$var$Chapter = ({ chapter: chapter, handleNextChapter: handleNextChapter, state: state, currentChapterIndex: currentChapterIndex, handleNext: handleNext, handleReset: handleReset, totalChapters: totalChapters, handlePreSignSubmit: handlePreSignSubmit, ...props })=>{
    const questionsToShow = 1;
    const [nextQuestion, setNextQuestion] = (0, $8NFma.useState)(questionsToShow);
    const [isLastQuestion, setIsLastQuestion] = (0, $8NFma.useState)(false);
    const [answered, setAnswered] = (0, $8NFma.useState)(null);
    let currentProgress = state.form[0].Answers.length;
    const [showAccount, setShowAccount] = (0, $8NFma.useState)(false);
    const [showPreSign, setShowPreSign] = (0, $8NFma.useState)(false);
    (0, $8NFma.useEffect)(()=>{
        props.setCurrentChapterTitle(chapter.title);
    }, [
        chapter.title
    ]);
    const onNext = ()=>{
        setAnswered(currentChapterIndex);
        if (nextQuestion < chapter.questions.length) setNextQuestion(nextQuestion + 1);
        else handleNext();
    };
    // detect last question to insert Account component
    (0, $8NFma.useEffect)(()=>{
        if (currentChapterIndex === 2 && chapter.questions[chapter.questions.length - 1]) setIsLastQuestion(true);
    }, [
        currentChapterIndex,
        chapter.questions
    ]);
    const onEdit = (index, id, currentChapterIndex, isLastQuestion)=>{
        setNextQuestion(index + 1);
        props.setCurrentChapterTitle(chapter.title);
        handleReset(id, currentChapterIndex, isLastQuestion);
        if (isLastQuestion) {
            setShowAccount(false);
            setShowPreSign(false);
        }
        if (id === 'account') setShowPreSign(false);
    };
    // animation
    const chapterRefs = (0, $8NFma.useRef)([]);
    (0, $8NFma.useEffect)(()=>{
        if (chapterRefs.current[currentChapterIndex]) chapterRefs.current[currentChapterIndex].scrollIntoView({
            behavior: "smooth",
            block: 'nearest',
            inline: 'start'
        });
    }, [
        currentChapterIndex
    ]);
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $13f4c0370d7de649$exports.Fragment), {
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("section", {
            className: "pension-wizard-block__section",
            ref: (element)=>chapterRefs.current[currentChapterIndex] = element,
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                    className: `pension-wizard-block__chapter ${answered === currentChapterIndex ? "answered" : null}`,
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                        className: "pension-wizard-block__chapter__card",
                        children: [
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                className: "pension-wizard-block__chapter__card__img",
                                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("img", {
                                    src: `../../../images/0${currentChapterIndex + 1}.svg`,
                                    alt: ""
                                }, currentChapterIndex)
                            }),
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("p", {
                                className: "pension-wizard-block__chapter__card__count",
                                children: [
                                    "Del ",
                                    currentChapterIndex + 1,
                                    " av ",
                                    totalChapters
                                ]
                            }),
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("h2", {
                                className: "pension-wizard-block__chapter__card__headline",
                                children: chapter.title
                            }),
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("p", {
                                className: "pension-wizard-block__chapter__card__info",
                                children: chapter.preamble
                            })
                        ]
                    })
                }),
                props.questions && props.questions.length > 0 && props.questions.slice(0, nextQuestion).map((q, i)=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $a186ac013ce1bab2$export$2e2bcd8739ae039), {
                        question: q,
                        headline: q.questionText,
                        text: q.helpText,
                        id: q.id,
                        state: state,
                        total: props.questions.length,
                        handleNext: onNext,
                        totalIndex: currentProgress,
                        index: i,
                        currentChapterIndex: currentChapterIndex,
                        handleReset: onEdit,
                        isLastQuestion: isLastQuestion,
                        handlePreSignSubmit: handlePreSignSubmit,
                        toggleShowAccount: ()=>setShowAccount(true),
                        togglePreSign: ()=>setShowPreSign(true)
                    }, q.id)),
                showAccount && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $b05f15c1b2dd1b92$export$2e2bcd8739ae039), {
                    state: state,
                    total: currentProgress + 1,
                    progress: currentProgress + 1,
                    totalIndex: currentProgress,
                    currentChapterIndex: currentChapterIndex,
                    handleNext: onNext,
                    handleReset: onEdit,
                    togglePreSign: ()=>setShowPreSign(true)
                }),
                showPreSign && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $924071b42abeed35$export$2e2bcd8739ae039), {
                    state: state
                })
            ]
        })
    });
};
// state
const $8df271a6da8a3e79$var$mapDispatchToProps = (dispatch)=>{
    return {
        setCurrentProgress: (payload)=>dispatch((0, $e0bb054daf10d535$export$f059a5f39ec89d4)(payload)),
        setCurrentChapterTitle: (payload)=>dispatch((0, $e0bb054daf10d535$export$23d64402cbf037a2)(payload))
    };
};
var $8df271a6da8a3e79$export$2e2bcd8739ae039 = (0, $5a4066412ccab0c1$export$64605811ab45167f)(null, $8df271a6da8a3e79$var$mapDispatchToProps)($8df271a6da8a3e79$var$Chapter);



// components



const $5197008dd362d385$var$ManualValidation = ()=>{
    const onRedirect = ()=>{
        window.location.href = `${$b8ceef3013a3a6fa$export$c1c8c4a48179a206.start}`;
    };
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
        className: "pension-wizard-block__question pension-wizard-block__question__validate",
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
            className: "pension-wizard-block__question__card",
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                    className: "pension-wizard-block__question__sign__illustration",
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("img", {
                        src: `../../../images/info-circle.svg`,
                        alt: ""
                    })
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $1a6d44ba24626eed$export$2e2bcd8739ae039), {
                    showCount: false,
                    showApplication: false,
                    headline: $b8ceef3013a3a6fa$export$abbdf820e7b8bc0a.headline,
                    text: $b8ceef3013a3a6fa$export$abbdf820e7b8bc0a.text
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                    onClick: onRedirect,
                    type: "button",
                    className: "button button--green",
                    children: $b8ceef3013a3a6fa$export$abbdf820e7b8bc0a.buttonText
                })
            ]
        })
    });
};
var $5197008dd362d385$export$2e2bcd8739ae039 = $5197008dd362d385$var$ManualValidation;


// components



const $2ac41abe77e18e18$var$Error = ()=>{
    const onRedirect = ()=>{
        window.location.href = `${$b8ceef3013a3a6fa$export$c1c8c4a48179a206.start}`;
    };
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
        className: "pension-wizard-block__question pension-wizard-block__question__error",
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
            className: "pension-wizard-block__question__card",
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                    className: "pension-wizard-block__question__sign__illustration",
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("img", {
                        src: `../../../images/fail-circle.svg`,
                        alt: ""
                    })
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $1a6d44ba24626eed$export$2e2bcd8739ae039), {
                    showCount: false,
                    showApplication: false,
                    headline: $b8ceef3013a3a6fa$export$a3bc9b8ed74fc.headline,
                    text: $b8ceef3013a3a6fa$export$a3bc9b8ed74fc.text
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                    onClick: onRedirect,
                    type: "button",
                    className: "button button--green",
                    children: $b8ceef3013a3a6fa$export$a3bc9b8ed74fc.buttonText
                })
            ]
        })
    });
};
var $2ac41abe77e18e18$export$2e2bcd8739ae039 = $2ac41abe77e18e18$var$Error;




parcelRequire("8NFma");

var $6ca61931a1353f67$exports = {};
$6ca61931a1353f67$exports = JSON.parse("{\"v\":\"5.7.13\",\"fr\":30,\"ip\":0,\"op\":60,\"w\":50,\"h\":50,\"nm\":\"heartbeat_breath\",\"ddd\":0,\"assets\":[],\"layers\":[{\"ddd\":0,\"ind\":1,\"ty\":3,\"nm\":\"Null 1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":0,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[25,27,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[0,0,0],\"ix\":1,\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":0,\"s\":[2,2,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":15,\"s\":[2.25,2.25,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0,0,0]},\"t\":30,\"s\":[2,2,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":45,\"s\":[2.25,2.25,100]},{\"t\":60,\"s\":[2,2,100]}],\"ix\":6,\"l\":2}},\"ao\":0,\"ip\":0,\"op\":60,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":2,\"ty\":4,\"nm\":\"blue\",\"parent\":1,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[0.01,0.959,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[450,380,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[-98.366,0],[0,-124.327],[0,0],[82.756,-55.747]],\"o\":[[34.327,-83.087],[128.868,0],[0,0],[0,204.895],[0,0]],\"v\":[[-225,-238.495],[-8.32,-380.381],[225,-155.261],[225,-139.192],[-225,380.381]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0,0.450980395079,0.741176486015,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[675.01,380.959],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":60,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":3,\"ty\":4,\"nm\":\"green\",\"parent\":1,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[0.01,0.959,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[450,380,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[98.366,0],[0,-124.327],[0,0],[-82.756,-55.747]],\"o\":[[-34.327,-83.087],[-128.868,0],[0,0],[0,204.895],[0,0]],\"v\":[[225,-238.495],[8.32,-380.381],[-225,-155.261],[-225,-139.192],[225,380.381]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0,0.690196096897,0.298039227724,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[225.01,380.959],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 2\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":60,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":4,\"ty\":4,\"nm\":\"Blue line\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[25,25,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[-62.646,47.854,0],\"ix\":1,\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":0,\"s\":[60,60,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":30,\"s\":[66,66,100]},{\"t\":60,\"s\":[60,60,100]}],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"d\":1,\"ty\":\"el\",\"s\":{\"a\":0,\"k\":[50.708,50.708],\"ix\":2},\"p\":{\"a\":0,\"k\":[0,0],\"ix\":3},\"nm\":\"Ellipse Path 1\",\"mn\":\"ADBE Vector Shape - Ellipse\",\"hd\":false},{\"ty\":\"tm\",\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":0,\"s\":[0]},{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":30,\"s\":[0]},{\"t\":60,\"s\":[100]}],\"ix\":1},\"e\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":0,\"s\":[0]},{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":30,\"s\":[100]},{\"t\":60,\"s\":[100]}],\"ix\":2},\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":0,\"s\":[0]},{\"t\":60,\"s\":[360]}],\"ix\":3},\"m\":1,\"ix\":2,\"nm\":\"Trim Paths 1\",\"mn\":\"ADBE Vector Filter - Trim\",\"hd\":false},{\"ty\":\"st\",\"c\":{\"a\":0,\"k\":[0.690577548158,0.774791941923,0.828982125077,1],\"ix\":3},\"o\":{\"a\":0,\"k\":100,\"ix\":4},\"w\":{\"a\":0,\"k\":3,\"ix\":5},\"lc\":1,\"lj\":1,\"ml\":4,\"bm\":0,\"nm\":\"Stroke 1\",\"mn\":\"ADBE Vector Graphic - Stroke\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[-62.646,47.854],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Ellipse 1\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":60,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":5,\"ty\":4,\"nm\":\"blue\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":80,\"ix\":11},\"r\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":0,\"s\":[0]},{\"t\":60,\"s\":[-360]}],\"ix\":10},\"p\":{\"a\":0,\"k\":[25,25,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[-62.646,47.854,0],\"ix\":1,\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":0,\"s\":[71,71,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":30,\"s\":[78,78,100]},{\"t\":60,\"s\":[71,71,100]}],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"d\":1,\"ty\":\"el\",\"s\":{\"a\":0,\"k\":[50.708,50.708],\"ix\":2},\"p\":{\"a\":0,\"k\":[0,0],\"ix\":3},\"nm\":\"Ellipse Path 1\",\"mn\":\"ADBE Vector Shape - Ellipse\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,1,1,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[-62.646,47.854],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Ellipse 1\",\"np\":3,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":60,\"st\":0,\"bm\":0}],\"markers\":[]}");


const $c05e712febf85ad3$var$HeartLoader = (props)=>{
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
        className: "heart-loader",
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2c1cc6e8319f49c7$exports))), {
                className: "heart-loader__animation",
                autoplay: true,
                loop: true,
                animationData: (0, (/*@__PURE__*/$parcel$interopDefault($6ca61931a1353f67$exports)))
            }),
            props.text && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("p", {
                children: props.text
            })
        ]
    });
};
var $c05e712febf85ad3$export$2e2bcd8739ae039 = $c05e712febf85ad3$var$HeartLoader;


const $35d30469a1f7288c$var$Form = (props)=>{
    const [appId, setAppId] = (0, $8NFma.useState)('');
    const [formState, setFormState] = (0, $8NFma.useState)({
        formId: '',
        Answers: []
    });
    const [start, setStart] = (0, $8NFma.useState)(false);
    const chaptersToShow = 1;
    const [nextChapter, setNextChapter] = (0, $8NFma.useState)(chaptersToShow - 1);
    const [currentStatus, setCurrentStatus] = (0, $8NFma.useState)('');
    let increment = props.increment;
    const url = props.url;
    let error = currentStatus === "SubmitFailed" || currentStatus === "Rejected";
    //// get and add formId
    const formId = props.formId;
    (0, $8NFma.useEffect)(()=>{
        setFormState({
            formId: formId,
            Answers: []
        });
    }, [
        formId
    ]);
    // track and update progress
    (0, $8NFma.useEffect)(()=>{
        let progress;
        if (formState.Answers.length > 0) {
            progress = formState.Answers.length + 1;
            props.updateProgress(progress * increment);
        } else {
            progress = formState.Answers.length;
            props.updateProgress(progress * increment);
        }
    }, [
        formState.Answers
    ]);
    // start application
    const onStart = (e)=>{
        e.preventDefault();
        setStart(true);
        onNext();
        props.updateProgress(increment);
    };
    const onNext = ()=>{
        if (props.chapters) {
            if (nextChapter < props.chapters.length) setNextChapter(nextChapter + 1);
        }
    };
    // get index by id of answers, rmeove from that index
    const onReset = (id, currentChapterIndex, isLastQuestion)=>{
        let formStateArr = formState.Answers;
        let formStateObj = formState;
        let index;
        let newProgress;
        if (id === 0 && currentChapterIndex === 0) {
            index = 0;
            formStateArr.splice(index);
            setStart(!start);
            setNextChapter(index);
            props.updateProgress(0);
        // account component
        } else if (id === "account") {
            index = 2;
            delete formStateObj.accountDetails;
            newProgress = formState.Answers.length + 1;
            props.updateProgress(newProgress * increment);
        } else {
            index = formStateArr.findIndex((q)=>q.QuestionId === id);
            formStateArr.splice(index);
            setNextChapter(currentChapterIndex + 1);
            newProgress = formState.Answers.length + 1;
            props.updateProgress(newProgress * increment);
            if (isLastQuestion) {
                index = 2;
                delete formStateObj.accountDetails;
            }
        }
    };
    // start submission process
    const onPreSignSubmit = (event)=>{
        event.preventDefault();
        props.submitForm(formState);
        props.updateLoading(true);
    };
    // get appId for application submission
    (0, $8NFma.useEffect)(()=>{
        if (!props.error) {
            if (props.appId && props.appId !== '') {
                setAppId(props.appId);
                setCurrentStatus('Submitted');
            }
        }
        if (props.error || props.hasErrored) {
            setCurrentStatus('SubmitFailed');
            props.updateLoading(false);
        }
    }, [
        props.appId,
        props.error,
        props.hasErrored
    ]);
    // get application status, act on current status and poll api until final status
    (0, $8NFma.useEffect)(()=>{
        const status = props.status;
        if (status === "Received" || status === "Pending") setCurrentStatus(status);
        if (status === "PendingManualValidation" || status === "Rejected") {
            props.updateLoading(false);
            setCurrentStatus(status);
        // redirect to bankid
        } else if (status === "WaitForSign") window.location.href = `${url}?appId=${appId}`;
    }, [
        props.status
    ]);
    (0, $8NFma.useEffect)(()=>{
        const interval = setInterval(()=>{
            if (props.loading && appId !== '') props.submitAppId({
                appId: appId
            });
        }, 1000);
        return ()=>clearInterval(interval);
    }, [
        props.loading,
        appId
    ]);
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
        className: "pension-wizard-block__container",
        children: [
            !props.loading && currentStatus === '' && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("form", {
                onSubmit: onPreSignSubmit,
                children: [
                    !start && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $13f4c0370d7de649$exports.Fragment), {
                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                            className: "pension-wizard-block__question",
                            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                className: "pension-wizard-block__question__card",
                                children: [
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $1a6d44ba24626eed$export$2e2bcd8739ae039), {
                                        showCount: false,
                                        headline: $b8ceef3013a3a6fa$export$b3571188c770cc5a.headline,
                                        text: $b8ceef3013a3a6fa$export$b3571188c770cc5a.text
                                    }),
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                                        type: "button",
                                        disabled: props.chapters && props.chapters.length === 0 ? true : false,
                                        className: `button button--green ${props.chapters && props.chapters.length === 0 ? "disabled" : ""}`,
                                        onClick: onStart,
                                        children: $b8ceef3013a3a6fa$export$b3571188c770cc5a.buttonText
                                    })
                                ]
                            })
                        })
                    }),
                    start && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("section", {
                        className: "pension-wizard-block__question answered",
                        tabIndex: -1,
                        onClick: ()=>{
                            onReset(0, 0);
                        },
                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                            className: "pension-wizard-block__question__card",
                            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                className: "pension-wizard-block__question__card__question",
                                children: [
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("h2", {
                                        className: "pension-wizard-block__question__card__headline",
                                        children: $b8ceef3013a3a6fa$export$b3571188c770cc5a.buttonText
                                    }),
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $2936875ef6cd3059$export$2e2bcd8739ae039), {
                                        answer: $b8ceef3013a3a6fa$export$b3571188c770cc5a.buttonText
                                    })
                                ]
                            })
                        })
                    }),
                    props.chapters && props.chapters.length && props.chapters.slice(0, nextChapter).map((chapter, index)=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $8df271a6da8a3e79$export$2e2bcd8739ae039), {
                            state: {
                                form: [
                                    formState,
                                    setFormState
                                ]
                            },
                            currentChapterIndex: index,
                            chapter: chapter,
                            title: ()=>props.setCurrentChapterTitle(chapter.title),
                            questions: chapter.questions,
                            totalChapters: props.chapters.length,
                            total: props.questions.length,
                            handleNext: onNext,
                            handleReset: onReset
                        }, index))
                ]
            }),
            props.loading && !props.questions && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $c05e712febf85ad3$export$2e2bcd8739ae039), {}),
            !props.loading && error && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $2ac41abe77e18e18$export$2e2bcd8739ae039), {}),
            !props.loading && currentStatus === "PendingManualValidation" && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $5197008dd362d385$export$2e2bcd8739ae039), {})
        ]
    });
};
// state
const $35d30469a1f7288c$var$mapStateToProps = (state)=>{
    return {
        error: state.pensionWizard.error,
        hasErrored: state.pageHasErrored,
        status: state.pensionWizard.status,
        appId: state.pensionWizard.appId,
        formId: state.pensionWizard.formId,
        stop: state.pensionWizardFlow.stop,
        loading: state.pensionWizardFlow.loading,
        currentProgress: state.pensionWizardProgress.currentProgress
    };
};
const $35d30469a1f7288c$var$mapDispatchToProps = (dispatch)=>{
    return {
        submitForm: (payload)=>dispatch((0, $e0bb054daf10d535$export$4993b9caf321516a)(payload)),
        submitAppId: (payload)=>dispatch((0, $e0bb054daf10d535$export$3f1ecdc4d97d1ccf)(payload)),
        updateProgress: (payload)=>dispatch((0, $e0bb054daf10d535$export$f059a5f39ec89d4)(payload)),
        updateLoading: (payload)=>dispatch((0, $e0bb054daf10d535$export$6ee946a9c0034f4a)(payload))
    };
};
var $35d30469a1f7288c$export$2e2bcd8739ae039 = (0, $5a4066412ccab0c1$export$64605811ab45167f)($35d30469a1f7288c$var$mapStateToProps, $35d30469a1f7288c$var$mapDispatchToProps)($35d30469a1f7288c$var$Form);










const $d7948b5a221eccf6$var$CloseDialog = (props)=>{
    const onCancel = ()=>{
        props.stop(false);
    };
    const onRedirect = ()=>{
        window.location.href = `${$b8ceef3013a3a6fa$export$c1c8c4a48179a206.start}`;
    };
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
        className: "pension-wizard-block__question__card",
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $1a6d44ba24626eed$export$2e2bcd8739ae039), {
                total: "",
                index: "",
                headline: props.headline,
                text: props.text
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                onClick: onRedirect,
                className: "button button--green",
                children: $b8ceef3013a3a6fa$export$34bf1befb2fab61a.buttonText
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("a", {
                onClick: onCancel,
                className: "pension-wizard-block__question__card__link",
                children: $b8ceef3013a3a6fa$export$34bf1befb2fab61a.linkText
            })
        ]
    });
};
const $d7948b5a221eccf6$var$mapStateToProps = (state)=>{
    return {
        content: state.pensionWizardModal.modalContent
    };
};
const $d7948b5a221eccf6$var$mapDispatchToProps = (dispatch)=>{
    return {
        stop: (payload)=>dispatch((0, $e0bb054daf10d535$export$980f7a87096fc373)(payload))
    };
};
var $d7948b5a221eccf6$export$2e2bcd8739ae039 = (0, $5a4066412ccab0c1$export$64605811ab45167f)($d7948b5a221eccf6$var$mapStateToProps, $d7948b5a221eccf6$var$mapDispatchToProps)($d7948b5a221eccf6$var$CloseDialog);







const $55a96ff55ab5ff20$var$StopDialog = (props)=>{
    const onCancel = ()=>{
        props.stop(false);
    };
    const onRedirect = ()=>{
        window.location.href = `${$b8ceef3013a3a6fa$export$c1c8c4a48179a206.advise}`;
    };
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
        className: "pension-wizard-block__question__card",
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $1a6d44ba24626eed$export$2e2bcd8739ae039), {
                total: "",
                index: "",
                headline: props.headline,
                text: props.text
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                className: "button button--green",
                onClick: onRedirect,
                children: $b8ceef3013a3a6fa$export$bb83dd1197ba90eb.buttonText
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("a", {
                className: "pension-wizard-block__question__card__link",
                onClick: onCancel,
                children: $b8ceef3013a3a6fa$export$bb83dd1197ba90eb.linkText
            })
        ]
    });
};
const $55a96ff55ab5ff20$var$mapStateToProps = (state)=>{
    return {
        content: state.pensionWizardModal.modalContent
    };
};
const $55a96ff55ab5ff20$var$mapDispatchToProps = (dispatch)=>{
    return {
        stop: (payload)=>dispatch((0, $e0bb054daf10d535$export$980f7a87096fc373)(payload))
    };
};
var $55a96ff55ab5ff20$export$2e2bcd8739ae039 = (0, $5a4066412ccab0c1$export$64605811ab45167f)($55a96ff55ab5ff20$var$mapStateToProps, $55a96ff55ab5ff20$var$mapDispatchToProps)($55a96ff55ab5ff20$var$StopDialog);



const $53d7b68dce250746$var$Modal = (props)=>{
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $9b0ae67beb2269f5$export$3ae376d12526dd6f), {
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $bb8231acd22e51c2$export$e25e478948902b8b).div, {
            className: "pension-wizard-block__modal",
            initial: {
                opacity: 0,
                scale: 0.75
            },
            animate: {
                opacity: 1,
                scale: 1,
                transition: {
                    ease: "easeOut",
                    duration: 0.15
                }
            },
            exit: {
                opacity: 0,
                scale: 0.75,
                transition: {
                    ease: "easeIn",
                    duration: 0.15
                }
            },
            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                className: "pension-wizard-block__question",
                children: [
                    props.content === 'CLOSE' && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $d7948b5a221eccf6$export$2e2bcd8739ae039), {
                        headline: $b8ceef3013a3a6fa$export$34bf1befb2fab61a.headline,
                        text: $b8ceef3013a3a6fa$export$34bf1befb2fab61a.text
                    }),
                    props.content === 'STOP' && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $55a96ff55ab5ff20$export$2e2bcd8739ae039), {
                        headline: $b8ceef3013a3a6fa$export$bb83dd1197ba90eb.headline,
                        text: $b8ceef3013a3a6fa$export$bb83dd1197ba90eb.text
                    })
                ]
            })
        })
    });
};
const $53d7b68dce250746$var$mapStateToProps = (state)=>{
    return {
        content: state.pensionWizardModal.modalContent
    };
};
var $53d7b68dce250746$export$2e2bcd8739ae039 = (0, $5a4066412ccab0c1$export$64605811ab45167f)($53d7b68dce250746$var$mapStateToProps, null)($53d7b68dce250746$var$Modal);




var $8NFma = parcelRequire("8NFma");


const $d462e4a5a0bdda96$var$FormHero = ()=>{
    const [imageLoading, setImageLoading] = (0, $8NFma.useState)(true);
    const [pulsing, setPulsing] = (0, $8NFma.useState)(true);
    const imageLoaded = ()=>{
        setImageLoading(false);
        setTimeout(()=>setPulsing(false), 600);
    };
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("section", {
        className: "top-nav",
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
            className: "top-nav__content",
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                    className: "top-nav__content__img__container",
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $bb8231acd22e51c2$export$e25e478948902b8b).img, {
                        className: `${pulsing ? "pulse" : ""}`,
                        onLoad: imageLoaded,
                        height: `${150}px`,
                        width: `${280}px`,
                        src: `../../../images/${0}.svg`,
                        alt: ""
                    })
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("h1", {
                            className: "top-nav__content__headline",
                            children: $b8ceef3013a3a6fa$export$124049a9e3d0d4c3.headline
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("p", {
                            className: "top-nav__content__preamble",
                            children: $b8ceef3013a3a6fa$export$124049a9e3d0d4c3.text
                        })
                    ]
                })
            ]
        })
    });
};
var $d462e4a5a0bdda96$export$2e2bcd8739ae039 = $d462e4a5a0bdda96$var$FormHero;





const $d8e5f342f4050093$var$FormHeader = (props)=>{
    let title = props.currentChapterTitle;
    const onStop = ()=>{
        props.stop(true);
        props.setModalContent('CLOSE');
    };
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $13f4c0370d7de649$exports.Fragment), {
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("nav", {
            className: "pension-wizard-block__form-header",
            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                className: "pension-wizard-block__form-header__container",
                children: [
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("a", {
                        className: "pension-wizard-block__form-header__container__logo",
                        href: "/",
                        "aria-label": "Tillbaka till startsidan",
                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("img", {
                            src: "../../../images/heart-small.svg",
                            alt: ""
                        })
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("p", {
                        className: "pension-wizard-block__form-header__container__title",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                        className: "pension-wizard-block__form-header__container__close",
                        onClick: onStop
                    })
                ]
            })
        })
    });
};
const $d8e5f342f4050093$var$mapStateToProps = (state)=>{
    return {
        currentChapterTitle: state.pensionWizardView.currentChapterTitle
    };
};
const $d8e5f342f4050093$var$mapDispatchToProps = (dispatch)=>{
    return {
        stop: (payload)=>dispatch((0, $e0bb054daf10d535$export$980f7a87096fc373)(payload)),
        setModalContent: (payload)=>dispatch((0, $e0bb054daf10d535$export$73f8cffc8347bbf1)(payload))
    };
};
var $d8e5f342f4050093$export$2e2bcd8739ae039 = (0, $5a4066412ccab0c1$export$64605811ab45167f)($d8e5f342f4050093$var$mapStateToProps, $d8e5f342f4050093$var$mapDispatchToProps)($d8e5f342f4050093$var$FormHeader);




const $3e87dfd14ecbeb79$var$ProgressBar = ({ ...props })=>{
    const progress = props.currentProgress;
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
        className: "progress-bar",
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($3e87dfd14ecbeb79$var$Range, {
            progress: progress
        })
    });
};
const $3e87dfd14ecbeb79$var$Range = ({ ...props })=>{
    return(// render current the filled range of progress bar along its width
    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
        className: "filler",
        style: {
            width: `${props.progress}%`
        }
    }));
};
// state
const $3e87dfd14ecbeb79$var$mapStateToProps = (state)=>{
    return {
        currentProgress: state.pensionWizardProgress.currentProgress
    };
};
var $3e87dfd14ecbeb79$export$2e2bcd8739ae039 = (0, $5a4066412ccab0c1$export$64605811ab45167f)($3e87dfd14ecbeb79$var$mapStateToProps, null)($3e87dfd14ecbeb79$var$ProgressBar);



parcelRequire("8NFma");



const $425d9d56a9e42242$var$HeartLoaderModal = (props)=>{
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $9b0ae67beb2269f5$export$3ae376d12526dd6f), {
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $bb8231acd22e51c2$export$e25e478948902b8b).div, {
            className: "heart-loader__modal",
            initial: {
                opacity: 0,
                scale: 0.75
            },
            animate: {
                opacity: 1,
                scale: 1,
                transition: {
                    ease: "easeOut",
                    duration: 0.15
                }
            },
            exit: {
                opacity: 0,
                scale: 0.75,
                transition: {
                    ease: "easeIn",
                    duration: 0.15
                }
            },
            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                className: "heart-loader",
                children: [
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2c1cc6e8319f49c7$exports))), {
                        className: "heart-loader__animation",
                        autoplay: true,
                        loop: true,
                        animationData: (0, (/*@__PURE__*/$parcel$interopDefault($6ca61931a1353f67$exports)))
                    }),
                    props.text && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("p", {
                        children: props.text
                    })
                ]
            })
        })
    });
};
var $425d9d56a9e42242$export$2e2bcd8739ae039 = $425d9d56a9e42242$var$HeartLoaderModal;


const $5bf3a07c101f86ca$var$FormContainer = (props)=>{
    // get data
    (0, $8NFma.useEffect)(()=>{
        props.loadQuestions();
    }, []);
    const totalQuestions = 22;
    const increment = 100 / totalQuestions;
    const url = (0, $e6aeb63e6149c504$export$161fa9a9af21e7de)('sign-url', props.mountRootId) || '';
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
        className: "pension-wizard-block",
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $d8e5f342f4050093$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $3e87dfd14ecbeb79$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $d462e4a5a0bdda96$export$2e2bcd8739ae039), {}),
            props.loading && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $425d9d56a9e42242$export$2e2bcd8739ae039), {}),
            props.stop && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $53d7b68dce250746$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $35d30469a1f7288c$export$2e2bcd8739ae039), {
                url: url,
                increment: increment,
                questions: props.questions,
                chapters: props.chapters
            })
        ]
    });
};
// state
const $5bf3a07c101f86ca$var$mapStateToProps = (state)=>{
    return {
        stop: state.pensionWizardFlow.stop,
        loading: state.pensionWizardFlow.loading,
        chapters: state.pensionWizard.chapters,
        questions: state.pensionWizard.questions
    };
};
const $5bf3a07c101f86ca$var$mapDispatchToProps = (dispatch)=>{
    return {
        loadQuestions: (questionsData)=>dispatch((0, $e0bb054daf10d535$export$fe2cf2aef257418b)(questionsData))
    };
};
var $5bf3a07c101f86ca$export$2e2bcd8739ae039 = (0, $5a4066412ccab0c1$export$64605811ab45167f)($5bf3a07c101f86ca$var$mapStateToProps, $5bf3a07c101f86ca$var$mapDispatchToProps)($5bf3a07c101f86ca$var$FormContainer);




/**
 * React Router DOM v6.23.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $8NFma = parcelRequire("8NFma");

var $2pmb0 = parcelRequire("2pmb0");
/**
 * @remix-run/router v1.16.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $47039de3e9f0864a$var$_extends() {
    $47039de3e9f0864a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $47039de3e9f0864a$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $47039de3e9f0864a$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($47039de3e9f0864a$export$e19cd5f9376f8cee || ($47039de3e9f0864a$export$e19cd5f9376f8cee = {}));
const $47039de3e9f0864a$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $47039de3e9f0864a$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $47039de3e9f0864a$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $47039de3e9f0864a$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $47039de3e9f0864a$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $47039de3e9f0864a$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $47039de3e9f0864a$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $47039de3e9f0864a$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $47039de3e9f0864a$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $47039de3e9f0864a$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $47039de3e9f0864a$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $47039de3e9f0864a$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $47039de3e9f0864a$export$fe53371bee54353d(to);
    }
    return $47039de3e9f0864a$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $47039de3e9f0864a$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $47039de3e9f0864a$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $47039de3e9f0864a$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $47039de3e9f0864a$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $47039de3e9f0864a$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $47039de3e9f0864a$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $47039de3e9f0864a$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $47039de3e9f0864a$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $47039de3e9f0864a$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $47039de3e9f0864a$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $47039de3e9f0864a$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $47039de3e9f0864a$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $47039de3e9f0864a$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $47039de3e9f0864a$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $47039de3e9f0864a$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $47039de3e9f0864a$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $47039de3e9f0864a$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $47039de3e9f0864a$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($47039de3e9f0864a$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $47039de3e9f0864a$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $47039de3e9f0864a$export$e19cd5f9376f8cee.Push;
        let location = $47039de3e9f0864a$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $47039de3e9f0864a$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $47039de3e9f0864a$export$e19cd5f9376f8cee.Replace;
        let location = $47039de3e9f0864a$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $47039de3e9f0864a$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $47039de3e9f0864a$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $47039de3e9f0864a$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($47039de3e9f0864a$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($47039de3e9f0864a$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $47039de3e9f0864a$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($47039de3e9f0864a$var$ResultType || ($47039de3e9f0864a$var$ResultType = {}));
const $47039de3e9f0864a$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $47039de3e9f0864a$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $47039de3e9f0864a$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $47039de3e9f0864a$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $47039de3e9f0864a$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($47039de3e9f0864a$var$isIndexRoute(route)) {
            let indexRoute = $47039de3e9f0864a$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $47039de3e9f0864a$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $47039de3e9f0864a$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $47039de3e9f0864a$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $47039de3e9f0864a$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $47039de3e9f0864a$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $47039de3e9f0864a$var$flattenRoutes(routes);
    $47039de3e9f0864a$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $47039de3e9f0864a$var$decodePath(pathname);
        matches = $47039de3e9f0864a$var$matchRouteBranch(branches[i], decoded);
    }
    return matches;
}
function $47039de3e9f0864a$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $47039de3e9f0864a$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $47039de3e9f0864a$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $47039de3e9f0864a$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $47039de3e9f0864a$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $47039de3e9f0864a$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $47039de3e9f0864a$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $47039de3e9f0864a$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $47039de3e9f0864a$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $47039de3e9f0864a$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $47039de3e9f0864a$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $47039de3e9f0864a$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $47039de3e9f0864a$var$paramRe = /^:[\w-]+$/;
const $47039de3e9f0864a$var$dynamicSegmentValue = 3;
const $47039de3e9f0864a$var$indexRouteValue = 2;
const $47039de3e9f0864a$var$emptySegmentValue = 1;
const $47039de3e9f0864a$var$staticSegmentValue = 10;
const $47039de3e9f0864a$var$splatPenalty = -2;
const $47039de3e9f0864a$var$isSplat = (s)=>s === "*";
function $47039de3e9f0864a$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($47039de3e9f0864a$var$isSplat)) initialScore += $47039de3e9f0864a$var$splatPenalty;
    if (index) initialScore += $47039de3e9f0864a$var$indexRouteValue;
    return segments.filter((s)=>!$47039de3e9f0864a$var$isSplat(s)).reduce((score, segment)=>score + ($47039de3e9f0864a$var$paramRe.test(segment) ? $47039de3e9f0864a$var$dynamicSegmentValue : segment === "" ? $47039de3e9f0864a$var$emptySegmentValue : $47039de3e9f0864a$var$staticSegmentValue), initialScore);
}
function $47039de3e9f0864a$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $47039de3e9f0864a$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $47039de3e9f0864a$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $47039de3e9f0864a$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $47039de3e9f0864a$export$a5c6d149b50c1d86($47039de3e9f0864a$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $47039de3e9f0864a$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $47039de3e9f0864a$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $47039de3e9f0864a$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $47039de3e9f0864a$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $47039de3e9f0864a$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $47039de3e9f0864a$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $47039de3e9f0864a$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $47039de3e9f0864a$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $47039de3e9f0864a$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $47039de3e9f0864a$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $47039de3e9f0864a$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $47039de3e9f0864a$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $47039de3e9f0864a$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $47039de3e9f0864a$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $47039de3e9f0864a$var$normalizeSearch(search),
        hash: $47039de3e9f0864a$var$normalizeHash(hash)
    };
}
function $47039de3e9f0864a$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $47039de3e9f0864a$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $47039de3e9f0864a$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $47039de3e9f0864a$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $47039de3e9f0864a$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === matches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $47039de3e9f0864a$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $47039de3e9f0864a$export$8ccf933b0513f8d0(toArg);
    else {
        to = $47039de3e9f0864a$var$_extends({}, toArg);
        $47039de3e9f0864a$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $47039de3e9f0864a$var$getInvalidPathError("?", "pathname", "search", to));
        $47039de3e9f0864a$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $47039de3e9f0864a$var$getInvalidPathError("#", "pathname", "hash", to));
        $47039de3e9f0864a$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $47039de3e9f0864a$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $47039de3e9f0864a$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $47039de3e9f0864a$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $47039de3e9f0864a$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $47039de3e9f0864a$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $47039de3e9f0864a$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $47039de3e9f0864a$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $47039de3e9f0864a$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $47039de3e9f0864a$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $47039de3e9f0864a$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $47039de3e9f0864a$export$42a99a7a4bc0e76a extends Error {
}
class $47039de3e9f0864a$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $47039de3e9f0864a$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $47039de3e9f0864a$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $47039de3e9f0864a$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $47039de3e9f0864a$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $47039de3e9f0864a$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $47039de3e9f0864a$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $47039de3e9f0864a$var$unwrapTrackedPromise(value) {
    if (!$47039de3e9f0864a$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $47039de3e9f0864a$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $47039de3e9f0864a$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $47039de3e9f0864a$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $47039de3e9f0864a$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $47039de3e9f0864a$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $47039de3e9f0864a$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $47039de3e9f0864a$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $47039de3e9f0864a$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $47039de3e9f0864a$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $47039de3e9f0864a$var$validMutationMethods = new Set($47039de3e9f0864a$var$validMutationMethodsArr);
const $47039de3e9f0864a$var$validRequestMethodsArr = [
    "get",
    ...$47039de3e9f0864a$var$validMutationMethodsArr
];
const $47039de3e9f0864a$var$validRequestMethods = new Set($47039de3e9f0864a$var$validRequestMethodsArr);
const $47039de3e9f0864a$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $47039de3e9f0864a$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $47039de3e9f0864a$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $47039de3e9f0864a$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $47039de3e9f0864a$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $47039de3e9f0864a$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $47039de3e9f0864a$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $47039de3e9f0864a$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $47039de3e9f0864a$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $47039de3e9f0864a$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $47039de3e9f0864a$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $47039de3e9f0864a$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.unstable_dataStrategy || $47039de3e9f0864a$var$defaultDataStrategy;
    // Config driven behavior flags
    let future = $47039de3e9f0864a$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        unstable_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $47039de3e9f0864a$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $47039de3e9f0864a$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $47039de3e9f0864a$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized;
    let hasLazyRoutes = initialMatches.some((m)=>m.route.lazy);
    let hasLoaders = initialMatches.some((m)=>m.route.loader);
    if (hasLazyRoutes) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!hasLoaders) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        let isRouteInitialized = (m)=>{
            // No loader, nothing to initialize
            if (!m.route.loader) return true;
            // Explicitly opting-in to running on hydration
            if (typeof m.route.loader === "function" && m.route.loader.hydrate === true) return false;
            // Otherwise, initialized if hydrated with data or an error
            return loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined;
        };
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every(isRouteInitialized);
        } else initialized = initialMatches.every(isRouteInitialized);
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $47039de3e9f0864a$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $47039de3e9f0864a$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $47039de3e9f0864a$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $47039de3e9f0864a$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $47039de3e9f0864a$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$47039de3e9f0864a$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($47039de3e9f0864a$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $47039de3e9f0864a$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $47039de3e9f0864a$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $47039de3e9f0864a$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $47039de3e9f0864a$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $47039de3e9f0864a$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $47039de3e9f0864a$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $47039de3e9f0864a$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $47039de3e9f0864a$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $47039de3e9f0864a$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($47039de3e9f0864a$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $47039de3e9f0864a$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $47039de3e9f0864a$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $47039de3e9f0864a$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $47039de3e9f0864a$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $47039de3e9f0864a$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $47039de3e9f0864a$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $47039de3e9f0864a$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $47039de3e9f0864a$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $47039de3e9f0864a$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $47039de3e9f0864a$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $47039de3e9f0864a$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $47039de3e9f0864a$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $47039de3e9f0864a$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $47039de3e9f0864a$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $47039de3e9f0864a$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $47039de3e9f0864a$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $47039de3e9f0864a$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $47039de3e9f0864a$var$findNearestBoundary(matches).route.id,
            {
                type: $47039de3e9f0864a$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $47039de3e9f0864a$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $47039de3e9f0864a$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // Create a GET request for the loaders
            request = $47039de3e9f0864a$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $47039de3e9f0864a$var$_extends({
            matches: matches
        }, $47039de3e9f0864a$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $47039de3e9f0864a$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        // Call our action and get the result
        let result;
        let actionMatch = $47039de3e9f0864a$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $47039de3e9f0864a$var$ResultType.error,
            error: $47039de3e9f0864a$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches);
            result = results[0];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($47039de3e9f0864a$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $47039de3e9f0864a$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($47039de3e9f0864a$var$isDeferredResult(result)) throw $47039de3e9f0864a$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($47039de3e9f0864a$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $47039de3e9f0864a$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $47039de3e9f0864a$export$e19cd5f9376f8cee.Push;
            return {
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $47039de3e9f0864a$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $47039de3e9f0864a$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $47039de3e9f0864a$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.unstable_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $47039de3e9f0864a$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $47039de3e9f0864a$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $47039de3e9f0864a$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        if (!isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration)) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $47039de3e9f0864a$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData;
            if (pendingActionResult && !$47039de3e9f0864a$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
            // would be a breaking change to use any.
            // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
            actionData = {
                [pendingActionResult[0]]: pendingActionResult[1].data
            };
            else if (state.actionData) {
                if (Object.keys(state.actionData).length === 0) actionData = null;
                else actionData = state.actionData;
            }
            updateState($47039de3e9f0864a$var$_extends({
                navigation: loadingNavigation
            }, actionData !== undefined ? {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $47039de3e9f0864a$var$findRedirect([
            ...loaderResults,
            ...fetcherResults
        ]);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(request, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $47039de3e9f0864a$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // During partial hydration, preserve SSR errors for routes that don't re-run
        if (future.v7_partialHydration && initialHydration && state.errors) Object.entries(state.errors).filter((_ref2)=>{
            let [id] = _ref2;
            return !matchesToLoad.some((m)=>m.route.id === id);
        }).forEach((_ref3)=>{
            let [routeId, error] = _ref3;
            errors = Object.assign(errors || {}, {
                [routeId]: error
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $47039de3e9f0864a$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $47039de3e9f0864a$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $47039de3e9f0864a$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $47039de3e9f0864a$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $47039de3e9f0864a$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $47039de3e9f0864a$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $47039de3e9f0864a$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $47039de3e9f0864a$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $47039de3e9f0864a$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $47039de3e9f0864a$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", fetchRequest, [
            match
        ], requestMatches);
        let actionResult = actionResults[0];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($47039de3e9f0864a$var$isRedirectResult(actionResult) || $47039de3e9f0864a$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $47039de3e9f0864a$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($47039de3e9f0864a$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $47039de3e9f0864a$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $47039de3e9f0864a$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($47039de3e9f0864a$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($47039de3e9f0864a$var$isDeferredResult(actionResult)) throw $47039de3e9f0864a$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $47039de3e9f0864a$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $47039de3e9f0864a$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $47039de3e9f0864a$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $47039de3e9f0864a$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $47039de3e9f0864a$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.unstable_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $47039de3e9f0864a$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $47039de3e9f0864a$var$findRedirect([
            ...loaderResults,
            ...fetcherResults
        ]);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(revalidationRequest, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $47039de3e9f0864a$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $47039de3e9f0864a$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $47039de3e9f0864a$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $47039de3e9f0864a$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $47039de3e9f0864a$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $47039de3e9f0864a$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", fetchRequest, [
            match
        ], matches);
        let result = results[0];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($47039de3e9f0864a$var$isDeferredResult(result)) result = await $47039de3e9f0864a$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $47039de3e9f0864a$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($47039de3e9f0864a$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $47039de3e9f0864a$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($47039de3e9f0864a$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $47039de3e9f0864a$export$3e9cee6b33872309(!$47039de3e9f0864a$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $47039de3e9f0864a$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $47039de3e9f0864a$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $47039de3e9f0864a$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $47039de3e9f0864a$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($47039de3e9f0864a$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $47039de3e9f0864a$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $47039de3e9f0864a$export$e19cd5f9376f8cee.Replace : $47039de3e9f0864a$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $47039de3e9f0864a$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($47039de3e9f0864a$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $47039de3e9f0864a$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $47039de3e9f0864a$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $47039de3e9f0864a$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches) {
        try {
            let results = await $47039de3e9f0864a$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties);
            return await Promise.all(results.map((result, i)=>{
                if ($47039de3e9f0864a$var$isRedirectHandlerResult(result)) {
                    let response = result.result;
                    return {
                        type: $47039de3e9f0864a$var$ResultType.redirect,
                        response: $47039de3e9f0864a$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath)
                    };
                }
                return $47039de3e9f0864a$var$convertHandlerResultToDataResult(result);
            }));
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            return matchesToLoad.map(()=>({
                    type: $47039de3e9f0864a$var$ResultType.error,
                    error: e
                }));
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        let [loaderResults, ...fetcherResults] = await Promise.all([
            matchesToLoad.length ? callDataStrategy("loader", request, matchesToLoad, matches) : [],
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) {
                    let fetcherRequest = $47039de3e9f0864a$var$createClientSideRequest(init.history, f.path, f.controller.signal);
                    return callDataStrategy("loader", fetcherRequest, [
                        f.match
                    ], f.matches).then((r)=>r[0]);
                } else return Promise.resolve({
                    type: $47039de3e9f0864a$var$ResultType.error,
                    error: $47039de3e9f0864a$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                });
            })
        ]);
        await Promise.all([
            $47039de3e9f0864a$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $47039de3e9f0864a$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $47039de3e9f0864a$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $47039de3e9f0864a$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $47039de3e9f0864a$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $47039de3e9f0864a$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $47039de3e9f0864a$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $47039de3e9f0864a$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $47039de3e9f0864a$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $47039de3e9f0864a$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $47039de3e9f0864a$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref4) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref4;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $47039de3e9f0864a$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $47039de3e9f0864a$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$47039de3e9f0864a$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $47039de3e9f0864a$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $47039de3e9f0864a$export$4d0306f8f6a4585b = Symbol("deferred");
function $47039de3e9f0864a$export$3336b097a6fbc59a(routes, opts) {
    $47039de3e9f0864a$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $47039de3e9f0864a$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $47039de3e9f0864a$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $47039de3e9f0864a$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, unstable_dataStrategy: unstable_dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $47039de3e9f0864a$var$createLocation("", $47039de3e9f0864a$export$fe53371bee54353d(url), null, "default");
        let matches = $47039de3e9f0864a$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$47039de3e9f0864a$var$isValidMethod(method) && method !== "HEAD") {
            let error = $47039de3e9f0864a$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $47039de3e9f0864a$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $47039de3e9f0864a$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $47039de3e9f0864a$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($47039de3e9f0864a$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $47039de3e9f0864a$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, unstable_dataStrategy: unstable_dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $47039de3e9f0864a$var$createLocation("", $47039de3e9f0864a$export$fe53371bee54353d(url), null, "default");
        let matches = $47039de3e9f0864a$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$47039de3e9f0864a$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $47039de3e9f0864a$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $47039de3e9f0864a$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $47039de3e9f0864a$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $47039de3e9f0864a$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $47039de3e9f0864a$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, false, match);
        if ($47039de3e9f0864a$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$47039de3e9f0864a$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $47039de3e9f0864a$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($47039de3e9f0864a$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $47039de3e9f0864a$var$getTargetMatch(matches, location), requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $47039de3e9f0864a$var$isResponse(result) ? result : $47039de3e9f0864a$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `HandlerResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($47039de3e9f0864a$var$isHandlerResult(e) && $47039de3e9f0864a$var$isResponse(e.result)) {
                if (e.type === $47039de3e9f0864a$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($47039de3e9f0864a$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $47039de3e9f0864a$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $47039de3e9f0864a$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, unstable_dataStrategy);
            result = results[0];
            if (request.signal.aborted) $47039de3e9f0864a$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($47039de3e9f0864a$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($47039de3e9f0864a$var$isDeferredResult(result)) {
            let error = $47039de3e9f0864a$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $47039de3e9f0864a$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($47039de3e9f0864a$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($47039de3e9f0864a$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $47039de3e9f0864a$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $47039de3e9f0864a$var$_extends({}, context, {
                statusCode: $47039de3e9f0864a$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $47039de3e9f0864a$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null);
        return $47039de3e9f0864a$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $47039de3e9f0864a$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $47039de3e9f0864a$var$isErrorResult(pendingActionResult[1]) ? $47039de3e9f0864a$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $47039de3e9f0864a$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy);
        if (request.signal.aborted) $47039de3e9f0864a$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $47039de3e9f0864a$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $47039de3e9f0864a$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy) {
        let results = await $47039de3e9f0864a$var$callDataStrategyImpl(unstable_dataStrategy || $47039de3e9f0864a$var$defaultDataStrategy, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext);
        return await Promise.all(results.map((result, i)=>{
            if ($47039de3e9f0864a$var$isRedirectHandlerResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $47039de3e9f0864a$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($47039de3e9f0864a$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            return $47039de3e9f0864a$var$convertHandlerResultToDataResult(result);
        }));
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $47039de3e9f0864a$export$fec11da027c70692(routes, context, error) {
    let newContext = $47039de3e9f0864a$var$_extends({}, context, {
        statusCode: $47039de3e9f0864a$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $47039de3e9f0864a$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $47039de3e9f0864a$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $47039de3e9f0864a$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $47039de3e9f0864a$export$cae722b0cc860f13(to ? to : ".", $47039de3e9f0864a$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $47039de3e9f0864a$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$47039de3e9f0864a$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $47039de3e9f0864a$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $47039de3e9f0864a$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $47039de3e9f0864a$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$47039de3e9f0864a$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$47039de3e9f0864a$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $47039de3e9f0864a$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $47039de3e9f0864a$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $47039de3e9f0864a$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$47039de3e9f0864a$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref5)=>{
                let [name, value] = _ref5;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$47039de3e9f0864a$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $47039de3e9f0864a$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $47039de3e9f0864a$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $47039de3e9f0864a$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $47039de3e9f0864a$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $47039de3e9f0864a$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($47039de3e9f0864a$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $47039de3e9f0864a$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $47039de3e9f0864a$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $47039de3e9f0864a$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $47039de3e9f0864a$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $47039de3e9f0864a$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $47039de3e9f0864a$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingActionResult && $47039de3e9f0864a$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[0] : undefined;
    let boundaryMatches = boundaryId ? $47039de3e9f0864a$var$getLoaderMatchesUntilBoundary(matches, boundaryId) : matches;
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (typeof route.loader !== "function" || route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($47039de3e9f0864a$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $47039de3e9f0864a$var$shouldRevalidateLoader(match, $47039de3e9f0864a$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            unstable_actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $47039de3e9f0864a$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $47039de3e9f0864a$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $47039de3e9f0864a$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $47039de3e9f0864a$var$shouldRevalidateLoader(fetcherMatch, $47039de3e9f0864a$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            unstable_actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $47039de3e9f0864a$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $47039de3e9f0864a$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $47039de3e9f0864a$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $47039de3e9f0864a$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $47039de3e9f0864a$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $47039de3e9f0864a$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$47039de3e9f0864a$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $47039de3e9f0864a$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
function $47039de3e9f0864a$var$defaultDataStrategy(opts) {
    return Promise.all(opts.matches.map((m)=>m.resolve()));
}
async function $47039de3e9f0864a$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext) {
    let routeIdsToLoad = matchesToLoad.reduce((acc, m)=>acc.add(m.route.id), new Set());
    let loadedMatches = new Set();
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: matches.map((match)=>{
            let shouldLoad = routeIdsToLoad.has(match.route.id);
            // `resolve` encapsulates the route.lazy, executing the
            // loader/action, and mapping return values/thrown errors to a
            // HandlerResult.  Users can pass a callback to take fine-grained control
            // over the execution of the loader/action
            let resolve = (handlerOverride)=>{
                loadedMatches.add(match.route.id);
                return shouldLoad ? $47039de3e9f0864a$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, requestContext) : Promise.resolve({
                    type: $47039de3e9f0864a$var$ResultType.data,
                    result: undefined
                });
            };
            return $47039de3e9f0864a$var$_extends({}, match, {
                shouldLoad: shouldLoad,
                resolve: resolve
            });
        }),
        request: request,
        params: matches[0].params,
        context: requestContext
    });
    // Throw if any loadRoute implementations not called since they are what
    // ensures a route is fully loaded
    matches.forEach((m)=>$47039de3e9f0864a$export$3e9cee6b33872309(loadedMatches.has(m.route.id), "`match.resolve()` was not called for route id \"" + m.route.id + "\". " + "You must call `match.resolve()` on every match passed to " + "`dataStrategy` to ensure all routes are properly loaded."));
    // Filter out any middleware-only matches for which we didn't need to run handlers
    return results.filter((_, i)=>routeIdsToLoad.has(matches[i].route.id));
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $47039de3e9f0864a$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<HandlerResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise;
        if (handlerOverride) handlerPromise = handlerOverride((ctx)=>actualHandler(ctx));
        else handlerPromise = (async ()=>{
            try {
                let val = await actualHandler();
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $47039de3e9f0864a$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await $47039de3e9f0864a$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $47039de3e9f0864a$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $47039de3e9f0864a$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $47039de3e9f0864a$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $47039de3e9f0864a$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // HandlerResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $47039de3e9f0864a$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $47039de3e9f0864a$var$convertHandlerResultToDataResult(handlerResult) {
    let { result: result, type: type, status: status } = handlerResult;
    if ($47039de3e9f0864a$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $47039de3e9f0864a$var$ResultType.error,
                error: e
            };
        }
        if (type === $47039de3e9f0864a$var$ResultType.error) return {
            type: $47039de3e9f0864a$var$ResultType.error,
            error: new $47039de3e9f0864a$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $47039de3e9f0864a$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $47039de3e9f0864a$var$ResultType.error) return {
        type: $47039de3e9f0864a$var$ResultType.error,
        error: result,
        statusCode: $47039de3e9f0864a$export$972111febbeef05b(result) ? result.status : status
    };
    if ($47039de3e9f0864a$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $47039de3e9f0864a$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $47039de3e9f0864a$var$ResultType.data,
        data: result,
        statusCode: status
    };
}
// Support relative routing in internal redirects
function $47039de3e9f0864a$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $47039de3e9f0864a$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$47039de3e9f0864a$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $47039de3e9f0864a$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $47039de3e9f0864a$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($47039de3e9f0864a$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $47039de3e9f0864a$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $47039de3e9f0864a$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($47039de3e9f0864a$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $47039de3e9f0864a$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $47039de3e9f0864a$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $47039de3e9f0864a$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $47039de3e9f0864a$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $47039de3e9f0864a$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $47039de3e9f0864a$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $47039de3e9f0864a$export$3e9cee6b33872309(!$47039de3e9f0864a$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($47039de3e9f0864a$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $47039de3e9f0864a$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $47039de3e9f0864a$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($47039de3e9f0864a$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $47039de3e9f0864a$var$processLoaderData(state, matches, matchesToLoad, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $47039de3e9f0864a$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $47039de3e9f0864a$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($47039de3e9f0864a$var$isErrorResult(result)) {
            let boundaryMatch = $47039de3e9f0864a$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $47039de3e9f0864a$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($47039de3e9f0864a$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $47039de3e9f0864a$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($47039de3e9f0864a$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $47039de3e9f0864a$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $47039de3e9f0864a$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $47039de3e9f0864a$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $47039de3e9f0864a$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $47039de3e9f0864a$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $47039de3e9f0864a$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $47039de3e9f0864a$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $47039de3e9f0864a$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $47039de3e9f0864a$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $47039de3e9f0864a$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $47039de3e9f0864a$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($47039de3e9f0864a$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $47039de3e9f0864a$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $47039de3e9f0864a$export$8ccf933b0513f8d0(path) : path;
    return $47039de3e9f0864a$export$fe53371bee54353d($47039de3e9f0864a$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $47039de3e9f0864a$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $47039de3e9f0864a$var$isHandlerResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $47039de3e9f0864a$var$ResultType.data || result.type === $47039de3e9f0864a$var$ResultType.error);
}
function $47039de3e9f0864a$var$isRedirectHandlerResult(result) {
    return $47039de3e9f0864a$var$isResponse(result.result) && $47039de3e9f0864a$var$redirectStatusCodes.has(result.result.status);
}
function $47039de3e9f0864a$var$isDeferredResult(result) {
    return result.type === $47039de3e9f0864a$var$ResultType.deferred;
}
function $47039de3e9f0864a$var$isErrorResult(result) {
    return result.type === $47039de3e9f0864a$var$ResultType.error;
}
function $47039de3e9f0864a$var$isRedirectResult(result) {
    return (result && result.type) === $47039de3e9f0864a$var$ResultType.redirect;
}
function $47039de3e9f0864a$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $47039de3e9f0864a$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $47039de3e9f0864a$var$isRedirectResponse(result) {
    if (!$47039de3e9f0864a$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $47039de3e9f0864a$var$isValidMethod(method) {
    return $47039de3e9f0864a$var$validRequestMethods.has(method.toLowerCase());
}
function $47039de3e9f0864a$var$isMutationMethod(method) {
    return $47039de3e9f0864a$var$validMutationMethods.has(method.toLowerCase());
}
async function $47039de3e9f0864a$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$47039de3e9f0864a$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($47039de3e9f0864a$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $47039de3e9f0864a$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $47039de3e9f0864a$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $47039de3e9f0864a$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $47039de3e9f0864a$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $47039de3e9f0864a$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $47039de3e9f0864a$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $47039de3e9f0864a$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $47039de3e9f0864a$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $47039de3e9f0864a$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $47039de3e9f0864a$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $47039de3e9f0864a$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $47039de3e9f0864a$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $47039de3e9f0864a$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $47039de3e9f0864a$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $47039de3e9f0864a$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $47039de3e9f0864a$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $47039de3e9f0864a$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $47039de3e9f0864a$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($47039de3e9f0864a$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $47039de3e9f0864a$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($47039de3e9f0864a$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $47039de3e9f0864a$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.23.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $8NFma = parcelRequire("8NFma");

function $7b8d8d3adba9a65c$var$_extends() {
    $7b8d8d3adba9a65c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7b8d8d3adba9a65c$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7b8d8d3adba9a65c$export$3add0d5dce533e2e = /*#__PURE__*/ $8NFma.createContext(null);
const $7b8d8d3adba9a65c$export$145dfa71566a64dc = /*#__PURE__*/ $8NFma.createContext(null);
const $7b8d8d3adba9a65c$var$AwaitContext = /*#__PURE__*/ $8NFma.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7b8d8d3adba9a65c$export$26749e8557646306 = /*#__PURE__*/ $8NFma.createContext(null);
const $7b8d8d3adba9a65c$export$c7914228fb69b0f5 = /*#__PURE__*/ $8NFma.createContext(null);
const $7b8d8d3adba9a65c$export$9072aa6dd1f93057 = /*#__PURE__*/ $8NFma.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $7b8d8d3adba9a65c$var$RouteErrorContext = /*#__PURE__*/ $8NFma.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $7b8d8d3adba9a65c$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7b8d8d3adba9a65c$export$9c954a9d03d32f4a() && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $8NFma.useContext($7b8d8d3adba9a65c$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7b8d8d3adba9a65c$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $47039de3e9f0864a$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $7b8d8d3adba9a65c$export$9c954a9d03d32f4a() {
    return $8NFma.useContext($7b8d8d3adba9a65c$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $7b8d8d3adba9a65c$export$45d76561a5302f2b() {
    !$7b8d8d3adba9a65c$export$9c954a9d03d32f4a() && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false);
    return $8NFma.useContext($7b8d8d3adba9a65c$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $7b8d8d3adba9a65c$export$1b3f31771c5d07c() {
    return $8NFma.useContext($7b8d8d3adba9a65c$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $7b8d8d3adba9a65c$export$6c330e8992e8a295(pattern) {
    !$7b8d8d3adba9a65c$export$9c954a9d03d32f4a() && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $7b8d8d3adba9a65c$export$45d76561a5302f2b();
    return $8NFma.useMemo(()=>(0, $47039de3e9f0864a$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7b8d8d3adba9a65c$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7b8d8d3adba9a65c$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $8NFma.useContext($7b8d8d3adba9a65c$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $8NFma.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $7b8d8d3adba9a65c$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $8NFma.useContext($7b8d8d3adba9a65c$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7b8d8d3adba9a65c$var$useNavigateStable() : $7b8d8d3adba9a65c$var$useNavigateUnstable();
}
function $7b8d8d3adba9a65c$var$useNavigateUnstable() {
    !$7b8d8d3adba9a65c$export$9c954a9d03d32f4a() && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false);
    let dataRouterContext = $8NFma.useContext($7b8d8d3adba9a65c$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $8NFma.useContext($7b8d8d3adba9a65c$export$26749e8557646306);
    let { matches: matches } = $8NFma.useContext($7b8d8d3adba9a65c$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7b8d8d3adba9a65c$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $47039de3e9f0864a$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $8NFma.useRef(false);
    $7b8d8d3adba9a65c$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $8NFma.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $47039de3e9f0864a$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $47039de3e9f0864a$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7b8d8d3adba9a65c$var$OutletContext = /*#__PURE__*/ $8NFma.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $7b8d8d3adba9a65c$export$4138103a3ae699cc() {
    return $8NFma.useContext($7b8d8d3adba9a65c$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $7b8d8d3adba9a65c$export$a3be3530d8e40d0b(context) {
    let outlet = $8NFma.useContext($7b8d8d3adba9a65c$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $7b8d8d3adba9a65c$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $8NFma.useContext($7b8d8d3adba9a65c$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $7b8d8d3adba9a65c$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $8NFma.useContext($7b8d8d3adba9a65c$export$26749e8557646306);
    let { matches: matches } = $8NFma.useContext($7b8d8d3adba9a65c$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7b8d8d3adba9a65c$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $47039de3e9f0864a$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $8NFma.useMemo(()=>(0, $47039de3e9f0864a$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $7b8d8d3adba9a65c$export$5d3fca4a98652595(routes, locationArg) {
    return $7b8d8d3adba9a65c$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7b8d8d3adba9a65c$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$7b8d8d3adba9a65c$export$9c954a9d03d32f4a() && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $8NFma.useContext($7b8d8d3adba9a65c$export$26749e8557646306);
    let { matches: parentMatches } = $8NFma.useContext($7b8d8d3adba9a65c$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $7b8d8d3adba9a65c$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $47039de3e9f0864a$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $47039de3e9f0864a$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $7b8d8d3adba9a65c$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $47039de3e9f0864a$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $47039de3e9f0864a$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7b8d8d3adba9a65c$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $47039de3e9f0864a$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7b8d8d3adba9a65c$var$DefaultErrorComponent() {
    let error = $7b8d8d3adba9a65c$export$ed527bf60f6e05f2();
    let message = (0, $47039de3e9f0864a$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $8NFma.createElement($8NFma.Fragment, null, /*#__PURE__*/ $8NFma.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $8NFma.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $8NFma.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7b8d8d3adba9a65c$var$defaultErrorElement = /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$var$DefaultErrorComponent, null);
class $7b8d8d3adba9a65c$var$RenderErrorBoundary extends $8NFma.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7b8d8d3adba9a65c$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $8NFma.useContext($7b8d8d3adba9a65c$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7b8d8d3adba9a65c$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $7b8d8d3adba9a65c$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $7b8d8d3adba9a65c$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $8NFma.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7b8d8d3adba9a65c$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7b8d8d3adba9a65c$var$DataRouterHook || {});
var $7b8d8d3adba9a65c$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7b8d8d3adba9a65c$var$DataRouterStateHook || {});
function $7b8d8d3adba9a65c$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $7b8d8d3adba9a65c$var$useDataRouterContext(hookName) {
    let ctx = $8NFma.useContext($7b8d8d3adba9a65c$export$3add0d5dce533e2e);
    !ctx && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false);
    return ctx;
}
function $7b8d8d3adba9a65c$var$useDataRouterState(hookName) {
    let state = $8NFma.useContext($7b8d8d3adba9a65c$export$145dfa71566a64dc);
    !state && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false);
    return state;
}
function $7b8d8d3adba9a65c$var$useRouteContext(hookName) {
    let route = $8NFma.useContext($7b8d8d3adba9a65c$export$9072aa6dd1f93057);
    !route && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $7b8d8d3adba9a65c$var$useCurrentRouteId(hookName) {
    let route = $7b8d8d3adba9a65c$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7b8d8d3adba9a65c$export$5fc8298006ad9e58() {
    return $7b8d8d3adba9a65c$var$useCurrentRouteId($7b8d8d3adba9a65c$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7b8d8d3adba9a65c$export$d0fd4b7106de2769() {
    let state = $7b8d8d3adba9a65c$var$useDataRouterState($7b8d8d3adba9a65c$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7b8d8d3adba9a65c$export$600dc272ed516c15() {
    let dataRouterContext = $7b8d8d3adba9a65c$var$useDataRouterContext($7b8d8d3adba9a65c$var$DataRouterHook.UseRevalidator);
    let state = $7b8d8d3adba9a65c$var$useDataRouterState($7b8d8d3adba9a65c$var$DataRouterStateHook.UseRevalidator);
    return $8NFma.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7b8d8d3adba9a65c$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7b8d8d3adba9a65c$var$useDataRouterState($7b8d8d3adba9a65c$var$DataRouterStateHook.UseMatches);
    return $8NFma.useMemo(()=>matches.map((m)=>(0, $47039de3e9f0864a$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7b8d8d3adba9a65c$export$1448a5050d252c4d() {
    let state = $7b8d8d3adba9a65c$var$useDataRouterState($7b8d8d3adba9a65c$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7b8d8d3adba9a65c$var$useCurrentRouteId($7b8d8d3adba9a65c$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7b8d8d3adba9a65c$export$fd5d37484eab868d(routeId) {
    let state = $7b8d8d3adba9a65c$var$useDataRouterState($7b8d8d3adba9a65c$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7b8d8d3adba9a65c$export$fdc00f3f26066d5e() {
    let state = $7b8d8d3adba9a65c$var$useDataRouterState($7b8d8d3adba9a65c$var$DataRouterStateHook.UseActionData);
    let routeId = $7b8d8d3adba9a65c$var$useCurrentRouteId($7b8d8d3adba9a65c$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7b8d8d3adba9a65c$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $8NFma.useContext($7b8d8d3adba9a65c$var$RouteErrorContext);
    let state = $7b8d8d3adba9a65c$var$useDataRouterState($7b8d8d3adba9a65c$var$DataRouterStateHook.UseRouteError);
    let routeId = $7b8d8d3adba9a65c$var$useCurrentRouteId($7b8d8d3adba9a65c$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $7b8d8d3adba9a65c$export$78a72ddb39bdd145() {
    let value = $8NFma.useContext($7b8d8d3adba9a65c$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $7b8d8d3adba9a65c$export$17f53340677d5831() {
    let value = $8NFma.useContext($7b8d8d3adba9a65c$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7b8d8d3adba9a65c$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7b8d8d3adba9a65c$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $7b8d8d3adba9a65c$var$useDataRouterContext($7b8d8d3adba9a65c$var$DataRouterHook.UseBlocker);
    let state = $7b8d8d3adba9a65c$var$useDataRouterState($7b8d8d3adba9a65c$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $8NFma.useState("");
    let blockerFunction = $8NFma.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $7b8d8d3adba9a65c$var$_extends({}, currentLocation, {
                pathname: (0, $47039de3e9f0864a$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7b8d8d3adba9a65c$var$_extends({}, nextLocation, {
                pathname: (0, $47039de3e9f0864a$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $8NFma.useEffect(()=>{
        let key = String(++$7b8d8d3adba9a65c$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $8NFma.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $47039de3e9f0864a$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7b8d8d3adba9a65c$var$useNavigateStable() {
    let { router: router } = $7b8d8d3adba9a65c$var$useDataRouterContext($7b8d8d3adba9a65c$var$DataRouterHook.UseNavigateStable);
    let id = $7b8d8d3adba9a65c$var$useCurrentRouteId($7b8d8d3adba9a65c$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $8NFma.useRef(false);
    $7b8d8d3adba9a65c$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $8NFma.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7b8d8d3adba9a65c$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7b8d8d3adba9a65c$var$alreadyWarned = {};
function $7b8d8d3adba9a65c$var$warningOnce(key, cond, message) {
    if (!cond && !$7b8d8d3adba9a65c$var$alreadyWarned[key]) $7b8d8d3adba9a65c$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $7b8d8d3adba9a65c$var$START_TRANSITION = "startTransition";
const $7b8d8d3adba9a65c$var$startTransitionImpl = $8NFma[$7b8d8d3adba9a65c$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7b8d8d3adba9a65c$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $8NFma.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8NFma.useCallback((newState)=>{
        if (v7_startTransition && $7b8d8d3adba9a65c$var$startTransitionImpl) $7b8d8d3adba9a65c$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $8NFma.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $8NFma.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $8NFma.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $8NFma.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $8NFma.createElement($8NFma.Fragment, null, /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $7b8d8d3adba9a65c$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $7b8d8d3adba9a65c$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $7b8d8d3adba9a65c$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $8NFma.useRef();
    if (historyRef.current == null) historyRef.current = (0, $47039de3e9f0864a$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8NFma.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8NFma.useCallback((newState)=>{
        v7_startTransition && $7b8d8d3adba9a65c$var$startTransitionImpl ? $7b8d8d3adba9a65c$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8NFma.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $7b8d8d3adba9a65c$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7b8d8d3adba9a65c$export$9c954a9d03d32f4a() && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $8NFma.useContext($7b8d8d3adba9a65c$export$26749e8557646306);
    let { matches: matches } = $8NFma.useContext($7b8d8d3adba9a65c$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7b8d8d3adba9a65c$export$45d76561a5302f2b();
    let navigate = $7b8d8d3adba9a65c$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $47039de3e9f0864a$export$cae722b0cc860f13)(to, (0, $47039de3e9f0864a$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $8NFma.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $7b8d8d3adba9a65c$export$910ae8079b2c2852(props) {
    return $7b8d8d3adba9a65c$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $7b8d8d3adba9a65c$export$e7b0ac011bb776c6(_props) {
    (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $7b8d8d3adba9a65c$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $47039de3e9f0864a$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$7b8d8d3adba9a65c$export$9c954a9d03d32f4a() && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $8NFma.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $7b8d8d3adba9a65c$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $47039de3e9f0864a$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $8NFma.useMemo(()=>{
        let trailingPathname = (0, $47039de3e9f0864a$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $7b8d8d3adba9a65c$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7b8d8d3adba9a65c$export$5d3fca4a98652595($7b8d8d3adba9a65c$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7b8d8d3adba9a65c$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$var$ResolveAwait, null, children));
}
var $7b8d8d3adba9a65c$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7b8d8d3adba9a65c$var$AwaitRenderStatus || {});
const $7b8d8d3adba9a65c$var$neverSettledPromise = new Promise(()=>{});
class $7b8d8d3adba9a65c$var$AwaitErrorBoundary extends $8NFma.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7b8d8d3adba9a65c$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7b8d8d3adba9a65c$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7b8d8d3adba9a65c$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $7b8d8d3adba9a65c$var$AwaitRenderStatus.error : "_data" in promise ? $7b8d8d3adba9a65c$var$AwaitRenderStatus.success : $7b8d8d3adba9a65c$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7b8d8d3adba9a65c$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7b8d8d3adba9a65c$var$AwaitRenderStatus.error && promise._error instanceof (0, $47039de3e9f0864a$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $7b8d8d3adba9a65c$var$neverSettledPromise;
        if (status === $7b8d8d3adba9a65c$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7b8d8d3adba9a65c$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7b8d8d3adba9a65c$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $7b8d8d3adba9a65c$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7b8d8d3adba9a65c$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $8NFma.createElement($8NFma.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $7b8d8d3adba9a65c$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $8NFma.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $8NFma.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $8NFma.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7b8d8d3adba9a65c$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7b8d8d3adba9a65c$export$e7b0ac011bb776c6) && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7b8d8d3adba9a65c$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7b8d8d3adba9a65c$export$daf73786167a7f72(matches) {
    return $7b8d8d3adba9a65c$var$_renderMatches(matches);
}
function $7b8d8d3adba9a65c$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $8NFma.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $8NFma.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $8NFma.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $7b8d8d3adba9a65c$export$f30f7e456d254e83(routes, opts) {
    return (0, $47039de3e9f0864a$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7b8d8d3adba9a65c$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $47039de3e9f0864a$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7b8d8d3adba9a65c$export$52b333d321859367,
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy
    }).initialize();
}



function $a8cea113a6044695$var$_extends() {
    $a8cea113a6044695$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a8cea113a6044695$var$_extends.apply(this, arguments);
}
function $a8cea113a6044695$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $a8cea113a6044695$var$defaultMethod = "get";
const $a8cea113a6044695$var$defaultEncType = "application/x-www-form-urlencoded";
function $a8cea113a6044695$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $a8cea113a6044695$var$isButtonElement(object) {
    return $a8cea113a6044695$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $a8cea113a6044695$var$isFormElement(object) {
    return $a8cea113a6044695$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $a8cea113a6044695$var$isInputElement(object) {
    return $a8cea113a6044695$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $a8cea113a6044695$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $a8cea113a6044695$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$a8cea113a6044695$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $a8cea113a6044695$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $a8cea113a6044695$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $a8cea113a6044695$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $a8cea113a6044695$var$_formDataSupportsSubmitter = null;
function $a8cea113a6044695$var$isFormDataSubmitterSupported() {
    if ($a8cea113a6044695$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $a8cea113a6044695$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $a8cea113a6044695$var$_formDataSupportsSubmitter = true;
    }
    return $a8cea113a6044695$var$_formDataSupportsSubmitter;
}
const $a8cea113a6044695$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $a8cea113a6044695$var$getFormEncType(encType) {
    if (encType != null && !$a8cea113a6044695$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $a8cea113a6044695$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($a8cea113a6044695$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $47039de3e9f0864a$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $a8cea113a6044695$var$defaultMethod;
        encType = $a8cea113a6044695$var$getFormEncType(target.getAttribute("enctype")) || $a8cea113a6044695$var$defaultEncType;
        formData = new FormData(target);
    } else if ($a8cea113a6044695$var$isButtonElement(target) || $a8cea113a6044695$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $47039de3e9f0864a$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $a8cea113a6044695$var$defaultMethod;
        encType = $a8cea113a6044695$var$getFormEncType(target.getAttribute("formenctype")) || $a8cea113a6044695$var$getFormEncType(form.getAttribute("enctype")) || $a8cea113a6044695$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$a8cea113a6044695$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($a8cea113a6044695$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $a8cea113a6044695$var$defaultMethod;
        action = null;
        encType = $a8cea113a6044695$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $a8cea113a6044695$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $a8cea113a6044695$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $a8cea113a6044695$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $a8cea113a6044695$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $a8cea113a6044695$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $a8cea113a6044695$export$1f3f55432a00e06d(routes, opts) {
    return (0, $47039de3e9f0864a$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $a8cea113a6044695$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $47039de3e9f0864a$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $a8cea113a6044695$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7b8d8d3adba9a65c$export$52b333d321859367),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $a8cea113a6044695$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $47039de3e9f0864a$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $a8cea113a6044695$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $47039de3e9f0864a$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $a8cea113a6044695$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7b8d8d3adba9a65c$export$52b333d321859367),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $a8cea113a6044695$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $a8cea113a6044695$var$_extends({}, state, {
        errors: $a8cea113a6044695$var$deserializeErrors(state.errors)
    });
    return state;
}
function $a8cea113a6044695$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $47039de3e9f0864a$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $a8cea113a6044695$export$7ad602f0e94e62d1 = /*#__PURE__*/ $8NFma.createContext({
    isTransitioning: false
});
const $a8cea113a6044695$export$148fd98d095596d4 = /*#__PURE__*/ $8NFma.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $a8cea113a6044695$var$START_TRANSITION = "startTransition";
const $a8cea113a6044695$var$startTransitionImpl = $8NFma[$a8cea113a6044695$var$START_TRANSITION];
const $a8cea113a6044695$var$FLUSH_SYNC = "flushSync";
const $a8cea113a6044695$var$flushSyncImpl = $2pmb0[$a8cea113a6044695$var$FLUSH_SYNC];
const $a8cea113a6044695$var$USE_ID = "useId";
const $a8cea113a6044695$var$useIdImpl = $8NFma[$a8cea113a6044695$var$USE_ID];
function $a8cea113a6044695$var$startTransitionSafe(cb) {
    if ($a8cea113a6044695$var$startTransitionImpl) $a8cea113a6044695$var$startTransitionImpl(cb);
    else cb();
}
function $a8cea113a6044695$var$flushSyncSafe(cb) {
    if ($a8cea113a6044695$var$flushSyncImpl) $a8cea113a6044695$var$flushSyncImpl(cb);
    else cb();
}
class $a8cea113a6044695$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $a8cea113a6044695$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $8NFma.useState(router.state);
    let [pendingState, setPendingState] = $8NFma.useState();
    let [vtContext, setVtContext] = $8NFma.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $8NFma.useState();
    let [transition, setTransition] = $8NFma.useState();
    let [interruption, setInterruption] = $8NFma.useState();
    let fetcherData = $8NFma.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $8NFma.useCallback((cb)=>{
        if (v7_startTransition) $a8cea113a6044695$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $8NFma.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $a8cea113a6044695$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $a8cea113a6044695$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $a8cea113a6044695$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $a8cea113a6044695$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $a8cea113a6044695$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $8NFma.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $8NFma.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $a8cea113a6044695$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $8NFma.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $8NFma.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $8NFma.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $8NFma.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $8NFma.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $8NFma.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $8NFma.createElement($8NFma.Fragment, null, /*#__PURE__*/ $8NFma.createElement((0, $7b8d8d3adba9a65c$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $8NFma.createElement((0, $7b8d8d3adba9a65c$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $8NFma.createElement($a8cea113a6044695$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $8NFma.createElement($a8cea113a6044695$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $8NFma.createElement((0, $7b8d8d3adba9a65c$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $8NFma.createElement($a8cea113a6044695$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
function $a8cea113a6044695$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $7b8d8d3adba9a65c$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $a8cea113a6044695$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $8NFma.useRef();
    if (historyRef.current == null) historyRef.current = (0, $47039de3e9f0864a$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8NFma.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8NFma.useCallback((newState)=>{
        v7_startTransition && $a8cea113a6044695$var$startTransitionImpl ? $a8cea113a6044695$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8NFma.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $8NFma.createElement((0, $7b8d8d3adba9a65c$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $a8cea113a6044695$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $8NFma.useRef();
    if (historyRef.current == null) historyRef.current = (0, $47039de3e9f0864a$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8NFma.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8NFma.useCallback((newState)=>{
        v7_startTransition && $a8cea113a6044695$var$startTransitionImpl ? $a8cea113a6044695$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8NFma.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $8NFma.createElement((0, $7b8d8d3adba9a65c$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $a8cea113a6044695$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $8NFma.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8NFma.useCallback((newState)=>{
        v7_startTransition && $a8cea113a6044695$var$startTransitionImpl ? $a8cea113a6044695$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8NFma.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $8NFma.createElement((0, $7b8d8d3adba9a65c$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $a8cea113a6044695$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $a8cea113a6044695$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $a8cea113a6044695$export$a6c7ac8248d6e38a = /*#__PURE__*/ $8NFma.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $a8cea113a6044695$var$_objectWithoutPropertiesLoose(_ref7, $a8cea113a6044695$var$_excluded);
    let { basename: basename } = $8NFma.useContext((0, $7b8d8d3adba9a65c$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $a8cea113a6044695$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($a8cea113a6044695$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $47039de3e9f0864a$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $7b8d8d3adba9a65c$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $a8cea113a6044695$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $8NFma.createElement("a", $a8cea113a6044695$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $a8cea113a6044695$export$b0d92dbee9b5b60d = /*#__PURE__*/ $8NFma.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $a8cea113a6044695$var$_objectWithoutPropertiesLoose(_ref8, $a8cea113a6044695$var$_excluded2);
    let path = (0, $7b8d8d3adba9a65c$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $7b8d8d3adba9a65c$export$45d76561a5302f2b)();
    let routerState = $8NFma.useContext((0, $7b8d8d3adba9a65c$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $8NFma.useContext((0, $7b8d8d3adba9a65c$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $a8cea113a6044695$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $47039de3e9f0864a$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $8NFma.createElement($a8cea113a6044695$export$a6c7ac8248d6e38a, $a8cea113a6044695$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $a8cea113a6044695$export$a7fed597f4b8afd8 = /*#__PURE__*/ $8NFma.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $a8cea113a6044695$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $a8cea113a6044695$var$_objectWithoutPropertiesLoose(_ref9, $a8cea113a6044695$var$_excluded3);
    let submit = $a8cea113a6044695$export$47c85c6e3a081d3();
    let formAction = $a8cea113a6044695$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $8NFma.createElement("form", $a8cea113a6044695$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $a8cea113a6044695$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $a8cea113a6044695$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $a8cea113a6044695$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($a8cea113a6044695$var$DataRouterHook || ($a8cea113a6044695$var$DataRouterHook = {}));
var $a8cea113a6044695$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($a8cea113a6044695$var$DataRouterStateHook || ($a8cea113a6044695$var$DataRouterStateHook = {}));
// Internal hooks
function $a8cea113a6044695$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $a8cea113a6044695$var$useDataRouterContext(hookName) {
    let ctx = $8NFma.useContext((0, $7b8d8d3adba9a65c$export$3add0d5dce533e2e));
    !ctx && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false);
    return ctx;
}
function $a8cea113a6044695$var$useDataRouterState(hookName) {
    let state = $8NFma.useContext((0, $7b8d8d3adba9a65c$export$145dfa71566a64dc));
    !state && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $a8cea113a6044695$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $7b8d8d3adba9a65c$export$9770f232ac06a008)();
    let location = (0, $7b8d8d3adba9a65c$export$45d76561a5302f2b)();
    let path = (0, $7b8d8d3adba9a65c$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $8NFma.useCallback((event)=>{
        if ($a8cea113a6044695$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $47039de3e9f0864a$export$fe53371bee54353d)(location) === (0, $47039de3e9f0864a$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $a8cea113a6044695$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $8NFma.useRef($a8cea113a6044695$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $8NFma.useRef(false);
    let location = (0, $7b8d8d3adba9a65c$export$45d76561a5302f2b)();
    let searchParams = $8NFma.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $a8cea113a6044695$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $7b8d8d3adba9a65c$export$9770f232ac06a008)();
    let setSearchParams = $8NFma.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $a8cea113a6044695$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $a8cea113a6044695$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $a8cea113a6044695$var$fetcherId = 0;
let $a8cea113a6044695$var$getUniqueFetcherId = ()=>"__" + String(++$a8cea113a6044695$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $a8cea113a6044695$export$47c85c6e3a081d3() {
    let { router: router } = $a8cea113a6044695$var$useDataRouterContext($a8cea113a6044695$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $8NFma.useContext((0, $7b8d8d3adba9a65c$export$26749e8557646306));
    let currentRouteId = (0, $7b8d8d3adba9a65c$export$5fc8298006ad9e58)();
    return $8NFma.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $a8cea113a6044695$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $a8cea113a6044695$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $a8cea113a6044695$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $a8cea113a6044695$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $8NFma.useContext((0, $7b8d8d3adba9a65c$export$26749e8557646306));
    let routeContext = $8NFma.useContext((0, $7b8d8d3adba9a65c$export$9072aa6dd1f93057));
    !routeContext && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $a8cea113a6044695$var$_extends({}, (0, $7b8d8d3adba9a65c$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $7b8d8d3adba9a65c$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $47039de3e9f0864a$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $47039de3e9f0864a$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $a8cea113a6044695$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $a8cea113a6044695$var$useDataRouterContext($a8cea113a6044695$var$DataRouterHook.UseFetcher);
    let state = $a8cea113a6044695$var$useDataRouterState($a8cea113a6044695$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $8NFma.useContext($a8cea113a6044695$export$148fd98d095596d4);
    let route = $8NFma.useContext((0, $7b8d8d3adba9a65c$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false);
    !route && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $a8cea113a6044695$var$useIdImpl ? $a8cea113a6044695$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $8NFma.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($a8cea113a6044695$var$getUniqueFetcherId());
    // Registration/cleanup
    $8NFma.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $8NFma.useCallback((href, opts)=>{
        !routeId && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $a8cea113a6044695$export$47c85c6e3a081d3();
    let submit = $8NFma.useCallback((target, opts)=>{
        submitImpl(target, $a8cea113a6044695$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $8NFma.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $8NFma.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $8NFma.createElement($a8cea113a6044695$export$a7fed597f4b8afd8, $a8cea113a6044695$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $47039de3e9f0864a$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $8NFma.useMemo(()=>$a8cea113a6044695$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $a8cea113a6044695$export$fa996778a3a31087() {
    let state = $a8cea113a6044695$var$useDataRouterState($a8cea113a6044695$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $a8cea113a6044695$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $a8cea113a6044695$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $a8cea113a6044695$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $a8cea113a6044695$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $a8cea113a6044695$var$useDataRouterContext($a8cea113a6044695$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $a8cea113a6044695$var$useDataRouterState($a8cea113a6044695$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $8NFma.useContext((0, $7b8d8d3adba9a65c$export$26749e8557646306));
    let location = (0, $7b8d8d3adba9a65c$export$45d76561a5302f2b)();
    let matches = (0, $7b8d8d3adba9a65c$export$2378eb7f5ff86053)();
    let navigation = (0, $7b8d8d3adba9a65c$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $8NFma.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $a8cea113a6044695$var$usePageHide($8NFma.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $a8cea113a6044695$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $a8cea113a6044695$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($a8cea113a6044695$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8NFma.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $a8cea113a6044695$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $a8cea113a6044695$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8NFma.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($a8cea113a6044695$var$_extends({}, location, {
                    pathname: (0, $47039de3e9f0864a$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($a8cea113a6044695$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8NFma.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $a8cea113a6044695$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $8NFma.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $a8cea113a6044695$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $8NFma.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $a8cea113a6044695$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $7b8d8d3adba9a65c$export$b273b3273281a049)(when);
    $8NFma.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $8NFma.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $a8cea113a6044695$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $8NFma.useContext($a8cea113a6044695$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false);
    let { basename: basename } = $a8cea113a6044695$var$useDataRouterContext($a8cea113a6044695$var$DataRouterHook.useViewTransitionState);
    let path = (0, $7b8d8d3adba9a65c$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $47039de3e9f0864a$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $47039de3e9f0864a$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $47039de3e9f0864a$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $47039de3e9f0864a$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}




var $8NFma = parcelRequire("8NFma");

const $dfb9c5b1b5377d77$export$b3571188c770cc5a = {
    text: "Granska din ans\xf6kan om sparande som \xe4r bifogad som PDF nedan. Om allt st\xe4mmer signerar du din ans\xf6kan med BankID f\xf6r att starta sparandet.",
    headline: "Din ans\xf6kan \xe4r godk\xe4nd och kan signeras",
    disclaimer: "Tryck p\xe5 knappen f\xf6r att p\xe5b\xf6rja din ans\xf6kan.",
    buttonText: 'Signera med BankID'
};
const $dfb9c5b1b5377d77$export$ceb9104a85eb313f = {
    headline: "Allt \xe4r klart!",
    text: "Du har nu signerat din ans\xf6kan. Du kommer att f\xe5 en bekr\xe4ftelse p\xe5 den tecknade f\xf6rs\xe4kringen och  ditt f\xf6rs\xe4kringsbesked p\xe5 Mina sidor hos Futur Pension.",
    paragraph2: "Din ans\xf6kan med de svar du l\xe4mnat finns tillg\xe4nglig under Mina dokument p\xe5 L\xe4rarf\xf6rs\xe4kringars Mina sidor.",
    buttonText: "L\xe5ter bra! Avsluta guiden."
};
const $dfb9c5b1b5377d77$export$f4c5de44377d2946 = {
    text: "Starta BankID-appen i din telefon f\xf6r att signera din ans\xf6kan."
};
const $dfb9c5b1b5377d77$export$9dfb57691ca88efc = {
    headline: "Signera din ans\xf6kan",
    text: "Starta BankID-appen p\xe5 din mobila enhet och l\xe4s av QR-koden f\xf6r att signera din ans\xf6kan"
};
const $dfb9c5b1b5377d77$export$2c90cc2fc9d83c0f = {
    headline: "Signera din ans\xf6kan",
    text: "V\xe4lj hur du vill signera din ans\xf6kan"
};
const $dfb9c5b1b5377d77$export$7068153f52b1fcca = {
    headline: "Signera din ans\xf6kan",
    text: "Starta BankID-appen p\xe5 denna enhet f\xf6r att signera din ans\xf6kan"
};
const $dfb9c5b1b5377d77$export$a3bc9b8ed74fc = {
    headline: "Signeringen avbr\xf6ts",
    text: "Signeringen slutf\xf6rdes inte eftersom det tog f\xf6r l\xe5ng tid.",
    buttonText: "Signera p\xe5 nytt"
};
const $dfb9c5b1b5377d77$export$c1c8c4a48179a206 = {
    start: 'https://www.lararforsakringar.se/'
};
const $dfb9c5b1b5377d77$export$2389c26b9ec125dd = {
    start: '/',
    selectMethod: '/select-method',
    scanQr: '/scan-qr',
    openDesktopApp: '/open-desktop-app',
    openMobileApp: '/open-mobile-app',
    resultSuccess: '/result-success',
    resultFailed: '/result-failed'
};



var $8NFma = parcelRequire("8NFma");
const $a6d005de750935b6$export$8e37460b8e593c87 = /*#__PURE__*/ (0, $8NFma.createContext)();




var $e3de8058581b2390$exports = {};

$e3de8058581b2390$exports = (parcelRequire("hIarR")).getBundleURL('37CdW') + "done-circle.1ea9006c.svg";


var $f53d4a6a7ff92e8b$exports = {};

$f53d4a6a7ff92e8b$exports = (parcelRequire("hIarR")).getBundleURL('37CdW') + "BankID.04adb032.svg";


const $87457483bbfda43a$var$lfDataService = new (0, $25937fdb26d57abd$export$2e2bcd8739ae039)();
/**
 * Starts the signing process for the managed pension application.
 * 
 * @param {string} appId Application id from context.
 */ function $87457483bbfda43a$var$checkIfSigned(appId) {
    return $87457483bbfda43a$var$lfDataService.getManagedPensionApplicationBankIDStatus({
        appId: appId
    }).then((result)=>{
        return result.signed;
    });
}
const $87457483bbfda43a$var$Start = ()=>{
    const [isSigned, setIsSigned] = (0, $8NFma.useState)(null);
    const navigate = (0, $7b8d8d3adba9a65c$export$9770f232ac06a008)();
    const id = (0, $8NFma.useContext)((0, $a6d005de750935b6$export$8e37460b8e593c87));
    (0, $8NFma.useEffect)(()=>{
        if (id) $87457483bbfda43a$var$checkIfSigned(id).then((signed)=>{
            setIsSigned(signed);
            if (signed === true) navigate((0, $dfb9c5b1b5377d77$export$2389c26b9ec125dd).resultSuccess);
        });
    }, [
        id
    ]);
    if (isSigned === null) return null;
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
        className: "signature-process",
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
            className: "signature-process__container",
            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                className: "pension-wizard-block__question pension-wizard-block__question__sign",
                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                    className: "pension-wizard-block__question__card",
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                            className: "pension-wizard-block__question__sign__illustration",
                            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($e3de8058581b2390$exports))),
                                alt: ""
                            })
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $1a6d44ba24626eed$export$2e2bcd8739ae039), {
                            id: id,
                            showCount: false,
                            showApplication: true,
                            headline: $dfb9c5b1b5377d77$export$b3571188c770cc5a.headline,
                            text: $dfb9c5b1b5377d77$export$b3571188c770cc5a.text
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("button", {
                            type: "button",
                            onClick: ()=>navigate((0, $dfb9c5b1b5377d77$export$2389c26b9ec125dd).selectMethod),
                            className: "button button--green",
                            children: [
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                    className: "bankid-icon",
                                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($f53d4a6a7ff92e8b$exports))),
                                        alt: ""
                                    })
                                }),
                                $dfb9c5b1b5377d77$export$b3571188c770cc5a.buttonText
                            ]
                        })
                    ]
                })
            })
        })
    });
};
var $87457483bbfda43a$export$2e2bcd8739ae039 = $87457483bbfda43a$var$Start;





const $ae1a29c83f2153fa$var$StartButton = ({ text: text, onClick: onClick })=>{
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
        onClick: onClick,
        role: "button",
        className: "button button--green",
        children: text
    });
};
var $ae1a29c83f2153fa$export$2e2bcd8739ae039 = $ae1a29c83f2153fa$var$StartButton;


var $eeeaa62421b7b994$exports = {};
'use strict';
$eeeaa62421b7b994$exports = $eeeaa62421b7b994$var$isMobile;
$eeeaa62421b7b994$exports.isMobile = $eeeaa62421b7b994$var$isMobile;
$eeeaa62421b7b994$exports.default = $eeeaa62421b7b994$var$isMobile;
const $eeeaa62421b7b994$var$mobileRE = /(android|bb\d+|meego).+mobile|armv7l|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|samsungbrowser.*mobile|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i;
const $eeeaa62421b7b994$var$notMobileRE = /CrOS/;
const $eeeaa62421b7b994$var$tabletRE = /android|ipad|playbook|silk/i;
function $eeeaa62421b7b994$var$isMobile(opts) {
    if (!opts) opts = {};
    let ua = opts.ua;
    if (!ua && typeof navigator !== 'undefined') ua = navigator.userAgent;
    if (ua && ua.headers && typeof ua.headers['user-agent'] === 'string') ua = ua.headers['user-agent'];
    if (typeof ua !== 'string') return false;
    let result = $eeeaa62421b7b994$var$mobileRE.test(ua) && !$eeeaa62421b7b994$var$notMobileRE.test(ua) || !!opts.tablet && $eeeaa62421b7b994$var$tabletRE.test(ua);
    if (!result && opts.tablet && opts.featureDetect && navigator && navigator.maxTouchPoints > 1 && ua.indexOf('Macintosh') !== -1 && ua.indexOf('Safari') !== -1) result = true;
    return result;
}


const $0e2477bd26ba9b4d$var$useDevice = ()=>{
    const isMobileOrTablet = (0, (/*@__PURE__*/$parcel$interopDefault($eeeaa62421b7b994$exports)))({
        tablet: true,
        featureDetect: true
    });
    const isChromeOnIOS = navigator.userAgent.includes('CriOS');
    const isFirefoxOnIOS = navigator.userAgent.includes('FxiOS');
    const isOperaOnIOS = navigator.userAgent.includes('OPiOS');
    return {
        isMobileOrTablet: isMobileOrTablet,
        isChromeOnIOS: isChromeOnIOS,
        isFirefoxOnIOS: isFirefoxOnIOS,
        isOperaOnIOS: isOperaOnIOS
    };
};
var $0e2477bd26ba9b4d$export$2e2bcd8739ae039 = $0e2477bd26ba9b4d$var$useDevice;



const $ed0113ea011c929a$var$SelectMethod = ()=>{
    const { isMobileOrTablet: isMobileOrTablet } = (0, $0e2477bd26ba9b4d$export$2e2bcd8739ae039)();
    const navigate = (0, $7b8d8d3adba9a65c$export$9770f232ac06a008)();
    const url = isMobileOrTablet ? (0, $dfb9c5b1b5377d77$export$2389c26b9ec125dd).openMobileApp : (0, $dfb9c5b1b5377d77$export$2389c26b9ec125dd).openDesktopApp;
    const [searchParams] = (0, $a8cea113a6044695$export$f1a78c17382fe22a)();
    const appId = searchParams.get('appId');
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
        className: "signature-process",
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
            className: "signature-process__container",
            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                className: "signature-process__container__card",
                children: [
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("h2", {
                        className: "signature-process__container__card__headline",
                        children: $dfb9c5b1b5377d77$export$2c90cc2fc9d83c0f.headline
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("p", {
                        className: "signature-process__container__card__info",
                        children: $dfb9c5b1b5377d77$export$2c90cc2fc9d83c0f.text
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                        className: "signature-process__container__card__button-container",
                        children: [
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $ae1a29c83f2153fa$export$2e2bcd8739ae039), {
                                text: "BankId p\xe5 samma enhet",
                                onClick: ()=>navigate(url)
                            }),
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $ae1a29c83f2153fa$export$2e2bcd8739ae039), {
                                text: "BankID QR-kod",
                                onClick: ()=>navigate((0, $dfb9c5b1b5377d77$export$2389c26b9ec125dd).scanQr)
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var $ed0113ea011c929a$export$2e2bcd8739ae039 = $ed0113ea011c929a$var$SelectMethod;





var $8NFma = parcelRequire("8NFma");



const $0c20daa6b38f8ce6$var$QRCode = ({ signingRef: signingRef, id: id, stamp: stamp })=>{
    return signingRef && id && stamp ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("img", {
            className: "signature-process__container__card__qr-code",
            src: `/futur-qr-code?applicationid=${id}&signingReference=${signingRef}&rndm=${stamp}`
        })
    }) : null;
};
var $0c20daa6b38f8ce6$export$2e2bcd8739ae039 = $0c20daa6b38f8ce6$var$QRCode;




const $6829e207f13542ca$var$lfDataService = new (0, $25937fdb26d57abd$export$2e2bcd8739ae039)();
/**
 * data = {
 *     appId: string,
 *     signingRef: string,
 *     signed: boolean
 * }
 */ function $6829e207f13542ca$var$poll(data, getCurrentStatus) {
    return $6829e207f13542ca$var$lfDataService.getManagedPensionBankIDCurrentStatus(data).then((result)=>{
        getCurrentStatus(result.status);
        if (result.status === 'pending' || result.status === 'usersign') return new Promise((resolve)=>{
            setTimeout(()=>{
                resolve($6829e207f13542ca$var$poll(data, getCurrentStatus));
            }, 1000);
        });
        else return Promise.resolve(result.status);
    }).catch((e)=>{
        return Promise.resolve(null);
    });
}
/**
 * Handles the signing process for the managed pension application.
 * 
 * @param {string} appId Application id from context.
 * 
 * 
 */ function $6829e207f13542ca$var$sign(appId) {
    const signStatus = (appId)=>$6829e207f13542ca$var$lfDataService.startManagedPensionApplicationSigning({
            appId: appId
        }).then((result)=>{
            return {
                appId: appId,
                signingRef: result.signingReference
            };
        });
    const bankIdStatus = (data)=>$6829e207f13542ca$var$lfDataService.getManagedPensionApplicationBankIDStatus({
            appId: data.appId
        }).then((result)=>{
            return {
                ...data,
                signed: result.signed
            };
        });
    return signStatus(appId).then(bankIdStatus);
}
const $6829e207f13542ca$var$ScanQR = ()=>{
    const [signRef, setSignRef] = (0, $8NFma.useState)(null);
    const [requestStatus, setRequestStatus] = (0, $8NFma.useState)(null);
    const [stamp, setStamp] = (0, $8NFma.useState)(null);
    const hasStarted = (0, $8NFma.useRef)(false);
    const navigate = (0, $7b8d8d3adba9a65c$export$9770f232ac06a008)();
    const id = (0, $8NFma.useContext)((0, $a6d005de750935b6$export$8e37460b8e593c87));
    (0, $8NFma.useEffect)(()=>{
        if (id && !hasStarted.current) {
            hasStarted.current = true;
            $6829e207f13542ca$var$sign(id).then((data)=>{
                setSignRef(data.signingRef);
                return data;
            }).then((data)=>$6829e207f13542ca$var$poll(data, (current)=>{
                    const stamp = Date.now();
                    setStamp(stamp);
                    setRequestStatus(current);
                })).then((status)=>{
                if (status === 'complete') navigate((0, $dfb9c5b1b5377d77$export$2389c26b9ec125dd).resultSuccess);
                else {
                    setSignRef(null);
                    navigate((0, $dfb9c5b1b5377d77$export$2389c26b9ec125dd).resultFailed);
                }
            });
        }
    }, [
        id
    ]);
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
        className: "signature-process",
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
            className: "signature-process__container",
            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                className: "signature-process__container__card",
                children: [
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("h2", {
                        className: "signature-process__container__card__headline",
                        children: $dfb9c5b1b5377d77$export$9dfb57691ca88efc.headline
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("p", {
                        className: "signature-process__container__card__info",
                        children: $dfb9c5b1b5377d77$export$9dfb57691ca88efc.text
                    }),
                    requestStatus === 'pending' && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                        className: "signature-process__container__card__loader-container",
                        children: [
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $0c20daa6b38f8ce6$export$2e2bcd8739ae039), {
                                signingRef: signRef,
                                id: id,
                                stamp: stamp
                            }),
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $c05e712febf85ad3$export$2e2bcd8739ae039), {})
                        ]
                    }),
                    requestStatus === 'usersign' && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                        className: "signature-process__container__card__loader-container",
                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $c05e712febf85ad3$export$2e2bcd8739ae039), {})
                    }),
                    requestStatus === null && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                        className: "signature-process__container__card__link",
                        onClick: ()=>navigate((0, $dfb9c5b1b5377d77$export$2389c26b9ec125dd).selectMethod),
                        children: "Signera p\xe5 annat s\xe4tt"
                    })
                ]
            })
        })
    });
};
var $6829e207f13542ca$export$2e2bcd8739ae039 = $6829e207f13542ca$var$ScanQR;





var $8NFma = parcelRequire("8NFma");




const $7519a7df5ffd7d74$var$lfDataService = new (0, $25937fdb26d57abd$export$2e2bcd8739ae039)();
/**
 * Handles the mobile signing process for the managed pension application.
 * 
 * @param {string} appId Application id from context.
 */ /**
 * data = {
 *     appId: string,
 *     autoStartToken: string,
 *     signed: boolean
 * }
 */ function $7519a7df5ffd7d74$var$poll(data) {
    return $7519a7df5ffd7d74$var$lfDataService.getManagedPensionBankIDCurrentStatus(data).then((result)=>{
        if (result.status === 'pending' || result.status === 'usersign') return new Promise((resolve)=>{
            setTimeout(()=>{
                resolve($7519a7df5ffd7d74$var$poll(data));
            }, 1000);
        });
        else return Promise.resolve(result.status);
    }).catch((e)=>{
        return Promise.resolve(null);
    });
}
function $7519a7df5ffd7d74$var$sign(appId) {
    const signStatus = (appId)=>$7519a7df5ffd7d74$var$lfDataService.startManagedPensionApplicationSigning({
            appId: appId
        }).then((result)=>{
            return {
                appId: appId,
                autoStartToken: result.autoStartToken,
                signingRef: result.signingReference
            };
        });
    const bankIdStatus = (data)=>$7519a7df5ffd7d74$var$lfDataService.getManagedPensionApplicationBankIDStatus({
            appId: data.appId
        }).then((result)=>{
            return {
                ...data,
                signed: result.signed
            };
        });
    return signStatus(appId).then(bankIdStatus);
}
const $7519a7df5ffd7d74$var$OpenMobileApp = ()=>{
    const [state, setState] = (0, $8NFma.useState)({
        openBankIdUrl: '',
        signData: null,
        polling: false
    });
    const { openBankIdUrl: openBankIdUrl, signData: signData, polling: polling } = state;
    const id = (0, $8NFma.useContext)((0, $a6d005de750935b6$export$8e37460b8e593c87));
    const navigate = (0, $7b8d8d3adba9a65c$export$9770f232ac06a008)();
    (0, $8NFma.useEffect)(()=>{
        if (id) $7519a7df5ffd7d74$var$sign(id).then((data)=>{
            setState((prevState)=>({
                    ...prevState,
                    openBankIdUrl: `https://app.bankid.com/?autostarttoken=${data.autoStartToken}&redirect=null`,
                    signData: data,
                    polling: true
                }));
            return data;
        });
    }, [
        id
    ]);
    (0, $8NFma.useEffect)(()=>{
        if (polling && signData) {
            window.location.href = openBankIdUrl;
            $7519a7df5ffd7d74$var$poll(signData).then((status)=>{
                if (status === 'complete') navigate((0, $dfb9c5b1b5377d77$export$2389c26b9ec125dd).resultSuccess);
                else navigate((0, $dfb9c5b1b5377d77$export$2389c26b9ec125dd).resultFailed);
                setState((prevState)=>({
                        ...prevState,
                        openBankIdUrl: '',
                        signData: null,
                        polling: false
                    }));
            });
        }
    }, [
        polling,
        signData
    ]);
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
        className: "signature-process",
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
            className: "signature-process__container",
            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                className: "signature-process__container__card",
                children: [
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("h2", {
                        className: "signature-process__container__card__headline",
                        children: $dfb9c5b1b5377d77$export$7068153f52b1fcca.headline
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("p", {
                        className: "signature-process__container__card__info",
                        children: $dfb9c5b1b5377d77$export$7068153f52b1fcca.text
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                        className: "signature-process__container__card__button-container",
                        children: [
                            openBankIdUrl && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                                className: "button button--green",
                                onClick: ()=>setPolling(true),
                                children: "Starta BankID-appen"
                            }),
                            polling && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                className: "signature-process__container__card__loader-container",
                                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $c05e712febf85ad3$export$2e2bcd8739ae039), {})
                            }),
                            !polling && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                                className: "signature-process__container__card__link",
                                onClick: ()=>navigate((0, $dfb9c5b1b5377d77$export$2389c26b9ec125dd).selectMethod),
                                children: "Signera p\xe5 annat s\xe4tt"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var $7519a7df5ffd7d74$export$2e2bcd8739ae039 = $7519a7df5ffd7d74$var$OpenMobileApp;





var $8NFma = parcelRequire("8NFma");




const $61ab0c91f8100a05$var$lfDataService = new (0, $25937fdb26d57abd$export$2e2bcd8739ae039)();
/**
 * Handles the signing process for the managed pension application.
 * 
 * @param {string} appId Application id from context.
 */ /**
 * data = {
 *     appId: string,
 *     autoStartToken: string,
 *     signed: boolean
 * }
 */ function $61ab0c91f8100a05$var$poll(data) {
    return $61ab0c91f8100a05$var$lfDataService.getManagedPensionBankIDCurrentStatus(data).then((result)=>{
        if (result.status === 'pending' || result.status === 'usersign') return new Promise((resolve)=>{
            setTimeout(()=>{
                resolve($61ab0c91f8100a05$var$poll(data));
            }, 1000);
        });
        else return result.status;
    }).catch((e)=>{
        return null;
    });
}
function $61ab0c91f8100a05$var$sign(appId) {
    const signStatus = (appId)=>$61ab0c91f8100a05$var$lfDataService.startManagedPensionApplicationSigning({
            appId: appId
        }).then((result)=>{
            return {
                appId: appId,
                autoStartToken: result.autoStartToken,
                signingRef: result.signingReference
            };
        });
    const bankIdStatus = (data)=>$61ab0c91f8100a05$var$lfDataService.getManagedPensionApplicationBankIDStatus({
            appId: data.appId
        }).then((result)=>{
            return {
                ...data,
                signed: result.signed
            };
        });
    return signStatus(appId).then(bankIdStatus);
}
const $61ab0c91f8100a05$var$OpenDesktopApp = ()=>{
    const [polling, setPolling] = (0, $8NFma.useState)(false);
    const navigate = (0, $7b8d8d3adba9a65c$export$9770f232ac06a008)();
    const id = (0, $8NFma.useContext)((0, $a6d005de750935b6$export$8e37460b8e593c87));
    (0, $8NFma.useEffect)(()=>{
        if (id) $61ab0c91f8100a05$var$sign(id).then((data)=>{
            window.location.href = `bankid:///?autostarttoken=${data.autoStartToken}&redirect=null`;
            return data;
        }).then((data)=>{
            setPolling(true);
            return $61ab0c91f8100a05$var$poll(data);
        }).then((status)=>{
            if (status === 'complete') navigate((0, $dfb9c5b1b5377d77$export$2389c26b9ec125dd).resultSuccess);
            else navigate((0, $dfb9c5b1b5377d77$export$2389c26b9ec125dd).resultFailed);
            setPolling(false);
        });
    }, [
        id
    ]);
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
        className: "signature-process",
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
            className: "signature-process__container",
            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                className: "signature-process__container__card",
                children: [
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("h2", {
                        className: "signature-process__container__card__headline",
                        children: $dfb9c5b1b5377d77$export$7068153f52b1fcca.headline
                    }),
                    polling && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $13f4c0370d7de649$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("p", {
                                className: "signature-process__container__card__info",
                                children: "F\xf6rs\xf6ker starta BankID s\xe4kerhetsprogram"
                            }),
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                className: "signature-process__container__card__loader-container",
                                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $c05e712febf85ad3$export$2e2bcd8739ae039), {})
                            })
                        ]
                    }),
                    !polling && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                        className: "signature-process__container__card__link",
                        onClick: ()=>navigate((0, $dfb9c5b1b5377d77$export$2389c26b9ec125dd).selectMethod),
                        children: "\xd6ppna p\xe5 annat s\xe4tt"
                    })
                ]
            })
        })
    });
};
var $61ab0c91f8100a05$export$2e2bcd8739ae039 = $61ab0c91f8100a05$var$OpenDesktopApp;





const $11f8e06381ef2b6c$var$Error = ()=>{
    const navigate = (0, $7b8d8d3adba9a65c$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
        className: "signature-process",
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
            className: "signature-process__container",
            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                className: "signature-process__container__card",
                children: [
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("h2", {
                        className: "signature-process__container__card__headline",
                        children: $dfb9c5b1b5377d77$export$a3bc9b8ed74fc.headline
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("p", {
                        className: "signature-process__container__card__info",
                        children: $dfb9c5b1b5377d77$export$a3bc9b8ed74fc.text
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                        className: "button button--green",
                        onClick: ()=>navigate((0, $dfb9c5b1b5377d77$export$2389c26b9ec125dd).selectMethod),
                        children: $dfb9c5b1b5377d77$export$a3bc9b8ed74fc.buttonText
                    })
                ]
            })
        })
    });
};
var $11f8e06381ef2b6c$export$2e2bcd8739ae039 = $11f8e06381ef2b6c$var$Error;



parcelRequire("8NFma");



var $60949765cba52a92$exports = {};
$60949765cba52a92$exports = JSON.parse("{\"v\":\"5.7.13\",\"fr\":30,\"ip\":0,\"op\":120,\"w\":960,\"h\":680,\"nm\":\"hearts\",\"ddd\":0,\"assets\":[],\"layers\":[{\"ddd\":0,\"ind\":1,\"ty\":4,\"nm\":\"hearts_05 Outlines\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":0,\"s\":[892.147,81.714,0],\"to\":[0.291,3.661,0],\"ti\":[3.397,-0.036,0]},{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":32,\"s\":[887.147,85.464,0],\"to\":[-2.709,-0.464,0],\"ti\":[-0.075,2.063,0]},{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":63,\"s\":[884.296,81.125,0],\"to\":[0.139,-3.811,0],\"ti\":[-1.455,-0.365,0]},{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":89,\"s\":[889.544,77.651,0],\"to\":[3.175,0.797,0],\"ti\":[0,0,0]},{\"t\":119,\"s\":[892.147,81.714,0]}],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[52.642,44.537,0],\"ix\":1,\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":0,\"s\":[100,100,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":24,\"s\":[70,70,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":54,\"s\":[100,100,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":83,\"s\":[70,70,100]},{\"t\":119,\"s\":[100,100,100]}],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[-11.452,0],[0,-14.475],[0,0],[9.635,-6.491]],\"o\":[[3.997,-9.674],[15.004,0],[0,0],[0,23.855],[0,0]],\"v\":[[-26.196,-27.768],[-0.969,-44.286],[26.196,-18.076],[26.196,-16.206],[-26.196,44.286]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.160784313725,0.450980422076,0.737254901961,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[78.838,44.537],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[11.452,0],[0,-14.475],[0,0],[-9.635,-6.491],[0,0],[0,0]],\"o\":[[-3.997,-9.674],[-15.004,0],[0,0],[0,23.855],[0,0],[0,0],[0,0]],\"v\":[[25.011,-27.768],[-0.216,-44.286],[-27.381,-18.076],[-27.381,-16.206],[25.011,44.286],[27.381,42.664],[26.501,-29.042]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.215686289469,0.686274509804,0.294117647059,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[27.631,44.537],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 2\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":120,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":2,\"ty\":4,\"nm\":\"hearts_04 Outlines\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":0,\"s\":[769.201,491.74,0],\"to\":[7.299,-0.334,0],\"ti\":[-0.143,-1.854,0]},{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":28,\"s\":[776.451,496.49,0],\"to\":[0.143,1.854,0],\"ti\":[4.446,0.088,0]},{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":59,\"s\":[769.227,501.869,0],\"to\":[-3.54,-0.057,0],\"ti\":[0.027,4.164,0]},{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":88,\"s\":[763.215,496.476,0],\"to\":[-0.027,-4.164,0],\"ti\":[0,0,0]},{\"t\":119,\"s\":[769.201,491.74,0]}],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[36.049,30.511,0],\"ix\":1,\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":0,\"s\":[100,100,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":29,\"s\":[80,80,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":60,\"s\":[100,100,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":88,\"s\":[80,80,100]},{\"t\":119,\"s\":[100,100,100]}],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[-7.826,0],[0,-9.891],[0,0],[6.583,-4.435]],\"o\":[[2.731,-6.61],[10.252,0],[0,0],[0,16.3],[0,0]],\"v\":[[-17.899,-18.974],[-0.661,-30.26],[17.899,-12.352],[17.899,-11.074],[-17.899,30.26]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.160784313725,0.450980422076,0.737254901961,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[53.948,30.511],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[7.826,0],[0,-9.891],[0,0],[-6.583,-4.435],[0,0],[0,0]],\"o\":[[-2.731,-6.61],[-10.252,0],[0,0],[0,16.3],[0,0],[0,0],[0,0]],\"v\":[[17.09,-18.974],[-0.149,-30.26],[-18.71,-12.352],[-18.71,-11.074],[17.09,30.26],[18.71,29.152],[18.107,-19.844]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.215686289469,0.686274509804,0.294117647059,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[18.959,30.511],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 2\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":120,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":3,\"ty\":4,\"nm\":\"hearts_03 Outlines\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":0,\"s\":[128.479,262.671,0],\"to\":[-1.635,0.048,0],\"ti\":[0.011,-1.735,0]},{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":29,\"s\":[126.385,265.609,0],\"to\":[-0.01,1.548,0],\"ti\":[-1.333,-0.048,0]},{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":60,\"s\":[128.479,267.859,0],\"to\":[1.771,0.063,0],\"ti\":[0.01,1.421,0]},{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":90,\"s\":[131.354,265.484,0],\"to\":[-0.02,-2.765,0],\"ti\":[0,0,0]},{\"t\":119,\"s\":[128.479,262.671,0]}],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[33.771,28.586,0],\"ix\":1,\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":0,\"s\":[100,100,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":60,\"s\":[80,80,100]},{\"t\":120,\"s\":[100,100,100]}],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[-7.327,0],[0,-9.261],[0,0],[6.165,-4.153]],\"o\":[[2.557,-6.189],[9.6,0],[0,0],[0,15.263],[0,0]],\"v\":[[-16.761,-17.767],[-0.62,-28.336],[16.761,-11.566],[16.761,-10.37],[-16.761,28.336]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.160784313725,0.450980422076,0.737254901961,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[50.532,28.586],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[7.328,0],[0,-9.261],[0,0],[-6.165,-4.153],[0,0],[0,0]],\"o\":[[-2.557,-6.189],[-9.6,0],[0,0],[0,15.263],[0,0],[0,0],[0,0]],\"v\":[[16.002,-17.767],[-0.139,-28.336],[-17.519,-11.566],[-17.519,-10.37],[16.002,28.336],[17.519,27.298],[16.955,-18.582]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.215686289469,0.686274509804,0.294117647059,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[17.769,28.586],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 2\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":120,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":4,\"ty\":4,\"nm\":\"hearts_02 Outlines\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":0,\"s\":[515.854,341.271,0],\"to\":[-4.604,-0.083,0],\"ti\":[-0.021,-7.854,0]},{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":27,\"s\":[503.354,353.771,0],\"to\":[0.021,7.854,0],\"ti\":[-5.483,-0.017,0]},{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":60,\"s\":[516.83,364.483,0],\"to\":[5.483,0.017,0],\"ti\":[-0.007,6.492,0]},{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":90,\"s\":[527.93,353.242,0],\"to\":[0.007,-12.179,0],\"ti\":[0,0,0]},{\"t\":119,\"s\":[515.854,341.271,0]}],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[281.49,237.979,0],\"ix\":1,\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":0,\"s\":[100,100,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":53,\"s\":[80,80,100]},{\"t\":120,\"s\":[100,100,100]}],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[-61.476,0],[0,-77.701],[0,0],[51.721,-34.84]],\"o\":[[21.454,-51.927],[80.54,0],[0,0],[0,128.055],[0,0]],\"v\":[[-140.62,-149.055],[-5.2,-237.729],[140.62,-97.036],[140.62,-86.993],[-140.62,237.729]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.160784313725,0.450980422076,0.737254901961,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[422.11,237.98],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[61.476,0],[0,-77.701],[0,0],[-51.721,-34.84],[0,0],[0,0]],\"o\":[[-21.453,-51.927],[-80.54,0],[0,0],[0,128.055],[0,0],[0,0],[0,0]],\"v\":[[134.259,-149.055],[-1.161,-237.729],[-146.981,-97.036],[-146.981,-86.993],[134.259,237.729],[146.981,229.025],[142.257,-155.898]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.215686289469,0.686274509804,0.294117647059,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[147.231,237.98],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 2\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":120,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":5,\"ty\":4,\"nm\":\"hearts_01 Outlines\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":0,\"s\":[232.19,578.691,0],\"to\":[7.185,-0.253,0],\"ti\":[0.05,1.92,0]},{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":27,\"s\":[239.239,573.02,0],\"to\":[-0.13,-4.958,0],\"ti\":[1.878,-0.184,0]},{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":60,\"s\":[232.503,567.816,0],\"to\":[-1.69,0.184,0],\"ti\":[0.155,-5.933,0]},{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":90,\"s\":[224.565,573.066,0],\"to\":[-0.168,6.435,0],\"ti\":[0,0,0]},{\"t\":119,\"s\":[232.19,578.691,0]}],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[103.99,87.94,0],\"ix\":1,\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":0,\"s\":[100,100,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":22,\"s\":[80,80,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":60,\"s\":[100,100,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":90,\"s\":[80,80,100]},{\"t\":120,\"s\":[100,100,100]}],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[-22.677,0],[0,-28.661],[0,0],[19.078,-12.852]],\"o\":[[7.913,-19.154],[29.708,0],[0,0],[0,47.235],[0,0]],\"v\":[[-51.87,-54.982],[-1.918,-87.691],[51.87,-35.794],[51.87,-32.089],[-51.87,87.691]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.160784313725,0.450980422076,0.737254901961,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[155.86,87.94],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[22.677,0],[0,-28.661],[0,0],[-19.078,-12.852],[0,0],[0,0]],\"o\":[[-7.913,-19.154],[-29.709,0],[0,0],[0,47.235],[0,0],[0,0],[0,0]],\"v\":[[49.524,-54.982],[-0.429,-87.691],[-54.217,-35.794],[-54.217,-32.089],[49.524,87.691],[54.217,84.48],[52.475,-57.505]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.215686289469,0.686274509804,0.294117647059,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[54.466,87.94],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 2\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":120,\"st\":0,\"bm\":0}],\"markers\":[]}");


const $d15502415840981b$var$onRedirect = ()=>{
    window.location.href = `${$dfb9c5b1b5377d77$export$c1c8c4a48179a206.start}`;
};
const $d15502415840981b$var$Success = ()=>{
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
        className: "signature-process",
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
            className: "signature-process__container",
            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                className: "pension-wizard-block__question pension-wizard-block__question__sign",
                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                    className: "pension-wizard-block__question__card",
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2c1cc6e8319f49c7$exports))), {
                            className: "pension-wizard-block__question__sign__animation",
                            animationData: (0, (/*@__PURE__*/$parcel$interopDefault($60949765cba52a92$exports))),
                            autoplay: true
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $1a6d44ba24626eed$export$2e2bcd8739ae039), {
                            showCount: false,
                            headline: $dfb9c5b1b5377d77$export$ceb9104a85eb313f.headline,
                            text: $dfb9c5b1b5377d77$export$ceb9104a85eb313f.text,
                            paragraph2: $dfb9c5b1b5377d77$export$ceb9104a85eb313f.paragraph2
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                            onClick: $d15502415840981b$var$onRedirect,
                            type: "button",
                            className: "button button--green",
                            children: $dfb9c5b1b5377d77$export$ceb9104a85eb313f.buttonText
                        })
                    ]
                })
            })
        })
    });
};
var $d15502415840981b$export$2e2bcd8739ae039 = $d15502415840981b$var$Success;



const $7709e0978ba20aa0$var$Routing = ()=>{
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $a8cea113a6044695$export$7221d69dcfc8e36b), {
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $7b8d8d3adba9a65c$export$3565eb3d00ca5a74), {
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $7b8d8d3adba9a65c$export$e7b0ac011bb776c6), {
                    path: (0, $dfb9c5b1b5377d77$export$2389c26b9ec125dd).start,
                    element: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $87457483bbfda43a$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $7b8d8d3adba9a65c$export$e7b0ac011bb776c6), {
                    path: (0, $dfb9c5b1b5377d77$export$2389c26b9ec125dd).selectMethod,
                    element: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $ed0113ea011c929a$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $7b8d8d3adba9a65c$export$e7b0ac011bb776c6), {
                    path: (0, $dfb9c5b1b5377d77$export$2389c26b9ec125dd).scanQr,
                    element: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $6829e207f13542ca$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $7b8d8d3adba9a65c$export$e7b0ac011bb776c6), {
                    path: (0, $dfb9c5b1b5377d77$export$2389c26b9ec125dd).openMobileApp,
                    element: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $7519a7df5ffd7d74$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $7b8d8d3adba9a65c$export$e7b0ac011bb776c6), {
                    path: (0, $dfb9c5b1b5377d77$export$2389c26b9ec125dd).openDesktopApp,
                    element: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $61ab0c91f8100a05$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $7b8d8d3adba9a65c$export$e7b0ac011bb776c6), {
                    path: (0, $dfb9c5b1b5377d77$export$2389c26b9ec125dd).resultFailed,
                    element: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $11f8e06381ef2b6c$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $7b8d8d3adba9a65c$export$e7b0ac011bb776c6), {
                    path: (0, $dfb9c5b1b5377d77$export$2389c26b9ec125dd).resultSuccess,
                    element: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $d15502415840981b$export$2e2bcd8739ae039), {})
                })
            ]
        })
    });
};
var $7709e0978ba20aa0$export$2e2bcd8739ae039 = $7709e0978ba20aa0$var$Routing;




var $8NFma = parcelRequire("8NFma");

const $88168efa698b7339$var$AppIdProvider = ({ children: children })=>{
    const [appId, setAppId] = (0, $8NFma.useState)('');
    (0, $8NFma.useEffect)(()=>{
        const search = window.location.search;
        const params = new URLSearchParams(search);
        const id = params.get('appId');
        setAppId(id);
    }, []);
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $a6d005de750935b6$export$8e37460b8e593c87).Provider, {
        value: appId,
        children: children
    });
};
var $88168efa698b7339$export$2e2bcd8739ae039 = $88168efa698b7339$var$AppIdProvider;


const $97955f3f0f61fd5c$var$SignatureApp = ()=>{
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $88168efa698b7339$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $7709e0978ba20aa0$export$2e2bcd8739ae039), {})
    });
};
var $97955f3f0f61fd5c$export$2e2bcd8739ae039 = $97955f3f0f61fd5c$var$SignatureApp;


// src/utils/formatProdErrorMessage.ts
function $48ad2606c1c729ac$var$formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $48ad2606c1c729ac$var$$$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var $48ad2606c1c729ac$var$symbol_observable_default = $48ad2606c1c729ac$var$$$observable;
// src/utils/actionTypes.ts
var $48ad2606c1c729ac$var$randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var $48ad2606c1c729ac$var$ActionTypes = {
    INIT: `@@redux/INIT${$48ad2606c1c729ac$var$randomString()}`,
    REPLACE: `@@redux/REPLACE${$48ad2606c1c729ac$var$randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${$48ad2606c1c729ac$var$randomString()}`
};
var $48ad2606c1c729ac$export$4219e499db7ca678 = $48ad2606c1c729ac$var$ActionTypes;
// src/utils/isPlainObject.ts
function $48ad2606c1c729ac$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// src/utils/kindOf.ts
function $48ad2606c1c729ac$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($48ad2606c1c729ac$var$isDate(val)) return "date";
    if ($48ad2606c1c729ac$var$isError(val)) return "error";
    const constructorName = $48ad2606c1c729ac$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $48ad2606c1c729ac$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $48ad2606c1c729ac$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $48ad2606c1c729ac$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $48ad2606c1c729ac$var$kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function $48ad2606c1c729ac$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($48ad2606c1c729ac$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($48ad2606c1c729ac$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($48ad2606c1c729ac$var$formatProdErrorMessage(1));
        return enhancer($48ad2606c1c729ac$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($48ad2606c1c729ac$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($48ad2606c1c729ac$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($48ad2606c1c729ac$var$formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($48ad2606c1c729ac$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$48ad2606c1c729ac$export$53b83ca8eaab0383(action)) throw new Error($48ad2606c1c729ac$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($48ad2606c1c729ac$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($48ad2606c1c729ac$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($48ad2606c1c729ac$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($48ad2606c1c729ac$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $48ad2606c1c729ac$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($48ad2606c1c729ac$var$formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            },
            [$48ad2606c1c729ac$var$symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: $48ad2606c1c729ac$export$4219e499db7ca678.INIT
    });
    const store = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer,
        [$48ad2606c1c729ac$var$symbol_observable_default]: observable
    };
    return store;
}
function $48ad2606c1c729ac$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $48ad2606c1c729ac$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $48ad2606c1c729ac$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $48ad2606c1c729ac$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === $48ad2606c1c729ac$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$48ad2606c1c729ac$export$53b83ca8eaab0383(inputState)) return `The ${argumentName} has unexpected type of "${$48ad2606c1c729ac$var$kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $48ad2606c1c729ac$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function $48ad2606c1c729ac$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: $48ad2606c1c729ac$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($48ad2606c1c729ac$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $48ad2606c1c729ac$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($48ad2606c1c729ac$var$formatProdErrorMessage(13));
    });
}
function $48ad2606c1c729ac$export$66e4520cdb265d18(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        $48ad2606c1c729ac$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error($48ad2606c1c729ac$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $48ad2606c1c729ac$var$bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function $48ad2606c1c729ac$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $48ad2606c1c729ac$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($48ad2606c1c729ac$var$formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $48ad2606c1c729ac$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $48ad2606c1c729ac$export$f672e0b6f7222cd7(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function $48ad2606c1c729ac$export$9ff26e0402cc7b7(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error($48ad2606c1c729ac$var$formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = $48ad2606c1c729ac$export$f672e0b6f7222cd7(...chain)(store.dispatch);
            return {
                ...store,
                dispatch: dispatch
            };
        };
}
// src/utils/isAction.ts
function $48ad2606c1c729ac$export$b956e38827fca970(action) {
    return $48ad2606c1c729ac$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}


// src/index.ts
function $a26ea7fef75baa84$var$createThunkMiddleware(extraArgument) {
    const middleware = ({ dispatch: dispatch, getState: getState })=>(next)=>(action)=>{
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
    return middleware;
}
var $a26ea7fef75baa84$export$dd164f5517779f15 = $a26ea7fef75baa84$var$createThunkMiddleware();
var $a26ea7fef75baa84$export$16d06542a1949d9e = $a26ea7fef75baa84$var$createThunkMiddleware;


// reducers for actions used on all pages
function $c620aa1fdf6a4f8c$export$3bc863ab459b2487(state = false, action) {
    switch(action.type){
        case 'PAGE_HAS_ERRORED':
            return action.hasErrored;
        default:
            return state;
    }
}
function $c620aa1fdf6a4f8c$export$64caae22913cebe0(state = {}, action) {
    switch(action.type){
        case 'PAGE_ERROR':
            return action.error;
        default:
            return state;
    }
}
function $c620aa1fdf6a4f8c$export$f0717a52efe28651(state = true, action) {
    switch(action.type){
        case 'PAGE_IS_LOADING':
            return action.isLoading;
        default:
            return state;
    }
}
function $c620aa1fdf6a4f8c$export$66e3251e0b5ce91a(state = 0, action) {
    switch(action.type){
        case 'PAGE_CURRENT_STEP':
            return action.step;
        default:
            return state;
    }
}


function $e749f705f26506a4$export$9163db149c235668(state = [], action) {
    switch(action.type){
        case 'STARTPAGE_LOADED':
            return action.data;
        default:
            return state;
    }
}
function $e749f705f26506a4$export$f22f61c78bd1ebb9(state = [], action) {
    switch(action.type){
        case 'ANIMAL_POSSESSION_QUOTES_LOADED':
            return action.quotes;
        default:
            return state;
    }
}


function $a22f70b2cfe3b008$export$73936eb3a72bb5f1(state = {}, action) {
    switch(action.type){
        case 'INSURANCE_PREREGISTRATIONS_PAGE_LOADED':
            return {
                ...state,
                ...action.data
            };
        default:
            return state;
    }
}


// page data
function $1a7dd4d24b9f0ce8$export$9c6223b0d60664c9(state = {}, action) {
    switch(action.type){
        case 'INSURANCE_HEALTH_DECLARATION_DATA_LOADED':
            return {
                ...state,
                ...action.healthDeclarationPageData
            };
        case 'INSURANCE_HEALTH_DECLARATION_UPDATE_AUTOSAVE':
            return {
                ...state,
                autoSave: action.autoSave
            };
        default:
            return state;
    }
}
function $1a7dd4d24b9f0ce8$export$b48e485e61c1a3b4(state = {}, action) {
    switch(action.type){
        case 'INSURANCE_HEALTH_FORM_SAVED_RESULT':
            return {
                ...state,
                ...action.healthDeclarationSavedResult
            };
        default:
            return state;
    }
}
function $1a7dd4d24b9f0ce8$export$b0a80f3ff1cfea83(state = {}, action) {
    switch(action.type){
        case 'INSURANCE_HEALTH_FORM_INPUT_REMOVED':
            const { [action.questionId]: _, ...newState } = state;
            return newState;
        case 'INSURANCE_HEALTH_FORM_INPUT_UPDATED':
            return {
                ...state,
                [action.inputData.id]: action.inputData
            };
        default:
            return state;
    }
}
function $1a7dd4d24b9f0ce8$export$c9a5d41d1a6360ea(state = {}, action) {
    switch(action.type){
        case 'INSURANCE_HEALTH_FORM_REPEAT_FORM_INPUT':
            return {
                ...state,
                [action.groupId]: action.groupId in state ? state[action.groupId] + 1 : 1
            };
        case 'INSURANCE_HEALTH_FORM_REMOVE_REPEAT_FORM_INPUT':
            return {
                ...state,
                [action.groupId]: action.groupId in state ? state[action.groupId] - 1 : 1
            };
        default:
            return state;
    }
}
function $1a7dd4d24b9f0ce8$export$fc40cdc2ee854a24(state = {
    valid: false
}, action) {
    switch(action.type){
        case 'INSURANCE_HEALTH_FORM_STATUS':
            return {
                valid: action.valid
            };
        default:
            return state;
    }
}


// page data
function $6ac49a57be3c3ef4$export$d68d8fc5d37294c2(state = {}, action) {
    switch(action.type){
        case 'PENSION_GUIDANCE_DECLARATION_DATA_LOADED':
            return {
                ...state,
                ...action.pensionGuidancePageData
            };
        default:
            return state;
    }
}
function $6ac49a57be3c3ef4$export$feb0ac95962d1327(state = {}, action) {
    switch(action.type){
        case 'PENSION_GUIDANCE_FORM_SAVED_RESULT':
            return {
                ...state,
                ...action.pensionGuidanceSavedResult
            };
        default:
            return state;
    }
}
function $6ac49a57be3c3ef4$export$4719a58c95548390(state = {}, action) {
    switch(action.type){
        case 'PENSION_GUIDANCE_FORM_INPUT_REMOVED':
            const { [action.questionId]: _, ...newState } = state;
            return newState;
        case 'PENSION_GUIDANCE_FORM_INPUT_UPDATED':
            return {
                ...state,
                [action.inputData.id]: action.inputData
            };
        default:
            return state;
    }
}
function $6ac49a57be3c3ef4$export$43179fa86a8bb557(state = {}, action) {
    switch(action.type){
        case 'PENSION_GUIDANCE_REPEAT_FORM_INPUT':
            return {
                ...state,
                [action.groupId]: action.groupId in state ? state[action.groupId] + 1 : 1
            };
        case 'PENSION_GUIDANCE_REMOVE_REPEAT_FORM_INPUT':
            return {
                ...state,
                [action.groupId]: action.groupId in state ? state[action.groupId] - 1 : 1
            };
        default:
            return state;
    }
}
function $6ac49a57be3c3ef4$export$b726d79a7ba55b29(state = {
    valid: false
}, action) {
    switch(action.type){
        case 'PENSION_GUIDANCE_FORM_STATUS':
            return {
                valid: action.valid
            };
        default:
            return state;
    }
}


function $99bf0d1515d45c27$export$3e99e624eb80b1fd(state = {}, action) {
    switch(action.type){
        case 'PROFILE_PAGE_LOADED':
            return {
                ...state,
                ...action.data
            };
        default:
            return state;
    }
}


const $049c786c41d77969$var$defaultState = {
    formSubmitFailed: false,
    formSubmitted: false
};
function $049c786c41d77969$export$275b4386c02014fc(state = $049c786c41d77969$var$defaultState, action) {
    switch(action.type){
        case 'STUDENT_SPECIAL_TEASER_LOADED':
            return {
                ...state,
                ...action.data
            };
        case 'STUDENT_SPECIAL_PAYMENT_METHOD_LOADED':
            return {
                ...state,
                paymentMethod: action.data
            };
        case 'STUDENT_SPECIAL_TEASER_FORM_SUBMIT_FAILURE':
            return {
                ...state,
                formSubmitFailed: !!action.data
            };
        case 'STUDENT_SPECIAL_TEASER_FORM_SUBMITTED':
            return {
                ...state,
                formSubmitted: !!action.data.submitted,
                automaticForm: !!action.data.automatic
            };
        default:
            return state;
    }
}


const $59523fd1dfc0cf5a$var$defaultState = {
    formSubmitFailed: false
};
function $59523fd1dfc0cf5a$export$b9b326d3d7d2510(state = $59523fd1dfc0cf5a$var$defaultState, action) {
    switch(action.type){
        case 'COINSURED_FORM_SUBMITTED':
            return {
                ...state,
                ...action.data
            };
        case 'COINSURED_FORM_SUBMIT_FAILED':
            return {
                ...state,
                formSubmitFailed: !!action.data
            };
        case 'GET_CUSTOMER_INFO':
            return {
                ...state,
                ...action.payload
            };
        default:
            return state;
    }
}


const $f3e68318d43c7e0e$var$defaultState = {
    fetchAchievementsFailed: false,
    newAchievements: []
};
function $f3e68318d43c7e0e$export$18f16e2ca231ec3a(state = $f3e68318d43c7e0e$var$defaultState, action) {
    switch(action.type){
        case 'ACHIEVEMENTS_FETCH':
            return {
                ...state,
                ...action.data
            };
        case 'NEW_ACHIEVEMENTS_FETCH':
            return {
                ...state,
                ...action.data
            };
        case 'ACHIEVEMENTS_FETCH_FAILED':
            return {
                ...state,
                fetchAchievementsFailed: action.data
            };
        default:
            return state;
    }
}
function $f3e68318d43c7e0e$export$db104a47b835d573(state = $f3e68318d43c7e0e$var$defaultState, action) {
    switch(action.type){
        case 'NEW_ACHIEVEMENTS_FETCH':
            return {
                ...state,
                newAchievements: action.data
            };
        case 'ACHIEVEMENTS_FETCH_FAILED':
            return {
                ...state,
                fetchAchievementsFailed: action.data
            };
        default:
            return state;
    }
}


function $f048ac677ce4a65f$export$824fd65e6ad2bbc(state = {}, action) {
    switch(action.type){
        case 'TRAVEL_CERT_PAGE_LOADED':
            return {
                ...state,
                ...action.data
            };
        case 'TRAVEL_CERT_PAGE_MAIL_SENT_STATUS':
            return {
                ...state,
                travelCertMailSent: action.travelCertMailSent
            };
        default:
            return state;
    }
}


const $360bb4c589f6b04c$var$defaultState = {
    announcements: [],
    fetchAnnouncementsFailed: false
};
function $360bb4c589f6b04c$export$6f46ac4a53474a8c(state = $360bb4c589f6b04c$var$defaultState, action) {
    switch(action.type){
        case 'ANNOUNCEMENTS_FETCH':
            return {
                ...state,
                announcements: action.data
            };
        case 'ANNOUNCEMENTS_FETCH_FAILED':
            return {
                ...state,
                fetchAnnouncementsFailed: action.data
            };
        default:
            return state;
    }
}


const $7d36e2cf640b29c5$var$defaultState = {
    questions: [],
    wizardFormSubmitFailed: false
};
const $7d36e2cf640b29c5$export$7572ca2049c91f7f = (state = $7d36e2cf640b29c5$var$defaultState, action)=>{
    switch(action.type){
        case 'FETCH_WIZARD':
            return {
                ...state,
                questions: action.data
            };
        case 'WIZARD_FORM_SUBMITTED':
            return {
                ...state,
                ...action.data
            };
        case 'WIZARD_FORM_SUBMIT_FAILED':
            return {
                ...state,
                wizardFormSubmitFailed: !!action.data
            };
        default:
            return state;
    }
};


const $b6970598ee513295$var$dataState = {
    allQuestions: [],
    titles: [],
    chapters: [],
    error: false,
    formId: '',
    appId: '',
    status: ''
};
const $b6970598ee513295$var$uiState = {
    stop: false,
    loading: false
};
const $b6970598ee513295$var$statusState = {
    currentProgress: 0
};
const $b6970598ee513295$var$headerState = {
    currentChapterTitle: 'Starta ditt sparande'
};
const $b6970598ee513295$var$contentState = {
    modalContent: ''
};
const $b6970598ee513295$export$b77decafd0e8115b = (viewState = $b6970598ee513295$var$headerState, action)=>{
    switch(action.type){
        case 'CURRENT_CHAPTER_TITLE':
            return {
                currentChapterTitle: action.data
            };
        default:
            return viewState;
    }
};
const $b6970598ee513295$export$37cffcbcd29baa22 = (wizardState = $b6970598ee513295$var$uiState, action)=>{
    switch(action.type){
        case 'STOP':
            return {
                stop: action.data
            };
        case 'LOADING':
            return {
                loading: action.data
            };
        default:
            return wizardState;
    }
};
const $b6970598ee513295$export$c027c28f089d7101 = (progressState = $b6970598ee513295$var$statusState, action)=>{
    switch(action.type){
        case 'UPDATE_PROGRESS':
            return {
                currentProgress: action.data
            };
        default:
            return progressState;
    }
};
const $b6970598ee513295$export$2daa8469bfa1d533 = (modalState = $b6970598ee513295$var$contentState, action)=>{
    switch(action.type){
        case 'TOGGLE_MODAL_CONTENT':
            return {
                modalContent: action.data
            };
        default:
            return modalState;
    }
};
const $b6970598ee513295$export$5ec6a819e44881d3 = (formState = $b6970598ee513295$var$dataState, action)=>{
    switch(action.type){
        case 'FETCH_MANAGED_PENSION_QUESTIONS':
            return {
                ...formState,
                allQuestions: action.data
            };
        case 'PENSION_WIZARD_FORM_SUBMITTED':
            return {
                ...formState,
                ...action.data
            };
        case 'PENSION_WIZARD_FORM_SUBMIT_FAILED':
            return {
                ...formState,
                error: !!action.data
            };
        case 'CHAPTERS':
            return {
                ...formState,
                chapters: action.data
            };
        case 'CHAPTER_TITLES':
            return {
                ...formState,
                titles: action.data
            };
        case 'QUESTIONS':
            return {
                ...formState,
                questions: action.data
            };
        case "APPID":
            return {
                appId: action.data
            };
        case "FORMID":
            return {
                formId: action.data
            };
        case "STATUS":
            return {
                status: action.data
            };
        default:
            return formState;
    }
};


const $7ccdccdfdbc3f6fd$var$possessionsState = [];
const $7ccdccdfdbc3f6fd$var$metaDataState = {
    meta: []
};
const $7ccdccdfdbc3f6fd$export$b28478dc8e4c2b75 = (state = $7ccdccdfdbc3f6fd$var$possessionsState, action)=>{
    switch(action.type){
        case 'FETCH_POSSESSIONS_STARTED':
            return {
                ...state,
                dataLoading: true
            };
        case 'FETCH_POSSESSIONS_COMPLETE':
            return {
                ...state,
                dataLoading: false,
                ...action.data
            };
        default:
            return state;
    }
};
const $7ccdccdfdbc3f6fd$export$96a4adb346e3ca03 = (state = $7ccdccdfdbc3f6fd$var$metaDataState, action)=>{
    switch(action.type){
        case 'FETCH_METADATA':
            return {
                ...state,
                meta: action.data
            };
        default:
            return state;
    }
};




const $c863f39a9a9311af$export$f2bb489f2fc0a2fc = 'FETCH_FAQ_QUESTIONS_STARTED';
const $c863f39a9a9311af$export$7aa9138d3c9e4ced = 'FETCH_FAQ_QUESTIONS_COMPLETED';
const $c863f39a9a9311af$export$df71e155e8c2dc2f = ()=>({
        type: $c863f39a9a9311af$export$f2bb489f2fc0a2fc
    });
const $c863f39a9a9311af$export$ebc784287ddfc3a9 = (data)=>({
        type: $c863f39a9a9311af$export$7aa9138d3c9e4ced,
        payload: data
    });
const $c863f39a9a9311af$export$d495a04a9efadabd = (selectedCategory)=>{
    const lfDataService = new (0, $25937fdb26d57abd$export$2e2bcd8739ae039)();
    return async (dispatch)=>{
        dispatch($c863f39a9a9311af$export$df71e155e8c2dc2f());
        try {
            const response = await lfDataService.getCategorizedFAQData(selectedCategory);
            const { categories: categories, fAQQuestions: fAQQuestions } = response;
            dispatch($c863f39a9a9311af$export$ebc784287ddfc3a9({
                categories: categories,
                fAQQuestions: fAQQuestions
            }));
        } catch (error) {
            dispatch((0, $67f4b1d2fb7c2244$export$7a8bb273722d5103)(error));
            dispatch((0, $67f4b1d2fb7c2244$export$ea4b4733f4ca2df0)(true));
        }
    };
};


const $269be06195efda3b$var$initialState = {
    loading: false,
    categories: [],
    fAQQuestions: [],
    error: null
};
const $269be06195efda3b$export$2656dd27f2508213 = (state = $269be06195efda3b$var$initialState, action)=>{
    switch(action.type){
        case 0, $c863f39a9a9311af$export$f2bb489f2fc0a2fc:
            return {
                ...state,
                loading: true,
                error: null
            };
        case 0, $c863f39a9a9311af$export$7aa9138d3c9e4ced:
            return {
                ...state,
                loading: false,
                categories: action.payload.categories,
                fAQQuestions: action.payload.fAQQuestions,
                error: null
            };
        default:
            return state;
    }
};



const $17823336619cbd49$var$initialState = {
    fetching: false,
    fetched: false,
    error: null,
    statusCode: null,
    age: '',
    birthDate: '',
    canLogin: '',
    canPurchase: '',
    city: '',
    coAddress: null,
    country: '',
    countryCode: '',
    emailAddress: '',
    faxPhone: null,
    firstName: '',
    foAddress: null,
    gender: '',
    homePhone: '',
    lastName: '',
    mobilePhone: '',
    municipalityCode: null,
    personId: null,
    personalIdentityNumber: '',
    streetAddress: '',
    workPhone: null,
    zipCode: null,
    zipCodeArea: ''
};
function $17823336619cbd49$export$2e2bcd8739ae039(state = $17823336619cbd49$var$initialState, action = {}) {
    let returnState = {
        ...state
    };
    switch(action.type){
        case (0, $8ce77540804c1437$export$2e2bcd8739ae039).CUSTOMER_INFO_FETCHING_SET:
            returnState = {
                ...state,
                fetching: !!action.payload
            };
            break;
        case (0, $8ce77540804c1437$export$2e2bcd8739ae039).CUSTOMER_INFO_SET:
            returnState = {
                ...state,
                ...action.payload
            };
            break;
    }
    return returnState;
}




const $72ff08704ef85338$var$initialState = {
    fetching: false,
    fetched: false,
    error: null,
    statusCode: null,
    animals: []
};
function $72ff08704ef85338$export$2e2bcd8739ae039(state = $72ff08704ef85338$var$initialState, action = {}) {
    let returnState = {
        ...state
    };
    switch(action.type){
        case (0, $8ce77540804c1437$export$2e2bcd8739ae039).CUSTOMER_ANIMALS_FETCHING_SET:
            returnState = {
                ...state,
                fetching: !!action.payload
            };
            break;
        case (0, $8ce77540804c1437$export$2e2bcd8739ae039).CUSTOMER_ANIMALS_SET:
            returnState = {
                ...state,
                animals: action.payload
            };
            break;
    }
    return returnState;
}



const $d6155f0a31ee068e$var$initialState = {
    fetching: false,
    fetched: false,
    error: null,
    statusCode: null,
    children: []
};
function $d6155f0a31ee068e$export$2e2bcd8739ae039(state = $d6155f0a31ee068e$var$initialState, action = {}) {
    let returnState = {
        ...state
    };
    switch(action.type){
        case (0, $8ce77540804c1437$export$2e2bcd8739ae039).CUSTOMER_CHILDREN_FETCHING_SET:
            returnState = {
                ...state,
                fetching: !!action.payload
            };
            break;
        case (0, $8ce77540804c1437$export$2e2bcd8739ae039).CUSTOMER_CHILDREN_SET:
            returnState = {
                ...state,
                children: action.payload
            };
            break;
    }
    return returnState;
}


const $cdcbfa9846dafb6a$var$reducers = {
    customerInfo: $17823336619cbd49$export$2e2bcd8739ae039,
    coInsuredInfo: $e7d11b27b0d4ec0b$export$2e2bcd8739ae039,
    customerAnimals: $72ff08704ef85338$export$2e2bcd8739ae039,
    customerChildren: $d6155f0a31ee068e$export$2e2bcd8739ae039
};
var $cdcbfa9846dafb6a$export$2e2bcd8739ae039 = $cdcbfa9846dafb6a$var$reducers;


const $dc753b74f8c2d781$var$preregistrationSummaryState = [];
const $dc753b74f8c2d781$export$23704f32bc221227 = (state = $dc753b74f8c2d781$var$preregistrationSummaryState, action)=>{
    switch(action.type){
        case 'FETCH_PREREGISTRATIONSUMMARY_STARTED':
            return {
                ...state,
                dataLoading: true
            };
        case 'FETCH_PREREGISTRATIONSUMMARY_COMPLETE':
            return {
                ...state,
                dataLoading: false,
                ...action.data
            };
        default:
            return state;
    }
};


function $3e321d775fae69d2$export$7d8a5b498da695ac(initialState) {
    // enable redux devtools if debug global is set
    const composeEnhancers = window._bazDebug && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        serialize: {
            options: true
        }
    }) : (0, $48ad2606c1c729ac$export$f672e0b6f7222cd7);
    const rootReducer = (0, $48ad2606c1c729ac$export$66e4520cdb265d18)({
        pageIsLoading: $c620aa1fdf6a4f8c$export$f0717a52efe28651,
        pageError: $c620aa1fdf6a4f8c$export$64caae22913cebe0,
        pageHasErrored: $c620aa1fdf6a4f8c$export$3bc863ab459b2487,
        pageCurrentStep: $c620aa1fdf6a4f8c$export$66e3251e0b5ce91a,
        startPageData: $e749f705f26506a4$export$9163db149c235668,
        startPageAnimalPossessionQuoteData: $e749f705f26506a4$export$f22f61c78bd1ebb9,
        healthDeclarationPageData: $1a7dd4d24b9f0ce8$export$9c6223b0d60664c9,
        healthDeclarationFormInputs: $1a7dd4d24b9f0ce8$export$b0a80f3ff1cfea83,
        healthDeclarationRepeatedInputs: $1a7dd4d24b9f0ce8$export$c9a5d41d1a6360ea,
        healthDeclarationStatus: $1a7dd4d24b9f0ce8$export$fc40cdc2ee854a24,
        healthDeclarationSavedResult: $1a7dd4d24b9f0ce8$export$b48e485e61c1a3b4,
        pensionGuidancePageData: $6ac49a57be3c3ef4$export$d68d8fc5d37294c2,
        pensionGuidanceFormInputs: $6ac49a57be3c3ef4$export$4719a58c95548390,
        pensionGuidanceRepeatedInputs: $6ac49a57be3c3ef4$export$43179fa86a8bb557,
        pensionGuidanceStatus: $6ac49a57be3c3ef4$export$b726d79a7ba55b29,
        pensionGuidanceSavedResult: $6ac49a57be3c3ef4$export$feb0ac95962d1327,
        preregistrationPageData: $a22f70b2cfe3b008$export$73936eb3a72bb5f1,
        profilePageData: $99bf0d1515d45c27$export$3e99e624eb80b1fd,
        extendStudentInsuranceTeaserData: $049c786c41d77969$export$275b4386c02014fc,
        coInsuredFormData: $59523fd1dfc0cf5a$export$b9b326d3d7d2510,
        announcerData: $360bb4c589f6b04c$export$6f46ac4a53474a8c,
        wizardData: $7d36e2cf640b29c5$export$7572ca2049c91f7f,
        pensionWizard: $b6970598ee513295$export$5ec6a819e44881d3,
        pensionWizardFlow: $b6970598ee513295$export$37cffcbcd29baa22,
        pensionWizardView: $b6970598ee513295$export$b77decafd0e8115b,
        pensionWizardModal: $b6970598ee513295$export$2daa8469bfa1d533,
        pensionWizardProgress: $b6970598ee513295$export$c027c28f089d7101,
        possessionsData: $7ccdccdfdbc3f6fd$export$b28478dc8e4c2b75,
        metaData: $7ccdccdfdbc3f6fd$export$96a4adb346e3ca03,
        faqData: $269be06195efda3b$export$2656dd27f2508213,
        achievementsData: $f3e68318d43c7e0e$export$18f16e2ca231ec3a,
        newAchievementsData: $f3e68318d43c7e0e$export$db104a47b835d573,
        travelCertPageData: $f048ac677ce4a65f$export$824fd65e6ad2bbc,
        customerInfoPageCustomerInfo: (0, $cdcbfa9846dafb6a$export$2e2bcd8739ae039).customerInfo,
        customerInfoPageCoInsuredInfo: (0, $cdcbfa9846dafb6a$export$2e2bcd8739ae039).coInsuredInfo,
        customerInfoPageCustomerAnimals: (0, $cdcbfa9846dafb6a$export$2e2bcd8739ae039).customerAnimals,
        customerInfoPageCustomerChildren: (0, $cdcbfa9846dafb6a$export$2e2bcd8739ae039).customerChildren,
        preregistrationSummary: $dc753b74f8c2d781$export$23704f32bc221227
    });
    return (0, $48ad2606c1c729ac$export$f51a9068ac82ea43)(rootReducer, initialState, composeEnhancers((0, $48ad2606c1c729ac$export$9ff26e0402cc7b7)((0, $a26ea7fef75baa84$export$dd164f5517779f15))));
}


// react mount roots
const $9b0e1e744ff6c1d6$var$sections = [
    {
        id: 'mypages-start-root',
        component: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $2b17f3b505a2d431$export$2e2bcd8739ae039), {
            mountRootId: "mypages-start-root"
        })
    },
    {
        id: 'mypages-insurance-preregistration-root',
        component: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $a1bbebf1cc25d62e$export$2e2bcd8739ae039), {
            mountRootId: "mypages-insurance-preregistration-root"
        })
    },
    {
        id: 'mypages-insurance-health-declaration-root',
        component: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $0f02de9eff7b0a0d$export$2e2bcd8739ae039), {
            mountRootId: "mypages-insurance-health-declaration-root"
        })
    },
    {
        id: 'mypages-profile-root',
        component: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $d46d5bb68afd6fcd$export$2e2bcd8739ae039), {
            mountRootId: "mypages-profile-root"
        })
    },
    {
        id: 'mypages-travel-cert-root',
        component: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $1df16087f6936667$export$2e2bcd8739ae039), {
            mountRootId: "mypages-travel-cert-root"
        })
    },
    {
        id: 'mypages-pension-guidance-root',
        component: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $b5c9fbd602d2b3b3$export$2e2bcd8739ae039), {
            mountRootId: "mypages-pension-guidance-root"
        })
    },
    {
        id: 'mypages-customer-info-root',
        component: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $17dbe4af74964259$export$2e2bcd8739ae039), {
            mountRootId: "mypages-customer-info-root"
        })
    },
    {
        id: 'mypages-possessions-listing',
        component: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $4bda935fd8380b0f$export$2e2bcd8739ae039), {
            mountRootId: "mypages-possessions-listing"
        })
    },
    {
        id: 'mypages-preregistration-summary-result',
        component: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $c3f8668c50d28375$export$2e2bcd8739ae039), {
            mountRootId: "mypages-preregistration-summary-result"
        })
    },
    {
        id: 'mypages-student-special-teaser-root',
        component: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $199d50ff90edc78d$export$2e2bcd8739ae039), {
            mountRootId: "mypages-student-special-teaser-root"
        })
    },
    {
        id: 'coinsured-form-react-app-root',
        component: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $91be79c675db81a4$export$2e2bcd8739ae039), {
            mountRootId: "coinsured-form-react-app-root"
        })
    },
    {
        id: 'announcer-react-root',
        component: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $8b1fb2af530da74a$export$2e2bcd8739ae039), {
            mountRootId: "announcer-react-root"
        })
    },
    {
        id: 'achievements-react-app-root',
        component: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $f1b5b7a22df3a832$export$2e2bcd8739ae039), {
            mountRootId: "achievements-react-app-root"
        })
    },
    {
        id: 'achievements-animated-hero-react-app-root',
        component: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $85fd810c0a087852$export$2e2bcd8739ae039), {
            mountRootId: "achievements-animated-hero-react-app-root"
        })
    },
    {
        id: 'coinsured-form-react-app-root',
        component: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $91be79c675db81a4$export$2e2bcd8739ae039), {
            mountRootId: "coinsured-form-react-app-root"
        })
    },
    {
        id: 'basic-insurance-cover-react-app-root',
        component: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $4078074f44a2fef6$export$2e2bcd8739ae039), {
            mountRootId: "basic-insurance-cover-react-app-root"
        })
    },
    {
        id: 'managed-pension-insurance-wizard-block-react-app-root',
        component: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $5bf3a07c101f86ca$export$2e2bcd8739ae039), {
            mountRootId: "managed-pension-insurance-wizard-block-react-app-root"
        })
    },
    {
        id: 'signature-process-block-react-app-root',
        component: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $97955f3f0f61fd5c$export$2e2bcd8739ae039), {
            mountRootId: "signature-process-block-react-app-root"
        })
    },
    {
        class: 'customer-knowledge-wizard-block-react-app-root',
        component: (0, $ade84258485b4519$export$2e2bcd8739ae039)
    }
];
const $9b0e1e744ff6c1d6$var$AppWrapper = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
    position: relative;
    z-index: 1;
    padding: 0;
`;
function $9b0e1e744ff6c1d6$var$MyPagesApp() {
    // debug
    document.removeEventListener('DOMContentLoaded', $9b0e1e744ff6c1d6$var$MyPagesApp);
    window._bazDebug = true;
    //window._bazDebug = window.__lfSettings.jsDebugEnabled;
    // set moment locale
    (0, (/*@__PURE__*/$parcel$interopDefault($YChVI))).locale('sv');
    // redux store
    const store = (0, $3e321d775fae69d2$export$7d8a5b498da695ac)();
    window.__bazStore = store;
    // init my pages react "app"
    $9b0e1e744ff6c1d6$var$sections.map((section)=>{
        if (section.id) {
            let wrapperEl = document.getElementById(section.id);
            if (wrapperEl) {
                const root = (0, $503937b663c395c4$export$882461b6382ed46c)(wrapperEl);
                root.render(/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $5a4066412ccab0c1$export$2881499e37b75b9a), {
                    store: store,
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($9b0e1e744ff6c1d6$var$AppWrapper, {
                        children: section.component
                    })
                }));
            }
        } else if (section.class) {
            const wrapperEls = document.querySelectorAll('.' + section.class);
            wrapperEls.forEach((element)=>{
                const root = (0, $503937b663c395c4$export$882461b6382ed46c)(element);
                root.render(/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $5a4066412ccab0c1$export$2881499e37b75b9a), {
                    store: store,
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($9b0e1e744ff6c1d6$var$AppWrapper, {
                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)(section.component, {
                            element: element
                        })
                    })
                }));
            });
        }
    });
}
document.addEventListener('DOMContentLoaded', $9b0e1e744ff6c1d6$var$MyPagesApp);

})();
//# sourceMappingURL=MyPagesApp.js.map
